/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ((function(modules) {
	// Check all modules for deduplicated modules
	for(var i in modules) {
		if(Object.prototype.hasOwnProperty.call(modules, i)) {
			switch(typeof modules[i]) {
			case "function": break;
			case "object":
				// Module can be created from a template
				modules[i] = (function(_m) {
					var args = _m.slice(1), fn = modules[_m[0]];
					return function (a,b,c) {
						fn.apply(this, [a,b,c].concat(args));
					};
				}(modules[i]));
				break;
			default:
				// Module is a copy of another module
				modules[i] = modules[modules[i]];
				break;
			}
		}
	}
	return modules;
}([
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(712);


/***/ },
/* 1 */
/***/ function(module, exports, __webpack_require__) {

	var global    = __webpack_require__(7)
	  , core      = __webpack_require__(42)
	  , hide      = __webpack_require__(21)
	  , redefine  = __webpack_require__(27)
	  , ctx       = __webpack_require__(47)
	  , PROTOTYPE = 'prototype';
	
	var $export = function(type, name, source){
	  var IS_FORCED = type & $export.F
	    , IS_GLOBAL = type & $export.G
	    , IS_STATIC = type & $export.S
	    , IS_PROTO  = type & $export.P
	    , IS_BIND   = type & $export.B
	    , target    = IS_GLOBAL ? global : IS_STATIC ? global[name] || (global[name] = {}) : (global[name] || {})[PROTOTYPE]
	    , exports   = IS_GLOBAL ? core : core[name] || (core[name] = {})
	    , expProto  = exports[PROTOTYPE] || (exports[PROTOTYPE] = {})
	    , key, own, out, exp;
	  if(IS_GLOBAL)source = name;
	  for(key in source){
	    // contains in native
	    own = !IS_FORCED && target && target[key] !== undefined;
	    // export native or passed
	    out = (own ? target : source)[key];
	    // bind timers to global for call from export context
	    exp = IS_BIND && own ? ctx(out, global) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
	    // extend global
	    if(target)redefine(target, key, out, type & $export.U);
	    // export
	    if(exports[key] != out)hide(exports, key, exp);
	    if(IS_PROTO && expProto[key] != out)expProto[key] = out;
	  }
	};
	global.core = core;
	// type bitmap
	$export.F = 1;   // forced
	$export.G = 2;   // global
	$export.S = 4;   // static
	$export.P = 8;   // proto
	$export.B = 16;  // bind
	$export.W = 32;  // wrap
	$export.U = 64;  // safe
	$export.R = 128; // real proto method for `library` 
	module.exports = $export;

/***/ },
/* 2 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	/**
	 * Use invariant() to assert state which your program assumes to be true.
	 *
	 * Provide sprintf-style format (only %s is supported) and arguments
	 * to provide information about what broke and what you were
	 * expecting.
	 *
	 * The invariant message will be stripped in production, but the invariant
	 * will remain to ensure logic does not differ in production.
	 */
	
	function invariant(condition, format, a, b, c, d, e, f) {
	  if (false) {
	    if (format === undefined) {
	      throw new Error('invariant requires an error message argument');
	    }
	  }
	
	  if (!condition) {
	    var error;
	    if (format === undefined) {
	      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
	    } else {
	      var args = [a, b, c, d, e, f];
	      var argIndex = 0;
	      error = new Error(format.replace(/%s/g, function () {
	        return args[argIndex++];
	      }));
	      error.name = 'Invariant Violation';
	    }
	
	    error.framesToPop = 1; // we don't care about invariant's own frame
	    throw error;
	  }
	}
	
	module.exports = invariant;

/***/ },
/* 3 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = __webpack_require__(747);


/***/ },
/* 4 */
/***/ function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(10);
	module.exports = function(it){
	  if(!isObject(it))throw TypeError(it + ' is not an object!');
	  return it;
	};

/***/ },
/* 5 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule reactProdInvariant
	 * 
	 */
	'use strict';
	
	/**
	 * WARNING: DO NOT manually require this module.
	 * This is a replacement for `invariant(...)` used by the error code system
	 * and will _only_ be required by the corresponding babel pass.
	 * It always throws.
	 */
	
	function reactProdInvariant(code) {
	  var argCount = arguments.length - 1;
	
	  var message = 'Minified React error #' + code + '; visit ' + 'http://facebook.github.io/react/docs/error-decoder.html?invariant=' + code;
	
	  for (var argIdx = 0; argIdx < argCount; argIdx++) {
	    message += '&args[]=' + encodeURIComponent(arguments[argIdx + 1]);
	  }
	
	  message += ' for the full message or use the non-minified dev environment' + ' for full errors and additional helpful warnings.';
	
	  var error = new Error(message);
	  error.name = 'Invariant Violation';
	  error.framesToPop = 1; // we don't care about reactProdInvariant's own frame
	
	  throw error;
	}
	
	module.exports = reactProdInvariant;

/***/ },
/* 6 */
/***/ function(module, exports) {

	/*
	object-assign
	(c) Sindre Sorhus
	@license MIT
	*/
	
	'use strict';
	/* eslint-disable no-unused-vars */
	var getOwnPropertySymbols = Object.getOwnPropertySymbols;
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	var propIsEnumerable = Object.prototype.propertyIsEnumerable;
	
	function toObject(val) {
		if (val === null || val === undefined) {
			throw new TypeError('Object.assign cannot be called with null or undefined');
		}
	
		return Object(val);
	}
	
	function shouldUseNative() {
		try {
			if (!Object.assign) {
				return false;
			}
	
			// Detect buggy property enumeration order in older V8 versions.
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=4118
			var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
			test1[5] = 'de';
			if (Object.getOwnPropertyNames(test1)[0] === '5') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test2 = {};
			for (var i = 0; i < 10; i++) {
				test2['_' + String.fromCharCode(i)] = i;
			}
			var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
				return test2[n];
			});
			if (order2.join('') !== '0123456789') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test3 = {};
			'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
				test3[letter] = letter;
			});
			if (Object.keys(Object.assign({}, test3)).join('') !==
					'abcdefghijklmnopqrst') {
				return false;
			}
	
			return true;
		} catch (err) {
			// We don't expect any of the above to throw, but better to be safe.
			return false;
		}
	}
	
	module.exports = shouldUseNative() ? Object.assign : function (target, source) {
		var from;
		var to = toObject(target);
		var symbols;
	
		for (var s = 1; s < arguments.length; s++) {
			from = Object(arguments[s]);
	
			for (var key in from) {
				if (hasOwnProperty.call(from, key)) {
					to[key] = from[key];
				}
			}
	
			if (getOwnPropertySymbols) {
				symbols = getOwnPropertySymbols(from);
				for (var i = 0; i < symbols.length; i++) {
					if (propIsEnumerable.call(from, symbols[i])) {
						to[symbols[i]] = from[symbols[i]];
					}
				}
			}
		}
	
		return to;
	};


/***/ },
/* 7 */
/***/ function(module, exports) {

	// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
	var global = module.exports = typeof window != 'undefined' && window.Math == Math
	  ? window : typeof self != 'undefined' && self.Math == Math ? self : Function('return this')();
	if(typeof __g == 'number')__g = global; // eslint-disable-line no-undef

/***/ },
/* 8 */
/***/ function(module, exports) {

	module.exports = function(exec){
	  try {
	    return !!exec();
	  } catch(e){
	    return true;
	  }
	};

/***/ },
/* 9 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var emptyFunction = __webpack_require__(37);
	
	/**
	 * Similar to invariant but only logs a warning if the condition is not met.
	 * This can be used to log issues in development environments in critical
	 * paths. Removing the logging code for production environments will keep the
	 * same logic and follow the same code paths.
	 */
	
	var warning = emptyFunction;
	
	if (false) {
	  warning = function warning(condition, format) {
	    for (var _len = arguments.length, args = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
	      args[_key - 2] = arguments[_key];
	    }
	
	    if (format === undefined) {
	      throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
	    }
	
	    if (format.indexOf('Failed Composite propType: ') === 0) {
	      return; // Ignore CompositeComponent proptype check.
	    }
	
	    if (!condition) {
	      var argIndex = 0;
	      var message = 'Warning: ' + format.replace(/%s/g, function () {
	        return args[argIndex++];
	      });
	      if (typeof console !== 'undefined') {
	        console.error(message);
	      }
	      try {
	        // --- Welcome to debugging React ---
	        // This error was thrown as a convenience so that you can use this stack
	        // to find the callsite that caused this warning to fire.
	        throw new Error(message);
	      } catch (x) {}
	    }
	  };
	}
	
	module.exports = warning;

/***/ },
/* 10 */
/***/ function(module, exports) {

	module.exports = function(it){
	  return typeof it === 'object' ? it !== null : typeof it === 'function';
	};

/***/ },
/* 11 */
/***/ function(module, exports, __webpack_require__) {

	var store      = __webpack_require__(114)('wks')
	  , uid        = __webpack_require__(72)
	  , Symbol     = __webpack_require__(7).Symbol
	  , USE_SYMBOL = typeof Symbol == 'function';
	
	var $exports = module.exports = function(name){
	  return store[name] || (store[name] =
	    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
	};
	
	$exports.store = store;

/***/ },
/* 12 */
/***/ function(module, exports, __webpack_require__) {

	/* REACT HOT LOADER */ if (false) { (function () { var ReactHotAPI = require("/Users/jnunez/git/medscapetv/node_modules/react-hot-api/modules/index.js"), RootInstanceProvider = require("/Users/jnunez/git/medscapetv/node_modules/react-hot-loader/RootInstanceProvider.js"), ReactMount = require("react/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {
	
	'use strict';
	
	var _clone2 = __webpack_require__(662);
	
	var _clone3 = _interopRequireDefault(_clone2);
	
	var _extend2 = __webpack_require__(282);
	
	var _extend3 = _interopRequireDefault(_extend2);
	
	var _isArray2 = __webpack_require__(17);
	
	var _isArray3 = _interopRequireDefault(_isArray2);
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Util = {
	  /** Convert a float data type to a ratio.
	   *
	   * @params {number} x: The float number that will be converted to a fraction
	   */
	
	  floatToRatio: function floatToRatio(x) {
	    var tolerance = 1.0E-6;
	    var h1 = 1;
	    var h2 = 0;
	    var k1 = 0;
	    var k2 = 1;
	    var b = x;
	    do {
	      var a = Math.floor(b);
	      var aux = h1;
	      h1 = a * h1 + h2;
	      h2 = aux;
	      aux = k1;
	      k1 = a * k1 + k2;
	      k2 = aux;
	      b = 1 / (b - a);
	    } while (Math.abs(x - h1 / k1) > x * tolerance);
	
	    return h1 + '/' + k1;
	  },
	  capitalizeFirstLetter: function capitalizeFirstLetter(string) {
	    return string.charAt(0).toUpperCase() + string.slice(1);
	  },
	  getRegion: function getRegion(params) {
	    var itsParams = Util.getParams(params || window.location.search);
	    if (itsParams.region) {
	      return itsParams.region;
	    } else if (window.s_user_origin) {
	      return window.s_user_origin;
	    } else {
	      return null;
	    }
	  },
	  queryParams: function queryParams(source) {
	    var array = [];
	    for (var key in source) {
	      if ({}.hasOwnProperty.call(source, key)) {
	        array.push(encodeURIComponent(key) + '=' + encodeURIComponent(source[key]));
	      }
	    }
	    return array.join('&');
	  },
	  toArray: function toArray(obj) {
	    return (0, _isArray3.default)(obj) ? obj : [obj];
	  },
	  mixin: function mixin() {
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _extend3.default.apply(null, args.map(_clone3.default));
	  },
	  forceRepaint: function forceRepaint(node) {
	    node.style.display = 'none';
	    Util.nextTick(function () {
	      return node.style.display = '';
	    });
	  },
	
	
	  /* Returns true if the current device is mobile, else returns false */
	  isMobile: function isMobile() {
	    return (/android|webos|ipad|iphone|ipod|blackberry|iemobile|opera mini|windows ce|windows phone/i.test(navigator.userAgent.toLowerCase())
	    );
	  },
	
	  isTouchDevice: function isTouchDevice() {
	    return 'ontouchstart' in window || 'onmsgesturechange' in window;
	  },
	  /**
	   * Parse query params into an object
	   */
	
	  getParams: function getParams(qs_) {
	    return (qs_ || document.location.search).replace(/(^\?)/, '').split('&').map(function (n) {
	      return n = n.split('='), this[n[0]] = n[1], this;
	    }.bind({}))[0];
	  },
	
	  urlToJSONP: function urlToJSONP(dataUrl) {
	    var _dataUrl$split = dataUrl.split('?');
	
	    var _dataUrl$split2 = _slicedToArray(_dataUrl$split, 2);
	
	    var url = _dataUrl$split2[0];
	    var query = _dataUrl$split2[1]; /* eslint prefer-const:0 */
	
	    if (query) {
	      url += '?' + query + '&';
	    } else {
	      url += '?';
	    }
	    url += 'callback=?';
	    return url;
	  },
	
	  /**
	   * Alternate Environment Checking Function, Handles all
	   * combination of qa/staging/proddev and inserts a period, for
	   * direct use in URLs */
	  envCheck: function envCheck() {
	    var env = '';
	    if (window.location.href.indexOf('.staging.') !== -1) {
	      if (window.location.href.match(/\.qa\d\d/) !== null) {
	        env = '.staging' + window.location.href.match(/\.qa\d\d/)[0];
	      } else {
	        env = '.staging';
	      }
	    } else if (window.location.href.indexOf('.proddev.') !== -1) {
	      env = '.proddev';
	    } else if (window.location.href.match(/\.qa\d\d/) !== null) {
	      env = env + window.location.href.match(/\.qa\d\d/)[0];
	    }
	    return env;
	  },
	
	
	  /**
	   * returns the default image server for but also takes an override for when
	   * you're testing locally but you want to override and point at a remote.
	   */
	  imageServer: function imageServer(env) {
	    var sub = env ? env : Util.envCheck();
	    var prodEnv = ['www.medscape.com', 'www.medscape.org', 'reference.medscape.com', 'education.webmd.com'];
	    var isProd = prodEnv.some(function (envUrl) {
	      return window.location.host.indexOf(envUrl) !== -1;
	    });
	    if (isProd) {
	      return 'http://img.medscapestatic.com';
	    }
	    if (env === 'override') {
	      return '';
	    } else if (sub === '' && Util.isLocal()) {
	      return 'http://img.qa01.medscapestatic.com';
	    } else {
	      return 'http://img' + sub + '.medscapestatic.com';
	    }
	  },
	  getImageServer: function getImageServer() {
	    if (!window.location.origin) {
	      window.location.origin = window.location.protocol + '//' + window.location.hostname + (window.location.port ? ':' + window.location.port : '');
	    }
	    return window.location.origin.replace('www', 'img').replace('medscape', 'medscapestatic');
	  },
	  getJSONDataAttribute: function getJSONDataAttribute(name) {
	    var dataElement = document.querySelector('[data-' + name + ']');
	    if (dataElement !== null) {
	      try {
	        var data = dataElement.getAttribute('data-' + name);
	        var json = JSON.parse(data);
	        return json;
	      } catch (e) {
	        console.log('error');
	        return {};
	      }
	    }
	    return {};
	  },
	
	  isLocal: function isLocal() {
	    return document.location.hostname === 'localhost';
	  },
	
	  /** Returns true if the current device is Retina display */
	  isRetina: function isRetina() {
	    return window.devicePixelRatio > 1;
	  },
	
	  /** Returns true if the current device is ipad */
	  isIpad: function isIpad() {
	    return navigator.userAgent.match(/iPad/i) !== null;
	  },
	  isIOS: function isIOS(version) {
	    var isIOS = Util.isIpad() || navigator.userAgent.match(/iPhone/i);
	    if (version) {
	      isIOS = isIOS && navigator.userAgent.match(new RegExp('OS ' + version));
	    }
	    return isIOS;
	  },
	  isSafari: function isSafari() {
	    return Util.isIOS() && navigator.userAgent.indexOf('Safari') > -1;
	  },
	  isApp: function isApp() {
	    return !!navigator.userAgent.toLowerCase().match('medscape');
	  },
	  nextTick: function nextTick(f) {
	    setTimeout(f, 0);
	  },
	  removeElementById: function removeElementById(id) {
	    var elem = document.getElementById(id);
	    elem.parentNode.removeChild(elem);
	  },
	  getXhr: function getXhr(url) {
	    var Promise = __webpack_require__(678);
	    return new Promise(function (resolve, reject) {
	      var req = new XMLHttpRequest();
	      req.open('GET', url);
	      req.onload = function () {
	        if (req.status === 200) {
	          resolve(req.response);
	        } else {
	          reject(Error(req.statusText));
	        }
	      };
	      req.onerror = function () {
	        reject(Error('Network Error'));
	      };
	      req.send();
	    });
	  },
	  isDescendant: function isDescendant(parent, child) {
	    var node = child.parentNode;
	    while (node !== null) {
	      if (node === parent) {
	        return true;
	      }
	      node = node.parentNode;
	    }
	    return false;
	  },
	  getOffset: function getOffset(element, target) {
	    var offset = { top: element.offsetTop, left: element.offsetLeft };
	    var parent = element.offsetParent;
	    while (parent !== null && parent !== target) {
	      offset.left += parent.offsetLeft;
	      offset.top += parent.offsetTop;
	      parent = parent.offsetParent;
	    }
	    return offset;
	  },
	  setCookie: function setCookie(a, b, c) {
	    var e = '';
	    if (c) {
	      var d = new Date();
	      d.setTime(d.getTime() + c * 24 * 60 * 60 * 1e3);
	      e = '; expires=' + d.toGMTString();
	    }
	    document.cookie = a + '=' + b + e + '; path=/';
	  },
	  deleteCookie: function deleteCookie(a) {
	    Util.setCookie(a, '', -1);
	  },
	  getCookie: function getCookie(a) {
	    var b = a + '=';
	    var c = document.cookie.split(';');
	    for (var d = 0; d < c.length; d++) {
	      var e = c[d];
	      while (e.charAt(0) === ' ') {
	        e = e.substring(1, e.length);
	      }if (e.indexOf(b) === 0) {
	        return e.substring(b.length, e.length);
	      }
	    }
	    return null;
	  },
	  isElementInViewport: function isElementInViewport(el, offsetHeight) {
	    if (el !== null) {
	      var rect = el.getBoundingClientRect();
	
	      return rect.top + offsetHeight >= 0 && rect.left >= 0 && rect.bottom - offsetHeight <= (window.innerHeight || document.documentElement.clientHeight) && rect.right <= (window.innerWidth || document.documentElement.clientWidth);
	    }
	  },
	  isElementScrolled: function isElementScrolled(el) {
	    var top = window.pageYOffset || document.documentElement.scrollTop,
	        height = Math.max(document.documentElement.clientHeight, window.innerHeight || 0);
	    if (el !== null) {
	      var elTop = Util.getOffset(el, document).top;
	      return elTop + 100 < top + height;
	    }
	  }
	}; /* eslint no-param-reassign: 0 */
	/* eslint no-sequences: 0 */
	
	module.exports = Util;
	
	/* REACT HOT LOADER */ }).call(this); } finally { if (false) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("/Users/jnunez/git/medscapetv/node_modules/react-hot-loader/makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot apply hot update to " + "util.js" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }

/***/ },
/* 13 */
/***/ function(module, exports, __webpack_require__) {

	// Thank's IE8 for his funny defineProperty
	module.exports = !__webpack_require__(8)(function(){
	  return Object.defineProperty({}, 'a', {get: function(){ return 7; }}).a != 7;
	});

/***/ },
/* 14 */
/***/ function(module, exports, __webpack_require__) {

	var anObject       = __webpack_require__(4)
	  , IE8_DOM_DEFINE = __webpack_require__(224)
	  , toPrimitive    = __webpack_require__(44)
	  , dP             = Object.defineProperty;
	
	exports.f = __webpack_require__(13) ? Object.defineProperty : function defineProperty(O, P, Attributes){
	  anObject(O);
	  P = toPrimitive(P, true);
	  anObject(Attributes);
	  if(IE8_DOM_DEFINE)try {
	    return dP(O, P, Attributes);
	  } catch(e){ /* empty */ }
	  if('get' in Attributes || 'set' in Attributes)throw TypeError('Accessors not supported!');
	  if('value' in Attributes)O[P] = Attributes.value;
	  return O;
	};

/***/ },
/* 15 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDOMComponentTree
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(5);
	
	var DOMProperty = __webpack_require__(90);
	var ReactDOMComponentFlags = __webpack_require__(317);
	
	var invariant = __webpack_require__(2);
	
	var ATTR_NAME = DOMProperty.ID_ATTRIBUTE_NAME;
	var Flags = ReactDOMComponentFlags;
	
	var internalInstanceKey = '__reactInternalInstance$' + Math.random().toString(36).slice(2);
	
	/**
	 * Drill down (through composites and empty components) until we get a host or
	 * host text component.
	 *
	 * This is pretty polymorphic but unavoidable with the current structure we have
	 * for `_renderedChildren`.
	 */
	function getRenderedHostOrTextFromComponent(component) {
	  var rendered;
	  while (rendered = component._renderedComponent) {
	    component = rendered;
	  }
	  return component;
	}
	
	/**
	 * Populate `_hostNode` on the rendered host/text component with the given
	 * DOM node. The passed `inst` can be a composite.
	 */
	function precacheNode(inst, node) {
	  var hostInst = getRenderedHostOrTextFromComponent(inst);
	  hostInst._hostNode = node;
	  node[internalInstanceKey] = hostInst;
	}
	
	function uncacheNode(inst) {
	  var node = inst._hostNode;
	  if (node) {
	    delete node[internalInstanceKey];
	    inst._hostNode = null;
	  }
	}
	
	/**
	 * Populate `_hostNode` on each child of `inst`, assuming that the children
	 * match up with the DOM (element) children of `node`.
	 *
	 * We cache entire levels at once to avoid an n^2 problem where we access the
	 * children of a node sequentially and have to walk from the start to our target
	 * node every time.
	 *
	 * Since we update `_renderedChildren` and the actual DOM at (slightly)
	 * different times, we could race here and see a newer `_renderedChildren` than
	 * the DOM nodes we see. To avoid this, ReactMultiChild calls
	 * `prepareToManageChildren` before we change `_renderedChildren`, at which
	 * time the container's child nodes are always cached (until it unmounts).
	 */
	function precacheChildNodes(inst, node) {
	  if (inst._flags & Flags.hasCachedChildNodes) {
	    return;
	  }
	  var children = inst._renderedChildren;
	  var childNode = node.firstChild;
	  outer: for (var name in children) {
	    if (!children.hasOwnProperty(name)) {
	      continue;
	    }
	    var childInst = children[name];
	    var childID = getRenderedHostOrTextFromComponent(childInst)._domID;
	    if (childID == null) {
	      // We're currently unmounting this child in ReactMultiChild; skip it.
	      continue;
	    }
	    // We assume the child nodes are in the same order as the child instances.
	    for (; childNode !== null; childNode = childNode.nextSibling) {
	      if (childNode.nodeType === 1 && childNode.getAttribute(ATTR_NAME) === String(childID) || childNode.nodeType === 8 && childNode.nodeValue === ' react-text: ' + childID + ' ' || childNode.nodeType === 8 && childNode.nodeValue === ' react-empty: ' + childID + ' ') {
	        precacheNode(childInst, childNode);
	        continue outer;
	      }
	    }
	    // We reached the end of the DOM children without finding an ID match.
	     true ?  false ? invariant(false, 'Unable to find element with ID %s.', childID) : _prodInvariant('32', childID) : void 0;
	  }
	  inst._flags |= Flags.hasCachedChildNodes;
	}
	
	/**
	 * Given a DOM node, return the closest ReactDOMComponent or
	 * ReactDOMTextComponent instance ancestor.
	 */
	function getClosestInstanceFromNode(node) {
	  if (node[internalInstanceKey]) {
	    return node[internalInstanceKey];
	  }
	
	  // Walk up the tree until we find an ancestor whose instance we have cached.
	  var parents = [];
	  while (!node[internalInstanceKey]) {
	    parents.push(node);
	    if (node.parentNode) {
	      node = node.parentNode;
	    } else {
	      // Top of the tree. This node must not be part of a React tree (or is
	      // unmounted, potentially).
	      return null;
	    }
	  }
	
	  var closest;
	  var inst;
	  for (; node && (inst = node[internalInstanceKey]); node = parents.pop()) {
	    closest = inst;
	    if (parents.length) {
	      precacheChildNodes(inst, node);
	    }
	  }
	
	  return closest;
	}
	
	/**
	 * Given a DOM node, return the ReactDOMComponent or ReactDOMTextComponent
	 * instance, or null if the node was not rendered by this React.
	 */
	function getInstanceFromNode(node) {
	  var inst = getClosestInstanceFromNode(node);
	  if (inst != null && inst._hostNode === node) {
	    return inst;
	  } else {
	    return null;
	  }
	}
	
	/**
	 * Given a ReactDOMComponent or ReactDOMTextComponent, return the corresponding
	 * DOM node.
	 */
	function getNodeFromInstance(inst) {
	  // Without this first invariant, passing a non-DOM-component triggers the next
	  // invariant for a missing parent, which is super confusing.
	  !(inst._hostNode !== undefined) ?  false ? invariant(false, 'getNodeFromInstance: Invalid argument.') : _prodInvariant('33') : void 0;
	
	  if (inst._hostNode) {
	    return inst._hostNode;
	  }
	
	  // Walk up the tree until we find an ancestor whose DOM node we have cached.
	  var parents = [];
	  while (!inst._hostNode) {
	    parents.push(inst);
	    !inst._hostParent ?  false ? invariant(false, 'React DOM tree root should always have a node reference.') : _prodInvariant('34') : void 0;
	    inst = inst._hostParent;
	  }
	
	  // Now parents contains each ancestor that does *not* have a cached native
	  // node, and `inst` is the deepest ancestor that does.
	  for (; parents.length; inst = parents.pop()) {
	    precacheChildNodes(inst, inst._hostNode);
	  }
	
	  return inst._hostNode;
	}
	
	var ReactDOMComponentTree = {
	  getClosestInstanceFromNode: getClosestInstanceFromNode,
	  getInstanceFromNode: getInstanceFromNode,
	  getNodeFromInstance: getNodeFromInstance,
	  precacheChildNodes: precacheChildNodes,
	  precacheNode: precacheNode,
	  uncacheNode: uncacheNode
	};
	
	module.exports = ReactDOMComponentTree;

/***/ },
/* 16 */
/***/ function(module, exports, __webpack_require__) {

	// 7.1.15 ToLength
	var toInteger = __webpack_require__(58)
	  , min       = Math.min;
	module.exports = function(it){
	  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
	};

/***/ },
/* 17 */
/***/ function(module, exports) {

	/**
	 * Checks if `value` is classified as an `Array` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @type {Function}
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is correctly classified,
	 *  else `false`.
	 * @example
	 *
	 * _.isArray([1, 2, 3]);
	 * // => true
	 *
	 * _.isArray(document.body.children);
	 * // => false
	 *
	 * _.isArray('abc');
	 * // => false
	 *
	 * _.isArray(_.noop);
	 * // => false
	 */
	var isArray = Array.isArray;
	
	module.exports = isArray;


/***/ },
/* 18 */
/***/ function(module, exports, __webpack_require__) {

	// 7.1.13 ToObject(argument)
	var defined = __webpack_require__(35);
	module.exports = function(it){
	  return Object(defined(it));
	};

/***/ },
/* 19 */
/***/ function(module, exports) {

	var hasOwnProperty = {}.hasOwnProperty;
	module.exports = function(it, key){
	  return hasOwnProperty.call(it, key);
	};

/***/ },
/* 20 */
/***/ function(module, exports, __webpack_require__) {

	/* REACT HOT LOADER */ if (false) { (function () { var ReactHotAPI = require("/Users/jnunez/git/medscapetv/node_modules/react-hot-api/modules/index.js"), RootInstanceProvider = require("/Users/jnunez/git/medscapetv/node_modules/react-hot-loader/RootInstanceProvider.js"), ReactMount = require("react/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {
	
	'use strict';
	
	var _reflux = __webpack_require__(54);
	
	var _reflux2 = _interopRequireDefault(_reflux);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Actions = _reflux2.default.createActions(['load', 'enable', 'disable', 'selectVideo', 'start', 'end', 'toggle', 'replay', 'pause', 'subtitle', 'setVolume', 'setCurrentTime', 'mute', 'unmute', 'fullScreen', 'stopAutoplay', 'setClosedCaptioning', 'selectLanguage', 'exitFullScreen', 'deleteQna']);
	
	module.exports = Actions;
	
	/* REACT HOT LOADER */ }).call(this); } finally { if (false) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("/Users/jnunez/git/medscapetv/node_modules/react-hot-loader/makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot apply hot update to " + "video_actions.js" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }

/***/ },
/* 21 */
/***/ function(module, exports, __webpack_require__) {

	var dP         = __webpack_require__(14)
	  , createDesc = __webpack_require__(57);
	module.exports = __webpack_require__(13) ? function(object, key, value){
	  return dP.f(object, key, createDesc(1, value));
	} : function(object, key, value){
	  object[key] = value;
	  return object;
	};

/***/ },
/* 22 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
	
	/**
	 * Simple, lightweight module assisting with the detection and context of
	 * Worker. Helps avoid circular dependencies and allows code to reason about
	 * whether or not they are in a Worker, even if they never include the main
	 * `ReactWorker` dependency.
	 */
	var ExecutionEnvironment = {
	
	  canUseDOM: canUseDOM,
	
	  canUseWorkers: typeof Worker !== 'undefined',
	
	  canUseEventListeners: canUseDOM && !!(window.addEventListener || window.attachEvent),
	
	  canUseViewport: canUseDOM && !!window.screen,
	
	  isInWorker: !canUseDOM // For now, this is true - might change in the future.
	
	};
	
	module.exports = ExecutionEnvironment;

/***/ },
/* 23 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	'use strict';
	
	/**
	 * Use invariant() to assert state which your program assumes to be true.
	 *
	 * Provide sprintf-style format (only %s is supported) and arguments
	 * to provide information about what broke and what you were
	 * expecting.
	 *
	 * The invariant message will be stripped in production, but the invariant
	 * will remain to ensure logic does not differ in production.
	 */
	
	var invariant = function(condition, format, a, b, c, d, e, f) {
	  if (false) {
	    if (format === undefined) {
	      throw new Error('invariant requires an error message argument');
	    }
	  }
	
	  if (!condition) {
	    var error;
	    if (format === undefined) {
	      error = new Error(
	        'Minified exception occurred; use the non-minified dev environment ' +
	        'for the full error message and additional helpful warnings.'
	      );
	    } else {
	      var args = [a, b, c, d, e, f];
	      var argIndex = 0;
	      error = new Error(
	        format.replace(/%s/g, function() { return args[argIndex++]; })
	      );
	      error.name = 'Invariant Violation';
	    }
	
	    error.framesToPop = 1; // we don't care about invariant's own frame
	    throw error;
	  }
	};
	
	module.exports = invariant;


/***/ },
/* 24 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {var checkGlobal = __webpack_require__(592);
	
	/** Detect free variable `global` from Node.js. */
	var freeGlobal = checkGlobal(typeof global == 'object' && global);
	
	/** Detect free variable `self`. */
	var freeSelf = checkGlobal(typeof self == 'object' && self);
	
	/** Detect `this` as the global object. */
	var thisGlobal = checkGlobal(typeof this == 'object' && this);
	
	/** Used as a reference to the global object. */
	var root = freeGlobal || freeSelf || thisGlobal || Function('return this')();
	
	module.exports = root;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 25 */
/***/ function(module, exports, __webpack_require__) {

	/*
	 * isObject, extend, isFunction, isArguments are taken from undescore/lodash in
	 * order to remove the dependency
	 */
	var isObject = exports.isObject = function(obj) {
	    var type = typeof obj;
	    return type === 'function' || type === 'object' && !!obj;
	};
	
	exports.extend = function(obj) {
	    if (!isObject(obj)) {
	        return obj;
	    }
	    var source, prop;
	    for (var i = 1, length = arguments.length; i < length; i++) {
	        source = arguments[i];
	        for (prop in source) {
	            if (Object.getOwnPropertyDescriptor && Object.defineProperty) {
	                var propertyDescriptor = Object.getOwnPropertyDescriptor(source, prop);
	                Object.defineProperty(obj, prop, propertyDescriptor);
	            } else {
	                obj[prop] = source[prop];
	            }
	        }
	    }
	    return obj;
	};
	
	exports.isFunction = function(value) {
	    return typeof value === 'function';
	};
	
	exports.EventEmitter = __webpack_require__(802);
	
	exports.nextTick = function(callback) {
	    setTimeout(callback, 0);
	};
	
	exports.capitalize = function(string){
	    return string.charAt(0).toUpperCase()+string.slice(1);
	};
	
	exports.callbackName = function(string){
	    return "on"+exports.capitalize(string);
	};
	
	exports.object = function(keys,vals){
	    var o={}, i=0;
	    for(;i<keys.length;i++){
	        o[keys[i]] = vals[i];
	    }
	    return o;
	};
	
	exports.Promise = __webpack_require__(803);
	
	exports.createPromise = function(resolver) {
	    return new exports.Promise(resolver);
	};
	
	exports.isArguments = function(value) {
	    return typeof value === 'object' && ('callee' in value) && typeof value.length === 'number';
	};
	
	exports.throwIf = function(val,msg){
	    if (val){
	        throw Error(msg||val);
	    }
	};


/***/ },
/* 26 */
/***/ function(module, exports) {

	module.exports = function(it){
	  if(typeof it != 'function')throw TypeError(it + ' is not a function!');
	  return it;
	};

/***/ },
/* 27 */
/***/ function(module, exports, __webpack_require__) {

	var global    = __webpack_require__(7)
	  , hide      = __webpack_require__(21)
	  , has       = __webpack_require__(19)
	  , SRC       = __webpack_require__(72)('src')
	  , TO_STRING = 'toString'
	  , $toString = Function[TO_STRING]
	  , TPL       = ('' + $toString).split(TO_STRING);
	
	__webpack_require__(42).inspectSource = function(it){
	  return $toString.call(it);
	};
	
	(module.exports = function(O, key, val, safe){
	  var isFunction = typeof val == 'function';
	  if(isFunction)has(val, 'name') || hide(val, 'name', key);
	  if(O[key] === val)return;
	  if(isFunction)has(val, SRC) || hide(val, SRC, O[key] ? '' + O[key] : TPL.join(String(key)));
	  if(O === global){
	    O[key] = val;
	  } else {
	    if(!safe){
	      delete O[key];
	      hide(O, key, val);
	    } else {
	      if(O[key])O[key] = val;
	      else hide(O, key, val);
	    }
	  }
	// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
	})(Function.prototype, TO_STRING, function toString(){
	  return typeof this == 'function' && this[SRC] || $toString.call(this);
	});

/***/ },
/* 28 */
/***/ function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(1)
	  , fails   = __webpack_require__(8)
	  , defined = __webpack_require__(35)
	  , quot    = /"/g;
	// B.2.3.2.1 CreateHTML(string, tag, attribute, value)
	var createHTML = function(string, tag, attribute, value) {
	  var S  = String(defined(string))
	    , p1 = '<' + tag;
	  if(attribute !== '')p1 += ' ' + attribute + '="' + String(value).replace(quot, '&quot;') + '"';
	  return p1 + '>' + S + '</' + tag + '>';
	};
	module.exports = function(NAME, exec){
	  var O = {};
	  O[NAME] = exec(createHTML);
	  $export($export.P + $export.F * fails(function(){
	    var test = ''[NAME]('"');
	    return test !== test.toLowerCase() || test.split('"').length > 3;
	  }), 'String', O);
	};

/***/ },
/* 29 */
/***/ function(module, exports, __webpack_require__) {

	// to indexed object, toObject with fallback for non-array-like ES3 strings
	var IObject = __webpack_require__(92)
	  , defined = __webpack_require__(35);
	module.exports = function(it){
	  return IObject(defined(it));
	};

/***/ },
/* 30 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	  Copyright (c) 2016 Jed Watson.
	  Licensed under the MIT License (MIT), see
	  http://jedwatson.github.io/classnames
	*/
	/* global define */
	
	(function () {
		'use strict';
	
		var hasOwn = {}.hasOwnProperty;
	
		function classNames () {
			var classes = [];
	
			for (var i = 0; i < arguments.length; i++) {
				var arg = arguments[i];
				if (!arg) continue;
	
				var argType = typeof arg;
	
				if (argType === 'string' || argType === 'number') {
					classes.push(arg);
				} else if (Array.isArray(arg)) {
					classes.push(classNames.apply(null, arg));
				} else if (argType === 'object') {
					for (var key in arg) {
						if (hasOwn.call(arg, key) && arg[key]) {
							classes.push(key);
						}
					}
				}
			}
	
			return classes.join(' ');
		}
	
		if (typeof module !== 'undefined' && module.exports) {
			module.exports = classNames;
		} else if (true) {
			// register as 'classnames', consistent with npm package name
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
				return classNames;
			}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else {
			window.classNames = classNames;
		}
	}());


/***/ },
/* 31 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2016-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactInstrumentation
	 */
	
	'use strict';
	
	var debugTool = null;
	
	if (false) {
	  var ReactDebugTool = require('./ReactDebugTool');
	  debugTool = ReactDebugTool;
	}
	
	module.exports = { debugTool: debugTool };

/***/ },
/* 32 */
/***/ function(module, exports, __webpack_require__) {

	var pIE            = __webpack_require__(93)
	  , createDesc     = __webpack_require__(57)
	  , toIObject      = __webpack_require__(29)
	  , toPrimitive    = __webpack_require__(44)
	  , has            = __webpack_require__(19)
	  , IE8_DOM_DEFINE = __webpack_require__(224)
	  , gOPD           = Object.getOwnPropertyDescriptor;
	
	exports.f = __webpack_require__(13) ? gOPD : function getOwnPropertyDescriptor(O, P){
	  O = toIObject(O);
	  P = toPrimitive(P, true);
	  if(IE8_DOM_DEFINE)try {
	    return gOPD(O, P);
	  } catch(e){ /* empty */ }
	  if(has(O, P))return createDesc(!pIE.f.call(O, P), O[P]);
	};

/***/ },
/* 33 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
	var has         = __webpack_require__(19)
	  , toObject    = __webpack_require__(18)
	  , IE_PROTO    = __webpack_require__(160)('IE_PROTO')
	  , ObjectProto = Object.prototype;
	
	module.exports = Object.getPrototypeOf || function(O){
	  O = toObject(O);
	  if(has(O, IE_PROTO))return O[IE_PROTO];
	  if(typeof O.constructor == 'function' && O instanceof O.constructor){
	    return O.constructor.prototype;
	  } return O instanceof Object ? ObjectProto : null;
	};

/***/ },
/* 34 */
/***/ function(module, exports) {

	var toString = {}.toString;
	
	module.exports = function(it){
	  return toString.call(it).slice(8, -1);
	};

/***/ },
/* 35 */
/***/ function(module, exports) {

	// 7.2.1 RequireObjectCoercible(argument)
	module.exports = function(it){
	  if(it == undefined)throw TypeError("Can't call method on  " + it);
	  return it;
	};

/***/ },
/* 36 */
/***/ function(module, exports, __webpack_require__) {

	var fails = __webpack_require__(8);
	
	module.exports = function(method, arg){
	  return !!method && fails(function(){
	    arg ? method.call(null, function(){}, 1) : method.call(null);
	  });
	};

/***/ },
/* 37 */
/***/ function(module, exports) {

	"use strict";
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	function makeEmptyFunction(arg) {
	  return function () {
	    return arg;
	  };
	}
	
	/**
	 * This function accepts and discards inputs; it has no side effects. This is
	 * primarily useful idiomatically for overridable function endpoints which
	 * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
	 */
	var emptyFunction = function emptyFunction() {};
	
	emptyFunction.thatReturns = makeEmptyFunction;
	emptyFunction.thatReturnsFalse = makeEmptyFunction(false);
	emptyFunction.thatReturnsTrue = makeEmptyFunction(true);
	emptyFunction.thatReturnsNull = makeEmptyFunction(null);
	emptyFunction.thatReturnsThis = function () {
	  return this;
	};
	emptyFunction.thatReturnsArgument = function (arg) {
	  return arg;
	};
	
	module.exports = emptyFunction;

/***/ },
/* 38 */
/***/ function(module, exports, __webpack_require__) {

	var baseGet = __webpack_require__(257);
	
	/**
	 * Gets the value at `path` of `object`. If the resolved value is
	 * `undefined`, the `defaultValue` is used in its place.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.7.0
	 * @category Object
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path of the property to get.
	 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
	 * @returns {*} Returns the resolved value.
	 * @example
	 *
	 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
	 *
	 * _.get(object, 'a[0].b.c');
	 * // => 3
	 *
	 * _.get(object, ['a', '0', 'b', 'c']);
	 * // => 3
	 *
	 * _.get(object, 'a.b.c', 'default');
	 * // => 'default'
	 */
	function get(object, path, defaultValue) {
	  var result = object == null ? undefined : baseGet(object, path);
	  return result === undefined ? defaultValue : result;
	}
	
	module.exports = get;


/***/ },
/* 39 */
/***/ function(module, exports) {

	/**
	 * Checks if `value` is the
	 * [language type](http://www.ecma-international.org/ecma-262/6.0/#sec-ecmascript-language-types)
	 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(_.noop);
	 * // => true
	 *
	 * _.isObject(null);
	 * // => false
	 */
	function isObject(value) {
	  var type = typeof value;
	  return !!value && (type == 'object' || type == 'function');
	}
	
	module.exports = isObject;


/***/ },
/* 40 */
/***/ function(module, exports, __webpack_require__) {

	var baseHas = __webpack_require__(258),
	    baseKeys = __webpack_require__(581),
	    indexKeys = __webpack_require__(271),
	    isArrayLike = __webpack_require__(60),
	    isIndex = __webpack_require__(95),
	    isPrototype = __webpack_require__(96);
	
	/**
	 * Creates an array of the own enumerable property names of `object`.
	 *
	 * **Note:** Non-object values are coerced to objects. See the
	 * [ES spec](http://ecma-international.org/ecma-262/6.0/#sec-object.keys)
	 * for more details.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.keys(new Foo);
	 * // => ['a', 'b'] (iteration order is not guaranteed)
	 *
	 * _.keys('hi');
	 * // => ['0', '1']
	 */
	function keys(object) {
	  var isProto = isPrototype(object);
	  if (!(isProto || isArrayLike(object))) {
	    return baseKeys(object);
	  }
	  var indexes = indexKeys(object),
	      skipIndexes = !!indexes,
	      result = indexes || [],
	      length = result.length;
	
	  for (var key in object) {
	    if (baseHas(object, key) &&
	        !(skipIndexes && (key == 'length' || isIndex(key, length))) &&
	        !(isProto && key == 'constructor')) {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	module.exports = keys;


/***/ },
/* 41 */
/***/ function(module, exports, __webpack_require__) {

	// 0 -> Array#forEach
	// 1 -> Array#map
	// 2 -> Array#filter
	// 3 -> Array#some
	// 4 -> Array#every
	// 5 -> Array#find
	// 6 -> Array#findIndex
	var ctx      = __webpack_require__(47)
	  , IObject  = __webpack_require__(92)
	  , toObject = __webpack_require__(18)
	  , toLength = __webpack_require__(16)
	  , asc      = __webpack_require__(353);
	module.exports = function(TYPE, $create){
	  var IS_MAP        = TYPE == 1
	    , IS_FILTER     = TYPE == 2
	    , IS_SOME       = TYPE == 3
	    , IS_EVERY      = TYPE == 4
	    , IS_FIND_INDEX = TYPE == 6
	    , NO_HOLES      = TYPE == 5 || IS_FIND_INDEX
	    , create        = $create || asc;
	  return function($this, callbackfn, that){
	    var O      = toObject($this)
	      , self   = IObject(O)
	      , f      = ctx(callbackfn, that, 3)
	      , length = toLength(self.length)
	      , index  = 0
	      , result = IS_MAP ? create($this, length) : IS_FILTER ? create($this, 0) : undefined
	      , val, res;
	    for(;length > index; index++)if(NO_HOLES || index in self){
	      val = self[index];
	      res = f(val, index, O);
	      if(TYPE){
	        if(IS_MAP)result[index] = res;            // map
	        else if(res)switch(TYPE){
	          case 3: return true;                    // some
	          case 5: return val;                     // find
	          case 6: return index;                   // findIndex
	          case 2: result.push(val);               // filter
	        } else if(IS_EVERY)return false;          // every
	      }
	    }
	    return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : result;
	  };
	};

/***/ },
/* 42 */
/***/ function(module, exports) {

	var core = module.exports = {version: '2.4.0'};
	if(typeof __e == 'number')__e = core; // eslint-disable-line no-undef

/***/ },
/* 43 */
/***/ function(module, exports, __webpack_require__) {

	// most Object methods by ES6 should accept primitives
	var $export = __webpack_require__(1)
	  , core    = __webpack_require__(42)
	  , fails   = __webpack_require__(8);
	module.exports = function(KEY, exec){
	  var fn  = (core.Object || {})[KEY] || Object[KEY]
	    , exp = {};
	  exp[KEY] = exec(fn);
	  $export($export.S + $export.F * fails(function(){ fn(1); }), 'Object', exp);
	};

/***/ },
/* 44 */
/***/ function(module, exports, __webpack_require__) {

	// 7.1.1 ToPrimitive(input [, PreferredType])
	var isObject = __webpack_require__(10);
	// instead of the ES6 spec version, we didn't implement @@toPrimitive case
	// and the second argument - flag - preferred type is a string
	module.exports = function(it, S){
	  if(!isObject(it))return it;
	  var fn, val;
	  if(S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it)))return val;
	  if(typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it)))return val;
	  if(!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it)))return val;
	  throw TypeError("Can't convert object to primitive value");
	};

/***/ },
/* 45 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactElement
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(6);
	
	var ReactCurrentOwner = __webpack_require__(75);
	
	var warning = __webpack_require__(9);
	var canDefineProperty = __webpack_require__(331);
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	
	// The Symbol used to tag the ReactElement type. If there is no native Symbol
	// nor polyfill, then a plain number is used for performance.
	var REACT_ELEMENT_TYPE = typeof Symbol === 'function' && Symbol['for'] && Symbol['for']('react.element') || 0xeac7;
	
	var RESERVED_PROPS = {
	  key: true,
	  ref: true,
	  __self: true,
	  __source: true
	};
	
	var specialPropKeyWarningShown, specialPropRefWarningShown;
	
	function hasValidRef(config) {
	  if (false) {
	    if (hasOwnProperty.call(config, 'ref')) {
	      var getter = Object.getOwnPropertyDescriptor(config, 'ref').get;
	      if (getter && getter.isReactWarning) {
	        return false;
	      }
	    }
	  }
	  return config.ref !== undefined;
	}
	
	function hasValidKey(config) {
	  if (false) {
	    if (hasOwnProperty.call(config, 'key')) {
	      var getter = Object.getOwnPropertyDescriptor(config, 'key').get;
	      if (getter && getter.isReactWarning) {
	        return false;
	      }
	    }
	  }
	  return config.key !== undefined;
	}
	
	/**
	 * Factory method to create a new React element. This no longer adheres to
	 * the class pattern, so do not use new to call it. Also, no instanceof check
	 * will work. Instead test $$typeof field against Symbol.for('react.element') to check
	 * if something is a React Element.
	 *
	 * @param {*} type
	 * @param {*} key
	 * @param {string|object} ref
	 * @param {*} self A *temporary* helper to detect places where `this` is
	 * different from the `owner` when React.createElement is called, so that we
	 * can warn. We want to get rid of owner and replace string `ref`s with arrow
	 * functions, and as long as `this` and owner are the same, there will be no
	 * change in behavior.
	 * @param {*} source An annotation object (added by a transpiler or otherwise)
	 * indicating filename, line number, and/or other information.
	 * @param {*} owner
	 * @param {*} props
	 * @internal
	 */
	var ReactElement = function (type, key, ref, self, source, owner, props) {
	  var element = {
	    // This tag allow us to uniquely identify this as a React Element
	    $$typeof: REACT_ELEMENT_TYPE,
	
	    // Built-in properties that belong on the element
	    type: type,
	    key: key,
	    ref: ref,
	    props: props,
	
	    // Record the component responsible for creating this element.
	    _owner: owner
	  };
	
	  if (false) {
	    // The validation flag is currently mutative. We put it on
	    // an external backing store so that we can freeze the whole object.
	    // This can be replaced with a WeakMap once they are implemented in
	    // commonly used development environments.
	    element._store = {};
	
	    // To make comparing ReactElements easier for testing purposes, we make
	    // the validation flag non-enumerable (where possible, which should
	    // include every environment we run tests in), so the test framework
	    // ignores it.
	    if (canDefineProperty) {
	      Object.defineProperty(element._store, 'validated', {
	        configurable: false,
	        enumerable: false,
	        writable: true,
	        value: false
	      });
	      // self and source are DEV only properties.
	      Object.defineProperty(element, '_self', {
	        configurable: false,
	        enumerable: false,
	        writable: false,
	        value: self
	      });
	      // Two elements created in two different places should be considered
	      // equal for testing purposes and therefore we hide it from enumeration.
	      Object.defineProperty(element, '_source', {
	        configurable: false,
	        enumerable: false,
	        writable: false,
	        value: source
	      });
	    } else {
	      element._store.validated = false;
	      element._self = self;
	      element._source = source;
	    }
	    if (Object.freeze) {
	      Object.freeze(element.props);
	      Object.freeze(element);
	    }
	  }
	
	  return element;
	};
	
	/**
	 * Create and return a new ReactElement of the given type.
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.createelement
	 */
	ReactElement.createElement = function (type, config, children) {
	  var propName;
	
	  // Reserved names are extracted
	  var props = {};
	
	  var key = null;
	  var ref = null;
	  var self = null;
	  var source = null;
	
	  if (config != null) {
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(
	      /* eslint-disable no-proto */
	      config.__proto__ == null || config.__proto__ === Object.prototype,
	      /* eslint-enable no-proto */
	      'React.createElement(...): Expected props argument to be a plain object. ' + 'Properties defined in its prototype chain will be ignored.') : void 0;
	    }
	
	    if (hasValidRef(config)) {
	      ref = config.ref;
	    }
	    if (hasValidKey(config)) {
	      key = '' + config.key;
	    }
	
	    self = config.__self === undefined ? null : config.__self;
	    source = config.__source === undefined ? null : config.__source;
	    // Remaining properties are added to a new props object
	    for (propName in config) {
	      if (hasOwnProperty.call(config, propName) && !RESERVED_PROPS.hasOwnProperty(propName)) {
	        props[propName] = config[propName];
	      }
	    }
	  }
	
	  // Children can be more than one argument, and those are transferred onto
	  // the newly allocated props object.
	  var childrenLength = arguments.length - 2;
	  if (childrenLength === 1) {
	    props.children = children;
	  } else if (childrenLength > 1) {
	    var childArray = Array(childrenLength);
	    for (var i = 0; i < childrenLength; i++) {
	      childArray[i] = arguments[i + 2];
	    }
	    props.children = childArray;
	  }
	
	  // Resolve default props
	  if (type && type.defaultProps) {
	    var defaultProps = type.defaultProps;
	    for (propName in defaultProps) {
	      if (props[propName] === undefined) {
	        props[propName] = defaultProps[propName];
	      }
	    }
	  }
	  if (false) {
	    var displayName = typeof type === 'function' ? type.displayName || type.name || 'Unknown' : type;
	
	    // Create dummy `key` and `ref` property to `props` to warn users against its use
	    var warnAboutAccessingKey = function () {
	      if (!specialPropKeyWarningShown) {
	        specialPropKeyWarningShown = true;
	        process.env.NODE_ENV !== 'production' ? warning(false, '%s: `key` is not a prop. Trying to access it will result ' + 'in `undefined` being returned. If you need to access the same ' + 'value within the child component, you should pass it as a different ' + 'prop. (https://fb.me/react-special-props)', displayName) : void 0;
	      }
	      return undefined;
	    };
	    warnAboutAccessingKey.isReactWarning = true;
	
	    var warnAboutAccessingRef = function () {
	      if (!specialPropRefWarningShown) {
	        specialPropRefWarningShown = true;
	        process.env.NODE_ENV !== 'production' ? warning(false, '%s: `ref` is not a prop. Trying to access it will result ' + 'in `undefined` being returned. If you need to access the same ' + 'value within the child component, you should pass it as a different ' + 'prop. (https://fb.me/react-special-props)', displayName) : void 0;
	      }
	      return undefined;
	    };
	    warnAboutAccessingRef.isReactWarning = true;
	
	    if (typeof props.$$typeof === 'undefined' || props.$$typeof !== REACT_ELEMENT_TYPE) {
	      if (!props.hasOwnProperty('key')) {
	        Object.defineProperty(props, 'key', {
	          get: warnAboutAccessingKey,
	          configurable: true
	        });
	      }
	      if (!props.hasOwnProperty('ref')) {
	        Object.defineProperty(props, 'ref', {
	          get: warnAboutAccessingRef,
	          configurable: true
	        });
	      }
	    }
	  }
	  return ReactElement(type, key, ref, self, source, ReactCurrentOwner.current, props);
	};
	
	/**
	 * Return a function that produces ReactElements of a given type.
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.createfactory
	 */
	ReactElement.createFactory = function (type) {
	  var factory = ReactElement.createElement.bind(null, type);
	  // Expose the type on the factory and the prototype so that it can be
	  // easily accessed on elements. E.g. `<Foo />.type === Foo`.
	  // This should not be named `constructor` since this may not be the function
	  // that created the element, and it may not even be a constructor.
	  // Legacy hook TODO: Warn if this is accessed
	  factory.type = type;
	  return factory;
	};
	
	ReactElement.cloneAndReplaceKey = function (oldElement, newKey) {
	  var newElement = ReactElement(oldElement.type, newKey, oldElement.ref, oldElement._self, oldElement._source, oldElement._owner, oldElement.props);
	
	  return newElement;
	};
	
	/**
	 * Clone and return a new ReactElement using element as the starting point.
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.cloneelement
	 */
	ReactElement.cloneElement = function (element, config, children) {
	  var propName;
	
	  // Original props are copied
	  var props = _assign({}, element.props);
	
	  // Reserved names are extracted
	  var key = element.key;
	  var ref = element.ref;
	  // Self is preserved since the owner is preserved.
	  var self = element._self;
	  // Source is preserved since cloneElement is unlikely to be targeted by a
	  // transpiler, and the original source is probably a better indicator of the
	  // true owner.
	  var source = element._source;
	
	  // Owner will be preserved, unless ref is overridden
	  var owner = element._owner;
	
	  if (config != null) {
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(
	      /* eslint-disable no-proto */
	      config.__proto__ == null || config.__proto__ === Object.prototype,
	      /* eslint-enable no-proto */
	      'React.cloneElement(...): Expected props argument to be a plain object. ' + 'Properties defined in its prototype chain will be ignored.') : void 0;
	    }
	
	    if (hasValidRef(config)) {
	      // Silently steal the ref from the parent.
	      ref = config.ref;
	      owner = ReactCurrentOwner.current;
	    }
	    if (hasValidKey(config)) {
	      key = '' + config.key;
	    }
	
	    // Remaining properties override existing props
	    var defaultProps;
	    if (element.type && element.type.defaultProps) {
	      defaultProps = element.type.defaultProps;
	    }
	    for (propName in config) {
	      if (hasOwnProperty.call(config, propName) && !RESERVED_PROPS.hasOwnProperty(propName)) {
	        if (config[propName] === undefined && defaultProps !== undefined) {
	          // Resolve default props
	          props[propName] = defaultProps[propName];
	        } else {
	          props[propName] = config[propName];
	        }
	      }
	    }
	  }
	
	  // Children can be more than one argument, and those are transferred onto
	  // the newly allocated props object.
	  var childrenLength = arguments.length - 2;
	  if (childrenLength === 1) {
	    props.children = children;
	  } else if (childrenLength > 1) {
	    var childArray = Array(childrenLength);
	    for (var i = 0; i < childrenLength; i++) {
	      childArray[i] = arguments[i + 2];
	    }
	    props.children = childArray;
	  }
	
	  return ReactElement(element.type, key, ref, self, source, owner, props);
	};
	
	/**
	 * Verifies the object is a ReactElement.
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.isvalidelement
	 * @param {?object} object
	 * @return {boolean} True if `object` is a valid component.
	 * @final
	 */
	ReactElement.isValidElement = function (object) {
	  return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
	};
	
	ReactElement.REACT_ELEMENT_TYPE = REACT_ELEMENT_TYPE;
	
	module.exports = ReactElement;

/***/ },
/* 46 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactUpdates
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(5),
	    _assign = __webpack_require__(6);
	
	var CallbackQueue = __webpack_require__(311);
	var PooledClass = __webpack_require__(62);
	var ReactFeatureFlags = __webpack_require__(320);
	var ReactReconciler = __webpack_require__(91);
	var Transaction = __webpack_require__(103);
	
	var invariant = __webpack_require__(2);
	
	var dirtyComponents = [];
	var updateBatchNumber = 0;
	var asapCallbackQueue = CallbackQueue.getPooled();
	var asapEnqueued = false;
	
	var batchingStrategy = null;
	
	function ensureInjected() {
	  !(ReactUpdates.ReactReconcileTransaction && batchingStrategy) ?  false ? invariant(false, 'ReactUpdates: must inject a reconcile transaction class and batching strategy') : _prodInvariant('123') : void 0;
	}
	
	var NESTED_UPDATES = {
	  initialize: function () {
	    this.dirtyComponentsLength = dirtyComponents.length;
	  },
	  close: function () {
	    if (this.dirtyComponentsLength !== dirtyComponents.length) {
	      // Additional updates were enqueued by componentDidUpdate handlers or
	      // similar; before our own UPDATE_QUEUEING wrapper closes, we want to run
	      // these new updates so that if A's componentDidUpdate calls setState on
	      // B, B will update before the callback A's updater provided when calling
	      // setState.
	      dirtyComponents.splice(0, this.dirtyComponentsLength);
	      flushBatchedUpdates();
	    } else {
	      dirtyComponents.length = 0;
	    }
	  }
	};
	
	var UPDATE_QUEUEING = {
	  initialize: function () {
	    this.callbackQueue.reset();
	  },
	  close: function () {
	    this.callbackQueue.notifyAll();
	  }
	};
	
	var TRANSACTION_WRAPPERS = [NESTED_UPDATES, UPDATE_QUEUEING];
	
	function ReactUpdatesFlushTransaction() {
	  this.reinitializeTransaction();
	  this.dirtyComponentsLength = null;
	  this.callbackQueue = CallbackQueue.getPooled();
	  this.reconcileTransaction = ReactUpdates.ReactReconcileTransaction.getPooled(
	  /* useCreateElement */true);
	}
	
	_assign(ReactUpdatesFlushTransaction.prototype, Transaction.Mixin, {
	  getTransactionWrappers: function () {
	    return TRANSACTION_WRAPPERS;
	  },
	
	  destructor: function () {
	    this.dirtyComponentsLength = null;
	    CallbackQueue.release(this.callbackQueue);
	    this.callbackQueue = null;
	    ReactUpdates.ReactReconcileTransaction.release(this.reconcileTransaction);
	    this.reconcileTransaction = null;
	  },
	
	  perform: function (method, scope, a) {
	    // Essentially calls `this.reconcileTransaction.perform(method, scope, a)`
	    // with this transaction's wrappers around it.
	    return Transaction.Mixin.perform.call(this, this.reconcileTransaction.perform, this.reconcileTransaction, method, scope, a);
	  }
	});
	
	PooledClass.addPoolingTo(ReactUpdatesFlushTransaction);
	
	function batchedUpdates(callback, a, b, c, d, e) {
	  ensureInjected();
	  batchingStrategy.batchedUpdates(callback, a, b, c, d, e);
	}
	
	/**
	 * Array comparator for ReactComponents by mount ordering.
	 *
	 * @param {ReactComponent} c1 first component you're comparing
	 * @param {ReactComponent} c2 second component you're comparing
	 * @return {number} Return value usable by Array.prototype.sort().
	 */
	function mountOrderComparator(c1, c2) {
	  return c1._mountOrder - c2._mountOrder;
	}
	
	function runBatchedUpdates(transaction) {
	  var len = transaction.dirtyComponentsLength;
	  !(len === dirtyComponents.length) ?  false ? invariant(false, 'Expected flush transaction\'s stored dirty-components length (%s) to match dirty-components array length (%s).', len, dirtyComponents.length) : _prodInvariant('124', len, dirtyComponents.length) : void 0;
	
	  // Since reconciling a component higher in the owner hierarchy usually (not
	  // always -- see shouldComponentUpdate()) will reconcile children, reconcile
	  // them before their children by sorting the array.
	  dirtyComponents.sort(mountOrderComparator);
	
	  // Any updates enqueued while reconciling must be performed after this entire
	  // batch. Otherwise, if dirtyComponents is [A, B] where A has children B and
	  // C, B could update twice in a single batch if C's render enqueues an update
	  // to B (since B would have already updated, we should skip it, and the only
	  // way we can know to do so is by checking the batch counter).
	  updateBatchNumber++;
	
	  for (var i = 0; i < len; i++) {
	    // If a component is unmounted before pending changes apply, it will still
	    // be here, but we assume that it has cleared its _pendingCallbacks and
	    // that performUpdateIfNecessary is a noop.
	    var component = dirtyComponents[i];
	
	    // If performUpdateIfNecessary happens to enqueue any new updates, we
	    // shouldn't execute the callbacks until the next render happens, so
	    // stash the callbacks first
	    var callbacks = component._pendingCallbacks;
	    component._pendingCallbacks = null;
	
	    var markerName;
	    if (ReactFeatureFlags.logTopLevelRenders) {
	      var namedComponent = component;
	      // Duck type TopLevelWrapper. This is probably always true.
	      if (component._currentElement.props === component._renderedComponent._currentElement) {
	        namedComponent = component._renderedComponent;
	      }
	      markerName = 'React update: ' + namedComponent.getName();
	      console.time(markerName);
	    }
	
	    ReactReconciler.performUpdateIfNecessary(component, transaction.reconcileTransaction, updateBatchNumber);
	
	    if (markerName) {
	      console.timeEnd(markerName);
	    }
	
	    if (callbacks) {
	      for (var j = 0; j < callbacks.length; j++) {
	        transaction.callbackQueue.enqueue(callbacks[j], component.getPublicInstance());
	      }
	    }
	  }
	}
	
	var flushBatchedUpdates = function () {
	  // ReactUpdatesFlushTransaction's wrappers will clear the dirtyComponents
	  // array and perform any updates enqueued by mount-ready handlers (i.e.,
	  // componentDidUpdate) but we need to check here too in order to catch
	  // updates enqueued by setState callbacks and asap calls.
	  while (dirtyComponents.length || asapEnqueued) {
	    if (dirtyComponents.length) {
	      var transaction = ReactUpdatesFlushTransaction.getPooled();
	      transaction.perform(runBatchedUpdates, null, transaction);
	      ReactUpdatesFlushTransaction.release(transaction);
	    }
	
	    if (asapEnqueued) {
	      asapEnqueued = false;
	      var queue = asapCallbackQueue;
	      asapCallbackQueue = CallbackQueue.getPooled();
	      queue.notifyAll();
	      CallbackQueue.release(queue);
	    }
	  }
	};
	
	/**
	 * Mark a component as needing a rerender, adding an optional callback to a
	 * list of functions which will be executed once the rerender occurs.
	 */
	function enqueueUpdate(component) {
	  ensureInjected();
	
	  // Various parts of our code (such as ReactCompositeComponent's
	  // _renderValidatedComponent) assume that calls to render aren't nested;
	  // verify that that's the case. (This is called by each top-level update
	  // function, like setState, forceUpdate, etc.; creation and
	  // destruction of top-level components is guarded in ReactMount.)
	
	  if (!batchingStrategy.isBatchingUpdates) {
	    batchingStrategy.batchedUpdates(enqueueUpdate, component);
	    return;
	  }
	
	  dirtyComponents.push(component);
	  if (component._updateBatchNumber == null) {
	    component._updateBatchNumber = updateBatchNumber + 1;
	  }
	}
	
	/**
	 * Enqueue a callback to be run at the end of the current batching cycle. Throws
	 * if no updates are currently being performed.
	 */
	function asap(callback, context) {
	  !batchingStrategy.isBatchingUpdates ?  false ? invariant(false, 'ReactUpdates.asap: Can\'t enqueue an asap callback in a context whereupdates are not being batched.') : _prodInvariant('125') : void 0;
	  asapCallbackQueue.enqueue(callback, context);
	  asapEnqueued = true;
	}
	
	var ReactUpdatesInjection = {
	  injectReconcileTransaction: function (ReconcileTransaction) {
	    !ReconcileTransaction ?  false ? invariant(false, 'ReactUpdates: must provide a reconcile transaction class') : _prodInvariant('126') : void 0;
	    ReactUpdates.ReactReconcileTransaction = ReconcileTransaction;
	  },
	
	  injectBatchingStrategy: function (_batchingStrategy) {
	    !_batchingStrategy ?  false ? invariant(false, 'ReactUpdates: must provide a batching strategy') : _prodInvariant('127') : void 0;
	    !(typeof _batchingStrategy.batchedUpdates === 'function') ?  false ? invariant(false, 'ReactUpdates: must provide a batchedUpdates() function') : _prodInvariant('128') : void 0;
	    !(typeof _batchingStrategy.isBatchingUpdates === 'boolean') ?  false ? invariant(false, 'ReactUpdates: must provide an isBatchingUpdates boolean attribute') : _prodInvariant('129') : void 0;
	    batchingStrategy = _batchingStrategy;
	  }
	};
	
	var ReactUpdates = {
	  /**
	   * React references `ReactReconcileTransaction` using this property in order
	   * to allow dependency injection.
	   *
	   * @internal
	   */
	  ReactReconcileTransaction: null,
	
	  batchedUpdates: batchedUpdates,
	  enqueueUpdate: enqueueUpdate,
	  flushBatchedUpdates: flushBatchedUpdates,
	  injection: ReactUpdatesInjection,
	  asap: asap
	};
	
	module.exports = ReactUpdates;

/***/ },
/* 47 */
/***/ function(module, exports, __webpack_require__) {

	// optional / simple context binding
	var aFunction = __webpack_require__(26);
	module.exports = function(fn, that, length){
	  aFunction(fn);
	  if(that === undefined)return fn;
	  switch(length){
	    case 1: return function(a){
	      return fn.call(that, a);
	    };
	    case 2: return function(a, b){
	      return fn.call(that, a, b);
	    };
	    case 3: return function(a, b, c){
	      return fn.call(that, a, b, c);
	    };
	  }
	  return function(/* ...args */){
	    return fn.apply(that, arguments);
	  };
	};

/***/ },
/* 48 */
/***/ function(module, exports, __webpack_require__) {

	var Map     = __webpack_require__(239)
	  , $export = __webpack_require__(1)
	  , shared  = __webpack_require__(114)('metadata')
	  , store   = shared.store || (shared.store = new (__webpack_require__(242)));
	
	var getOrCreateMetadataMap = function(target, targetKey, create){
	  var targetMetadata = store.get(target);
	  if(!targetMetadata){
	    if(!create)return undefined;
	    store.set(target, targetMetadata = new Map);
	  }
	  var keyMetadata = targetMetadata.get(targetKey);
	  if(!keyMetadata){
	    if(!create)return undefined;
	    targetMetadata.set(targetKey, keyMetadata = new Map);
	  } return keyMetadata;
	};
	var ordinaryHasOwnMetadata = function(MetadataKey, O, P){
	  var metadataMap = getOrCreateMetadataMap(O, P, false);
	  return metadataMap === undefined ? false : metadataMap.has(MetadataKey);
	};
	var ordinaryGetOwnMetadata = function(MetadataKey, O, P){
	  var metadataMap = getOrCreateMetadataMap(O, P, false);
	  return metadataMap === undefined ? undefined : metadataMap.get(MetadataKey);
	};
	var ordinaryDefineOwnMetadata = function(MetadataKey, MetadataValue, O, P){
	  getOrCreateMetadataMap(O, P, true).set(MetadataKey, MetadataValue);
	};
	var ordinaryOwnMetadataKeys = function(target, targetKey){
	  var metadataMap = getOrCreateMetadataMap(target, targetKey, false)
	    , keys        = [];
	  if(metadataMap)metadataMap.forEach(function(_, key){ keys.push(key); });
	  return keys;
	};
	var toMetaKey = function(it){
	  return it === undefined || typeof it == 'symbol' ? it : String(it);
	};
	var exp = function(O){
	  $export($export.S, 'Reflect', O);
	};
	
	module.exports = {
	  store: store,
	  map: getOrCreateMetadataMap,
	  has: ordinaryHasOwnMetadata,
	  get: ordinaryGetOwnMetadata,
	  set: ordinaryDefineOwnMetadata,
	  keys: ordinaryOwnMetadataKeys,
	  key: toMetaKey,
	  exp: exp
	};

/***/ },
/* 49 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	if(__webpack_require__(13)){
	  var LIBRARY             = __webpack_require__(65)
	    , global              = __webpack_require__(7)
	    , fails               = __webpack_require__(8)
	    , $export             = __webpack_require__(1)
	    , $typed              = __webpack_require__(115)
	    , $buffer             = __webpack_require__(167)
	    , ctx                 = __webpack_require__(47)
	    , anInstance          = __webpack_require__(55)
	    , propertyDesc        = __webpack_require__(57)
	    , hide                = __webpack_require__(21)
	    , redefineAll         = __webpack_require__(69)
	    , isInteger           = __webpack_require__(154)
	    , toInteger           = __webpack_require__(58)
	    , toLength            = __webpack_require__(16)
	    , toIndex             = __webpack_require__(71)
	    , toPrimitive         = __webpack_require__(44)
	    , has                 = __webpack_require__(19)
	    , same                = __webpack_require__(236)
	    , classof             = __webpack_require__(78)
	    , isObject            = __webpack_require__(10)
	    , toObject            = __webpack_require__(18)
	    , isArrayIter         = __webpack_require__(152)
	    , create              = __webpack_require__(66)
	    , getPrototypeOf      = __webpack_require__(33)
	    , gOPN                = __webpack_require__(67).f
	    , isIterable          = __webpack_require__(360)
	    , getIterFn           = __webpack_require__(169)
	    , uid                 = __webpack_require__(72)
	    , wks                 = __webpack_require__(11)
	    , createArrayMethod   = __webpack_require__(41)
	    , createArrayIncludes = __webpack_require__(104)
	    , speciesConstructor  = __webpack_require__(161)
	    , ArrayIterators      = __webpack_require__(170)
	    , Iterators           = __webpack_require__(64)
	    , $iterDetect         = __webpack_require__(110)
	    , setSpecies          = __webpack_require__(70)
	    , arrayFill           = __webpack_require__(145)
	    , arrayCopyWithin     = __webpack_require__(217)
	    , $DP                 = __webpack_require__(14)
	    , $GOPD               = __webpack_require__(32)
	    , dP                  = $DP.f
	    , gOPD                = $GOPD.f
	    , RangeError          = global.RangeError
	    , TypeError           = global.TypeError
	    , Uint8Array          = global.Uint8Array
	    , ARRAY_BUFFER        = 'ArrayBuffer'
	    , SHARED_BUFFER       = 'Shared' + ARRAY_BUFFER
	    , BYTES_PER_ELEMENT   = 'BYTES_PER_ELEMENT'
	    , PROTOTYPE           = 'prototype'
	    , ArrayProto          = Array[PROTOTYPE]
	    , $ArrayBuffer        = $buffer.ArrayBuffer
	    , $DataView           = $buffer.DataView
	    , arrayForEach        = createArrayMethod(0)
	    , arrayFilter         = createArrayMethod(2)
	    , arraySome           = createArrayMethod(3)
	    , arrayEvery          = createArrayMethod(4)
	    , arrayFind           = createArrayMethod(5)
	    , arrayFindIndex      = createArrayMethod(6)
	    , arrayIncludes       = createArrayIncludes(true)
	    , arrayIndexOf        = createArrayIncludes(false)
	    , arrayValues         = ArrayIterators.values
	    , arrayKeys           = ArrayIterators.keys
	    , arrayEntries        = ArrayIterators.entries
	    , arrayLastIndexOf    = ArrayProto.lastIndexOf
	    , arrayReduce         = ArrayProto.reduce
	    , arrayReduceRight    = ArrayProto.reduceRight
	    , arrayJoin           = ArrayProto.join
	    , arraySort           = ArrayProto.sort
	    , arraySlice          = ArrayProto.slice
	    , arrayToString       = ArrayProto.toString
	    , arrayToLocaleString = ArrayProto.toLocaleString
	    , ITERATOR            = wks('iterator')
	    , TAG                 = wks('toStringTag')
	    , TYPED_CONSTRUCTOR   = uid('typed_constructor')
	    , DEF_CONSTRUCTOR     = uid('def_constructor')
	    , ALL_CONSTRUCTORS    = $typed.CONSTR
	    , TYPED_ARRAY         = $typed.TYPED
	    , VIEW                = $typed.VIEW
	    , WRONG_LENGTH        = 'Wrong length!';
	
	  var $map = createArrayMethod(1, function(O, length){
	    return allocate(speciesConstructor(O, O[DEF_CONSTRUCTOR]), length);
	  });
	
	  var LITTLE_ENDIAN = fails(function(){
	    return new Uint8Array(new Uint16Array([1]).buffer)[0] === 1;
	  });
	
	  var FORCED_SET = !!Uint8Array && !!Uint8Array[PROTOTYPE].set && fails(function(){
	    new Uint8Array(1).set({});
	  });
	
	  var strictToLength = function(it, SAME){
	    if(it === undefined)throw TypeError(WRONG_LENGTH);
	    var number = +it
	      , length = toLength(it);
	    if(SAME && !same(number, length))throw RangeError(WRONG_LENGTH);
	    return length;
	  };
	
	  var toOffset = function(it, BYTES){
	    var offset = toInteger(it);
	    if(offset < 0 || offset % BYTES)throw RangeError('Wrong offset!');
	    return offset;
	  };
	
	  var validate = function(it){
	    if(isObject(it) && TYPED_ARRAY in it)return it;
	    throw TypeError(it + ' is not a typed array!');
	  };
	
	  var allocate = function(C, length){
	    if(!(isObject(C) && TYPED_CONSTRUCTOR in C)){
	      throw TypeError('It is not a typed array constructor!');
	    } return new C(length);
	  };
	
	  var speciesFromList = function(O, list){
	    return fromList(speciesConstructor(O, O[DEF_CONSTRUCTOR]), list);
	  };
	
	  var fromList = function(C, list){
	    var index  = 0
	      , length = list.length
	      , result = allocate(C, length);
	    while(length > index)result[index] = list[index++];
	    return result;
	  };
	
	  var addGetter = function(it, key, internal){
	    dP(it, key, {get: function(){ return this._d[internal]; }});
	  };
	
	  var $from = function from(source /*, mapfn, thisArg */){
	    var O       = toObject(source)
	      , aLen    = arguments.length
	      , mapfn   = aLen > 1 ? arguments[1] : undefined
	      , mapping = mapfn !== undefined
	      , iterFn  = getIterFn(O)
	      , i, length, values, result, step, iterator;
	    if(iterFn != undefined && !isArrayIter(iterFn)){
	      for(iterator = iterFn.call(O), values = [], i = 0; !(step = iterator.next()).done; i++){
	        values.push(step.value);
	      } O = values;
	    }
	    if(mapping && aLen > 2)mapfn = ctx(mapfn, arguments[2], 2);
	    for(i = 0, length = toLength(O.length), result = allocate(this, length); length > i; i++){
	      result[i] = mapping ? mapfn(O[i], i) : O[i];
	    }
	    return result;
	  };
	
	  var $of = function of(/*...items*/){
	    var index  = 0
	      , length = arguments.length
	      , result = allocate(this, length);
	    while(length > index)result[index] = arguments[index++];
	    return result;
	  };
	
	  // iOS Safari 6.x fails here
	  var TO_LOCALE_BUG = !!Uint8Array && fails(function(){ arrayToLocaleString.call(new Uint8Array(1)); });
	
	  var $toLocaleString = function toLocaleString(){
	    return arrayToLocaleString.apply(TO_LOCALE_BUG ? arraySlice.call(validate(this)) : validate(this), arguments);
	  };
	
	  var proto = {
	    copyWithin: function copyWithin(target, start /*, end */){
	      return arrayCopyWithin.call(validate(this), target, start, arguments.length > 2 ? arguments[2] : undefined);
	    },
	    every: function every(callbackfn /*, thisArg */){
	      return arrayEvery(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    fill: function fill(value /*, start, end */){ // eslint-disable-line no-unused-vars
	      return arrayFill.apply(validate(this), arguments);
	    },
	    filter: function filter(callbackfn /*, thisArg */){
	      return speciesFromList(this, arrayFilter(validate(this), callbackfn,
	        arguments.length > 1 ? arguments[1] : undefined));
	    },
	    find: function find(predicate /*, thisArg */){
	      return arrayFind(validate(this), predicate, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    findIndex: function findIndex(predicate /*, thisArg */){
	      return arrayFindIndex(validate(this), predicate, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    forEach: function forEach(callbackfn /*, thisArg */){
	      arrayForEach(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    indexOf: function indexOf(searchElement /*, fromIndex */){
	      return arrayIndexOf(validate(this), searchElement, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    includes: function includes(searchElement /*, fromIndex */){
	      return arrayIncludes(validate(this), searchElement, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    join: function join(separator){ // eslint-disable-line no-unused-vars
	      return arrayJoin.apply(validate(this), arguments);
	    },
	    lastIndexOf: function lastIndexOf(searchElement /*, fromIndex */){ // eslint-disable-line no-unused-vars
	      return arrayLastIndexOf.apply(validate(this), arguments);
	    },
	    map: function map(mapfn /*, thisArg */){
	      return $map(validate(this), mapfn, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    reduce: function reduce(callbackfn /*, initialValue */){ // eslint-disable-line no-unused-vars
	      return arrayReduce.apply(validate(this), arguments);
	    },
	    reduceRight: function reduceRight(callbackfn /*, initialValue */){ // eslint-disable-line no-unused-vars
	      return arrayReduceRight.apply(validate(this), arguments);
	    },
	    reverse: function reverse(){
	      var that   = this
	        , length = validate(that).length
	        , middle = Math.floor(length / 2)
	        , index  = 0
	        , value;
	      while(index < middle){
	        value         = that[index];
	        that[index++] = that[--length];
	        that[length]  = value;
	      } return that;
	    },
	    some: function some(callbackfn /*, thisArg */){
	      return arraySome(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    sort: function sort(comparefn){
	      return arraySort.call(validate(this), comparefn);
	    },
	    subarray: function subarray(begin, end){
	      var O      = validate(this)
	        , length = O.length
	        , $begin = toIndex(begin, length);
	      return new (speciesConstructor(O, O[DEF_CONSTRUCTOR]))(
	        O.buffer,
	        O.byteOffset + $begin * O.BYTES_PER_ELEMENT,
	        toLength((end === undefined ? length : toIndex(end, length)) - $begin)
	      );
	    }
	  };
	
	  var $slice = function slice(start, end){
	    return speciesFromList(this, arraySlice.call(validate(this), start, end));
	  };
	
	  var $set = function set(arrayLike /*, offset */){
	    validate(this);
	    var offset = toOffset(arguments[1], 1)
	      , length = this.length
	      , src    = toObject(arrayLike)
	      , len    = toLength(src.length)
	      , index  = 0;
	    if(len + offset > length)throw RangeError(WRONG_LENGTH);
	    while(index < len)this[offset + index] = src[index++];
	  };
	
	  var $iterators = {
	    entries: function entries(){
	      return arrayEntries.call(validate(this));
	    },
	    keys: function keys(){
	      return arrayKeys.call(validate(this));
	    },
	    values: function values(){
	      return arrayValues.call(validate(this));
	    }
	  };
	
	  var isTAIndex = function(target, key){
	    return isObject(target)
	      && target[TYPED_ARRAY]
	      && typeof key != 'symbol'
	      && key in target
	      && String(+key) == String(key);
	  };
	  var $getDesc = function getOwnPropertyDescriptor(target, key){
	    return isTAIndex(target, key = toPrimitive(key, true))
	      ? propertyDesc(2, target[key])
	      : gOPD(target, key);
	  };
	  var $setDesc = function defineProperty(target, key, desc){
	    if(isTAIndex(target, key = toPrimitive(key, true))
	      && isObject(desc)
	      && has(desc, 'value')
	      && !has(desc, 'get')
	      && !has(desc, 'set')
	      // TODO: add validation descriptor w/o calling accessors
	      && !desc.configurable
	      && (!has(desc, 'writable') || desc.writable)
	      && (!has(desc, 'enumerable') || desc.enumerable)
	    ){
	      target[key] = desc.value;
	      return target;
	    } else return dP(target, key, desc);
	  };
	
	  if(!ALL_CONSTRUCTORS){
	    $GOPD.f = $getDesc;
	    $DP.f   = $setDesc;
	  }
	
	  $export($export.S + $export.F * !ALL_CONSTRUCTORS, 'Object', {
	    getOwnPropertyDescriptor: $getDesc,
	    defineProperty:           $setDesc
	  });
	
	  if(fails(function(){ arrayToString.call({}); })){
	    arrayToString = arrayToLocaleString = function toString(){
	      return arrayJoin.call(this);
	    }
	  }
	
	  var $TypedArrayPrototype$ = redefineAll({}, proto);
	  redefineAll($TypedArrayPrototype$, $iterators);
	  hide($TypedArrayPrototype$, ITERATOR, $iterators.values);
	  redefineAll($TypedArrayPrototype$, {
	    slice:          $slice,
	    set:            $set,
	    constructor:    function(){ /* noop */ },
	    toString:       arrayToString,
	    toLocaleString: $toLocaleString
	  });
	  addGetter($TypedArrayPrototype$, 'buffer', 'b');
	  addGetter($TypedArrayPrototype$, 'byteOffset', 'o');
	  addGetter($TypedArrayPrototype$, 'byteLength', 'l');
	  addGetter($TypedArrayPrototype$, 'length', 'e');
	  dP($TypedArrayPrototype$, TAG, {
	    get: function(){ return this[TYPED_ARRAY]; }
	  });
	
	  module.exports = function(KEY, BYTES, wrapper, CLAMPED){
	    CLAMPED = !!CLAMPED;
	    var NAME       = KEY + (CLAMPED ? 'Clamped' : '') + 'Array'
	      , ISNT_UINT8 = NAME != 'Uint8Array'
	      , GETTER     = 'get' + KEY
	      , SETTER     = 'set' + KEY
	      , TypedArray = global[NAME]
	      , Base       = TypedArray || {}
	      , TAC        = TypedArray && getPrototypeOf(TypedArray)
	      , FORCED     = !TypedArray || !$typed.ABV
	      , O          = {}
	      , TypedArrayPrototype = TypedArray && TypedArray[PROTOTYPE];
	    var getter = function(that, index){
	      var data = that._d;
	      return data.v[GETTER](index * BYTES + data.o, LITTLE_ENDIAN);
	    };
	    var setter = function(that, index, value){
	      var data = that._d;
	      if(CLAMPED)value = (value = Math.round(value)) < 0 ? 0 : value > 0xff ? 0xff : value & 0xff;
	      data.v[SETTER](index * BYTES + data.o, value, LITTLE_ENDIAN);
	    };
	    var addElement = function(that, index){
	      dP(that, index, {
	        get: function(){
	          return getter(this, index);
	        },
	        set: function(value){
	          return setter(this, index, value);
	        },
	        enumerable: true
	      });
	    };
	    if(FORCED){
	      TypedArray = wrapper(function(that, data, $offset, $length){
	        anInstance(that, TypedArray, NAME, '_d');
	        var index  = 0
	          , offset = 0
	          , buffer, byteLength, length, klass;
	        if(!isObject(data)){
	          length     = strictToLength(data, true)
	          byteLength = length * BYTES;
	          buffer     = new $ArrayBuffer(byteLength);
	        } else if(data instanceof $ArrayBuffer || (klass = classof(data)) == ARRAY_BUFFER || klass == SHARED_BUFFER){
	          buffer = data;
	          offset = toOffset($offset, BYTES);
	          var $len = data.byteLength;
	          if($length === undefined){
	            if($len % BYTES)throw RangeError(WRONG_LENGTH);
	            byteLength = $len - offset;
	            if(byteLength < 0)throw RangeError(WRONG_LENGTH);
	          } else {
	            byteLength = toLength($length) * BYTES;
	            if(byteLength + offset > $len)throw RangeError(WRONG_LENGTH);
	          }
	          length = byteLength / BYTES;
	        } else if(TYPED_ARRAY in data){
	          return fromList(TypedArray, data);
	        } else {
	          return $from.call(TypedArray, data);
	        }
	        hide(that, '_d', {
	          b: buffer,
	          o: offset,
	          l: byteLength,
	          e: length,
	          v: new $DataView(buffer)
	        });
	        while(index < length)addElement(that, index++);
	      });
	      TypedArrayPrototype = TypedArray[PROTOTYPE] = create($TypedArrayPrototype$);
	      hide(TypedArrayPrototype, 'constructor', TypedArray);
	    } else if(!$iterDetect(function(iter){
	      // V8 works with iterators, but fails in many other cases
	      // https://code.google.com/p/v8/issues/detail?id=4552
	      new TypedArray(null); // eslint-disable-line no-new
	      new TypedArray(iter); // eslint-disable-line no-new
	    }, true)){
	      TypedArray = wrapper(function(that, data, $offset, $length){
	        anInstance(that, TypedArray, NAME);
	        var klass;
	        // `ws` module bug, temporarily remove validation length for Uint8Array
	        // https://github.com/websockets/ws/pull/645
	        if(!isObject(data))return new Base(strictToLength(data, ISNT_UINT8));
	        if(data instanceof $ArrayBuffer || (klass = classof(data)) == ARRAY_BUFFER || klass == SHARED_BUFFER){
	          return $length !== undefined
	            ? new Base(data, toOffset($offset, BYTES), $length)
	            : $offset !== undefined
	              ? new Base(data, toOffset($offset, BYTES))
	              : new Base(data);
	        }
	        if(TYPED_ARRAY in data)return fromList(TypedArray, data);
	        return $from.call(TypedArray, data);
	      });
	      arrayForEach(TAC !== Function.prototype ? gOPN(Base).concat(gOPN(TAC)) : gOPN(Base), function(key){
	        if(!(key in TypedArray))hide(TypedArray, key, Base[key]);
	      });
	      TypedArray[PROTOTYPE] = TypedArrayPrototype;
	      if(!LIBRARY)TypedArrayPrototype.constructor = TypedArray;
	    }
	    var $nativeIterator   = TypedArrayPrototype[ITERATOR]
	      , CORRECT_ITER_NAME = !!$nativeIterator && ($nativeIterator.name == 'values' || $nativeIterator.name == undefined)
	      , $iterator         = $iterators.values;
	    hide(TypedArray, TYPED_CONSTRUCTOR, true);
	    hide(TypedArrayPrototype, TYPED_ARRAY, NAME);
	    hide(TypedArrayPrototype, VIEW, true);
	    hide(TypedArrayPrototype, DEF_CONSTRUCTOR, TypedArray);
	
	    if(CLAMPED ? new TypedArray(1)[TAG] != NAME : !(TAG in TypedArrayPrototype)){
	      dP(TypedArrayPrototype, TAG, {
	        get: function(){ return NAME; }
	      });
	    }
	
	    O[NAME] = TypedArray;
	
	    $export($export.G + $export.W + $export.F * (TypedArray != Base), O);
	
	    $export($export.S, NAME, {
	      BYTES_PER_ELEMENT: BYTES,
	      from: $from,
	      of: $of
	    });
	
	    if(!(BYTES_PER_ELEMENT in TypedArrayPrototype))hide(TypedArrayPrototype, BYTES_PER_ELEMENT, BYTES);
	
	    $export($export.P, NAME, proto);
	
	    setSpecies(NAME);
	
	    $export($export.P + $export.F * FORCED_SET, NAME, {set: $set});
	
	    $export($export.P + $export.F * !CORRECT_ITER_NAME, NAME, $iterators);
	
	    $export($export.P + $export.F * (TypedArrayPrototype.toString != arrayToString), NAME, {toString: arrayToString});
	
	    $export($export.P + $export.F * fails(function(){
	      new TypedArray(1).slice();
	    }), NAME, {slice: $slice});
	
	    $export($export.P + $export.F * (fails(function(){
	      return [1, 2].toLocaleString() != new TypedArray([1, 2]).toLocaleString()
	    }) || !fails(function(){
	      TypedArrayPrototype.toLocaleString.call([1, 2]);
	    })), NAME, {toLocaleString: $toLocaleString});
	
	    Iterators[NAME] = CORRECT_ITER_NAME ? $nativeIterator : $iterator;
	    if(!LIBRARY && !CORRECT_ITER_NAME)hide(TypedArrayPrototype, ITERATOR, $iterator);
	  };
	} else module.exports = function(){ /* empty */ };

/***/ },
/* 50 */
/***/ function(module, exports) {

	"use strict";
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	/**
	 * Allows extraction of a minified key. Let's the build system minify keys
	 * without losing the ability to dynamically use key strings as values
	 * themselves. Pass in an object with a single key/val pair and it will return
	 * you the string key of that single record. Suppose you want to grab the
	 * value for a key 'className' inside of an object. Key/val minification may
	 * have aliased that key to be 'xa12'. keyOf({className: null}) will return
	 * 'xa12' in that case. Resolve keys you want to use once at startup time, then
	 * reuse those resolutions.
	 */
	var keyOf = function keyOf(oneKeyObj) {
	  var key;
	  for (key in oneKeyObj) {
	    if (!oneKeyObj.hasOwnProperty(key)) {
	      continue;
	    }
	    return key;
	  }
	  return null;
	};
	
	module.exports = keyOf;

/***/ },
/* 51 */
/***/ function(module, exports, __webpack_require__) {

	/* REACT HOT LOADER */ if (false) { (function () { var ReactHotAPI = require("/Users/jnunez/git/medscapetv/node_modules/react-hot-api/modules/index.js"), RootInstanceProvider = require("/Users/jnunez/git/medscapetv/node_modules/react-hot-loader/RootInstanceProvider.js"), ReactMount = require("react/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {
	
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _reflux = __webpack_require__(54);
	
	var _reflux2 = _interopRequireDefault(_reflux);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _reflux2.default.createActions(['slideNavigate', 'selectLanguage', 'scrub', 'closedCaption', 'transcriptOpen', 'commentsOpen', 'transcriptClose', 'commentsClose', 'socialMedia', 'selectVideo', 'internalLink', 'externalLink', 'showMore', 'showLess', 'routeChange', 'sectionScrollView']);
	
	/* REACT HOT LOADER */ }).call(this); } finally { if (false) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("/Users/jnunez/git/medscapetv/node_modules/react-hot-loader/makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot apply hot update to " + "tracking_actions.js" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }

/***/ },
/* 52 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule EventConstants
	 */
	
	'use strict';
	
	var keyMirror = __webpack_require__(117);
	
	var PropagationPhases = keyMirror({ bubbled: null, captured: null });
	
	/**
	 * Types of raw signals from the browser caught at the top level.
	 */
	var topLevelTypes = keyMirror({
	  topAbort: null,
	  topAnimationEnd: null,
	  topAnimationIteration: null,
	  topAnimationStart: null,
	  topBlur: null,
	  topCanPlay: null,
	  topCanPlayThrough: null,
	  topChange: null,
	  topClick: null,
	  topCompositionEnd: null,
	  topCompositionStart: null,
	  topCompositionUpdate: null,
	  topContextMenu: null,
	  topCopy: null,
	  topCut: null,
	  topDoubleClick: null,
	  topDrag: null,
	  topDragEnd: null,
	  topDragEnter: null,
	  topDragExit: null,
	  topDragLeave: null,
	  topDragOver: null,
	  topDragStart: null,
	  topDrop: null,
	  topDurationChange: null,
	  topEmptied: null,
	  topEncrypted: null,
	  topEnded: null,
	  topError: null,
	  topFocus: null,
	  topInput: null,
	  topInvalid: null,
	  topKeyDown: null,
	  topKeyPress: null,
	  topKeyUp: null,
	  topLoad: null,
	  topLoadedData: null,
	  topLoadedMetadata: null,
	  topLoadStart: null,
	  topMouseDown: null,
	  topMouseMove: null,
	  topMouseOut: null,
	  topMouseOver: null,
	  topMouseUp: null,
	  topPaste: null,
	  topPause: null,
	  topPlay: null,
	  topPlaying: null,
	  topProgress: null,
	  topRateChange: null,
	  topReset: null,
	  topScroll: null,
	  topSeeked: null,
	  topSeeking: null,
	  topSelectionChange: null,
	  topStalled: null,
	  topSubmit: null,
	  topSuspend: null,
	  topTextInput: null,
	  topTimeUpdate: null,
	  topTouchCancel: null,
	  topTouchEnd: null,
	  topTouchMove: null,
	  topTouchStart: null,
	  topTransitionEnd: null,
	  topVolumeChange: null,
	  topWaiting: null,
	  topWheel: null
	});
	
	var EventConstants = {
	  topLevelTypes: topLevelTypes,
	  PropagationPhases: PropagationPhases
	};
	
	module.exports = EventConstants;

/***/ },
/* 53 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule SyntheticEvent
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(6);
	
	var PooledClass = __webpack_require__(62);
	
	var emptyFunction = __webpack_require__(37);
	var warning = __webpack_require__(9);
	
	var didWarnForAddedNewProperty = false;
	var isProxySupported = typeof Proxy === 'function';
	
	var shouldBeReleasedProperties = ['dispatchConfig', '_targetInst', 'nativeEvent', 'isDefaultPrevented', 'isPropagationStopped', '_dispatchListeners', '_dispatchInstances'];
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var EventInterface = {
	  type: null,
	  target: null,
	  // currentTarget is set when dispatching; no use in copying it here
	  currentTarget: emptyFunction.thatReturnsNull,
	  eventPhase: null,
	  bubbles: null,
	  cancelable: null,
	  timeStamp: function (event) {
	    return event.timeStamp || Date.now();
	  },
	  defaultPrevented: null,
	  isTrusted: null
	};
	
	/**
	 * Synthetic events are dispatched by event plugins, typically in response to a
	 * top-level event delegation handler.
	 *
	 * These systems should generally use pooling to reduce the frequency of garbage
	 * collection. The system should check `isPersistent` to determine whether the
	 * event should be released into the pool after being dispatched. Users that
	 * need a persisted event should invoke `persist`.
	 *
	 * Synthetic events (and subclasses) implement the DOM Level 3 Events API by
	 * normalizing browser quirks. Subclasses do not necessarily have to implement a
	 * DOM interface; custom application-specific events can also subclass this.
	 *
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {*} targetInst Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @param {DOMEventTarget} nativeEventTarget Target node.
	 */
	function SyntheticEvent(dispatchConfig, targetInst, nativeEvent, nativeEventTarget) {
	  if (false) {
	    // these have a getter/setter for warnings
	    delete this.nativeEvent;
	    delete this.preventDefault;
	    delete this.stopPropagation;
	  }
	
	  this.dispatchConfig = dispatchConfig;
	  this._targetInst = targetInst;
	  this.nativeEvent = nativeEvent;
	
	  var Interface = this.constructor.Interface;
	  for (var propName in Interface) {
	    if (!Interface.hasOwnProperty(propName)) {
	      continue;
	    }
	    if (false) {
	      delete this[propName]; // this has a getter/setter for warnings
	    }
	    var normalize = Interface[propName];
	    if (normalize) {
	      this[propName] = normalize(nativeEvent);
	    } else {
	      if (propName === 'target') {
	        this.target = nativeEventTarget;
	      } else {
	        this[propName] = nativeEvent[propName];
	      }
	    }
	  }
	
	  var defaultPrevented = nativeEvent.defaultPrevented != null ? nativeEvent.defaultPrevented : nativeEvent.returnValue === false;
	  if (defaultPrevented) {
	    this.isDefaultPrevented = emptyFunction.thatReturnsTrue;
	  } else {
	    this.isDefaultPrevented = emptyFunction.thatReturnsFalse;
	  }
	  this.isPropagationStopped = emptyFunction.thatReturnsFalse;
	  return this;
	}
	
	_assign(SyntheticEvent.prototype, {
	
	  preventDefault: function () {
	    this.defaultPrevented = true;
	    var event = this.nativeEvent;
	    if (!event) {
	      return;
	    }
	
	    if (event.preventDefault) {
	      event.preventDefault();
	    } else {
	      event.returnValue = false;
	    }
	    this.isDefaultPrevented = emptyFunction.thatReturnsTrue;
	  },
	
	  stopPropagation: function () {
	    var event = this.nativeEvent;
	    if (!event) {
	      return;
	    }
	
	    if (event.stopPropagation) {
	      event.stopPropagation();
	    } else {
	      event.cancelBubble = true;
	    }
	    this.isPropagationStopped = emptyFunction.thatReturnsTrue;
	  },
	
	  /**
	   * We release all dispatched `SyntheticEvent`s after each event loop, adding
	   * them back into the pool. This allows a way to hold onto a reference that
	   * won't be added back into the pool.
	   */
	  persist: function () {
	    this.isPersistent = emptyFunction.thatReturnsTrue;
	  },
	
	  /**
	   * Checks if this event should be released back into the pool.
	   *
	   * @return {boolean} True if this should not be released, false otherwise.
	   */
	  isPersistent: emptyFunction.thatReturnsFalse,
	
	  /**
	   * `PooledClass` looks for `destructor` on each instance it releases.
	   */
	  destructor: function () {
	    var Interface = this.constructor.Interface;
	    for (var propName in Interface) {
	      if (false) {
	        Object.defineProperty(this, propName, getPooledWarningPropertyDefinition(propName, Interface[propName]));
	      } else {
	        this[propName] = null;
	      }
	    }
	    for (var i = 0; i < shouldBeReleasedProperties.length; i++) {
	      this[shouldBeReleasedProperties[i]] = null;
	    }
	    if (false) {
	      Object.defineProperty(this, 'nativeEvent', getPooledWarningPropertyDefinition('nativeEvent', null));
	      Object.defineProperty(this, 'preventDefault', getPooledWarningPropertyDefinition('preventDefault', emptyFunction));
	      Object.defineProperty(this, 'stopPropagation', getPooledWarningPropertyDefinition('stopPropagation', emptyFunction));
	    }
	  }
	
	});
	
	SyntheticEvent.Interface = EventInterface;
	
	if (false) {
	  if (isProxySupported) {
	    /*eslint-disable no-func-assign */
	    SyntheticEvent = new Proxy(SyntheticEvent, {
	      construct: function (target, args) {
	        return this.apply(target, Object.create(target.prototype), args);
	      },
	      apply: function (constructor, that, args) {
	        return new Proxy(constructor.apply(that, args), {
	          set: function (target, prop, value) {
	            if (prop !== 'isPersistent' && !target.constructor.Interface.hasOwnProperty(prop) && shouldBeReleasedProperties.indexOf(prop) === -1) {
	              process.env.NODE_ENV !== 'production' ? warning(didWarnForAddedNewProperty || target.isPersistent(), 'This synthetic event is reused for performance reasons. If you\'re ' + 'seeing this, you\'re adding a new property in the synthetic event object. ' + 'The property is never released. See ' + 'https://fb.me/react-event-pooling for more information.') : void 0;
	              didWarnForAddedNewProperty = true;
	            }
	            target[prop] = value;
	            return true;
	          }
	        });
	      }
	    });
	    /*eslint-enable no-func-assign */
	  }
	}
	/**
	 * Helper to reduce boilerplate when creating subclasses.
	 *
	 * @param {function} Class
	 * @param {?object} Interface
	 */
	SyntheticEvent.augmentClass = function (Class, Interface) {
	  var Super = this;
	
	  var E = function () {};
	  E.prototype = Super.prototype;
	  var prototype = new E();
	
	  _assign(prototype, Class.prototype);
	  Class.prototype = prototype;
	  Class.prototype.constructor = Class;
	
	  Class.Interface = _assign({}, Super.Interface, Interface);
	  Class.augmentClass = Super.augmentClass;
	
	  PooledClass.addPoolingTo(Class, PooledClass.fourArgumentPooler);
	};
	
	PooledClass.addPoolingTo(SyntheticEvent, PooledClass.fourArgumentPooler);
	
	module.exports = SyntheticEvent;
	
	/**
	  * Helper to nullify syntheticEvent instance properties when destructing
	  *
	  * @param {object} SyntheticEvent
	  * @param {String} propName
	  * @return {object} defineProperty object
	  */
	function getPooledWarningPropertyDefinition(propName, getVal) {
	  var isFunction = typeof getVal === 'function';
	  return {
	    configurable: true,
	    set: set,
	    get: get
	  };
	
	  function set(val) {
	    var action = isFunction ? 'setting the method' : 'setting the property';
	    warn(action, 'This is effectively a no-op');
	    return val;
	  }
	
	  function get() {
	    var action = isFunction ? 'accessing the method' : 'accessing the property';
	    var result = isFunction ? 'This is a no-op function' : 'This is set to null';
	    warn(action, result);
	    return getVal;
	  }
	
	  function warn(action, result) {
	    var warningCondition = false;
	     false ? warning(warningCondition, 'This synthetic event is reused for performance reasons. If you\'re seeing this, ' + 'you\'re %s `%s` on a released/nullified synthetic event. %s. ' + 'If you must keep the original synthetic event around, use event.persist(). ' + 'See https://fb.me/react-event-pooling for more information.', action, propName, result) : void 0;
	  }
	}

/***/ },
/* 54 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(76);


/***/ },
/* 55 */
/***/ function(module, exports) {

	module.exports = function(it, Constructor, name, forbiddenField){
	  if(!(it instanceof Constructor) || (forbiddenField !== undefined && forbiddenField in it)){
	    throw TypeError(name + ': incorrect invocation!');
	  } return it;
	};

/***/ },
/* 56 */
/***/ function(module, exports, __webpack_require__) {

	var META     = __webpack_require__(72)('meta')
	  , isObject = __webpack_require__(10)
	  , has      = __webpack_require__(19)
	  , setDesc  = __webpack_require__(14).f
	  , id       = 0;
	var isExtensible = Object.isExtensible || function(){
	  return true;
	};
	var FREEZE = !__webpack_require__(8)(function(){
	  return isExtensible(Object.preventExtensions({}));
	});
	var setMeta = function(it){
	  setDesc(it, META, {value: {
	    i: 'O' + ++id, // object ID
	    w: {}          // weak collections IDs
	  }});
	};
	var fastKey = function(it, create){
	  // return primitive with prefix
	  if(!isObject(it))return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
	  if(!has(it, META)){
	    // can't set metadata to uncaught frozen object
	    if(!isExtensible(it))return 'F';
	    // not necessary to add metadata
	    if(!create)return 'E';
	    // add missing metadata
	    setMeta(it);
	  // return object ID
	  } return it[META].i;
	};
	var getWeak = function(it, create){
	  if(!has(it, META)){
	    // can't set metadata to uncaught frozen object
	    if(!isExtensible(it))return true;
	    // not necessary to add metadata
	    if(!create)return false;
	    // add missing metadata
	    setMeta(it);
	  // return hash weak collections IDs
	  } return it[META].w;
	};
	// add metadata on freeze-family methods calling
	var onFreeze = function(it){
	  if(FREEZE && meta.NEED && isExtensible(it) && !has(it, META))setMeta(it);
	  return it;
	};
	var meta = module.exports = {
	  KEY:      META,
	  NEED:     false,
	  fastKey:  fastKey,
	  getWeak:  getWeak,
	  onFreeze: onFreeze
	};

/***/ },
/* 57 */
/***/ function(module, exports) {

	module.exports = function(bitmap, value){
	  return {
	    enumerable  : !(bitmap & 1),
	    configurable: !(bitmap & 2),
	    writable    : !(bitmap & 4),
	    value       : value
	  };
	};

/***/ },
/* 58 */
/***/ function(module, exports) {

	// 7.1.4 ToInteger
	var ceil  = Math.ceil
	  , floor = Math.floor;
	module.exports = function(it){
	  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
	};

/***/ },
/* 59 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.createPath = exports.parsePath = exports.getQueryStringValueFromPath = exports.stripQueryStringValueFromPath = exports.addQueryStringValueToPath = undefined;
	
	var _warning = __webpack_require__(63);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var addQueryStringValueToPath = exports.addQueryStringValueToPath = function addQueryStringValueToPath(path, key, value) {
	  var _parsePath = parsePath(path);
	
	  var pathname = _parsePath.pathname;
	  var search = _parsePath.search;
	  var hash = _parsePath.hash;
	
	
	  return createPath({
	    pathname: pathname,
	    search: search + (search.indexOf('?') === -1 ? '?' : '&') + key + '=' + value,
	    hash: hash
	  });
	};
	
	var stripQueryStringValueFromPath = exports.stripQueryStringValueFromPath = function stripQueryStringValueFromPath(path, key) {
	  var _parsePath2 = parsePath(path);
	
	  var pathname = _parsePath2.pathname;
	  var search = _parsePath2.search;
	  var hash = _parsePath2.hash;
	
	
	  return createPath({
	    pathname: pathname,
	    search: search.replace(new RegExp('([?&])' + key + '=[a-zA-Z0-9]+(&?)'), function (match, prefix, suffix) {
	      return prefix === '?' ? prefix : suffix;
	    }),
	    hash: hash
	  });
	};
	
	var getQueryStringValueFromPath = exports.getQueryStringValueFromPath = function getQueryStringValueFromPath(path, key) {
	  var _parsePath3 = parsePath(path);
	
	  var search = _parsePath3.search;
	
	  var match = search.match(new RegExp('[?&]' + key + '=([a-zA-Z0-9]+)'));
	  return match && match[1];
	};
	
	var extractPath = function extractPath(string) {
	  var match = string.match(/^(https?:)?\/\/[^\/]*/);
	  return match == null ? string : string.substring(match[0].length);
	};
	
	var parsePath = exports.parsePath = function parsePath(path) {
	  var pathname = extractPath(path);
	  var search = '';
	  var hash = '';
	
	   false ? (0, _warning2.default)(path === pathname, 'A path must be pathname + search + hash only, not a full URL like "%s"', path) : void 0;
	
	  var hashIndex = pathname.indexOf('#');
	  if (hashIndex !== -1) {
	    hash = pathname.substring(hashIndex);
	    pathname = pathname.substring(0, hashIndex);
	  }
	
	  var searchIndex = pathname.indexOf('?');
	  if (searchIndex !== -1) {
	    search = pathname.substring(searchIndex);
	    pathname = pathname.substring(0, searchIndex);
	  }
	
	  if (pathname === '') pathname = '/';
	
	  return {
	    pathname: pathname,
	    search: search,
	    hash: hash
	  };
	};
	
	var createPath = exports.createPath = function createPath(location) {
	  if (location == null || typeof location === 'string') return location;
	
	  var basename = location.basename;
	  var pathname = location.pathname;
	  var search = location.search;
	  var hash = location.hash;
	
	  var path = (basename || '') + pathname;
	
	  if (search && search !== '?') path += search;
	
	  if (hash) path += hash;
	
	  return path;
	};

/***/ },
/* 60 */
/***/ function(module, exports, __webpack_require__) {

	var getLength = __webpack_require__(616),
	    isFunction = __webpack_require__(135),
	    isLength = __webpack_require__(136);
	
	/**
	 * Checks if `value` is array-like. A value is considered array-like if it's
	 * not a function and has a `value.length` that's an integer greater than or
	 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
	 * @example
	 *
	 * _.isArrayLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isArrayLike(document.body.children);
	 * // => true
	 *
	 * _.isArrayLike('abc');
	 * // => true
	 *
	 * _.isArrayLike(_.noop);
	 * // => false
	 */
	function isArrayLike(value) {
	  return value != null && isLength(getLength(value)) && !isFunction(value);
	}
	
	module.exports = isArrayLike;


/***/ },
/* 61 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.isReactChildren = isReactChildren;
	exports.createRouteFromReactElement = createRouteFromReactElement;
	exports.createRoutesFromReactChildren = createRoutesFromReactChildren;
	exports.createRoutes = createRoutes;
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function isValidChild(object) {
	  return object == null || _react2.default.isValidElement(object);
	}
	
	function isReactChildren(object) {
	  return isValidChild(object) || Array.isArray(object) && object.every(isValidChild);
	}
	
	function createRoute(defaultProps, props) {
	  return _extends({}, defaultProps, props);
	}
	
	function createRouteFromReactElement(element) {
	  var type = element.type;
	  var route = createRoute(type.defaultProps, element.props);
	
	  if (route.children) {
	    var childRoutes = createRoutesFromReactChildren(route.children, route);
	
	    if (childRoutes.length) route.childRoutes = childRoutes;
	
	    delete route.children;
	  }
	
	  return route;
	}
	
	/**
	 * Creates and returns a routes object from the given ReactChildren. JSX
	 * provides a convenient way to visualize how routes in the hierarchy are
	 * nested.
	 *
	 *   import { Route, createRoutesFromReactChildren } from 'react-router'
	 *
	 *   const routes = createRoutesFromReactChildren(
	 *     <Route component={App}>
	 *       <Route path="home" component={Dashboard}/>
	 *       <Route path="news" component={NewsFeed}/>
	 *     </Route>
	 *   )
	 *
	 * Note: This method is automatically used when you provide <Route> children
	 * to a <Router> component.
	 */
	function createRoutesFromReactChildren(children, parentRoute) {
	  var routes = [];
	
	  _react2.default.Children.forEach(children, function (element) {
	    if (_react2.default.isValidElement(element)) {
	      // Component classes may have a static create* method.
	      if (element.type.createRouteFromReactElement) {
	        var route = element.type.createRouteFromReactElement(element, parentRoute);
	
	        if (route) routes.push(route);
	      } else {
	        routes.push(createRouteFromReactElement(element));
	      }
	    }
	  });
	
	  return routes;
	}
	
	/**
	 * Creates and returns an array of routes from the given object which
	 * may be a JSX route, a plain object route, or an array of either.
	 */
	function createRoutes(routes) {
	  if (isReactChildren(routes)) {
	    routes = createRoutesFromReactChildren(routes);
	  } else if (routes && !Array.isArray(routes)) {
	    routes = [routes];
	  }
	
	  return routes;
	}

/***/ },
/* 62 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule PooledClass
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(5);
	
	var invariant = __webpack_require__(2);
	
	/**
	 * Static poolers. Several custom versions for each potential number of
	 * arguments. A completely generic pooler is easy to implement, but would
	 * require accessing the `arguments` object. In each of these, `this` refers to
	 * the Class itself, not an instance. If any others are needed, simply add them
	 * here, or in their own files.
	 */
	var oneArgumentPooler = function (copyFieldsFrom) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, copyFieldsFrom);
	    return instance;
	  } else {
	    return new Klass(copyFieldsFrom);
	  }
	};
	
	var twoArgumentPooler = function (a1, a2) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, a1, a2);
	    return instance;
	  } else {
	    return new Klass(a1, a2);
	  }
	};
	
	var threeArgumentPooler = function (a1, a2, a3) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, a1, a2, a3);
	    return instance;
	  } else {
	    return new Klass(a1, a2, a3);
	  }
	};
	
	var fourArgumentPooler = function (a1, a2, a3, a4) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, a1, a2, a3, a4);
	    return instance;
	  } else {
	    return new Klass(a1, a2, a3, a4);
	  }
	};
	
	var fiveArgumentPooler = function (a1, a2, a3, a4, a5) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, a1, a2, a3, a4, a5);
	    return instance;
	  } else {
	    return new Klass(a1, a2, a3, a4, a5);
	  }
	};
	
	var standardReleaser = function (instance) {
	  var Klass = this;
	  !(instance instanceof Klass) ?  false ? invariant(false, 'Trying to release an instance into a pool of a different type.') : _prodInvariant('25') : void 0;
	  instance.destructor();
	  if (Klass.instancePool.length < Klass.poolSize) {
	    Klass.instancePool.push(instance);
	  }
	};
	
	var DEFAULT_POOL_SIZE = 10;
	var DEFAULT_POOLER = oneArgumentPooler;
	
	/**
	 * Augments `CopyConstructor` to be a poolable class, augmenting only the class
	 * itself (statically) not adding any prototypical fields. Any CopyConstructor
	 * you give this may have a `poolSize` property, and will look for a
	 * prototypical `destructor` on instances.
	 *
	 * @param {Function} CopyConstructor Constructor that can be used to reset.
	 * @param {Function} pooler Customizable pooler.
	 */
	var addPoolingTo = function (CopyConstructor, pooler) {
	  var NewKlass = CopyConstructor;
	  NewKlass.instancePool = [];
	  NewKlass.getPooled = pooler || DEFAULT_POOLER;
	  if (!NewKlass.poolSize) {
	    NewKlass.poolSize = DEFAULT_POOL_SIZE;
	  }
	  NewKlass.release = standardReleaser;
	  return NewKlass;
	};
	
	var PooledClass = {
	  addPoolingTo: addPoolingTo,
	  oneArgumentPooler: oneArgumentPooler,
	  twoArgumentPooler: twoArgumentPooler,
	  threeArgumentPooler: threeArgumentPooler,
	  fourArgumentPooler: fourArgumentPooler,
	  fiveArgumentPooler: fiveArgumentPooler
	};
	
	module.exports = PooledClass;

/***/ },
/* 63 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	'use strict';
	
	/**
	 * Similar to invariant but only logs a warning if the condition is not met.
	 * This can be used to log issues in development environments in critical
	 * paths. Removing the logging code for production environments will keep the
	 * same logic and follow the same code paths.
	 */
	
	var warning = function() {};
	
	if (false) {
	  warning = function(condition, format, args) {
	    var len = arguments.length;
	    args = new Array(len > 2 ? len - 2 : 0);
	    for (var key = 2; key < len; key++) {
	      args[key - 2] = arguments[key];
	    }
	    if (format === undefined) {
	      throw new Error(
	        '`warning(condition, format, ...args)` requires a warning ' +
	        'message argument'
	      );
	    }
	
	    if (format.length < 10 || (/^[s\W]*$/).test(format)) {
	      throw new Error(
	        'The warning format should be able to uniquely identify this ' +
	        'warning. Please, use a more descriptive format than: ' + format
	      );
	    }
	
	    if (!condition) {
	      var argIndex = 0;
	      var message = 'Warning: ' +
	        format.replace(/%s/g, function() {
	          return args[argIndex++];
	        });
	      if (typeof console !== 'undefined') {
	        console.error(message);
	      }
	      try {
	        // This error was thrown as a convenience so that you can use this stack
	        // to find the callsite that caused this warning to fire.
	        throw new Error(message);
	      } catch(x) {}
	    }
	  };
	}
	
	module.exports = warning;


/***/ },
/* 64 */
/***/ function(module, exports) {

	module.exports = {};

/***/ },
/* 65 */
/***/ function(module, exports) {

	module.exports = false;

/***/ },
/* 66 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
	var anObject    = __webpack_require__(4)
	  , dPs         = __webpack_require__(229)
	  , enumBugKeys = __webpack_require__(148)
	  , IE_PROTO    = __webpack_require__(160)('IE_PROTO')
	  , Empty       = function(){ /* empty */ }
	  , PROTOTYPE   = 'prototype';
	
	// Create object with fake `null` prototype: use iframe Object with cleared prototype
	var createDict = function(){
	  // Thrash, waste and sodomy: IE GC bug
	  var iframe = __webpack_require__(147)('iframe')
	    , i      = enumBugKeys.length
	    , gt     = '>'
	    , iframeDocument;
	  iframe.style.display = 'none';
	  __webpack_require__(150).appendChild(iframe);
	  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
	  // createDict = iframe.contentWindow.Object;
	  // html.removeChild(iframe);
	  iframeDocument = iframe.contentWindow.document;
	  iframeDocument.open();
	  iframeDocument.write('<script>document.F=Object</script' + gt);
	  iframeDocument.close();
	  createDict = iframeDocument.F;
	  while(i--)delete createDict[PROTOTYPE][enumBugKeys[i]];
	  return createDict();
	};
	
	module.exports = Object.create || function create(O, Properties){
	  var result;
	  if(O !== null){
	    Empty[PROTOTYPE] = anObject(O);
	    result = new Empty;
	    Empty[PROTOTYPE] = null;
	    // add "__proto__" for Object.getPrototypeOf polyfill
	    result[IE_PROTO] = O;
	  } else result = createDict();
	  return Properties === undefined ? result : dPs(result, Properties);
	};

/***/ },
/* 67 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
	var $keys      = __webpack_require__(231)
	  , hiddenKeys = __webpack_require__(148).concat('length', 'prototype');
	
	exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O){
	  return $keys(O, hiddenKeys);
	};

/***/ },
/* 68 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.14 / 15.2.3.14 Object.keys(O)
	var $keys       = __webpack_require__(231)
	  , enumBugKeys = __webpack_require__(148);
	
	module.exports = Object.keys || function keys(O){
	  return $keys(O, enumBugKeys);
	};

/***/ },
/* 69 */
/***/ function(module, exports, __webpack_require__) {

	var redefine = __webpack_require__(27);
	module.exports = function(target, src, safe){
	  for(var key in src)redefine(target, key, src[key], safe);
	  return target;
	};

/***/ },
/* 70 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var global      = __webpack_require__(7)
	  , dP          = __webpack_require__(14)
	  , DESCRIPTORS = __webpack_require__(13)
	  , SPECIES     = __webpack_require__(11)('species');
	
	module.exports = function(KEY){
	  var C = global[KEY];
	  if(DESCRIPTORS && C && !C[SPECIES])dP.f(C, SPECIES, {
	    configurable: true,
	    get: function(){ return this; }
	  });
	};

/***/ },
/* 71 */
/***/ function(module, exports, __webpack_require__) {

	var toInteger = __webpack_require__(58)
	  , max       = Math.max
	  , min       = Math.min;
	module.exports = function(index, length){
	  index = toInteger(index);
	  return index < 0 ? max(index + length, 0) : min(index, length);
	};

/***/ },
/* 72 */
/***/ function(module, exports) {

	var id = 0
	  , px = Math.random();
	module.exports = function(key){
	  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
	};

/***/ },
/* 73 */
/***/ function(module, exports) {

	/**
	 * Checks if `value` is object-like. A value is object-like if it's not `null`
	 * and has a `typeof` result of "object".
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 * @example
	 *
	 * _.isObjectLike({});
	 * // => true
	 *
	 * _.isObjectLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isObjectLike(_.noop);
	 * // => false
	 *
	 * _.isObjectLike(null);
	 * // => false
	 */
	function isObjectLike(value) {
	  return !!value && typeof value == 'object';
	}
	
	module.exports = isObjectLike;


/***/ },
/* 74 */
/***/ function(module, exports, __webpack_require__) {

	/* REACT HOT LOADER */ if (false) { (function () { var ReactHotAPI = require("/Users/jnunez/git/medscapetv/node_modules/react-hot-api/modules/index.js"), RootInstanceProvider = require("/Users/jnunez/git/medscapetv/node_modules/react-hot-loader/RootInstanceProvider.js"), ReactMount = require("react/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {
	
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _map2 = __webpack_require__(286);
	
	var _map3 = _interopRequireDefault(_map2);
	
	var _reduce2 = __webpack_require__(288);
	
	var _reduce3 = _interopRequireDefault(_reduce2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Utility mixin for dealing with times in the format: HH:MM:SS
	 */
	exports.default = {
	  /**
	   * @param {string} prettyTime - Time in the format HH::MM:SS
	   * @returns {number} - Seconds
	   */
	  secondsFromPrettyTime: function secondsFromPrettyTime(prettyTime) {
	    return (0, _reduce3.default)(prettyTime.split(':').reverse(), function (state, chunk) {
	      return {
	        seconds: state.seconds + parseInt(chunk, 10) * state.multiplier,
	        multiplier: state.multiplier * 60
	      };
	    }, { seconds: 0, multiplier: 1 }).seconds;
	  },
	  /**
	   * @param {number} seconds
	   * @param {number} [places=3] - The number of places to return. E.g. 3 -> '00:00:00' 2 -> '00:00'
	   */
	  secondsToPrettyTime: function secondsToPrettyTime(seconds, places) {
	    var hours = Math.floor(seconds / 3600),
	        minutes = Math.floor((seconds - hours * 3600) / 60),
	        times = [hours, minutes, Math.floor(seconds - hours * 3600 - minutes * 60)];
	    var offset = void 0;
	
	    if (places) {
	      offset = times.length - places;
	    } else {
	      offset = seconds > 60 * 60 ? 0 : 1;
	    }
	
	    return (0, _map3.default)(times.slice(offset), function (time) {
	      if (isNaN(time)) {
	        return '00';
	      } else if (time < 10) {
	        return '0' + time;
	      } else {
	        return time.toString();
	      }
	    }).join(':');
	  }
	};
	
	/* REACT HOT LOADER */ }).call(this); } finally { if (false) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("/Users/jnunez/git/medscapetv/node_modules/react-hot-loader/makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot apply hot update to " + "has_pretty_time.js" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }

/***/ },
/* 75 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactCurrentOwner
	 */
	
	'use strict';
	
	/**
	 * Keeps track of the current owner.
	 *
	 * The current owner is the component who should own any components that are
	 * currently being constructed.
	 */
	
	var ReactCurrentOwner = {
	
	  /**
	   * @internal
	   * @type {ReactComponent}
	   */
	  current: null
	
	};
	
	module.exports = ReactCurrentOwner;

/***/ },
/* 76 */
/***/ function(module, exports, __webpack_require__) {

	exports.ActionMethods = __webpack_require__(804);
	
	exports.ListenerMethods = __webpack_require__(339);
	
	exports.PublisherMethods = __webpack_require__(806);
	
	exports.StoreMethods = __webpack_require__(807);
	
	exports.createAction = __webpack_require__(811);
	
	exports.createStore = __webpack_require__(340);
	
	exports.connect = __webpack_require__(809);
	
	exports.connectFilter = __webpack_require__(810);
	
	exports.ListenerMixin = __webpack_require__(805);
	
	exports.listenTo = __webpack_require__(812);
	
	exports.listenToMany = __webpack_require__(813);
	
	
	var maker = __webpack_require__(341).staticJoinCreator;
	
	exports.joinTrailing = exports.all = maker("last"); // Reflux.all alias for backward compatibility
	
	exports.joinLeading = maker("first");
	
	exports.joinStrict = maker("strict");
	
	exports.joinConcat = maker("all");
	
	var _ = __webpack_require__(25);
	
	exports.EventEmitter = _.EventEmitter;
	
	exports.Promise = _.Promise;
	
	/**
	 * Convenience function for creating a set of actions
	 *
	 * @param definitions the definitions for the actions to be created
	 * @returns an object with actions of corresponding action names
	 */
	exports.createActions = function(definitions) {
	    var actions = {};
	    for (var k in definitions){
	        if (definitions.hasOwnProperty(k)) {
	            var val = definitions[k],
	                actionName = _.isObject(val) ? k : val;
	
	            actions[actionName] = exports.createAction(val);
	        }
	    }
	    return actions;
	};
	
	/**
	 * Sets the eventmitter that Reflux uses
	 */
	exports.setEventEmitter = function(ctx) {
	    var _ = __webpack_require__(25);
	    exports.EventEmitter = _.EventEmitter = ctx;
	};
	
	
	/**
	 * Sets the Promise library that Reflux uses
	 */
	exports.setPromise = function(ctx) {
	    var _ = __webpack_require__(25);
	    exports.Promise = _.Promise = ctx;
	};
	
	
	/**
	 * Sets the Promise factory that creates new promises
	 * @param {Function} factory has the signature `function(resolver) { return [new Promise]; }`
	 */
	exports.setPromiseFactory = function(factory) {
	    var _ = __webpack_require__(25);
	    _.createPromise = factory;
	};
	
	
	/**
	 * Sets the method used for deferring actions and stores
	 */
	exports.nextTick = function(nextTick) {
	    var _ = __webpack_require__(25);
	    _.nextTick = nextTick;
	};
	
	/**
	 * Provides the set of created actions and stores for introspection
	 */
	exports.__keep = __webpack_require__(215);
	
	/**
	 * Warn if Function.prototype.bind not available
	 */
	if (!Function.prototype.bind) {
	  console.error(
	    'Function.prototype.bind not available. ' +
	    'ES5 shim required. ' +
	    'https://github.com/spoike/refluxjs#es5'
	  );
	}


/***/ },
/* 77 */
/***/ function(module, exports, __webpack_require__) {

	// 22.1.3.31 Array.prototype[@@unscopables]
	var UNSCOPABLES = __webpack_require__(11)('unscopables')
	  , ArrayProto  = Array.prototype;
	if(ArrayProto[UNSCOPABLES] == undefined)__webpack_require__(21)(ArrayProto, UNSCOPABLES, {});
	module.exports = function(key){
	  ArrayProto[UNSCOPABLES][key] = true;
	};

/***/ },
/* 78 */
/***/ function(module, exports, __webpack_require__) {

	// getting tag from 19.1.3.6 Object.prototype.toString()
	var cof = __webpack_require__(34)
	  , TAG = __webpack_require__(11)('toStringTag')
	  // ES3 wrong here
	  , ARG = cof(function(){ return arguments; }()) == 'Arguments';
	
	// fallback for IE11 Script Access Denied error
	var tryGet = function(it, key){
	  try {
	    return it[key];
	  } catch(e){ /* empty */ }
	};
	
	module.exports = function(it){
	  var O, T, B;
	  return it === undefined ? 'Undefined' : it === null ? 'Null'
	    // @@toStringTag case
	    : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
	    // builtinTag case
	    : ARG ? cof(O)
	    // ES3 arguments fallback
	    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
	};

/***/ },
/* 79 */
/***/ function(module, exports, __webpack_require__) {

	var ctx         = __webpack_require__(47)
	  , call        = __webpack_require__(225)
	  , isArrayIter = __webpack_require__(152)
	  , anObject    = __webpack_require__(4)
	  , toLength    = __webpack_require__(16)
	  , getIterFn   = __webpack_require__(169)
	  , BREAK       = {}
	  , RETURN      = {};
	var exports = module.exports = function(iterable, entries, fn, that, ITERATOR){
	  var iterFn = ITERATOR ? function(){ return iterable; } : getIterFn(iterable)
	    , f      = ctx(fn, that, entries ? 2 : 1)
	    , index  = 0
	    , length, step, iterator, result;
	  if(typeof iterFn != 'function')throw TypeError(iterable + ' is not iterable!');
	  // fast case for arrays with default iterator
	  if(isArrayIter(iterFn))for(length = toLength(iterable.length); length > index; index++){
	    result = entries ? f(anObject(step = iterable[index])[0], step[1]) : f(iterable[index]);
	    if(result === BREAK || result === RETURN)return result;
	  } else for(iterator = iterFn.call(iterable); !(step = iterator.next()).done; ){
	    result = call(iterator, f, step.value, entries);
	    if(result === BREAK || result === RETURN)return result;
	  }
	};
	exports.BREAK  = BREAK;
	exports.RETURN = RETURN;

/***/ },
/* 80 */
/***/ function(module, exports, __webpack_require__) {

	var def = __webpack_require__(14).f
	  , has = __webpack_require__(19)
	  , TAG = __webpack_require__(11)('toStringTag');
	
	module.exports = function(it, tag, stat){
	  if(it && !has(it = stat ? it : it.prototype, TAG))def(it, TAG, {configurable: true, value: tag});
	};

/***/ },
/* 81 */
/***/ function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(1)
	  , defined = __webpack_require__(35)
	  , fails   = __webpack_require__(8)
	  , spaces  = __webpack_require__(165)
	  , space   = '[' + spaces + ']'
	  , non     = '\u200b\u0085'
	  , ltrim   = RegExp('^' + space + space + '*')
	  , rtrim   = RegExp(space + space + '*$');
	
	var exporter = function(KEY, exec, ALIAS){
	  var exp   = {};
	  var FORCE = fails(function(){
	    return !!spaces[KEY]() || non[KEY]() != non;
	  });
	  var fn = exp[KEY] = FORCE ? exec(trim) : spaces[KEY];
	  if(ALIAS)exp[ALIAS] = fn;
	  $export($export.P + $export.F * FORCE, 'String', exp);
	};
	
	// 1 -> String#trimLeft
	// 2 -> String#trimRight
	// 3 -> String#trim
	var trim = exporter.trim = function(string, TYPE){
	  string = String(defined(string));
	  if(TYPE & 1)string = string.replace(ltrim, '');
	  if(TYPE & 2)string = string.replace(rtrim, '');
	  return string;
	};
	
	module.exports = exporter;

/***/ },
/* 82 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.locationsAreEqual = exports.statesAreEqual = exports.createLocation = exports.createQuery = undefined;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; };
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _invariant = __webpack_require__(23);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _warning = __webpack_require__(63);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _PathUtils = __webpack_require__(59);
	
	var _Actions = __webpack_require__(118);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var createQuery = exports.createQuery = function createQuery(props) {
	  return _extends(Object.create(null), props);
	};
	
	var createLocation = exports.createLocation = function createLocation() {
	  var input = arguments.length <= 0 || arguments[0] === undefined ? '/' : arguments[0];
	  var action = arguments.length <= 1 || arguments[1] === undefined ? _Actions.POP : arguments[1];
	  var key = arguments.length <= 2 || arguments[2] === undefined ? null : arguments[2];
	
	  var object = typeof input === 'string' ? (0, _PathUtils.parsePath)(input) : input;
	
	   false ? (0, _warning2.default)(!object.path, 'Location descriptor objects should have a `pathname`, not a `path`.') : void 0;
	
	  var pathname = object.pathname || '/';
	  var search = object.search || '';
	  var hash = object.hash || '';
	  var state = object.state;
	
	  return {
	    pathname: pathname,
	    search: search,
	    hash: hash,
	    state: state,
	    action: action,
	    key: key
	  };
	};
	
	var isDate = function isDate(object) {
	  return Object.prototype.toString.call(object) === '[object Date]';
	};
	
	var statesAreEqual = exports.statesAreEqual = function statesAreEqual(a, b) {
	  if (a === b) return true;
	
	  var typeofA = typeof a === 'undefined' ? 'undefined' : _typeof(a);
	  var typeofB = typeof b === 'undefined' ? 'undefined' : _typeof(b);
	
	  if (typeofA !== typeofB) return false;
	
	  !(typeofA !== 'function') ?  false ? (0, _invariant2.default)(false, 'You must not store functions in location state') : (0, _invariant2.default)(false) : void 0;
	
	  // Not the same object, but same type.
	  if (typeofA === 'object') {
	    !!(isDate(a) && isDate(b)) ?  false ? (0, _invariant2.default)(false, 'You must not store Date objects in location state') : (0, _invariant2.default)(false) : void 0;
	
	    if (!Array.isArray(a)) {
	      var keysofA = Object.keys(a);
	      var keysofB = Object.keys(b);
	      return keysofA.length === keysofB.length && keysofA.every(function (key) {
	        return statesAreEqual(a[key], b[key]);
	      });
	    }
	
	    return Array.isArray(b) && a.length === b.length && a.every(function (item, index) {
	      return statesAreEqual(item, b[index]);
	    });
	  }
	
	  // All other serializable types (string, number, boolean)
	  // should be strict equal.
	  return false;
	};
	
	var locationsAreEqual = exports.locationsAreEqual = function locationsAreEqual(a, b) {
	  return a.key === b.key &&
	  // a.action === b.action && // Different action !== location change.
	  a.pathname === b.pathname && a.search === b.search && a.hash === b.hash && statesAreEqual(a.state, b.state);
	};

/***/ },
/* 83 */
/***/ function(module, exports, __webpack_require__) {

	var baseIsNative = __webpack_require__(580),
	    getValue = __webpack_require__(618);
	
	/**
	 * Gets the native function at `key` of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {string} key The key of the method to get.
	 * @returns {*} Returns the function if it's native, else `undefined`.
	 */
	function getNative(object, key) {
	  var value = getValue(object, key);
	  return baseIsNative(value) ? value : undefined;
	}
	
	module.exports = getNative;


/***/ },
/* 84 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = __webpack_require__(750);


/***/ },
/* 85 */
/***/ function(module, exports, __webpack_require__) {

	/* REACT HOT LOADER */ if (false) { (function () { var ReactHotAPI = require("/Users/jnunez/git/medscapetv/node_modules/react-hot-api/modules/index.js"), RootInstanceProvider = require("/Users/jnunez/git/medscapetv/node_modules/react-hot-loader/RootInstanceProvider.js"), ReactMount = require("react/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {
	
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _get2 = __webpack_require__(38);
	
	var _get3 = _interopRequireDefault(_get2);
	
	var _throttle2 = __webpack_require__(289);
	
	var _throttle3 = _interopRequireDefault(_throttle2);
	
	var _extend2 = __webpack_require__(282);
	
	var _extend3 = _interopRequireDefault(_extend2);
	
	var _reflux = __webpack_require__(54);
	
	var _reflux2 = _interopRequireDefault(_reflux);
	
	var _reactRouter = __webpack_require__(87);
	
	var _util = __webpack_require__(12);
	
	var _videoApi = __webpack_require__(711);
	
	var _videoApi2 = _interopRequireDefault(_videoApi);
	
	var _config = __webpack_require__(710);
	
	var _config2 = _interopRequireDefault(_config);
	
	var _media_store = __webpack_require__(705);
	
	var _media_store2 = _interopRequireDefault(_media_store);
	
	var _store_state = __webpack_require__(297);
	
	var _store_state2 = _interopRequireDefault(_store_state);
	
	var _video_actions = __webpack_require__(20);
	
	var _video_actions2 = _interopRequireDefault(_video_actions);
	
	var _descriptor_store = __webpack_require__(191);
	
	var _descriptor_store2 = _interopRequireDefault(_descriptor_store);
	
	var _has_pretty_time = __webpack_require__(74);
	
	var _has_pretty_time2 = _interopRequireDefault(_has_pretty_time);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _reflux2.default.createStore({
	  listenables: _video_actions2.default,
	  mixins: [_store_state2.default, _media_store2.default, _has_pretty_time2.default],
	  stateNamespace: 'video',
	  queued: [],
	  getInitialState: function getInitialState() {
	    return {
	      isVideo: true,
	      hasStarted: false
	    };
	  },
	  onLoad: function onLoad(elementId, video) {
	    var _this = this;
	
	    var descriptor = _descriptor_store2.default.getDescriptor(),
	        ampPath = '/amp-premier/',
	        pluginPath = ampPath + 'plugins/',
	        ampURL = (0, _util.isLocal)() ? ampPath : 'http://img' + (0, _util.envCheck)() + '.medscape.com/pi/core' + ampPath,
	        pluginURL = (0, _util.isLocal)() ? pluginPath : 'http://img' + (0, _util.envCheck)() + '.medscape.com/pi/core' + pluginPath,
	        watermark = descriptor.watermark ? descriptor.watermark : '',
	        config = (0, _extend3.default)((0, _config2.default)(pluginURL, ampURL), {
	      media: video,
	      debug: false,
	      autoplay: video.autoplay,
	      playsinline: true,
	      controls: {
	        'native': (0, _util.isMobile)() && !(0, _util.isIpad)(),
	        mode: (0, _util.isMobile)() && !(0, _util.isIpad)() ? 'auto' : 'none'
	      },
	      branding: {
	        id: 'logo',
	        logo: watermark
	      },
	      playoverlay: { enabled: true },
	      captioning: { enabled: !((0, _util.isMobile)() && !(0, _util.isIpad)()) },
	      webmd: {
	        chapterData: descriptor.videos[descriptor.videos.findIndex(function (inVideo) {
	          return inVideo === video;
	        })].chapters
	      },
	      mode: 'html'
	    });
	    config.flash = config.flash || {};
	    config.flash.params = { wmmode: 'transparent' };
	    if (this.mediaApi) {
	      this.removeMediaEvents();
	      this.mediaApi.destroy();
	      if (document.getElementById('captions') !== null) {
	        document.getElementById('captions').parentNode.removeChild(document.getElementById('captions'));
	      }
	      var videoEl = document.getElementById(elementId);
	      videoEl.removeAttribute('crossorigin');
	      while (videoEl.firstChild) {
	        videoEl.removeChild(videoEl.firstChild);
	      }
	    }
	    this.mediaApi = new _videoApi2.default(elementId, config);
	    this.mediaApi.init(function () {
	      _this.mediaApi._v.setAutoplay(config.autoplay && !_this.state.stopAutoplay);
	      _this.addMediaEvents();
	    });
	    this.mediaApi.ready(this.onReady.bind(this));
	    this.setState({
	      meta: video,
	      index: descriptor.videos.findIndex(function (inVideo) {
	        return inVideo === video;
	      }),
	      event: 'loading',
	      isLoading: false,
	      viewed: {},
	      playerType: this.mediaApi._v.getPlayerType()
	    });
	    this.mediaApi._v.getMediaElement().addEventListener('touchend', function () {
	      if (document.getElementById('tvPlayer').classList.contains('presistant-video')) {
	        if (_this.mediaApi._v.getMediaElement().paused) {
	          _this.mediaApi._v.getMediaElement().play();
	        } else {
	          _this.mediaApi._v.getMediaElement().pause();
	        }
	      }
	    });
	    // DEBUG REMOVEME
	    window.mediaApi = this.mediaApi;
	    this.time = false;
	  },
	  exitFullScreenMobile: function exitFullScreenMobile() {
	    if (!(0, _util.isIpad)() && (0, _util.isMobile)()) {
	      this.mediaApi.exitFullScreen();
	      this.mediaApi._v.getMediaElement().setAttribute('controls', '');
	    }
	  },
	  loadMobileCC: function loadMobileCC(index) {
	    var _this2 = this;
	
	    if ((0, _util.isMobile)() && !(0, _util.isIpad)()) {
	      (function () {
	        var ccArray = _descriptor_store2.default.getCCArray(index),
	            ccEnabled = _descriptor_store2.default.hasCCEnabled(index),
	            videoElement = _this2.mediaApi._v.getMediaElement();
	
	        ccArray.forEach(function (ccInfo, i) {
	          var key = Object.keys(ccInfo)[0],
	              ccFileName = ccInfo[key];
	          if (typeof ccFileName !== 'undefined' && ccEnabled === true) {
	            var trackUrl = ((0, _util.imageServer)((0, _util.envCheck)()) + '/' + _descriptor_store2.default.getCCFileRoot(index).replace(/^en\//, '') + ccFileName).replace('.xml', '.vtt'),
	                track = document.createElement('track');
	            videoElement.setAttribute('crossorigin', 'anonymous');
	            _this2.ccLoaded = true;
	            track.kind = 'captions';
	            track.srclang = key;
	            track.label = key;
	            track.src = trackUrl;
	            track.id = 'caption-' + key;
	            if (document.getElementById('caption-' + key) === null) {
	              videoElement.appendChild(track);
	              if (i === 0) {
	                videoElement.mode = 'showing';
	                videoElement.textTracks[i].mode = 'showing';
	              } else {
	                videoElement.textTracks[i].mode = 'hidden';
	              }
	            }
	          }
	        });
	      })();
	    }
	  },
	  getInitDuration: function getInitDuration(meta) {
	    if ((0, _get3.default)(meta, 'duration', false)) {
	      return meta.duration;
	    } else {
	      return this.mediaApi.getDuration() || 0;
	    }
	  },
	  onReady: function onReady() {
	    if (!(0, _util.isMobile)() && !(0, _util.isIpad)()) {
	      this._setupFullScreenIdleDetection();
	    }
	    var meta = _descriptor_store2.default.getVideo(this.state.index);
	    this._isReady = true;
	    this.setState({
	      index: this.state.index,
	      api: this.mediaApi,
	      event: 'ready',
	      isLoading: false,
	      isBuffering: false,
	      isPlaying: false,
	      currentTime: this.mediaApi.getCurrentTime(),
	      duration: this.getDuration(meta),
	      meta: meta,
	      isCaptioningOn: (0, _get3.default)(meta, 'hasCcAutoDisplay', false),
	      ccLang: (0, _get3.default)(meta, 'ccDefaultLang', 'en'),
	      playerType: this.mediaApi._v.getPlayerType()
	    });
	    this.dequeue();
	  },
	  onStopAutoplay: function onStopAutoplay() {
	    this.setState({
	      stopAutoplay: true
	    });
	  },
	  onSelectVideo: function onSelectVideo(video, index) {
	    if (document.getElementById('captions') !== null) {
	      document.getElementById('captions').parentNode.removeChild(document.getElementById('captions'));
	    }
	    if (typeof this.mediaApi === 'undefined' || typeof this.mediaApi._v === 'undefined') {
	      return null;
	    }
	    var videoEl = this.mediaApi._v.getMediaElement();
	    videoEl.removeAttribute('crossorigin');
	    while (videoEl.firstChild) {
	      videoEl.removeChild(videoEl.firstChild);
	    }
	    if (this.mediaApi && !(0, _util.isMobile)()) {
	      this.setVideoTime.call(this, 0, this.mediaApi);
	      this.mediaApi.autoplay = video.autoplay;
	      this.mediaApi._config.autoplay = video.autoplay;
	    }
	    if (!this._isReady) {
	      this.enqueue('onSelectVideo', video, index);
	      return null;
	    }
	    this.mediaApi._v.setAutoplay(video.autoplay);
	    this.mediaApi.setMedia(video);
	    // window.mediaApi = this.mediaApi;
	    this.setState({
	      index: index,
	      meta: video,
	      isPlaying: video.autoplay,
	      isLoading: false,
	      isEnded: false,
	      event: 'videoSelected',
	      currentTime: 0
	    });
	    window.trackingEnabled = false;
	    s_md.pageName = document.location.host.replace('www.', '') + document.location.pathname;
	    s_md.eVar1 = document.location.host.replace('www.', '') + document.location.pathname;
	    s_md.pageURL = document.location.href;
	    s_md.prop7 = document.location.pathname.substring(1);
	  },
	
	  setVideoTime: (0, _throttle3.default)(function (newTime, mediaApi) {
	    if (mediaApi) {
	      mediaApi.setCurrentTime(newTime);
	    }
	  }, 500, {
	    'leading': true,
	    'trailing': false
	  }),
	  onSetCurrentTime: function onSetCurrentTime(time) {
	    if ((0, _util.isIpad)() && !this.state.hasStarted) {
	      this.mediaApi.play();
	    }
	    var meta = _descriptor_store2.default.getVideo(this.state.index);
	    this.clearQueue('onSetCurrentTime');
	    this.setVideoTime.call(this, time, this.mediaApi);
	    if (!this.state.isPlaying) {
	      this.enqueue('onSetCurrentTime', time);
	      this.setState({
	        event: 'settingTime',
	        pushedTime: time,
	        currentTime: time,
	        isLoading: true,
	        duration: meta.duration
	      });
	      return;
	    }
	    // on the first load of a video, the duration isn't set and
	    // setting the current time doesn't work until the player has
	    // started. Because Akamai makes shitty, fragile APIs. This also
	    // has the effect of setting the time optimistically. `pushedTime`
	    // is cleared by the progress event.
	    this.setState({
	      event: 'settingTime',
	      pushedTime: time,
	      currentTime: time,
	      isLoading: true,
	      duration: this.mediaApi.getDuration()
	    });
	  },
	  onBuffering: function onBuffering() {},
	  onProgress: function onProgress() {
	    var bufferredEnd = null;
	    if (this.mediaApi._v.getMediaElement().readyState === 4) {
	      bufferredEnd = this.mediaApi._v.getMediaElement().buffered.end(this.mediaApi._v.getMediaElement().buffered.length - 1);
	    }
	    this.setState({
	      event: 'progress',
	      isBuffering: false,
	      isLoading: false,
	      hasStarted: this.mediaApi.getCurrentTime() !== 0,
	      // WARNING: this is commented out because the video api sends a
	      // bogus 'progress' event after the video has been paused.
	      // Don't set isPlaying to true inside this setState call.
	      // isPlaying:   true, <---- don't do this.
	      // Hopefully that will save you some debugging time in the future.
	      pushedTime: null,
	      currentTime: this.mediaApi.getCurrentTime(),
	      duration: this.mediaApi.getDuration(),
	      bufferredEnd: bufferredEnd
	    });
	  },
	  onSetVolume: function onSetVolume(volume) {
	    this.mediaApi._v.setVolume(volume);
	  },
	  onVolumeChanged: function onVolumeChanged() {
	    this.setState({
	      event: 'volumeChanged',
	      currentVolume: this.mediaApi.getVolume()
	    });
	  },
	  onMute: function onMute() {
	    this.onSetVolume(0);
	  },
	  onUnmute: function onUnmute(volume) {
	    this.onSetVolume(volume);
	  },
	  onSetClosedCaptioning: function onSetClosedCaptioning(turnOn) {
	    if (turnOn) {
	      this.mediaApi.setCaptionLanguage(this.state.ccLang, true);
	      this.mediaApi.turnClosedCaptionOn();
	    } else {
	      this.mediaApi.setCaptionLanguage('', false);
	      this.mediaApi.turnClosedCaptionOff();
	    }
	    this.setState({
	      isCaptioningOn: turnOn
	    });
	  },
	  onSelectLanguage: function onSelectLanguage(lang) {
	    if (lang !== '') {
	      this.mediaApi.setCaptionLanguage(lang, true);
	      this.setState({
	        ccLang: lang,
	        isOpen: false
	      });
	    } else {
	      this.setState({
	        ccLang: lang,
	        isOpen: false
	      });
	    }
	  },
	  onEnd: function onEnd() {},
	  onEnded: function onEnded() {
	    this.mediaApi.end();
	    this.state.viewed[this.state.index] = true;
	    this.setState({
	      isPlaying: false,
	      isEnded: true,
	      event: 'ended'
	    });
	    var index = this.state.index === -1 ? 1 : this.state.index + 1;
	    var nextVideo = _descriptor_store2.default.getVideo(index);
	    if (!nextVideo.autoplay) {
	      this.mediaApi._v.config.autoplay = nextVideo.autoplay;
	      this.mediaApi._config.autoplay = nextVideo.autoplay;
	      this.mediaApi._config.media.autoplay = nextVideo.autoplay;
	    }
	    if (typeof nextVideo !== 'undefined') {
	      var basePath = (0, _util.isLocal)() ? '' : '/mtv/' + window.MedscapeTVInstance.seriesUrlFragment;
	      _reactRouter.browserHistory.push(basePath + '/' + nextVideo.videoUrlFragment);
	    }
	  },
	  onReplay: function onReplay() {
	    window.trackingEnabled = false;
	    this.mediaApi.replay();
	    // the duration gets wiped after the video ends so we have to go back to the config.
	    this.setState({
	      isPlaying: true,
	      duration: this.getDuration(true),
	      hasStarted: true, // always true after the first start
	      isEnded: false,
	      canPlay: false
	    });
	  },
	  onStart: function onStart() {
	    this.mediaApi.play();
	    if (!this._isReady) {
	      this.enqueue('onStart');
	      return;
	    }
	    this.setState({
	      event: 'start',
	      isPlaying: true,
	      hasStarted: true, // always true after the first start
	      isLoading: true,
	      isEnded: false,
	      canPlay: false
	    });
	  },
	  onCanPlay: function onCanPlay() {},
	  onStarted: function onStarted() {
	    var progressPoster = (0, _get3.default)(this, 'state.meta.progressPoster', null);
	    if (progressPoster !== null && !((0, _util.isMobile)() && !(0, _util.isIpad)())) {
	      document.querySelector('.akamai-poster-image').setAttribute('src', progressPoster);
	      if (progressPoster === '') {
	        document.querySelector('.akamai-poster-image').style.display = 'none';
	      }
	    }
	    this.loadMobileCC(this.state.index);
	    this.dequeue();
	    this.setState({
	      isPlaying: true,
	      isLoading: false,
	      isEnded: false,
	      event: 'play',
	      hasStarted: true,
	      currentVolume: this.mediaApi.getVolume()
	    });
	    if (this.state.isCaptioningOn && (!(0, _util.isMobile)() || (0, _util.isIpad)())) {
	      this.mediaApi.setCaptionLanguage(this.state.ccLang, true);
	      this.mediaApi.turnClosedCaptionOn();
	    }
	  },
	  onToggle: function onToggle() {
	    if (this.isPlaying()) {
	      this.onPause();
	    } else {
	      this.onStart();
	    }
	  },
	  getIndex: function getIndex() {
	    return this.state.index;
	  },
	
	  /* accessors */
	  isPlaying: function isPlaying() {
	    return this.state.isPlaying;
	  },
	  getCurrentTime: function getCurrentTime() {
	    if (!this._isReady) return 0;
	    return this.mediaApi.getCurrentTime();
	  },
	  getDuration: function getDuration() {
	    return this.mediaApi.getDuration();
	  },
	  getVideoUrlFragment: function getVideoUrlFragment() {
	    return (0, _get3.default)(this, 'state.meta.videoUrlFragment', '');
	  },
	  getSeriesTitle: function getSeriesTitle() {
	    return _descriptor_store2.default.state.seriesUrlFragment;
	  },
	  getTitle: function getTitle() {
	    return _descriptor_store2.default.getTitle(this.state.index);
	  },
	  getVersion: function getVersion() {
	    return 'Medscape/AMP';
	  }
	}); /* global define BASE_PLUGIN_URL BASE_AMP_URL s_md screenfull */
	
	/* REACT HOT LOADER */ }).call(this); } finally { if (false) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("/Users/jnunez/git/medscapetv/node_modules/react-hot-loader/makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot apply hot update to " + "video_store.js" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }

/***/ },
/* 86 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.compilePattern = compilePattern;
	exports.matchPattern = matchPattern;
	exports.getParamNames = getParamNames;
	exports.getParams = getParams;
	exports.formatPattern = formatPattern;
	
	var _invariant = __webpack_require__(23);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function escapeRegExp(string) {
	  return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
	}
	
	function _compilePattern(pattern) {
	  var regexpSource = '';
	  var paramNames = [];
	  var tokens = [];
	
	  var match = void 0,
	      lastIndex = 0,
	      matcher = /:([a-zA-Z_$][a-zA-Z0-9_$]*)|\*\*|\*|\(|\)/g;
	  while (match = matcher.exec(pattern)) {
	    if (match.index !== lastIndex) {
	      tokens.push(pattern.slice(lastIndex, match.index));
	      regexpSource += escapeRegExp(pattern.slice(lastIndex, match.index));
	    }
	
	    if (match[1]) {
	      regexpSource += '([^/]+)';
	      paramNames.push(match[1]);
	    } else if (match[0] === '**') {
	      regexpSource += '(.*)';
	      paramNames.push('splat');
	    } else if (match[0] === '*') {
	      regexpSource += '(.*?)';
	      paramNames.push('splat');
	    } else if (match[0] === '(') {
	      regexpSource += '(?:';
	    } else if (match[0] === ')') {
	      regexpSource += ')?';
	    }
	
	    tokens.push(match[0]);
	
	    lastIndex = matcher.lastIndex;
	  }
	
	  if (lastIndex !== pattern.length) {
	    tokens.push(pattern.slice(lastIndex, pattern.length));
	    regexpSource += escapeRegExp(pattern.slice(lastIndex, pattern.length));
	  }
	
	  return {
	    pattern: pattern,
	    regexpSource: regexpSource,
	    paramNames: paramNames,
	    tokens: tokens
	  };
	}
	
	var CompiledPatternsCache = Object.create(null);
	
	function compilePattern(pattern) {
	  if (!CompiledPatternsCache[pattern]) CompiledPatternsCache[pattern] = _compilePattern(pattern);
	
	  return CompiledPatternsCache[pattern];
	}
	
	/**
	 * Attempts to match a pattern on the given pathname. Patterns may use
	 * the following special characters:
	 *
	 * - :paramName     Matches a URL segment up to the next /, ?, or #. The
	 *                  captured string is considered a "param"
	 * - ()             Wraps a segment of the URL that is optional
	 * - *              Consumes (non-greedy) all characters up to the next
	 *                  character in the pattern, or to the end of the URL if
	 *                  there is none
	 * - **             Consumes (greedy) all characters up to the next character
	 *                  in the pattern, or to the end of the URL if there is none
	 *
	 *  The function calls callback(error, matched) when finished.
	 * The return value is an object with the following properties:
	 *
	 * - remainingPathname
	 * - paramNames
	 * - paramValues
	 */
	function matchPattern(pattern, pathname) {
	  // Ensure pattern starts with leading slash for consistency with pathname.
	  if (pattern.charAt(0) !== '/') {
	    pattern = '/' + pattern;
	  }
	
	  var _compilePattern2 = compilePattern(pattern),
	      regexpSource = _compilePattern2.regexpSource,
	      paramNames = _compilePattern2.paramNames,
	      tokens = _compilePattern2.tokens;
	
	  if (pattern.charAt(pattern.length - 1) !== '/') {
	    regexpSource += '/?'; // Allow optional path separator at end.
	  }
	
	  // Special-case patterns like '*' for catch-all routes.
	  if (tokens[tokens.length - 1] === '*') {
	    regexpSource += '$';
	  }
	
	  var match = pathname.match(new RegExp('^' + regexpSource, 'i'));
	  if (match == null) {
	    return null;
	  }
	
	  var matchedPath = match[0];
	  var remainingPathname = pathname.substr(matchedPath.length);
	
	  if (remainingPathname) {
	    // Require that the match ends at a path separator, if we didn't match
	    // the full path, so any remaining pathname is a new path segment.
	    if (matchedPath.charAt(matchedPath.length - 1) !== '/') {
	      return null;
	    }
	
	    // If there is a remaining pathname, treat the path separator as part of
	    // the remaining pathname for properly continuing the match.
	    remainingPathname = '/' + remainingPathname;
	  }
	
	  return {
	    remainingPathname: remainingPathname,
	    paramNames: paramNames,
	    paramValues: match.slice(1).map(function (v) {
	      return v && decodeURIComponent(v);
	    })
	  };
	}
	
	function getParamNames(pattern) {
	  return compilePattern(pattern).paramNames;
	}
	
	function getParams(pattern, pathname) {
	  var match = matchPattern(pattern, pathname);
	  if (!match) {
	    return null;
	  }
	
	  var paramNames = match.paramNames,
	      paramValues = match.paramValues;
	
	  var params = {};
	
	  paramNames.forEach(function (paramName, index) {
	    params[paramName] = paramValues[index];
	  });
	
	  return params;
	}
	
	/**
	 * Returns a version of the given pattern with params interpolated. Throws
	 * if there is a dynamic segment of the pattern for which there is no param.
	 */
	function formatPattern(pattern, params) {
	  params = params || {};
	
	  var _compilePattern3 = compilePattern(pattern),
	      tokens = _compilePattern3.tokens;
	
	  var parenCount = 0,
	      pathname = '',
	      splatIndex = 0,
	      parenHistory = [];
	
	  var token = void 0,
	      paramName = void 0,
	      paramValue = void 0;
	  for (var i = 0, len = tokens.length; i < len; ++i) {
	    token = tokens[i];
	
	    if (token === '*' || token === '**') {
	      paramValue = Array.isArray(params.splat) ? params.splat[splatIndex++] : params.splat;
	
	      !(paramValue != null || parenCount > 0) ?  false ? (0, _invariant2.default)(false, 'Missing splat #%s for path "%s"', splatIndex, pattern) : (0, _invariant2.default)(false) : void 0;
	
	      if (paramValue != null) pathname += encodeURI(paramValue);
	    } else if (token === '(') {
	      parenHistory[parenCount] = '';
	      parenCount += 1;
	    } else if (token === ')') {
	      var parenText = parenHistory.pop();
	      parenCount -= 1;
	
	      if (parenCount) parenHistory[parenCount - 1] += parenText;else pathname += parenText;
	    } else if (token.charAt(0) === ':') {
	      paramName = token.substring(1);
	      paramValue = params[paramName];
	
	      !(paramValue != null || parenCount > 0) ?  false ? (0, _invariant2.default)(false, 'Missing "%s" parameter for path "%s"', paramName, pattern) : (0, _invariant2.default)(false) : void 0;
	
	      if (paramValue == null) {
	        if (parenCount) {
	          parenHistory[parenCount - 1] = '';
	
	          var curTokenIdx = tokens.indexOf(token);
	          var tokensSubset = tokens.slice(curTokenIdx, tokens.length);
	          var nextParenIdx = -1;
	
	          for (var _i = 0; _i < tokensSubset.length; _i++) {
	            if (tokensSubset[_i] == ')') {
	              nextParenIdx = _i;
	              break;
	            }
	          }
	
	          !(nextParenIdx > 0) ?  false ? (0, _invariant2.default)(false, 'Path "%s" is missing end paren at segment "%s"', pattern, tokensSubset.join('')) : (0, _invariant2.default)(false) : void 0;
	
	          // jump to ending paren
	          i = curTokenIdx + nextParenIdx - 1;
	        }
	      } else if (parenCount) parenHistory[parenCount - 1] += encodeURIComponent(paramValue);else pathname += encodeURIComponent(paramValue);
	    } else {
	      if (parenCount) parenHistory[parenCount - 1] += token;else pathname += token;
	    }
	  }
	
	  !(parenCount <= 0) ?  false ? (0, _invariant2.default)(false, 'Path "%s" is missing end paren', pattern) : (0, _invariant2.default)(false) : void 0;
	
	  return pathname.replace(/\/+/g, '/');
	}

/***/ },
/* 87 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.createMemoryHistory = exports.hashHistory = exports.browserHistory = exports.applyRouterMiddleware = exports.formatPattern = exports.useRouterHistory = exports.match = exports.routerShape = exports.locationShape = exports.RouterContext = exports.createRoutes = exports.Route = exports.Redirect = exports.IndexRoute = exports.IndexRedirect = exports.withRouter = exports.IndexLink = exports.Link = exports.Router = undefined;
	
	var _RouteUtils = __webpack_require__(61);
	
	Object.defineProperty(exports, 'createRoutes', {
	  enumerable: true,
	  get: function get() {
	    return _RouteUtils.createRoutes;
	  }
	});
	
	var _PropTypes = __webpack_require__(194);
	
	Object.defineProperty(exports, 'locationShape', {
	  enumerable: true,
	  get: function get() {
	    return _PropTypes.locationShape;
	  }
	});
	Object.defineProperty(exports, 'routerShape', {
	  enumerable: true,
	  get: function get() {
	    return _PropTypes.routerShape;
	  }
	});
	
	var _PatternUtils = __webpack_require__(86);
	
	Object.defineProperty(exports, 'formatPattern', {
	  enumerable: true,
	  get: function get() {
	    return _PatternUtils.formatPattern;
	  }
	});
	
	var _Router2 = __webpack_require__(718);
	
	var _Router3 = _interopRequireDefault(_Router2);
	
	var _Link2 = __webpack_require__(299);
	
	var _Link3 = _interopRequireDefault(_Link2);
	
	var _IndexLink2 = __webpack_require__(714);
	
	var _IndexLink3 = _interopRequireDefault(_IndexLink2);
	
	var _withRouter2 = __webpack_require__(729);
	
	var _withRouter3 = _interopRequireDefault(_withRouter2);
	
	var _IndexRedirect2 = __webpack_require__(715);
	
	var _IndexRedirect3 = _interopRequireDefault(_IndexRedirect2);
	
	var _IndexRoute2 = __webpack_require__(716);
	
	var _IndexRoute3 = _interopRequireDefault(_IndexRoute2);
	
	var _Redirect2 = __webpack_require__(301);
	
	var _Redirect3 = _interopRequireDefault(_Redirect2);
	
	var _Route2 = __webpack_require__(717);
	
	var _Route3 = _interopRequireDefault(_Route2);
	
	var _RouterContext2 = __webpack_require__(195);
	
	var _RouterContext3 = _interopRequireDefault(_RouterContext2);
	
	var _match2 = __webpack_require__(727);
	
	var _match3 = _interopRequireDefault(_match2);
	
	var _useRouterHistory2 = __webpack_require__(306);
	
	var _useRouterHistory3 = _interopRequireDefault(_useRouterHistory2);
	
	var _applyRouterMiddleware2 = __webpack_require__(720);
	
	var _applyRouterMiddleware3 = _interopRequireDefault(_applyRouterMiddleware2);
	
	var _browserHistory2 = __webpack_require__(721);
	
	var _browserHistory3 = _interopRequireDefault(_browserHistory2);
	
	var _hashHistory2 = __webpack_require__(725);
	
	var _hashHistory3 = _interopRequireDefault(_hashHistory2);
	
	var _createMemoryHistory2 = __webpack_require__(303);
	
	var _createMemoryHistory3 = _interopRequireDefault(_createMemoryHistory2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.Router = _Router3.default; /* components */
	
	exports.Link = _Link3.default;
	exports.IndexLink = _IndexLink3.default;
	exports.withRouter = _withRouter3.default;
	
	/* components (configuration) */
	
	exports.IndexRedirect = _IndexRedirect3.default;
	exports.IndexRoute = _IndexRoute3.default;
	exports.Redirect = _Redirect3.default;
	exports.Route = _Route3.default;
	
	/* utils */
	
	exports.RouterContext = _RouterContext3.default;
	exports.match = _match3.default;
	exports.useRouterHistory = _useRouterHistory3.default;
	exports.applyRouterMiddleware = _applyRouterMiddleware3.default;
	
	/* histories */
	
	exports.browserHistory = _browserHistory3.default;
	exports.hashHistory = _hashHistory3.default;
	exports.createMemoryHistory = _createMemoryHistory3.default;

/***/ },
/* 88 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = routerWarning;
	exports._resetWarned = _resetWarned;
	
	var _warning = __webpack_require__(63);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var warned = {};
	
	function routerWarning(falseToWarn, message) {
	  // Only issue deprecation warnings once.
	  if (message.indexOf('deprecated') !== -1) {
	    if (warned[message]) {
	      return;
	    }
	
	    warned[message] = true;
	  }
	
	  message = '[react-router] ' + message;
	
	  for (var _len = arguments.length, args = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
	    args[_key - 2] = arguments[_key];
	  }
	
	  _warning2.default.apply(undefined, [falseToWarn, message].concat(args));
	}
	
	function _resetWarned() {
	  warned = {};
	}

/***/ },
/* 89 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule DOMLazyTree
	 */
	
	'use strict';
	
	var DOMNamespaces = __webpack_require__(197);
	var setInnerHTML = __webpack_require__(143);
	
	var createMicrosoftUnsafeLocalFunction = __webpack_require__(207);
	var setTextContent = __webpack_require__(338);
	
	var ELEMENT_NODE_TYPE = 1;
	var DOCUMENT_FRAGMENT_NODE_TYPE = 11;
	
	/**
	 * In IE (8-11) and Edge, appending nodes with no children is dramatically
	 * faster than appending a full subtree, so we essentially queue up the
	 * .appendChild calls here and apply them so each node is added to its parent
	 * before any children are added.
	 *
	 * In other browsers, doing so is slower or neutral compared to the other order
	 * (in Firefox, twice as slow) so we only do this inversion in IE.
	 *
	 * See https://github.com/spicyj/innerhtml-vs-createelement-vs-clonenode.
	 */
	var enableLazy = typeof document !== 'undefined' && typeof document.documentMode === 'number' || typeof navigator !== 'undefined' && typeof navigator.userAgent === 'string' && /\bEdge\/\d/.test(navigator.userAgent);
	
	function insertTreeChildren(tree) {
	  if (!enableLazy) {
	    return;
	  }
	  var node = tree.node;
	  var children = tree.children;
	  if (children.length) {
	    for (var i = 0; i < children.length; i++) {
	      insertTreeBefore(node, children[i], null);
	    }
	  } else if (tree.html != null) {
	    setInnerHTML(node, tree.html);
	  } else if (tree.text != null) {
	    setTextContent(node, tree.text);
	  }
	}
	
	var insertTreeBefore = createMicrosoftUnsafeLocalFunction(function (parentNode, tree, referenceNode) {
	  // DocumentFragments aren't actually part of the DOM after insertion so
	  // appending children won't update the DOM. We need to ensure the fragment
	  // is properly populated first, breaking out of our lazy approach for just
	  // this level. Also, some <object> plugins (like Flash Player) will read
	  // <param> nodes immediately upon insertion into the DOM, so <object>
	  // must also be populated prior to insertion into the DOM.
	  if (tree.node.nodeType === DOCUMENT_FRAGMENT_NODE_TYPE || tree.node.nodeType === ELEMENT_NODE_TYPE && tree.node.nodeName.toLowerCase() === 'object' && (tree.node.namespaceURI == null || tree.node.namespaceURI === DOMNamespaces.html)) {
	    insertTreeChildren(tree);
	    parentNode.insertBefore(tree.node, referenceNode);
	  } else {
	    parentNode.insertBefore(tree.node, referenceNode);
	    insertTreeChildren(tree);
	  }
	});
	
	function replaceChildWithTree(oldNode, newTree) {
	  oldNode.parentNode.replaceChild(newTree.node, oldNode);
	  insertTreeChildren(newTree);
	}
	
	function queueChild(parentTree, childTree) {
	  if (enableLazy) {
	    parentTree.children.push(childTree);
	  } else {
	    parentTree.node.appendChild(childTree.node);
	  }
	}
	
	function queueHTML(tree, html) {
	  if (enableLazy) {
	    tree.html = html;
	  } else {
	    setInnerHTML(tree.node, html);
	  }
	}
	
	function queueText(tree, text) {
	  if (enableLazy) {
	    tree.text = text;
	  } else {
	    setTextContent(tree.node, text);
	  }
	}
	
	function toString() {
	  return this.node.nodeName;
	}
	
	function DOMLazyTree(node) {
	  return {
	    node: node,
	    children: [],
	    html: null,
	    text: null,
	    toString: toString
	  };
	}
	
	DOMLazyTree.insertTreeBefore = insertTreeBefore;
	DOMLazyTree.replaceChildWithTree = replaceChildWithTree;
	DOMLazyTree.queueChild = queueChild;
	DOMLazyTree.queueHTML = queueHTML;
	DOMLazyTree.queueText = queueText;
	
	module.exports = DOMLazyTree;

/***/ },
/* 90 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule DOMProperty
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(5);
	
	var invariant = __webpack_require__(2);
	
	function checkMask(value, bitmask) {
	  return (value & bitmask) === bitmask;
	}
	
	var DOMPropertyInjection = {
	  /**
	   * Mapping from normalized, camelcased property names to a configuration that
	   * specifies how the associated DOM property should be accessed or rendered.
	   */
	  MUST_USE_PROPERTY: 0x1,
	  HAS_BOOLEAN_VALUE: 0x4,
	  HAS_NUMERIC_VALUE: 0x8,
	  HAS_POSITIVE_NUMERIC_VALUE: 0x10 | 0x8,
	  HAS_OVERLOADED_BOOLEAN_VALUE: 0x20,
	
	  /**
	   * Inject some specialized knowledge about the DOM. This takes a config object
	   * with the following properties:
	   *
	   * isCustomAttribute: function that given an attribute name will return true
	   * if it can be inserted into the DOM verbatim. Useful for data-* or aria-*
	   * attributes where it's impossible to enumerate all of the possible
	   * attribute names,
	   *
	   * Properties: object mapping DOM property name to one of the
	   * DOMPropertyInjection constants or null. If your attribute isn't in here,
	   * it won't get written to the DOM.
	   *
	   * DOMAttributeNames: object mapping React attribute name to the DOM
	   * attribute name. Attribute names not specified use the **lowercase**
	   * normalized name.
	   *
	   * DOMAttributeNamespaces: object mapping React attribute name to the DOM
	   * attribute namespace URL. (Attribute names not specified use no namespace.)
	   *
	   * DOMPropertyNames: similar to DOMAttributeNames but for DOM properties.
	   * Property names not specified use the normalized name.
	   *
	   * DOMMutationMethods: Properties that require special mutation methods. If
	   * `value` is undefined, the mutation method should unset the property.
	   *
	   * @param {object} domPropertyConfig the config as described above.
	   */
	  injectDOMPropertyConfig: function (domPropertyConfig) {
	    var Injection = DOMPropertyInjection;
	    var Properties = domPropertyConfig.Properties || {};
	    var DOMAttributeNamespaces = domPropertyConfig.DOMAttributeNamespaces || {};
	    var DOMAttributeNames = domPropertyConfig.DOMAttributeNames || {};
	    var DOMPropertyNames = domPropertyConfig.DOMPropertyNames || {};
	    var DOMMutationMethods = domPropertyConfig.DOMMutationMethods || {};
	
	    if (domPropertyConfig.isCustomAttribute) {
	      DOMProperty._isCustomAttributeFunctions.push(domPropertyConfig.isCustomAttribute);
	    }
	
	    for (var propName in Properties) {
	      !!DOMProperty.properties.hasOwnProperty(propName) ?  false ? invariant(false, 'injectDOMPropertyConfig(...): You\'re trying to inject DOM property \'%s\' which has already been injected. You may be accidentally injecting the same DOM property config twice, or you may be injecting two configs that have conflicting property names.', propName) : _prodInvariant('48', propName) : void 0;
	
	      var lowerCased = propName.toLowerCase();
	      var propConfig = Properties[propName];
	
	      var propertyInfo = {
	        attributeName: lowerCased,
	        attributeNamespace: null,
	        propertyName: propName,
	        mutationMethod: null,
	
	        mustUseProperty: checkMask(propConfig, Injection.MUST_USE_PROPERTY),
	        hasBooleanValue: checkMask(propConfig, Injection.HAS_BOOLEAN_VALUE),
	        hasNumericValue: checkMask(propConfig, Injection.HAS_NUMERIC_VALUE),
	        hasPositiveNumericValue: checkMask(propConfig, Injection.HAS_POSITIVE_NUMERIC_VALUE),
	        hasOverloadedBooleanValue: checkMask(propConfig, Injection.HAS_OVERLOADED_BOOLEAN_VALUE)
	      };
	      !(propertyInfo.hasBooleanValue + propertyInfo.hasNumericValue + propertyInfo.hasOverloadedBooleanValue <= 1) ?  false ? invariant(false, 'DOMProperty: Value can be one of boolean, overloaded boolean, or numeric value, but not a combination: %s', propName) : _prodInvariant('50', propName) : void 0;
	
	      if (false) {
	        DOMProperty.getPossibleStandardName[lowerCased] = propName;
	      }
	
	      if (DOMAttributeNames.hasOwnProperty(propName)) {
	        var attributeName = DOMAttributeNames[propName];
	        propertyInfo.attributeName = attributeName;
	        if (false) {
	          DOMProperty.getPossibleStandardName[attributeName] = propName;
	        }
	      }
	
	      if (DOMAttributeNamespaces.hasOwnProperty(propName)) {
	        propertyInfo.attributeNamespace = DOMAttributeNamespaces[propName];
	      }
	
	      if (DOMPropertyNames.hasOwnProperty(propName)) {
	        propertyInfo.propertyName = DOMPropertyNames[propName];
	      }
	
	      if (DOMMutationMethods.hasOwnProperty(propName)) {
	        propertyInfo.mutationMethod = DOMMutationMethods[propName];
	      }
	
	      DOMProperty.properties[propName] = propertyInfo;
	    }
	  }
	};
	
	/* eslint-disable max-len */
	var ATTRIBUTE_NAME_START_CHAR = ':A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD';
	/* eslint-enable max-len */
	
	/**
	 * DOMProperty exports lookup objects that can be used like functions:
	 *
	 *   > DOMProperty.isValid['id']
	 *   true
	 *   > DOMProperty.isValid['foobar']
	 *   undefined
	 *
	 * Although this may be confusing, it performs better in general.
	 *
	 * @see http://jsperf.com/key-exists
	 * @see http://jsperf.com/key-missing
	 */
	var DOMProperty = {
	
	  ID_ATTRIBUTE_NAME: 'data-reactid',
	  ROOT_ATTRIBUTE_NAME: 'data-reactroot',
	
	  ATTRIBUTE_NAME_START_CHAR: ATTRIBUTE_NAME_START_CHAR,
	  ATTRIBUTE_NAME_CHAR: ATTRIBUTE_NAME_START_CHAR + '\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040',
	
	  /**
	   * Map from property "standard name" to an object with info about how to set
	   * the property in the DOM. Each object contains:
	   *
	   * attributeName:
	   *   Used when rendering markup or with `*Attribute()`.
	   * attributeNamespace
	   * propertyName:
	   *   Used on DOM node instances. (This includes properties that mutate due to
	   *   external factors.)
	   * mutationMethod:
	   *   If non-null, used instead of the property or `setAttribute()` after
	   *   initial render.
	   * mustUseProperty:
	   *   Whether the property must be accessed and mutated as an object property.
	   * hasBooleanValue:
	   *   Whether the property should be removed when set to a falsey value.
	   * hasNumericValue:
	   *   Whether the property must be numeric or parse as a numeric and should be
	   *   removed when set to a falsey value.
	   * hasPositiveNumericValue:
	   *   Whether the property must be positive numeric or parse as a positive
	   *   numeric and should be removed when set to a falsey value.
	   * hasOverloadedBooleanValue:
	   *   Whether the property can be used as a flag as well as with a value.
	   *   Removed when strictly equal to false; present without a value when
	   *   strictly equal to true; present with a value otherwise.
	   */
	  properties: {},
	
	  /**
	   * Mapping from lowercase property names to the properly cased version, used
	   * to warn in the case of missing properties. Available only in __DEV__.
	   * @type {Object}
	   */
	  getPossibleStandardName:  false ? {} : null,
	
	  /**
	   * All of the isCustomAttribute() functions that have been injected.
	   */
	  _isCustomAttributeFunctions: [],
	
	  /**
	   * Checks whether a property name is a custom attribute.
	   * @method
	   */
	  isCustomAttribute: function (attributeName) {
	    for (var i = 0; i < DOMProperty._isCustomAttributeFunctions.length; i++) {
	      var isCustomAttributeFn = DOMProperty._isCustomAttributeFunctions[i];
	      if (isCustomAttributeFn(attributeName)) {
	        return true;
	      }
	    }
	    return false;
	  },
	
	  injection: DOMPropertyInjection
	};
	
	module.exports = DOMProperty;

/***/ },
/* 91 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactReconciler
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(5);
	
	var ReactRef = __webpack_require__(774);
	var ReactInstrumentation = __webpack_require__(31);
	
	var invariant = __webpack_require__(2);
	
	/**
	 * Helper to call ReactRef.attachRefs with this composite component, split out
	 * to avoid allocations in the transaction mount-ready queue.
	 */
	function attachRefs() {
	  ReactRef.attachRefs(this, this._currentElement);
	}
	
	var ReactReconciler = {
	
	  /**
	   * Initializes the component, renders markup, and registers event listeners.
	   *
	   * @param {ReactComponent} internalInstance
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {?object} the containing host component instance
	   * @param {?object} info about the host container
	   * @return {?string} Rendered markup to be inserted into the DOM.
	   * @final
	   * @internal
	   */
	  mountComponent: function (internalInstance, transaction, hostParent, hostContainerInfo, context) {
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onBeforeMountComponent(internalInstance._debugID, internalInstance._currentElement);
	        ReactInstrumentation.debugTool.onBeginReconcilerTimer(internalInstance._debugID, 'mountComponent');
	      }
	    }
	    var markup = internalInstance.mountComponent(transaction, hostParent, hostContainerInfo, context);
	    if (internalInstance._currentElement && internalInstance._currentElement.ref != null) {
	      transaction.getReactMountReady().enqueue(attachRefs, internalInstance);
	    }
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onEndReconcilerTimer(internalInstance._debugID, 'mountComponent');
	        ReactInstrumentation.debugTool.onMountComponent(internalInstance._debugID);
	      }
	    }
	    return markup;
	  },
	
	  /**
	   * Returns a value that can be passed to
	   * ReactComponentEnvironment.replaceNodeWithMarkup.
	   */
	  getHostNode: function (internalInstance) {
	    return internalInstance.getHostNode();
	  },
	
	  /**
	   * Releases any resources allocated by `mountComponent`.
	   *
	   * @final
	   * @internal
	   */
	  unmountComponent: function (internalInstance, safely) {
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onBeginReconcilerTimer(internalInstance._debugID, 'unmountComponent');
	      }
	    }
	    ReactRef.detachRefs(internalInstance, internalInstance._currentElement);
	    internalInstance.unmountComponent(safely);
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onEndReconcilerTimer(internalInstance._debugID, 'unmountComponent');
	        ReactInstrumentation.debugTool.onUnmountComponent(internalInstance._debugID);
	      }
	    }
	  },
	
	  /**
	   * Update a component using a new element.
	   *
	   * @param {ReactComponent} internalInstance
	   * @param {ReactElement} nextElement
	   * @param {ReactReconcileTransaction} transaction
	   * @param {object} context
	   * @internal
	   */
	  receiveComponent: function (internalInstance, nextElement, transaction, context) {
	    var prevElement = internalInstance._currentElement;
	
	    if (nextElement === prevElement && context === internalInstance._context) {
	      // Since elements are immutable after the owner is rendered,
	      // we can do a cheap identity compare here to determine if this is a
	      // superfluous reconcile. It's possible for state to be mutable but such
	      // change should trigger an update of the owner which would recreate
	      // the element. We explicitly check for the existence of an owner since
	      // it's possible for an element created outside a composite to be
	      // deeply mutated and reused.
	
	      // TODO: Bailing out early is just a perf optimization right?
	      // TODO: Removing the return statement should affect correctness?
	      return;
	    }
	
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onBeforeUpdateComponent(internalInstance._debugID, nextElement);
	        ReactInstrumentation.debugTool.onBeginReconcilerTimer(internalInstance._debugID, 'receiveComponent');
	      }
	    }
	
	    var refsChanged = ReactRef.shouldUpdateRefs(prevElement, nextElement);
	
	    if (refsChanged) {
	      ReactRef.detachRefs(internalInstance, prevElement);
	    }
	
	    internalInstance.receiveComponent(nextElement, transaction, context);
	
	    if (refsChanged && internalInstance._currentElement && internalInstance._currentElement.ref != null) {
	      transaction.getReactMountReady().enqueue(attachRefs, internalInstance);
	    }
	
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onEndReconcilerTimer(internalInstance._debugID, 'receiveComponent');
	        ReactInstrumentation.debugTool.onUpdateComponent(internalInstance._debugID);
	      }
	    }
	  },
	
	  /**
	   * Flush any dirty changes in a component.
	   *
	   * @param {ReactComponent} internalInstance
	   * @param {ReactReconcileTransaction} transaction
	   * @internal
	   */
	  performUpdateIfNecessary: function (internalInstance, transaction, updateBatchNumber) {
	    if (internalInstance._updateBatchNumber !== updateBatchNumber) {
	      // The component's enqueued batch number should always be the current
	      // batch or the following one.
	      !(internalInstance._updateBatchNumber == null || internalInstance._updateBatchNumber === updateBatchNumber + 1) ?  false ? invariant(false, 'performUpdateIfNecessary: Unexpected batch number (current %s, pending %s)', updateBatchNumber, internalInstance._updateBatchNumber) : _prodInvariant('121', updateBatchNumber, internalInstance._updateBatchNumber) : void 0;
	      return;
	    }
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onBeginReconcilerTimer(internalInstance._debugID, 'performUpdateIfNecessary');
	        ReactInstrumentation.debugTool.onBeforeUpdateComponent(internalInstance._debugID, internalInstance._currentElement);
	      }
	    }
	    internalInstance.performUpdateIfNecessary(transaction);
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onEndReconcilerTimer(internalInstance._debugID, 'performUpdateIfNecessary');
	        ReactInstrumentation.debugTool.onUpdateComponent(internalInstance._debugID);
	      }
	    }
	  }
	
	};
	
	module.exports = ReactReconciler;

/***/ },
/* 92 */
/***/ function(module, exports, __webpack_require__) {

	// fallback for non-array-like ES3 and non-enumerable old V8 strings
	var cof = __webpack_require__(34);
	module.exports = Object('z').propertyIsEnumerable(0) ? Object : function(it){
	  return cof(it) == 'String' ? it.split('') : Object(it);
	};

/***/ },
/* 93 */
/***/ function(module, exports) {

	exports.f = {}.propertyIsEnumerable;

/***/ },
/* 94 */
/***/ function(module, exports, __webpack_require__) {

	var assignValue = __webpack_require__(123);
	
	/**
	 * Copies properties of `source` to `object`.
	 *
	 * @private
	 * @param {Object} source The object to copy properties from.
	 * @param {Array} props The property identifiers to copy.
	 * @param {Object} [object={}] The object to copy properties to.
	 * @param {Function} [customizer] The function to customize copied values.
	 * @returns {Object} Returns `object`.
	 */
	function copyObject(source, props, object, customizer) {
	  object || (object = {});
	
	  var index = -1,
	      length = props.length;
	
	  while (++index < length) {
	    var key = props[index];
	
	    var newValue = customizer
	      ? customizer(object[key], source[key], key, object, source)
	      : source[key];
	
	    assignValue(object, key, newValue);
	  }
	  return object;
	}
	
	module.exports = copyObject;


/***/ },
/* 95 */
/***/ function(module, exports) {

	/** Used as references for various `Number` constants. */
	var MAX_SAFE_INTEGER = 9007199254740991;
	
	/** Used to detect unsigned integer values. */
	var reIsUint = /^(?:0|[1-9]\d*)$/;
	
	/**
	 * Checks if `value` is a valid array-like index.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
	 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
	 */
	function isIndex(value, length) {
	  length = length == null ? MAX_SAFE_INTEGER : length;
	  return !!length &&
	    (typeof value == 'number' || reIsUint.test(value)) &&
	    (value > -1 && value % 1 == 0 && value < length);
	}
	
	module.exports = isIndex;


/***/ },
/* 96 */
/***/ function(module, exports) {

	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Checks if `value` is likely a prototype object.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
	 */
	function isPrototype(value) {
	  var Ctor = value && value.constructor,
	      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;
	
	  return value === proto;
	}
	
	module.exports = isPrototype;


/***/ },
/* 97 */
/***/ function(module, exports, __webpack_require__) {

	var baseToString = __webpack_require__(590);
	
	/**
	 * Converts `value` to a string. An empty string is returned for `null`
	 * and `undefined` values. The sign of `-0` is preserved.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to process.
	 * @returns {string} Returns the string.
	 * @example
	 *
	 * _.toString(null);
	 * // => ''
	 *
	 * _.toString(-0);
	 * // => '-0'
	 *
	 * _.toString([1, 2, 3]);
	 * // => '1,2,3'
	 */
	function toString(value) {
	  return value == null ? '' : baseToString(value);
	}
	
	module.exports = toString;


/***/ },
/* 98 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.routes = exports.route = exports.components = exports.component = exports.history = undefined;
	exports.falsy = falsy;
	
	var _react = __webpack_require__(3);
	
	var func = _react.PropTypes.func,
	    object = _react.PropTypes.object,
	    arrayOf = _react.PropTypes.arrayOf,
	    oneOfType = _react.PropTypes.oneOfType,
	    element = _react.PropTypes.element,
	    shape = _react.PropTypes.shape,
	    string = _react.PropTypes.string;
	function falsy(props, propName, componentName) {
	  if (props[propName]) return new Error('<' + componentName + '> should not have a "' + propName + '" prop');
	}
	
	var history = exports.history = shape({
	  listen: func.isRequired,
	  push: func.isRequired,
	  replace: func.isRequired,
	  go: func.isRequired,
	  goBack: func.isRequired,
	  goForward: func.isRequired
	});
	
	var component = exports.component = oneOfType([func, string]);
	var components = exports.components = oneOfType([component, object]);
	var route = exports.route = oneOfType([object, element]);
	var routes = exports.routes = oneOfType([route, arrayOf(route)]);

/***/ },
/* 99 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule EventPluginHub
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(5);
	
	var EventPluginRegistry = __webpack_require__(198);
	var EventPluginUtils = __webpack_require__(199);
	var ReactErrorUtils = __webpack_require__(203);
	
	var accumulateInto = __webpack_require__(330);
	var forEachAccumulated = __webpack_require__(332);
	var invariant = __webpack_require__(2);
	
	/**
	 * Internal store for event listeners
	 */
	var listenerBank = {};
	
	/**
	 * Internal queue of events that have accumulated their dispatches and are
	 * waiting to have their dispatches executed.
	 */
	var eventQueue = null;
	
	/**
	 * Dispatches an event and releases it back into the pool, unless persistent.
	 *
	 * @param {?object} event Synthetic event to be dispatched.
	 * @param {boolean} simulated If the event is simulated (changes exn behavior)
	 * @private
	 */
	var executeDispatchesAndRelease = function (event, simulated) {
	  if (event) {
	    EventPluginUtils.executeDispatchesInOrder(event, simulated);
	
	    if (!event.isPersistent()) {
	      event.constructor.release(event);
	    }
	  }
	};
	var executeDispatchesAndReleaseSimulated = function (e) {
	  return executeDispatchesAndRelease(e, true);
	};
	var executeDispatchesAndReleaseTopLevel = function (e) {
	  return executeDispatchesAndRelease(e, false);
	};
	
	/**
	 * This is a unified interface for event plugins to be installed and configured.
	 *
	 * Event plugins can implement the following properties:
	 *
	 *   `extractEvents` {function(string, DOMEventTarget, string, object): *}
	 *     Required. When a top-level event is fired, this method is expected to
	 *     extract synthetic events that will in turn be queued and dispatched.
	 *
	 *   `eventTypes` {object}
	 *     Optional, plugins that fire events must publish a mapping of registration
	 *     names that are used to register listeners. Values of this mapping must
	 *     be objects that contain `registrationName` or `phasedRegistrationNames`.
	 *
	 *   `executeDispatch` {function(object, function, string)}
	 *     Optional, allows plugins to override how an event gets dispatched. By
	 *     default, the listener is simply invoked.
	 *
	 * Each plugin that is injected into `EventsPluginHub` is immediately operable.
	 *
	 * @public
	 */
	var EventPluginHub = {
	
	  /**
	   * Methods for injecting dependencies.
	   */
	  injection: {
	
	    /**
	     * @param {array} InjectedEventPluginOrder
	     * @public
	     */
	    injectEventPluginOrder: EventPluginRegistry.injectEventPluginOrder,
	
	    /**
	     * @param {object} injectedNamesToPlugins Map from names to plugin modules.
	     */
	    injectEventPluginsByName: EventPluginRegistry.injectEventPluginsByName
	
	  },
	
	  /**
	   * Stores `listener` at `listenerBank[registrationName][id]`. Is idempotent.
	   *
	   * @param {object} inst The instance, which is the source of events.
	   * @param {string} registrationName Name of listener (e.g. `onClick`).
	   * @param {function} listener The callback to store.
	   */
	  putListener: function (inst, registrationName, listener) {
	    !(typeof listener === 'function') ?  false ? invariant(false, 'Expected %s listener to be a function, instead got type %s', registrationName, typeof listener) : _prodInvariant('94', registrationName, typeof listener) : void 0;
	
	    var bankForRegistrationName = listenerBank[registrationName] || (listenerBank[registrationName] = {});
	    bankForRegistrationName[inst._rootNodeID] = listener;
	
	    var PluginModule = EventPluginRegistry.registrationNameModules[registrationName];
	    if (PluginModule && PluginModule.didPutListener) {
	      PluginModule.didPutListener(inst, registrationName, listener);
	    }
	  },
	
	  /**
	   * @param {object} inst The instance, which is the source of events.
	   * @param {string} registrationName Name of listener (e.g. `onClick`).
	   * @return {?function} The stored callback.
	   */
	  getListener: function (inst, registrationName) {
	    var bankForRegistrationName = listenerBank[registrationName];
	    return bankForRegistrationName && bankForRegistrationName[inst._rootNodeID];
	  },
	
	  /**
	   * Deletes a listener from the registration bank.
	   *
	   * @param {object} inst The instance, which is the source of events.
	   * @param {string} registrationName Name of listener (e.g. `onClick`).
	   */
	  deleteListener: function (inst, registrationName) {
	    var PluginModule = EventPluginRegistry.registrationNameModules[registrationName];
	    if (PluginModule && PluginModule.willDeleteListener) {
	      PluginModule.willDeleteListener(inst, registrationName);
	    }
	
	    var bankForRegistrationName = listenerBank[registrationName];
	    // TODO: This should never be null -- when is it?
	    if (bankForRegistrationName) {
	      delete bankForRegistrationName[inst._rootNodeID];
	    }
	  },
	
	  /**
	   * Deletes all listeners for the DOM element with the supplied ID.
	   *
	   * @param {object} inst The instance, which is the source of events.
	   */
	  deleteAllListeners: function (inst) {
	    for (var registrationName in listenerBank) {
	      if (!listenerBank.hasOwnProperty(registrationName)) {
	        continue;
	      }
	
	      if (!listenerBank[registrationName][inst._rootNodeID]) {
	        continue;
	      }
	
	      var PluginModule = EventPluginRegistry.registrationNameModules[registrationName];
	      if (PluginModule && PluginModule.willDeleteListener) {
	        PluginModule.willDeleteListener(inst, registrationName);
	      }
	
	      delete listenerBank[registrationName][inst._rootNodeID];
	    }
	  },
	
	  /**
	   * Allows registered plugins an opportunity to extract events from top-level
	   * native browser events.
	   *
	   * @return {*} An accumulation of synthetic events.
	   * @internal
	   */
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    var events;
	    var plugins = EventPluginRegistry.plugins;
	    for (var i = 0; i < plugins.length; i++) {
	      // Not every plugin in the ordering may be loaded at runtime.
	      var possiblePlugin = plugins[i];
	      if (possiblePlugin) {
	        var extractedEvents = possiblePlugin.extractEvents(topLevelType, targetInst, nativeEvent, nativeEventTarget);
	        if (extractedEvents) {
	          events = accumulateInto(events, extractedEvents);
	        }
	      }
	    }
	    return events;
	  },
	
	  /**
	   * Enqueues a synthetic event that should be dispatched when
	   * `processEventQueue` is invoked.
	   *
	   * @param {*} events An accumulation of synthetic events.
	   * @internal
	   */
	  enqueueEvents: function (events) {
	    if (events) {
	      eventQueue = accumulateInto(eventQueue, events);
	    }
	  },
	
	  /**
	   * Dispatches all synthetic events on the event queue.
	   *
	   * @internal
	   */
	  processEventQueue: function (simulated) {
	    // Set `eventQueue` to null before processing it so that we can tell if more
	    // events get enqueued while processing.
	    var processingEventQueue = eventQueue;
	    eventQueue = null;
	    if (simulated) {
	      forEachAccumulated(processingEventQueue, executeDispatchesAndReleaseSimulated);
	    } else {
	      forEachAccumulated(processingEventQueue, executeDispatchesAndReleaseTopLevel);
	    }
	    !!eventQueue ?  false ? invariant(false, 'processEventQueue(): Additional events were enqueued while processing an event queue. Support for this has not yet been implemented.') : _prodInvariant('95') : void 0;
	    // This would be a good time to rethrow if any of the event handlers threw.
	    ReactErrorUtils.rethrowCaughtError();
	  },
	
	  /**
	   * These are needed for tests only. Do not use!
	   */
	  __purge: function () {
	    listenerBank = {};
	  },
	
	  __getListenerBank: function () {
	    return listenerBank;
	  }
	
	};
	
	module.exports = EventPluginHub;

/***/ },
/* 100 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule EventPropagators
	 */
	
	'use strict';
	
	var EventConstants = __webpack_require__(52);
	var EventPluginHub = __webpack_require__(99);
	var EventPluginUtils = __webpack_require__(199);
	
	var accumulateInto = __webpack_require__(330);
	var forEachAccumulated = __webpack_require__(332);
	var warning = __webpack_require__(9);
	
	var PropagationPhases = EventConstants.PropagationPhases;
	var getListener = EventPluginHub.getListener;
	
	/**
	 * Some event types have a notion of different registration names for different
	 * "phases" of propagation. This finds listeners by a given phase.
	 */
	function listenerAtPhase(inst, event, propagationPhase) {
	  var registrationName = event.dispatchConfig.phasedRegistrationNames[propagationPhase];
	  return getListener(inst, registrationName);
	}
	
	/**
	 * Tags a `SyntheticEvent` with dispatched listeners. Creating this function
	 * here, allows us to not have to bind or create functions for each event.
	 * Mutating the event's members allows us to not have to create a wrapping
	 * "dispatch" object that pairs the event with the listener.
	 */
	function accumulateDirectionalDispatches(inst, upwards, event) {
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(inst, 'Dispatching inst must not be null') : void 0;
	  }
	  var phase = upwards ? PropagationPhases.bubbled : PropagationPhases.captured;
	  var listener = listenerAtPhase(inst, event, phase);
	  if (listener) {
	    event._dispatchListeners = accumulateInto(event._dispatchListeners, listener);
	    event._dispatchInstances = accumulateInto(event._dispatchInstances, inst);
	  }
	}
	
	/**
	 * Collect dispatches (must be entirely collected before dispatching - see unit
	 * tests). Lazily allocate the array to conserve memory.  We must loop through
	 * each event and perform the traversal for each one. We cannot perform a
	 * single traversal for the entire collection of events because each event may
	 * have a different target.
	 */
	function accumulateTwoPhaseDispatchesSingle(event) {
	  if (event && event.dispatchConfig.phasedRegistrationNames) {
	    EventPluginUtils.traverseTwoPhase(event._targetInst, accumulateDirectionalDispatches, event);
	  }
	}
	
	/**
	 * Same as `accumulateTwoPhaseDispatchesSingle`, but skips over the targetID.
	 */
	function accumulateTwoPhaseDispatchesSingleSkipTarget(event) {
	  if (event && event.dispatchConfig.phasedRegistrationNames) {
	    var targetInst = event._targetInst;
	    var parentInst = targetInst ? EventPluginUtils.getParentInstance(targetInst) : null;
	    EventPluginUtils.traverseTwoPhase(parentInst, accumulateDirectionalDispatches, event);
	  }
	}
	
	/**
	 * Accumulates without regard to direction, does not look for phased
	 * registration names. Same as `accumulateDirectDispatchesSingle` but without
	 * requiring that the `dispatchMarker` be the same as the dispatched ID.
	 */
	function accumulateDispatches(inst, ignoredDirection, event) {
	  if (event && event.dispatchConfig.registrationName) {
	    var registrationName = event.dispatchConfig.registrationName;
	    var listener = getListener(inst, registrationName);
	    if (listener) {
	      event._dispatchListeners = accumulateInto(event._dispatchListeners, listener);
	      event._dispatchInstances = accumulateInto(event._dispatchInstances, inst);
	    }
	  }
	}
	
	/**
	 * Accumulates dispatches on an `SyntheticEvent`, but only for the
	 * `dispatchMarker`.
	 * @param {SyntheticEvent} event
	 */
	function accumulateDirectDispatchesSingle(event) {
	  if (event && event.dispatchConfig.registrationName) {
	    accumulateDispatches(event._targetInst, null, event);
	  }
	}
	
	function accumulateTwoPhaseDispatches(events) {
	  forEachAccumulated(events, accumulateTwoPhaseDispatchesSingle);
	}
	
	function accumulateTwoPhaseDispatchesSkipTarget(events) {
	  forEachAccumulated(events, accumulateTwoPhaseDispatchesSingleSkipTarget);
	}
	
	function accumulateEnterLeaveDispatches(leave, enter, from, to) {
	  EventPluginUtils.traverseEnterLeave(from, to, accumulateDispatches, leave, enter);
	}
	
	function accumulateDirectDispatches(events) {
	  forEachAccumulated(events, accumulateDirectDispatchesSingle);
	}
	
	/**
	 * A small set of propagation patterns, each of which will accept a small amount
	 * of information, and generate a set of "dispatch ready event objects" - which
	 * are sets of events that have already been annotated with a set of dispatched
	 * listener functions/ids. The API is designed this way to discourage these
	 * propagation strategies from actually executing the dispatches, since we
	 * always want to collect the entire set of dispatches before executing event a
	 * single one.
	 *
	 * @constructor EventPropagators
	 */
	var EventPropagators = {
	  accumulateTwoPhaseDispatches: accumulateTwoPhaseDispatches,
	  accumulateTwoPhaseDispatchesSkipTarget: accumulateTwoPhaseDispatchesSkipTarget,
	  accumulateDirectDispatches: accumulateDirectDispatches,
	  accumulateEnterLeaveDispatches: accumulateEnterLeaveDispatches
	};
	
	module.exports = EventPropagators;

/***/ },
/* 101 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactInstanceMap
	 */
	
	'use strict';
	
	/**
	 * `ReactInstanceMap` maintains a mapping from a public facing stateful
	 * instance (key) and the internal representation (value). This allows public
	 * methods to accept the user facing instance as an argument and map them back
	 * to internal methods.
	 */
	
	// TODO: Replace this with ES6: var ReactInstanceMap = new Map();
	
	var ReactInstanceMap = {
	
	  /**
	   * This API should be called `delete` but we'd have to make sure to always
	   * transform these to strings for IE support. When this transform is fully
	   * supported we can rename it.
	   */
	  remove: function (key) {
	    key._reactInternalInstance = undefined;
	  },
	
	  get: function (key) {
	    return key._reactInternalInstance;
	  },
	
	  has: function (key) {
	    return key._reactInternalInstance !== undefined;
	  },
	
	  set: function (key, value) {
	    key._reactInternalInstance = value;
	  }
	
	};
	
	module.exports = ReactInstanceMap;

/***/ },
/* 102 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule SyntheticUIEvent
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(53);
	
	var getEventTarget = __webpack_require__(210);
	
	/**
	 * @interface UIEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var UIEventInterface = {
	  view: function (event) {
	    if (event.view) {
	      return event.view;
	    }
	
	    var target = getEventTarget(event);
	    if (target.window === target) {
	      // target is a window object
	      return target;
	    }
	
	    var doc = target.ownerDocument;
	    // TODO: Figure out why `ownerDocument` is sometimes undefined in IE8.
	    if (doc) {
	      return doc.defaultView || doc.parentWindow;
	    } else {
	      return window;
	    }
	  },
	  detail: function (event) {
	    return event.detail || 0;
	  }
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticEvent}
	 */
	function SyntheticUIEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticUIEvent, UIEventInterface);
	
	module.exports = SyntheticUIEvent;

/***/ },
/* 103 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule Transaction
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(5);
	
	var invariant = __webpack_require__(2);
	
	/**
	 * `Transaction` creates a black box that is able to wrap any method such that
	 * certain invariants are maintained before and after the method is invoked
	 * (Even if an exception is thrown while invoking the wrapped method). Whoever
	 * instantiates a transaction can provide enforcers of the invariants at
	 * creation time. The `Transaction` class itself will supply one additional
	 * automatic invariant for you - the invariant that any transaction instance
	 * should not be run while it is already being run. You would typically create a
	 * single instance of a `Transaction` for reuse multiple times, that potentially
	 * is used to wrap several different methods. Wrappers are extremely simple -
	 * they only require implementing two methods.
	 *
	 * <pre>
	 *                       wrappers (injected at creation time)
	 *                                      +        +
	 *                                      |        |
	 *                    +-----------------|--------|--------------+
	 *                    |                 v        |              |
	 *                    |      +---------------+   |              |
	 *                    |   +--|    wrapper1   |---|----+         |
	 *                    |   |  +---------------+   v    |         |
	 *                    |   |          +-------------+  |         |
	 *                    |   |     +----|   wrapper2  |--------+   |
	 *                    |   |     |    +-------------+  |     |   |
	 *                    |   |     |                     |     |   |
	 *                    |   v     v                     v     v   | wrapper
	 *                    | +---+ +---+   +---------+   +---+ +---+ | invariants
	 * perform(anyMethod) | |   | |   |   |         |   |   | |   | | maintained
	 * +----------------->|-|---|-|---|-->|anyMethod|---|---|-|---|-|-------->
	 *                    | |   | |   |   |         |   |   | |   | |
	 *                    | |   | |   |   |         |   |   | |   | |
	 *                    | |   | |   |   |         |   |   | |   | |
	 *                    | +---+ +---+   +---------+   +---+ +---+ |
	 *                    |  initialize                    close    |
	 *                    +-----------------------------------------+
	 * </pre>
	 *
	 * Use cases:
	 * - Preserving the input selection ranges before/after reconciliation.
	 *   Restoring selection even in the event of an unexpected error.
	 * - Deactivating events while rearranging the DOM, preventing blurs/focuses,
	 *   while guaranteeing that afterwards, the event system is reactivated.
	 * - Flushing a queue of collected DOM mutations to the main UI thread after a
	 *   reconciliation takes place in a worker thread.
	 * - Invoking any collected `componentDidUpdate` callbacks after rendering new
	 *   content.
	 * - (Future use case): Wrapping particular flushes of the `ReactWorker` queue
	 *   to preserve the `scrollTop` (an automatic scroll aware DOM).
	 * - (Future use case): Layout calculations before and after DOM updates.
	 *
	 * Transactional plugin API:
	 * - A module that has an `initialize` method that returns any precomputation.
	 * - and a `close` method that accepts the precomputation. `close` is invoked
	 *   when the wrapped process is completed, or has failed.
	 *
	 * @param {Array<TransactionalWrapper>} transactionWrapper Wrapper modules
	 * that implement `initialize` and `close`.
	 * @return {Transaction} Single transaction for reuse in thread.
	 *
	 * @class Transaction
	 */
	var Mixin = {
	  /**
	   * Sets up this instance so that it is prepared for collecting metrics. Does
	   * so such that this setup method may be used on an instance that is already
	   * initialized, in a way that does not consume additional memory upon reuse.
	   * That can be useful if you decide to make your subclass of this mixin a
	   * "PooledClass".
	   */
	  reinitializeTransaction: function () {
	    this.transactionWrappers = this.getTransactionWrappers();
	    if (this.wrapperInitData) {
	      this.wrapperInitData.length = 0;
	    } else {
	      this.wrapperInitData = [];
	    }
	    this._isInTransaction = false;
	  },
	
	  _isInTransaction: false,
	
	  /**
	   * @abstract
	   * @return {Array<TransactionWrapper>} Array of transaction wrappers.
	   */
	  getTransactionWrappers: null,
	
	  isInTransaction: function () {
	    return !!this._isInTransaction;
	  },
	
	  /**
	   * Executes the function within a safety window. Use this for the top level
	   * methods that result in large amounts of computation/mutations that would
	   * need to be safety checked. The optional arguments helps prevent the need
	   * to bind in many cases.
	   *
	   * @param {function} method Member of scope to call.
	   * @param {Object} scope Scope to invoke from.
	   * @param {Object?=} a Argument to pass to the method.
	   * @param {Object?=} b Argument to pass to the method.
	   * @param {Object?=} c Argument to pass to the method.
	   * @param {Object?=} d Argument to pass to the method.
	   * @param {Object?=} e Argument to pass to the method.
	   * @param {Object?=} f Argument to pass to the method.
	   *
	   * @return {*} Return value from `method`.
	   */
	  perform: function (method, scope, a, b, c, d, e, f) {
	    !!this.isInTransaction() ?  false ? invariant(false, 'Transaction.perform(...): Cannot initialize a transaction when there is already an outstanding transaction.') : _prodInvariant('27') : void 0;
	    var errorThrown;
	    var ret;
	    try {
	      this._isInTransaction = true;
	      // Catching errors makes debugging more difficult, so we start with
	      // errorThrown set to true before setting it to false after calling
	      // close -- if it's still set to true in the finally block, it means
	      // one of these calls threw.
	      errorThrown = true;
	      this.initializeAll(0);
	      ret = method.call(scope, a, b, c, d, e, f);
	      errorThrown = false;
	    } finally {
	      try {
	        if (errorThrown) {
	          // If `method` throws, prefer to show that stack trace over any thrown
	          // by invoking `closeAll`.
	          try {
	            this.closeAll(0);
	          } catch (err) {}
	        } else {
	          // Since `method` didn't throw, we don't want to silence the exception
	          // here.
	          this.closeAll(0);
	        }
	      } finally {
	        this._isInTransaction = false;
	      }
	    }
	    return ret;
	  },
	
	  initializeAll: function (startIndex) {
	    var transactionWrappers = this.transactionWrappers;
	    for (var i = startIndex; i < transactionWrappers.length; i++) {
	      var wrapper = transactionWrappers[i];
	      try {
	        // Catching errors makes debugging more difficult, so we start with the
	        // OBSERVED_ERROR state before overwriting it with the real return value
	        // of initialize -- if it's still set to OBSERVED_ERROR in the finally
	        // block, it means wrapper.initialize threw.
	        this.wrapperInitData[i] = Transaction.OBSERVED_ERROR;
	        this.wrapperInitData[i] = wrapper.initialize ? wrapper.initialize.call(this) : null;
	      } finally {
	        if (this.wrapperInitData[i] === Transaction.OBSERVED_ERROR) {
	          // The initializer for wrapper i threw an error; initialize the
	          // remaining wrappers but silence any exceptions from them to ensure
	          // that the first error is the one to bubble up.
	          try {
	            this.initializeAll(i + 1);
	          } catch (err) {}
	        }
	      }
	    }
	  },
	
	  /**
	   * Invokes each of `this.transactionWrappers.close[i]` functions, passing into
	   * them the respective return values of `this.transactionWrappers.init[i]`
	   * (`close`rs that correspond to initializers that failed will not be
	   * invoked).
	   */
	  closeAll: function (startIndex) {
	    !this.isInTransaction() ?  false ? invariant(false, 'Transaction.closeAll(): Cannot close transaction when none are open.') : _prodInvariant('28') : void 0;
	    var transactionWrappers = this.transactionWrappers;
	    for (var i = startIndex; i < transactionWrappers.length; i++) {
	      var wrapper = transactionWrappers[i];
	      var initData = this.wrapperInitData[i];
	      var errorThrown;
	      try {
	        // Catching errors makes debugging more difficult, so we start with
	        // errorThrown set to true before setting it to false after calling
	        // close -- if it's still set to true in the finally block, it means
	        // wrapper.close threw.
	        errorThrown = true;
	        if (initData !== Transaction.OBSERVED_ERROR && wrapper.close) {
	          wrapper.close.call(this, initData);
	        }
	        errorThrown = false;
	      } finally {
	        if (errorThrown) {
	          // The closer for wrapper i threw an error; close the remaining
	          // wrappers but silence any exceptions from them to ensure that the
	          // first error is the one to bubble up.
	          try {
	            this.closeAll(i + 1);
	          } catch (e) {}
	        }
	      }
	    }
	    this.wrapperInitData.length = 0;
	  }
	};
	
	var Transaction = {
	
	  Mixin: Mixin,
	
	  /**
	   * Token to look for to determine if an error occurred.
	   */
	  OBSERVED_ERROR: {}
	
	};
	
	module.exports = Transaction;

/***/ },
/* 104 */
/***/ function(module, exports, __webpack_require__) {

	// false -> Array#indexOf
	// true  -> Array#includes
	var toIObject = __webpack_require__(29)
	  , toLength  = __webpack_require__(16)
	  , toIndex   = __webpack_require__(71);
	module.exports = function(IS_INCLUDES){
	  return function($this, el, fromIndex){
	    var O      = toIObject($this)
	      , length = toLength(O.length)
	      , index  = toIndex(fromIndex, length)
	      , value;
	    // Array#includes uses SameValueZero equality algorithm
	    if(IS_INCLUDES && el != el)while(length > index){
	      value = O[index++];
	      if(value != value)return true;
	    // Array#toIndex ignores holes, Array#includes - not
	    } else for(;length > index; index++)if(IS_INCLUDES || index in O){
	      if(O[index] === el)return IS_INCLUDES || index || 0;
	    } return !IS_INCLUDES && -1;
	  };
	};

/***/ },
/* 105 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var global            = __webpack_require__(7)
	  , $export           = __webpack_require__(1)
	  , redefine          = __webpack_require__(27)
	  , redefineAll       = __webpack_require__(69)
	  , meta              = __webpack_require__(56)
	  , forOf             = __webpack_require__(79)
	  , anInstance        = __webpack_require__(55)
	  , isObject          = __webpack_require__(10)
	  , fails             = __webpack_require__(8)
	  , $iterDetect       = __webpack_require__(110)
	  , setToStringTag    = __webpack_require__(80)
	  , inheritIfRequired = __webpack_require__(151);
	
	module.exports = function(NAME, wrapper, methods, common, IS_MAP, IS_WEAK){
	  var Base  = global[NAME]
	    , C     = Base
	    , ADDER = IS_MAP ? 'set' : 'add'
	    , proto = C && C.prototype
	    , O     = {};
	  var fixMethod = function(KEY){
	    var fn = proto[KEY];
	    redefine(proto, KEY,
	      KEY == 'delete' ? function(a){
	        return IS_WEAK && !isObject(a) ? false : fn.call(this, a === 0 ? 0 : a);
	      } : KEY == 'has' ? function has(a){
	        return IS_WEAK && !isObject(a) ? false : fn.call(this, a === 0 ? 0 : a);
	      } : KEY == 'get' ? function get(a){
	        return IS_WEAK && !isObject(a) ? undefined : fn.call(this, a === 0 ? 0 : a);
	      } : KEY == 'add' ? function add(a){ fn.call(this, a === 0 ? 0 : a); return this; }
	        : function set(a, b){ fn.call(this, a === 0 ? 0 : a, b); return this; }
	    );
	  };
	  if(typeof C != 'function' || !(IS_WEAK || proto.forEach && !fails(function(){
	    new C().entries().next();
	  }))){
	    // create collection constructor
	    C = common.getConstructor(wrapper, NAME, IS_MAP, ADDER);
	    redefineAll(C.prototype, methods);
	    meta.NEED = true;
	  } else {
	    var instance             = new C
	      // early implementations not supports chaining
	      , HASNT_CHAINING       = instance[ADDER](IS_WEAK ? {} : -0, 1) != instance
	      // V8 ~  Chromium 40- weak-collections throws on primitives, but should return false
	      , THROWS_ON_PRIMITIVES = fails(function(){ instance.has(1); })
	      // most early implementations doesn't supports iterables, most modern - not close it correctly
	      , ACCEPT_ITERABLES     = $iterDetect(function(iter){ new C(iter); }) // eslint-disable-line no-new
	      // for early implementations -0 and +0 not the same
	      , BUGGY_ZERO = !IS_WEAK && fails(function(){
	        // V8 ~ Chromium 42- fails only with 5+ elements
	        var $instance = new C()
	          , index     = 5;
	        while(index--)$instance[ADDER](index, index);
	        return !$instance.has(-0);
	      });
	    if(!ACCEPT_ITERABLES){ 
	      C = wrapper(function(target, iterable){
	        anInstance(target, C, NAME);
	        var that = inheritIfRequired(new Base, target, C);
	        if(iterable != undefined)forOf(iterable, IS_MAP, that[ADDER], that);
	        return that;
	      });
	      C.prototype = proto;
	      proto.constructor = C;
	    }
	    if(THROWS_ON_PRIMITIVES || BUGGY_ZERO){
	      fixMethod('delete');
	      fixMethod('has');
	      IS_MAP && fixMethod('get');
	    }
	    if(BUGGY_ZERO || HASNT_CHAINING)fixMethod(ADDER);
	    // weak collections should not contains .clear method
	    if(IS_WEAK && proto.clear)delete proto.clear;
	  }
	
	  setToStringTag(C, NAME);
	
	  O[NAME] = C;
	  $export($export.G + $export.W + $export.F * (C != Base), O);
	
	  if(!IS_WEAK)common.setStrong(C, NAME, IS_MAP);
	
	  return C;
	};

/***/ },
/* 106 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var hide     = __webpack_require__(21)
	  , redefine = __webpack_require__(27)
	  , fails    = __webpack_require__(8)
	  , defined  = __webpack_require__(35)
	  , wks      = __webpack_require__(11);
	
	module.exports = function(KEY, length, exec){
	  var SYMBOL   = wks(KEY)
	    , fns      = exec(defined, SYMBOL, ''[KEY])
	    , strfn    = fns[0]
	    , rxfn     = fns[1];
	  if(fails(function(){
	    var O = {};
	    O[SYMBOL] = function(){ return 7; };
	    return ''[KEY](O) != 7;
	  })){
	    redefine(String.prototype, KEY, strfn);
	    hide(RegExp.prototype, SYMBOL, length == 2
	      // 21.2.5.8 RegExp.prototype[@@replace](string, replaceValue)
	      // 21.2.5.11 RegExp.prototype[@@split](string, limit)
	      ? function(string, arg){ return rxfn.call(string, this, arg); }
	      // 21.2.5.6 RegExp.prototype[@@match](string)
	      // 21.2.5.9 RegExp.prototype[@@search](string)
	      : function(string){ return rxfn.call(string, this); }
	    );
	  }
	};

/***/ },
/* 107 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// 21.2.5.3 get RegExp.prototype.flags
	var anObject = __webpack_require__(4);
	module.exports = function(){
	  var that   = anObject(this)
	    , result = '';
	  if(that.global)     result += 'g';
	  if(that.ignoreCase) result += 'i';
	  if(that.multiline)  result += 'm';
	  if(that.unicode)    result += 'u';
	  if(that.sticky)     result += 'y';
	  return result;
	};

/***/ },
/* 108 */
/***/ function(module, exports) {

	// fast apply, http://jsperf.lnkit.com/fast-apply/5
	module.exports = function(fn, args, that){
	  var un = that === undefined;
	  switch(args.length){
	    case 0: return un ? fn()
	                      : fn.call(that);
	    case 1: return un ? fn(args[0])
	                      : fn.call(that, args[0]);
	    case 2: return un ? fn(args[0], args[1])
	                      : fn.call(that, args[0], args[1]);
	    case 3: return un ? fn(args[0], args[1], args[2])
	                      : fn.call(that, args[0], args[1], args[2]);
	    case 4: return un ? fn(args[0], args[1], args[2], args[3])
	                      : fn.call(that, args[0], args[1], args[2], args[3]);
	  } return              fn.apply(that, args);
	};

/***/ },
/* 109 */
/***/ function(module, exports, __webpack_require__) {

	// 7.2.8 IsRegExp(argument)
	var isObject = __webpack_require__(10)
	  , cof      = __webpack_require__(34)
	  , MATCH    = __webpack_require__(11)('match');
	module.exports = function(it){
	  var isRegExp;
	  return isObject(it) && ((isRegExp = it[MATCH]) !== undefined ? !!isRegExp : cof(it) == 'RegExp');
	};

/***/ },
/* 110 */
/***/ function(module, exports, __webpack_require__) {

	var ITERATOR     = __webpack_require__(11)('iterator')
	  , SAFE_CLOSING = false;
	
	try {
	  var riter = [7][ITERATOR]();
	  riter['return'] = function(){ SAFE_CLOSING = true; };
	  Array.from(riter, function(){ throw 2; });
	} catch(e){ /* empty */ }
	
	module.exports = function(exec, skipClosing){
	  if(!skipClosing && !SAFE_CLOSING)return false;
	  var safe = false;
	  try {
	    var arr  = [7]
	      , iter = arr[ITERATOR]();
	    iter.next = function(){ return {done: safe = true}; };
	    arr[ITERATOR] = function(){ return iter; };
	    exec(arr);
	  } catch(e){ /* empty */ }
	  return safe;
	};

/***/ },
/* 111 */
/***/ function(module, exports, __webpack_require__) {

	// Forced replacement prototype accessors methods
	module.exports = __webpack_require__(65)|| !__webpack_require__(8)(function(){
	  var K = Math.random();
	  // In FF throws only define methods
	  __defineSetter__.call(null, K, function(){ /* empty */});
	  delete __webpack_require__(7)[K];
	});

/***/ },
/* 112 */
/***/ function(module, exports) {

	exports.f = Object.getOwnPropertySymbols;

/***/ },
/* 113 */
/***/ function(module, exports, __webpack_require__) {

	// Works with __proto__ only. Old v8 can't work with null proto objects.
	/* eslint-disable no-proto */
	var isObject = __webpack_require__(10)
	  , anObject = __webpack_require__(4);
	var check = function(O, proto){
	  anObject(O);
	  if(!isObject(proto) && proto !== null)throw TypeError(proto + ": can't set as prototype!");
	};
	module.exports = {
	  set: Object.setPrototypeOf || ('__proto__' in {} ? // eslint-disable-line
	    function(test, buggy, set){
	      try {
	        set = __webpack_require__(47)(Function.call, __webpack_require__(32).f(Object.prototype, '__proto__').set, 2);
	        set(test, []);
	        buggy = !(test instanceof Array);
	      } catch(e){ buggy = true; }
	      return function setPrototypeOf(O, proto){
	        check(O, proto);
	        if(buggy)O.__proto__ = proto;
	        else set(O, proto);
	        return O;
	      };
	    }({}, false) : undefined),
	  check: check
	};

/***/ },
/* 114 */
/***/ function(module, exports, __webpack_require__) {

	var global = __webpack_require__(7)
	  , SHARED = '__core-js_shared__'
	  , store  = global[SHARED] || (global[SHARED] = {});
	module.exports = function(key){
	  return store[key] || (store[key] = {});
	};

/***/ },
/* 115 */
/***/ function(module, exports, __webpack_require__) {

	var global = __webpack_require__(7)
	  , hide   = __webpack_require__(21)
	  , uid    = __webpack_require__(72)
	  , TYPED  = uid('typed_array')
	  , VIEW   = uid('view')
	  , ABV    = !!(global.ArrayBuffer && global.DataView)
	  , CONSTR = ABV
	  , i = 0, l = 9, Typed;
	
	var TypedArrayConstructors = (
	  'Int8Array,Uint8Array,Uint8ClampedArray,Int16Array,Uint16Array,Int32Array,Uint32Array,Float32Array,Float64Array'
	).split(',');
	
	while(i < l){
	  if(Typed = global[TypedArrayConstructors[i++]]){
	    hide(Typed.prototype, TYPED, true);
	    hide(Typed.prototype, VIEW, true);
	  } else CONSTR = false;
	}
	
	module.exports = {
	  ABV:    ABV,
	  CONSTR: CONSTR,
	  TYPED:  TYPED,
	  VIEW:   VIEW
	};

/***/ },
/* 116 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var emptyObject = {};
	
	if (false) {
	  Object.freeze(emptyObject);
	}
	
	module.exports = emptyObject;

/***/ },
/* 117 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var invariant = __webpack_require__(2);
	
	/**
	 * Constructs an enumeration with keys equal to their value.
	 *
	 * For example:
	 *
	 *   var COLORS = keyMirror({blue: null, red: null});
	 *   var myColor = COLORS.blue;
	 *   var isColorValid = !!COLORS[myColor];
	 *
	 * The last line could not be performed if the values of the generated enum were
	 * not equal to their keys.
	 *
	 *   Input:  {key1: val1, key2: val2}
	 *   Output: {key1: key1, key2: key2}
	 *
	 * @param {object} obj
	 * @return {object}
	 */
	var keyMirror = function keyMirror(obj) {
	  var ret = {};
	  var key;
	  !(obj instanceof Object && !Array.isArray(obj)) ?  false ? invariant(false, 'keyMirror(...): Argument must be an object.') : invariant(false) : void 0;
	  for (key in obj) {
	    if (!obj.hasOwnProperty(key)) {
	      continue;
	    }
	    ret[key] = key;
	  }
	  return ret;
	};
	
	module.exports = keyMirror;

/***/ },
/* 118 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	/**
	 * Indicates that navigation was caused by a call to history.push.
	 */
	var PUSH = exports.PUSH = 'PUSH';
	
	/**
	 * Indicates that navigation was caused by a call to history.replace.
	 */
	var REPLACE = exports.REPLACE = 'REPLACE';
	
	/**
	 * Indicates that navigation was caused by some other action such
	 * as using a browser's back/forward buttons and/or manually manipulating
	 * the URL in a browser's location bar. This is the default.
	 *
	 * See https://developer.mozilla.org/en-US/docs/Web/API/WindowEventHandlers/onpopstate
	 * for more information.
	 */
	var POP = exports.POP = 'POP';

/***/ },
/* 119 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	var addEventListener = exports.addEventListener = function addEventListener(node, event, listener) {
	  return node.addEventListener ? node.addEventListener(event, listener, false) : node.attachEvent('on' + event, listener);
	};
	
	var removeEventListener = exports.removeEventListener = function removeEventListener(node, event, listener) {
	  return node.removeEventListener ? node.removeEventListener(event, listener, false) : node.detachEvent('on' + event, listener);
	};
	
	/**
	 * Returns true if the HTML5 history API is supported. Taken from Modernizr.
	 *
	 * https://github.com/Modernizr/Modernizr/blob/master/LICENSE
	 * https://github.com/Modernizr/Modernizr/blob/master/feature-detects/history.js
	 * changed to avoid false negatives for Windows Phones: https://github.com/reactjs/react-router/issues/586
	 */
	var supportsHistory = exports.supportsHistory = function supportsHistory() {
	  var ua = window.navigator.userAgent;
	
	  if ((ua.indexOf('Android 2.') !== -1 || ua.indexOf('Android 4.0') !== -1) && ua.indexOf('Mobile Safari') !== -1 && ua.indexOf('Chrome') === -1 && ua.indexOf('Windows Phone') === -1) return false;
	
	  return window.history && 'pushState' in window.history;
	};
	
	/**
	 * Returns false if using go(n) with hash history causes a full page reload.
	 */
	var supportsGoWithoutReloadUsingHash = exports.supportsGoWithoutReloadUsingHash = function supportsGoWithoutReloadUsingHash() {
	  return window.navigator.userAgent.indexOf('Firefox') === -1;
	};
	
	/**
	 * Returns true if browser fires popstate on hash change.
	 * IE10 and IE11 do not.
	 */
	var supportsPopstateOnHashchange = exports.supportsPopstateOnHashchange = function supportsPopstateOnHashchange() {
	  return window.navigator.userAgent.indexOf('Trident') === -1;
	};

/***/ },
/* 120 */
/***/ function(module, exports, __webpack_require__) {

	var listCacheClear = __webpack_require__(633),
	    listCacheDelete = __webpack_require__(634),
	    listCacheGet = __webpack_require__(635),
	    listCacheHas = __webpack_require__(636),
	    listCacheSet = __webpack_require__(637);
	
	/**
	 * Creates an list cache object.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function ListCache(entries) {
	  var index = -1,
	      length = entries ? entries.length : 0;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	// Add methods to `ListCache`.
	ListCache.prototype.clear = listCacheClear;
	ListCache.prototype['delete'] = listCacheDelete;
	ListCache.prototype.get = listCacheGet;
	ListCache.prototype.has = listCacheHas;
	ListCache.prototype.set = listCacheSet;
	
	module.exports = ListCache;


/***/ },
/* 121 */
/***/ function(module, exports) {

	/**
	 * A faster alternative to `Function#apply`, this function invokes `func`
	 * with the `this` binding of `thisArg` and the arguments of `args`.
	 *
	 * @private
	 * @param {Function} func The function to invoke.
	 * @param {*} thisArg The `this` binding of `func`.
	 * @param {Array} args The arguments to invoke `func` with.
	 * @returns {*} Returns the result of `func`.
	 */
	function apply(func, thisArg, args) {
	  var length = args.length;
	  switch (length) {
	    case 0: return func.call(thisArg);
	    case 1: return func.call(thisArg, args[0]);
	    case 2: return func.call(thisArg, args[0], args[1]);
	    case 3: return func.call(thisArg, args[0], args[1], args[2]);
	  }
	  return func.apply(thisArg, args);
	}
	
	module.exports = apply;


/***/ },
/* 122 */
/***/ function(module, exports) {

	/**
	 * A specialized version of `_.reduce` for arrays without support for
	 * iteratee shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @param {*} [accumulator] The initial value.
	 * @param {boolean} [initAccum] Specify using the first element of `array` as
	 *  the initial value.
	 * @returns {*} Returns the accumulated value.
	 */
	function arrayReduce(array, iteratee, accumulator, initAccum) {
	  var index = -1,
	      length = array ? array.length : 0;
	
	  if (initAccum && length) {
	    accumulator = array[++index];
	  }
	  while (++index < length) {
	    accumulator = iteratee(accumulator, array[index], index, array);
	  }
	  return accumulator;
	}
	
	module.exports = arrayReduce;


/***/ },
/* 123 */
/***/ function(module, exports, __webpack_require__) {

	var eq = __webpack_require__(134);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Assigns `value` to `key` of `object` if the existing value is not equivalent
	 * using [`SameValueZero`](http://ecma-international.org/ecma-262/6.0/#sec-samevaluezero)
	 * for equality comparisons.
	 *
	 * @private
	 * @param {Object} object The object to modify.
	 * @param {string} key The key of the property to assign.
	 * @param {*} value The value to assign.
	 */
	function assignValue(object, key, value) {
	  var objValue = object[key];
	  if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
	      (value === undefined && !(key in object))) {
	    object[key] = value;
	  }
	}
	
	module.exports = assignValue;


/***/ },
/* 124 */
/***/ function(module, exports, __webpack_require__) {

	var eq = __webpack_require__(134);
	
	/**
	 * Gets the index at which the `key` is found in `array` of key-value pairs.
	 *
	 * @private
	 * @param {Array} array The array to search.
	 * @param {*} key The key to search for.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 */
	function assocIndexOf(array, key) {
	  var length = array.length;
	  while (length--) {
	    if (eq(array[length][0], key)) {
	      return length;
	    }
	  }
	  return -1;
	}
	
	module.exports = assocIndexOf;


/***/ },
/* 125 */
/***/ function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(39);
	
	/** Built-in value references. */
	var objectCreate = Object.create;
	
	/**
	 * The base implementation of `_.create` without support for assigning
	 * properties to the created object.
	 *
	 * @private
	 * @param {Object} prototype The object to inherit from.
	 * @returns {Object} Returns the new object.
	 */
	function baseCreate(proto) {
	  return isObject(proto) ? objectCreate(proto) : {};
	}
	
	module.exports = baseCreate;


/***/ },
/* 126 */
/***/ function(module, exports, __webpack_require__) {

	var baseForOwn = __webpack_require__(575),
	    createBaseEach = __webpack_require__(603);
	
	/**
	 * The base implementation of `_.forEach` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array|Object} Returns `collection`.
	 */
	var baseEach = createBaseEach(baseForOwn);
	
	module.exports = baseEach;


/***/ },
/* 127 */
/***/ function(module, exports, __webpack_require__) {

	var baseMatches = __webpack_require__(584),
	    baseMatchesProperty = __webpack_require__(585),
	    identity = __webpack_require__(283),
	    isArray = __webpack_require__(17),
	    property = __webpack_require__(670);
	
	/**
	 * The base implementation of `_.iteratee`.
	 *
	 * @private
	 * @param {*} [value=_.identity] The value to convert to an iteratee.
	 * @returns {Function} Returns the iteratee.
	 */
	function baseIteratee(value) {
	  // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
	  // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
	  if (typeof value == 'function') {
	    return value;
	  }
	  if (value == null) {
	    return identity;
	  }
	  if (typeof value == 'object') {
	    return isArray(value)
	      ? baseMatchesProperty(value[0], value[1])
	      : baseMatches(value);
	  }
	  return property(value);
	}
	
	module.exports = baseIteratee;


/***/ },
/* 128 */
/***/ function(module, exports, __webpack_require__) {

	var baseCreate = __webpack_require__(125),
	    isObject = __webpack_require__(39);
	
	/**
	 * Creates a function that produces an instance of `Ctor` regardless of
	 * whether it was invoked as part of a `new` expression or by `call` or `apply`.
	 *
	 * @private
	 * @param {Function} Ctor The constructor to wrap.
	 * @returns {Function} Returns the new wrapped function.
	 */
	function createCtorWrapper(Ctor) {
	  return function() {
	    // Use a `switch` statement to work with class constructors. See
	    // http://ecma-international.org/ecma-262/6.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
	    // for more details.
	    var args = arguments;
	    switch (args.length) {
	      case 0: return new Ctor;
	      case 1: return new Ctor(args[0]);
	      case 2: return new Ctor(args[0], args[1]);
	      case 3: return new Ctor(args[0], args[1], args[2]);
	      case 4: return new Ctor(args[0], args[1], args[2], args[3]);
	      case 5: return new Ctor(args[0], args[1], args[2], args[3], args[4]);
	      case 6: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
	      case 7: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
	    }
	    var thisBinding = baseCreate(Ctor.prototype),
	        result = Ctor.apply(thisBinding, args);
	
	    // Mimic the constructor's `return` behavior.
	    // See https://es5.github.io/#x13.2.2 for more details.
	    return isObject(result) ? result : thisBinding;
	  };
	}
	
	module.exports = createCtorWrapper;


/***/ },
/* 129 */
/***/ function(module, exports, __webpack_require__) {

	var isKeyable = __webpack_require__(629);
	
	/**
	 * Gets the data for `map`.
	 *
	 * @private
	 * @param {Object} map The map to query.
	 * @param {string} key The reference key.
	 * @returns {*} Returns the map data.
	 */
	function getMapData(map, key) {
	  var data = map.__data__;
	  return isKeyable(key)
	    ? data[typeof key == 'string' ? 'string' : 'hash']
	    : data.map;
	}
	
	module.exports = getMapData;


/***/ },
/* 130 */
/***/ function(module, exports, __webpack_require__) {

	var isArray = __webpack_require__(17),
	    isSymbol = __webpack_require__(137);
	
	/** Used to match property names within property paths. */
	var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
	    reIsPlainProp = /^\w*$/;
	
	/**
	 * Checks if `value` is a property name and not a property path.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @param {Object} [object] The object to query keys on.
	 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
	 */
	function isKey(value, object) {
	  if (isArray(value)) {
	    return false;
	  }
	  var type = typeof value;
	  if (type == 'number' || type == 'symbol' || type == 'boolean' ||
	      value == null || isSymbol(value)) {
	    return true;
	  }
	  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
	    (object != null && value in Object(object));
	}
	
	module.exports = isKey;


/***/ },
/* 131 */
/***/ function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(83);
	
	/* Built-in method references that are verified to be native. */
	var nativeCreate = getNative(Object, 'create');
	
	module.exports = nativeCreate;


/***/ },
/* 132 */
/***/ function(module, exports) {

	/** Used as the internal argument placeholder. */
	var PLACEHOLDER = '__lodash_placeholder__';
	
	/**
	 * Replaces all `placeholder` elements in `array` with an internal placeholder
	 * and returns an array of their indexes.
	 *
	 * @private
	 * @param {Array} array The array to modify.
	 * @param {*} placeholder The placeholder to replace.
	 * @returns {Array} Returns the new array of placeholder indexes.
	 */
	function replaceHolders(array, placeholder) {
	  var index = -1,
	      length = array.length,
	      resIndex = 0,
	      result = [];
	
	  while (++index < length) {
	    var value = array[index];
	    if (value === placeholder || value === PLACEHOLDER) {
	      array[index] = PLACEHOLDER;
	      result[resIndex++] = index;
	    }
	  }
	  return result;
	}
	
	module.exports = replaceHolders;


/***/ },
/* 133 */
/***/ function(module, exports, __webpack_require__) {

	var isSymbol = __webpack_require__(137);
	
	/** Used as references for various `Number` constants. */
	var INFINITY = 1 / 0;
	
	/**
	 * Converts `value` to a string key if it's not a string or symbol.
	 *
	 * @private
	 * @param {*} value The value to inspect.
	 * @returns {string|symbol} Returns the key.
	 */
	function toKey(value) {
	  if (typeof value == 'string' || isSymbol(value)) {
	    return value;
	  }
	  var result = (value + '');
	  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
	}
	
	module.exports = toKey;


/***/ },
/* 134 */
/***/ function(module, exports) {

	/**
	 * Performs a
	 * [`SameValueZero`](http://ecma-international.org/ecma-262/6.0/#sec-samevaluezero)
	 * comparison between two values to determine if they are equivalent.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	 * @example
	 *
	 * var object = { 'user': 'fred' };
	 * var other = { 'user': 'fred' };
	 *
	 * _.eq(object, object);
	 * // => true
	 *
	 * _.eq(object, other);
	 * // => false
	 *
	 * _.eq('a', 'a');
	 * // => true
	 *
	 * _.eq('a', Object('a'));
	 * // => false
	 *
	 * _.eq(NaN, NaN);
	 * // => true
	 */
	function eq(value, other) {
	  return value === other || (value !== value && other !== other);
	}
	
	module.exports = eq;


/***/ },
/* 135 */
/***/ function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(39);
	
	/** `Object#toString` result references. */
	var funcTag = '[object Function]',
	    genTag = '[object GeneratorFunction]';
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objectToString = objectProto.toString;
	
	/**
	 * Checks if `value` is classified as a `Function` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is correctly classified,
	 *  else `false`.
	 * @example
	 *
	 * _.isFunction(_);
	 * // => true
	 *
	 * _.isFunction(/abc/);
	 * // => false
	 */
	function isFunction(value) {
	  // The use of `Object#toString` avoids issues with the `typeof` operator
	  // in Safari 8 which returns 'object' for typed array and weak map constructors,
	  // and PhantomJS 1.9 which returns 'function' for `NodeList` instances.
	  var tag = isObject(value) ? objectToString.call(value) : '';
	  return tag == funcTag || tag == genTag;
	}
	
	module.exports = isFunction;


/***/ },
/* 136 */
/***/ function(module, exports) {

	/** Used as references for various `Number` constants. */
	var MAX_SAFE_INTEGER = 9007199254740991;
	
	/**
	 * Checks if `value` is a valid array-like length.
	 *
	 * **Note:** This function is loosely based on
	 * [`ToLength`](http://ecma-international.org/ecma-262/6.0/#sec-tolength).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a valid length,
	 *  else `false`.
	 * @example
	 *
	 * _.isLength(3);
	 * // => true
	 *
	 * _.isLength(Number.MIN_VALUE);
	 * // => false
	 *
	 * _.isLength(Infinity);
	 * // => false
	 *
	 * _.isLength('3');
	 * // => false
	 */
	function isLength(value) {
	  return typeof value == 'number' &&
	    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
	}
	
	module.exports = isLength;


/***/ },
/* 137 */
/***/ function(module, exports, __webpack_require__) {

	var isObjectLike = __webpack_require__(73);
	
	/** `Object#toString` result references. */
	var symbolTag = '[object Symbol]';
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objectToString = objectProto.toString;
	
	/**
	 * Checks if `value` is classified as a `Symbol` primitive or object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is correctly classified,
	 *  else `false`.
	 * @example
	 *
	 * _.isSymbol(Symbol.iterator);
	 * // => true
	 *
	 * _.isSymbol('abc');
	 * // => false
	 */
	function isSymbol(value) {
	  return typeof value == 'symbol' ||
	    (isObjectLike(value) && objectToString.call(value) == symbolTag);
	}
	
	module.exports = isSymbol;


/***/ },
/* 138 */
30,
/* 139 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule DisabledInputUtils
	 */
	
	'use strict';
	
	var disableableMouseListenerNames = {
	  onClick: true,
	  onDoubleClick: true,
	  onMouseDown: true,
	  onMouseMove: true,
	  onMouseUp: true,
	
	  onClickCapture: true,
	  onDoubleClickCapture: true,
	  onMouseDownCapture: true,
	  onMouseMoveCapture: true,
	  onMouseUpCapture: true
	};
	
	/**
	 * Implements a host component that does not receive mouse events
	 * when `disabled` is set.
	 */
	var DisabledInputUtils = {
	  getHostProps: function (inst, props) {
	    if (!props.disabled) {
	      return props;
	    }
	
	    // Copy the props, except the mouse listeners
	    var hostProps = {};
	    for (var key in props) {
	      if (!disableableMouseListenerNames[key] && props.hasOwnProperty(key)) {
	        hostProps[key] = props[key];
	      }
	    }
	
	    return hostProps;
	  }
	};
	
	module.exports = DisabledInputUtils;

/***/ },
/* 140 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactBrowserEventEmitter
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(6);
	
	var EventConstants = __webpack_require__(52);
	var EventPluginRegistry = __webpack_require__(198);
	var ReactEventEmitterMixin = __webpack_require__(767);
	var ViewportMetrics = __webpack_require__(329);
	
	var getVendorPrefixedEventName = __webpack_require__(797);
	var isEventSupported = __webpack_require__(211);
	
	/**
	 * Summary of `ReactBrowserEventEmitter` event handling:
	 *
	 *  - Top-level delegation is used to trap most native browser events. This
	 *    may only occur in the main thread and is the responsibility of
	 *    ReactEventListener, which is injected and can therefore support pluggable
	 *    event sources. This is the only work that occurs in the main thread.
	 *
	 *  - We normalize and de-duplicate events to account for browser quirks. This
	 *    may be done in the worker thread.
	 *
	 *  - Forward these native events (with the associated top-level type used to
	 *    trap it) to `EventPluginHub`, which in turn will ask plugins if they want
	 *    to extract any synthetic events.
	 *
	 *  - The `EventPluginHub` will then process each event by annotating them with
	 *    "dispatches", a sequence of listeners and IDs that care about that event.
	 *
	 *  - The `EventPluginHub` then dispatches the events.
	 *
	 * Overview of React and the event system:
	 *
	 * +------------+    .
	 * |    DOM     |    .
	 * +------------+    .
	 *       |           .
	 *       v           .
	 * +------------+    .
	 * | ReactEvent |    .
	 * |  Listener  |    .
	 * +------------+    .                         +-----------+
	 *       |           .               +--------+|SimpleEvent|
	 *       |           .               |         |Plugin     |
	 * +-----|------+    .               v         +-----------+
	 * |     |      |    .    +--------------+                    +------------+
	 * |     +-----------.--->|EventPluginHub|                    |    Event   |
	 * |            |    .    |              |     +-----------+  | Propagators|
	 * | ReactEvent |    .    |              |     |TapEvent   |  |------------|
	 * |  Emitter   |    .    |              |<---+|Plugin     |  |other plugin|
	 * |            |    .    |              |     +-----------+  |  utilities |
	 * |     +-----------.--->|              |                    +------------+
	 * |     |      |    .    +--------------+
	 * +-----|------+    .                ^        +-----------+
	 *       |           .                |        |Enter/Leave|
	 *       +           .                +-------+|Plugin     |
	 * +-------------+   .                         +-----------+
	 * | application |   .
	 * |-------------|   .
	 * |             |   .
	 * |             |   .
	 * +-------------+   .
	 *                   .
	 *    React Core     .  General Purpose Event Plugin System
	 */
	
	var hasEventPageXY;
	var alreadyListeningTo = {};
	var isMonitoringScrollValue = false;
	var reactTopListenersCounter = 0;
	
	// For events like 'submit' which don't consistently bubble (which we trap at a
	// lower node than `document`), binding at `document` would cause duplicate
	// events so we don't include them here
	var topEventMapping = {
	  topAbort: 'abort',
	  topAnimationEnd: getVendorPrefixedEventName('animationend') || 'animationend',
	  topAnimationIteration: getVendorPrefixedEventName('animationiteration') || 'animationiteration',
	  topAnimationStart: getVendorPrefixedEventName('animationstart') || 'animationstart',
	  topBlur: 'blur',
	  topCanPlay: 'canplay',
	  topCanPlayThrough: 'canplaythrough',
	  topChange: 'change',
	  topClick: 'click',
	  topCompositionEnd: 'compositionend',
	  topCompositionStart: 'compositionstart',
	  topCompositionUpdate: 'compositionupdate',
	  topContextMenu: 'contextmenu',
	  topCopy: 'copy',
	  topCut: 'cut',
	  topDoubleClick: 'dblclick',
	  topDrag: 'drag',
	  topDragEnd: 'dragend',
	  topDragEnter: 'dragenter',
	  topDragExit: 'dragexit',
	  topDragLeave: 'dragleave',
	  topDragOver: 'dragover',
	  topDragStart: 'dragstart',
	  topDrop: 'drop',
	  topDurationChange: 'durationchange',
	  topEmptied: 'emptied',
	  topEncrypted: 'encrypted',
	  topEnded: 'ended',
	  topError: 'error',
	  topFocus: 'focus',
	  topInput: 'input',
	  topKeyDown: 'keydown',
	  topKeyPress: 'keypress',
	  topKeyUp: 'keyup',
	  topLoadedData: 'loadeddata',
	  topLoadedMetadata: 'loadedmetadata',
	  topLoadStart: 'loadstart',
	  topMouseDown: 'mousedown',
	  topMouseMove: 'mousemove',
	  topMouseOut: 'mouseout',
	  topMouseOver: 'mouseover',
	  topMouseUp: 'mouseup',
	  topPaste: 'paste',
	  topPause: 'pause',
	  topPlay: 'play',
	  topPlaying: 'playing',
	  topProgress: 'progress',
	  topRateChange: 'ratechange',
	  topScroll: 'scroll',
	  topSeeked: 'seeked',
	  topSeeking: 'seeking',
	  topSelectionChange: 'selectionchange',
	  topStalled: 'stalled',
	  topSuspend: 'suspend',
	  topTextInput: 'textInput',
	  topTimeUpdate: 'timeupdate',
	  topTouchCancel: 'touchcancel',
	  topTouchEnd: 'touchend',
	  topTouchMove: 'touchmove',
	  topTouchStart: 'touchstart',
	  topTransitionEnd: getVendorPrefixedEventName('transitionend') || 'transitionend',
	  topVolumeChange: 'volumechange',
	  topWaiting: 'waiting',
	  topWheel: 'wheel'
	};
	
	/**
	 * To ensure no conflicts with other potential React instances on the page
	 */
	var topListenersIDKey = '_reactListenersID' + String(Math.random()).slice(2);
	
	function getListeningForDocument(mountAt) {
	  // In IE8, `mountAt` is a host object and doesn't have `hasOwnProperty`
	  // directly.
	  if (!Object.prototype.hasOwnProperty.call(mountAt, topListenersIDKey)) {
	    mountAt[topListenersIDKey] = reactTopListenersCounter++;
	    alreadyListeningTo[mountAt[topListenersIDKey]] = {};
	  }
	  return alreadyListeningTo[mountAt[topListenersIDKey]];
	}
	
	/**
	 * `ReactBrowserEventEmitter` is used to attach top-level event listeners. For
	 * example:
	 *
	 *   EventPluginHub.putListener('myID', 'onClick', myFunction);
	 *
	 * This would allocate a "registration" of `('onClick', myFunction)` on 'myID'.
	 *
	 * @internal
	 */
	var ReactBrowserEventEmitter = _assign({}, ReactEventEmitterMixin, {
	
	  /**
	   * Injectable event backend
	   */
	  ReactEventListener: null,
	
	  injection: {
	    /**
	     * @param {object} ReactEventListener
	     */
	    injectReactEventListener: function (ReactEventListener) {
	      ReactEventListener.setHandleTopLevel(ReactBrowserEventEmitter.handleTopLevel);
	      ReactBrowserEventEmitter.ReactEventListener = ReactEventListener;
	    }
	  },
	
	  /**
	   * Sets whether or not any created callbacks should be enabled.
	   *
	   * @param {boolean} enabled True if callbacks should be enabled.
	   */
	  setEnabled: function (enabled) {
	    if (ReactBrowserEventEmitter.ReactEventListener) {
	      ReactBrowserEventEmitter.ReactEventListener.setEnabled(enabled);
	    }
	  },
	
	  /**
	   * @return {boolean} True if callbacks are enabled.
	   */
	  isEnabled: function () {
	    return !!(ReactBrowserEventEmitter.ReactEventListener && ReactBrowserEventEmitter.ReactEventListener.isEnabled());
	  },
	
	  /**
	   * We listen for bubbled touch events on the document object.
	   *
	   * Firefox v8.01 (and possibly others) exhibited strange behavior when
	   * mounting `onmousemove` events at some node that was not the document
	   * element. The symptoms were that if your mouse is not moving over something
	   * contained within that mount point (for example on the background) the
	   * top-level listeners for `onmousemove` won't be called. However, if you
	   * register the `mousemove` on the document object, then it will of course
	   * catch all `mousemove`s. This along with iOS quirks, justifies restricting
	   * top-level listeners to the document object only, at least for these
	   * movement types of events and possibly all events.
	   *
	   * @see http://www.quirksmode.org/blog/archives/2010/09/click_event_del.html
	   *
	   * Also, `keyup`/`keypress`/`keydown` do not bubble to the window on IE, but
	   * they bubble to document.
	   *
	   * @param {string} registrationName Name of listener (e.g. `onClick`).
	   * @param {object} contentDocumentHandle Document which owns the container
	   */
	  listenTo: function (registrationName, contentDocumentHandle) {
	    var mountAt = contentDocumentHandle;
	    var isListening = getListeningForDocument(mountAt);
	    var dependencies = EventPluginRegistry.registrationNameDependencies[registrationName];
	
	    var topLevelTypes = EventConstants.topLevelTypes;
	    for (var i = 0; i < dependencies.length; i++) {
	      var dependency = dependencies[i];
	      if (!(isListening.hasOwnProperty(dependency) && isListening[dependency])) {
	        if (dependency === topLevelTypes.topWheel) {
	          if (isEventSupported('wheel')) {
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(topLevelTypes.topWheel, 'wheel', mountAt);
	          } else if (isEventSupported('mousewheel')) {
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(topLevelTypes.topWheel, 'mousewheel', mountAt);
	          } else {
	            // Firefox needs to capture a different mouse scroll event.
	            // @see http://www.quirksmode.org/dom/events/tests/scroll.html
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(topLevelTypes.topWheel, 'DOMMouseScroll', mountAt);
	          }
	        } else if (dependency === topLevelTypes.topScroll) {
	
	          if (isEventSupported('scroll', true)) {
	            ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent(topLevelTypes.topScroll, 'scroll', mountAt);
	          } else {
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(topLevelTypes.topScroll, 'scroll', ReactBrowserEventEmitter.ReactEventListener.WINDOW_HANDLE);
	          }
	        } else if (dependency === topLevelTypes.topFocus || dependency === topLevelTypes.topBlur) {
	
	          if (isEventSupported('focus', true)) {
	            ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent(topLevelTypes.topFocus, 'focus', mountAt);
	            ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent(topLevelTypes.topBlur, 'blur', mountAt);
	          } else if (isEventSupported('focusin')) {
	            // IE has `focusin` and `focusout` events which bubble.
	            // @see http://www.quirksmode.org/blog/archives/2008/04/delegating_the.html
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(topLevelTypes.topFocus, 'focusin', mountAt);
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(topLevelTypes.topBlur, 'focusout', mountAt);
	          }
	
	          // to make sure blur and focus event listeners are only attached once
	          isListening[topLevelTypes.topBlur] = true;
	          isListening[topLevelTypes.topFocus] = true;
	        } else if (topEventMapping.hasOwnProperty(dependency)) {
	          ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(dependency, topEventMapping[dependency], mountAt);
	        }
	
	        isListening[dependency] = true;
	      }
	    }
	  },
	
	  trapBubbledEvent: function (topLevelType, handlerBaseName, handle) {
	    return ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(topLevelType, handlerBaseName, handle);
	  },
	
	  trapCapturedEvent: function (topLevelType, handlerBaseName, handle) {
	    return ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent(topLevelType, handlerBaseName, handle);
	  },
	
	  /**
	   * Listens to window scroll and resize events. We cache scroll values so that
	   * application code can access them without triggering reflows.
	   *
	   * ViewportMetrics is only used by SyntheticMouse/TouchEvent and only when
	   * pageX/pageY isn't supported (legacy browsers).
	   *
	   * NOTE: Scroll events do not bubble.
	   *
	   * @see http://www.quirksmode.org/dom/events/scroll.html
	   */
	  ensureScrollValueMonitoring: function () {
	    if (hasEventPageXY === undefined) {
	      hasEventPageXY = document.createEvent && 'pageX' in document.createEvent('MouseEvent');
	    }
	    if (!hasEventPageXY && !isMonitoringScrollValue) {
	      var refresh = ViewportMetrics.refreshScrollValues;
	      ReactBrowserEventEmitter.ReactEventListener.monitorScrollValue(refresh);
	      isMonitoringScrollValue = true;
	    }
	  }
	
	});
	
	module.exports = ReactBrowserEventEmitter;

/***/ },
/* 141 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule SyntheticMouseEvent
	 */
	
	'use strict';
	
	var SyntheticUIEvent = __webpack_require__(102);
	var ViewportMetrics = __webpack_require__(329);
	
	var getEventModifierState = __webpack_require__(209);
	
	/**
	 * @interface MouseEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var MouseEventInterface = {
	  screenX: null,
	  screenY: null,
	  clientX: null,
	  clientY: null,
	  ctrlKey: null,
	  shiftKey: null,
	  altKey: null,
	  metaKey: null,
	  getModifierState: getEventModifierState,
	  button: function (event) {
	    // Webkit, Firefox, IE9+
	    // which:  1 2 3
	    // button: 0 1 2 (standard)
	    var button = event.button;
	    if ('which' in event) {
	      return button;
	    }
	    // IE<9
	    // which:  undefined
	    // button: 0 0 0
	    // button: 1 4 2 (onmouseup)
	    return button === 2 ? 2 : button === 4 ? 1 : 0;
	  },
	  buttons: null,
	  relatedTarget: function (event) {
	    return event.relatedTarget || (event.fromElement === event.srcElement ? event.toElement : event.fromElement);
	  },
	  // "Proprietary" Interface.
	  pageX: function (event) {
	    return 'pageX' in event ? event.pageX : event.clientX + ViewportMetrics.currentScrollLeft;
	  },
	  pageY: function (event) {
	    return 'pageY' in event ? event.pageY : event.clientY + ViewportMetrics.currentScrollTop;
	  }
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticMouseEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticUIEvent.augmentClass(SyntheticMouseEvent, MouseEventInterface);
	
	module.exports = SyntheticMouseEvent;

/***/ },
/* 142 */
/***/ function(module, exports) {

	/**
	 * Copyright 2016-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * Based on the escape-html library, which is used under the MIT License below:
	 *
	 * Copyright (c) 2012-2013 TJ Holowaychuk
	 * Copyright (c) 2015 Andreas Lubbe
	 * Copyright (c) 2015 Tiancheng "Timothy" Gu
	 *
	 * Permission is hereby granted, free of charge, to any person obtaining
	 * a copy of this software and associated documentation files (the
	 * 'Software'), to deal in the Software without restriction, including
	 * without limitation the rights to use, copy, modify, merge, publish,
	 * distribute, sublicense, and/or sell copies of the Software, and to
	 * permit persons to whom the Software is furnished to do so, subject to
	 * the following conditions:
	 *
	 * The above copyright notice and this permission notice shall be
	 * included in all copies or substantial portions of the Software.
	 *
	 * THE SOFTWARE IS PROVIDED 'AS IS', WITHOUT WARRANTY OF ANY KIND,
	 * EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	 * MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.
	 * IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY
	 * CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
	 * TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE
	 * SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
	 *
	 * @providesModule escapeTextContentForBrowser
	 */
	
	'use strict';
	
	// code copied and modified from escape-html
	/**
	 * Module variables.
	 * @private
	 */
	
	var matchHtmlRegExp = /["'&<>]/;
	
	/**
	 * Escape special characters in the given string of html.
	 *
	 * @param  {string} string The string to escape for inserting into HTML
	 * @return {string}
	 * @public
	 */
	
	function escapeHtml(string) {
	  var str = '' + string;
	  var match = matchHtmlRegExp.exec(str);
	
	  if (!match) {
	    return str;
	  }
	
	  var escape;
	  var html = '';
	  var index = 0;
	  var lastIndex = 0;
	
	  for (index = match.index; index < str.length; index++) {
	    switch (str.charCodeAt(index)) {
	      case 34:
	        // "
	        escape = '&quot;';
	        break;
	      case 38:
	        // &
	        escape = '&amp;';
	        break;
	      case 39:
	        // '
	        escape = '&#x27;'; // modified from escape-html; used to be '&#39'
	        break;
	      case 60:
	        // <
	        escape = '&lt;';
	        break;
	      case 62:
	        // >
	        escape = '&gt;';
	        break;
	      default:
	        continue;
	    }
	
	    if (lastIndex !== index) {
	      html += str.substring(lastIndex, index);
	    }
	
	    lastIndex = index + 1;
	    html += escape;
	  }
	
	  return lastIndex !== index ? html + str.substring(lastIndex, index) : html;
	}
	// end code copied and modified from escape-html
	
	/**
	 * Escapes text to prevent scripting attacks.
	 *
	 * @param {*} text Text value to escape.
	 * @return {string} An escaped string.
	 */
	function escapeTextContentForBrowser(text) {
	  if (typeof text === 'boolean' || typeof text === 'number') {
	    // this shortcircuit helps perf for types that we know will never have
	    // special characters, especially given that this function is used often
	    // for numeric dom ids.
	    return '' + text;
	  }
	  return escapeHtml(text);
	}
	
	module.exports = escapeTextContentForBrowser;

/***/ },
/* 143 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule setInnerHTML
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(22);
	var DOMNamespaces = __webpack_require__(197);
	
	var WHITESPACE_TEST = /^[ \r\n\t\f]/;
	var NONVISIBLE_TEST = /<(!--|link|noscript|meta|script|style)[ \r\n\t\f\/>]/;
	
	var createMicrosoftUnsafeLocalFunction = __webpack_require__(207);
	
	// SVG temp container for IE lacking innerHTML
	var reusableSVGContainer;
	
	/**
	 * Set the innerHTML property of a node, ensuring that whitespace is preserved
	 * even in IE8.
	 *
	 * @param {DOMElement} node
	 * @param {string} html
	 * @internal
	 */
	var setInnerHTML = createMicrosoftUnsafeLocalFunction(function (node, html) {
	  // IE does not have innerHTML for SVG nodes, so instead we inject the
	  // new markup in a temp node and then move the child nodes across into
	  // the target node
	  if (node.namespaceURI === DOMNamespaces.svg && !('innerHTML' in node)) {
	    reusableSVGContainer = reusableSVGContainer || document.createElement('div');
	    reusableSVGContainer.innerHTML = '<svg>' + html + '</svg>';
	    var newNodes = reusableSVGContainer.firstChild.childNodes;
	    for (var i = 0; i < newNodes.length; i++) {
	      node.appendChild(newNodes[i]);
	    }
	  } else {
	    node.innerHTML = html;
	  }
	});
	
	if (ExecutionEnvironment.canUseDOM) {
	  // IE8: When updating a just created node with innerHTML only leading
	  // whitespace is removed. When updating an existing node with innerHTML
	  // whitespace in root TextNodes is also collapsed.
	  // @see quirksmode.org/bugreports/archives/2004/11/innerhtml_and_t.html
	
	  // Feature detection; only IE8 is known to behave improperly like this.
	  var testElement = document.createElement('div');
	  testElement.innerHTML = ' ';
	  if (testElement.innerHTML === '') {
	    setInnerHTML = function (node, html) {
	      // Magic theory: IE8 supposedly differentiates between added and updated
	      // nodes when processing innerHTML, innerHTML on updated nodes suffers
	      // from worse whitespace behavior. Re-adding a node like this triggers
	      // the initial and more favorable whitespace behavior.
	      // TODO: What to do on a detached node?
	      if (node.parentNode) {
	        node.parentNode.replaceChild(node, node);
	      }
	
	      // We also implement a workaround for non-visible tags disappearing into
	      // thin air on IE8, this only happens if there is no visible text
	      // in-front of the non-visible tags. Piggyback on the whitespace fix
	      // and simply check if any non-visible tags appear in the source.
	      if (WHITESPACE_TEST.test(html) || html[0] === '<' && NONVISIBLE_TEST.test(html)) {
	        // Recover leading whitespace by temporarily prepending any character.
	        // \uFEFF has the potential advantage of being zero-width/invisible.
	        // UglifyJS drops U+FEFF chars when parsing, so use String.fromCharCode
	        // in hopes that this is preserved even if "\uFEFF" is transformed to
	        // the actual Unicode character (by Babel, for example).
	        // https://github.com/mishoo/UglifyJS2/blob/v2.4.20/lib/parse.js#L216
	        node.innerHTML = String.fromCharCode(0xFEFF) + html;
	
	        // deleteData leaves an empty `TextNode` which offsets the index of all
	        // children. Definitely want to avoid this.
	        var textNode = node.firstChild;
	        if (textNode.data.length === 1) {
	          node.removeChild(textNode);
	        } else {
	          textNode.deleteData(0, 1);
	        }
	      } else {
	        node.innerHTML = html;
	      }
	    };
	  }
	  testElement = null;
	}
	
	module.exports = setInnerHTML;

/***/ },
/* 144 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(setImmediate, clearImmediate) {var nextTick = __webpack_require__(292).nextTick;
	var apply = Function.prototype.apply;
	var slice = Array.prototype.slice;
	var immediateIds = {};
	var nextImmediateId = 0;
	
	// DOM APIs, for completeness
	
	exports.setTimeout = function() {
	  return new Timeout(apply.call(setTimeout, window, arguments), clearTimeout);
	};
	exports.setInterval = function() {
	  return new Timeout(apply.call(setInterval, window, arguments), clearInterval);
	};
	exports.clearTimeout =
	exports.clearInterval = function(timeout) { timeout.close(); };
	
	function Timeout(id, clearFn) {
	  this._id = id;
	  this._clearFn = clearFn;
	}
	Timeout.prototype.unref = Timeout.prototype.ref = function() {};
	Timeout.prototype.close = function() {
	  this._clearFn.call(window, this._id);
	};
	
	// Does not start the time, just sets up the members needed.
	exports.enroll = function(item, msecs) {
	  clearTimeout(item._idleTimeoutId);
	  item._idleTimeout = msecs;
	};
	
	exports.unenroll = function(item) {
	  clearTimeout(item._idleTimeoutId);
	  item._idleTimeout = -1;
	};
	
	exports._unrefActive = exports.active = function(item) {
	  clearTimeout(item._idleTimeoutId);
	
	  var msecs = item._idleTimeout;
	  if (msecs >= 0) {
	    item._idleTimeoutId = setTimeout(function onTimeout() {
	      if (item._onTimeout)
	        item._onTimeout();
	    }, msecs);
	  }
	};
	
	// That's not how node.js implements it but the exposed api is the same.
	exports.setImmediate = typeof setImmediate === "function" ? setImmediate : function(fn) {
	  var id = nextImmediateId++;
	  var args = arguments.length < 2 ? false : slice.call(arguments, 1);
	
	  immediateIds[id] = true;
	
	  nextTick(function onNextTick() {
	    if (immediateIds[id]) {
	      // fn.call() is faster so we optimize for the common use-case
	      // @see http://jsperf.com/call-apply-segu
	      if (args) {
	        fn.apply(null, args);
	      } else {
	        fn.call(null);
	      }
	      // Prevent ids from leaking
	      exports.clearImmediate(id);
	    }
	  });
	
	  return id;
	};
	
	exports.clearImmediate = typeof clearImmediate === "function" ? clearImmediate : function(id) {
	  delete immediateIds[id];
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(144).setImmediate, __webpack_require__(144).clearImmediate))

/***/ },
/* 145 */
/***/ function(module, exports, __webpack_require__) {

	// 22.1.3.6 Array.prototype.fill(value, start = 0, end = this.length)
	'use strict';
	var toObject = __webpack_require__(18)
	  , toIndex  = __webpack_require__(71)
	  , toLength = __webpack_require__(16);
	module.exports = function fill(value /*, start = 0, end = @length */){
	  var O      = toObject(this)
	    , length = toLength(O.length)
	    , aLen   = arguments.length
	    , index  = toIndex(aLen > 1 ? arguments[1] : undefined, length)
	    , end    = aLen > 2 ? arguments[2] : undefined
	    , endPos = end === undefined ? length : toIndex(end, length);
	  while(endPos > index)O[index++] = value;
	  return O;
	};

/***/ },
/* 146 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $defineProperty = __webpack_require__(14)
	  , createDesc      = __webpack_require__(57);
	
	module.exports = function(object, index, value){
	  if(index in object)$defineProperty.f(object, index, createDesc(0, value));
	  else object[index] = value;
	};

/***/ },
/* 147 */
/***/ function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(10)
	  , document = __webpack_require__(7).document
	  // in old IE typeof document.createElement is 'object'
	  , is = isObject(document) && isObject(document.createElement);
	module.exports = function(it){
	  return is ? document.createElement(it) : {};
	};

/***/ },
/* 148 */
/***/ function(module, exports) {

	// IE 8- don't enum bug keys
	module.exports = (
	  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
	).split(',');

/***/ },
/* 149 */
/***/ function(module, exports, __webpack_require__) {

	var MATCH = __webpack_require__(11)('match');
	module.exports = function(KEY){
	  var re = /./;
	  try {
	    '/./'[KEY](re);
	  } catch(e){
	    try {
	      re[MATCH] = false;
	      return !'/./'[KEY](re);
	    } catch(f){ /* empty */ }
	  } return true;
	};

/***/ },
/* 150 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(7).document && document.documentElement;

/***/ },
/* 151 */
/***/ function(module, exports, __webpack_require__) {

	var isObject       = __webpack_require__(10)
	  , setPrototypeOf = __webpack_require__(113).set;
	module.exports = function(that, target, C){
	  var P, S = target.constructor;
	  if(S !== C && typeof S == 'function' && (P = S.prototype) !== C.prototype && isObject(P) && setPrototypeOf){
	    setPrototypeOf(that, P);
	  } return that;
	};

/***/ },
/* 152 */
/***/ function(module, exports, __webpack_require__) {

	// check on default Array iterator
	var Iterators  = __webpack_require__(64)
	  , ITERATOR   = __webpack_require__(11)('iterator')
	  , ArrayProto = Array.prototype;
	
	module.exports = function(it){
	  return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
	};

/***/ },
/* 153 */
/***/ function(module, exports, __webpack_require__) {

	// 7.2.2 IsArray(argument)
	var cof = __webpack_require__(34);
	module.exports = Array.isArray || function isArray(arg){
	  return cof(arg) == 'Array';
	};

/***/ },
/* 154 */
/***/ function(module, exports, __webpack_require__) {

	// 20.1.2.3 Number.isInteger(number)
	var isObject = __webpack_require__(10)
	  , floor    = Math.floor;
	module.exports = function isInteger(it){
	  return !isObject(it) && isFinite(it) && floor(it) === it;
	};

/***/ },
/* 155 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var create         = __webpack_require__(66)
	  , descriptor     = __webpack_require__(57)
	  , setToStringTag = __webpack_require__(80)
	  , IteratorPrototype = {};
	
	// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
	__webpack_require__(21)(IteratorPrototype, __webpack_require__(11)('iterator'), function(){ return this; });
	
	module.exports = function(Constructor, NAME, next){
	  Constructor.prototype = create(IteratorPrototype, {next: descriptor(1, next)});
	  setToStringTag(Constructor, NAME + ' Iterator');
	};

/***/ },
/* 156 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var LIBRARY        = __webpack_require__(65)
	  , $export        = __webpack_require__(1)
	  , redefine       = __webpack_require__(27)
	  , hide           = __webpack_require__(21)
	  , has            = __webpack_require__(19)
	  , Iterators      = __webpack_require__(64)
	  , $iterCreate    = __webpack_require__(155)
	  , setToStringTag = __webpack_require__(80)
	  , getPrototypeOf = __webpack_require__(33)
	  , ITERATOR       = __webpack_require__(11)('iterator')
	  , BUGGY          = !([].keys && 'next' in [].keys()) // Safari has buggy iterators w/o `next`
	  , FF_ITERATOR    = '@@iterator'
	  , KEYS           = 'keys'
	  , VALUES         = 'values';
	
	var returnThis = function(){ return this; };
	
	module.exports = function(Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED){
	  $iterCreate(Constructor, NAME, next);
	  var getMethod = function(kind){
	    if(!BUGGY && kind in proto)return proto[kind];
	    switch(kind){
	      case KEYS: return function keys(){ return new Constructor(this, kind); };
	      case VALUES: return function values(){ return new Constructor(this, kind); };
	    } return function entries(){ return new Constructor(this, kind); };
	  };
	  var TAG        = NAME + ' Iterator'
	    , DEF_VALUES = DEFAULT == VALUES
	    , VALUES_BUG = false
	    , proto      = Base.prototype
	    , $native    = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT]
	    , $default   = $native || getMethod(DEFAULT)
	    , $entries   = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined
	    , $anyNative = NAME == 'Array' ? proto.entries || $native : $native
	    , methods, key, IteratorPrototype;
	  // Fix native
	  if($anyNative){
	    IteratorPrototype = getPrototypeOf($anyNative.call(new Base));
	    if(IteratorPrototype !== Object.prototype){
	      // Set @@toStringTag to native iterators
	      setToStringTag(IteratorPrototype, TAG, true);
	      // fix for some old engines
	      if(!LIBRARY && !has(IteratorPrototype, ITERATOR))hide(IteratorPrototype, ITERATOR, returnThis);
	    }
	  }
	  // fix Array#{values, @@iterator}.name in V8 / FF
	  if(DEF_VALUES && $native && $native.name !== VALUES){
	    VALUES_BUG = true;
	    $default = function values(){ return $native.call(this); };
	  }
	  // Define iterator
	  if((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])){
	    hide(proto, ITERATOR, $default);
	  }
	  // Plug for library
	  Iterators[NAME] = $default;
	  Iterators[TAG]  = returnThis;
	  if(DEFAULT){
	    methods = {
	      values:  DEF_VALUES ? $default : getMethod(VALUES),
	      keys:    IS_SET     ? $default : getMethod(KEYS),
	      entries: $entries
	    };
	    if(FORCED)for(key in methods){
	      if(!(key in proto))redefine(proto, key, methods[key]);
	    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
	  }
	  return methods;
	};

/***/ },
/* 157 */
/***/ function(module, exports) {

	// 20.2.2.14 Math.expm1(x)
	var $expm1 = Math.expm1;
	module.exports = (!$expm1
	  // Old FF bug
	  || $expm1(10) > 22025.465794806719 || $expm1(10) < 22025.4657948067165168
	  // Tor Browser bug
	  || $expm1(-2e-17) != -2e-17
	) ? function expm1(x){
	  return (x = +x) == 0 ? x : x > -1e-6 && x < 1e-6 ? x + x * x / 2 : Math.exp(x) - 1;
	} : $expm1;

/***/ },
/* 158 */
/***/ function(module, exports) {

	// 20.2.2.28 Math.sign(x)
	module.exports = Math.sign || function sign(x){
	  return (x = +x) == 0 || x != x ? x : x < 0 ? -1 : 1;
	};

/***/ },
/* 159 */
/***/ function(module, exports, __webpack_require__) {

	var global    = __webpack_require__(7)
	  , macrotask = __webpack_require__(166).set
	  , Observer  = global.MutationObserver || global.WebKitMutationObserver
	  , process   = global.process
	  , Promise   = global.Promise
	  , isNode    = __webpack_require__(34)(process) == 'process';
	
	module.exports = function(){
	  var head, last, notify;
	
	  var flush = function(){
	    var parent, fn;
	    if(isNode && (parent = process.domain))parent.exit();
	    while(head){
	      fn   = head.fn;
	      head = head.next;
	      try {
	        fn();
	      } catch(e){
	        if(head)notify();
	        else last = undefined;
	        throw e;
	      }
	    } last = undefined;
	    if(parent)parent.enter();
	  };
	
	  // Node.js
	  if(isNode){
	    notify = function(){
	      process.nextTick(flush);
	    };
	  // browsers with MutationObserver
	  } else if(Observer){
	    var toggle = true
	      , node   = document.createTextNode('');
	    new Observer(flush).observe(node, {characterData: true}); // eslint-disable-line no-new
	    notify = function(){
	      node.data = toggle = !toggle;
	    };
	  // environments with maybe non-completely correct, but existent Promise
	  } else if(Promise && Promise.resolve){
	    var promise = Promise.resolve();
	    notify = function(){
	      promise.then(flush);
	    };
	  // for other environments - macrotask based on:
	  // - setImmediate
	  // - MessageChannel
	  // - window.postMessag
	  // - onreadystatechange
	  // - setTimeout
	  } else {
	    notify = function(){
	      // strange IE + webpack dev server bug - use .call(global)
	      macrotask.call(global, flush);
	    };
	  }
	
	  return function(fn){
	    var task = {fn: fn, next: undefined};
	    if(last)last.next = task;
	    if(!head){
	      head = task;
	      notify();
	    } last = task;
	  };
	};

/***/ },
/* 160 */
/***/ function(module, exports, __webpack_require__) {

	var shared = __webpack_require__(114)('keys')
	  , uid    = __webpack_require__(72);
	module.exports = function(key){
	  return shared[key] || (shared[key] = uid(key));
	};

/***/ },
/* 161 */
/***/ function(module, exports, __webpack_require__) {

	// 7.3.20 SpeciesConstructor(O, defaultConstructor)
	var anObject  = __webpack_require__(4)
	  , aFunction = __webpack_require__(26)
	  , SPECIES   = __webpack_require__(11)('species');
	module.exports = function(O, D){
	  var C = anObject(O).constructor, S;
	  return C === undefined || (S = anObject(C)[SPECIES]) == undefined ? D : aFunction(S);
	};

/***/ },
/* 162 */
/***/ function(module, exports, __webpack_require__) {

	var toInteger = __webpack_require__(58)
	  , defined   = __webpack_require__(35);
	// true  -> String#at
	// false -> String#codePointAt
	module.exports = function(TO_STRING){
	  return function(that, pos){
	    var s = String(defined(that))
	      , i = toInteger(pos)
	      , l = s.length
	      , a, b;
	    if(i < 0 || i >= l)return TO_STRING ? '' : undefined;
	    a = s.charCodeAt(i);
	    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
	      ? TO_STRING ? s.charAt(i) : a
	      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
	  };
	};

/***/ },
/* 163 */
/***/ function(module, exports, __webpack_require__) {

	// helper for String#{startsWith, endsWith, includes}
	var isRegExp = __webpack_require__(109)
	  , defined  = __webpack_require__(35);
	
	module.exports = function(that, searchString, NAME){
	  if(isRegExp(searchString))throw TypeError('String#' + NAME + " doesn't accept regex!");
	  return String(defined(that));
	};

/***/ },
/* 164 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var toInteger = __webpack_require__(58)
	  , defined   = __webpack_require__(35);
	
	module.exports = function repeat(count){
	  var str = String(defined(this))
	    , res = ''
	    , n   = toInteger(count);
	  if(n < 0 || n == Infinity)throw RangeError("Count can't be negative");
	  for(;n > 0; (n >>>= 1) && (str += str))if(n & 1)res += str;
	  return res;
	};

/***/ },
/* 165 */
/***/ function(module, exports) {

	module.exports = '\x09\x0A\x0B\x0C\x0D\x20\xA0\u1680\u180E\u2000\u2001\u2002\u2003' +
	  '\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF';

/***/ },
/* 166 */
/***/ function(module, exports, __webpack_require__) {

	var ctx                = __webpack_require__(47)
	  , invoke             = __webpack_require__(108)
	  , html               = __webpack_require__(150)
	  , cel                = __webpack_require__(147)
	  , global             = __webpack_require__(7)
	  , process            = global.process
	  , setTask            = global.setImmediate
	  , clearTask          = global.clearImmediate
	  , MessageChannel     = global.MessageChannel
	  , counter            = 0
	  , queue              = {}
	  , ONREADYSTATECHANGE = 'onreadystatechange'
	  , defer, channel, port;
	var run = function(){
	  var id = +this;
	  if(queue.hasOwnProperty(id)){
	    var fn = queue[id];
	    delete queue[id];
	    fn();
	  }
	};
	var listener = function(event){
	  run.call(event.data);
	};
	// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
	if(!setTask || !clearTask){
	  setTask = function setImmediate(fn){
	    var args = [], i = 1;
	    while(arguments.length > i)args.push(arguments[i++]);
	    queue[++counter] = function(){
	      invoke(typeof fn == 'function' ? fn : Function(fn), args);
	    };
	    defer(counter);
	    return counter;
	  };
	  clearTask = function clearImmediate(id){
	    delete queue[id];
	  };
	  // Node.js 0.8-
	  if(__webpack_require__(34)(process) == 'process'){
	    defer = function(id){
	      process.nextTick(ctx(run, id, 1));
	    };
	  // Browsers with MessageChannel, includes WebWorkers
	  } else if(MessageChannel){
	    channel = new MessageChannel;
	    port    = channel.port2;
	    channel.port1.onmessage = listener;
	    defer = ctx(port.postMessage, port, 1);
	  // Browsers with postMessage, skip WebWorkers
	  // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
	  } else if(global.addEventListener && typeof postMessage == 'function' && !global.importScripts){
	    defer = function(id){
	      global.postMessage(id + '', '*');
	    };
	    global.addEventListener('message', listener, false);
	  // IE8-
	  } else if(ONREADYSTATECHANGE in cel('script')){
	    defer = function(id){
	      html.appendChild(cel('script'))[ONREADYSTATECHANGE] = function(){
	        html.removeChild(this);
	        run.call(id);
	      };
	    };
	  // Rest old browsers
	  } else {
	    defer = function(id){
	      setTimeout(ctx(run, id, 1), 0);
	    };
	  }
	}
	module.exports = {
	  set:   setTask,
	  clear: clearTask
	};

/***/ },
/* 167 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var global         = __webpack_require__(7)
	  , DESCRIPTORS    = __webpack_require__(13)
	  , LIBRARY        = __webpack_require__(65)
	  , $typed         = __webpack_require__(115)
	  , hide           = __webpack_require__(21)
	  , redefineAll    = __webpack_require__(69)
	  , fails          = __webpack_require__(8)
	  , anInstance     = __webpack_require__(55)
	  , toInteger      = __webpack_require__(58)
	  , toLength       = __webpack_require__(16)
	  , gOPN           = __webpack_require__(67).f
	  , dP             = __webpack_require__(14).f
	  , arrayFill      = __webpack_require__(145)
	  , setToStringTag = __webpack_require__(80)
	  , ARRAY_BUFFER   = 'ArrayBuffer'
	  , DATA_VIEW      = 'DataView'
	  , PROTOTYPE      = 'prototype'
	  , WRONG_LENGTH   = 'Wrong length!'
	  , WRONG_INDEX    = 'Wrong index!'
	  , $ArrayBuffer   = global[ARRAY_BUFFER]
	  , $DataView      = global[DATA_VIEW]
	  , Math           = global.Math
	  , parseInt       = global.parseInt
	  , RangeError     = global.RangeError
	  , Infinity       = global.Infinity
	  , BaseBuffer     = $ArrayBuffer
	  , abs            = Math.abs
	  , pow            = Math.pow
	  , min            = Math.min
	  , floor          = Math.floor
	  , log            = Math.log
	  , LN2            = Math.LN2
	  , BUFFER         = 'buffer'
	  , BYTE_LENGTH    = 'byteLength'
	  , BYTE_OFFSET    = 'byteOffset'
	  , $BUFFER        = DESCRIPTORS ? '_b' : BUFFER
	  , $LENGTH        = DESCRIPTORS ? '_l' : BYTE_LENGTH
	  , $OFFSET        = DESCRIPTORS ? '_o' : BYTE_OFFSET;
	
	// IEEE754 conversions based on https://github.com/feross/ieee754
	var packIEEE754 = function(value, mLen, nBytes){
	  var buffer = Array(nBytes)
	    , eLen   = nBytes * 8 - mLen - 1
	    , eMax   = (1 << eLen) - 1
	    , eBias  = eMax >> 1
	    , rt     = mLen === 23 ? pow(2, -24) - pow(2, -77) : 0
	    , i      = 0
	    , s      = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0
	    , e, m, c;
	  value = abs(value)
	  if(value != value || value === Infinity){
	    m = value != value ? 1 : 0;
	    e = eMax;
	  } else {
	    e = floor(log(value) / LN2);
	    if(value * (c = pow(2, -e)) < 1){
	      e--;
	      c *= 2;
	    }
	    if(e + eBias >= 1){
	      value += rt / c;
	    } else {
	      value += rt * pow(2, 1 - eBias);
	    }
	    if(value * c >= 2){
	      e++;
	      c /= 2;
	    }
	    if(e + eBias >= eMax){
	      m = 0;
	      e = eMax;
	    } else if(e + eBias >= 1){
	      m = (value * c - 1) * pow(2, mLen);
	      e = e + eBias;
	    } else {
	      m = value * pow(2, eBias - 1) * pow(2, mLen);
	      e = 0;
	    }
	  }
	  for(; mLen >= 8; buffer[i++] = m & 255, m /= 256, mLen -= 8);
	  e = e << mLen | m;
	  eLen += mLen;
	  for(; eLen > 0; buffer[i++] = e & 255, e /= 256, eLen -= 8);
	  buffer[--i] |= s * 128;
	  return buffer;
	};
	var unpackIEEE754 = function(buffer, mLen, nBytes){
	  var eLen  = nBytes * 8 - mLen - 1
	    , eMax  = (1 << eLen) - 1
	    , eBias = eMax >> 1
	    , nBits = eLen - 7
	    , i     = nBytes - 1
	    , s     = buffer[i--]
	    , e     = s & 127
	    , m;
	  s >>= 7;
	  for(; nBits > 0; e = e * 256 + buffer[i], i--, nBits -= 8);
	  m = e & (1 << -nBits) - 1;
	  e >>= -nBits;
	  nBits += mLen;
	  for(; nBits > 0; m = m * 256 + buffer[i], i--, nBits -= 8);
	  if(e === 0){
	    e = 1 - eBias;
	  } else if(e === eMax){
	    return m ? NaN : s ? -Infinity : Infinity;
	  } else {
	    m = m + pow(2, mLen);
	    e = e - eBias;
	  } return (s ? -1 : 1) * m * pow(2, e - mLen);
	};
	
	var unpackI32 = function(bytes){
	  return bytes[3] << 24 | bytes[2] << 16 | bytes[1] << 8 | bytes[0];
	};
	var packI8 = function(it){
	  return [it & 0xff];
	};
	var packI16 = function(it){
	  return [it & 0xff, it >> 8 & 0xff];
	};
	var packI32 = function(it){
	  return [it & 0xff, it >> 8 & 0xff, it >> 16 & 0xff, it >> 24 & 0xff];
	};
	var packF64 = function(it){
	  return packIEEE754(it, 52, 8);
	};
	var packF32 = function(it){
	  return packIEEE754(it, 23, 4);
	};
	
	var addGetter = function(C, key, internal){
	  dP(C[PROTOTYPE], key, {get: function(){ return this[internal]; }});
	};
	
	var get = function(view, bytes, index, isLittleEndian){
	  var numIndex = +index
	    , intIndex = toInteger(numIndex);
	  if(numIndex != intIndex || intIndex < 0 || intIndex + bytes > view[$LENGTH])throw RangeError(WRONG_INDEX);
	  var store = view[$BUFFER]._b
	    , start = intIndex + view[$OFFSET]
	    , pack  = store.slice(start, start + bytes);
	  return isLittleEndian ? pack : pack.reverse();
	};
	var set = function(view, bytes, index, conversion, value, isLittleEndian){
	  var numIndex = +index
	    , intIndex = toInteger(numIndex);
	  if(numIndex != intIndex || intIndex < 0 || intIndex + bytes > view[$LENGTH])throw RangeError(WRONG_INDEX);
	  var store = view[$BUFFER]._b
	    , start = intIndex + view[$OFFSET]
	    , pack  = conversion(+value);
	  for(var i = 0; i < bytes; i++)store[start + i] = pack[isLittleEndian ? i : bytes - i - 1];
	};
	
	var validateArrayBufferArguments = function(that, length){
	  anInstance(that, $ArrayBuffer, ARRAY_BUFFER);
	  var numberLength = +length
	    , byteLength   = toLength(numberLength);
	  if(numberLength != byteLength)throw RangeError(WRONG_LENGTH);
	  return byteLength;
	};
	
	if(!$typed.ABV){
	  $ArrayBuffer = function ArrayBuffer(length){
	    var byteLength = validateArrayBufferArguments(this, length);
	    this._b       = arrayFill.call(Array(byteLength), 0);
	    this[$LENGTH] = byteLength;
	  };
	
	  $DataView = function DataView(buffer, byteOffset, byteLength){
	    anInstance(this, $DataView, DATA_VIEW);
	    anInstance(buffer, $ArrayBuffer, DATA_VIEW);
	    var bufferLength = buffer[$LENGTH]
	      , offset       = toInteger(byteOffset);
	    if(offset < 0 || offset > bufferLength)throw RangeError('Wrong offset!');
	    byteLength = byteLength === undefined ? bufferLength - offset : toLength(byteLength);
	    if(offset + byteLength > bufferLength)throw RangeError(WRONG_LENGTH);
	    this[$BUFFER] = buffer;
	    this[$OFFSET] = offset;
	    this[$LENGTH] = byteLength;
	  };
	
	  if(DESCRIPTORS){
	    addGetter($ArrayBuffer, BYTE_LENGTH, '_l');
	    addGetter($DataView, BUFFER, '_b');
	    addGetter($DataView, BYTE_LENGTH, '_l');
	    addGetter($DataView, BYTE_OFFSET, '_o');
	  }
	
	  redefineAll($DataView[PROTOTYPE], {
	    getInt8: function getInt8(byteOffset){
	      return get(this, 1, byteOffset)[0] << 24 >> 24;
	    },
	    getUint8: function getUint8(byteOffset){
	      return get(this, 1, byteOffset)[0];
	    },
	    getInt16: function getInt16(byteOffset /*, littleEndian */){
	      var bytes = get(this, 2, byteOffset, arguments[1]);
	      return (bytes[1] << 8 | bytes[0]) << 16 >> 16;
	    },
	    getUint16: function getUint16(byteOffset /*, littleEndian */){
	      var bytes = get(this, 2, byteOffset, arguments[1]);
	      return bytes[1] << 8 | bytes[0];
	    },
	    getInt32: function getInt32(byteOffset /*, littleEndian */){
	      return unpackI32(get(this, 4, byteOffset, arguments[1]));
	    },
	    getUint32: function getUint32(byteOffset /*, littleEndian */){
	      return unpackI32(get(this, 4, byteOffset, arguments[1])) >>> 0;
	    },
	    getFloat32: function getFloat32(byteOffset /*, littleEndian */){
	      return unpackIEEE754(get(this, 4, byteOffset, arguments[1]), 23, 4);
	    },
	    getFloat64: function getFloat64(byteOffset /*, littleEndian */){
	      return unpackIEEE754(get(this, 8, byteOffset, arguments[1]), 52, 8);
	    },
	    setInt8: function setInt8(byteOffset, value){
	      set(this, 1, byteOffset, packI8, value);
	    },
	    setUint8: function setUint8(byteOffset, value){
	      set(this, 1, byteOffset, packI8, value);
	    },
	    setInt16: function setInt16(byteOffset, value /*, littleEndian */){
	      set(this, 2, byteOffset, packI16, value, arguments[2]);
	    },
	    setUint16: function setUint16(byteOffset, value /*, littleEndian */){
	      set(this, 2, byteOffset, packI16, value, arguments[2]);
	    },
	    setInt32: function setInt32(byteOffset, value /*, littleEndian */){
	      set(this, 4, byteOffset, packI32, value, arguments[2]);
	    },
	    setUint32: function setUint32(byteOffset, value /*, littleEndian */){
	      set(this, 4, byteOffset, packI32, value, arguments[2]);
	    },
	    setFloat32: function setFloat32(byteOffset, value /*, littleEndian */){
	      set(this, 4, byteOffset, packF32, value, arguments[2]);
	    },
	    setFloat64: function setFloat64(byteOffset, value /*, littleEndian */){
	      set(this, 8, byteOffset, packF64, value, arguments[2]);
	    }
	  });
	} else {
	  if(!fails(function(){
	    new $ArrayBuffer;     // eslint-disable-line no-new
	  }) || !fails(function(){
	    new $ArrayBuffer(.5); // eslint-disable-line no-new
	  })){
	    $ArrayBuffer = function ArrayBuffer(length){
	      return new BaseBuffer(validateArrayBufferArguments(this, length));
	    };
	    var ArrayBufferProto = $ArrayBuffer[PROTOTYPE] = BaseBuffer[PROTOTYPE];
	    for(var keys = gOPN(BaseBuffer), j = 0, key; keys.length > j; ){
	      if(!((key = keys[j++]) in $ArrayBuffer))hide($ArrayBuffer, key, BaseBuffer[key]);
	    };
	    if(!LIBRARY)ArrayBufferProto.constructor = $ArrayBuffer;
	  }
	  // iOS Safari 7.x bug
	  var view = new $DataView(new $ArrayBuffer(2))
	    , $setInt8 = $DataView[PROTOTYPE].setInt8;
	  view.setInt8(0, 2147483648);
	  view.setInt8(1, 2147483649);
	  if(view.getInt8(0) || !view.getInt8(1))redefineAll($DataView[PROTOTYPE], {
	    setInt8: function setInt8(byteOffset, value){
	      $setInt8.call(this, byteOffset, value << 24 >> 24);
	    },
	    setUint8: function setUint8(byteOffset, value){
	      $setInt8.call(this, byteOffset, value << 24 >> 24);
	    }
	  }, true);
	}
	setToStringTag($ArrayBuffer, ARRAY_BUFFER);
	setToStringTag($DataView, DATA_VIEW);
	hide($DataView[PROTOTYPE], $typed.VIEW, true);
	exports[ARRAY_BUFFER] = $ArrayBuffer;
	exports[DATA_VIEW] = $DataView;

/***/ },
/* 168 */
/***/ function(module, exports, __webpack_require__) {

	var global         = __webpack_require__(7)
	  , core           = __webpack_require__(42)
	  , LIBRARY        = __webpack_require__(65)
	  , wksExt         = __webpack_require__(238)
	  , defineProperty = __webpack_require__(14).f;
	module.exports = function(name){
	  var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
	  if(name.charAt(0) != '_' && !(name in $Symbol))defineProperty($Symbol, name, {value: wksExt.f(name)});
	};

/***/ },
/* 169 */
/***/ function(module, exports, __webpack_require__) {

	var classof   = __webpack_require__(78)
	  , ITERATOR  = __webpack_require__(11)('iterator')
	  , Iterators = __webpack_require__(64);
	module.exports = __webpack_require__(42).getIteratorMethod = function(it){
	  if(it != undefined)return it[ITERATOR]
	    || it['@@iterator']
	    || Iterators[classof(it)];
	};

/***/ },
/* 170 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var addToUnscopables = __webpack_require__(77)
	  , step             = __webpack_require__(226)
	  , Iterators        = __webpack_require__(64)
	  , toIObject        = __webpack_require__(29);
	
	// 22.1.3.4 Array.prototype.entries()
	// 22.1.3.13 Array.prototype.keys()
	// 22.1.3.29 Array.prototype.values()
	// 22.1.3.30 Array.prototype[@@iterator]()
	module.exports = __webpack_require__(156)(Array, 'Array', function(iterated, kind){
	  this._t = toIObject(iterated); // target
	  this._i = 0;                   // next index
	  this._k = kind;                // kind
	// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
	}, function(){
	  var O     = this._t
	    , kind  = this._k
	    , index = this._i++;
	  if(!O || index >= O.length){
	    this._t = undefined;
	    return step(1);
	  }
	  if(kind == 'keys'  )return step(0, index);
	  if(kind == 'values')return step(0, O[index]);
	  return step(0, [index, O[index]]);
	}, 'values');
	
	// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
	Iterators.Arguments = Iterators.Array;
	
	addToUnscopables('keys');
	addToUnscopables('values');
	addToUnscopables('entries');

/***/ },
/* 171 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = ClassList
	
	var indexOf = __webpack_require__(534),
	    trim = __webpack_require__(822),
	    arr = Array.prototype
	
	/**
	 * ClassList(elem) is kind of like Element#classList.
	 *
	 * @param {Element} elem
	 * @return {ClassList}
	 */
	function ClassList (elem) {
	  if (!(this instanceof ClassList))
	    return new ClassList(elem)
	
	  var classes = trim(elem.className).split(/\s+/),
	      i
	
	  this._elem = elem
	
	  this.length = 0
	
	  for (i = 0; i < classes.length; i += 1) {
	    if (classes[i])
	      arr.push.call(this, classes[i])
	  }
	}
	
	/**
	 * add(class1 [, class2 [, ...]]) adds the given class(es) to the
	 * element.
	 *
	 * @param {String} ...
	 * @return {Context}
	 */
	ClassList.prototype.add = function () {
	  var name,
	      i
	
	  for (i = 0; i < arguments.length; i += 1) {
	    name = '' + arguments[i]
	
	    if (indexOf(this, name) >= 0)
	      continue
	
	    arr.push.call(this, name)
	  }
	
	  this._elem.className = this.toString()
	
	  return this
	}
	
	/**
	 * remove(class1 [, class2 [, ...]]) removes the given class(es) from
	 * the element.
	 *
	 * @param {String} ...
	 * @return {Context}
	 */
	ClassList.prototype.remove = function () {
	  var index,
	      name,
	      i
	
	  for (i = 0; i < arguments.length; i += 1) {
	    name = '' + arguments[i]
	    index = indexOf(this, name)
	
	    if (index < 0) continue
	
	    arr.splice.call(this, index, 1)
	  }
	
	  this._elem.className = this.toString()
	
	  return this
	}
	
	/**
	 * contains(name) determines if the element has a given class.
	 *
	 * @param {String} name
	 * @return {Boolean}
	 */
	ClassList.prototype.contains = function (name) {
	  name += ''
	  return indexOf(this, name) >= 0
	}
	
	/**
	 * toggle(name [, force]) toggles a class. If force is a boolean,
	 * this method is basically just an alias for add/remove.
	 *
	 * @param {String} name
	 * @param {Boolean} force
	 * @return {Context}
	 */
	ClassList.prototype.toggle = function (name, force) {
	  name += ''
	
	  if (force === true) return this.add(name)
	  if (force === false) return this.remove(name)
	
	  return this[this.contains(name) ? 'remove' : 'add'](name)
	}
	
	/**
	 * toString() returns the className of the element.
	 *
	 * @return {String}
	 */
	ClassList.prototype.toString = function () {
	  return arr.join.call(this, ' ')
	}


/***/ },
/* 172 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.go = exports.replaceLocation = exports.pushLocation = exports.startListener = exports.getUserConfirmation = exports.getCurrentLocation = undefined;
	
	var _LocationUtils = __webpack_require__(82);
	
	var _DOMUtils = __webpack_require__(119);
	
	var _DOMStateStorage = __webpack_require__(248);
	
	var _PathUtils = __webpack_require__(59);
	
	var _ExecutionEnvironment = __webpack_require__(173);
	
	var PopStateEvent = 'popstate';
	var HashChangeEvent = 'hashchange';
	
	var needsHashchangeListener = _ExecutionEnvironment.canUseDOM && !(0, _DOMUtils.supportsPopstateOnHashchange)();
	
	var _createLocation = function _createLocation(historyState) {
	  var key = historyState && historyState.key;
	
	  return (0, _LocationUtils.createLocation)({
	    pathname: window.location.pathname,
	    search: window.location.search,
	    hash: window.location.hash,
	    state: key ? (0, _DOMStateStorage.readState)(key) : undefined
	  }, undefined, key);
	};
	
	var getCurrentLocation = exports.getCurrentLocation = function getCurrentLocation() {
	  var historyState = void 0;
	  try {
	    historyState = window.history.state || {};
	  } catch (error) {
	    // IE 11 sometimes throws when accessing window.history.state
	    // See https://github.com/ReactTraining/history/pull/289
	    historyState = {};
	  }
	
	  return _createLocation(historyState);
	};
	
	var getUserConfirmation = exports.getUserConfirmation = function getUserConfirmation(message, callback) {
	  return callback(window.confirm(message));
	}; // eslint-disable-line no-alert
	
	var startListener = exports.startListener = function startListener(listener) {
	  var handlePopState = function handlePopState(event) {
	    if (event.state !== undefined) // Ignore extraneous popstate events in WebKit
	      listener(_createLocation(event.state));
	  };
	
	  (0, _DOMUtils.addEventListener)(window, PopStateEvent, handlePopState);
	
	  var handleUnpoppedHashChange = function handleUnpoppedHashChange() {
	    return listener(getCurrentLocation());
	  };
	
	  if (needsHashchangeListener) {
	    (0, _DOMUtils.addEventListener)(window, HashChangeEvent, handleUnpoppedHashChange);
	  }
	
	  return function () {
	    (0, _DOMUtils.removeEventListener)(window, PopStateEvent, handlePopState);
	
	    if (needsHashchangeListener) {
	      (0, _DOMUtils.removeEventListener)(window, HashChangeEvent, handleUnpoppedHashChange);
	    }
	  };
	};
	
	var updateLocation = function updateLocation(location, updateState) {
	  var state = location.state;
	  var key = location.key;
	
	
	  if (state !== undefined) (0, _DOMStateStorage.saveState)(key, state);
	
	  updateState({ key: key }, (0, _PathUtils.createPath)(location));
	};
	
	var pushLocation = exports.pushLocation = function pushLocation(location) {
	  return updateLocation(location, function (state, path) {
	    return window.history.pushState(state, null, path);
	  });
	};
	
	var replaceLocation = exports.replaceLocation = function replaceLocation(location) {
	  return updateLocation(location, function (state, path) {
	    return window.history.replaceState(state, null, path);
	  });
	};
	
	var go = exports.go = function go(n) {
	  if (n) window.history.go(n);
	};

/***/ },
/* 173 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	var canUseDOM = exports.canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

/***/ },
/* 174 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _AsyncUtils = __webpack_require__(551);
	
	var _PathUtils = __webpack_require__(59);
	
	var _runTransitionHook = __webpack_require__(175);
	
	var _runTransitionHook2 = _interopRequireDefault(_runTransitionHook);
	
	var _Actions = __webpack_require__(118);
	
	var _LocationUtils = __webpack_require__(82);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var createHistory = function createHistory() {
	  var options = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	  var getCurrentLocation = options.getCurrentLocation;
	  var getUserConfirmation = options.getUserConfirmation;
	  var pushLocation = options.pushLocation;
	  var replaceLocation = options.replaceLocation;
	  var go = options.go;
	  var keyLength = options.keyLength;
	
	
	  var currentLocation = void 0;
	  var pendingLocation = void 0;
	  var beforeListeners = [];
	  var listeners = [];
	  var allKeys = [];
	
	  var getCurrentIndex = function getCurrentIndex() {
	    if (pendingLocation && pendingLocation.action === _Actions.POP) return allKeys.indexOf(pendingLocation.key);
	
	    if (currentLocation) return allKeys.indexOf(currentLocation.key);
	
	    return -1;
	  };
	
	  var updateLocation = function updateLocation(nextLocation) {
	    var currentIndex = getCurrentIndex();
	
	    currentLocation = nextLocation;
	
	    if (currentLocation.action === _Actions.PUSH) {
	      allKeys = [].concat(allKeys.slice(0, currentIndex + 1), [currentLocation.key]);
	    } else if (currentLocation.action === _Actions.REPLACE) {
	      allKeys[currentIndex] = currentLocation.key;
	    }
	
	    listeners.forEach(function (listener) {
	      return listener(currentLocation);
	    });
	  };
	
	  var listenBefore = function listenBefore(listener) {
	    beforeListeners.push(listener);
	
	    return function () {
	      return beforeListeners = beforeListeners.filter(function (item) {
	        return item !== listener;
	      });
	    };
	  };
	
	  var listen = function listen(listener) {
	    listeners.push(listener);
	
	    return function () {
	      return listeners = listeners.filter(function (item) {
	        return item !== listener;
	      });
	    };
	  };
	
	  var confirmTransitionTo = function confirmTransitionTo(location, callback) {
	    (0, _AsyncUtils.loopAsync)(beforeListeners.length, function (index, next, done) {
	      (0, _runTransitionHook2.default)(beforeListeners[index], location, function (result) {
	        return result != null ? done(result) : next();
	      });
	    }, function (message) {
	      if (getUserConfirmation && typeof message === 'string') {
	        getUserConfirmation(message, function (ok) {
	          return callback(ok !== false);
	        });
	      } else {
	        callback(message !== false);
	      }
	    });
	  };
	
	  var transitionTo = function transitionTo(nextLocation) {
	    if (currentLocation && (0, _LocationUtils.locationsAreEqual)(currentLocation, nextLocation) || pendingLocation && (0, _LocationUtils.locationsAreEqual)(pendingLocation, nextLocation)) return; // Nothing to do
	
	    pendingLocation = nextLocation;
	
	    confirmTransitionTo(nextLocation, function (ok) {
	      if (pendingLocation !== nextLocation) return; // Transition was interrupted during confirmation
	
	      pendingLocation = null;
	
	      if (ok) {
	        // Treat PUSH to same path like REPLACE to be consistent with browsers
	        if (nextLocation.action === _Actions.PUSH) {
	          var prevPath = (0, _PathUtils.createPath)(currentLocation);
	          var nextPath = (0, _PathUtils.createPath)(nextLocation);
	
	          if (nextPath === prevPath && (0, _LocationUtils.statesAreEqual)(currentLocation.state, nextLocation.state)) nextLocation.action = _Actions.REPLACE;
	        }
	
	        if (nextLocation.action === _Actions.POP) {
	          updateLocation(nextLocation);
	        } else if (nextLocation.action === _Actions.PUSH) {
	          if (pushLocation(nextLocation) !== false) updateLocation(nextLocation);
	        } else if (nextLocation.action === _Actions.REPLACE) {
	          if (replaceLocation(nextLocation) !== false) updateLocation(nextLocation);
	        }
	      } else if (currentLocation && nextLocation.action === _Actions.POP) {
	        var prevIndex = allKeys.indexOf(currentLocation.key);
	        var nextIndex = allKeys.indexOf(nextLocation.key);
	
	        if (prevIndex !== -1 && nextIndex !== -1) go(prevIndex - nextIndex); // Restore the URL
	      }
	    });
	  };
	
	  var push = function push(input) {
	    return transitionTo(createLocation(input, _Actions.PUSH));
	  };
	
	  var replace = function replace(input) {
	    return transitionTo(createLocation(input, _Actions.REPLACE));
	  };
	
	  var goBack = function goBack() {
	    return go(-1);
	  };
	
	  var goForward = function goForward() {
	    return go(1);
	  };
	
	  var createKey = function createKey() {
	    return Math.random().toString(36).substr(2, keyLength || 6);
	  };
	
	  var createHref = function createHref(location) {
	    return (0, _PathUtils.createPath)(location);
	  };
	
	  var createLocation = function createLocation(location, action) {
	    var key = arguments.length <= 2 || arguments[2] === undefined ? createKey() : arguments[2];
	    return (0, _LocationUtils.createLocation)(location, action, key);
	  };
	
	  return {
	    getCurrentLocation: getCurrentLocation,
	    listenBefore: listenBefore,
	    listen: listen,
	    transitionTo: transitionTo,
	    push: push,
	    replace: replace,
	    go: go,
	    goBack: goBack,
	    goForward: goForward,
	    createKey: createKey,
	    createPath: _PathUtils.createPath,
	    createHref: createHref,
	    createLocation: createLocation
	  };
	};
	
	exports.default = createHistory;

/***/ },
/* 175 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _warning = __webpack_require__(63);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var runTransitionHook = function runTransitionHook(hook, location, callback) {
	  var result = hook(location, callback);
	
	  if (hook.length < 2) {
	    // Assume the hook runs synchronously and automatically
	    // call the callback with the return value.
	    callback(result);
	  } else {
	     false ? (0, _warning2.default)(result === undefined, 'You should not "return" in a transition hook with a callback argument; ' + 'call the callback instead') : void 0;
	  }
	};
	
	exports.default = runTransitionHook;

/***/ },
/* 176 */
/***/ function(module, exports, __webpack_require__) {

	var baseCreate = __webpack_require__(125),
	    baseLodash = __webpack_require__(180);
	
	/** Used as references for the maximum length and index of an array. */
	var MAX_ARRAY_LENGTH = 4294967295;
	
	/**
	 * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
	 *
	 * @private
	 * @constructor
	 * @param {*} value The value to wrap.
	 */
	function LazyWrapper(value) {
	  this.__wrapped__ = value;
	  this.__actions__ = [];
	  this.__dir__ = 1;
	  this.__filtered__ = false;
	  this.__iteratees__ = [];
	  this.__takeCount__ = MAX_ARRAY_LENGTH;
	  this.__views__ = [];
	}
	
	// Ensure `LazyWrapper` is an instance of `baseLodash`.
	LazyWrapper.prototype = baseCreate(baseLodash.prototype);
	LazyWrapper.prototype.constructor = LazyWrapper;
	
	module.exports = LazyWrapper;


/***/ },
/* 177 */
/***/ function(module, exports, __webpack_require__) {

	var mapCacheClear = __webpack_require__(638),
	    mapCacheDelete = __webpack_require__(639),
	    mapCacheGet = __webpack_require__(640),
	    mapCacheHas = __webpack_require__(641),
	    mapCacheSet = __webpack_require__(642);
	
	/**
	 * Creates a map cache object to store key-value pairs.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function MapCache(entries) {
	  var index = -1,
	      length = entries ? entries.length : 0;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	// Add methods to `MapCache`.
	MapCache.prototype.clear = mapCacheClear;
	MapCache.prototype['delete'] = mapCacheDelete;
	MapCache.prototype.get = mapCacheGet;
	MapCache.prototype.has = mapCacheHas;
	MapCache.prototype.set = mapCacheSet;
	
	module.exports = MapCache;


/***/ },
/* 178 */
/***/ function(module, exports, __webpack_require__) {

	var ListCache = __webpack_require__(120),
	    stackClear = __webpack_require__(649),
	    stackDelete = __webpack_require__(650),
	    stackGet = __webpack_require__(651),
	    stackHas = __webpack_require__(652),
	    stackSet = __webpack_require__(653);
	
	/**
	 * Creates a stack cache object to store key-value pairs.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function Stack(entries) {
	  this.__data__ = new ListCache(entries);
	}
	
	// Add methods to `Stack`.
	Stack.prototype.clear = stackClear;
	Stack.prototype['delete'] = stackDelete;
	Stack.prototype.get = stackGet;
	Stack.prototype.has = stackHas;
	Stack.prototype.set = stackSet;
	
	module.exports = Stack;


/***/ },
/* 179 */
/***/ function(module, exports, __webpack_require__) {

	var root = __webpack_require__(24);
	
	/** Built-in value references. */
	var Symbol = root.Symbol;
	
	module.exports = Symbol;


/***/ },
/* 180 */
/***/ function(module, exports) {

	/**
	 * The function whose prototype chain sequence wrappers inherit from.
	 *
	 * @private
	 */
	function baseLodash() {
	  // No operation performed.
	}
	
	module.exports = baseLodash;


/***/ },
/* 181 */
/***/ function(module, exports, __webpack_require__) {

	var Uint8Array = __webpack_require__(254);
	
	/**
	 * Creates a clone of `arrayBuffer`.
	 *
	 * @private
	 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
	 * @returns {ArrayBuffer} Returns the cloned array buffer.
	 */
	function cloneArrayBuffer(arrayBuffer) {
	  var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
	  new Uint8Array(result).set(new Uint8Array(arrayBuffer));
	  return result;
	}
	
	module.exports = cloneArrayBuffer;


/***/ },
/* 182 */
/***/ function(module, exports) {

	/**
	 * Copies the values of `source` to `array`.
	 *
	 * @private
	 * @param {Array} source The array to copy values from.
	 * @param {Array} [array=[]] The array to copy values to.
	 * @returns {Array} Returns `array`.
	 */
	function copyArray(source, array) {
	  var index = -1,
	      length = source.length;
	
	  array || (array = Array(length));
	  while (++index < length) {
	    array[index] = source[index];
	  }
	  return array;
	}
	
	module.exports = copyArray;


/***/ },
/* 183 */
/***/ function(module, exports, __webpack_require__) {

	var isIterateeCall = __webpack_require__(628),
	    rest = __webpack_require__(190);
	
	/**
	 * Creates a function like `_.assign`.
	 *
	 * @private
	 * @param {Function} assigner The function to assign values.
	 * @returns {Function} Returns the new assigner function.
	 */
	function createAssigner(assigner) {
	  return rest(function(object, sources) {
	    var index = -1,
	        length = sources.length,
	        customizer = length > 1 ? sources[length - 1] : undefined,
	        guard = length > 2 ? sources[2] : undefined;
	
	    customizer = (assigner.length > 3 && typeof customizer == 'function')
	      ? (length--, customizer)
	      : undefined;
	
	    if (guard && isIterateeCall(sources[0], sources[1], guard)) {
	      customizer = length < 3 ? undefined : customizer;
	      length = 1;
	    }
	    object = Object(object);
	    while (++index < length) {
	      var source = sources[index];
	      if (source) {
	        assigner(object, source, index, customizer);
	      }
	    }
	    return object;
	  });
	}
	
	module.exports = createAssigner;


/***/ },
/* 184 */
/***/ function(module, exports) {

	/**
	 * Gets the argument placeholder value for `func`.
	 *
	 * @private
	 * @param {Function} func The function to inspect.
	 * @returns {*} Returns the placeholder value.
	 */
	function getHolder(func) {
	  var object = func;
	  return object.placeholder;
	}
	
	module.exports = getHolder;


/***/ },
/* 185 */
/***/ function(module, exports, __webpack_require__) {

	var DataView = __webpack_require__(558),
	    Map = __webpack_require__(253),
	    Promise = __webpack_require__(560),
	    Set = __webpack_require__(562),
	    WeakMap = __webpack_require__(255),
	    toSource = __webpack_require__(278);
	
	/** `Object#toString` result references. */
	var mapTag = '[object Map]',
	    objectTag = '[object Object]',
	    promiseTag = '[object Promise]',
	    setTag = '[object Set]',
	    weakMapTag = '[object WeakMap]';
	
	var dataViewTag = '[object DataView]';
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objectToString = objectProto.toString;
	
	/** Used to detect maps, sets, and weakmaps. */
	var dataViewCtorString = toSource(DataView),
	    mapCtorString = toSource(Map),
	    promiseCtorString = toSource(Promise),
	    setCtorString = toSource(Set),
	    weakMapCtorString = toSource(WeakMap);
	
	/**
	 * Gets the `toStringTag` of `value`.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the `toStringTag`.
	 */
	function getTag(value) {
	  return objectToString.call(value);
	}
	
	// Fallback for data views, maps, sets, and weak maps in IE 11,
	// for data views in Edge, and promises in Node.js.
	if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
	    (Map && getTag(new Map) != mapTag) ||
	    (Promise && getTag(Promise.resolve()) != promiseTag) ||
	    (Set && getTag(new Set) != setTag) ||
	    (WeakMap && getTag(new WeakMap) != weakMapTag)) {
	  getTag = function(value) {
	    var result = objectToString.call(value),
	        Ctor = result == objectTag ? value.constructor : undefined,
	        ctorString = Ctor ? toSource(Ctor) : undefined;
	
	    if (ctorString) {
	      switch (ctorString) {
	        case dataViewCtorString: return dataViewTag;
	        case mapCtorString: return mapTag;
	        case promiseCtorString: return promiseTag;
	        case setCtorString: return setTag;
	        case weakMapCtorString: return weakMapTag;
	      }
	    }
	    return result;
	  };
	}
	
	module.exports = getTag;


/***/ },
/* 186 */
/***/ function(module, exports) {

	/**
	 * Checks if `value` is a host object in IE < 9.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a host object, else `false`.
	 */
	function isHostObject(value) {
	  // Many host objects are `Object` objects that can coerce to strings
	  // despite having improperly defined `toString` methods.
	  var result = false;
	  if (value != null && typeof value.toString != 'function') {
	    try {
	      result = !!(value + '');
	    } catch (e) {}
	  }
	  return result;
	}
	
	module.exports = isHostObject;


/***/ },
/* 187 */
/***/ function(module, exports, __webpack_require__) {

	var isArrayLikeObject = __webpack_require__(666);
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]';
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objectToString = objectProto.toString;
	
	/** Built-in value references. */
	var propertyIsEnumerable = objectProto.propertyIsEnumerable;
	
	/**
	 * Checks if `value` is likely an `arguments` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is correctly classified,
	 *  else `false`.
	 * @example
	 *
	 * _.isArguments(function() { return arguments; }());
	 * // => true
	 *
	 * _.isArguments([1, 2, 3]);
	 * // => false
	 */
	function isArguments(value) {
	  // Safari 8.1 incorrectly makes `arguments.callee` enumerable in strict mode.
	  return isArrayLikeObject(value) && hasOwnProperty.call(value, 'callee') &&
	    (!propertyIsEnumerable.call(value, 'callee') || objectToString.call(value) == argsTag);
	}
	
	module.exports = isArguments;


/***/ },
/* 188 */
/***/ function(module, exports, __webpack_require__) {

	var getTag = __webpack_require__(185),
	    isArguments = __webpack_require__(187),
	    isArray = __webpack_require__(17),
	    isArrayLike = __webpack_require__(60),
	    isBuffer = __webpack_require__(284),
	    isFunction = __webpack_require__(135),
	    isObjectLike = __webpack_require__(73),
	    isString = __webpack_require__(189),
	    keys = __webpack_require__(40);
	
	/** `Object#toString` result references. */
	var mapTag = '[object Map]',
	    setTag = '[object Set]';
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/** Built-in value references. */
	var propertyIsEnumerable = objectProto.propertyIsEnumerable;
	
	/** Detect if properties shadowing those on `Object.prototype` are non-enumerable. */
	var nonEnumShadows = !propertyIsEnumerable.call({ 'valueOf': 1 }, 'valueOf');
	
	/**
	 * Checks if `value` is an empty object, collection, map, or set.
	 *
	 * Objects are considered empty if they have no own enumerable string keyed
	 * properties.
	 *
	 * Array-like values such as `arguments` objects, arrays, buffers, strings, or
	 * jQuery-like collections are considered empty if they have a `length` of `0`.
	 * Similarly, maps and sets are considered empty if they have a `size` of `0`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is empty, else `false`.
	 * @example
	 *
	 * _.isEmpty(null);
	 * // => true
	 *
	 * _.isEmpty(true);
	 * // => true
	 *
	 * _.isEmpty(1);
	 * // => true
	 *
	 * _.isEmpty([1, 2, 3]);
	 * // => false
	 *
	 * _.isEmpty({ 'a': 1 });
	 * // => false
	 */
	function isEmpty(value) {
	  if (isArrayLike(value) &&
	      (isArray(value) || isString(value) || isFunction(value.splice) ||
	        isArguments(value) || isBuffer(value))) {
	    return !value.length;
	  }
	  if (isObjectLike(value)) {
	    var tag = getTag(value);
	    if (tag == mapTag || tag == setTag) {
	      return !value.size;
	    }
	  }
	  for (var key in value) {
	    if (hasOwnProperty.call(value, key)) {
	      return false;
	    }
	  }
	  return !(nonEnumShadows && keys(value).length);
	}
	
	module.exports = isEmpty;


/***/ },
/* 189 */
/***/ function(module, exports, __webpack_require__) {

	var isArray = __webpack_require__(17),
	    isObjectLike = __webpack_require__(73);
	
	/** `Object#toString` result references. */
	var stringTag = '[object String]';
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objectToString = objectProto.toString;
	
	/**
	 * Checks if `value` is classified as a `String` primitive or object.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is correctly classified,
	 *  else `false`.
	 * @example
	 *
	 * _.isString('abc');
	 * // => true
	 *
	 * _.isString(1);
	 * // => false
	 */
	function isString(value) {
	  return typeof value == 'string' ||
	    (!isArray(value) && isObjectLike(value) && objectToString.call(value) == stringTag);
	}
	
	module.exports = isString;


/***/ },
/* 190 */
/***/ function(module, exports, __webpack_require__) {

	var apply = __webpack_require__(121),
	    toInteger = __webpack_require__(290);
	
	/** Used as the `TypeError` message for "Functions" methods. */
	var FUNC_ERROR_TEXT = 'Expected a function';
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeMax = Math.max;
	
	/**
	 * Creates a function that invokes `func` with the `this` binding of the
	 * created function and arguments from `start` and beyond provided as
	 * an array.
	 *
	 * **Note:** This method is based on the
	 * [rest parameter](https://mdn.io/rest_parameters).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Function
	 * @param {Function} func The function to apply a rest parameter to.
	 * @param {number} [start=func.length-1] The start position of the rest parameter.
	 * @returns {Function} Returns the new function.
	 * @example
	 *
	 * var say = _.rest(function(what, names) {
	 *   return what + ' ' + _.initial(names).join(', ') +
	 *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
	 * });
	 *
	 * say('hello', 'fred', 'barney', 'pebbles');
	 * // => 'hello fred, barney, & pebbles'
	 */
	function rest(func, start) {
	  if (typeof func != 'function') {
	    throw new TypeError(FUNC_ERROR_TEXT);
	  }
	  start = nativeMax(start === undefined ? (func.length - 1) : toInteger(start), 0);
	  return function() {
	    var args = arguments,
	        index = -1,
	        length = nativeMax(args.length - start, 0),
	        array = Array(length);
	
	    while (++index < length) {
	      array[index] = args[start + index];
	    }
	    switch (start) {
	      case 0: return func.call(this, array);
	      case 1: return func.call(this, args[0], array);
	      case 2: return func.call(this, args[0], args[1], array);
	    }
	    var otherArgs = Array(start + 1);
	    index = -1;
	    while (++index < start) {
	      otherArgs[index] = args[index];
	    }
	    otherArgs[start] = array;
	    return apply(func, this, otherArgs);
	  };
	}
	
	module.exports = rest;


/***/ },
/* 191 */
/***/ function(module, exports, __webpack_require__) {

	/* REACT HOT LOADER */ if (false) { (function () { var ReactHotAPI = require("/Users/jnunez/git/medscapetv/node_modules/react-hot-api/modules/index.js"), RootInstanceProvider = require("/Users/jnunez/git/medscapetv/node_modules/react-hot-loader/RootInstanceProvider.js"), ReactMount = require("react/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {
	
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _isEmpty2 = __webpack_require__(188);
	
	var _isEmpty3 = _interopRequireDefault(_isEmpty2);
	
	var _reflux = __webpack_require__(54);
	
	var _reflux2 = _interopRequireDefault(_reflux);
	
	var _descriptor_actions = __webpack_require__(293);
	
	var _descriptor_actions2 = _interopRequireDefault(_descriptor_actions);
	
	var _compiler = __webpack_require__(700);
	
	var _compiler2 = _interopRequireDefault(_compiler);
	
	var _store_state = __webpack_require__(297);
	
	var _store_state2 = _interopRequireDefault(_store_state);
	
	var _has_pretty_time = __webpack_require__(74);
	
	var _has_pretty_time2 = _interopRequireDefault(_has_pretty_time);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _reflux2.default.createStore({
	  mixins: [_store_state2.default, _has_pretty_time2.default],
	  listenables: _descriptor_actions2.default,
	  stateNamespace: 'descriptor',
	  defaultVideoOptions: {
	    shouldShowControlsDesktop: true,
	    shouldShowNativeControlsMobile: true,
	    shouldAutoPlay: false,
	    watermark: null
	  },
	  onLoadJSON: function onLoadJSON(descriptor, videoUrlFragment) {
	    descriptor.videos.forEach(function (element, index) {
	      if (element.isIndexed) {
	        element.videoIndex = index;
	      }
	    });
	    descriptor.chapterList = descriptor.videos.slice(0);
	    var inIndex = descriptor.chapterList.findIndex(function (video) {
	      return video.videoUrlFragment === videoUrlFragment;
	    });
	    var ifiPlaceHolder = void 0,
	        placeHolders = void 0;
	    if (typeof descriptor.placeHolders !== 'undefined') {
	      ifiPlaceHolder = descriptor.placeHolders.filter(function (inPlaceHolder) {
	        return inPlaceHolder.isIfi === true;
	      });
	      placeHolders = descriptor.placeHolders.filter(function (inPlaceHolder) {
	        return inPlaceHolder.isIfi === false;
	      });
	    }
	    if (!isNaN(inIndex) && inIndex !== -1) {
	      if (!(0, _isEmpty3.default)(ifiPlaceHolder)) {
	        descriptor.chapterList.splice(inIndex + 1, 0, ifiPlaceHolder[0]);
	      } else if (!(0, _isEmpty3.default)(descriptor.advertisement_videos[0])) {
	        descriptor.chapterList.splice(inIndex + 1, 0, descriptor.advertisement_videos[0]);
	        descriptor.videos.splice(inIndex + 1, 0, descriptor.advertisement_videos[0]);
	      }
	    } else {
	      if (!(0, _isEmpty3.default)(ifiPlaceHolder)) {
	        descriptor.chapterList.splice(1, 0, ifiPlaceHolder[0]);
	      } else if (!(0, _isEmpty3.default)(descriptor.advertisement_videos[0])) {
	        descriptor.chapterList.splice(1, 0, descriptor.advertisement_videos[0]);
	        descriptor.videos.splice(1, 0, descriptor.advertisement_videos[0]);
	      }
	    }
	    if (!(0, _isEmpty3.default)(placeHolders)) {
	      descriptor.chapterList = descriptor.chapterList.concat(placeHolders);
	    }
	    this.compile(descriptor, videoUrlFragment);
	  },
	  getTitle: function getTitle(index) {
	    return index !== -1 ? this.state.videos[index].title : null;
	  },
	  getDescriptor: function getDescriptor() {
	    return this.state;
	  },
	  isVideo: function isVideo() {
	    return this.state.isVideo;
	  },
	  getInitialIndex: function getInitialIndex() {
	    return this.state.initialIndex;
	  },
	  getVideo: function getVideo(index) {
	    return this.state.videos[index];
	  },
	  getCCFileRoot: function getCCFileRoot(index) {
	    return this.state.videos[index].ccFileRoot;
	  },
	  hasCCEnabled: function hasCCEnabled(index) {
	    return this.state.videos[index].hasCc;
	  },
	  getCCInfo: function getCCInfo(index) {
	    return this.state.videos[index].ccInfo[0];
	  },
	  getCCArray: function getCCArray(index) {
	    return this.state.videos[index].ccInfo;
	  },
	  getVideos: function getVideos() {
	    return this.state.videos;
	  },
	  getVideoCount: function getVideoCount() {
	    return this.state.videos.length;
	  },
	  compile: function compile(descriptor, videoUrlFragment) {
	    var compiler = new _compiler2.default(descriptor, videoUrlFragment);
	    compiler.compile();
	    this.setState(compiler.getDescriptor());
	  }
	});
	
	/* REACT HOT LOADER */ }).call(this); } finally { if (false) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("/Users/jnunez/git/medscapetv/node_modules/react-hot-loader/makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot apply hot update to " + "descriptor_store.js" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }

/***/ },
/* 192 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.loopAsync = loopAsync;
	exports.mapAsync = mapAsync;
	function loopAsync(turns, work, callback) {
	  var currentTurn = 0,
	      isDone = false;
	  var sync = false,
	      hasNext = false,
	      doneArgs = void 0;
	
	  function done() {
	    isDone = true;
	    if (sync) {
	      // Iterate instead of recursing if possible.
	      doneArgs = [].concat(Array.prototype.slice.call(arguments));
	      return;
	    }
	
	    callback.apply(this, arguments);
	  }
	
	  function next() {
	    if (isDone) {
	      return;
	    }
	
	    hasNext = true;
	    if (sync) {
	      // Iterate instead of recursing if possible.
	      return;
	    }
	
	    sync = true;
	
	    while (!isDone && currentTurn < turns && hasNext) {
	      hasNext = false;
	      work.call(this, currentTurn++, next, done);
	    }
	
	    sync = false;
	
	    if (isDone) {
	      // This means the loop finished synchronously.
	      callback.apply(this, doneArgs);
	      return;
	    }
	
	    if (currentTurn >= turns && hasNext) {
	      isDone = true;
	      callback();
	    }
	  }
	
	  next();
	}
	
	function mapAsync(array, work, callback) {
	  var length = array.length;
	  var values = [];
	
	  if (length === 0) return callback(null, values);
	
	  var isDone = false,
	      doneCount = 0;
	
	  function done(index, error, value) {
	    if (isDone) return;
	
	    if (error) {
	      isDone = true;
	      callback(error);
	    } else {
	      values[index] = value;
	
	      isDone = ++doneCount === length;
	
	      if (isDone) callback(null, values);
	    }
	  }
	
	  array.forEach(function (item, index) {
	    work(item, index, function (error, value) {
	      done(index, error, value);
	    });
	  });
	}

/***/ },
/* 193 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.ContextProvider = ContextProvider;
	exports.ContextSubscriber = ContextSubscriber;
	
	var _react = __webpack_require__(3);
	
	// Works around issues with context updates failing to propagate.
	// Caveat: the context value is expected to never change its identity.
	// https://github.com/facebook/react/issues/2517
	// https://github.com/reactjs/react-router/issues/470
	
	var contextProviderShape = _react.PropTypes.shape({
	  subscribe: _react.PropTypes.func.isRequired,
	  eventIndex: _react.PropTypes.number.isRequired
	});
	
	function makeContextName(name) {
	  return '@@contextSubscriber/' + name;
	}
	
	function ContextProvider(name) {
	  var _childContextTypes, _ref2;
	
	  var contextName = makeContextName(name);
	  var listenersKey = contextName + '/listeners';
	  var eventIndexKey = contextName + '/eventIndex';
	  var subscribeKey = contextName + '/subscribe';
	
	  return _ref2 = {
	    childContextTypes: (_childContextTypes = {}, _childContextTypes[contextName] = contextProviderShape.isRequired, _childContextTypes),
	
	    getChildContext: function getChildContext() {
	      var _ref;
	
	      return _ref = {}, _ref[contextName] = {
	        eventIndex: this[eventIndexKey],
	        subscribe: this[subscribeKey]
	      }, _ref;
	    },
	    componentWillMount: function componentWillMount() {
	      this[listenersKey] = [];
	      this[eventIndexKey] = 0;
	    },
	    componentWillReceiveProps: function componentWillReceiveProps() {
	      this[eventIndexKey]++;
	    },
	    componentDidUpdate: function componentDidUpdate() {
	      var _this = this;
	
	      this[listenersKey].forEach(function (listener) {
	        return listener(_this[eventIndexKey]);
	      });
	    }
	  }, _ref2[subscribeKey] = function (listener) {
	    var _this2 = this;
	
	    // No need to immediately call listener here.
	    this[listenersKey].push(listener);
	
	    return function () {
	      _this2[listenersKey] = _this2[listenersKey].filter(function (item) {
	        return item !== listener;
	      });
	    };
	  }, _ref2;
	}
	
	function ContextSubscriber(name) {
	  var _contextTypes, _ref4;
	
	  var contextName = makeContextName(name);
	  var lastRenderedEventIndexKey = contextName + '/lastRenderedEventIndex';
	  var handleContextUpdateKey = contextName + '/handleContextUpdate';
	  var unsubscribeKey = contextName + '/unsubscribe';
	
	  return _ref4 = {
	    contextTypes: (_contextTypes = {}, _contextTypes[contextName] = contextProviderShape, _contextTypes),
	
	    getInitialState: function getInitialState() {
	      var _ref3;
	
	      if (!this.context[contextName]) {
	        return {};
	      }
	
	      return _ref3 = {}, _ref3[lastRenderedEventIndexKey] = this.context[contextName].eventIndex, _ref3;
	    },
	    componentDidMount: function componentDidMount() {
	      if (!this.context[contextName]) {
	        return;
	      }
	
	      this[unsubscribeKey] = this.context[contextName].subscribe(this[handleContextUpdateKey]);
	    },
	    componentWillReceiveProps: function componentWillReceiveProps() {
	      var _setState;
	
	      if (!this.context[contextName]) {
	        return;
	      }
	
	      this.setState((_setState = {}, _setState[lastRenderedEventIndexKey] = this.context[contextName].eventIndex, _setState));
	    },
	    componentWillUnmount: function componentWillUnmount() {
	      if (!this[unsubscribeKey]) {
	        return;
	      }
	
	      this[unsubscribeKey]();
	      this[unsubscribeKey] = null;
	    }
	  }, _ref4[handleContextUpdateKey] = function (eventIndex) {
	    if (eventIndex !== this.state[lastRenderedEventIndexKey]) {
	      var _setState2;
	
	      this.setState((_setState2 = {}, _setState2[lastRenderedEventIndexKey] = eventIndex, _setState2));
	    }
	  }, _ref4;
	}

/***/ },
/* 194 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.locationShape = exports.routerShape = undefined;
	
	var _react = __webpack_require__(3);
	
	var func = _react.PropTypes.func,
	    object = _react.PropTypes.object,
	    shape = _react.PropTypes.shape,
	    string = _react.PropTypes.string;
	var routerShape = exports.routerShape = shape({
	  push: func.isRequired,
	  replace: func.isRequired,
	  go: func.isRequired,
	  goBack: func.isRequired,
	  goForward: func.isRequired,
	  setRouteLeaveHook: func.isRequired,
	  isActive: func.isRequired
	});
	
	var locationShape = exports.locationShape = shape({
	  pathname: string.isRequired,
	  search: string.isRequired,
	  state: object,
	  action: string.isRequired,
	  key: string
	});

/***/ },
/* 195 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _invariant = __webpack_require__(23);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _getRouteParams = __webpack_require__(724);
	
	var _getRouteParams2 = _interopRequireDefault(_getRouteParams);
	
	var _ContextUtils = __webpack_require__(193);
	
	var _RouteUtils = __webpack_require__(61);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _React$PropTypes = _react2.default.PropTypes,
	    array = _React$PropTypes.array,
	    func = _React$PropTypes.func,
	    object = _React$PropTypes.object;
	
	/**
	 * A <RouterContext> renders the component tree for a given router state
	 * and sets the history object and the current location in context.
	 */
	
	var RouterContext = _react2.default.createClass({
	  displayName: 'RouterContext',
	
	
	  mixins: [(0, _ContextUtils.ContextProvider)('router')],
	
	  propTypes: {
	    router: object.isRequired,
	    location: object.isRequired,
	    routes: array.isRequired,
	    params: object.isRequired,
	    components: array.isRequired,
	    createElement: func.isRequired
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      createElement: _react2.default.createElement
	    };
	  },
	
	
	  childContextTypes: {
	    router: object.isRequired
	  },
	
	  getChildContext: function getChildContext() {
	    return {
	      router: this.props.router
	    };
	  },
	  createElement: function createElement(component, props) {
	    return component == null ? null : this.props.createElement(component, props);
	  },
	  render: function render() {
	    var _this = this;
	
	    var _props = this.props,
	        location = _props.location,
	        routes = _props.routes,
	        params = _props.params,
	        components = _props.components,
	        router = _props.router;
	
	    var element = null;
	
	    if (components) {
	      element = components.reduceRight(function (element, components, index) {
	        if (components == null) return element; // Don't create new children; use the grandchildren.
	
	        var route = routes[index];
	        var routeParams = (0, _getRouteParams2.default)(route, params);
	        var props = {
	          location: location,
	          params: params,
	          route: route,
	          router: router,
	          routeParams: routeParams,
	          routes: routes
	        };
	
	        if ((0, _RouteUtils.isReactChildren)(element)) {
	          props.children = element;
	        } else if (element) {
	          for (var prop in element) {
	            if (Object.prototype.hasOwnProperty.call(element, prop)) props[prop] = element[prop];
	          }
	        }
	
	        if ((typeof components === 'undefined' ? 'undefined' : _typeof(components)) === 'object') {
	          var elements = {};
	
	          for (var key in components) {
	            if (Object.prototype.hasOwnProperty.call(components, key)) {
	              // Pass through the key as a prop to createElement to allow
	              // custom createElement functions to know which named component
	              // they're rendering, for e.g. matching up to fetched data.
	              elements[key] = _this.createElement(components[key], _extends({
	                key: key }, props));
	            }
	          }
	
	          return elements;
	        }
	
	        return _this.createElement(components, props);
	      }, element);
	    }
	
	    !(element === null || element === false || _react2.default.isValidElement(element)) ?  false ? (0, _invariant2.default)(false, 'The root route must render a single element') : (0, _invariant2.default)(false) : void 0;
	
	    return element;
	  }
	});
	
	exports.default = RouterContext;
	module.exports = exports['default'];

/***/ },
/* 196 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule DOMChildrenOperations
	 */
	
	'use strict';
	
	var DOMLazyTree = __webpack_require__(89);
	var Danger = __webpack_require__(742);
	var ReactMultiChildUpdateTypes = __webpack_require__(324);
	var ReactDOMComponentTree = __webpack_require__(15);
	var ReactInstrumentation = __webpack_require__(31);
	
	var createMicrosoftUnsafeLocalFunction = __webpack_require__(207);
	var setInnerHTML = __webpack_require__(143);
	var setTextContent = __webpack_require__(338);
	
	function getNodeAfter(parentNode, node) {
	  // Special case for text components, which return [open, close] comments
	  // from getHostNode.
	  if (Array.isArray(node)) {
	    node = node[1];
	  }
	  return node ? node.nextSibling : parentNode.firstChild;
	}
	
	/**
	 * Inserts `childNode` as a child of `parentNode` at the `index`.
	 *
	 * @param {DOMElement} parentNode Parent node in which to insert.
	 * @param {DOMElement} childNode Child node to insert.
	 * @param {number} index Index at which to insert the child.
	 * @internal
	 */
	var insertChildAt = createMicrosoftUnsafeLocalFunction(function (parentNode, childNode, referenceNode) {
	  // We rely exclusively on `insertBefore(node, null)` instead of also using
	  // `appendChild(node)`. (Using `undefined` is not allowed by all browsers so
	  // we are careful to use `null`.)
	  parentNode.insertBefore(childNode, referenceNode);
	});
	
	function insertLazyTreeChildAt(parentNode, childTree, referenceNode) {
	  DOMLazyTree.insertTreeBefore(parentNode, childTree, referenceNode);
	}
	
	function moveChild(parentNode, childNode, referenceNode) {
	  if (Array.isArray(childNode)) {
	    moveDelimitedText(parentNode, childNode[0], childNode[1], referenceNode);
	  } else {
	    insertChildAt(parentNode, childNode, referenceNode);
	  }
	}
	
	function removeChild(parentNode, childNode) {
	  if (Array.isArray(childNode)) {
	    var closingComment = childNode[1];
	    childNode = childNode[0];
	    removeDelimitedText(parentNode, childNode, closingComment);
	    parentNode.removeChild(closingComment);
	  }
	  parentNode.removeChild(childNode);
	}
	
	function moveDelimitedText(parentNode, openingComment, closingComment, referenceNode) {
	  var node = openingComment;
	  while (true) {
	    var nextNode = node.nextSibling;
	    insertChildAt(parentNode, node, referenceNode);
	    if (node === closingComment) {
	      break;
	    }
	    node = nextNode;
	  }
	}
	
	function removeDelimitedText(parentNode, startNode, closingComment) {
	  while (true) {
	    var node = startNode.nextSibling;
	    if (node === closingComment) {
	      // The closing comment is removed by ReactMultiChild.
	      break;
	    } else {
	      parentNode.removeChild(node);
	    }
	  }
	}
	
	function replaceDelimitedText(openingComment, closingComment, stringText) {
	  var parentNode = openingComment.parentNode;
	  var nodeAfterComment = openingComment.nextSibling;
	  if (nodeAfterComment === closingComment) {
	    // There are no text nodes between the opening and closing comments; insert
	    // a new one if stringText isn't empty.
	    if (stringText) {
	      insertChildAt(parentNode, document.createTextNode(stringText), nodeAfterComment);
	    }
	  } else {
	    if (stringText) {
	      // Set the text content of the first node after the opening comment, and
	      // remove all following nodes up until the closing comment.
	      setTextContent(nodeAfterComment, stringText);
	      removeDelimitedText(parentNode, nodeAfterComment, closingComment);
	    } else {
	      removeDelimitedText(parentNode, openingComment, closingComment);
	    }
	  }
	
	  if (false) {
	    ReactInstrumentation.debugTool.onHostOperation(ReactDOMComponentTree.getInstanceFromNode(openingComment)._debugID, 'replace text', stringText);
	  }
	}
	
	var dangerouslyReplaceNodeWithMarkup = Danger.dangerouslyReplaceNodeWithMarkup;
	if (false) {
	  dangerouslyReplaceNodeWithMarkup = function (oldChild, markup, prevInstance) {
	    Danger.dangerouslyReplaceNodeWithMarkup(oldChild, markup);
	    if (prevInstance._debugID !== 0) {
	      ReactInstrumentation.debugTool.onHostOperation(prevInstance._debugID, 'replace with', markup.toString());
	    } else {
	      var nextInstance = ReactDOMComponentTree.getInstanceFromNode(markup.node);
	      if (nextInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onHostOperation(nextInstance._debugID, 'mount', markup.toString());
	      }
	    }
	  };
	}
	
	/**
	 * Operations for updating with DOM children.
	 */
	var DOMChildrenOperations = {
	
	  dangerouslyReplaceNodeWithMarkup: dangerouslyReplaceNodeWithMarkup,
	
	  replaceDelimitedText: replaceDelimitedText,
	
	  /**
	   * Updates a component's children by processing a series of updates. The
	   * update configurations are each expected to have a `parentNode` property.
	   *
	   * @param {array<object>} updates List of update configurations.
	   * @internal
	   */
	  processUpdates: function (parentNode, updates) {
	    if (false) {
	      var parentNodeDebugID = ReactDOMComponentTree.getInstanceFromNode(parentNode)._debugID;
	    }
	
	    for (var k = 0; k < updates.length; k++) {
	      var update = updates[k];
	      switch (update.type) {
	        case ReactMultiChildUpdateTypes.INSERT_MARKUP:
	          insertLazyTreeChildAt(parentNode, update.content, getNodeAfter(parentNode, update.afterNode));
	          if (false) {
	            ReactInstrumentation.debugTool.onHostOperation(parentNodeDebugID, 'insert child', { toIndex: update.toIndex, content: update.content.toString() });
	          }
	          break;
	        case ReactMultiChildUpdateTypes.MOVE_EXISTING:
	          moveChild(parentNode, update.fromNode, getNodeAfter(parentNode, update.afterNode));
	          if (false) {
	            ReactInstrumentation.debugTool.onHostOperation(parentNodeDebugID, 'move child', { fromIndex: update.fromIndex, toIndex: update.toIndex });
	          }
	          break;
	        case ReactMultiChildUpdateTypes.SET_MARKUP:
	          setInnerHTML(parentNode, update.content);
	          if (false) {
	            ReactInstrumentation.debugTool.onHostOperation(parentNodeDebugID, 'replace children', update.content.toString());
	          }
	          break;
	        case ReactMultiChildUpdateTypes.TEXT_CONTENT:
	          setTextContent(parentNode, update.content);
	          if (false) {
	            ReactInstrumentation.debugTool.onHostOperation(parentNodeDebugID, 'replace text', update.content.toString());
	          }
	          break;
	        case ReactMultiChildUpdateTypes.REMOVE_NODE:
	          removeChild(parentNode, update.fromNode);
	          if (false) {
	            ReactInstrumentation.debugTool.onHostOperation(parentNodeDebugID, 'remove child', { fromIndex: update.fromIndex });
	          }
	          break;
	      }
	    }
	  }
	
	};
	
	module.exports = DOMChildrenOperations;

/***/ },
/* 197 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule DOMNamespaces
	 */
	
	'use strict';
	
	var DOMNamespaces = {
	  html: 'http://www.w3.org/1999/xhtml',
	  mathml: 'http://www.w3.org/1998/Math/MathML',
	  svg: 'http://www.w3.org/2000/svg'
	};
	
	module.exports = DOMNamespaces;

/***/ },
/* 198 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule EventPluginRegistry
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(5);
	
	var invariant = __webpack_require__(2);
	
	/**
	 * Injectable ordering of event plugins.
	 */
	var EventPluginOrder = null;
	
	/**
	 * Injectable mapping from names to event plugin modules.
	 */
	var namesToPlugins = {};
	
	/**
	 * Recomputes the plugin list using the injected plugins and plugin ordering.
	 *
	 * @private
	 */
	function recomputePluginOrdering() {
	  if (!EventPluginOrder) {
	    // Wait until an `EventPluginOrder` is injected.
	    return;
	  }
	  for (var pluginName in namesToPlugins) {
	    var PluginModule = namesToPlugins[pluginName];
	    var pluginIndex = EventPluginOrder.indexOf(pluginName);
	    !(pluginIndex > -1) ?  false ? invariant(false, 'EventPluginRegistry: Cannot inject event plugins that do not exist in the plugin ordering, `%s`.', pluginName) : _prodInvariant('96', pluginName) : void 0;
	    if (EventPluginRegistry.plugins[pluginIndex]) {
	      continue;
	    }
	    !PluginModule.extractEvents ?  false ? invariant(false, 'EventPluginRegistry: Event plugins must implement an `extractEvents` method, but `%s` does not.', pluginName) : _prodInvariant('97', pluginName) : void 0;
	    EventPluginRegistry.plugins[pluginIndex] = PluginModule;
	    var publishedEvents = PluginModule.eventTypes;
	    for (var eventName in publishedEvents) {
	      !publishEventForPlugin(publishedEvents[eventName], PluginModule, eventName) ?  false ? invariant(false, 'EventPluginRegistry: Failed to publish event `%s` for plugin `%s`.', eventName, pluginName) : _prodInvariant('98', eventName, pluginName) : void 0;
	    }
	  }
	}
	
	/**
	 * Publishes an event so that it can be dispatched by the supplied plugin.
	 *
	 * @param {object} dispatchConfig Dispatch configuration for the event.
	 * @param {object} PluginModule Plugin publishing the event.
	 * @return {boolean} True if the event was successfully published.
	 * @private
	 */
	function publishEventForPlugin(dispatchConfig, PluginModule, eventName) {
	  !!EventPluginRegistry.eventNameDispatchConfigs.hasOwnProperty(eventName) ?  false ? invariant(false, 'EventPluginHub: More than one plugin attempted to publish the same event name, `%s`.', eventName) : _prodInvariant('99', eventName) : void 0;
	  EventPluginRegistry.eventNameDispatchConfigs[eventName] = dispatchConfig;
	
	  var phasedRegistrationNames = dispatchConfig.phasedRegistrationNames;
	  if (phasedRegistrationNames) {
	    for (var phaseName in phasedRegistrationNames) {
	      if (phasedRegistrationNames.hasOwnProperty(phaseName)) {
	        var phasedRegistrationName = phasedRegistrationNames[phaseName];
	        publishRegistrationName(phasedRegistrationName, PluginModule, eventName);
	      }
	    }
	    return true;
	  } else if (dispatchConfig.registrationName) {
	    publishRegistrationName(dispatchConfig.registrationName, PluginModule, eventName);
	    return true;
	  }
	  return false;
	}
	
	/**
	 * Publishes a registration name that is used to identify dispatched events and
	 * can be used with `EventPluginHub.putListener` to register listeners.
	 *
	 * @param {string} registrationName Registration name to add.
	 * @param {object} PluginModule Plugin publishing the event.
	 * @private
	 */
	function publishRegistrationName(registrationName, PluginModule, eventName) {
	  !!EventPluginRegistry.registrationNameModules[registrationName] ?  false ? invariant(false, 'EventPluginHub: More than one plugin attempted to publish the same registration name, `%s`.', registrationName) : _prodInvariant('100', registrationName) : void 0;
	  EventPluginRegistry.registrationNameModules[registrationName] = PluginModule;
	  EventPluginRegistry.registrationNameDependencies[registrationName] = PluginModule.eventTypes[eventName].dependencies;
	
	  if (false) {
	    var lowerCasedName = registrationName.toLowerCase();
	    EventPluginRegistry.possibleRegistrationNames[lowerCasedName] = registrationName;
	
	    if (registrationName === 'onDoubleClick') {
	      EventPluginRegistry.possibleRegistrationNames.ondblclick = registrationName;
	    }
	  }
	}
	
	/**
	 * Registers plugins so that they can extract and dispatch events.
	 *
	 * @see {EventPluginHub}
	 */
	var EventPluginRegistry = {
	
	  /**
	   * Ordered list of injected plugins.
	   */
	  plugins: [],
	
	  /**
	   * Mapping from event name to dispatch config
	   */
	  eventNameDispatchConfigs: {},
	
	  /**
	   * Mapping from registration name to plugin module
	   */
	  registrationNameModules: {},
	
	  /**
	   * Mapping from registration name to event name
	   */
	  registrationNameDependencies: {},
	
	  /**
	   * Mapping from lowercase registration names to the properly cased version,
	   * used to warn in the case of missing event handlers. Available
	   * only in __DEV__.
	   * @type {Object}
	   */
	  possibleRegistrationNames:  false ? {} : null,
	
	  /**
	   * Injects an ordering of plugins (by plugin name). This allows the ordering
	   * to be decoupled from injection of the actual plugins so that ordering is
	   * always deterministic regardless of packaging, on-the-fly injection, etc.
	   *
	   * @param {array} InjectedEventPluginOrder
	   * @internal
	   * @see {EventPluginHub.injection.injectEventPluginOrder}
	   */
	  injectEventPluginOrder: function (InjectedEventPluginOrder) {
	    !!EventPluginOrder ?  false ? invariant(false, 'EventPluginRegistry: Cannot inject event plugin ordering more than once. You are likely trying to load more than one copy of React.') : _prodInvariant('101') : void 0;
	    // Clone the ordering so it cannot be dynamically mutated.
	    EventPluginOrder = Array.prototype.slice.call(InjectedEventPluginOrder);
	    recomputePluginOrdering();
	  },
	
	  /**
	   * Injects plugins to be used by `EventPluginHub`. The plugin names must be
	   * in the ordering injected by `injectEventPluginOrder`.
	   *
	   * Plugins can be injected as part of page initialization or on-the-fly.
	   *
	   * @param {object} injectedNamesToPlugins Map from names to plugin modules.
	   * @internal
	   * @see {EventPluginHub.injection.injectEventPluginsByName}
	   */
	  injectEventPluginsByName: function (injectedNamesToPlugins) {
	    var isOrderingDirty = false;
	    for (var pluginName in injectedNamesToPlugins) {
	      if (!injectedNamesToPlugins.hasOwnProperty(pluginName)) {
	        continue;
	      }
	      var PluginModule = injectedNamesToPlugins[pluginName];
	      if (!namesToPlugins.hasOwnProperty(pluginName) || namesToPlugins[pluginName] !== PluginModule) {
	        !!namesToPlugins[pluginName] ?  false ? invariant(false, 'EventPluginRegistry: Cannot inject two different event plugins using the same name, `%s`.', pluginName) : _prodInvariant('102', pluginName) : void 0;
	        namesToPlugins[pluginName] = PluginModule;
	        isOrderingDirty = true;
	      }
	    }
	    if (isOrderingDirty) {
	      recomputePluginOrdering();
	    }
	  },
	
	  /**
	   * Looks up the plugin for the supplied event.
	   *
	   * @param {object} event A synthetic event.
	   * @return {?object} The plugin that created the supplied event.
	   * @internal
	   */
	  getPluginModuleForEvent: function (event) {
	    var dispatchConfig = event.dispatchConfig;
	    if (dispatchConfig.registrationName) {
	      return EventPluginRegistry.registrationNameModules[dispatchConfig.registrationName] || null;
	    }
	    for (var phase in dispatchConfig.phasedRegistrationNames) {
	      if (!dispatchConfig.phasedRegistrationNames.hasOwnProperty(phase)) {
	        continue;
	      }
	      var PluginModule = EventPluginRegistry.registrationNameModules[dispatchConfig.phasedRegistrationNames[phase]];
	      if (PluginModule) {
	        return PluginModule;
	      }
	    }
	    return null;
	  },
	
	  /**
	   * Exposed for unit testing.
	   * @private
	   */
	  _resetEventPlugins: function () {
	    EventPluginOrder = null;
	    for (var pluginName in namesToPlugins) {
	      if (namesToPlugins.hasOwnProperty(pluginName)) {
	        delete namesToPlugins[pluginName];
	      }
	    }
	    EventPluginRegistry.plugins.length = 0;
	
	    var eventNameDispatchConfigs = EventPluginRegistry.eventNameDispatchConfigs;
	    for (var eventName in eventNameDispatchConfigs) {
	      if (eventNameDispatchConfigs.hasOwnProperty(eventName)) {
	        delete eventNameDispatchConfigs[eventName];
	      }
	    }
	
	    var registrationNameModules = EventPluginRegistry.registrationNameModules;
	    for (var registrationName in registrationNameModules) {
	      if (registrationNameModules.hasOwnProperty(registrationName)) {
	        delete registrationNameModules[registrationName];
	      }
	    }
	
	    if (false) {
	      var possibleRegistrationNames = EventPluginRegistry.possibleRegistrationNames;
	      for (var lowerCasedName in possibleRegistrationNames) {
	        if (possibleRegistrationNames.hasOwnProperty(lowerCasedName)) {
	          delete possibleRegistrationNames[lowerCasedName];
	        }
	      }
	    }
	  }
	
	};
	
	module.exports = EventPluginRegistry;

/***/ },
/* 199 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule EventPluginUtils
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(5);
	
	var EventConstants = __webpack_require__(52);
	var ReactErrorUtils = __webpack_require__(203);
	
	var invariant = __webpack_require__(2);
	var warning = __webpack_require__(9);
	
	/**
	 * Injected dependencies:
	 */
	
	/**
	 * - `ComponentTree`: [required] Module that can convert between React instances
	 *   and actual node references.
	 */
	var ComponentTree;
	var TreeTraversal;
	var injection = {
	  injectComponentTree: function (Injected) {
	    ComponentTree = Injected;
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(Injected && Injected.getNodeFromInstance && Injected.getInstanceFromNode, 'EventPluginUtils.injection.injectComponentTree(...): Injected ' + 'module is missing getNodeFromInstance or getInstanceFromNode.') : void 0;
	    }
	  },
	  injectTreeTraversal: function (Injected) {
	    TreeTraversal = Injected;
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(Injected && Injected.isAncestor && Injected.getLowestCommonAncestor, 'EventPluginUtils.injection.injectTreeTraversal(...): Injected ' + 'module is missing isAncestor or getLowestCommonAncestor.') : void 0;
	    }
	  }
	};
	
	var topLevelTypes = EventConstants.topLevelTypes;
	
	function isEndish(topLevelType) {
	  return topLevelType === topLevelTypes.topMouseUp || topLevelType === topLevelTypes.topTouchEnd || topLevelType === topLevelTypes.topTouchCancel;
	}
	
	function isMoveish(topLevelType) {
	  return topLevelType === topLevelTypes.topMouseMove || topLevelType === topLevelTypes.topTouchMove;
	}
	function isStartish(topLevelType) {
	  return topLevelType === topLevelTypes.topMouseDown || topLevelType === topLevelTypes.topTouchStart;
	}
	
	var validateEventDispatches;
	if (false) {
	  validateEventDispatches = function (event) {
	    var dispatchListeners = event._dispatchListeners;
	    var dispatchInstances = event._dispatchInstances;
	
	    var listenersIsArr = Array.isArray(dispatchListeners);
	    var listenersLen = listenersIsArr ? dispatchListeners.length : dispatchListeners ? 1 : 0;
	
	    var instancesIsArr = Array.isArray(dispatchInstances);
	    var instancesLen = instancesIsArr ? dispatchInstances.length : dispatchInstances ? 1 : 0;
	
	    process.env.NODE_ENV !== 'production' ? warning(instancesIsArr === listenersIsArr && instancesLen === listenersLen, 'EventPluginUtils: Invalid `event`.') : void 0;
	  };
	}
	
	/**
	 * Dispatch the event to the listener.
	 * @param {SyntheticEvent} event SyntheticEvent to handle
	 * @param {boolean} simulated If the event is simulated (changes exn behavior)
	 * @param {function} listener Application-level callback
	 * @param {*} inst Internal component instance
	 */
	function executeDispatch(event, simulated, listener, inst) {
	  var type = event.type || 'unknown-event';
	  event.currentTarget = EventPluginUtils.getNodeFromInstance(inst);
	  if (simulated) {
	    ReactErrorUtils.invokeGuardedCallbackWithCatch(type, listener, event);
	  } else {
	    ReactErrorUtils.invokeGuardedCallback(type, listener, event);
	  }
	  event.currentTarget = null;
	}
	
	/**
	 * Standard/simple iteration through an event's collected dispatches.
	 */
	function executeDispatchesInOrder(event, simulated) {
	  var dispatchListeners = event._dispatchListeners;
	  var dispatchInstances = event._dispatchInstances;
	  if (false) {
	    validateEventDispatches(event);
	  }
	  if (Array.isArray(dispatchListeners)) {
	    for (var i = 0; i < dispatchListeners.length; i++) {
	      if (event.isPropagationStopped()) {
	        break;
	      }
	      // Listeners and Instances are two parallel arrays that are always in sync.
	      executeDispatch(event, simulated, dispatchListeners[i], dispatchInstances[i]);
	    }
	  } else if (dispatchListeners) {
	    executeDispatch(event, simulated, dispatchListeners, dispatchInstances);
	  }
	  event._dispatchListeners = null;
	  event._dispatchInstances = null;
	}
	
	/**
	 * Standard/simple iteration through an event's collected dispatches, but stops
	 * at the first dispatch execution returning true, and returns that id.
	 *
	 * @return {?string} id of the first dispatch execution who's listener returns
	 * true, or null if no listener returned true.
	 */
	function executeDispatchesInOrderStopAtTrueImpl(event) {
	  var dispatchListeners = event._dispatchListeners;
	  var dispatchInstances = event._dispatchInstances;
	  if (false) {
	    validateEventDispatches(event);
	  }
	  if (Array.isArray(dispatchListeners)) {
	    for (var i = 0; i < dispatchListeners.length; i++) {
	      if (event.isPropagationStopped()) {
	        break;
	      }
	      // Listeners and Instances are two parallel arrays that are always in sync.
	      if (dispatchListeners[i](event, dispatchInstances[i])) {
	        return dispatchInstances[i];
	      }
	    }
	  } else if (dispatchListeners) {
	    if (dispatchListeners(event, dispatchInstances)) {
	      return dispatchInstances;
	    }
	  }
	  return null;
	}
	
	/**
	 * @see executeDispatchesInOrderStopAtTrueImpl
	 */
	function executeDispatchesInOrderStopAtTrue(event) {
	  var ret = executeDispatchesInOrderStopAtTrueImpl(event);
	  event._dispatchInstances = null;
	  event._dispatchListeners = null;
	  return ret;
	}
	
	/**
	 * Execution of a "direct" dispatch - there must be at most one dispatch
	 * accumulated on the event or it is considered an error. It doesn't really make
	 * sense for an event with multiple dispatches (bubbled) to keep track of the
	 * return values at each dispatch execution, but it does tend to make sense when
	 * dealing with "direct" dispatches.
	 *
	 * @return {*} The return value of executing the single dispatch.
	 */
	function executeDirectDispatch(event) {
	  if (false) {
	    validateEventDispatches(event);
	  }
	  var dispatchListener = event._dispatchListeners;
	  var dispatchInstance = event._dispatchInstances;
	  !!Array.isArray(dispatchListener) ?  false ? invariant(false, 'executeDirectDispatch(...): Invalid `event`.') : _prodInvariant('103') : void 0;
	  event.currentTarget = dispatchListener ? EventPluginUtils.getNodeFromInstance(dispatchInstance) : null;
	  var res = dispatchListener ? dispatchListener(event) : null;
	  event.currentTarget = null;
	  event._dispatchListeners = null;
	  event._dispatchInstances = null;
	  return res;
	}
	
	/**
	 * @param {SyntheticEvent} event
	 * @return {boolean} True iff number of dispatches accumulated is greater than 0.
	 */
	function hasDispatches(event) {
	  return !!event._dispatchListeners;
	}
	
	/**
	 * General utilities that are useful in creating custom Event Plugins.
	 */
	var EventPluginUtils = {
	  isEndish: isEndish,
	  isMoveish: isMoveish,
	  isStartish: isStartish,
	
	  executeDirectDispatch: executeDirectDispatch,
	  executeDispatchesInOrder: executeDispatchesInOrder,
	  executeDispatchesInOrderStopAtTrue: executeDispatchesInOrderStopAtTrue,
	  hasDispatches: hasDispatches,
	
	  getInstanceFromNode: function (node) {
	    return ComponentTree.getInstanceFromNode(node);
	  },
	  getNodeFromInstance: function (node) {
	    return ComponentTree.getNodeFromInstance(node);
	  },
	  isAncestor: function (a, b) {
	    return TreeTraversal.isAncestor(a, b);
	  },
	  getLowestCommonAncestor: function (a, b) {
	    return TreeTraversal.getLowestCommonAncestor(a, b);
	  },
	  getParentInstance: function (inst) {
	    return TreeTraversal.getParentInstance(inst);
	  },
	  traverseTwoPhase: function (target, fn, arg) {
	    return TreeTraversal.traverseTwoPhase(target, fn, arg);
	  },
	  traverseEnterLeave: function (from, to, fn, argFrom, argTo) {
	    return TreeTraversal.traverseEnterLeave(from, to, fn, argFrom, argTo);
	  },
	
	  injection: injection
	};
	
	module.exports = EventPluginUtils;

/***/ },
/* 200 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule KeyEscapeUtils
	 * 
	 */
	
	'use strict';
	
	/**
	 * Escape and wrap key so it is safe to use as a reactid
	 *
	 * @param {string} key to be escaped.
	 * @return {string} the escaped key.
	 */
	
	function escape(key) {
	  var escapeRegex = /[=:]/g;
	  var escaperLookup = {
	    '=': '=0',
	    ':': '=2'
	  };
	  var escapedString = ('' + key).replace(escapeRegex, function (match) {
	    return escaperLookup[match];
	  });
	
	  return '$' + escapedString;
	}
	
	/**
	 * Unescape and unwrap key for human-readable display
	 *
	 * @param {string} key to unescape.
	 * @return {string} the unescaped key.
	 */
	function unescape(key) {
	  var unescapeRegex = /(=0|=2)/g;
	  var unescaperLookup = {
	    '=0': '=',
	    '=2': ':'
	  };
	  var keySubstring = key[0] === '.' && key[1] === '$' ? key.substring(2) : key.substring(1);
	
	  return ('' + keySubstring).replace(unescapeRegex, function (match) {
	    return unescaperLookup[match];
	  });
	}
	
	var KeyEscapeUtils = {
	  escape: escape,
	  unescape: unescape
	};
	
	module.exports = KeyEscapeUtils;

/***/ },
/* 201 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule LinkedValueUtils
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(5);
	
	var ReactPropTypes = __webpack_require__(327);
	var ReactPropTypeLocations = __webpack_require__(205);
	
	var invariant = __webpack_require__(2);
	var warning = __webpack_require__(9);
	
	var hasReadOnlyValue = {
	  'button': true,
	  'checkbox': true,
	  'image': true,
	  'hidden': true,
	  'radio': true,
	  'reset': true,
	  'submit': true
	};
	
	function _assertSingleLink(inputProps) {
	  !(inputProps.checkedLink == null || inputProps.valueLink == null) ?  false ? invariant(false, 'Cannot provide a checkedLink and a valueLink. If you want to use checkedLink, you probably don\'t want to use valueLink and vice versa.') : _prodInvariant('87') : void 0;
	}
	function _assertValueLink(inputProps) {
	  _assertSingleLink(inputProps);
	  !(inputProps.value == null && inputProps.onChange == null) ?  false ? invariant(false, 'Cannot provide a valueLink and a value or onChange event. If you want to use value or onChange, you probably don\'t want to use valueLink.') : _prodInvariant('88') : void 0;
	}
	
	function _assertCheckedLink(inputProps) {
	  _assertSingleLink(inputProps);
	  !(inputProps.checked == null && inputProps.onChange == null) ?  false ? invariant(false, 'Cannot provide a checkedLink and a checked property or onChange event. If you want to use checked or onChange, you probably don\'t want to use checkedLink') : _prodInvariant('89') : void 0;
	}
	
	var propTypes = {
	  value: function (props, propName, componentName) {
	    if (!props[propName] || hasReadOnlyValue[props.type] || props.onChange || props.readOnly || props.disabled) {
	      return null;
	    }
	    return new Error('You provided a `value` prop to a form field without an ' + '`onChange` handler. This will render a read-only field. If ' + 'the field should be mutable use `defaultValue`. Otherwise, ' + 'set either `onChange` or `readOnly`.');
	  },
	  checked: function (props, propName, componentName) {
	    if (!props[propName] || props.onChange || props.readOnly || props.disabled) {
	      return null;
	    }
	    return new Error('You provided a `checked` prop to a form field without an ' + '`onChange` handler. This will render a read-only field. If ' + 'the field should be mutable use `defaultChecked`. Otherwise, ' + 'set either `onChange` or `readOnly`.');
	  },
	  onChange: ReactPropTypes.func
	};
	
	var loggedTypeFailures = {};
	function getDeclarationErrorAddendum(owner) {
	  if (owner) {
	    var name = owner.getName();
	    if (name) {
	      return ' Check the render method of `' + name + '`.';
	    }
	  }
	  return '';
	}
	
	/**
	 * Provide a linked `value` attribute for controlled forms. You should not use
	 * this outside of the ReactDOM controlled form components.
	 */
	var LinkedValueUtils = {
	  checkPropTypes: function (tagName, props, owner) {
	    for (var propName in propTypes) {
	      if (propTypes.hasOwnProperty(propName)) {
	        var error = propTypes[propName](props, propName, tagName, ReactPropTypeLocations.prop);
	      }
	      if (error instanceof Error && !(error.message in loggedTypeFailures)) {
	        // Only monitor this failure once because there tends to be a lot of the
	        // same error.
	        loggedTypeFailures[error.message] = true;
	
	        var addendum = getDeclarationErrorAddendum(owner);
	         false ? warning(false, 'Failed form propType: %s%s', error.message, addendum) : void 0;
	      }
	    }
	  },
	
	  /**
	   * @param {object} inputProps Props for form component
	   * @return {*} current value of the input either from value prop or link.
	   */
	  getValue: function (inputProps) {
	    if (inputProps.valueLink) {
	      _assertValueLink(inputProps);
	      return inputProps.valueLink.value;
	    }
	    return inputProps.value;
	  },
	
	  /**
	   * @param {object} inputProps Props for form component
	   * @return {*} current checked status of the input either from checked prop
	   *             or link.
	   */
	  getChecked: function (inputProps) {
	    if (inputProps.checkedLink) {
	      _assertCheckedLink(inputProps);
	      return inputProps.checkedLink.value;
	    }
	    return inputProps.checked;
	  },
	
	  /**
	   * @param {object} inputProps Props for form component
	   * @param {SyntheticEvent} event change event to handle
	   */
	  executeOnChange: function (inputProps, event) {
	    if (inputProps.valueLink) {
	      _assertValueLink(inputProps);
	      return inputProps.valueLink.requestChange(event.target.value);
	    } else if (inputProps.checkedLink) {
	      _assertCheckedLink(inputProps);
	      return inputProps.checkedLink.requestChange(event.target.checked);
	    } else if (inputProps.onChange) {
	      return inputProps.onChange.call(undefined, event);
	    }
	  }
	};
	
	module.exports = LinkedValueUtils;

/***/ },
/* 202 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactComponentEnvironment
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(5);
	
	var invariant = __webpack_require__(2);
	
	var injected = false;
	
	var ReactComponentEnvironment = {
	
	  /**
	   * Optionally injectable environment dependent cleanup hook. (server vs.
	   * browser etc). Example: A browser system caches DOM nodes based on component
	   * ID and must remove that cache entry when this instance is unmounted.
	   */
	  unmountIDFromEnvironment: null,
	
	  /**
	   * Optionally injectable hook for swapping out mount images in the middle of
	   * the tree.
	   */
	  replaceNodeWithMarkup: null,
	
	  /**
	   * Optionally injectable hook for processing a queue of child updates. Will
	   * later move into MultiChildComponents.
	   */
	  processChildrenUpdates: null,
	
	  injection: {
	    injectEnvironment: function (environment) {
	      !!injected ?  false ? invariant(false, 'ReactCompositeComponent: injectEnvironment() can only be called once.') : _prodInvariant('104') : void 0;
	      ReactComponentEnvironment.unmountIDFromEnvironment = environment.unmountIDFromEnvironment;
	      ReactComponentEnvironment.replaceNodeWithMarkup = environment.replaceNodeWithMarkup;
	      ReactComponentEnvironment.processChildrenUpdates = environment.processChildrenUpdates;
	      injected = true;
	    }
	  }
	
	};
	
	module.exports = ReactComponentEnvironment;

/***/ },
/* 203 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactErrorUtils
	 */
	
	'use strict';
	
	var caughtError = null;
	
	/**
	 * Call a function while guarding against errors that happens within it.
	 *
	 * @param {?String} name of the guard to use for logging or debugging
	 * @param {Function} func The function to invoke
	 * @param {*} a First argument
	 * @param {*} b Second argument
	 */
	function invokeGuardedCallback(name, func, a, b) {
	  try {
	    return func(a, b);
	  } catch (x) {
	    if (caughtError === null) {
	      caughtError = x;
	    }
	    return undefined;
	  }
	}
	
	var ReactErrorUtils = {
	  invokeGuardedCallback: invokeGuardedCallback,
	
	  /**
	   * Invoked by ReactTestUtils.Simulate so that any errors thrown by the event
	   * handler are sure to be rethrown by rethrowCaughtError.
	   */
	  invokeGuardedCallbackWithCatch: invokeGuardedCallback,
	
	  /**
	   * During execution of guarded functions we will capture the first error which
	   * we will rethrow to be handled by the top level error handler.
	   */
	  rethrowCaughtError: function () {
	    if (caughtError) {
	      var error = caughtError;
	      caughtError = null;
	      throw error;
	    }
	  }
	};
	
	if (false) {
	  /**
	   * To help development we can get better devtools integration by simulating a
	   * real browser event.
	   */
	  if (typeof window !== 'undefined' && typeof window.dispatchEvent === 'function' && typeof document !== 'undefined' && typeof document.createEvent === 'function') {
	    var fakeNode = document.createElement('react');
	    ReactErrorUtils.invokeGuardedCallback = function (name, func, a, b) {
	      var boundFunc = func.bind(null, a, b);
	      var evtType = 'react-' + name;
	      fakeNode.addEventListener(evtType, boundFunc, false);
	      var evt = document.createEvent('Event');
	      evt.initEvent(evtType, false, false);
	      fakeNode.dispatchEvent(evt);
	      fakeNode.removeEventListener(evtType, boundFunc, false);
	    };
	  }
	}
	
	module.exports = ReactErrorUtils;

/***/ },
/* 204 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactPropTypeLocationNames
	 */
	
	'use strict';
	
	var ReactPropTypeLocationNames = {};
	
	if (false) {
	  ReactPropTypeLocationNames = {
	    prop: 'prop',
	    context: 'context',
	    childContext: 'child context'
	  };
	}
	
	module.exports = ReactPropTypeLocationNames;

/***/ },
/* 205 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactPropTypeLocations
	 */
	
	'use strict';
	
	var keyMirror = __webpack_require__(117);
	
	var ReactPropTypeLocations = keyMirror({
	  prop: null,
	  context: null,
	  childContext: null
	});
	
	module.exports = ReactPropTypeLocations;

/***/ },
/* 206 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactUpdateQueue
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(5);
	
	var ReactCurrentOwner = __webpack_require__(75);
	var ReactInstanceMap = __webpack_require__(101);
	var ReactInstrumentation = __webpack_require__(31);
	var ReactUpdates = __webpack_require__(46);
	
	var invariant = __webpack_require__(2);
	var warning = __webpack_require__(9);
	
	function enqueueUpdate(internalInstance) {
	  ReactUpdates.enqueueUpdate(internalInstance);
	}
	
	function formatUnexpectedArgument(arg) {
	  var type = typeof arg;
	  if (type !== 'object') {
	    return type;
	  }
	  var displayName = arg.constructor && arg.constructor.name || type;
	  var keys = Object.keys(arg);
	  if (keys.length > 0 && keys.length < 20) {
	    return displayName + ' (keys: ' + keys.join(', ') + ')';
	  }
	  return displayName;
	}
	
	function getInternalInstanceReadyForUpdate(publicInstance, callerName) {
	  var internalInstance = ReactInstanceMap.get(publicInstance);
	  if (!internalInstance) {
	    if (false) {
	      // Only warn when we have a callerName. Otherwise we should be silent.
	      // We're probably calling from enqueueCallback. We don't want to warn
	      // there because we already warned for the corresponding lifecycle method.
	      process.env.NODE_ENV !== 'production' ? warning(!callerName, '%s(...): Can only update a mounted or mounting component. ' + 'This usually means you called %s() on an unmounted component. ' + 'This is a no-op. Please check the code for the %s component.', callerName, callerName, publicInstance.constructor.displayName) : void 0;
	    }
	    return null;
	  }
	
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(ReactCurrentOwner.current == null, '%s(...): Cannot update during an existing state transition (such as ' + 'within `render` or another component\'s constructor). Render methods ' + 'should be a pure function of props and state; constructor ' + 'side-effects are an anti-pattern, but can be moved to ' + '`componentWillMount`.', callerName) : void 0;
	  }
	
	  return internalInstance;
	}
	
	/**
	 * ReactUpdateQueue allows for state updates to be scheduled into a later
	 * reconciliation step.
	 */
	var ReactUpdateQueue = {
	
	  /**
	   * Checks whether or not this composite component is mounted.
	   * @param {ReactClass} publicInstance The instance we want to test.
	   * @return {boolean} True if mounted, false otherwise.
	   * @protected
	   * @final
	   */
	  isMounted: function (publicInstance) {
	    if (false) {
	      var owner = ReactCurrentOwner.current;
	      if (owner !== null) {
	        process.env.NODE_ENV !== 'production' ? warning(owner._warnedAboutRefsInRender, '%s is accessing isMounted inside its render() function. ' + 'render() should be a pure function of props and state. It should ' + 'never access something that requires stale data from the previous ' + 'render, such as refs. Move this logic to componentDidMount and ' + 'componentDidUpdate instead.', owner.getName() || 'A component') : void 0;
	        owner._warnedAboutRefsInRender = true;
	      }
	    }
	    var internalInstance = ReactInstanceMap.get(publicInstance);
	    if (internalInstance) {
	      // During componentWillMount and render this will still be null but after
	      // that will always render to something. At least for now. So we can use
	      // this hack.
	      return !!internalInstance._renderedComponent;
	    } else {
	      return false;
	    }
	  },
	
	  /**
	   * Enqueue a callback that will be executed after all the pending updates
	   * have processed.
	   *
	   * @param {ReactClass} publicInstance The instance to use as `this` context.
	   * @param {?function} callback Called after state is updated.
	   * @param {string} callerName Name of the calling function in the public API.
	   * @internal
	   */
	  enqueueCallback: function (publicInstance, callback, callerName) {
	    ReactUpdateQueue.validateCallback(callback, callerName);
	    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance);
	
	    // Previously we would throw an error if we didn't have an internal
	    // instance. Since we want to make it a no-op instead, we mirror the same
	    // behavior we have in other enqueue* methods.
	    // We also need to ignore callbacks in componentWillMount. See
	    // enqueueUpdates.
	    if (!internalInstance) {
	      return null;
	    }
	
	    if (internalInstance._pendingCallbacks) {
	      internalInstance._pendingCallbacks.push(callback);
	    } else {
	      internalInstance._pendingCallbacks = [callback];
	    }
	    // TODO: The callback here is ignored when setState is called from
	    // componentWillMount. Either fix it or disallow doing so completely in
	    // favor of getInitialState. Alternatively, we can disallow
	    // componentWillMount during server-side rendering.
	    enqueueUpdate(internalInstance);
	  },
	
	  enqueueCallbackInternal: function (internalInstance, callback) {
	    if (internalInstance._pendingCallbacks) {
	      internalInstance._pendingCallbacks.push(callback);
	    } else {
	      internalInstance._pendingCallbacks = [callback];
	    }
	    enqueueUpdate(internalInstance);
	  },
	
	  /**
	   * Forces an update. This should only be invoked when it is known with
	   * certainty that we are **not** in a DOM transaction.
	   *
	   * You may want to call this when you know that some deeper aspect of the
	   * component's state has changed but `setState` was not called.
	   *
	   * This will not invoke `shouldComponentUpdate`, but it will invoke
	   * `componentWillUpdate` and `componentDidUpdate`.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @internal
	   */
	  enqueueForceUpdate: function (publicInstance) {
	    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance, 'forceUpdate');
	
	    if (!internalInstance) {
	      return;
	    }
	
	    internalInstance._pendingForceUpdate = true;
	
	    enqueueUpdate(internalInstance);
	  },
	
	  /**
	   * Replaces all of the state. Always use this or `setState` to mutate state.
	   * You should treat `this.state` as immutable.
	   *
	   * There is no guarantee that `this.state` will be immediately updated, so
	   * accessing `this.state` after calling this method may return the old value.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object} completeState Next state.
	   * @internal
	   */
	  enqueueReplaceState: function (publicInstance, completeState) {
	    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance, 'replaceState');
	
	    if (!internalInstance) {
	      return;
	    }
	
	    internalInstance._pendingStateQueue = [completeState];
	    internalInstance._pendingReplaceState = true;
	
	    enqueueUpdate(internalInstance);
	  },
	
	  /**
	   * Sets a subset of the state. This only exists because _pendingState is
	   * internal. This provides a merging strategy that is not available to deep
	   * properties which is confusing. TODO: Expose pendingState or don't use it
	   * during the merge.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object} partialState Next partial state to be merged with state.
	   * @internal
	   */
	  enqueueSetState: function (publicInstance, partialState) {
	    if (false) {
	      ReactInstrumentation.debugTool.onSetState();
	      process.env.NODE_ENV !== 'production' ? warning(partialState != null, 'setState(...): You passed an undefined or null state object; ' + 'instead, use forceUpdate().') : void 0;
	    }
	
	    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance, 'setState');
	
	    if (!internalInstance) {
	      return;
	    }
	
	    var queue = internalInstance._pendingStateQueue || (internalInstance._pendingStateQueue = []);
	    queue.push(partialState);
	
	    enqueueUpdate(internalInstance);
	  },
	
	  enqueueElementInternal: function (internalInstance, nextElement, nextContext) {
	    internalInstance._pendingElement = nextElement;
	    // TODO: introduce _pendingContext instead of setting it directly.
	    internalInstance._context = nextContext;
	    enqueueUpdate(internalInstance);
	  },
	
	  validateCallback: function (callback, callerName) {
	    !(!callback || typeof callback === 'function') ?  false ? invariant(false, '%s(...): Expected the last optional `callback` argument to be a function. Instead received: %s.', callerName, formatUnexpectedArgument(callback)) : _prodInvariant('122', callerName, formatUnexpectedArgument(callback)) : void 0;
	  }
	
	};
	
	module.exports = ReactUpdateQueue;

/***/ },
/* 207 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule createMicrosoftUnsafeLocalFunction
	 */
	
	/* globals MSApp */
	
	'use strict';
	
	/**
	 * Create a function which has 'unsafe' privileges (required by windows8 apps)
	 */
	
	var createMicrosoftUnsafeLocalFunction = function (func) {
	  if (typeof MSApp !== 'undefined' && MSApp.execUnsafeLocalFunction) {
	    return function (arg0, arg1, arg2, arg3) {
	      MSApp.execUnsafeLocalFunction(function () {
	        return func(arg0, arg1, arg2, arg3);
	      });
	    };
	  } else {
	    return func;
	  }
	};
	
	module.exports = createMicrosoftUnsafeLocalFunction;

/***/ },
/* 208 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule getEventCharCode
	 */
	
	'use strict';
	
	/**
	 * `charCode` represents the actual "character code" and is safe to use with
	 * `String.fromCharCode`. As such, only keys that correspond to printable
	 * characters produce a valid `charCode`, the only exception to this is Enter.
	 * The Tab-key is considered non-printable and does not have a `charCode`,
	 * presumably because it does not produce a tab-character in browsers.
	 *
	 * @param {object} nativeEvent Native browser event.
	 * @return {number} Normalized `charCode` property.
	 */
	
	function getEventCharCode(nativeEvent) {
	  var charCode;
	  var keyCode = nativeEvent.keyCode;
	
	  if ('charCode' in nativeEvent) {
	    charCode = nativeEvent.charCode;
	
	    // FF does not set `charCode` for the Enter-key, check against `keyCode`.
	    if (charCode === 0 && keyCode === 13) {
	      charCode = 13;
	    }
	  } else {
	    // IE8 does not implement `charCode`, but `keyCode` has the correct value.
	    charCode = keyCode;
	  }
	
	  // Some non-printable keys are reported in `charCode`/`keyCode`, discard them.
	  // Must not discard the (non-)printable Enter-key.
	  if (charCode >= 32 || charCode === 13) {
	    return charCode;
	  }
	
	  return 0;
	}
	
	module.exports = getEventCharCode;

/***/ },
/* 209 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule getEventModifierState
	 */
	
	'use strict';
	
	/**
	 * Translation from modifier key to the associated property in the event.
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/#keys-Modifiers
	 */
	
	var modifierKeyToProp = {
	  'Alt': 'altKey',
	  'Control': 'ctrlKey',
	  'Meta': 'metaKey',
	  'Shift': 'shiftKey'
	};
	
	// IE8 does not implement getModifierState so we simply map it to the only
	// modifier keys exposed by the event itself, does not support Lock-keys.
	// Currently, all major browsers except Chrome seems to support Lock-keys.
	function modifierStateGetter(keyArg) {
	  var syntheticEvent = this;
	  var nativeEvent = syntheticEvent.nativeEvent;
	  if (nativeEvent.getModifierState) {
	    return nativeEvent.getModifierState(keyArg);
	  }
	  var keyProp = modifierKeyToProp[keyArg];
	  return keyProp ? !!nativeEvent[keyProp] : false;
	}
	
	function getEventModifierState(nativeEvent) {
	  return modifierStateGetter;
	}
	
	module.exports = getEventModifierState;

/***/ },
/* 210 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule getEventTarget
	 */
	
	'use strict';
	
	/**
	 * Gets the target node from a native browser event by accounting for
	 * inconsistencies in browser DOM APIs.
	 *
	 * @param {object} nativeEvent Native browser event.
	 * @return {DOMEventTarget} Target node.
	 */
	
	function getEventTarget(nativeEvent) {
	  var target = nativeEvent.target || nativeEvent.srcElement || window;
	
	  // Normalize SVG <use> element events #4963
	  if (target.correspondingUseElement) {
	    target = target.correspondingUseElement;
	  }
	
	  // Safari may fire events on text nodes (Node.TEXT_NODE is 3).
	  // @see http://www.quirksmode.org/js/events_properties.html
	  return target.nodeType === 3 ? target.parentNode : target;
	}
	
	module.exports = getEventTarget;

/***/ },
/* 211 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule isEventSupported
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(22);
	
	var useHasFeature;
	if (ExecutionEnvironment.canUseDOM) {
	  useHasFeature = document.implementation && document.implementation.hasFeature &&
	  // always returns true in newer browsers as per the standard.
	  // @see http://dom.spec.whatwg.org/#dom-domimplementation-hasfeature
	  document.implementation.hasFeature('', '') !== true;
	}
	
	/**
	 * Checks if an event is supported in the current execution environment.
	 *
	 * NOTE: This will not work correctly for non-generic events such as `change`,
	 * `reset`, `load`, `error`, and `select`.
	 *
	 * Borrows from Modernizr.
	 *
	 * @param {string} eventNameSuffix Event name, e.g. "click".
	 * @param {?boolean} capture Check if the capture phase is supported.
	 * @return {boolean} True if the event is supported.
	 * @internal
	 * @license Modernizr 3.0.0pre (Custom Build) | MIT
	 */
	function isEventSupported(eventNameSuffix, capture) {
	  if (!ExecutionEnvironment.canUseDOM || capture && !('addEventListener' in document)) {
	    return false;
	  }
	
	  var eventName = 'on' + eventNameSuffix;
	  var isSupported = eventName in document;
	
	  if (!isSupported) {
	    var element = document.createElement('div');
	    element.setAttribute(eventName, 'return;');
	    isSupported = typeof element[eventName] === 'function';
	  }
	
	  if (!isSupported && useHasFeature && eventNameSuffix === 'wheel') {
	    // This is the only way to test support for the `wheel` event in IE9+.
	    isSupported = document.implementation.hasFeature('Events.wheel', '3.0');
	  }
	
	  return isSupported;
	}
	
	module.exports = isEventSupported;

/***/ },
/* 212 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule shouldUpdateReactComponent
	 */
	
	'use strict';
	
	/**
	 * Given a `prevElement` and `nextElement`, determines if the existing
	 * instance should be updated as opposed to being destroyed or replaced by a new
	 * instance. Both arguments are elements. This ensures that this logic can
	 * operate on stateless trees without any backing instance.
	 *
	 * @param {?object} prevElement
	 * @param {?object} nextElement
	 * @return {boolean} True if the existing instance should be updated.
	 * @protected
	 */
	
	function shouldUpdateReactComponent(prevElement, nextElement) {
	  var prevEmpty = prevElement === null || prevElement === false;
	  var nextEmpty = nextElement === null || nextElement === false;
	  if (prevEmpty || nextEmpty) {
	    return prevEmpty === nextEmpty;
	  }
	
	  var prevType = typeof prevElement;
	  var nextType = typeof nextElement;
	  if (prevType === 'string' || prevType === 'number') {
	    return nextType === 'string' || nextType === 'number';
	  } else {
	    return nextType === 'object' && prevElement.type === nextElement.type && prevElement.key === nextElement.key;
	  }
	}
	
	module.exports = shouldUpdateReactComponent;

/***/ },
/* 213 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule traverseAllChildren
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(5);
	
	var ReactCurrentOwner = __webpack_require__(75);
	var ReactElement = __webpack_require__(45);
	
	var getIteratorFn = __webpack_require__(334);
	var invariant = __webpack_require__(2);
	var KeyEscapeUtils = __webpack_require__(200);
	var warning = __webpack_require__(9);
	
	var SEPARATOR = '.';
	var SUBSEPARATOR = ':';
	
	/**
	 * TODO: Test that a single child and an array with one item have the same key
	 * pattern.
	 */
	
	var didWarnAboutMaps = false;
	
	/**
	 * Generate a key string that identifies a component within a set.
	 *
	 * @param {*} component A component that could contain a manual key.
	 * @param {number} index Index that is used if a manual key is not provided.
	 * @return {string}
	 */
	function getComponentKey(component, index) {
	  // Do some typechecking here since we call this blindly. We want to ensure
	  // that we don't block potential future ES APIs.
	  if (component && typeof component === 'object' && component.key != null) {
	    // Explicit key
	    return KeyEscapeUtils.escape(component.key);
	  }
	  // Implicit key determined by the index in the set
	  return index.toString(36);
	}
	
	/**
	 * @param {?*} children Children tree container.
	 * @param {!string} nameSoFar Name of the key path so far.
	 * @param {!function} callback Callback to invoke with each child found.
	 * @param {?*} traverseContext Used to pass information throughout the traversal
	 * process.
	 * @return {!number} The number of children in this subtree.
	 */
	function traverseAllChildrenImpl(children, nameSoFar, callback, traverseContext) {
	  var type = typeof children;
	
	  if (type === 'undefined' || type === 'boolean') {
	    // All of the above are perceived as null.
	    children = null;
	  }
	
	  if (children === null || type === 'string' || type === 'number' || ReactElement.isValidElement(children)) {
	    callback(traverseContext, children,
	    // If it's the only child, treat the name as if it was wrapped in an array
	    // so that it's consistent if the number of children grows.
	    nameSoFar === '' ? SEPARATOR + getComponentKey(children, 0) : nameSoFar);
	    return 1;
	  }
	
	  var child;
	  var nextName;
	  var subtreeCount = 0; // Count of children found in the current subtree.
	  var nextNamePrefix = nameSoFar === '' ? SEPARATOR : nameSoFar + SUBSEPARATOR;
	
	  if (Array.isArray(children)) {
	    for (var i = 0; i < children.length; i++) {
	      child = children[i];
	      nextName = nextNamePrefix + getComponentKey(child, i);
	      subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	    }
	  } else {
	    var iteratorFn = getIteratorFn(children);
	    if (iteratorFn) {
	      var iterator = iteratorFn.call(children);
	      var step;
	      if (iteratorFn !== children.entries) {
	        var ii = 0;
	        while (!(step = iterator.next()).done) {
	          child = step.value;
	          nextName = nextNamePrefix + getComponentKey(child, ii++);
	          subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	        }
	      } else {
	        if (false) {
	          process.env.NODE_ENV !== 'production' ? warning(didWarnAboutMaps, 'Using Maps as children is not yet fully supported. It is an ' + 'experimental feature that might be removed. Convert it to a ' + 'sequence / iterable of keyed ReactElements instead.') : void 0;
	          didWarnAboutMaps = true;
	        }
	        // Iterator will provide entry [k,v] tuples rather than values.
	        while (!(step = iterator.next()).done) {
	          var entry = step.value;
	          if (entry) {
	            child = entry[1];
	            nextName = nextNamePrefix + KeyEscapeUtils.escape(entry[0]) + SUBSEPARATOR + getComponentKey(child, 0);
	            subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	          }
	        }
	      }
	    } else if (type === 'object') {
	      var addendum = '';
	      if (false) {
	        addendum = ' If you meant to render a collection of children, use an array ' + 'instead or wrap the object using createFragment(object) from the ' + 'React add-ons.';
	        if (children._isReactElement) {
	          addendum = ' It looks like you\'re using an element created by a different ' + 'version of React. Make sure to use only one copy of React.';
	        }
	        if (ReactCurrentOwner.current) {
	          var name = ReactCurrentOwner.current.getName();
	          if (name) {
	            addendum += ' Check the render method of `' + name + '`.';
	          }
	        }
	      }
	      var childrenString = String(children);
	       true ?  false ? invariant(false, 'Objects are not valid as a React child (found: %s).%s', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : _prodInvariant('31', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : void 0;
	    }
	  }
	
	  return subtreeCount;
	}
	
	/**
	 * Traverses children that are typically specified as `props.children`, but
	 * might also be specified through attributes:
	 *
	 * - `traverseAllChildren(this.props.children, ...)`
	 * - `traverseAllChildren(this.props.leftPanelChildren, ...)`
	 *
	 * The `traverseContext` is an optional argument that is passed through the
	 * entire traversal. It can be used to store accumulations or anything else that
	 * the callback might find relevant.
	 *
	 * @param {?*} children Children tree object.
	 * @param {!function} callback To invoke upon traversing each child.
	 * @param {?*} traverseContext Context for traversal.
	 * @return {!number} The number of children in this subtree.
	 */
	function traverseAllChildren(children, callback, traverseContext) {
	  if (children == null) {
	    return 0;
	  }
	
	  return traverseAllChildrenImpl(children, '', callback, traverseContext);
	}
	
	module.exports = traverseAllChildren;

/***/ },
/* 214 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule validateDOMNesting
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(6);
	
	var emptyFunction = __webpack_require__(37);
	var warning = __webpack_require__(9);
	
	var validateDOMNesting = emptyFunction;
	
	if (false) {
	  // This validation code was written based on the HTML5 parsing spec:
	  // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-scope
	  //
	  // Note: this does not catch all invalid nesting, nor does it try to (as it's
	  // not clear what practical benefit doing so provides); instead, we warn only
	  // for cases where the parser will give a parse tree differing from what React
	  // intended. For example, <b><div></div></b> is invalid but we don't warn
	  // because it still parses correctly; we do warn for other cases like nested
	  // <p> tags where the beginning of the second element implicitly closes the
	  // first, causing a confusing mess.
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#special
	  var specialTags = ['address', 'applet', 'area', 'article', 'aside', 'base', 'basefont', 'bgsound', 'blockquote', 'body', 'br', 'button', 'caption', 'center', 'col', 'colgroup', 'dd', 'details', 'dir', 'div', 'dl', 'dt', 'embed', 'fieldset', 'figcaption', 'figure', 'footer', 'form', 'frame', 'frameset', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'head', 'header', 'hgroup', 'hr', 'html', 'iframe', 'img', 'input', 'isindex', 'li', 'link', 'listing', 'main', 'marquee', 'menu', 'menuitem', 'meta', 'nav', 'noembed', 'noframes', 'noscript', 'object', 'ol', 'p', 'param', 'plaintext', 'pre', 'script', 'section', 'select', 'source', 'style', 'summary', 'table', 'tbody', 'td', 'template', 'textarea', 'tfoot', 'th', 'thead', 'title', 'tr', 'track', 'ul', 'wbr', 'xmp'];
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-scope
	  var inScopeTags = ['applet', 'caption', 'html', 'table', 'td', 'th', 'marquee', 'object', 'template',
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#html-integration-point
	  // TODO: Distinguish by namespace here -- for <title>, including it here
	  // errs on the side of fewer warnings
	  'foreignObject', 'desc', 'title'];
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-button-scope
	  var buttonScopeTags = inScopeTags.concat(['button']);
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#generate-implied-end-tags
	  var impliedEndTags = ['dd', 'dt', 'li', 'option', 'optgroup', 'p', 'rp', 'rt'];
	
	  var emptyAncestorInfo = {
	    current: null,
	
	    formTag: null,
	    aTagInScope: null,
	    buttonTagInScope: null,
	    nobrTagInScope: null,
	    pTagInButtonScope: null,
	
	    listItemTagAutoclosing: null,
	    dlItemTagAutoclosing: null
	  };
	
	  var updatedAncestorInfo = function (oldInfo, tag, instance) {
	    var ancestorInfo = _assign({}, oldInfo || emptyAncestorInfo);
	    var info = { tag: tag, instance: instance };
	
	    if (inScopeTags.indexOf(tag) !== -1) {
	      ancestorInfo.aTagInScope = null;
	      ancestorInfo.buttonTagInScope = null;
	      ancestorInfo.nobrTagInScope = null;
	    }
	    if (buttonScopeTags.indexOf(tag) !== -1) {
	      ancestorInfo.pTagInButtonScope = null;
	    }
	
	    // See rules for 'li', 'dd', 'dt' start tags in
	    // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inbody
	    if (specialTags.indexOf(tag) !== -1 && tag !== 'address' && tag !== 'div' && tag !== 'p') {
	      ancestorInfo.listItemTagAutoclosing = null;
	      ancestorInfo.dlItemTagAutoclosing = null;
	    }
	
	    ancestorInfo.current = info;
	
	    if (tag === 'form') {
	      ancestorInfo.formTag = info;
	    }
	    if (tag === 'a') {
	      ancestorInfo.aTagInScope = info;
	    }
	    if (tag === 'button') {
	      ancestorInfo.buttonTagInScope = info;
	    }
	    if (tag === 'nobr') {
	      ancestorInfo.nobrTagInScope = info;
	    }
	    if (tag === 'p') {
	      ancestorInfo.pTagInButtonScope = info;
	    }
	    if (tag === 'li') {
	      ancestorInfo.listItemTagAutoclosing = info;
	    }
	    if (tag === 'dd' || tag === 'dt') {
	      ancestorInfo.dlItemTagAutoclosing = info;
	    }
	
	    return ancestorInfo;
	  };
	
	  /**
	   * Returns whether
	   */
	  var isTagValidWithParent = function (tag, parentTag) {
	    // First, let's check if we're in an unusual parsing mode...
	    switch (parentTag) {
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inselect
	      case 'select':
	        return tag === 'option' || tag === 'optgroup' || tag === '#text';
	      case 'optgroup':
	        return tag === 'option' || tag === '#text';
	      // Strictly speaking, seeing an <option> doesn't mean we're in a <select>
	      // but
	      case 'option':
	        return tag === '#text';
	
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intd
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-incaption
	      // No special behavior since these rules fall back to "in body" mode for
	      // all except special table nodes which cause bad parsing behavior anyway.
	
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intr
	      case 'tr':
	        return tag === 'th' || tag === 'td' || tag === 'style' || tag === 'script' || tag === 'template';
	
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intbody
	      case 'tbody':
	      case 'thead':
	      case 'tfoot':
	        return tag === 'tr' || tag === 'style' || tag === 'script' || tag === 'template';
	
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-incolgroup
	      case 'colgroup':
	        return tag === 'col' || tag === 'template';
	
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intable
	      case 'table':
	        return tag === 'caption' || tag === 'colgroup' || tag === 'tbody' || tag === 'tfoot' || tag === 'thead' || tag === 'style' || tag === 'script' || tag === 'template';
	
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inhead
	      case 'head':
	        return tag === 'base' || tag === 'basefont' || tag === 'bgsound' || tag === 'link' || tag === 'meta' || tag === 'title' || tag === 'noscript' || tag === 'noframes' || tag === 'style' || tag === 'script' || tag === 'template';
	
	      // https://html.spec.whatwg.org/multipage/semantics.html#the-html-element
	      case 'html':
	        return tag === 'head' || tag === 'body';
	      case '#document':
	        return tag === 'html';
	    }
	
	    // Probably in the "in body" parsing mode, so we outlaw only tag combos
	    // where the parsing rules cause implicit opens or closes to be added.
	    // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inbody
	    switch (tag) {
	      case 'h1':
	      case 'h2':
	      case 'h3':
	      case 'h4':
	      case 'h5':
	      case 'h6':
	        return parentTag !== 'h1' && parentTag !== 'h2' && parentTag !== 'h3' && parentTag !== 'h4' && parentTag !== 'h5' && parentTag !== 'h6';
	
	      case 'rp':
	      case 'rt':
	        return impliedEndTags.indexOf(parentTag) === -1;
	
	      case 'body':
	      case 'caption':
	      case 'col':
	      case 'colgroup':
	      case 'frame':
	      case 'head':
	      case 'html':
	      case 'tbody':
	      case 'td':
	      case 'tfoot':
	      case 'th':
	      case 'thead':
	      case 'tr':
	        // These tags are only valid with a few parents that have special child
	        // parsing rules -- if we're down here, then none of those matched and
	        // so we allow it only if we don't know what the parent is, as all other
	        // cases are invalid.
	        return parentTag == null;
	    }
	
	    return true;
	  };
	
	  /**
	   * Returns whether
	   */
	  var findInvalidAncestorForTag = function (tag, ancestorInfo) {
	    switch (tag) {
	      case 'address':
	      case 'article':
	      case 'aside':
	      case 'blockquote':
	      case 'center':
	      case 'details':
	      case 'dialog':
	      case 'dir':
	      case 'div':
	      case 'dl':
	      case 'fieldset':
	      case 'figcaption':
	      case 'figure':
	      case 'footer':
	      case 'header':
	      case 'hgroup':
	      case 'main':
	      case 'menu':
	      case 'nav':
	      case 'ol':
	      case 'p':
	      case 'section':
	      case 'summary':
	      case 'ul':
	
	      case 'pre':
	      case 'listing':
	
	      case 'table':
	
	      case 'hr':
	
	      case 'xmp':
	
	      case 'h1':
	      case 'h2':
	      case 'h3':
	      case 'h4':
	      case 'h5':
	      case 'h6':
	        return ancestorInfo.pTagInButtonScope;
	
	      case 'form':
	        return ancestorInfo.formTag || ancestorInfo.pTagInButtonScope;
	
	      case 'li':
	        return ancestorInfo.listItemTagAutoclosing;
	
	      case 'dd':
	      case 'dt':
	        return ancestorInfo.dlItemTagAutoclosing;
	
	      case 'button':
	        return ancestorInfo.buttonTagInScope;
	
	      case 'a':
	        // Spec says something about storing a list of markers, but it sounds
	        // equivalent to this check.
	        return ancestorInfo.aTagInScope;
	
	      case 'nobr':
	        return ancestorInfo.nobrTagInScope;
	    }
	
	    return null;
	  };
	
	  /**
	   * Given a ReactCompositeComponent instance, return a list of its recursive
	   * owners, starting at the root and ending with the instance itself.
	   */
	  var findOwnerStack = function (instance) {
	    if (!instance) {
	      return [];
	    }
	
	    var stack = [];
	    do {
	      stack.push(instance);
	    } while (instance = instance._currentElement._owner);
	    stack.reverse();
	    return stack;
	  };
	
	  var didWarn = {};
	
	  validateDOMNesting = function (childTag, childInstance, ancestorInfo) {
	    ancestorInfo = ancestorInfo || emptyAncestorInfo;
	    var parentInfo = ancestorInfo.current;
	    var parentTag = parentInfo && parentInfo.tag;
	
	    var invalidParent = isTagValidWithParent(childTag, parentTag) ? null : parentInfo;
	    var invalidAncestor = invalidParent ? null : findInvalidAncestorForTag(childTag, ancestorInfo);
	    var problematic = invalidParent || invalidAncestor;
	
	    if (problematic) {
	      var ancestorTag = problematic.tag;
	      var ancestorInstance = problematic.instance;
	
	      var childOwner = childInstance && childInstance._currentElement._owner;
	      var ancestorOwner = ancestorInstance && ancestorInstance._currentElement._owner;
	
	      var childOwners = findOwnerStack(childOwner);
	      var ancestorOwners = findOwnerStack(ancestorOwner);
	
	      var minStackLen = Math.min(childOwners.length, ancestorOwners.length);
	      var i;
	
	      var deepestCommon = -1;
	      for (i = 0; i < minStackLen; i++) {
	        if (childOwners[i] === ancestorOwners[i]) {
	          deepestCommon = i;
	        } else {
	          break;
	        }
	      }
	
	      var UNKNOWN = '(unknown)';
	      var childOwnerNames = childOwners.slice(deepestCommon + 1).map(function (inst) {
	        return inst.getName() || UNKNOWN;
	      });
	      var ancestorOwnerNames = ancestorOwners.slice(deepestCommon + 1).map(function (inst) {
	        return inst.getName() || UNKNOWN;
	      });
	      var ownerInfo = [].concat(
	      // If the parent and child instances have a common owner ancestor, start
	      // with that -- otherwise we just start with the parent's owners.
	      deepestCommon !== -1 ? childOwners[deepestCommon].getName() || UNKNOWN : [], ancestorOwnerNames, ancestorTag,
	      // If we're warning about an invalid (non-parent) ancestry, add '...'
	      invalidAncestor ? ['...'] : [], childOwnerNames, childTag).join(' > ');
	
	      var warnKey = !!invalidParent + '|' + childTag + '|' + ancestorTag + '|' + ownerInfo;
	      if (didWarn[warnKey]) {
	        return;
	      }
	      didWarn[warnKey] = true;
	
	      var tagDisplayName = childTag;
	      if (childTag !== '#text') {
	        tagDisplayName = '<' + childTag + '>';
	      }
	
	      if (invalidParent) {
	        var info = '';
	        if (ancestorTag === 'table' && childTag === 'tr') {
	          info += ' Add a <tbody> to your code to match the DOM tree generated by ' + 'the browser.';
	        }
	        process.env.NODE_ENV !== 'production' ? warning(false, 'validateDOMNesting(...): %s cannot appear as a child of <%s>. ' + 'See %s.%s', tagDisplayName, ancestorTag, ownerInfo, info) : void 0;
	      } else {
	        process.env.NODE_ENV !== 'production' ? warning(false, 'validateDOMNesting(...): %s cannot appear as a descendant of ' + '<%s>. See %s.', tagDisplayName, ancestorTag, ownerInfo) : void 0;
	      }
	    }
	  };
	
	  validateDOMNesting.updatedAncestorInfo = updatedAncestorInfo;
	
	  // For testing
	  validateDOMNesting.isTagValidInContext = function (tag, ancestorInfo) {
	    ancestorInfo = ancestorInfo || emptyAncestorInfo;
	    var parentInfo = ancestorInfo.current;
	    var parentTag = parentInfo && parentInfo.tag;
	    return isTagValidWithParent(tag, parentTag) && !findInvalidAncestorForTag(tag, ancestorInfo);
	  };
	}
	
	module.exports = validateDOMNesting;

/***/ },
/* 215 */
/***/ function(module, exports) {

	exports.createdStores = [];
	
	exports.createdActions = [];
	
	exports.reset = function() {
	    while(exports.createdStores.length) {
	        exports.createdStores.pop();
	    }
	    while(exports.createdActions.length) {
	        exports.createdActions.pop();
	    }
	};


/***/ },
/* 216 */
/***/ function(module, exports, __webpack_require__) {

	var cof = __webpack_require__(34);
	module.exports = function(it, msg){
	  if(typeof it != 'number' && cof(it) != 'Number')throw TypeError(msg);
	  return +it;
	};

/***/ },
/* 217 */
/***/ function(module, exports, __webpack_require__) {

	// 22.1.3.3 Array.prototype.copyWithin(target, start, end = this.length)
	'use strict';
	var toObject = __webpack_require__(18)
	  , toIndex  = __webpack_require__(71)
	  , toLength = __webpack_require__(16);
	
	module.exports = [].copyWithin || function copyWithin(target/*= 0*/, start/*= 0, end = @length*/){
	  var O     = toObject(this)
	    , len   = toLength(O.length)
	    , to    = toIndex(target, len)
	    , from  = toIndex(start, len)
	    , end   = arguments.length > 2 ? arguments[2] : undefined
	    , count = Math.min((end === undefined ? len : toIndex(end, len)) - from, len - to)
	    , inc   = 1;
	  if(from < to && to < from + count){
	    inc  = -1;
	    from += count - 1;
	    to   += count - 1;
	  }
	  while(count-- > 0){
	    if(from in O)O[to] = O[from];
	    else delete O[to];
	    to   += inc;
	    from += inc;
	  } return O;
	};

/***/ },
/* 218 */
/***/ function(module, exports, __webpack_require__) {

	var forOf = __webpack_require__(79);
	
	module.exports = function(iter, ITERATOR){
	  var result = [];
	  forOf(iter, false, result.push, result, ITERATOR);
	  return result;
	};


/***/ },
/* 219 */
/***/ function(module, exports, __webpack_require__) {

	var aFunction = __webpack_require__(26)
	  , toObject  = __webpack_require__(18)
	  , IObject   = __webpack_require__(92)
	  , toLength  = __webpack_require__(16);
	
	module.exports = function(that, callbackfn, aLen, memo, isRight){
	  aFunction(callbackfn);
	  var O      = toObject(that)
	    , self   = IObject(O)
	    , length = toLength(O.length)
	    , index  = isRight ? length - 1 : 0
	    , i      = isRight ? -1 : 1;
	  if(aLen < 2)for(;;){
	    if(index in self){
	      memo = self[index];
	      index += i;
	      break;
	    }
	    index += i;
	    if(isRight ? index < 0 : length <= index){
	      throw TypeError('Reduce of empty array with no initial value');
	    }
	  }
	  for(;isRight ? index >= 0 : length > index; index += i)if(index in self){
	    memo = callbackfn(memo, self[index], index, O);
	  }
	  return memo;
	};

/***/ },
/* 220 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var aFunction  = __webpack_require__(26)
	  , isObject   = __webpack_require__(10)
	  , invoke     = __webpack_require__(108)
	  , arraySlice = [].slice
	  , factories  = {};
	
	var construct = function(F, len, args){
	  if(!(len in factories)){
	    for(var n = [], i = 0; i < len; i++)n[i] = 'a[' + i + ']';
	    factories[len] = Function('F,a', 'return new F(' + n.join(',') + ')');
	  } return factories[len](F, args);
	};
	
	module.exports = Function.bind || function bind(that /*, args... */){
	  var fn       = aFunction(this)
	    , partArgs = arraySlice.call(arguments, 1);
	  var bound = function(/* args... */){
	    var args = partArgs.concat(arraySlice.call(arguments));
	    return this instanceof bound ? construct(fn, args.length, args) : invoke(fn, args, that);
	  };
	  if(isObject(fn.prototype))bound.prototype = fn.prototype;
	  return bound;
	};

/***/ },
/* 221 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var dP          = __webpack_require__(14).f
	  , create      = __webpack_require__(66)
	  , hide        = __webpack_require__(21)
	  , redefineAll = __webpack_require__(69)
	  , ctx         = __webpack_require__(47)
	  , anInstance  = __webpack_require__(55)
	  , defined     = __webpack_require__(35)
	  , forOf       = __webpack_require__(79)
	  , $iterDefine = __webpack_require__(156)
	  , step        = __webpack_require__(226)
	  , setSpecies  = __webpack_require__(70)
	  , DESCRIPTORS = __webpack_require__(13)
	  , fastKey     = __webpack_require__(56).fastKey
	  , SIZE        = DESCRIPTORS ? '_s' : 'size';
	
	var getEntry = function(that, key){
	  // fast case
	  var index = fastKey(key), entry;
	  if(index !== 'F')return that._i[index];
	  // frozen object case
	  for(entry = that._f; entry; entry = entry.n){
	    if(entry.k == key)return entry;
	  }
	};
	
	module.exports = {
	  getConstructor: function(wrapper, NAME, IS_MAP, ADDER){
	    var C = wrapper(function(that, iterable){
	      anInstance(that, C, NAME, '_i');
	      that._i = create(null); // index
	      that._f = undefined;    // first entry
	      that._l = undefined;    // last entry
	      that[SIZE] = 0;         // size
	      if(iterable != undefined)forOf(iterable, IS_MAP, that[ADDER], that);
	    });
	    redefineAll(C.prototype, {
	      // 23.1.3.1 Map.prototype.clear()
	      // 23.2.3.2 Set.prototype.clear()
	      clear: function clear(){
	        for(var that = this, data = that._i, entry = that._f; entry; entry = entry.n){
	          entry.r = true;
	          if(entry.p)entry.p = entry.p.n = undefined;
	          delete data[entry.i];
	        }
	        that._f = that._l = undefined;
	        that[SIZE] = 0;
	      },
	      // 23.1.3.3 Map.prototype.delete(key)
	      // 23.2.3.4 Set.prototype.delete(value)
	      'delete': function(key){
	        var that  = this
	          , entry = getEntry(that, key);
	        if(entry){
	          var next = entry.n
	            , prev = entry.p;
	          delete that._i[entry.i];
	          entry.r = true;
	          if(prev)prev.n = next;
	          if(next)next.p = prev;
	          if(that._f == entry)that._f = next;
	          if(that._l == entry)that._l = prev;
	          that[SIZE]--;
	        } return !!entry;
	      },
	      // 23.2.3.6 Set.prototype.forEach(callbackfn, thisArg = undefined)
	      // 23.1.3.5 Map.prototype.forEach(callbackfn, thisArg = undefined)
	      forEach: function forEach(callbackfn /*, that = undefined */){
	        anInstance(this, C, 'forEach');
	        var f = ctx(callbackfn, arguments.length > 1 ? arguments[1] : undefined, 3)
	          , entry;
	        while(entry = entry ? entry.n : this._f){
	          f(entry.v, entry.k, this);
	          // revert to the last existing entry
	          while(entry && entry.r)entry = entry.p;
	        }
	      },
	      // 23.1.3.7 Map.prototype.has(key)
	      // 23.2.3.7 Set.prototype.has(value)
	      has: function has(key){
	        return !!getEntry(this, key);
	      }
	    });
	    if(DESCRIPTORS)dP(C.prototype, 'size', {
	      get: function(){
	        return defined(this[SIZE]);
	      }
	    });
	    return C;
	  },
	  def: function(that, key, value){
	    var entry = getEntry(that, key)
	      , prev, index;
	    // change existing entry
	    if(entry){
	      entry.v = value;
	    // create new entry
	    } else {
	      that._l = entry = {
	        i: index = fastKey(key, true), // <- index
	        k: key,                        // <- key
	        v: value,                      // <- value
	        p: prev = that._l,             // <- previous entry
	        n: undefined,                  // <- next entry
	        r: false                       // <- removed
	      };
	      if(!that._f)that._f = entry;
	      if(prev)prev.n = entry;
	      that[SIZE]++;
	      // add to index
	      if(index !== 'F')that._i[index] = entry;
	    } return that;
	  },
	  getEntry: getEntry,
	  setStrong: function(C, NAME, IS_MAP){
	    // add .keys, .values, .entries, [@@iterator]
	    // 23.1.3.4, 23.1.3.8, 23.1.3.11, 23.1.3.12, 23.2.3.5, 23.2.3.8, 23.2.3.10, 23.2.3.11
	    $iterDefine(C, NAME, function(iterated, kind){
	      this._t = iterated;  // target
	      this._k = kind;      // kind
	      this._l = undefined; // previous
	    }, function(){
	      var that  = this
	        , kind  = that._k
	        , entry = that._l;
	      // revert to the last existing entry
	      while(entry && entry.r)entry = entry.p;
	      // get next entry
	      if(!that._t || !(that._l = entry = entry ? entry.n : that._t._f)){
	        // or finish the iteration
	        that._t = undefined;
	        return step(1);
	      }
	      // return step by kind
	      if(kind == 'keys'  )return step(0, entry.k);
	      if(kind == 'values')return step(0, entry.v);
	      return step(0, [entry.k, entry.v]);
	    }, IS_MAP ? 'entries' : 'values' , !IS_MAP, true);
	
	    // add [@@species], 23.1.2.2, 23.2.2.2
	    setSpecies(NAME);
	  }
	};

/***/ },
/* 222 */
/***/ function(module, exports, __webpack_require__) {

	// https://github.com/DavidBruant/Map-Set.prototype.toJSON
	var classof = __webpack_require__(78)
	  , from    = __webpack_require__(218);
	module.exports = function(NAME){
	  return function toJSON(){
	    if(classof(this) != NAME)throw TypeError(NAME + "#toJSON isn't generic");
	    return from(this);
	  };
	};

/***/ },
/* 223 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var redefineAll       = __webpack_require__(69)
	  , getWeak           = __webpack_require__(56).getWeak
	  , anObject          = __webpack_require__(4)
	  , isObject          = __webpack_require__(10)
	  , anInstance        = __webpack_require__(55)
	  , forOf             = __webpack_require__(79)
	  , createArrayMethod = __webpack_require__(41)
	  , $has              = __webpack_require__(19)
	  , arrayFind         = createArrayMethod(5)
	  , arrayFindIndex    = createArrayMethod(6)
	  , id                = 0;
	
	// fallback for uncaught frozen keys
	var uncaughtFrozenStore = function(that){
	  return that._l || (that._l = new UncaughtFrozenStore);
	};
	var UncaughtFrozenStore = function(){
	  this.a = [];
	};
	var findUncaughtFrozen = function(store, key){
	  return arrayFind(store.a, function(it){
	    return it[0] === key;
	  });
	};
	UncaughtFrozenStore.prototype = {
	  get: function(key){
	    var entry = findUncaughtFrozen(this, key);
	    if(entry)return entry[1];
	  },
	  has: function(key){
	    return !!findUncaughtFrozen(this, key);
	  },
	  set: function(key, value){
	    var entry = findUncaughtFrozen(this, key);
	    if(entry)entry[1] = value;
	    else this.a.push([key, value]);
	  },
	  'delete': function(key){
	    var index = arrayFindIndex(this.a, function(it){
	      return it[0] === key;
	    });
	    if(~index)this.a.splice(index, 1);
	    return !!~index;
	  }
	};
	
	module.exports = {
	  getConstructor: function(wrapper, NAME, IS_MAP, ADDER){
	    var C = wrapper(function(that, iterable){
	      anInstance(that, C, NAME, '_i');
	      that._i = id++;      // collection id
	      that._l = undefined; // leak store for uncaught frozen objects
	      if(iterable != undefined)forOf(iterable, IS_MAP, that[ADDER], that);
	    });
	    redefineAll(C.prototype, {
	      // 23.3.3.2 WeakMap.prototype.delete(key)
	      // 23.4.3.3 WeakSet.prototype.delete(value)
	      'delete': function(key){
	        if(!isObject(key))return false;
	        var data = getWeak(key);
	        if(data === true)return uncaughtFrozenStore(this)['delete'](key);
	        return data && $has(data, this._i) && delete data[this._i];
	      },
	      // 23.3.3.4 WeakMap.prototype.has(key)
	      // 23.4.3.4 WeakSet.prototype.has(value)
	      has: function has(key){
	        if(!isObject(key))return false;
	        var data = getWeak(key);
	        if(data === true)return uncaughtFrozenStore(this).has(key);
	        return data && $has(data, this._i);
	      }
	    });
	    return C;
	  },
	  def: function(that, key, value){
	    var data = getWeak(anObject(key), true);
	    if(data === true)uncaughtFrozenStore(that).set(key, value);
	    else data[that._i] = value;
	    return that;
	  },
	  ufstore: uncaughtFrozenStore
	};

/***/ },
/* 224 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = !__webpack_require__(13) && !__webpack_require__(8)(function(){
	  return Object.defineProperty(__webpack_require__(147)('div'), 'a', {get: function(){ return 7; }}).a != 7;
	});

/***/ },
/* 225 */
/***/ function(module, exports, __webpack_require__) {

	// call something on iterator step with safe closing on error
	var anObject = __webpack_require__(4);
	module.exports = function(iterator, fn, value, entries){
	  try {
	    return entries ? fn(anObject(value)[0], value[1]) : fn(value);
	  // 7.4.6 IteratorClose(iterator, completion)
	  } catch(e){
	    var ret = iterator['return'];
	    if(ret !== undefined)anObject(ret.call(iterator));
	    throw e;
	  }
	};

/***/ },
/* 226 */
/***/ function(module, exports) {

	module.exports = function(done, value){
	  return {value: value, done: !!done};
	};

/***/ },
/* 227 */
/***/ function(module, exports) {

	// 20.2.2.20 Math.log1p(x)
	module.exports = Math.log1p || function log1p(x){
	  return (x = +x) > -1e-8 && x < 1e-8 ? x - x * x / 2 : Math.log(1 + x);
	};

/***/ },
/* 228 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// 19.1.2.1 Object.assign(target, source, ...)
	var getKeys  = __webpack_require__(68)
	  , gOPS     = __webpack_require__(112)
	  , pIE      = __webpack_require__(93)
	  , toObject = __webpack_require__(18)
	  , IObject  = __webpack_require__(92)
	  , $assign  = Object.assign;
	
	// should work with symbols and should have deterministic property order (V8 bug)
	module.exports = !$assign || __webpack_require__(8)(function(){
	  var A = {}
	    , B = {}
	    , S = Symbol()
	    , K = 'abcdefghijklmnopqrst';
	  A[S] = 7;
	  K.split('').forEach(function(k){ B[k] = k; });
	  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
	}) ? function assign(target, source){ // eslint-disable-line no-unused-vars
	  var T     = toObject(target)
	    , aLen  = arguments.length
	    , index = 1
	    , getSymbols = gOPS.f
	    , isEnum     = pIE.f;
	  while(aLen > index){
	    var S      = IObject(arguments[index++])
	      , keys   = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S)
	      , length = keys.length
	      , j      = 0
	      , key;
	    while(length > j)if(isEnum.call(S, key = keys[j++]))T[key] = S[key];
	  } return T;
	} : $assign;

/***/ },
/* 229 */
/***/ function(module, exports, __webpack_require__) {

	var dP       = __webpack_require__(14)
	  , anObject = __webpack_require__(4)
	  , getKeys  = __webpack_require__(68);
	
	module.exports = __webpack_require__(13) ? Object.defineProperties : function defineProperties(O, Properties){
	  anObject(O);
	  var keys   = getKeys(Properties)
	    , length = keys.length
	    , i = 0
	    , P;
	  while(length > i)dP.f(O, P = keys[i++], Properties[P]);
	  return O;
	};

/***/ },
/* 230 */
/***/ function(module, exports, __webpack_require__) {

	// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
	var toIObject = __webpack_require__(29)
	  , gOPN      = __webpack_require__(67).f
	  , toString  = {}.toString;
	
	var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
	  ? Object.getOwnPropertyNames(window) : [];
	
	var getWindowNames = function(it){
	  try {
	    return gOPN(it);
	  } catch(e){
	    return windowNames.slice();
	  }
	};
	
	module.exports.f = function getOwnPropertyNames(it){
	  return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
	};


/***/ },
/* 231 */
/***/ function(module, exports, __webpack_require__) {

	var has          = __webpack_require__(19)
	  , toIObject    = __webpack_require__(29)
	  , arrayIndexOf = __webpack_require__(104)(false)
	  , IE_PROTO     = __webpack_require__(160)('IE_PROTO');
	
	module.exports = function(object, names){
	  var O      = toIObject(object)
	    , i      = 0
	    , result = []
	    , key;
	  for(key in O)if(key != IE_PROTO)has(O, key) && result.push(key);
	  // Don't enum bug & hidden keys
	  while(names.length > i)if(has(O, key = names[i++])){
	    ~arrayIndexOf(result, key) || result.push(key);
	  }
	  return result;
	};

/***/ },
/* 232 */
/***/ function(module, exports, __webpack_require__) {

	var getKeys   = __webpack_require__(68)
	  , toIObject = __webpack_require__(29)
	  , isEnum    = __webpack_require__(93).f;
	module.exports = function(isEntries){
	  return function(it){
	    var O      = toIObject(it)
	      , keys   = getKeys(O)
	      , length = keys.length
	      , i      = 0
	      , result = []
	      , key;
	    while(length > i)if(isEnum.call(O, key = keys[i++])){
	      result.push(isEntries ? [key, O[key]] : O[key]);
	    } return result;
	  };
	};

/***/ },
/* 233 */
/***/ function(module, exports, __webpack_require__) {

	// all object keys, includes non-enumerable and symbols
	var gOPN     = __webpack_require__(67)
	  , gOPS     = __webpack_require__(112)
	  , anObject = __webpack_require__(4)
	  , Reflect  = __webpack_require__(7).Reflect;
	module.exports = Reflect && Reflect.ownKeys || function ownKeys(it){
	  var keys       = gOPN.f(anObject(it))
	    , getSymbols = gOPS.f;
	  return getSymbols ? keys.concat(getSymbols(it)) : keys;
	};

/***/ },
/* 234 */
/***/ function(module, exports, __webpack_require__) {

	var $parseFloat = __webpack_require__(7).parseFloat
	  , $trim       = __webpack_require__(81).trim;
	
	module.exports = 1 / $parseFloat(__webpack_require__(165) + '-0') !== -Infinity ? function parseFloat(str){
	  var string = $trim(String(str), 3)
	    , result = $parseFloat(string);
	  return result === 0 && string.charAt(0) == '-' ? -0 : result;
	} : $parseFloat;

/***/ },
/* 235 */
/***/ function(module, exports, __webpack_require__) {

	var $parseInt = __webpack_require__(7).parseInt
	  , $trim     = __webpack_require__(81).trim
	  , ws        = __webpack_require__(165)
	  , hex       = /^[\-+]?0[xX]/;
	
	module.exports = $parseInt(ws + '08') !== 8 || $parseInt(ws + '0x16') !== 22 ? function parseInt(str, radix){
	  var string = $trim(String(str), 3);
	  return $parseInt(string, (radix >>> 0) || (hex.test(string) ? 16 : 10));
	} : $parseInt;

/***/ },
/* 236 */
/***/ function(module, exports) {

	// 7.2.9 SameValue(x, y)
	module.exports = Object.is || function is(x, y){
	  return x === y ? x !== 0 || 1 / x === 1 / y : x != x && y != y;
	};

/***/ },
/* 237 */
/***/ function(module, exports, __webpack_require__) {

	// https://github.com/tc39/proposal-string-pad-start-end
	var toLength = __webpack_require__(16)
	  , repeat   = __webpack_require__(164)
	  , defined  = __webpack_require__(35);
	
	module.exports = function(that, maxLength, fillString, left){
	  var S            = String(defined(that))
	    , stringLength = S.length
	    , fillStr      = fillString === undefined ? ' ' : String(fillString)
	    , intMaxLength = toLength(maxLength);
	  if(intMaxLength <= stringLength || fillStr == '')return S;
	  var fillLen = intMaxLength - stringLength
	    , stringFiller = repeat.call(fillStr, Math.ceil(fillLen / fillStr.length));
	  if(stringFiller.length > fillLen)stringFiller = stringFiller.slice(0, fillLen);
	  return left ? stringFiller + S : S + stringFiller;
	};


/***/ },
/* 238 */
/***/ function(module, exports, __webpack_require__) {

	exports.f = __webpack_require__(11);

/***/ },
/* 239 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var strong = __webpack_require__(221);
	
	// 23.1 Map Objects
	module.exports = __webpack_require__(105)('Map', function(get){
	  return function Map(){ return get(this, arguments.length > 0 ? arguments[0] : undefined); };
	}, {
	  // 23.1.3.6 Map.prototype.get(key)
	  get: function get(key){
	    var entry = strong.getEntry(this, key);
	    return entry && entry.v;
	  },
	  // 23.1.3.9 Map.prototype.set(key, value)
	  set: function set(key, value){
	    return strong.def(this, key === 0 ? 0 : key, value);
	  }
	}, strong, true);

/***/ },
/* 240 */
/***/ function(module, exports, __webpack_require__) {

	// 21.2.5.3 get RegExp.prototype.flags()
	if(__webpack_require__(13) && /./g.flags != 'g')__webpack_require__(14).f(RegExp.prototype, 'flags', {
	  configurable: true,
	  get: __webpack_require__(107)
	});

/***/ },
/* 241 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var strong = __webpack_require__(221);
	
	// 23.2 Set Objects
	module.exports = __webpack_require__(105)('Set', function(get){
	  return function Set(){ return get(this, arguments.length > 0 ? arguments[0] : undefined); };
	}, {
	  // 23.2.3.1 Set.prototype.add(value)
	  add: function add(value){
	    return strong.def(this, value = value === 0 ? 0 : value, value);
	  }
	}, strong);

/***/ },
/* 242 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var each         = __webpack_require__(41)(0)
	  , redefine     = __webpack_require__(27)
	  , meta         = __webpack_require__(56)
	  , assign       = __webpack_require__(228)
	  , weak         = __webpack_require__(223)
	  , isObject     = __webpack_require__(10)
	  , has          = __webpack_require__(19)
	  , getWeak      = meta.getWeak
	  , isExtensible = Object.isExtensible
	  , uncaughtFrozenStore = weak.ufstore
	  , tmp          = {}
	  , InternalMap;
	
	var wrapper = function(get){
	  return function WeakMap(){
	    return get(this, arguments.length > 0 ? arguments[0] : undefined);
	  };
	};
	
	var methods = {
	  // 23.3.3.3 WeakMap.prototype.get(key)
	  get: function get(key){
	    if(isObject(key)){
	      var data = getWeak(key);
	      if(data === true)return uncaughtFrozenStore(this).get(key);
	      return data ? data[this._i] : undefined;
	    }
	  },
	  // 23.3.3.5 WeakMap.prototype.set(key, value)
	  set: function set(key, value){
	    return weak.def(this, key, value);
	  }
	};
	
	// 23.3 WeakMap Objects
	var $WeakMap = module.exports = __webpack_require__(105)('WeakMap', wrapper, methods, weak, true, true);
	
	// IE11 WeakMap frozen keys fix
	if(new $WeakMap().set((Object.freeze || Object)(tmp), 7).get(tmp) != 7){
	  InternalMap = weak.getConstructor(wrapper);
	  assign(InternalMap.prototype, methods);
	  meta.NEED = true;
	  each(['delete', 'has', 'get', 'set'], function(key){
	    var proto  = $WeakMap.prototype
	      , method = proto[key];
	    redefine(proto, key, function(a, b){
	      // store frozen objects on internal weakmap shim
	      if(isObject(a) && !isExtensible(a)){
	        if(!this._f)this._f = new InternalMap;
	        var result = this._f[key](a, b);
	        return key == 'set' ? this : result;
	      // store all the rest on native weakmap
	      } return method.call(this, a, b);
	    });
	  });
	}

/***/ },
/* 243 */
/***/ function(module, exports) {

	/*
		MIT License http://www.opensource.org/licenses/mit-license.php
		Author Tobias Koppers @sokra
	*/
	// css base code, injected by the css-loader
	module.exports = function() {
		var list = [];
	
		// return the list of modules as css string
		list.toString = function toString() {
			var result = [];
			for(var i = 0; i < this.length; i++) {
				var item = this[i];
				if(item[2]) {
					result.push("@media " + item[2] + "{" + item[1] + "}");
				} else {
					result.push(item[1]);
				}
			}
			return result.join("");
		};
	
		// import a list of modules into the list
		list.i = function(modules, mediaQuery) {
			if(typeof modules === "string")
				modules = [[null, modules, ""]];
			var alreadyImportedModules = {};
			for(var i = 0; i < this.length; i++) {
				var id = this[i][0];
				if(typeof id === "number")
					alreadyImportedModules[id] = true;
			}
			for(i = 0; i < modules.length; i++) {
				var item = modules[i];
				// skip already imported module
				// this implementation is not 100% perfect for weird media query combinations
				//  when a module is imported multiple times with different media queries.
				//  I hope this will never occur (Hey this way we have smaller bundles)
				if(typeof item[0] !== "number" || !alreadyImportedModules[item[0]]) {
					if(mediaQuery && !item[2]) {
						item[2] = mediaQuery;
					} else if(mediaQuery) {
						item[2] = "(" + item[2] + ") and (" + mediaQuery + ")";
					}
					list.push(item);
				}
			}
		};
		return list;
	};


/***/ },
/* 244 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 *
	 * @typechecks
	 */
	
	var emptyFunction = __webpack_require__(37);
	
	/**
	 * Upstream version of event listener. Does not take into account specific
	 * nature of platform.
	 */
	var EventListener = {
	  /**
	   * Listen to DOM events during the bubble phase.
	   *
	   * @param {DOMEventTarget} target DOM element to register listener on.
	   * @param {string} eventType Event type, e.g. 'click' or 'mouseover'.
	   * @param {function} callback Callback function.
	   * @return {object} Object with a `remove` method.
	   */
	  listen: function listen(target, eventType, callback) {
	    if (target.addEventListener) {
	      target.addEventListener(eventType, callback, false);
	      return {
	        remove: function remove() {
	          target.removeEventListener(eventType, callback, false);
	        }
	      };
	    } else if (target.attachEvent) {
	      target.attachEvent('on' + eventType, callback);
	      return {
	        remove: function remove() {
	          target.detachEvent('on' + eventType, callback);
	        }
	      };
	    }
	  },
	
	  /**
	   * Listen to DOM events during the capture phase.
	   *
	   * @param {DOMEventTarget} target DOM element to register listener on.
	   * @param {string} eventType Event type, e.g. 'click' or 'mouseover'.
	   * @param {function} callback Callback function.
	   * @return {object} Object with a `remove` method.
	   */
	  capture: function capture(target, eventType, callback) {
	    if (target.addEventListener) {
	      target.addEventListener(eventType, callback, true);
	      return {
	        remove: function remove() {
	          target.removeEventListener(eventType, callback, true);
	        }
	      };
	    } else {
	      if (false) {
	        console.error('Attempted to listen to events during the capture phase on a ' + 'browser that does not support the capture phase. Your application ' + 'will not receive some events.');
	      }
	      return {
	        remove: emptyFunction
	      };
	    }
	  },
	
	  registerDefault: function registerDefault() {}
	};
	
	module.exports = EventListener;

/***/ },
/* 245 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	/**
	 * @param {DOMElement} node input/textarea to focus
	 */
	
	function focusNode(node) {
	  // IE8 can throw "Can't move focus to the control because it is invisible,
	  // not enabled, or of a type that does not accept the focus." for all kinds of
	  // reasons that are too expensive and fragile to test.
	  try {
	    node.focus();
	  } catch (e) {}
	}
	
	module.exports = focusNode;

/***/ },
/* 246 */
/***/ function(module, exports) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks
	 */
	
	/* eslint-disable fb-www/typeof-undefined */
	
	/**
	 * Same as document.activeElement but wraps in a try-catch block. In IE it is
	 * not safe to call document.activeElement if there is nothing focused.
	 *
	 * The activeElement will be null only if the document or document body is not
	 * yet defined.
	 */
	function getActiveElement() /*?DOMElement*/{
	  if (typeof document === 'undefined') {
	    return null;
	  }
	  try {
	    return document.activeElement || document.body;
	  } catch (e) {
	    return document.body;
	  }
	}
	
	module.exports = getActiveElement;

/***/ },
/* 247 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks
	 * 
	 */
	
	/*eslint-disable no-self-compare */
	
	'use strict';
	
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	
	/**
	 * inlined Object.is polyfill to avoid requiring consumers ship their own
	 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
	 */
	function is(x, y) {
	  // SameValue algorithm
	  if (x === y) {
	    // Steps 1-5, 7-10
	    // Steps 6.b-6.e: +0 != -0
	    return x !== 0 || 1 / x === 1 / y;
	  } else {
	    // Step 6.a: NaN == NaN
	    return x !== x && y !== y;
	  }
	}
	
	/**
	 * Performs equality by iterating through keys on an object and returning false
	 * when any key has values which are not strictly equal between the arguments.
	 * Returns true when the values of all keys are strictly equal.
	 */
	function shallowEqual(objA, objB) {
	  if (is(objA, objB)) {
	    return true;
	  }
	
	  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
	    return false;
	  }
	
	  var keysA = Object.keys(objA);
	  var keysB = Object.keys(objB);
	
	  if (keysA.length !== keysB.length) {
	    return false;
	  }
	
	  // Test for A's keys different from B.
	  for (var i = 0; i < keysA.length; i++) {
	    if (!hasOwnProperty.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
	      return false;
	    }
	  }
	
	  return true;
	}
	
	module.exports = shallowEqual;

/***/ },
/* 248 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.readState = exports.saveState = undefined;
	
	var _warning = __webpack_require__(63);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var QuotaExceededErrors = {
	  QuotaExceededError: true,
	  QUOTA_EXCEEDED_ERR: true
	};
	
	var SecurityErrors = {
	  SecurityError: true
	};
	
	var KeyPrefix = '@@History/';
	
	var createKey = function createKey(key) {
	  return KeyPrefix + key;
	};
	
	var saveState = exports.saveState = function saveState(key, state) {
	  if (!window.sessionStorage) {
	    // Session storage is not available or hidden.
	    // sessionStorage is undefined in Internet Explorer when served via file protocol.
	     false ? (0, _warning2.default)(false, '[history] Unable to save state; sessionStorage is not available') : void 0;
	
	    return;
	  }
	
	  try {
	    if (state == null) {
	      window.sessionStorage.removeItem(createKey(key));
	    } else {
	      window.sessionStorage.setItem(createKey(key), JSON.stringify(state));
	    }
	  } catch (error) {
	    if (SecurityErrors[error.name]) {
	      // Blocking cookies in Chrome/Firefox/Safari throws SecurityError on any
	      // attempt to access window.sessionStorage.
	       false ? (0, _warning2.default)(false, '[history] Unable to save state; sessionStorage is not available due to security settings') : void 0;
	
	      return;
	    }
	
	    if (QuotaExceededErrors[error.name] && window.sessionStorage.length === 0) {
	      // Safari "private mode" throws QuotaExceededError.
	       false ? (0, _warning2.default)(false, '[history] Unable to save state; sessionStorage is not available in Safari private mode') : void 0;
	
	      return;
	    }
	
	    throw error;
	  }
	};
	
	var readState = exports.readState = function readState(key) {
	  var json = void 0;
	  try {
	    json = window.sessionStorage.getItem(createKey(key));
	  } catch (error) {
	    if (SecurityErrors[error.name]) {
	      // Blocking cookies in Chrome/Firefox/Safari throws SecurityError on any
	      // attempt to access window.sessionStorage.
	       false ? (0, _warning2.default)(false, '[history] Unable to read state; sessionStorage is not available due to security settings') : void 0;
	
	      return undefined;
	    }
	  }
	
	  if (json) {
	    try {
	      return JSON.parse(json);
	    } catch (error) {
	      // Ignore invalid JSON.
	    }
	  }
	
	  return undefined;
	};

/***/ },
/* 249 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _runTransitionHook = __webpack_require__(175);
	
	var _runTransitionHook2 = _interopRequireDefault(_runTransitionHook);
	
	var _PathUtils = __webpack_require__(59);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var useBasename = function useBasename(createHistory) {
	  return function () {
	    var options = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	    var history = createHistory(options);
	    var basename = options.basename;
	
	
	    var addBasename = function addBasename(location) {
	      if (!location) return location;
	
	      if (basename && location.basename == null) {
	        if (location.pathname.indexOf(basename) === 0) {
	          location.pathname = location.pathname.substring(basename.length);
	          location.basename = basename;
	
	          if (location.pathname === '') location.pathname = '/';
	        } else {
	          location.basename = '';
	        }
	      }
	
	      return location;
	    };
	
	    var prependBasename = function prependBasename(location) {
	      if (!basename) return location;
	
	      var object = typeof location === 'string' ? (0, _PathUtils.parsePath)(location) : location;
	      var pname = object.pathname;
	      var normalizedBasename = basename.slice(-1) === '/' ? basename : basename + '/';
	      var normalizedPathname = pname.charAt(0) === '/' ? pname.slice(1) : pname;
	      var pathname = normalizedBasename + normalizedPathname;
	
	      return _extends({}, object, {
	        pathname: pathname
	      });
	    };
	
	    // Override all read methods with basename-aware versions.
	    var getCurrentLocation = function getCurrentLocation() {
	      return addBasename(history.getCurrentLocation());
	    };
	
	    var listenBefore = function listenBefore(hook) {
	      return history.listenBefore(function (location, callback) {
	        return (0, _runTransitionHook2.default)(hook, addBasename(location), callback);
	      });
	    };
	
	    var listen = function listen(listener) {
	      return history.listen(function (location) {
	        return listener(addBasename(location));
	      });
	    };
	
	    // Override all write methods with basename-aware versions.
	    var push = function push(location) {
	      return history.push(prependBasename(location));
	    };
	
	    var replace = function replace(location) {
	      return history.replace(prependBasename(location));
	    };
	
	    var createPath = function createPath(location) {
	      return history.createPath(prependBasename(location));
	    };
	
	    var createHref = function createHref(location) {
	      return history.createHref(prependBasename(location));
	    };
	
	    var createLocation = function createLocation(location) {
	      for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	        args[_key - 1] = arguments[_key];
	      }
	
	      return addBasename(history.createLocation.apply(history, [prependBasename(location)].concat(args)));
	    };
	
	    return _extends({}, history, {
	      getCurrentLocation: getCurrentLocation,
	      listenBefore: listenBefore,
	      listen: listen,
	      push: push,
	      replace: replace,
	      createPath: createPath,
	      createHref: createHref,
	      createLocation: createLocation
	    });
	  };
	};
	
	exports.default = useBasename;

/***/ },
/* 250 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _queryString = __webpack_require__(679);
	
	var _runTransitionHook = __webpack_require__(175);
	
	var _runTransitionHook2 = _interopRequireDefault(_runTransitionHook);
	
	var _LocationUtils = __webpack_require__(82);
	
	var _PathUtils = __webpack_require__(59);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var defaultStringifyQuery = function defaultStringifyQuery(query) {
	  return (0, _queryString.stringify)(query).replace(/%20/g, '+');
	};
	
	var defaultParseQueryString = _queryString.parse;
	
	/**
	 * Returns a new createHistory function that may be used to create
	 * history objects that know how to handle URL queries.
	 */
	var useQueries = function useQueries(createHistory) {
	  return function () {
	    var options = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	    var history = createHistory(options);
	    var stringifyQuery = options.stringifyQuery;
	    var parseQueryString = options.parseQueryString;
	
	
	    if (typeof stringifyQuery !== 'function') stringifyQuery = defaultStringifyQuery;
	
	    if (typeof parseQueryString !== 'function') parseQueryString = defaultParseQueryString;
	
	    var decodeQuery = function decodeQuery(location) {
	      if (!location) return location;
	
	      if (location.query == null) location.query = parseQueryString(location.search.substring(1));
	
	      return location;
	    };
	
	    var encodeQuery = function encodeQuery(location, query) {
	      if (query == null) return location;
	
	      var object = typeof location === 'string' ? (0, _PathUtils.parsePath)(location) : location;
	      var queryString = stringifyQuery(query);
	      var search = queryString ? '?' + queryString : '';
	
	      return _extends({}, object, {
	        search: search
	      });
	    };
	
	    // Override all read methods with query-aware versions.
	    var getCurrentLocation = function getCurrentLocation() {
	      return decodeQuery(history.getCurrentLocation());
	    };
	
	    var listenBefore = function listenBefore(hook) {
	      return history.listenBefore(function (location, callback) {
	        return (0, _runTransitionHook2.default)(hook, decodeQuery(location), callback);
	      });
	    };
	
	    var listen = function listen(listener) {
	      return history.listen(function (location) {
	        return listener(decodeQuery(location));
	      });
	    };
	
	    // Override all write methods with query-aware versions.
	    var push = function push(location) {
	      return history.push(encodeQuery(location, location.query));
	    };
	
	    var replace = function replace(location) {
	      return history.replace(encodeQuery(location, location.query));
	    };
	
	    var createPath = function createPath(location) {
	      return history.createPath(encodeQuery(location, location.query));
	    };
	
	    var createHref = function createHref(location) {
	      return history.createHref(encodeQuery(location, location.query));
	    };
	
	    var createLocation = function createLocation(location) {
	      for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	        args[_key - 1] = arguments[_key];
	      }
	
	      var newLocation = history.createLocation.apply(history, [encodeQuery(location, location.query)].concat(args));
	
	      if (location.query) newLocation.query = (0, _LocationUtils.createQuery)(location.query);
	
	      return decodeQuery(newLocation);
	    };
	
	    return _extends({}, history, {
	      getCurrentLocation: getCurrentLocation,
	      listenBefore: listenBefore,
	      listen: listen,
	      push: push,
	      replace: replace,
	      createPath: createPath,
	      createHref: createHref,
	      createLocation: createLocation
	    });
	  };
	};
	
	exports.default = useQueries;

/***/ },
/* 251 */
/***/ function(module, exports, __webpack_require__) {

	var camel2hyphen = __webpack_require__(819);
	
	var isDimension = function (feature) {
	  var re = /[height|width]$/;
	  return re.test(feature);
	};
	
	var obj2mq = function (obj) {
	  var mq = '';
	  var features = Object.keys(obj);
	  features.forEach(function (feature, index) {
	    var value = obj[feature];
	    feature = camel2hyphen(feature);
	    // Add px to dimension features
	    if (isDimension(feature) && typeof value === 'number') {
	      value = value + 'px';
	    }
	    if (value === true) {
	      mq += feature;
	    } else if (value === false) {
	      mq += 'not ' + feature;
	    } else {
	      mq += '(' + feature + ': ' + value + ')';
	    }
	    if (index < features.length-1) {
	      mq += ' and '
	    }
	  });
	  return mq;
	};
	
	var json2mq = function (query) {
	  var mq = '';
	  if (typeof query === 'string') {
	    return query;
	  }
	  // Handling array of media queries
	  if (query instanceof Array) {
	    query.forEach(function (q, index) {
	      mq += obj2mq(q);
	      if (index < query.length-1) {
	        mq += ', '
	      }
	    });
	    return mq;
	  }
	  // Handling single media query
	  return obj2mq(query);
	};
	
	module.exports = json2mq;

/***/ },
/* 252 */
/***/ function(module, exports, __webpack_require__) {

	var baseCreate = __webpack_require__(125),
	    baseLodash = __webpack_require__(180);
	
	/**
	 * The base constructor for creating `lodash` wrapper objects.
	 *
	 * @private
	 * @param {*} value The value to wrap.
	 * @param {boolean} [chainAll] Enable explicit method chain sequences.
	 */
	function LodashWrapper(value, chainAll) {
	  this.__wrapped__ = value;
	  this.__actions__ = [];
	  this.__chain__ = !!chainAll;
	  this.__index__ = 0;
	  this.__values__ = undefined;
	}
	
	LodashWrapper.prototype = baseCreate(baseLodash.prototype);
	LodashWrapper.prototype.constructor = LodashWrapper;
	
	module.exports = LodashWrapper;


/***/ },
/* 253 */
/***/ function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(83),
	    root = __webpack_require__(24);
	
	/* Built-in method references that are verified to be native. */
	var Map = getNative(root, 'Map');
	
	module.exports = Map;


/***/ },
/* 254 */
/***/ function(module, exports, __webpack_require__) {

	var root = __webpack_require__(24);
	
	/** Built-in value references. */
	var Uint8Array = root.Uint8Array;
	
	module.exports = Uint8Array;


/***/ },
/* 255 */
/***/ function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(83),
	    root = __webpack_require__(24);
	
	/* Built-in method references that are verified to be native. */
	var WeakMap = getNative(root, 'WeakMap');
	
	module.exports = WeakMap;


/***/ },
/* 256 */
/***/ function(module, exports) {

	/**
	 * A specialized version of `_.forEach` for arrays without support for
	 * iteratee shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns `array`.
	 */
	function arrayEach(array, iteratee) {
	  var index = -1,
	      length = array ? array.length : 0;
	
	  while (++index < length) {
	    if (iteratee(array[index], index, array) === false) {
	      break;
	    }
	  }
	  return array;
	}
	
	module.exports = arrayEach;


/***/ },
/* 257 */
/***/ function(module, exports, __webpack_require__) {

	var castPath = __webpack_require__(262),
	    isKey = __webpack_require__(130),
	    toKey = __webpack_require__(133);
	
	/**
	 * The base implementation of `_.get` without support for default values.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path of the property to get.
	 * @returns {*} Returns the resolved value.
	 */
	function baseGet(object, path) {
	  path = isKey(path, object) ? [path] : castPath(path);
	
	  var index = 0,
	      length = path.length;
	
	  while (object != null && index < length) {
	    object = object[toKey(path[index++])];
	  }
	  return (index && index == length) ? object : undefined;
	}
	
	module.exports = baseGet;


/***/ },
/* 258 */
/***/ function(module, exports, __webpack_require__) {

	var getPrototype = __webpack_require__(269);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * The base implementation of `_.has` without support for deep paths.
	 *
	 * @private
	 * @param {Object} [object] The object to query.
	 * @param {Array|string} key The key to check.
	 * @returns {boolean} Returns `true` if `key` exists, else `false`.
	 */
	function baseHas(object, key) {
	  // Avoid a bug in IE 10-11 where objects with a [[Prototype]] of `null`,
	  // that are composed entirely of index properties, return `false` for
	  // `hasOwnProperty` checks of them.
	  return object != null &&
	    (hasOwnProperty.call(object, key) ||
	      (typeof object == 'object' && key in object && getPrototype(object) === null));
	}
	
	module.exports = baseHas;


/***/ },
/* 259 */
/***/ function(module, exports, __webpack_require__) {

	var baseIsEqualDeep = __webpack_require__(578),
	    isObject = __webpack_require__(39),
	    isObjectLike = __webpack_require__(73);
	
	/**
	 * The base implementation of `_.isEqual` which supports partial comparisons
	 * and tracks traversed objects.
	 *
	 * @private
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @param {Function} [customizer] The function to customize comparisons.
	 * @param {boolean} [bitmask] The bitmask of comparison flags.
	 *  The bitmask may be composed of the following flags:
	 *     1 - Unordered comparison
	 *     2 - Partial comparison
	 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
	 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	 */
	function baseIsEqual(value, other, customizer, bitmask, stack) {
	  if (value === other) {
	    return true;
	  }
	  if (value == null || other == null || (!isObject(value) && !isObjectLike(other))) {
	    return value !== value && other !== other;
	  }
	  return baseIsEqualDeep(value, other, baseIsEqual, customizer, bitmask, stack);
	}
	
	module.exports = baseIsEqual;


/***/ },
/* 260 */
/***/ function(module, exports) {

	/**
	 * The base implementation of `_.property` without support for deep paths.
	 *
	 * @private
	 * @param {string} key The key of the property to get.
	 * @returns {Function} Returns the new accessor function.
	 */
	function baseProperty(key) {
	  return function(object) {
	    return object == null ? undefined : object[key];
	  };
	}
	
	module.exports = baseProperty;


/***/ },
/* 261 */
/***/ function(module, exports, __webpack_require__) {

	var identity = __webpack_require__(283),
	    metaMap = __webpack_require__(275);
	
	/**
	 * The base implementation of `setData` without support for hot loop detection.
	 *
	 * @private
	 * @param {Function} func The function to associate metadata with.
	 * @param {*} data The metadata.
	 * @returns {Function} Returns `func`.
	 */
	var baseSetData = !metaMap ? identity : function(func, data) {
	  metaMap.set(func, data);
	  return func;
	};
	
	module.exports = baseSetData;


/***/ },
/* 262 */
/***/ function(module, exports, __webpack_require__) {

	var isArray = __webpack_require__(17),
	    stringToPath = __webpack_require__(655);
	
	/**
	 * Casts `value` to a path array if it's not one.
	 *
	 * @private
	 * @param {*} value The value to inspect.
	 * @returns {Array} Returns the cast property path array.
	 */
	function castPath(value) {
	  return isArray(value) ? value : stringToPath(value);
	}
	
	module.exports = castPath;


/***/ },
/* 263 */
/***/ function(module, exports) {

	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeMax = Math.max;
	
	/**
	 * Creates an array that is the composition of partially applied arguments,
	 * placeholders, and provided arguments into a single array of arguments.
	 *
	 * @private
	 * @param {Array} args The provided arguments.
	 * @param {Array} partials The arguments to prepend to those provided.
	 * @param {Array} holders The `partials` placeholder indexes.
	 * @params {boolean} [isCurried] Specify composing for a curried function.
	 * @returns {Array} Returns the new array of composed arguments.
	 */
	function composeArgs(args, partials, holders, isCurried) {
	  var argsIndex = -1,
	      argsLength = args.length,
	      holdersLength = holders.length,
	      leftIndex = -1,
	      leftLength = partials.length,
	      rangeLength = nativeMax(argsLength - holdersLength, 0),
	      result = Array(leftLength + rangeLength),
	      isUncurried = !isCurried;
	
	  while (++leftIndex < leftLength) {
	    result[leftIndex] = partials[leftIndex];
	  }
	  while (++argsIndex < holdersLength) {
	    if (isUncurried || argsIndex < argsLength) {
	      result[holders[argsIndex]] = args[argsIndex];
	    }
	  }
	  while (rangeLength--) {
	    result[leftIndex++] = args[argsIndex++];
	  }
	  return result;
	}
	
	module.exports = composeArgs;


/***/ },
/* 264 */
/***/ function(module, exports) {

	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeMax = Math.max;
	
	/**
	 * This function is like `composeArgs` except that the arguments composition
	 * is tailored for `_.partialRight`.
	 *
	 * @private
	 * @param {Array} args The provided arguments.
	 * @param {Array} partials The arguments to append to those provided.
	 * @param {Array} holders The `partials` placeholder indexes.
	 * @params {boolean} [isCurried] Specify composing for a curried function.
	 * @returns {Array} Returns the new array of composed arguments.
	 */
	function composeArgsRight(args, partials, holders, isCurried) {
	  var argsIndex = -1,
	      argsLength = args.length,
	      holdersIndex = -1,
	      holdersLength = holders.length,
	      rightIndex = -1,
	      rightLength = partials.length,
	      rangeLength = nativeMax(argsLength - holdersLength, 0),
	      result = Array(rangeLength + rightLength),
	      isUncurried = !isCurried;
	
	  while (++argsIndex < rangeLength) {
	    result[argsIndex] = args[argsIndex];
	  }
	  var offset = argsIndex;
	  while (++rightIndex < rightLength) {
	    result[offset + rightIndex] = partials[rightIndex];
	  }
	  while (++holdersIndex < holdersLength) {
	    if (isUncurried || argsIndex < argsLength) {
	      result[offset + holders[holdersIndex]] = args[argsIndex++];
	    }
	  }
	  return result;
	}
	
	module.exports = composeArgsRight;


/***/ },
/* 265 */
/***/ function(module, exports, __webpack_require__) {

	var composeArgs = __webpack_require__(263),
	    composeArgsRight = __webpack_require__(264),
	    countHolders = __webpack_require__(602),
	    createCtorWrapper = __webpack_require__(128),
	    createRecurryWrapper = __webpack_require__(266),
	    getHolder = __webpack_require__(184),
	    reorder = __webpack_require__(646),
	    replaceHolders = __webpack_require__(132),
	    root = __webpack_require__(24);
	
	/** Used to compose bitmasks for wrapper metadata. */
	var BIND_FLAG = 1,
	    BIND_KEY_FLAG = 2,
	    CURRY_FLAG = 8,
	    CURRY_RIGHT_FLAG = 16,
	    ARY_FLAG = 128,
	    FLIP_FLAG = 512;
	
	/**
	 * Creates a function that wraps `func` to invoke it with optional `this`
	 * binding of `thisArg`, partial application, and currying.
	 *
	 * @private
	 * @param {Function|string} func The function or method name to wrap.
	 * @param {number} bitmask The bitmask of wrapper flags. See `createWrapper`
	 *  for more details.
	 * @param {*} [thisArg] The `this` binding of `func`.
	 * @param {Array} [partials] The arguments to prepend to those provided to
	 *  the new function.
	 * @param {Array} [holders] The `partials` placeholder indexes.
	 * @param {Array} [partialsRight] The arguments to append to those provided
	 *  to the new function.
	 * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
	 * @param {Array} [argPos] The argument positions of the new function.
	 * @param {number} [ary] The arity cap of `func`.
	 * @param {number} [arity] The arity of `func`.
	 * @returns {Function} Returns the new wrapped function.
	 */
	function createHybridWrapper(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
	  var isAry = bitmask & ARY_FLAG,
	      isBind = bitmask & BIND_FLAG,
	      isBindKey = bitmask & BIND_KEY_FLAG,
	      isCurried = bitmask & (CURRY_FLAG | CURRY_RIGHT_FLAG),
	      isFlip = bitmask & FLIP_FLAG,
	      Ctor = isBindKey ? undefined : createCtorWrapper(func);
	
	  function wrapper() {
	    var length = arguments.length,
	        args = Array(length),
	        index = length;
	
	    while (index--) {
	      args[index] = arguments[index];
	    }
	    if (isCurried) {
	      var placeholder = getHolder(wrapper),
	          holdersCount = countHolders(args, placeholder);
	    }
	    if (partials) {
	      args = composeArgs(args, partials, holders, isCurried);
	    }
	    if (partialsRight) {
	      args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
	    }
	    length -= holdersCount;
	    if (isCurried && length < arity) {
	      var newHolders = replaceHolders(args, placeholder);
	      return createRecurryWrapper(
	        func, bitmask, createHybridWrapper, wrapper.placeholder, thisArg,
	        args, newHolders, argPos, ary, arity - length
	      );
	    }
	    var thisBinding = isBind ? thisArg : this,
	        fn = isBindKey ? thisBinding[func] : func;
	
	    length = args.length;
	    if (argPos) {
	      args = reorder(args, argPos);
	    } else if (isFlip && length > 1) {
	      args.reverse();
	    }
	    if (isAry && ary < length) {
	      args.length = ary;
	    }
	    if (this && this !== root && this instanceof wrapper) {
	      fn = Ctor || createCtorWrapper(fn);
	    }
	    return fn.apply(thisBinding, args);
	  }
	  return wrapper;
	}
	
	module.exports = createHybridWrapper;


/***/ },
/* 266 */
/***/ function(module, exports, __webpack_require__) {

	var isLaziable = __webpack_require__(630),
	    setData = __webpack_require__(276);
	
	/** Used to compose bitmasks for wrapper metadata. */
	var BIND_FLAG = 1,
	    BIND_KEY_FLAG = 2,
	    CURRY_BOUND_FLAG = 4,
	    CURRY_FLAG = 8,
	    PARTIAL_FLAG = 32,
	    PARTIAL_RIGHT_FLAG = 64;
	
	/**
	 * Creates a function that wraps `func` to continue currying.
	 *
	 * @private
	 * @param {Function} func The function to wrap.
	 * @param {number} bitmask The bitmask of wrapper flags. See `createWrapper`
	 *  for more details.
	 * @param {Function} wrapFunc The function to create the `func` wrapper.
	 * @param {*} placeholder The placeholder value.
	 * @param {*} [thisArg] The `this` binding of `func`.
	 * @param {Array} [partials] The arguments to prepend to those provided to
	 *  the new function.
	 * @param {Array} [holders] The `partials` placeholder indexes.
	 * @param {Array} [argPos] The argument positions of the new function.
	 * @param {number} [ary] The arity cap of `func`.
	 * @param {number} [arity] The arity of `func`.
	 * @returns {Function} Returns the new wrapped function.
	 */
	function createRecurryWrapper(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
	  var isCurry = bitmask & CURRY_FLAG,
	      newHolders = isCurry ? holders : undefined,
	      newHoldersRight = isCurry ? undefined : holders,
	      newPartials = isCurry ? partials : undefined,
	      newPartialsRight = isCurry ? undefined : partials;
	
	  bitmask |= (isCurry ? PARTIAL_FLAG : PARTIAL_RIGHT_FLAG);
	  bitmask &= ~(isCurry ? PARTIAL_RIGHT_FLAG : PARTIAL_FLAG);
	
	  if (!(bitmask & CURRY_BOUND_FLAG)) {
	    bitmask &= ~(BIND_FLAG | BIND_KEY_FLAG);
	  }
	  var newData = [
	    func, bitmask, thisArg, newPartials, newHolders, newPartialsRight,
	    newHoldersRight, argPos, ary, arity
	  ];
	
	  var result = wrapFunc.apply(undefined, newData);
	  if (isLaziable(func)) {
	    setData(result, newData);
	  }
	  result.placeholder = placeholder;
	  return result;
	}
	
	module.exports = createRecurryWrapper;


/***/ },
/* 267 */
/***/ function(module, exports, __webpack_require__) {

	var SetCache = __webpack_require__(563),
	    arraySome = __webpack_require__(569);
	
	/** Used to compose bitmasks for comparison styles. */
	var UNORDERED_COMPARE_FLAG = 1,
	    PARTIAL_COMPARE_FLAG = 2;
	
	/**
	 * A specialized version of `baseIsEqualDeep` for arrays with support for
	 * partial deep comparisons.
	 *
	 * @private
	 * @param {Array} array The array to compare.
	 * @param {Array} other The other array to compare.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Function} customizer The function to customize comparisons.
	 * @param {number} bitmask The bitmask of comparison flags. See `baseIsEqual`
	 *  for more details.
	 * @param {Object} stack Tracks traversed `array` and `other` objects.
	 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
	 */
	function equalArrays(array, other, equalFunc, customizer, bitmask, stack) {
	  var isPartial = bitmask & PARTIAL_COMPARE_FLAG,
	      arrLength = array.length,
	      othLength = other.length;
	
	  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
	    return false;
	  }
	  // Assume cyclic values are equal.
	  var stacked = stack.get(array);
	  if (stacked) {
	    return stacked == other;
	  }
	  var index = -1,
	      result = true,
	      seen = (bitmask & UNORDERED_COMPARE_FLAG) ? new SetCache : undefined;
	
	  stack.set(array, other);
	
	  // Ignore non-index properties.
	  while (++index < arrLength) {
	    var arrValue = array[index],
	        othValue = other[index];
	
	    if (customizer) {
	      var compared = isPartial
	        ? customizer(othValue, arrValue, index, other, array, stack)
	        : customizer(arrValue, othValue, index, array, other, stack);
	    }
	    if (compared !== undefined) {
	      if (compared) {
	        continue;
	      }
	      result = false;
	      break;
	    }
	    // Recursively compare arrays (susceptible to call stack limits).
	    if (seen) {
	      if (!arraySome(other, function(othValue, othIndex) {
	            if (!seen.has(othIndex) &&
	                (arrValue === othValue || equalFunc(arrValue, othValue, customizer, bitmask, stack))) {
	              return seen.add(othIndex);
	            }
	          })) {
	        result = false;
	        break;
	      }
	    } else if (!(
	          arrValue === othValue ||
	            equalFunc(arrValue, othValue, customizer, bitmask, stack)
	        )) {
	      result = false;
	      break;
	    }
	  }
	  stack['delete'](array);
	  return result;
	}
	
	module.exports = equalArrays;


/***/ },
/* 268 */
/***/ function(module, exports, __webpack_require__) {

	var metaMap = __webpack_require__(275),
	    noop = __webpack_require__(669);
	
	/**
	 * Gets metadata for `func`.
	 *
	 * @private
	 * @param {Function} func The function to query.
	 * @returns {*} Returns the metadata for `func`.
	 */
	var getData = !metaMap ? noop : function(func) {
	  return metaMap.get(func);
	};
	
	module.exports = getData;


/***/ },
/* 269 */
/***/ function(module, exports) {

	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeGetPrototype = Object.getPrototypeOf;
	
	/**
	 * Gets the `[[Prototype]]` of `value`.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {null|Object} Returns the `[[Prototype]]`.
	 */
	function getPrototype(value) {
	  return nativeGetPrototype(Object(value));
	}
	
	module.exports = getPrototype;


/***/ },
/* 270 */
/***/ function(module, exports, __webpack_require__) {

	var stubArray = __webpack_require__(672);
	
	/** Built-in value references. */
	var getOwnPropertySymbols = Object.getOwnPropertySymbols;
	
	/**
	 * Creates an array of the own enumerable symbol properties of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of symbols.
	 */
	function getSymbols(object) {
	  // Coerce `object` to an object to avoid non-object errors in V8.
	  // See https://bugs.chromium.org/p/v8/issues/detail?id=3443 for more details.
	  return getOwnPropertySymbols(Object(object));
	}
	
	// Fallback for IE < 11.
	if (!getOwnPropertySymbols) {
	  getSymbols = stubArray;
	}
	
	module.exports = getSymbols;


/***/ },
/* 271 */
/***/ function(module, exports, __webpack_require__) {

	var baseTimes = __webpack_require__(589),
	    isArguments = __webpack_require__(187),
	    isArray = __webpack_require__(17),
	    isLength = __webpack_require__(136),
	    isString = __webpack_require__(189);
	
	/**
	 * Creates an array of index keys for `object` values of arrays,
	 * `arguments` objects, and strings, otherwise `null` is returned.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array|null} Returns index keys, else `null`.
	 */
	function indexKeys(object) {
	  var length = object ? object.length : undefined;
	  if (isLength(length) &&
	      (isArray(object) || isString(object) || isArguments(object))) {
	    return baseTimes(length, String);
	  }
	  return null;
	}
	
	module.exports = indexKeys;


/***/ },
/* 272 */
/***/ function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(39);
	
	/**
	 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` if suitable for strict
	 *  equality comparisons, else `false`.
	 */
	function isStrictComparable(value) {
	  return value === value && !isObject(value);
	}
	
	module.exports = isStrictComparable;


/***/ },
/* 273 */
/***/ function(module, exports) {

	/**
	 * Converts `map` to its key-value pairs.
	 *
	 * @private
	 * @param {Object} map The map to convert.
	 * @returns {Array} Returns the key-value pairs.
	 */
	function mapToArray(map) {
	  var index = -1,
	      result = Array(map.size);
	
	  map.forEach(function(value, key) {
	    result[++index] = [key, value];
	  });
	  return result;
	}
	
	module.exports = mapToArray;


/***/ },
/* 274 */
/***/ function(module, exports) {

	/**
	 * A specialized version of `matchesProperty` for source values suitable
	 * for strict equality comparisons, i.e. `===`.
	 *
	 * @private
	 * @param {string} key The key of the property to get.
	 * @param {*} srcValue The value to match.
	 * @returns {Function} Returns the new spec function.
	 */
	function matchesStrictComparable(key, srcValue) {
	  return function(object) {
	    if (object == null) {
	      return false;
	    }
	    return object[key] === srcValue &&
	      (srcValue !== undefined || (key in Object(object)));
	  };
	}
	
	module.exports = matchesStrictComparable;


/***/ },
/* 275 */
/***/ function(module, exports, __webpack_require__) {

	var WeakMap = __webpack_require__(255);
	
	/** Used to store function metadata. */
	var metaMap = WeakMap && new WeakMap;
	
	module.exports = metaMap;


/***/ },
/* 276 */
/***/ function(module, exports, __webpack_require__) {

	var baseSetData = __webpack_require__(261),
	    now = __webpack_require__(287);
	
	/** Used to detect hot functions by number of calls within a span of milliseconds. */
	var HOT_COUNT = 150,
	    HOT_SPAN = 16;
	
	/**
	 * Sets metadata for `func`.
	 *
	 * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
	 * period of time, it will trip its breaker and transition to an identity
	 * function to avoid garbage collection pauses in V8. See
	 * [V8 issue 2070](https://bugs.chromium.org/p/v8/issues/detail?id=2070)
	 * for more details.
	 *
	 * @private
	 * @param {Function} func The function to associate metadata with.
	 * @param {*} data The metadata.
	 * @returns {Function} Returns `func`.
	 */
	var setData = (function() {
	  var count = 0,
	      lastCalled = 0;
	
	  return function(key, value) {
	    var stamp = now(),
	        remaining = HOT_SPAN - (stamp - lastCalled);
	
	    lastCalled = stamp;
	    if (remaining > 0) {
	      if (++count >= HOT_COUNT) {
	        return key;
	      }
	    } else {
	      count = 0;
	    }
	    return baseSetData(key, value);
	  };
	}());
	
	module.exports = setData;


/***/ },
/* 277 */
/***/ function(module, exports) {

	/**
	 * Converts `set` to an array of its values.
	 *
	 * @private
	 * @param {Object} set The set to convert.
	 * @returns {Array} Returns the values.
	 */
	function setToArray(set) {
	  var index = -1,
	      result = Array(set.size);
	
	  set.forEach(function(value) {
	    result[++index] = value;
	  });
	  return result;
	}
	
	module.exports = setToArray;


/***/ },
/* 278 */
/***/ function(module, exports) {

	/** Used to resolve the decompiled source of functions. */
	var funcToString = Function.prototype.toString;
	
	/**
	 * Converts `func` to its source code.
	 *
	 * @private
	 * @param {Function} func The function to process.
	 * @returns {string} Returns the source code.
	 */
	function toSource(func) {
	  if (func != null) {
	    try {
	      return funcToString.call(func);
	    } catch (e) {}
	    try {
	      return (func + '');
	    } catch (e) {}
	  }
	  return '';
	}
	
	module.exports = toSource;


/***/ },
/* 279 */
/***/ function(module, exports, __webpack_require__) {

	var assignValue = __webpack_require__(123),
	    copyObject = __webpack_require__(94),
	    createAssigner = __webpack_require__(183),
	    isArrayLike = __webpack_require__(60),
	    isPrototype = __webpack_require__(96),
	    keys = __webpack_require__(40);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/** Built-in value references. */
	var propertyIsEnumerable = objectProto.propertyIsEnumerable;
	
	/** Detect if properties shadowing those on `Object.prototype` are non-enumerable. */
	var nonEnumShadows = !propertyIsEnumerable.call({ 'valueOf': 1 }, 'valueOf');
	
	/**
	 * Assigns own enumerable string keyed properties of source objects to the
	 * destination object. Source objects are applied from left to right.
	 * Subsequent sources overwrite property assignments of previous sources.
	 *
	 * **Note:** This method mutates `object` and is loosely based on
	 * [`Object.assign`](https://mdn.io/Object/assign).
	 *
	 * @static
	 * @memberOf _
	 * @since 0.10.0
	 * @category Object
	 * @param {Object} object The destination object.
	 * @param {...Object} [sources] The source objects.
	 * @returns {Object} Returns `object`.
	 * @see _.assignIn
	 * @example
	 *
	 * function Foo() {
	 *   this.c = 3;
	 * }
	 *
	 * function Bar() {
	 *   this.e = 5;
	 * }
	 *
	 * Foo.prototype.d = 4;
	 * Bar.prototype.f = 6;
	 *
	 * _.assign({ 'a': 1 }, new Foo, new Bar);
	 * // => { 'a': 1, 'c': 3, 'e': 5 }
	 */
	var assign = createAssigner(function(object, source) {
	  if (nonEnumShadows || isPrototype(source) || isArrayLike(source)) {
	    copyObject(source, keys(source), object);
	    return;
	  }
	  for (var key in source) {
	    if (hasOwnProperty.call(source, key)) {
	      assignValue(object, key, source[key]);
	    }
	  }
	});
	
	module.exports = assign;


/***/ },
/* 280 */
/***/ function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(39),
	    now = __webpack_require__(287),
	    toNumber = __webpack_require__(291);
	
	/** Used as the `TypeError` message for "Functions" methods. */
	var FUNC_ERROR_TEXT = 'Expected a function';
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeMax = Math.max,
	    nativeMin = Math.min;
	
	/**
	 * Creates a debounced function that delays invoking `func` until after `wait`
	 * milliseconds have elapsed since the last time the debounced function was
	 * invoked. The debounced function comes with a `cancel` method to cancel
	 * delayed `func` invocations and a `flush` method to immediately invoke them.
	 * Provide an options object to indicate whether `func` should be invoked on
	 * the leading and/or trailing edge of the `wait` timeout. The `func` is invoked
	 * with the last arguments provided to the debounced function. Subsequent calls
	 * to the debounced function return the result of the last `func` invocation.
	 *
	 * **Note:** If `leading` and `trailing` options are `true`, `func` is invoked
	 * on the trailing edge of the timeout only if the debounced function is
	 * invoked more than once during the `wait` timeout.
	 *
	 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
	 * for details over the differences between `_.debounce` and `_.throttle`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Function
	 * @param {Function} func The function to debounce.
	 * @param {number} [wait=0] The number of milliseconds to delay.
	 * @param {Object} [options={}] The options object.
	 * @param {boolean} [options.leading=false]
	 *  Specify invoking on the leading edge of the timeout.
	 * @param {number} [options.maxWait]
	 *  The maximum time `func` is allowed to be delayed before it's invoked.
	 * @param {boolean} [options.trailing=true]
	 *  Specify invoking on the trailing edge of the timeout.
	 * @returns {Function} Returns the new debounced function.
	 * @example
	 *
	 * // Avoid costly calculations while the window size is in flux.
	 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
	 *
	 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
	 * jQuery(element).on('click', _.debounce(sendMail, 300, {
	 *   'leading': true,
	 *   'trailing': false
	 * }));
	 *
	 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
	 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
	 * var source = new EventSource('/stream');
	 * jQuery(source).on('message', debounced);
	 *
	 * // Cancel the trailing debounced invocation.
	 * jQuery(window).on('popstate', debounced.cancel);
	 */
	function debounce(func, wait, options) {
	  var lastArgs,
	      lastThis,
	      maxWait,
	      result,
	      timerId,
	      lastCallTime,
	      lastInvokeTime = 0,
	      leading = false,
	      maxing = false,
	      trailing = true;
	
	  if (typeof func != 'function') {
	    throw new TypeError(FUNC_ERROR_TEXT);
	  }
	  wait = toNumber(wait) || 0;
	  if (isObject(options)) {
	    leading = !!options.leading;
	    maxing = 'maxWait' in options;
	    maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
	    trailing = 'trailing' in options ? !!options.trailing : trailing;
	  }
	
	  function invokeFunc(time) {
	    var args = lastArgs,
	        thisArg = lastThis;
	
	    lastArgs = lastThis = undefined;
	    lastInvokeTime = time;
	    result = func.apply(thisArg, args);
	    return result;
	  }
	
	  function leadingEdge(time) {
	    // Reset any `maxWait` timer.
	    lastInvokeTime = time;
	    // Start the timer for the trailing edge.
	    timerId = setTimeout(timerExpired, wait);
	    // Invoke the leading edge.
	    return leading ? invokeFunc(time) : result;
	  }
	
	  function remainingWait(time) {
	    var timeSinceLastCall = time - lastCallTime,
	        timeSinceLastInvoke = time - lastInvokeTime,
	        result = wait - timeSinceLastCall;
	
	    return maxing ? nativeMin(result, maxWait - timeSinceLastInvoke) : result;
	  }
	
	  function shouldInvoke(time) {
	    var timeSinceLastCall = time - lastCallTime,
	        timeSinceLastInvoke = time - lastInvokeTime;
	
	    // Either this is the first call, activity has stopped and we're at the
	    // trailing edge, the system time has gone backwards and we're treating
	    // it as the trailing edge, or we've hit the `maxWait` limit.
	    return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
	      (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
	  }
	
	  function timerExpired() {
	    var time = now();
	    if (shouldInvoke(time)) {
	      return trailingEdge(time);
	    }
	    // Restart the timer.
	    timerId = setTimeout(timerExpired, remainingWait(time));
	  }
	
	  function trailingEdge(time) {
	    timerId = undefined;
	
	    // Only invoke if we have `lastArgs` which means `func` has been
	    // debounced at least once.
	    if (trailing && lastArgs) {
	      return invokeFunc(time);
	    }
	    lastArgs = lastThis = undefined;
	    return result;
	  }
	
	  function cancel() {
	    lastInvokeTime = 0;
	    lastArgs = lastCallTime = lastThis = timerId = undefined;
	  }
	
	  function flush() {
	    return timerId === undefined ? result : trailingEdge(now());
	  }
	
	  function debounced() {
	    var time = now(),
	        isInvoking = shouldInvoke(time);
	
	    lastArgs = arguments;
	    lastThis = this;
	    lastCallTime = time;
	
	    if (isInvoking) {
	      if (timerId === undefined) {
	        return leadingEdge(lastCallTime);
	      }
	      if (maxing) {
	        // Handle invocations in a tight loop.
	        timerId = setTimeout(timerExpired, wait);
	        return invokeFunc(lastCallTime);
	      }
	    }
	    if (timerId === undefined) {
	      timerId = setTimeout(timerExpired, wait);
	    }
	    return result;
	  }
	  debounced.cancel = cancel;
	  debounced.flush = flush;
	  return debounced;
	}
	
	module.exports = debounce;


/***/ },
/* 281 */
/***/ function(module, exports, __webpack_require__) {

	var apply = __webpack_require__(121),
	    assignInDefaults = __webpack_require__(570),
	    assignInWith = __webpack_require__(658),
	    rest = __webpack_require__(190);
	
	/**
	 * Assigns own and inherited enumerable string keyed properties of source
	 * objects to the destination object for all destination properties that
	 * resolve to `undefined`. Source objects are applied from left to right.
	 * Once a property is set, additional values of the same property are ignored.
	 *
	 * **Note:** This method mutates `object`.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The destination object.
	 * @param {...Object} [sources] The source objects.
	 * @returns {Object} Returns `object`.
	 * @see _.defaultsDeep
	 * @example
	 *
	 * _.defaults({ 'user': 'barney' }, { 'age': 36 }, { 'user': 'fred' });
	 * // => { 'user': 'barney', 'age': 36 }
	 */
	var defaults = rest(function(args) {
	  args.push(undefined, assignInDefaults);
	  return apply(assignInWith, undefined, args);
	});
	
	module.exports = defaults;


/***/ },
/* 282 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(657);


/***/ },
/* 283 */
/***/ function(module, exports) {

	/**
	 * This method returns the first argument given to it.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Util
	 * @param {*} value Any value.
	 * @returns {*} Returns `value`.
	 * @example
	 *
	 * var object = { 'user': 'fred' };
	 *
	 * console.log(_.identity(object) === object);
	 * // => true
	 */
	function identity(value) {
	  return value;
	}
	
	module.exports = identity;


/***/ },
/* 284 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var root = __webpack_require__(24),
	    stubFalse = __webpack_require__(673);
	
	/** Detect free variable `exports`. */
	var freeExports = typeof exports == 'object' && exports;
	
	/** Detect free variable `module`. */
	var freeModule = freeExports && typeof module == 'object' && module;
	
	/** Detect the popular CommonJS extension `module.exports`. */
	var moduleExports = freeModule && freeModule.exports === freeExports;
	
	/** Built-in value references. */
	var Buffer = moduleExports ? root.Buffer : undefined;
	
	/**
	 * Checks if `value` is a buffer.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.3.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
	 * @example
	 *
	 * _.isBuffer(new Buffer(2));
	 * // => true
	 *
	 * _.isBuffer(new Uint8Array(2));
	 * // => false
	 */
	var isBuffer = !Buffer ? stubFalse : function(value) {
	  return value instanceof Buffer;
	};
	
	module.exports = isBuffer;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(851)(module)))

/***/ },
/* 285 */
/***/ function(module, exports, __webpack_require__) {

	var baseKeysIn = __webpack_require__(582),
	    indexKeys = __webpack_require__(271),
	    isIndex = __webpack_require__(95),
	    isPrototype = __webpack_require__(96);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Creates an array of the own and inherited enumerable property names of `object`.
	 *
	 * **Note:** Non-object values are coerced to objects.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category Object
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.keysIn(new Foo);
	 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
	 */
	function keysIn(object) {
	  var index = -1,
	      isProto = isPrototype(object),
	      props = baseKeysIn(object),
	      propsLength = props.length,
	      indexes = indexKeys(object),
	      skipIndexes = !!indexes,
	      result = indexes || [],
	      length = result.length;
	
	  while (++index < propsLength) {
	    var key = props[index];
	    if (!(skipIndexes && (key == 'length' || isIndex(key, length))) &&
	        !(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	module.exports = keysIn;


/***/ },
/* 286 */
/***/ function(module, exports, __webpack_require__) {

	var arrayMap = __webpack_require__(567),
	    baseIteratee = __webpack_require__(127),
	    baseMap = __webpack_require__(583),
	    isArray = __webpack_require__(17);
	
	/**
	 * Creates an array of values by running each element in `collection` thru
	 * `iteratee`. The iteratee is invoked with three arguments:
	 * (value, index|key, collection).
	 *
	 * Many lodash methods are guarded to work as iteratees for methods like
	 * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
	 *
	 * The guarded methods are:
	 * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
	 * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
	 * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
	 * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Collection
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Array|Function|Object|string} [iteratee=_.identity]
	 *  The function invoked per iteration.
	 * @returns {Array} Returns the new mapped array.
	 * @example
	 *
	 * function square(n) {
	 *   return n * n;
	 * }
	 *
	 * _.map([4, 8], square);
	 * // => [16, 64]
	 *
	 * _.map({ 'a': 4, 'b': 8 }, square);
	 * // => [16, 64] (iteration order is not guaranteed)
	 *
	 * var users = [
	 *   { 'user': 'barney' },
	 *   { 'user': 'fred' }
	 * ];
	 *
	 * // The `_.property` iteratee shorthand.
	 * _.map(users, 'user');
	 * // => ['barney', 'fred']
	 */
	function map(collection, iteratee) {
	  var func = isArray(collection) ? arrayMap : baseMap;
	  return func(collection, baseIteratee(iteratee, 3));
	}
	
	module.exports = map;


/***/ },
/* 287 */
/***/ function(module, exports) {

	/**
	 * Gets the timestamp of the number of milliseconds that have elapsed since
	 * the Unix epoch (1 January 1970 00:00:00 UTC).
	 *
	 * @static
	 * @memberOf _
	 * @since 2.4.0
	 * @category Date
	 * @returns {number} Returns the timestamp.
	 * @example
	 *
	 * _.defer(function(stamp) {
	 *   console.log(_.now() - stamp);
	 * }, _.now());
	 * // => Logs the number of milliseconds it took for the deferred invocation.
	 */
	function now() {
	  return Date.now();
	}
	
	module.exports = now;


/***/ },
/* 288 */
/***/ function(module, exports, __webpack_require__) {

	var arrayReduce = __webpack_require__(122),
	    baseEach = __webpack_require__(126),
	    baseIteratee = __webpack_require__(127),
	    baseReduce = __webpack_require__(587),
	    isArray = __webpack_require__(17);
	
	/**
	 * Reduces `collection` to a value which is the accumulated result of running
	 * each element in `collection` thru `iteratee`, where each successive
	 * invocation is supplied the return value of the previous. If `accumulator`
	 * is not given, the first element of `collection` is used as the initial
	 * value. The iteratee is invoked with four arguments:
	 * (accumulator, value, index|key, collection).
	 *
	 * Many lodash methods are guarded to work as iteratees for methods like
	 * `_.reduce`, `_.reduceRight`, and `_.transform`.
	 *
	 * The guarded methods are:
	 * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
	 * and `sortBy`
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Collection
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	 * @param {*} [accumulator] The initial value.
	 * @returns {*} Returns the accumulated value.
	 * @see _.reduceRight
	 * @example
	 *
	 * _.reduce([1, 2], function(sum, n) {
	 *   return sum + n;
	 * }, 0);
	 * // => 3
	 *
	 * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
	 *   (result[value] || (result[value] = [])).push(key);
	 *   return result;
	 * }, {});
	 * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
	 */
	function reduce(collection, iteratee, accumulator) {
	  var func = isArray(collection) ? arrayReduce : baseReduce,
	      initAccum = arguments.length < 3;
	
	  return func(collection, baseIteratee(iteratee, 4), accumulator, initAccum, baseEach);
	}
	
	module.exports = reduce;


/***/ },
/* 289 */
/***/ function(module, exports, __webpack_require__) {

	var debounce = __webpack_require__(280),
	    isObject = __webpack_require__(39);
	
	/** Used as the `TypeError` message for "Functions" methods. */
	var FUNC_ERROR_TEXT = 'Expected a function';
	
	/**
	 * Creates a throttled function that only invokes `func` at most once per
	 * every `wait` milliseconds. The throttled function comes with a `cancel`
	 * method to cancel delayed `func` invocations and a `flush` method to
	 * immediately invoke them. Provide an options object to indicate whether
	 * `func` should be invoked on the leading and/or trailing edge of the `wait`
	 * timeout. The `func` is invoked with the last arguments provided to the
	 * throttled function. Subsequent calls to the throttled function return the
	 * result of the last `func` invocation.
	 *
	 * **Note:** If `leading` and `trailing` options are `true`, `func` is
	 * invoked on the trailing edge of the timeout only if the throttled function
	 * is invoked more than once during the `wait` timeout.
	 *
	 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
	 * for details over the differences between `_.throttle` and `_.debounce`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Function
	 * @param {Function} func The function to throttle.
	 * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
	 * @param {Object} [options={}] The options object.
	 * @param {boolean} [options.leading=true]
	 *  Specify invoking on the leading edge of the timeout.
	 * @param {boolean} [options.trailing=true]
	 *  Specify invoking on the trailing edge of the timeout.
	 * @returns {Function} Returns the new throttled function.
	 * @example
	 *
	 * // Avoid excessively updating the position while scrolling.
	 * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
	 *
	 * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
	 * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
	 * jQuery(element).on('click', throttled);
	 *
	 * // Cancel the trailing throttled invocation.
	 * jQuery(window).on('popstate', throttled.cancel);
	 */
	function throttle(func, wait, options) {
	  var leading = true,
	      trailing = true;
	
	  if (typeof func != 'function') {
	    throw new TypeError(FUNC_ERROR_TEXT);
	  }
	  if (isObject(options)) {
	    leading = 'leading' in options ? !!options.leading : leading;
	    trailing = 'trailing' in options ? !!options.trailing : trailing;
	  }
	  return debounce(func, wait, {
	    'leading': leading,
	    'maxWait': wait,
	    'trailing': trailing
	  });
	}
	
	module.exports = throttle;


/***/ },
/* 290 */
/***/ function(module, exports, __webpack_require__) {

	var toFinite = __webpack_require__(674);
	
	/**
	 * Converts `value` to an integer.
	 *
	 * **Note:** This method is loosely based on
	 * [`ToInteger`](http://www.ecma-international.org/ecma-262/6.0/#sec-tointeger).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to convert.
	 * @returns {number} Returns the converted integer.
	 * @example
	 *
	 * _.toInteger(3.2);
	 * // => 3
	 *
	 * _.toInteger(Number.MIN_VALUE);
	 * // => 0
	 *
	 * _.toInteger(Infinity);
	 * // => 1.7976931348623157e+308
	 *
	 * _.toInteger('3.2');
	 * // => 3
	 */
	function toInteger(value) {
	  var result = toFinite(value),
	      remainder = result % 1;
	
	  return result === result ? (remainder ? result - remainder : result) : 0;
	}
	
	module.exports = toInteger;


/***/ },
/* 291 */
/***/ function(module, exports, __webpack_require__) {

	var isFunction = __webpack_require__(135),
	    isObject = __webpack_require__(39),
	    isSymbol = __webpack_require__(137);
	
	/** Used as references for various `Number` constants. */
	var NAN = 0 / 0;
	
	/** Used to match leading and trailing whitespace. */
	var reTrim = /^\s+|\s+$/g;
	
	/** Used to detect bad signed hexadecimal string values. */
	var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
	
	/** Used to detect binary string values. */
	var reIsBinary = /^0b[01]+$/i;
	
	/** Used to detect octal string values. */
	var reIsOctal = /^0o[0-7]+$/i;
	
	/** Built-in method references without a dependency on `root`. */
	var freeParseInt = parseInt;
	
	/**
	 * Converts `value` to a number.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to process.
	 * @returns {number} Returns the number.
	 * @example
	 *
	 * _.toNumber(3.2);
	 * // => 3.2
	 *
	 * _.toNumber(Number.MIN_VALUE);
	 * // => 5e-324
	 *
	 * _.toNumber(Infinity);
	 * // => Infinity
	 *
	 * _.toNumber('3.2');
	 * // => 3.2
	 */
	function toNumber(value) {
	  if (typeof value == 'number') {
	    return value;
	  }
	  if (isSymbol(value)) {
	    return NAN;
	  }
	  if (isObject(value)) {
	    var other = isFunction(value.valueOf) ? value.valueOf() : value;
	    value = isObject(other) ? (other + '') : other;
	  }
	  if (typeof value != 'string') {
	    return value === 0 ? value : +value;
	  }
	  value = value.replace(reTrim, '');
	  var isBinary = reIsBinary.test(value);
	  return (isBinary || reIsOctal.test(value))
	    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
	    : (reIsBadHex.test(value) ? NAN : +value);
	}
	
	module.exports = toNumber;


/***/ },
/* 292 */
/***/ function(module, exports) {

	// shim for using process in browser
	
	var process = module.exports = {};
	
	// cached from whatever global is present so that test runners that stub it
	// don't break things.  But we need to wrap it in a try catch in case it is
	// wrapped in strict mode code which doesn't define any globals.  It's inside a
	// function because try/catches deoptimize in certain engines.
	
	var cachedSetTimeout;
	var cachedClearTimeout;
	
	(function () {
	  try {
	    cachedSetTimeout = setTimeout;
	  } catch (e) {
	    cachedSetTimeout = function () {
	      throw new Error('setTimeout is not defined');
	    }
	  }
	  try {
	    cachedClearTimeout = clearTimeout;
	  } catch (e) {
	    cachedClearTimeout = function () {
	      throw new Error('clearTimeout is not defined');
	    }
	  }
	} ())
	var queue = [];
	var draining = false;
	var currentQueue;
	var queueIndex = -1;
	
	function cleanUpNextTick() {
	    if (!draining || !currentQueue) {
	        return;
	    }
	    draining = false;
	    if (currentQueue.length) {
	        queue = currentQueue.concat(queue);
	    } else {
	        queueIndex = -1;
	    }
	    if (queue.length) {
	        drainQueue();
	    }
	}
	
	function drainQueue() {
	    if (draining) {
	        return;
	    }
	    var timeout = cachedSetTimeout(cleanUpNextTick);
	    draining = true;
	
	    var len = queue.length;
	    while(len) {
	        currentQueue = queue;
	        queue = [];
	        while (++queueIndex < len) {
	            if (currentQueue) {
	                currentQueue[queueIndex].run();
	            }
	        }
	        queueIndex = -1;
	        len = queue.length;
	    }
	    currentQueue = null;
	    draining = false;
	    cachedClearTimeout(timeout);
	}
	
	process.nextTick = function (fun) {
	    var args = new Array(arguments.length - 1);
	    if (arguments.length > 1) {
	        for (var i = 1; i < arguments.length; i++) {
	            args[i - 1] = arguments[i];
	        }
	    }
	    queue.push(new Item(fun, args));
	    if (queue.length === 1 && !draining) {
	        cachedSetTimeout(drainQueue, 0);
	    }
	};
	
	// v8 likes predictible objects
	function Item(fun, array) {
	    this.fun = fun;
	    this.array = array;
	}
	Item.prototype.run = function () {
	    this.fun.apply(null, this.array);
	};
	process.title = 'browser';
	process.browser = true;
	process.env = {};
	process.argv = [];
	process.version = ''; // empty string to avoid regexp issues
	process.versions = {};
	
	function noop() {}
	
	process.on = noop;
	process.addListener = noop;
	process.once = noop;
	process.off = noop;
	process.removeListener = noop;
	process.removeAllListeners = noop;
	process.emit = noop;
	
	process.binding = function (name) {
	    throw new Error('process.binding is not supported');
	};
	
	process.cwd = function () { return '/' };
	process.chdir = function (dir) {
	    throw new Error('process.chdir is not supported');
	};
	process.umask = function() { return 0; };


/***/ },
/* 293 */
/***/ function(module, exports, __webpack_require__) {

	/* REACT HOT LOADER */ if (false) { (function () { var ReactHotAPI = require("/Users/jnunez/git/medscapetv/node_modules/react-hot-api/modules/index.js"), RootInstanceProvider = require("/Users/jnunez/git/medscapetv/node_modules/react-hot-loader/RootInstanceProvider.js"), ReactMount = require("react/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {
	
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _reflux = __webpack_require__(54);
	
	var _reflux2 = _interopRequireDefault(_reflux);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Actions = _reflux2.default.createActions({
	  loadJSON: {}
	});
	
	exports.default = Actions;
	
	/* REACT HOT LOADER */ }).call(this); } finally { if (false) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("/Users/jnunez/git/medscapetv/node_modules/react-hot-loader/makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot apply hot update to " + "descriptor_actions.js" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }

/***/ },
/* 294 */
/***/ function(module, exports, __webpack_require__) {

	/* REACT HOT LOADER */ if (false) { (function () { var ReactHotAPI = require("/Users/jnunez/git/medscapetv/node_modules/react-hot-api/modules/index.js"), RootInstanceProvider = require("/Users/jnunez/git/medscapetv/node_modules/react-hot-loader/RootInstanceProvider.js"), ReactMount = require("react/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {
	
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _get2 = __webpack_require__(38);
	
	var _get3 = _interopRequireDefault(_get2);
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(30);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _tracking_actions = __webpack_require__(51);
	
	var _tracking_actions2 = _interopRequireDefault(_tracking_actions);
	
	var _has_slider_events = __webpack_require__(296);
	
	var _has_slider_events2 = _interopRequireDefault(_has_slider_events);
	
	var _has_percentage_width = __webpack_require__(295);
	
	var _has_percentage_width2 = _interopRequireDefault(_has_percentage_width);
	
	var _ios_video_set_current_time = __webpack_require__(704);
	
	var _ios_video_set_current_time2 = _interopRequireDefault(_ios_video_set_current_time);
	
	var _drag_bar = __webpack_require__(693);
	
	var _drag_bar2 = _interopRequireDefault(_drag_bar);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _react2.default.createClass({
	  displayName: 'Player.ProgressBar',
	  propTypes: {
	    currentTime: _react.PropTypes.number,
	    duration: _react.PropTypes.number,
	    isLoading: _react.PropTypes.bool,
	    isBuffering: _react.PropTypes.bool,
	    hasLength: _react.PropTypes.bool,
	    hasScrub: _react.PropTypes.bool,
	    hasProgress: _react.PropTypes.bool,
	    isFullScreen: _react.PropTypes.bool,
	    bufferredEnd: _react.PropTypes.number,
	    meta: _react.PropTypes.object
	  },
	  mixins: [_has_slider_events2.default, _has_percentage_width2.default, _ios_video_set_current_time2.default],
	  getDefaultProps: function getDefaultProps() {
	    return {
	      hasLength: true,
	      hasScrub: true,
	      hasProgress: true
	    };
	  },
	  getInitialState: function getInitialState() {
	    return {
	      isDragging: false
	    };
	  },
	  componentDidMount: function componentDidMount() {},
	  shouldComponentUpdate: function shouldComponentUpdate(nextProps) {
	    if (this.props.currentTime === nextProps.currentTime) {
	      return true;
	    }
	    if (this.props.bufferredEnd !== nextProps.bufferredEnd) {
	      return true;
	    }
	    if (nextProps.event === 'ready') {
	      return true;
	    }
	    if (typeof nextProps.currentTime === 'undefined') {
	      return false;
	    }
	    if (typeof nextProps.duration === 'undefined') {
	      return false;
	    }
	    if (nextProps.isBuffering !== this.props.isBuffering || nextProps.isLoading !== this.props.isLoading) {
	      return true;
	    }
	    var delta = nextProps.currentTime - this.props.currentTime;
	    return nextProps.duration !== this.props.duration || Math.abs(delta) > 0.005;
	  },
	  seek: function seek(e) {
	    if (!this.props.hasScrub || document.getElementById('tvPlayer').classList.contains('presistant-video')) {
	      return;
	    }
	    var seekTo = this.getSliderValueX(e, this.props.duration, this.props.isFullScreen, document.querySelector('.video-player-controls-wrap'));
	    _tracking_actions2.default.scrub();
	    if (this.seekTime !== seekTo) {
	      this.setCurrentTime(seekTo);
	    }
	    this.seekTime = seekTo;
	  },
	  dragStart: function dragStart(e) {
	    if (this.props.hasScrub && !document.getElementById('tvPlayer').classList.contains('presistant-video')) {
	      this.refs.dragBar.dragStart(e);
	    }
	  },
	  render: function render() {
	    var duration = this.props.duration,
	        currentTime = this.props.currentTime,
	        style = this.getStyle(currentTime, duration, this.props.isFullScreen),
	        loadedStyle = this.getStyle(this.props.bufferredEnd, duration, this.props.isFullScreen),
	        wrapStyle = (0, _classnames2.default)({
	      'video-player-progress-bar-wrap': true,
	      'grabbable': this.props.hasScrub,
	      'is-advertisement': (0, _get3.default)(this, 'props.meta.isAdvertisement', false)
	    });
	    // NB: the drag bar is just there to make the user feel
	    // good. seek happens when the mouseup bubbles to the outter div
	    var dragBar = void 0;
	    if (this.props.hasProgress) {
	      dragBar = _react2.default.createElement(_drag_bar2.default, { ref: 'dragBar',
	        className: 'video-player-elapsed-time-indicator',
	        hasScrub: this.props.hasScrub,
	        currentTime: this.props.currentTime,
	        duration: this.props.duration,
	        isFullScreen: this.props.isFullScreen,
	        style: style,
	        isDragging: this.state.isDragging,
	        onDragEnd: this.seek });
	    }
	    return _react2.default.createElement(
	      'div',
	      { className: wrapStyle,
	        onMouseUp: this.seek,
	        onTouchEnd: this.seek,
	        onMouseDown: this.dragStart,
	        onTouchStart: this.dragStart },
	      _react2.default.createElement('div', { className: 'video-player-loaded-bar', style: loadedStyle }),
	      dragBar
	    );
	  }
	});
	
	/* REACT HOT LOADER */ }).call(this); } finally { if (false) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("/Users/jnunez/git/medscapetv/node_modules/react-hot-loader/makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot apply hot update to " + "progress_bar.jsx" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }

/***/ },
/* 295 */
/***/ function(module, exports, __webpack_require__) {

	/* REACT HOT LOADER */ if (false) { (function () { var ReactHotAPI = require("/Users/jnunez/git/medscapetv/node_modules/react-hot-api/modules/index.js"), RootInstanceProvider = require("/Users/jnunez/git/medscapetv/node_modules/react-hot-loader/RootInstanceProvider.js"), ReactMount = require("react/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {
	
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  getStyle: function getStyle(elapsed, total, fullscreen) {
	    var percent = void 0;
	    if (fullscreen === true) {
	      percent = (elapsed / total * 100).toFixed(2);
	    } else {
	      percent = (elapsed / total * 100).toFixed(2);
	    }
	    if (isNaN(percent) || percent < 0) {
	      percent = 0;
	    } else if (percent > 100) {
	      percent = 100;
	    }
	    return {
	      width: percent + '%'
	    };
	  }
	};
	
	/* REACT HOT LOADER */ }).call(this); } finally { if (false) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("/Users/jnunez/git/medscapetv/node_modules/react-hot-loader/makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot apply hot update to " + "has_percentage_width.js" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }

/***/ },
/* 296 */
/***/ function(module, exports, __webpack_require__) {

	/* REACT HOT LOADER */ if (false) { (function () { var ReactHotAPI = require("/Users/jnunez/git/medscapetv/node_modules/react-hot-api/modules/index.js"), RootInstanceProvider = require("/Users/jnunez/git/medscapetv/node_modules/react-hot-loader/RootInstanceProvider.js"), ReactMount = require("react/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {
	
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _util = __webpack_require__(12);
	
	exports.default = {
	  getSliderValueX: function getSliderValueX(mouseEvent, totalValue, isFullScreen, sliderElement) {
	    var pageX = mouseEvent.nativeEvent ? mouseEvent.nativeEvent.pageX : mouseEvent.pageX;
	    if (isFullScreen === true) {
	      var offsetWidth = mouseEvent.currentTarget === document ? document.documentElement.offsetWidth : mouseEvent.currentTarget.offsetWidth,
	          mousePosition = pageX,
	          sliderPercent = mousePosition / offsetWidth;
	      return totalValue * sliderPercent;
	    } else {
	      var percentScrubbed = (pageX - (0, _util.getOffset)(sliderElement, document).left) / sliderElement.offsetWidth,
	          seekTo = percentScrubbed * totalValue;
	      return seekTo;
	    }
	  },
	  getSliderValueY: function getSliderValueY(mouseEvent, totalValue) {
	    var pageY = mouseEvent.nativeEvent ? mouseEvent.nativeEvent.pageY : mouseEvent.pageY,
	        mousePosition = pageY - this.findPos(mouseEvent.currentTarget)[1],
	        sliderPercent = mousePosition / mouseEvent.currentTarget.offsetHeight;
	    return totalValue - totalValue * sliderPercent;
	  },
	  findPos: function findPos(obj) {
	    if (obj === document) {
	      return [0, 0];
	    }
	    var curleft = 0;
	    var curtop = 0;
	    var object = obj;
	    if (obj.offsetParent) {
	      do {
	        curleft += object.offsetLeft;
	        curtop += object.offsetTop;
	      } while ((object = object.offsetParent) !== null);
	      return [curleft, curtop];
	    }
	  }
	}; /* eslint no-cond-assign: 0 */
	
	/* REACT HOT LOADER */ }).call(this); } finally { if (false) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("/Users/jnunez/git/medscapetv/node_modules/react-hot-loader/makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot apply hot update to " + "has_slider_events.js" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }

/***/ },
/* 297 */
/***/ function(module, exports, __webpack_require__) {

	/* REACT HOT LOADER */ if (false) { (function () { var ReactHotAPI = require("/Users/jnunez/git/medscapetv/node_modules/react-hot-api/modules/index.js"), RootInstanceProvider = require("/Users/jnunez/git/medscapetv/node_modules/react-hot-loader/RootInstanceProvider.js"), ReactMount = require("react/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {
	
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	exports.default = {
	  init: function init() {
	    this.state = this._getInitialState();
	  },
	  _getInitialState: function _getInitialState() {
	    if (this.getInitialState) return this.getInitialState();
	    if (this.initialState) return this.initialState;
	    return {};
	  },
	  resetState: function resetState() {
	    this.state = this.getInitialState();
	  },
	  setState: function setState(state) {
	    this.updateState({
	      $merge: state
	    });
	  },
	  updateState: function updateState(query) {
	    var update = __webpack_require__(682);
	    this.state = update(this.state, query);
	    Object.freeze(this.state);
	    if (this.stateNamespace) {
	      this.trigger(_defineProperty({}, this.stateNamespace, this.state));
	    } else {
	      this.trigger(this.state);
	    }
	  },
	  getState: function getState() {
	    return this.state;
	  }
	};
	
	/* REACT HOT LOADER */ }).call(this); } finally { if (false) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("/Users/jnunez/git/medscapetv/node_modules/react-hot-loader/makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot apply hot update to " + "store_state.js" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }

/***/ },
/* 298 */
/***/ function(module, exports, __webpack_require__) {

	/* REACT HOT LOADER */ if (false) { (function () { var ReactHotAPI = require("/Users/jnunez/git/medscapetv/node_modules/react-hot-api/modules/index.js"), RootInstanceProvider = require("/Users/jnunez/git/medscapetv/node_modules/react-hot-loader/RootInstanceProvider.js"), ReactMount = require("react/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {
	
	'use strict';
	
	var _util = __webpack_require__(12);
	
	var Animation = {
	  updateHeight: function updateHeight(wrapper, content, prevHeight) {
	    var shouldGrow = wrapper.offsetHeight < prevHeight;
	    wrapper.style.height = prevHeight + 'px';
	    var prev = null;
	    var applyChange = function applyChange(timestamp) {
	      var change = prev ? timestamp - prev : 1,
	          h = parseInt(wrapper.style.height, 10) + (shouldGrow ? -change : change);
	      prev = timestamp;
	      if (shouldGrow && h > content.offsetHeight || !shouldGrow && h < content.offsetHeight) {
	        wrapper.style.height = h + 'px';
	        document.getElementById('medscape-tver').style.opacity = document.getElementById('medscape-tver').style.opacity + 0.10;
	        requestAnimationFrame(applyChange);
	      } else {
	        document.getElementById('medscape-tver').style.opacity = 1;
	        wrapper.style.height = 'auto';
	      }
	    };
	    requestAnimationFrame(applyChange);
	  },
	  slideFadeIn: function slideFadeIn(element, elementContent) {
	    var start = null;
	    element.style.display = 'block';
	    elementContent.style.opacity = '0';
	    var widthModifier = 2;
	    if ((0, _util.isMobile)()) {
	      widthModifier = 1;
	    }
	    if ((0, _util.isIpad)()) {
	      widthModifier = 1.5;
	    }
	    function step(timestamp) {
	      if (!start) start = timestamp;
	      var progress = timestamp - start;
	      var width = Math.min(progress / 5, 2000);
	      width = width > 100 ? 100 : width;
	      elementContent.style.left = 100 - width / widthModifier + '%';
	      elementContent.style.opacity = width / 100;
	      if (width < 100) {
	        requestAnimationFrame(step);
	      }
	    }
	    requestAnimationFrame(step);
	  },
	  slideFadeOut: function slideFadeOut(element, elementContent) {
	    var start = null;
	    element.style.display = 'block';
	    element.style.opacity = '1';
	    var widthModifier = 2;
	    if ((0, _util.isMobile)()) {
	      widthModifier = 1;
	    }
	    if ((0, _util.isIpad)()) {
	      widthModifier = 1.5;
	    }
	    function step(timestamp) {
	      if (!start) start = timestamp;
	      var progress = timestamp - start;
	      var width = Math.min(progress / 5, 2000);
	      width = width > 100 ? 100 : width;
	      width = 100 - width;
	      elementContent.style.left = 100 - width / 2 + '%';
	      elementContent.style.opacity = width / widthModifier;
	      if (width > 0) {
	        requestAnimationFrame(step);
	      } else {
	        element.style.display = 'none';
	        elementContent.style.opacity = '0';
	      }
	    }
	    requestAnimationFrame(step);
	  }
	};
	module.exports = Animation;
	
	/* REACT HOT LOADER */ }).call(this); } finally { if (false) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("/Users/jnunez/git/medscapetv/node_modules/react-hot-loader/makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot apply hot update to " + "animation.js" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }

/***/ },
/* 299 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _invariant = __webpack_require__(23);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _PropTypes = __webpack_require__(194);
	
	var _ContextUtils = __webpack_require__(193);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var _React$PropTypes = _react2.default.PropTypes,
	    bool = _React$PropTypes.bool,
	    object = _React$PropTypes.object,
	    string = _React$PropTypes.string,
	    func = _React$PropTypes.func,
	    oneOfType = _React$PropTypes.oneOfType;
	
	
	function isLeftClickEvent(event) {
	  return event.button === 0;
	}
	
	function isModifiedEvent(event) {
	  return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
	}
	
	// TODO: De-duplicate against hasAnyProperties in createTransitionManager.
	function isEmptyObject(object) {
	  for (var p in object) {
	    if (Object.prototype.hasOwnProperty.call(object, p)) return false;
	  }return true;
	}
	
	function resolveToLocation(to, router) {
	  return typeof to === 'function' ? to(router.location) : to;
	}
	
	/**
	 * A <Link> is used to create an <a> element that links to a route.
	 * When that route is active, the link gets the value of its
	 * activeClassName prop.
	 *
	 * For example, assuming you have the following route:
	 *
	 *   <Route path="/posts/:postID" component={Post} />
	 *
	 * You could use the following component to link to that route:
	 *
	 *   <Link to={`/posts/${post.id}`} />
	 *
	 * Links may pass along location state and/or query string parameters
	 * in the state/query props, respectively.
	 *
	 *   <Link ... query={{ show: true }} state={{ the: 'state' }} />
	 */
	var Link = _react2.default.createClass({
	  displayName: 'Link',
	
	
	  mixins: [(0, _ContextUtils.ContextSubscriber)('router')],
	
	  contextTypes: {
	    router: _PropTypes.routerShape
	  },
	
	  propTypes: {
	    to: oneOfType([string, object, func]),
	    query: object,
	    hash: string,
	    state: object,
	    activeStyle: object,
	    activeClassName: string,
	    onlyActiveOnIndex: bool.isRequired,
	    onClick: func,
	    target: string
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      onlyActiveOnIndex: false,
	      style: {}
	    };
	  },
	  handleClick: function handleClick(event) {
	    if (this.props.onClick) this.props.onClick(event);
	
	    if (event.defaultPrevented) return;
	
	    var router = this.context.router;
	
	    !router ?  false ? (0, _invariant2.default)(false, '<Link>s rendered outside of a router context cannot navigate.') : (0, _invariant2.default)(false) : void 0;
	
	    if (isModifiedEvent(event) || !isLeftClickEvent(event)) return;
	
	    // If target prop is set (e.g. to "_blank"), let browser handle link.
	    /* istanbul ignore if: untestable with Karma */
	    if (this.props.target) return;
	
	    event.preventDefault();
	
	    router.push(resolveToLocation(this.props.to, router));
	  },
	  render: function render() {
	    var _props = this.props,
	        to = _props.to,
	        activeClassName = _props.activeClassName,
	        activeStyle = _props.activeStyle,
	        onlyActiveOnIndex = _props.onlyActiveOnIndex,
	        props = _objectWithoutProperties(_props, ['to', 'activeClassName', 'activeStyle', 'onlyActiveOnIndex']);
	
	    // Ignore if rendered outside the context of router to simplify unit testing.
	
	
	    var router = this.context.router;
	
	
	    if (router) {
	      // If user does not specify a `to` prop, return an empty anchor tag.
	      if (to == null) {
	        return _react2.default.createElement('a', props);
	      }
	
	      var toLocation = resolveToLocation(to, router);
	      props.href = router.createHref(toLocation);
	
	      if (activeClassName || activeStyle != null && !isEmptyObject(activeStyle)) {
	        if (router.isActive(toLocation, onlyActiveOnIndex)) {
	          if (activeClassName) {
	            if (props.className) {
	              props.className += ' ' + activeClassName;
	            } else {
	              props.className = activeClassName;
	            }
	          }
	
	          if (activeStyle) props.style = _extends({}, props.style, activeStyle);
	        }
	      }
	    }
	
	    return _react2.default.createElement('a', _extends({}, props, { onClick: this.handleClick }));
	  }
	});
	
	exports.default = Link;
	module.exports = exports['default'];

/***/ },
/* 300 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports.isPromise = isPromise;
	function isPromise(obj) {
	  return obj && typeof obj.then === 'function';
	}

/***/ },
/* 301 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _invariant = __webpack_require__(23);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _RouteUtils = __webpack_require__(61);
	
	var _PatternUtils = __webpack_require__(86);
	
	var _InternalPropTypes = __webpack_require__(98);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _React$PropTypes = _react2.default.PropTypes,
	    string = _React$PropTypes.string,
	    object = _React$PropTypes.object;
	
	/**
	 * A <Redirect> is used to declare another URL path a client should
	 * be sent to when they request a given URL.
	 *
	 * Redirects are placed alongside routes in the route configuration
	 * and are traversed in the same manner.
	 */
	/* eslint-disable react/require-render-return */
	
	var Redirect = _react2.default.createClass({
	  displayName: 'Redirect',
	
	
	  statics: {
	    createRouteFromReactElement: function createRouteFromReactElement(element) {
	      var route = (0, _RouteUtils.createRouteFromReactElement)(element);
	
	      if (route.from) route.path = route.from;
	
	      route.onEnter = function (nextState, replace) {
	        var location = nextState.location,
	            params = nextState.params;
	
	
	        var pathname = void 0;
	        if (route.to.charAt(0) === '/') {
	          pathname = (0, _PatternUtils.formatPattern)(route.to, params);
	        } else if (!route.to) {
	          pathname = location.pathname;
	        } else {
	          var routeIndex = nextState.routes.indexOf(route);
	          var parentPattern = Redirect.getRoutePattern(nextState.routes, routeIndex - 1);
	          var pattern = parentPattern.replace(/\/*$/, '/') + route.to;
	          pathname = (0, _PatternUtils.formatPattern)(pattern, params);
	        }
	
	        replace({
	          pathname: pathname,
	          query: route.query || location.query,
	          state: route.state || location.state
	        });
	      };
	
	      return route;
	    },
	    getRoutePattern: function getRoutePattern(routes, routeIndex) {
	      var parentPattern = '';
	
	      for (var i = routeIndex; i >= 0; i--) {
	        var route = routes[i];
	        var pattern = route.path || '';
	
	        parentPattern = pattern.replace(/\/*$/, '/') + parentPattern;
	
	        if (pattern.indexOf('/') === 0) break;
	      }
	
	      return '/' + parentPattern;
	    }
	  },
	
	  propTypes: {
	    path: string,
	    from: string, // Alias for path
	    to: string.isRequired,
	    query: object,
	    state: object,
	    onEnter: _InternalPropTypes.falsy,
	    children: _InternalPropTypes.falsy
	  },
	
	  /* istanbul ignore next: sanity check */
	  render: function render() {
	     true ?  false ? (0, _invariant2.default)(false, '<Redirect> elements are for router configuration only and should not be rendered') : (0, _invariant2.default)(false) : void 0;
	  }
	});
	
	exports.default = Redirect;
	module.exports = exports['default'];

/***/ },
/* 302 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.createRouterObject = createRouterObject;
	exports.assignRouterState = assignRouterState;
	function createRouterObject(history, transitionManager, state) {
	  var router = _extends({}, history, {
	    setRouteLeaveHook: transitionManager.listenBeforeLeavingRoute,
	    isActive: transitionManager.isActive
	  });
	
	  return assignRouterState(router, state);
	}
	
	function assignRouterState(router, _ref) {
	  var location = _ref.location,
	      params = _ref.params,
	      routes = _ref.routes;
	
	  router.location = location;
	  router.params = params;
	  router.routes = routes;
	
	  return router;
	}

/***/ },
/* 303 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = createMemoryHistory;
	
	var _useQueries = __webpack_require__(250);
	
	var _useQueries2 = _interopRequireDefault(_useQueries);
	
	var _useBasename = __webpack_require__(249);
	
	var _useBasename2 = _interopRequireDefault(_useBasename);
	
	var _createMemoryHistory = __webpack_require__(556);
	
	var _createMemoryHistory2 = _interopRequireDefault(_createMemoryHistory);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function createMemoryHistory(options) {
	  // signatures and type checking differ between `useQueries` and
	  // `createMemoryHistory`, have to create `memoryHistory` first because
	  // `useQueries` doesn't understand the signature
	  var memoryHistory = (0, _createMemoryHistory2.default)(options);
	  var createHistory = function createHistory() {
	    return memoryHistory;
	  };
	  var history = (0, _useQueries2.default)((0, _useBasename2.default)(createHistory))(options);
	  return history;
	}
	module.exports = exports['default'];

/***/ },
/* 304 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	exports.default = function (createHistory) {
	  var history = void 0;
	  if (canUseDOM) history = (0, _useRouterHistory2.default)(createHistory)();
	  return history;
	};
	
	var _useRouterHistory = __webpack_require__(306);
	
	var _useRouterHistory2 = _interopRequireDefault(_useRouterHistory);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
	
	module.exports = exports['default'];

/***/ },
/* 305 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = createTransitionManager;
	
	var _routerWarning = __webpack_require__(88);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	var _computeChangedRoutes2 = __webpack_require__(722);
	
	var _computeChangedRoutes3 = _interopRequireDefault(_computeChangedRoutes2);
	
	var _TransitionUtils = __webpack_require__(719);
	
	var _isActive2 = __webpack_require__(726);
	
	var _isActive3 = _interopRequireDefault(_isActive2);
	
	var _getComponents = __webpack_require__(723);
	
	var _getComponents2 = _interopRequireDefault(_getComponents);
	
	var _matchRoutes = __webpack_require__(728);
	
	var _matchRoutes2 = _interopRequireDefault(_matchRoutes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function hasAnyProperties(object) {
	  for (var p in object) {
	    if (Object.prototype.hasOwnProperty.call(object, p)) return true;
	  }return false;
	}
	
	function createTransitionManager(history, routes) {
	  var state = {};
	
	  // Signature should be (location, indexOnly), but needs to support (path,
	  // query, indexOnly)
	  function isActive(location, indexOnly) {
	    location = history.createLocation(location);
	
	    return (0, _isActive3.default)(location, indexOnly, state.location, state.routes, state.params);
	  }
	
	  var partialNextState = void 0;
	
	  function match(location, callback) {
	    if (partialNextState && partialNextState.location === location) {
	      // Continue from where we left off.
	      finishMatch(partialNextState, callback);
	    } else {
	      (0, _matchRoutes2.default)(routes, location, function (error, nextState) {
	        if (error) {
	          callback(error);
	        } else if (nextState) {
	          finishMatch(_extends({}, nextState, { location: location }), callback);
	        } else {
	          callback();
	        }
	      });
	    }
	  }
	
	  function finishMatch(nextState, callback) {
	    var _computeChangedRoutes = (0, _computeChangedRoutes3.default)(state, nextState),
	        leaveRoutes = _computeChangedRoutes.leaveRoutes,
	        changeRoutes = _computeChangedRoutes.changeRoutes,
	        enterRoutes = _computeChangedRoutes.enterRoutes;
	
	    (0, _TransitionUtils.runLeaveHooks)(leaveRoutes, state);
	
	    // Tear down confirmation hooks for left routes
	    leaveRoutes.filter(function (route) {
	      return enterRoutes.indexOf(route) === -1;
	    }).forEach(removeListenBeforeHooksForRoute);
	
	    // change and enter hooks are run in series
	    (0, _TransitionUtils.runChangeHooks)(changeRoutes, state, nextState, function (error, redirectInfo) {
	      if (error || redirectInfo) return handleErrorOrRedirect(error, redirectInfo);
	
	      (0, _TransitionUtils.runEnterHooks)(enterRoutes, nextState, finishEnterHooks);
	    });
	
	    function finishEnterHooks(error, redirectInfo) {
	      if (error || redirectInfo) return handleErrorOrRedirect(error, redirectInfo);
	
	      // TODO: Fetch components after state is updated.
	      (0, _getComponents2.default)(nextState, function (error, components) {
	        if (error) {
	          callback(error);
	        } else {
	          // TODO: Make match a pure function and have some other API
	          // for "match and update state".
	          callback(null, null, state = _extends({}, nextState, { components: components }));
	        }
	      });
	    }
	
	    function handleErrorOrRedirect(error, redirectInfo) {
	      if (error) callback(error);else callback(null, redirectInfo);
	    }
	  }
	
	  var RouteGuid = 1;
	
	  function getRouteID(route) {
	    var create = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	    return route.__id__ || create && (route.__id__ = RouteGuid++);
	  }
	
	  var RouteHooks = Object.create(null);
	
	  function getRouteHooksForRoutes(routes) {
	    return routes.map(function (route) {
	      return RouteHooks[getRouteID(route)];
	    }).filter(function (hook) {
	      return hook;
	    });
	  }
	
	  function transitionHook(location, callback) {
	    (0, _matchRoutes2.default)(routes, location, function (error, nextState) {
	      if (nextState == null) {
	        // TODO: We didn't actually match anything, but hang
	        // onto error/nextState so we don't have to matchRoutes
	        // again in the listen callback.
	        callback();
	        return;
	      }
	
	      // Cache some state here so we don't have to
	      // matchRoutes() again in the listen callback.
	      partialNextState = _extends({}, nextState, { location: location });
	
	      var hooks = getRouteHooksForRoutes((0, _computeChangedRoutes3.default)(state, partialNextState).leaveRoutes);
	
	      var result = void 0;
	      for (var i = 0, len = hooks.length; result == null && i < len; ++i) {
	        // Passing the location arg here indicates to
	        // the user that this is a transition hook.
	        result = hooks[i](location);
	      }
	
	      callback(result);
	    });
	  }
	
	  /* istanbul ignore next: untestable with Karma */
	  function beforeUnloadHook() {
	    // Synchronously check to see if any route hooks want
	    // to prevent the current window/tab from closing.
	    if (state.routes) {
	      var hooks = getRouteHooksForRoutes(state.routes);
	
	      var message = void 0;
	      for (var i = 0, len = hooks.length; typeof message !== 'string' && i < len; ++i) {
	        // Passing no args indicates to the user that this is a
	        // beforeunload hook. We don't know the next location.
	        message = hooks[i]();
	      }
	
	      return message;
	    }
	  }
	
	  var unlistenBefore = void 0,
	      unlistenBeforeUnload = void 0;
	
	  function removeListenBeforeHooksForRoute(route) {
	    var routeID = getRouteID(route);
	    if (!routeID) {
	      return;
	    }
	
	    delete RouteHooks[routeID];
	
	    if (!hasAnyProperties(RouteHooks)) {
	      // teardown transition & beforeunload hooks
	      if (unlistenBefore) {
	        unlistenBefore();
	        unlistenBefore = null;
	      }
	
	      if (unlistenBeforeUnload) {
	        unlistenBeforeUnload();
	        unlistenBeforeUnload = null;
	      }
	    }
	  }
	
	  /**
	   * Registers the given hook function to run before leaving the given route.
	   *
	   * During a normal transition, the hook function receives the next location
	   * as its only argument and can return either a prompt message (string) to show the user,
	   * to make sure they want to leave the page; or `false`, to prevent the transition.
	   * Any other return value will have no effect.
	   *
	   * During the beforeunload event (in browsers) the hook receives no arguments.
	   * In this case it must return a prompt message to prevent the transition.
	   *
	   * Returns a function that may be used to unbind the listener.
	   */
	  function listenBeforeLeavingRoute(route, hook) {
	    var thereWereNoRouteHooks = !hasAnyProperties(RouteHooks);
	    var routeID = getRouteID(route, true);
	
	    RouteHooks[routeID] = hook;
	
	    if (thereWereNoRouteHooks) {
	      // setup transition & beforeunload hooks
	      unlistenBefore = history.listenBefore(transitionHook);
	
	      if (history.listenBeforeUnload) unlistenBeforeUnload = history.listenBeforeUnload(beforeUnloadHook);
	    }
	
	    return function () {
	      removeListenBeforeHooksForRoute(route);
	    };
	  }
	
	  /**
	   * This is the API for stateful environments. As the location
	   * changes, we update state and call the listener. We can also
	   * gracefully handle errors and redirects.
	   */
	  function listen(listener) {
	    function historyListener(location) {
	      if (state.location === location) {
	        listener(null, state);
	      } else {
	        match(location, function (error, redirectLocation, nextState) {
	          if (error) {
	            listener(error);
	          } else if (redirectLocation) {
	            history.replace(redirectLocation);
	          } else if (nextState) {
	            listener(null, nextState);
	          } else {
	             false ? (0, _routerWarning2.default)(false, 'Location "%s" did not match any routes', location.pathname + location.search + location.hash) : void 0;
	          }
	        });
	      }
	    }
	
	    // TODO: Only use a single history listener. Otherwise we'll end up with
	    // multiple concurrent calls to match.
	
	    // Set up the history listener first in case the initial match redirects.
	    var unsubscribe = history.listen(historyListener);
	
	    if (state.location) {
	      // Picking up on a matchContext.
	      listener(null, state);
	    } else {
	      historyListener(history.getCurrentLocation());
	    }
	
	    return unsubscribe;
	  }
	
	  return {
	    isActive: isActive,
	    match: match,
	    listenBeforeLeavingRoute: listenBeforeLeavingRoute,
	    listen: listen
	  };
	}
	module.exports = exports['default'];

/***/ },
/* 306 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = useRouterHistory;
	
	var _useQueries = __webpack_require__(250);
	
	var _useQueries2 = _interopRequireDefault(_useQueries);
	
	var _useBasename = __webpack_require__(249);
	
	var _useBasename2 = _interopRequireDefault(_useBasename);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function useRouterHistory(createHistory) {
	  return function (options) {
	    var history = (0, _useQueries2.default)((0, _useBasename2.default)(createHistory))(options);
	    return history;
	  };
	}
	module.exports = exports['default'];

/***/ },
/* 307 */
/***/ function(module, exports) {

	'use strict';
	
	var defaultProps = {
	    className: '',
	    accessibility: true,
	    adaptiveHeight: false,
	    arrows: true,
	    autoplay: false,
	    autoplaySpeed: 3000,
	    centerMode: false,
	    centerPadding: '50px',
	    cssEase: 'ease',
	    dots: false,
	    dotsClass: 'slick-dots',
	    draggable: true,
	    easing: 'linear',
	    edgeFriction: 0.35,
	    fade: false,
	    focusOnSelect: false,
	    infinite: true,
	    initialSlide: 0,
	    lazyLoad: false,
	    pauseOnHover: true,
	    responsive: null,
	    rtl: false,
	    slide: 'div',
	    slidesToShow: 1,
	    slidesToScroll: 1,
	    speed: 500,
	    swipe: true,
	    swipeToSlide: false,
	    touchMove: true,
	    touchThreshold: 5,
	    useCSS: true,
	    variableWidth: false,
	    vertical: false,
	    waitForAnimate: true,
	    afterChange: null,
	    beforeChange: null,
	    edgeEvent: null,
	    init: null,
	    swipeEvent: null,
	    // nextArrow, prevArrow are react componets
	    nextArrow: null,
	    prevArrow: null
	};
	
	module.exports = defaultProps;

/***/ },
/* 308 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(84);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _trackHelper = __webpack_require__(309);
	
	var _objectAssign = __webpack_require__(6);
	
	var _objectAssign2 = _interopRequireDefault(_objectAssign);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var helpers = {
	  initialize: function initialize(props) {
	    var slickList = _reactDom2.default.findDOMNode(this.list);
	
	    var slideCount = _react2.default.Children.count(props.children);
	    var listWidth = this.getWidth(slickList);
	    var trackWidth = this.getWidth(_reactDom2.default.findDOMNode(this.track));
	    var slideWidth;
	
	    if (!props.vertical) {
	      slideWidth = this.getWidth(_reactDom2.default.findDOMNode(this)) / props.slidesToShow;
	    } else {
	      slideWidth = this.getWidth(_reactDom2.default.findDOMNode(this));
	    }
	
	    var slideHeight = this.getHeight(slickList.querySelector('[data-index="0"]'));
	    var listHeight = slideHeight * props.slidesToShow;
	
	    var currentSlide = props.rtl ? slideCount - 1 - props.initialSlide : props.initialSlide;
	
	    this.setState({
	      slideCount: slideCount,
	      slideWidth: slideWidth,
	      listWidth: listWidth,
	      trackWidth: trackWidth,
	      currentSlide: currentSlide,
	      slideHeight: slideHeight,
	      listHeight: listHeight
	    }, function () {
	
	      var targetLeft = (0, _trackHelper.getTrackLeft)((0, _objectAssign2.default)({
	        slideIndex: this.state.currentSlide,
	        trackRef: this.track
	      }, props, this.state));
	      // getCSS function needs previously set state
	      var trackStyle = (0, _trackHelper.getTrackCSS)((0, _objectAssign2.default)({ left: targetLeft }, props, this.state));
	
	      this.setState({ trackStyle: trackStyle });
	
	      this.autoPlay(); // once we're set up, trigger the initial autoplay.
	    });
	  },
	  update: function update(props) {
	    var slickList = _reactDom2.default.findDOMNode(this.list);
	    // This method has mostly same code as initialize method.
	    // Refactor it
	    var slideCount = _react2.default.Children.count(props.children);
	    var listWidth = this.getWidth(slickList);
	    var trackWidth = this.getWidth(_reactDom2.default.findDOMNode(this.track));
	    var slideWidth;
	
	    if (!props.vertical) {
	      slideWidth = this.getWidth(_reactDom2.default.findDOMNode(this)) / props.slidesToShow;
	    } else {
	      slideWidth = this.getWidth(_reactDom2.default.findDOMNode(this));
	    }
	
	    var slideHeight = this.getHeight(slickList.querySelector('[data-index="0"]'));
	    var listHeight = slideHeight * props.slidesToShow;
	
	    // pause slider if autoplay is set to false
	    if (!props.autoplay) this.pause();
	
	    this.setState({
	      slideCount: slideCount,
	      slideWidth: slideWidth,
	      listWidth: listWidth,
	      trackWidth: trackWidth,
	      slideHeight: slideHeight,
	      listHeight: listHeight
	    }, function () {
	
	      var targetLeft = (0, _trackHelper.getTrackLeft)((0, _objectAssign2.default)({
	        slideIndex: this.state.currentSlide,
	        trackRef: this.track
	      }, props, this.state));
	      // getCSS function needs previously set state
	      var trackStyle = (0, _trackHelper.getTrackCSS)((0, _objectAssign2.default)({ left: targetLeft }, props, this.state));
	
	      this.setState({ trackStyle: trackStyle });
	    });
	  },
	  getWidth: function getWidth(elem) {
	    return elem.getBoundingClientRect().width || elem.offsetWidth;
	  },
	  getHeight: function getHeight(elem) {
	    return elem.getBoundingClientRect().height || elem.offsetHeight;
	  },
	
	  adaptHeight: function adaptHeight() {
	    if (this.props.adaptiveHeight) {
	      var selector = '[data-index="' + this.state.currentSlide + '"]';
	      if (this.list) {
	        var slickList = _reactDom2.default.findDOMNode(this.list);
	        slickList.style.height = slickList.querySelector(selector).offsetHeight + 'px';
	      }
	    }
	  },
	  slideHandler: function slideHandler(index) {
	    var _this = this;
	
	    // Functionality of animateSlide and postSlide is merged into this function
	    // console.log('slideHandler', index);
	    var targetSlide, currentSlide;
	    var targetLeft, currentLeft;
	    var callback;
	
	    if (this.props.waitForAnimate && this.state.animating) {
	      return;
	    }
	
	    if (this.props.fade) {
	      currentSlide = this.state.currentSlide;
	
	      // Don't change slide if it's not infite and current slide is the first or last slide.
	      if (this.props.infinite === false && (index < 0 || index >= this.state.slideCount)) {
	        return;
	      }
	
	      //  Shifting targetSlide back into the range
	      if (index < 0) {
	        targetSlide = index + this.state.slideCount;
	      } else if (index >= this.state.slideCount) {
	        targetSlide = index - this.state.slideCount;
	      } else {
	        targetSlide = index;
	      }
	
	      if (this.props.lazyLoad && this.state.lazyLoadedList.indexOf(targetSlide) < 0) {
	        this.setState({
	          lazyLoadedList: this.state.lazyLoadedList.concat(targetSlide)
	        });
	      }
	
	      callback = function callback() {
	        _this.setState({
	          animating: false
	        });
	        if (_this.props.afterChange) {
	          _this.props.afterChange(targetSlide);
	        }
	        delete _this.animationEndCallback;
	      };
	
	      this.setState({
	        animating: true,
	        currentSlide: targetSlide
	      }, function () {
	        this.animationEndCallback = setTimeout(callback, this.props.speed);
	      });
	
	      if (this.props.beforeChange) {
	        this.props.beforeChange(this.state.currentSlide, targetSlide);
	      }
	
	      this.autoPlay();
	      return;
	    }
	
	    targetSlide = index;
	    if (targetSlide < 0) {
	      if (this.props.infinite === false) {
	        currentSlide = 0;
	      } else if (this.state.slideCount % this.props.slidesToScroll !== 0) {
	        currentSlide = this.state.slideCount - this.state.slideCount % this.props.slidesToScroll;
	      } else {
	        currentSlide = this.state.slideCount + targetSlide;
	      }
	    } else if (targetSlide >= this.state.slideCount) {
	      if (this.props.infinite === false) {
	        currentSlide = this.state.slideCount - this.props.slidesToShow;
	      } else if (this.state.slideCount % this.props.slidesToScroll !== 0) {
	        currentSlide = 0;
	      } else {
	        currentSlide = targetSlide - this.state.slideCount;
	      }
	    } else {
	      currentSlide = targetSlide;
	    }
	
	    targetLeft = (0, _trackHelper.getTrackLeft)((0, _objectAssign2.default)({
	      slideIndex: targetSlide,
	      trackRef: this.track
	    }, this.props, this.state));
	
	    currentLeft = (0, _trackHelper.getTrackLeft)((0, _objectAssign2.default)({
	      slideIndex: currentSlide,
	      trackRef: this.track
	    }, this.props, this.state));
	
	    if (this.props.infinite === false) {
	      targetLeft = currentLeft;
	    }
	
	    if (this.props.beforeChange) {
	      this.props.beforeChange(this.state.currentSlide, currentSlide);
	    }
	
	    if (this.props.lazyLoad) {
	      var loaded = true;
	      var slidesToLoad = [];
	      for (var i = targetSlide; i < targetSlide + this.props.slidesToShow; i++) {
	        loaded = loaded && this.state.lazyLoadedList.indexOf(i) >= 0;
	        if (!loaded) {
	          slidesToLoad.push(i);
	        }
	      }
	      if (!loaded) {
	        this.setState({
	          lazyLoadedList: this.state.lazyLoadedList.concat(slidesToLoad)
	        });
	      }
	    }
	
	    // Slide Transition happens here.
	    // animated transition happens to target Slide and
	    // non - animated transition happens to current Slide
	    // If CSS transitions are false, directly go the current slide.
	
	    if (this.props.useCSS === false) {
	
	      this.setState({
	        currentSlide: currentSlide,
	        trackStyle: (0, _trackHelper.getTrackCSS)((0, _objectAssign2.default)({ left: currentLeft }, this.props, this.state))
	      }, function () {
	        if (this.props.afterChange) {
	          this.props.afterChange(currentSlide);
	        }
	      });
	    } else {
	
	      var nextStateChanges = {
	        animating: false,
	        currentSlide: currentSlide,
	        trackStyle: (0, _trackHelper.getTrackCSS)((0, _objectAssign2.default)({ left: currentLeft }, this.props, this.state)),
	        swipeLeft: null
	      };
	
	      callback = function callback() {
	        _this.setState(nextStateChanges);
	        if (_this.props.afterChange) {
	          _this.props.afterChange(currentSlide);
	        }
	        delete _this.animationEndCallback;
	      };
	
	      this.setState({
	        animating: true,
	        currentSlide: currentSlide,
	        trackStyle: (0, _trackHelper.getTrackAnimateCSS)((0, _objectAssign2.default)({ left: targetLeft }, this.props, this.state))
	      }, function () {
	        this.animationEndCallback = setTimeout(callback, this.props.speed);
	      });
	    }
	
	    this.autoPlay();
	  },
	  swipeDirection: function swipeDirection(touchObject) {
	    var xDist, yDist, r, swipeAngle;
	
	    xDist = touchObject.startX - touchObject.curX;
	    yDist = touchObject.startY - touchObject.curY;
	    r = Math.atan2(yDist, xDist);
	
	    swipeAngle = Math.round(r * 180 / Math.PI);
	    if (swipeAngle < 0) {
	      swipeAngle = 360 - Math.abs(swipeAngle);
	    }
	    if (swipeAngle <= 45 && swipeAngle >= 0 || swipeAngle <= 360 && swipeAngle >= 315) {
	      return this.props.rtl === false ? 'left' : 'right';
	    }
	    if (swipeAngle >= 135 && swipeAngle <= 225) {
	      return this.props.rtl === false ? 'right' : 'left';
	    }
	    if (this.props.verticalSwiping === true) {
	      if (swipeAngle >= 35 && swipeAngle <= 135) {
	        return 'down';
	      } else {
	        return 'up';
	      }
	    }
	
	    return 'vertical';
	  },
	  autoPlay: function autoPlay() {
	    var _this2 = this;
	
	    if (this.state.autoPlayTimer) {
	      return;
	    }
	    var play = function play() {
	      if (_this2.state.mounted) {
	        var nextIndex = _this2.props.rtl ? _this2.state.currentSlide - _this2.props.slidesToScroll : _this2.state.currentSlide + _this2.props.slidesToScroll;
	        _this2.slideHandler(nextIndex);
	      }
	    };
	    if (this.props.autoplay) {
	      this.setState({
	        autoPlayTimer: setInterval(play, this.props.autoplaySpeed)
	      });
	    }
	  },
	  pause: function pause() {
	    if (this.state.autoPlayTimer) {
	      clearInterval(this.state.autoPlayTimer);
	      this.setState({
	        autoPlayTimer: null
	      });
	    }
	  }
	};
	
	exports.default = helpers;

/***/ },
/* 309 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.getTrackLeft = exports.getTrackAnimateCSS = exports.getTrackCSS = undefined;
	
	var _reactDom = __webpack_require__(84);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _objectAssign = __webpack_require__(6);
	
	var _objectAssign2 = _interopRequireDefault(_objectAssign);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var checkSpecKeys = function checkSpecKeys(spec, keysArray) {
	  return keysArray.reduce(function (value, key) {
	    return value && spec.hasOwnProperty(key);
	  }, true) ? null : console.error('Keys Missing', spec);
	};
	
	var getTrackCSS = exports.getTrackCSS = function getTrackCSS(spec) {
	  checkSpecKeys(spec, ['left', 'variableWidth', 'slideCount', 'slidesToShow', 'slideWidth']);
	
	  var trackWidth, trackHeight;
	
	  var trackChildren = spec.slideCount + 2 * spec.slidesToShow;
	
	  if (!spec.vertical) {
	    if (spec.variableWidth) {
	      trackWidth = (spec.slideCount + 2 * spec.slidesToShow) * spec.slideWidth;
	    } else if (spec.centerMode) {
	      trackWidth = (spec.slideCount + 2 * (spec.slidesToShow + 1)) * spec.slideWidth;
	    } else {
	      trackWidth = (spec.slideCount + 2 * spec.slidesToShow) * spec.slideWidth;
	    }
	  } else {
	    trackHeight = trackChildren * spec.slideHeight;
	  }
	
	  var style = {
	    opacity: 1,
	    WebkitTransform: !spec.vertical ? 'translate3d(' + spec.left + 'px, 0px, 0px)' : 'translate3d(0px, ' + spec.left + 'px, 0px)',
	    transform: !spec.vertical ? 'translate3d(' + spec.left + 'px, 0px, 0px)' : 'translate3d(0px, ' + spec.left + 'px, 0px)',
	    transition: '',
	    WebkitTransition: '',
	    msTransform: !spec.vertical ? 'translateX(' + spec.left + 'px)' : 'translateY(' + spec.left + 'px)'
	  };
	
	  if (trackWidth) {
	    (0, _objectAssign2.default)(style, { width: trackWidth });
	  }
	
	  if (trackHeight) {
	    (0, _objectAssign2.default)(style, { height: trackHeight });
	  }
	
	  // Fallback for IE8
	  if (window && !window.addEventListener && window.attachEvent) {
	    if (!spec.vertical) {
	      style.marginLeft = spec.left + 'px';
	    } else {
	      style.marginTop = spec.left + 'px';
	    }
	  }
	
	  return style;
	};
	
	var getTrackAnimateCSS = exports.getTrackAnimateCSS = function getTrackAnimateCSS(spec) {
	  checkSpecKeys(spec, ['left', 'variableWidth', 'slideCount', 'slidesToShow', 'slideWidth', 'speed', 'cssEase']);
	
	  var style = getTrackCSS(spec);
	  // useCSS is true by default so it can be undefined
	  style.WebkitTransition = '-webkit-transform ' + spec.speed + 'ms ' + spec.cssEase;
	  style.transition = 'transform ' + spec.speed + 'ms ' + spec.cssEase;
	  return style;
	};
	
	var getTrackLeft = exports.getTrackLeft = function getTrackLeft(spec) {
	
	  checkSpecKeys(spec, ['slideIndex', 'trackRef', 'infinite', 'centerMode', 'slideCount', 'slidesToShow', 'slidesToScroll', 'slideWidth', 'listWidth', 'variableWidth', 'slideHeight']);
	
	  var slideOffset = 0;
	  var targetLeft;
	  var targetSlide;
	  var verticalOffset = 0;
	
	  if (spec.fade) {
	    return 0;
	  }
	
	  if (spec.infinite) {
	    if (spec.slideCount >= spec.slidesToShow) {
	      slideOffset = spec.slideWidth * spec.slidesToShow * -1;
	      verticalOffset = spec.slideHeight * spec.slidesToShow * -1;
	    }
	    if (spec.slideCount % spec.slidesToScroll !== 0) {
	      if (spec.slideIndex + spec.slidesToScroll > spec.slideCount && spec.slideCount > spec.slidesToShow) {
	        if (spec.slideIndex > spec.slideCount) {
	          slideOffset = (spec.slidesToShow - (spec.slideIndex - spec.slideCount)) * spec.slideWidth * -1;
	          verticalOffset = (spec.slidesToShow - (spec.slideIndex - spec.slideCount)) * spec.slideHeight * -1;
	        } else {
	          slideOffset = spec.slideCount % spec.slidesToScroll * spec.slideWidth * -1;
	          verticalOffset = spec.slideCount % spec.slidesToScroll * spec.slideHeight * -1;
	        }
	      }
	    }
	  } else {
	
	    if (spec.slideCount % spec.slidesToScroll !== 0) {
	      if (spec.slideIndex + spec.slidesToScroll > spec.slideCount && spec.slideCount > spec.slidesToShow) {
	        var slidesToOffset = spec.slidesToShow - spec.slideCount % spec.slidesToScroll;
	        slideOffset = slidesToOffset * spec.slideWidth;
	      }
	    }
	  }
	
	  if (spec.centerMode) {
	    if (spec.infinite) {
	      slideOffset += spec.slideWidth * Math.floor(spec.slidesToShow / 2);
	    } else {
	      slideOffset = spec.slideWidth * Math.floor(spec.slidesToShow / 2);
	    }
	  }
	
	  if (!spec.vertical) {
	    targetLeft = spec.slideIndex * spec.slideWidth * -1 + slideOffset;
	  } else {
	    targetLeft = spec.slideIndex * spec.slideHeight * -1 + verticalOffset;
	  }
	
	  if (spec.variableWidth === true) {
	    var targetSlideIndex;
	    if (spec.slideCount <= spec.slidesToShow || spec.infinite === false) {
	      targetSlide = _reactDom2.default.findDOMNode(spec.trackRef).childNodes[spec.slideIndex];
	    } else {
	      targetSlideIndex = spec.slideIndex + spec.slidesToShow;
	      targetSlide = _reactDom2.default.findDOMNode(spec.trackRef).childNodes[targetSlideIndex];
	    }
	    targetLeft = targetSlide ? targetSlide.offsetLeft * -1 : 0;
	    if (spec.centerMode === true) {
	      if (spec.infinite === false) {
	        targetSlide = _reactDom2.default.findDOMNode(spec.trackRef).children[spec.slideIndex];
	      } else {
	        targetSlide = _reactDom2.default.findDOMNode(spec.trackRef).children[spec.slideIndex + spec.slidesToShow + 1];
	      }
	
	      targetLeft = targetSlide ? targetSlide.offsetLeft * -1 : 0;
	      targetLeft += (spec.listWidth - targetSlide.offsetWidth) / 2;
	    }
	  }
	
	  return targetLeft;
	};

/***/ },
/* 310 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule CSSProperty
	 */
	
	'use strict';
	
	/**
	 * CSS properties which accept numbers but are not in units of "px".
	 */
	
	var isUnitlessNumber = {
	  animationIterationCount: true,
	  borderImageOutset: true,
	  borderImageSlice: true,
	  borderImageWidth: true,
	  boxFlex: true,
	  boxFlexGroup: true,
	  boxOrdinalGroup: true,
	  columnCount: true,
	  flex: true,
	  flexGrow: true,
	  flexPositive: true,
	  flexShrink: true,
	  flexNegative: true,
	  flexOrder: true,
	  gridRow: true,
	  gridColumn: true,
	  fontWeight: true,
	  lineClamp: true,
	  lineHeight: true,
	  opacity: true,
	  order: true,
	  orphans: true,
	  tabSize: true,
	  widows: true,
	  zIndex: true,
	  zoom: true,
	
	  // SVG-related properties
	  fillOpacity: true,
	  floodOpacity: true,
	  stopOpacity: true,
	  strokeDasharray: true,
	  strokeDashoffset: true,
	  strokeMiterlimit: true,
	  strokeOpacity: true,
	  strokeWidth: true
	};
	
	/**
	 * @param {string} prefix vendor-specific prefix, eg: Webkit
	 * @param {string} key style name, eg: transitionDuration
	 * @return {string} style name prefixed with `prefix`, properly camelCased, eg:
	 * WebkitTransitionDuration
	 */
	function prefixKey(prefix, key) {
	  return prefix + key.charAt(0).toUpperCase() + key.substring(1);
	}
	
	/**
	 * Support style names that may come passed in prefixed by adding permutations
	 * of vendor prefixes.
	 */
	var prefixes = ['Webkit', 'ms', 'Moz', 'O'];
	
	// Using Object.keys here, or else the vanilla for-in loop makes IE8 go into an
	// infinite loop, because it iterates over the newly added props too.
	Object.keys(isUnitlessNumber).forEach(function (prop) {
	  prefixes.forEach(function (prefix) {
	    isUnitlessNumber[prefixKey(prefix, prop)] = isUnitlessNumber[prop];
	  });
	});
	
	/**
	 * Most style properties can be unset by doing .style[prop] = '' but IE8
	 * doesn't like doing that with shorthand properties so for the properties that
	 * IE8 breaks on, which are listed here, we instead unset each of the
	 * individual properties. See http://bugs.jquery.com/ticket/12385.
	 * The 4-value 'clock' properties like margin, padding, border-width seem to
	 * behave without any problems. Curiously, list-style works too without any
	 * special prodding.
	 */
	var shorthandPropertyExpansions = {
	  background: {
	    backgroundAttachment: true,
	    backgroundColor: true,
	    backgroundImage: true,
	    backgroundPositionX: true,
	    backgroundPositionY: true,
	    backgroundRepeat: true
	  },
	  backgroundPosition: {
	    backgroundPositionX: true,
	    backgroundPositionY: true
	  },
	  border: {
	    borderWidth: true,
	    borderStyle: true,
	    borderColor: true
	  },
	  borderBottom: {
	    borderBottomWidth: true,
	    borderBottomStyle: true,
	    borderBottomColor: true
	  },
	  borderLeft: {
	    borderLeftWidth: true,
	    borderLeftStyle: true,
	    borderLeftColor: true
	  },
	  borderRight: {
	    borderRightWidth: true,
	    borderRightStyle: true,
	    borderRightColor: true
	  },
	  borderTop: {
	    borderTopWidth: true,
	    borderTopStyle: true,
	    borderTopColor: true
	  },
	  font: {
	    fontStyle: true,
	    fontVariant: true,
	    fontWeight: true,
	    fontSize: true,
	    lineHeight: true,
	    fontFamily: true
	  },
	  outline: {
	    outlineWidth: true,
	    outlineStyle: true,
	    outlineColor: true
	  }
	};
	
	var CSSProperty = {
	  isUnitlessNumber: isUnitlessNumber,
	  shorthandPropertyExpansions: shorthandPropertyExpansions
	};
	
	module.exports = CSSProperty;

/***/ },
/* 311 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule CallbackQueue
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(5),
	    _assign = __webpack_require__(6);
	
	var PooledClass = __webpack_require__(62);
	
	var invariant = __webpack_require__(2);
	
	/**
	 * A specialized pseudo-event module to help keep track of components waiting to
	 * be notified when their DOM representations are available for use.
	 *
	 * This implements `PooledClass`, so you should never need to instantiate this.
	 * Instead, use `CallbackQueue.getPooled()`.
	 *
	 * @class ReactMountReady
	 * @implements PooledClass
	 * @internal
	 */
	function CallbackQueue() {
	  this._callbacks = null;
	  this._contexts = null;
	}
	
	_assign(CallbackQueue.prototype, {
	
	  /**
	   * Enqueues a callback to be invoked when `notifyAll` is invoked.
	   *
	   * @param {function} callback Invoked when `notifyAll` is invoked.
	   * @param {?object} context Context to call `callback` with.
	   * @internal
	   */
	  enqueue: function (callback, context) {
	    this._callbacks = this._callbacks || [];
	    this._contexts = this._contexts || [];
	    this._callbacks.push(callback);
	    this._contexts.push(context);
	  },
	
	  /**
	   * Invokes all enqueued callbacks and clears the queue. This is invoked after
	   * the DOM representation of a component has been created or updated.
	   *
	   * @internal
	   */
	  notifyAll: function () {
	    var callbacks = this._callbacks;
	    var contexts = this._contexts;
	    if (callbacks) {
	      !(callbacks.length === contexts.length) ?  false ? invariant(false, 'Mismatched list of contexts in callback queue') : _prodInvariant('24') : void 0;
	      this._callbacks = null;
	      this._contexts = null;
	      for (var i = 0; i < callbacks.length; i++) {
	        callbacks[i].call(contexts[i]);
	      }
	      callbacks.length = 0;
	      contexts.length = 0;
	    }
	  },
	
	  checkpoint: function () {
	    return this._callbacks ? this._callbacks.length : 0;
	  },
	
	  rollback: function (len) {
	    if (this._callbacks) {
	      this._callbacks.length = len;
	      this._contexts.length = len;
	    }
	  },
	
	  /**
	   * Resets the internal queue.
	   *
	   * @internal
	   */
	  reset: function () {
	    this._callbacks = null;
	    this._contexts = null;
	  },
	
	  /**
	   * `PooledClass` looks for this.
	   */
	  destructor: function () {
	    this.reset();
	  }
	
	});
	
	PooledClass.addPoolingTo(CallbackQueue);
	
	module.exports = CallbackQueue;

/***/ },
/* 312 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule DOMPropertyOperations
	 */
	
	'use strict';
	
	var DOMProperty = __webpack_require__(90);
	var ReactDOMComponentTree = __webpack_require__(15);
	var ReactDOMInstrumentation = __webpack_require__(759);
	var ReactInstrumentation = __webpack_require__(31);
	
	var quoteAttributeValueForBrowser = __webpack_require__(799);
	var warning = __webpack_require__(9);
	
	var VALID_ATTRIBUTE_NAME_REGEX = new RegExp('^[' + DOMProperty.ATTRIBUTE_NAME_START_CHAR + '][' + DOMProperty.ATTRIBUTE_NAME_CHAR + ']*$');
	var illegalAttributeNameCache = {};
	var validatedAttributeNameCache = {};
	
	function isAttributeNameSafe(attributeName) {
	  if (validatedAttributeNameCache.hasOwnProperty(attributeName)) {
	    return true;
	  }
	  if (illegalAttributeNameCache.hasOwnProperty(attributeName)) {
	    return false;
	  }
	  if (VALID_ATTRIBUTE_NAME_REGEX.test(attributeName)) {
	    validatedAttributeNameCache[attributeName] = true;
	    return true;
	  }
	  illegalAttributeNameCache[attributeName] = true;
	   false ? warning(false, 'Invalid attribute name: `%s`', attributeName) : void 0;
	  return false;
	}
	
	function shouldIgnoreValue(propertyInfo, value) {
	  return value == null || propertyInfo.hasBooleanValue && !value || propertyInfo.hasNumericValue && isNaN(value) || propertyInfo.hasPositiveNumericValue && value < 1 || propertyInfo.hasOverloadedBooleanValue && value === false;
	}
	
	/**
	 * Operations for dealing with DOM properties.
	 */
	var DOMPropertyOperations = {
	
	  /**
	   * Creates markup for the ID property.
	   *
	   * @param {string} id Unescaped ID.
	   * @return {string} Markup string.
	   */
	  createMarkupForID: function (id) {
	    return DOMProperty.ID_ATTRIBUTE_NAME + '=' + quoteAttributeValueForBrowser(id);
	  },
	
	  setAttributeForID: function (node, id) {
	    node.setAttribute(DOMProperty.ID_ATTRIBUTE_NAME, id);
	  },
	
	  createMarkupForRoot: function () {
	    return DOMProperty.ROOT_ATTRIBUTE_NAME + '=""';
	  },
	
	  setAttributeForRoot: function (node) {
	    node.setAttribute(DOMProperty.ROOT_ATTRIBUTE_NAME, '');
	  },
	
	  /**
	   * Creates markup for a property.
	   *
	   * @param {string} name
	   * @param {*} value
	   * @return {?string} Markup string, or null if the property was invalid.
	   */
	  createMarkupForProperty: function (name, value) {
	    if (false) {
	      ReactDOMInstrumentation.debugTool.onCreateMarkupForProperty(name, value);
	    }
	    var propertyInfo = DOMProperty.properties.hasOwnProperty(name) ? DOMProperty.properties[name] : null;
	    if (propertyInfo) {
	      if (shouldIgnoreValue(propertyInfo, value)) {
	        return '';
	      }
	      var attributeName = propertyInfo.attributeName;
	      if (propertyInfo.hasBooleanValue || propertyInfo.hasOverloadedBooleanValue && value === true) {
	        return attributeName + '=""';
	      }
	      return attributeName + '=' + quoteAttributeValueForBrowser(value);
	    } else if (DOMProperty.isCustomAttribute(name)) {
	      if (value == null) {
	        return '';
	      }
	      return name + '=' + quoteAttributeValueForBrowser(value);
	    }
	    return null;
	  },
	
	  /**
	   * Creates markup for a custom property.
	   *
	   * @param {string} name
	   * @param {*} value
	   * @return {string} Markup string, or empty string if the property was invalid.
	   */
	  createMarkupForCustomAttribute: function (name, value) {
	    if (!isAttributeNameSafe(name) || value == null) {
	      return '';
	    }
	    return name + '=' + quoteAttributeValueForBrowser(value);
	  },
	
	  /**
	   * Sets the value for a property on a node.
	   *
	   * @param {DOMElement} node
	   * @param {string} name
	   * @param {*} value
	   */
	  setValueForProperty: function (node, name, value) {
	    var propertyInfo = DOMProperty.properties.hasOwnProperty(name) ? DOMProperty.properties[name] : null;
	    if (propertyInfo) {
	      var mutationMethod = propertyInfo.mutationMethod;
	      if (mutationMethod) {
	        mutationMethod(node, value);
	      } else if (shouldIgnoreValue(propertyInfo, value)) {
	        this.deleteValueForProperty(node, name);
	        return;
	      } else if (propertyInfo.mustUseProperty) {
	        // Contrary to `setAttribute`, object properties are properly
	        // `toString`ed by IE8/9.
	        node[propertyInfo.propertyName] = value;
	      } else {
	        var attributeName = propertyInfo.attributeName;
	        var namespace = propertyInfo.attributeNamespace;
	        // `setAttribute` with objects becomes only `[object]` in IE8/9,
	        // ('' + value) makes it output the correct toString()-value.
	        if (namespace) {
	          node.setAttributeNS(namespace, attributeName, '' + value);
	        } else if (propertyInfo.hasBooleanValue || propertyInfo.hasOverloadedBooleanValue && value === true) {
	          node.setAttribute(attributeName, '');
	        } else {
	          node.setAttribute(attributeName, '' + value);
	        }
	      }
	    } else if (DOMProperty.isCustomAttribute(name)) {
	      DOMPropertyOperations.setValueForAttribute(node, name, value);
	      return;
	    }
	
	    if (false) {
	      ReactDOMInstrumentation.debugTool.onSetValueForProperty(node, name, value);
	      var payload = {};
	      payload[name] = value;
	      ReactInstrumentation.debugTool.onHostOperation(ReactDOMComponentTree.getInstanceFromNode(node)._debugID, 'update attribute', payload);
	    }
	  },
	
	  setValueForAttribute: function (node, name, value) {
	    if (!isAttributeNameSafe(name)) {
	      return;
	    }
	    if (value == null) {
	      node.removeAttribute(name);
	    } else {
	      node.setAttribute(name, '' + value);
	    }
	
	    if (false) {
	      var payload = {};
	      payload[name] = value;
	      ReactInstrumentation.debugTool.onHostOperation(ReactDOMComponentTree.getInstanceFromNode(node)._debugID, 'update attribute', payload);
	    }
	  },
	
	  /**
	   * Deletes an attributes from a node.
	   *
	   * @param {DOMElement} node
	   * @param {string} name
	   */
	  deleteValueForAttribute: function (node, name) {
	    node.removeAttribute(name);
	    if (false) {
	      ReactDOMInstrumentation.debugTool.onDeleteValueForProperty(node, name);
	      ReactInstrumentation.debugTool.onHostOperation(ReactDOMComponentTree.getInstanceFromNode(node)._debugID, 'remove attribute', name);
	    }
	  },
	
	  /**
	   * Deletes the value for a property on a node.
	   *
	   * @param {DOMElement} node
	   * @param {string} name
	   */
	  deleteValueForProperty: function (node, name) {
	    var propertyInfo = DOMProperty.properties.hasOwnProperty(name) ? DOMProperty.properties[name] : null;
	    if (propertyInfo) {
	      var mutationMethod = propertyInfo.mutationMethod;
	      if (mutationMethod) {
	        mutationMethod(node, undefined);
	      } else if (propertyInfo.mustUseProperty) {
	        var propName = propertyInfo.propertyName;
	        if (propertyInfo.hasBooleanValue) {
	          node[propName] = false;
	        } else {
	          node[propName] = '';
	        }
	      } else {
	        node.removeAttribute(propertyInfo.attributeName);
	      }
	    } else if (DOMProperty.isCustomAttribute(name)) {
	      node.removeAttribute(name);
	    }
	
	    if (false) {
	      ReactDOMInstrumentation.debugTool.onDeleteValueForProperty(node, name);
	      ReactInstrumentation.debugTool.onHostOperation(ReactDOMComponentTree.getInstanceFromNode(node)._debugID, 'remove attribute', name);
	    }
	  }
	
	};
	
	module.exports = DOMPropertyOperations;

/***/ },
/* 313 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactChildren
	 */
	
	'use strict';
	
	var PooledClass = __webpack_require__(62);
	var ReactElement = __webpack_require__(45);
	
	var emptyFunction = __webpack_require__(37);
	var traverseAllChildren = __webpack_require__(213);
	
	var twoArgumentPooler = PooledClass.twoArgumentPooler;
	var fourArgumentPooler = PooledClass.fourArgumentPooler;
	
	var userProvidedKeyEscapeRegex = /\/+/g;
	function escapeUserProvidedKey(text) {
	  return ('' + text).replace(userProvidedKeyEscapeRegex, '$&/');
	}
	
	/**
	 * PooledClass representing the bookkeeping associated with performing a child
	 * traversal. Allows avoiding binding callbacks.
	 *
	 * @constructor ForEachBookKeeping
	 * @param {!function} forEachFunction Function to perform traversal with.
	 * @param {?*} forEachContext Context to perform context with.
	 */
	function ForEachBookKeeping(forEachFunction, forEachContext) {
	  this.func = forEachFunction;
	  this.context = forEachContext;
	  this.count = 0;
	}
	ForEachBookKeeping.prototype.destructor = function () {
	  this.func = null;
	  this.context = null;
	  this.count = 0;
	};
	PooledClass.addPoolingTo(ForEachBookKeeping, twoArgumentPooler);
	
	function forEachSingleChild(bookKeeping, child, name) {
	  var func = bookKeeping.func;
	  var context = bookKeeping.context;
	
	  func.call(context, child, bookKeeping.count++);
	}
	
	/**
	 * Iterates through children that are typically specified as `props.children`.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.foreach
	 *
	 * The provided forEachFunc(child, index) will be called for each
	 * leaf child.
	 *
	 * @param {?*} children Children tree container.
	 * @param {function(*, int)} forEachFunc
	 * @param {*} forEachContext Context for forEachContext.
	 */
	function forEachChildren(children, forEachFunc, forEachContext) {
	  if (children == null) {
	    return children;
	  }
	  var traverseContext = ForEachBookKeeping.getPooled(forEachFunc, forEachContext);
	  traverseAllChildren(children, forEachSingleChild, traverseContext);
	  ForEachBookKeeping.release(traverseContext);
	}
	
	/**
	 * PooledClass representing the bookkeeping associated with performing a child
	 * mapping. Allows avoiding binding callbacks.
	 *
	 * @constructor MapBookKeeping
	 * @param {!*} mapResult Object containing the ordered map of results.
	 * @param {!function} mapFunction Function to perform mapping with.
	 * @param {?*} mapContext Context to perform mapping with.
	 */
	function MapBookKeeping(mapResult, keyPrefix, mapFunction, mapContext) {
	  this.result = mapResult;
	  this.keyPrefix = keyPrefix;
	  this.func = mapFunction;
	  this.context = mapContext;
	  this.count = 0;
	}
	MapBookKeeping.prototype.destructor = function () {
	  this.result = null;
	  this.keyPrefix = null;
	  this.func = null;
	  this.context = null;
	  this.count = 0;
	};
	PooledClass.addPoolingTo(MapBookKeeping, fourArgumentPooler);
	
	function mapSingleChildIntoContext(bookKeeping, child, childKey) {
	  var result = bookKeeping.result;
	  var keyPrefix = bookKeeping.keyPrefix;
	  var func = bookKeeping.func;
	  var context = bookKeeping.context;
	
	
	  var mappedChild = func.call(context, child, bookKeeping.count++);
	  if (Array.isArray(mappedChild)) {
	    mapIntoWithKeyPrefixInternal(mappedChild, result, childKey, emptyFunction.thatReturnsArgument);
	  } else if (mappedChild != null) {
	    if (ReactElement.isValidElement(mappedChild)) {
	      mappedChild = ReactElement.cloneAndReplaceKey(mappedChild,
	      // Keep both the (mapped) and old keys if they differ, just as
	      // traverseAllChildren used to do for objects as children
	      keyPrefix + (mappedChild.key && (!child || child.key !== mappedChild.key) ? escapeUserProvidedKey(mappedChild.key) + '/' : '') + childKey);
	    }
	    result.push(mappedChild);
	  }
	}
	
	function mapIntoWithKeyPrefixInternal(children, array, prefix, func, context) {
	  var escapedPrefix = '';
	  if (prefix != null) {
	    escapedPrefix = escapeUserProvidedKey(prefix) + '/';
	  }
	  var traverseContext = MapBookKeeping.getPooled(array, escapedPrefix, func, context);
	  traverseAllChildren(children, mapSingleChildIntoContext, traverseContext);
	  MapBookKeeping.release(traverseContext);
	}
	
	/**
	 * Maps children that are typically specified as `props.children`.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.map
	 *
	 * The provided mapFunction(child, key, index) will be called for each
	 * leaf child.
	 *
	 * @param {?*} children Children tree container.
	 * @param {function(*, int)} func The map function.
	 * @param {*} context Context for mapFunction.
	 * @return {object} Object containing the ordered map of results.
	 */
	function mapChildren(children, func, context) {
	  if (children == null) {
	    return children;
	  }
	  var result = [];
	  mapIntoWithKeyPrefixInternal(children, result, null, func, context);
	  return result;
	}
	
	function forEachSingleChildDummy(traverseContext, child, name) {
	  return null;
	}
	
	/**
	 * Count the number of children that are typically specified as
	 * `props.children`.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.count
	 *
	 * @param {?*} children Children tree container.
	 * @return {number} The number of children.
	 */
	function countChildren(children, context) {
	  return traverseAllChildren(children, forEachSingleChildDummy, null);
	}
	
	/**
	 * Flatten a children object (typically specified as `props.children`) and
	 * return an array with appropriately re-keyed children.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.toarray
	 */
	function toArray(children) {
	  var result = [];
	  mapIntoWithKeyPrefixInternal(children, result, null, emptyFunction.thatReturnsArgument);
	  return result;
	}
	
	var ReactChildren = {
	  forEach: forEachChildren,
	  map: mapChildren,
	  mapIntoWithKeyPrefixInternal: mapIntoWithKeyPrefixInternal,
	  count: countChildren,
	  toArray: toArray
	};
	
	module.exports = ReactChildren;

/***/ },
/* 314 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactClass
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(5),
	    _assign = __webpack_require__(6);
	
	var ReactComponent = __webpack_require__(315);
	var ReactElement = __webpack_require__(45);
	var ReactPropTypeLocations = __webpack_require__(205);
	var ReactPropTypeLocationNames = __webpack_require__(204);
	var ReactNoopUpdateQueue = __webpack_require__(326);
	
	var emptyObject = __webpack_require__(116);
	var invariant = __webpack_require__(2);
	var keyMirror = __webpack_require__(117);
	var keyOf = __webpack_require__(50);
	var warning = __webpack_require__(9);
	
	var MIXINS_KEY = keyOf({ mixins: null });
	
	/**
	 * Policies that describe methods in `ReactClassInterface`.
	 */
	var SpecPolicy = keyMirror({
	  /**
	   * These methods may be defined only once by the class specification or mixin.
	   */
	  DEFINE_ONCE: null,
	  /**
	   * These methods may be defined by both the class specification and mixins.
	   * Subsequent definitions will be chained. These methods must return void.
	   */
	  DEFINE_MANY: null,
	  /**
	   * These methods are overriding the base class.
	   */
	  OVERRIDE_BASE: null,
	  /**
	   * These methods are similar to DEFINE_MANY, except we assume they return
	   * objects. We try to merge the keys of the return values of all the mixed in
	   * functions. If there is a key conflict we throw.
	   */
	  DEFINE_MANY_MERGED: null
	});
	
	var injectedMixins = [];
	
	/**
	 * Composite components are higher-level components that compose other composite
	 * or host components.
	 *
	 * To create a new type of `ReactClass`, pass a specification of
	 * your new class to `React.createClass`. The only requirement of your class
	 * specification is that you implement a `render` method.
	 *
	 *   var MyComponent = React.createClass({
	 *     render: function() {
	 *       return <div>Hello World</div>;
	 *     }
	 *   });
	 *
	 * The class specification supports a specific protocol of methods that have
	 * special meaning (e.g. `render`). See `ReactClassInterface` for
	 * more the comprehensive protocol. Any other properties and methods in the
	 * class specification will be available on the prototype.
	 *
	 * @interface ReactClassInterface
	 * @internal
	 */
	var ReactClassInterface = {
	
	  /**
	   * An array of Mixin objects to include when defining your component.
	   *
	   * @type {array}
	   * @optional
	   */
	  mixins: SpecPolicy.DEFINE_MANY,
	
	  /**
	   * An object containing properties and methods that should be defined on
	   * the component's constructor instead of its prototype (static methods).
	   *
	   * @type {object}
	   * @optional
	   */
	  statics: SpecPolicy.DEFINE_MANY,
	
	  /**
	   * Definition of prop types for this component.
	   *
	   * @type {object}
	   * @optional
	   */
	  propTypes: SpecPolicy.DEFINE_MANY,
	
	  /**
	   * Definition of context types for this component.
	   *
	   * @type {object}
	   * @optional
	   */
	  contextTypes: SpecPolicy.DEFINE_MANY,
	
	  /**
	   * Definition of context types this component sets for its children.
	   *
	   * @type {object}
	   * @optional
	   */
	  childContextTypes: SpecPolicy.DEFINE_MANY,
	
	  // ==== Definition methods ====
	
	  /**
	   * Invoked when the component is mounted. Values in the mapping will be set on
	   * `this.props` if that prop is not specified (i.e. using an `in` check).
	   *
	   * This method is invoked before `getInitialState` and therefore cannot rely
	   * on `this.state` or use `this.setState`.
	   *
	   * @return {object}
	   * @optional
	   */
	  getDefaultProps: SpecPolicy.DEFINE_MANY_MERGED,
	
	  /**
	   * Invoked once before the component is mounted. The return value will be used
	   * as the initial value of `this.state`.
	   *
	   *   getInitialState: function() {
	   *     return {
	   *       isOn: false,
	   *       fooBaz: new BazFoo()
	   *     }
	   *   }
	   *
	   * @return {object}
	   * @optional
	   */
	  getInitialState: SpecPolicy.DEFINE_MANY_MERGED,
	
	  /**
	   * @return {object}
	   * @optional
	   */
	  getChildContext: SpecPolicy.DEFINE_MANY_MERGED,
	
	  /**
	   * Uses props from `this.props` and state from `this.state` to render the
	   * structure of the component.
	   *
	   * No guarantees are made about when or how often this method is invoked, so
	   * it must not have side effects.
	   *
	   *   render: function() {
	   *     var name = this.props.name;
	   *     return <div>Hello, {name}!</div>;
	   *   }
	   *
	   * @return {ReactComponent}
	   * @nosideeffects
	   * @required
	   */
	  render: SpecPolicy.DEFINE_ONCE,
	
	  // ==== Delegate methods ====
	
	  /**
	   * Invoked when the component is initially created and about to be mounted.
	   * This may have side effects, but any external subscriptions or data created
	   * by this method must be cleaned up in `componentWillUnmount`.
	   *
	   * @optional
	   */
	  componentWillMount: SpecPolicy.DEFINE_MANY,
	
	  /**
	   * Invoked when the component has been mounted and has a DOM representation.
	   * However, there is no guarantee that the DOM node is in the document.
	   *
	   * Use this as an opportunity to operate on the DOM when the component has
	   * been mounted (initialized and rendered) for the first time.
	   *
	   * @param {DOMElement} rootNode DOM element representing the component.
	   * @optional
	   */
	  componentDidMount: SpecPolicy.DEFINE_MANY,
	
	  /**
	   * Invoked before the component receives new props.
	   *
	   * Use this as an opportunity to react to a prop transition by updating the
	   * state using `this.setState`. Current props are accessed via `this.props`.
	   *
	   *   componentWillReceiveProps: function(nextProps, nextContext) {
	   *     this.setState({
	   *       likesIncreasing: nextProps.likeCount > this.props.likeCount
	   *     });
	   *   }
	   *
	   * NOTE: There is no equivalent `componentWillReceiveState`. An incoming prop
	   * transition may cause a state change, but the opposite is not true. If you
	   * need it, you are probably looking for `componentWillUpdate`.
	   *
	   * @param {object} nextProps
	   * @optional
	   */
	  componentWillReceiveProps: SpecPolicy.DEFINE_MANY,
	
	  /**
	   * Invoked while deciding if the component should be updated as a result of
	   * receiving new props, state and/or context.
	   *
	   * Use this as an opportunity to `return false` when you're certain that the
	   * transition to the new props/state/context will not require a component
	   * update.
	   *
	   *   shouldComponentUpdate: function(nextProps, nextState, nextContext) {
	   *     return !equal(nextProps, this.props) ||
	   *       !equal(nextState, this.state) ||
	   *       !equal(nextContext, this.context);
	   *   }
	   *
	   * @param {object} nextProps
	   * @param {?object} nextState
	   * @param {?object} nextContext
	   * @return {boolean} True if the component should update.
	   * @optional
	   */
	  shouldComponentUpdate: SpecPolicy.DEFINE_ONCE,
	
	  /**
	   * Invoked when the component is about to update due to a transition from
	   * `this.props`, `this.state` and `this.context` to `nextProps`, `nextState`
	   * and `nextContext`.
	   *
	   * Use this as an opportunity to perform preparation before an update occurs.
	   *
	   * NOTE: You **cannot** use `this.setState()` in this method.
	   *
	   * @param {object} nextProps
	   * @param {?object} nextState
	   * @param {?object} nextContext
	   * @param {ReactReconcileTransaction} transaction
	   * @optional
	   */
	  componentWillUpdate: SpecPolicy.DEFINE_MANY,
	
	  /**
	   * Invoked when the component's DOM representation has been updated.
	   *
	   * Use this as an opportunity to operate on the DOM when the component has
	   * been updated.
	   *
	   * @param {object} prevProps
	   * @param {?object} prevState
	   * @param {?object} prevContext
	   * @param {DOMElement} rootNode DOM element representing the component.
	   * @optional
	   */
	  componentDidUpdate: SpecPolicy.DEFINE_MANY,
	
	  /**
	   * Invoked when the component is about to be removed from its parent and have
	   * its DOM representation destroyed.
	   *
	   * Use this as an opportunity to deallocate any external resources.
	   *
	   * NOTE: There is no `componentDidUnmount` since your component will have been
	   * destroyed by that point.
	   *
	   * @optional
	   */
	  componentWillUnmount: SpecPolicy.DEFINE_MANY,
	
	  // ==== Advanced methods ====
	
	  /**
	   * Updates the component's currently mounted DOM representation.
	   *
	   * By default, this implements React's rendering and reconciliation algorithm.
	   * Sophisticated clients may wish to override this.
	   *
	   * @param {ReactReconcileTransaction} transaction
	   * @internal
	   * @overridable
	   */
	  updateComponent: SpecPolicy.OVERRIDE_BASE
	
	};
	
	/**
	 * Mapping from class specification keys to special processing functions.
	 *
	 * Although these are declared like instance properties in the specification
	 * when defining classes using `React.createClass`, they are actually static
	 * and are accessible on the constructor instead of the prototype. Despite
	 * being static, they must be defined outside of the "statics" key under
	 * which all other static methods are defined.
	 */
	var RESERVED_SPEC_KEYS = {
	  displayName: function (Constructor, displayName) {
	    Constructor.displayName = displayName;
	  },
	  mixins: function (Constructor, mixins) {
	    if (mixins) {
	      for (var i = 0; i < mixins.length; i++) {
	        mixSpecIntoComponent(Constructor, mixins[i]);
	      }
	    }
	  },
	  childContextTypes: function (Constructor, childContextTypes) {
	    if (false) {
	      validateTypeDef(Constructor, childContextTypes, ReactPropTypeLocations.childContext);
	    }
	    Constructor.childContextTypes = _assign({}, Constructor.childContextTypes, childContextTypes);
	  },
	  contextTypes: function (Constructor, contextTypes) {
	    if (false) {
	      validateTypeDef(Constructor, contextTypes, ReactPropTypeLocations.context);
	    }
	    Constructor.contextTypes = _assign({}, Constructor.contextTypes, contextTypes);
	  },
	  /**
	   * Special case getDefaultProps which should move into statics but requires
	   * automatic merging.
	   */
	  getDefaultProps: function (Constructor, getDefaultProps) {
	    if (Constructor.getDefaultProps) {
	      Constructor.getDefaultProps = createMergedResultFunction(Constructor.getDefaultProps, getDefaultProps);
	    } else {
	      Constructor.getDefaultProps = getDefaultProps;
	    }
	  },
	  propTypes: function (Constructor, propTypes) {
	    if (false) {
	      validateTypeDef(Constructor, propTypes, ReactPropTypeLocations.prop);
	    }
	    Constructor.propTypes = _assign({}, Constructor.propTypes, propTypes);
	  },
	  statics: function (Constructor, statics) {
	    mixStaticSpecIntoComponent(Constructor, statics);
	  },
	  autobind: function () {} };
	
	// noop
	function validateTypeDef(Constructor, typeDef, location) {
	  for (var propName in typeDef) {
	    if (typeDef.hasOwnProperty(propName)) {
	      // use a warning instead of an invariant so components
	      // don't show up in prod but only in __DEV__
	       false ? warning(typeof typeDef[propName] === 'function', '%s: %s type `%s` is invalid; it must be a function, usually from ' + 'React.PropTypes.', Constructor.displayName || 'ReactClass', ReactPropTypeLocationNames[location], propName) : void 0;
	    }
	  }
	}
	
	function validateMethodOverride(isAlreadyDefined, name) {
	  var specPolicy = ReactClassInterface.hasOwnProperty(name) ? ReactClassInterface[name] : null;
	
	  // Disallow overriding of base class methods unless explicitly allowed.
	  if (ReactClassMixin.hasOwnProperty(name)) {
	    !(specPolicy === SpecPolicy.OVERRIDE_BASE) ?  false ? invariant(false, 'ReactClassInterface: You are attempting to override `%s` from your class specification. Ensure that your method names do not overlap with React methods.', name) : _prodInvariant('73', name) : void 0;
	  }
	
	  // Disallow defining methods more than once unless explicitly allowed.
	  if (isAlreadyDefined) {
	    !(specPolicy === SpecPolicy.DEFINE_MANY || specPolicy === SpecPolicy.DEFINE_MANY_MERGED) ?  false ? invariant(false, 'ReactClassInterface: You are attempting to define `%s` on your component more than once. This conflict may be due to a mixin.', name) : _prodInvariant('74', name) : void 0;
	  }
	}
	
	/**
	 * Mixin helper which handles policy validation and reserved
	 * specification keys when building React classes.
	 */
	function mixSpecIntoComponent(Constructor, spec) {
	  if (!spec) {
	    return;
	  }
	
	  !(typeof spec !== 'function') ?  false ? invariant(false, 'ReactClass: You\'re attempting to use a component class or function as a mixin. Instead, just use a regular object.') : _prodInvariant('75') : void 0;
	  !!ReactElement.isValidElement(spec) ?  false ? invariant(false, 'ReactClass: You\'re attempting to use a component as a mixin. Instead, just use a regular object.') : _prodInvariant('76') : void 0;
	
	  var proto = Constructor.prototype;
	  var autoBindPairs = proto.__reactAutoBindPairs;
	
	  // By handling mixins before any other properties, we ensure the same
	  // chaining order is applied to methods with DEFINE_MANY policy, whether
	  // mixins are listed before or after these methods in the spec.
	  if (spec.hasOwnProperty(MIXINS_KEY)) {
	    RESERVED_SPEC_KEYS.mixins(Constructor, spec.mixins);
	  }
	
	  for (var name in spec) {
	    if (!spec.hasOwnProperty(name)) {
	      continue;
	    }
	
	    if (name === MIXINS_KEY) {
	      // We have already handled mixins in a special case above.
	      continue;
	    }
	
	    var property = spec[name];
	    var isAlreadyDefined = proto.hasOwnProperty(name);
	    validateMethodOverride(isAlreadyDefined, name);
	
	    if (RESERVED_SPEC_KEYS.hasOwnProperty(name)) {
	      RESERVED_SPEC_KEYS[name](Constructor, property);
	    } else {
	      // Setup methods on prototype:
	      // The following member methods should not be automatically bound:
	      // 1. Expected ReactClass methods (in the "interface").
	      // 2. Overridden methods (that were mixed in).
	      var isReactClassMethod = ReactClassInterface.hasOwnProperty(name);
	      var isFunction = typeof property === 'function';
	      var shouldAutoBind = isFunction && !isReactClassMethod && !isAlreadyDefined && spec.autobind !== false;
	
	      if (shouldAutoBind) {
	        autoBindPairs.push(name, property);
	        proto[name] = property;
	      } else {
	        if (isAlreadyDefined) {
	          var specPolicy = ReactClassInterface[name];
	
	          // These cases should already be caught by validateMethodOverride.
	          !(isReactClassMethod && (specPolicy === SpecPolicy.DEFINE_MANY_MERGED || specPolicy === SpecPolicy.DEFINE_MANY)) ?  false ? invariant(false, 'ReactClass: Unexpected spec policy %s for key %s when mixing in component specs.', specPolicy, name) : _prodInvariant('77', specPolicy, name) : void 0;
	
	          // For methods which are defined more than once, call the existing
	          // methods before calling the new property, merging if appropriate.
	          if (specPolicy === SpecPolicy.DEFINE_MANY_MERGED) {
	            proto[name] = createMergedResultFunction(proto[name], property);
	          } else if (specPolicy === SpecPolicy.DEFINE_MANY) {
	            proto[name] = createChainedFunction(proto[name], property);
	          }
	        } else {
	          proto[name] = property;
	          if (false) {
	            // Add verbose displayName to the function, which helps when looking
	            // at profiling tools.
	            if (typeof property === 'function' && spec.displayName) {
	              proto[name].displayName = spec.displayName + '_' + name;
	            }
	          }
	        }
	      }
	    }
	  }
	}
	
	function mixStaticSpecIntoComponent(Constructor, statics) {
	  if (!statics) {
	    return;
	  }
	  for (var name in statics) {
	    var property = statics[name];
	    if (!statics.hasOwnProperty(name)) {
	      continue;
	    }
	
	    var isReserved = name in RESERVED_SPEC_KEYS;
	    !!isReserved ?  false ? invariant(false, 'ReactClass: You are attempting to define a reserved property, `%s`, that shouldn\'t be on the "statics" key. Define it as an instance property instead; it will still be accessible on the constructor.', name) : _prodInvariant('78', name) : void 0;
	
	    var isInherited = name in Constructor;
	    !!isInherited ?  false ? invariant(false, 'ReactClass: You are attempting to define `%s` on your component more than once. This conflict may be due to a mixin.', name) : _prodInvariant('79', name) : void 0;
	    Constructor[name] = property;
	  }
	}
	
	/**
	 * Merge two objects, but throw if both contain the same key.
	 *
	 * @param {object} one The first object, which is mutated.
	 * @param {object} two The second object
	 * @return {object} one after it has been mutated to contain everything in two.
	 */
	function mergeIntoWithNoDuplicateKeys(one, two) {
	  !(one && two && typeof one === 'object' && typeof two === 'object') ?  false ? invariant(false, 'mergeIntoWithNoDuplicateKeys(): Cannot merge non-objects.') : _prodInvariant('80') : void 0;
	
	  for (var key in two) {
	    if (two.hasOwnProperty(key)) {
	      !(one[key] === undefined) ?  false ? invariant(false, 'mergeIntoWithNoDuplicateKeys(): Tried to merge two objects with the same key: `%s`. This conflict may be due to a mixin; in particular, this may be caused by two getInitialState() or getDefaultProps() methods returning objects with clashing keys.', key) : _prodInvariant('81', key) : void 0;
	      one[key] = two[key];
	    }
	  }
	  return one;
	}
	
	/**
	 * Creates a function that invokes two functions and merges their return values.
	 *
	 * @param {function} one Function to invoke first.
	 * @param {function} two Function to invoke second.
	 * @return {function} Function that invokes the two argument functions.
	 * @private
	 */
	function createMergedResultFunction(one, two) {
	  return function mergedResult() {
	    var a = one.apply(this, arguments);
	    var b = two.apply(this, arguments);
	    if (a == null) {
	      return b;
	    } else if (b == null) {
	      return a;
	    }
	    var c = {};
	    mergeIntoWithNoDuplicateKeys(c, a);
	    mergeIntoWithNoDuplicateKeys(c, b);
	    return c;
	  };
	}
	
	/**
	 * Creates a function that invokes two functions and ignores their return vales.
	 *
	 * @param {function} one Function to invoke first.
	 * @param {function} two Function to invoke second.
	 * @return {function} Function that invokes the two argument functions.
	 * @private
	 */
	function createChainedFunction(one, two) {
	  return function chainedFunction() {
	    one.apply(this, arguments);
	    two.apply(this, arguments);
	  };
	}
	
	/**
	 * Binds a method to the component.
	 *
	 * @param {object} component Component whose method is going to be bound.
	 * @param {function} method Method to be bound.
	 * @return {function} The bound method.
	 */
	function bindAutoBindMethod(component, method) {
	  var boundMethod = method.bind(component);
	  if (false) {
	    boundMethod.__reactBoundContext = component;
	    boundMethod.__reactBoundMethod = method;
	    boundMethod.__reactBoundArguments = null;
	    var componentName = component.constructor.displayName;
	    var _bind = boundMethod.bind;
	    boundMethod.bind = function (newThis) {
	      for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	        args[_key - 1] = arguments[_key];
	      }
	
	      // User is trying to bind() an autobound method; we effectively will
	      // ignore the value of "this" that the user is trying to use, so
	      // let's warn.
	      if (newThis !== component && newThis !== null) {
	        process.env.NODE_ENV !== 'production' ? warning(false, 'bind(): React component methods may only be bound to the ' + 'component instance. See %s', componentName) : void 0;
	      } else if (!args.length) {
	        process.env.NODE_ENV !== 'production' ? warning(false, 'bind(): You are binding a component method to the component. ' + 'React does this for you automatically in a high-performance ' + 'way, so you can safely remove this call. See %s', componentName) : void 0;
	        return boundMethod;
	      }
	      var reboundMethod = _bind.apply(boundMethod, arguments);
	      reboundMethod.__reactBoundContext = component;
	      reboundMethod.__reactBoundMethod = method;
	      reboundMethod.__reactBoundArguments = args;
	      return reboundMethod;
	    };
	  }
	  return boundMethod;
	}
	
	/**
	 * Binds all auto-bound methods in a component.
	 *
	 * @param {object} component Component whose method is going to be bound.
	 */
	function bindAutoBindMethods(component) {
	  var pairs = component.__reactAutoBindPairs;
	  for (var i = 0; i < pairs.length; i += 2) {
	    var autoBindKey = pairs[i];
	    var method = pairs[i + 1];
	    component[autoBindKey] = bindAutoBindMethod(component, method);
	  }
	}
	
	/**
	 * Add more to the ReactClass base class. These are all legacy features and
	 * therefore not already part of the modern ReactComponent.
	 */
	var ReactClassMixin = {
	
	  /**
	   * TODO: This will be deprecated because state should always keep a consistent
	   * type signature and the only use case for this, is to avoid that.
	   */
	  replaceState: function (newState, callback) {
	    this.updater.enqueueReplaceState(this, newState);
	    if (callback) {
	      this.updater.enqueueCallback(this, callback, 'replaceState');
	    }
	  },
	
	  /**
	   * Checks whether or not this composite component is mounted.
	   * @return {boolean} True if mounted, false otherwise.
	   * @protected
	   * @final
	   */
	  isMounted: function () {
	    return this.updater.isMounted(this);
	  }
	};
	
	var ReactClassComponent = function () {};
	_assign(ReactClassComponent.prototype, ReactComponent.prototype, ReactClassMixin);
	
	/**
	 * Module for creating composite components.
	 *
	 * @class ReactClass
	 */
	var ReactClass = {
	
	  /**
	   * Creates a composite component class given a class specification.
	   * See https://facebook.github.io/react/docs/top-level-api.html#react.createclass
	   *
	   * @param {object} spec Class specification (which must define `render`).
	   * @return {function} Component constructor function.
	   * @public
	   */
	  createClass: function (spec) {
	    var Constructor = function (props, context, updater) {
	      // This constructor gets overridden by mocks. The argument is used
	      // by mocks to assert on what gets mounted.
	
	      if (false) {
	        process.env.NODE_ENV !== 'production' ? warning(this instanceof Constructor, 'Something is calling a React component directly. Use a factory or ' + 'JSX instead. See: https://fb.me/react-legacyfactory') : void 0;
	      }
	
	      // Wire up auto-binding
	      if (this.__reactAutoBindPairs.length) {
	        bindAutoBindMethods(this);
	      }
	
	      this.props = props;
	      this.context = context;
	      this.refs = emptyObject;
	      this.updater = updater || ReactNoopUpdateQueue;
	
	      this.state = null;
	
	      // ReactClasses doesn't have constructors. Instead, they use the
	      // getInitialState and componentWillMount methods for initialization.
	
	      var initialState = this.getInitialState ? this.getInitialState() : null;
	      if (false) {
	        // We allow auto-mocks to proceed as if they're returning null.
	        if (initialState === undefined && this.getInitialState._isMockFunction) {
	          // This is probably bad practice. Consider warning here and
	          // deprecating this convenience.
	          initialState = null;
	        }
	      }
	      !(typeof initialState === 'object' && !Array.isArray(initialState)) ?  false ? invariant(false, '%s.getInitialState(): must return an object or null', Constructor.displayName || 'ReactCompositeComponent') : _prodInvariant('82', Constructor.displayName || 'ReactCompositeComponent') : void 0;
	
	      this.state = initialState;
	    };
	    Constructor.prototype = new ReactClassComponent();
	    Constructor.prototype.constructor = Constructor;
	    Constructor.prototype.__reactAutoBindPairs = [];
	
	    injectedMixins.forEach(mixSpecIntoComponent.bind(null, Constructor));
	
	    mixSpecIntoComponent(Constructor, spec);
	
	    // Initialize the defaultProps property after all mixins have been merged.
	    if (Constructor.getDefaultProps) {
	      Constructor.defaultProps = Constructor.getDefaultProps();
	    }
	
	    if (false) {
	      // This is a tag to indicate that the use of these method names is ok,
	      // since it's used with createClass. If it's not, then it's likely a
	      // mistake so we'll warn you to use the static property, property
	      // initializer or constructor respectively.
	      if (Constructor.getDefaultProps) {
	        Constructor.getDefaultProps.isReactClassApproved = {};
	      }
	      if (Constructor.prototype.getInitialState) {
	        Constructor.prototype.getInitialState.isReactClassApproved = {};
	      }
	    }
	
	    !Constructor.prototype.render ?  false ? invariant(false, 'createClass(...): Class specification must implement a `render` method.') : _prodInvariant('83') : void 0;
	
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(!Constructor.prototype.componentShouldUpdate, '%s has a method called ' + 'componentShouldUpdate(). Did you mean shouldComponentUpdate()? ' + 'The name is phrased as a question because the function is ' + 'expected to return a value.', spec.displayName || 'A component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(!Constructor.prototype.componentWillRecieveProps, '%s has a method called ' + 'componentWillRecieveProps(). Did you mean componentWillReceiveProps()?', spec.displayName || 'A component') : void 0;
	    }
	
	    // Reduce time spent doing lookups by setting these on the prototype.
	    for (var methodName in ReactClassInterface) {
	      if (!Constructor.prototype[methodName]) {
	        Constructor.prototype[methodName] = null;
	      }
	    }
	
	    return Constructor;
	  },
	
	  injection: {
	    injectMixin: function (mixin) {
	      injectedMixins.push(mixin);
	    }
	  }
	
	};
	
	module.exports = ReactClass;

/***/ },
/* 315 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactComponent
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(5);
	
	var ReactNoopUpdateQueue = __webpack_require__(326);
	
	var canDefineProperty = __webpack_require__(331);
	var emptyObject = __webpack_require__(116);
	var invariant = __webpack_require__(2);
	var warning = __webpack_require__(9);
	
	/**
	 * Base class helpers for the updating state of a component.
	 */
	function ReactComponent(props, context, updater) {
	  this.props = props;
	  this.context = context;
	  this.refs = emptyObject;
	  // We initialize the default updater but the real one gets injected by the
	  // renderer.
	  this.updater = updater || ReactNoopUpdateQueue;
	}
	
	ReactComponent.prototype.isReactComponent = {};
	
	/**
	 * Sets a subset of the state. Always use this to mutate
	 * state. You should treat `this.state` as immutable.
	 *
	 * There is no guarantee that `this.state` will be immediately updated, so
	 * accessing `this.state` after calling this method may return the old value.
	 *
	 * There is no guarantee that calls to `setState` will run synchronously,
	 * as they may eventually be batched together.  You can provide an optional
	 * callback that will be executed when the call to setState is actually
	 * completed.
	 *
	 * When a function is provided to setState, it will be called at some point in
	 * the future (not synchronously). It will be called with the up to date
	 * component arguments (state, props, context). These values can be different
	 * from this.* because your function may be called after receiveProps but before
	 * shouldComponentUpdate, and this new state, props, and context will not yet be
	 * assigned to this.
	 *
	 * @param {object|function} partialState Next partial state or function to
	 *        produce next partial state to be merged with current state.
	 * @param {?function} callback Called after state is updated.
	 * @final
	 * @protected
	 */
	ReactComponent.prototype.setState = function (partialState, callback) {
	  !(typeof partialState === 'object' || typeof partialState === 'function' || partialState == null) ?  false ? invariant(false, 'setState(...): takes an object of state variables to update or a function which returns an object of state variables.') : _prodInvariant('85') : void 0;
	  this.updater.enqueueSetState(this, partialState);
	  if (callback) {
	    this.updater.enqueueCallback(this, callback, 'setState');
	  }
	};
	
	/**
	 * Forces an update. This should only be invoked when it is known with
	 * certainty that we are **not** in a DOM transaction.
	 *
	 * You may want to call this when you know that some deeper aspect of the
	 * component's state has changed but `setState` was not called.
	 *
	 * This will not invoke `shouldComponentUpdate`, but it will invoke
	 * `componentWillUpdate` and `componentDidUpdate`.
	 *
	 * @param {?function} callback Called after update is complete.
	 * @final
	 * @protected
	 */
	ReactComponent.prototype.forceUpdate = function (callback) {
	  this.updater.enqueueForceUpdate(this);
	  if (callback) {
	    this.updater.enqueueCallback(this, callback, 'forceUpdate');
	  }
	};
	
	/**
	 * Deprecated APIs. These APIs used to exist on classic React classes but since
	 * we would like to deprecate them, we're not going to move them over to this
	 * modern base class. Instead, we define a getter that warns if it's accessed.
	 */
	if (false) {
	  var deprecatedAPIs = {
	    isMounted: ['isMounted', 'Instead, make sure to clean up subscriptions and pending requests in ' + 'componentWillUnmount to prevent memory leaks.'],
	    replaceState: ['replaceState', 'Refactor your code to use setState instead (see ' + 'https://github.com/facebook/react/issues/3236).']
	  };
	  var defineDeprecationWarning = function (methodName, info) {
	    if (canDefineProperty) {
	      Object.defineProperty(ReactComponent.prototype, methodName, {
	        get: function () {
	          process.env.NODE_ENV !== 'production' ? warning(false, '%s(...) is deprecated in plain JavaScript React classes. %s', info[0], info[1]) : void 0;
	          return undefined;
	        }
	      });
	    }
	  };
	  for (var fnName in deprecatedAPIs) {
	    if (deprecatedAPIs.hasOwnProperty(fnName)) {
	      defineDeprecationWarning(fnName, deprecatedAPIs[fnName]);
	    }
	  }
	}
	
	module.exports = ReactComponent;

/***/ },
/* 316 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactComponentBrowserEnvironment
	 */
	
	'use strict';
	
	var DOMChildrenOperations = __webpack_require__(196);
	var ReactDOMIDOperations = __webpack_require__(757);
	
	/**
	 * Abstracts away all functionality of the reconciler that requires knowledge of
	 * the browser context. TODO: These callers should be refactored to avoid the
	 * need for this injection.
	 */
	var ReactComponentBrowserEnvironment = {
	
	  processChildrenUpdates: ReactDOMIDOperations.dangerouslyProcessChildrenUpdates,
	
	  replaceNodeWithMarkup: DOMChildrenOperations.dangerouslyReplaceNodeWithMarkup,
	
	  /**
	   * If a particular environment requires that some resources be cleaned up,
	   * specify this in the injected Mixin. In the DOM, we would likely want to
	   * purge any cached node ID lookups.
	   *
	   * @private
	   */
	  unmountIDFromEnvironment: function (rootNodeID) {}
	
	};
	
	module.exports = ReactComponentBrowserEnvironment;

/***/ },
/* 317 */
/***/ function(module, exports) {

	/**
	 * Copyright 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDOMComponentFlags
	 */
	
	'use strict';
	
	var ReactDOMComponentFlags = {
	  hasCachedChildNodes: 1 << 0
	};
	
	module.exports = ReactDOMComponentFlags;

/***/ },
/* 318 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDOMSelect
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(6);
	
	var DisabledInputUtils = __webpack_require__(139);
	var LinkedValueUtils = __webpack_require__(201);
	var ReactDOMComponentTree = __webpack_require__(15);
	var ReactUpdates = __webpack_require__(46);
	
	var warning = __webpack_require__(9);
	
	var didWarnValueLink = false;
	var didWarnValueDefaultValue = false;
	
	function updateOptionsIfPendingUpdateAndMounted() {
	  if (this._rootNodeID && this._wrapperState.pendingUpdate) {
	    this._wrapperState.pendingUpdate = false;
	
	    var props = this._currentElement.props;
	    var value = LinkedValueUtils.getValue(props);
	
	    if (value != null) {
	      updateOptions(this, Boolean(props.multiple), value);
	    }
	  }
	}
	
	function getDeclarationErrorAddendum(owner) {
	  if (owner) {
	    var name = owner.getName();
	    if (name) {
	      return ' Check the render method of `' + name + '`.';
	    }
	  }
	  return '';
	}
	
	var valuePropNames = ['value', 'defaultValue'];
	
	/**
	 * Validation function for `value` and `defaultValue`.
	 * @private
	 */
	function checkSelectPropTypes(inst, props) {
	  var owner = inst._currentElement._owner;
	  LinkedValueUtils.checkPropTypes('select', props, owner);
	
	  if (props.valueLink !== undefined && !didWarnValueLink) {
	     false ? warning(false, '`valueLink` prop on `select` is deprecated; set `value` and `onChange` instead.') : void 0;
	    didWarnValueLink = true;
	  }
	
	  for (var i = 0; i < valuePropNames.length; i++) {
	    var propName = valuePropNames[i];
	    if (props[propName] == null) {
	      continue;
	    }
	    if (props.multiple) {
	       false ? warning(Array.isArray(props[propName]), 'The `%s` prop supplied to <select> must be an array if ' + '`multiple` is true.%s', propName, getDeclarationErrorAddendum(owner)) : void 0;
	    } else {
	       false ? warning(!Array.isArray(props[propName]), 'The `%s` prop supplied to <select> must be a scalar ' + 'value if `multiple` is false.%s', propName, getDeclarationErrorAddendum(owner)) : void 0;
	    }
	  }
	}
	
	/**
	 * @param {ReactDOMComponent} inst
	 * @param {boolean} multiple
	 * @param {*} propValue A stringable (with `multiple`, a list of stringables).
	 * @private
	 */
	function updateOptions(inst, multiple, propValue) {
	  var selectedValue, i;
	  var options = ReactDOMComponentTree.getNodeFromInstance(inst).options;
	
	  if (multiple) {
	    selectedValue = {};
	    for (i = 0; i < propValue.length; i++) {
	      selectedValue['' + propValue[i]] = true;
	    }
	    for (i = 0; i < options.length; i++) {
	      var selected = selectedValue.hasOwnProperty(options[i].value);
	      if (options[i].selected !== selected) {
	        options[i].selected = selected;
	      }
	    }
	  } else {
	    // Do not set `select.value` as exact behavior isn't consistent across all
	    // browsers for all cases.
	    selectedValue = '' + propValue;
	    for (i = 0; i < options.length; i++) {
	      if (options[i].value === selectedValue) {
	        options[i].selected = true;
	        return;
	      }
	    }
	    if (options.length) {
	      options[0].selected = true;
	    }
	  }
	}
	
	/**
	 * Implements a <select> host component that allows optionally setting the
	 * props `value` and `defaultValue`. If `multiple` is false, the prop must be a
	 * stringable. If `multiple` is true, the prop must be an array of stringables.
	 *
	 * If `value` is not supplied (or null/undefined), user actions that change the
	 * selected option will trigger updates to the rendered options.
	 *
	 * If it is supplied (and not null/undefined), the rendered options will not
	 * update in response to user actions. Instead, the `value` prop must change in
	 * order for the rendered options to update.
	 *
	 * If `defaultValue` is provided, any options with the supplied values will be
	 * selected.
	 */
	var ReactDOMSelect = {
	  getHostProps: function (inst, props) {
	    return _assign({}, DisabledInputUtils.getHostProps(inst, props), {
	      onChange: inst._wrapperState.onChange,
	      value: undefined
	    });
	  },
	
	  mountWrapper: function (inst, props) {
	    if (false) {
	      checkSelectPropTypes(inst, props);
	    }
	
	    var value = LinkedValueUtils.getValue(props);
	    inst._wrapperState = {
	      pendingUpdate: false,
	      initialValue: value != null ? value : props.defaultValue,
	      listeners: null,
	      onChange: _handleChange.bind(inst),
	      wasMultiple: Boolean(props.multiple)
	    };
	
	    if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValueDefaultValue) {
	       false ? warning(false, 'Select elements must be either controlled or uncontrolled ' + '(specify either the value prop, or the defaultValue prop, but not ' + 'both). Decide between using a controlled or uncontrolled select ' + 'element and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components') : void 0;
	      didWarnValueDefaultValue = true;
	    }
	  },
	
	  getSelectValueContext: function (inst) {
	    // ReactDOMOption looks at this initial value so the initial generated
	    // markup has correct `selected` attributes
	    return inst._wrapperState.initialValue;
	  },
	
	  postUpdateWrapper: function (inst) {
	    var props = inst._currentElement.props;
	
	    // After the initial mount, we control selected-ness manually so don't pass
	    // this value down
	    inst._wrapperState.initialValue = undefined;
	
	    var wasMultiple = inst._wrapperState.wasMultiple;
	    inst._wrapperState.wasMultiple = Boolean(props.multiple);
	
	    var value = LinkedValueUtils.getValue(props);
	    if (value != null) {
	      inst._wrapperState.pendingUpdate = false;
	      updateOptions(inst, Boolean(props.multiple), value);
	    } else if (wasMultiple !== Boolean(props.multiple)) {
	      // For simplicity, reapply `defaultValue` if `multiple` is toggled.
	      if (props.defaultValue != null) {
	        updateOptions(inst, Boolean(props.multiple), props.defaultValue);
	      } else {
	        // Revert the select back to its default unselected state.
	        updateOptions(inst, Boolean(props.multiple), props.multiple ? [] : '');
	      }
	    }
	  }
	};
	
	function _handleChange(event) {
	  var props = this._currentElement.props;
	  var returnValue = LinkedValueUtils.executeOnChange(props, event);
	
	  if (this._rootNodeID) {
	    this._wrapperState.pendingUpdate = true;
	  }
	  ReactUpdates.asap(updateOptionsIfPendingUpdateAndMounted, this);
	  return returnValue;
	}
	
	module.exports = ReactDOMSelect;

/***/ },
/* 319 */
/***/ function(module, exports) {

	/**
	 * Copyright 2014-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactEmptyComponent
	 */
	
	'use strict';
	
	var emptyComponentFactory;
	
	var ReactEmptyComponentInjection = {
	  injectEmptyComponentFactory: function (factory) {
	    emptyComponentFactory = factory;
	  }
	};
	
	var ReactEmptyComponent = {
	  create: function (instantiate) {
	    return emptyComponentFactory(instantiate);
	  }
	};
	
	ReactEmptyComponent.injection = ReactEmptyComponentInjection;
	
	module.exports = ReactEmptyComponent;

/***/ },
/* 320 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactFeatureFlags
	 * 
	 */
	
	'use strict';
	
	var ReactFeatureFlags = {
	  // When true, call console.time() before and .timeEnd() after each top-level
	  // render (both initial renders and updates). Useful when looking at prod-mode
	  // timeline profiles in Chrome, for example.
	  logTopLevelRenders: false
	};
	
	module.exports = ReactFeatureFlags;

/***/ },
/* 321 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactHostComponent
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(5),
	    _assign = __webpack_require__(6);
	
	var invariant = __webpack_require__(2);
	
	var genericComponentClass = null;
	// This registry keeps track of wrapper classes around host tags.
	var tagToComponentClass = {};
	var textComponentClass = null;
	
	var ReactHostComponentInjection = {
	  // This accepts a class that receives the tag string. This is a catch all
	  // that can render any kind of tag.
	  injectGenericComponentClass: function (componentClass) {
	    genericComponentClass = componentClass;
	  },
	  // This accepts a text component class that takes the text string to be
	  // rendered as props.
	  injectTextComponentClass: function (componentClass) {
	    textComponentClass = componentClass;
	  },
	  // This accepts a keyed object with classes as values. Each key represents a
	  // tag. That particular tag will use this class instead of the generic one.
	  injectComponentClasses: function (componentClasses) {
	    _assign(tagToComponentClass, componentClasses);
	  }
	};
	
	/**
	 * Get a host internal component class for a specific tag.
	 *
	 * @param {ReactElement} element The element to create.
	 * @return {function} The internal class constructor function.
	 */
	function createInternalComponent(element) {
	  !genericComponentClass ?  false ? invariant(false, 'There is no registered component for the tag %s', element.type) : _prodInvariant('111', element.type) : void 0;
	  return new genericComponentClass(element);
	}
	
	/**
	 * @param {ReactText} text
	 * @return {ReactComponent}
	 */
	function createInstanceForText(text) {
	  return new textComponentClass(text);
	}
	
	/**
	 * @param {ReactComponent} component
	 * @return {boolean}
	 */
	function isTextComponent(component) {
	  return component instanceof textComponentClass;
	}
	
	var ReactHostComponent = {
	  createInternalComponent: createInternalComponent,
	  createInstanceForText: createInstanceForText,
	  isTextComponent: isTextComponent,
	  injection: ReactHostComponentInjection
	};
	
	module.exports = ReactHostComponent;

/***/ },
/* 322 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactInputSelection
	 */
	
	'use strict';
	
	var ReactDOMSelection = __webpack_require__(761);
	
	var containsNode = __webpack_require__(540);
	var focusNode = __webpack_require__(245);
	var getActiveElement = __webpack_require__(246);
	
	function isInDocument(node) {
	  return containsNode(document.documentElement, node);
	}
	
	/**
	 * @ReactInputSelection: React input selection module. Based on Selection.js,
	 * but modified to be suitable for react and has a couple of bug fixes (doesn't
	 * assume buttons have range selections allowed).
	 * Input selection module for React.
	 */
	var ReactInputSelection = {
	
	  hasSelectionCapabilities: function (elem) {
	    var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
	    return nodeName && (nodeName === 'input' && elem.type === 'text' || nodeName === 'textarea' || elem.contentEditable === 'true');
	  },
	
	  getSelectionInformation: function () {
	    var focusedElem = getActiveElement();
	    return {
	      focusedElem: focusedElem,
	      selectionRange: ReactInputSelection.hasSelectionCapabilities(focusedElem) ? ReactInputSelection.getSelection(focusedElem) : null
	    };
	  },
	
	  /**
	   * @restoreSelection: If any selection information was potentially lost,
	   * restore it. This is useful when performing operations that could remove dom
	   * nodes and place them back in, resulting in focus being lost.
	   */
	  restoreSelection: function (priorSelectionInformation) {
	    var curFocusedElem = getActiveElement();
	    var priorFocusedElem = priorSelectionInformation.focusedElem;
	    var priorSelectionRange = priorSelectionInformation.selectionRange;
	    if (curFocusedElem !== priorFocusedElem && isInDocument(priorFocusedElem)) {
	      if (ReactInputSelection.hasSelectionCapabilities(priorFocusedElem)) {
	        ReactInputSelection.setSelection(priorFocusedElem, priorSelectionRange);
	      }
	      focusNode(priorFocusedElem);
	    }
	  },
	
	  /**
	   * @getSelection: Gets the selection bounds of a focused textarea, input or
	   * contentEditable node.
	   * -@input: Look up selection bounds of this input
	   * -@return {start: selectionStart, end: selectionEnd}
	   */
	  getSelection: function (input) {
	    var selection;
	
	    if ('selectionStart' in input) {
	      // Modern browser with input or textarea.
	      selection = {
	        start: input.selectionStart,
	        end: input.selectionEnd
	      };
	    } else if (document.selection && input.nodeName && input.nodeName.toLowerCase() === 'input') {
	      // IE8 input.
	      var range = document.selection.createRange();
	      // There can only be one selection per document in IE, so it must
	      // be in our element.
	      if (range.parentElement() === input) {
	        selection = {
	          start: -range.moveStart('character', -input.value.length),
	          end: -range.moveEnd('character', -input.value.length)
	        };
	      }
	    } else {
	      // Content editable or old IE textarea.
	      selection = ReactDOMSelection.getOffsets(input);
	    }
	
	    return selection || { start: 0, end: 0 };
	  },
	
	  /**
	   * @setSelection: Sets the selection bounds of a textarea or input and focuses
	   * the input.
	   * -@input     Set selection bounds of this input or textarea
	   * -@offsets   Object of same form that is returned from get*
	   */
	  setSelection: function (input, offsets) {
	    var start = offsets.start;
	    var end = offsets.end;
	    if (end === undefined) {
	      end = start;
	    }
	
	    if ('selectionStart' in input) {
	      input.selectionStart = start;
	      input.selectionEnd = Math.min(end, input.value.length);
	    } else if (document.selection && input.nodeName && input.nodeName.toLowerCase() === 'input') {
	      var range = input.createTextRange();
	      range.collapse(true);
	      range.moveStart('character', start);
	      range.moveEnd('character', end - start);
	      range.select();
	    } else {
	      ReactDOMSelection.setOffsets(input, offsets);
	    }
	  }
	};
	
	module.exports = ReactInputSelection;

/***/ },
/* 323 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactMount
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(5);
	
	var DOMLazyTree = __webpack_require__(89);
	var DOMProperty = __webpack_require__(90);
	var ReactBrowserEventEmitter = __webpack_require__(140);
	var ReactCurrentOwner = __webpack_require__(75);
	var ReactDOMComponentTree = __webpack_require__(15);
	var ReactDOMContainerInfo = __webpack_require__(753);
	var ReactDOMFeatureFlags = __webpack_require__(756);
	var ReactElement = __webpack_require__(45);
	var ReactFeatureFlags = __webpack_require__(320);
	var ReactInstanceMap = __webpack_require__(101);
	var ReactInstrumentation = __webpack_require__(31);
	var ReactMarkupChecksum = __webpack_require__(770);
	var ReactReconciler = __webpack_require__(91);
	var ReactUpdateQueue = __webpack_require__(206);
	var ReactUpdates = __webpack_require__(46);
	
	var emptyObject = __webpack_require__(116);
	var instantiateReactComponent = __webpack_require__(336);
	var invariant = __webpack_require__(2);
	var setInnerHTML = __webpack_require__(143);
	var shouldUpdateReactComponent = __webpack_require__(212);
	var warning = __webpack_require__(9);
	
	var ATTR_NAME = DOMProperty.ID_ATTRIBUTE_NAME;
	var ROOT_ATTR_NAME = DOMProperty.ROOT_ATTRIBUTE_NAME;
	
	var ELEMENT_NODE_TYPE = 1;
	var DOC_NODE_TYPE = 9;
	var DOCUMENT_FRAGMENT_NODE_TYPE = 11;
	
	var instancesByReactRootID = {};
	
	/**
	 * Finds the index of the first character
	 * that's not common between the two given strings.
	 *
	 * @return {number} the index of the character where the strings diverge
	 */
	function firstDifferenceIndex(string1, string2) {
	  var minLen = Math.min(string1.length, string2.length);
	  for (var i = 0; i < minLen; i++) {
	    if (string1.charAt(i) !== string2.charAt(i)) {
	      return i;
	    }
	  }
	  return string1.length === string2.length ? -1 : minLen;
	}
	
	/**
	 * @param {DOMElement|DOMDocument} container DOM element that may contain
	 * a React component
	 * @return {?*} DOM element that may have the reactRoot ID, or null.
	 */
	function getReactRootElementInContainer(container) {
	  if (!container) {
	    return null;
	  }
	
	  if (container.nodeType === DOC_NODE_TYPE) {
	    return container.documentElement;
	  } else {
	    return container.firstChild;
	  }
	}
	
	function internalGetID(node) {
	  // If node is something like a window, document, or text node, none of
	  // which support attributes or a .getAttribute method, gracefully return
	  // the empty string, as if the attribute were missing.
	  return node.getAttribute && node.getAttribute(ATTR_NAME) || '';
	}
	
	/**
	 * Mounts this component and inserts it into the DOM.
	 *
	 * @param {ReactComponent} componentInstance The instance to mount.
	 * @param {DOMElement} container DOM element to mount into.
	 * @param {ReactReconcileTransaction} transaction
	 * @param {boolean} shouldReuseMarkup If true, do not insert markup
	 */
	function mountComponentIntoNode(wrapperInstance, container, transaction, shouldReuseMarkup, context) {
	  var markerName;
	  if (ReactFeatureFlags.logTopLevelRenders) {
	    var wrappedElement = wrapperInstance._currentElement.props;
	    var type = wrappedElement.type;
	    markerName = 'React mount: ' + (typeof type === 'string' ? type : type.displayName || type.name);
	    console.time(markerName);
	  }
	
	  var markup = ReactReconciler.mountComponent(wrapperInstance, transaction, null, ReactDOMContainerInfo(wrapperInstance, container), context);
	
	  if (markerName) {
	    console.timeEnd(markerName);
	  }
	
	  wrapperInstance._renderedComponent._topLevelWrapper = wrapperInstance;
	  ReactMount._mountImageIntoNode(markup, container, wrapperInstance, shouldReuseMarkup, transaction);
	}
	
	/**
	 * Batched mount.
	 *
	 * @param {ReactComponent} componentInstance The instance to mount.
	 * @param {DOMElement} container DOM element to mount into.
	 * @param {boolean} shouldReuseMarkup If true, do not insert markup
	 */
	function batchedMountComponentIntoNode(componentInstance, container, shouldReuseMarkup, context) {
	  var transaction = ReactUpdates.ReactReconcileTransaction.getPooled(
	  /* useCreateElement */
	  !shouldReuseMarkup && ReactDOMFeatureFlags.useCreateElement);
	  transaction.perform(mountComponentIntoNode, null, componentInstance, container, transaction, shouldReuseMarkup, context);
	  ReactUpdates.ReactReconcileTransaction.release(transaction);
	}
	
	/**
	 * Unmounts a component and removes it from the DOM.
	 *
	 * @param {ReactComponent} instance React component instance.
	 * @param {DOMElement} container DOM element to unmount from.
	 * @final
	 * @internal
	 * @see {ReactMount.unmountComponentAtNode}
	 */
	function unmountComponentFromNode(instance, container, safely) {
	  if (false) {
	    ReactInstrumentation.debugTool.onBeginFlush();
	  }
	  ReactReconciler.unmountComponent(instance, safely);
	  if (false) {
	    ReactInstrumentation.debugTool.onEndFlush();
	  }
	
	  if (container.nodeType === DOC_NODE_TYPE) {
	    container = container.documentElement;
	  }
	
	  // http://jsperf.com/emptying-a-node
	  while (container.lastChild) {
	    container.removeChild(container.lastChild);
	  }
	}
	
	/**
	 * True if the supplied DOM node has a direct React-rendered child that is
	 * not a React root element. Useful for warning in `render`,
	 * `unmountComponentAtNode`, etc.
	 *
	 * @param {?DOMElement} node The candidate DOM node.
	 * @return {boolean} True if the DOM element contains a direct child that was
	 * rendered by React but is not a root element.
	 * @internal
	 */
	function hasNonRootReactChild(container) {
	  var rootEl = getReactRootElementInContainer(container);
	  if (rootEl) {
	    var inst = ReactDOMComponentTree.getInstanceFromNode(rootEl);
	    return !!(inst && inst._hostParent);
	  }
	}
	
	function getHostRootInstanceInContainer(container) {
	  var rootEl = getReactRootElementInContainer(container);
	  var prevHostInstance = rootEl && ReactDOMComponentTree.getInstanceFromNode(rootEl);
	  return prevHostInstance && !prevHostInstance._hostParent ? prevHostInstance : null;
	}
	
	function getTopLevelWrapperInContainer(container) {
	  var root = getHostRootInstanceInContainer(container);
	  return root ? root._hostContainerInfo._topLevelWrapper : null;
	}
	
	/**
	 * Temporary (?) hack so that we can store all top-level pending updates on
	 * composites instead of having to worry about different types of components
	 * here.
	 */
	var topLevelRootCounter = 1;
	var TopLevelWrapper = function () {
	  this.rootID = topLevelRootCounter++;
	};
	TopLevelWrapper.prototype.isReactComponent = {};
	if (false) {
	  TopLevelWrapper.displayName = 'TopLevelWrapper';
	}
	TopLevelWrapper.prototype.render = function () {
	  // this.props is actually a ReactElement
	  return this.props;
	};
	
	/**
	 * Mounting is the process of initializing a React component by creating its
	 * representative DOM elements and inserting them into a supplied `container`.
	 * Any prior content inside `container` is destroyed in the process.
	 *
	 *   ReactMount.render(
	 *     component,
	 *     document.getElementById('container')
	 *   );
	 *
	 *   <div id="container">                   <-- Supplied `container`.
	 *     <div data-reactid=".3">              <-- Rendered reactRoot of React
	 *       // ...                                 component.
	 *     </div>
	 *   </div>
	 *
	 * Inside of `container`, the first element rendered is the "reactRoot".
	 */
	var ReactMount = {
	
	  TopLevelWrapper: TopLevelWrapper,
	
	  /**
	   * Used by devtools. The keys are not important.
	   */
	  _instancesByReactRootID: instancesByReactRootID,
	
	  /**
	   * This is a hook provided to support rendering React components while
	   * ensuring that the apparent scroll position of its `container` does not
	   * change.
	   *
	   * @param {DOMElement} container The `container` being rendered into.
	   * @param {function} renderCallback This must be called once to do the render.
	   */
	  scrollMonitor: function (container, renderCallback) {
	    renderCallback();
	  },
	
	  /**
	   * Take a component that's already mounted into the DOM and replace its props
	   * @param {ReactComponent} prevComponent component instance already in the DOM
	   * @param {ReactElement} nextElement component instance to render
	   * @param {DOMElement} container container to render into
	   * @param {?function} callback function triggered on completion
	   */
	  _updateRootComponent: function (prevComponent, nextElement, nextContext, container, callback) {
	    ReactMount.scrollMonitor(container, function () {
	      ReactUpdateQueue.enqueueElementInternal(prevComponent, nextElement, nextContext);
	      if (callback) {
	        ReactUpdateQueue.enqueueCallbackInternal(prevComponent, callback);
	      }
	    });
	
	    return prevComponent;
	  },
	
	  /**
	   * Render a new component into the DOM. Hooked by devtools!
	   *
	   * @param {ReactElement} nextElement element to render
	   * @param {DOMElement} container container to render into
	   * @param {boolean} shouldReuseMarkup if we should skip the markup insertion
	   * @return {ReactComponent} nextComponent
	   */
	  _renderNewRootComponent: function (nextElement, container, shouldReuseMarkup, context) {
	    // Various parts of our code (such as ReactCompositeComponent's
	    // _renderValidatedComponent) assume that calls to render aren't nested;
	    // verify that that's the case.
	     false ? warning(ReactCurrentOwner.current == null, '_renderNewRootComponent(): Render methods should be a pure function ' + 'of props and state; triggering nested component updates from ' + 'render is not allowed. If necessary, trigger nested updates in ' + 'componentDidUpdate. Check the render method of %s.', ReactCurrentOwner.current && ReactCurrentOwner.current.getName() || 'ReactCompositeComponent') : void 0;
	
	    !(container && (container.nodeType === ELEMENT_NODE_TYPE || container.nodeType === DOC_NODE_TYPE || container.nodeType === DOCUMENT_FRAGMENT_NODE_TYPE)) ?  false ? invariant(false, '_registerComponent(...): Target container is not a DOM element.') : _prodInvariant('37') : void 0;
	
	    ReactBrowserEventEmitter.ensureScrollValueMonitoring();
	    var componentInstance = instantiateReactComponent(nextElement, false);
	
	    // The initial render is synchronous but any updates that happen during
	    // rendering, in componentWillMount or componentDidMount, will be batched
	    // according to the current batching strategy.
	
	    ReactUpdates.batchedUpdates(batchedMountComponentIntoNode, componentInstance, container, shouldReuseMarkup, context);
	
	    var wrapperID = componentInstance._instance.rootID;
	    instancesByReactRootID[wrapperID] = componentInstance;
	
	    if (false) {
	      // The instance here is TopLevelWrapper so we report mount for its child.
	      ReactInstrumentation.debugTool.onMountRootComponent(componentInstance._renderedComponent._debugID);
	    }
	
	    return componentInstance;
	  },
	
	  /**
	   * Renders a React component into the DOM in the supplied `container`.
	   *
	   * If the React component was previously rendered into `container`, this will
	   * perform an update on it and only mutate the DOM as necessary to reflect the
	   * latest React component.
	   *
	   * @param {ReactComponent} parentComponent The conceptual parent of this render tree.
	   * @param {ReactElement} nextElement Component element to render.
	   * @param {DOMElement} container DOM element to render into.
	   * @param {?function} callback function triggered on completion
	   * @return {ReactComponent} Component instance rendered in `container`.
	   */
	  renderSubtreeIntoContainer: function (parentComponent, nextElement, container, callback) {
	    !(parentComponent != null && ReactInstanceMap.has(parentComponent)) ?  false ? invariant(false, 'parentComponent must be a valid React Component') : _prodInvariant('38') : void 0;
	    return ReactMount._renderSubtreeIntoContainer(parentComponent, nextElement, container, callback);
	  },
	
	  _renderSubtreeIntoContainer: function (parentComponent, nextElement, container, callback) {
	    ReactUpdateQueue.validateCallback(callback, 'ReactDOM.render');
	    !ReactElement.isValidElement(nextElement) ?  false ? invariant(false, 'ReactDOM.render(): Invalid component element.%s', typeof nextElement === 'string' ? ' Instead of passing a string like \'div\', pass ' + 'React.createElement(\'div\') or <div />.' : typeof nextElement === 'function' ? ' Instead of passing a class like Foo, pass ' + 'React.createElement(Foo) or <Foo />.' :
	    // Check if it quacks like an element
	    nextElement != null && nextElement.props !== undefined ? ' This may be caused by unintentionally loading two independent ' + 'copies of React.' : '') : _prodInvariant('39', typeof nextElement === 'string' ? ' Instead of passing a string like \'div\', pass ' + 'React.createElement(\'div\') or <div />.' : typeof nextElement === 'function' ? ' Instead of passing a class like Foo, pass ' + 'React.createElement(Foo) or <Foo />.' : nextElement != null && nextElement.props !== undefined ? ' This may be caused by unintentionally loading two independent ' + 'copies of React.' : '') : void 0;
	
	     false ? warning(!container || !container.tagName || container.tagName.toUpperCase() !== 'BODY', 'render(): Rendering components directly into document.body is ' + 'discouraged, since its children are often manipulated by third-party ' + 'scripts and browser extensions. This may lead to subtle ' + 'reconciliation issues. Try rendering into a container element created ' + 'for your app.') : void 0;
	
	    var nextWrappedElement = ReactElement(TopLevelWrapper, null, null, null, null, null, nextElement);
	
	    var nextContext;
	    if (parentComponent) {
	      var parentInst = ReactInstanceMap.get(parentComponent);
	      nextContext = parentInst._processChildContext(parentInst._context);
	    } else {
	      nextContext = emptyObject;
	    }
	
	    var prevComponent = getTopLevelWrapperInContainer(container);
	
	    if (prevComponent) {
	      var prevWrappedElement = prevComponent._currentElement;
	      var prevElement = prevWrappedElement.props;
	      if (shouldUpdateReactComponent(prevElement, nextElement)) {
	        var publicInst = prevComponent._renderedComponent.getPublicInstance();
	        var updatedCallback = callback && function () {
	          callback.call(publicInst);
	        };
	        ReactMount._updateRootComponent(prevComponent, nextWrappedElement, nextContext, container, updatedCallback);
	        return publicInst;
	      } else {
	        ReactMount.unmountComponentAtNode(container);
	      }
	    }
	
	    var reactRootElement = getReactRootElementInContainer(container);
	    var containerHasReactMarkup = reactRootElement && !!internalGetID(reactRootElement);
	    var containerHasNonRootReactChild = hasNonRootReactChild(container);
	
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(!containerHasNonRootReactChild, 'render(...): Replacing React-rendered children with a new root ' + 'component. If you intended to update the children of this node, ' + 'you should instead have the existing children update their state ' + 'and render the new components instead of calling ReactDOM.render.') : void 0;
	
	      if (!containerHasReactMarkup || reactRootElement.nextSibling) {
	        var rootElementSibling = reactRootElement;
	        while (rootElementSibling) {
	          if (internalGetID(rootElementSibling)) {
	            process.env.NODE_ENV !== 'production' ? warning(false, 'render(): Target node has markup rendered by React, but there ' + 'are unrelated nodes as well. This is most commonly caused by ' + 'white-space inserted around server-rendered markup.') : void 0;
	            break;
	          }
	          rootElementSibling = rootElementSibling.nextSibling;
	        }
	      }
	    }
	
	    var shouldReuseMarkup = containerHasReactMarkup && !prevComponent && !containerHasNonRootReactChild;
	    var component = ReactMount._renderNewRootComponent(nextWrappedElement, container, shouldReuseMarkup, nextContext)._renderedComponent.getPublicInstance();
	    if (callback) {
	      callback.call(component);
	    }
	    return component;
	  },
	
	  /**
	   * Renders a React component into the DOM in the supplied `container`.
	   * See https://facebook.github.io/react/docs/top-level-api.html#reactdom.render
	   *
	   * If the React component was previously rendered into `container`, this will
	   * perform an update on it and only mutate the DOM as necessary to reflect the
	   * latest React component.
	   *
	   * @param {ReactElement} nextElement Component element to render.
	   * @param {DOMElement} container DOM element to render into.
	   * @param {?function} callback function triggered on completion
	   * @return {ReactComponent} Component instance rendered in `container`.
	   */
	  render: function (nextElement, container, callback) {
	    return ReactMount._renderSubtreeIntoContainer(null, nextElement, container, callback);
	  },
	
	  /**
	   * Unmounts and destroys the React component rendered in the `container`.
	   * See https://facebook.github.io/react/docs/top-level-api.html#reactdom.unmountcomponentatnode
	   *
	   * @param {DOMElement} container DOM element containing a React component.
	   * @return {boolean} True if a component was found in and unmounted from
	   *                   `container`
	   */
	  unmountComponentAtNode: function (container) {
	    // Various parts of our code (such as ReactCompositeComponent's
	    // _renderValidatedComponent) assume that calls to render aren't nested;
	    // verify that that's the case. (Strictly speaking, unmounting won't cause a
	    // render but we still don't expect to be in a render call here.)
	     false ? warning(ReactCurrentOwner.current == null, 'unmountComponentAtNode(): Render methods should be a pure function ' + 'of props and state; triggering nested component updates from render ' + 'is not allowed. If necessary, trigger nested updates in ' + 'componentDidUpdate. Check the render method of %s.', ReactCurrentOwner.current && ReactCurrentOwner.current.getName() || 'ReactCompositeComponent') : void 0;
	
	    !(container && (container.nodeType === ELEMENT_NODE_TYPE || container.nodeType === DOC_NODE_TYPE || container.nodeType === DOCUMENT_FRAGMENT_NODE_TYPE)) ?  false ? invariant(false, 'unmountComponentAtNode(...): Target container is not a DOM element.') : _prodInvariant('40') : void 0;
	
	    var prevComponent = getTopLevelWrapperInContainer(container);
	    if (!prevComponent) {
	      // Check if the node being unmounted was rendered by React, but isn't a
	      // root node.
	      var containerHasNonRootReactChild = hasNonRootReactChild(container);
	
	      // Check if the container itself is a React root node.
	      var isContainerReactRoot = container.nodeType === 1 && container.hasAttribute(ROOT_ATTR_NAME);
	
	      if (false) {
	        process.env.NODE_ENV !== 'production' ? warning(!containerHasNonRootReactChild, 'unmountComponentAtNode(): The node you\'re attempting to unmount ' + 'was rendered by React and is not a top-level container. %s', isContainerReactRoot ? 'You may have accidentally passed in a React root node instead ' + 'of its container.' : 'Instead, have the parent component update its state and ' + 'rerender in order to remove this component.') : void 0;
	      }
	
	      return false;
	    }
	    delete instancesByReactRootID[prevComponent._instance.rootID];
	    ReactUpdates.batchedUpdates(unmountComponentFromNode, prevComponent, container, false);
	    return true;
	  },
	
	  _mountImageIntoNode: function (markup, container, instance, shouldReuseMarkup, transaction) {
	    !(container && (container.nodeType === ELEMENT_NODE_TYPE || container.nodeType === DOC_NODE_TYPE || container.nodeType === DOCUMENT_FRAGMENT_NODE_TYPE)) ?  false ? invariant(false, 'mountComponentIntoNode(...): Target container is not valid.') : _prodInvariant('41') : void 0;
	
	    if (shouldReuseMarkup) {
	      var rootElement = getReactRootElementInContainer(container);
	      if (ReactMarkupChecksum.canReuseMarkup(markup, rootElement)) {
	        ReactDOMComponentTree.precacheNode(instance, rootElement);
	        return;
	      } else {
	        var checksum = rootElement.getAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME);
	        rootElement.removeAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME);
	
	        var rootMarkup = rootElement.outerHTML;
	        rootElement.setAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME, checksum);
	
	        var normalizedMarkup = markup;
	        if (false) {
	          // because rootMarkup is retrieved from the DOM, various normalizations
	          // will have occurred which will not be present in `markup`. Here,
	          // insert markup into a <div> or <iframe> depending on the container
	          // type to perform the same normalizations before comparing.
	          var normalizer;
	          if (container.nodeType === ELEMENT_NODE_TYPE) {
	            normalizer = document.createElement('div');
	            normalizer.innerHTML = markup;
	            normalizedMarkup = normalizer.innerHTML;
	          } else {
	            normalizer = document.createElement('iframe');
	            document.body.appendChild(normalizer);
	            normalizer.contentDocument.write(markup);
	            normalizedMarkup = normalizer.contentDocument.documentElement.outerHTML;
	            document.body.removeChild(normalizer);
	          }
	        }
	
	        var diffIndex = firstDifferenceIndex(normalizedMarkup, rootMarkup);
	        var difference = ' (client) ' + normalizedMarkup.substring(diffIndex - 20, diffIndex + 20) + '\n (server) ' + rootMarkup.substring(diffIndex - 20, diffIndex + 20);
	
	        !(container.nodeType !== DOC_NODE_TYPE) ?  false ? invariant(false, 'You\'re trying to render a component to the document using server rendering but the checksum was invalid. This usually means you rendered a different component type or props on the client from the one on the server, or your render() methods are impure. React cannot handle this case due to cross-browser quirks by rendering at the document root. You should look for environment dependent code in your components and ensure the props are the same client and server side:\n%s', difference) : _prodInvariant('42', difference) : void 0;
	
	        if (false) {
	          process.env.NODE_ENV !== 'production' ? warning(false, 'React attempted to reuse markup in a container but the ' + 'checksum was invalid. This generally means that you are ' + 'using server rendering and the markup generated on the ' + 'server was not what the client was expecting. React injected ' + 'new markup to compensate which works but you have lost many ' + 'of the benefits of server rendering. Instead, figure out ' + 'why the markup being generated is different on the client ' + 'or server:\n%s', difference) : void 0;
	        }
	      }
	    }
	
	    !(container.nodeType !== DOC_NODE_TYPE) ?  false ? invariant(false, 'You\'re trying to render a component to the document but you didn\'t use server rendering. We can\'t do this without using server rendering due to cross-browser quirks. See ReactDOMServer.renderToString() for server rendering.') : _prodInvariant('43') : void 0;
	
	    if (transaction.useCreateElement) {
	      while (container.lastChild) {
	        container.removeChild(container.lastChild);
	      }
	      DOMLazyTree.insertTreeBefore(container, markup, null);
	    } else {
	      setInnerHTML(container, markup);
	      ReactDOMComponentTree.precacheNode(instance, container.firstChild);
	    }
	
	    if (false) {
	      var hostNode = ReactDOMComponentTree.getInstanceFromNode(container.firstChild);
	      if (hostNode._debugID !== 0) {
	        ReactInstrumentation.debugTool.onHostOperation(hostNode._debugID, 'mount', markup.toString());
	      }
	    }
	  }
	};
	
	module.exports = ReactMount;

/***/ },
/* 324 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactMultiChildUpdateTypes
	 */
	
	'use strict';
	
	var keyMirror = __webpack_require__(117);
	
	/**
	 * When a component's children are updated, a series of update configuration
	 * objects are created in order to batch and serialize the required changes.
	 *
	 * Enumerates all the possible types of update configurations.
	 *
	 * @internal
	 */
	var ReactMultiChildUpdateTypes = keyMirror({
	  INSERT_MARKUP: null,
	  MOVE_EXISTING: null,
	  REMOVE_NODE: null,
	  SET_MARKUP: null,
	  TEXT_CONTENT: null
	});
	
	module.exports = ReactMultiChildUpdateTypes;

/***/ },
/* 325 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactNodeTypes
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(5);
	
	var ReactElement = __webpack_require__(45);
	
	var invariant = __webpack_require__(2);
	
	var ReactNodeTypes = {
	  HOST: 0,
	  COMPOSITE: 1,
	  EMPTY: 2,
	
	  getType: function (node) {
	    if (node === null || node === false) {
	      return ReactNodeTypes.EMPTY;
	    } else if (ReactElement.isValidElement(node)) {
	      if (typeof node.type === 'function') {
	        return ReactNodeTypes.COMPOSITE;
	      } else {
	        return ReactNodeTypes.HOST;
	      }
	    }
	     true ?  false ? invariant(false, 'Unexpected node: %s', node) : _prodInvariant('26', node) : void 0;
	  }
	};
	
	module.exports = ReactNodeTypes;

/***/ },
/* 326 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactNoopUpdateQueue
	 */
	
	'use strict';
	
	var warning = __webpack_require__(9);
	
	function warnNoop(publicInstance, callerName) {
	  if (false) {
	    var constructor = publicInstance.constructor;
	    process.env.NODE_ENV !== 'production' ? warning(false, '%s(...): Can only update a mounted or mounting component. ' + 'This usually means you called %s() on an unmounted component. ' + 'This is a no-op. Please check the code for the %s component.', callerName, callerName, constructor && (constructor.displayName || constructor.name) || 'ReactClass') : void 0;
	  }
	}
	
	/**
	 * This is the abstract API for an update queue.
	 */
	var ReactNoopUpdateQueue = {
	
	  /**
	   * Checks whether or not this composite component is mounted.
	   * @param {ReactClass} publicInstance The instance we want to test.
	   * @return {boolean} True if mounted, false otherwise.
	   * @protected
	   * @final
	   */
	  isMounted: function (publicInstance) {
	    return false;
	  },
	
	  /**
	   * Enqueue a callback that will be executed after all the pending updates
	   * have processed.
	   *
	   * @param {ReactClass} publicInstance The instance to use as `this` context.
	   * @param {?function} callback Called after state is updated.
	   * @internal
	   */
	  enqueueCallback: function (publicInstance, callback) {},
	
	  /**
	   * Forces an update. This should only be invoked when it is known with
	   * certainty that we are **not** in a DOM transaction.
	   *
	   * You may want to call this when you know that some deeper aspect of the
	   * component's state has changed but `setState` was not called.
	   *
	   * This will not invoke `shouldComponentUpdate`, but it will invoke
	   * `componentWillUpdate` and `componentDidUpdate`.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @internal
	   */
	  enqueueForceUpdate: function (publicInstance) {
	    warnNoop(publicInstance, 'forceUpdate');
	  },
	
	  /**
	   * Replaces all of the state. Always use this or `setState` to mutate state.
	   * You should treat `this.state` as immutable.
	   *
	   * There is no guarantee that `this.state` will be immediately updated, so
	   * accessing `this.state` after calling this method may return the old value.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object} completeState Next state.
	   * @internal
	   */
	  enqueueReplaceState: function (publicInstance, completeState) {
	    warnNoop(publicInstance, 'replaceState');
	  },
	
	  /**
	   * Sets a subset of the state. This only exists because _pendingState is
	   * internal. This provides a merging strategy that is not available to deep
	   * properties which is confusing. TODO: Expose pendingState or don't use it
	   * during the merge.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object} partialState Next partial state to be merged with state.
	   * @internal
	   */
	  enqueueSetState: function (publicInstance, partialState) {
	    warnNoop(publicInstance, 'setState');
	  }
	};
	
	module.exports = ReactNoopUpdateQueue;

/***/ },
/* 327 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactPropTypes
	 */
	
	'use strict';
	
	var ReactElement = __webpack_require__(45);
	var ReactPropTypeLocationNames = __webpack_require__(204);
	
	var emptyFunction = __webpack_require__(37);
	var getIteratorFn = __webpack_require__(334);
	
	/**
	 * Collection of methods that allow declaration and validation of props that are
	 * supplied to React components. Example usage:
	 *
	 *   var Props = require('ReactPropTypes');
	 *   var MyArticle = React.createClass({
	 *     propTypes: {
	 *       // An optional string prop named "description".
	 *       description: Props.string,
	 *
	 *       // A required enum prop named "category".
	 *       category: Props.oneOf(['News','Photos']).isRequired,
	 *
	 *       // A prop named "dialog" that requires an instance of Dialog.
	 *       dialog: Props.instanceOf(Dialog).isRequired
	 *     },
	 *     render: function() { ... }
	 *   });
	 *
	 * A more formal specification of how these methods are used:
	 *
	 *   type := array|bool|func|object|number|string|oneOf([...])|instanceOf(...)
	 *   decl := ReactPropTypes.{type}(.isRequired)?
	 *
	 * Each and every declaration produces a function with the same signature. This
	 * allows the creation of custom validation functions. For example:
	 *
	 *  var MyLink = React.createClass({
	 *    propTypes: {
	 *      // An optional string or URI prop named "href".
	 *      href: function(props, propName, componentName) {
	 *        var propValue = props[propName];
	 *        if (propValue != null && typeof propValue !== 'string' &&
	 *            !(propValue instanceof URI)) {
	 *          return new Error(
	 *            'Expected a string or an URI for ' + propName + ' in ' +
	 *            componentName
	 *          );
	 *        }
	 *      }
	 *    },
	 *    render: function() {...}
	 *  });
	 *
	 * @internal
	 */
	
	var ANONYMOUS = '<<anonymous>>';
	
	var ReactPropTypes = {
	  array: createPrimitiveTypeChecker('array'),
	  bool: createPrimitiveTypeChecker('boolean'),
	  func: createPrimitiveTypeChecker('function'),
	  number: createPrimitiveTypeChecker('number'),
	  object: createPrimitiveTypeChecker('object'),
	  string: createPrimitiveTypeChecker('string'),
	  symbol: createPrimitiveTypeChecker('symbol'),
	
	  any: createAnyTypeChecker(),
	  arrayOf: createArrayOfTypeChecker,
	  element: createElementTypeChecker(),
	  instanceOf: createInstanceTypeChecker,
	  node: createNodeChecker(),
	  objectOf: createObjectOfTypeChecker,
	  oneOf: createEnumTypeChecker,
	  oneOfType: createUnionTypeChecker,
	  shape: createShapeTypeChecker
	};
	
	/**
	 * inlined Object.is polyfill to avoid requiring consumers ship their own
	 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
	 */
	/*eslint-disable no-self-compare*/
	function is(x, y) {
	  // SameValue algorithm
	  if (x === y) {
	    // Steps 1-5, 7-10
	    // Steps 6.b-6.e: +0 != -0
	    return x !== 0 || 1 / x === 1 / y;
	  } else {
	    // Step 6.a: NaN == NaN
	    return x !== x && y !== y;
	  }
	}
	/*eslint-enable no-self-compare*/
	
	function createChainableTypeChecker(validate) {
	  function checkType(isRequired, props, propName, componentName, location, propFullName) {
	    componentName = componentName || ANONYMOUS;
	    propFullName = propFullName || propName;
	    if (props[propName] == null) {
	      var locationName = ReactPropTypeLocationNames[location];
	      if (isRequired) {
	        return new Error('Required ' + locationName + ' `' + propFullName + '` was not specified in ' + ('`' + componentName + '`.'));
	      }
	      return null;
	    } else {
	      return validate(props, propName, componentName, location, propFullName);
	    }
	  }
	
	  var chainedCheckType = checkType.bind(null, false);
	  chainedCheckType.isRequired = checkType.bind(null, true);
	
	  return chainedCheckType;
	}
	
	function createPrimitiveTypeChecker(expectedType) {
	  function validate(props, propName, componentName, location, propFullName) {
	    var propValue = props[propName];
	    var propType = getPropType(propValue);
	    if (propType !== expectedType) {
	      var locationName = ReactPropTypeLocationNames[location];
	      // `propValue` being instance of, say, date/regexp, pass the 'object'
	      // check, but we can offer a more precise error message here rather than
	      // 'of type `object`'.
	      var preciseType = getPreciseType(propValue);
	
	      return new Error('Invalid ' + locationName + ' `' + propFullName + '` of type ' + ('`' + preciseType + '` supplied to `' + componentName + '`, expected ') + ('`' + expectedType + '`.'));
	    }
	    return null;
	  }
	  return createChainableTypeChecker(validate);
	}
	
	function createAnyTypeChecker() {
	  return createChainableTypeChecker(emptyFunction.thatReturns(null));
	}
	
	function createArrayOfTypeChecker(typeChecker) {
	  function validate(props, propName, componentName, location, propFullName) {
	    if (typeof typeChecker !== 'function') {
	      return new Error('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside arrayOf.');
	    }
	    var propValue = props[propName];
	    if (!Array.isArray(propValue)) {
	      var locationName = ReactPropTypeLocationNames[location];
	      var propType = getPropType(propValue);
	      return new Error('Invalid ' + locationName + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an array.'));
	    }
	    for (var i = 0; i < propValue.length; i++) {
	      var error = typeChecker(propValue, i, componentName, location, propFullName + '[' + i + ']');
	      if (error instanceof Error) {
	        return error;
	      }
	    }
	    return null;
	  }
	  return createChainableTypeChecker(validate);
	}
	
	function createElementTypeChecker() {
	  function validate(props, propName, componentName, location, propFullName) {
	    if (!ReactElement.isValidElement(props[propName])) {
	      var locationName = ReactPropTypeLocationNames[location];
	      return new Error('Invalid ' + locationName + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a single ReactElement.'));
	    }
	    return null;
	  }
	  return createChainableTypeChecker(validate);
	}
	
	function createInstanceTypeChecker(expectedClass) {
	  function validate(props, propName, componentName, location, propFullName) {
	    if (!(props[propName] instanceof expectedClass)) {
	      var locationName = ReactPropTypeLocationNames[location];
	      var expectedClassName = expectedClass.name || ANONYMOUS;
	      var actualClassName = getClassName(props[propName]);
	      return new Error('Invalid ' + locationName + ' `' + propFullName + '` of type ' + ('`' + actualClassName + '` supplied to `' + componentName + '`, expected ') + ('instance of `' + expectedClassName + '`.'));
	    }
	    return null;
	  }
	  return createChainableTypeChecker(validate);
	}
	
	function createEnumTypeChecker(expectedValues) {
	  if (!Array.isArray(expectedValues)) {
	    return createChainableTypeChecker(function () {
	      return new Error('Invalid argument supplied to oneOf, expected an instance of array.');
	    });
	  }
	
	  function validate(props, propName, componentName, location, propFullName) {
	    var propValue = props[propName];
	    for (var i = 0; i < expectedValues.length; i++) {
	      if (is(propValue, expectedValues[i])) {
	        return null;
	      }
	    }
	
	    var locationName = ReactPropTypeLocationNames[location];
	    var valuesString = JSON.stringify(expectedValues);
	    return new Error('Invalid ' + locationName + ' `' + propFullName + '` of value `' + propValue + '` ' + ('supplied to `' + componentName + '`, expected one of ' + valuesString + '.'));
	  }
	  return createChainableTypeChecker(validate);
	}
	
	function createObjectOfTypeChecker(typeChecker) {
	  function validate(props, propName, componentName, location, propFullName) {
	    if (typeof typeChecker !== 'function') {
	      return new Error('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside objectOf.');
	    }
	    var propValue = props[propName];
	    var propType = getPropType(propValue);
	    if (propType !== 'object') {
	      var locationName = ReactPropTypeLocationNames[location];
	      return new Error('Invalid ' + locationName + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an object.'));
	    }
	    for (var key in propValue) {
	      if (propValue.hasOwnProperty(key)) {
	        var error = typeChecker(propValue, key, componentName, location, propFullName + '.' + key);
	        if (error instanceof Error) {
	          return error;
	        }
	      }
	    }
	    return null;
	  }
	  return createChainableTypeChecker(validate);
	}
	
	function createUnionTypeChecker(arrayOfTypeCheckers) {
	  if (!Array.isArray(arrayOfTypeCheckers)) {
	    return createChainableTypeChecker(function () {
	      return new Error('Invalid argument supplied to oneOfType, expected an instance of array.');
	    });
	  }
	
	  function validate(props, propName, componentName, location, propFullName) {
	    for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
	      var checker = arrayOfTypeCheckers[i];
	      if (checker(props, propName, componentName, location, propFullName) == null) {
	        return null;
	      }
	    }
	
	    var locationName = ReactPropTypeLocationNames[location];
	    return new Error('Invalid ' + locationName + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`.'));
	  }
	  return createChainableTypeChecker(validate);
	}
	
	function createNodeChecker() {
	  function validate(props, propName, componentName, location, propFullName) {
	    if (!isNode(props[propName])) {
	      var locationName = ReactPropTypeLocationNames[location];
	      return new Error('Invalid ' + locationName + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a ReactNode.'));
	    }
	    return null;
	  }
	  return createChainableTypeChecker(validate);
	}
	
	function createShapeTypeChecker(shapeTypes) {
	  function validate(props, propName, componentName, location, propFullName) {
	    var propValue = props[propName];
	    var propType = getPropType(propValue);
	    if (propType !== 'object') {
	      var locationName = ReactPropTypeLocationNames[location];
	      return new Error('Invalid ' + locationName + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
	    }
	    for (var key in shapeTypes) {
	      var checker = shapeTypes[key];
	      if (!checker) {
	        continue;
	      }
	      var error = checker(propValue, key, componentName, location, propFullName + '.' + key);
	      if (error) {
	        return error;
	      }
	    }
	    return null;
	  }
	  return createChainableTypeChecker(validate);
	}
	
	function isNode(propValue) {
	  switch (typeof propValue) {
	    case 'number':
	    case 'string':
	    case 'undefined':
	      return true;
	    case 'boolean':
	      return !propValue;
	    case 'object':
	      if (Array.isArray(propValue)) {
	        return propValue.every(isNode);
	      }
	      if (propValue === null || ReactElement.isValidElement(propValue)) {
	        return true;
	      }
	
	      var iteratorFn = getIteratorFn(propValue);
	      if (iteratorFn) {
	        var iterator = iteratorFn.call(propValue);
	        var step;
	        if (iteratorFn !== propValue.entries) {
	          while (!(step = iterator.next()).done) {
	            if (!isNode(step.value)) {
	              return false;
	            }
	          }
	        } else {
	          // Iterator will provide entry [k,v] tuples rather than values.
	          while (!(step = iterator.next()).done) {
	            var entry = step.value;
	            if (entry) {
	              if (!isNode(entry[1])) {
	                return false;
	              }
	            }
	          }
	        }
	      } else {
	        return false;
	      }
	
	      return true;
	    default:
	      return false;
	  }
	}
	
	function isSymbol(propType, propValue) {
	  // Native Symbol.
	  if (propType === 'symbol') {
	    return true;
	  }
	
	  // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'
	  if (propValue['@@toStringTag'] === 'Symbol') {
	    return true;
	  }
	
	  // Fallback for non-spec compliant Symbols which are polyfilled.
	  if (typeof Symbol === 'function' && propValue instanceof Symbol) {
	    return true;
	  }
	
	  return false;
	}
	
	// Equivalent of `typeof` but with special handling for array and regexp.
	function getPropType(propValue) {
	  var propType = typeof propValue;
	  if (Array.isArray(propValue)) {
	    return 'array';
	  }
	  if (propValue instanceof RegExp) {
	    // Old webkits (at least until Android 4.0) return 'function' rather than
	    // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
	    // passes PropTypes.object.
	    return 'object';
	  }
	  if (isSymbol(propType, propValue)) {
	    return 'symbol';
	  }
	  return propType;
	}
	
	// This handles more types than `getPropType`. Only used for error messages.
	// See `createPrimitiveTypeChecker`.
	function getPreciseType(propValue) {
	  var propType = getPropType(propValue);
	  if (propType === 'object') {
	    if (propValue instanceof Date) {
	      return 'date';
	    } else if (propValue instanceof RegExp) {
	      return 'regexp';
	    }
	  }
	  return propType;
	}
	
	// Returns class name of the object, if any.
	function getClassName(propValue) {
	  if (!propValue.constructor || !propValue.constructor.name) {
	    return ANONYMOUS;
	  }
	  return propValue.constructor.name;
	}
	
	module.exports = ReactPropTypes;

/***/ },
/* 328 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactVersion
	 */
	
	'use strict';
	
	module.exports = '15.2.1';

/***/ },
/* 329 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ViewportMetrics
	 */
	
	'use strict';
	
	var ViewportMetrics = {
	
	  currentScrollLeft: 0,
	
	  currentScrollTop: 0,
	
	  refreshScrollValues: function (scrollPosition) {
	    ViewportMetrics.currentScrollLeft = scrollPosition.x;
	    ViewportMetrics.currentScrollTop = scrollPosition.y;
	  }
	
	};
	
	module.exports = ViewportMetrics;

/***/ },
/* 330 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule accumulateInto
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(5);
	
	var invariant = __webpack_require__(2);
	
	/**
	 * Accumulates items that must not be null or undefined into the first one. This
	 * is used to conserve memory by avoiding array allocations, and thus sacrifices
	 * API cleanness. Since `current` can be null before being passed in and not
	 * null after this function, make sure to assign it back to `current`:
	 *
	 * `a = accumulateInto(a, b);`
	 *
	 * This API should be sparingly used. Try `accumulate` for something cleaner.
	 *
	 * @return {*|array<*>} An accumulation of items.
	 */
	
	function accumulateInto(current, next) {
	  !(next != null) ?  false ? invariant(false, 'accumulateInto(...): Accumulated items must not be null or undefined.') : _prodInvariant('30') : void 0;
	
	  if (current == null) {
	    return next;
	  }
	
	  // Both are not empty. Warning: Never call x.concat(y) when you are not
	  // certain that x is an Array (x could be a string with concat method).
	  if (Array.isArray(current)) {
	    if (Array.isArray(next)) {
	      current.push.apply(current, next);
	      return current;
	    }
	    current.push(next);
	    return current;
	  }
	
	  if (Array.isArray(next)) {
	    // A bit too dangerous to mutate `next`.
	    return [current].concat(next);
	  }
	
	  return [current, next];
	}
	
	module.exports = accumulateInto;

/***/ },
/* 331 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule canDefineProperty
	 */
	
	'use strict';
	
	var canDefineProperty = false;
	if (false) {
	  try {
	    Object.defineProperty({}, 'x', { get: function () {} });
	    canDefineProperty = true;
	  } catch (x) {
	    // IE will fail on defineProperty
	  }
	}
	
	module.exports = canDefineProperty;

/***/ },
/* 332 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule forEachAccumulated
	 * 
	 */
	
	'use strict';
	
	/**
	 * @param {array} arr an "accumulation" of items which is either an Array or
	 * a single item. Useful when paired with the `accumulate` module. This is a
	 * simple utility that allows us to reason about a collection of items, but
	 * handling the case when there is exactly one item (and we do not need to
	 * allocate an array).
	 */
	
	function forEachAccumulated(arr, cb, scope) {
	  if (Array.isArray(arr)) {
	    arr.forEach(cb, scope);
	  } else if (arr) {
	    cb.call(scope, arr);
	  }
	}
	
	module.exports = forEachAccumulated;

/***/ },
/* 333 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule getHostComponentFromComposite
	 */
	
	'use strict';
	
	var ReactNodeTypes = __webpack_require__(325);
	
	function getHostComponentFromComposite(inst) {
	  var type;
	
	  while ((type = inst._renderedNodeType) === ReactNodeTypes.COMPOSITE) {
	    inst = inst._renderedComponent;
	  }
	
	  if (type === ReactNodeTypes.HOST) {
	    return inst._renderedComponent;
	  } else if (type === ReactNodeTypes.EMPTY) {
	    return null;
	  }
	}
	
	module.exports = getHostComponentFromComposite;

/***/ },
/* 334 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule getIteratorFn
	 * 
	 */
	
	'use strict';
	
	/* global Symbol */
	
	var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
	var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.
	
	/**
	 * Returns the iterator method function contained on the iterable object.
	 *
	 * Be sure to invoke the function with the iterable as context:
	 *
	 *     var iteratorFn = getIteratorFn(myIterable);
	 *     if (iteratorFn) {
	 *       var iterator = iteratorFn.call(myIterable);
	 *       ...
	 *     }
	 *
	 * @param {?object} maybeIterable
	 * @return {?function}
	 */
	function getIteratorFn(maybeIterable) {
	  var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
	  if (typeof iteratorFn === 'function') {
	    return iteratorFn;
	  }
	}
	
	module.exports = getIteratorFn;

/***/ },
/* 335 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule getTextContentAccessor
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(22);
	
	var contentKey = null;
	
	/**
	 * Gets the key used to access text content on a DOM node.
	 *
	 * @return {?string} Key used to access text content.
	 * @internal
	 */
	function getTextContentAccessor() {
	  if (!contentKey && ExecutionEnvironment.canUseDOM) {
	    // Prefer textContent to innerText because many browsers support both but
	    // SVG <text> elements don't support innerText even when <div> does.
	    contentKey = 'textContent' in document.documentElement ? 'textContent' : 'innerText';
	  }
	  return contentKey;
	}
	
	module.exports = getTextContentAccessor;

/***/ },
/* 336 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule instantiateReactComponent
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(5),
	    _assign = __webpack_require__(6);
	
	var ReactCompositeComponent = __webpack_require__(749);
	var ReactEmptyComponent = __webpack_require__(319);
	var ReactHostComponent = __webpack_require__(321);
	var ReactInstrumentation = __webpack_require__(31);
	
	var invariant = __webpack_require__(2);
	var warning = __webpack_require__(9);
	
	// To avoid a cyclic dependency, we create the final class in this module
	var ReactCompositeComponentWrapper = function (element) {
	  this.construct(element);
	};
	_assign(ReactCompositeComponentWrapper.prototype, ReactCompositeComponent.Mixin, {
	  _instantiateReactComponent: instantiateReactComponent
	});
	
	function getDeclarationErrorAddendum(owner) {
	  if (owner) {
	    var name = owner.getName();
	    if (name) {
	      return ' Check the render method of `' + name + '`.';
	    }
	  }
	  return '';
	}
	
	function getDisplayName(instance) {
	  var element = instance._currentElement;
	  if (element == null) {
	    return '#empty';
	  } else if (typeof element === 'string' || typeof element === 'number') {
	    return '#text';
	  } else if (typeof element.type === 'string') {
	    return element.type;
	  } else if (instance.getName) {
	    return instance.getName() || 'Unknown';
	  } else {
	    return element.type.displayName || element.type.name || 'Unknown';
	  }
	}
	
	/**
	 * Check if the type reference is a known internal type. I.e. not a user
	 * provided composite type.
	 *
	 * @param {function} type
	 * @return {boolean} Returns true if this is a valid internal type.
	 */
	function isInternalComponentType(type) {
	  return typeof type === 'function' && typeof type.prototype !== 'undefined' && typeof type.prototype.mountComponent === 'function' && typeof type.prototype.receiveComponent === 'function';
	}
	
	var nextDebugID = 1;
	
	/**
	 * Given a ReactNode, create an instance that will actually be mounted.
	 *
	 * @param {ReactNode} node
	 * @param {boolean} shouldHaveDebugID
	 * @return {object} A new instance of the element's constructor.
	 * @protected
	 */
	function instantiateReactComponent(node, shouldHaveDebugID) {
	  var instance;
	
	  if (node === null || node === false) {
	    instance = ReactEmptyComponent.create(instantiateReactComponent);
	  } else if (typeof node === 'object') {
	    var element = node;
	    !(element && (typeof element.type === 'function' || typeof element.type === 'string')) ?  false ? invariant(false, 'Element type is invalid: expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s', element.type == null ? element.type : typeof element.type, getDeclarationErrorAddendum(element._owner)) : _prodInvariant('130', element.type == null ? element.type : typeof element.type, getDeclarationErrorAddendum(element._owner)) : void 0;
	
	    // Special case string values
	    if (typeof element.type === 'string') {
	      instance = ReactHostComponent.createInternalComponent(element);
	    } else if (isInternalComponentType(element.type)) {
	      // This is temporarily available for custom components that are not string
	      // representations. I.e. ART. Once those are updated to use the string
	      // representation, we can drop this code path.
	      instance = new element.type(element);
	
	      // We renamed this. Allow the old name for compat. :(
	      if (!instance.getHostNode) {
	        instance.getHostNode = instance.getNativeNode;
	      }
	    } else {
	      instance = new ReactCompositeComponentWrapper(element);
	    }
	  } else if (typeof node === 'string' || typeof node === 'number') {
	    instance = ReactHostComponent.createInstanceForText(node);
	  } else {
	     true ?  false ? invariant(false, 'Encountered invalid React node of type %s', typeof node) : _prodInvariant('131', typeof node) : void 0;
	  }
	
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(typeof instance.mountComponent === 'function' && typeof instance.receiveComponent === 'function' && typeof instance.getHostNode === 'function' && typeof instance.unmountComponent === 'function', 'Only React Components can be mounted.') : void 0;
	  }
	
	  // These two fields are used by the DOM and ART diffing algorithms
	  // respectively. Instead of using expandos on components, we should be
	  // storing the state needed by the diffing algorithms elsewhere.
	  instance._mountIndex = 0;
	  instance._mountImage = null;
	
	  if (false) {
	    if (shouldHaveDebugID) {
	      var debugID = nextDebugID++;
	      instance._debugID = debugID;
	      var displayName = getDisplayName(instance);
	      ReactInstrumentation.debugTool.onSetDisplayName(debugID, displayName);
	      var owner = node && node._owner;
	      if (owner) {
	        ReactInstrumentation.debugTool.onSetOwner(debugID, owner._debugID);
	      }
	    } else {
	      instance._debugID = 0;
	    }
	  }
	
	  // Internal instances should fully constructed at this point, so they should
	  // not get any new fields added to them at this point.
	  if (false) {
	    if (Object.preventExtensions) {
	      Object.preventExtensions(instance);
	    }
	  }
	
	  return instance;
	}
	
	module.exports = instantiateReactComponent;

/***/ },
/* 337 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule isTextInputElement
	 * 
	 */
	
	'use strict';
	
	/**
	 * @see http://www.whatwg.org/specs/web-apps/current-work/multipage/the-input-element.html#input-type-attr-summary
	 */
	
	var supportedInputTypes = {
	  'color': true,
	  'date': true,
	  'datetime': true,
	  'datetime-local': true,
	  'email': true,
	  'month': true,
	  'number': true,
	  'password': true,
	  'range': true,
	  'search': true,
	  'tel': true,
	  'text': true,
	  'time': true,
	  'url': true,
	  'week': true
	};
	
	function isTextInputElement(elem) {
	  var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
	
	  if (nodeName === 'input') {
	    return !!supportedInputTypes[elem.type];
	  }
	
	  if (nodeName === 'textarea') {
	    return true;
	  }
	
	  return false;
	}
	
	module.exports = isTextInputElement;

/***/ },
/* 338 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule setTextContent
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(22);
	var escapeTextContentForBrowser = __webpack_require__(142);
	var setInnerHTML = __webpack_require__(143);
	
	/**
	 * Set the textContent property of a node, ensuring that whitespace is preserved
	 * even in IE8. innerText is a poor substitute for textContent and, among many
	 * issues, inserts <br> instead of the literal newline chars. innerHTML behaves
	 * as it should.
	 *
	 * @param {DOMElement} node
	 * @param {string} text
	 * @internal
	 */
	var setTextContent = function (node, text) {
	  if (text) {
	    var firstChild = node.firstChild;
	
	    if (firstChild && firstChild === node.lastChild && firstChild.nodeType === 3) {
	      firstChild.nodeValue = text;
	      return;
	    }
	  }
	  node.textContent = text;
	};
	
	if (ExecutionEnvironment.canUseDOM) {
	  if (!('textContent' in document.documentElement)) {
	    setTextContent = function (node, text) {
	      setInnerHTML(node, escapeTextContentForBrowser(text));
	    };
	  }
	}
	
	module.exports = setTextContent;

/***/ },
/* 339 */
/***/ function(module, exports, __webpack_require__) {

	var _ = __webpack_require__(25),
	    maker = __webpack_require__(341).instanceJoinCreator;
	
	/**
	 * Extract child listenables from a parent from their
	 * children property and return them in a keyed Object
	 *
	 * @param {Object} listenable The parent listenable
	 */
	var mapChildListenables = function(listenable) {
	    var i = 0, children = {}, childName;
	    for (;i < (listenable.children||[]).length; ++i) {
	        childName = listenable.children[i];
	        if(listenable[childName]){
	            children[childName] = listenable[childName];
	        }
	    }
	    return children;
	};
	
	/**
	 * Make a flat dictionary of all listenables including their
	 * possible children (recursively), concatenating names in camelCase.
	 *
	 * @param {Object} listenables The top-level listenables
	 */
	var flattenListenables = function(listenables) {
	    var flattened = {};
	    for(var key in listenables){
	        var listenable = listenables[key];
	        var childMap = mapChildListenables(listenable);
	
	        // recursively flatten children
	        var children = flattenListenables(childMap);
	
	        // add the primary listenable and chilren
	        flattened[key] = listenable;
	        for(var childKey in children){
	            var childListenable = children[childKey];
	            flattened[key + _.capitalize(childKey)] = childListenable;
	        }
	    }
	
	    return flattened;
	};
	
	/**
	 * A module of methods related to listening.
	 */
	module.exports = {
	
	    /**
	     * An internal utility function used by `validateListening`
	     *
	     * @param {Action|Store} listenable The listenable we want to search for
	     * @returns {Boolean} The result of a recursive search among `this.subscriptions`
	     */
	    hasListener: function(listenable) {
	        var i = 0, j, listener, listenables;
	        for (;i < (this.subscriptions||[]).length; ++i) {
	            listenables = [].concat(this.subscriptions[i].listenable);
	            for (j = 0; j < listenables.length; j++){
	                listener = listenables[j];
	                if (listener === listenable || listener.hasListener && listener.hasListener(listenable)) {
	                    return true;
	                }
	            }
	        }
	        return false;
	    },
	
	    /**
	     * A convenience method that listens to all listenables in the given object.
	     *
	     * @param {Object} listenables An object of listenables. Keys will be used as callback method names.
	     */
	    listenToMany: function(listenables){
	        var allListenables = flattenListenables(listenables);
	        for(var key in allListenables){
	            var cbname = _.callbackName(key),
	                localname = this[cbname] ? cbname : this[key] ? key : undefined;
	            if (localname){
	                this.listenTo(allListenables[key],localname,this[cbname+"Default"]||this[localname+"Default"]||localname);
	            }
	        }
	    },
	
	    /**
	     * Checks if the current context can listen to the supplied listenable
	     *
	     * @param {Action|Store} listenable An Action or Store that should be
	     *  listened to.
	     * @returns {String|Undefined} An error message, or undefined if there was no problem.
	     */
	    validateListening: function(listenable){
	        if (listenable === this) {
	            return "Listener is not able to listen to itself";
	        }
	        if (!_.isFunction(listenable.listen)) {
	            return listenable + " is missing a listen method";
	        }
	        if (listenable.hasListener && listenable.hasListener(this)) {
	            return "Listener cannot listen to this listenable because of circular loop";
	        }
	    },
	
	    /**
	     * Sets up a subscription to the given listenable for the context object
	     *
	     * @param {Action|Store} listenable An Action or Store that should be
	     *  listened to.
	     * @param {Function|String} callback The callback to register as event handler
	     * @param {Function|String} defaultCallback The callback to register as default handler
	     * @returns {Object} A subscription obj where `stop` is an unsub function and `listenable` is the object being listened to
	     */
	    listenTo: function(listenable, callback, defaultCallback) {
	        var desub, unsubscriber, subscriptionobj, subs = this.subscriptions = this.subscriptions || [];
	        _.throwIf(this.validateListening(listenable));
	        this.fetchInitialState(listenable, defaultCallback);
	        desub = listenable.listen(this[callback]||callback, this);
	        unsubscriber = function() {
	            var index = subs.indexOf(subscriptionobj);
	            _.throwIf(index === -1,'Tried to remove listen already gone from subscriptions list!');
	            subs.splice(index, 1);
	            desub();
	        };
	        subscriptionobj = {
	            stop: unsubscriber,
	            listenable: listenable
	        };
	        subs.push(subscriptionobj);
	        return subscriptionobj;
	    },
	
	    /**
	     * Stops listening to a single listenable
	     *
	     * @param {Action|Store} listenable The action or store we no longer want to listen to
	     * @returns {Boolean} True if a subscription was found and removed, otherwise false.
	     */
	    stopListeningTo: function(listenable){
	        var sub, i = 0, subs = this.subscriptions || [];
	        for(;i < subs.length; i++){
	            sub = subs[i];
	            if (sub.listenable === listenable){
	                sub.stop();
	                _.throwIf(subs.indexOf(sub)!==-1,'Failed to remove listen from subscriptions list!');
	                return true;
	            }
	        }
	        return false;
	    },
	
	    /**
	     * Stops all subscriptions and empties subscriptions array
	     */
	    stopListeningToAll: function(){
	        var remaining, subs = this.subscriptions || [];
	        while((remaining=subs.length)){
	            subs[0].stop();
	            _.throwIf(subs.length!==remaining-1,'Failed to remove listen from subscriptions list!');
	        }
	    },
	
	    /**
	     * Used in `listenTo`. Fetches initial data from a publisher if it has a `getInitialState` method.
	     * @param {Action|Store} listenable The publisher we want to get initial state from
	     * @param {Function|String} defaultCallback The method to receive the data
	     */
	    fetchInitialState: function (listenable, defaultCallback) {
	        defaultCallback = (defaultCallback && this[defaultCallback]) || defaultCallback;
	        var me = this;
	        if (_.isFunction(defaultCallback) && _.isFunction(listenable.getInitialState)) {
	            var data = listenable.getInitialState();
	            if (data && _.isFunction(data.then)) {
	                data.then(function() {
	                    defaultCallback.apply(me, arguments);
	                });
	            } else {
	                defaultCallback.call(this, data);
	            }
	        }
	    },
	
	    /**
	     * The callback will be called once all listenables have triggered at least once.
	     * It will be invoked with the last emission from each listenable.
	     * @param {...Publishers} publishers Publishers that should be tracked.
	     * @param {Function|String} callback The method to call when all publishers have emitted
	     * @returns {Object} A subscription obj where `stop` is an unsub function and `listenable` is an array of listenables
	     */
	    joinTrailing: maker("last"),
	
	    /**
	     * The callback will be called once all listenables have triggered at least once.
	     * It will be invoked with the first emission from each listenable.
	     * @param {...Publishers} publishers Publishers that should be tracked.
	     * @param {Function|String} callback The method to call when all publishers have emitted
	     * @returns {Object} A subscription obj where `stop` is an unsub function and `listenable` is an array of listenables
	     */
	    joinLeading: maker("first"),
	
	    /**
	     * The callback will be called once all listenables have triggered at least once.
	     * It will be invoked with all emission from each listenable.
	     * @param {...Publishers} publishers Publishers that should be tracked.
	     * @param {Function|String} callback The method to call when all publishers have emitted
	     * @returns {Object} A subscription obj where `stop` is an unsub function and `listenable` is an array of listenables
	     */
	    joinConcat: maker("all"),
	
	    /**
	     * The callback will be called once all listenables have triggered.
	     * If a callback triggers twice before that happens, an error is thrown.
	     * @param {...Publishers} publishers Publishers that should be tracked.
	     * @param {Function|String} callback The method to call when all publishers have emitted
	     * @returns {Object} A subscription obj where `stop` is an unsub function and `listenable` is an array of listenables
	     */
	    joinStrict: maker("strict")
	};


/***/ },
/* 340 */
/***/ function(module, exports, __webpack_require__) {

	var _ = __webpack_require__(25),
	    Reflux = __webpack_require__(76),
	    Keep = __webpack_require__(215),
	    mixer = __webpack_require__(814),
	    allowed = {preEmit:1,shouldEmit:1},
	    bindMethods = __webpack_require__(808);
	
	/**
	 * Creates an event emitting Data Store. It is mixed in with functions
	 * from the `ListenerMethods` and `PublisherMethods` mixins. `preEmit`
	 * and `shouldEmit` may be overridden in the definition object.
	 *
	 * @param {Object} definition The data store object definition
	 * @returns {Store} A data store instance
	 */
	module.exports = function(definition) {
	
	    definition = definition || {};
	
	    for(var a in Reflux.StoreMethods){
	        if (!allowed[a] && (Reflux.PublisherMethods[a] || Reflux.ListenerMethods[a])){
	            throw new Error("Cannot override API method " + a +
	                " in Reflux.StoreMethods. Use another method name or override it on Reflux.PublisherMethods / Reflux.ListenerMethods instead."
	            );
	        }
	    }
	
	    for(var d in definition){
	        if (!allowed[d] && (Reflux.PublisherMethods[d] || Reflux.ListenerMethods[d])){
	            throw new Error("Cannot override API method " + d +
	                " in store creation. Use another method name or override it on Reflux.PublisherMethods / Reflux.ListenerMethods instead."
	            );
	        }
	    }
	
	    definition = mixer(definition);
	
	    function Store() {
	        var i=0, arr;
	        this.subscriptions = [];
	        this.emitter = new _.EventEmitter();
	        this.eventLabel = "change";
	        bindMethods(this, definition);
	        if (this.init && _.isFunction(this.init)) {
	            this.init();
	        }
	        if (this.listenables){
	            arr = [].concat(this.listenables);
	            for(;i < arr.length;i++){
	                this.listenToMany(arr[i]);
	            }
	        }
	    }
	
	    _.extend(Store.prototype, Reflux.ListenerMethods, Reflux.PublisherMethods, Reflux.StoreMethods, definition);
	
	    var store = new Store();
	    Keep.createdStores.push(store);
	
	    return store;
	};


/***/ },
/* 341 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Internal module used to create static and instance join methods
	 */
	
	var slice = Array.prototype.slice,
	    _ = __webpack_require__(25),
	    createStore = __webpack_require__(340),
	    strategyMethodNames = {
	        strict: "joinStrict",
	        first: "joinLeading",
	        last: "joinTrailing",
	        all: "joinConcat"
	    };
	
	/**
	 * Used in `index.js` to create the static join methods
	 * @param {String} strategy Which strategy to use when tracking listenable trigger arguments
	 * @returns {Function} A static function which returns a store with a join listen on the given listenables using the given strategy
	 */
	exports.staticJoinCreator = function(strategy){
	    return function(/* listenables... */) {
	        var listenables = slice.call(arguments);
	        return createStore({
	            init: function(){
	                this[strategyMethodNames[strategy]].apply(this,listenables.concat("triggerAsync"));
	            }
	        });
	    };
	};
	
	/**
	 * Used in `ListenerMethods.js` to create the instance join methods
	 * @param {String} strategy Which strategy to use when tracking listenable trigger arguments
	 * @returns {Function} An instance method which sets up a join listen on the given listenables using the given strategy
	 */
	exports.instanceJoinCreator = function(strategy){
	    return function(/* listenables..., callback*/){
	        _.throwIf(arguments.length < 3,'Cannot create a join with less than 2 listenables!');
	        var listenables = slice.call(arguments),
	            callback = listenables.pop(),
	            numberOfListenables = listenables.length,
	            join = {
	                numberOfListenables: numberOfListenables,
	                callback: this[callback]||callback,
	                listener: this,
	                strategy: strategy
	            }, i, cancels = [], subobj;
	        for (i = 0; i < numberOfListenables; i++) {
	            _.throwIf(this.validateListening(listenables[i]));
	        }
	        for (i = 0; i < numberOfListenables; i++) {
	            cancels.push(listenables[i].listen(newListener(i,join),this));
	        }
	        reset(join);
	        subobj = {listenable: listenables};
	        subobj.stop = makeStopper(subobj,cancels,this);
	        this.subscriptions = (this.subscriptions || []).concat(subobj);
	        return subobj;
	    };
	};
	
	// ---- internal join functions ----
	
	function makeStopper(subobj,cancels,context){
	    return function() {
	        var i, subs = context.subscriptions,
	            index = (subs ? subs.indexOf(subobj) : -1);
	        _.throwIf(index === -1,'Tried to remove join already gone from subscriptions list!');
	        for(i=0;i < cancels.length; i++){
	            cancels[i]();
	        }
	        subs.splice(index, 1);
	    };
	}
	
	function reset(join) {
	    join.listenablesEmitted = new Array(join.numberOfListenables);
	    join.args = new Array(join.numberOfListenables);
	}
	
	function newListener(i,join) {
	    return function() {
	        var callargs = slice.call(arguments);
	        if (join.listenablesEmitted[i]){
	            switch(join.strategy){
	                case "strict": throw new Error("Strict join failed because listener triggered twice.");
	                case "last": join.args[i] = callargs; break;
	                case "all": join.args[i].push(callargs);
	            }
	        } else {
	            join.listenablesEmitted[i] = true;
	            join.args[i] = (join.strategy==="all"?[callargs]:callargs);
	        }
	        emitIfAllListenablesEmitted(join);
	    };
	}
	
	function emitIfAllListenablesEmitted(join) {
	    for (var i = 0; i < join.numberOfListenables; i++) {
	        if (!join.listenablesEmitted[i]) {
	            return;
	        }
	    }
	    join.callback.apply(join.listener,join.args);
	    reset(join);
	}


/***/ },
/* 342 */
/***/ function(module, exports) {

	/*!
	* screenfull
	* v3.0.0 - 2015-11-24
	* (c) Sindre Sorhus; MIT License
	*/
	(function () {
		'use strict';
	
		var isCommonjs = typeof module !== 'undefined' && module.exports;
		var keyboardAllowed = typeof Element !== 'undefined' && 'ALLOW_KEYBOARD_INPUT' in Element;
	
		var fn = (function () {
			var val;
			var valLength;
	
			var fnMap = [
				[
					'requestFullscreen',
					'exitFullscreen',
					'fullscreenElement',
					'fullscreenEnabled',
					'fullscreenchange',
					'fullscreenerror'
				],
				// new WebKit
				[
					'webkitRequestFullscreen',
					'webkitExitFullscreen',
					'webkitFullscreenElement',
					'webkitFullscreenEnabled',
					'webkitfullscreenchange',
					'webkitfullscreenerror'
	
				],
				// old WebKit (Safari 5.1)
				[
					'webkitRequestFullScreen',
					'webkitCancelFullScreen',
					'webkitCurrentFullScreenElement',
					'webkitCancelFullScreen',
					'webkitfullscreenchange',
					'webkitfullscreenerror'
	
				],
				[
					'mozRequestFullScreen',
					'mozCancelFullScreen',
					'mozFullScreenElement',
					'mozFullScreenEnabled',
					'mozfullscreenchange',
					'mozfullscreenerror'
				],
				[
					'msRequestFullscreen',
					'msExitFullscreen',
					'msFullscreenElement',
					'msFullscreenEnabled',
					'MSFullscreenChange',
					'MSFullscreenError'
				]
			];
	
			var i = 0;
			var l = fnMap.length;
			var ret = {};
	
			for (; i < l; i++) {
				val = fnMap[i];
				if (val && val[1] in document) {
					for (i = 0, valLength = val.length; i < valLength; i++) {
						ret[fnMap[0][i]] = val[i];
					}
					return ret;
				}
			}
	
			return false;
		})();
	
		var screenfull = {
			request: function (elem) {
				var request = fn.requestFullscreen;
	
				elem = elem || document.documentElement;
	
				// Work around Safari 5.1 bug: reports support for
				// keyboard in fullscreen even though it doesn't.
				// Browser sniffing, since the alternative with
				// setTimeout is even worse.
				if (/5\.1[\.\d]* Safari/.test(navigator.userAgent)) {
					elem[request]();
				} else {
					elem[request](keyboardAllowed && Element.ALLOW_KEYBOARD_INPUT);
				}
			},
			exit: function () {
				document[fn.exitFullscreen]();
			},
			toggle: function (elem) {
				if (this.isFullscreen) {
					this.exit();
				} else {
					this.request(elem);
				}
			},
			raw: fn
		};
	
		if (!fn) {
			if (isCommonjs) {
				module.exports = false;
			} else {
				window.screenfull = false;
			}
	
			return;
		}
	
		Object.defineProperties(screenfull, {
			isFullscreen: {
				get: function () {
					return Boolean(document[fn.fullscreenElement]);
				}
			},
			element: {
				enumerable: true,
				get: function () {
					return document[fn.fullscreenElement];
				}
			},
			enabled: {
				enumerable: true,
				get: function () {
					// Coerce to boolean in case of old WebKit
					return Boolean(document[fn.fullscreenEnabled]);
				}
			}
		});
	
		if (isCommonjs) {
			module.exports = screenfull;
		} else {
			window.screenfull = screenfull;
		}
	})();


/***/ },
/* 343 */
/***/ function(module, exports, __webpack_require__) {

	/*
		MIT License http://www.opensource.org/licenses/mit-license.php
		Author Tobias Koppers @sokra
	*/
	var stylesInDom = {},
		memoize = function(fn) {
			var memo;
			return function () {
				if (typeof memo === "undefined") memo = fn.apply(this, arguments);
				return memo;
			};
		},
		isOldIE = memoize(function() {
			return /msie [6-9]\b/.test(window.navigator.userAgent.toLowerCase());
		}),
		getHeadElement = memoize(function () {
			return document.head || document.getElementsByTagName("head")[0];
		}),
		singletonElement = null,
		singletonCounter = 0;
	
	module.exports = function(list, options) {
		if(false) {
			if(typeof document !== "object") throw new Error("The style-loader cannot be used in a non-browser environment");
		}
	
		options = options || {};
		// Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
		// tags it will allow on a page
		if (typeof options.singleton === "undefined") options.singleton = isOldIE();
	
		var styles = listToStyles(list);
		addStylesToDom(styles, options);
	
		return function update(newList) {
			var mayRemove = [];
			for(var i = 0; i < styles.length; i++) {
				var item = styles[i];
				var domStyle = stylesInDom[item.id];
				domStyle.refs--;
				mayRemove.push(domStyle);
			}
			if(newList) {
				var newStyles = listToStyles(newList);
				addStylesToDom(newStyles, options);
			}
			for(var i = 0; i < mayRemove.length; i++) {
				var domStyle = mayRemove[i];
				if(domStyle.refs === 0) {
					for(var j = 0; j < domStyle.parts.length; j++)
						domStyle.parts[j]();
					delete stylesInDom[domStyle.id];
				}
			}
		};
	}
	
	function addStylesToDom(styles, options) {
		for(var i = 0; i < styles.length; i++) {
			var item = styles[i];
			var domStyle = stylesInDom[item.id];
			if(domStyle) {
				domStyle.refs++;
				for(var j = 0; j < domStyle.parts.length; j++) {
					domStyle.parts[j](item.parts[j]);
				}
				for(; j < item.parts.length; j++) {
					domStyle.parts.push(addStyle(item.parts[j], options));
				}
			} else {
				var parts = [];
				for(var j = 0; j < item.parts.length; j++) {
					parts.push(addStyle(item.parts[j], options));
				}
				stylesInDom[item.id] = {id: item.id, refs: 1, parts: parts};
			}
		}
	}
	
	function listToStyles(list) {
		var styles = [];
		var newStyles = {};
		for(var i = 0; i < list.length; i++) {
			var item = list[i];
			var id = item[0];
			var css = item[1];
			var media = item[2];
			var sourceMap = item[3];
			var part = {css: css, media: media, sourceMap: sourceMap};
			if(!newStyles[id])
				styles.push(newStyles[id] = {id: id, parts: [part]});
			else
				newStyles[id].parts.push(part);
		}
		return styles;
	}
	
	function createStyleElement() {
		var styleElement = document.createElement("style");
		var head = getHeadElement();
		styleElement.type = "text/css";
		head.appendChild(styleElement);
		return styleElement;
	}
	
	function createLinkElement() {
		var linkElement = document.createElement("link");
		var head = getHeadElement();
		linkElement.rel = "stylesheet";
		head.appendChild(linkElement);
		return linkElement;
	}
	
	function addStyle(obj, options) {
		var styleElement, update, remove;
	
		if (options.singleton) {
			var styleIndex = singletonCounter++;
			styleElement = singletonElement || (singletonElement = createStyleElement());
			update = applyToSingletonTag.bind(null, styleElement, styleIndex, false);
			remove = applyToSingletonTag.bind(null, styleElement, styleIndex, true);
		} else if(obj.sourceMap &&
			typeof URL === "function" &&
			typeof URL.createObjectURL === "function" &&
			typeof URL.revokeObjectURL === "function" &&
			typeof Blob === "function" &&
			typeof btoa === "function") {
			styleElement = createLinkElement();
			update = updateLink.bind(null, styleElement);
			remove = function() {
				styleElement.parentNode.removeChild(styleElement);
				if(styleElement.href)
					URL.revokeObjectURL(styleElement.href);
			};
		} else {
			styleElement = createStyleElement();
			update = applyToTag.bind(null, styleElement);
			remove = function() {
				styleElement.parentNode.removeChild(styleElement);
			};
		}
	
		update(obj);
	
		return function updateStyle(newObj) {
			if(newObj) {
				if(newObj.css === obj.css && newObj.media === obj.media && newObj.sourceMap === obj.sourceMap)
					return;
				update(obj = newObj);
			} else {
				remove();
			}
		};
	}
	
	var replaceText = (function () {
		var textStore = [];
	
		return function (index, replacement) {
			textStore[index] = replacement;
			return textStore.filter(Boolean).join('\n');
		};
	})();
	
	function applyToSingletonTag(styleElement, index, remove, obj) {
		var css = remove ? "" : obj.css;
	
		if (styleElement.styleSheet) {
			styleElement.styleSheet.cssText = replaceText(index, css);
		} else {
			var cssNode = document.createTextNode(css);
			var childNodes = styleElement.childNodes;
			if (childNodes[index]) styleElement.removeChild(childNodes[index]);
			if (childNodes.length) {
				styleElement.insertBefore(cssNode, childNodes[index]);
			} else {
				styleElement.appendChild(cssNode);
			}
		}
	}
	
	function applyToTag(styleElement, obj) {
		var css = obj.css;
		var media = obj.media;
		var sourceMap = obj.sourceMap;
	
		if(media) {
			styleElement.setAttribute("media", media)
		}
	
		if(styleElement.styleSheet) {
			styleElement.styleSheet.cssText = css;
		} else {
			while(styleElement.firstChild) {
				styleElement.removeChild(styleElement.firstChild);
			}
			styleElement.appendChild(document.createTextNode(css));
		}
	}
	
	function updateLink(linkElement, obj) {
		var css = obj.css;
		var media = obj.media;
		var sourceMap = obj.sourceMap;
	
		if(sourceMap) {
			// http://stackoverflow.com/a/26603875
			css += "\n/*# sourceMappingURL=data:application/json;base64," + btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))) + " */";
		}
	
		var blob = new Blob([css], { type: "text/css" });
	
		var oldSrc = linkElement.href;
	
		linkElement.href = URL.createObjectURL(blob);
	
		if(oldSrc)
			URL.revokeObjectURL(oldSrc);
	}


/***/ },
/* 344 */
/***/ function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiIHN0YW5kYWxvbmU9Im5vIj8+Cjxzdmcgd2lkdGg9IjE3cHgiIGhlaWdodD0iMjhweCIgdmlld0JveD0iMCAwIDE3IDI4IiB2ZXJzaW9uPSIxLjEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiPgogICAgPCEtLSBHZW5lcmF0b3I6IHNrZXRjaHRvb2wgMy43ICgyODE2OSkgLSBodHRwOi8vd3d3LmJvaGVtaWFuY29kaW5nLmNvbS9za2V0Y2ggLS0+CiAgICA8dGl0bGU+Q0M5QTdFMUEtMkM2RC00MDhFLUFCQUUtNjVGQTI1Mjg2RDk0PC90aXRsZT4KICAgIDxkZXNjPkNyZWF0ZWQgd2l0aCBza2V0Y2h0b29sLjwvZGVzYz4KICAgIDxkZWZzPjwvZGVmcz4KICAgIDxnIGlkPSJQYWdlLTEiIHN0cm9rZT0ibm9uZSIgc3Ryb2tlLXdpZHRoPSIxIiBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPgogICAgICAgIDxnIGlkPSJCdXR0b25zIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtMjk1LjAwMDAwMCwgLTEyNC4wMDAwMDApIiBmaWxsPSIjMDA1QjgxIj4KICAgICAgICAgICAgPGcgaWQ9IkNhcm91c2VsTGVmdEFycm93IiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgzMDkuMTQyMTM2LCAxMzguMTQyMTM2KSBzY2FsZSgtMSwgMSkgcm90YXRlKC0zMTUuMDAwMDAwKSB0cmFuc2xhdGUoLTMwOS4xNDIxMzYsIC0xMzguMTQyMTM2KSB0cmFuc2xhdGUoMjk5LjE0MjEzNiwgMTI4LjE0MjEzNikiPgogICAgICAgICAgICAgICAgPHJlY3QgaWQ9IlJlY3RhbmdsZS0yMjMwIiB4PSIyLjI3MzczNjc1ZS0xMyIgeT0iMS4xMzY4NjgzOGUtMTMiIHdpZHRoPSIxOS41MjI2MzQ0IiBoZWlnaHQ9IjMuNDg3NjkwNTMiPjwvcmVjdD4KICAgICAgICAgICAgICAgIDxwb2x5Z29uIGlkPSJSZWN0YW5nbGUtMjIzMCIgcG9pbnRzPSIxNi40NjgzMzg1IDE5LjM4NjYwMjEgMTYuNDY4MzM4NSAwLjU1MzA3MzIzNSAxOS45NTYwMjkgMC41NTMwNzMyMzUgMTkuOTU2MDI5IDE5LjM4NjYwMjEiPjwvcG9seWdvbj4KICAgICAgICAgICAgPC9nPgogICAgICAgIDwvZz4KICAgIDwvZz4KPC9zdmc+Cg=="

/***/ },
/* 345 */
/***/ function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiIHN0YW5kYWxvbmU9Im5vIj8+Cjxzdmcgd2lkdGg9IjE3cHgiIGhlaWdodD0iMjhweCIgdmlld0JveD0iMCAwIDE3IDI4IiB2ZXJzaW9uPSIxLjEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiPgogICAgPCEtLSBHZW5lcmF0b3I6IHNrZXRjaHRvb2wgMy43ICgyODE2OSkgLSBodHRwOi8vd3d3LmJvaGVtaWFuY29kaW5nLmNvbS9za2V0Y2ggLS0+CiAgICA8dGl0bGU+Q0Y1RTZFRTItQjcxRC00OTgxLUFFQjctM0RENzk3QTdCQ0E0PC90aXRsZT4KICAgIDxkZXNjPkNyZWF0ZWQgd2l0aCBza2V0Y2h0b29sLjwvZGVzYz4KICAgIDxkZWZzPjwvZGVmcz4KICAgIDxnIGlkPSJQYWdlLTEiIHN0cm9rZT0ibm9uZSIgc3Ryb2tlLXdpZHRoPSIxIiBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPgogICAgICAgIDxnIGlkPSJCdXR0b25zIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtMzkxLjAwMDAwMCwgLTEyNC4wMDAwMDApIiBmaWxsPSIjMDA1QjgxIj4KICAgICAgICAgICAgPGcgaWQ9IkNhcm91c2VsUmlnaHRBcnJvdyIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMzk0LjE0MjEzNiwgMTM4LjE0MjEzNikgcm90YXRlKC0zMTUuMDAwMDAwKSB0cmFuc2xhdGUoLTM5NC4xNDIxMzYsIC0xMzguMTQyMTM2KSB0cmFuc2xhdGUoMzg0LjE0MjEzNiwgMTI4LjE0MjEzNikiPgogICAgICAgICAgICAgICAgPHJlY3QgaWQ9IlJlY3RhbmdsZS0yMjMwIiB4PSItMi4yNzM3MzY3NWUtMTMiIHk9Ii0xLjEzNjg2ODM4ZS0xMyIgd2lkdGg9IjE5LjUyMjYzNDQiIGhlaWdodD0iMy40ODc2OTA1MyI+PC9yZWN0PgogICAgICAgICAgICAgICAgPHBvbHlnb24gaWQ9IlJlY3RhbmdsZS0yMjMwIiBwb2ludHM9IjE2LjQ2ODMzODUgMTkuMzg2NjAyMSAxNi40NjgzMzg1IDAuNTUzMDczMjM1IDE5Ljk1NjAyOSAwLjU1MzA3MzIzNSAxOS45NTYwMjkgMTkuMzg2NjAyMSI+PC9wb2x5Z29uPgogICAgICAgICAgICA8L2c+CiAgICAgICAgPC9nPgogICAgPC9nPgo8L3N2Zz4K"

/***/ },
/* 346 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABkAAAAYCAYAAAAPtVbGAAAAAXNSR0IArs4c6QAAAMxJREFUSA3FlmEOgzAIRs1usd3CC6y7idf0UDPZDbqvOpoGkUFlmQkpRXiv6Q/jkHOeELch+AEzIeYVi+SOeCIeUR6w0oc5ViYKYaJGkKqAkgiRKogQmQRnRC5Bj6hL4BGdEjDRUmBUozVEoMFCBZLoJwImekFSYnd91CetF6n4l1p7RW0edhgJKtW6hRpMe2cWWiCWnkOhZ9jTW4U9Q64ZV3M91paYZk1NDMy3KkN9yUlf9iILxSui/Ei4PhWaaydCYYoUkBzMETGX9Q3JGctlXl3sGQAAAABJRU5ErkJggg=="

/***/ },
/* 347 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFQAAABFCAYAAADU4cH/AAAAAXNSR0IArs4c6QAAAVxJREFUeAHt3MFNw0AQBVAbcaMYWgDRBgVwoIjQBcdcSB2kjnCAIrghmRmRnBIjiEYoyz5LiaJ1PJ599unL3mGwlQqM0zQtSiu2UWyKNl/isxrHMX+XbQlaWrCss78pdBugT5WnOqssptYwnAfCQ6cQm5j3qtO5mzYBAgQIECBAgAABAgQIECCwFcj47plGnUDveWid5LaSPLSYNPPQ6+KayhEgQIAAAQIECBAgQIAAAQIEmhEQ3/3uUr3H3+/jEcjl3GHiuzmZw+MXMXx3eNfXKNDvdPb35R36uD9shAABAgQIECBAgAABAgQIEGhVIOO7q1abP6G+843u14j13uShdVflI0rdiO/qQPNJxsv8WtfV7LbSboWIZbcCJk6AAAECBAgQIECAAAECBBoVyPhu0WjvP2l7F1qUL2s5d/Je8tDyZS3nQOWhczJHjmce+t+Xu7Ss5ZE3x0kc9gnARjrOBqWf/AAAAABJRU5ErkJggg=="

/***/ },
/* 348 */
/***/ function(module, exports) {

	/*
	 * ************************************************************************
	 *
	 *  ADOBE CONFIDENTIAL
	 *  ___________________
	 *
	 *   (c) Copyright 2016 Adobe Systems Incorporated
	 *   All Rights Reserved.
	 *
	 *  NOTICE:  All information contained herein is, and remains
	 *  the property of Adobe Systems Incorporated and its suppliers,
	 *  if any.  The intellectual and technical concepts contained
	 *  herein are proprietary to Adobe Systems Incorporated and its
	 *  suppliers and may be covered by U.S. and Foreign Patents,
	 *  patents in process, and are protected by trade secret or copyright law.
	 *  Dissemination of this information or reproduction of this material
	 *  is strictly forbidden unless prior written permission is obtained
	 *  from Adobe Systems Incorporated.
	 * ************************************************************************
	 */
	
	/*
	 * video heartbeats - 1.5.4 - 2016-02-02
	 * Copyright (c) 2016 Adobe Systems, Inc. All Rights Reserved.
	 */
	
	// Heartbeat core
	!function(a){if("undefined"==typeof b)var b={};if("undefined"==typeof c)var c={};if("undefined"==typeof d)var d={};if(d.radio||(d.radio={}),d.plugin||(d.plugin={}),"undefined"==typeof e)var e={};e.clock||(e.clock={}),function(a){"use strict";function b(a,b){var c=(65535&a)+(65535&b),d=(a>>16)+(b>>16)+(c>>16);return d<<16|65535&c}function c(a,b){return a<<b|a>>>32-b}function d(a,d,e,f,g,h){return b(c(b(b(d,a),b(f,h)),g),e)}function e(a,b,c,e,f,g,h){return d(b&c|~b&e,a,b,f,g,h)}function f(a,b,c,e,f,g,h){return d(b&e|c&~e,a,b,f,g,h)}function g(a,b,c,e,f,g,h){return d(b^c^e,a,b,f,g,h)}function h(a,b,c,e,f,g,h){return d(c^(b|~e),a,b,f,g,h)}function i(a,c){a[c>>5]|=128<<c%32,a[(c+64>>>9<<4)+14]=c;var d,i,j,k,l,m=1732584193,n=-271733879,o=-1732584194,p=271733878;for(d=0;d<a.length;d+=16)i=m,j=n,k=o,l=p,m=e(m,n,o,p,a[d],7,-680876936),p=e(p,m,n,o,a[d+1],12,-389564586),o=e(o,p,m,n,a[d+2],17,606105819),n=e(n,o,p,m,a[d+3],22,-1044525330),m=e(m,n,o,p,a[d+4],7,-176418897),p=e(p,m,n,o,a[d+5],12,1200080426),o=e(o,p,m,n,a[d+6],17,-1473231341),n=e(n,o,p,m,a[d+7],22,-45705983),m=e(m,n,o,p,a[d+8],7,1770035416),p=e(p,m,n,o,a[d+9],12,-1958414417),o=e(o,p,m,n,a[d+10],17,-42063),n=e(n,o,p,m,a[d+11],22,-1990404162),m=e(m,n,o,p,a[d+12],7,1804603682),p=e(p,m,n,o,a[d+13],12,-40341101),o=e(o,p,m,n,a[d+14],17,-1502002290),n=e(n,o,p,m,a[d+15],22,1236535329),m=f(m,n,o,p,a[d+1],5,-165796510),p=f(p,m,n,o,a[d+6],9,-1069501632),o=f(o,p,m,n,a[d+11],14,643717713),n=f(n,o,p,m,a[d],20,-373897302),m=f(m,n,o,p,a[d+5],5,-701558691),p=f(p,m,n,o,a[d+10],9,38016083),o=f(o,p,m,n,a[d+15],14,-660478335),n=f(n,o,p,m,a[d+4],20,-405537848),m=f(m,n,o,p,a[d+9],5,568446438),p=f(p,m,n,o,a[d+14],9,-1019803690),o=f(o,p,m,n,a[d+3],14,-187363961),n=f(n,o,p,m,a[d+8],20,1163531501),m=f(m,n,o,p,a[d+13],5,-1444681467),p=f(p,m,n,o,a[d+2],9,-51403784),o=f(o,p,m,n,a[d+7],14,1735328473),n=f(n,o,p,m,a[d+12],20,-1926607734),m=g(m,n,o,p,a[d+5],4,-378558),p=g(p,m,n,o,a[d+8],11,-2022574463),o=g(o,p,m,n,a[d+11],16,1839030562),n=g(n,o,p,m,a[d+14],23,-35309556),m=g(m,n,o,p,a[d+1],4,-1530992060),p=g(p,m,n,o,a[d+4],11,1272893353),o=g(o,p,m,n,a[d+7],16,-155497632),n=g(n,o,p,m,a[d+10],23,-1094730640),m=g(m,n,o,p,a[d+13],4,681279174),p=g(p,m,n,o,a[d],11,-358537222),o=g(o,p,m,n,a[d+3],16,-722521979),n=g(n,o,p,m,a[d+6],23,76029189),m=g(m,n,o,p,a[d+9],4,-640364487),p=g(p,m,n,o,a[d+12],11,-421815835),o=g(o,p,m,n,a[d+15],16,530742520),n=g(n,o,p,m,a[d+2],23,-995338651),m=h(m,n,o,p,a[d],6,-198630844),p=h(p,m,n,o,a[d+7],10,1126891415),o=h(o,p,m,n,a[d+14],15,-1416354905),n=h(n,o,p,m,a[d+5],21,-57434055),m=h(m,n,o,p,a[d+12],6,1700485571),p=h(p,m,n,o,a[d+3],10,-1894986606),o=h(o,p,m,n,a[d+10],15,-1051523),n=h(n,o,p,m,a[d+1],21,-2054922799),m=h(m,n,o,p,a[d+8],6,1873313359),p=h(p,m,n,o,a[d+15],10,-30611744),o=h(o,p,m,n,a[d+6],15,-1560198380),n=h(n,o,p,m,a[d+13],21,1309151649),m=h(m,n,o,p,a[d+4],6,-145523070),p=h(p,m,n,o,a[d+11],10,-1120210379),o=h(o,p,m,n,a[d+2],15,718787259),n=h(n,o,p,m,a[d+9],21,-343485551),m=b(m,i),n=b(n,j),o=b(o,k),p=b(p,l);return[m,n,o,p]}function j(a){var b,c="";for(b=0;b<32*a.length;b+=8)c+=String.fromCharCode(a[b>>5]>>>b%32&255);return c}function k(a){var b,c=[];for(c[(a.length>>2)-1]=void 0,b=0;b<c.length;b+=1)c[b]=0;for(b=0;b<8*a.length;b+=8)c[b>>5]|=(255&a.charCodeAt(b/8))<<b%32;return c}function l(a){return j(i(k(a),8*a.length))}function m(a,b){var c,d,e=k(a),f=[],g=[];for(f[15]=g[15]=void 0,e.length>16&&(e=i(e,8*a.length)),c=0;16>c;c+=1)f[c]=909522486^e[c],g[c]=1549556828^e[c];return d=i(f.concat(k(b)),512+8*b.length),j(i(g.concat(d),640))}function n(a){var b,c,d="0123456789abcdef",e="";for(c=0;c<a.length;c+=1)b=a.charCodeAt(c),e+=d.charAt(b>>>4&15)+d.charAt(15&b);return e}function o(a){return unescape(encodeURIComponent(a))}function p(a){return l(o(a))}function q(a){return n(p(a))}function r(a,b){return m(o(a),o(b))}function s(a,b){return n(r(a,b))}function t(a,b,c){return b?c?r(b,a):s(b,a):c?p(a):q(a)}a.md5=t}(b),function(a){"use strict";var b={};b.startsWith=function(a,b){return 0==a.indexOf(b)},a.StringUtils=b}(b),function(a){"use strict";var b={};b.clone=function(a){var b={};for(var c in a)a.hasOwnProperty(c)&&(b[c]=a[c]);return b},b.merge=function(a,c){var d=b.clone(a);for(var e in c)c.hasOwnProperty(e)&&(d[e]=c[e]);return d},a.ObjectUtils=b}(b),function(a){"use strict";function b(a,b,c){this.fn=a,this.ctx=b,this.params=c}b.prototype.run=function(){this.params?this.fn.apply(this.ctx,this.params):this.fn.apply(this.ctx)},a.radio.Command=b}(d),function(a){"use strict";function b(a,b){this._queue=[],this._lastTs=0,this._isSuspended="undefined"!=typeof a?a:!1,this._delay="undefined"!=typeof b?b:0}b.prototype.addCommand=function(a){this._queue.push(a),this._drain()},b.prototype.cancelAllCommands=function(){this._queue=[]},b.prototype.isEmpty=function(){return 0===this._queue.length},b.prototype.suspend=function(){this._isSuspended=!0},b.prototype.resume=function(){this._isSuspended=!1,this._drain()},b.prototype.flush=function(){this._isSuspended=!1;for(var a=0;a<this._queue.length;a++){var b=this._queue[a];b.run()}this._queue=[]},b.prototype._drain=function(){if(!this._isSuspended&&!this._drainInProgress){this._drainInProgress=!0;var a=this;!function b(){var c=a._queue.shift();c?a._runCommand(c,function(){a._isSuspended||b()}):a._drainInProgress=!1}()}},b.prototype._runCommand=function(a,b){function c(){a.run(),null!=b&&b.call(d)}var d=this;if(0==this._lastTs)c();else{var e=(new Date).getTime(),f=e-this._lastTs;this._lastTs=e,f<this._delay?setTimeout(c,this._delay-f):c()}},a.radio.CommandQueue=b}(d),function(a){"use strict";function b(a,b){if(this._name=a,!b)throw new Error("Reference to the logger object cannot be NULL");this._logger=b,this._listeners={},this._requests={},this._commands={},this._isShutDown=!1}function c(a,c){if(a===c)return!0;for(var d=(a||"").split(b.SEPARATOR),e=(c||"").split(b.SEPARATOR),f=!0,g=0;g<d.length;g++)f=f&&(d[g]===b.WILDCARD||d[g]===e[g]);return f}b.WILDCARD="*",b.SEPARATOR=":",b.prototype.toString=function(){return"<channel: "+this._name+">"},b.prototype.shutdown=function(){this._isShutDown||(this._logger.debug(d,"#shutdown > Shutting down"),this.off(),this._requests={},this._commands={},this._isShutDown=!0)},b.prototype.on=function(a,b,c){this._isShutDown||(this._listeners[a]||(this._listeners[a]=[]),this._listeners[a].push({fn:b,ctx:c}))},b.prototype.off=function(a,b,c){if(!this._isShutDown){if(b="function"==typeof b?b:null,!a&&null==b&&!c)return void(this._listeners={});if(a)this._removeListener(a,b,c);else for(a in this._listeners)this._listeners.hasOwnProperty(a)&&this._removeListener(a,b,c)}},b.prototype.trigger=function(a){if(!this._isShutDown)for(var b in this._listeners)if(this._listeners.hasOwnProperty(b)&&c(b,a.name))for(var d=this._listeners[b].slice(0),e=0;e<d.length;e++){var f=d[e];f.fn.call(f.ctx,a)}},b.prototype.comply=function(a,b,c){this._isShutDown||(this._commands[a]={cmd:b,ctx:c})},b.prototype.command=function(a,b){if(!this._isShutDown){var c=this._commands[a];return c?void c.cmd.call(c.ctx,b):void this._logger.warn(d,"#command > No command handler for: "+a)}},b.prototype.reply=function(a,b,c){this._isShutDown||(this._requests[a]={fn:b,ctx:c})},b.prototype.request=function(a){if(!this._isShutDown){var b=this._requests[a];return b?b.fn.call(b.ctx):(this._logger.warn(d,"#request > No request handler for: "+a),null)}},b.prototype._removeListener=function(a,b,c){b="function"==typeof b?b:null;var d=this._listeners[a];if(d){if(!d.length||null==b&&!c)return void delete this._listeners[a];for(var e=0;e<d.length;e++){var f=d[e];null!==b&&b!==f.fn||c&&c!==f.ctx||this._listeners[a].splice(e,1)}}};var d="radio::Channel";a.radio.Channel=b}(d),function(a){"use strict";function b(a){if(!a)throw new Error("Reference to the logger object cannot be NULL");this._logger=a,this._channels={}}var c=a.radio.Channel;b.prototype.channel=function(a){return this._channels[a]||(this._channels[a]=new c(a,this._logger)),this._channels[a]},b.prototype.shutdown=function(){for(var a in this._channels)this._channels.hasOwnProperty(a)&&this._channels[a].shutdown()},a.radio.Radio=b}(d),function(a){"use strict";function b(a,b){function c(){this.constructor=a}for(var d in b)b.hasOwnProperty(d)&&(a[d]=b[d]);return c.prototype=b.prototype,a.prototype=new c,a.__super__=b.prototype,a}a.extend=b}(d),function(a){"use strict";function b(){}b.prototype.write=function(a){throw new Error("Implementation error: Method must be overridden.")},a.ILogWriter=b}(d),function(a){"use strict";function b(){}b.prototype.write=function(a){window.console&&window.console.log&&window.console.log(a)},a.LogWriter=b}(d,c),function(a){"use strict";function b(){}b.prototype.setLogWriter=function(a){throw new Error("Implementation error: Method must be overridden.")},b.prototype.getLogWriter=function(){throw new Error("Implementation error: Method must be overridden.")},b.prototype.getEnabled=function(){throw new Error("Implementation error: Method must be overridden.")},b.prototype.enable=function(){throw new Error("Implementation error: Method must be overridden.")},b.prototype.disable=function(){throw new Error("Implementation error: Method must be overridden.")},b.prototype.debug=function(a,b){throw new Error("Implementation error: Method must be overridden.")},b.prototype.info=function(a,b){throw new Error("Implementation error: Method must be overridden.")},b.prototype.warn=function(a,b){throw new Error("Implementation error: Method must be overridden.")},b.prototype.error=function(a,b){throw new Error("Implementation error: Method must be overridden.")},a.ILogger=b}(d),function(a){"use strict";function b(){this._logWriter=new d}function c(a){return 10>a?"00"+a:100>a?"0"+a:""+a}var d=a.LogWriter;b.prototype.setLogWriter=function(a){if(!a)throw new Error("Reference to the ILogWriter object cannot be NULL");this._logWriter=a,this._enabled=!1},b.prototype.getLogWriter=function(){return this._logWriter},b.prototype.getEnabled=function(){return this._enabled},b.prototype.enable=function(){this._enabled=!0},b.prototype.disable=function(){this._enabled=!1},b.prototype.debug=function(a,b){this._log(a,f,b)},b.prototype.info=function(a,b){this._log(a,e,b)},b.prototype.warn=function(a,b){this._log(a,g,b)},b.prototype.error=function(a,b){this._log(a,h,b)},b.prototype._log=function(a,b,d){if(b==h||this._enabled){var e="",f=new Date;e+="["+f.toTimeString()+"."+c(f.getMilliseconds())+"] ["+b+"] ",e+="["+a+"] "+d,this._logWriter.write(e)}};var e="INFO",f="DEBUG",g="WARN",h="ERROR";a.Logger=b}(d),function(a){"use strict";function b(a,b){this._pluginName=a,this._eventName=b}var c=a.radio.Channel;b.prototype.getPluginName=function(){return this._pluginName},b.prototype.getEventName=function(){return this._eventName},b.prototype.getName=function(){return this._pluginName+c.SEPARATOR+this._eventName},a.Trigger=b}(d),function(a){"use strict";function b(a,b){this.name=a,this.data=b}b.SUCCESS="success",b.ERROR="error",b.createFromTrigger=function(a){return new b(a.getName())},a.Event=b}(d),function(a){"use strict";function b(){this._events={}}b.prototype.addEventListener=function(a,b,c){a&&b&&(c=c||window,this._events[a]=this._events[a]||[],this._events[a].push({cb:b,ctx:c}))},b.prototype.removeEventListener=function(a,b,c){if(a&&b){c=c||window;var d,e,f=!1;for(e in this._events)if(a===e){f=!0;break}if(f){for(d=this._events[e].length-1;d>=0;d--){var g=this._events[e][d];b===g.cb&&c===g.ctx&&this._events[e].splice(d,1)}this._events[e].length||delete this._events[e]}}},b.prototype.dispatchEvent=function(a){if(a.name){var b,c;for(b in this._events)if(this._events.hasOwnProperty(b)&&a.name===b){var d=this._events[b],e=d.slice(0),f=e.length;for(c=0;f>c;c++)e[c].cb.call(e[c].ctx,a);break}}},b.prototype.removeAllListeners=function(a){if(a){var b,c;for(c in this._events)if(this._events.hasOwnProperty(c)){for(b=this._events[c].length-1;b>=0;b--){var d=this._events[c][b];d.ctx===a&&this._events[c].splice(b,1)}this._events[c].length||delete this._events[c]}}else this._events={}},a.EventDispatcher=b}(d),function(a){"use strict";function b(){}function c(a,b){this.url=a||null,this.method=b,this._xmlhttp=null}function d(){d.__super__.constructor.call(this),this._connection=null}var e=a.Event,f=a.EventDispatcher;b.GET="GET",d.RESPONSE="response",d.INSTANCE="instance",a.extend(d,f),d.prototype.close=function(){this.removeAllListeners(null)},d.prototype.load=function(a){a&&a.method&&a.url&&(a._xmlhttp=this._createCORSRequest(a),a._xmlhttp?a._xmlhttp.send():this._loadImage(a))},d.prototype._createCORSRequest=function(a){var b=null;if("undefined"!=typeof window.XMLHttpRequest){var c=new window.XMLHttpRequest;"withCredentials"in c&&(b=c,b.open(a.method,a.url,!0))}if(null==b&&"undefined"!=typeof window.XDomainRequest&&(b=new window.XDomainRequest,b.open(a.method,a.url)),b){var f={};f[d.INSTANCE]=this;var g=this;b.onload=function(){return b.status&&parseInt(b.status,10)>=400?this.onerror():(f[d.RESPONSE]=b.responseText,void g.dispatchEvent(new e(e.SUCCESS,f)))},b.onerror=function(){g.dispatchEvent(new e(e.ERROR,f))}}return b},d.prototype._loadImage=function(a){this._connection||(this._connection=new Image,this._connection.alt=""),this._connection.src=a.url;var b={};b[d.RESPONSE]="",b[d.INSTANCE]=this,this.dispatchEvent(new e(e.SUCCESS,b))},a.URLRequestMethod=b,a.URLRequest=c,a.URLLoader=d}(d),function(a){"use strict";var b="js",c="1.5.4.34",d="c8947c",e=3,f={};f.getVersion=function(){return b+"-"+c+"-"+d},f.getMajor=function(){return f.getNumberAtPosition(0)},f.getMinor=function(){return f.getNumberAtPosition(1)},f.getMicro=function(){return f.getNumberAtPosition(2)},f.getPatch=function(){return f.getNumberAtPosition(3)},f.getBuild=function(){return d},f.getApiLevel=function(){return e},f.getNumberAtPosition=function(a){return c.split(".")[a]},a.Version=f}(c),function(a){"use strict";function b(a,b){this._message=a,this._details=b}b.prototype.getMessage=function(){return this._message},b.prototype.getDetails=function(){return this._details},a.ErrorInfo=b}(c),function(a){"use strict";function b(){this.debugLogging=!1}a.HeartbeatConfig=b}(c),function(a){"use strict";function b(){}b.prototype.onError=function(a){},a.HeartbeatDelegate=b}(c),function(a){"use strict";function b(){}b.prototype.configure=function(a){throw new Error("Implementation error: Method must be overridden.")},b.prototype.bootstrap=function(a){throw new Error("Implementation error: Method must be overridden.")},b.prototype.setup=function(){throw new Error("Implementation error: Method must be overridden.")},b.prototype.destroy=function(){throw new Error("Implementation error: Method must be overridden.")},b.prototype.enable=function(){throw new Error("Implementation error: Method must be overridden.")},b.prototype.disable=function(){throw new Error("Implementation error: Method must be overridden.")},b.prototype.getName=function(){throw new Error("Implementation error: Method must be overridden.")},b.prototype.isInitialized=function(){throw new Error("Implementation error: Method must be overridden.")},b.prototype.resolveData=function(a){throw new Error("Implementation error: Method must be overridden.")},a.plugin.IPlugin=b}(d),function(a){"use strict";function b(a,b,c,d){this.trigger=a,this.action=c,this.plugin=b,this._paramMappings={},this.mergeParams(d)}var c=a.plugin.ParamMapping;b.prototype.mergeParams=function(a){if(a)for(var b=0;b<a.length;b++){var c=a[b];this._paramMappings[c.getKeyName()]=c}},b.prototype.getParams=function(){var a=[];for(var b in this._paramMappings)this._paramMappings.hasOwnProperty(b)&&a.push(this._paramMappings[b]);return a},b.prototype.addParam=function(a){this._paramMappings[a.getKeyName()]=a},b.prototype.removeParam=function(a,b){var d=new c(a,b);this._paramMappings.hasOwnProperty(d.getKeyName())&&delete this._paramMappings[d.getKeyName()]},a.plugin.Behaviour=b}(d),function(a){"use strict";function b(a,b,d){this._pluginName=a,this._key=b,this._paramName=d||a+c.SEPARATOR+b}var c=a.radio.Channel;b.prototype.getPluginName=function(){return this._pluginName},b.prototype.getKey=function(){return this._key},b.prototype.getKeyName=function(){return this._pluginName+c.SEPARATOR+this._key},b.prototype.getParamName=function(){return this._paramName},a.plugin.ParamMapping=b}(d),function(a){"use strict";function b(a){if(!a)throw new Error("Reference to the logger object cannot be NULL");this._logger=a,this._plugins={},this._behaviours={},this._radio=new d(this._logger),this._dataChannel=this._radio.channel(g),this._ctrlChannel=this._radio.channel(h)}var c=a.Event,d=a.radio.Radio,e=a.radio.Channel,f=a.plugin.Behaviour;b.ERROR="error",b.prototype.addPlugin=function(a){var b=a.getName();this._plugins[b]&&this._logger.warn(i,"#addPlugin > Replacing plugin: "+b),this._plugins[b]=a,a.bootstrap(this)},b.prototype.setupPlugins=function(){for(var a in this._plugins)this._plugins.hasOwnProperty(a)&&this._plugins[a].setup()},b.prototype.pluginExists=function(a){return!!this._plugins[a]},b.prototype.isPluginInitialized=function(a){return this._plugins[a]&&this._plugins[a].isInitialized()},b.prototype.on=function(a,b,c,d){this._dataChannel.on(a+e.SEPARATOR+b,c,d)},b.prototype.off=function(a,b,c,d){var f=a&&b?a+e.SEPARATOR+b:null;this._dataChannel.off(f,c,d)},b.prototype.trigger=function(a){var b=a.name,c=this._behaviours[b];if(c){var d,e,f,g,h,i={},j={};for(d=0;d<c.length;d++)if(f=c[d],g=f.getParams())for(e=0;e<g.length;e++)h=g[e],i[h.getPluginName()]=i[h.getPluginName()]||[],h.key in i[h.getPluginName()]||i[h.getPluginName()].push(h.getKey());for(var k in i)i.hasOwnProperty(k)&&(j[k]=this.request(k,i[k]));for(d=0;d<c.length;d++){f=c[d];var l={_behaviour:f,_eventData:a.data||{}};if(g=f.getParams()){for(e=0;e<g.length;e++)h=g[e],l[h.getParamName()]=j[h.getPluginName()]?j[h.getPluginName()][h.getKey()]:null;this.command(f.plugin.getName(),f.action,l)}}}this._dataChannel.trigger(a)},b.prototype.request=function(a,b){var c=this._plugins[a];return c&&b&&0!=b.length?c.resolveData(b):null},b.prototype.raise=function(a){this._errorInfo=a;var d=new c(b.ERROR,a);this._ctrlChannel.trigger(d)},b.prototype.getErrorInfo=function(){return this._errorInfo},b.prototype.destroy=function(){this._radio.shutdown();for(var a in this._plugins)this._plugins.hasOwnProperty(a)&&this._plugins[a].destroy()},b.prototype.comply=function(a,b,c){this._dataChannel.comply(a.getName()+e.SEPARATOR+b,c,a)},b.prototype.command=function(a,b,c){this._dataChannel.command(a+e.SEPARATOR+b,c)},b.prototype.registerBehaviour=function(a,b,c,d){var e=a.getName(),g=new f(a,b,c,d);this._behaviours[e]=this._behaviours[e]||[],this._behaviours[e].push(g)};var g="data_channel",h="ctrl_channel",i="plugin::PluginManager";a.plugin.PluginManager=b}(d),function(a,b){"use strict";function c(a){this._name=a,this._isInitialized=!1,this._isDestroyed=!1,this._isEnabled=!0,this._dataResolver={},this._logTag="plugin::"+this.getName(),this._logger=new d}var d=a.Logger,e=a.Trigger,f=a.Event,g=b.ErrorInfo;c.INITIALIZED="initialized",c.prototype.configure=function(a){},c.prototype.bootstrap=function(a){this._pluginManager=a,this._isDestroyed&&this._pluginManager.raise(new g("Invalid state.","Plugin already destroyed."))},c.prototype.setup=function(){this._trigger(c.INITIALIZED),this._isInitialized=!0},c.prototype.destroy=function(){this._isDestroyed||(this._isDestroyed=!0,this._teardown())},c.prototype.enable=function(){this._isEnabled=!0,this._enabled()},c.prototype.disable=function(){this._isEnabled=!1,this._disabled()},c.prototype.getName=function(){return this._name},c.prototype.getLogger=function(){return this._logger},c.prototype.isInitialized=function(){return this._isInitialized},c.prototype.resolveData=function(a){if(!this._isEnabled||!this._isInitialized)return this._logger.warn(this._logTag,"Unable to retrieve plugin data. Plugin: "+this._name+". Enabled: "+this._isEnabled+". Initialized: "+this._isInitialized+"."),null;if("function"==typeof this._dataResolver)return this._dataResolver.call(this,a);var b=null;if(a)for(var c=0;c<a.length;c++){var d=a[c];this._dataResolver.hasOwnProperty(d)&&(b=b||{},"function"==typeof this._dataResolver[d]?b[d]=this._dataResolver[d].call(this):b[d]=this._dataResolver[d])}return b},c.prototype.toString=function(){return"<plugin: "+this._name+">"},c.prototype._enabled=function(){},c.prototype._disabled=function(){},c.prototype._teardown=function(){},c.prototype._canProcess=function(){return this._isEnabled?this._isDestroyed?(this._logger.error(this._logTag,"Plugin destroyed."),!1):!0:(this._logger.error(this._logTag,"Plugin disabled."),!1)},c.prototype._trigger=function(a,b){var c=f.createFromTrigger(new e(this.getName(),a));c.data=b,this._pluginManager.trigger(c)},a.plugin.BasePlugin=c}(d,c),function(a){"use strict";function b(a,b,c){this.name=a,this.interval=b,this.isActive=!1,this.repeatCount="undefined"!=typeof c?c:e,this._nextTickTimestamp=0,this.reset()}function c(a,b){if(!a)throw new Error("Reference to the ClockService object cannot be NULL");if(this._service=a,!b)throw new Error("Reference to the logger object cannot be NULL");this._logger=b,this._isDestroyed=!1,this._timers={};var c=this;this._clock=window.setInterval(function(){c._onTick()},1e3*f)}b.prototype.reset=function(){this.tick=0,this._createdTimestamp=(new Date).getTime(),this._updateNextTickTimestamp()},b.prototype.shouldTick=function(){var a=(new Date).getTime();return a>this._nextTickTimestamp-f/2?(this.tick++,this._updateNextTickTimestamp(),!0):!1},b.prototype._updateNextTickTimestamp=function(){this._nextTickTimestamp=this._createdTimestamp+1e3*this.interval*(this.tick+1)},c.prototype.createTimer=function(a,c,d){this._timers[a]=new b(a,c,d)},c.prototype.destroyTimer=function(a){delete this._timers[a]},c.prototype.resumeTimer=function(a,b){b="undefined"!=typeof b?b:!1,this._logger.debug(d,"#resumeTimer(name="+a+", reset="+b+")");var c=this._timers[a];c&&(c.isActive=!0,b&&c.reset())},c.prototype.pauseTimer=function(a,b){b="undefined"!=typeof b?b:!1,this._logger.debug(d,"#pauseTimer(name="+a+", reset="+b+")");var c=this._timers[a];c&&(c.isActive=!1,b&&c.reset())},c.prototype.isTimerPaused=function(a){var b=this._timers[a];return b?!b.isActive:!1},c.prototype.destroy=function(){this._isDestroyed||(this._isDestroyed=!0,this._timers={},window.clearInterval(this._clock))},c.prototype._onTick=function(){for(var a in this._timers)if(this._timers.hasOwnProperty(a)){var b=this._timers[a];b.isActive&&b.shouldTick()&&(b.interval>1&&this._logger.debug(d,"#_onTick() > "+b.name+"("+b.tick+" | "+b.repeatCount+")"),0!=b.repeatCount?(this._service.onTick(b.name,b.interval,b.tick),b.repeatCount!=e&&b.repeatCount--):this.destroyTimer(b.name))}};var d="service.clock::TimerManager",e=-1,f=.25;a.clock.TimerDescriptor=b,a.clock.TimerManager=c}(e),function(a,b,c){"use strict";function d(a){if(d.__super__.constructor.call(this,h),!a)throw new Error("Reference to the logger object cannot be NULL");this._logger=a,this._timerManager=new e(this,this._logger),this._setupDataResolver()}var e=c.clock.TimerManager,f=b.StringUtils,g=a.plugin.BasePlugin;a.extend(d,g),d.prototype.bootstrap=function(a){d.__super__.bootstrap.call(this,a),this._pluginManager.comply(this,i,this._cmdCreate),this._pluginManager.comply(this,k,this._cmdResume),this._pluginManager.comply(this,j,this._cmdPause),this._pluginManager.comply(this,l,this._cmdDestroy)},d.prototype._teardown=function(){this._timerManager.destroy()},d.prototype._cmdCreate=function(a){var b=a[o]||s;this._timerManager.createTimer(a[m],a[n],b)},d.prototype._cmdPause=function(a){this._timerManager.pauseTimer(a[m],!!a[q])},d.prototype._cmdResume=function(a){this._timerManager.resumeTimer(a[m],!!a[q])},d.prototype._cmdDestroy=function(a){this._timerManager.destroyTimer(a[m])},d.prototype.onTick=function(a,b,c){a+=".tick";var d={};d[m]=a,d[n]=b,d[p]=c,this._trigger(a,d)},d.prototype._setupDataResolver=function(){var a={},b=this._timerManager;a[r]=function(a){return b.isTimerPaused(a)},this._dataResolver=function(b){if(!b||0==b.length)return null;for(var c=null,d=0;d<b.length;d++){var e=b[d];if(c=c||{},f.startsWith(e,r)){var g=e.split(r+".");g.length>0&&(c[e]=a[r].call(this,g[1]))}}return c}};var h="service.clock",i="create",j="pause",k="resume",l="destroy",m="name",n="interval",o="repeat_count",p="tick",q="reset",r="is_paused",s=-1;c.clock.ClockService=d}(d,b,e),function(a,b,c){"use strict";function d(a,b){if(this._logger=new e,this._pluginManager=new f(this._logger),this._pluginManager.addPlugin(new g(this._logger)),b)for(var c=0;c<b.length;c++)this._pluginManager.addPlugin(b[c]);this._pluginManager.setupPlugins(),this._isDestroyed=!1}var e=a.Logger,f=a.plugin.PluginManager,g=b.clock.ClockService;d.prototype.configure=function(a){if(!a)throw new Error("Configuration object cannot be NULL.");a.debugLogging?this._logger.enable():this._logger.disable(),this._isDestroyed&&this._logger.error(h,"Instance is destroyed.")},d.prototype.destroy=function(){this._isDestroyed||(this._pluginManager.destroy(),this._isDestroyed=!0)};var h="Heartbeat";c.Heartbeat=d}(d,e,c),a.ADB||(a.ADB={}),a.ADB.core||(a.ADB.core=d),a.ADB.va||(a.ADB.va=c),a.ADB.va.utils||(a.ADB.va.utils=b),a.ADB.va.plugins||(a.ADB.va.plugins={})}(this);
	
	// VideoPlayerPlugin
	!function(a){if("undefined"==typeof b)var b={};!function(a){"use strict";var b={};b.ASSET_TYPE_VOD="vod",b.ASSET_TYPE_LIVE="live",b.ASSET_TYPE_LINEAR="linear",a.AssetType=b}(b),function(a){"use strict";function b(){this.playerName=null,this.name=null,this.position=null,this.startTime=null}b.prototype.toString=function(){return"playerName="+this.playerName+", name="+this.name+", position="+this.position+", startTime="+this.startTime},a.AdBreakInfo=b}(b),function(a){"use strict";function b(){this.id=null,this.name=null,this.length=null,this.position=null}b.prototype.toString=function(){return"id="+this.id+", name="+this.name+", length="+this.length+", position="+this.position},a.AdInfo=b}(b),function(a){"use strict";function b(){this.name=null,this.length=null,this.position=null,this.startTime=null}b.prototype.toString=function(){return"name="+this.name+", length="+this.length+", position="+this.position+", startTime="+this.startTime},a.ChapterInfo=b}(b),function(a){"use strict";function b(){this.bitrate=null,this.fps=null,this.droppedFrames=null,this.startupTime=null}b.prototype.toString=function(){return"bitrate="+this.bitrate+", fps="+this.fps+", droppedFrames="+this.droppedFrames+", startupTime="+this.startupTime},a.QoSInfo=b}(b),function(a){"use strict";function b(){this.playerName=null,this.id=null,this.name=null,this.length=null,this.playhead=null,this.streamType=null}b.prototype.toString=function(){return"playerName="+this.playerName+", id="+this.id+", name="+this.name+", length="+this.length+", playhead="+this.playhead+", streamType="+this.streamType},a.VideoInfo=b}(b),function(a){"use strict";function b(){this.debugLogging=!1}a.VideoPlayerPluginConfig=b}(b),function(a){"use strict";function b(){}b.prototype.getVideoInfo=function(){throw new Error("Implementation error: Method must be overridden.")},b.prototype.getAdBreakInfo=function(){return null},b.prototype.getAdInfo=function(){return null},b.prototype.getChapterInfo=function(){return null},b.prototype.getQoSInfo=function(){return null},a.VideoPlayerPluginDelegate=b}(b),function(a,b){"use strict";function c(a){if(c.__super__.constructor.call(this,f),!a)throw new Error("PlayerPlugin delegate cannot be NULL.");this._delegate=a,this._isTrackingSessionActive=!1,this._isTrackingSessionStarted=!1,this._playheadTimer=null,this._previousPlayhead=-1,this._stalledPlayheadCount=0,this._playheadStalled=!1,this._setupDataResolver()}var d=a.plugin.BasePlugin,e=b.VideoPlayerPluginConfig;a.extend(c,d),c.prototype.configure=function(a){if(!a)throw new Error("Reference to the configuration data cannot be NULL.");if(!(a instanceof e))throw new Error("Expected config data to be instance of VideoPlayerPluginConfig.");a.debugLogging?this._logger.enable():this._logger.disable(),this._logger.debug(this._logTag,"#configure(debugLogging="+a.debugLogging+")")},c.prototype.trackSessionStart=function(){if(this._logger.info(this._logTag,"#trackSessionStart()"),this._canProcess()){if(!this._isTrackingSessionActive)return void this._logger.warn(this._logTag,"#trackSessionStart() > No active tracking session.");if(this._isTrackingSessionStarted)return void this._logger.info(this._logTag,"#trackSessionStart() > Tracking session already started.");this._trigger(k),this._isTrackingSessionStarted=!0}},c.prototype.trackVideoLoad=function(){this._logger.info(this._logTag,"#trackVideoLoad()"),this._canProcess()&&(this._trigger(i),this._isTrackingSessionActive=!0,this._isTrackingSessionStarted=!1)},c.prototype.trackVideoUnload=function(){if(this._logger.info(this._logTag,"#trackVideoUnload()"),this._canProcess()){if(!this._isTrackingSessionActive)return void this._logger.warn(this._logTag,"#trackVideoUnload() > No active tracking session.");this._stopPlayheadTimer(),this._trigger(j),this._isTrackingSessionActive=!1,this._isTrackingSessionStarted=!1}},c.prototype.trackPlay=function(){this._logger.info(this._logTag,"#trackPlay()"),this._canProcess()&&this._startSessionIfNeeded("trackPlay")&&(this._trigger(n),this._startPlayheadTimer())},c.prototype.trackPause=function(){this._logger.info(this._logTag,"#trackPause()"),this._canProcess()&&this._startSessionIfNeeded("trackPause")&&(this._stopPlayheadTimer(),this._trigger(o))},c.prototype.trackBufferStart=function(){this._logger.info(this._logTag,"#trackBufferStart()"),this._canProcess()&&this._startSessionIfNeeded("trackBufferStart")&&(this._stopPlayheadTimer(),this._trigger(r))},c.prototype.trackBufferComplete=function(){this._logger.info(this._logTag,"#trackBufferComplete()"),this._canProcess()&&this._startSessionIfNeeded("trackBufferComplete")&&(this._trigger(s),this._startPlayheadTimer())},c.prototype.trackSeekStart=function(){this._logger.info(this._logTag,"#trackSeekStart()"),this._canProcess()&&this._startSessionIfNeeded("trackSeekStart")&&(this._stopPlayheadTimer(),this._trigger(t))},c.prototype.trackSeekComplete=function(){this._logger.info(this._logTag,"#trackSeekComplete()"),this._canProcess()&&this._startSessionIfNeeded("trackSeekComplete")&&(this._trigger(u),this._startPlayheadTimer())},c.prototype.trackComplete=function(a){if(this._logger.info(this._logTag,"#trackComplete()"),this._canProcess()&&this._startSessionIfNeeded("trackComplete")){var b={};b[z]=a,this._stopPlayheadTimer(),this._trigger(l,b)}},c.prototype.trackTimedMetadata=function(a){this._logger.info(this._logTag,"#trackComplete()"),this._canProcess()&&this._startSessionIfNeeded("trackTimedMetadata")&&this._trigger(m,a)},c.prototype.trackChapterStart=function(){this._logger.info(this._logTag,"#trackChapterStart()"),this._canProcess()&&this._startSessionIfNeeded("#trackChapterStart")&&this._trigger(v)},c.prototype.trackChapterComplete=function(){this._logger.info(this._logTag,"trackChapterComplete()"),this._canProcess()&&this._startSessionIfNeeded("trackChapterComplete")&&this._trigger(w)},c.prototype.trackAdStart=function(){this._logger.info(this._logTag,"#trackAdStart()"),this._canProcess()&&this._startSessionIfNeeded("trackAdStart")&&this._trigger(p)},c.prototype.trackAdComplete=function(){this._logger.info(this._logTag,"#trackAdComplete()"),this._canProcess()&&this._startSessionIfNeeded("trackAdComplete")&&this._trigger(q)},c.prototype.trackBitrateChange=function(){this._logger.info(this._logTag,"#trackBitrateChange()"),this._canProcess()&&this._startSessionIfNeeded("trackBitrateChange")&&this._trigger(x)},c.prototype.trackVideoPlayerError=function(a){if(this._logger.info(this._logTag,"#trackVideoPlayerError(errorId="+a+")"),this._startSessionIfNeeded("trackVideoPlayerError")){var b={};b[A]=h,b[B]=a,this._trigger(y,b)}},c.prototype.trackApplicationError=function(a){if(this._logger.info(this._logTag,"#trackApplicationError(errorId="+a+")"),this._startSessionIfNeeded("trackApplicationError")){var b={};b[A]=g,b[B]=a,this._trigger(y,b)}},c.prototype._setupDataResolver=function(){function a(){return g.video?g.video:(g.video=h._delegate.getVideoInfo(),h._logger.info(h._logTag,"Data from delegate > VideoInfo: "+g.video),g.video)}function b(){return g.ad?g.ad:(g.ad=h._delegate.getAdInfo(),h._logger.info(h._logTag,"Data from delegate > AdInfo: "+g.ad),g.ad)}function c(){return g.pod?g.pod:(g.pod=h._delegate.getAdBreakInfo(),h._logger.info(h._logTag,"Data from delegate > AdBreakInfo: "+g.pod),g.pod)}function d(){return g.chapter?g.chapter:(g.chapter=h._delegate.getChapterInfo(),h._logger.info(h._logTag,"Data from delegate > ChapterInfo: "+g.chapter),g.chapter)}function e(){return g.qos?g.qos:(g.qos=h._delegate.getQoSInfo(),h._logger.info(h._logTag,"Data from delegate > QoSInfo: "+g.qos),g.qos)}var f={},g={},h=this;f["video.id"]=function(){var b=a(),c=b?b.id:null;return h._logger.debug(h._logTag,"Resolving video.id: "+c),c},f["video.name"]=function(){var b=a(),c=b?b.name:null;return h._logger.debug(h._logTag,"Resolving video.name: "+c),c},f["video.length"]=function(){var b=a(),c=b?b.length:NaN;return h._logger.debug(h._logTag,"Resolving video.length: "+c),c},f["video.playerName"]=function(){var b=a(),c=b?b.playerName:null;return h._logger.debug(h._logTag,"Resolving video.playerName: "+c),c},f["video.streamType"]=function(){var b=a(),c=b?b.streamType:null;return h._logger.debug(h._logTag,"Resolving video.streamType: "+c),c},f["video.playhead"]=function(){var b=a(),c=b?b.playhead:NaN;return h._logger.debug(h._logTag,"Resolving video.playhead: "+c),c},f["pod.name"]=function(){var a=c(),b=a?a.name:null;return h._logger.debug(h._logTag,"Resolving pod.name: "+b),b},f["pod.playerName"]=function(){var a=c(),b=a?a.playerName:null;return h._logger.debug(h._logTag,"Resolving pod.playerName: "+b),b},f["pod.position"]=function(){var a=c(),b=a?a.position:NaN;return h._logger.debug(h._logTag,"Resolving pod.position: "+b),b},f["pod.startTime"]=function(){var a=c(),b=a?a.startTime:NaN;return h._logger.debug(h._logTag,"Resolving pod.startTime: "+b),b},f["ad.isInAd"]=function(){var a=b(),c=null!=a;return h._logger.debug(h._logTag,"Resolving ad.isInAd: "+c),c},f["ad.isInAdBreak"]=function(){var a=c(),b=null!=a;return h._logger.debug(h._logTag,"Resolving ad.isInAdBreak: "+b),b},f["ad.id"]=function(){var a=b(),c=a?a.id:null;return h._logger.debug(h._logTag,"Resolving ad.id: "+c),c},f["ad.name"]=function(){var a=b(),c=a?a.name:null;return h._logger.debug(h._logTag,"Resolving ad.name: "+c),c},f["ad.length"]=function(){var a=b(),c=a?a.length:NaN;return h._logger.debug(h._logTag,"Resolving ad.length: "+c),c},f["ad.position"]=function(){var a=b(),c=a?a.position:NaN;return h._logger.debug(h._logTag,"Resolving ad.position: "+c),c},f["chapter.isInChapter"]=function(){var a=d(),b=null!=a;return h._logger.debug(h._logTag,"Resolving chapter.isInChapter: "+b),b},f["chapter.name"]=function(){var a=d(),b=a?a.name:null;return h._logger.debug(h._logTag,"Resolving chapter.name: "+b),b},f["chapter.length"]=function(){var a=d(),b=a?a.length:NaN;return h._logger.debug(h._logTag,"Resolving chapter.length: "+b),b},f["chapter.position"]=function(){var a=d(),b=a?a.position:NaN;return h._logger.debug(h._logTag,"Resolving chapter.position: "+b),b},f["chapter.startTime"]=function(){var a=d(),b=a?a.startTime:NaN;return h._logger.debug(h._logTag,"Resolving chapter.startTime: "+b),b},f["qos.bitrate"]=function(){var a=e(),b=a?a.bitrate:NaN;return h._logger.debug(h._logTag,"Resolving qos.bitrate: "+b),b},f["qos.fps"]=function(){var a=e(),b=a?a.fps:NaN;return h._logger.debug(h._logTag,"Resolving qos.fps: "+b),b},f["qos.droppedFrames"]=function(){var a=e(),b=a?a.droppedFrames:NaN;return h._logger.debug(h._logTag,"Resolving qos.droppedFrames: "+b),b},f["qos.startupTime"]=function(){var a=e(),b=a?1e3*a.startupTime:NaN;return h._logger.debug(h._logTag,"Resolving qos.startupTime: "+b),b},this._dataResolver=function(a){if(!a||0==a.length)return null;g={};for(var b=null,c=0;c<a.length;c++){var d=a[c];b=b||{},b[d]=f.hasOwnProperty(d)?f[d].call(this):null}return b}},c.prototype._trackPlayheadStall=function(){this._canProcess()&&(this._playheadStalled||(this._logger.info(this._logTag,"#_trackPlayheadStall()"),this._stalledPlayheadCount=0,this._playheadStalled=!0,this._trigger(o)))},c.prototype._trackExitStall=function(){this._canProcess()&&(this._stalledPlayheadCount=0,this._playheadStalled&&(this._logger.info(this._logTag,"#_trackExitStall()"),this._playheadStalled=!1,this.trackPlay()))},c.prototype._startPlayheadTimer=function(){var a=this;this._playheadTimer||(this._playheadTimer=setInterval(function(){if(a._canProcess()){var b=a._dataResolver(["ad.isInAd","video.playhead"]);if(b.hasOwnProperty("ad.isInAd")&&b["ad.isInAd"])a._playheadStalled&&a._trackExitStall();else{var c=b["video.playhead"];c!=a._previousPlayhead?a._trackExitStall():a._previousPlayhead>=0&&c==a._previousPlayhead&&(a._stalledPlayheadCount++,a._stalledPlayheadCount==D&&a._trackPlayheadStall()),a._previousPlayhead=c}}},C))},c.prototype._stopPlayheadTimer=function(){this._playheadTimer&&(clearInterval(this._playheadTimer),this._playheadTimer=null),this._stalledPlayheadCount=0},c.prototype._startSessionIfNeeded=function(a){return this._isTrackingSessionActive?(this._isTrackingSessionStarted||(this._logger.info(this._logTag,"#"+a+"() > Tracking session auto-start."),this.trackSessionStart()),!0):(this._logger.warn(this._logTag,"#"+a+"() > No active tracking session."),!1)};var f="player",g="sourceErrorExternal",h="sourceErrorSDK",i="video_load",j="video_unload",k="video_start",l="video_complete",m="timed_metadata",n="play",o="pause",p="ad_start",q="ad_complete",r="buffer_start",s="buffer_complete",t="seek_start",u="seek_complete",v="chapter_start",w="chapter_complete",x="bitrate_change",y="track_error",z="callback",A="source",B="error_id",C=1001,D=2;b.VideoPlayerPlugin=c}(a.ADB.core,b),a.ADB.va.plugins.videoplayer||(a.ADB.va.plugins.videoplayer=b)}(this);
	
	// AdobeHeartbeatPlugin
	!function(a){if("undefined"==typeof b)var b={};b.clock||(b.clock={}),b.context||(b.context={}),b.filter||(b.filter={}),b.model||(b.model={}),b.network||(b.network={}),function(a,b){"use strict";function c(a,b,c,d,e){if(!b)throw new Error("Reference to the channel object cannot be NULL");if(this._channel=b,!a)throw new Error("Reference to the pluginManager object cannot be NULL");if(this._pluginManager=a,!e)throw new Error("Reference to the logger object cannot be NULL");this._logTag="ah::Timer."+c,this._logger=e,this._isDestroyed=!1,this._createTimer(c,d),this._installHandlers()}var d=a.Event;c.KEY_NAME="name",c.KEY_INTERVAL="interval",c.KEY_RESET="reset",c.prototype.resume=function(a){this._logger.debug(this._logTag,"Starting timer: "+this._name);var b={};b[c.KEY_NAME]=e+"."+this._name,b[c.KEY_RESET]=a,this._pluginManager.command(f,i,b)},c.prototype.pause=function(a){this._logger.debug(this._logTag,"Stopping timer: "+this._name);var b={};b[c.KEY_NAME]=e+"."+this._name,b[c.KEY_RESET]=a,this._pluginManager.command(f,h,b)},c.prototype.destroy=function(){if(!this._isDestroyed){this._isDestroyed=!0,this._uninstallHandlers();var a={};a[c.KEY_NAME]=e+"."+this._name,this._pluginManager.command(f,j,a)}},c.prototype.setInterval=function(a){var b=k+"."+e+"."+this._name,c=this._pluginManager.request(f,[b])[b];this.pause(!0),this._createTimer(this._name,a),c||this.resume(!0)},c.prototype._cmdResume=function(a){var b=!1;null!=a&&a.hasOwnProperty(c.KEY_RESET)&&(b=a[c.KEY_RESET]),this.resume(b)},c.prototype._cmdPause=function(a){var b=!1;null!=a&&a.hasOwnProperty(c.KEY_RESET)&&(b=a[c.KEY_RESET]),this.pause(b)},c.prototype._onTick=function(a,b){this._channel.trigger(new d("clock:"+this._name+".tick",b))},c.prototype._installHandlers=function(){this._channel.comply("clock:"+this._name+".resume",this._cmdResume,this),this._channel.comply("clock:"+this._name+".pause",this._cmdPause,this),this._pluginManager.on(f,e+"."+this._name+".tick",this._onTick,this)},c.prototype._uninstallHandlers=function(){this._channel.off(null,null,this),this._pluginManager.off(null,null,null,this)},c.prototype._createTimer=function(a,b){this._name=a,this._interval=b;var d={};d[c.KEY_NAME]=e+"."+this._name,d[c.KEY_INTERVAL]=this._interval,this._pluginManager.command(f,g,d)};var e="heartbeat",f="service.clock",g="create",h="pause",i="resume",j="destroy",k="is_paused";b.clock.Timer=c}(a.ADB.core,b),function(a,b){"use strict";function c(a,b,d){c.__super__.constructor.call(this,a,b,f,h,d)}var d=a.Event,e=b.clock.Timer;a.extend(c,e),c.prototype._onCheckStatusComplete=function(a){var b=a.data[l];if(this._logger.debug(this._logTag,"#_onCheckStatusComplete(interval="+b+")"),b){if(b==this._interval)return void this._logger.debug(this._logTag,"#_onCheckStatusComplete() > Interval value not changed.");b>g?(this._logger.warn(this._logTag,"#_onCheckStatusComplete() > Interval value too large: "+b),this.setInterval(g)):(this._logger.debug(this._logTag,"#_onCheckStatusComplete() > Interval changed to: "+b),this.setInterval(b))}else this._logger.warn(this._logTag,"#_onCheckStatusComplete() > Invalid interval value."),this.setInterval(h)},c.prototype._getSettings=function(a){this._logger.debug(this._logTag,"#_getSettings()"),this._channel.trigger(new d(i))},c.prototype._installHandlers=function(){c.__super__._installHandlers.call(this),this._channel.on(j,this._getSettings,this),this._channel.on(k,this._onCheckStatusComplete,this),this._channel.reply(l,function(){return this._interval},this)};var f="check_status",g=600,h=60,i="clock:check_status.tick",j="clock:check_status.get_settings",k="net:check_status_complete",l="check_status_interval";b.clock.CheckStatusTimer=c}(a.ADB.core,b),function(a,b){"use strict";function c(a,b,d){c.__super__.constructor.call(this,a,b,e,f,d)}var d=b.clock.Timer;a.extend(c,d),c.prototype._onCheckStatusComplete=function(a){var b=a.data[g];if(this._logger.debug(this._logTag,"#_onCheckStatusComplete(interval="+b+")"),b){if(b==this._interval)return void this._logger.debug(this._logTag,"#_onCheckStatusComplete() > Interval value not changed.");this._logger.debug(this._logTag,"#_onCheckStatusComplete() > Interval changed to: "+b),this.setInterval(b)}else this._logger.warn(this._logTag,"#_onCheckStatusComplete() > Invalid interval value."),this.setInterval(f)},c.prototype._installHandlers=function(){c.__super__._installHandlers.call(this),this._channel.on(h,this._onCheckStatusComplete,this),this._channel.reply(g,function(){return this._interval},this)};var e="reporting",f=10,g="reporting_interval",h="net:check_status_complete";b.clock.ReportingTimer=c}(a.ADB.core,b),function(a,b){"use strict";function c(a,b,d){c.__super__.constructor.call(this,a,b,e,f,d)}var d=b.clock.Timer;a.extend(c,d);var e="flush_filter",f=.25;b.clock.FlushFilterTimer=c}(a.ADB.core,b),function(a,b){"use strict";function c(a,b,c){if(!a)throw new Error("Reference to the pluginManager object cannot be NULL");if(!b)throw new Error("Reference to the channel object cannot be NULL");if(!c)throw new Error("Reference to the logger object cannot be NULL");this._isDestroyed=!1,this._reportingTimer=new f(a,b,c),this._checkStatusTimer=new d(a,b,c),this._flushFilterTimer=new e(a,b,c)}var d=b.clock.CheckStatusTimer,e=b.clock.FlushFilterTimer,f=b.clock.ReportingTimer;c.prototype.destroy=function(){this._isDestroyed||(this._isDestroyed=!0,this._reportingTimer.destroy(),this._checkStatusTimer.destroy(),this._flushFilterTimer.destroy())},b.clock.Clock=c}(a.ADB.core,b),function(a,b){"use strict";function c(a,b){this.value=a,this.hint=b}function d(a){this.realm=a,this.data={}}c.HINT_SHORT="short",d.prototype.setField=function(a,b,d){this.data[a]=new c(b,d)},d.prototype._createAccessor=function(a,b,c){var d=this;return function(){return arguments.length&&(d[a]=arguments[0],d.setField(b,arguments[0],c)),d[a]}},b.model.Dao=d,b.model.DaoField=c}(a.ADB.core,b),function(a,b){"use strict";function c(){if(c.__super__.constructor.call(this,"asset"),this.adId=this._createAccessor("_adId","ad_id",null),this.sid=this._createAccessor("_sid","ad_sid",null),this.resolver=this._createAccessor("_resolver","resolver",null),this.podId=this._createAccessor("_podId","pod_id",null),this.podPosition=this._createAccessor("_podPosition","pod_position",null),this.podOffset=this._createAccessor("_podOffset","pod_offset",null),this.podName=this._createAccessor("_podName","pod_name",null),this.adLength=this._createAccessor("_adLength","ad_length",null),this.adName=this._createAccessor("_adName","ad_name",null),arguments.length&&arguments[0]instanceof c){var a=arguments[0];this.adId(a.adId()),this.sid(a.sid()),this.resolver(a.resolver()),this.podId(a.podId()),this.podPosition(a.podPosition()),this.podOffset(a.podOffset()),this.podName(a.podName()),this.adLength(a.adLength()),this.adName(a.adName())}else this.adId(""),this.sid(""),this.resolver(""),this.podId(""),this.podPosition(""),this.podOffset(0),this.podName(""),this.adLength(0),this.adName("")}var d=b.model.Dao;a.extend(c,d),b.model.AdDao=c}(a.ADB.core,b),function(a,b){"use strict";function c(){if(c.__super__.constructor.call(this,"sc"),this.reportSuiteId=this._createAccessor("_reportSuiteId","rsid",null),this.trackingServer=this._createAccessor("_trackingServer","tracking_server",null),this.ssl=this._createAccessor("_ssl","ssl",e.HINT_SHORT),arguments.length&&arguments[0]instanceof c){var a=arguments[0];this.reportSuiteId(a.reportSuiteId()),this.trackingServer(a.trackingServer()),this.ssl(a.ssl())}else this.reportSuiteId(""),this.trackingServer(""),this.ssl(0)}var d=b.model.Dao,e=b.model.DaoField;a.extend(c,d),b.model.AdobeAnalyticsDao=c}(a.ADB.core,b),function(a,b){"use strict";function c(){if(c.__super__.constructor.call(this,"stream"),this.id=this._createAccessor("_id","chapter_id",null),this.sid=this._createAccessor("_sid","chapter_sid",null),this.name=this._createAccessor("_name","chapter_name",null),this.position=this._createAccessor("_position","chapter_pos",null),this.length=this._createAccessor("_length","chapter_length",null),this.offset=this._createAccessor("_offset","chapter_offset",null),arguments.length&&arguments[0]instanceof c){var a=arguments[0];this.id(a.id()),this.sid(a.sid()),this.name(a.name()),this.position(a.position()),this.length(a.length()),this.offset(a.offset())}else this.id(""),this.sid(""),this.name(""),this.position(0),this.length(0),this.offset(0)}var d=b.model.Dao;a.extend(c,d),b.model.ChapterDao=c}(a.ADB.core,b),function(a,b){"use strict";function c(){if(c.__super__.constructor.call(this,"asset"),this.type=this._createAccessor("_type","type",null),this.videoId=this._createAccessor("_videoId","video_id",null),this.publisher=this._createAccessor("_publisher","publisher",null),this.adData=this._createAccessor("_adData","ad_data",null),this.chapterData=this._createAccessor("_chapterData","chapter_data",null),this.length=this._createAccessor("_length","length",null),this.name=this._createAccessor("_name","name",null),arguments.length&&arguments[0]instanceof c){var a=arguments[0];this.type(a.type()),this.name(a.name()),this.videoId(a.videoId()),this.publisher(a.publisher()),this.length(a.length());var b=a.adData()?new e(a.adData()):null;this.adData(b);var d=a.chapterData()?new f(a.chapterData()):null;this.chapterData(d)}else this.type(""),this.name(""),this.videoId(""),this.publisher(""),this.length(0),this.adData(null),this.chapterData(null)}var d=b.model.Dao,e=b.model.AdDao,f=b.model.ChapterDao;a.extend(c,d),c.TYPE_AD="ad",c.TYPE_MAIN_CONTENT="main",b.model.AssetDao=c}(a.ADB.core,b),function(a,b){"use strict";function c(){if(c.__super__.constructor.call(this,"event"),this.type=this._createAccessor("_type","type",null),this.duration=this._createAccessor("_duration","duration",null),this.playhead=this._createAccessor("_playhead","playhead",null),this.id=this._createAccessor("_id","id",null),this.source=this._createAccessor("_source","source",null),this.ts=this._createAccessor("_ts","ts",null),this.prevTs=this._createAccessor("_prevTs","prev_ts",null),arguments.length&&arguments[0]instanceof c){var a=arguments[0];this.type(a.type()),this.duration(a.duration()),this.playhead(a.playhead()),this.id(a.id()),this.source(a.source()),this.ts(a.ts()),this.prevTs(a.prevTs())}else this.type(""),this.duration(0),this.playhead(0),this.id(""),this.source(""),this.ts(0),this.prevTs(-1)}var d=b.model.Dao;a.extend(c,d),c.EVENT_TYPE_AA_START="aa_start",c.EVENT_TYPE_AA_AD_START="aa_ad_start",c.EVENT_TYPE_START="start",c.EVENT_TYPE_CHAPTER_START="chapter_start",c.EVENT_TYPE_CHAPTER_COMPLETE="chapter_complete",c.EVENT_TYPE_PLAY="play",c.EVENT_TYPE_PAUSE="pause",c.EVENT_TYPE_BUFFER="buffer",c.EVENT_TYPE_BITRATE_CHANGE="bitrate_change",c.EVENT_TYPE_ERROR="error",c.EVENT_TYPE_COMPLETE="complete",b.model.EventDao=c}(a.ADB.core,b),function(a,b){"use strict";function c(){if(c.__super__.constructor.call(this,"stream"),this.bitrate=this._createAccessor("_bitrate","bitrate",null),this.fps=this._createAccessor("_fps","fps",null),this.droppedFrames=this._createAccessor("_droppedFrames","dropped_frames",null),this.startupTime=this._createAccessor("_startup_time","startup_time",null),arguments.length&&arguments[0]instanceof c){var a=arguments[0];this.bitrate(a.bitrate()),this.fps(a.fps()),this.droppedFrames(a.droppedFrames()),this.startupTime(a.startupTime()),this.isStartupTimeOverridden=a.isStartupTimeOverridden}else this.bitrate(0),this.fps(0),this.droppedFrames(0),this.startupTime(0),this.isStartupTimeOverridden=!1}var d=b.model.Dao;a.extend(c,d),b.model.QoSDao=c}(a.ADB.core,b),function(a,b){"use strict";function c(){if(c.__super__.constructor.call(this,"sp"),this.ovp=this._createAccessor("_ovp","ovp",null),this.sdk=this._createAccessor("_sdk","sdk",null),this.channel=this._createAccessor("_channel","channel",null),this.playerName=this._createAccessor("_playerName","player_name",null),this.libVersion=this._createAccessor("_libVersion","hb_version",null),this.apiLevel=this._createAccessor("_apiLevel","hb_api_lvl",null),arguments.length&&arguments[0]instanceof c){var a=arguments[0];this.ovp(a.ovp()),this.sdk(a.sdk()),this.channel(a.channel()),this.playerName(a.playerName()),this.libVersion(a.libVersion()),this.apiLevel(a.apiLevel())}else this.ovp(e),this.sdk(e),this.channel(e),this.playerName(""),this.libVersion(""),this.apiLevel(0)}var d=b.model.Dao;a.extend(c,d);var e="unknown";b.model.ServiceProviderDao=c}(a.ADB.core,b),function(a,b){"use strict";function c(){if(c.__super__.constructor.call(this,"event"),this.sessionId=this._createAccessor("_sessionId","sid",null),arguments.length&&arguments[0]instanceof c){var a=arguments[0];this.sessionId(a.sessionId())}else this.sessionId(null)}var d=b.model.Dao;a.extend(c,d),b.model.SessionDao=c}(a.ADB.core,b),function(a,b){"use strict";function c(){if(c.__super__.constructor.call(this,"stream"),this.type=this._createAccessor("_type","type",null),arguments.length&&arguments[0]instanceof c){var a=arguments[0];this.type(a.type())}else this.type(null)}var d=b.model.Dao;a.extend(c,d),b.model.StreamDao=c}(a.ADB.core,b),function(a,b){"use strict";function c(){if(c.__super__.constructor.call(this,"user"),this.analyticsVisitorId=this._createAccessor("_analyticsVisitorId","aid",null),this.marketingCloudVisitorId=this._createAccessor("_marketingCloudVisitorId","mid",null),this.visitorId=this._createAccessor("_visitorId","id",null),arguments.length&&arguments[0]instanceof c){var a=arguments[0];this.analyticsVisitorId(a.analyticsVisitorId()),this.marketingCloudVisitorId(a.marketingCloudVisitorId()),this.visitorId(a.visitorId())}else this.analyticsVisitorId(null),this.marketingCloudVisitorId(null),this.visitorId(null)}var d=b.model.Dao;a.extend(c,d),b.model.UserDao=c}(a.ADB.core,b),function(a,b){"use strict";function c(a,b,c,i,j){this.eventData=new e,this.eventData.type(b),this.eventData.duration(0),this.eventData.ts((new Date).getTime()),this.eventData.playhead(c),this.assetData=new f(a._assetData),this.streamData=new g(a._streamData),this.qosData=new h(a._qosData),this.cuserData=d.clone(a._cuserData),this.meta=i,this.callback=j}var d=a.ObjectUtils,e=b.model.EventDao,f=b.model.AssetDao,g=b.model.StreamDao,h=b.model.QoSDao;b.model.TrackItem=c}(a.ADB.va.utils,b),function(a,b){"use strict";function c(a,b,c,i,j){this.adobeAnalyticsData=a,this.userData=b,this.serviceProviderData=c,this.sessionData=i,this.eventData=new e(j.eventData),this.assetData=new f(j.assetData),this.streamData=new g(j.streamData),this.qosData=new h(j.qosData),this.cuserData=d.clone(j.cuserData),this.meta=d.clone(j.meta),this.callback=j.callback}var d=a.ObjectUtils,e=b.model.EventDao,f=b.model.AssetDao,g=b.model.StreamDao,h=b.model.QoSDao;b.model.CUserDao;b.model.Report=c}(a.ADB.va.utils,b),function(a){"use strict";function b(){}b.prototype.serializeReport=function(a){},b.prototype.serializeDao=function(a){},b.prototype.serializeMap=function(a){},b.prototype.serializeNumber=function(a,b,c,d){},b.prototype.serializeString=function(a,b,c,d){},a.model.ISerializer=b}(b),function(a,b){"use strict";function c(a){if(!a)throw new Error("Reference to the logger object cannot be NULL");this._logger=a}var d=b.model.Dao,e=b.model.DaoField,f=b.model.ISerializer;a.extend(c,f),c.prototype.serializeReport=function(a){var b=[];return b.push(this.serializeDao(a.adobeAnalyticsData)),b.push(this.serializeDao(a.userData)),b.push(this.serializeMap(a.cuserData,"cuser")),b.push(this.serializeDao(a.serviceProviderData)),b.push(this.serializeDao(a.sessionData)),b.push(this.serializeDao(a.eventData)),b.push(this.serializeDao(a.assetData)),b.push(this.serializeDao(a.streamData)),b.push(this.serializeDao(a.qosData)),b.push(this.serializeMap(a.meta,"meta")),{serializedOutput:b.filter(function(a){return!!a}).join("&"),callback:a.callback}},c.prototype.serializeDao=function(a){var b=this._processDao(a);return b.filter(function(a){return!!a}).join("&")},c.prototype.serializeMap=function(a,b){var c=[],d=b?b:"meta";for(var e in a)a.hasOwnProperty(e)&&a[e]&&c.push("s:"+d+":"+e+"="+window.encodeURIComponent(a[e]));return c.join("&")},c.prototype.serializeNumber=function(a,b,c,d){var f=h;return null==b||isNaN(b)?null:(d===e.HINT_SHORT&&(f=i),f+":"+c+":"+a+"="+Math.floor(b))},c.prototype.serializeString=function(a,b,c,d){return b?j+":"+c+":"+a+"="+window.encodeURIComponent(b):null},c.prototype._processDao=function(a){var b=[];for(var c in a.data)if(a.data.hasOwnProperty(c)){var e=a.data[c],f=e.value,h=e.hint,i=null,j=a.realm;if(null==f)continue;"number"==typeof f?i=this.serializeNumber(c,f,j,h):"string"==typeof f?i=this.serializeString(c,f,j,h):f instanceof d?i=this.serializeDao(f):this._logger.warn(g,"#_processDao() > Unable to serialize DAO. Field: "+c+". Value: "+f+"."),i&&b.push(i)}return b};var g="ah::QuerystringSerializer",h="l",i="h",j="s";b.model.QuerystringSerializer=c}(a.ADB.core,b),function(a,b){"use strict";function c(a,b){if(!a)throw new Error("Reference to the data object cannot be NULL");if(this._data=a,!b)throw new Error("Reference to the logger object cannot be NULL");this._logger=b}c.prototype.parse=function(){var a,b,c,i,j;if(window.DOMParser){var k=new window.DOMParser;j=k.parseFromString(this._data,"text/xml")}else j=new window.ActiveXObject("Microsoft.XMLDOM"),j.async=!1,j.loadXML(this.data);var l;l=parseInt(j.getElementsByTagName("trackingInterval")[0].childNodes[0].nodeValue,10),l&&(a=l),l=parseInt(j.getElementsByTagName("setupCheckInterval")[0].childNodes[0].nodeValue,10),l&&(b=l),l=parseInt(j.getElementsByTagName("trackExternalErrors")[0].childNodes[0].nodeValue,10),l&&(c=1==l),j.getElementsByTagName("nielsenEnabled")[0]?(l=parseInt(j.getElementsByTagName("nielsenEnabled")[0].childNodes[0].nodeValue,10),i=1==l):i=!0;var m={};return m[e]=a,m[f]=b,m[g]=c,m[h]=i,this._logger.debug(d,"#parse() > Obtained configuration settings."),m};var d="ah::SettingsParser",e="reporting_interval",f="check_status_interval",g="track_external_errors",h="nielsen_enabled";b.network.SettingsParser=c}(a.ADB.core,b),function(a,b){"use strict";function c(a,b){if(this._trackingServer=null,this._checkStatusServer=null,this._publisher=null,this._quietMode=!1,this._isConfigured=!1,this._isDestroyed=!1,!a)throw new Error("Reference to the channel object cannot be NULL");if(this._channel=a,!b)throw new Error("Reference to the logger object cannot be NULL");this._logger=b,this._serializer=new i(b),this._installEventListeners()}var d=a.Event,e=a.URLRequestMethod,f=a.URLRequest,g=a.URLLoader,h=b.network.SettingsParser,i=b.model.QuerystringSerializer;c.prototype.destroy=function(){this._isDestroyed||(this._isDestroyed=!0,this._logger.debug(j,"#destroy()"),this._uninstallEventListeners())},c.prototype._onApiConfig=function(a){var b=a.data;this._logger.debug(j,"#_onApiConfig(sb_server="+b[k]+", check_status_server="+b[l]+", publisher="+b[m]+", quiet_mode="+b[n]+", ssl="+b[o]+")"),this._trackingServer=this._updateRequestProtocol(b[k],b[o]),this._checkStatusServer=this._updateRequestProtocol(b[l],b[o]),this._publisher=b[m],this._quietMode=b[n],this._isConfigured=!0},c.prototype._onFilterReportAvailable=function(a){var b=a.data;if(!this._isConfigured)return void this._logger.warn(j,"#_onFilterReportAvailable() > Unable to send request: not configured.");var c=b[p],h=this._serializer.serializeReport(c),i=this._trackingServer+"/?"+h.serializedOutput,k=new f(i,e.GET);this._logger.debug(j,"_onFilterReportAvailable() > "+k.url);var l=this,m=function(a){o.close(),h.callback&&h.callback.call(null)},n=function(a){o.close(),l._logger.warn(j,"#_onFilterReportAvailable() > Failed to send heartbeat report."),h.callback&&h.callback.call(null)};if(!this._quietMode){var o=new g;o.addEventListener(d.SUCCESS,m,this),o.addEventListener(d.ERROR,n,this),o.load(k)}},c.prototype._onClockCheckStatusTick=function(a){function b(a){if(a.data){var b=new h(a.data.response,i._logger),c=b.parse();c?i._channel.trigger(new d(t,c)):i._logger.warn(j,"#_onClockCheckStatusTick() > Failed to parse the config. settings.")}n.close()}function c(a){i._logger.warn(j,"#_onClockCheckStatusTick() > Failed to obtain the config. settings."),n.close()}if(!this._isConfigured)return void this._logger.warn(j,"#_onClockCheckStatusTick() > Unable to send request: not configured.");if(!this._publisher)return void this._logger.warn(j,"#_onClockCheckStatusTick() > Publisher is NULL.");var i=this,k=this._publisher.replace(/[^a-zA-Z0-9]+/,"-").toLocaleLowerCase(),l=this._checkStatusServer+k+".xml?r="+(new Date).getTime(),m=new f(l,e.GET),n=new g;n.addEventListener(d.SUCCESS,b,this),n.addEventListener(d.ERROR,c,this),this._logger.debug(j,"#_onClockCheckStatusTick() > Get new settings from: "+l),n.load(m)},c.prototype._updateRequestProtocol=function(a,b){var c=a;return 0===c.indexOf("http://")?c=c.slice(7):0===c.indexOf("https://")&&(c=c.slice(8)),b?"https://"+c:"http://"+c},c.prototype._installEventListeners=function(){this._channel.on(q,this._onApiConfig,this),this._channel.on(r,this._onFilterReportAvailable,this),this._channel.on(s,this._onClockCheckStatusTick,this)},c.prototype._uninstallEventListeners=function(){this._channel.off(null,null,this)};var j="ah::Network",k="tracking_server",l="check_status_server",m="publisher",n="quiet_mode",o="ssl",p="report",q="api:config",r="filter:data_available",s="clock:check_status.tick",t="net:check_status_complete";b.network.Network=c}(a.ADB.core,b),function(a,b){"use strict";function c(a,b){if(!a)throw new Error("Reference to the channel object cannot be NULL");if(this._channel=a,!b)throw new Error("Reference to the logger object cannot be NULL");this._logger=b,this._isDestroyed=!1,this._isBufferingInProgress=!1,this._reportBuffer={},this._tsHistory={},this._workQueue=new i,this._installEventListeners()}function d(a){var b=[];if(a)for(var c=0;c<a.length;c++){var d=a[c];d.eventData.type()!=k.EVENT_TYPE_PAUSE&&b.push(d)}return b}function e(a){var b=-1,c=-1,d=[];return a.forEach(function(a){a.eventData.type()==k.EVENT_TYPE_START?a.assetData.type()==l.TYPE_MAIN_CONTENT?-1==b?b=d.push(a)-1:(a.eventData.prevTs(-1),d[b]=a):-1==c?c=d.push(a)-1:(a.eventData.prevTs(-1),d[c]=a):d.push(a)}),d}function f(a){var b=[];return a.forEach(function(c){if(c.eventData.type()==k.EVENT_TYPE_PLAY){if(c.eventData.duration()>t)b.push(c);else if(0==c.eventData.duration()&&c.assetData.type()==l.TYPE_MAIN_CONTENT){var d=g(a);d.indexOf(c)==d.length-1&&b.push(c)}}else b.push(c)}),b}function g(a){var b=[];return a.forEach(function(a){(a.eventData.type()==k.EVENT_TYPE_PLAY||a.eventData.type()==k.EVENT_TYPE_BUFFER||a.eventData.type()==k.EVENT_TYPE_START)&&b.push(a)}),b}var h=a.radio.Command,i=a.radio.CommandQueue,j=a.Event,k=b.model.EventDao,l=b.model.AssetDao;c.prototype.destroy=function(){this._isDestroyed||(this._isDestroyed=!0,this._logger.debug(v,"#destroy()"),this._uninstallEventListeners(),this.clear())},c.prototype.clear=function(){this._logger.debug(v,"#clear()"),this._workQueue.cancelAllCommands(),this._reportBuffer={},this._tsHistory={},this._isBufferingInProgress=!1},c.prototype._bufferReport=function(a){if(!this._isDestroyed){var b=a[q];if(b){var c=b.sessionData.sessionId();this._reportBuffer[c]=this._reportBuffer[c]||[],this._reportBuffer[c].push(b)}if(!this._isBufferingInProgress){this._isBufferingInProgress=!0;var d={};d[p]=!0,d[r]=1,this._channel.command(s,d)}}},c.prototype._flushBufferReport=function(){function a(a){if(a)for(var c=0;c<a.length;c++){var d=a[c],e=d.sessionData.sessionId();b._tsHistory[e]=b._tsHistory[e]||{};var f=d.eventData.type()+"."+(d.assetData.type()==l.TYPE_AD?d.assetData.adData().adId():d.assetData.videoId());b._tsHistory[e].hasOwnProperty(f)&&d.eventData.prevTs(b._tsHistory[e][f]),b._tsHistory[e][f]=d.eventData.ts()}}if(!this._isDestroyed){var b=this;for(var c in this._reportBuffer)if(this._reportBuffer.hasOwnProperty(c)){var g=f(e(d(this._reportBuffer[c])));a(g);for(var h=0;h<g.length;h++){var i=g[h],k={};k[q]=i,this._channel.trigger(new j(n,k))}}this._reportBuffer={};var m=this._channel.request(u),o=this._tsHistory[m]||{};this._tsHistory={},this._tsHistory[m]=o,this._isBufferingInProgress=!1}},c.prototype._onContextReportAvailable=function(a){var b=a.data;this._workQueue.addCommand(new h(this._bufferReport,this,[b]))},c.prototype._onClockFlushFilterTick=function(a){this._workQueue.addCommand(new h(this._flushBufferReport,this))},c.prototype._installEventListeners=function(){this._channel.on(m,this._onContextReportAvailable,this),this._channel.on(o,this._onClockFlushFilterTick,this)},c.prototype._uninstallEventListeners=function(){this._channel.off(null,null,this)};var m="context:report_available",n="filter:data_available",o="clock:flush_filter.tick",p="reset",q="report",r="repeat_count",s="clock:flush_filter.resume",t=250,u="session_id",v="ah::ReportFilter";b.filter.ReportFilter=c}(a.ADB.core,b),function(a,b){"use strict";function c(a,b){this._onFail={fn:a,ctx:b}}var d=a.ErrorInfo;c.prototype.validateFields=function(a,b){if(!a)return this._fail("Data cannot be null");if(b)for(var c=0;c<b.length;c++){var d=b[c];switch(d){case"videoId":if(!a.hasOwnProperty("videoId"))return this._fail("The ID for the main video must be specified.");if("string"!=typeof a.videoId)return this._fail("The ID for the main video must be a String.");if(""===a.videoId)return this._fail("The ID for the main video cannot be an empty string.");break;case"streamType":if(!a.hasOwnProperty("streamType"))return this._fail("The stream type for the main video must be specified.");if("string"!=typeof a.streamType)return this._fail("The stream type for the main video must be a String.");if(""===a.streamType)return this._fail("The stream type for the main video cannot be an empty string.");break;case"videoLength":if(!a.hasOwnProperty("videoLength"))return this._fail("The length of the main video must be specified.");if("number"!=typeof a.videoLength)return this._fail("The length of the main video must be a Number.");if(isNaN(a.videoLength))return this._fail("The length of the main video cannot be NaN.");break;case"playhead":if(!a.hasOwnProperty("playhead"))return this._fail("The playhead for the main video must be specified.");if("number"!=typeof a.playhead)return this._fail("The playhead for the main video must be a Number.");if(isNaN(a.playhead))return this._fail("The playhead for the main video cannot be NaN.");break;case"playerName":if(!a.hasOwnProperty("playerName"))return this._fail("The player name for the main video must be specified.");if("string"!=typeof a.playerName)return this._fail("The player name for the main video must be a String.");if(""===a.playerName)return this._fail("The player name for the main video cannot be an empty string.");break;case"podPlayerName":if(!a.hasOwnProperty("podPlayerName"))return this._fail("The player name for the ad-break must be specified.");if("string"!=typeof a.podPlayerName)return this._fail("The player name for the ad-break must be a String.");if(""===a.podPlayerName)return this._fail("The player name for the ad-break cannot be an empty string.");break;case"podPosition":if(!a.hasOwnProperty("podPosition"))return this._fail("Position (index) of the ad-break must be specified.");if("number"!=typeof a.podPosition)return this._fail("Position (index) of the ad-break must be a Number.");if(isNaN(a.podPosition))return this._fail("Position (index) of the ad-break cannot be NaN.");break;case"adId":if(!a.hasOwnProperty("adId"))return this._fail("The ad ID must be specified.");if("string"!=typeof a.adId)return this._fail("The ad ID must be a String.");if(""===a.adId)return this._fail("The ad ID cannot be an empty string.");break;case"adPosition":if(!a.hasOwnProperty("adPosition"))return this._fail("Position (index) of the ad must be specified.");if("number"!=typeof a.adPosition)return this._fail("Position (index) of the ad must be a Number.");if(isNaN(a.adPosition))return this._fail("Position (index) of the ad cannot be NaN.");break;case"chapterPosition":if(!a.hasOwnProperty("chapterPosition"))return this._fail("Position (index) of the chapter must be specified.");if("number"!=typeof a.chapterPosition)return this._fail("Position (index) of the chapter must be a Number.");if(isNaN(a.chapterPosition))return this._fail("Position (index) of the chapter cannot be NaN.");break;case"chapterOffset":if(!a.hasOwnProperty("chapterOffset"))return this._fail("Chapter start-time (offset) must be specified.");if("number"!=typeof a.chapterOffset)return this._fail("Chapter start-time (offset) must be a Number.");if(isNaN(a.chapterOffset))return this._fail("Chapter start-time (offset) cannot be NaN.");break;case"chapterLength":if(!a.hasOwnProperty("chapterLength"))return this._fail("The length of the chapter must be specified.");if("number"!=typeof a.chapterLength)return this._fail("The length of the chapter must be a Number.");if(isNaN(a.chapterLength))return this._fail("The length of the chapter cannot be NaN.");break;default:return this._fail("Unable to validate unknown parameter: "+d)}}return!0},c.prototype._fail=function(a){var b=new d("Invalid input data",a);return this._onFail.fn&&this._onFail.fn.call(this._onFail.ctx,b),!1},b.context.InputDataValidator=c}(a.ADB.va,b),function(a,b){"use strict";function c(a,b){if(!b)throw new Error("Reference to the logger object cannot be NULL");if(this._logger=b,!a)throw new Error("Reference to the context object cannot be NULL");this._context=a}var d=b.model.Report;c.prototype.createReportForItem=function(a){return this._logger.debug(e,"Creating report for item: "+a.eventData.type()),new d(this._context._adobeAnalyticsData,this._context._userData,this._context._serviceProviderData,this._context._sessionData,a)};var e="ah::ReportFactory";b.context.ReportFactory=c}(a.ADB.core,b),function(a,b,c,d){"use strict";function e(a,b){if(!a)throw new Error("Reference to the channel object cannot be NULL");if(this._channel=a,!b)throw new Error("Reference to the logger object cannot be NULL");this._logger=b,this._lastInBandItem=null,this._autoComputedStartupTime=0,this._reportingInterval=ba,this._assetData=null,this._streamData=null,this._qosData=null,this._sessionData=null,this._cuserData=null,this._adobeAnalyticsData=new j,this._serviceProviderData=new k,this._userData=new l,this._isTrackingSessionActive=!1,this._isVideoComplete=!1,this._activeAssetId=null,this._isDestroyed=!1,this._doNotOverrideEventDuration=!1,this._reportFactory=new t(this,this._logger),this._inputDataValidator=new u(function(a){this._logger.error(v,a.getMessage()+" | "+a.getDetails()),this._channel.trigger(new h(x,a))},this),this._stashedChapterData=null,this._stashedAdData=null,this._trackExternalErrors=!0,this._installEventListeners()}var f=c.md5,g=c.ObjectUtils,h=a.Event,i=d.model.SessionDao,j=d.model.AdobeAnalyticsDao,k=d.model.ServiceProviderDao,l=d.model.UserDao,m=d.model.EventDao,n=d.model.AssetDao,o=d.model.StreamDao,p=d.model.QoSDao,q=d.model.AdDao,r=d.model.ChapterDao,s=d.model.TrackItem,t=d.context.ReportFactory,u=d.context.InputDataValidator;e.prototype.destroy=function(){this._isDestroyed||(this._isDestroyed=!0,this._logger.debug(v,"#destroy()"),this._uninstallEventListeners())},e.prototype._onApiAnalyticsStart=function(a){this._logger.debug(v,"#_onApiAnalyticsStart()");var b=a.data;if(this._checkCall("_onApiAnalyticsStart")&&this._inputDataValidator.validateFields(b,["playhead"])){this._userData.visitorId(b.vid),this._userData.analyticsVisitorId(b.aid),this._userData.marketingCloudVisitorId(b.mid),b.customerIDs&&(this._cuserData=b.customerIDs),this._updateQoSInfo(b);var c=new s(this,m.EVENT_TYPE_AA_START,b.playhead,null,b._eventData[C]);c.assetData.adData(null),c.assetData.type(n.TYPE_MAIN_CONTENT),this._cuserData=null,this._sendHit(c)}},e.prototype._onApiAnalyticsAdStart=function(a){this._logger.debug(v,"#_onApiAnalyticsAdStart()");var b=a.data;if(this._checkCall("_onApiAnalyticsAdStart")&&this._inputDataValidator.validateFields(b,["playhead"])){this._updateQoSInfo(b);var c=new s(this,m.EVENT_TYPE_AA_AD_START,b.playhead,null,b._eventData[C]);this._sendHit(c)}},e.prototype._onApiVideoLoad=function(a){this._logger.debug(v,"#_onApiVideoLoad()"),
	this._resetInternalState(),this._sessionData.sessionId(this._generateSessionId()),this._isTrackingSessionActive=!0},e.prototype._onApiVideoUnload=function(a){return this._logger.debug(v,"#_onApiVideoUnload()"),this._isTrackingSessionActive?void(this._isTrackingSessionActive=!1):void this._logger.debug(v,"#_onApiVideoUnload() > No active tracking session.")},e.prototype._onApiVideoStart=function(a){var b=a.data;if(this._logger.debug(v,"#_onApiVideoStart(id="+b.videoId+", name="+b.videoName+", length="+b.videoLength+", type="+b.streamType+", playerName="+b.playerName+")"),this._checkCall("_onApiVideoStart")&&this._inputDataValidator.validateFields(b,["videoId","streamType","videoLength","playhead","playerName"])){this._adobeAnalyticsData.reportSuiteId(b.rsid),this._adobeAnalyticsData.trackingServer(b.trackingServer),this._adobeAnalyticsData.ssl(Number(b.useSsl)),this._serviceProviderData.ovp(b.ovp),this._serviceProviderData.sdk(b.sdk),this._serviceProviderData.channel(b.channel),this._serviceProviderData.libVersion(b.version),this._serviceProviderData.apiLevel(b.apiLvl),this._activeAssetId=b.videoId,this._serviceProviderData.playerName(b.playerName),this._assetData.videoId(this._activeAssetId),this._assetData.length(b.videoLength),this._assetData.type(n.TYPE_MAIN_CONTENT),this._assetData.publisher(b.publisher),this._assetData.name(b.videoName),this._streamData.type(b.streamType),this._updateQoSInfo(b);var c=b.metaNielsen?g.merge(b.metaVideo,b.metaNielsen):b.metaVideo,d=new s(this,m.EVENT_TYPE_START,b.playhead,c,b._eventData[C]);this._sendHit(d)}},e.prototype._onApiVideoComplete=function(a){this._logger.debug(v,"#_onApiVideoComplete()");var b=a.data;if(this._checkCall("_onApiVideoComplete")){var c=new s(this,m.EVENT_TYPE_COMPLETE,this._assetData.length(),null,b._eventData[C]);this._sendHit(c),this._isVideoComplete=!0}},e.prototype._onApiPlay=function(a){this._logger.debug(v,"#_onApiPlay()");var b=a.data;if(this._checkCall("_onApiPlay")&&this._inputDataValidator.validateFields(b,["playhead"])){this._updateQoSInfo(b);var c=new s(this,m.EVENT_TYPE_PLAY,b.playhead,null,b._eventData[C]);this._sendHit(c)}},e.prototype._onApiPause=function(a){this._logger.debug(v,"#_onApiPause()");var b=a.data;if(this._checkCall("_onApiPause")&&this._inputDataValidator.validateFields(b,["playhead"])){this._updateQoSInfo(b);var c=new s(this,m.EVENT_TYPE_PAUSE,b.playhead,null,b._eventData[C]);this._sendHit(c)}},e.prototype._onApiBufferStart=function(a){this._logger.debug(v,"#_onApiBufferStart()");var b=a.data;if(this._checkCall("_onApiBufferStart")&&this._inputDataValidator.validateFields(b,["playhead"])){this._updateQoSInfo(b);var c=new s(this,m.EVENT_TYPE_BUFFER,b.playhead,null,b._eventData[C]);this._sendHit(c)}},e.prototype._onApiSeekStart=function(a){this._logger.debug(v,"#_onApiSeekStart()"),this._checkCall("_onApiSeekStart")&&(this._stashedAdData=this._assetData.adData(),this._stashedChapterData=this._assetData.chapterData(),this._assetData.adData(null),this._assetData.type(n.TYPE_MAIN_CONTENT),this._activeAssetId=this._assetData.videoId(),this._assetData.chapterData(null))},e.prototype._onApiSeekComplete=function(a){this._logger.debug(v,"#_onApiSeekComplete()");var b=a.data;if(this._checkCall("_onApiSeekComplete")&&this._inputDataValidator.validateFields(b,["playhead"])){if(b.isInAd){if(!this._inputDataValidator.validateFields(b,["adId","adPosition","podPosition","podPlayerName"]))return;var c=f(this._assetData.videoId())+"_"+b.podPosition;if(this._stashedAdData&&this._stashedAdData.podId()==c&&parseInt(this._stashedAdData.podPosition(),10)==b.adPosition)this._assetData.adData(this._stashedAdData),this._activeAssetId=this._stashedAdData.adId();else if(!this._assetData.adData()){this._activeAssetId=b.adId;var d=new q;d.adId(this._activeAssetId),d.adName(b.adName),d.adLength(b.adLength),d.podId(c),d.resolver(b.podPlayerName),d.podPosition(b.podPosition+""),d.podName(b.podName),d.podOffset(b.podSecond),d.sid(this._generateSessionId()),this._assetData.adData(d)}this._assetData.type(n.TYPE_AD)}else this._assetData.adData(null),this._assetData.type(n.TYPE_MAIN_CONTENT),this._activeAssetId=this._assetData.videoId();if(b.isInChapter){if(!this._inputDataValidator.validateFields(b,["chapterPosition","chapterLength","chapterOffset"]))return;if(this._stashedChapterData&&b.chapterPosition==this._stashedChapterData.position())this._assetData.chapterData(this._stashedChapterData);else if(!this._assetData.chapterData()){var e=new r;e.id(f(this._assetData.videoId())+"_"+b.chapterPosition),e.name(b.chapterName),e.length(b.chapterLength),e.position(b.chapterPosition),e.offset(b.chapterOffset),e.sid(this._generateSessionId()),this._assetData.chapterData(e)}}else this._assetData.chapterData(null);this._stashedAdData=null,this._stashedChapterData=null}},e.prototype._onApiAdStart=function(a){var b=a.data;if(this._logger.debug(v,"#_onApiAdStart(id="+b.adId+", player_name="+b.podPlayerName+", parent_name="+this._assetData.videoId()+", pod_pos="+b.adPosition+")"),this._checkCall("_onApiAdStart")&&this._inputDataValidator.validateFields(b,["playhead","podPosition","podPlayerName","adId","adPosition"])){this._activeAssetId=b.adId;var c=new q;c.adId(this._activeAssetId),c.adName(b.adName),c.adLength(b.adLength),c.resolver(b.podPlayerName),c.podId(f(this._assetData.videoId())+"_"+b.podPosition),c.podPosition(b.adPosition+""),c.podName(b.podName),c.podOffset(b.podSecond),c.sid(this._generateSessionId()),this._assetData.adData(c),this._assetData.type(n.TYPE_AD),this._updateQoSInfo(b);var d=g.merge(b.metaVideo,b.metaAd);d=b.metaNielsen?g.merge(d,b.metaNielsen):d;var e=new s(this,m.EVENT_TYPE_START,b.playhead,d,b._eventData[C]);this._sendHit(e)}},e.prototype._onApiAdComplete=function(a){this._logger.debug(v,"#_onApiAdComplete()");var b=a.data;if(this._checkCall("_onApiAdComplete")&&this._inputDataValidator.validateFields(b,["playhead"])){if(this._assetData.type()!=n.TYPE_AD)return void this._logger.warn(v,"#_onApiAdComplete() > Ignoring the ad complete event, because we are no longer in an ad.");this._updateQoSInfo(b);var c=new s(this,m.EVENT_TYPE_COMPLETE,b.playhead,null,b._eventData[C]);this._sendHit(c),this._assetData.adData(null),this._assetData.type(n.TYPE_MAIN_CONTENT),this._activeAssetId=this._assetData.videoId()}},e.prototype._onApiChapterStart=function(a){var b=a.data;if(this._logger.debug(v,"#_onApiChapterStart(name="+b.chapterName+", length="+b.chapterLength+", position="+b.chapterPosition+", chapter_offset="+b.chapterOffset+")"),this._checkCall("_onApiChapterStart")&&this._inputDataValidator.validateFields(b,["playhead","chapterPosition","chapterOffset","chapterLength"])){var c=new r;c.id(f(this._assetData.videoId())+"_"+b.chapterPosition),c.name(b.chapterName),c.length(b.chapterLength),c.position(b.chapterPosition),c.offset(b.chapterOffset),c.sid(this._generateSessionId()),this._assetData.chapterData(c),this._updateQoSInfo(b);var d=g.merge(b.metaVideo,b.metaAd);d=b.metaNielsen?g.merge(d,b.metaNielsen):d;var e=new s(this,m.EVENT_TYPE_CHAPTER_START,b.playhead,d,b._eventData[C]);e.assetData.adData(null),e.assetData.type(n.TYPE_MAIN_CONTENT),this._sendHit(e)}},e.prototype._onApiChapterComplete=function(a){this._logger.debug(v,"#_onApiChapterComplete()");var b=a.data;if(this._checkCall("_onApiChapterComplete")&&this._inputDataValidator.validateFields(b,["playhead"])){if(!this._assetData.chapterData())return void this._logger.warn(v,"#_onApiChapterComplete() > Ignoring the chapter complete event, because we are no longer in a chapter.");this._updateQoSInfo(b);var c=new s(this,m.EVENT_TYPE_CHAPTER_COMPLETE,b.playhead,null,b._eventData[C]);c.assetData.adData(null),c.assetData.type(n.TYPE_MAIN_CONTENT),this._sendHit(c),this._assetData.chapterData(null)}},e.prototype._onApiBitrateChange=function(a){this._logger.debug(v,"#_onApiBitrateChange()");var b=a.data;if(this._checkCall("_onApiBitrateChange")&&this._inputDataValidator.validateFields(b,["playhead"])){this._updateQoSInfo(b);var c=new s(this,m.EVENT_TYPE_BITRATE_CHANGE,b.playhead,null,b._eventData[C]);this._sendHit(c)}},e.prototype._onApiTrackError=function(a){var b=a.data;if(this._logger.debug(v,"#_onApiTrackError(source="+b._eventData.source+", err_id="+b._eventData.error_id+")"),!this._isTrackingSessionActive)return void this._logger.warn(v,"#_onApiTrackError() > No active tracking session.");if(this._trackExternalErrors||b._eventData.source===w){this._updateQoSInfo(b);var c=new s(this,m.EVENT_TYPE_ERROR,0,null,b._eventData[C]);c.eventData.id(b._eventData.error_id),c.eventData.source(b._eventData.source),this._sendHit(c)}},e.prototype._onApiTrackInternalError=function(a){this._logger.debug(v,"#_onApiTrackInternalError(source="+b.source+", err_id="+b.error_id+")");var b=a.data;this._updateQoSInfo(b);var c=new s(this,m.EVENT_TYPE_ERROR,0);c.eventData.id(b.error_id),c.eventData.source(b.source),this._sendHit(c)},e.prototype._onApiQuantumEnd=function(a){this._logger.debug(v,"#_onApiQuantumEnd(interval="+this._channel.request(A)+")");var b=a.data;this._checkCall("_onApiQuantumEnd")&&this._inputDataValidator.validateFields(b,["playhead"])&&(this._lastInBandItem.eventData.playhead(b.playhead),this._updateQoSInfo(b),this._lastInBandItem.qosData.bitrate(this._qosData.bitrate()),this._lastInBandItem.qosData.fps(this._qosData.fps()),this._lastInBandItem.qosData.droppedFrames(this._qosData.droppedFrames()),this._lastInBandItem.qosData.startupTime(this._qosData.startupTime()),this._sendHit(this._lastInBandItem))},e.prototype._onNetworkCheckStatusComplete=function(a){var b=a.data;this._trackExternalErrors=b[F],this._reportingInterval=b[G],this._reportingInterval||(this._reportingInterval=ba),this._logger.debug(v,"#_onNetworkCheckStatusComplete(track_ext_err="+this._trackExternalErrors+")")},e.prototype._installEventListeners=function(){this._channel.on(H,this._onApiAnalyticsStart,this),this._channel.on(I,this._onApiAnalyticsAdStart,this),this._channel.on(J,this._onApiVideoLoad,this),this._channel.on(K,this._onApiVideoUnload,this),this._channel.on(L,this._onApiVideoStart,this),this._channel.on(M,this._onApiVideoComplete,this),this._channel.on(N,this._onApiAdStart,this),this._channel.on(O,this._onApiAdComplete,this),this._channel.on(P,this._onApiPlay,this),this._channel.on(Q,this._onApiPause,this),this._channel.on(R,this._onApiBufferStart,this),this._channel.on(S,this._onApiSeekStart,this),this._channel.on(T,this._onApiSeekComplete,this),this._channel.on(U,this._onApiChapterStart,this),this._channel.on(V,this._onApiChapterComplete,this),this._channel.on(Y,this._onApiBitrateChange,this),this._channel.on(W,this._onApiTrackError,this),this._channel.on(X,this._onApiTrackInternalError,this),this._channel.on(Z,this._onApiQuantumEnd,this),this._channel.on(_,this._onNetworkCheckStatusComplete,this),this._channel.reply(B,function(){return this._sessionData&&this._sessionData.sessionId()?this._sessionData.sessionId():null},this)},e.prototype._uninstallEventListeners=function(){this._channel.off(null,null,this)},e.prototype._resetInternalState=function(){this._logger.debug(v,"#_resetInternalState()"),this._isTrackingSessionActive=!1,this._isVideoComplete=!1,this._autoComputedStartupTime=0,this._streamData=new o,this._qosData=new p,this._sessionData=new i,this._assetData=new n,this._cuserData=null,this._stashedAdData=null,this._stashedChapterData=null,this._lastInBandItem=null},e.prototype._generateSessionId=function(){return""+(new Date).getTime()+Math.floor(1e9*Math.random())},e.prototype._updateQoSInfo=function(a){this._qosData.bitrate(a.bitrate||0),this._qosData.fps(a.fps||0),this._qosData.droppedFrames(a.droppedFrames||0),null==a.startupTime||isNaN(a.startupTime)?(this._qosData.startupTime(this._autoComputedStartupTime),this._qosData.isStartupTimeOverridden=!1):(this._qosData.startupTime(a.startupTime),this._qosData.isStartupTimeOverridden=!0)},e.prototype._checkCall=function(a){return this._isTrackingSessionActive?this._isVideoComplete?(this._logger.warn(v,"#"+a+"() > The video content already completed."),!1):!0:(this._logger.warn(v,"#"+a+"() > No active tracking session."),!1)},e.prototype._updateLastInBandItem=function(a){var b=(new Date).getTime(),c=1e3*Math.abs(a.eventData.playhead()-this._lastInBandItem.eventData.playhead()),d=Math.abs(b-this._lastInBandItem.eventData.ts());this._lastInBandItem.eventData.type()!=m.EVENT_TYPE_PAUSE?(d*aa>=c||this._doNotOverrideEventDuration)&&d<=this._reportingInterval*aa*1e3?this._lastInBandItem.eventData.duration(b-this._lastInBandItem.eventData.ts()):(this._logger.warn(v,"[WARNING] Resetting duration in lastInBandItem to 0. playheadDelta:"+c+" tsDelta:"+d+" event type:"+this._lastInBandItem.eventData.type()),this._lastInBandItem.eventData.duration(0)):this._lastInBandItem.eventData.duration(b-this._lastInBandItem.eventData.ts()),this._doNotOverrideEventDuration&&(this._doNotOverrideEventDuration=!1),this._lastInBandItem.eventData.ts(b),this._lastInBandItem.eventData.playhead(a.eventData.playhead()),this._lastInBandItem.qosData.startupTime(a.qosData.startupTime()),this._lastInBandItem.qosData.isStartupTimeOverridden=a.qosData.isStartupTimeOverridden},e.prototype._sendHit=function(a){function b(a){var b=c._reportFactory.createReportForItem(a);b.qosData.isStartupTimeOverridden||b.qosData.startupTime(c._autoComputedStartupTime);var e={};e[D]=b,c._channel.trigger(new h($,e)),(b.eventData.type()==m.EVENT_TYPE_PLAY||b.eventData.type()==m.EVENT_TYPE_BUFFER||b.eventData.type()==m.EVENT_TYPE_START)&&(d={},d[E]=!0,c._channel.command(y,d))}var c=this,d={};switch(a.eventData.type()){case m.EVENT_TYPE_START:case m.EVENT_TYPE_PLAY:case m.EVENT_TYPE_PAUSE:case m.EVENT_TYPE_BUFFER:this._lastInBandItem&&(this._updateLastInBandItem(a),this._lastInBandItem.eventData.type()==m.EVENT_TYPE_START&&this._lastInBandItem.assetData.type()==n.TYPE_MAIN_CONTENT&&(this._autoComputedStartupTime+=this._lastInBandItem.eventData.duration()),a!=this._lastInBandItem&&b(this._lastInBandItem)),b(a),this._lastInBandItem=a,d={},d[E]=!0,this._channel.command(y,d);break;case m.EVENT_TYPE_COMPLETE:this._lastInBandItem&&(a.assetData.type()==n.TYPE_AD&&(this._doNotOverrideEventDuration=!0),this._updateLastInBandItem(a),b(this._lastInBandItem)),b(a),a.assetData.type()==n.TYPE_MAIN_CONTENT?(this._lastInBandItem=null,d={},d[E]=!0,this._channel.command(z,d)):a.assetData.type()==n.TYPE_AD&&(this._lastInBandItem.assetData.adData(null),this._lastInBandItem.assetData.type(n.TYPE_MAIN_CONTENT),this._doNotOverrideEventDuration=!0);break;case m.EVENT_TYPE_CHAPTER_START:case m.EVENT_TYPE_CHAPTER_COMPLETE:this._lastInBandItem&&(this._updateLastInBandItem(a),b(this._lastInBandItem)),b(a),this._lastInBandItem&&(this._lastInBandItem.assetData.chapterData(a.eventData.type()==m.EVENT_TYPE_CHAPTER_START?new r(a.assetData.chapterData()):null),this._lastInBandItem.eventData.duration(0),b(this._lastInBandItem));break;default:b(a)}};var v="ah::Context",w="sourceErrorSDK",x="error",y="clock:reporting.resume",z="clock:reporting.pause",A="reporting_interval",B="session_id",C="callback",D="report",E="reset",F="track_external_errors",G="reporting_interval",H="api:aa_start",I="api:aa_ad_start",J="api:video_load",K="api:video_unload",L="api:video_start",M="api:video_complete",N="api:ad_start",O="api:ad_complete",P="api:play",Q="api:pause",R="api:buffer_start",S="api:seek_start",T="api:seek_complete",U="api:chapter_start",V="api:chapter_complete",W="api:track_error",X="api:track_internal_error",Y="api:bitrate_change",Z="api:quantum_end",$="context:report_available",_="net:check_status_complete",aa=1.5,ba=10;d.context.Context=e}(a.ADB.core,a.ADB.va,a.ADB.va.utils,b),function(a){"use strict";function b(a,b){this.trackingServer=a,this.publisher=b,this.ssl=!1,this.ovp=c,this.sdk=c,this.quietMode=!1,this.debugLogging=!1,this.__isPrimetime=!1,this.__psdkVersion=null}var c="unknown";a.AdobeHeartbeatPluginConfig=b}(b),function(a){"use strict";function b(){}b.prototype.onError=function(a){},a.AdobeHeartbeatPluginDelegate=b}(b),function(a,b,c){"use strict";function d(a){d.__super__.constructor.call(this,q),this._radio=new i(this._logger),this._channel=this._radio.channel(w),this._delegate=a,this._context=new l(this._channel,this._logger),this._filter=new m(this._channel,this._logger),this._network=new n(this._channel,this._logger),this._setupDataResolver()}var e=a.Event,f=a.Trigger,g=a.plugin.BasePlugin,h=a.plugin.ParamMapping,i=a.radio.Radio,j=b.ErrorInfo,k=b.Version,l=c.context.Context,m=c.filter.ReportFilter,n=c.network.Network,o=c.clock.Clock,p=c.AdobeHeartbeatPluginConfig;a.extend(d,g),d.prototype.configure=function(a){if(!a)throw new Error("Reference to the configuration data cannot be NULL.");if(!(a instanceof p))throw new Error("Expected config data to be instance of AdobeHeartbeatPluginConfig.");this._config=a,this._config.debugLogging?this._logger.enable():this._logger.disable(),this._logger.debug(this._logTag,"#configure({trackingServer="+this._config.trackingServer+", publisher="+this._config.publisher+", quietMode="+this._config.quietMode+", ssl="+this._config.ssl+"})");var b=this._config.trackingServer+"/settings/",c={};c[V]=this._config.trackingServer,c[W]=b,c[X]=this._config.publisher,c[Y]=this._config.quietMode,c[Z]=this._config.ssl,this._channel.trigger(new e(aa,c)),this._isConfigured=!0},d.prototype.bootstrap=function(a){d.__super__.bootstrap.call(this,a),this._channel.on(x,this._onError,this),this._clock=new o(this._pluginManager,this._channel,this._logger),this._channel.command(ta),this._channel.trigger(new e(va)),this._registerCommands(),this._registerBehaviours()},d.prototype._teardown=function(){this._logger.debug(this._logTag,"#_teardown()"),this._radio.shutdown(),this._context.destroy(),this._clock.destroy(),this._filter.destroy(),this._network.destroy()},d.prototype._canProcess=function(){return this._isConfigured?this._errorInfo?(this._logger.error(this._logTag,"_canProcess() > Plugin in ERROR state."),!1):d.__super__._canProcess.call(this):(this._logger.error(this._logTag,"_canProcess() > Plugin not configured."),!1)},d.prototype._cmdAnalyticsError=function(a){this._errorInfo||(this._errorInfo=new j("Internal error","AdobeAnalyticsPlugin is in ERROR state."),this._trigger(x,this._errorInfo),this._delegate&&this._delegate.onError(this._errorInfo))},d.prototype._cmdAnalyticsStart=function(a){this._canProcess()&&this._channel.trigger(new e($,a))},d.prototype._cmdAnalyticsAdStart=function(a){this._canProcess()&&this._channel.trigger(new e(_,a))},d.prototype._cmdVideoLoad=function(a){this._errorInfo=null,this._canProcess()&&(this._isTrackingSessionActive&&this._channel.trigger(new e(ca,a)),this._isTrackingSessionActive=!1,this._isPaused=!0,this._isSeeking=!1,this._isBuffering=!1,this._filter.clear(),this._channel.trigger(new e(ba,a)),this._isTrackingSessionActive=!0)},d.prototype._cmdVideoUnload=function(a){this._errorInfo=null,this._canProcess()&&(this._channel.trigger(new e(ca,a)),this._isTrackingSessionActive=!1)},d.prototype._cmdVideoStart=function(a){this._canProcess()&&this._channel.trigger(new e(da,a))},d.prototype._cmdVideoComplete=function(a){this._canProcess()&&this._channel.trigger(new e(ea,a))},d.prototype._cmdPlay=function(a){this._canProcess()&&(this._isPaused=!1,this._resumePlaybackIfPossible(a))},d.prototype._cmdPause=function(a){this._canProcess()&&(this._channel.trigger(new e(ia,a)),this._isPaused=!0)},d.prototype._cmdAdStart=function(a){this._canProcess()&&(this._channel.trigger(new e(fa,a)),this._resumePlaybackIfPossible(a))},d.prototype._cmdAdComplete=function(a){this._canProcess()&&(this._channel.trigger(new e(ga,a)),a.isInAdBreak||this._resumePlaybackIfPossible(a))},d.prototype._cmdBufferStart=function(a){this._canProcess()&&(this._channel.trigger(new e(ja,a)),this._isBuffering=!0)},d.prototype._cmdBufferComplete=function(a){this._canProcess()&&(this._isBuffering=!1,this._resumePlaybackIfPossible(a))},d.prototype._cmdSeekStart=function(a){this._canProcess()&&(this._channel.trigger(new e(ka,a)),this._channel.trigger(new e(ia,a)),this._isSeeking=!0)},d.prototype._cmdSeekComplete=function(a){this._canProcess()&&(this._channel.trigger(new e(la,a)),this._isSeeking=!1,this._resumePlaybackIfPossible(a))},d.prototype._cmdChapterStart=function(a){this._canProcess()&&this._channel.trigger(new e(ma,a))},d.prototype._cmdChapterComplete=function(a){this._canProcess()&&this._channel.trigger(new e(na,a))},d.prototype._cmdBitrateChange=function(a){this._canProcess()&&this._channel.trigger(new e(qa,a))},d.prototype._cmdTrackError=function(a){this._canProcess()&&this._channel.trigger(new e(oa,a))},d.prototype._cmdClockReportingTick=function(a){this._canProcess()&&this._channel.trigger(new e(ra,a))},d.prototype._onError=function(a){this._errorInfo=a.data;var b={};b[T]=sa,b[U]=this._errorInfo.getMessage()+"|"+this._errorInfo.getDetails(),this._channel.trigger(new e(pa,b));var c={};c[S]=!0,this._channel.command(ua,c),this._trigger(x,this._errorInfo),this._delegate&&this._delegate.onError(this._errorInfo)},d.prototype._registerCommands=function(){this._pluginManager.comply(this,"handleAnalyticsError",this._cmdAnalyticsError),this._pluginManager.comply(this,"handleAnalyticsStart",this._cmdAnalyticsStart),this._pluginManager.comply(this,"handleAnalyticsAdStart",this._cmdAnalyticsAdStart),this._pluginManager.comply(this,"handleVideoLoad",this._cmdVideoLoad),this._pluginManager.comply(this,"handleVideoUnload",this._cmdVideoUnload),this._pluginManager.comply(this,"handleVideoStart",this._cmdVideoStart),this._pluginManager.comply(this,"handleVideoComplete",this._cmdVideoComplete),this._pluginManager.comply(this,"handlePlay",this._cmdPlay),this._pluginManager.comply(this,"handlePause",this._cmdPause),this._pluginManager.comply(this,"handleAdStart",this._cmdAdStart),this._pluginManager.comply(this,"handleAdComplete",this._cmdAdComplete),this._pluginManager.comply(this,"handleBufferStart",this._cmdBufferStart),this._pluginManager.comply(this,"handleBufferComplete",this._cmdBufferComplete),this._pluginManager.comply(this,"handleSeekStart",this._cmdSeekStart),this._pluginManager.comply(this,"handleSeekComplete",this._cmdSeekComplete),this._pluginManager.comply(this,"handleChapterStart",this._cmdChapterStart),this._pluginManager.comply(this,"handleChapterComplete",this._cmdChapterComplete),this._pluginManager.comply(this,"handleBitrateChange",this._cmdBitrateChange),this._pluginManager.comply(this,"handleTrackError",this._cmdTrackError),this._pluginManager.comply(this,"handleClockReportingTick",this._cmdClockReportingTick)},d.prototype._registerBehaviours=function(){this._pluginManager.registerBehaviour(new f(t,A),this,"handleVideoLoad"),this._pluginManager.registerBehaviour(new f(t,B),this,"handleVideoUnload"),this._pluginManager.registerBehaviour(new f(t,C),this,"handleVideoStart",[new h(t,"video.id","videoId"),new h(t,"video.name","videoName"),new h(t,"video.length","videoLength"),new h(t,"video.playhead","playhead"),new h(t,"video.playerName","playerName"),new h(t,"video.streamType","streamType"),new h(t,"qos.fps","fps"),new h(t,"qos.droppedFrames","droppedFrames"),new h(t,"qos.bitrate","bitrate"),new h(t,"qos.startupTime","startupTime"),new h(s,"rsid","rsid"),new h(s,"tracking_server","trackingServer"),new h(s,"channel","channel"),new h(s,"meta.video.*","metaVideo"),new h(s,"ssl","useSsl"),new h(u,"meta","metaNielsen"),new h(r,"publisher","publisher"),new h(r,"sdk","sdk"),new h(r,"ovp","ovp"),new h(r,"version","version"),new h(r,"api_level","apiLvl")]),this._pluginManager.registerBehaviour(new f(t,D),this,"handleVideoComplete",[new h(t,"qos.fps","fps"),new h(t,"qos.droppedFrames","droppedFrames"),new h(t,"qos.bitrate","bitrate"),new h(t,"qos.startupTime","startupTime")]),this._pluginManager.registerBehaviour(new f(t,E),this,"handlePlay",[new h(t,"video.playhead","playhead"),new h(t,"qos.fps","fps"),new h(t,"qos.droppedFrames","droppedFrames"),new h(t,"qos.bitrate","bitrate"),new h(t,"qos.startupTime","startupTime")]),this._pluginManager.registerBehaviour(new f(t,F),this,"handlePause",[new h(t,"video.playhead","playhead"),new h(t,"qos.fps","fps"),new h(t,"qos.droppedFrames","droppedFrames"),new h(t,"qos.bitrate","bitrate"),new h(t,"qos.startupTime","startupTime")]),this._pluginManager.registerBehaviour(new f(t,G),this,"handleAdStart",[new h(t,"video.playhead","playhead"),new h(t,"ad.id","adId"),new h(t,"ad.name","adName"),new h(t,"ad.length","adLength"),new h(t,"ad.position","adPosition"),new h(t,"pod.name","podName"),new h(t,"pod.playerName","podPlayerName"),new h(t,"pod.position","podPosition"),new h(t,"pod.startTime","podSecond"),new h(t,"qos.fps","fps"),new h(t,"qos.droppedFrames","droppedFrames"),new h(t,"qos.bitrate","bitrate"),new h(t,"qos.startupTime","startupTime"),new h(s,"meta.video.*","metaVideo"),new h(s,"meta.ad.*","metaAd"),new h(u,"meta","metaNielsen")]),this._pluginManager.registerBehaviour(new f(t,H),this,"handleAdComplete",[new h(t,"video.playhead","playhead"),new h(t,"ad.isInAdBreak","isInAdBreak"),new h(t,"qos.fps","fps"),new h(t,"qos.droppedFrames","droppedFrames"),new h(t,"qos.bitrate","bitrate"),new h(t,"qos.startupTime","startupTime")]),this._pluginManager.registerBehaviour(new f(t,I),this,"handleBufferStart",[new h(t,"video.playhead","playhead"),new h(t,"qos.fps","fps"),new h(t,"qos.droppedFrames","droppedFrames"),new h(t,"qos.bitrate","bitrate"),new h(t,"qos.startupTime","startupTime")]),this._pluginManager.registerBehaviour(new f(t,J),this,"handleBufferComplete",[new h(t,"video.playhead","playhead"),new h(t,"qos.fps","fps"),new h(t,"qos.droppedFrames","droppedFrames"),new h(t,"qos.bitrate","bitrate"),new h(t,"qos.startupTime","startupTime")]),this._pluginManager.registerBehaviour(new f(t,K),this,"handleSeekStart",[new h(t,"video.playhead","playhead")]),this._pluginManager.registerBehaviour(new f(t,L),this,"handleSeekComplete",[new h(t,"video.playhead","playhead"),new h(t,"ad.isInAd","isInAd"),new h(t,"ad.id","adId"),new h(t,"ad.position","adPosition"),new h(t,"pod.playerName","podPlayerName"),new h(t,"pod.position","podPosition"),new h(t,"chapter.isInChapter","isInChapter"),new h(t,"chapter.position","chapterPosition"),new h(t,"chapter.name","chapterName"),new h(t,"chapter.length","chapterLength"),new h(t,"chapter.startTime","chapterOffset"),new h(t,"qos.fps","fps"),new h(t,"qos.droppedFrames","droppedFrames"),new h(t,"qos.bitrate","bitrate"),new h(t,"qos.startupTime","startupTime")]),this._pluginManager.registerBehaviour(new f(t,M),this,"handleChapterStart",[new h(t,"video.playhead","playhead"),new h(t,"chapter.position","chapterPosition"),new h(t,"chapter.name","chapterName"),new h(t,"chapter.length","chapterLength"),new h(t,"chapter.startTime","chapterOffset"),new h(t,"qos.fps","fps"),new h(t,"qos.droppedFrames","droppedFrames"),new h(t,"qos.bitrate","bitrate"),new h(t,"qos.startupTime","startupTime"),new h(s,"meta.video.*","metaVideo"),new h(s,"meta.chapter.*","metaChapter"),new h(u,"meta","metaNielsen")]),this._pluginManager.registerBehaviour(new f(t,N),this,"handleChapterComplete",[new h(t,"video.playhead","playhead"),new h(t,"qos.fps","fps"),new h(t,"qos.droppedFrames","droppedFrames"),new h(t,"qos.bitrate","bitrate"),new h(t,"qos.startupTime","startupTime")]),this._pluginManager.registerBehaviour(new f(t,O),this,"handleBitrateChange",[new h(t,"video.playhead","playhead"),new h(t,"qos.fps","fps"),new h(t,"qos.droppedFrames","droppedFrames"),new h(t,"qos.bitrate","bitrate"),new h(t,"qos.startupTime","startupTime")]),this._pluginManager.registerBehaviour(new f(t,P),this,"handleTrackError"),this._pluginManager.registerBehaviour(new f(v,R),this,"handleClockReportingTick",[new h(t,"video.playhead","playhead"),new h(t,"qos.fps","fps"),new h(t,"qos.droppedFrames","droppedFrames"),new h(t,"qos.bitrate","bitrate"),new h(t,"qos.startupTime","startupTime")]),this._pluginManager.registerBehaviour(new f(s,x),this,"handleAnalyticsError"),this._pluginManager.registerBehaviour(new f(s,y),this,"handleAnalyticsStart",[new h(s,"vid","vid"),new h(s,"aid","aid"),new h(s,"mid","mid"),new h(s,"customerIDs","customerIDs"),new h(t,"video.playhead","playhead"),new h(t,"qos.fps","fps"),new h(t,"qos.droppedFrames","droppedFrames"),new h(t,"qos.bitrate","bitrate"),new h(t,"qos.startupTime","startupTime")]),this._pluginManager.registerBehaviour(new f(s,z),this,"handleAnalyticsAdStart",[new h(t,"video.playhead","playhead"),new h(t,"qos.fps","fps"),new h(t,"qos.droppedFrames","droppedFrames"),new h(t,"qos.bitrate","bitrate"),new h(t,"qos.startupTime","startupTime")])},d.prototype._setupDataResolver=function(){var a={},b=this;a.version=function(){return k.getVersion()},a.api_level=function(){return k.getApiLevel()},a.tracking_server=function(){return b._config?b._config.trackingServer:null},a.publisher=function(){return b._config?b._config.publisher:null},a.quiet_mode=function(){return b._config?b._config.quietMode:!1},a.ovp=function(){return b._config?b._config.ovp:null},a.sdk=function(){return b._config?b._config.sdk:null},a.is_primetime=function(){return b._config?b._config.__isPrimetime:!1},a.psdk_version=function(){return b._config?b._config.__psdkVersion:null},this._dataResolver=function(b){if(!b||0==b.length)return null;for(var c=null,d=0;d<b.length;d++){var e=b[d];c=c||{},c[e]=a.hasOwnProperty(e)?a[e].call(this):null}return c}},d.prototype._resumePlaybackIfPossible=function(a){this._errorInfo||this._isPaused||this._isSeeking||this._isBuffering||this._channel.trigger(new e(ha,a))};var q="adobe-heartbeat",r=q,s="adobe-analytics",t="player",u="nielsen",v="service.clock",w="heartbeat-channel",x="error",y="aa_start",z="sc_ad_start",A="video_load",B="video_unload",C="video_start",D="video_complete",E="play",F="pause",G="ad_start",H="ad_complete",I="buffer_start",J="buffer_complete",K="seek_start",L="seek_complete",M="chapter_start",N="chapter_complete",O="bitrate_change",P="track_error",Q="heartbeat.reporting",R=Q+".tick",S="reset",T="source",U="error_id",V="tracking_server",W="check_status_server",X="publisher",Y="quiet_mode",Z="ssl",$="api:aa_start",_="api:aa_ad_start",aa="api:config",ba="api:video_load",ca="api:video_unload",da="api:video_start",ea="api:video_complete",fa="api:ad_start",ga="api:ad_complete",ha="api:play",ia="api:pause",ja="api:buffer_start",ka="api:seek_start",la="api:seek_complete",ma="api:chapter_start",na="api:chapter_complete",oa="api:track_error",pa="api:track_internal_error",qa="api:bitrate_change",ra="api:quantum_end",sa="sourceErrorHeartbeat",ta="clock:check_status.resume",ua="clock:reporting.pause",va="clock:check_status.get_settings";c.AdobeHeartbeatPlugin=d}(a.ADB.core,a.ADB.va,b),a.ADB.va.plugins.ah||(a.ADB.va.plugins.ah=b)}(this);
	
	// AdobeAnalyticsPlugin
	!function(a){if("undefined"==typeof b)var b={};!function(a,b){"use strict";function c(a,b){this._onFail={fn:a,ctx:b}}var d=a.ErrorInfo;c.prototype.validateFields=function(a,b){if(!a)return this._fail("Data cannot be null");if(b)for(var c=0;c<b.length;c++){var d=b[c];switch(d){case"videoId":if(!a.hasOwnProperty("videoId"))return this._fail("The ID for the main video must be specified.");if("string"!=typeof a.videoId)return this._fail("The ID for the main video must be a String.");if(""===a.videoId)return this._fail("The ID for the main video cannot be an empty string.");break;case"streamType":if(!a.hasOwnProperty("streamType"))return this._fail("The stream type for the main video must be specified.");if("string"!=typeof a.streamType)return this._fail("The stream type for the main video must be a String.");if(""===a.streamType)return this._fail("The stream type for the main video cannot be an empty string.");break;case"playerName":if(!a.hasOwnProperty("playerName"))return this._fail("The player name for the main video must be specified.");if("string"!=typeof a.playerName)return this._fail("The player name for the main video must be a String.");if(""===a.playerName)return this._fail("The player name for the main video cannot be an empty string.");break;case"videoLength":if(!a.hasOwnProperty("videoLength"))return this._fail("The length of the main video must be specified.");if("number"!=typeof a.videoLength)return this._fail("The length of the main video must be a Number.");if(isNaN(a.videoLength))return this._fail("The length of the main video cannot be NaN.");break;case"podPlayerName":if(!a.hasOwnProperty("podPlayerName"))return this._fail("The player name for the ad-break must be specified.");if("string"!=typeof a.podPlayerName)return this._fail("The player name for the ad-break must be a String.");if(""===a.podPlayerName)return this._fail("The player name for the ad-break cannot be an empty string.");break;case"podPosition":if(!a.hasOwnProperty("podPosition"))return this._fail("Position (index) of the ad-break must be specified.");if("number"!=typeof a.podPosition)return this._fail("Position (index) of the ad-break must be a Number.");if(isNaN(a.podPosition))return this._fail("Position (index) of the ad-break cannot be NaN.");break;case"adId":if(!a.hasOwnProperty("adId"))return this._fail("The ad ID must be specified.");if("string"!=typeof a.adId)return this._fail("The ad ID must be a String.");if(""===a.adId)return this._fail("The ad ID cannot be an empty string.");break;case"adPosition":if(!a.hasOwnProperty("adPosition"))return this._fail("Position (index) of the ad must be specified.");if("number"!=typeof a.adPosition)return this._fail("Position (index) of the ad must be a Number.");if(isNaN(a.adPosition))return this._fail("Position (index) of the ad cannot be NaN.");break;case"adLength":if(!a.hasOwnProperty("adLength"))return this._fail("The length of the ad must be specified.");if("number"!=typeof a.adLength)return this._fail("The length of the ad must be a Number.");if(isNaN(a.adLength))return this._fail("The length of the ad cannot be NaN.");break;default:return this._fail("Unable to validate unknown parameter: "+d)}}return!0},c.prototype._fail=function(a){var b=new d("Invalid input data",a);return this._onFail.fn&&this._onFail.fn.call(this._onFail.ctx,b),!1},b.InputDataValidator=c}(a.ADB.va,b),function(a){"use strict";function b(){this.channel=c,this.debugLogging=!1}var c="";a.AdobeAnalyticsPluginConfig=b}(b),function(a){"use strict";function b(){}b.prototype.onError=function(a){},a.AdobeAnalyticsPluginDelegate=b}(b),function(a,b,c,d){"use strict";function e(a,b){if(e.__super__.constructor.call(this,r),!a)throw new Error("The reference to the AppMeasurement object cannot be NULL.");this._appMeasurement=a,this._delegate=b,this._customMetaKeys=[],this._videoMetadata={},this._adMetadata={},this._chapterMetadata={},this._errorInfo=null,this._workQueue=new k(!0,w),this._inputDataValidator=new q(function(a){this._errorInfo=a,this._logger.error(this._logTag,a.getMessage()+" | "+a.getDetails()),this._trigger(x,a),this._delegate&&this._delegate.onError(this._errorInfo)},this),this._appMeasurement.isReadyToTrack(),this._setupDataResolver()}var f=a.Trigger,g=a.plugin.BasePlugin,h=a.plugin.ParamMapping,i=a.radio.Channel,j=a.radio.Command,k=a.radio.CommandQueue,l=b.ErrorInfo,m=c.md5,n=c.StringUtils,o=c.ObjectUtils,p=d.AdobeAnalyticsPluginConfig,q=d.InputDataValidator;a.extend(e,g),e.prototype.configure=function(a){if(!a)throw new Error("Reference to the configuration data cannot be NULL.");if(!(a instanceof p))throw new Error("Expected config data to be instance of AdobeAnalyticsPluginConfig.");this._config=a,this._config.debugLogging?this._logger.enable():this._logger.disable(),this._logger.debug(this._logTag,"#configure({trackingServer="+this._config.debugLogging+", channel="+this._config.channel+", ssl="+this._appMeasurement.ssl+"})")},e.prototype.bootstrap=function(a){e.__super__.bootstrap.call(this,a),this._registerCommands(),this._registerBehaviours()},e.prototype.setup=function(){this._appMeasurement.isReadyToTrack()?this._onAppMeasurementReady():this._appMeasurement.callbackWhenReadyToTrack(this,this._onAppMeasurementReady,[]),e.__super__.setup.call(this)},e.prototype.setVideoMetadata=function(a){this._videoMetadata=o.clone(a)},e.prototype.setAdMetadata=function(a){this._adMetadata=o.clone(a)},e.prototype.setChapterMetadata=function(a){this._chapterMetadata=o.clone(a)},e.prototype._canProcess=function(){return this._errorInfo?(this._logger.error(this._logTag,"#_canProcess() > In ERROR state."),!1):e.__super__._canProcess.call(this)},e.prototype._cmdVideoLoad=function(a){this._errorInfo=null},e.prototype._cmdVideoStart=function(a){this._logger.debug(this._logTag,"#_cmdVideoStart()"),this._canProcess()&&this._workQueue.addCommand(new j(this._executeOpen,this,[a]))},e.prototype._cmdAdStart=function(a){this._logger.debug(this._logTag,"#_cmdAdStart()"),this._canProcess()&&this._workQueue.addCommand(new j(this._executeOpenAd,this,[a]))},e.prototype._cmdHeartbeatPluginError=function(a){this._errorInfo||(this._errorInfo=new l("Internal error","HeartbeatPlugin is in ERROR state."),this._trigger(x,this._errorInfo),this._delegate&&this._delegate.onError(this._errorInfo))},e.prototype._resetAppMeasurementContextData=function(){delete this._appMeasurement.contextData["a.contentType"],delete this._appMeasurement.contextData["a.media.name"],delete this._appMeasurement.contextData["a.media.friendlyName"],delete this._appMeasurement.contextData["a.media.length"],delete this._appMeasurement.contextData["a.media.playerName"],delete this._appMeasurement.contextData["a.media.channel"],delete this._appMeasurement.contextData["a.media.view"],delete this._appMeasurement.contextData["a.media.ad.name"],delete this._appMeasurement.contextData["a.media.ad.friendlyName"],delete this._appMeasurement.contextData["a.media.ad.podFriendlyName"],delete this._appMeasurement.contextData["a.media.ad.length"],delete this._appMeasurement.contextData["a.media.ad.playerName"],delete this._appMeasurement.contextData["a.media.ad.pod"],delete this._appMeasurement.contextData["a.media.ad.podPosition"],delete this._appMeasurement.contextData["a.media.ad.podSecond"],delete this._appMeasurement.contextData["a.media.ad.view"];for(var a=0;a<this._customMetaKeys.length;a++){var b=this._customMetaKeys[a];delete this._appMeasurement.contextData[b]}this._customMetaKeys=[]},e.prototype._executeOpen=function(a){if(this._logger.debug(this._logTag,"#_executeOpen(id="+a.videoId+", videoName="+a.videoName+", streamType="+a.streamType+", length="+a.videoLength+", playerName="+a.playerName+", channel="+a.channel+", isPrimetime="+a.isPrimetime+")"),this._canProcess()&&this._inputDataValidator.validateFields(a,["videoId","streamType","videoLength","playerName"])){this._resetAppMeasurementContextData();for(var b in a.metaVideo)a.metaVideo.hasOwnProperty(b)&&(this._appMeasurement.contextData[b]=a.metaVideo[b],this._customMetaKeys.push(b));if(a.metaNielsen)for(var b in a.metaNielsen)a.metaNielsen.hasOwnProperty(b)&&(this._appMeasurement.contextData[b]=a.metaNielsen[b],this._customMetaKeys.push(b));this._appMeasurement.contextData["a.contentType"]=a.streamType,this._appMeasurement.contextData["a.media.name"]=a.videoId,this._appMeasurement.contextData["a.media.friendlyName"]=a.videoName||"",this._appMeasurement.contextData["a.media.length"]=Math.floor(a.videoLength)||"0.0",this._appMeasurement.contextData["a.media.playerName"]=a.playerName,this._appMeasurement.contextData["a.media.channel"]=a.channel||"",this._appMeasurement.contextData["a.media.view"]=!0,this._appMeasurement.pev3=y,this._appMeasurement.pe=a.isPrimetime?B:A,this._appMeasurement.track();var c=this;setTimeout(function(){c._trigger(E,a)},0)}},e.prototype._executeOpenAd=function(a){var b=m(a.videoId)+"_"+a.podPosition;if(this._logger.debug(this._logTag,"#_executeOpenAd(id="+a.adId+", streamType="+a.streamType+", length="+a.adLength+", podPlayerName="+a.podPlayerName+", parentId="+a.videoId+", podId="+b+", parentPodPosition="+a.adPosition+", podSecond="+a.podSecond+")"),this._canProcess()&&this._inputDataValidator.validateFields(a,["videoId","streamType","playerName","adId","adLength","podPlayerName","adPosition"])){a.podSecond=null==a.podSecond||isNaN(a.podSecond)?a.playhead:a.podSecond,this._resetAppMeasurementContextData();var c;for(c in a.metaVideo)a.metaVideo.hasOwnProperty(c)&&(this._appMeasurement.contextData[c]=a.metaVideo[c],this._customMetaKeys.push(c));for(c in a.metaAd)a.metaAd.hasOwnProperty(c)&&(this._appMeasurement.contextData[c]=a.metaAd[c],this._customMetaKeys.push(c));if(a.metaNielsen)for(var c in a.metaNielsen)a.metaNielsen.hasOwnProperty(c)&&(this._appMeasurement.contextData[c]=a.metaNielsen[c],this._customMetaKeys.push(c));this._appMeasurement.contextData["a.contentType"]=a.streamType,this._appMeasurement.contextData["a.media.name"]=a.videoId,this._appMeasurement.contextData["a.media.playerName"]=a.playerName,this._appMeasurement.contextData["a.media.channel"]=a.channel||"",this._appMeasurement.contextData["a.media.ad.name"]=a.adId,this._appMeasurement.contextData["a.media.ad.friendlyName"]=a.adName||"",this._appMeasurement.contextData["a.media.ad.podFriendlyName"]=a.podName||"",this._appMeasurement.contextData["a.media.ad.length"]=Math.floor(a.adLength)||"0.0",this._appMeasurement.contextData["a.media.ad.playerName"]=a.podPlayerName,this._appMeasurement.contextData["a.media.ad.pod"]=b,this._appMeasurement.contextData["a.media.ad.podPosition"]=Math.floor(a.adPosition)||"0.0",this._appMeasurement.contextData["a.media.ad.podSecond"]=Math.floor(a.podSecond)||"0.0",this._appMeasurement.contextData["a.media.ad.view"]=!0,this._appMeasurement.pev3=z,this._appMeasurement.pe=a.isPrimetime?D:C,this._appMeasurement.track();var d=this;setTimeout(function(){d._trigger(F,a)},0)}},e.prototype._setupDataResolver=function(){var a={},b=this;a.rsid=function(){return b._appMeasurement.account},a.tracking_server=function(){return b._appMeasurement.ssl&&b._appMeasurement.trackingServerSecure?b._appMeasurement.trackingServerSecure:b._appMeasurement.trackingServer},a.ssl=function(){return b._appMeasurement.ssl},a.vid=function(){return b._appMeasurement.visitorID},a.aid=function(){return b._appMeasurement.analyticsVisitorID},a.mid=function(){return b._appMeasurement.marketingCloudVisitorID},a.customerIDs=function(){var a=b._appMeasurement.visitor.getCustomerIDs(),c={};for(var d in a)if(a.hasOwnProperty(d)){var e=a[d];if("object"==typeof e){for(var f in e)e.hasOwnProperty(f)&&("authState"==f?c[d+".as"]=e[f]:c[d+"."+f]=e[f]);c[d+".as"]||(c[d+".as"]="0")}}return c},a.channel=function(){return b._config?b._config.channel:null},a.meta=function(a){var c=a.split(".");if(c.length<2)return null;var d=c.shift();switch(a=c.join("."),d){case"video":return a==i.WILDCARD?b._videoMetadata:b._videoMetadata[a];case"ad":return a==i.WILDCARD?b._adMetadata:b._adMetadata[a];case"chapter":return a==i.WILDCARD?b._chapterMetadata:b._chapterMetadata[a];default:return null}},this._dataResolver=function(b){if(!b||0==b.length)return null;for(var c=null,d=0;d<b.length;d++){var e=b[d];c=c||{},n.startsWith(e,"meta.")?c[e]=a.meta(e.split("meta.")[1]):c[e]=a.hasOwnProperty(e)?a[e].call(this):null}return c}},e.prototype._registerCommands=function(){this._pluginManager.comply(this,"handleVideoLoad",this._cmdVideoLoad),this._pluginManager.comply(this,"handleVideoStart",this._cmdVideoStart),this._pluginManager.comply(this,"handleAdStart",this._cmdAdStart),this._pluginManager.comply(this,"handleHeartbeatPluginError",this._cmdHeartbeatPluginError)},e.prototype._registerBehaviours=function(){this._pluginManager.registerBehaviour(new f(u,G),this,"handleVideoLoad"),this._pluginManager.registerBehaviour(new f(u,H),this,"handleVideoStart",[new h(u,"video.id","videoId"),new h(u,"video.streamType","streamType"),new h(u,"video.name","videoName"),new h(u,"video.length","videoLength"),new h(u,"video.playerName","playerName"),new h(u,"video.streamType","streamType"),new h(v,"is_primetime","isPrimetime"),new h(s,"channel","channel"),new h(s,"meta.video.*","metaVideo"),new h(t,"meta","metaNielsen")]),this._pluginManager.registerBehaviour(new f(u,I),this,"handleAdStart",[new h(u,"video.id","videoId"),new h(u,"video.streamType","streamType"),new h(u,"video.playhead","playhead"),new h(u,"video.playerName","playerName"),new h(u,"ad.id","adId"),new h(u,"ad.length","adLength"),new h(u,"ad.position","adPosition"),new h(u,"ad.name","adName"),new h(u,"pod.name","podName"),new h(u,"pod.position","podPosition"),new h(u,"pod.playerName","podPlayerName"),new h(u,"pod.startTime","podSecond"),new h(v,"is_primetime","isPrimetime"),new h(s,"channel","channel"),new h(s,"meta.video.*","metaVideo"),new h(s,"meta.ad.*","metaAd"),new h(t,"meta","metaNielsen")]),this._pluginManager.registerBehaviour(new f(v,x),this,"handleHeartbeatPluginError")},e.prototype._onAppMeasurementReady=function(){this._workQueue.resume()};var r="adobe-analytics",s=r,t="nielsen",u="player",v="adobe-heartbeat",w=2e3,x="error",y="video",z="videoAd",A="ms_s",B="msp_s",C="msa_s",D="mspa_s",E="aa_start",F="sc_ad_start",G="video_load",H="video_start",I="ad_start";d.AdobeAnalyticsPlugin=e}(a.ADB.core,a.ADB.va,a.ADB.va.utils,b),a.ADB.va.plugins.aa||(a.ADB.va.plugins.aa=b)}(this);


/***/ },
/* 349 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(84);
	
	var _medscape_tv = __webpack_require__(683);
	
	var _medscape_tv2 = _interopRequireDefault(_medscape_tv);
	
	var _util = __webpack_require__(12);
	
	var _reactRouter = __webpack_require__(87);
	
	__webpack_require__(350);
	
	__webpack_require__(852);
	
	__webpack_require__(171);
	
	__webpack_require__(709);
	
	__webpack_require__(820);
	
	__webpack_require__(821);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var body = document.querySelector('body'),
	    mtvRoutePath = ':videoUrlFragment',
	    cpData = document.querySelector('[data-cp]'),
	    cp = cpData !== null ? JSON.parse(cpData.getAttribute('data-cp')) : '',
	    activityId = cp.activityId,
	    routePath = (0, _util.isLocal)() ? '/' : '/mtv/' + window.MedscapeTVInstance.seriesUrlFragment; /* global jQuery */
	
	cp.tacticId = (0, _util.getParams)(window.location.search).tacticId || cp.tacticId;
	var url = 'http://api' + (0, _util.envCheck)() + '.medscape.com/cp/ipplastvisit/user/' + Number(window.s_registered_user_id) / 27.0 + '/activities/' + activityId + '?' + (0, _util.queryParams)(cp);
	
	if ((0, _util.isMobile)() && !(0, _util.isIpad)()) {
	  body.classList.add('is-mobile');
	  document.getElementById('bodypadding').classList.add('is-mobile');
	} else {
	  body.classList.add('is-desktop');
	}
	jQuery.ajax({
	  dataType: 'json',
	  url: url,
	  method: 'GET',
	  mode: 'cors',
	  success: function success(response) {
	    var chapter = response.activities[0].scene;
	    if (chapter) {
	      var index = parseInt(chapter.name.split('scn')[1], 10) - 1;
	      if (index > 0) {
	        _reactRouter.browserHistory.push('' + routePath + window.MedscapeTVInstance.videos[index].videoUrlFragment);
	      }
	    }
	    (0, _reactDom.render)(_react2.default.createElement(
	      _reactRouter.Router,
	      { history: _reactRouter.browserHistory },
	      _react2.default.createElement(
	        _reactRouter.Route,
	        { path: routePath },
	        _react2.default.createElement(_reactRouter.IndexRoute, { component: _medscape_tv2.default }),
	        _react2.default.createElement(_reactRouter.Route, { path: mtvRoutePath, component: _medscape_tv2.default })
	      )
	    ), document.getElementById('jsx-video-player'));
	  },
	  timeout: 2000
	}).fail(function () {
	  (0, _reactDom.render)(_react2.default.createElement(
	    _reactRouter.Router,
	    { history: _reactRouter.browserHistory },
	    _react2.default.createElement(
	      _reactRouter.Route,
	      { path: routePath },
	      _react2.default.createElement(_reactRouter.IndexRoute, { component: _medscape_tv2.default }),
	      _react2.default.createElement(_reactRouter.Route, { path: mtvRoutePath, component: _medscape_tv2.default })
	    )
	  ), document.getElementById('jsx-video-player'));
	});

/***/ },
/* 350 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {"use strict";
	
	__webpack_require__(532);
	
	__webpack_require__(815);
	
	__webpack_require__(351);
	
	/* eslint max-len: 0 */
	
	if (global._babelPolyfill) {
	  throw new Error("only one instance of babel-polyfill is allowed");
	}
	global._babelPolyfill = true;
	
	// Should be removed in the next major release:
	
	var DEFINE_PROPERTY = "defineProperty";
	function define(O, key, value) {
	  O[key] || Object[DEFINE_PROPERTY](O, key, {
	    writable: true,
	    configurable: true,
	    value: value
	  });
	}
	
	define(String.prototype, "padLeft", "".padStart);
	define(String.prototype, "padRight", "".padEnd);
	
	"pop,reverse,shift,keys,values,entries,indexOf,every,some,forEach,map,filter,find,findIndex,includes,join,slice,concat,push,splice,unshift,sort,lastIndexOf,reduce,reduceRight,copyWithin,fill".split(",").forEach(function (key) {
	  [][key] && define(Array, key, Function.call.bind([][key]));
	});
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 351 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(361);
	module.exports = __webpack_require__(42).RegExp.escape;

/***/ },
/* 352 */
/***/ function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(10)
	  , isArray  = __webpack_require__(153)
	  , SPECIES  = __webpack_require__(11)('species');
	
	module.exports = function(original){
	  var C;
	  if(isArray(original)){
	    C = original.constructor;
	    // cross-realm fallback
	    if(typeof C == 'function' && (C === Array || isArray(C.prototype)))C = undefined;
	    if(isObject(C)){
	      C = C[SPECIES];
	      if(C === null)C = undefined;
	    }
	  } return C === undefined ? Array : C;
	};

/***/ },
/* 353 */
/***/ function(module, exports, __webpack_require__) {

	// 9.4.2.3 ArraySpeciesCreate(originalArray, length)
	var speciesConstructor = __webpack_require__(352);
	
	module.exports = function(original, length){
	  return new (speciesConstructor(original))(length);
	};

/***/ },
/* 354 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var anObject    = __webpack_require__(4)
	  , toPrimitive = __webpack_require__(44)
	  , NUMBER      = 'number';
	
	module.exports = function(hint){
	  if(hint !== 'string' && hint !== NUMBER && hint !== 'default')throw TypeError('Incorrect hint');
	  return toPrimitive(anObject(this), hint != NUMBER);
	};

/***/ },
/* 355 */
/***/ function(module, exports, __webpack_require__) {

	// all enumerable object keys, includes symbols
	var getKeys = __webpack_require__(68)
	  , gOPS    = __webpack_require__(112)
	  , pIE     = __webpack_require__(93);
	module.exports = function(it){
	  var result     = getKeys(it)
	    , getSymbols = gOPS.f;
	  if(getSymbols){
	    var symbols = getSymbols(it)
	      , isEnum  = pIE.f
	      , i       = 0
	      , key;
	    while(symbols.length > i)if(isEnum.call(it, key = symbols[i++]))result.push(key);
	  } return result;
	};

/***/ },
/* 356 */
/***/ function(module, exports, __webpack_require__) {

	var getKeys   = __webpack_require__(68)
	  , toIObject = __webpack_require__(29);
	module.exports = function(object, el){
	  var O      = toIObject(object)
	    , keys   = getKeys(O)
	    , length = keys.length
	    , index  = 0
	    , key;
	  while(length > index)if(O[key = keys[index++]] === el)return key;
	};

/***/ },
/* 357 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var path      = __webpack_require__(358)
	  , invoke    = __webpack_require__(108)
	  , aFunction = __webpack_require__(26);
	module.exports = function(/* ...pargs */){
	  var fn     = aFunction(this)
	    , length = arguments.length
	    , pargs  = Array(length)
	    , i      = 0
	    , _      = path._
	    , holder = false;
	  while(length > i)if((pargs[i] = arguments[i++]) === _)holder = true;
	  return function(/* ...args */){
	    var that = this
	      , aLen = arguments.length
	      , j = 0, k = 0, args;
	    if(!holder && !aLen)return invoke(fn, pargs, that);
	    args = pargs.slice();
	    if(holder)for(;length > j; j++)if(args[j] === _)args[j] = arguments[k++];
	    while(aLen > k)args.push(arguments[k++]);
	    return invoke(fn, args, that);
	  };
	};

/***/ },
/* 358 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(7);

/***/ },
/* 359 */
/***/ function(module, exports) {

	module.exports = function(regExp, replace){
	  var replacer = replace === Object(replace) ? function(part){
	    return replace[part];
	  } : replace;
	  return function(it){
	    return String(it).replace(regExp, replacer);
	  };
	};

/***/ },
/* 360 */
/***/ function(module, exports, __webpack_require__) {

	var classof   = __webpack_require__(78)
	  , ITERATOR  = __webpack_require__(11)('iterator')
	  , Iterators = __webpack_require__(64);
	module.exports = __webpack_require__(42).isIterable = function(it){
	  var O = Object(it);
	  return O[ITERATOR] !== undefined
	    || '@@iterator' in O
	    || Iterators.hasOwnProperty(classof(O));
	};

/***/ },
/* 361 */
/***/ function(module, exports, __webpack_require__) {

	// https://github.com/benjamingr/RexExp.escape
	var $export = __webpack_require__(1)
	  , $re     = __webpack_require__(359)(/[\\^$*+?.()|[\]{}]/g, '\\$&');
	
	$export($export.S, 'RegExp', {escape: function escape(it){ return $re(it); }});


/***/ },
/* 362 */
/***/ function(module, exports, __webpack_require__) {

	// 22.1.3.3 Array.prototype.copyWithin(target, start, end = this.length)
	var $export = __webpack_require__(1);
	
	$export($export.P, 'Array', {copyWithin: __webpack_require__(217)});
	
	__webpack_require__(77)('copyWithin');

/***/ },
/* 363 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(1)
	  , $every  = __webpack_require__(41)(4);
	
	$export($export.P + $export.F * !__webpack_require__(36)([].every, true), 'Array', {
	  // 22.1.3.5 / 15.4.4.16 Array.prototype.every(callbackfn [, thisArg])
	  every: function every(callbackfn /* , thisArg */){
	    return $every(this, callbackfn, arguments[1]);
	  }
	});

/***/ },
/* 364 */
/***/ function(module, exports, __webpack_require__) {

	// 22.1.3.6 Array.prototype.fill(value, start = 0, end = this.length)
	var $export = __webpack_require__(1);
	
	$export($export.P, 'Array', {fill: __webpack_require__(145)});
	
	__webpack_require__(77)('fill');

/***/ },
/* 365 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(1)
	  , $filter = __webpack_require__(41)(2);
	
	$export($export.P + $export.F * !__webpack_require__(36)([].filter, true), 'Array', {
	  // 22.1.3.7 / 15.4.4.20 Array.prototype.filter(callbackfn [, thisArg])
	  filter: function filter(callbackfn /* , thisArg */){
	    return $filter(this, callbackfn, arguments[1]);
	  }
	});

/***/ },
/* 366 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// 22.1.3.9 Array.prototype.findIndex(predicate, thisArg = undefined)
	var $export = __webpack_require__(1)
	  , $find   = __webpack_require__(41)(6)
	  , KEY     = 'findIndex'
	  , forced  = true;
	// Shouldn't skip holes
	if(KEY in [])Array(1)[KEY](function(){ forced = false; });
	$export($export.P + $export.F * forced, 'Array', {
	  findIndex: function findIndex(callbackfn/*, that = undefined */){
	    return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
	  }
	});
	__webpack_require__(77)(KEY);

/***/ },
/* 367 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// 22.1.3.8 Array.prototype.find(predicate, thisArg = undefined)
	var $export = __webpack_require__(1)
	  , $find   = __webpack_require__(41)(5)
	  , KEY     = 'find'
	  , forced  = true;
	// Shouldn't skip holes
	if(KEY in [])Array(1)[KEY](function(){ forced = false; });
	$export($export.P + $export.F * forced, 'Array', {
	  find: function find(callbackfn/*, that = undefined */){
	    return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
	  }
	});
	__webpack_require__(77)(KEY);

/***/ },
/* 368 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export  = __webpack_require__(1)
	  , $forEach = __webpack_require__(41)(0)
	  , STRICT   = __webpack_require__(36)([].forEach, true);
	
	$export($export.P + $export.F * !STRICT, 'Array', {
	  // 22.1.3.10 / 15.4.4.18 Array.prototype.forEach(callbackfn [, thisArg])
	  forEach: function forEach(callbackfn /* , thisArg */){
	    return $forEach(this, callbackfn, arguments[1]);
	  }
	});

/***/ },
/* 369 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var ctx            = __webpack_require__(47)
	  , $export        = __webpack_require__(1)
	  , toObject       = __webpack_require__(18)
	  , call           = __webpack_require__(225)
	  , isArrayIter    = __webpack_require__(152)
	  , toLength       = __webpack_require__(16)
	  , createProperty = __webpack_require__(146)
	  , getIterFn      = __webpack_require__(169);
	
	$export($export.S + $export.F * !__webpack_require__(110)(function(iter){ Array.from(iter); }), 'Array', {
	  // 22.1.2.1 Array.from(arrayLike, mapfn = undefined, thisArg = undefined)
	  from: function from(arrayLike/*, mapfn = undefined, thisArg = undefined*/){
	    var O       = toObject(arrayLike)
	      , C       = typeof this == 'function' ? this : Array
	      , aLen    = arguments.length
	      , mapfn   = aLen > 1 ? arguments[1] : undefined
	      , mapping = mapfn !== undefined
	      , index   = 0
	      , iterFn  = getIterFn(O)
	      , length, result, step, iterator;
	    if(mapping)mapfn = ctx(mapfn, aLen > 2 ? arguments[2] : undefined, 2);
	    // if object isn't iterable or it's array with default iterator - use simple case
	    if(iterFn != undefined && !(C == Array && isArrayIter(iterFn))){
	      for(iterator = iterFn.call(O), result = new C; !(step = iterator.next()).done; index++){
	        createProperty(result, index, mapping ? call(iterator, mapfn, [step.value, index], true) : step.value);
	      }
	    } else {
	      length = toLength(O.length);
	      for(result = new C(length); length > index; index++){
	        createProperty(result, index, mapping ? mapfn(O[index], index) : O[index]);
	      }
	    }
	    result.length = index;
	    return result;
	  }
	});


/***/ },
/* 370 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export       = __webpack_require__(1)
	  , $indexOf      = __webpack_require__(104)(false)
	  , $native       = [].indexOf
	  , NEGATIVE_ZERO = !!$native && 1 / [1].indexOf(1, -0) < 0;
	
	$export($export.P + $export.F * (NEGATIVE_ZERO || !__webpack_require__(36)($native)), 'Array', {
	  // 22.1.3.11 / 15.4.4.14 Array.prototype.indexOf(searchElement [, fromIndex])
	  indexOf: function indexOf(searchElement /*, fromIndex = 0 */){
	    return NEGATIVE_ZERO
	      // convert -0 to +0
	      ? $native.apply(this, arguments) || 0
	      : $indexOf(this, searchElement, arguments[1]);
	  }
	});

/***/ },
/* 371 */
/***/ function(module, exports, __webpack_require__) {

	// 22.1.2.2 / 15.4.3.2 Array.isArray(arg)
	var $export = __webpack_require__(1);
	
	$export($export.S, 'Array', {isArray: __webpack_require__(153)});

/***/ },
/* 372 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// 22.1.3.13 Array.prototype.join(separator)
	var $export   = __webpack_require__(1)
	  , toIObject = __webpack_require__(29)
	  , arrayJoin = [].join;
	
	// fallback for not array-like strings
	$export($export.P + $export.F * (__webpack_require__(92) != Object || !__webpack_require__(36)(arrayJoin)), 'Array', {
	  join: function join(separator){
	    return arrayJoin.call(toIObject(this), separator === undefined ? ',' : separator);
	  }
	});

/***/ },
/* 373 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export       = __webpack_require__(1)
	  , toIObject     = __webpack_require__(29)
	  , toInteger     = __webpack_require__(58)
	  , toLength      = __webpack_require__(16)
	  , $native       = [].lastIndexOf
	  , NEGATIVE_ZERO = !!$native && 1 / [1].lastIndexOf(1, -0) < 0;
	
	$export($export.P + $export.F * (NEGATIVE_ZERO || !__webpack_require__(36)($native)), 'Array', {
	  // 22.1.3.14 / 15.4.4.15 Array.prototype.lastIndexOf(searchElement [, fromIndex])
	  lastIndexOf: function lastIndexOf(searchElement /*, fromIndex = @[*-1] */){
	    // convert -0 to +0
	    if(NEGATIVE_ZERO)return $native.apply(this, arguments) || 0;
	    var O      = toIObject(this)
	      , length = toLength(O.length)
	      , index  = length - 1;
	    if(arguments.length > 1)index = Math.min(index, toInteger(arguments[1]));
	    if(index < 0)index = length + index;
	    for(;index >= 0; index--)if(index in O)if(O[index] === searchElement)return index || 0;
	    return -1;
	  }
	});

/***/ },
/* 374 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(1)
	  , $map    = __webpack_require__(41)(1);
	
	$export($export.P + $export.F * !__webpack_require__(36)([].map, true), 'Array', {
	  // 22.1.3.15 / 15.4.4.19 Array.prototype.map(callbackfn [, thisArg])
	  map: function map(callbackfn /* , thisArg */){
	    return $map(this, callbackfn, arguments[1]);
	  }
	});

/***/ },
/* 375 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export        = __webpack_require__(1)
	  , createProperty = __webpack_require__(146);
	
	// WebKit Array.of isn't generic
	$export($export.S + $export.F * __webpack_require__(8)(function(){
	  function F(){}
	  return !(Array.of.call(F) instanceof F);
	}), 'Array', {
	  // 22.1.2.3 Array.of( ...items)
	  of: function of(/* ...args */){
	    var index  = 0
	      , aLen   = arguments.length
	      , result = new (typeof this == 'function' ? this : Array)(aLen);
	    while(aLen > index)createProperty(result, index, arguments[index++]);
	    result.length = aLen;
	    return result;
	  }
	});

/***/ },
/* 376 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(1)
	  , $reduce = __webpack_require__(219);
	
	$export($export.P + $export.F * !__webpack_require__(36)([].reduceRight, true), 'Array', {
	  // 22.1.3.19 / 15.4.4.22 Array.prototype.reduceRight(callbackfn [, initialValue])
	  reduceRight: function reduceRight(callbackfn /* , initialValue */){
	    return $reduce(this, callbackfn, arguments.length, arguments[1], true);
	  }
	});

/***/ },
/* 377 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(1)
	  , $reduce = __webpack_require__(219);
	
	$export($export.P + $export.F * !__webpack_require__(36)([].reduce, true), 'Array', {
	  // 22.1.3.18 / 15.4.4.21 Array.prototype.reduce(callbackfn [, initialValue])
	  reduce: function reduce(callbackfn /* , initialValue */){
	    return $reduce(this, callbackfn, arguments.length, arguments[1], false);
	  }
	});

/***/ },
/* 378 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export    = __webpack_require__(1)
	  , html       = __webpack_require__(150)
	  , cof        = __webpack_require__(34)
	  , toIndex    = __webpack_require__(71)
	  , toLength   = __webpack_require__(16)
	  , arraySlice = [].slice;
	
	// fallback for not array-like ES3 strings and DOM objects
	$export($export.P + $export.F * __webpack_require__(8)(function(){
	  if(html)arraySlice.call(html);
	}), 'Array', {
	  slice: function slice(begin, end){
	    var len   = toLength(this.length)
	      , klass = cof(this);
	    end = end === undefined ? len : end;
	    if(klass == 'Array')return arraySlice.call(this, begin, end);
	    var start  = toIndex(begin, len)
	      , upTo   = toIndex(end, len)
	      , size   = toLength(upTo - start)
	      , cloned = Array(size)
	      , i      = 0;
	    for(; i < size; i++)cloned[i] = klass == 'String'
	      ? this.charAt(start + i)
	      : this[start + i];
	    return cloned;
	  }
	});

/***/ },
/* 379 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(1)
	  , $some   = __webpack_require__(41)(3);
	
	$export($export.P + $export.F * !__webpack_require__(36)([].some, true), 'Array', {
	  // 22.1.3.23 / 15.4.4.17 Array.prototype.some(callbackfn [, thisArg])
	  some: function some(callbackfn /* , thisArg */){
	    return $some(this, callbackfn, arguments[1]);
	  }
	});

/***/ },
/* 380 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export   = __webpack_require__(1)
	  , aFunction = __webpack_require__(26)
	  , toObject  = __webpack_require__(18)
	  , fails     = __webpack_require__(8)
	  , $sort     = [].sort
	  , test      = [1, 2, 3];
	
	$export($export.P + $export.F * (fails(function(){
	  // IE8-
	  test.sort(undefined);
	}) || !fails(function(){
	  // V8 bug
	  test.sort(null);
	  // Old WebKit
	}) || !__webpack_require__(36)($sort)), 'Array', {
	  // 22.1.3.25 Array.prototype.sort(comparefn)
	  sort: function sort(comparefn){
	    return comparefn === undefined
	      ? $sort.call(toObject(this))
	      : $sort.call(toObject(this), aFunction(comparefn));
	  }
	});

/***/ },
/* 381 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(70)('Array');

/***/ },
/* 382 */
/***/ function(module, exports, __webpack_require__) {

	// 20.3.3.1 / 15.9.4.4 Date.now()
	var $export = __webpack_require__(1);
	
	$export($export.S, 'Date', {now: function(){ return new Date().getTime(); }});

/***/ },
/* 383 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// 20.3.4.36 / 15.9.5.43 Date.prototype.toISOString()
	var $export = __webpack_require__(1)
	  , fails   = __webpack_require__(8)
	  , getTime = Date.prototype.getTime;
	
	var lz = function(num){
	  return num > 9 ? num : '0' + num;
	};
	
	// PhantomJS / old WebKit has a broken implementations
	$export($export.P + $export.F * (fails(function(){
	  return new Date(-5e13 - 1).toISOString() != '0385-07-25T07:06:39.999Z';
	}) || !fails(function(){
	  new Date(NaN).toISOString();
	})), 'Date', {
	  toISOString: function toISOString(){
	    if(!isFinite(getTime.call(this)))throw RangeError('Invalid time value');
	    var d = this
	      , y = d.getUTCFullYear()
	      , m = d.getUTCMilliseconds()
	      , s = y < 0 ? '-' : y > 9999 ? '+' : '';
	    return s + ('00000' + Math.abs(y)).slice(s ? -6 : -4) +
	      '-' + lz(d.getUTCMonth() + 1) + '-' + lz(d.getUTCDate()) +
	      'T' + lz(d.getUTCHours()) + ':' + lz(d.getUTCMinutes()) +
	      ':' + lz(d.getUTCSeconds()) + '.' + (m > 99 ? m : '0' + lz(m)) + 'Z';
	  }
	});

/***/ },
/* 384 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export     = __webpack_require__(1)
	  , toObject    = __webpack_require__(18)
	  , toPrimitive = __webpack_require__(44);
	
	$export($export.P + $export.F * __webpack_require__(8)(function(){
	  return new Date(NaN).toJSON() !== null || Date.prototype.toJSON.call({toISOString: function(){ return 1; }}) !== 1;
	}), 'Date', {
	  toJSON: function toJSON(key){
	    var O  = toObject(this)
	      , pv = toPrimitive(O);
	    return typeof pv == 'number' && !isFinite(pv) ? null : O.toISOString();
	  }
	});

/***/ },
/* 385 */
/***/ function(module, exports, __webpack_require__) {

	var TO_PRIMITIVE = __webpack_require__(11)('toPrimitive')
	  , proto        = Date.prototype;
	
	if(!(TO_PRIMITIVE in proto))__webpack_require__(21)(proto, TO_PRIMITIVE, __webpack_require__(354));

/***/ },
/* 386 */
/***/ function(module, exports, __webpack_require__) {

	var DateProto    = Date.prototype
	  , INVALID_DATE = 'Invalid Date'
	  , TO_STRING    = 'toString'
	  , $toString    = DateProto[TO_STRING]
	  , getTime      = DateProto.getTime;
	if(new Date(NaN) + '' != INVALID_DATE){
	  __webpack_require__(27)(DateProto, TO_STRING, function toString(){
	    var value = getTime.call(this);
	    return value === value ? $toString.call(this) : INVALID_DATE;
	  });
	}

/***/ },
/* 387 */
/***/ function(module, exports, __webpack_require__) {

	// 19.2.3.2 / 15.3.4.5 Function.prototype.bind(thisArg, args...)
	var $export = __webpack_require__(1);
	
	$export($export.P, 'Function', {bind: __webpack_require__(220)});

/***/ },
/* 388 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var isObject       = __webpack_require__(10)
	  , getPrototypeOf = __webpack_require__(33)
	  , HAS_INSTANCE   = __webpack_require__(11)('hasInstance')
	  , FunctionProto  = Function.prototype;
	// 19.2.3.6 Function.prototype[@@hasInstance](V)
	if(!(HAS_INSTANCE in FunctionProto))__webpack_require__(14).f(FunctionProto, HAS_INSTANCE, {value: function(O){
	  if(typeof this != 'function' || !isObject(O))return false;
	  if(!isObject(this.prototype))return O instanceof this;
	  // for environment w/o native `@@hasInstance` logic enough `instanceof`, but add this:
	  while(O = getPrototypeOf(O))if(this.prototype === O)return true;
	  return false;
	}});

/***/ },
/* 389 */
/***/ function(module, exports, __webpack_require__) {

	var dP         = __webpack_require__(14).f
	  , createDesc = __webpack_require__(57)
	  , has        = __webpack_require__(19)
	  , FProto     = Function.prototype
	  , nameRE     = /^\s*function ([^ (]*)/
	  , NAME       = 'name';
	
	var isExtensible = Object.isExtensible || function(){
	  return true;
	};
	
	// 19.2.4.2 name
	NAME in FProto || __webpack_require__(13) && dP(FProto, NAME, {
	  configurable: true,
	  get: function(){
	    try {
	      var that = this
	        , name = ('' + that).match(nameRE)[1];
	      has(that, NAME) || !isExtensible(that) || dP(that, NAME, createDesc(5, name));
	      return name;
	    } catch(e){
	      return '';
	    }
	  }
	});

/***/ },
/* 390 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.3 Math.acosh(x)
	var $export = __webpack_require__(1)
	  , log1p   = __webpack_require__(227)
	  , sqrt    = Math.sqrt
	  , $acosh  = Math.acosh;
	
	$export($export.S + $export.F * !($acosh
	  // V8 bug: https://code.google.com/p/v8/issues/detail?id=3509
	  && Math.floor($acosh(Number.MAX_VALUE)) == 710
	  // Tor Browser bug: Math.acosh(Infinity) -> NaN 
	  && $acosh(Infinity) == Infinity
	), 'Math', {
	  acosh: function acosh(x){
	    return (x = +x) < 1 ? NaN : x > 94906265.62425156
	      ? Math.log(x) + Math.LN2
	      : log1p(x - 1 + sqrt(x - 1) * sqrt(x + 1));
	  }
	});

/***/ },
/* 391 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.5 Math.asinh(x)
	var $export = __webpack_require__(1)
	  , $asinh  = Math.asinh;
	
	function asinh(x){
	  return !isFinite(x = +x) || x == 0 ? x : x < 0 ? -asinh(-x) : Math.log(x + Math.sqrt(x * x + 1));
	}
	
	// Tor Browser bug: Math.asinh(0) -> -0 
	$export($export.S + $export.F * !($asinh && 1 / $asinh(0) > 0), 'Math', {asinh: asinh});

/***/ },
/* 392 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.7 Math.atanh(x)
	var $export = __webpack_require__(1)
	  , $atanh  = Math.atanh;
	
	// Tor Browser bug: Math.atanh(-0) -> 0 
	$export($export.S + $export.F * !($atanh && 1 / $atanh(-0) < 0), 'Math', {
	  atanh: function atanh(x){
	    return (x = +x) == 0 ? x : Math.log((1 + x) / (1 - x)) / 2;
	  }
	});

/***/ },
/* 393 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.9 Math.cbrt(x)
	var $export = __webpack_require__(1)
	  , sign    = __webpack_require__(158);
	
	$export($export.S, 'Math', {
	  cbrt: function cbrt(x){
	    return sign(x = +x) * Math.pow(Math.abs(x), 1 / 3);
	  }
	});

/***/ },
/* 394 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.11 Math.clz32(x)
	var $export = __webpack_require__(1);
	
	$export($export.S, 'Math', {
	  clz32: function clz32(x){
	    return (x >>>= 0) ? 31 - Math.floor(Math.log(x + 0.5) * Math.LOG2E) : 32;
	  }
	});

/***/ },
/* 395 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.12 Math.cosh(x)
	var $export = __webpack_require__(1)
	  , exp     = Math.exp;
	
	$export($export.S, 'Math', {
	  cosh: function cosh(x){
	    return (exp(x = +x) + exp(-x)) / 2;
	  }
	});

/***/ },
/* 396 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.14 Math.expm1(x)
	var $export = __webpack_require__(1)
	  , $expm1  = __webpack_require__(157);
	
	$export($export.S + $export.F * ($expm1 != Math.expm1), 'Math', {expm1: $expm1});

/***/ },
/* 397 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.16 Math.fround(x)
	var $export   = __webpack_require__(1)
	  , sign      = __webpack_require__(158)
	  , pow       = Math.pow
	  , EPSILON   = pow(2, -52)
	  , EPSILON32 = pow(2, -23)
	  , MAX32     = pow(2, 127) * (2 - EPSILON32)
	  , MIN32     = pow(2, -126);
	
	var roundTiesToEven = function(n){
	  return n + 1 / EPSILON - 1 / EPSILON;
	};
	
	
	$export($export.S, 'Math', {
	  fround: function fround(x){
	    var $abs  = Math.abs(x)
	      , $sign = sign(x)
	      , a, result;
	    if($abs < MIN32)return $sign * roundTiesToEven($abs / MIN32 / EPSILON32) * MIN32 * EPSILON32;
	    a = (1 + EPSILON32 / EPSILON) * $abs;
	    result = a - (a - $abs);
	    if(result > MAX32 || result != result)return $sign * Infinity;
	    return $sign * result;
	  }
	});

/***/ },
/* 398 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.17 Math.hypot([value1[, value2[, … ]]])
	var $export = __webpack_require__(1)
	  , abs     = Math.abs;
	
	$export($export.S, 'Math', {
	  hypot: function hypot(value1, value2){ // eslint-disable-line no-unused-vars
	    var sum  = 0
	      , i    = 0
	      , aLen = arguments.length
	      , larg = 0
	      , arg, div;
	    while(i < aLen){
	      arg = abs(arguments[i++]);
	      if(larg < arg){
	        div  = larg / arg;
	        sum  = sum * div * div + 1;
	        larg = arg;
	      } else if(arg > 0){
	        div  = arg / larg;
	        sum += div * div;
	      } else sum += arg;
	    }
	    return larg === Infinity ? Infinity : larg * Math.sqrt(sum);
	  }
	});

/***/ },
/* 399 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.18 Math.imul(x, y)
	var $export = __webpack_require__(1)
	  , $imul   = Math.imul;
	
	// some WebKit versions fails with big numbers, some has wrong arity
	$export($export.S + $export.F * __webpack_require__(8)(function(){
	  return $imul(0xffffffff, 5) != -5 || $imul.length != 2;
	}), 'Math', {
	  imul: function imul(x, y){
	    var UINT16 = 0xffff
	      , xn = +x
	      , yn = +y
	      , xl = UINT16 & xn
	      , yl = UINT16 & yn;
	    return 0 | xl * yl + ((UINT16 & xn >>> 16) * yl + xl * (UINT16 & yn >>> 16) << 16 >>> 0);
	  }
	});

/***/ },
/* 400 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.21 Math.log10(x)
	var $export = __webpack_require__(1);
	
	$export($export.S, 'Math', {
	  log10: function log10(x){
	    return Math.log(x) / Math.LN10;
	  }
	});

/***/ },
/* 401 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.20 Math.log1p(x)
	var $export = __webpack_require__(1);
	
	$export($export.S, 'Math', {log1p: __webpack_require__(227)});

/***/ },
/* 402 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.22 Math.log2(x)
	var $export = __webpack_require__(1);
	
	$export($export.S, 'Math', {
	  log2: function log2(x){
	    return Math.log(x) / Math.LN2;
	  }
	});

/***/ },
/* 403 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.28 Math.sign(x)
	var $export = __webpack_require__(1);
	
	$export($export.S, 'Math', {sign: __webpack_require__(158)});

/***/ },
/* 404 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.30 Math.sinh(x)
	var $export = __webpack_require__(1)
	  , expm1   = __webpack_require__(157)
	  , exp     = Math.exp;
	
	// V8 near Chromium 38 has a problem with very small numbers
	$export($export.S + $export.F * __webpack_require__(8)(function(){
	  return !Math.sinh(-2e-17) != -2e-17;
	}), 'Math', {
	  sinh: function sinh(x){
	    return Math.abs(x = +x) < 1
	      ? (expm1(x) - expm1(-x)) / 2
	      : (exp(x - 1) - exp(-x - 1)) * (Math.E / 2);
	  }
	});

/***/ },
/* 405 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.33 Math.tanh(x)
	var $export = __webpack_require__(1)
	  , expm1   = __webpack_require__(157)
	  , exp     = Math.exp;
	
	$export($export.S, 'Math', {
	  tanh: function tanh(x){
	    var a = expm1(x = +x)
	      , b = expm1(-x);
	    return a == Infinity ? 1 : b == Infinity ? -1 : (a - b) / (exp(x) + exp(-x));
	  }
	});

/***/ },
/* 406 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.34 Math.trunc(x)
	var $export = __webpack_require__(1);
	
	$export($export.S, 'Math', {
	  trunc: function trunc(it){
	    return (it > 0 ? Math.floor : Math.ceil)(it);
	  }
	});

/***/ },
/* 407 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var global            = __webpack_require__(7)
	  , has               = __webpack_require__(19)
	  , cof               = __webpack_require__(34)
	  , inheritIfRequired = __webpack_require__(151)
	  , toPrimitive       = __webpack_require__(44)
	  , fails             = __webpack_require__(8)
	  , gOPN              = __webpack_require__(67).f
	  , gOPD              = __webpack_require__(32).f
	  , dP                = __webpack_require__(14).f
	  , $trim             = __webpack_require__(81).trim
	  , NUMBER            = 'Number'
	  , $Number           = global[NUMBER]
	  , Base              = $Number
	  , proto             = $Number.prototype
	  // Opera ~12 has broken Object#toString
	  , BROKEN_COF        = cof(__webpack_require__(66)(proto)) == NUMBER
	  , TRIM              = 'trim' in String.prototype;
	
	// 7.1.3 ToNumber(argument)
	var toNumber = function(argument){
	  var it = toPrimitive(argument, false);
	  if(typeof it == 'string' && it.length > 2){
	    it = TRIM ? it.trim() : $trim(it, 3);
	    var first = it.charCodeAt(0)
	      , third, radix, maxCode;
	    if(first === 43 || first === 45){
	      third = it.charCodeAt(2);
	      if(third === 88 || third === 120)return NaN; // Number('+0x1') should be NaN, old V8 fix
	    } else if(first === 48){
	      switch(it.charCodeAt(1)){
	        case 66 : case 98  : radix = 2; maxCode = 49; break; // fast equal /^0b[01]+$/i
	        case 79 : case 111 : radix = 8; maxCode = 55; break; // fast equal /^0o[0-7]+$/i
	        default : return +it;
	      }
	      for(var digits = it.slice(2), i = 0, l = digits.length, code; i < l; i++){
	        code = digits.charCodeAt(i);
	        // parseInt parses a string to a first unavailable symbol
	        // but ToNumber should return NaN if a string contains unavailable symbols
	        if(code < 48 || code > maxCode)return NaN;
	      } return parseInt(digits, radix);
	    }
	  } return +it;
	};
	
	if(!$Number(' 0o1') || !$Number('0b1') || $Number('+0x1')){
	  $Number = function Number(value){
	    var it = arguments.length < 1 ? 0 : value
	      , that = this;
	    return that instanceof $Number
	      // check on 1..constructor(foo) case
	      && (BROKEN_COF ? fails(function(){ proto.valueOf.call(that); }) : cof(that) != NUMBER)
	        ? inheritIfRequired(new Base(toNumber(it)), that, $Number) : toNumber(it);
	  };
	  for(var keys = __webpack_require__(13) ? gOPN(Base) : (
	    // ES3:
	    'MAX_VALUE,MIN_VALUE,NaN,NEGATIVE_INFINITY,POSITIVE_INFINITY,' +
	    // ES6 (in case, if modules with ES6 Number statics required before):
	    'EPSILON,isFinite,isInteger,isNaN,isSafeInteger,MAX_SAFE_INTEGER,' +
	    'MIN_SAFE_INTEGER,parseFloat,parseInt,isInteger'
	  ).split(','), j = 0, key; keys.length > j; j++){
	    if(has(Base, key = keys[j]) && !has($Number, key)){
	      dP($Number, key, gOPD(Base, key));
	    }
	  }
	  $Number.prototype = proto;
	  proto.constructor = $Number;
	  __webpack_require__(27)(global, NUMBER, $Number);
	}

/***/ },
/* 408 */
/***/ function(module, exports, __webpack_require__) {

	// 20.1.2.1 Number.EPSILON
	var $export = __webpack_require__(1);
	
	$export($export.S, 'Number', {EPSILON: Math.pow(2, -52)});

/***/ },
/* 409 */
/***/ function(module, exports, __webpack_require__) {

	// 20.1.2.2 Number.isFinite(number)
	var $export   = __webpack_require__(1)
	  , _isFinite = __webpack_require__(7).isFinite;
	
	$export($export.S, 'Number', {
	  isFinite: function isFinite(it){
	    return typeof it == 'number' && _isFinite(it);
	  }
	});

/***/ },
/* 410 */
/***/ function(module, exports, __webpack_require__) {

	// 20.1.2.3 Number.isInteger(number)
	var $export = __webpack_require__(1);
	
	$export($export.S, 'Number', {isInteger: __webpack_require__(154)});

/***/ },
/* 411 */
/***/ function(module, exports, __webpack_require__) {

	// 20.1.2.4 Number.isNaN(number)
	var $export = __webpack_require__(1);
	
	$export($export.S, 'Number', {
	  isNaN: function isNaN(number){
	    return number != number;
	  }
	});

/***/ },
/* 412 */
/***/ function(module, exports, __webpack_require__) {

	// 20.1.2.5 Number.isSafeInteger(number)
	var $export   = __webpack_require__(1)
	  , isInteger = __webpack_require__(154)
	  , abs       = Math.abs;
	
	$export($export.S, 'Number', {
	  isSafeInteger: function isSafeInteger(number){
	    return isInteger(number) && abs(number) <= 0x1fffffffffffff;
	  }
	});

/***/ },
/* 413 */
/***/ function(module, exports, __webpack_require__) {

	// 20.1.2.6 Number.MAX_SAFE_INTEGER
	var $export = __webpack_require__(1);
	
	$export($export.S, 'Number', {MAX_SAFE_INTEGER: 0x1fffffffffffff});

/***/ },
/* 414 */
/***/ function(module, exports, __webpack_require__) {

	// 20.1.2.10 Number.MIN_SAFE_INTEGER
	var $export = __webpack_require__(1);
	
	$export($export.S, 'Number', {MIN_SAFE_INTEGER: -0x1fffffffffffff});

/***/ },
/* 415 */
/***/ function(module, exports, __webpack_require__) {

	var $export     = __webpack_require__(1)
	  , $parseFloat = __webpack_require__(234);
	// 20.1.2.12 Number.parseFloat(string)
	$export($export.S + $export.F * (Number.parseFloat != $parseFloat), 'Number', {parseFloat: $parseFloat});

/***/ },
/* 416 */
/***/ function(module, exports, __webpack_require__) {

	var $export   = __webpack_require__(1)
	  , $parseInt = __webpack_require__(235);
	// 20.1.2.13 Number.parseInt(string, radix)
	$export($export.S + $export.F * (Number.parseInt != $parseInt), 'Number', {parseInt: $parseInt});

/***/ },
/* 417 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export      = __webpack_require__(1)
	  , anInstance   = __webpack_require__(55)
	  , toInteger    = __webpack_require__(58)
	  , aNumberValue = __webpack_require__(216)
	  , repeat       = __webpack_require__(164)
	  , $toFixed     = 1..toFixed
	  , floor        = Math.floor
	  , data         = [0, 0, 0, 0, 0, 0]
	  , ERROR        = 'Number.toFixed: incorrect invocation!'
	  , ZERO         = '0';
	
	var multiply = function(n, c){
	  var i  = -1
	    , c2 = c;
	  while(++i < 6){
	    c2 += n * data[i];
	    data[i] = c2 % 1e7;
	    c2 = floor(c2 / 1e7);
	  }
	};
	var divide = function(n){
	  var i = 6
	    , c = 0;
	  while(--i >= 0){
	    c += data[i];
	    data[i] = floor(c / n);
	    c = (c % n) * 1e7;
	  }
	};
	var numToString = function(){
	  var i = 6
	    , s = '';
	  while(--i >= 0){
	    if(s !== '' || i === 0 || data[i] !== 0){
	      var t = String(data[i]);
	      s = s === '' ? t : s + repeat.call(ZERO, 7 - t.length) + t;
	    }
	  } return s;
	};
	var pow = function(x, n, acc){
	  return n === 0 ? acc : n % 2 === 1 ? pow(x, n - 1, acc * x) : pow(x * x, n / 2, acc);
	};
	var log = function(x){
	  var n  = 0
	    , x2 = x;
	  while(x2 >= 4096){
	    n += 12;
	    x2 /= 4096;
	  }
	  while(x2 >= 2){
	    n  += 1;
	    x2 /= 2;
	  } return n;
	};
	
	$export($export.P + $export.F * (!!$toFixed && (
	  0.00008.toFixed(3) !== '0.000' ||
	  0.9.toFixed(0) !== '1' ||
	  1.255.toFixed(2) !== '1.25' ||
	  1000000000000000128..toFixed(0) !== '1000000000000000128'
	) || !__webpack_require__(8)(function(){
	  // V8 ~ Android 4.3-
	  $toFixed.call({});
	})), 'Number', {
	  toFixed: function toFixed(fractionDigits){
	    var x = aNumberValue(this, ERROR)
	      , f = toInteger(fractionDigits)
	      , s = ''
	      , m = ZERO
	      , e, z, j, k;
	    if(f < 0 || f > 20)throw RangeError(ERROR);
	    if(x != x)return 'NaN';
	    if(x <= -1e21 || x >= 1e21)return String(x);
	    if(x < 0){
	      s = '-';
	      x = -x;
	    }
	    if(x > 1e-21){
	      e = log(x * pow(2, 69, 1)) - 69;
	      z = e < 0 ? x * pow(2, -e, 1) : x / pow(2, e, 1);
	      z *= 0x10000000000000;
	      e = 52 - e;
	      if(e > 0){
	        multiply(0, z);
	        j = f;
	        while(j >= 7){
	          multiply(1e7, 0);
	          j -= 7;
	        }
	        multiply(pow(10, j, 1), 0);
	        j = e - 1;
	        while(j >= 23){
	          divide(1 << 23);
	          j -= 23;
	        }
	        divide(1 << j);
	        multiply(1, 1);
	        divide(2);
	        m = numToString();
	      } else {
	        multiply(0, z);
	        multiply(1 << -e, 0);
	        m = numToString() + repeat.call(ZERO, f);
	      }
	    }
	    if(f > 0){
	      k = m.length;
	      m = s + (k <= f ? '0.' + repeat.call(ZERO, f - k) + m : m.slice(0, k - f) + '.' + m.slice(k - f));
	    } else {
	      m = s + m;
	    } return m;
	  }
	});

/***/ },
/* 418 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export      = __webpack_require__(1)
	  , $fails       = __webpack_require__(8)
	  , aNumberValue = __webpack_require__(216)
	  , $toPrecision = 1..toPrecision;
	
	$export($export.P + $export.F * ($fails(function(){
	  // IE7-
	  return $toPrecision.call(1, undefined) !== '1';
	}) || !$fails(function(){
	  // V8 ~ Android 4.3-
	  $toPrecision.call({});
	})), 'Number', {
	  toPrecision: function toPrecision(precision){
	    var that = aNumberValue(this, 'Number#toPrecision: incorrect invocation!');
	    return precision === undefined ? $toPrecision.call(that) : $toPrecision.call(that, precision); 
	  }
	});

/***/ },
/* 419 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.3.1 Object.assign(target, source)
	var $export = __webpack_require__(1);
	
	$export($export.S + $export.F, 'Object', {assign: __webpack_require__(228)});

/***/ },
/* 420 */
/***/ function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(1)
	// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
	$export($export.S, 'Object', {create: __webpack_require__(66)});

/***/ },
/* 421 */
/***/ function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(1);
	// 19.1.2.3 / 15.2.3.7 Object.defineProperties(O, Properties)
	$export($export.S + $export.F * !__webpack_require__(13), 'Object', {defineProperties: __webpack_require__(229)});

/***/ },
/* 422 */
/***/ function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(1);
	// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
	$export($export.S + $export.F * !__webpack_require__(13), 'Object', {defineProperty: __webpack_require__(14).f});

/***/ },
/* 423 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.5 Object.freeze(O)
	var isObject = __webpack_require__(10)
	  , meta     = __webpack_require__(56).onFreeze;
	
	__webpack_require__(43)('freeze', function($freeze){
	  return function freeze(it){
	    return $freeze && isObject(it) ? $freeze(meta(it)) : it;
	  };
	});

/***/ },
/* 424 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
	var toIObject                 = __webpack_require__(29)
	  , $getOwnPropertyDescriptor = __webpack_require__(32).f;
	
	__webpack_require__(43)('getOwnPropertyDescriptor', function(){
	  return function getOwnPropertyDescriptor(it, key){
	    return $getOwnPropertyDescriptor(toIObject(it), key);
	  };
	});

/***/ },
/* 425 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.7 Object.getOwnPropertyNames(O)
	__webpack_require__(43)('getOwnPropertyNames', function(){
	  return __webpack_require__(230).f;
	});

/***/ },
/* 426 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.9 Object.getPrototypeOf(O)
	var toObject        = __webpack_require__(18)
	  , $getPrototypeOf = __webpack_require__(33);
	
	__webpack_require__(43)('getPrototypeOf', function(){
	  return function getPrototypeOf(it){
	    return $getPrototypeOf(toObject(it));
	  };
	});

/***/ },
/* 427 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.11 Object.isExtensible(O)
	var isObject = __webpack_require__(10);
	
	__webpack_require__(43)('isExtensible', function($isExtensible){
	  return function isExtensible(it){
	    return isObject(it) ? $isExtensible ? $isExtensible(it) : true : false;
	  };
	});

/***/ },
/* 428 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.12 Object.isFrozen(O)
	var isObject = __webpack_require__(10);
	
	__webpack_require__(43)('isFrozen', function($isFrozen){
	  return function isFrozen(it){
	    return isObject(it) ? $isFrozen ? $isFrozen(it) : false : true;
	  };
	});

/***/ },
/* 429 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.13 Object.isSealed(O)
	var isObject = __webpack_require__(10);
	
	__webpack_require__(43)('isSealed', function($isSealed){
	  return function isSealed(it){
	    return isObject(it) ? $isSealed ? $isSealed(it) : false : true;
	  };
	});

/***/ },
/* 430 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.3.10 Object.is(value1, value2)
	var $export = __webpack_require__(1);
	$export($export.S, 'Object', {is: __webpack_require__(236)});

/***/ },
/* 431 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.14 Object.keys(O)
	var toObject = __webpack_require__(18)
	  , $keys    = __webpack_require__(68);
	
	__webpack_require__(43)('keys', function(){
	  return function keys(it){
	    return $keys(toObject(it));
	  };
	});

/***/ },
/* 432 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.15 Object.preventExtensions(O)
	var isObject = __webpack_require__(10)
	  , meta     = __webpack_require__(56).onFreeze;
	
	__webpack_require__(43)('preventExtensions', function($preventExtensions){
	  return function preventExtensions(it){
	    return $preventExtensions && isObject(it) ? $preventExtensions(meta(it)) : it;
	  };
	});

/***/ },
/* 433 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.17 Object.seal(O)
	var isObject = __webpack_require__(10)
	  , meta     = __webpack_require__(56).onFreeze;
	
	__webpack_require__(43)('seal', function($seal){
	  return function seal(it){
	    return $seal && isObject(it) ? $seal(meta(it)) : it;
	  };
	});

/***/ },
/* 434 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.3.19 Object.setPrototypeOf(O, proto)
	var $export = __webpack_require__(1);
	$export($export.S, 'Object', {setPrototypeOf: __webpack_require__(113).set});

/***/ },
/* 435 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// 19.1.3.6 Object.prototype.toString()
	var classof = __webpack_require__(78)
	  , test    = {};
	test[__webpack_require__(11)('toStringTag')] = 'z';
	if(test + '' != '[object z]'){
	  __webpack_require__(27)(Object.prototype, 'toString', function toString(){
	    return '[object ' + classof(this) + ']';
	  }, true);
	}

/***/ },
/* 436 */
/***/ function(module, exports, __webpack_require__) {

	var $export     = __webpack_require__(1)
	  , $parseFloat = __webpack_require__(234);
	// 18.2.4 parseFloat(string)
	$export($export.G + $export.F * (parseFloat != $parseFloat), {parseFloat: $parseFloat});

/***/ },
/* 437 */
/***/ function(module, exports, __webpack_require__) {

	var $export   = __webpack_require__(1)
	  , $parseInt = __webpack_require__(235);
	// 18.2.5 parseInt(string, radix)
	$export($export.G + $export.F * (parseInt != $parseInt), {parseInt: $parseInt});

/***/ },
/* 438 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var LIBRARY            = __webpack_require__(65)
	  , global             = __webpack_require__(7)
	  , ctx                = __webpack_require__(47)
	  , classof            = __webpack_require__(78)
	  , $export            = __webpack_require__(1)
	  , isObject           = __webpack_require__(10)
	  , anObject           = __webpack_require__(4)
	  , aFunction          = __webpack_require__(26)
	  , anInstance         = __webpack_require__(55)
	  , forOf              = __webpack_require__(79)
	  , setProto           = __webpack_require__(113).set
	  , speciesConstructor = __webpack_require__(161)
	  , task               = __webpack_require__(166).set
	  , microtask          = __webpack_require__(159)()
	  , PROMISE            = 'Promise'
	  , TypeError          = global.TypeError
	  , process            = global.process
	  , $Promise           = global[PROMISE]
	  , process            = global.process
	  , isNode             = classof(process) == 'process'
	  , empty              = function(){ /* empty */ }
	  , Internal, GenericPromiseCapability, Wrapper;
	
	var USE_NATIVE = !!function(){
	  try {
	    // correct subclassing with @@species support
	    var promise     = $Promise.resolve(1)
	      , FakePromise = (promise.constructor = {})[__webpack_require__(11)('species')] = function(exec){ exec(empty, empty); };
	    // unhandled rejections tracking support, NodeJS Promise without it fails @@species test
	    return (isNode || typeof PromiseRejectionEvent == 'function') && promise.then(empty) instanceof FakePromise;
	  } catch(e){ /* empty */ }
	}();
	
	// helpers
	var sameConstructor = function(a, b){
	  // with library wrapper special case
	  return a === b || a === $Promise && b === Wrapper;
	};
	var isThenable = function(it){
	  var then;
	  return isObject(it) && typeof (then = it.then) == 'function' ? then : false;
	};
	var newPromiseCapability = function(C){
	  return sameConstructor($Promise, C)
	    ? new PromiseCapability(C)
	    : new GenericPromiseCapability(C);
	};
	var PromiseCapability = GenericPromiseCapability = function(C){
	  var resolve, reject;
	  this.promise = new C(function($$resolve, $$reject){
	    if(resolve !== undefined || reject !== undefined)throw TypeError('Bad Promise constructor');
	    resolve = $$resolve;
	    reject  = $$reject;
	  });
	  this.resolve = aFunction(resolve);
	  this.reject  = aFunction(reject);
	};
	var perform = function(exec){
	  try {
	    exec();
	  } catch(e){
	    return {error: e};
	  }
	};
	var notify = function(promise, isReject){
	  if(promise._n)return;
	  promise._n = true;
	  var chain = promise._c;
	  microtask(function(){
	    var value = promise._v
	      , ok    = promise._s == 1
	      , i     = 0;
	    var run = function(reaction){
	      var handler = ok ? reaction.ok : reaction.fail
	        , resolve = reaction.resolve
	        , reject  = reaction.reject
	        , domain  = reaction.domain
	        , result, then;
	      try {
	        if(handler){
	          if(!ok){
	            if(promise._h == 2)onHandleUnhandled(promise);
	            promise._h = 1;
	          }
	          if(handler === true)result = value;
	          else {
	            if(domain)domain.enter();
	            result = handler(value);
	            if(domain)domain.exit();
	          }
	          if(result === reaction.promise){
	            reject(TypeError('Promise-chain cycle'));
	          } else if(then = isThenable(result)){
	            then.call(result, resolve, reject);
	          } else resolve(result);
	        } else reject(value);
	      } catch(e){
	        reject(e);
	      }
	    };
	    while(chain.length > i)run(chain[i++]); // variable length - can't use forEach
	    promise._c = [];
	    promise._n = false;
	    if(isReject && !promise._h)onUnhandled(promise);
	  });
	};
	var onUnhandled = function(promise){
	  task.call(global, function(){
	    var value = promise._v
	      , abrupt, handler, console;
	    if(isUnhandled(promise)){
	      abrupt = perform(function(){
	        if(isNode){
	          process.emit('unhandledRejection', value, promise);
	        } else if(handler = global.onunhandledrejection){
	          handler({promise: promise, reason: value});
	        } else if((console = global.console) && console.error){
	          console.error('Unhandled promise rejection', value);
	        }
	      });
	      // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
	      promise._h = isNode || isUnhandled(promise) ? 2 : 1;
	    } promise._a = undefined;
	    if(abrupt)throw abrupt.error;
	  });
	};
	var isUnhandled = function(promise){
	  if(promise._h == 1)return false;
	  var chain = promise._a || promise._c
	    , i     = 0
	    , reaction;
	  while(chain.length > i){
	    reaction = chain[i++];
	    if(reaction.fail || !isUnhandled(reaction.promise))return false;
	  } return true;
	};
	var onHandleUnhandled = function(promise){
	  task.call(global, function(){
	    var handler;
	    if(isNode){
	      process.emit('rejectionHandled', promise);
	    } else if(handler = global.onrejectionhandled){
	      handler({promise: promise, reason: promise._v});
	    }
	  });
	};
	var $reject = function(value){
	  var promise = this;
	  if(promise._d)return;
	  promise._d = true;
	  promise = promise._w || promise; // unwrap
	  promise._v = value;
	  promise._s = 2;
	  if(!promise._a)promise._a = promise._c.slice();
	  notify(promise, true);
	};
	var $resolve = function(value){
	  var promise = this
	    , then;
	  if(promise._d)return;
	  promise._d = true;
	  promise = promise._w || promise; // unwrap
	  try {
	    if(promise === value)throw TypeError("Promise can't be resolved itself");
	    if(then = isThenable(value)){
	      microtask(function(){
	        var wrapper = {_w: promise, _d: false}; // wrap
	        try {
	          then.call(value, ctx($resolve, wrapper, 1), ctx($reject, wrapper, 1));
	        } catch(e){
	          $reject.call(wrapper, e);
	        }
	      });
	    } else {
	      promise._v = value;
	      promise._s = 1;
	      notify(promise, false);
	    }
	  } catch(e){
	    $reject.call({_w: promise, _d: false}, e); // wrap
	  }
	};
	
	// constructor polyfill
	if(!USE_NATIVE){
	  // 25.4.3.1 Promise(executor)
	  $Promise = function Promise(executor){
	    anInstance(this, $Promise, PROMISE, '_h');
	    aFunction(executor);
	    Internal.call(this);
	    try {
	      executor(ctx($resolve, this, 1), ctx($reject, this, 1));
	    } catch(err){
	      $reject.call(this, err);
	    }
	  };
	  Internal = function Promise(executor){
	    this._c = [];             // <- awaiting reactions
	    this._a = undefined;      // <- checked in isUnhandled reactions
	    this._s = 0;              // <- state
	    this._d = false;          // <- done
	    this._v = undefined;      // <- value
	    this._h = 0;              // <- rejection state, 0 - default, 1 - handled, 2 - unhandled
	    this._n = false;          // <- notify
	  };
	  Internal.prototype = __webpack_require__(69)($Promise.prototype, {
	    // 25.4.5.3 Promise.prototype.then(onFulfilled, onRejected)
	    then: function then(onFulfilled, onRejected){
	      var reaction    = newPromiseCapability(speciesConstructor(this, $Promise));
	      reaction.ok     = typeof onFulfilled == 'function' ? onFulfilled : true;
	      reaction.fail   = typeof onRejected == 'function' && onRejected;
	      reaction.domain = isNode ? process.domain : undefined;
	      this._c.push(reaction);
	      if(this._a)this._a.push(reaction);
	      if(this._s)notify(this, false);
	      return reaction.promise;
	    },
	    // 25.4.5.1 Promise.prototype.catch(onRejected)
	    'catch': function(onRejected){
	      return this.then(undefined, onRejected);
	    }
	  });
	  PromiseCapability = function(){
	    var promise  = new Internal;
	    this.promise = promise;
	    this.resolve = ctx($resolve, promise, 1);
	    this.reject  = ctx($reject, promise, 1);
	  };
	}
	
	$export($export.G + $export.W + $export.F * !USE_NATIVE, {Promise: $Promise});
	__webpack_require__(80)($Promise, PROMISE);
	__webpack_require__(70)(PROMISE);
	Wrapper = __webpack_require__(42)[PROMISE];
	
	// statics
	$export($export.S + $export.F * !USE_NATIVE, PROMISE, {
	  // 25.4.4.5 Promise.reject(r)
	  reject: function reject(r){
	    var capability = newPromiseCapability(this)
	      , $$reject   = capability.reject;
	    $$reject(r);
	    return capability.promise;
	  }
	});
	$export($export.S + $export.F * (LIBRARY || !USE_NATIVE), PROMISE, {
	  // 25.4.4.6 Promise.resolve(x)
	  resolve: function resolve(x){
	    // instanceof instead of internal slot check because we should fix it without replacement native Promise core
	    if(x instanceof $Promise && sameConstructor(x.constructor, this))return x;
	    var capability = newPromiseCapability(this)
	      , $$resolve  = capability.resolve;
	    $$resolve(x);
	    return capability.promise;
	  }
	});
	$export($export.S + $export.F * !(USE_NATIVE && __webpack_require__(110)(function(iter){
	  $Promise.all(iter)['catch'](empty);
	})), PROMISE, {
	  // 25.4.4.1 Promise.all(iterable)
	  all: function all(iterable){
	    var C          = this
	      , capability = newPromiseCapability(C)
	      , resolve    = capability.resolve
	      , reject     = capability.reject;
	    var abrupt = perform(function(){
	      var values    = []
	        , index     = 0
	        , remaining = 1;
	      forOf(iterable, false, function(promise){
	        var $index        = index++
	          , alreadyCalled = false;
	        values.push(undefined);
	        remaining++;
	        C.resolve(promise).then(function(value){
	          if(alreadyCalled)return;
	          alreadyCalled  = true;
	          values[$index] = value;
	          --remaining || resolve(values);
	        }, reject);
	      });
	      --remaining || resolve(values);
	    });
	    if(abrupt)reject(abrupt.error);
	    return capability.promise;
	  },
	  // 25.4.4.4 Promise.race(iterable)
	  race: function race(iterable){
	    var C          = this
	      , capability = newPromiseCapability(C)
	      , reject     = capability.reject;
	    var abrupt = perform(function(){
	      forOf(iterable, false, function(promise){
	        C.resolve(promise).then(capability.resolve, reject);
	      });
	    });
	    if(abrupt)reject(abrupt.error);
	    return capability.promise;
	  }
	});

/***/ },
/* 439 */
/***/ function(module, exports, __webpack_require__) {

	// 26.1.1 Reflect.apply(target, thisArgument, argumentsList)
	var $export   = __webpack_require__(1)
	  , aFunction = __webpack_require__(26)
	  , anObject  = __webpack_require__(4)
	  , _apply    = Function.apply;
	
	$export($export.S, 'Reflect', {
	  apply: function apply(target, thisArgument, argumentsList){
	    return _apply.call(aFunction(target), thisArgument, anObject(argumentsList));
	  }
	});

/***/ },
/* 440 */
/***/ function(module, exports, __webpack_require__) {

	// 26.1.2 Reflect.construct(target, argumentsList [, newTarget])
	var $export   = __webpack_require__(1)
	  , create    = __webpack_require__(66)
	  , aFunction = __webpack_require__(26)
	  , anObject  = __webpack_require__(4)
	  , isObject  = __webpack_require__(10)
	  , bind      = __webpack_require__(220);
	
	// MS Edge supports only 2 arguments
	// FF Nightly sets third argument as `new.target`, but does not create `this` from it
	$export($export.S + $export.F * __webpack_require__(8)(function(){
	  function F(){}
	  return !(Reflect.construct(function(){}, [], F) instanceof F);
	}), 'Reflect', {
	  construct: function construct(Target, args /*, newTarget*/){
	    aFunction(Target);
	    anObject(args);
	    var newTarget = arguments.length < 3 ? Target : aFunction(arguments[2]);
	    if(Target == newTarget){
	      // w/o altered newTarget, optimization for 0-4 arguments
	      switch(args.length){
	        case 0: return new Target;
	        case 1: return new Target(args[0]);
	        case 2: return new Target(args[0], args[1]);
	        case 3: return new Target(args[0], args[1], args[2]);
	        case 4: return new Target(args[0], args[1], args[2], args[3]);
	      }
	      // w/o altered newTarget, lot of arguments case
	      var $args = [null];
	      $args.push.apply($args, args);
	      return new (bind.apply(Target, $args));
	    }
	    // with altered newTarget, not support built-in constructors
	    var proto    = newTarget.prototype
	      , instance = create(isObject(proto) ? proto : Object.prototype)
	      , result   = Function.apply.call(Target, instance, args);
	    return isObject(result) ? result : instance;
	  }
	});

/***/ },
/* 441 */
/***/ function(module, exports, __webpack_require__) {

	// 26.1.3 Reflect.defineProperty(target, propertyKey, attributes)
	var dP          = __webpack_require__(14)
	  , $export     = __webpack_require__(1)
	  , anObject    = __webpack_require__(4)
	  , toPrimitive = __webpack_require__(44);
	
	// MS Edge has broken Reflect.defineProperty - throwing instead of returning false
	$export($export.S + $export.F * __webpack_require__(8)(function(){
	  Reflect.defineProperty(dP.f({}, 1, {value: 1}), 1, {value: 2});
	}), 'Reflect', {
	  defineProperty: function defineProperty(target, propertyKey, attributes){
	    anObject(target);
	    propertyKey = toPrimitive(propertyKey, true);
	    anObject(attributes);
	    try {
	      dP.f(target, propertyKey, attributes);
	      return true;
	    } catch(e){
	      return false;
	    }
	  }
	});

/***/ },
/* 442 */
/***/ function(module, exports, __webpack_require__) {

	// 26.1.4 Reflect.deleteProperty(target, propertyKey)
	var $export  = __webpack_require__(1)
	  , gOPD     = __webpack_require__(32).f
	  , anObject = __webpack_require__(4);
	
	$export($export.S, 'Reflect', {
	  deleteProperty: function deleteProperty(target, propertyKey){
	    var desc = gOPD(anObject(target), propertyKey);
	    return desc && !desc.configurable ? false : delete target[propertyKey];
	  }
	});

/***/ },
/* 443 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// 26.1.5 Reflect.enumerate(target)
	var $export  = __webpack_require__(1)
	  , anObject = __webpack_require__(4);
	var Enumerate = function(iterated){
	  this._t = anObject(iterated); // target
	  this._i = 0;                  // next index
	  var keys = this._k = []       // keys
	    , key;
	  for(key in iterated)keys.push(key);
	};
	__webpack_require__(155)(Enumerate, 'Object', function(){
	  var that = this
	    , keys = that._k
	    , key;
	  do {
	    if(that._i >= keys.length)return {value: undefined, done: true};
	  } while(!((key = keys[that._i++]) in that._t));
	  return {value: key, done: false};
	});
	
	$export($export.S, 'Reflect', {
	  enumerate: function enumerate(target){
	    return new Enumerate(target);
	  }
	});

/***/ },
/* 444 */
/***/ function(module, exports, __webpack_require__) {

	// 26.1.7 Reflect.getOwnPropertyDescriptor(target, propertyKey)
	var gOPD     = __webpack_require__(32)
	  , $export  = __webpack_require__(1)
	  , anObject = __webpack_require__(4);
	
	$export($export.S, 'Reflect', {
	  getOwnPropertyDescriptor: function getOwnPropertyDescriptor(target, propertyKey){
	    return gOPD.f(anObject(target), propertyKey);
	  }
	});

/***/ },
/* 445 */
/***/ function(module, exports, __webpack_require__) {

	// 26.1.8 Reflect.getPrototypeOf(target)
	var $export  = __webpack_require__(1)
	  , getProto = __webpack_require__(33)
	  , anObject = __webpack_require__(4);
	
	$export($export.S, 'Reflect', {
	  getPrototypeOf: function getPrototypeOf(target){
	    return getProto(anObject(target));
	  }
	});

/***/ },
/* 446 */
/***/ function(module, exports, __webpack_require__) {

	// 26.1.6 Reflect.get(target, propertyKey [, receiver])
	var gOPD           = __webpack_require__(32)
	  , getPrototypeOf = __webpack_require__(33)
	  , has            = __webpack_require__(19)
	  , $export        = __webpack_require__(1)
	  , isObject       = __webpack_require__(10)
	  , anObject       = __webpack_require__(4);
	
	function get(target, propertyKey/*, receiver*/){
	  var receiver = arguments.length < 3 ? target : arguments[2]
	    , desc, proto;
	  if(anObject(target) === receiver)return target[propertyKey];
	  if(desc = gOPD.f(target, propertyKey))return has(desc, 'value')
	    ? desc.value
	    : desc.get !== undefined
	      ? desc.get.call(receiver)
	      : undefined;
	  if(isObject(proto = getPrototypeOf(target)))return get(proto, propertyKey, receiver);
	}
	
	$export($export.S, 'Reflect', {get: get});

/***/ },
/* 447 */
/***/ function(module, exports, __webpack_require__) {

	// 26.1.9 Reflect.has(target, propertyKey)
	var $export = __webpack_require__(1);
	
	$export($export.S, 'Reflect', {
	  has: function has(target, propertyKey){
	    return propertyKey in target;
	  }
	});

/***/ },
/* 448 */
/***/ function(module, exports, __webpack_require__) {

	// 26.1.10 Reflect.isExtensible(target)
	var $export       = __webpack_require__(1)
	  , anObject      = __webpack_require__(4)
	  , $isExtensible = Object.isExtensible;
	
	$export($export.S, 'Reflect', {
	  isExtensible: function isExtensible(target){
	    anObject(target);
	    return $isExtensible ? $isExtensible(target) : true;
	  }
	});

/***/ },
/* 449 */
/***/ function(module, exports, __webpack_require__) {

	// 26.1.11 Reflect.ownKeys(target)
	var $export = __webpack_require__(1);
	
	$export($export.S, 'Reflect', {ownKeys: __webpack_require__(233)});

/***/ },
/* 450 */
/***/ function(module, exports, __webpack_require__) {

	// 26.1.12 Reflect.preventExtensions(target)
	var $export            = __webpack_require__(1)
	  , anObject           = __webpack_require__(4)
	  , $preventExtensions = Object.preventExtensions;
	
	$export($export.S, 'Reflect', {
	  preventExtensions: function preventExtensions(target){
	    anObject(target);
	    try {
	      if($preventExtensions)$preventExtensions(target);
	      return true;
	    } catch(e){
	      return false;
	    }
	  }
	});

/***/ },
/* 451 */
/***/ function(module, exports, __webpack_require__) {

	// 26.1.14 Reflect.setPrototypeOf(target, proto)
	var $export  = __webpack_require__(1)
	  , setProto = __webpack_require__(113);
	
	if(setProto)$export($export.S, 'Reflect', {
	  setPrototypeOf: function setPrototypeOf(target, proto){
	    setProto.check(target, proto);
	    try {
	      setProto.set(target, proto);
	      return true;
	    } catch(e){
	      return false;
	    }
	  }
	});

/***/ },
/* 452 */
/***/ function(module, exports, __webpack_require__) {

	// 26.1.13 Reflect.set(target, propertyKey, V [, receiver])
	var dP             = __webpack_require__(14)
	  , gOPD           = __webpack_require__(32)
	  , getPrototypeOf = __webpack_require__(33)
	  , has            = __webpack_require__(19)
	  , $export        = __webpack_require__(1)
	  , createDesc     = __webpack_require__(57)
	  , anObject       = __webpack_require__(4)
	  , isObject       = __webpack_require__(10);
	
	function set(target, propertyKey, V/*, receiver*/){
	  var receiver = arguments.length < 4 ? target : arguments[3]
	    , ownDesc  = gOPD.f(anObject(target), propertyKey)
	    , existingDescriptor, proto;
	  if(!ownDesc){
	    if(isObject(proto = getPrototypeOf(target))){
	      return set(proto, propertyKey, V, receiver);
	    }
	    ownDesc = createDesc(0);
	  }
	  if(has(ownDesc, 'value')){
	    if(ownDesc.writable === false || !isObject(receiver))return false;
	    existingDescriptor = gOPD.f(receiver, propertyKey) || createDesc(0);
	    existingDescriptor.value = V;
	    dP.f(receiver, propertyKey, existingDescriptor);
	    return true;
	  }
	  return ownDesc.set === undefined ? false : (ownDesc.set.call(receiver, V), true);
	}
	
	$export($export.S, 'Reflect', {set: set});

/***/ },
/* 453 */
/***/ function(module, exports, __webpack_require__) {

	var global            = __webpack_require__(7)
	  , inheritIfRequired = __webpack_require__(151)
	  , dP                = __webpack_require__(14).f
	  , gOPN              = __webpack_require__(67).f
	  , isRegExp          = __webpack_require__(109)
	  , $flags            = __webpack_require__(107)
	  , $RegExp           = global.RegExp
	  , Base              = $RegExp
	  , proto             = $RegExp.prototype
	  , re1               = /a/g
	  , re2               = /a/g
	  // "new" creates a new object, old webkit buggy here
	  , CORRECT_NEW       = new $RegExp(re1) !== re1;
	
	if(__webpack_require__(13) && (!CORRECT_NEW || __webpack_require__(8)(function(){
	  re2[__webpack_require__(11)('match')] = false;
	  // RegExp constructor can alter flags and IsRegExp works correct with @@match
	  return $RegExp(re1) != re1 || $RegExp(re2) == re2 || $RegExp(re1, 'i') != '/a/i';
	}))){
	  $RegExp = function RegExp(p, f){
	    var tiRE = this instanceof $RegExp
	      , piRE = isRegExp(p)
	      , fiU  = f === undefined;
	    return !tiRE && piRE && p.constructor === $RegExp && fiU ? p
	      : inheritIfRequired(CORRECT_NEW
	        ? new Base(piRE && !fiU ? p.source : p, f)
	        : Base((piRE = p instanceof $RegExp) ? p.source : p, piRE && fiU ? $flags.call(p) : f)
	      , tiRE ? this : proto, $RegExp);
	  };
	  var proxy = function(key){
	    key in $RegExp || dP($RegExp, key, {
	      configurable: true,
	      get: function(){ return Base[key]; },
	      set: function(it){ Base[key] = it; }
	    });
	  };
	  for(var keys = gOPN(Base), i = 0; keys.length > i; )proxy(keys[i++]);
	  proto.constructor = $RegExp;
	  $RegExp.prototype = proto;
	  __webpack_require__(27)(global, 'RegExp', $RegExp);
	}
	
	__webpack_require__(70)('RegExp');

/***/ },
/* 454 */
/***/ function(module, exports, __webpack_require__) {

	// @@match logic
	__webpack_require__(106)('match', 1, function(defined, MATCH, $match){
	  // 21.1.3.11 String.prototype.match(regexp)
	  return [function match(regexp){
	    'use strict';
	    var O  = defined(this)
	      , fn = regexp == undefined ? undefined : regexp[MATCH];
	    return fn !== undefined ? fn.call(regexp, O) : new RegExp(regexp)[MATCH](String(O));
	  }, $match];
	});

/***/ },
/* 455 */
/***/ function(module, exports, __webpack_require__) {

	// @@replace logic
	__webpack_require__(106)('replace', 2, function(defined, REPLACE, $replace){
	  // 21.1.3.14 String.prototype.replace(searchValue, replaceValue)
	  return [function replace(searchValue, replaceValue){
	    'use strict';
	    var O  = defined(this)
	      , fn = searchValue == undefined ? undefined : searchValue[REPLACE];
	    return fn !== undefined
	      ? fn.call(searchValue, O, replaceValue)
	      : $replace.call(String(O), searchValue, replaceValue);
	  }, $replace];
	});

/***/ },
/* 456 */
/***/ function(module, exports, __webpack_require__) {

	// @@search logic
	__webpack_require__(106)('search', 1, function(defined, SEARCH, $search){
	  // 21.1.3.15 String.prototype.search(regexp)
	  return [function search(regexp){
	    'use strict';
	    var O  = defined(this)
	      , fn = regexp == undefined ? undefined : regexp[SEARCH];
	    return fn !== undefined ? fn.call(regexp, O) : new RegExp(regexp)[SEARCH](String(O));
	  }, $search];
	});

/***/ },
/* 457 */
/***/ function(module, exports, __webpack_require__) {

	// @@split logic
	__webpack_require__(106)('split', 2, function(defined, SPLIT, $split){
	  'use strict';
	  var isRegExp   = __webpack_require__(109)
	    , _split     = $split
	    , $push      = [].push
	    , $SPLIT     = 'split'
	    , LENGTH     = 'length'
	    , LAST_INDEX = 'lastIndex';
	  if(
	    'abbc'[$SPLIT](/(b)*/)[1] == 'c' ||
	    'test'[$SPLIT](/(?:)/, -1)[LENGTH] != 4 ||
	    'ab'[$SPLIT](/(?:ab)*/)[LENGTH] != 2 ||
	    '.'[$SPLIT](/(.?)(.?)/)[LENGTH] != 4 ||
	    '.'[$SPLIT](/()()/)[LENGTH] > 1 ||
	    ''[$SPLIT](/.?/)[LENGTH]
	  ){
	    var NPCG = /()??/.exec('')[1] === undefined; // nonparticipating capturing group
	    // based on es5-shim implementation, need to rework it
	    $split = function(separator, limit){
	      var string = String(this);
	      if(separator === undefined && limit === 0)return [];
	      // If `separator` is not a regex, use native split
	      if(!isRegExp(separator))return _split.call(string, separator, limit);
	      var output = [];
	      var flags = (separator.ignoreCase ? 'i' : '') +
	                  (separator.multiline ? 'm' : '') +
	                  (separator.unicode ? 'u' : '') +
	                  (separator.sticky ? 'y' : '');
	      var lastLastIndex = 0;
	      var splitLimit = limit === undefined ? 4294967295 : limit >>> 0;
	      // Make `global` and avoid `lastIndex` issues by working with a copy
	      var separatorCopy = new RegExp(separator.source, flags + 'g');
	      var separator2, match, lastIndex, lastLength, i;
	      // Doesn't need flags gy, but they don't hurt
	      if(!NPCG)separator2 = new RegExp('^' + separatorCopy.source + '$(?!\\s)', flags);
	      while(match = separatorCopy.exec(string)){
	        // `separatorCopy.lastIndex` is not reliable cross-browser
	        lastIndex = match.index + match[0][LENGTH];
	        if(lastIndex > lastLastIndex){
	          output.push(string.slice(lastLastIndex, match.index));
	          // Fix browsers whose `exec` methods don't consistently return `undefined` for NPCG
	          if(!NPCG && match[LENGTH] > 1)match[0].replace(separator2, function(){
	            for(i = 1; i < arguments[LENGTH] - 2; i++)if(arguments[i] === undefined)match[i] = undefined;
	          });
	          if(match[LENGTH] > 1 && match.index < string[LENGTH])$push.apply(output, match.slice(1));
	          lastLength = match[0][LENGTH];
	          lastLastIndex = lastIndex;
	          if(output[LENGTH] >= splitLimit)break;
	        }
	        if(separatorCopy[LAST_INDEX] === match.index)separatorCopy[LAST_INDEX]++; // Avoid an infinite loop
	      }
	      if(lastLastIndex === string[LENGTH]){
	        if(lastLength || !separatorCopy.test(''))output.push('');
	      } else output.push(string.slice(lastLastIndex));
	      return output[LENGTH] > splitLimit ? output.slice(0, splitLimit) : output;
	    };
	  // Chakra, V8
	  } else if('0'[$SPLIT](undefined, 0)[LENGTH]){
	    $split = function(separator, limit){
	      return separator === undefined && limit === 0 ? [] : _split.call(this, separator, limit);
	    };
	  }
	  // 21.1.3.17 String.prototype.split(separator, limit)
	  return [function split(separator, limit){
	    var O  = defined(this)
	      , fn = separator == undefined ? undefined : separator[SPLIT];
	    return fn !== undefined ? fn.call(separator, O, limit) : $split.call(String(O), separator, limit);
	  }, $split];
	});

/***/ },
/* 458 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	__webpack_require__(240);
	var anObject    = __webpack_require__(4)
	  , $flags      = __webpack_require__(107)
	  , DESCRIPTORS = __webpack_require__(13)
	  , TO_STRING   = 'toString'
	  , $toString   = /./[TO_STRING];
	
	var define = function(fn){
	  __webpack_require__(27)(RegExp.prototype, TO_STRING, fn, true);
	};
	
	// 21.2.5.14 RegExp.prototype.toString()
	if(__webpack_require__(8)(function(){ return $toString.call({source: 'a', flags: 'b'}) != '/a/b'; })){
	  define(function toString(){
	    var R = anObject(this);
	    return '/'.concat(R.source, '/',
	      'flags' in R ? R.flags : !DESCRIPTORS && R instanceof RegExp ? $flags.call(R) : undefined);
	  });
	// FF44- RegExp#toString has a wrong name
	} else if($toString.name != TO_STRING){
	  define(function toString(){
	    return $toString.call(this);
	  });
	}

/***/ },
/* 459 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.2 String.prototype.anchor(name)
	__webpack_require__(28)('anchor', function(createHTML){
	  return function anchor(name){
	    return createHTML(this, 'a', 'name', name);
	  }
	});

/***/ },
/* 460 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.3 String.prototype.big()
	__webpack_require__(28)('big', function(createHTML){
	  return function big(){
	    return createHTML(this, 'big', '', '');
	  }
	});

/***/ },
/* 461 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.4 String.prototype.blink()
	__webpack_require__(28)('blink', function(createHTML){
	  return function blink(){
	    return createHTML(this, 'blink', '', '');
	  }
	});

/***/ },
/* 462 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.5 String.prototype.bold()
	__webpack_require__(28)('bold', function(createHTML){
	  return function bold(){
	    return createHTML(this, 'b', '', '');
	  }
	});

/***/ },
/* 463 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(1)
	  , $at     = __webpack_require__(162)(false);
	$export($export.P, 'String', {
	  // 21.1.3.3 String.prototype.codePointAt(pos)
	  codePointAt: function codePointAt(pos){
	    return $at(this, pos);
	  }
	});

/***/ },
/* 464 */
/***/ function(module, exports, __webpack_require__) {

	// 21.1.3.6 String.prototype.endsWith(searchString [, endPosition])
	'use strict';
	var $export   = __webpack_require__(1)
	  , toLength  = __webpack_require__(16)
	  , context   = __webpack_require__(163)
	  , ENDS_WITH = 'endsWith'
	  , $endsWith = ''[ENDS_WITH];
	
	$export($export.P + $export.F * __webpack_require__(149)(ENDS_WITH), 'String', {
	  endsWith: function endsWith(searchString /*, endPosition = @length */){
	    var that = context(this, searchString, ENDS_WITH)
	      , endPosition = arguments.length > 1 ? arguments[1] : undefined
	      , len    = toLength(that.length)
	      , end    = endPosition === undefined ? len : Math.min(toLength(endPosition), len)
	      , search = String(searchString);
	    return $endsWith
	      ? $endsWith.call(that, search, end)
	      : that.slice(end - search.length, end) === search;
	  }
	});

/***/ },
/* 465 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.6 String.prototype.fixed()
	__webpack_require__(28)('fixed', function(createHTML){
	  return function fixed(){
	    return createHTML(this, 'tt', '', '');
	  }
	});

/***/ },
/* 466 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.7 String.prototype.fontcolor(color)
	__webpack_require__(28)('fontcolor', function(createHTML){
	  return function fontcolor(color){
	    return createHTML(this, 'font', 'color', color);
	  }
	});

/***/ },
/* 467 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.8 String.prototype.fontsize(size)
	__webpack_require__(28)('fontsize', function(createHTML){
	  return function fontsize(size){
	    return createHTML(this, 'font', 'size', size);
	  }
	});

/***/ },
/* 468 */
/***/ function(module, exports, __webpack_require__) {

	var $export        = __webpack_require__(1)
	  , toIndex        = __webpack_require__(71)
	  , fromCharCode   = String.fromCharCode
	  , $fromCodePoint = String.fromCodePoint;
	
	// length should be 1, old FF problem
	$export($export.S + $export.F * (!!$fromCodePoint && $fromCodePoint.length != 1), 'String', {
	  // 21.1.2.2 String.fromCodePoint(...codePoints)
	  fromCodePoint: function fromCodePoint(x){ // eslint-disable-line no-unused-vars
	    var res  = []
	      , aLen = arguments.length
	      , i    = 0
	      , code;
	    while(aLen > i){
	      code = +arguments[i++];
	      if(toIndex(code, 0x10ffff) !== code)throw RangeError(code + ' is not a valid code point');
	      res.push(code < 0x10000
	        ? fromCharCode(code)
	        : fromCharCode(((code -= 0x10000) >> 10) + 0xd800, code % 0x400 + 0xdc00)
	      );
	    } return res.join('');
	  }
	});

/***/ },
/* 469 */
/***/ function(module, exports, __webpack_require__) {

	// 21.1.3.7 String.prototype.includes(searchString, position = 0)
	'use strict';
	var $export  = __webpack_require__(1)
	  , context  = __webpack_require__(163)
	  , INCLUDES = 'includes';
	
	$export($export.P + $export.F * __webpack_require__(149)(INCLUDES), 'String', {
	  includes: function includes(searchString /*, position = 0 */){
	    return !!~context(this, searchString, INCLUDES)
	      .indexOf(searchString, arguments.length > 1 ? arguments[1] : undefined);
	  }
	});

/***/ },
/* 470 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.9 String.prototype.italics()
	__webpack_require__(28)('italics', function(createHTML){
	  return function italics(){
	    return createHTML(this, 'i', '', '');
	  }
	});

/***/ },
/* 471 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $at  = __webpack_require__(162)(true);
	
	// 21.1.3.27 String.prototype[@@iterator]()
	__webpack_require__(156)(String, 'String', function(iterated){
	  this._t = String(iterated); // target
	  this._i = 0;                // next index
	// 21.1.5.2.1 %StringIteratorPrototype%.next()
	}, function(){
	  var O     = this._t
	    , index = this._i
	    , point;
	  if(index >= O.length)return {value: undefined, done: true};
	  point = $at(O, index);
	  this._i += point.length;
	  return {value: point, done: false};
	});

/***/ },
/* 472 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.10 String.prototype.link(url)
	__webpack_require__(28)('link', function(createHTML){
	  return function link(url){
	    return createHTML(this, 'a', 'href', url);
	  }
	});

/***/ },
/* 473 */
/***/ function(module, exports, __webpack_require__) {

	var $export   = __webpack_require__(1)
	  , toIObject = __webpack_require__(29)
	  , toLength  = __webpack_require__(16);
	
	$export($export.S, 'String', {
	  // 21.1.2.4 String.raw(callSite, ...substitutions)
	  raw: function raw(callSite){
	    var tpl  = toIObject(callSite.raw)
	      , len  = toLength(tpl.length)
	      , aLen = arguments.length
	      , res  = []
	      , i    = 0;
	    while(len > i){
	      res.push(String(tpl[i++]));
	      if(i < aLen)res.push(String(arguments[i]));
	    } return res.join('');
	  }
	});

/***/ },
/* 474 */
/***/ function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(1);
	
	$export($export.P, 'String', {
	  // 21.1.3.13 String.prototype.repeat(count)
	  repeat: __webpack_require__(164)
	});

/***/ },
/* 475 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.11 String.prototype.small()
	__webpack_require__(28)('small', function(createHTML){
	  return function small(){
	    return createHTML(this, 'small', '', '');
	  }
	});

/***/ },
/* 476 */
/***/ function(module, exports, __webpack_require__) {

	// 21.1.3.18 String.prototype.startsWith(searchString [, position ])
	'use strict';
	var $export     = __webpack_require__(1)
	  , toLength    = __webpack_require__(16)
	  , context     = __webpack_require__(163)
	  , STARTS_WITH = 'startsWith'
	  , $startsWith = ''[STARTS_WITH];
	
	$export($export.P + $export.F * __webpack_require__(149)(STARTS_WITH), 'String', {
	  startsWith: function startsWith(searchString /*, position = 0 */){
	    var that   = context(this, searchString, STARTS_WITH)
	      , index  = toLength(Math.min(arguments.length > 1 ? arguments[1] : undefined, that.length))
	      , search = String(searchString);
	    return $startsWith
	      ? $startsWith.call(that, search, index)
	      : that.slice(index, index + search.length) === search;
	  }
	});

/***/ },
/* 477 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.12 String.prototype.strike()
	__webpack_require__(28)('strike', function(createHTML){
	  return function strike(){
	    return createHTML(this, 'strike', '', '');
	  }
	});

/***/ },
/* 478 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.13 String.prototype.sub()
	__webpack_require__(28)('sub', function(createHTML){
	  return function sub(){
	    return createHTML(this, 'sub', '', '');
	  }
	});

/***/ },
/* 479 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.14 String.prototype.sup()
	__webpack_require__(28)('sup', function(createHTML){
	  return function sup(){
	    return createHTML(this, 'sup', '', '');
	  }
	});

/***/ },
/* 480 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// 21.1.3.25 String.prototype.trim()
	__webpack_require__(81)('trim', function($trim){
	  return function trim(){
	    return $trim(this, 3);
	  };
	});

/***/ },
/* 481 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// ECMAScript 6 symbols shim
	var global         = __webpack_require__(7)
	  , has            = __webpack_require__(19)
	  , DESCRIPTORS    = __webpack_require__(13)
	  , $export        = __webpack_require__(1)
	  , redefine       = __webpack_require__(27)
	  , META           = __webpack_require__(56).KEY
	  , $fails         = __webpack_require__(8)
	  , shared         = __webpack_require__(114)
	  , setToStringTag = __webpack_require__(80)
	  , uid            = __webpack_require__(72)
	  , wks            = __webpack_require__(11)
	  , wksExt         = __webpack_require__(238)
	  , wksDefine      = __webpack_require__(168)
	  , keyOf          = __webpack_require__(356)
	  , enumKeys       = __webpack_require__(355)
	  , isArray        = __webpack_require__(153)
	  , anObject       = __webpack_require__(4)
	  , toIObject      = __webpack_require__(29)
	  , toPrimitive    = __webpack_require__(44)
	  , createDesc     = __webpack_require__(57)
	  , _create        = __webpack_require__(66)
	  , gOPNExt        = __webpack_require__(230)
	  , $GOPD          = __webpack_require__(32)
	  , $DP            = __webpack_require__(14)
	  , $keys          = __webpack_require__(68)
	  , gOPD           = $GOPD.f
	  , dP             = $DP.f
	  , gOPN           = gOPNExt.f
	  , $Symbol        = global.Symbol
	  , $JSON          = global.JSON
	  , _stringify     = $JSON && $JSON.stringify
	  , PROTOTYPE      = 'prototype'
	  , HIDDEN         = wks('_hidden')
	  , TO_PRIMITIVE   = wks('toPrimitive')
	  , isEnum         = {}.propertyIsEnumerable
	  , SymbolRegistry = shared('symbol-registry')
	  , AllSymbols     = shared('symbols')
	  , OPSymbols      = shared('op-symbols')
	  , ObjectProto    = Object[PROTOTYPE]
	  , USE_NATIVE     = typeof $Symbol == 'function'
	  , QObject        = global.QObject;
	// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
	var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;
	
	// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
	var setSymbolDesc = DESCRIPTORS && $fails(function(){
	  return _create(dP({}, 'a', {
	    get: function(){ return dP(this, 'a', {value: 7}).a; }
	  })).a != 7;
	}) ? function(it, key, D){
	  var protoDesc = gOPD(ObjectProto, key);
	  if(protoDesc)delete ObjectProto[key];
	  dP(it, key, D);
	  if(protoDesc && it !== ObjectProto)dP(ObjectProto, key, protoDesc);
	} : dP;
	
	var wrap = function(tag){
	  var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
	  sym._k = tag;
	  return sym;
	};
	
	var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function(it){
	  return typeof it == 'symbol';
	} : function(it){
	  return it instanceof $Symbol;
	};
	
	var $defineProperty = function defineProperty(it, key, D){
	  if(it === ObjectProto)$defineProperty(OPSymbols, key, D);
	  anObject(it);
	  key = toPrimitive(key, true);
	  anObject(D);
	  if(has(AllSymbols, key)){
	    if(!D.enumerable){
	      if(!has(it, HIDDEN))dP(it, HIDDEN, createDesc(1, {}));
	      it[HIDDEN][key] = true;
	    } else {
	      if(has(it, HIDDEN) && it[HIDDEN][key])it[HIDDEN][key] = false;
	      D = _create(D, {enumerable: createDesc(0, false)});
	    } return setSymbolDesc(it, key, D);
	  } return dP(it, key, D);
	};
	var $defineProperties = function defineProperties(it, P){
	  anObject(it);
	  var keys = enumKeys(P = toIObject(P))
	    , i    = 0
	    , l = keys.length
	    , key;
	  while(l > i)$defineProperty(it, key = keys[i++], P[key]);
	  return it;
	};
	var $create = function create(it, P){
	  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
	};
	var $propertyIsEnumerable = function propertyIsEnumerable(key){
	  var E = isEnum.call(this, key = toPrimitive(key, true));
	  if(this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key))return false;
	  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
	};
	var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key){
	  it  = toIObject(it);
	  key = toPrimitive(key, true);
	  if(it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key))return;
	  var D = gOPD(it, key);
	  if(D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key]))D.enumerable = true;
	  return D;
	};
	var $getOwnPropertyNames = function getOwnPropertyNames(it){
	  var names  = gOPN(toIObject(it))
	    , result = []
	    , i      = 0
	    , key;
	  while(names.length > i){
	    if(!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META)result.push(key);
	  } return result;
	};
	var $getOwnPropertySymbols = function getOwnPropertySymbols(it){
	  var IS_OP  = it === ObjectProto
	    , names  = gOPN(IS_OP ? OPSymbols : toIObject(it))
	    , result = []
	    , i      = 0
	    , key;
	  while(names.length > i){
	    if(has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true))result.push(AllSymbols[key]);
	  } return result;
	};
	
	// 19.4.1.1 Symbol([description])
	if(!USE_NATIVE){
	  $Symbol = function Symbol(){
	    if(this instanceof $Symbol)throw TypeError('Symbol is not a constructor!');
	    var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
	    var $set = function(value){
	      if(this === ObjectProto)$set.call(OPSymbols, value);
	      if(has(this, HIDDEN) && has(this[HIDDEN], tag))this[HIDDEN][tag] = false;
	      setSymbolDesc(this, tag, createDesc(1, value));
	    };
	    if(DESCRIPTORS && setter)setSymbolDesc(ObjectProto, tag, {configurable: true, set: $set});
	    return wrap(tag);
	  };
	  redefine($Symbol[PROTOTYPE], 'toString', function toString(){
	    return this._k;
	  });
	
	  $GOPD.f = $getOwnPropertyDescriptor;
	  $DP.f   = $defineProperty;
	  __webpack_require__(67).f = gOPNExt.f = $getOwnPropertyNames;
	  __webpack_require__(93).f  = $propertyIsEnumerable;
	  __webpack_require__(112).f = $getOwnPropertySymbols;
	
	  if(DESCRIPTORS && !__webpack_require__(65)){
	    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
	  }
	
	  wksExt.f = function(name){
	    return wrap(wks(name));
	  }
	}
	
	$export($export.G + $export.W + $export.F * !USE_NATIVE, {Symbol: $Symbol});
	
	for(var symbols = (
	  // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
	  'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'
	).split(','), i = 0; symbols.length > i; )wks(symbols[i++]);
	
	for(var symbols = $keys(wks.store), i = 0; symbols.length > i; )wksDefine(symbols[i++]);
	
	$export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
	  // 19.4.2.1 Symbol.for(key)
	  'for': function(key){
	    return has(SymbolRegistry, key += '')
	      ? SymbolRegistry[key]
	      : SymbolRegistry[key] = $Symbol(key);
	  },
	  // 19.4.2.5 Symbol.keyFor(sym)
	  keyFor: function keyFor(key){
	    if(isSymbol(key))return keyOf(SymbolRegistry, key);
	    throw TypeError(key + ' is not a symbol!');
	  },
	  useSetter: function(){ setter = true; },
	  useSimple: function(){ setter = false; }
	});
	
	$export($export.S + $export.F * !USE_NATIVE, 'Object', {
	  // 19.1.2.2 Object.create(O [, Properties])
	  create: $create,
	  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
	  defineProperty: $defineProperty,
	  // 19.1.2.3 Object.defineProperties(O, Properties)
	  defineProperties: $defineProperties,
	  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
	  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
	  // 19.1.2.7 Object.getOwnPropertyNames(O)
	  getOwnPropertyNames: $getOwnPropertyNames,
	  // 19.1.2.8 Object.getOwnPropertySymbols(O)
	  getOwnPropertySymbols: $getOwnPropertySymbols
	});
	
	// 24.3.2 JSON.stringify(value [, replacer [, space]])
	$JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function(){
	  var S = $Symbol();
	  // MS Edge converts symbol values to JSON as {}
	  // WebKit converts symbol values to JSON as null
	  // V8 throws on boxed symbols
	  return _stringify([S]) != '[null]' || _stringify({a: S}) != '{}' || _stringify(Object(S)) != '{}';
	})), 'JSON', {
	  stringify: function stringify(it){
	    if(it === undefined || isSymbol(it))return; // IE8 returns string on undefined
	    var args = [it]
	      , i    = 1
	      , replacer, $replacer;
	    while(arguments.length > i)args.push(arguments[i++]);
	    replacer = args[1];
	    if(typeof replacer == 'function')$replacer = replacer;
	    if($replacer || !isArray(replacer))replacer = function(key, value){
	      if($replacer)value = $replacer.call(this, key, value);
	      if(!isSymbol(value))return value;
	    };
	    args[1] = replacer;
	    return _stringify.apply($JSON, args);
	  }
	});
	
	// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
	$Symbol[PROTOTYPE][TO_PRIMITIVE] || __webpack_require__(21)($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
	// 19.4.3.5 Symbol.prototype[@@toStringTag]
	setToStringTag($Symbol, 'Symbol');
	// 20.2.1.9 Math[@@toStringTag]
	setToStringTag(Math, 'Math', true);
	// 24.3.3 JSON[@@toStringTag]
	setToStringTag(global.JSON, 'JSON', true);

/***/ },
/* 482 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export      = __webpack_require__(1)
	  , $typed       = __webpack_require__(115)
	  , buffer       = __webpack_require__(167)
	  , anObject     = __webpack_require__(4)
	  , toIndex      = __webpack_require__(71)
	  , toLength     = __webpack_require__(16)
	  , isObject     = __webpack_require__(10)
	  , TYPED_ARRAY  = __webpack_require__(11)('typed_array')
	  , ArrayBuffer  = __webpack_require__(7).ArrayBuffer
	  , speciesConstructor = __webpack_require__(161)
	  , $ArrayBuffer = buffer.ArrayBuffer
	  , $DataView    = buffer.DataView
	  , $isView      = $typed.ABV && ArrayBuffer.isView
	  , $slice       = $ArrayBuffer.prototype.slice
	  , VIEW         = $typed.VIEW
	  , ARRAY_BUFFER = 'ArrayBuffer';
	
	$export($export.G + $export.W + $export.F * (ArrayBuffer !== $ArrayBuffer), {ArrayBuffer: $ArrayBuffer});
	
	$export($export.S + $export.F * !$typed.CONSTR, ARRAY_BUFFER, {
	  // 24.1.3.1 ArrayBuffer.isView(arg)
	  isView: function isView(it){
	    return $isView && $isView(it) || isObject(it) && VIEW in it;
	  }
	});
	
	$export($export.P + $export.U + $export.F * __webpack_require__(8)(function(){
	  return !new $ArrayBuffer(2).slice(1, undefined).byteLength;
	}), ARRAY_BUFFER, {
	  // 24.1.4.3 ArrayBuffer.prototype.slice(start, end)
	  slice: function slice(start, end){
	    if($slice !== undefined && end === undefined)return $slice.call(anObject(this), start); // FF fix
	    var len    = anObject(this).byteLength
	      , first  = toIndex(start, len)
	      , final  = toIndex(end === undefined ? len : end, len)
	      , result = new (speciesConstructor(this, $ArrayBuffer))(toLength(final - first))
	      , viewS  = new $DataView(this)
	      , viewT  = new $DataView(result)
	      , index  = 0;
	    while(first < final){
	      viewT.setUint8(index++, viewS.getUint8(first++));
	    } return result;
	  }
	});
	
	__webpack_require__(70)(ARRAY_BUFFER);

/***/ },
/* 483 */
/***/ function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(1);
	$export($export.G + $export.W + $export.F * !__webpack_require__(115).ABV, {
	  DataView: __webpack_require__(167).DataView
	});

/***/ },
/* 484 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(49)('Float32', 4, function(init){
	  return function Float32Array(data, byteOffset, length){
	    return init(this, data, byteOffset, length);
	  };
	});

/***/ },
/* 485 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(49)('Float64', 8, function(init){
	  return function Float64Array(data, byteOffset, length){
	    return init(this, data, byteOffset, length);
	  };
	});

/***/ },
/* 486 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(49)('Int16', 2, function(init){
	  return function Int16Array(data, byteOffset, length){
	    return init(this, data, byteOffset, length);
	  };
	});

/***/ },
/* 487 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(49)('Int32', 4, function(init){
	  return function Int32Array(data, byteOffset, length){
	    return init(this, data, byteOffset, length);
	  };
	});

/***/ },
/* 488 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(49)('Int8', 1, function(init){
	  return function Int8Array(data, byteOffset, length){
	    return init(this, data, byteOffset, length);
	  };
	});

/***/ },
/* 489 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(49)('Uint16', 2, function(init){
	  return function Uint16Array(data, byteOffset, length){
	    return init(this, data, byteOffset, length);
	  };
	});

/***/ },
/* 490 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(49)('Uint32', 4, function(init){
	  return function Uint32Array(data, byteOffset, length){
	    return init(this, data, byteOffset, length);
	  };
	});

/***/ },
/* 491 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(49)('Uint8', 1, function(init){
	  return function Uint8Array(data, byteOffset, length){
	    return init(this, data, byteOffset, length);
	  };
	});

/***/ },
/* 492 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(49)('Uint8', 1, function(init){
	  return function Uint8ClampedArray(data, byteOffset, length){
	    return init(this, data, byteOffset, length);
	  };
	}, true);

/***/ },
/* 493 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var weak = __webpack_require__(223);
	
	// 23.4 WeakSet Objects
	__webpack_require__(105)('WeakSet', function(get){
	  return function WeakSet(){ return get(this, arguments.length > 0 ? arguments[0] : undefined); };
	}, {
	  // 23.4.3.1 WeakSet.prototype.add(value)
	  add: function add(value){
	    return weak.def(this, value, true);
	  }
	}, weak, false, true);

/***/ },
/* 494 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/tc39/Array.prototype.includes
	var $export   = __webpack_require__(1)
	  , $includes = __webpack_require__(104)(true);
	
	$export($export.P, 'Array', {
	  includes: function includes(el /*, fromIndex = 0 */){
	    return $includes(this, el, arguments.length > 1 ? arguments[1] : undefined);
	  }
	});
	
	__webpack_require__(77)('includes');

/***/ },
/* 495 */
/***/ function(module, exports, __webpack_require__) {

	// https://github.com/rwaldron/tc39-notes/blob/master/es6/2014-09/sept-25.md#510-globalasap-for-enqueuing-a-microtask
	var $export   = __webpack_require__(1)
	  , microtask = __webpack_require__(159)()
	  , process   = __webpack_require__(7).process
	  , isNode    = __webpack_require__(34)(process) == 'process';
	
	$export($export.G, {
	  asap: function asap(fn){
	    var domain = isNode && process.domain;
	    microtask(domain ? domain.bind(fn) : fn);
	  }
	});

/***/ },
/* 496 */
/***/ function(module, exports, __webpack_require__) {

	// https://github.com/ljharb/proposal-is-error
	var $export = __webpack_require__(1)
	  , cof     = __webpack_require__(34);
	
	$export($export.S, 'Error', {
	  isError: function isError(it){
	    return cof(it) === 'Error';
	  }
	});

/***/ },
/* 497 */
/***/ function(module, exports, __webpack_require__) {

	// https://github.com/DavidBruant/Map-Set.prototype.toJSON
	var $export  = __webpack_require__(1);
	
	$export($export.P + $export.R, 'Map', {toJSON: __webpack_require__(222)('Map')});

/***/ },
/* 498 */
/***/ function(module, exports, __webpack_require__) {

	// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
	var $export = __webpack_require__(1);
	
	$export($export.S, 'Math', {
	  iaddh: function iaddh(x0, x1, y0, y1){
	    var $x0 = x0 >>> 0
	      , $x1 = x1 >>> 0
	      , $y0 = y0 >>> 0;
	    return $x1 + (y1 >>> 0) + (($x0 & $y0 | ($x0 | $y0) & ~($x0 + $y0 >>> 0)) >>> 31) | 0;
	  }
	});

/***/ },
/* 499 */
/***/ function(module, exports, __webpack_require__) {

	// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
	var $export = __webpack_require__(1);
	
	$export($export.S, 'Math', {
	  imulh: function imulh(u, v){
	    var UINT16 = 0xffff
	      , $u = +u
	      , $v = +v
	      , u0 = $u & UINT16
	      , v0 = $v & UINT16
	      , u1 = $u >> 16
	      , v1 = $v >> 16
	      , t  = (u1 * v0 >>> 0) + (u0 * v0 >>> 16);
	    return u1 * v1 + (t >> 16) + ((u0 * v1 >>> 0) + (t & UINT16) >> 16);
	  }
	});

/***/ },
/* 500 */
/***/ function(module, exports, __webpack_require__) {

	// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
	var $export = __webpack_require__(1);
	
	$export($export.S, 'Math', {
	  isubh: function isubh(x0, x1, y0, y1){
	    var $x0 = x0 >>> 0
	      , $x1 = x1 >>> 0
	      , $y0 = y0 >>> 0;
	    return $x1 - (y1 >>> 0) - ((~$x0 & $y0 | ~($x0 ^ $y0) & $x0 - $y0 >>> 0) >>> 31) | 0;
	  }
	});

/***/ },
/* 501 */
/***/ function(module, exports, __webpack_require__) {

	// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
	var $export = __webpack_require__(1);
	
	$export($export.S, 'Math', {
	  umulh: function umulh(u, v){
	    var UINT16 = 0xffff
	      , $u = +u
	      , $v = +v
	      , u0 = $u & UINT16
	      , v0 = $v & UINT16
	      , u1 = $u >>> 16
	      , v1 = $v >>> 16
	      , t  = (u1 * v0 >>> 0) + (u0 * v0 >>> 16);
	    return u1 * v1 + (t >>> 16) + ((u0 * v1 >>> 0) + (t & UINT16) >>> 16);
	  }
	});

/***/ },
/* 502 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export         = __webpack_require__(1)
	  , toObject        = __webpack_require__(18)
	  , aFunction       = __webpack_require__(26)
	  , $defineProperty = __webpack_require__(14);
	
	// B.2.2.2 Object.prototype.__defineGetter__(P, getter)
	__webpack_require__(13) && $export($export.P + __webpack_require__(111), 'Object', {
	  __defineGetter__: function __defineGetter__(P, getter){
	    $defineProperty.f(toObject(this), P, {get: aFunction(getter), enumerable: true, configurable: true});
	  }
	});

/***/ },
/* 503 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export         = __webpack_require__(1)
	  , toObject        = __webpack_require__(18)
	  , aFunction       = __webpack_require__(26)
	  , $defineProperty = __webpack_require__(14);
	
	// B.2.2.3 Object.prototype.__defineSetter__(P, setter)
	__webpack_require__(13) && $export($export.P + __webpack_require__(111), 'Object', {
	  __defineSetter__: function __defineSetter__(P, setter){
	    $defineProperty.f(toObject(this), P, {set: aFunction(setter), enumerable: true, configurable: true});
	  }
	});

/***/ },
/* 504 */
/***/ function(module, exports, __webpack_require__) {

	// https://github.com/tc39/proposal-object-values-entries
	var $export  = __webpack_require__(1)
	  , $entries = __webpack_require__(232)(true);
	
	$export($export.S, 'Object', {
	  entries: function entries(it){
	    return $entries(it);
	  }
	});

/***/ },
/* 505 */
/***/ function(module, exports, __webpack_require__) {

	// https://github.com/tc39/proposal-object-getownpropertydescriptors
	var $export        = __webpack_require__(1)
	  , ownKeys        = __webpack_require__(233)
	  , toIObject      = __webpack_require__(29)
	  , gOPD           = __webpack_require__(32)
	  , createProperty = __webpack_require__(146);
	
	$export($export.S, 'Object', {
	  getOwnPropertyDescriptors: function getOwnPropertyDescriptors(object){
	    var O       = toIObject(object)
	      , getDesc = gOPD.f
	      , keys    = ownKeys(O)
	      , result  = {}
	      , i       = 0
	      , key, D;
	    while(keys.length > i)createProperty(result, key = keys[i++], getDesc(O, key));
	    return result;
	  }
	});

/***/ },
/* 506 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export                  = __webpack_require__(1)
	  , toObject                 = __webpack_require__(18)
	  , toPrimitive              = __webpack_require__(44)
	  , getPrototypeOf           = __webpack_require__(33)
	  , getOwnPropertyDescriptor = __webpack_require__(32).f;
	
	// B.2.2.4 Object.prototype.__lookupGetter__(P)
	__webpack_require__(13) && $export($export.P + __webpack_require__(111), 'Object', {
	  __lookupGetter__: function __lookupGetter__(P){
	    var O = toObject(this)
	      , K = toPrimitive(P, true)
	      , D;
	    do {
	      if(D = getOwnPropertyDescriptor(O, K))return D.get;
	    } while(O = getPrototypeOf(O));
	  }
	});

/***/ },
/* 507 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export                  = __webpack_require__(1)
	  , toObject                 = __webpack_require__(18)
	  , toPrimitive              = __webpack_require__(44)
	  , getPrototypeOf           = __webpack_require__(33)
	  , getOwnPropertyDescriptor = __webpack_require__(32).f;
	
	// B.2.2.5 Object.prototype.__lookupSetter__(P)
	__webpack_require__(13) && $export($export.P + __webpack_require__(111), 'Object', {
	  __lookupSetter__: function __lookupSetter__(P){
	    var O = toObject(this)
	      , K = toPrimitive(P, true)
	      , D;
	    do {
	      if(D = getOwnPropertyDescriptor(O, K))return D.set;
	    } while(O = getPrototypeOf(O));
	  }
	});

/***/ },
/* 508 */
/***/ function(module, exports, __webpack_require__) {

	// https://github.com/tc39/proposal-object-values-entries
	var $export = __webpack_require__(1)
	  , $values = __webpack_require__(232)(false);
	
	$export($export.S, 'Object', {
	  values: function values(it){
	    return $values(it);
	  }
	});

/***/ },
/* 509 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/zenparsing/es-observable
	var $export     = __webpack_require__(1)
	  , global      = __webpack_require__(7)
	  , core        = __webpack_require__(42)
	  , microtask   = __webpack_require__(159)()
	  , OBSERVABLE  = __webpack_require__(11)('observable')
	  , aFunction   = __webpack_require__(26)
	  , anObject    = __webpack_require__(4)
	  , anInstance  = __webpack_require__(55)
	  , redefineAll = __webpack_require__(69)
	  , hide        = __webpack_require__(21)
	  , forOf       = __webpack_require__(79)
	  , RETURN      = forOf.RETURN;
	
	var getMethod = function(fn){
	  return fn == null ? undefined : aFunction(fn);
	};
	
	var cleanupSubscription = function(subscription){
	  var cleanup = subscription._c;
	  if(cleanup){
	    subscription._c = undefined;
	    cleanup();
	  }
	};
	
	var subscriptionClosed = function(subscription){
	  return subscription._o === undefined;
	};
	
	var closeSubscription = function(subscription){
	  if(!subscriptionClosed(subscription)){
	    subscription._o = undefined;
	    cleanupSubscription(subscription);
	  }
	};
	
	var Subscription = function(observer, subscriber){
	  anObject(observer);
	  this._c = undefined;
	  this._o = observer;
	  observer = new SubscriptionObserver(this);
	  try {
	    var cleanup      = subscriber(observer)
	      , subscription = cleanup;
	    if(cleanup != null){
	      if(typeof cleanup.unsubscribe === 'function')cleanup = function(){ subscription.unsubscribe(); };
	      else aFunction(cleanup);
	      this._c = cleanup;
	    }
	  } catch(e){
	    observer.error(e);
	    return;
	  } if(subscriptionClosed(this))cleanupSubscription(this);
	};
	
	Subscription.prototype = redefineAll({}, {
	  unsubscribe: function unsubscribe(){ closeSubscription(this); }
	});
	
	var SubscriptionObserver = function(subscription){
	  this._s = subscription;
	};
	
	SubscriptionObserver.prototype = redefineAll({}, {
	  next: function next(value){
	    var subscription = this._s;
	    if(!subscriptionClosed(subscription)){
	      var observer = subscription._o;
	      try {
	        var m = getMethod(observer.next);
	        if(m)return m.call(observer, value);
	      } catch(e){
	        try {
	          closeSubscription(subscription);
	        } finally {
	          throw e;
	        }
	      }
	    }
	  },
	  error: function error(value){
	    var subscription = this._s;
	    if(subscriptionClosed(subscription))throw value;
	    var observer = subscription._o;
	    subscription._o = undefined;
	    try {
	      var m = getMethod(observer.error);
	      if(!m)throw value;
	      value = m.call(observer, value);
	    } catch(e){
	      try {
	        cleanupSubscription(subscription);
	      } finally {
	        throw e;
	      }
	    } cleanupSubscription(subscription);
	    return value;
	  },
	  complete: function complete(value){
	    var subscription = this._s;
	    if(!subscriptionClosed(subscription)){
	      var observer = subscription._o;
	      subscription._o = undefined;
	      try {
	        var m = getMethod(observer.complete);
	        value = m ? m.call(observer, value) : undefined;
	      } catch(e){
	        try {
	          cleanupSubscription(subscription);
	        } finally {
	          throw e;
	        }
	      } cleanupSubscription(subscription);
	      return value;
	    }
	  }
	});
	
	var $Observable = function Observable(subscriber){
	  anInstance(this, $Observable, 'Observable', '_f')._f = aFunction(subscriber);
	};
	
	redefineAll($Observable.prototype, {
	  subscribe: function subscribe(observer){
	    return new Subscription(observer, this._f);
	  },
	  forEach: function forEach(fn){
	    var that = this;
	    return new (core.Promise || global.Promise)(function(resolve, reject){
	      aFunction(fn);
	      var subscription = that.subscribe({
	        next : function(value){
	          try {
	            return fn(value);
	          } catch(e){
	            reject(e);
	            subscription.unsubscribe();
	          }
	        },
	        error: reject,
	        complete: resolve
	      });
	    });
	  }
	});
	
	redefineAll($Observable, {
	  from: function from(x){
	    var C = typeof this === 'function' ? this : $Observable;
	    var method = getMethod(anObject(x)[OBSERVABLE]);
	    if(method){
	      var observable = anObject(method.call(x));
	      return observable.constructor === C ? observable : new C(function(observer){
	        return observable.subscribe(observer);
	      });
	    }
	    return new C(function(observer){
	      var done = false;
	      microtask(function(){
	        if(!done){
	          try {
	            if(forOf(x, false, function(it){
	              observer.next(it);
	              if(done)return RETURN;
	            }) === RETURN)return;
	          } catch(e){
	            if(done)throw e;
	            observer.error(e);
	            return;
	          } observer.complete();
	        }
	      });
	      return function(){ done = true; };
	    });
	  },
	  of: function of(){
	    for(var i = 0, l = arguments.length, items = Array(l); i < l;)items[i] = arguments[i++];
	    return new (typeof this === 'function' ? this : $Observable)(function(observer){
	      var done = false;
	      microtask(function(){
	        if(!done){
	          for(var i = 0; i < items.length; ++i){
	            observer.next(items[i]);
	            if(done)return;
	          } observer.complete();
	        }
	      });
	      return function(){ done = true; };
	    });
	  }
	});
	
	hide($Observable.prototype, OBSERVABLE, function(){ return this; });
	
	$export($export.G, {Observable: $Observable});
	
	__webpack_require__(70)('Observable');

/***/ },
/* 510 */
/***/ function(module, exports, __webpack_require__) {

	var metadata                  = __webpack_require__(48)
	  , anObject                  = __webpack_require__(4)
	  , toMetaKey                 = metadata.key
	  , ordinaryDefineOwnMetadata = metadata.set;
	
	metadata.exp({defineMetadata: function defineMetadata(metadataKey, metadataValue, target, targetKey){
	  ordinaryDefineOwnMetadata(metadataKey, metadataValue, anObject(target), toMetaKey(targetKey));
	}});

/***/ },
/* 511 */
/***/ function(module, exports, __webpack_require__) {

	var metadata               = __webpack_require__(48)
	  , anObject               = __webpack_require__(4)
	  , toMetaKey              = metadata.key
	  , getOrCreateMetadataMap = metadata.map
	  , store                  = metadata.store;
	
	metadata.exp({deleteMetadata: function deleteMetadata(metadataKey, target /*, targetKey */){
	  var targetKey   = arguments.length < 3 ? undefined : toMetaKey(arguments[2])
	    , metadataMap = getOrCreateMetadataMap(anObject(target), targetKey, false);
	  if(metadataMap === undefined || !metadataMap['delete'](metadataKey))return false;
	  if(metadataMap.size)return true;
	  var targetMetadata = store.get(target);
	  targetMetadata['delete'](targetKey);
	  return !!targetMetadata.size || store['delete'](target);
	}});

/***/ },
/* 512 */
/***/ function(module, exports, __webpack_require__) {

	var Set                     = __webpack_require__(241)
	  , from                    = __webpack_require__(218)
	  , metadata                = __webpack_require__(48)
	  , anObject                = __webpack_require__(4)
	  , getPrototypeOf          = __webpack_require__(33)
	  , ordinaryOwnMetadataKeys = metadata.keys
	  , toMetaKey               = metadata.key;
	
	var ordinaryMetadataKeys = function(O, P){
	  var oKeys  = ordinaryOwnMetadataKeys(O, P)
	    , parent = getPrototypeOf(O);
	  if(parent === null)return oKeys;
	  var pKeys  = ordinaryMetadataKeys(parent, P);
	  return pKeys.length ? oKeys.length ? from(new Set(oKeys.concat(pKeys))) : pKeys : oKeys;
	};
	
	metadata.exp({getMetadataKeys: function getMetadataKeys(target /*, targetKey */){
	  return ordinaryMetadataKeys(anObject(target), arguments.length < 2 ? undefined : toMetaKey(arguments[1]));
	}});

/***/ },
/* 513 */
/***/ function(module, exports, __webpack_require__) {

	var metadata               = __webpack_require__(48)
	  , anObject               = __webpack_require__(4)
	  , getPrototypeOf         = __webpack_require__(33)
	  , ordinaryHasOwnMetadata = metadata.has
	  , ordinaryGetOwnMetadata = metadata.get
	  , toMetaKey              = metadata.key;
	
	var ordinaryGetMetadata = function(MetadataKey, O, P){
	  var hasOwn = ordinaryHasOwnMetadata(MetadataKey, O, P);
	  if(hasOwn)return ordinaryGetOwnMetadata(MetadataKey, O, P);
	  var parent = getPrototypeOf(O);
	  return parent !== null ? ordinaryGetMetadata(MetadataKey, parent, P) : undefined;
	};
	
	metadata.exp({getMetadata: function getMetadata(metadataKey, target /*, targetKey */){
	  return ordinaryGetMetadata(metadataKey, anObject(target), arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
	}});

/***/ },
/* 514 */
/***/ function(module, exports, __webpack_require__) {

	var metadata                = __webpack_require__(48)
	  , anObject                = __webpack_require__(4)
	  , ordinaryOwnMetadataKeys = metadata.keys
	  , toMetaKey               = metadata.key;
	
	metadata.exp({getOwnMetadataKeys: function getOwnMetadataKeys(target /*, targetKey */){
	  return ordinaryOwnMetadataKeys(anObject(target), arguments.length < 2 ? undefined : toMetaKey(arguments[1]));
	}});

/***/ },
/* 515 */
/***/ function(module, exports, __webpack_require__) {

	var metadata               = __webpack_require__(48)
	  , anObject               = __webpack_require__(4)
	  , ordinaryGetOwnMetadata = metadata.get
	  , toMetaKey              = metadata.key;
	
	metadata.exp({getOwnMetadata: function getOwnMetadata(metadataKey, target /*, targetKey */){
	  return ordinaryGetOwnMetadata(metadataKey, anObject(target)
	    , arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
	}});

/***/ },
/* 516 */
/***/ function(module, exports, __webpack_require__) {

	var metadata               = __webpack_require__(48)
	  , anObject               = __webpack_require__(4)
	  , getPrototypeOf         = __webpack_require__(33)
	  , ordinaryHasOwnMetadata = metadata.has
	  , toMetaKey              = metadata.key;
	
	var ordinaryHasMetadata = function(MetadataKey, O, P){
	  var hasOwn = ordinaryHasOwnMetadata(MetadataKey, O, P);
	  if(hasOwn)return true;
	  var parent = getPrototypeOf(O);
	  return parent !== null ? ordinaryHasMetadata(MetadataKey, parent, P) : false;
	};
	
	metadata.exp({hasMetadata: function hasMetadata(metadataKey, target /*, targetKey */){
	  return ordinaryHasMetadata(metadataKey, anObject(target), arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
	}});

/***/ },
/* 517 */
/***/ function(module, exports, __webpack_require__) {

	var metadata               = __webpack_require__(48)
	  , anObject               = __webpack_require__(4)
	  , ordinaryHasOwnMetadata = metadata.has
	  , toMetaKey              = metadata.key;
	
	metadata.exp({hasOwnMetadata: function hasOwnMetadata(metadataKey, target /*, targetKey */){
	  return ordinaryHasOwnMetadata(metadataKey, anObject(target)
	    , arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
	}});

/***/ },
/* 518 */
/***/ function(module, exports, __webpack_require__) {

	var metadata                  = __webpack_require__(48)
	  , anObject                  = __webpack_require__(4)
	  , aFunction                 = __webpack_require__(26)
	  , toMetaKey                 = metadata.key
	  , ordinaryDefineOwnMetadata = metadata.set;
	
	metadata.exp({metadata: function metadata(metadataKey, metadataValue){
	  return function decorator(target, targetKey){
	    ordinaryDefineOwnMetadata(
	      metadataKey, metadataValue,
	      (targetKey !== undefined ? anObject : aFunction)(target),
	      toMetaKey(targetKey)
	    );
	  };
	}});

/***/ },
/* 519 */
/***/ function(module, exports, __webpack_require__) {

	// https://github.com/DavidBruant/Map-Set.prototype.toJSON
	var $export  = __webpack_require__(1);
	
	$export($export.P + $export.R, 'Set', {toJSON: __webpack_require__(222)('Set')});

/***/ },
/* 520 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/mathiasbynens/String.prototype.at
	var $export = __webpack_require__(1)
	  , $at     = __webpack_require__(162)(true);
	
	$export($export.P, 'String', {
	  at: function at(pos){
	    return $at(this, pos);
	  }
	});

/***/ },
/* 521 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// https://tc39.github.io/String.prototype.matchAll/
	var $export     = __webpack_require__(1)
	  , defined     = __webpack_require__(35)
	  , toLength    = __webpack_require__(16)
	  , isRegExp    = __webpack_require__(109)
	  , getFlags    = __webpack_require__(107)
	  , RegExpProto = RegExp.prototype;
	
	var $RegExpStringIterator = function(regexp, string){
	  this._r = regexp;
	  this._s = string;
	};
	
	__webpack_require__(155)($RegExpStringIterator, 'RegExp String', function next(){
	  var match = this._r.exec(this._s);
	  return {value: match, done: match === null};
	});
	
	$export($export.P, 'String', {
	  matchAll: function matchAll(regexp){
	    defined(this);
	    if(!isRegExp(regexp))throw TypeError(regexp + ' is not a regexp!');
	    var S     = String(this)
	      , flags = 'flags' in RegExpProto ? String(regexp.flags) : getFlags.call(regexp)
	      , rx    = new RegExp(regexp.source, ~flags.indexOf('g') ? flags : 'g' + flags);
	    rx.lastIndex = toLength(regexp.lastIndex);
	    return new $RegExpStringIterator(rx, S);
	  }
	});

/***/ },
/* 522 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/tc39/proposal-string-pad-start-end
	var $export = __webpack_require__(1)
	  , $pad    = __webpack_require__(237);
	
	$export($export.P, 'String', {
	  padEnd: function padEnd(maxLength /*, fillString = ' ' */){
	    return $pad(this, maxLength, arguments.length > 1 ? arguments[1] : undefined, false);
	  }
	});

/***/ },
/* 523 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/tc39/proposal-string-pad-start-end
	var $export = __webpack_require__(1)
	  , $pad    = __webpack_require__(237);
	
	$export($export.P, 'String', {
	  padStart: function padStart(maxLength /*, fillString = ' ' */){
	    return $pad(this, maxLength, arguments.length > 1 ? arguments[1] : undefined, true);
	  }
	});

/***/ },
/* 524 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/sebmarkbage/ecmascript-string-left-right-trim
	__webpack_require__(81)('trimLeft', function($trim){
	  return function trimLeft(){
	    return $trim(this, 1);
	  };
	}, 'trimStart');

/***/ },
/* 525 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/sebmarkbage/ecmascript-string-left-right-trim
	__webpack_require__(81)('trimRight', function($trim){
	  return function trimRight(){
	    return $trim(this, 2);
	  };
	}, 'trimEnd');

/***/ },
/* 526 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(168)('asyncIterator');

/***/ },
/* 527 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(168)('observable');

/***/ },
/* 528 */
/***/ function(module, exports, __webpack_require__) {

	// https://github.com/ljharb/proposal-global
	var $export = __webpack_require__(1);
	
	$export($export.S, 'System', {global: __webpack_require__(7)});

/***/ },
/* 529 */
/***/ function(module, exports, __webpack_require__) {

	var $iterators    = __webpack_require__(170)
	  , redefine      = __webpack_require__(27)
	  , global        = __webpack_require__(7)
	  , hide          = __webpack_require__(21)
	  , Iterators     = __webpack_require__(64)
	  , wks           = __webpack_require__(11)
	  , ITERATOR      = wks('iterator')
	  , TO_STRING_TAG = wks('toStringTag')
	  , ArrayValues   = Iterators.Array;
	
	for(var collections = ['NodeList', 'DOMTokenList', 'MediaList', 'StyleSheetList', 'CSSRuleList'], i = 0; i < 5; i++){
	  var NAME       = collections[i]
	    , Collection = global[NAME]
	    , proto      = Collection && Collection.prototype
	    , key;
	  if(proto){
	    if(!proto[ITERATOR])hide(proto, ITERATOR, ArrayValues);
	    if(!proto[TO_STRING_TAG])hide(proto, TO_STRING_TAG, NAME);
	    Iterators[NAME] = ArrayValues;
	    for(key in $iterators)if(!proto[key])redefine(proto, key, $iterators[key], true);
	  }
	}

/***/ },
/* 530 */
/***/ function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(1)
	  , $task   = __webpack_require__(166);
	$export($export.G + $export.B, {
	  setImmediate:   $task.set,
	  clearImmediate: $task.clear
	});

/***/ },
/* 531 */
/***/ function(module, exports, __webpack_require__) {

	// ie9- setTimeout & setInterval additional parameters fix
	var global     = __webpack_require__(7)
	  , $export    = __webpack_require__(1)
	  , invoke     = __webpack_require__(108)
	  , partial    = __webpack_require__(357)
	  , navigator  = global.navigator
	  , MSIE       = !!navigator && /MSIE .\./.test(navigator.userAgent); // <- dirty ie9- check
	var wrap = function(set){
	  return MSIE ? function(fn, time /*, ...args */){
	    return set(invoke(
	      partial,
	      [].slice.call(arguments, 2),
	      typeof fn == 'function' ? fn : Function(fn)
	    ), time);
	  } : set;
	};
	$export($export.G + $export.B + $export.F * MSIE, {
	  setTimeout:  wrap(global.setTimeout),
	  setInterval: wrap(global.setInterval)
	});

/***/ },
/* 532 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(481);
	__webpack_require__(420);
	__webpack_require__(422);
	__webpack_require__(421);
	__webpack_require__(424);
	__webpack_require__(426);
	__webpack_require__(431);
	__webpack_require__(425);
	__webpack_require__(423);
	__webpack_require__(433);
	__webpack_require__(432);
	__webpack_require__(428);
	__webpack_require__(429);
	__webpack_require__(427);
	__webpack_require__(419);
	__webpack_require__(430);
	__webpack_require__(434);
	__webpack_require__(435);
	__webpack_require__(387);
	__webpack_require__(389);
	__webpack_require__(388);
	__webpack_require__(437);
	__webpack_require__(436);
	__webpack_require__(407);
	__webpack_require__(417);
	__webpack_require__(418);
	__webpack_require__(408);
	__webpack_require__(409);
	__webpack_require__(410);
	__webpack_require__(411);
	__webpack_require__(412);
	__webpack_require__(413);
	__webpack_require__(414);
	__webpack_require__(415);
	__webpack_require__(416);
	__webpack_require__(390);
	__webpack_require__(391);
	__webpack_require__(392);
	__webpack_require__(393);
	__webpack_require__(394);
	__webpack_require__(395);
	__webpack_require__(396);
	__webpack_require__(397);
	__webpack_require__(398);
	__webpack_require__(399);
	__webpack_require__(400);
	__webpack_require__(401);
	__webpack_require__(402);
	__webpack_require__(403);
	__webpack_require__(404);
	__webpack_require__(405);
	__webpack_require__(406);
	__webpack_require__(468);
	__webpack_require__(473);
	__webpack_require__(480);
	__webpack_require__(471);
	__webpack_require__(463);
	__webpack_require__(464);
	__webpack_require__(469);
	__webpack_require__(474);
	__webpack_require__(476);
	__webpack_require__(459);
	__webpack_require__(460);
	__webpack_require__(461);
	__webpack_require__(462);
	__webpack_require__(465);
	__webpack_require__(466);
	__webpack_require__(467);
	__webpack_require__(470);
	__webpack_require__(472);
	__webpack_require__(475);
	__webpack_require__(477);
	__webpack_require__(478);
	__webpack_require__(479);
	__webpack_require__(382);
	__webpack_require__(384);
	__webpack_require__(383);
	__webpack_require__(386);
	__webpack_require__(385);
	__webpack_require__(371);
	__webpack_require__(369);
	__webpack_require__(375);
	__webpack_require__(372);
	__webpack_require__(378);
	__webpack_require__(380);
	__webpack_require__(368);
	__webpack_require__(374);
	__webpack_require__(365);
	__webpack_require__(379);
	__webpack_require__(363);
	__webpack_require__(377);
	__webpack_require__(376);
	__webpack_require__(370);
	__webpack_require__(373);
	__webpack_require__(362);
	__webpack_require__(364);
	__webpack_require__(367);
	__webpack_require__(366);
	__webpack_require__(381);
	__webpack_require__(170);
	__webpack_require__(453);
	__webpack_require__(458);
	__webpack_require__(240);
	__webpack_require__(454);
	__webpack_require__(455);
	__webpack_require__(456);
	__webpack_require__(457);
	__webpack_require__(438);
	__webpack_require__(239);
	__webpack_require__(241);
	__webpack_require__(242);
	__webpack_require__(493);
	__webpack_require__(482);
	__webpack_require__(483);
	__webpack_require__(488);
	__webpack_require__(491);
	__webpack_require__(492);
	__webpack_require__(486);
	__webpack_require__(489);
	__webpack_require__(487);
	__webpack_require__(490);
	__webpack_require__(484);
	__webpack_require__(485);
	__webpack_require__(439);
	__webpack_require__(440);
	__webpack_require__(441);
	__webpack_require__(442);
	__webpack_require__(443);
	__webpack_require__(446);
	__webpack_require__(444);
	__webpack_require__(445);
	__webpack_require__(447);
	__webpack_require__(448);
	__webpack_require__(449);
	__webpack_require__(450);
	__webpack_require__(452);
	__webpack_require__(451);
	__webpack_require__(494);
	__webpack_require__(520);
	__webpack_require__(523);
	__webpack_require__(522);
	__webpack_require__(524);
	__webpack_require__(525);
	__webpack_require__(521);
	__webpack_require__(526);
	__webpack_require__(527);
	__webpack_require__(505);
	__webpack_require__(508);
	__webpack_require__(504);
	__webpack_require__(502);
	__webpack_require__(503);
	__webpack_require__(506);
	__webpack_require__(507);
	__webpack_require__(497);
	__webpack_require__(519);
	__webpack_require__(528);
	__webpack_require__(496);
	__webpack_require__(498);
	__webpack_require__(500);
	__webpack_require__(499);
	__webpack_require__(501);
	__webpack_require__(510);
	__webpack_require__(511);
	__webpack_require__(513);
	__webpack_require__(512);
	__webpack_require__(515);
	__webpack_require__(514);
	__webpack_require__(516);
	__webpack_require__(517);
	__webpack_require__(518);
	__webpack_require__(495);
	__webpack_require__(509);
	__webpack_require__(531);
	__webpack_require__(530);
	__webpack_require__(529);
	module.exports = __webpack_require__(42);

/***/ },
/* 533 */
/***/ function(module, exports) {

	var canUseDOM = !!(
	  typeof window !== 'undefined' &&
	  window.document &&
	  window.document.createElement
	);
	
	module.exports = canUseDOM;

/***/ },
/* 534 */
/***/ function(module, exports) {

	module.exports = function(arr, obj){
	  if (arr.indexOf) return arr.indexOf(obj);
	  for (var i = 0; i < arr.length; ++i) {
	    if (arr[i] === obj) return i;
	  }
	  return -1;
	};

/***/ },
/* 535 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(243)();
	exports.push([module.id, ".is-mobile .medscape-tv .has-title-card .akamai-play.akamai-overlay{background-size:10%}.medscape-tv-player .akamai-paused .akamai-title-bar,.medscape-tv-player .akamai-ready .akamai-title-bar{display:none}.medscape-tv .has-title-card .akamai-play.akamai-overlay,.medscape-tv .has-title-card .akamai-play.akamai-overlay:active,.medscape-tv .has-title-card .akamai-play.akamai-overlay:hover{width:100%;height:100%;top:0;left:0;background-position:center;font-family:proxima_nova_rgregular,arial,sans-serif;background-size:9%;background-position-y:45%}.medscape-tv .akamai-caption-text p,.video-player-empty-shell,.video-player-standalone{font-family:proxima_nova_rgregular,arial,sans-serif}.medscape-tv .has-title-card .akamai-play.akamai-overlay .series-title,.medscape-tv .has-title-card .akamai-play.akamai-overlay:active .series-title,.medscape-tv .has-title-card .akamai-play.akamai-overlay:hover .series-title{margin-top:20%;margin-left:30px;font-size:16px;display:block;color:#CCC}.medscape-tv .has-title-card .akamai-play.akamai-overlay .episode-title,.medscape-tv .has-title-card .akamai-play.akamai-overlay:active .episode-title,.medscape-tv .has-title-card .akamai-play.akamai-overlay:hover .episode-title{margin-left:30px;font-size:30px;display:block;color:#FFF}.medscape-tv .has-title-card .akamai-play.akamai-overlay .episode-legend,.medscape-tv .has-title-card .akamai-play.akamai-overlay:active .episode-legend,.medscape-tv .has-title-card .akamai-play.akamai-overlay:hover .episode-legend{font-size:16px;display:block;color:#FFF;background-color:rgba(0,0,0,.4);padding:10px}.medscape-tv .akamai-caption-text p:empty,.medscape-tv .akamai-play.akamai-overlay .episode-legend,.medscape-tv .akamai-play.akamai-overlay .episode-title,.medscape-tv .akamai-play.akamai-overlay .series-title{display:none}.medscape-tv .akamai-play.akamai-overlay{right:45%;bottom:45%;z-index:95}.medscape-tv .is-idle .akamai-caption-text{bottom:0!important}.medscape-tv .akamai-caption-text{bottom:50px!important;background:0 0}.medscape-tv .akamai-caption-text p{font-size:18px;padding:10px 30px;border-radius:3px;background-color:rgba(0,0,0,.6)}.medscape-tv-wrapper .akamai-play.akamai-overlay,.medscape-tv-wrapper .akamai-play.akamai-overlay:active,.medscape-tv-wrapper .akamai-play.akamai-overlay:hover{background-repeat:no-repeat;background-position-x:0;background-position-y:0;height:18%;width:10%;margin:0;background-size:80px;-webkit-background-size:cover;-moz-background-size:cover;-o-background-size:cover;background-image:url(\"http://img.qa00.medscapestatic.com/pi/core/medscapetv/assets/images/video-player/play-icon.png\")}.video-player-screen{background-size:100%}.video-player-screen:before{display:block;content:\"\";width:100%;padding-top:56.25%}.video-player-screen>.content{position:absolute;top:0;left:0;right:0;bottom:0}.video-player-screen .akamai-branding-logo{opacity:1}.video-player-screen .akamai-ended .akamai-replay{display:none}object.akamai-media-element,video.akamai-media-element{width:100%}.akamai-controls-native .akamai-branding.akamai-overlay{display:block}.video-player-error,.video-player-screen .akamai-waiting .akamai-loading.akamai-overlay,.video-player-screen .akamai-waiting .akamai-waiting.akamai-overlay{display:none}img.akamai-branding-image{position:absolute;bottom:10px;right:10px;height:10%;opacity:1;display:none}.video-player-screen.is-paused{-webkit-filter:brightness(.8);filter:brightness(.8);webkit-filter:brightness(.8)}.video-player-empty-shell{min-width:100%;height:233px;background:#6a6a6a;color:#FEFEFE;content:\"Loading. . .\";text-align:center;padding-top:200px}.video-player-standalone{-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;max-width:840px;position:relative;font-size:12px;margin-right:400px;-webkit-transition:max-width .5s linear;transition:max-width .5s linear}.video-player-standalone.is-fullscreen{margin-right:0}.video-player-error.is-error{display:block;background:#000;color:#fff}.video-player-screen.is-playing .akamai-poster.akamai-layer{display:none}.video-player-screen.is-paused .akamai-poster.akamai-layer{display:table}.video-player-progress-bar-wrap{background-color:#d8d8d8;height:4px}.video-player-progress-bar{width:98%;height:4px;padding:0 0 0 1%}.video-player-loaded-bar{background-color:#fff;position:absolute;height:4px}.video-player-playlist{position:absolute;bottom:-50px;width:733px;height:50px}.video-player-playlist .video-player-playlist-index{display:none}.video-player-playlist.is-open .video-player-playlist-index{list-style:none;position:absolute;top:0;left:0;display:block;z-index:510;padding:12px;border:1px solid #333;background:#fff;cursor:pointer}.video-player-overlay{position:absolute;top:0;left:0;width:100%;height:90%;background-position:50% 50%;z-index:10}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min-resolution:192dpi){.video-player-overlay{background-position:50% 50%;background-size:150px 150px}}.video-player-controls-wrap{position:absolute;width:100%;bottom:-3px;height:40px;z-index:98;-webkit-transition:height .3s;transition:height .3s}.video-player-controls-wrap.is-idle{height:7px;-webkit-transition:height .3s;transition:height .3s}.is-idle .video-player-controls{display:none}.video-player-controls{height:36px;width:100%;display:block;color:#ccc;background-color:#000;opacity:.8}.video-player-controls:after{content:\"\";display:table;clear:both}.video-player-controls .button,.video-player-controls button{height:36px;outline:0;border:0;color:#9a9a9a;cursor:pointer;background-color:transparent;padding:0;margin:0 1% 0 0}.video-player-controls .video-player-play-button{-webkit-transition:all .5s;transition:all .5s;float:left;width:5%;font-size:0;background-image:url("+__webpack_require__(837)+");background-repeat:no-repeat;background-position:center}.video-player-controls .video-player-play-button:hover{background-image:url("+__webpack_require__(836)+")}.video-player-controls .video-player-play-button.is-playing{background-image:url("+__webpack_require__(835)+");background-position:center}.video-player-controls .video-player-play-button.is-playing:hover{background-image:url("+__webpack_require__(834)+")}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:192dpi),only screen and (min-resolution:2dppx){.video-player-play-button{background-position:center 7px;background-size:15px 21px}}.video-player-load-progress{position:relative;height:100%;background-color:#d8d8d8}.video-player-load-progress.is-buffering,.video-player-load-progress.is-loading{-ms-box-sizing:border-box;box-sizing:border-box;text-align:center;line-height:3;background-color:#9a9a9a;background-image:-webkit-linear-gradient(135deg,rgba(255,255,255,.15) 25%,transparent 25%,transparent 50%,rgba(255,255,255,.15) 50%,rgba(255,255,255,.15) 75%,transparent 75%,transparent);background-image:linear-gradient(-45deg,rgba(255,255,255,.15) 25%,transparent 25%,transparent 50%,rgba(255,255,255,.15) 50%,rgba(255,255,255,.15) 75%,transparent 75%,transparent);-ms-background-size:30px 30px;background-size:30px 30px;-webkit-animation:move 1s linear infinite;animation:move 1s linear infinite}.draggable-medtv{background-color:#007cb0;position:absolute;border-radius:7px;width:10px;height:10px;right:-10px;bottom:-50%;z-index:510}.video-player-elapsed-time-indicator{height:4px;background-color:#007cb0;width:0;position:relative}.video-player-duration,.video-player-elapsed-time,.video-player-progress-divider{line-height:14px;height:14px;display:inline-block}video-player-controls.is-buffering .video-player-elapsed-time-indicator{-ms-box-sizing:border-box;box-sizing:border-box;background-color:#e6eef2;overflow:hidden;background-image:-webkit-linear-gradient(135deg,rgba(255,255,255,.15) 25%,transparent 25%,transparent 50%,rgba(255,255,255,.15) 50%,rgba(255,255,255,.15) 75%,transparent 75%,transparent);background-image:linear-gradient(-45deg,rgba(255,255,255,.15) 25%,transparent 25%,transparent 50%,rgba(255,255,255,.15) 50%,rgba(255,255,255,.15) 75%,transparent 75%,transparent);-ms-background-size:30px 30px;background-size:30px 30px;-webkit-animation:move 1s linear infinite;animation:move 1s linear infinite}.video-player-time-tracking{margin:11px 0;width:20%;text-align:left;float:left;overflow:hidden}.video-player-elapsed-time{text-align:right}.video-player-progress-divider{margin:0 3px;text-align:center;color:#9a9a9a}.video-player-duration{text-align:left}.video-player-volume-slider{float:right;width:5%;height:36px;position:relative;margin-right:1%}.video-player-volume-button{width:100%;float:left;font-size:0;background-position:right 8px}.video-player-volume-muted-button{-webkit-transition:all .5s;transition:all .5s;background-image:url("+__webpack_require__(849)+");background-repeat:no-repeat;background-position:center}.video-player-volume-low-button,.video-player-volume-med-button{-webkit-transition:all .5s;background-position:center;background-repeat:no-repeat}.video-player-volume-muted-button:hover{background-image:url("+__webpack_require__(848)+")}.video-player-volume-low-button{transition:all .5s;background-image:url("+__webpack_require__(845)+")}.video-player-volume-low-button:hover{background-image:url("+__webpack_require__(844)+")}.video-player-volume-med-button{transition:all .5s;background-image:url("+__webpack_require__(847)+")}.video-player-volume-med-button:hover{background-image:url("+__webpack_require__(846)+")}.video-player-volume-high-button{-webkit-transition:all .5s;transition:all .5s;background-image:url("+__webpack_require__(843)+");background-repeat:no-repeat;background-position:center}.video-player-volume-high-button:hover{background-image:url("+__webpack_require__(842)+")}.video-player-cc-chrome{float:left}.video-player-cc-button{cursor:pointer}.video-player-volume-slider.is-muted .video-player-mute-button{text-decoration:line-through;background-position:right 8px;border:1px solid #00f}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min-resolution:192dpi){.video-player-volume-slider .video-player-mute-button,.video-player-volume-slider.is-muted .video-player-mute-button{background-position:right 8px;background-size:22px 19px}}.video-player-volume-boundary-wrap{background-color:#000;bottom:100%;height:100px;position:absolute;width:100%;margin-bottom:4px;display:none}.is-active .video-player-volume-boundary-wrap{display:block}.video-player-volume-boundary{height:70px;margin:15px 0;position:relative}.video-player-volume-line{border-right:3px solid #FFF;position:absolute;bottom:0;left:49%;height:100%;cursor:-webkit-grab;cursor:grab}.video-player-volume-indicator{position:absolute;bottom:0;left:49%}.video-player-volume-indicator-icon{width:11px;height:11px;background-color:#007cb0;border-radius:5px;left:-5px;position:absolute}.video-player-cc-button{width:5%;float:right;height:100%;font-family:proxima_nova_rgregular,sans-serif;font-size:18px;font-weight:lighter;line-height:150%;color:#fff;text-align:center;vertical-align:text-bottom;padding-top:6px;margin-right:1%;-webkit-transition:all .5s;transition:all .5s}.video-player-cc-button.is-on{text-decoration:underline}.video-player-cc-button:hover{color:#005B81}.player-cc-list-item.is-selected{color:#fff;font-weight:700}.player-cc-list{position:absolute;bottom:100%;background-color:#000;opacity:.8;color:#ccc;margin:0;list-style:none;padding:10px}.video-player-fullscreen-button{float:right;width:5%;font-size:0;background-image:url("+__webpack_require__(828)+");background-repeat:no-repeat;background-position:center;-webkit-transition:all .5s;transition:all .5s}.video-player-fullscreen-button:hover{background-image:url("+__webpack_require__(827)+")}.video-player-fullscreen-button.is-fullscreen{background-image:url("+__webpack_require__(830)+")}.video-player-fullscreen-button.is-fullscreen:hover{background-image:url("+__webpack_require__(829)+")}.video-player-standalone.is-fullscreen{width:100%;max-width:100%;height:100%;background:#000}.video-player-standalone.is-fullscreen .video-player-error,.video-player-standalone.is-fullscreen .video-player-playlist{display:none}.video-player-standalone.is-fullscreen .video-player-controls{bottom:0;left:0;z-index:2;webkit-transition:.5s linear;-moz-transition:.5s linear;-ms-transition:.5s linear;-o-transition:.5s linear}.fallback-fullscreen .video-player-standalone.is-fullscreen{position:fixed;top:0;left:0;width:100%;height:100%;z-index:199}@-webkit-keyframes move{0%{background-position:0 0}100%{background-position:30px 30px}}@keyframes move{0%{background-position:0 0}100%{background-position:30px 30px}}.json-editor{padding:1em;margin:1em;border:2px solid #CCC;border-radius:3px}.json-editor.is-saved{border:2px solid #CCC}.json-editor .json-editor-error-message{color:#A00;font-size:18px;font-style:italic}.json-editor .json-editor-text{border:none;outline:0;font-family:Consolas,Monaco,\"Lucida Console\",\"Courier New\",mono-spaced;width:100%;height:600px}.json-editor .json-editor-save-button{margin-top:24px;outline:0;color:#9a9a9a;border:1px solid #222;border-radius:3px;font-size:24px;background:#333}.layout{display:block}.layout .left-side{max-width:770px;width:100%;float:left}.layout .right-side{float:left;width:770px}@media (min-width:1200px){.layout{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row}.layout .left-side{max-width:770px}.layout .right-side{-webkit-box-flex:2;-ms-flex-positive:2;flex-grow:2;width:auto}}.is-mobile .video-player-overlay{background-size:20%}.is-mobile ::-webkit-media-controls-start-playback-button{display:none!important}.is-mobile video::-webkit-media-controls-overlay-play-button{display:none!important}.is-mobile audio::-webkit-media-controls,.is-mobile video::-webkit-media-controls{z-index:100}", ""]);

/***/ },
/* 536 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(243)();
	exports.push([module.id, ".slick-next:before,.slick-prev:before{content:none}.video-player-standalone{width:100%}.upNextChapter{display:none}#jsx-video-player{height:100%}#bodypadding .presistant-video-margin .slider-wrap{padding-top:580px}#bodypadding #jsx-video-player .presistant-video-animation{top:-160px;-webkit-transition:top .3s linear;transition:top .3s linear}#bodypadding .presistant-video{background-color:#fff;position:fixed;overflow:hidden;top:0;width:auto;margin:0 auto;left:0;right:0;z-index:999;-webkit-transition:top .3s linear;transition:top .3s linear;box-shadow:0 2px 4px 0 rgba(0,0,0,.3)}#bodypadding .presistant-video .grabbable{cursor:default}.grabbable,a.slick-slide,a.slick-slide div.video-player-playlist-item{cursor:pointer}#bodypadding .presistant-video .social-media-wrap{-webkit-box-flex:0;-ms-flex-positive:0;flex-grow:0}#bodypadding .presistant-video .chrome-row{display:-webkit-box;display:-ms-flexbox;display:flex;width:100%;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between}#bodypadding .presistant-video .chrome-cell{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column}#bodypadding .presistant-video .chrome-cell .ifiLinks{display:inherit;-webkit-box-ordinal-group:5;-ms-flex-order:4;order:4}#bodypadding .presistant-video .chrome-cell .ifiLinks a{color:#4d4184;text-align:left;margin:0 20px 0 0;font-size:14px;font-weight:400;font-style:normal}#bodypadding .presistant-video .chrome-cell .ifiLinks a:first-of-type{border-right:1px solid #d7d7d7;padding-right:20px}#bodypadding .presistant-video .chrome-cell .ifiLinks a:hover{text-decoration:underline}#bodypadding .presistant-video #pollWrapper{-ms-flex-wrap:nowrap;flex-wrap:nowrap}#bodypadding .presistant-video .highlight-content{padding:0;max-width:100%;margin:0}#bodypadding .presistant-video .medscape-tv-poll-wrapper{max-width:1440px;margin:0 auto}#bodypadding .presistant-video .upNextChapter{text-decoration:none;border-left:solid 2px #d7d7d7;display:block}#bodypadding .presistant-video .back-link,#bodypadding .presistant-video .comments-wrap,#bodypadding .presistant-video .ifiLinks,#bodypadding .presistant-video .share-wrap,#bodypadding .presistant-video .transcript-wrap,#bodypadding .presistant-video .video-player-cc-button,#bodypadding .presistant-video .video-player-fullscreen-button,#bodypadding .presistant-video .video-player-time-tracking,#bodypadding .presistant-video .video-player-volume-slider{display:none}#bodypadding .presistant-video .video-player-standalone{margin:0;width:285px;display:block;-ms-flex-negative:0;flex-shrink:0}#bodypadding .presistant-video .akamai-cc-active .akamai-caption-text,#bodypadding .presistant-video .episode-title,#bodypadding .presistant-video .video-player-controls{display:none}#bodypadding .presistant-video .medscape-tv-chrome{margin:0;-webkit-box-flex:1;-ms-flex-positive:1;flex-grow:1;-ms-flex-negative:1;flex-shrink:1;background-color:#fff;width:auto;padding:20px}#bodypadding .presistant-video .label-advertisment{font-size:14px;line-height:18px;margin:10px 0 0;padding:0}#bodypadding .presistant-video .label-episode{margin:0;padding:0;font-size:13px}#bodypadding .presistant-video .medscape-tv-chrome-title{font-family:proxima_nova_rgregular,arial,sans-serif;font-weight:400;font-size:24px;line-height:24px;color:#000;-webkit-box-ordinal-group:4;-ms-flex-order:3;order:3;border:none;margin-top:10px}#bodypadding .presistant-video .medscape-tv-player{margin-top:0}#bodypadding .presistant-video .upNextChapter{height:100%;-webkit-box-ordinal-group:2;-ms-flex-order:1;order:1;max-width:300px;padding-left:30px;background-image:url("+__webpack_require__(345)+");background-repeat:no-repeat;background-position:right center}#pollWrapper,.presistant-video .medscape-tv-chrome{-ms-flex-direction:row;-webkit-box-direction:normal}#bodypadding .presistant-video .upNextChapter h1{margin:0;font-size:20px;color:#767674}#bodypadding .presistant-video .upNextChapter .upNextChapterTitle{font-size:20px;margin-top:10px;margin-right:30px;color:#000}#bodypadding .presistant-video .video-player-controls-wrap{height:7px}@media (min-width:768px) and (max-width:1024px){#bodypadding .presistant-video .upNextChapter{display:none}#bodypadding .video-player-standalone{margin-right:0;max-width:none}#bodypadding .medscape-tv-chrome{margin-right:0}}@media (min-width:150px) and (max-width:767px){.topRightBox{margin-top:20px}#bodypadding #cast-list,.darkBg,.highlight-wrap .highlight-content,.lightBg,.whiteBg{padding:1vw}#bodypadding .portait{width:47vw;margin:1vw}#bodypadding .presistant-video .upNextChapter{display:none}#bodypadding .presistant-video .video-player-standalone{margin-right:0;width:45.37vw;height:25vw}#bodypadding .video-player-standalone{margin-right:0}#bodypadding .slider-wrap{margin:0 auto;max-width:none}#bodypadding .presistant-video .medscape-tv-chrome{margin-right:0;max-width:50vw}#bodypadding .medscape-tv-chrome{margin-right:0}#bodypadding .presistant-video .label-advertisment,#bodypadding .presistant-video .medscape-tv-chrome-title{font-size:3vw}}#cast-list{padding:30px 35px 30px 15px}#video_player_screen{width:100%}#pollWrapper{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;flex-direction:row;-ms-flex-wrap:wrap;flex-wrap:wrap}#bodypadding .slick-slide img{opacity:1}.fallback-fullscreen{position:fixed}a.video-player-playlist-item{text-decoration:none!important}a.video-player-playlist-item:hover{text-decoration:none}.slick-slider{margin-bottom:0}a.slick-slide{text-decoration:none}.not-visible{display:none!important}#bodypadding{padding:0;width:auto}#bodypadding .ep-guide{max-width:600px}.grabbable{cursor:grab;cursor:-webkit-grab}.grabbable:active{cursor:pointer;cursor:grabbing;cursor:-webkit-grabbing}.hero-bg{background-image:-webkit-linear-gradient(left,#000 0,transparent 50%,#000 100%),url(\"http://img.qa00.medscapestatic.com/pi/core/medscapetv/assets/images/template/hero-image@2x.png\");background-image:linear-gradient(to right,#000 0,transparent 50%,#000 100%),url(\"http://img.qa00.medscapestatic.com/pi/core/medscapetv/assets/images/template/hero-image@2x.png\");background-size:1280px 100%;background-repeat:no-repeat;height:350px;position:absolute;top:0;left:0;width:100%;background-position:center;background-color:#000}.highlight-wrap{background-color:#082734;position:relative;z-index:300;background-image:-webkit-linear-gradient(top,#000,#082734);background-image:linear-gradient(to bottom,#000,#082734);min-height:600px}.highlight-content{padding:20px 0;margin:0 auto;width:auto;position:relative;z-index:1}#bodypadding .highlight-content{padding-top:9px}a.back-link{color:#CCC;cursor:pointer;margin:0;font-family:'Roboto Condensed',arial,sans-serif;font-size:13px;text-decoration:none}a.back-link img{height:15px;margin-right:8px;vertical-align:sub}a.back-link:hover,a.back-link:link,a.back-link:visited{color:#CCC}.medscape-tv-wrapper{width:auto;font-family:proxima_nova_rgregular,arial,sans-serif}.medscape-tv-wrapper .medscape-tv{text-align:left}.medscape-tv-wrapper .medscape-tv .slick-next{right:-3%}.medscape-tv-wrapper .medscape-tv .slick-disabled{opacity:.1}@media (min-width:150px) and (max-width:767px){.medscape-tv-wrapper{width:auto}}.add{width:23%;float:right}.add img{width:100%}.video-player-overlay{height:90%;z-index:9}video{-webkit-transform-style:preserve-3d;transform-style:preserve-3}.is-advertisement .draggable-medtv,.is-advertisement .video-player-elapsed-time-indicator{background-color:#f69b6f}.advertisment{color:#f69b6f}.social-media-wrap{margin-top:0;-webkit-box-flex:1;-ms-flex-positive:1;flex-grow:1;min-width:250px;display:-webkit-box;display:-ms-flexbox;display:flex}.comments-wrap,.share-wrap,.transcript-wrap{font-family:proxima_nova_rgregular,arial,sans-serif;font-size:14px;cursor:pointer;display:inline-block;background-repeat:no-repeat;background-position:4px 12px;padding:10px 20px;z-index:98}.comments-wrap,.transcript-wrap{-webkit-box-flex:0;-ms-flex-positive:0;flex-grow:0;color:#aaa}.comments-wrap:hover,.transcript-wrap:hover{color:#fff}.share-wrap{color:#aaa}.label-advertisment,.medscape-tv-chrome{display:-webkit-box;display:-ms-flexbox}.label-advertisment,.label-episode{text-align:left;padding:10px 0 0;margin:0 2% 2% 0;height:15px;background-repeat:no-repeat}.share-wrap:hover{color:#fff}.label-episode{-webkit-box-flex:5;-ms-flex-positive:5;flex-grow:5;color:#aaa;line-height:15px}.label-advertisment{-webkit-box-flex:5;-ms-flex-positive:5;flex-grow:5;font-size:1em;line-height:1em;color:#f69b6f;display:flex}.comments-wrap{background-image:url("+__webpack_require__(825)+")}.transcript-wrap{background-image:url("+__webpack_require__(840)+")}.share-wrap{background-image:url("+__webpack_require__(839)+")}.medscape-tv-chrome{display:flex;-ms-flex-wrap:wrap-reverse;flex-wrap:wrap-reverse;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;width:100%;margin-right:400px;z-index:100}.presistant-video .medscape-tv-chrome{-webkit-box-orient:horizontal;flex-direction:row;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between}.medscape-tv-chrome-title{color:#FFF;font-size:19px;margin:0 0 12px;line-height:20px;font-family:proxima_nova_ltlight,arial;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row;border-bottom:1px solid rgba(214,219,222,.5);padding-bottom:12px}.medscape-tv-chrome-title .label{font-size:14px;line-height:2.1;color:#ccc;white-space:nowrap;display:-webkit-box;display:-ms-flexbox;display:flex;margin-right:10px}.slick-list{width:99%}div.video-player-playlist-item{cursor:default}div.video-player-playlist-item:hover .hover-btn{display:block}div.video-player-playlist-item:hover .thumbnail-btn{-webkit-filter:none;filter:none;webkit-filter:none}.video-player-playlist-item{padding:0;position:relative;cursor:pointer;display:block;width:94%;margin:0 6% 0 0}.video-player-playlist-item img{width:100%;height:100%}.video-player-playlist-item .hover-btn{display:none}.video-player-playlist-item:hover .hover-btn{display:block}.video-player-playlist-item:hover .thumbnail-btn{-webkit-filter:brightness(1.2);filter:brightness(1.2);webkit-filter:brightness(1.2)}.is-selected .medscape-tv-chapter-title{color:#999}.has-viewed .medscape-tv-chapter-thumbnail,.is-selected .medscape-tv-chapter-thumbnail{opacity:.3;-webkit-transition:opacity 2s;transition:opacity 2s}.slick-next,.slick-prev{-webkit-transition:all .5s;height:28px;width:17px;top:22%}.episode-title{color:#FFF;font-size:13px;margin:0 0 4px}.slick-next,.slick-next:focus,.slick-next:hover,.slick-prev,.slick-prev:focus,.slick-prev:hover{background-repeat:no-repeat;color:inherit}.slick-prev{transition:all .5s;background-image:url("+__webpack_require__(823)+");line-height:0;font-size:0}.slick-prev:focus,.slick-prev:hover{background-image:url("+__webpack_require__(344)+")}.slick-next{transition:all .5s;background-image:url("+__webpack_require__(824)+")}.slick-next:focus,.slick-next:hover{-webkit-transition:all .5s;transition:all .5s;background-image:url("+__webpack_require__(345)+")}.overlay{position:fixed;width:100%;height:100%;top:0;left:0;background:rgba(255,255,255,.5);filter:progid:DXImageTransform.Microsoft.gradient(startColorstr=#99000000, endColorstr=#99000000);z-index:999999999;display:none}.overlay.is-visible{display:block}.overlay .overlay-close{width:40px;height:40px;position:absolute;right:0;top:0;overflow:hidden;border:none;text-indent:200%;color:transparent;outline:0;z-index:100}.slider-wrap{max-width:875px;width:875px}@media (min-width:1024px) and (max-width:1280px){.slider-wrap{max-width:720px;width:720px}}@media (min-width:768px) and (max-width:1024px){.slider-wrap{width:80vw;margin:0 auto}}@media (min-width:150px) and (max-width:768px){.slider-wrap{width:80vw;margin:0 auto}}.video-player-playlist-item .hover-btn{width:20%;height:auto;position:absolute;top:15%;left:40%}.slider .video-player-playlist-item .coming-soon-thumb{width:94%;opacity:.5!important}.coming-soon,.now-playing,.watched{font-size:13px;line-height:13px;display:inline-block;color:#FFF;padding:3px 5px;position:absolute;top:0;left:0}.now-playing{background-color:rgba(0,90,129,.8)}.watched{background-color:rgba(170,170,170,.8)}.coming-soon{background-color:rgba(0,0,0,.6)}.video-title{margin:10px 0;color:#fff;font-size:16px}.video-title .low-light{margin:10px 0 7px;color:#aaa;font-size:14px}.video-title .advertisment{margin:10px 0;font-size:12px}.medscape-tv-player{width:100%;margin-top:9px;top:-160px}.hidden{display:none}.ifiLinks{margin:10px 0 0;color:#fff;text-align:right;font-size:18px}.ifiLinks a,.ifiLinks a:active,.ifiLinks a:hover,.ifiLinks a:link,.ifiLinks a:visited{color:#fff;font-weight:700;margin-left:20px}.share-wrap{position:relative}.share-wrap .share-menu{width:60px;position:absolute;bottom:34px;left:2px;background-color:#FFF;color:transparent;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none}.share-wrap .share-menu .email-button:hover,.share-wrap .share-menu .facebook-button:hover,.share-wrap .share-menu .google-button:hover,.share-wrap .share-menu .linkedIn-button:hover,.share-wrap .share-menu .print-button:hover,.share-wrap .share-menu .twitter-button:hover{background-color:#092734}.share-wrap .share-menu:after{top:100%;left:50%;border:solid transparent;content:\" \";height:0;width:0;position:absolute;pointer-events:none;border-color:rgba(136,183,213,0);border-top-color:#FFF;border-width:10px;margin-left:-10px}.share-wrap .share-menu div{float:left;width:30px;height:30px;opacity:.9;transition:opacity .2s;-webkit-transition:opacity .2s;-moz-transition:opacity .2s;background-repeat:no-repeat;background-position:center}.share-wrap .share-menu .facebook-button{background-image:url("+__webpack_require__(831)+")}.share-wrap .share-menu .twitter-button{background-image:url("+__webpack_require__(841)+")}.share-wrap .share-menu .google-button{background-image:url("+__webpack_require__(832)+")}.share-wrap .share-menu .linkedIn-button{background-image:url("+__webpack_require__(833)+")}.share-wrap .share-menu .email-button{background-image:url("+__webpack_require__(826)+")}.share-wrap .share-menu .print-button{background-image:url("+__webpack_require__(838)+")}@-webkit-keyframes fadeIn{from{opacity:0;opacity:1\\9}to{opacity:1}}@keyframes fadeIn{from{opacity:0;opacity:1\\9}to{opacity:1}}@-webkit-keyframes fade-out{from{opacity:1;opacity:1\\9}to{opacity:0}}@keyframes fade-out{from{opacity:1;opacity:1\\9}to{opacity:0}}.video-player-playlist .video-player-playlist-index,.video-player-standalone.is-paused .akamai-poster.akamai-layer{display:table!important}.fade-in{opacity:0;-webkit-animation:fadeIn ease-in 1;animation:fadeIn ease-in 1;-webkit-animation-fill-mode:forwards;animation-fill-mode:forwards;-webkit-animation-duration:.25s;animation-duration:.25s;-webkit-transform-style:flat;transform-style:flat}.fade-out{opacity:1;-webkit-animation:fade-out ease-in 1;animation:fade-out ease-in 1;-webkit-animation-fill-mode:forwards;animation-fill-mode:forwards;-webkit-animation-duration:.2s;animation-duration:.2s}@media only screen and (min-device-width:768px) and (max-device-width:1024px) and (-webkit-min-device-pixel-ratio:1){.highlight-wrap .medscape-tv-wrapper{width:auto;margin:0 400px 0 0}}#medscape-tver ::cue{color:#FFF}.is-mobile #video_player_screen{width:100%}.is-mobile .video-player-progress-bar-wrap{display:none}.is-mobile #pollWrapper,.is-mobile .presistant-video .video-player-progress-bar-wrap{display:block}.is-mobile .medscape-tv-wrapper .akamai-play.akamai-overlay{background-size:contain}.is-mobile .video-player-standalone{overflow:auto;max-width:none;width:auto;display:block}.is-mobile .highlight-wrap{min-height:auto}.is-mobile .presistant-video #pollWrapper{display:-webkit-box;display:-ms-flexbox;display:flex}#bodypadding.is-mobile .presistant-video .video-player-standalone{-webkit-box-flex:0;-ms-flex-positive:0;flex-grow:0}.is-mobile .presistant-video #video_player_screen{width:45.37vw;height:25vw}#bodypadding.is-mobile .presistant-video,#bodypadding.is-mobile .presistant-video .label-advertisment,#bodypadding.is-mobile .presistant-video .label-episode{height:auto}#bodypadding.is-mobile .presistant-video-margin .slider-wrap{padding-top:80vw}#bodypadding.is-mobile .presistant-video video::-internal-media-controls-overflow-button,#bodypadding.is-mobile .presistant-video video::-webkit-media-controls,#bodypadding.is-mobile .presistant-video video::-webkit-media-controls-current-time-display,#bodypadding.is-mobile .presistant-video video::-webkit-media-controls-enclosure,#bodypadding.is-mobile .presistant-video video::-webkit-media-controls-fullscreen-button,#bodypadding.is-mobile .presistant-video video::-webkit-media-controls-mute-button,#bodypadding.is-mobile .presistant-video video::-webkit-media-controls-panel-container,#bodypadding.is-mobile .presistant-video video::-webkit-media-controls-play-button,#bodypadding.is-mobile .presistant-video video::-webkit-media-controls-time-remaining-display,#bodypadding.is-mobile .presistant-video video::-webkit-media-controls-toggle-closed-captions-button,#bodypadding.is-mobile .presistant-video video::-webkit-media-controls-volume-slider{display:none}#bodypadding.is-mobile .presistant-video .akamai-overlays{display:none}#bodypadding.is-mobile .presistant-video .label-episode{display:block;word-spacing:9px;margin-bottom:4px}#bodypadding.is-mobile .presistant-video .medscape-tv-player{padding-bottom:0}#bodypadding.is-mobile .presistant-video .chrome-cell{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:reverse;-ms-flex-direction:column-reverse;flex-direction:column-reverse;color:#000}#bodypadding.is-mobile .presistant-video .ifiLinks{display:none}#bodypadding.is-mobile .presistant-video .ifiLinks-sticky{display:block;background-color:#fff;width:100%;box-shadow:0 2px 4px 0 rgba(0,0,0,.3);padding-bottom:10px}#bodypadding.is-mobile .presistant-video .ifiLinks-sticky a{display:inline-block;font-weight:400;font-size:3vw;margin-top:10px;color:#4d4184;width:48%;text-align:center}#bodypadding.is-mobile .presistant-video .social-media-wrap{min-width:initial;max-width:none;-webkit-box-ordinal-group:4;-ms-flex-order:3;order:3;border:none;padding:0}#bodypadding.is-mobile .presistant-video .social-media-wrap .label-advertisment{margin:0 auto;font-size:3.2vw}#bodypadding.is-mobile .presistant-video .medscape-tv-chrome-title{margin:0;line-height:3.5vw;font-size:3.5vw;-webkit-box-ordinal-group:3;-ms-flex-order:2;order:2}#bodypadding.is-mobile .presistant-video .medscape-tv-chrome{padding:10px;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column}.is-mobile .content-placeholder,.is-mobile .video-player-standalone{margin:0}#bodypadding.is-mobile .slider-wrap{width:100%}#bodypadding.is-mobile .portait{width:96vw}@media only screen and (min-device-width:768px) and (max-device-width:1024px){.Topad,.topLeftBox{float:left}.Topad{text-align:center;margin-left:auto;margin-right:auto;width:23%}.Topad img{width:100%;margin:0}.highlight-wrap{min-height:760px;padding:0 10px}.topRightBox{float:right}.whoWho{float:left}}.overlayed{position:fixed;overflow:hidden}.is-mobile .ifiLinks{margin:0;color:#fff;text-align:center;font-size:14px}.is-mobile .ifiLinks a,.is-mobile .ifiLinks a:active,.is-mobile .ifiLinks a:hover,.is-mobile .ifiLinks a:link,.is-mobile .ifiLinks a:visited{color:#fff;font-weight:700;margin:0}.is-mobile .overlay{width:100vw;height:100vh}.is-mobile .hover-btn{display:none!important}.is-mobile .medscape-tv .has-title-card .akamai-play.akamai-overlay .episode-title{margin-left:30px;font-size:12px;display:block}.is-mobile .label-advertisment{-ms-flex-preferred-size:100%;flex-basis:100%;margin:0}.is-mobile .label-episode{margin-top:4%}.is-mobile .medscape-tv-chrome-title{margin:10px 0 0;font-size:15px;line-height:15px;padding:0;width:auto;display:-webkit-box;display:-ms-flexbox;display:flex;text-align:left;border:none}.is-mobile .ep-guide,.is-mobile .medscape-tv-player{width:100%}.is-mobile .social-media-wrap{display:-webkit-box;display:-ms-flexbox;display:flex;-ms-flex-wrap:wrap;flex-wrap:wrap;border-bottom:1px solid #CCC;-ms-flex-pack:distribute;justify-content:space-around;padding-bottom:10px;margin-bottom:10px}.is-mobile .social-media-wrap .label-episode{display:none}.is-mobile .video-title,.is-mobile .video-title .advertisment{margin:0 0 10px}.is-mobile .low-light{margin:0}.is-mobile .medscape-tv-chrome{padding:0;margin-bottom:10px;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:reverse;-ms-flex-direction:column-reverse;flex-direction:column-reverse}.is-mobile .episode-guide{min-height:140px}.is-mobile a.back-link{margin:0 0 0 10px;text-decoration:none}.is-mobile .video-player-standalone{padding-bottom:5px;font:proxima_nova_rgregular}.is-mobile .medscape-tv-wrapper{width:100%!important;padding:0;margin:0;background-color:transparent;position:relative;float:none}.is-mobile .slider{width:auto;clear:both;margin:0;padding:0;position:relative;max-height:460px;overflow-y:hidden}.is-mobile .slider.display-more{overflow-y:visible;height:auto;max-height:none}.is-mobile .slider div:nth-child(2){border-top:0}.is-mobile .show-more{display:none;margin:10px auto 0;background-color:#092734;border-radius:0 0 50% 50%;padding-top:10px;position:absolute;bottom:-70px;width:33%;left:33%;text-align:center;line-height:20px;color:#fff}.is-mobile .show-more span{display:block;background-color:#092734;border-color:#fff}.is-mobile .show-more .show-more-border{width:60px;margin:0 auto;height:30px}.is-mobile .now-playing,.is-mobile .watched{top:10px}.is-mobile .coming-soon{margin-top:10px}.is-mobile .slider .video-player-playlist-item .coming-soon-thumb{opacity:.5;width:40vw;height:25vw}.is-mobile .video-player-playlist-item{text-decoration:none;clear:right;margin:10px 0;width:auto;display:-webkit-box;display:-ms-flexbox;display:flex;border-top:1px solid rgba(255,255,255,.2);padding-top:10px;font:proxima_nova_rgregular}.is-mobile .medscape-tv-chapters .video-player-playlist-item:first-child,.is-mobile .medscape-tv-chapters:first-child{margin-top:90px}.medscape-tv-comments .overlay-header h2,.medscape-tv-transcript .overlay-header h2{background-position:left;background-repeat:no-repeat;line-height:30px;background-position-y:4px}.is-mobile .video-player-playlist-item img{width:40vw;height:25vw;display:-webkit-inline-box;display:-ms-inline-flexbox;display:inline-flex;margin-right:10px}.is-mobile .video-player-playlist-item img.hover-btn{width:20%;height:auto;left:40%;top:40%}.is-mobile .video-player-playlist-item .video-title{width:40vw;display:-webkit-inline-box;display:-ms-inline-flexbox;display:inline-flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column}.is-mobile a:first-of-type{border:none}.is-mobile .comments-wrap,.is-mobile .share-wrap,.is-mobile .transcript-wrap{float:left;color:#aaa;height:auto}.is-mobile .medscape-tv-chrome-notes-button,.is-mobile .medscape-tv-menu-dropdown{position:relative;float:right;top:auto;right:auto}.is-mobile .medscape-tv-chapters{width:100%;float:none;border-top:1px solid #E1E1E1;border-bottom:0;overflow-y:scroll;-webkit-overflow-scrolling:touch}@media (min-width:0) and (max-width:1023px){.is-mobile .medscape-tv-chapters .video-player-controls{display:none}}.is-mobile .medscape-tv-chapters .video-player-playlist-item{display:block;width:auto;float:none;border-top:1px solid #E1E1E1;border-bottom:0}@media (min-width:0) and (max-width:1024px) and (orientation:landscape){.is-mobile .medscape-tv-chapters{width:39.8%;margin-right:0}.is-mobile .medscape-tv-chapters video-player-playlist-item{height:50px;overflow:hidden}.is-mobile .medscape-tv-chapters .medscape-tv-chapter{width:70px}.is-mobile .medscape-tv-chapters .medscape-tv-chapter-title{font-size:11px}}.medscape-tv-comments,.medscape-tv-transcript{overflow-y:scroll;position:absolute;top:0;right:0}.is-mobile .medscape-tv-chapters,.is-mobile .medscape-tv-header{display:none}.is-mobile .medscape-tv-player .medscape-tv-chapters{display:block}.is-mobile .overlay_content{height:94%}@media (min-width:0) and (max-width:1024px) and (orientation:landscape){.is-mobile .medscape-tv-chapters{display:block}.is-mobile .medscape-tv-header{display:none}.is-mobile .medscape-tv-chrome:after{content:\"\";display:table;clear:both}.is-mobile .medscape-tv-chrome-title{padding-top:20px}.is-mobile .medscape-tv-player{width:100%}.is-mobile .medscape-tv-player .medscape-tv-chapters{display:none}.is-mobile .overlay_content{height:80%}}@media (min-width:768px) and (max-width:1023px){.is-mobile .overlay_content{height:80%}}.is-mobile .medscape-tv-transcript{width:100%}.is-mobile .medscape-tv-transcript .transcript-item .transcript-content p{width:auto}.medscape-tv-transcript{height:100%;width:50%;font-family:proxima_nova_ltlight,arial,sans-serif;background-color:#FFF}.medscape-tv-transcript .overlay-header{background-color:#005b81;width:100%;padding:15px 0}.medscape-tv-transcript .overlay-header h2{background-image:url("+__webpack_require__(347)+");background-size:26px 26px;color:#FFF;display:block;font-family:proxima_nova_ltlight,arial,sans-serif;font-size:30px;margin:0 20px;padding:0 0 0 35px}.medscape-tv-transcript .overlay-header h4,.medscape-tv-transcript .transcript-item .transcript-content h4,.medscape-tv-transcript .transcript-item .transcript-content strong{font-family:proxima_nova_ltsemibold,arial,sans-serif}.medscape-tv-transcript .overlay-header .close-btn{float:right;margin:0 15px 0 0;cursor:pointer;background-image:url("+__webpack_require__(346)+");height:25px;width:25px;background-size:cover}.medscape-tv-transcript .transcript-item{margin:70px 20px;clear:both}.medscape-tv-transcript .transcript-item .transcript-content h4{color:#000;font-size:20px;margin:0 0 25px 5px;font-weight:700}.medscape-tv-transcript .transcript-item .transcript-content .transcript-time{color:#005b81;font-family:proxima_nova_ltsemibold,arial,sans-serif;font-size:30px;font-weight:700;float:left;margin-right:20px}.medscape-tv-transcript .transcript-item .transcript-content p{font-family:proxima_nova_ltlight!important;font-size:16px;padding:0 10px;font-weight:300}.is-mobile .medscape-tv-comments{width:100%}.medscape-tv-comments{height:100%;width:50%;background-color:#FFF;font-family:proxima_nova_ltlight,Arial,sans-serif}.medscape-tv-comments .content-wrap{border-bottom:1px solid #CCC;margin:10px 30px;padding-bottom:10px;display:-webkit-box;display:-ms-flexbox;display:flex;-ms-flex-wrap:wrap;flex-wrap:wrap;-webkit-box-pack:end;-ms-flex-pack:end;justify-content:flex-end}.medscape-tv-comments .content-wrap #comments-form{-webkit-box-flex:6;-ms-flex-positive:6;flex-grow:6;width:100%}.medscape-tv-comments .content-wrap .date,.medscape-tv-comments .content-wrap .name,.medscape-tv-comments .content-wrap .title{-webkit-box-flex:1;-ms-flex-positive:1;flex-grow:1;width:33%;height:20px}.medscape-tv-comments .content-wrap .date{text-align:right}.medscape-tv-comments .content-wrap .likes{-webkit-box-flex:1;-ms-flex-positive:1;flex-grow:1;width:80%;height:20px}.medscape-tv-comments .content-wrap .like,.medscape-tv-comments .content-wrap .reply{-webkit-box-flex:1;-ms-flex-positive:1;flex-grow:1;width:10%;height:20px;color:#007cb0;cursor:pointer}.medscape-tv-comments .content-wrap .disclaimer{-webkit-box-flex:5;-ms-flex-positive:5;flex-grow:5;font-size:12px}.medscape-tv-comments .content-wrap div{-webkit-box-flex:1;-ms-flex-positive:1;flex-grow:1;padding:25px 0}.medscape-tv-comments #comment-text-area{width:100%;height:80px;margin:20px 0 10px}.medscape-tv-comments #comment-submit{background-color:#007cb0;border-radius:3px;color:#FFF;cursor:pointer;height:20px;padding:10px 15px;text-align:center;-webkit-box-flex:0;-ms-flex-positive:0;flex-grow:0}.medscape-tv-comments .overlay-header{background-color:#005b81;width:100%;padding:15px 0;font-weight:400!important}.medscape-tv-comments .overlay-header h2{background-image:url("+__webpack_require__(347)+");background-size:26px 26px;color:#FFF;display:block;margin:0 20px;padding:0 0 0 35px;font-family:proxima_nova_ltlight,Arial,sans-serif;font-size:24px}.ep-guide .desc,.ep-guide .title1,.ep-guide .title2{font-family:proxima_nova_ltlight,arial,sans-serif}.medscape-tv-comments .overlay-header .close-btn{float:right;margin:0 15px 0 0;cursor:pointer;background-image:url("+__webpack_require__(346)+");height:25px;width:25px;background-size:cover}#livefyre{margin-top:80px}.medscape-tv-comments .overlay-content{padding:0 25px;margin-top:-40px}.medscape-tv-comments .overlay-content .fyre-box-wrapper{max-width:50%}.medscape-tv-comments .overlay-content .fyre-box-wrapper span.fyre-user-drop{background:0 0}.medscape-tv-comments .overlay-content .fyre-box-wrapper span.fyre-user-drop:after{background-color:#005B81;color:#fff;content:'\\25bc';display:block;position:absolute;top:0;right:0;width:14px;bottom:0;z-index:-1}.is-mobile .ep-guide .desc,.is-mobile .ep-guide .ep-buttons .episode,.medscape-tv-comments .overlay-content .fyre-comment-stream .fyre-comment-actions,.medscape-tv-comments .overlay-content .fyre-comment-stream .fyre-comment-user,.medscape-tv-comments .overlay-content .fyre-editor-toolbar .fyre-share-button,.medscape-tv-comments .overlay-content .fyre-editor-toolbar div.fyre-button-left,.medscape-tv-comments .overlay-content .fyre-editor-toolbar div.fyre-button-left:nth-child(2),.medscape-tv-comments .overlay-content .fyre-live-container,.medscape-tv-comments .overlay-content .fyre-login-bar img,.medscape-tv-comments .overlay-content .fyre-stream-stats{display:none}.medscape-tv-comments .overlay-content .fyre-box-wrapper a.fyre-user-profile-link{white-space:normal;font-size:15px;border:1px solid #eee;border-radius:2px;padding:0 0 0 8px}.medscape-tv-comments .overlay-content .fyre-login-bar{position:relative}.medscape-tv-comments .overlay-content .fyre-login-bar .fyre-box-wrapper{left:auto}.medscape-tv-comments .overlay-content .fyre-editor .fyre-editor-container .fyre-editor-editable{background:0 0;border-radius:0;box-shadow:none}.medscape-tv-comments .overlay-content .fyre-editor-toolbar .goog-toolbar>div{background:0 0;border:none!important;margin:10px 0}.medscape-tv-comments .overlay-content .fyre-editor-toolbar .fyre-post-button{background-color:#1580E4!important;background-image:none!important;border-radius:2px!important}.medscape-tv-comments .overlay-content .fyre-editor-toolbar .fyre-button-right-inner-box{color:#fff!important;font-weight:400!important;text-shadow:none!important}.medscape-tv-comments .overlay-content .fyre-stream-sort{text-align:right}.medscape-tv-comments .overlay-content .fyre-comment-stream .fyre-comment-body,.medscape-tv-comments .overlay-content .fyre-comment-stream .fyre-comment-head{margin-left:0}.medscape-tv-comments .overlay-content .fyre-comment-stream a.fyre-comment-username{color:#000;text-decoration:none;cursor:default}.medscape-tv-comments .overlay-content .fyre-comment-stream .fyre-comment-action-button{color:#1580E4!important}.medscape-tv-comments .overlay-content .fyre-comment-stream .fyre-comment-divider{margin-left:0;color:#333}.medscape-tv-comments .overlay-content .fyre-comment-stream .fyre-comment-date{color:#000}.episode-guide{min-height:340px}.ep-guide-overlay{width:100%;background-size:cover;margin-top:-20px}.ep-guide{color:#fff;max-width:600px}.ep-guide .title1{font-size:1.2em;padding-top:30px;text-transform:uppercase}.ep-guide .title2{font-size:3em;margin-top:10px;line-height:1}.ep-guide .desc{font-size:1.3em;margin-top:20px}.is-mobile .ep-guide{margin:20px 10px 0;min-height:140px}.is-mobile .slider{margin-top:15px}.ep-guide .ep-buttons{position:relative;margin:14px 0}.ep-guide .ep-buttons span{-webkit-transition:all .5s;transition:all .5s;background:url(\"http://img.qa00.medscapestatic.com/pi/core/medscapetv/assets/images/video-player/play-overlay.svg\") 10px center no-repeat #007CB0;background-size:20px 20px;font-size:22px;display:inline-block;border-radius:3px;font-weight:300;font-family:proxima_nova_rgregular,arial,sans-serif;padding:10px 20px 10px 47px;margin:15px 15px 10px 0;color:#fff}.ep-guide .ep-buttons span:hover{-webkit-transition:all .5s;transition:all .5s;background-color:#005b81}.share{display:inline-block;background-image:url(\"http://img.staging.medscapestatic.com/pi/core/assets/images/video-player/share-icon.svg\");background-position:left center;background-repeat:no-repeat;color:#aaa;cursor:pointer;margin:10px 0 30px 17px;padding:0 0 0 17px}@media all and (max-width:786px){.ep-guide .title1{font-size:.7em;margin-top:0;padding-top:0}.ep-guide .title2{font-size:2em}.ep-guide .desc{font-size:.9em}}@media all and (max-width:480px){.ep-guide .title2{font-size:1.7em}}", ""]);

/***/ },
/* 537 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/*!
	 * enquire.js v2.1.1 - Awesome Media Queries in JavaScript
	 * Copyright (c) 2014 Nick Williams - http://wicky.nillia.ms/enquire.js
	 * License: MIT (http://www.opensource.org/licenses/mit-license.php)
	 */
	
	;(function (name, context, factory) {
		var matchMedia = window.matchMedia;
	
		if (typeof module !== 'undefined' && module.exports) {
			module.exports = factory(matchMedia);
		}
		else if (true) {
			!(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
				return (context[name] = factory(matchMedia));
			}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		}
		else {
			context[name] = factory(matchMedia);
		}
	}('enquire', this, function (matchMedia) {
	
		'use strict';
	
	    /*jshint unused:false */
	    /**
	     * Helper function for iterating over a collection
	     *
	     * @param collection
	     * @param fn
	     */
	    function each(collection, fn) {
	        var i      = 0,
	            length = collection.length,
	            cont;
	
	        for(i; i < length; i++) {
	            cont = fn(collection[i], i);
	            if(cont === false) {
	                break; //allow early exit
	            }
	        }
	    }
	
	    /**
	     * Helper function for determining whether target object is an array
	     *
	     * @param target the object under test
	     * @return {Boolean} true if array, false otherwise
	     */
	    function isArray(target) {
	        return Object.prototype.toString.apply(target) === '[object Array]';
	    }
	
	    /**
	     * Helper function for determining whether target object is a function
	     *
	     * @param target the object under test
	     * @return {Boolean} true if function, false otherwise
	     */
	    function isFunction(target) {
	        return typeof target === 'function';
	    }
	
	    /**
	     * Delegate to handle a media query being matched and unmatched.
	     *
	     * @param {object} options
	     * @param {function} options.match callback for when the media query is matched
	     * @param {function} [options.unmatch] callback for when the media query is unmatched
	     * @param {function} [options.setup] one-time callback triggered the first time a query is matched
	     * @param {boolean} [options.deferSetup=false] should the setup callback be run immediately, rather than first time query is matched?
	     * @constructor
	     */
	    function QueryHandler(options) {
	        this.options = options;
	        !options.deferSetup && this.setup();
	    }
	    QueryHandler.prototype = {
	
	        /**
	         * coordinates setup of the handler
	         *
	         * @function
	         */
	        setup : function() {
	            if(this.options.setup) {
	                this.options.setup();
	            }
	            this.initialised = true;
	        },
	
	        /**
	         * coordinates setup and triggering of the handler
	         *
	         * @function
	         */
	        on : function() {
	            !this.initialised && this.setup();
	            this.options.match && this.options.match();
	        },
	
	        /**
	         * coordinates the unmatch event for the handler
	         *
	         * @function
	         */
	        off : function() {
	            this.options.unmatch && this.options.unmatch();
	        },
	
	        /**
	         * called when a handler is to be destroyed.
	         * delegates to the destroy or unmatch callbacks, depending on availability.
	         *
	         * @function
	         */
	        destroy : function() {
	            this.options.destroy ? this.options.destroy() : this.off();
	        },
	
	        /**
	         * determines equality by reference.
	         * if object is supplied compare options, if function, compare match callback
	         *
	         * @function
	         * @param {object || function} [target] the target for comparison
	         */
	        equals : function(target) {
	            return this.options === target || this.options.match === target;
	        }
	
	    };
	    /**
	     * Represents a single media query, manages it's state and registered handlers for this query
	     *
	     * @constructor
	     * @param {string} query the media query string
	     * @param {boolean} [isUnconditional=false] whether the media query should run regardless of whether the conditions are met. Primarily for helping older browsers deal with mobile-first design
	     */
	    function MediaQuery(query, isUnconditional) {
	        this.query = query;
	        this.isUnconditional = isUnconditional;
	        this.handlers = [];
	        this.mql = matchMedia(query);
	
	        var self = this;
	        this.listener = function(mql) {
	            self.mql = mql;
	            self.assess();
	        };
	        this.mql.addListener(this.listener);
	    }
	    MediaQuery.prototype = {
	
	        /**
	         * add a handler for this query, triggering if already active
	         *
	         * @param {object} handler
	         * @param {function} handler.match callback for when query is activated
	         * @param {function} [handler.unmatch] callback for when query is deactivated
	         * @param {function} [handler.setup] callback for immediate execution when a query handler is registered
	         * @param {boolean} [handler.deferSetup=false] should the setup callback be deferred until the first time the handler is matched?
	         */
	        addHandler : function(handler) {
	            var qh = new QueryHandler(handler);
	            this.handlers.push(qh);
	
	            this.matches() && qh.on();
	        },
	
	        /**
	         * removes the given handler from the collection, and calls it's destroy methods
	         * 
	         * @param {object || function} handler the handler to remove
	         */
	        removeHandler : function(handler) {
	            var handlers = this.handlers;
	            each(handlers, function(h, i) {
	                if(h.equals(handler)) {
	                    h.destroy();
	                    return !handlers.splice(i,1); //remove from array and exit each early
	                }
	            });
	        },
	
	        /**
	         * Determine whether the media query should be considered a match
	         * 
	         * @return {Boolean} true if media query can be considered a match, false otherwise
	         */
	        matches : function() {
	            return this.mql.matches || this.isUnconditional;
	        },
	
	        /**
	         * Clears all handlers and unbinds events
	         */
	        clear : function() {
	            each(this.handlers, function(handler) {
	                handler.destroy();
	            });
	            this.mql.removeListener(this.listener);
	            this.handlers.length = 0; //clear array
	        },
	
	        /*
	         * Assesses the query, turning on all handlers if it matches, turning them off if it doesn't match
	         */
	        assess : function() {
	            var action = this.matches() ? 'on' : 'off';
	
	            each(this.handlers, function(handler) {
	                handler[action]();
	            });
	        }
	    };
	    /**
	     * Allows for registration of query handlers.
	     * Manages the query handler's state and is responsible for wiring up browser events
	     *
	     * @constructor
	     */
	    function MediaQueryDispatch () {
	        if(!matchMedia) {
	            throw new Error('matchMedia not present, legacy browsers require a polyfill');
	        }
	
	        this.queries = {};
	        this.browserIsIncapable = !matchMedia('only all').matches;
	    }
	
	    MediaQueryDispatch.prototype = {
	
	        /**
	         * Registers a handler for the given media query
	         *
	         * @param {string} q the media query
	         * @param {object || Array || Function} options either a single query handler object, a function, or an array of query handlers
	         * @param {function} options.match fired when query matched
	         * @param {function} [options.unmatch] fired when a query is no longer matched
	         * @param {function} [options.setup] fired when handler first triggered
	         * @param {boolean} [options.deferSetup=false] whether setup should be run immediately or deferred until query is first matched
	         * @param {boolean} [shouldDegrade=false] whether this particular media query should always run on incapable browsers
	         */
	        register : function(q, options, shouldDegrade) {
	            var queries         = this.queries,
	                isUnconditional = shouldDegrade && this.browserIsIncapable;
	
	            if(!queries[q]) {
	                queries[q] = new MediaQuery(q, isUnconditional);
	            }
	
	            //normalise to object in an array
	            if(isFunction(options)) {
	                options = { match : options };
	            }
	            if(!isArray(options)) {
	                options = [options];
	            }
	            each(options, function(handler) {
	                queries[q].addHandler(handler);
	            });
	
	            return this;
	        },
	
	        /**
	         * unregisters a query and all it's handlers, or a specific handler for a query
	         *
	         * @param {string} q the media query to target
	         * @param {object || function} [handler] specific handler to unregister
	         */
	        unregister : function(q, handler) {
	            var query = this.queries[q];
	
	            if(query) {
	                if(handler) {
	                    query.removeHandler(handler);
	                }
	                else {
	                    query.clear();
	                    delete this.queries[q];
	                }
	            }
	
	            return this;
	        }
	    };
	
		return new MediaQueryDispatch();
	
	}));

/***/ },
/* 538 */
/***/ function(module, exports) {

	"use strict";
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks
	 */
	
	var _hyphenPattern = /-(.)/g;
	
	/**
	 * Camelcases a hyphenated string, for example:
	 *
	 *   > camelize('background-color')
	 *   < "backgroundColor"
	 *
	 * @param {string} string
	 * @return {string}
	 */
	function camelize(string) {
	  return string.replace(_hyphenPattern, function (_, character) {
	    return character.toUpperCase();
	  });
	}
	
	module.exports = camelize;

/***/ },
/* 539 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks
	 */
	
	'use strict';
	
	var camelize = __webpack_require__(538);
	
	var msPattern = /^-ms-/;
	
	/**
	 * Camelcases a hyphenated CSS property name, for example:
	 *
	 *   > camelizeStyleName('background-color')
	 *   < "backgroundColor"
	 *   > camelizeStyleName('-moz-transition')
	 *   < "MozTransition"
	 *   > camelizeStyleName('-ms-transition')
	 *   < "msTransition"
	 *
	 * As Andi Smith suggests
	 * (http://www.andismith.com/blog/2012/02/modernizr-prefixed/), an `-ms` prefix
	 * is converted to lowercase `ms`.
	 *
	 * @param {string} string
	 * @return {string}
	 */
	function camelizeStyleName(string) {
	  return camelize(string.replace(msPattern, 'ms-'));
	}
	
	module.exports = camelizeStyleName;

/***/ },
/* 540 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	var isTextNode = __webpack_require__(548);
	
	/*eslint-disable no-bitwise */
	
	/**
	 * Checks if a given DOM node contains or is another DOM node.
	 */
	function containsNode(outerNode, innerNode) {
	  if (!outerNode || !innerNode) {
	    return false;
	  } else if (outerNode === innerNode) {
	    return true;
	  } else if (isTextNode(outerNode)) {
	    return false;
	  } else if (isTextNode(innerNode)) {
	    return containsNode(outerNode, innerNode.parentNode);
	  } else if ('contains' in outerNode) {
	    return outerNode.contains(innerNode);
	  } else if (outerNode.compareDocumentPosition) {
	    return !!(outerNode.compareDocumentPosition(innerNode) & 16);
	  } else {
	    return false;
	  }
	}
	
	module.exports = containsNode;

/***/ },
/* 541 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks
	 */
	
	var invariant = __webpack_require__(2);
	
	/**
	 * Convert array-like objects to arrays.
	 *
	 * This API assumes the caller knows the contents of the data type. For less
	 * well defined inputs use createArrayFromMixed.
	 *
	 * @param {object|function|filelist} obj
	 * @return {array}
	 */
	function toArray(obj) {
	  var length = obj.length;
	
	  // Some browsers builtin objects can report typeof 'function' (e.g. NodeList
	  // in old versions of Safari).
	  !(!Array.isArray(obj) && (typeof obj === 'object' || typeof obj === 'function')) ?  false ? invariant(false, 'toArray: Array-like object expected') : invariant(false) : void 0;
	
	  !(typeof length === 'number') ?  false ? invariant(false, 'toArray: Object needs a length property') : invariant(false) : void 0;
	
	  !(length === 0 || length - 1 in obj) ?  false ? invariant(false, 'toArray: Object should have keys for indices') : invariant(false) : void 0;
	
	  !(typeof obj.callee !== 'function') ?  false ? invariant(false, 'toArray: Object can\'t be `arguments`. Use rest params ' + '(function(...args) {}) or Array.from() instead.') : invariant(false) : void 0;
	
	  // Old IE doesn't give collections access to hasOwnProperty. Assume inputs
	  // without method will throw during the slice call and skip straight to the
	  // fallback.
	  if (obj.hasOwnProperty) {
	    try {
	      return Array.prototype.slice.call(obj);
	    } catch (e) {
	      // IE < 9 does not support Array#slice on collections objects
	    }
	  }
	
	  // Fall back to copying key by key. This assumes all keys have a value,
	  // so will not preserve sparsely populated inputs.
	  var ret = Array(length);
	  for (var ii = 0; ii < length; ii++) {
	    ret[ii] = obj[ii];
	  }
	  return ret;
	}
	
	/**
	 * Perform a heuristic test to determine if an object is "array-like".
	 *
	 *   A monk asked Joshu, a Zen master, "Has a dog Buddha nature?"
	 *   Joshu replied: "Mu."
	 *
	 * This function determines if its argument has "array nature": it returns
	 * true if the argument is an actual array, an `arguments' object, or an
	 * HTMLCollection (e.g. node.childNodes or node.getElementsByTagName()).
	 *
	 * It will return false for other array-like objects like Filelist.
	 *
	 * @param {*} obj
	 * @return {boolean}
	 */
	function hasArrayNature(obj) {
	  return(
	    // not null/false
	    !!obj && (
	    // arrays are objects, NodeLists are functions in Safari
	    typeof obj == 'object' || typeof obj == 'function') &&
	    // quacks like an array
	    'length' in obj &&
	    // not window
	    !('setInterval' in obj) &&
	    // no DOM node should be considered an array-like
	    // a 'select' element has 'length' and 'item' properties on IE8
	    typeof obj.nodeType != 'number' && (
	    // a real array
	    Array.isArray(obj) ||
	    // arguments
	    'callee' in obj ||
	    // HTMLCollection/NodeList
	    'item' in obj)
	  );
	}
	
	/**
	 * Ensure that the argument is an array by wrapping it in an array if it is not.
	 * Creates a copy of the argument if it is already an array.
	 *
	 * This is mostly useful idiomatically:
	 *
	 *   var createArrayFromMixed = require('createArrayFromMixed');
	 *
	 *   function takesOneOrMoreThings(things) {
	 *     things = createArrayFromMixed(things);
	 *     ...
	 *   }
	 *
	 * This allows you to treat `things' as an array, but accept scalars in the API.
	 *
	 * If you need to convert an array-like object, like `arguments`, into an array
	 * use toArray instead.
	 *
	 * @param {*} obj
	 * @return {array}
	 */
	function createArrayFromMixed(obj) {
	  if (!hasArrayNature(obj)) {
	    return [obj];
	  } else if (Array.isArray(obj)) {
	    return obj.slice();
	  } else {
	    return toArray(obj);
	  }
	}
	
	module.exports = createArrayFromMixed;

/***/ },
/* 542 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks
	 */
	
	/*eslint-disable fb-www/unsafe-html*/
	
	var ExecutionEnvironment = __webpack_require__(22);
	
	var createArrayFromMixed = __webpack_require__(541);
	var getMarkupWrap = __webpack_require__(543);
	var invariant = __webpack_require__(2);
	
	/**
	 * Dummy container used to render all markup.
	 */
	var dummyNode = ExecutionEnvironment.canUseDOM ? document.createElement('div') : null;
	
	/**
	 * Pattern used by `getNodeName`.
	 */
	var nodeNamePattern = /^\s*<(\w+)/;
	
	/**
	 * Extracts the `nodeName` of the first element in a string of markup.
	 *
	 * @param {string} markup String of markup.
	 * @return {?string} Node name of the supplied markup.
	 */
	function getNodeName(markup) {
	  var nodeNameMatch = markup.match(nodeNamePattern);
	  return nodeNameMatch && nodeNameMatch[1].toLowerCase();
	}
	
	/**
	 * Creates an array containing the nodes rendered from the supplied markup. The
	 * optionally supplied `handleScript` function will be invoked once for each
	 * <script> element that is rendered. If no `handleScript` function is supplied,
	 * an exception is thrown if any <script> elements are rendered.
	 *
	 * @param {string} markup A string of valid HTML markup.
	 * @param {?function} handleScript Invoked once for each rendered <script>.
	 * @return {array<DOMElement|DOMTextNode>} An array of rendered nodes.
	 */
	function createNodesFromMarkup(markup, handleScript) {
	  var node = dummyNode;
	  !!!dummyNode ?  false ? invariant(false, 'createNodesFromMarkup dummy not initialized') : invariant(false) : void 0;
	  var nodeName = getNodeName(markup);
	
	  var wrap = nodeName && getMarkupWrap(nodeName);
	  if (wrap) {
	    node.innerHTML = wrap[1] + markup + wrap[2];
	
	    var wrapDepth = wrap[0];
	    while (wrapDepth--) {
	      node = node.lastChild;
	    }
	  } else {
	    node.innerHTML = markup;
	  }
	
	  var scripts = node.getElementsByTagName('script');
	  if (scripts.length) {
	    !handleScript ?  false ? invariant(false, 'createNodesFromMarkup(...): Unexpected <script> element rendered.') : invariant(false) : void 0;
	    createArrayFromMixed(scripts).forEach(handleScript);
	  }
	
	  var nodes = Array.from(node.childNodes);
	  while (node.lastChild) {
	    node.removeChild(node.lastChild);
	  }
	  return nodes;
	}
	
	module.exports = createNodesFromMarkup;

/***/ },
/* 543 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	/*eslint-disable fb-www/unsafe-html */
	
	var ExecutionEnvironment = __webpack_require__(22);
	
	var invariant = __webpack_require__(2);
	
	/**
	 * Dummy container used to detect which wraps are necessary.
	 */
	var dummyNode = ExecutionEnvironment.canUseDOM ? document.createElement('div') : null;
	
	/**
	 * Some browsers cannot use `innerHTML` to render certain elements standalone,
	 * so we wrap them, render the wrapped nodes, then extract the desired node.
	 *
	 * In IE8, certain elements cannot render alone, so wrap all elements ('*').
	 */
	
	var shouldWrap = {};
	
	var selectWrap = [1, '<select multiple="true">', '</select>'];
	var tableWrap = [1, '<table>', '</table>'];
	var trWrap = [3, '<table><tbody><tr>', '</tr></tbody></table>'];
	
	var svgWrap = [1, '<svg xmlns="http://www.w3.org/2000/svg">', '</svg>'];
	
	var markupWrap = {
	  '*': [1, '?<div>', '</div>'],
	
	  'area': [1, '<map>', '</map>'],
	  'col': [2, '<table><tbody></tbody><colgroup>', '</colgroup></table>'],
	  'legend': [1, '<fieldset>', '</fieldset>'],
	  'param': [1, '<object>', '</object>'],
	  'tr': [2, '<table><tbody>', '</tbody></table>'],
	
	  'optgroup': selectWrap,
	  'option': selectWrap,
	
	  'caption': tableWrap,
	  'colgroup': tableWrap,
	  'tbody': tableWrap,
	  'tfoot': tableWrap,
	  'thead': tableWrap,
	
	  'td': trWrap,
	  'th': trWrap
	};
	
	// Initialize the SVG elements since we know they'll always need to be wrapped
	// consistently. If they are created inside a <div> they will be initialized in
	// the wrong namespace (and will not display).
	var svgElements = ['circle', 'clipPath', 'defs', 'ellipse', 'g', 'image', 'line', 'linearGradient', 'mask', 'path', 'pattern', 'polygon', 'polyline', 'radialGradient', 'rect', 'stop', 'text', 'tspan'];
	svgElements.forEach(function (nodeName) {
	  markupWrap[nodeName] = svgWrap;
	  shouldWrap[nodeName] = true;
	});
	
	/**
	 * Gets the markup wrap configuration for the supplied `nodeName`.
	 *
	 * NOTE: This lazily detects which wraps are necessary for the current browser.
	 *
	 * @param {string} nodeName Lowercase `nodeName`.
	 * @return {?array} Markup wrap configuration, if applicable.
	 */
	function getMarkupWrap(nodeName) {
	  !!!dummyNode ?  false ? invariant(false, 'Markup wrapping node not initialized') : invariant(false) : void 0;
	  if (!markupWrap.hasOwnProperty(nodeName)) {
	    nodeName = '*';
	  }
	  if (!shouldWrap.hasOwnProperty(nodeName)) {
	    if (nodeName === '*') {
	      dummyNode.innerHTML = '<link />';
	    } else {
	      dummyNode.innerHTML = '<' + nodeName + '></' + nodeName + '>';
	    }
	    shouldWrap[nodeName] = !dummyNode.firstChild;
	  }
	  return shouldWrap[nodeName] ? markupWrap[nodeName] : null;
	}
	
	module.exports = getMarkupWrap;

/***/ },
/* 544 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks
	 */
	
	'use strict';
	
	/**
	 * Gets the scroll position of the supplied element or window.
	 *
	 * The return values are unbounded, unlike `getScrollPosition`. This means they
	 * may be negative or exceed the element boundaries (which is possible using
	 * inertial scrolling).
	 *
	 * @param {DOMWindow|DOMElement} scrollable
	 * @return {object} Map with `x` and `y` keys.
	 */
	
	function getUnboundedScrollPosition(scrollable) {
	  if (scrollable === window) {
	    return {
	      x: window.pageXOffset || document.documentElement.scrollLeft,
	      y: window.pageYOffset || document.documentElement.scrollTop
	    };
	  }
	  return {
	    x: scrollable.scrollLeft,
	    y: scrollable.scrollTop
	  };
	}
	
	module.exports = getUnboundedScrollPosition;

/***/ },
/* 545 */
/***/ function(module, exports) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks
	 */
	
	var _uppercasePattern = /([A-Z])/g;
	
	/**
	 * Hyphenates a camelcased string, for example:
	 *
	 *   > hyphenate('backgroundColor')
	 *   < "background-color"
	 *
	 * For CSS style names, use `hyphenateStyleName` instead which works properly
	 * with all vendor prefixes, including `ms`.
	 *
	 * @param {string} string
	 * @return {string}
	 */
	function hyphenate(string) {
	  return string.replace(_uppercasePattern, '-$1').toLowerCase();
	}
	
	module.exports = hyphenate;

/***/ },
/* 546 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks
	 */
	
	'use strict';
	
	var hyphenate = __webpack_require__(545);
	
	var msPattern = /^ms-/;
	
	/**
	 * Hyphenates a camelcased CSS property name, for example:
	 *
	 *   > hyphenateStyleName('backgroundColor')
	 *   < "background-color"
	 *   > hyphenateStyleName('MozTransition')
	 *   < "-moz-transition"
	 *   > hyphenateStyleName('msTransition')
	 *   < "-ms-transition"
	 *
	 * As Modernizr suggests (http://modernizr.com/docs/#prefixed), an `ms` prefix
	 * is converted to `-ms-`.
	 *
	 * @param {string} string
	 * @return {string}
	 */
	function hyphenateStyleName(string) {
	  return hyphenate(string).replace(msPattern, '-ms-');
	}
	
	module.exports = hyphenateStyleName;

/***/ },
/* 547 */
/***/ function(module, exports) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks
	 */
	
	/**
	 * @param {*} object The object to check.
	 * @return {boolean} Whether or not the object is a DOM node.
	 */
	function isNode(object) {
	  return !!(object && (typeof Node === 'function' ? object instanceof Node : typeof object === 'object' && typeof object.nodeType === 'number' && typeof object.nodeName === 'string'));
	}
	
	module.exports = isNode;

/***/ },
/* 548 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks
	 */
	
	var isNode = __webpack_require__(547);
	
	/**
	 * @param {*} object The object to check.
	 * @return {boolean} Whether or not the object is a DOM text node.
	 */
	function isTextNode(object) {
	  return isNode(object) && object.nodeType == 3;
	}
	
	module.exports = isTextNode;

/***/ },
/* 549 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	
	/**
	 * Executes the provided `callback` once for each enumerable own property in the
	 * object and constructs a new object from the results. The `callback` is
	 * invoked with three arguments:
	 *
	 *  - the property value
	 *  - the property name
	 *  - the object being traversed
	 *
	 * Properties that are added after the call to `mapObject` will not be visited
	 * by `callback`. If the values of existing properties are changed, the value
	 * passed to `callback` will be the value at the time `mapObject` visits them.
	 * Properties that are deleted before being visited are not visited.
	 *
	 * @grep function objectMap()
	 * @grep function objMap()
	 *
	 * @param {?object} object
	 * @param {function} callback
	 * @param {*} context
	 * @return {?object}
	 */
	function mapObject(object, callback, context) {
	  if (!object) {
	    return null;
	  }
	  var result = {};
	  for (var name in object) {
	    if (hasOwnProperty.call(object, name)) {
	      result[name] = callback.call(context, object[name], name, object);
	    }
	  }
	  return result;
	}
	
	module.exports = mapObject;

/***/ },
/* 550 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 * @typechecks static-only
	 */
	
	'use strict';
	
	/**
	 * Memoizes the return value of a function that accepts one string argument.
	 */
	
	function memoizeStringOnly(callback) {
	  var cache = {};
	  return function (string) {
	    if (!cache.hasOwnProperty(string)) {
	      cache[string] = callback.call(this, string);
	    }
	    return cache[string];
	  };
	}
	
	module.exports = memoizeStringOnly;

/***/ },
/* 551 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	var loopAsync = exports.loopAsync = function loopAsync(turns, work, callback) {
	  var currentTurn = 0,
	      isDone = false;
	  var isSync = false,
	      hasNext = false,
	      doneArgs = void 0;
	
	  var done = function done() {
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    isDone = true;
	
	    if (isSync) {
	      // Iterate instead of recursing if possible.
	      doneArgs = args;
	      return;
	    }
	
	    callback.apply(undefined, args);
	  };
	
	  var next = function next() {
	    if (isDone) return;
	
	    hasNext = true;
	
	    if (isSync) return; // Iterate instead of recursing if possible.
	
	    isSync = true;
	
	    while (!isDone && currentTurn < turns && hasNext) {
	      hasNext = false;
	      work(currentTurn++, next, done);
	    }
	
	    isSync = false;
	
	    if (isDone) {
	      // This means the loop finished synchronously.
	      callback.apply(undefined, doneArgs);
	      return;
	    }
	
	    if (currentTurn >= turns && hasNext) {
	      isDone = true;
	      callback();
	    }
	  };
	
	  next();
	};

/***/ },
/* 552 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.replaceLocation = exports.pushLocation = exports.startListener = exports.getCurrentLocation = exports.go = exports.getUserConfirmation = undefined;
	
	var _BrowserProtocol = __webpack_require__(172);
	
	Object.defineProperty(exports, 'getUserConfirmation', {
	  enumerable: true,
	  get: function get() {
	    return _BrowserProtocol.getUserConfirmation;
	  }
	});
	Object.defineProperty(exports, 'go', {
	  enumerable: true,
	  get: function get() {
	    return _BrowserProtocol.go;
	  }
	});
	
	var _warning = __webpack_require__(63);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _LocationUtils = __webpack_require__(82);
	
	var _DOMUtils = __webpack_require__(119);
	
	var _DOMStateStorage = __webpack_require__(248);
	
	var _PathUtils = __webpack_require__(59);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var HashChangeEvent = 'hashchange';
	
	var getHashPath = function getHashPath() {
	  // We can't use window.location.hash here because it's not
	  // consistent across browsers - Firefox will pre-decode it!
	  var href = window.location.href;
	  var hashIndex = href.indexOf('#');
	  return hashIndex === -1 ? '' : href.substring(hashIndex + 1);
	};
	
	var pushHashPath = function pushHashPath(path) {
	  return window.location.hash = path;
	};
	
	var replaceHashPath = function replaceHashPath(path) {
	  var hashIndex = window.location.href.indexOf('#');
	
	  window.location.replace(window.location.href.slice(0, hashIndex >= 0 ? hashIndex : 0) + '#' + path);
	};
	
	var getCurrentLocation = exports.getCurrentLocation = function getCurrentLocation(pathCoder, queryKey) {
	  var path = pathCoder.decodePath(getHashPath());
	  var key = (0, _PathUtils.getQueryStringValueFromPath)(path, queryKey);
	
	  var state = void 0;
	  if (key) {
	    path = (0, _PathUtils.stripQueryStringValueFromPath)(path, queryKey);
	    state = (0, _DOMStateStorage.readState)(key);
	  }
	
	  var init = (0, _PathUtils.parsePath)(path);
	  init.state = state;
	
	  return (0, _LocationUtils.createLocation)(init, undefined, key);
	};
	
	var prevLocation = void 0;
	
	var startListener = exports.startListener = function startListener(listener, pathCoder, queryKey) {
	  var handleHashChange = function handleHashChange() {
	    var path = getHashPath();
	    var encodedPath = pathCoder.encodePath(path);
	
	    if (path !== encodedPath) {
	      // Always be sure we have a properly-encoded hash.
	      replaceHashPath(encodedPath);
	    } else {
	      var currentLocation = getCurrentLocation(pathCoder, queryKey);
	
	      if (prevLocation && currentLocation.key && prevLocation.key === currentLocation.key) return; // Ignore extraneous hashchange events
	
	      prevLocation = currentLocation;
	
	      listener(currentLocation);
	    }
	  };
	
	  // Ensure the hash is encoded properly.
	  var path = getHashPath();
	  var encodedPath = pathCoder.encodePath(path);
	
	  if (path !== encodedPath) replaceHashPath(encodedPath);
	
	  (0, _DOMUtils.addEventListener)(window, HashChangeEvent, handleHashChange);
	
	  return function () {
	    return (0, _DOMUtils.removeEventListener)(window, HashChangeEvent, handleHashChange);
	  };
	};
	
	var updateLocation = function updateLocation(location, pathCoder, queryKey, updateHash) {
	  var state = location.state;
	  var key = location.key;
	
	
	  var path = pathCoder.encodePath((0, _PathUtils.createPath)(location));
	
	  if (state !== undefined) {
	    path = (0, _PathUtils.addQueryStringValueToPath)(path, queryKey, key);
	    (0, _DOMStateStorage.saveState)(key, state);
	  }
	
	  prevLocation = location;
	
	  updateHash(path);
	};
	
	var pushLocation = exports.pushLocation = function pushLocation(location, pathCoder, queryKey) {
	  return updateLocation(location, pathCoder, queryKey, function (path) {
	    if (getHashPath() !== path) {
	      pushHashPath(path);
	    } else {
	       false ? (0, _warning2.default)(false, 'You cannot PUSH the same path using hash history') : void 0;
	    }
	  });
	};
	
	var replaceLocation = exports.replaceLocation = function replaceLocation(location, pathCoder, queryKey) {
	  return updateLocation(location, pathCoder, queryKey, function (path) {
	    if (getHashPath() !== path) replaceHashPath(path);
	  });
	};

/***/ },
/* 553 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.replaceLocation = exports.pushLocation = exports.getCurrentLocation = exports.go = exports.getUserConfirmation = undefined;
	
	var _BrowserProtocol = __webpack_require__(172);
	
	Object.defineProperty(exports, 'getUserConfirmation', {
	  enumerable: true,
	  get: function get() {
	    return _BrowserProtocol.getUserConfirmation;
	  }
	});
	Object.defineProperty(exports, 'go', {
	  enumerable: true,
	  get: function get() {
	    return _BrowserProtocol.go;
	  }
	});
	
	var _LocationUtils = __webpack_require__(82);
	
	var _PathUtils = __webpack_require__(59);
	
	var getCurrentLocation = exports.getCurrentLocation = function getCurrentLocation() {
	  return (0, _LocationUtils.createLocation)(window.location);
	};
	
	var pushLocation = exports.pushLocation = function pushLocation(location) {
	  window.location.href = (0, _PathUtils.createPath)(location);
	  return false; // Don't update location
	};
	
	var replaceLocation = exports.replaceLocation = function replaceLocation(location) {
	  window.location.replace((0, _PathUtils.createPath)(location));
	  return false; // Don't update location
	};

/***/ },
/* 554 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _invariant = __webpack_require__(23);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _ExecutionEnvironment = __webpack_require__(173);
	
	var _BrowserProtocol = __webpack_require__(172);
	
	var BrowserProtocol = _interopRequireWildcard(_BrowserProtocol);
	
	var _RefreshProtocol = __webpack_require__(553);
	
	var RefreshProtocol = _interopRequireWildcard(_RefreshProtocol);
	
	var _DOMUtils = __webpack_require__(119);
	
	var _createHistory = __webpack_require__(174);
	
	var _createHistory2 = _interopRequireDefault(_createHistory);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Creates and returns a history object that uses HTML5's history API
	 * (pushState, replaceState, and the popstate event) to manage history.
	 * This is the recommended method of managing history in browsers because
	 * it provides the cleanest URLs.
	 *
	 * Note: In browsers that do not support the HTML5 history API full
	 * page reloads will be used to preserve clean URLs. You can force this
	 * behavior using { forceRefresh: true } in options.
	 */
	var createBrowserHistory = function createBrowserHistory() {
	  var options = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	  !_ExecutionEnvironment.canUseDOM ?  false ? (0, _invariant2.default)(false, 'Browser history needs a DOM') : (0, _invariant2.default)(false) : void 0;
	
	  var useRefresh = options.forceRefresh || !(0, _DOMUtils.supportsHistory)();
	  var Protocol = useRefresh ? RefreshProtocol : BrowserProtocol;
	
	  var getUserConfirmation = Protocol.getUserConfirmation;
	  var getCurrentLocation = Protocol.getCurrentLocation;
	  var pushLocation = Protocol.pushLocation;
	  var replaceLocation = Protocol.replaceLocation;
	  var go = Protocol.go;
	
	
	  var history = (0, _createHistory2.default)(_extends({
	    getUserConfirmation: getUserConfirmation }, options, {
	    getCurrentLocation: getCurrentLocation,
	    pushLocation: pushLocation,
	    replaceLocation: replaceLocation,
	    go: go
	  }));
	
	  var listenerCount = 0,
	      stopListener = void 0;
	
	  var startListener = function startListener(listener, before) {
	    if (++listenerCount === 1) stopListener = BrowserProtocol.startListener(history.transitionTo);
	
	    var unlisten = before ? history.listenBefore(listener) : history.listen(listener);
	
	    return function () {
	      unlisten();
	
	      if (--listenerCount === 0) stopListener();
	    };
	  };
	
	  var listenBefore = function listenBefore(listener) {
	    return startListener(listener, true);
	  };
	
	  var listen = function listen(listener) {
	    return startListener(listener, false);
	  };
	
	  return _extends({}, history, {
	    listenBefore: listenBefore,
	    listen: listen
	  });
	};
	
	exports.default = createBrowserHistory;

/***/ },
/* 555 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _warning = __webpack_require__(63);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _invariant = __webpack_require__(23);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _ExecutionEnvironment = __webpack_require__(173);
	
	var _DOMUtils = __webpack_require__(119);
	
	var _HashProtocol = __webpack_require__(552);
	
	var HashProtocol = _interopRequireWildcard(_HashProtocol);
	
	var _createHistory = __webpack_require__(174);
	
	var _createHistory2 = _interopRequireDefault(_createHistory);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DefaultQueryKey = '_k';
	
	var addLeadingSlash = function addLeadingSlash(path) {
	  return path.charAt(0) === '/' ? path : '/' + path;
	};
	
	var HashPathCoders = {
	  hashbang: {
	    encodePath: function encodePath(path) {
	      return path.charAt(0) === '!' ? path : '!' + path;
	    },
	    decodePath: function decodePath(path) {
	      return path.charAt(0) === '!' ? path.substring(1) : path;
	    }
	  },
	  noslash: {
	    encodePath: function encodePath(path) {
	      return path.charAt(0) === '/' ? path.substring(1) : path;
	    },
	    decodePath: addLeadingSlash
	  },
	  slash: {
	    encodePath: addLeadingSlash,
	    decodePath: addLeadingSlash
	  }
	};
	
	var createHashHistory = function createHashHistory() {
	  var options = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	  !_ExecutionEnvironment.canUseDOM ?  false ? (0, _invariant2.default)(false, 'Hash history needs a DOM') : (0, _invariant2.default)(false) : void 0;
	
	  var queryKey = options.queryKey;
	  var hashType = options.hashType;
	
	
	   false ? (0, _warning2.default)(queryKey !== false, 'Using { queryKey: false } no longer works. Instead, just don\'t ' + 'use location state if you don\'t want a key in your URL query string') : void 0;
	
	  if (typeof queryKey !== 'string') queryKey = DefaultQueryKey;
	
	  if (hashType == null) hashType = 'slash';
	
	  if (!(hashType in HashPathCoders)) {
	     false ? (0, _warning2.default)(false, 'Invalid hash type: %s', hashType) : void 0;
	
	    hashType = 'slash';
	  }
	
	  var pathCoder = HashPathCoders[hashType];
	
	  var getUserConfirmation = HashProtocol.getUserConfirmation;
	
	
	  var getCurrentLocation = function getCurrentLocation() {
	    return HashProtocol.getCurrentLocation(pathCoder, queryKey);
	  };
	
	  var pushLocation = function pushLocation(location) {
	    return HashProtocol.pushLocation(location, pathCoder, queryKey);
	  };
	
	  var replaceLocation = function replaceLocation(location) {
	    return HashProtocol.replaceLocation(location, pathCoder, queryKey);
	  };
	
	  var history = (0, _createHistory2.default)(_extends({
	    getUserConfirmation: getUserConfirmation }, options, {
	    getCurrentLocation: getCurrentLocation,
	    pushLocation: pushLocation,
	    replaceLocation: replaceLocation,
	    go: HashProtocol.go
	  }));
	
	  var listenerCount = 0,
	      stopListener = void 0;
	
	  var startListener = function startListener(listener, before) {
	    if (++listenerCount === 1) stopListener = HashProtocol.startListener(history.transitionTo, pathCoder, queryKey);
	
	    var unlisten = before ? history.listenBefore(listener) : history.listen(listener);
	
	    return function () {
	      unlisten();
	
	      if (--listenerCount === 0) stopListener();
	    };
	  };
	
	  var listenBefore = function listenBefore(listener) {
	    return startListener(listener, true);
	  };
	
	  var listen = function listen(listener) {
	    return startListener(listener, false);
	  };
	
	  var goIsSupportedWithoutReload = (0, _DOMUtils.supportsGoWithoutReloadUsingHash)();
	
	  var go = function go(n) {
	     false ? (0, _warning2.default)(goIsSupportedWithoutReload, 'Hash history go(n) causes a full page reload in this browser') : void 0;
	
	    history.go(n);
	  };
	
	  var createHref = function createHref(path) {
	    return '#' + pathCoder.encodePath(history.createHref(path));
	  };
	
	  return _extends({}, history, {
	    listenBefore: listenBefore,
	    listen: listen,
	    go: go,
	    createHref: createHref
	  });
	};
	
	exports.default = createHashHistory;

/***/ },
/* 556 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _warning = __webpack_require__(63);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _invariant = __webpack_require__(23);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _LocationUtils = __webpack_require__(82);
	
	var _PathUtils = __webpack_require__(59);
	
	var _createHistory = __webpack_require__(174);
	
	var _createHistory2 = _interopRequireDefault(_createHistory);
	
	var _Actions = __webpack_require__(118);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var createStateStorage = function createStateStorage(entries) {
	  return entries.filter(function (entry) {
	    return entry.state;
	  }).reduce(function (memo, entry) {
	    memo[entry.key] = entry.state;
	    return memo;
	  }, {});
	};
	
	var createMemoryHistory = function createMemoryHistory() {
	  var options = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	  if (Array.isArray(options)) {
	    options = { entries: options };
	  } else if (typeof options === 'string') {
	    options = { entries: [options] };
	  }
	
	  var getCurrentLocation = function getCurrentLocation() {
	    var entry = entries[current];
	    var path = (0, _PathUtils.createPath)(entry);
	
	    var key = void 0,
	        state = void 0;
	    if (entry.key) {
	      key = entry.key;
	      state = readState(key);
	    }
	
	    var init = (0, _PathUtils.parsePath)(path);
	
	    return (0, _LocationUtils.createLocation)(_extends({}, init, { state: state }), undefined, key);
	  };
	
	  var canGo = function canGo(n) {
	    var index = current + n;
	    return index >= 0 && index < entries.length;
	  };
	
	  var go = function go(n) {
	    if (!n) return;
	
	    if (!canGo(n)) {
	       false ? (0, _warning2.default)(false, 'Cannot go(%s) there is not enough history', n) : void 0;
	
	      return;
	    }
	
	    current += n;
	    var currentLocation = getCurrentLocation();
	
	    // Change action to POP
	    history.transitionTo(_extends({}, currentLocation, { action: _Actions.POP }));
	  };
	
	  var pushLocation = function pushLocation(location) {
	    current += 1;
	
	    if (current < entries.length) entries.splice(current);
	
	    entries.push(location);
	
	    saveState(location.key, location.state);
	  };
	
	  var replaceLocation = function replaceLocation(location) {
	    entries[current] = location;
	    saveState(location.key, location.state);
	  };
	
	  var history = (0, _createHistory2.default)(_extends({}, options, {
	    getCurrentLocation: getCurrentLocation,
	    pushLocation: pushLocation,
	    replaceLocation: replaceLocation,
	    go: go
	  }));
	
	  var _options = options;
	  var entries = _options.entries;
	  var current = _options.current;
	
	
	  if (typeof entries === 'string') {
	    entries = [entries];
	  } else if (!Array.isArray(entries)) {
	    entries = ['/'];
	  }
	
	  entries = entries.map(function (entry) {
	    return (0, _LocationUtils.createLocation)(entry);
	  });
	
	  if (current == null) {
	    current = entries.length - 1;
	  } else {
	    !(current >= 0 && current < entries.length) ?  false ? (0, _invariant2.default)(false, 'Current index must be >= 0 and < %s, was %s', entries.length, current) : (0, _invariant2.default)(false) : void 0;
	  }
	
	  var storage = createStateStorage(entries);
	
	  var saveState = function saveState(key, state) {
	    return storage[key] = state;
	  };
	
	  var readState = function readState(key) {
	    return storage[key];
	  };
	
	  return _extends({}, history, {
	    canGo: canGo
	  });
	};
	
	exports.default = createMemoryHistory;

/***/ },
/* 557 */
/***/ function(module, exports) {

	/**
	 * Copyright 2015, Yahoo! Inc.
	 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
	 */
	'use strict';
	
	var REACT_STATICS = {
	    childContextTypes: true,
	    contextTypes: true,
	    defaultProps: true,
	    displayName: true,
	    getDefaultProps: true,
	    mixins: true,
	    propTypes: true,
	    type: true
	};
	
	var KNOWN_STATICS = {
	    name: true,
	    length: true,
	    prototype: true,
	    caller: true,
	    arguments: true,
	    arity: true
	};
	
	var isGetOwnPropertySymbolsAvailable = typeof Object.getOwnPropertySymbols === 'function';
	
	module.exports = function hoistNonReactStatics(targetComponent, sourceComponent, customStatics) {
	    if (typeof sourceComponent !== 'string') { // don't hoist over string (html) components
	        var keys = Object.getOwnPropertyNames(sourceComponent);
	
	        /* istanbul ignore else */
	        if (isGetOwnPropertySymbolsAvailable) {
	            keys = keys.concat(Object.getOwnPropertySymbols(sourceComponent));
	        }
	
	        for (var i = 0; i < keys.length; ++i) {
	            if (!REACT_STATICS[keys[i]] && !KNOWN_STATICS[keys[i]] && (!customStatics || !customStatics[keys[i]])) {
	                try {
	                    targetComponent[keys[i]] = sourceComponent[keys[i]];
	                } catch (error) {
	
	                }
	            }
	        }
	    }
	
	    return targetComponent;
	};


/***/ },
/* 558 */
/***/ function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(83),
	    root = __webpack_require__(24);
	
	/* Built-in method references that are verified to be native. */
	var DataView = getNative(root, 'DataView');
	
	module.exports = DataView;


/***/ },
/* 559 */
/***/ function(module, exports, __webpack_require__) {

	var hashClear = __webpack_require__(620),
	    hashDelete = __webpack_require__(621),
	    hashGet = __webpack_require__(622),
	    hashHas = __webpack_require__(623),
	    hashSet = __webpack_require__(624);
	
	/**
	 * Creates a hash object.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function Hash(entries) {
	  var index = -1,
	      length = entries ? entries.length : 0;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	// Add methods to `Hash`.
	Hash.prototype.clear = hashClear;
	Hash.prototype['delete'] = hashDelete;
	Hash.prototype.get = hashGet;
	Hash.prototype.has = hashHas;
	Hash.prototype.set = hashSet;
	
	module.exports = Hash;


/***/ },
/* 560 */
/***/ function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(83),
	    root = __webpack_require__(24);
	
	/* Built-in method references that are verified to be native. */
	var Promise = getNative(root, 'Promise');
	
	module.exports = Promise;


/***/ },
/* 561 */
/***/ function(module, exports, __webpack_require__) {

	var root = __webpack_require__(24);
	
	/** Built-in value references. */
	var Reflect = root.Reflect;
	
	module.exports = Reflect;


/***/ },
/* 562 */
/***/ function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(83),
	    root = __webpack_require__(24);
	
	/* Built-in method references that are verified to be native. */
	var Set = getNative(root, 'Set');
	
	module.exports = Set;


/***/ },
/* 563 */
/***/ function(module, exports, __webpack_require__) {

	var MapCache = __webpack_require__(177),
	    setCacheAdd = __webpack_require__(647),
	    setCacheHas = __webpack_require__(648);
	
	/**
	 *
	 * Creates an array cache object to store unique values.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [values] The values to cache.
	 */
	function SetCache(values) {
	  var index = -1,
	      length = values ? values.length : 0;
	
	  this.__data__ = new MapCache;
	  while (++index < length) {
	    this.add(values[index]);
	  }
	}
	
	// Add methods to `SetCache`.
	SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
	SetCache.prototype.has = setCacheHas;
	
	module.exports = SetCache;


/***/ },
/* 564 */
/***/ function(module, exports) {

	/**
	 * Adds the key-value `pair` to `map`.
	 *
	 * @private
	 * @param {Object} map The map to modify.
	 * @param {Array} pair The key-value pair to add.
	 * @returns {Object} Returns `map`.
	 */
	function addMapEntry(map, pair) {
	  // Don't return `Map#set` because it doesn't return the map instance in IE 11.
	  map.set(pair[0], pair[1]);
	  return map;
	}
	
	module.exports = addMapEntry;


/***/ },
/* 565 */
/***/ function(module, exports) {

	/**
	 * Adds `value` to `set`.
	 *
	 * @private
	 * @param {Object} set The set to modify.
	 * @param {*} value The value to add.
	 * @returns {Object} Returns `set`.
	 */
	function addSetEntry(set, value) {
	  set.add(value);
	  return set;
	}
	
	module.exports = addSetEntry;


/***/ },
/* 566 */
/***/ function(module, exports) {

	/**
	 * A specialized version of `_.filter` for arrays without support for
	 * iteratee shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} predicate The function invoked per iteration.
	 * @returns {Array} Returns the new filtered array.
	 */
	function arrayFilter(array, predicate) {
	  var index = -1,
	      length = array ? array.length : 0,
	      resIndex = 0,
	      result = [];
	
	  while (++index < length) {
	    var value = array[index];
	    if (predicate(value, index, array)) {
	      result[resIndex++] = value;
	    }
	  }
	  return result;
	}
	
	module.exports = arrayFilter;


/***/ },
/* 567 */
/***/ function(module, exports) {

	/**
	 * A specialized version of `_.map` for arrays without support for iteratee
	 * shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns the new mapped array.
	 */
	function arrayMap(array, iteratee) {
	  var index = -1,
	      length = array ? array.length : 0,
	      result = Array(length);
	
	  while (++index < length) {
	    result[index] = iteratee(array[index], index, array);
	  }
	  return result;
	}
	
	module.exports = arrayMap;


/***/ },
/* 568 */
/***/ function(module, exports) {

	/**
	 * Appends the elements of `values` to `array`.
	 *
	 * @private
	 * @param {Array} array The array to modify.
	 * @param {Array} values The values to append.
	 * @returns {Array} Returns `array`.
	 */
	function arrayPush(array, values) {
	  var index = -1,
	      length = values.length,
	      offset = array.length;
	
	  while (++index < length) {
	    array[offset + index] = values[index];
	  }
	  return array;
	}
	
	module.exports = arrayPush;


/***/ },
/* 569 */
/***/ function(module, exports) {

	/**
	 * A specialized version of `_.some` for arrays without support for iteratee
	 * shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} predicate The function invoked per iteration.
	 * @returns {boolean} Returns `true` if any element passes the predicate check,
	 *  else `false`.
	 */
	function arraySome(array, predicate) {
	  var index = -1,
	      length = array ? array.length : 0;
	
	  while (++index < length) {
	    if (predicate(array[index], index, array)) {
	      return true;
	    }
	  }
	  return false;
	}
	
	module.exports = arraySome;


/***/ },
/* 570 */
/***/ function(module, exports, __webpack_require__) {

	var eq = __webpack_require__(134);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Used by `_.defaults` to customize its `_.assignIn` use.
	 *
	 * @private
	 * @param {*} objValue The destination value.
	 * @param {*} srcValue The source value.
	 * @param {string} key The key of the property to assign.
	 * @param {Object} object The parent object of `objValue`.
	 * @returns {*} Returns the value to assign.
	 */
	function assignInDefaults(objValue, srcValue, key, object) {
	  if (objValue === undefined ||
	      (eq(objValue, objectProto[key]) && !hasOwnProperty.call(object, key))) {
	    return srcValue;
	  }
	  return objValue;
	}
	
	module.exports = assignInDefaults;


/***/ },
/* 571 */
/***/ function(module, exports, __webpack_require__) {

	var copyObject = __webpack_require__(94),
	    keys = __webpack_require__(40);
	
	/**
	 * The base implementation of `_.assign` without support for multiple sources
	 * or `customizer` functions.
	 *
	 * @private
	 * @param {Object} object The destination object.
	 * @param {Object} source The source object.
	 * @returns {Object} Returns `object`.
	 */
	function baseAssign(object, source) {
	  return object && copyObject(source, keys(source), object);
	}
	
	module.exports = baseAssign;


/***/ },
/* 572 */
/***/ function(module, exports, __webpack_require__) {

	var Stack = __webpack_require__(178),
	    arrayEach = __webpack_require__(256),
	    assignValue = __webpack_require__(123),
	    baseAssign = __webpack_require__(571),
	    cloneBuffer = __webpack_require__(593),
	    copyArray = __webpack_require__(182),
	    copySymbols = __webpack_require__(600),
	    getAllKeys = __webpack_require__(614),
	    getTag = __webpack_require__(185),
	    initCloneArray = __webpack_require__(625),
	    initCloneByTag = __webpack_require__(626),
	    initCloneObject = __webpack_require__(627),
	    isArray = __webpack_require__(17),
	    isBuffer = __webpack_require__(284),
	    isHostObject = __webpack_require__(186),
	    isObject = __webpack_require__(39),
	    keys = __webpack_require__(40);
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]',
	    arrayTag = '[object Array]',
	    boolTag = '[object Boolean]',
	    dateTag = '[object Date]',
	    errorTag = '[object Error]',
	    funcTag = '[object Function]',
	    genTag = '[object GeneratorFunction]',
	    mapTag = '[object Map]',
	    numberTag = '[object Number]',
	    objectTag = '[object Object]',
	    regexpTag = '[object RegExp]',
	    setTag = '[object Set]',
	    stringTag = '[object String]',
	    symbolTag = '[object Symbol]',
	    weakMapTag = '[object WeakMap]';
	
	var arrayBufferTag = '[object ArrayBuffer]',
	    dataViewTag = '[object DataView]',
	    float32Tag = '[object Float32Array]',
	    float64Tag = '[object Float64Array]',
	    int8Tag = '[object Int8Array]',
	    int16Tag = '[object Int16Array]',
	    int32Tag = '[object Int32Array]',
	    uint8Tag = '[object Uint8Array]',
	    uint8ClampedTag = '[object Uint8ClampedArray]',
	    uint16Tag = '[object Uint16Array]',
	    uint32Tag = '[object Uint32Array]';
	
	/** Used to identify `toStringTag` values supported by `_.clone`. */
	var cloneableTags = {};
	cloneableTags[argsTag] = cloneableTags[arrayTag] =
	cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] =
	cloneableTags[boolTag] = cloneableTags[dateTag] =
	cloneableTags[float32Tag] = cloneableTags[float64Tag] =
	cloneableTags[int8Tag] = cloneableTags[int16Tag] =
	cloneableTags[int32Tag] = cloneableTags[mapTag] =
	cloneableTags[numberTag] = cloneableTags[objectTag] =
	cloneableTags[regexpTag] = cloneableTags[setTag] =
	cloneableTags[stringTag] = cloneableTags[symbolTag] =
	cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
	cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
	cloneableTags[errorTag] = cloneableTags[funcTag] =
	cloneableTags[weakMapTag] = false;
	
	/**
	 * The base implementation of `_.clone` and `_.cloneDeep` which tracks
	 * traversed objects.
	 *
	 * @private
	 * @param {*} value The value to clone.
	 * @param {boolean} [isDeep] Specify a deep clone.
	 * @param {boolean} [isFull] Specify a clone including symbols.
	 * @param {Function} [customizer] The function to customize cloning.
	 * @param {string} [key] The key of `value`.
	 * @param {Object} [object] The parent object of `value`.
	 * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
	 * @returns {*} Returns the cloned value.
	 */
	function baseClone(value, isDeep, isFull, customizer, key, object, stack) {
	  var result;
	  if (customizer) {
	    result = object ? customizer(value, key, object, stack) : customizer(value);
	  }
	  if (result !== undefined) {
	    return result;
	  }
	  if (!isObject(value)) {
	    return value;
	  }
	  var isArr = isArray(value);
	  if (isArr) {
	    result = initCloneArray(value);
	    if (!isDeep) {
	      return copyArray(value, result);
	    }
	  } else {
	    var tag = getTag(value),
	        isFunc = tag == funcTag || tag == genTag;
	
	    if (isBuffer(value)) {
	      return cloneBuffer(value, isDeep);
	    }
	    if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
	      if (isHostObject(value)) {
	        return object ? value : {};
	      }
	      result = initCloneObject(isFunc ? {} : value);
	      if (!isDeep) {
	        return copySymbols(value, baseAssign(result, value));
	      }
	    } else {
	      if (!cloneableTags[tag]) {
	        return object ? value : {};
	      }
	      result = initCloneByTag(value, tag, baseClone, isDeep);
	    }
	  }
	  // Check for circular references and return its corresponding clone.
	  stack || (stack = new Stack);
	  var stacked = stack.get(value);
	  if (stacked) {
	    return stacked;
	  }
	  stack.set(value, result);
	
	  if (!isArr) {
	    var props = isFull ? getAllKeys(value) : keys(value);
	  }
	  // Recursively populate clone (susceptible to call stack limits).
	  arrayEach(props || value, function(subValue, key) {
	    if (props) {
	      key = subValue;
	      subValue = value[key];
	    }
	    assignValue(result, key, baseClone(subValue, isDeep, isFull, customizer, key, value, stack));
	  });
	  return result;
	}
	
	module.exports = baseClone;


/***/ },
/* 573 */
/***/ function(module, exports, __webpack_require__) {

	var baseEach = __webpack_require__(126);
	
	/**
	 * The base implementation of `_.filter` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} predicate The function invoked per iteration.
	 * @returns {Array} Returns the new filtered array.
	 */
	function baseFilter(collection, predicate) {
	  var result = [];
	  baseEach(collection, function(value, index, collection) {
	    if (predicate(value, index, collection)) {
	      result.push(value);
	    }
	  });
	  return result;
	}
	
	module.exports = baseFilter;


/***/ },
/* 574 */
/***/ function(module, exports, __webpack_require__) {

	var createBaseFor = __webpack_require__(604);
	
	/**
	 * The base implementation of `baseForOwn` which iterates over `object`
	 * properties returned by `keysFunc` and invokes `iteratee` for each property.
	 * Iteratee functions may exit iteration early by explicitly returning `false`.
	 *
	 * @private
	 * @param {Object} object The object to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @param {Function} keysFunc The function to get the keys of `object`.
	 * @returns {Object} Returns `object`.
	 */
	var baseFor = createBaseFor();
	
	module.exports = baseFor;


/***/ },
/* 575 */
/***/ function(module, exports, __webpack_require__) {

	var baseFor = __webpack_require__(574),
	    keys = __webpack_require__(40);
	
	/**
	 * The base implementation of `_.forOwn` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Object} object The object to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Object} Returns `object`.
	 */
	function baseForOwn(object, iteratee) {
	  return object && baseFor(object, iteratee, keys);
	}
	
	module.exports = baseForOwn;


/***/ },
/* 576 */
/***/ function(module, exports, __webpack_require__) {

	var arrayPush = __webpack_require__(568),
	    isArray = __webpack_require__(17);
	
	/**
	 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
	 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
	 * symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Function} keysFunc The function to get the keys of `object`.
	 * @param {Function} symbolsFunc The function to get the symbols of `object`.
	 * @returns {Array} Returns the array of property names and symbols.
	 */
	function baseGetAllKeys(object, keysFunc, symbolsFunc) {
	  var result = keysFunc(object);
	  return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
	}
	
	module.exports = baseGetAllKeys;


/***/ },
/* 577 */
/***/ function(module, exports) {

	/**
	 * The base implementation of `_.hasIn` without support for deep paths.
	 *
	 * @private
	 * @param {Object} [object] The object to query.
	 * @param {Array|string} key The key to check.
	 * @returns {boolean} Returns `true` if `key` exists, else `false`.
	 */
	function baseHasIn(object, key) {
	  return object != null && key in Object(object);
	}
	
	module.exports = baseHasIn;


/***/ },
/* 578 */
/***/ function(module, exports, __webpack_require__) {

	var Stack = __webpack_require__(178),
	    equalArrays = __webpack_require__(267),
	    equalByTag = __webpack_require__(612),
	    equalObjects = __webpack_require__(613),
	    getTag = __webpack_require__(185),
	    isArray = __webpack_require__(17),
	    isHostObject = __webpack_require__(186),
	    isTypedArray = __webpack_require__(667);
	
	/** Used to compose bitmasks for comparison styles. */
	var PARTIAL_COMPARE_FLAG = 2;
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]',
	    arrayTag = '[object Array]',
	    objectTag = '[object Object]';
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * A specialized version of `baseIsEqual` for arrays and objects which performs
	 * deep comparisons and tracks traversed objects enabling objects with circular
	 * references to be compared.
	 *
	 * @private
	 * @param {Object} object The object to compare.
	 * @param {Object} other The other object to compare.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Function} [customizer] The function to customize comparisons.
	 * @param {number} [bitmask] The bitmask of comparison flags. See `baseIsEqual`
	 *  for more details.
	 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
	 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	 */
	function baseIsEqualDeep(object, other, equalFunc, customizer, bitmask, stack) {
	  var objIsArr = isArray(object),
	      othIsArr = isArray(other),
	      objTag = arrayTag,
	      othTag = arrayTag;
	
	  if (!objIsArr) {
	    objTag = getTag(object);
	    objTag = objTag == argsTag ? objectTag : objTag;
	  }
	  if (!othIsArr) {
	    othTag = getTag(other);
	    othTag = othTag == argsTag ? objectTag : othTag;
	  }
	  var objIsObj = objTag == objectTag && !isHostObject(object),
	      othIsObj = othTag == objectTag && !isHostObject(other),
	      isSameTag = objTag == othTag;
	
	  if (isSameTag && !objIsObj) {
	    stack || (stack = new Stack);
	    return (objIsArr || isTypedArray(object))
	      ? equalArrays(object, other, equalFunc, customizer, bitmask, stack)
	      : equalByTag(object, other, objTag, equalFunc, customizer, bitmask, stack);
	  }
	  if (!(bitmask & PARTIAL_COMPARE_FLAG)) {
	    var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
	        othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');
	
	    if (objIsWrapped || othIsWrapped) {
	      var objUnwrapped = objIsWrapped ? object.value() : object,
	          othUnwrapped = othIsWrapped ? other.value() : other;
	
	      stack || (stack = new Stack);
	      return equalFunc(objUnwrapped, othUnwrapped, customizer, bitmask, stack);
	    }
	  }
	  if (!isSameTag) {
	    return false;
	  }
	  stack || (stack = new Stack);
	  return equalObjects(object, other, equalFunc, customizer, bitmask, stack);
	}
	
	module.exports = baseIsEqualDeep;


/***/ },
/* 579 */
/***/ function(module, exports, __webpack_require__) {

	var Stack = __webpack_require__(178),
	    baseIsEqual = __webpack_require__(259);
	
	/** Used to compose bitmasks for comparison styles. */
	var UNORDERED_COMPARE_FLAG = 1,
	    PARTIAL_COMPARE_FLAG = 2;
	
	/**
	 * The base implementation of `_.isMatch` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Object} object The object to inspect.
	 * @param {Object} source The object of property values to match.
	 * @param {Array} matchData The property names, values, and compare flags to match.
	 * @param {Function} [customizer] The function to customize comparisons.
	 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
	 */
	function baseIsMatch(object, source, matchData, customizer) {
	  var index = matchData.length,
	      length = index,
	      noCustomizer = !customizer;
	
	  if (object == null) {
	    return !length;
	  }
	  object = Object(object);
	  while (index--) {
	    var data = matchData[index];
	    if ((noCustomizer && data[2])
	          ? data[1] !== object[data[0]]
	          : !(data[0] in object)
	        ) {
	      return false;
	    }
	  }
	  while (++index < length) {
	    data = matchData[index];
	    var key = data[0],
	        objValue = object[key],
	        srcValue = data[1];
	
	    if (noCustomizer && data[2]) {
	      if (objValue === undefined && !(key in object)) {
	        return false;
	      }
	    } else {
	      var stack = new Stack;
	      if (customizer) {
	        var result = customizer(objValue, srcValue, key, object, source, stack);
	      }
	      if (!(result === undefined
	            ? baseIsEqual(srcValue, objValue, customizer, UNORDERED_COMPARE_FLAG | PARTIAL_COMPARE_FLAG, stack)
	            : result
	          )) {
	        return false;
	      }
	    }
	  }
	  return true;
	}
	
	module.exports = baseIsMatch;


/***/ },
/* 580 */
/***/ function(module, exports, __webpack_require__) {

	var isFunction = __webpack_require__(135),
	    isHostObject = __webpack_require__(186),
	    isMasked = __webpack_require__(631),
	    isObject = __webpack_require__(39),
	    toSource = __webpack_require__(278);
	
	/**
	 * Used to match `RegExp`
	 * [syntax characters](http://ecma-international.org/ecma-262/6.0/#sec-patterns).
	 */
	var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
	
	/** Used to detect host constructors (Safari). */
	var reIsHostCtor = /^\[object .+?Constructor\]$/;
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to resolve the decompiled source of functions. */
	var funcToString = Function.prototype.toString;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/** Used to detect if a method is native. */
	var reIsNative = RegExp('^' +
	  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
	  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
	);
	
	/**
	 * The base implementation of `_.isNative` without bad shim checks.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a native function,
	 *  else `false`.
	 */
	function baseIsNative(value) {
	  if (!isObject(value) || isMasked(value)) {
	    return false;
	  }
	  var pattern = (isFunction(value) || isHostObject(value)) ? reIsNative : reIsHostCtor;
	  return pattern.test(toSource(value));
	}
	
	module.exports = baseIsNative;


/***/ },
/* 581 */
/***/ function(module, exports) {

	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeKeys = Object.keys;
	
	/**
	 * The base implementation of `_.keys` which doesn't skip the constructor
	 * property of prototypes or treat sparse arrays as dense.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 */
	function baseKeys(object) {
	  return nativeKeys(Object(object));
	}
	
	module.exports = baseKeys;


/***/ },
/* 582 */
/***/ function(module, exports, __webpack_require__) {

	var Reflect = __webpack_require__(561),
	    iteratorToArray = __webpack_require__(632);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Built-in value references. */
	var enumerate = Reflect ? Reflect.enumerate : undefined,
	    propertyIsEnumerable = objectProto.propertyIsEnumerable;
	
	/**
	 * The base implementation of `_.keysIn` which doesn't skip the constructor
	 * property of prototypes or treat sparse arrays as dense.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 */
	function baseKeysIn(object) {
	  object = object == null ? object : Object(object);
	
	  var result = [];
	  for (var key in object) {
	    result.push(key);
	  }
	  return result;
	}
	
	// Fallback for IE < 9 with es6-shim.
	if (enumerate && !propertyIsEnumerable.call({ 'valueOf': 1 }, 'valueOf')) {
	  baseKeysIn = function(object) {
	    return iteratorToArray(enumerate(object));
	  };
	}
	
	module.exports = baseKeysIn;


/***/ },
/* 583 */
/***/ function(module, exports, __webpack_require__) {

	var baseEach = __webpack_require__(126),
	    isArrayLike = __webpack_require__(60);
	
	/**
	 * The base implementation of `_.map` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns the new mapped array.
	 */
	function baseMap(collection, iteratee) {
	  var index = -1,
	      result = isArrayLike(collection) ? Array(collection.length) : [];
	
	  baseEach(collection, function(value, key, collection) {
	    result[++index] = iteratee(value, key, collection);
	  });
	  return result;
	}
	
	module.exports = baseMap;


/***/ },
/* 584 */
/***/ function(module, exports, __webpack_require__) {

	var baseIsMatch = __webpack_require__(579),
	    getMatchData = __webpack_require__(617),
	    matchesStrictComparable = __webpack_require__(274);
	
	/**
	 * The base implementation of `_.matches` which doesn't clone `source`.
	 *
	 * @private
	 * @param {Object} source The object of property values to match.
	 * @returns {Function} Returns the new spec function.
	 */
	function baseMatches(source) {
	  var matchData = getMatchData(source);
	  if (matchData.length == 1 && matchData[0][2]) {
	    return matchesStrictComparable(matchData[0][0], matchData[0][1]);
	  }
	  return function(object) {
	    return object === source || baseIsMatch(object, source, matchData);
	  };
	}
	
	module.exports = baseMatches;


/***/ },
/* 585 */
/***/ function(module, exports, __webpack_require__) {

	var baseIsEqual = __webpack_require__(259),
	    get = __webpack_require__(38),
	    hasIn = __webpack_require__(665),
	    isKey = __webpack_require__(130),
	    isStrictComparable = __webpack_require__(272),
	    matchesStrictComparable = __webpack_require__(274),
	    toKey = __webpack_require__(133);
	
	/** Used to compose bitmasks for comparison styles. */
	var UNORDERED_COMPARE_FLAG = 1,
	    PARTIAL_COMPARE_FLAG = 2;
	
	/**
	 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
	 *
	 * @private
	 * @param {string} path The path of the property to get.
	 * @param {*} srcValue The value to match.
	 * @returns {Function} Returns the new spec function.
	 */
	function baseMatchesProperty(path, srcValue) {
	  if (isKey(path) && isStrictComparable(srcValue)) {
	    return matchesStrictComparable(toKey(path), srcValue);
	  }
	  return function(object) {
	    var objValue = get(object, path);
	    return (objValue === undefined && objValue === srcValue)
	      ? hasIn(object, path)
	      : baseIsEqual(srcValue, objValue, undefined, UNORDERED_COMPARE_FLAG | PARTIAL_COMPARE_FLAG);
	  };
	}
	
	module.exports = baseMatchesProperty;


/***/ },
/* 586 */
/***/ function(module, exports, __webpack_require__) {

	var baseGet = __webpack_require__(257);
	
	/**
	 * A specialized version of `baseProperty` which supports deep paths.
	 *
	 * @private
	 * @param {Array|string} path The path of the property to get.
	 * @returns {Function} Returns the new accessor function.
	 */
	function basePropertyDeep(path) {
	  return function(object) {
	    return baseGet(object, path);
	  };
	}
	
	module.exports = basePropertyDeep;


/***/ },
/* 587 */
/***/ function(module, exports) {

	/**
	 * The base implementation of `_.reduce` and `_.reduceRight`, without support
	 * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
	 *
	 * @private
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @param {*} accumulator The initial value.
	 * @param {boolean} initAccum Specify using the first or last element of
	 *  `collection` as the initial value.
	 * @param {Function} eachFunc The function to iterate over `collection`.
	 * @returns {*} Returns the accumulated value.
	 */
	function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
	  eachFunc(collection, function(value, index, collection) {
	    accumulator = initAccum
	      ? (initAccum = false, value)
	      : iteratee(accumulator, value, index, collection);
	  });
	  return accumulator;
	}
	
	module.exports = baseReduce;


/***/ },
/* 588 */
/***/ function(module, exports) {

	/**
	 * The base implementation of `_.slice` without an iteratee call guard.
	 *
	 * @private
	 * @param {Array} array The array to slice.
	 * @param {number} [start=0] The start position.
	 * @param {number} [end=array.length] The end position.
	 * @returns {Array} Returns the slice of `array`.
	 */
	function baseSlice(array, start, end) {
	  var index = -1,
	      length = array.length;
	
	  if (start < 0) {
	    start = -start > length ? 0 : (length + start);
	  }
	  end = end > length ? length : end;
	  if (end < 0) {
	    end += length;
	  }
	  length = start > end ? 0 : ((end - start) >>> 0);
	  start >>>= 0;
	
	  var result = Array(length);
	  while (++index < length) {
	    result[index] = array[index + start];
	  }
	  return result;
	}
	
	module.exports = baseSlice;


/***/ },
/* 589 */
/***/ function(module, exports) {

	/**
	 * The base implementation of `_.times` without support for iteratee shorthands
	 * or max array length checks.
	 *
	 * @private
	 * @param {number} n The number of times to invoke `iteratee`.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns the array of results.
	 */
	function baseTimes(n, iteratee) {
	  var index = -1,
	      result = Array(n);
	
	  while (++index < n) {
	    result[index] = iteratee(index);
	  }
	  return result;
	}
	
	module.exports = baseTimes;


/***/ },
/* 590 */
/***/ function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(179),
	    isSymbol = __webpack_require__(137);
	
	/** Used as references for various `Number` constants. */
	var INFINITY = 1 / 0;
	
	/** Used to convert symbols to primitives and strings. */
	var symbolProto = Symbol ? Symbol.prototype : undefined,
	    symbolToString = symbolProto ? symbolProto.toString : undefined;
	
	/**
	 * The base implementation of `_.toString` which doesn't convert nullish
	 * values to empty strings.
	 *
	 * @private
	 * @param {*} value The value to process.
	 * @returns {string} Returns the string.
	 */
	function baseToString(value) {
	  // Exit early for strings to avoid a performance hit in some environments.
	  if (typeof value == 'string') {
	    return value;
	  }
	  if (isSymbol(value)) {
	    return symbolToString ? symbolToString.call(value) : '';
	  }
	  var result = (value + '');
	  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
	}
	
	module.exports = baseToString;


/***/ },
/* 591 */
/***/ function(module, exports, __webpack_require__) {

	var baseSlice = __webpack_require__(588);
	
	/**
	 * Casts `array` to a slice if it's needed.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {number} start The start position.
	 * @param {number} [end=array.length] The end position.
	 * @returns {Array} Returns the cast slice.
	 */
	function castSlice(array, start, end) {
	  var length = array.length;
	  end = end === undefined ? length : end;
	  return (!start && end >= length) ? array : baseSlice(array, start, end);
	}
	
	module.exports = castSlice;


/***/ },
/* 592 */
/***/ function(module, exports) {

	/**
	 * Checks if `value` is a global object.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {null|Object} Returns `value` if it's a global object, else `null`.
	 */
	function checkGlobal(value) {
	  return (value && value.Object === Object) ? value : null;
	}
	
	module.exports = checkGlobal;


/***/ },
/* 593 */
/***/ function(module, exports) {

	/**
	 * Creates a clone of  `buffer`.
	 *
	 * @private
	 * @param {Buffer} buffer The buffer to clone.
	 * @param {boolean} [isDeep] Specify a deep clone.
	 * @returns {Buffer} Returns the cloned buffer.
	 */
	function cloneBuffer(buffer, isDeep) {
	  if (isDeep) {
	    return buffer.slice();
	  }
	  var result = new buffer.constructor(buffer.length);
	  buffer.copy(result);
	  return result;
	}
	
	module.exports = cloneBuffer;


/***/ },
/* 594 */
/***/ function(module, exports, __webpack_require__) {

	var cloneArrayBuffer = __webpack_require__(181);
	
	/**
	 * Creates a clone of `dataView`.
	 *
	 * @private
	 * @param {Object} dataView The data view to clone.
	 * @param {boolean} [isDeep] Specify a deep clone.
	 * @returns {Object} Returns the cloned data view.
	 */
	function cloneDataView(dataView, isDeep) {
	  var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
	  return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
	}
	
	module.exports = cloneDataView;


/***/ },
/* 595 */
/***/ function(module, exports, __webpack_require__) {

	var addMapEntry = __webpack_require__(564),
	    arrayReduce = __webpack_require__(122),
	    mapToArray = __webpack_require__(273);
	
	/**
	 * Creates a clone of `map`.
	 *
	 * @private
	 * @param {Object} map The map to clone.
	 * @param {Function} cloneFunc The function to clone values.
	 * @param {boolean} [isDeep] Specify a deep clone.
	 * @returns {Object} Returns the cloned map.
	 */
	function cloneMap(map, isDeep, cloneFunc) {
	  var array = isDeep ? cloneFunc(mapToArray(map), true) : mapToArray(map);
	  return arrayReduce(array, addMapEntry, new map.constructor);
	}
	
	module.exports = cloneMap;


/***/ },
/* 596 */
/***/ function(module, exports) {

	/** Used to match `RegExp` flags from their coerced string values. */
	var reFlags = /\w*$/;
	
	/**
	 * Creates a clone of `regexp`.
	 *
	 * @private
	 * @param {Object} regexp The regexp to clone.
	 * @returns {Object} Returns the cloned regexp.
	 */
	function cloneRegExp(regexp) {
	  var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
	  result.lastIndex = regexp.lastIndex;
	  return result;
	}
	
	module.exports = cloneRegExp;


/***/ },
/* 597 */
/***/ function(module, exports, __webpack_require__) {

	var addSetEntry = __webpack_require__(565),
	    arrayReduce = __webpack_require__(122),
	    setToArray = __webpack_require__(277);
	
	/**
	 * Creates a clone of `set`.
	 *
	 * @private
	 * @param {Object} set The set to clone.
	 * @param {Function} cloneFunc The function to clone values.
	 * @param {boolean} [isDeep] Specify a deep clone.
	 * @returns {Object} Returns the cloned set.
	 */
	function cloneSet(set, isDeep, cloneFunc) {
	  var array = isDeep ? cloneFunc(setToArray(set), true) : setToArray(set);
	  return arrayReduce(array, addSetEntry, new set.constructor);
	}
	
	module.exports = cloneSet;


/***/ },
/* 598 */
/***/ function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(179);
	
	/** Used to convert symbols to primitives and strings. */
	var symbolProto = Symbol ? Symbol.prototype : undefined,
	    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;
	
	/**
	 * Creates a clone of the `symbol` object.
	 *
	 * @private
	 * @param {Object} symbol The symbol object to clone.
	 * @returns {Object} Returns the cloned symbol object.
	 */
	function cloneSymbol(symbol) {
	  return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
	}
	
	module.exports = cloneSymbol;


/***/ },
/* 599 */
/***/ function(module, exports, __webpack_require__) {

	var cloneArrayBuffer = __webpack_require__(181);
	
	/**
	 * Creates a clone of `typedArray`.
	 *
	 * @private
	 * @param {Object} typedArray The typed array to clone.
	 * @param {boolean} [isDeep] Specify a deep clone.
	 * @returns {Object} Returns the cloned typed array.
	 */
	function cloneTypedArray(typedArray, isDeep) {
	  var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
	  return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
	}
	
	module.exports = cloneTypedArray;


/***/ },
/* 600 */
/***/ function(module, exports, __webpack_require__) {

	var copyObject = __webpack_require__(94),
	    getSymbols = __webpack_require__(270);
	
	/**
	 * Copies own symbol properties of `source` to `object`.
	 *
	 * @private
	 * @param {Object} source The object to copy symbols from.
	 * @param {Object} [object={}] The object to copy symbols to.
	 * @returns {Object} Returns `object`.
	 */
	function copySymbols(source, object) {
	  return copyObject(source, getSymbols(source), object);
	}
	
	module.exports = copySymbols;


/***/ },
/* 601 */
/***/ function(module, exports, __webpack_require__) {

	var root = __webpack_require__(24);
	
	/** Used to detect overreaching core-js shims. */
	var coreJsData = root['__core-js_shared__'];
	
	module.exports = coreJsData;


/***/ },
/* 602 */
/***/ function(module, exports) {

	/**
	 * Gets the number of `placeholder` occurrences in `array`.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {*} placeholder The placeholder to search for.
	 * @returns {number} Returns the placeholder count.
	 */
	function countHolders(array, placeholder) {
	  var length = array.length,
	      result = 0;
	
	  while (length--) {
	    if (array[length] === placeholder) {
	      result++;
	    }
	  }
	  return result;
	}
	
	module.exports = countHolders;


/***/ },
/* 603 */
/***/ function(module, exports, __webpack_require__) {

	var isArrayLike = __webpack_require__(60);
	
	/**
	 * Creates a `baseEach` or `baseEachRight` function.
	 *
	 * @private
	 * @param {Function} eachFunc The function to iterate over a collection.
	 * @param {boolean} [fromRight] Specify iterating from right to left.
	 * @returns {Function} Returns the new base function.
	 */
	function createBaseEach(eachFunc, fromRight) {
	  return function(collection, iteratee) {
	    if (collection == null) {
	      return collection;
	    }
	    if (!isArrayLike(collection)) {
	      return eachFunc(collection, iteratee);
	    }
	    var length = collection.length,
	        index = fromRight ? length : -1,
	        iterable = Object(collection);
	
	    while ((fromRight ? index-- : ++index < length)) {
	      if (iteratee(iterable[index], index, iterable) === false) {
	        break;
	      }
	    }
	    return collection;
	  };
	}
	
	module.exports = createBaseEach;


/***/ },
/* 604 */
/***/ function(module, exports) {

	/**
	 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
	 *
	 * @private
	 * @param {boolean} [fromRight] Specify iterating from right to left.
	 * @returns {Function} Returns the new base function.
	 */
	function createBaseFor(fromRight) {
	  return function(object, iteratee, keysFunc) {
	    var index = -1,
	        iterable = Object(object),
	        props = keysFunc(object),
	        length = props.length;
	
	    while (length--) {
	      var key = props[fromRight ? length : ++index];
	      if (iteratee(iterable[key], key, iterable) === false) {
	        break;
	      }
	    }
	    return object;
	  };
	}
	
	module.exports = createBaseFor;


/***/ },
/* 605 */
/***/ function(module, exports, __webpack_require__) {

	var createCtorWrapper = __webpack_require__(128),
	    root = __webpack_require__(24);
	
	/** Used to compose bitmasks for wrapper metadata. */
	var BIND_FLAG = 1;
	
	/**
	 * Creates a function that wraps `func` to invoke it with the optional `this`
	 * binding of `thisArg`.
	 *
	 * @private
	 * @param {Function} func The function to wrap.
	 * @param {number} bitmask The bitmask of wrapper flags. See `createWrapper`
	 *  for more details.
	 * @param {*} [thisArg] The `this` binding of `func`.
	 * @returns {Function} Returns the new wrapped function.
	 */
	function createBaseWrapper(func, bitmask, thisArg) {
	  var isBind = bitmask & BIND_FLAG,
	      Ctor = createCtorWrapper(func);
	
	  function wrapper() {
	    var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
	    return fn.apply(isBind ? thisArg : this, arguments);
	  }
	  return wrapper;
	}
	
	module.exports = createBaseWrapper;


/***/ },
/* 606 */
/***/ function(module, exports, __webpack_require__) {

	var castSlice = __webpack_require__(591),
	    reHasComplexSymbol = __webpack_require__(644),
	    stringToArray = __webpack_require__(654),
	    toString = __webpack_require__(97);
	
	/**
	 * Creates a function like `_.lowerFirst`.
	 *
	 * @private
	 * @param {string} methodName The name of the `String` case method to use.
	 * @returns {Function} Returns the new case function.
	 */
	function createCaseFirst(methodName) {
	  return function(string) {
	    string = toString(string);
	
	    var strSymbols = reHasComplexSymbol.test(string)
	      ? stringToArray(string)
	      : undefined;
	
	    var chr = strSymbols
	      ? strSymbols[0]
	      : string.charAt(0);
	
	    var trailing = strSymbols
	      ? castSlice(strSymbols, 1).join('')
	      : string.slice(1);
	
	    return chr[methodName]() + trailing;
	  };
	}
	
	module.exports = createCaseFirst;


/***/ },
/* 607 */
/***/ function(module, exports, __webpack_require__) {

	var arrayReduce = __webpack_require__(122),
	    deburr = __webpack_require__(663),
	    words = __webpack_require__(676);
	
	/** Used to compose unicode capture groups. */
	var rsApos = "['\u2019]";
	
	/** Used to match apostrophes. */
	var reApos = RegExp(rsApos, 'g');
	
	/**
	 * Creates a function like `_.camelCase`.
	 *
	 * @private
	 * @param {Function} callback The function to combine each word.
	 * @returns {Function} Returns the new compounder function.
	 */
	function createCompounder(callback) {
	  return function(string) {
	    return arrayReduce(words(deburr(string).replace(reApos, '')), callback, '');
	  };
	}
	
	module.exports = createCompounder;


/***/ },
/* 608 */
/***/ function(module, exports, __webpack_require__) {

	var apply = __webpack_require__(121),
	    createCtorWrapper = __webpack_require__(128),
	    createHybridWrapper = __webpack_require__(265),
	    createRecurryWrapper = __webpack_require__(266),
	    getHolder = __webpack_require__(184),
	    replaceHolders = __webpack_require__(132),
	    root = __webpack_require__(24);
	
	/**
	 * Creates a function that wraps `func` to enable currying.
	 *
	 * @private
	 * @param {Function} func The function to wrap.
	 * @param {number} bitmask The bitmask of wrapper flags. See `createWrapper`
	 *  for more details.
	 * @param {number} arity The arity of `func`.
	 * @returns {Function} Returns the new wrapped function.
	 */
	function createCurryWrapper(func, bitmask, arity) {
	  var Ctor = createCtorWrapper(func);
	
	  function wrapper() {
	    var length = arguments.length,
	        args = Array(length),
	        index = length,
	        placeholder = getHolder(wrapper);
	
	    while (index--) {
	      args[index] = arguments[index];
	    }
	    var holders = (length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder)
	      ? []
	      : replaceHolders(args, placeholder);
	
	    length -= holders.length;
	    if (length < arity) {
	      return createRecurryWrapper(
	        func, bitmask, createHybridWrapper, wrapper.placeholder, undefined,
	        args, holders, undefined, undefined, arity - length);
	    }
	    var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
	    return apply(fn, this, args);
	  }
	  return wrapper;
	}
	
	module.exports = createCurryWrapper;


/***/ },
/* 609 */
/***/ function(module, exports, __webpack_require__) {

	var apply = __webpack_require__(121),
	    createCtorWrapper = __webpack_require__(128),
	    root = __webpack_require__(24);
	
	/** Used to compose bitmasks for wrapper metadata. */
	var BIND_FLAG = 1;
	
	/**
	 * Creates a function that wraps `func` to invoke it with the `this` binding
	 * of `thisArg` and `partials` prepended to the arguments it receives.
	 *
	 * @private
	 * @param {Function} func The function to wrap.
	 * @param {number} bitmask The bitmask of wrapper flags. See `createWrapper`
	 *  for more details.
	 * @param {*} thisArg The `this` binding of `func`.
	 * @param {Array} partials The arguments to prepend to those provided to
	 *  the new function.
	 * @returns {Function} Returns the new wrapped function.
	 */
	function createPartialWrapper(func, bitmask, thisArg, partials) {
	  var isBind = bitmask & BIND_FLAG,
	      Ctor = createCtorWrapper(func);
	
	  function wrapper() {
	    var argsIndex = -1,
	        argsLength = arguments.length,
	        leftIndex = -1,
	        leftLength = partials.length,
	        args = Array(leftLength + argsLength),
	        fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
	
	    while (++leftIndex < leftLength) {
	      args[leftIndex] = partials[leftIndex];
	    }
	    while (argsLength--) {
	      args[leftIndex++] = arguments[++argsIndex];
	    }
	    return apply(fn, isBind ? thisArg : this, args);
	  }
	  return wrapper;
	}
	
	module.exports = createPartialWrapper;


/***/ },
/* 610 */
/***/ function(module, exports, __webpack_require__) {

	var baseSetData = __webpack_require__(261),
	    createBaseWrapper = __webpack_require__(605),
	    createCurryWrapper = __webpack_require__(608),
	    createHybridWrapper = __webpack_require__(265),
	    createPartialWrapper = __webpack_require__(609),
	    getData = __webpack_require__(268),
	    mergeData = __webpack_require__(643),
	    setData = __webpack_require__(276),
	    toInteger = __webpack_require__(290);
	
	/** Used as the `TypeError` message for "Functions" methods. */
	var FUNC_ERROR_TEXT = 'Expected a function';
	
	/** Used to compose bitmasks for wrapper metadata. */
	var BIND_FLAG = 1,
	    BIND_KEY_FLAG = 2,
	    CURRY_FLAG = 8,
	    CURRY_RIGHT_FLAG = 16,
	    PARTIAL_FLAG = 32,
	    PARTIAL_RIGHT_FLAG = 64;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeMax = Math.max;
	
	/**
	 * Creates a function that either curries or invokes `func` with optional
	 * `this` binding and partially applied arguments.
	 *
	 * @private
	 * @param {Function|string} func The function or method name to wrap.
	 * @param {number} bitmask The bitmask of wrapper flags.
	 *  The bitmask may be composed of the following flags:
	 *     1 - `_.bind`
	 *     2 - `_.bindKey`
	 *     4 - `_.curry` or `_.curryRight` of a bound function
	 *     8 - `_.curry`
	 *    16 - `_.curryRight`
	 *    32 - `_.partial`
	 *    64 - `_.partialRight`
	 *   128 - `_.rearg`
	 *   256 - `_.ary`
	 *   512 - `_.flip`
	 * @param {*} [thisArg] The `this` binding of `func`.
	 * @param {Array} [partials] The arguments to be partially applied.
	 * @param {Array} [holders] The `partials` placeholder indexes.
	 * @param {Array} [argPos] The argument positions of the new function.
	 * @param {number} [ary] The arity cap of `func`.
	 * @param {number} [arity] The arity of `func`.
	 * @returns {Function} Returns the new wrapped function.
	 */
	function createWrapper(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
	  var isBindKey = bitmask & BIND_KEY_FLAG;
	  if (!isBindKey && typeof func != 'function') {
	    throw new TypeError(FUNC_ERROR_TEXT);
	  }
	  var length = partials ? partials.length : 0;
	  if (!length) {
	    bitmask &= ~(PARTIAL_FLAG | PARTIAL_RIGHT_FLAG);
	    partials = holders = undefined;
	  }
	  ary = ary === undefined ? ary : nativeMax(toInteger(ary), 0);
	  arity = arity === undefined ? arity : toInteger(arity);
	  length -= holders ? holders.length : 0;
	
	  if (bitmask & PARTIAL_RIGHT_FLAG) {
	    var partialsRight = partials,
	        holdersRight = holders;
	
	    partials = holders = undefined;
	  }
	  var data = isBindKey ? undefined : getData(func);
	
	  var newData = [
	    func, bitmask, thisArg, partials, holders, partialsRight, holdersRight,
	    argPos, ary, arity
	  ];
	
	  if (data) {
	    mergeData(newData, data);
	  }
	  func = newData[0];
	  bitmask = newData[1];
	  thisArg = newData[2];
	  partials = newData[3];
	  holders = newData[4];
	  arity = newData[9] = newData[9] == null
	    ? (isBindKey ? 0 : func.length)
	    : nativeMax(newData[9] - length, 0);
	
	  if (!arity && bitmask & (CURRY_FLAG | CURRY_RIGHT_FLAG)) {
	    bitmask &= ~(CURRY_FLAG | CURRY_RIGHT_FLAG);
	  }
	  if (!bitmask || bitmask == BIND_FLAG) {
	    var result = createBaseWrapper(func, bitmask, thisArg);
	  } else if (bitmask == CURRY_FLAG || bitmask == CURRY_RIGHT_FLAG) {
	    result = createCurryWrapper(func, bitmask, arity);
	  } else if ((bitmask == PARTIAL_FLAG || bitmask == (BIND_FLAG | PARTIAL_FLAG)) && !holders.length) {
	    result = createPartialWrapper(func, bitmask, thisArg, partials);
	  } else {
	    result = createHybridWrapper.apply(undefined, newData);
	  }
	  var setter = data ? baseSetData : setData;
	  return setter(result, newData);
	}
	
	module.exports = createWrapper;


/***/ },
/* 611 */
/***/ function(module, exports) {

	/** Used to map latin-1 supplementary letters to basic latin letters. */
	var deburredLetters = {
	  '\xc0': 'A',  '\xc1': 'A', '\xc2': 'A', '\xc3': 'A', '\xc4': 'A', '\xc5': 'A',
	  '\xe0': 'a',  '\xe1': 'a', '\xe2': 'a', '\xe3': 'a', '\xe4': 'a', '\xe5': 'a',
	  '\xc7': 'C',  '\xe7': 'c',
	  '\xd0': 'D',  '\xf0': 'd',
	  '\xc8': 'E',  '\xc9': 'E', '\xca': 'E', '\xcb': 'E',
	  '\xe8': 'e',  '\xe9': 'e', '\xea': 'e', '\xeb': 'e',
	  '\xcC': 'I',  '\xcd': 'I', '\xce': 'I', '\xcf': 'I',
	  '\xeC': 'i',  '\xed': 'i', '\xee': 'i', '\xef': 'i',
	  '\xd1': 'N',  '\xf1': 'n',
	  '\xd2': 'O',  '\xd3': 'O', '\xd4': 'O', '\xd5': 'O', '\xd6': 'O', '\xd8': 'O',
	  '\xf2': 'o',  '\xf3': 'o', '\xf4': 'o', '\xf5': 'o', '\xf6': 'o', '\xf8': 'o',
	  '\xd9': 'U',  '\xda': 'U', '\xdb': 'U', '\xdc': 'U',
	  '\xf9': 'u',  '\xfa': 'u', '\xfb': 'u', '\xfc': 'u',
	  '\xdd': 'Y',  '\xfd': 'y', '\xff': 'y',
	  '\xc6': 'Ae', '\xe6': 'ae',
	  '\xde': 'Th', '\xfe': 'th',
	  '\xdf': 'ss'
	};
	
	/**
	 * Used by `_.deburr` to convert latin-1 supplementary letters to basic latin letters.
	 *
	 * @private
	 * @param {string} letter The matched letter to deburr.
	 * @returns {string} Returns the deburred letter.
	 */
	function deburrLetter(letter) {
	  return deburredLetters[letter];
	}
	
	module.exports = deburrLetter;


/***/ },
/* 612 */
/***/ function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(179),
	    Uint8Array = __webpack_require__(254),
	    equalArrays = __webpack_require__(267),
	    mapToArray = __webpack_require__(273),
	    setToArray = __webpack_require__(277);
	
	/** Used to compose bitmasks for comparison styles. */
	var UNORDERED_COMPARE_FLAG = 1,
	    PARTIAL_COMPARE_FLAG = 2;
	
	/** `Object#toString` result references. */
	var boolTag = '[object Boolean]',
	    dateTag = '[object Date]',
	    errorTag = '[object Error]',
	    mapTag = '[object Map]',
	    numberTag = '[object Number]',
	    regexpTag = '[object RegExp]',
	    setTag = '[object Set]',
	    stringTag = '[object String]',
	    symbolTag = '[object Symbol]';
	
	var arrayBufferTag = '[object ArrayBuffer]',
	    dataViewTag = '[object DataView]';
	
	/** Used to convert symbols to primitives and strings. */
	var symbolProto = Symbol ? Symbol.prototype : undefined,
	    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;
	
	/**
	 * A specialized version of `baseIsEqualDeep` for comparing objects of
	 * the same `toStringTag`.
	 *
	 * **Note:** This function only supports comparing values with tags of
	 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
	 *
	 * @private
	 * @param {Object} object The object to compare.
	 * @param {Object} other The other object to compare.
	 * @param {string} tag The `toStringTag` of the objects to compare.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Function} customizer The function to customize comparisons.
	 * @param {number} bitmask The bitmask of comparison flags. See `baseIsEqual`
	 *  for more details.
	 * @param {Object} stack Tracks traversed `object` and `other` objects.
	 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	 */
	function equalByTag(object, other, tag, equalFunc, customizer, bitmask, stack) {
	  switch (tag) {
	    case dataViewTag:
	      if ((object.byteLength != other.byteLength) ||
	          (object.byteOffset != other.byteOffset)) {
	        return false;
	      }
	      object = object.buffer;
	      other = other.buffer;
	
	    case arrayBufferTag:
	      if ((object.byteLength != other.byteLength) ||
	          !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
	        return false;
	      }
	      return true;
	
	    case boolTag:
	    case dateTag:
	      // Coerce dates and booleans to numbers, dates to milliseconds and
	      // booleans to `1` or `0` treating invalid dates coerced to `NaN` as
	      // not equal.
	      return +object == +other;
	
	    case errorTag:
	      return object.name == other.name && object.message == other.message;
	
	    case numberTag:
	      // Treat `NaN` vs. `NaN` as equal.
	      return (object != +object) ? other != +other : object == +other;
	
	    case regexpTag:
	    case stringTag:
	      // Coerce regexes to strings and treat strings, primitives and objects,
	      // as equal. See http://www.ecma-international.org/ecma-262/6.0/#sec-regexp.prototype.tostring
	      // for more details.
	      return object == (other + '');
	
	    case mapTag:
	      var convert = mapToArray;
	
	    case setTag:
	      var isPartial = bitmask & PARTIAL_COMPARE_FLAG;
	      convert || (convert = setToArray);
	
	      if (object.size != other.size && !isPartial) {
	        return false;
	      }
	      // Assume cyclic values are equal.
	      var stacked = stack.get(object);
	      if (stacked) {
	        return stacked == other;
	      }
	      bitmask |= UNORDERED_COMPARE_FLAG;
	      stack.set(object, other);
	
	      // Recursively compare objects (susceptible to call stack limits).
	      return equalArrays(convert(object), convert(other), equalFunc, customizer, bitmask, stack);
	
	    case symbolTag:
	      if (symbolValueOf) {
	        return symbolValueOf.call(object) == symbolValueOf.call(other);
	      }
	  }
	  return false;
	}
	
	module.exports = equalByTag;


/***/ },
/* 613 */
/***/ function(module, exports, __webpack_require__) {

	var baseHas = __webpack_require__(258),
	    keys = __webpack_require__(40);
	
	/** Used to compose bitmasks for comparison styles. */
	var PARTIAL_COMPARE_FLAG = 2;
	
	/**
	 * A specialized version of `baseIsEqualDeep` for objects with support for
	 * partial deep comparisons.
	 *
	 * @private
	 * @param {Object} object The object to compare.
	 * @param {Object} other The other object to compare.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Function} customizer The function to customize comparisons.
	 * @param {number} bitmask The bitmask of comparison flags. See `baseIsEqual`
	 *  for more details.
	 * @param {Object} stack Tracks traversed `object` and `other` objects.
	 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	 */
	function equalObjects(object, other, equalFunc, customizer, bitmask, stack) {
	  var isPartial = bitmask & PARTIAL_COMPARE_FLAG,
	      objProps = keys(object),
	      objLength = objProps.length,
	      othProps = keys(other),
	      othLength = othProps.length;
	
	  if (objLength != othLength && !isPartial) {
	    return false;
	  }
	  var index = objLength;
	  while (index--) {
	    var key = objProps[index];
	    if (!(isPartial ? key in other : baseHas(other, key))) {
	      return false;
	    }
	  }
	  // Assume cyclic values are equal.
	  var stacked = stack.get(object);
	  if (stacked) {
	    return stacked == other;
	  }
	  var result = true;
	  stack.set(object, other);
	
	  var skipCtor = isPartial;
	  while (++index < objLength) {
	    key = objProps[index];
	    var objValue = object[key],
	        othValue = other[key];
	
	    if (customizer) {
	      var compared = isPartial
	        ? customizer(othValue, objValue, key, other, object, stack)
	        : customizer(objValue, othValue, key, object, other, stack);
	    }
	    // Recursively compare objects (susceptible to call stack limits).
	    if (!(compared === undefined
	          ? (objValue === othValue || equalFunc(objValue, othValue, customizer, bitmask, stack))
	          : compared
	        )) {
	      result = false;
	      break;
	    }
	    skipCtor || (skipCtor = key == 'constructor');
	  }
	  if (result && !skipCtor) {
	    var objCtor = object.constructor,
	        othCtor = other.constructor;
	
	    // Non `Object` object instances with different constructors are not equal.
	    if (objCtor != othCtor &&
	        ('constructor' in object && 'constructor' in other) &&
	        !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
	          typeof othCtor == 'function' && othCtor instanceof othCtor)) {
	      result = false;
	    }
	  }
	  stack['delete'](object);
	  return result;
	}
	
	module.exports = equalObjects;


/***/ },
/* 614 */
/***/ function(module, exports, __webpack_require__) {

	var baseGetAllKeys = __webpack_require__(576),
	    getSymbols = __webpack_require__(270),
	    keys = __webpack_require__(40);
	
	/**
	 * Creates an array of own enumerable property names and symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names and symbols.
	 */
	function getAllKeys(object) {
	  return baseGetAllKeys(object, keys, getSymbols);
	}
	
	module.exports = getAllKeys;


/***/ },
/* 615 */
/***/ function(module, exports, __webpack_require__) {

	var realNames = __webpack_require__(645);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Gets the name of `func`.
	 *
	 * @private
	 * @param {Function} func The function to query.
	 * @returns {string} Returns the function name.
	 */
	function getFuncName(func) {
	  var result = (func.name + ''),
	      array = realNames[result],
	      length = hasOwnProperty.call(realNames, result) ? array.length : 0;
	
	  while (length--) {
	    var data = array[length],
	        otherFunc = data.func;
	    if (otherFunc == null || otherFunc == func) {
	      return data.name;
	    }
	  }
	  return result;
	}
	
	module.exports = getFuncName;


/***/ },
/* 616 */
/***/ function(module, exports, __webpack_require__) {

	var baseProperty = __webpack_require__(260);
	
	/**
	 * Gets the "length" property value of `object`.
	 *
	 * **Note:** This function is used to avoid a
	 * [JIT bug](https://bugs.webkit.org/show_bug.cgi?id=142792) that affects
	 * Safari on at least iOS 8.1-8.3 ARM64.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {*} Returns the "length" value.
	 */
	var getLength = baseProperty('length');
	
	module.exports = getLength;


/***/ },
/* 617 */
/***/ function(module, exports, __webpack_require__) {

	var isStrictComparable = __webpack_require__(272),
	    keys = __webpack_require__(40);
	
	/**
	 * Gets the property names, values, and compare flags of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the match data of `object`.
	 */
	function getMatchData(object) {
	  var result = keys(object),
	      length = result.length;
	
	  while (length--) {
	    var key = result[length],
	        value = object[key];
	
	    result[length] = [key, value, isStrictComparable(value)];
	  }
	  return result;
	}
	
	module.exports = getMatchData;


/***/ },
/* 618 */
/***/ function(module, exports) {

	/**
	 * Gets the value at `key` of `object`.
	 *
	 * @private
	 * @param {Object} [object] The object to query.
	 * @param {string} key The key of the property to get.
	 * @returns {*} Returns the property value.
	 */
	function getValue(object, key) {
	  return object == null ? undefined : object[key];
	}
	
	module.exports = getValue;


/***/ },
/* 619 */
/***/ function(module, exports, __webpack_require__) {

	var castPath = __webpack_require__(262),
	    isArguments = __webpack_require__(187),
	    isArray = __webpack_require__(17),
	    isIndex = __webpack_require__(95),
	    isKey = __webpack_require__(130),
	    isLength = __webpack_require__(136),
	    isString = __webpack_require__(189),
	    toKey = __webpack_require__(133);
	
	/**
	 * Checks if `path` exists on `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path to check.
	 * @param {Function} hasFunc The function to check properties.
	 * @returns {boolean} Returns `true` if `path` exists, else `false`.
	 */
	function hasPath(object, path, hasFunc) {
	  path = isKey(path, object) ? [path] : castPath(path);
	
	  var result,
	      index = -1,
	      length = path.length;
	
	  while (++index < length) {
	    var key = toKey(path[index]);
	    if (!(result = object != null && hasFunc(object, key))) {
	      break;
	    }
	    object = object[key];
	  }
	  if (result) {
	    return result;
	  }
	  var length = object ? object.length : 0;
	  return !!length && isLength(length) && isIndex(key, length) &&
	    (isArray(object) || isString(object) || isArguments(object));
	}
	
	module.exports = hasPath;


/***/ },
/* 620 */
/***/ function(module, exports, __webpack_require__) {

	var nativeCreate = __webpack_require__(131);
	
	/**
	 * Removes all key-value entries from the hash.
	 *
	 * @private
	 * @name clear
	 * @memberOf Hash
	 */
	function hashClear() {
	  this.__data__ = nativeCreate ? nativeCreate(null) : {};
	}
	
	module.exports = hashClear;


/***/ },
/* 621 */
/***/ function(module, exports) {

	/**
	 * Removes `key` and its value from the hash.
	 *
	 * @private
	 * @name delete
	 * @memberOf Hash
	 * @param {Object} hash The hash to modify.
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function hashDelete(key) {
	  return this.has(key) && delete this.__data__[key];
	}
	
	module.exports = hashDelete;


/***/ },
/* 622 */
/***/ function(module, exports, __webpack_require__) {

	var nativeCreate = __webpack_require__(131);
	
	/** Used to stand-in for `undefined` hash values. */
	var HASH_UNDEFINED = '__lodash_hash_undefined__';
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Gets the hash value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf Hash
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function hashGet(key) {
	  var data = this.__data__;
	  if (nativeCreate) {
	    var result = data[key];
	    return result === HASH_UNDEFINED ? undefined : result;
	  }
	  return hasOwnProperty.call(data, key) ? data[key] : undefined;
	}
	
	module.exports = hashGet;


/***/ },
/* 623 */
/***/ function(module, exports, __webpack_require__) {

	var nativeCreate = __webpack_require__(131);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Checks if a hash value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf Hash
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function hashHas(key) {
	  var data = this.__data__;
	  return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
	}
	
	module.exports = hashHas;


/***/ },
/* 624 */
/***/ function(module, exports, __webpack_require__) {

	var nativeCreate = __webpack_require__(131);
	
	/** Used to stand-in for `undefined` hash values. */
	var HASH_UNDEFINED = '__lodash_hash_undefined__';
	
	/**
	 * Sets the hash `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf Hash
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the hash instance.
	 */
	function hashSet(key, value) {
	  var data = this.__data__;
	  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
	  return this;
	}
	
	module.exports = hashSet;


/***/ },
/* 625 */
/***/ function(module, exports) {

	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Initializes an array clone.
	 *
	 * @private
	 * @param {Array} array The array to clone.
	 * @returns {Array} Returns the initialized clone.
	 */
	function initCloneArray(array) {
	  var length = array.length,
	      result = array.constructor(length);
	
	  // Add properties assigned by `RegExp#exec`.
	  if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
	    result.index = array.index;
	    result.input = array.input;
	  }
	  return result;
	}
	
	module.exports = initCloneArray;


/***/ },
/* 626 */
/***/ function(module, exports, __webpack_require__) {

	var cloneArrayBuffer = __webpack_require__(181),
	    cloneDataView = __webpack_require__(594),
	    cloneMap = __webpack_require__(595),
	    cloneRegExp = __webpack_require__(596),
	    cloneSet = __webpack_require__(597),
	    cloneSymbol = __webpack_require__(598),
	    cloneTypedArray = __webpack_require__(599);
	
	/** `Object#toString` result references. */
	var boolTag = '[object Boolean]',
	    dateTag = '[object Date]',
	    mapTag = '[object Map]',
	    numberTag = '[object Number]',
	    regexpTag = '[object RegExp]',
	    setTag = '[object Set]',
	    stringTag = '[object String]',
	    symbolTag = '[object Symbol]';
	
	var arrayBufferTag = '[object ArrayBuffer]',
	    dataViewTag = '[object DataView]',
	    float32Tag = '[object Float32Array]',
	    float64Tag = '[object Float64Array]',
	    int8Tag = '[object Int8Array]',
	    int16Tag = '[object Int16Array]',
	    int32Tag = '[object Int32Array]',
	    uint8Tag = '[object Uint8Array]',
	    uint8ClampedTag = '[object Uint8ClampedArray]',
	    uint16Tag = '[object Uint16Array]',
	    uint32Tag = '[object Uint32Array]';
	
	/**
	 * Initializes an object clone based on its `toStringTag`.
	 *
	 * **Note:** This function only supports cloning values with tags of
	 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
	 *
	 * @private
	 * @param {Object} object The object to clone.
	 * @param {string} tag The `toStringTag` of the object to clone.
	 * @param {Function} cloneFunc The function to clone values.
	 * @param {boolean} [isDeep] Specify a deep clone.
	 * @returns {Object} Returns the initialized clone.
	 */
	function initCloneByTag(object, tag, cloneFunc, isDeep) {
	  var Ctor = object.constructor;
	  switch (tag) {
	    case arrayBufferTag:
	      return cloneArrayBuffer(object);
	
	    case boolTag:
	    case dateTag:
	      return new Ctor(+object);
	
	    case dataViewTag:
	      return cloneDataView(object, isDeep);
	
	    case float32Tag: case float64Tag:
	    case int8Tag: case int16Tag: case int32Tag:
	    case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
	      return cloneTypedArray(object, isDeep);
	
	    case mapTag:
	      return cloneMap(object, isDeep, cloneFunc);
	
	    case numberTag:
	    case stringTag:
	      return new Ctor(object);
	
	    case regexpTag:
	      return cloneRegExp(object);
	
	    case setTag:
	      return cloneSet(object, isDeep, cloneFunc);
	
	    case symbolTag:
	      return cloneSymbol(object);
	  }
	}
	
	module.exports = initCloneByTag;


/***/ },
/* 627 */
/***/ function(module, exports, __webpack_require__) {

	var baseCreate = __webpack_require__(125),
	    getPrototype = __webpack_require__(269),
	    isPrototype = __webpack_require__(96);
	
	/**
	 * Initializes an object clone.
	 *
	 * @private
	 * @param {Object} object The object to clone.
	 * @returns {Object} Returns the initialized clone.
	 */
	function initCloneObject(object) {
	  return (typeof object.constructor == 'function' && !isPrototype(object))
	    ? baseCreate(getPrototype(object))
	    : {};
	}
	
	module.exports = initCloneObject;


/***/ },
/* 628 */
/***/ function(module, exports, __webpack_require__) {

	var eq = __webpack_require__(134),
	    isArrayLike = __webpack_require__(60),
	    isIndex = __webpack_require__(95),
	    isObject = __webpack_require__(39);
	
	/**
	 * Checks if the given arguments are from an iteratee call.
	 *
	 * @private
	 * @param {*} value The potential iteratee value argument.
	 * @param {*} index The potential iteratee index or key argument.
	 * @param {*} object The potential iteratee object argument.
	 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
	 *  else `false`.
	 */
	function isIterateeCall(value, index, object) {
	  if (!isObject(object)) {
	    return false;
	  }
	  var type = typeof index;
	  if (type == 'number'
	        ? (isArrayLike(object) && isIndex(index, object.length))
	        : (type == 'string' && index in object)
	      ) {
	    return eq(object[index], value);
	  }
	  return false;
	}
	
	module.exports = isIterateeCall;


/***/ },
/* 629 */
/***/ function(module, exports) {

	/**
	 * Checks if `value` is suitable for use as unique object key.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
	 */
	function isKeyable(value) {
	  var type = typeof value;
	  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
	    ? (value !== '__proto__')
	    : (value === null);
	}
	
	module.exports = isKeyable;


/***/ },
/* 630 */
/***/ function(module, exports, __webpack_require__) {

	var LazyWrapper = __webpack_require__(176),
	    getData = __webpack_require__(268),
	    getFuncName = __webpack_require__(615),
	    lodash = __webpack_require__(677);
	
	/**
	 * Checks if `func` has a lazy counterpart.
	 *
	 * @private
	 * @param {Function} func The function to check.
	 * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
	 *  else `false`.
	 */
	function isLaziable(func) {
	  var funcName = getFuncName(func),
	      other = lodash[funcName];
	
	  if (typeof other != 'function' || !(funcName in LazyWrapper.prototype)) {
	    return false;
	  }
	  if (func === other) {
	    return true;
	  }
	  var data = getData(other);
	  return !!data && func === data[0];
	}
	
	module.exports = isLaziable;


/***/ },
/* 631 */
/***/ function(module, exports, __webpack_require__) {

	var coreJsData = __webpack_require__(601);
	
	/** Used to detect methods masquerading as native. */
	var maskSrcKey = (function() {
	  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
	  return uid ? ('Symbol(src)_1.' + uid) : '';
	}());
	
	/**
	 * Checks if `func` has its source masked.
	 *
	 * @private
	 * @param {Function} func The function to check.
	 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
	 */
	function isMasked(func) {
	  return !!maskSrcKey && (maskSrcKey in func);
	}
	
	module.exports = isMasked;


/***/ },
/* 632 */
/***/ function(module, exports) {

	/**
	 * Converts `iterator` to an array.
	 *
	 * @private
	 * @param {Object} iterator The iterator to convert.
	 * @returns {Array} Returns the converted array.
	 */
	function iteratorToArray(iterator) {
	  var data,
	      result = [];
	
	  while (!(data = iterator.next()).done) {
	    result.push(data.value);
	  }
	  return result;
	}
	
	module.exports = iteratorToArray;


/***/ },
/* 633 */
/***/ function(module, exports) {

	/**
	 * Removes all key-value entries from the list cache.
	 *
	 * @private
	 * @name clear
	 * @memberOf ListCache
	 */
	function listCacheClear() {
	  this.__data__ = [];
	}
	
	module.exports = listCacheClear;


/***/ },
/* 634 */
/***/ function(module, exports, __webpack_require__) {

	var assocIndexOf = __webpack_require__(124);
	
	/** Used for built-in method references. */
	var arrayProto = Array.prototype;
	
	/** Built-in value references. */
	var splice = arrayProto.splice;
	
	/**
	 * Removes `key` and its value from the list cache.
	 *
	 * @private
	 * @name delete
	 * @memberOf ListCache
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function listCacheDelete(key) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  if (index < 0) {
	    return false;
	  }
	  var lastIndex = data.length - 1;
	  if (index == lastIndex) {
	    data.pop();
	  } else {
	    splice.call(data, index, 1);
	  }
	  return true;
	}
	
	module.exports = listCacheDelete;


/***/ },
/* 635 */
/***/ function(module, exports, __webpack_require__) {

	var assocIndexOf = __webpack_require__(124);
	
	/**
	 * Gets the list cache value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf ListCache
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function listCacheGet(key) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  return index < 0 ? undefined : data[index][1];
	}
	
	module.exports = listCacheGet;


/***/ },
/* 636 */
/***/ function(module, exports, __webpack_require__) {

	var assocIndexOf = __webpack_require__(124);
	
	/**
	 * Checks if a list cache value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf ListCache
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function listCacheHas(key) {
	  return assocIndexOf(this.__data__, key) > -1;
	}
	
	module.exports = listCacheHas;


/***/ },
/* 637 */
/***/ function(module, exports, __webpack_require__) {

	var assocIndexOf = __webpack_require__(124);
	
	/**
	 * Sets the list cache `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf ListCache
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the list cache instance.
	 */
	function listCacheSet(key, value) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  if (index < 0) {
	    data.push([key, value]);
	  } else {
	    data[index][1] = value;
	  }
	  return this;
	}
	
	module.exports = listCacheSet;


/***/ },
/* 638 */
/***/ function(module, exports, __webpack_require__) {

	var Hash = __webpack_require__(559),
	    ListCache = __webpack_require__(120),
	    Map = __webpack_require__(253);
	
	/**
	 * Removes all key-value entries from the map.
	 *
	 * @private
	 * @name clear
	 * @memberOf MapCache
	 */
	function mapCacheClear() {
	  this.__data__ = {
	    'hash': new Hash,
	    'map': new (Map || ListCache),
	    'string': new Hash
	  };
	}
	
	module.exports = mapCacheClear;


/***/ },
/* 639 */
/***/ function(module, exports, __webpack_require__) {

	var getMapData = __webpack_require__(129);
	
	/**
	 * Removes `key` and its value from the map.
	 *
	 * @private
	 * @name delete
	 * @memberOf MapCache
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function mapCacheDelete(key) {
	  return getMapData(this, key)['delete'](key);
	}
	
	module.exports = mapCacheDelete;


/***/ },
/* 640 */
/***/ function(module, exports, __webpack_require__) {

	var getMapData = __webpack_require__(129);
	
	/**
	 * Gets the map value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf MapCache
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function mapCacheGet(key) {
	  return getMapData(this, key).get(key);
	}
	
	module.exports = mapCacheGet;


/***/ },
/* 641 */
/***/ function(module, exports, __webpack_require__) {

	var getMapData = __webpack_require__(129);
	
	/**
	 * Checks if a map value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf MapCache
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function mapCacheHas(key) {
	  return getMapData(this, key).has(key);
	}
	
	module.exports = mapCacheHas;


/***/ },
/* 642 */
/***/ function(module, exports, __webpack_require__) {

	var getMapData = __webpack_require__(129);
	
	/**
	 * Sets the map `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf MapCache
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the map cache instance.
	 */
	function mapCacheSet(key, value) {
	  getMapData(this, key).set(key, value);
	  return this;
	}
	
	module.exports = mapCacheSet;


/***/ },
/* 643 */
/***/ function(module, exports, __webpack_require__) {

	var composeArgs = __webpack_require__(263),
	    composeArgsRight = __webpack_require__(264),
	    replaceHolders = __webpack_require__(132);
	
	/** Used as the internal argument placeholder. */
	var PLACEHOLDER = '__lodash_placeholder__';
	
	/** Used to compose bitmasks for wrapper metadata. */
	var BIND_FLAG = 1,
	    BIND_KEY_FLAG = 2,
	    CURRY_BOUND_FLAG = 4,
	    CURRY_FLAG = 8,
	    ARY_FLAG = 128,
	    REARG_FLAG = 256;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeMin = Math.min;
	
	/**
	 * Merges the function metadata of `source` into `data`.
	 *
	 * Merging metadata reduces the number of wrappers used to invoke a function.
	 * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
	 * may be applied regardless of execution order. Methods like `_.ary` and
	 * `_.rearg` modify function arguments, making the order in which they are
	 * executed important, preventing the merging of metadata. However, we make
	 * an exception for a safe combined case where curried functions have `_.ary`
	 * and or `_.rearg` applied.
	 *
	 * @private
	 * @param {Array} data The destination metadata.
	 * @param {Array} source The source metadata.
	 * @returns {Array} Returns `data`.
	 */
	function mergeData(data, source) {
	  var bitmask = data[1],
	      srcBitmask = source[1],
	      newBitmask = bitmask | srcBitmask,
	      isCommon = newBitmask < (BIND_FLAG | BIND_KEY_FLAG | ARY_FLAG);
	
	  var isCombo =
	    ((srcBitmask == ARY_FLAG) && (bitmask == CURRY_FLAG)) ||
	    ((srcBitmask == ARY_FLAG) && (bitmask == REARG_FLAG) && (data[7].length <= source[8])) ||
	    ((srcBitmask == (ARY_FLAG | REARG_FLAG)) && (source[7].length <= source[8]) && (bitmask == CURRY_FLAG));
	
	  // Exit early if metadata can't be merged.
	  if (!(isCommon || isCombo)) {
	    return data;
	  }
	  // Use source `thisArg` if available.
	  if (srcBitmask & BIND_FLAG) {
	    data[2] = source[2];
	    // Set when currying a bound function.
	    newBitmask |= bitmask & BIND_FLAG ? 0 : CURRY_BOUND_FLAG;
	  }
	  // Compose partial arguments.
	  var value = source[3];
	  if (value) {
	    var partials = data[3];
	    data[3] = partials ? composeArgs(partials, value, source[4]) : value;
	    data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : source[4];
	  }
	  // Compose partial right arguments.
	  value = source[5];
	  if (value) {
	    partials = data[5];
	    data[5] = partials ? composeArgsRight(partials, value, source[6]) : value;
	    data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : source[6];
	  }
	  // Use source `argPos` if available.
	  value = source[7];
	  if (value) {
	    data[7] = value;
	  }
	  // Use source `ary` if it's smaller.
	  if (srcBitmask & ARY_FLAG) {
	    data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
	  }
	  // Use source `arity` if one is not provided.
	  if (data[9] == null) {
	    data[9] = source[9];
	  }
	  // Use source `func` and merge bitmasks.
	  data[0] = source[0];
	  data[1] = newBitmask;
	
	  return data;
	}
	
	module.exports = mergeData;


/***/ },
/* 644 */
/***/ function(module, exports) {

	/** Used to compose unicode character classes. */
	var rsAstralRange = '\\ud800-\\udfff',
	    rsComboMarksRange = '\\u0300-\\u036f\\ufe20-\\ufe23',
	    rsComboSymbolsRange = '\\u20d0-\\u20f0',
	    rsVarRange = '\\ufe0e\\ufe0f';
	
	/** Used to compose unicode capture groups. */
	var rsZWJ = '\\u200d';
	
	/** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */
	var reHasComplexSymbol = RegExp('[' + rsZWJ + rsAstralRange  + rsComboMarksRange + rsComboSymbolsRange + rsVarRange + ']');
	
	module.exports = reHasComplexSymbol;


/***/ },
/* 645 */
/***/ function(module, exports) {

	/** Used to lookup unminified function names. */
	var realNames = {};
	
	module.exports = realNames;


/***/ },
/* 646 */
/***/ function(module, exports, __webpack_require__) {

	var copyArray = __webpack_require__(182),
	    isIndex = __webpack_require__(95);
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeMin = Math.min;
	
	/**
	 * Reorder `array` according to the specified indexes where the element at
	 * the first index is assigned as the first element, the element at
	 * the second index is assigned as the second element, and so on.
	 *
	 * @private
	 * @param {Array} array The array to reorder.
	 * @param {Array} indexes The arranged array indexes.
	 * @returns {Array} Returns `array`.
	 */
	function reorder(array, indexes) {
	  var arrLength = array.length,
	      length = nativeMin(indexes.length, arrLength),
	      oldArray = copyArray(array);
	
	  while (length--) {
	    var index = indexes[length];
	    array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined;
	  }
	  return array;
	}
	
	module.exports = reorder;


/***/ },
/* 647 */
/***/ function(module, exports) {

	/** Used to stand-in for `undefined` hash values. */
	var HASH_UNDEFINED = '__lodash_hash_undefined__';
	
	/**
	 * Adds `value` to the array cache.
	 *
	 * @private
	 * @name add
	 * @memberOf SetCache
	 * @alias push
	 * @param {*} value The value to cache.
	 * @returns {Object} Returns the cache instance.
	 */
	function setCacheAdd(value) {
	  this.__data__.set(value, HASH_UNDEFINED);
	  return this;
	}
	
	module.exports = setCacheAdd;


/***/ },
/* 648 */
/***/ function(module, exports) {

	/**
	 * Checks if `value` is in the array cache.
	 *
	 * @private
	 * @name has
	 * @memberOf SetCache
	 * @param {*} value The value to search for.
	 * @returns {number} Returns `true` if `value` is found, else `false`.
	 */
	function setCacheHas(value) {
	  return this.__data__.has(value);
	}
	
	module.exports = setCacheHas;


/***/ },
/* 649 */
/***/ function(module, exports, __webpack_require__) {

	var ListCache = __webpack_require__(120);
	
	/**
	 * Removes all key-value entries from the stack.
	 *
	 * @private
	 * @name clear
	 * @memberOf Stack
	 */
	function stackClear() {
	  this.__data__ = new ListCache;
	}
	
	module.exports = stackClear;


/***/ },
/* 650 */
/***/ function(module, exports) {

	/**
	 * Removes `key` and its value from the stack.
	 *
	 * @private
	 * @name delete
	 * @memberOf Stack
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function stackDelete(key) {
	  return this.__data__['delete'](key);
	}
	
	module.exports = stackDelete;


/***/ },
/* 651 */
/***/ function(module, exports) {

	/**
	 * Gets the stack value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf Stack
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function stackGet(key) {
	  return this.__data__.get(key);
	}
	
	module.exports = stackGet;


/***/ },
/* 652 */
/***/ function(module, exports) {

	/**
	 * Checks if a stack value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf Stack
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function stackHas(key) {
	  return this.__data__.has(key);
	}
	
	module.exports = stackHas;


/***/ },
/* 653 */
/***/ function(module, exports, __webpack_require__) {

	var ListCache = __webpack_require__(120),
	    MapCache = __webpack_require__(177);
	
	/** Used as the size to enable large array optimizations. */
	var LARGE_ARRAY_SIZE = 200;
	
	/**
	 * Sets the stack `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf Stack
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the stack cache instance.
	 */
	function stackSet(key, value) {
	  var cache = this.__data__;
	  if (cache instanceof ListCache && cache.__data__.length == LARGE_ARRAY_SIZE) {
	    cache = this.__data__ = new MapCache(cache.__data__);
	  }
	  cache.set(key, value);
	  return this;
	}
	
	module.exports = stackSet;


/***/ },
/* 654 */
/***/ function(module, exports) {

	/** Used to compose unicode character classes. */
	var rsAstralRange = '\\ud800-\\udfff',
	    rsComboMarksRange = '\\u0300-\\u036f\\ufe20-\\ufe23',
	    rsComboSymbolsRange = '\\u20d0-\\u20f0',
	    rsVarRange = '\\ufe0e\\ufe0f';
	
	/** Used to compose unicode capture groups. */
	var rsAstral = '[' + rsAstralRange + ']',
	    rsCombo = '[' + rsComboMarksRange + rsComboSymbolsRange + ']',
	    rsFitz = '\\ud83c[\\udffb-\\udfff]',
	    rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
	    rsNonAstral = '[^' + rsAstralRange + ']',
	    rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
	    rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
	    rsZWJ = '\\u200d';
	
	/** Used to compose unicode regexes. */
	var reOptMod = rsModifier + '?',
	    rsOptVar = '[' + rsVarRange + ']?',
	    rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
	    rsSeq = rsOptVar + reOptMod + rsOptJoin,
	    rsSymbol = '(?:' + [rsNonAstral + rsCombo + '?', rsCombo, rsRegional, rsSurrPair, rsAstral].join('|') + ')';
	
	/** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */
	var reComplexSymbol = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');
	
	/**
	 * Converts `string` to an array.
	 *
	 * @private
	 * @param {string} string The string to convert.
	 * @returns {Array} Returns the converted array.
	 */
	function stringToArray(string) {
	  return string.match(reComplexSymbol);
	}
	
	module.exports = stringToArray;


/***/ },
/* 655 */
/***/ function(module, exports, __webpack_require__) {

	var memoize = __webpack_require__(668),
	    toString = __webpack_require__(97);
	
	/** Used to match property names within property paths. */
	var rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(\.|\[\])(?:\4|$))/g;
	
	/** Used to match backslashes in property paths. */
	var reEscapeChar = /\\(\\)?/g;
	
	/**
	 * Converts `string` to a property path array.
	 *
	 * @private
	 * @param {string} string The string to convert.
	 * @returns {Array} Returns the property path array.
	 */
	var stringToPath = memoize(function(string) {
	  var result = [];
	  toString(string).replace(rePropName, function(match, number, quote, string) {
	    result.push(quote ? string.replace(reEscapeChar, '$1') : (number || match));
	  });
	  return result;
	});
	
	module.exports = stringToPath;


/***/ },
/* 656 */
/***/ function(module, exports, __webpack_require__) {

	var LazyWrapper = __webpack_require__(176),
	    LodashWrapper = __webpack_require__(252),
	    copyArray = __webpack_require__(182);
	
	/**
	 * Creates a clone of `wrapper`.
	 *
	 * @private
	 * @param {Object} wrapper The wrapper to clone.
	 * @returns {Object} Returns the cloned wrapper.
	 */
	function wrapperClone(wrapper) {
	  if (wrapper instanceof LazyWrapper) {
	    return wrapper.clone();
	  }
	  var result = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
	  result.__actions__ = copyArray(wrapper.__actions__);
	  result.__index__  = wrapper.__index__;
	  result.__values__ = wrapper.__values__;
	  return result;
	}
	
	module.exports = wrapperClone;


/***/ },
/* 657 */
/***/ function(module, exports, __webpack_require__) {

	var assignValue = __webpack_require__(123),
	    copyObject = __webpack_require__(94),
	    createAssigner = __webpack_require__(183),
	    isArrayLike = __webpack_require__(60),
	    isPrototype = __webpack_require__(96),
	    keysIn = __webpack_require__(285);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Built-in value references. */
	var propertyIsEnumerable = objectProto.propertyIsEnumerable;
	
	/** Detect if properties shadowing those on `Object.prototype` are non-enumerable. */
	var nonEnumShadows = !propertyIsEnumerable.call({ 'valueOf': 1 }, 'valueOf');
	
	/**
	 * This method is like `_.assign` except that it iterates over own and
	 * inherited source properties.
	 *
	 * **Note:** This method mutates `object`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @alias extend
	 * @category Object
	 * @param {Object} object The destination object.
	 * @param {...Object} [sources] The source objects.
	 * @returns {Object} Returns `object`.
	 * @see _.assign
	 * @example
	 *
	 * function Foo() {
	 *   this.b = 2;
	 * }
	 *
	 * function Bar() {
	 *   this.d = 4;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 * Bar.prototype.e = 5;
	 *
	 * _.assignIn({ 'a': 1 }, new Foo, new Bar);
	 * // => { 'a': 1, 'b': 2, 'c': 3, 'd': 4, 'e': 5 }
	 */
	var assignIn = createAssigner(function(object, source) {
	  if (nonEnumShadows || isPrototype(source) || isArrayLike(source)) {
	    copyObject(source, keysIn(source), object);
	    return;
	  }
	  for (var key in source) {
	    assignValue(object, key, source[key]);
	  }
	});
	
	module.exports = assignIn;


/***/ },
/* 658 */
/***/ function(module, exports, __webpack_require__) {

	var copyObject = __webpack_require__(94),
	    createAssigner = __webpack_require__(183),
	    keysIn = __webpack_require__(285);
	
	/**
	 * This method is like `_.assignIn` except that it accepts `customizer`
	 * which is invoked to produce the assigned values. If `customizer` returns
	 * `undefined`, assignment is handled by the method instead. The `customizer`
	 * is invoked with five arguments: (objValue, srcValue, key, object, source).
	 *
	 * **Note:** This method mutates `object`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @alias extendWith
	 * @category Object
	 * @param {Object} object The destination object.
	 * @param {...Object} sources The source objects.
	 * @param {Function} [customizer] The function to customize assigned values.
	 * @returns {Object} Returns `object`.
	 * @see _.assignWith
	 * @example
	 *
	 * function customizer(objValue, srcValue) {
	 *   return _.isUndefined(objValue) ? srcValue : objValue;
	 * }
	 *
	 * var defaults = _.partialRight(_.assignInWith, customizer);
	 *
	 * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
	 * // => { 'a': 1, 'b': 2 }
	 */
	var assignInWith = createAssigner(function(object, source, srcIndex, customizer) {
	  copyObject(source, keysIn(source), object, customizer);
	});
	
	module.exports = assignInWith;


/***/ },
/* 659 */
/***/ function(module, exports, __webpack_require__) {

	var createWrapper = __webpack_require__(610),
	    getHolder = __webpack_require__(184),
	    replaceHolders = __webpack_require__(132),
	    rest = __webpack_require__(190);
	
	/** Used to compose bitmasks for wrapper metadata. */
	var BIND_FLAG = 1,
	    PARTIAL_FLAG = 32;
	
	/**
	 * Creates a function that invokes `func` with the `this` binding of `thisArg`
	 * and `partials` prepended to the arguments it receives.
	 *
	 * The `_.bind.placeholder` value, which defaults to `_` in monolithic builds,
	 * may be used as a placeholder for partially applied arguments.
	 *
	 * **Note:** Unlike native `Function#bind`, this method doesn't set the "length"
	 * property of bound functions.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Function
	 * @param {Function} func The function to bind.
	 * @param {*} thisArg The `this` binding of `func`.
	 * @param {...*} [partials] The arguments to be partially applied.
	 * @returns {Function} Returns the new bound function.
	 * @example
	 *
	 * var greet = function(greeting, punctuation) {
	 *   return greeting + ' ' + this.user + punctuation;
	 * };
	 *
	 * var object = { 'user': 'fred' };
	 *
	 * var bound = _.bind(greet, object, 'hi');
	 * bound('!');
	 * // => 'hi fred!'
	 *
	 * // Bound with placeholders.
	 * var bound = _.bind(greet, object, _, '!');
	 * bound('hi');
	 * // => 'hi fred!'
	 */
	var bind = rest(function(func, thisArg, partials) {
	  var bitmask = BIND_FLAG;
	  if (partials.length) {
	    var holders = replaceHolders(partials, getHolder(bind));
	    bitmask |= PARTIAL_FLAG;
	  }
	  return createWrapper(func, bitmask, thisArg, partials, holders);
	});
	
	// Assign default placeholders.
	bind.placeholder = {};
	
	module.exports = bind;


/***/ },
/* 660 */
/***/ function(module, exports, __webpack_require__) {

	var capitalize = __webpack_require__(661),
	    createCompounder = __webpack_require__(607);
	
	/**
	 * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category String
	 * @param {string} [string=''] The string to convert.
	 * @returns {string} Returns the camel cased string.
	 * @example
	 *
	 * _.camelCase('Foo Bar');
	 * // => 'fooBar'
	 *
	 * _.camelCase('--foo-bar--');
	 * // => 'fooBar'
	 *
	 * _.camelCase('__FOO_BAR__');
	 * // => 'fooBar'
	 */
	var camelCase = createCompounder(function(result, word, index) {
	  word = word.toLowerCase();
	  return result + (index ? capitalize(word) : word);
	});
	
	module.exports = camelCase;


/***/ },
/* 661 */
/***/ function(module, exports, __webpack_require__) {

	var toString = __webpack_require__(97),
	    upperFirst = __webpack_require__(675);
	
	/**
	 * Converts the first character of `string` to upper case and the remaining
	 * to lower case.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category String
	 * @param {string} [string=''] The string to capitalize.
	 * @returns {string} Returns the capitalized string.
	 * @example
	 *
	 * _.capitalize('FRED');
	 * // => 'Fred'
	 */
	function capitalize(string) {
	  return upperFirst(toString(string).toLowerCase());
	}
	
	module.exports = capitalize;


/***/ },
/* 662 */
/***/ function(module, exports, __webpack_require__) {

	var baseClone = __webpack_require__(572);
	
	/**
	 * Creates a shallow clone of `value`.
	 *
	 * **Note:** This method is loosely based on the
	 * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
	 * and supports cloning arrays, array buffers, booleans, date objects, maps,
	 * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
	 * arrays. The own enumerable properties of `arguments` objects are cloned
	 * as plain objects. An empty object is returned for uncloneable values such
	 * as error objects, functions, DOM nodes, and WeakMaps.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to clone.
	 * @returns {*} Returns the cloned value.
	 * @see _.cloneDeep
	 * @example
	 *
	 * var objects = [{ 'a': 1 }, { 'b': 2 }];
	 *
	 * var shallow = _.clone(objects);
	 * console.log(shallow[0] === objects[0]);
	 * // => true
	 */
	function clone(value) {
	  return baseClone(value, false, true);
	}
	
	module.exports = clone;


/***/ },
/* 663 */
/***/ function(module, exports, __webpack_require__) {

	var deburrLetter = __webpack_require__(611),
	    toString = __webpack_require__(97);
	
	/** Used to match latin-1 supplementary letters (excluding mathematical operators). */
	var reLatin1 = /[\xc0-\xd6\xd8-\xde\xdf-\xf6\xf8-\xff]/g;
	
	/** Used to compose unicode character classes. */
	var rsComboMarksRange = '\\u0300-\\u036f\\ufe20-\\ufe23',
	    rsComboSymbolsRange = '\\u20d0-\\u20f0';
	
	/** Used to compose unicode capture groups. */
	var rsCombo = '[' + rsComboMarksRange + rsComboSymbolsRange + ']';
	
	/**
	 * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
	 * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
	 */
	var reComboMark = RegExp(rsCombo, 'g');
	
	/**
	 * Deburrs `string` by converting
	 * [latin-1 supplementary letters](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
	 * to basic latin letters and removing
	 * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category String
	 * @param {string} [string=''] The string to deburr.
	 * @returns {string} Returns the deburred string.
	 * @example
	 *
	 * _.deburr('déjà vu');
	 * // => 'deja vu'
	 */
	function deburr(string) {
	  string = toString(string);
	  return string && string.replace(reLatin1, deburrLetter).replace(reComboMark, '');
	}
	
	module.exports = deburr;


/***/ },
/* 664 */
/***/ function(module, exports, __webpack_require__) {

	var arrayEach = __webpack_require__(256),
	    baseEach = __webpack_require__(126),
	    baseIteratee = __webpack_require__(127),
	    isArray = __webpack_require__(17);
	
	/**
	 * Iterates over elements of `collection` and invokes `iteratee` for each element.
	 * The iteratee is invoked with three arguments: (value, index|key, collection).
	 * Iteratee functions may exit iteration early by explicitly returning `false`.
	 *
	 * **Note:** As with other "Collections" methods, objects with a "length"
	 * property are iterated like arrays. To avoid this behavior use `_.forIn`
	 * or `_.forOwn` for object iteration.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @alias each
	 * @category Collection
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	 * @returns {Array|Object} Returns `collection`.
	 * @see _.forEachRight
	 * @example
	 *
	 * _([1, 2]).forEach(function(value) {
	 *   console.log(value);
	 * });
	 * // => Logs `1` then `2`.
	 *
	 * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
	 *   console.log(key);
	 * });
	 * // => Logs 'a' then 'b' (iteration order is not guaranteed).
	 */
	function forEach(collection, iteratee) {
	  var func = isArray(collection) ? arrayEach : baseEach;
	  return func(collection, baseIteratee(iteratee, 3));
	}
	
	module.exports = forEach;


/***/ },
/* 665 */
/***/ function(module, exports, __webpack_require__) {

	var baseHasIn = __webpack_require__(577),
	    hasPath = __webpack_require__(619);
	
	/**
	 * Checks if `path` is a direct or inherited property of `object`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Object
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path to check.
	 * @returns {boolean} Returns `true` if `path` exists, else `false`.
	 * @example
	 *
	 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
	 *
	 * _.hasIn(object, 'a');
	 * // => true
	 *
	 * _.hasIn(object, 'a.b');
	 * // => true
	 *
	 * _.hasIn(object, ['a', 'b']);
	 * // => true
	 *
	 * _.hasIn(object, 'b');
	 * // => false
	 */
	function hasIn(object, path) {
	  return object != null && hasPath(object, path, baseHasIn);
	}
	
	module.exports = hasIn;


/***/ },
/* 666 */
/***/ function(module, exports, __webpack_require__) {

	var isArrayLike = __webpack_require__(60),
	    isObjectLike = __webpack_require__(73);
	
	/**
	 * This method is like `_.isArrayLike` except that it also checks if `value`
	 * is an object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an array-like object,
	 *  else `false`.
	 * @example
	 *
	 * _.isArrayLikeObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isArrayLikeObject(document.body.children);
	 * // => true
	 *
	 * _.isArrayLikeObject('abc');
	 * // => false
	 *
	 * _.isArrayLikeObject(_.noop);
	 * // => false
	 */
	function isArrayLikeObject(value) {
	  return isObjectLike(value) && isArrayLike(value);
	}
	
	module.exports = isArrayLikeObject;


/***/ },
/* 667 */
/***/ function(module, exports, __webpack_require__) {

	var isLength = __webpack_require__(136),
	    isObjectLike = __webpack_require__(73);
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]',
	    arrayTag = '[object Array]',
	    boolTag = '[object Boolean]',
	    dateTag = '[object Date]',
	    errorTag = '[object Error]',
	    funcTag = '[object Function]',
	    mapTag = '[object Map]',
	    numberTag = '[object Number]',
	    objectTag = '[object Object]',
	    regexpTag = '[object RegExp]',
	    setTag = '[object Set]',
	    stringTag = '[object String]',
	    weakMapTag = '[object WeakMap]';
	
	var arrayBufferTag = '[object ArrayBuffer]',
	    dataViewTag = '[object DataView]',
	    float32Tag = '[object Float32Array]',
	    float64Tag = '[object Float64Array]',
	    int8Tag = '[object Int8Array]',
	    int16Tag = '[object Int16Array]',
	    int32Tag = '[object Int32Array]',
	    uint8Tag = '[object Uint8Array]',
	    uint8ClampedTag = '[object Uint8ClampedArray]',
	    uint16Tag = '[object Uint16Array]',
	    uint32Tag = '[object Uint32Array]';
	
	/** Used to identify `toStringTag` values of typed arrays. */
	var typedArrayTags = {};
	typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
	typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
	typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
	typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
	typedArrayTags[uint32Tag] = true;
	typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
	typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
	typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
	typedArrayTags[errorTag] = typedArrayTags[funcTag] =
	typedArrayTags[mapTag] = typedArrayTags[numberTag] =
	typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
	typedArrayTags[setTag] = typedArrayTags[stringTag] =
	typedArrayTags[weakMapTag] = false;
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objectToString = objectProto.toString;
	
	/**
	 * Checks if `value` is classified as a typed array.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is correctly classified,
	 *  else `false`.
	 * @example
	 *
	 * _.isTypedArray(new Uint8Array);
	 * // => true
	 *
	 * _.isTypedArray([]);
	 * // => false
	 */
	function isTypedArray(value) {
	  return isObjectLike(value) &&
	    isLength(value.length) && !!typedArrayTags[objectToString.call(value)];
	}
	
	module.exports = isTypedArray;


/***/ },
/* 668 */
/***/ function(module, exports, __webpack_require__) {

	var MapCache = __webpack_require__(177);
	
	/** Used as the `TypeError` message for "Functions" methods. */
	var FUNC_ERROR_TEXT = 'Expected a function';
	
	/**
	 * Creates a function that memoizes the result of `func`. If `resolver` is
	 * provided, it determines the cache key for storing the result based on the
	 * arguments provided to the memoized function. By default, the first argument
	 * provided to the memoized function is used as the map cache key. The `func`
	 * is invoked with the `this` binding of the memoized function.
	 *
	 * **Note:** The cache is exposed as the `cache` property on the memoized
	 * function. Its creation may be customized by replacing the `_.memoize.Cache`
	 * constructor with one whose instances implement the
	 * [`Map`](http://ecma-international.org/ecma-262/6.0/#sec-properties-of-the-map-prototype-object)
	 * method interface of `delete`, `get`, `has`, and `set`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Function
	 * @param {Function} func The function to have its output memoized.
	 * @param {Function} [resolver] The function to resolve the cache key.
	 * @returns {Function} Returns the new memoized function.
	 * @example
	 *
	 * var object = { 'a': 1, 'b': 2 };
	 * var other = { 'c': 3, 'd': 4 };
	 *
	 * var values = _.memoize(_.values);
	 * values(object);
	 * // => [1, 2]
	 *
	 * values(other);
	 * // => [3, 4]
	 *
	 * object.a = 2;
	 * values(object);
	 * // => [1, 2]
	 *
	 * // Modify the result cache.
	 * values.cache.set(object, ['a', 'b']);
	 * values(object);
	 * // => ['a', 'b']
	 *
	 * // Replace `_.memoize.Cache`.
	 * _.memoize.Cache = WeakMap;
	 */
	function memoize(func, resolver) {
	  if (typeof func != 'function' || (resolver && typeof resolver != 'function')) {
	    throw new TypeError(FUNC_ERROR_TEXT);
	  }
	  var memoized = function() {
	    var args = arguments,
	        key = resolver ? resolver.apply(this, args) : args[0],
	        cache = memoized.cache;
	
	    if (cache.has(key)) {
	      return cache.get(key);
	    }
	    var result = func.apply(this, args);
	    memoized.cache = cache.set(key, result);
	    return result;
	  };
	  memoized.cache = new (memoize.Cache || MapCache);
	  return memoized;
	}
	
	// Assign cache to `_.memoize`.
	memoize.Cache = MapCache;
	
	module.exports = memoize;


/***/ },
/* 669 */
/***/ function(module, exports) {

	/**
	 * A method that returns `undefined`.
	 *
	 * @static
	 * @memberOf _
	 * @since 2.3.0
	 * @category Util
	 * @example
	 *
	 * _.times(2, _.noop);
	 * // => [undefined, undefined]
	 */
	function noop() {
	  // No operation performed.
	}
	
	module.exports = noop;


/***/ },
/* 670 */
/***/ function(module, exports, __webpack_require__) {

	var baseProperty = __webpack_require__(260),
	    basePropertyDeep = __webpack_require__(586),
	    isKey = __webpack_require__(130),
	    toKey = __webpack_require__(133);
	
	/**
	 * Creates a function that returns the value at `path` of a given object.
	 *
	 * @static
	 * @memberOf _
	 * @since 2.4.0
	 * @category Util
	 * @param {Array|string} path The path of the property to get.
	 * @returns {Function} Returns the new accessor function.
	 * @example
	 *
	 * var objects = [
	 *   { 'a': { 'b': 2 } },
	 *   { 'a': { 'b': 1 } }
	 * ];
	 *
	 * _.map(objects, _.property('a.b'));
	 * // => [2, 1]
	 *
	 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
	 * // => [1, 2]
	 */
	function property(path) {
	  return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
	}
	
	module.exports = property;


/***/ },
/* 671 */
/***/ function(module, exports, __webpack_require__) {

	var arrayFilter = __webpack_require__(566),
	    baseFilter = __webpack_require__(573),
	    baseIteratee = __webpack_require__(127),
	    isArray = __webpack_require__(17);
	
	/**
	 * The opposite of `_.filter`; this method returns the elements of `collection`
	 * that `predicate` does **not** return truthy for.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Collection
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Array|Function|Object|string} [predicate=_.identity]
	 *  The function invoked per iteration.
	 * @returns {Array} Returns the new filtered array.
	 * @see _.filter
	 * @example
	 *
	 * var users = [
	 *   { 'user': 'barney', 'age': 36, 'active': false },
	 *   { 'user': 'fred',   'age': 40, 'active': true }
	 * ];
	 *
	 * _.reject(users, function(o) { return !o.active; });
	 * // => objects for ['fred']
	 *
	 * // The `_.matches` iteratee shorthand.
	 * _.reject(users, { 'age': 40, 'active': true });
	 * // => objects for ['barney']
	 *
	 * // The `_.matchesProperty` iteratee shorthand.
	 * _.reject(users, ['active', false]);
	 * // => objects for ['fred']
	 *
	 * // The `_.property` iteratee shorthand.
	 * _.reject(users, 'active');
	 * // => objects for ['barney']
	 */
	function reject(collection, predicate) {
	  var func = isArray(collection) ? arrayFilter : baseFilter;
	  predicate = baseIteratee(predicate, 3);
	  return func(collection, function(value, index, collection) {
	    return !predicate(value, index, collection);
	  });
	}
	
	module.exports = reject;


/***/ },
/* 672 */
/***/ function(module, exports) {

	/**
	 * A method that returns a new empty array.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.13.0
	 * @category Util
	 * @returns {Array} Returns the new empty array.
	 * @example
	 *
	 * var arrays = _.times(2, _.stubArray);
	 *
	 * console.log(arrays);
	 * // => [[], []]
	 *
	 * console.log(arrays[0] === arrays[1]);
	 * // => false
	 */
	function stubArray() {
	  return [];
	}
	
	module.exports = stubArray;


/***/ },
/* 673 */
/***/ function(module, exports) {

	/**
	 * A method that returns `false`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.13.0
	 * @category Util
	 * @returns {boolean} Returns `false`.
	 * @example
	 *
	 * _.times(2, _.stubFalse);
	 * // => [false, false]
	 */
	function stubFalse() {
	  return false;
	}
	
	module.exports = stubFalse;


/***/ },
/* 674 */
/***/ function(module, exports, __webpack_require__) {

	var toNumber = __webpack_require__(291);
	
	/** Used as references for various `Number` constants. */
	var INFINITY = 1 / 0,
	    MAX_INTEGER = 1.7976931348623157e+308;
	
	/**
	 * Converts `value` to a finite number.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.12.0
	 * @category Lang
	 * @param {*} value The value to convert.
	 * @returns {number} Returns the converted number.
	 * @example
	 *
	 * _.toFinite(3.2);
	 * // => 3.2
	 *
	 * _.toFinite(Number.MIN_VALUE);
	 * // => 5e-324
	 *
	 * _.toFinite(Infinity);
	 * // => 1.7976931348623157e+308
	 *
	 * _.toFinite('3.2');
	 * // => 3.2
	 */
	function toFinite(value) {
	  if (!value) {
	    return value === 0 ? value : 0;
	  }
	  value = toNumber(value);
	  if (value === INFINITY || value === -INFINITY) {
	    var sign = (value < 0 ? -1 : 1);
	    return sign * MAX_INTEGER;
	  }
	  return value === value ? value : 0;
	}
	
	module.exports = toFinite;


/***/ },
/* 675 */
/***/ function(module, exports, __webpack_require__) {

	var createCaseFirst = __webpack_require__(606);
	
	/**
	 * Converts the first character of `string` to upper case.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category String
	 * @param {string} [string=''] The string to convert.
	 * @returns {string} Returns the converted string.
	 * @example
	 *
	 * _.upperFirst('fred');
	 * // => 'Fred'
	 *
	 * _.upperFirst('FRED');
	 * // => 'FRED'
	 */
	var upperFirst = createCaseFirst('toUpperCase');
	
	module.exports = upperFirst;


/***/ },
/* 676 */
/***/ function(module, exports, __webpack_require__) {

	var toString = __webpack_require__(97);
	
	/** Used to match non-compound words composed of alphanumeric characters. */
	var reBasicWord = /[a-zA-Z0-9]+/g;
	
	/** Used to compose unicode character classes. */
	var rsAstralRange = '\\ud800-\\udfff',
	    rsComboMarksRange = '\\u0300-\\u036f\\ufe20-\\ufe23',
	    rsComboSymbolsRange = '\\u20d0-\\u20f0',
	    rsDingbatRange = '\\u2700-\\u27bf',
	    rsLowerRange = 'a-z\\xdf-\\xf6\\xf8-\\xff',
	    rsMathOpRange = '\\xac\\xb1\\xd7\\xf7',
	    rsNonCharRange = '\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf',
	    rsPunctuationRange = '\\u2000-\\u206f',
	    rsSpaceRange = ' \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000',
	    rsUpperRange = 'A-Z\\xc0-\\xd6\\xd8-\\xde',
	    rsVarRange = '\\ufe0e\\ufe0f',
	    rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;
	
	/** Used to compose unicode capture groups. */
	var rsApos = "['\u2019]",
	    rsBreak = '[' + rsBreakRange + ']',
	    rsCombo = '[' + rsComboMarksRange + rsComboSymbolsRange + ']',
	    rsDigits = '\\d+',
	    rsDingbat = '[' + rsDingbatRange + ']',
	    rsLower = '[' + rsLowerRange + ']',
	    rsMisc = '[^' + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + ']',
	    rsFitz = '\\ud83c[\\udffb-\\udfff]',
	    rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
	    rsNonAstral = '[^' + rsAstralRange + ']',
	    rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
	    rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
	    rsUpper = '[' + rsUpperRange + ']',
	    rsZWJ = '\\u200d';
	
	/** Used to compose unicode regexes. */
	var rsLowerMisc = '(?:' + rsLower + '|' + rsMisc + ')',
	    rsUpperMisc = '(?:' + rsUpper + '|' + rsMisc + ')',
	    rsOptLowerContr = '(?:' + rsApos + '(?:d|ll|m|re|s|t|ve))?',
	    rsOptUpperContr = '(?:' + rsApos + '(?:D|LL|M|RE|S|T|VE))?',
	    reOptMod = rsModifier + '?',
	    rsOptVar = '[' + rsVarRange + ']?',
	    rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
	    rsSeq = rsOptVar + reOptMod + rsOptJoin,
	    rsEmoji = '(?:' + [rsDingbat, rsRegional, rsSurrPair].join('|') + ')' + rsSeq;
	
	/** Used to match complex or compound words. */
	var reComplexWord = RegExp([
	  rsUpper + '?' + rsLower + '+' + rsOptLowerContr + '(?=' + [rsBreak, rsUpper, '$'].join('|') + ')',
	  rsUpperMisc + '+' + rsOptUpperContr + '(?=' + [rsBreak, rsUpper + rsLowerMisc, '$'].join('|') + ')',
	  rsUpper + '?' + rsLowerMisc + '+' + rsOptLowerContr,
	  rsUpper + '+' + rsOptUpperContr,
	  rsDigits,
	  rsEmoji
	].join('|'), 'g');
	
	/** Used to detect strings that need a more robust regexp to match words. */
	var reHasComplexWord = /[a-z][A-Z]|[A-Z]{2,}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;
	
	/**
	 * Splits `string` into an array of its words.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category String
	 * @param {string} [string=''] The string to inspect.
	 * @param {RegExp|string} [pattern] The pattern to match words.
	 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	 * @returns {Array} Returns the words of `string`.
	 * @example
	 *
	 * _.words('fred, barney, & pebbles');
	 * // => ['fred', 'barney', 'pebbles']
	 *
	 * _.words('fred, barney, & pebbles', /[^, ]+/g);
	 * // => ['fred', 'barney', '&', 'pebbles']
	 */
	function words(string, pattern, guard) {
	  string = toString(string);
	  pattern = guard ? undefined : pattern;
	
	  if (pattern === undefined) {
	    pattern = reHasComplexWord.test(string) ? reComplexWord : reBasicWord;
	  }
	  return string.match(pattern) || [];
	}
	
	module.exports = words;


/***/ },
/* 677 */
/***/ function(module, exports, __webpack_require__) {

	var LazyWrapper = __webpack_require__(176),
	    LodashWrapper = __webpack_require__(252),
	    baseLodash = __webpack_require__(180),
	    isArray = __webpack_require__(17),
	    isObjectLike = __webpack_require__(73),
	    wrapperClone = __webpack_require__(656);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Creates a `lodash` object which wraps `value` to enable implicit method
	 * chain sequences. Methods that operate on and return arrays, collections,
	 * and functions can be chained together. Methods that retrieve a single value
	 * or may return a primitive value will automatically end the chain sequence
	 * and return the unwrapped value. Otherwise, the value must be unwrapped
	 * with `_#value`.
	 *
	 * Explicit chain sequences, which must be unwrapped with `_#value`, may be
	 * enabled using `_.chain`.
	 *
	 * The execution of chained methods is lazy, that is, it's deferred until
	 * `_#value` is implicitly or explicitly called.
	 *
	 * Lazy evaluation allows several methods to support shortcut fusion.
	 * Shortcut fusion is an optimization to merge iteratee calls; this avoids
	 * the creation of intermediate arrays and can greatly reduce the number of
	 * iteratee executions. Sections of a chain sequence qualify for shortcut
	 * fusion if the section is applied to an array of at least `200` elements
	 * and any iteratees accept only one argument. The heuristic for whether a
	 * section qualifies for shortcut fusion is subject to change.
	 *
	 * Chaining is supported in custom builds as long as the `_#value` method is
	 * directly or indirectly included in the build.
	 *
	 * In addition to lodash methods, wrappers have `Array` and `String` methods.
	 *
	 * The wrapper `Array` methods are:
	 * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
	 *
	 * The wrapper `String` methods are:
	 * `replace` and `split`
	 *
	 * The wrapper methods that support shortcut fusion are:
	 * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
	 * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
	 * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
	 *
	 * The chainable wrapper methods are:
	 * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
	 * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
	 * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
	 * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
	 * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
	 * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
	 * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
	 * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
	 * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
	 * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
	 * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
	 * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
	 * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
	 * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
	 * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
	 * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
	 * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
	 * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
	 * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
	 * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
	 * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
	 * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
	 * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
	 * `zipObject`, `zipObjectDeep`, and `zipWith`
	 *
	 * The wrapper methods that are **not** chainable by default are:
	 * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
	 * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `deburr`, `divide`, `each`,
	 * `eachRight`, `endsWith`, `eq`, `escape`, `escapeRegExp`, `every`, `find`,
	 * `findIndex`, `findKey`, `findLast`, `findLastIndex`, `findLastKey`, `first`,
	 * `floor`, `forEach`, `forEachRight`, `forIn`, `forInRight`, `forOwn`,
	 * `forOwnRight`, `get`, `gt`, `gte`, `has`, `hasIn`, `head`, `identity`,
	 * `includes`, `indexOf`, `inRange`, `invoke`, `isArguments`, `isArray`,
	 * `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`, `isBoolean`,
	 * `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`, `isEqualWith`,
	 * `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`, `isMap`,
	 * `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
	 * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
	 * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
	 * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
	 * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
	 * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
	 * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
	 * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
	 * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
	 * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
	 * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
	 * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
	 * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
	 * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
	 * `upperFirst`, `value`, and `words`
	 *
	 * @name _
	 * @constructor
	 * @category Seq
	 * @param {*} value The value to wrap in a `lodash` instance.
	 * @returns {Object} Returns the new `lodash` wrapper instance.
	 * @example
	 *
	 * function square(n) {
	 *   return n * n;
	 * }
	 *
	 * var wrapped = _([1, 2, 3]);
	 *
	 * // Returns an unwrapped value.
	 * wrapped.reduce(_.add);
	 * // => 6
	 *
	 * // Returns a wrapped value.
	 * var squares = wrapped.map(square);
	 *
	 * _.isArray(squares);
	 * // => false
	 *
	 * _.isArray(squares.value());
	 * // => true
	 */
	function lodash(value) {
	  if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
	    if (value instanceof LodashWrapper) {
	      return value;
	    }
	    if (hasOwnProperty.call(value, '__wrapped__')) {
	      return wrapperClone(value);
	    }
	  }
	  return new LodashWrapper(value);
	}
	
	// Ensure wrappers are instances of `baseLodash`.
	lodash.prototype = baseLodash.prototype;
	lodash.prototype.constructor = lodash;
	
	module.exports = lodash;


/***/ },
/* 678 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(global, setImmediate) {/*! Native Promise Only
	    v0.8.1 (c) Kyle Simpson
	    MIT License: http://getify.mit-license.org
	*/
	
	(function UMD(name,context,definition){
		// special form of UMD for polyfilling across evironments
		context[name] = context[name] || definition();
		if (typeof module != "undefined" && module.exports) { module.exports = context[name]; }
		else if (true) { !(__WEBPACK_AMD_DEFINE_RESULT__ = function $AMD$(){ return context[name]; }.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)); }
	})("Promise",typeof global != "undefined" ? global : this,function DEF(){
		/*jshint validthis:true */
		"use strict";
	
		var builtInProp, cycle, scheduling_queue,
			ToString = Object.prototype.toString,
			timer = (typeof setImmediate != "undefined") ?
				function timer(fn) { return setImmediate(fn); } :
				setTimeout
		;
	
		// dammit, IE8.
		try {
			Object.defineProperty({},"x",{});
			builtInProp = function builtInProp(obj,name,val,config) {
				return Object.defineProperty(obj,name,{
					value: val,
					writable: true,
					configurable: config !== false
				});
			};
		}
		catch (err) {
			builtInProp = function builtInProp(obj,name,val) {
				obj[name] = val;
				return obj;
			};
		}
	
		// Note: using a queue instead of array for efficiency
		scheduling_queue = (function Queue() {
			var first, last, item;
	
			function Item(fn,self) {
				this.fn = fn;
				this.self = self;
				this.next = void 0;
			}
	
			return {
				add: function add(fn,self) {
					item = new Item(fn,self);
					if (last) {
						last.next = item;
					}
					else {
						first = item;
					}
					last = item;
					item = void 0;
				},
				drain: function drain() {
					var f = first;
					first = last = cycle = void 0;
	
					while (f) {
						f.fn.call(f.self);
						f = f.next;
					}
				}
			};
		})();
	
		function schedule(fn,self) {
			scheduling_queue.add(fn,self);
			if (!cycle) {
				cycle = timer(scheduling_queue.drain);
			}
		}
	
		// promise duck typing
		function isThenable(o) {
			var _then, o_type = typeof o;
	
			if (o != null &&
				(
					o_type == "object" || o_type == "function"
				)
			) {
				_then = o.then;
			}
			return typeof _then == "function" ? _then : false;
		}
	
		function notify() {
			for (var i=0; i<this.chain.length; i++) {
				notifyIsolated(
					this,
					(this.state === 1) ? this.chain[i].success : this.chain[i].failure,
					this.chain[i]
				);
			}
			this.chain.length = 0;
		}
	
		// NOTE: This is a separate function to isolate
		// the `try..catch` so that other code can be
		// optimized better
		function notifyIsolated(self,cb,chain) {
			var ret, _then;
			try {
				if (cb === false) {
					chain.reject(self.msg);
				}
				else {
					if (cb === true) {
						ret = self.msg;
					}
					else {
						ret = cb.call(void 0,self.msg);
					}
	
					if (ret === chain.promise) {
						chain.reject(TypeError("Promise-chain cycle"));
					}
					else if (_then = isThenable(ret)) {
						_then.call(ret,chain.resolve,chain.reject);
					}
					else {
						chain.resolve(ret);
					}
				}
			}
			catch (err) {
				chain.reject(err);
			}
		}
	
		function resolve(msg) {
			var _then, self = this;
	
			// already triggered?
			if (self.triggered) { return; }
	
			self.triggered = true;
	
			// unwrap
			if (self.def) {
				self = self.def;
			}
	
			try {
				if (_then = isThenable(msg)) {
					schedule(function(){
						var def_wrapper = new MakeDefWrapper(self);
						try {
							_then.call(msg,
								function $resolve$(){ resolve.apply(def_wrapper,arguments); },
								function $reject$(){ reject.apply(def_wrapper,arguments); }
							);
						}
						catch (err) {
							reject.call(def_wrapper,err);
						}
					})
				}
				else {
					self.msg = msg;
					self.state = 1;
					if (self.chain.length > 0) {
						schedule(notify,self);
					}
				}
			}
			catch (err) {
				reject.call(new MakeDefWrapper(self),err);
			}
		}
	
		function reject(msg) {
			var self = this;
	
			// already triggered?
			if (self.triggered) { return; }
	
			self.triggered = true;
	
			// unwrap
			if (self.def) {
				self = self.def;
			}
	
			self.msg = msg;
			self.state = 2;
			if (self.chain.length > 0) {
				schedule(notify,self);
			}
		}
	
		function iteratePromises(Constructor,arr,resolver,rejecter) {
			for (var idx=0; idx<arr.length; idx++) {
				(function IIFE(idx){
					Constructor.resolve(arr[idx])
					.then(
						function $resolver$(msg){
							resolver(idx,msg);
						},
						rejecter
					);
				})(idx);
			}
		}
	
		function MakeDefWrapper(self) {
			this.def = self;
			this.triggered = false;
		}
	
		function MakeDef(self) {
			this.promise = self;
			this.state = 0;
			this.triggered = false;
			this.chain = [];
			this.msg = void 0;
		}
	
		function Promise(executor) {
			if (typeof executor != "function") {
				throw TypeError("Not a function");
			}
	
			if (this.__NPO__ !== 0) {
				throw TypeError("Not a promise");
			}
	
			// instance shadowing the inherited "brand"
			// to signal an already "initialized" promise
			this.__NPO__ = 1;
	
			var def = new MakeDef(this);
	
			this["then"] = function then(success,failure) {
				var o = {
					success: typeof success == "function" ? success : true,
					failure: typeof failure == "function" ? failure : false
				};
				// Note: `then(..)` itself can be borrowed to be used against
				// a different promise constructor for making the chained promise,
				// by substituting a different `this` binding.
				o.promise = new this.constructor(function extractChain(resolve,reject) {
					if (typeof resolve != "function" || typeof reject != "function") {
						throw TypeError("Not a function");
					}
	
					o.resolve = resolve;
					o.reject = reject;
				});
				def.chain.push(o);
	
				if (def.state !== 0) {
					schedule(notify,def);
				}
	
				return o.promise;
			};
			this["catch"] = function $catch$(failure) {
				return this.then(void 0,failure);
			};
	
			try {
				executor.call(
					void 0,
					function publicResolve(msg){
						resolve.call(def,msg);
					},
					function publicReject(msg) {
						reject.call(def,msg);
					}
				);
			}
			catch (err) {
				reject.call(def,err);
			}
		}
	
		var PromisePrototype = builtInProp({},"constructor",Promise,
			/*configurable=*/false
		);
	
		// Note: Android 4 cannot use `Object.defineProperty(..)` here
		Promise.prototype = PromisePrototype;
	
		// built-in "brand" to signal an "uninitialized" promise
		builtInProp(PromisePrototype,"__NPO__",0,
			/*configurable=*/false
		);
	
		builtInProp(Promise,"resolve",function Promise$resolve(msg) {
			var Constructor = this;
	
			// spec mandated checks
			// note: best "isPromise" check that's practical for now
			if (msg && typeof msg == "object" && msg.__NPO__ === 1) {
				return msg;
			}
	
			return new Constructor(function executor(resolve,reject){
				if (typeof resolve != "function" || typeof reject != "function") {
					throw TypeError("Not a function");
				}
	
				resolve(msg);
			});
		});
	
		builtInProp(Promise,"reject",function Promise$reject(msg) {
			return new this(function executor(resolve,reject){
				if (typeof resolve != "function" || typeof reject != "function") {
					throw TypeError("Not a function");
				}
	
				reject(msg);
			});
		});
	
		builtInProp(Promise,"all",function Promise$all(arr) {
			var Constructor = this;
	
			// spec mandated checks
			if (ToString.call(arr) != "[object Array]") {
				return Constructor.reject(TypeError("Not an array"));
			}
			if (arr.length === 0) {
				return Constructor.resolve([]);
			}
	
			return new Constructor(function executor(resolve,reject){
				if (typeof resolve != "function" || typeof reject != "function") {
					throw TypeError("Not a function");
				}
	
				var len = arr.length, msgs = Array(len), count = 0;
	
				iteratePromises(Constructor,arr,function resolver(idx,msg) {
					msgs[idx] = msg;
					if (++count === len) {
						resolve(msgs);
					}
				},reject);
			});
		});
	
		builtInProp(Promise,"race",function Promise$race(arr) {
			var Constructor = this;
	
			// spec mandated checks
			if (ToString.call(arr) != "[object Array]") {
				return Constructor.reject(TypeError("Not an array"));
			}
	
			return new Constructor(function executor(resolve,reject){
				if (typeof resolve != "function" || typeof reject != "function") {
					throw TypeError("Not a function");
				}
	
				iteratePromises(Constructor,arr,function resolver(idx,msg){
					resolve(msg);
				},reject);
			});
		});
	
		return Promise;
	});
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(144).setImmediate))

/***/ },
/* 679 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var strictUriEncode = __webpack_require__(818);
	var objectAssign = __webpack_require__(6);
	
	function encode(value, opts) {
		if (opts.encode) {
			return opts.strict ? strictUriEncode(value) : encodeURIComponent(value);
		}
	
		return value;
	}
	
	exports.extract = function (str) {
		return str.split('?')[1] || '';
	};
	
	exports.parse = function (str) {
		// Create an object with no prototype
		// https://github.com/sindresorhus/query-string/issues/47
		var ret = Object.create(null);
	
		if (typeof str !== 'string') {
			return ret;
		}
	
		str = str.trim().replace(/^(\?|#|&)/, '');
	
		if (!str) {
			return ret;
		}
	
		str.split('&').forEach(function (param) {
			var parts = param.replace(/\+/g, ' ').split('=');
			// Firefox (pre 40) decodes `%3D` to `=`
			// https://github.com/sindresorhus/query-string/pull/37
			var key = parts.shift();
			var val = parts.length > 0 ? parts.join('=') : undefined;
	
			key = decodeURIComponent(key);
	
			// missing `=` should be `null`:
			// http://w3.org/TR/2012/WD-url-20120524/#collect-url-parameters
			val = val === undefined ? null : decodeURIComponent(val);
	
			if (ret[key] === undefined) {
				ret[key] = val;
			} else if (Array.isArray(ret[key])) {
				ret[key].push(val);
			} else {
				ret[key] = [ret[key], val];
			}
		});
	
		return ret;
	};
	
	exports.stringify = function (obj, opts) {
		var defaults = {
			encode: true,
			strict: true
		};
	
		opts = objectAssign(defaults, opts);
	
		return obj ? Object.keys(obj).sort().map(function (key) {
			var val = obj[key];
	
			if (val === undefined) {
				return '';
			}
	
			if (val === null) {
				return encode(key, opts);
			}
	
			if (Array.isArray(val)) {
				var result = [];
	
				val.slice().forEach(function (val2) {
					if (val2 === undefined) {
						return;
					}
	
					if (val2 === null) {
						result.push(encode(key, opts));
					} else {
						result.push(encode(key, opts) + '=' + encode(val2, opts));
					}
				});
	
				return result.join('&');
			}
	
			return encode(key, opts) + '=' + encode(val, opts);
		}).filter(function (x) {
			return x.length > 0;
		}).join('&') : '';
	};


/***/ },
/* 680 */
/***/ function(module, exports) {

	module.exports = "  !function(t,e){if(!t.ES6Promise){t.ES6Promise=e();t.ES6Promise.polyfill()}}(this,function(){\"use strict\";function t(t){return\"function\"==typeof t||\"object\"==typeof t&&null!==t}function e(t){return\"function\"==typeof t}function n(t){I=t}function r(t){J=t}function o(){return function(){return process.nextTick(a)}}function i(){return\"undefined\"!=typeof H?function(){H(a)}:c()}function s(){var t=0,e=new V(a),n=document.createTextNode(\"\");return e.observe(n,{characterData:!0}),function(){n.data=t=++t%2}}function u(){var t=new MessageChannel;return t.port1.onmessage=a,function(){return t.port2.postMessage(0)}}function c(){var t=setTimeout;return function(){return t(a,1)}}function a(){for(var t=0;t<G;t+=2){var e=$[t],n=$[t+1];e(n),$[t]=void 0,$[t+1]=void 0}G=0}function f(){try{var t=require,e=t(\"vertx\");return H=e.runOnLoop||e.runOnContext,i()}catch(n){return c()}}function l(t,e){var n=arguments,r=this,o=new this.constructor(p);void 0===o[et]&&k(o);var i=r._state;return i?!function(){var t=n[i-1];J(function(){return x(i,o,t,r._result)})}():E(r,o,t,e),o}function h(t){var e=this;if(t&&\"object\"==typeof t&&t.constructor===e)return t;var n=new e(p);return g(n,t),n}function p(){}function v(){return new TypeError(\"You cannot resolve a promise with itself\")}function d(){return new TypeError(\"A promises callback cannot return that same promise.\")}function _(t){try{return t.then}catch(e){return it.error=e,it}}function y(t,e,n,r){try{t.call(e,n,r)}catch(o){return o}}function m(t,e,n){J(function(t){var r=!1,o=y(n,e,function(n){r||(r=!0,e!==n?g(t,n):S(t,n))},function(e){r||(r=!0,j(t,e))},\"Settle: \"+(t._label||\" unknown promise\"));!r&&o&&(r=!0,j(t,o))},t)}function b(t,e){e._state===rt?S(t,e._result):e._state===ot?j(t,e._result):E(e,void 0,function(e){return g(t,e)},function(e){return j(t,e)})}function w(t,n,r){n.constructor===t.constructor&&r===l&&n.constructor.resolve===h?b(t,n):r===it?j(t,it.error):void 0===r?S(t,n):e(r)?m(t,n,r):S(t,n)}function g(e,n){e===n?j(e,v()):t(n)?w(e,n,_(n)):S(e,n)}function A(t){t._onerror&&t._onerror(t._result),P(t)}function S(t,e){t._state===nt&&(t._result=e,t._state=rt,0!==t._subscribers.length&&J(P,t))}function j(t,e){t._state===nt&&(t._state=ot,t._result=e,J(A,t))}function E(t,e,n,r){var o=t._subscribers,i=o.length;t._onerror=null,o[i]=e,o[i+rt]=n,o[i+ot]=r,0===i&&t._state&&J(P,t)}function P(t){var e=t._subscribers,n=t._state;if(0!==e.length){for(var r=void 0,o=void 0,i=t._result,s=0;s<e.length;s+=3)r=e[s],o=e[s+n],r?x(n,r,o,i):o(i);t._subscribers.length=0}}function T(){this.error=null}function M(t,e){try{return t(e)}catch(n){return st.error=n,st}}function x(t,n,r,o){var i=e(r),s=void 0,u=void 0,c=void 0,a=void 0;if(i){if(s=M(r,o),s===st?(a=!0,u=s.error,s=null):c=!0,n===s)return void j(n,d())}else s=o,c=!0;n._state!==nt||(i&&c?g(n,s):a?j(n,u):t===rt?S(n,s):t===ot&&j(n,s))}function C(t,e){try{e(function(e){g(t,e)},function(e){j(t,e)})}catch(n){j(t,n)}}function O(){return ut++}function k(t){t[et]=ut++,t._state=void 0,t._result=void 0,t._subscribers=[]}function Y(t,e){this._instanceConstructor=t,this.promise=new t(p),this.promise[et]||k(this.promise),B(e)?(this._input=e,this.length=e.length,this._remaining=e.length,this._result=new Array(this.length),0===this.length?S(this.promise,this._result):(this.length=this.length||0,this._enumerate(),0===this._remaining&&S(this.promise,this._result))):j(this.promise,q())}function q(){return new Error(\"Array Methods must be provided an Array\")}function F(t){return new Y(this,t).promise}function D(t){var e=this;return new e(B(t)?function(n,r){for(var o=t.length,i=0;i<o;i++)e.resolve(t[i]).then(n,r)}:function(t,e){return e(new TypeError(\"You must pass an array to race.\"))})}function K(t){var e=this,n=new e(p);return j(n,t),n}function L(){throw new TypeError(\"You must pass a resolver function as the first argument to the promise constructor\")}function N(){throw new TypeError(\"Failed to construct 'Promise': Please use the 'new' operator, this object constructor cannot be called as a function.\")}function U(t){this[et]=O(),this._result=this._state=void 0,this._subscribers=[],p!==t&&(\"function\"!=typeof t&&L(),this instanceof U?C(this,t):N())}function W(){var t=void 0;if(\"undefined\"!=typeof global)t=global;else if(\"undefined\"!=typeof self)t=self;else try{t=Function(\"return this\")()}catch(e){throw new Error(\"polyfill failed because global object is unavailable in this environment\")}var n=t.Promise;if(n){var r=null;try{r=Object.prototype.toString.call(n.resolve())}catch(e){}if(\"[object Promise]\"===r&&!n.cast)return}t.Promise=U}var z=void 0;z=Array.isArray?Array.isArray:function(t){return\"[object Array]\"===Object.prototype.toString.call(t)};var B=z,G=0,H=void 0,I=void 0,J=function(t,e){$[G]=t,$[G+1]=e,G+=2,2===G&&(I?I(a):tt())},Q=\"undefined\"!=typeof window?window:void 0,R=Q||{},V=R.MutationObserver||R.WebKitMutationObserver,X=\"undefined\"==typeof self&&\"undefined\"!=typeof process&&\"[object process]\"==={}.toString.call(process),Z=\"undefined\"!=typeof Uint8ClampedArray&&\"undefined\"!=typeof importScripts&&\"undefined\"!=typeof MessageChannel,$=new Array(1e3),tt=void 0;tt=X?o():V?s():Z?u():void 0===Q&&\"function\"==typeof require?f():c();var et=Math.random().toString(36).substring(16),nt=void 0,rt=1,ot=2,it=new T,st=new T,ut=0;return Y.prototype._enumerate=function(){for(var t=this.length,e=this._input,n=0;this._state===nt&&n<t;n++)this._eachEntry(e[n],n)},Y.prototype._eachEntry=function(t,e){var n=this._instanceConstructor,r=n.resolve;if(r===h){var o=_(t);if(o===l&&t._state!==nt)this._settledAt(t._state,e,t._result);else if(\"function\"!=typeof o)this._remaining--,this._result[e]=t;else if(n===U){var i=new n(p);w(i,t,o),this._willSettleAt(i,e)}else this._willSettleAt(new n(function(e){return e(t)}),e)}else this._willSettleAt(r(t),e)},Y.prototype._settledAt=function(t,e,n){var r=this.promise;r._state===nt&&(this._remaining--,t===ot?j(r,n):this._result[e]=n),0===this._remaining&&S(r,this._result)},Y.prototype._willSettleAt=function(t,e){var n=this;E(t,void 0,function(t){return n._settledAt(rt,e,t)},function(t){return n._settledAt(ot,e,t)})},U.all=F,U.race=D,U.resolve=h,U.reject=K,U._setScheduler=n,U._setAsap=r,U._asap=J,U.prototype={constructor:U,then:l,\"catch\":function(t){return this.then(null,t)}},U.polyfill=W,U.Promise=U,U});\n  (function(n){function i(a,d){this.setNotifyMethod(a);this.setNotifyContext(d)}function j(a,d,b){this.name=a;this.body=d;this.type=b}function k(){}function m(){}function l(){this.subCommands=[];this.initializeMacroCommand()}function g(a,d){this.mediatorName=a||this.constructor.NAME;this.viewComponent=d}function h(a,d){this.proxyName=a||this.constructor.NAME;null!=d&&this.setData(d)}function b(a){if(null!=b.instanceMap[a])throw Error(b.MULTITON_MSG);this.initializeNotifier(a);b.instanceMap[a]=this;\n  this.initializeFacade()}function c(a){if(null!=c.instanceMap[a])throw Error(c.MULTITON_MSG);this.multitonKey=a;c.instanceMap[this.multitonKey]=this;this.mediatorMap=[];this.observerMap=[];this.initializeView()}function e(a){if(e.instanceMap[a])throw Error(e.MULTITON_MSG);this.multitonKey=a;e.instanceMap[a]=this;this.proxyMap=[];this.initializeModel()}function f(a){if(null!=f.instanceMap[a])throw Error(f.MULTITON_MSG);this.multitonKey=a;f.instanceMap[this.multitonKey]=this;this.commandMap=[];this.initializeController()}\n  function p(a,d,b){for(var a=a.split(\".\"),b=b||o.global,c,e,f=0,g=a.length;f<g;f++)c=b,e=a[f],b=null==b[e]?b[e]={}:b[e];return null==d?b:c[e]=d}null==n&&(n=window);if(!n.puremvc){i.prototype.setNotifyMethod=function(a){this.notify=a};i.prototype.setNotifyContext=function(a){this.context=a};i.prototype.getNotifyMethod=function(){return this.notify};i.prototype.getNotifyContext=function(){return this.context};i.prototype.notifyObserver=function(a){this.getNotifyMethod().call(this.getNotifyContext(),\n  a)};i.prototype.compareNotifyContext=function(a){return a===this.context};i.prototype.notify=null;i.prototype.context=null;j.prototype.getName=function(){return this.name};j.prototype.setBody=function(a){this.body=a};j.prototype.getBody=function(){return this.body};j.prototype.setType=function(a){this.type=a};j.prototype.getType=function(){return this.type};j.prototype.toString=function(){var a=\"Notification Name: \"+this.getName(),a=a+(\"\\nBody:\"+(null==this.body?\"null\":this.body.toString()));return a+=\n  \"\\nType:\"+(null==this.type?\"null\":this.type)};j.prototype.name=null;j.prototype.type=null;j.prototype.body=null;k.prototype.sendNotification=function(a,d,b){var c=this.getFacade();c&&c.sendNotification(a,d,b)};k.prototype.initializeNotifier=function(a){this.multitonKey=\"\"+a;this.facade=this.getFacade()};k.prototype.getFacade=function(){if(null==this.multitonKey)throw Error(k.MULTITON_MSG);return b.getInstance(this.multitonKey)};k.prototype.multitonKey=null;k.MULTITON_MSG=\"multitonKey for this Notifier not yet initialized!\";\n  m.prototype=new k;m.prototype.constructor=m;m.prototype.execute=function(){};l.prototype=new k;l.prototype.constructor=l;l.prototype.subCommands=null;l.prototype.initializeMacroCommand=function(){};l.prototype.addSubCommand=function(a){this.subCommands.push(a)};l.prototype.execute=function(a){for(;0<this.subCommands.length;){var d=new (this.subCommands.shift());d.initializeNotifier(this.multitonKey);d.execute(a)}};g.NAME=\"Mediator\";g.prototype=new k;g.prototype.constructor=g;g.prototype.getMediatorName=\n  function(){return this.mediatorName};g.prototype.setViewComponent=function(a){this.viewComponent=a};g.prototype.getViewComponent=function(){return this.viewComponent};g.prototype.listNotificationInterests=function(){return[]};g.prototype.handleNotification=function(){};g.prototype.onRegister=function(){};g.prototype.onRemove=function(){};g.prototype.mediatorName=null;g.prototype.viewComponent=null;h.NAME=\"Proxy\";h.prototype=new k;h.prototype.constructor=h;h.prototype.getProxyName=function(){return this.proxyName};\n  h.prototype.setData=function(a){this.data=a};h.prototype.getData=function(){return this.data};h.prototype.onRegister=function(){};h.prototype.onRemove=function(){};h.prototype.proxyName=null;h.prototype.data=null;b.prototype.initializeFacade=function(){this.initializeModel();this.initializeController();this.initializeView()};b.getInstance=function(a){if(null==a)return null;null==b.instanceMap[a]&&(b.instanceMap[a]=new b(a));return b.instanceMap[a]};b.prototype.initializeController=function(){if(null==\n  this.controller)this.controller=f.getInstance(this.multitonKey)};b.prototype.initializeModel=function(){if(null==this.model)this.model=e.getInstance(this.multitonKey)};b.prototype.initializeView=function(){if(null==this.view)this.view=c.getInstance(this.multitonKey)};b.prototype.registerCommand=function(a,d){this.controller.registerCommand(a,d)};b.prototype.removeCommand=function(a){this.controller.removeCommand(a)};b.prototype.hasCommand=function(a){return this.controller.hasCommand(a)};b.prototype.registerProxy=\n  function(a){this.model.registerProxy(a)};b.prototype.retrieveProxy=function(a){return this.model.retrieveProxy(a)};b.prototype.removeProxy=function(a){var d=null;null!=this.model&&(d=this.model.removeProxy(a));return d};b.prototype.hasProxy=function(a){return this.model.hasProxy(a)};b.prototype.registerMediator=function(a){null!=this.view&&this.view.registerMediator(a)};b.prototype.retrieveMediator=function(a){return this.view.retrieveMediator(a)};b.prototype.removeMediator=function(a){var d=null;\n  null!=this.view&&(d=this.view.removeMediator(a));return d};b.prototype.hasMediator=function(a){return this.view.hasMediator(a)};b.prototype.sendNotification=function(a,d,b){this.notifyObservers(new j(a,d,b))};b.prototype.notifyObservers=function(a){null!=this.view&&this.view.notifyObservers(a)};b.prototype.initializeNotifier=function(a){this.multitonKey=a};b.hasCore=function(a){return null!=b.instanceMap[a]};b.removeCore=function(a){null!=b.instanceMap[a]&&(e.removeModel(a),c.removeView(a),f.removeController(a),\n  delete b.instanceMap[a])};b.prototype.controller=null;b.prototype.model=null;b.prototype.view=null;b.prototype.multitonKey=null;b.instanceMap=[];b.MULTITON_MSG=\"Facade instance for this Multiton key already constructed!\";c.prototype.initializeView=function(){};c.getInstance=function(a){if(null==a)return null;null==c.instanceMap[a]&&(c.instanceMap[a]=new c(a));return c.instanceMap[a]};c.prototype.registerObserver=function(a,d){null!=this.observerMap[a]?this.observerMap[a].push(d):this.observerMap[a]=\n  [d]};c.prototype.notifyObservers=function(a){if(null!=this.observerMap[a.getName()]){for(var d=this.observerMap[a.getName()],b=[],c,e=0;e<d.length;e++)c=d[e],b.push(c);for(e=0;e<b.length;e++)c=b[e],c.notifyObserver(a)}};c.prototype.removeObserver=function(a,d){for(var b=this.observerMap[a],c=0;c<b.length;c++)if(!0==b[c].compareNotifyContext(d)){b.splice(c,1);break}0==b.length&&delete this.observerMap[a]};c.prototype.registerMediator=function(a){if(null==this.mediatorMap[a.getMediatorName()]){a.initializeNotifier(this.multitonKey);\n  this.mediatorMap[a.getMediatorName()]=a;var d=a.listNotificationInterests();if(0<d.length)for(var b=new i(a.handleNotification,a),c=0;c<d.length;c++)this.registerObserver(d[c],b);a.onRegister()}};c.prototype.retrieveMediator=function(a){return this.mediatorMap[a]};c.prototype.removeMediator=function(a){var d=this.mediatorMap[a];if(d){for(var b=d.listNotificationInterests(),c=0;c<b.length;c++)this.removeObserver(b[c],d);delete this.mediatorMap[a];d.onRemove()}return d};c.prototype.hasMediator=function(a){return null!=\n  this.mediatorMap[a]};c.removeView=function(a){delete c.instanceMap[a]};c.prototype.mediatorMap=null;c.prototype.observerMap=null;c.instanceMap=[];c.prototype.multitonKey=null;c.MULTITON_MSG=\"View instance for this Multiton key already constructed!\";e.prototype.initializeModel=function(){};e.getInstance=function(a){if(null==a)return null;null==e.instanceMap[a]&&(e.instanceMap[a]=new e(a));return e.instanceMap[a]};e.prototype.registerProxy=function(a){a.initializeNotifier(this.multitonKey);this.proxyMap[a.getProxyName()]=\n  a;a.onRegister()};e.prototype.retrieveProxy=function(a){return this.proxyMap[a]};e.prototype.hasProxy=function(a){return null!=this.proxyMap[a]};e.prototype.removeProxy=function(a){var b=this.proxyMap[a];b&&(this.proxyMap[a]=null,b.onRemove());return b};e.removeModel=function(a){delete e.instanceMap[a]};e.prototype.proxyMap=null;e.instanceMap=[];e.MULTITON_MSG=\"Model instance for this Multiton key already constructed!\";f.prototype.initializeController=function(){this.view=c.getInstance(this.multitonKey)};\n  f.getInstance=function(a){if(null==a)return null;null==this.instanceMap[a]&&(this.instanceMap[a]=new this(a));return this.instanceMap[a]};f.prototype.executeCommand=function(a){var b=this.commandMap[a.getName()];null!=b&&(b=new b,b.initializeNotifier(this.multitonKey),b.execute(a))};f.prototype.registerCommand=function(a,b){null==this.commandMap[a]&&this.view.registerObserver(a,new i(this.executeCommand,this));this.commandMap[a]=b};f.prototype.hasCommand=function(a){return null!=this.commandMap[a]};\n  f.prototype.removeCommand=function(a){this.hasCommand(a)&&(this.view.removeObserver(a,this),this.commandMap[a]=null)};f.removeController=function(a){delete this.instanceMap[a]};f.prototype.view=null;f.prototype.commandMap=null;f.prototype.multitonKey=null;f.instanceMap=[];f.MULTITON_MSG=\"controller key for this Multiton key already constructed\";var o={global:function(){return this}(),extend:function(a,b){if(\"function\"!==typeof a)throw new TypeError(\"#extend- child should be Function\");if(\"function\"!==\n  typeof b)throw new TypeError(\"#extend- parent should be Function\");if(b!==a){var c=new Function;c.prototype=b.prototype;a.prototype=new c;return a.prototype.constructor=a}},decorate:function(a,b){for(var c in b)a[c]=b[c];return a}};n.puremvc={View:c,Model:e,Controller:f,SimpleCommand:m,MacroCommand:l,Facade:b,Mediator:g,Observer:i,Notification:j,Notifier:k,Proxy:h,define:function(a,b,c){a||(a={});var e=a.name,f=a.parent,g=\"function\"===typeof f,h=a.scope||null;if(\"parent\"in a&&!g)throw new TypeError(\"Class parent must be Function\");\n  if(a.hasOwnProperty(\"constructor\")){if(a=a.constructor,\"function\"!==typeof a)throw new TypeError(\"Class constructor must be Function\");}else a=g?function(){f.apply(this,arguments)}:new Function;g&&o.extend(a,f);if(b)g=a.prototype,o.decorate(g,b),g.constructor=a;c&&o.decorate(a,c);if(e){if(\"string\"!==typeof e)throw new TypeError(\"Class name must be primitive string\");p(e,a,h)}return a},declare:p}}})(this);\n\n  (function() {\n  var  global, version, _ref;\n\n\n    function AkamaiSDKManager() {\n      var legacyCheck, sdk, versions,\n        _this = this;\n      sdk = null;\n      this.getSDK = function() {\n        return sdk;\n      };\n      this.setSDK = function(newSDK) {\n        var key, value;\n        sdk = newSDK;\n        legacyCheck();\n        for (key in sdk) {\n          value = sdk[key];\n          window[key] = value;\n        }\n        return sdk;\n      };\n      this.saveSDK = function(version, object) {\n        var key, value, _ref;\n        if (!(object != null) || !(version != null) || version === \"\") {\n          return;\n        }\n        if (!(object.main != null)) {\n          for (key in object) {\n            value = object[key];\n            if (!((value != null ? value.VERSION : void 0) === version)) {\n              continue;\n            }\n            object.main = value;\n            break;\n          }\n        }\n        if ((_ref = object.version) == null) {\n          object.version = version;\n        }\n        versions.push(object);\n        this[version] = object;\n        return object;\n      };\n      versions = [];\n      this.getVersions = function() {\n        return versions.slice();\n      };\n      this.getVersion = function(version) {\n        return this[version];\n      };\n      this.setVersion = function(version) {\n        sdk = this.getVersion(version);\n        if (!(sdk != null)) {\n          return null;\n        }\n        this.setSDK(sdk);\n        return sdk;\n      };\n      this.revert = function() {\n        return this.setSDK(versions[0]);\n      };\n      this.noConflict = function() {\n        var current;\n        current = this.getSDK();\n        this.revert();\n        return current;\n      };\n      this.create = (function() {\n        var Creator;\n        Creator = function(cls, args) {\n          this.prototype = cls.prototype;\n          return cls.apply(this, args);\n        };\n        return function(args) {\n          return new Creator(sdk.main, arguments);\n        };\n      })();\n      legacyCheck = function() {\n        var key, obj, value, _ref, _ref1;\n        if ((_ref = window.com) != null ? (_ref1 = _ref.akamai) != null ? _ref1.amp : void 0 : void 0) {\n          for (key in window) {\n            value = window[key];\n            if ((value === window.AMP || value === window.AMPremier) && ((value != null ? value.VERSION : void 0) != null) && value.VERSION !== \"\" && value.VERSION !== (sdk != null ? sdk.version : void 0) && (!(_this[value.VERSION] != null))) {\n              obj = {};\n              obj.main = value;\n              obj.com = window.com;\n              if (window.AMP) {\n                obj.AMP = window.AMP;\n              }\n              if (window.AMPPremier) {\n                obj.AMPremier = window.AMPPremier;\n              }\n              if (window.Utils) {\n                obj.Utils = window.Utils;\n              }\n              if (window.QueryString) {\n                obj.QueryString = window.QueryString;\n              }\n              if (window.QueryParams) {\n                obj.QueryParams = window.QueryParams;\n              }\n              _this.saveSDK(value.VERSION, obj);\n              break;\n            }\n          }\n        }\n      };\n      legacyCheck();\n    }\n\n\n  if ((_ref = window.AKAMAI_MEDIA_PLAYER) == null) {\n    window.AKAMAI_MEDIA_PLAYER = new AkamaiSDKManager();\n  }\n  version = \"AMP - Premier : WebMD v0.65.0.0005\";\n  if (!(window.AKAMAI_MEDIA_PLAYER[version] != null)) {\n    global = window.AKAMAI_MEDIA_PLAYER[version] = {};\n    /* Start JS Lib\n    */\n    function __hasProp(prop) {\n  \treturn {}[\"hasOwnProperty\"](prop);\n  }\n\n  function __extends(child, parent) {\n  \tfor (var key in parent) {\n  \t\tif (__hasProp[\"call\"](parent, key))\n  \t\t\tchild[key] = parent[key];\n  \t}\n  \tfunction ctor() {\n  \t\tthis.constructor = child;\n  \t}\n\n  \tctor.prototype = parent.prototype;\n  \tchild.prototype = new ctor;\n  \tchild.__super__ = parent.prototype;\n  \treturn child;\n  }\n\n  function __indexOf(item) {\n  \tfor (var i = 0, l = this.length; i < l; i++) {\n  \t\tif ( i in this && this[i] === item)\n  \t\t\treturn i;\n  \t}\n  \treturn -1;\n  }\n\n  function __bind(fn, me) {\n  \treturn function() {\n  \t\treturn fn[\"apply\"](me, arguments);\n  \t};\n  }\n\n  function QueryString() {}\n\n  QueryString.construct = function() {\n    var key, value, vars;\n    vars = this.deserialize(window.location.search);\n    for (key in vars) {\n      value = vars[key];\n      QueryString[key] = value;\n    }\n    return true;\n  };\n\n  QueryString.serialize = function(obj, prefix) {\n    var k, p, str, v;\n    str = [];\n    for (p in obj) {\n      v = obj[p];\n      if (!(v != null)) {\n        continue;\n      }\n      k = (prefix ? prefix + \"[\" + p + \"]\" : p);\n      str.push((typeof v === \"object\" ? this.serialize(v, k) : encodeURIComponent(k) + \"=\" + encodeURIComponent(v)));\n    }\n    return str.join(\"&\");\n  };\n\n  QueryString.deserialize = function(uri) {\n    var results;\n    if (uri != null) {\n      results = {};\n      uri = uri.replace(/^[^?]*\\?/, \"\");\n      uri.replace(new RegExp(\"([^?=&]+)(=([^&]*))?\", \"g\"), function($0, $1, $2, $3) {\n        results[decodeURIComponent($1)] = decodeURIComponent($3);\n      });\n    }\n    return results;\n  };\n\n  QueryString.constructed = QueryString.construct();\n\n  /**\n   * Creates a new instance of MediaProxy. Used to track player configuration settings.\n   *\n   * @param {Object} data The config object.\n   * @constructor\n   * @private\n   * @extends {puremvc.Proxy}\n  */\n  function ModuleProxy(data, name) {\n    this.config = data;\n    ModuleProxy.__super__.constructor.call(this, name);\n  }\n\n\n  __extends(ModuleProxy, puremvc.Proxy);\n\n\n  /** @static\n  */\n  ModuleProxy.NAME = \"ModuleProxy\";\n\n  /** @private\n  */\n  ModuleProxy.prototype.defaults = null;\n\n  ModuleProxy.prototype.config = null;\n\n  /** @override\n  */\n  ModuleProxy.prototype.initializeNotifier = function(key) {\n    ModuleProxy.__super__.initializeNotifier.call(this, key);\n    this.createData();\n  };\n\n  /**\n  */\n  ModuleProxy.prototype.createData = function() {\n    this.setData(this.config);\n  };\n\n  /**\n  */\n  ModuleProxy.prototype.getDefaults = function() {\n    return this.defaults;\n  };\n\n  /**\n   * Sets the data for this proxy.\n   *\n   * @param {Object} value\n   *    The new data for this proxy\n   * @override\n  */\n  ModuleProxy.prototype.setData = function(data) {\n    var dflt, key, obj, value, _ref;\n    if (data == null) {\n      data = {};\n    }\n    obj = {};\n    _ref = this.getDefaults();\n    for (key in _ref) {\n      dflt = _ref[key];\n      value = key in data ? data[key] : dflt;\n      obj[key] = value;\n    }\n    ModuleProxy.__super__.setData.call(this, obj);\n    return data;\n  };\n\n  /**\n  */\n  ModuleProxy.prototype.destroy = function() {};\n\n  /**\n   * The Module class.\n   *\n   * @param {Object}  config        The configuration object\n   * @param {Object}  viewComponent The player's container element\n   * @constructor\n   * @private\n   * @extends {puremvc.Facade}\n  */\n  function Module(viewComponent) {\n    this.viewComponent = viewComponent;\n    Module.__super__.constructor.call(this, this.getModuleName() + \"-\" + Date.now());\n    this.dispatcher = new EventDispatcher(this);\n    this.logger = Logger;\n    this.moduleMap = {};\n  }\n\n\n  __extends(Module, puremvc.Facade);\n\n\n  Module.prototype.logger = null;\n\n  Module.prototype.config = null;\n\n  Module.prototype.moduleName = null;\n\n  Module.prototype.moduleMap = null;\n\n  Module.prototype.viewComponent = null;\n\n  Module.prototype.dispatcher = null;\n\n  Module.prototype.oninitialized = null;\n\n  Module.prototype.onerror = null;\n\n  Module.prototype.parentModule = null;\n\n  /**\n   * Initialization function.\n   *\n   * @param {Object}  config  The plugin's configuration object.\n  */\n  Module.prototype.initialize = function(config, parentModule) {\n    this.config = config;\n    this.parentModule = parentModule;\n    this.loadModuleResources();\n  };\n\n  /**\n  */\n  Module.prototype.loadModuleResources = function() {\n    var resource, _i, _len, _ref, _ref1;\n    if (!((_ref = this.config.resources) != null ? _ref.length : void 0) > 0) {\n      this.resourcesLoaded();\n      return;\n    }\n    _ref1 = this.config.resources;\n    for (_i = 0, _len = _ref1.length; _i < _len; _i++) {\n      resource = _ref1[_i];\n      resource.src = this.evaluatePaths(resource.src);\n      if (resource.debug != null) {\n        resource.debug = this.evaluatePaths(resource.debug);\n      }\n    }\n    AMP.addResources(this.config.resources, this.resourcesLoaded.bind(this), this.resourcesError.bind(this));\n  };\n\n  /**\n  */\n  Module.prototype.evaluatePaths = function(path) {\n    var paths, _ref, _ref1;\n    if (!(path != null)) {\n      return;\n    }\n    paths = this.config.paths || ((_ref = this.parentModule) != null ? (_ref1 = _ref.config) != null ? _ref1.paths : void 0 : void 0);\n    if (paths != null) {\n      path = path.replace(/#{paths\\.[^}]*}/g, function(match) {\n        return DataBinding[\"eval\"](match, null, null, null, paths);\n      });\n    }\n    return path;\n  };\n\n  /**\n   * The resources failed to load.\n   *\n   * @private\n  */\n  Module.prototype.resourcesError = function(error) {\n    if (typeof this.onerror === \"function\") {\n      this.onerror(this);\n    }\n  };\n\n  /**\n   * The resources have finished loaded, load the extensions.\n   *\n   * @private\n  */\n  Module.prototype.resourcesLoaded = function() {\n    this.createFramework();\n    if (typeof this.oninitialized === \"function\") {\n      this.oninitialized(this);\n    }\n  };\n\n  /**\n   * Framework based initialization function for defining default\n   * mvc classes. Meant to be overwritten by base classes.\n  */\n  Module.prototype.createFramework = function() {\n    this.createModel();\n    this.createController();\n    this.createView();\n  };\n\n  /**\n  */\n  Module.prototype.createModel = function() {\n    this.registerProxy(new ModuleProxy(this.config));\n  };\n\n  /**\n  */\n  Module.prototype.createView = function() {};\n\n  /**\n  */\n  Module.prototype.createController = function() {\n    this.registerCommand(Notifications.DISPATCH_EVENT, DispatchEventCommand);\n  };\n\n  /**\n  */\n  Module.prototype.getModuleName = function() {\n    return this.moduleName;\n  };\n\n  /**\n   * @return {Object} The configuration object.\n   * @expose\n  */\n  Module.prototype.getConfig = function() {\n    return this.config;\n  };\n\n  /**\n  */\n  Module.prototype.hasModule = function(moduleName) {\n    return this.moduleMap[moduleName] != null;\n  };\n\n  /**\n  */\n  Module.prototype.getModules = function() {\n    var key, modules, value, _ref;\n    modules = {};\n    _ref = this.moduleMap;\n    for (key in _ref) {\n      value = _ref[key];\n      modules[key] = value.module;\n    }\n    return modules;\n  };\n\n  /**\n  */\n  Module.prototype.registerModule = function(module) {\n    var adaptor, moduleName;\n    moduleName = module.getModuleName();\n    if (!(module != null) || (this.moduleMap[moduleName] != null)) {\n      return;\n    }\n    adaptor = new ModuleAdapter(module);\n    this.moduleMap[moduleName] = adaptor;\n    this.registerMediator(adaptor);\n    module.onRegister();\n  };\n\n  /**\n  */\n  Module.prototype.retrieveModule = function(moduleName) {\n    return this.moduleMap[moduleName].module;\n  };\n\n  /**\n  */\n  Module.prototype.removeModule = function(moduleName) {\n    var adaptor, module;\n    adaptor = this.moduleMap[moduleName];\n    if (!(adaptor != null)) {\n      return;\n    }\n    delete this.moduleMap[moduleName];\n    this.removeMediator(moduleName);\n    module = adaptor.module;\n    module.onRemove.call(module);\n    return module;\n  };\n\n  /** List INotification interests.\n  */\n  Module.prototype.listNotificationInterests = function() {\n    return [];\n  };\n\n  /** List Notification publications\n  */\n  Module.prototype.listNotificationPublications = function() {\n    return [];\n  };\n\n  /** Get the IMediator's view component.\n  */\n  Module.prototype.getViewComponent = function() {\n    return this.viewComponent;\n  };\n\n  /** Set the IMediator's view component.\n  */\n  Module.prototype.setViewComponent = function(viewComponent) {\n    this.viewComponent = viewComponent;\n    return viewComponent;\n  };\n\n  /** Called by the parent module when the Module is registered\n  */\n  Module.prototype.onRegister = function() {};\n\n  /** Called by the parent module when the Module is removed\n  */\n  Module.prototype.onRemove = function() {};\n\n  /** Destroys the module\n  */\n  Module.prototype.destroy = function() {\n    var key, value, _ref, _ref1;\n    if (this.getModules() != null) {\n      _ref = this.getModules();\n      for (key in _ref) {\n        value = _ref[key];\n        this.removeModule(key);\n        value.destroy();\n      }\n    }\n    if ((_ref1 = this.retrieveProxy(ModuleProxy.NAME)) != null) {\n      if (typeof _ref1.destroy === \"function\") {\n        _ref1.destroy();\n      }\n    }\n    puremvc.Facade.removeCore(this.multitonKey);\n    if (this.viewComponent != null) {\n      this.viewComponent.innerHTML = \"\";\n      this.viewComponent.className = \"\";\n    }\n    for (key in this) {\n      try {\n        this[key] = null;\n      } catch (error) {\n\n      }\n      delete this[key];\n    }\n  };\n\n  /**\n   * Adds a listener for a given event type.\n   *\n   * @param {!string}  type  A string representing the event's type.\n   * @param {!Function} func  A function to call when the event is triggered.\n   * @expose\n  */\n  Module.prototype.addEventListener = function(type, func) {\n    this.dispatcher.addEventListener(type, func);\n  };\n\n  /**\n   * Adds a listener for a given event type and removes it after it has been triggered once.\n  */\n  Module.prototype.once = function(type, func) {\n    this.dispatcher.once(type, func);\n  };\n\n  /**\n  */\n  Module.prototype.logEvent = function(event) {\n    var prefix;\n    if (/(timeupdate|progress)/.test(event.type) === true) {\n      return;\n    }\n    prefix = this.getModuleName().toUpperCase();\n    if (event.dispatcher) {\n      prefix += \" \" + event.dispatcher;\n    }\n    this.logger.log(\"[\" + prefix + \" EVENT] \" + event.type, event);\n  };\n\n  /**\n   * Dispathes and event, triggering all event listener of the event's type.\n   *\n   * @param {!IEvent} event The event to dispatch.\n   * @expose\n  */\n  Module.prototype.dispatchEvent = function(event) {\n    this.logEvent(event);\n    this.dispatcher.dispatchEvent(event);\n  };\n\n  /**\n   * Removes a listener for a given event type.\n   *\n   * @param {!string}  type  A string representing the event's type.\n   * @param {!Function} func  A function to call when the event is triggered.\n   * @return {?Function} the handler that was removed if any\n   * @expose\n  */\n  Module.prototype.removeEventListener = function(type, func) {\n    this.dispatcher.removeEventListener(type, func);\n  };\n\n  /**\n   * Creates a new EventDispatcher\n   *\n   * @constructor\n   * @private\n   * @implements {IEventDispatcher}\n  */\n  function EventDispatcher(target, catchErrors) {\n    this.target = target != null ? target : this;\n    this.catchErrors = catchErrors != null ? catchErrors : true;\n    this.listenerMap = {};\n  }\n\n  /**\n   * Adds a listener for a given event type.\n   *\n   * @param {!string}  type  A string representing the event's type.\n   * @param {!Function} func  A function to call when the event is triggered.\n   * @param {boolean=} capture\n  */\n  EventDispatcher.prototype.addEventListener = function(type, func, capture) {\n    if (!(func != null) || !(type != null)) {\n      return;\n    }\n    if (!(this.listenerMap[type] != null)) {\n      this.listenerMap[type] = [];\n    }\n    if (this.listenerMap[type].indexOf(func) !== -1) {\n      return;\n    }\n    this.listenerMap[type].push(func);\n  };\n\n  /**\n   * Adds a listener for a given event type and removes it after it has been triggered once.\n  */\n  EventDispatcher.prototype.once = function(type, func) {\n    func.once = true;\n    this.addEventListener(type, func);\n  };\n\n  /**\n   * Dispathes and event, triggering all event listener of the event's type.\n   *\n   * @param {!IEvent} event The event to dispatch.\n  */\n  EventDispatcher.prototype.dispatchEvent = function(event) {\n    var listener, listeners, remove, _i, _j, _len, _len1;\n    listeners = this.listenerMap[event.type];\n    listener = this.target[\"on\" + event.type];\n    event.target = this.target;\n    remove = null;\n    if (listener != null) {\n      listener.apply(this.target, [event]);\n    }\n    if (!(listeners != null)) {\n      return;\n    }\n    for (_i = 0, _len = listeners.length; _i < _len; _i++) {\n      listener = listeners[_i];\n      listener.apply(this.target, [event]);\n      if (listener.once === true) {\n        if (remove == null) {\n          remove = [];\n        }\n        remove.push(listener);\n      }\n    }\n    if ((remove != null ? remove.length : void 0) > 0) {\n      for (_j = 0, _len1 = remove.length; _j < _len1; _j++) {\n        listener = remove[_j];\n        listeners.splice(listeners.indexOf(listener), 1);\n      }\n    }\n  };\n\n  EventDispatcher.prototype.callListener = function(event, listener) {\n    try {\n      listener.apply(this.target, [event]);\n    } catch (error) {\n      if (this.catchErrors === true) {\n        this.processEventError(error, event, listener);\n      } else {\n        throw error;\n      }\n    }\n  };\n\n  EventDispatcher.prototype.processEventError = function(error, event, listener) {\n    var err, file, line;\n    file = error.fileName || error.sourceURL;\n    line = error.lineNumber || error.line;\n    err = {\n      message: error.message,\n      name: \"AMP Event Listener Error\",\n      file: file,\n      fileName: file,\n      line: line,\n      lineNumber: line,\n      error: error,\n      event: event,\n      listener: listener,\n      functionName: listener.name,\n      toString: function() {\n        var message;\n        message = \"\" + this.name + \":\";\n        message += \"\\n\\t\" + (this.error.toString());\n        if (this.event != null) {\n          message += \"\\n\\t\\tevent: \" + this.event.type;\n        }\n        if (this.listener != null) {\n          message += \"\\n\\t\\tfunction: \" + this.listener.name;\n        }\n        if (this.file != null) {\n          message += \"\\n\\t\\tfile: \" + this.file;\n        }\n        if (this.line != null) {\n          message += \"\\n\\t\\tline: \" + this.line;\n        }\n        return message;\n      }\n    };\n    setTimeout(function (err) { throw err; }, 0, err);\n  };\n\n  /**\n   * Removes a listener for a given event type.\n   *\n   * @param {!string}  type  A string representing the event's type.\n   * @param {!Function} func  A function to call when the event is triggered.\n   * @return {?Function} the handler that was removed if any\n   * @param {boolean=} capture\n  */\n  EventDispatcher.prototype.removeEventListener = function(type, func, capture) {\n    var index, listeners;\n    if (!(func != null) || !(type != null)) {\n      return;\n    }\n    listeners = this.listenerMap[type];\n    if (!(listeners != null)) {\n      return;\n    }\n    index = listeners != null ? listeners.indexOf(func) : void 0;\n    if (index === -1) {\n      return;\n    }\n    return listeners.splice(index, 1);\n  };\n\n  /**\n   * @constructor\n   * @private\n  */\n  function TrackList(list) {\n    this.list = list != null ? list : [];\n    TrackList.__super__.constructor.call(this);\n    this.handlers = {\n      change: this.changeHandler.bind(this)\n    };\n  }\n\n\n  __extends(TrackList, EventDispatcher);\n\n\n  TrackList.prototype.onchange = null;\n\n  TrackList.prototype.list = null;\n\n  /**\n  */\n  TrackList.prototype.changeHandler = function(event) {\n    this.dispatchEvent(event);\n  };\n\n  /**\n   * @param {string} key\n   *     The key\n   *\n   * @param {Object} value\n   *     The value\n  */\n  TrackList.prototype.add = function(track, dispatch) {\n    if (dispatch == null) {\n      dispatch = true;\n    }\n    this.list.push(track);\n    track.addEventListener(\"change\", this.handlers.change);\n    if (dispatch === true) {\n      this.dispatchEvent({\n        type: \"addtrack\"\n      });\n    }\n  };\n\n  TrackList.prototype.set = function(list) {\n    var index, track, _i, _len;\n    this.clear();\n    if (!(list != null) || list.length === 0) {\n      return;\n    }\n    for (index = _i = 0, _len = list.length; _i < _len; index = ++_i) {\n      track = list[index];\n      this.add(track, false);\n      this[index] = null;\n      delete this[index];\n    }\n    this.dispatchEvent({\n      type: \"addtrack\"\n    });\n  };\n\n  /**\n   * @param {string} key\n   *     The module's key\n   *\n   * @return {Object}\n   *     The item at the given key.\n  */\n  TrackList.prototype.item = function(index) {\n    return this.list[index];\n  };\n\n  /**\n   * @param {string} key\n   *     The module's key\n   *\n   * @return {Object}\n   *     The item.\n  */\n  TrackList.prototype.remove = function(index, dispatch) {\n    var track;\n    if (dispatch == null) {\n      dispatch = true;\n    }\n    if (!(__indexOf.call(this, index) >= 0)) {\n      return;\n    }\n    track = this.list.splice(index, 1);\n    track.removeEventListener(\"change\", this.handlers.change);\n    if (dispatch === true) {\n      this.dispatchEvent({\n        type: \"removetrack\"\n      });\n    }\n    return track;\n  };\n\n  TrackList.prototype.clear = function() {\n    var index, track, _i, _len;\n    if (this.list.length === 0) {\n      return;\n    }\n    for (index = _i = 0, _len = this.length; _i < _len; index = ++_i) {\n      track = this[index];\n      this.remove(track, false);\n      this.list[index] = null;\n      delete this.list[index];\n    }\n    this.dispatchEvent({\n      type: \"removetrack\"\n    });\n  };\n\n  TrackList.prototype.forEach = function(func, scope) {\n    var index, item, _i, _len, _ref;\n    if (!(func != null)) {\n      return;\n    }\n    _ref = this.list;\n    for (index = _i = 0, _len = _ref.length; _i < _len; index = ++_i) {\n      item = _ref[index];\n      func.call(scope, item, index, this.list);\n    }\n  };\n\n  TrackList.prototype.getTrackById = function(id) {\n    var track, _i, _len, _ref;\n    _ref = this.list;\n    for (_i = 0, _len = _ref.length; _i < _len; _i++) {\n      track = _ref[_i];\n      if (track.id === id) {\n        return track;\n      }\n    }\n  };\n\n  TrackList.prototype.getLength = function() {\n    return this.list.length;\n  };\n\n  /**\n   * The InstallPlayer class.\n   *\n   * @constructor\n   * @private\n   * @param {Object} viewComponent\n  */\n  function InstallPlayer(viewComponent) {\n    var anchor, div, img, message;\n    viewComponent.className = Namespace.PREFIX + \"player\";\n    div = UI.create(\"install-flash\", viewComponent);\n    message = UI.create(null, div, \"p\", \"To view this page ensure that Adobe Flash Player version 10.2.0 or greater is installed.\");\n    anchor = UI.create(null, div, \"a\");\n    anchor.href = 'http://www.adobe.com/go/getflashplayer';\n    img = UI.create(null, anchor, \"img\");\n    img.src = \"//www.adobe.com/images/shared/download_buttons/get_flash_player.gif\";\n    img.alt = \"Get Adobe Flash player\";\n  }\n\n  InstallPlayer.prototype.initialize = function() {};\n\n  /**\n  */\n  InstallPlayer.prototype.getModules = function() {\n    return [];\n  };\n\n  /**\n   * @constructor\n   * @private\n  */\n  function Manager() {\n    this.map = {};\n  }\n\n  /**\n   * @type {Object.<string, Object>}\n   * @private\n  */\n  Manager.prototype.map = null;\n\n  /**\n   * @param {string} key\n   *     The key\n   *\n   * @param {Object} value\n   *     The value\n  */\n  Manager.prototype.add = function(key, value) {\n    this.map[key] = value;\n  };\n\n  /**\n   * @param {string} key\n   *     The module's key\n   *\n   * @return {Object}\n   *     The item at the given key.\n  */\n  Manager.prototype.item = function(key) {\n    return this.map[key];\n  };\n\n  /**\n   * @param {string} key\n   *     The module's key\n   *\n   * @return {Object}\n   *     The item.\n  */\n  Manager.prototype.remove = function(key) {\n    var item;\n    item = this.map[key];\n    if (item != null) {\n      this.map[key] = null;\n      delete this.map[key];\n    }\n    return item;\n  };\n\n  function URL() {}\n\n  /**\n   * The URL to send the request to.\n   *\n   * @type {String}\n  */\n  URL.prototype.url = null;\n\n  /**\n   * The HTTP method to use, such as \"GET\", \"POST\", \"PUT\", \"DELETE\", etc.\n   * Ignored for non-HTTP(S) URLs.\n   *\n   * @type {String}\n  */\n  URL.prototype.method = null;\n\n  /**\n   * A Boolean that indicates whether or not cross-site Access-Control\n   * requests should be made using credentials such as cookies or authorization\n   * headers.\n   *\n   * @type {Boolean}\n  */\n  URL.prototype.withCredentials = null;\n\n  /**\n   * A key value map of http headers to include in the reques\n   *\n   * @type {Object}\n  */\n  URL.prototype.headers = null;\n\n  /**\n   * Data to send with a POST request\n   *\n   * @type {Object}\n  */\n  URL.prototype.data = null;\n\n  function Authorization(key, token, expiration) {\n    this.key = key;\n    this.token = token;\n    this.expiration = expiration;\n  }\n\n  Authorization.prototype.key = null;\n\n  Authorization.prototype.token = null;\n\n  Authorization.prototype.expiration = null;\n\n  /**\n   * @constructor\n   * @extends {Manager}\n  */\n  function ResourceManager() {\n    ResourceManager.__super__.constructor.call(this);\n  }\n\n\n  __extends(ResourceManager, Manager);\n\n\n  /**\n   * @override\n  */\n  ResourceManager.prototype.add = function(resource, callback, onerror) {\n    var item, onload, src;\n    src = Logger.enabled && (resource.debug != null) ? resource.debug : resource.src;\n    item = this.item(src);\n    if (resource.enabled === false || (item != null ? item.loaded : void 0) === true) {\n      callback();\n      return;\n    }\n    if ((item != null ? item.loaded : void 0) === false) {\n      item.callbacks.push(callback);\n      return;\n    }\n    resource.loaded = false;\n    resource.callbacks = [callback];\n    onload = this.resourceLoaded.bind(resource);\n    ResourceManager.__super__.add.call(this, src, resource);\n    if (resource.type === Utils.mimeTypes.js) {\n      Utils.loadScript(src, onload, document.body, onerror);\n      return;\n    }\n    if (resource.type === Utils.mimeTypes.css) {\n      Utils.loadStyleSheet(src);\n    }\n    onload();\n  };\n\n  /**\n   *\n  */\n  ResourceManager.prototype.resourceLoaded = function() {\n    var callback, callbacks, _i, _len;\n    this.loaded = true;\n    callbacks = this.callbacks;\n    this.callbacks = null;\n    delete this.callbacks;\n    for (_i = 0, _len = callbacks.length; _i < _len; _i++) {\n      callback = callbacks[_i];\n      callback();\n    }\n    callbacks = null;\n  };\n\n  /**\n   * @param {Array.<akamai.amp.Resource>} resource\n   *    The resource\n   *\n   * @param {Function} callback\n  */\n  ResourceManager.prototype.addResources = function(resources, callback, onerror) {\n    var complete, index, next,\n      _this = this;\n    if (!(resources != null ? resources.length : void 0) > 0) {\n      callback();\n      return;\n    }\n    index = 0;\n    next = function() {\n      _this.add(resources[index], complete, onerror);\n    };\n    complete = function() {\n      index++;\n      if (index >= resources.length) {\n        callback();\n      } else {\n        next();\n      }\n    };\n    next();\n  };\n\n  /**\n   * The PluginsInitializedCommand class.\n   *\n   * @constructor\n   * @private\n   * @extends {puremvc.SimpleCommand}\n  */\n  function PluginsInitializedCommand() {\n    PluginsInitializedCommand.__super__.constructor.call(this);\n  }\n\n\n  __extends(PluginsInitializedCommand, puremvc.SimpleCommand);\n\n\n  /**\n   * Executes the command.\n   *\n   * @param {puremvc.Notification} notification\n   *    The notification.\n   *\n   * @override\n  */\n  PluginsInitializedCommand.prototype.execute = function(notification) {\n    var media, _ref;\n    this.sendNotification(Notifications.READY, this.facade.config);\n    media = (_ref = this.facade.config) != null ? _ref.media : void 0;\n    if (media != null) {\n      setTimeout(this.sendNotification.bind(this, Notifications.SET_MEDIA, media), 0);\n    }\n  };\n\n  /**\n   * The PlayerCommand class. Base class for commands that need access\n   * to the application state or the media\n   *\n   * @constructor\n   * @private\n   * @extends {puremvc.SimpleCommand}\n  */\n  function PlayerCommand() {\n    PlayerCommand.__super__.constructor.call(this);\n  }\n\n\n  __extends(PlayerCommand, puremvc.SimpleCommand);\n\n\n  PlayerCommand.prototype.applicationState = null;\n\n  PlayerCommand.prototype.media = null;\n\n  PlayerCommand.prototype.player = null;\n\n  PlayerCommand.prototype.playback = null;\n\n  PlayerCommand.prototype.config = null;\n\n  PlayerCommand.prototype.logger = null;\n\n  PlayerCommand.prototype.bindings = null;\n\n  PlayerCommand.prototype.params = null;\n\n  PlayerCommand.prototype.playerCore = null;\n\n  PlayerCommand.prototype.security = null;\n\n  PlayerCommand.prototype.tracks = null;\n\n  /** @override\n  */\n  PlayerCommand.prototype.initializeNotifier = function(key) {\n    var _ref;\n    PlayerCommand.__super__.initializeNotifier.call(this, key);\n    this.player = this.facade.player || this.facade;\n    this.applicationState = this.player.appState;\n    this.media = this.player.mediaProxy;\n    this.config = this.player.configuration;\n    this.logger = this.player.logger;\n    this.bindings = this.player.bindings;\n    this.params = this.player.params;\n    this.playerCore = this.player.playerCore;\n    this.security = this.player.security;\n    this.tracks = this.player.tracks;\n    this.playback = ((_ref = this.player.playerCore) != null ? _ref.getActivePlaybackCore() : void 0) || this.player.playback;\n  };\n\n  /**\n   * The TogglePlayPauseCommand class.\n   *\n   * @constructor\n   * @private\n   * @extends {amp.player.controller.PlayerCommand}\n  */\n  function TogglePlayPauseCommand() {\n    TogglePlayPauseCommand.__super__.constructor.call(this);\n  }\n\n\n  __extends(TogglePlayPauseCommand, PlayerCommand);\n\n\n  /**\n   * Executes the command.\n   *\n   * @param {puremvc.Notification} notification\n   *    The notification.\n   *\n   * @override\n  */\n  TogglePlayPauseCommand.prototype.execute = function(notification) {\n    var note;\n    if (this.applicationState.getSeeking()) {\n      return;\n    }\n    switch (this.applicationState.getPlayState()) {\n      case PlayState.ENDED:\n        note = Notifications.REPLAY;\n        break;\n      case PlayState.PAUSED:\n      case PlayState.READY:\n        note = Notifications.PLAY;\n        break;\n      case PlayState.PLAYING:\n        note = Notifications.PAUSE;\n        break;\n      case PlayState.WAITING:\n        if (this.facade.getMediaElement().paused === true) {\n          note = Notifications.PLAY;\n        }\n    }\n    this.sendNotification(note, true);\n  };\n\n  /**\n   * The ToggleFullScreenCommand class.\n   *\n   * @constructor\n   * @private\n   * @extends {amp.player.controller.PlayerCommand}\n  */\n  function ToggleFullScreenCommand() {\n    ToggleFullScreenCommand.__super__.constructor.call(this);\n  }\n\n\n  __extends(ToggleFullScreenCommand, PlayerCommand);\n\n\n  /**\n   * Executes the command.\n   *\n   * @param {puremvc.Notification} notification\n   *    The notification.\n   *\n   * @override\n  */\n  ToggleFullScreenCommand.prototype.execute = function(notification) {\n    var state;\n    state = this.applicationState.getDisplayState() === DisplayState.FULL_SCREEN ? DisplayState.NORMAL : DisplayState.FULL_SCREEN;\n    this.sendNotification(Notifications.CHANGE_DISPLAY_STATE, state);\n  };\n\n  /**\n   * The PlayerCommand class. Base class for commands that need access\n   * to the application state or the media\n   *\n   * @constructor\n   * @private\n   * @extends {puremvc.SimpleCommand}\n  */\n  function PlayerEventCommand() {\n    PlayerEventCommand.__super__.constructor.call(this);\n  }\n\n\n  __extends(PlayerEventCommand, PlayerCommand);\n\n\n  /**\n   *\n  */\n  PlayerEventCommand.prototype.dispatchEvent = function(type, detail) {\n    var event;\n    if (typeof type !== \"string\") {\n      detail = type.getBody() != null ? type.getBody() : {};\n      type = type.getName();\n    }\n    event = new Event(type, detail);\n    this.sendNotification(Notifications.DISPATCH_EVENT, event);\n  };\n\n  /**\n   *\n  */\n  PlayerEventCommand.prototype.dispatchEventAfterCommand = function(type, detail) {\n    setTimeout(this.dispatchEvent.bind(this, type, detail), 0);\n  };\n\n  /**\n   * Executes the command.\n   *\n   * @param {puremvc.Notification} notification\n   *    The notification.\n   *\n   * @override\n  */\n  PlayerEventCommand.prototype.execute = function(notification) {\n    this.dispatchEvent(notification);\n  };\n\n  /**\n   * The PlayCommand class.\n   *\n   * @constructor\n   * @private\n   * @extends {puremvc.MacroCommand}\n  */\n  function PlayingCommand() {\n    PlayingCommand.__super__.constructor.call(this);\n  }\n\n\n  __extends(PlayingCommand, PlayerCommand);\n\n\n  /**\n   * Executes the command.\n   *\n   * @param {puremvc.Notification} notification\n   *    The notification.\n   *\n   * @override\n  */\n  PlayingCommand.prototype.execute = function(notification) {\n    if (this.applicationState.getIsUserActive() === true) {\n      return;\n    }\n    this.sendNotification(Notifications.CHANGE_PLAY_STATE, PlayState.PLAYING);\n  };\n\n  /**\n   * @enum {string}\n   * @const\n   * @private\n  */\n\n  var FullscreenMode = {\n    /**\n     *\n    */\n\n    EXTERNAL: \"external\"\n  };\n\n  /**\n   * @enum {string}\n   * @const\n   * @private\n  */\n\n  var ControlsMode = {\n    /**\n     * Constant representing auto controls mode\n    */\n\n    AUTO: \"auto\",\n    /**\n     * Constant representing the persistent controls mode\n    */\n\n    PERSISTENT: \"persistent\",\n    /**\n     * Constant representing none controls mode\n    */\n\n    NONE: \"none\"\n  };\n\n  /**\n   * The PauseCommand class.\n   *\n   * @constructor\n   * @private\n   * @extends {amp.player.controller.PlayerEventCommand}\n  */\n  function PauseCommand() {\n    PauseCommand.__super__.constructor.call(this);\n  }\n\n\n  __extends(PauseCommand, PlayerEventCommand);\n\n\n  /**\n   * Executes the command.\n   *\n   * @param {puremvc.Notification} notification\n   *    The notification.\n   *\n   * @override\n  */\n  PauseCommand.prototype.execute = function(notification) {\n    this.playback.pause();\n    this.sendNotification(Notifications.CHANGE_ACTIVE_STATE, ActiveState.ACTIVE);\n    PauseCommand.__super__.execute.call(this, notification);\n  };\n\n  /**\n   * The ChangeAutoplayCommand class.\n   *\n   * @constructor\n   * @private\n   * @extends {amp.player.controller.PlayerCommand}\n  */\n  function ChangeAutoplayCommand() {\n    ChangeAutoplayCommand.__super__.constructor.call(this);\n  }\n\n\n  __extends(ChangeAutoplayCommand, PlayerCommand);\n\n\n  /**\n   * Executes the command.\n   *\n   * @param {puremvc.Notification} notification\n   *    The notification.\n   *\n   * @override\n  */\n  ChangeAutoplayCommand.prototype.execute = function(notification) {\n    this.config.setAutoplay(notification.getBody());\n  };\n\n  /**\n   * The ChangeLoopCommand class.\n   *\n   * @constructor\n   * @private\n   * @extends {amp.player.controller.PlayerCommand}\n  */\n  function ChangeLoopCommand() {\n    ChangeLoopCommand.__super__.constructor.call(this);\n  }\n\n\n  __extends(ChangeLoopCommand, PlayerCommand);\n\n\n  /**\n   * Executes the command.\n   *\n   * @param {puremvc.Notification} notification\n   *    The notification.\n   *\n   * @override\n  */\n  ChangeLoopCommand.prototype.execute = function(notification) {\n    this.config.setLoop(notification.getBody());\n  };\n\n  /**\n   * The ChangeVolumeCommand class.\n   *\n   * @constructor\n   * @private\n   * @extends {amp.player.controller.PlayerCommand}\n  */\n  function ChangeVolumeCommand() {\n    ChangeVolumeCommand.__super__.constructor.call(this);\n  }\n\n\n  __extends(ChangeVolumeCommand, PlayerCommand);\n\n\n  /**\n   * Executes the command.\n   *\n   * @param {puremvc.Notification} notification\n   *    The notification.\n   *\n   * @override\n  */\n  ChangeVolumeCommand.prototype.execute = function(notification) {\n    this.playback.setVolume(notification.getBody());\n  };\n\n  /**\n   * The MediaValidatedCommand class.\n   *\n   * @constructor\n   * @private\n   * @extends {puremvc.SimpleCommand}\n  */\n  function MediaValidatedCommand() {\n    MediaValidatedCommand.__super__.constructor.call(this);\n  }\n\n\n  __extends(MediaValidatedCommand, PlayerCommand);\n\n\n  /**\n   * Executes the command.\n   *\n   * @param {puremvc.Notification} notification\n   *    The notification.\n   *\n   * @override\n  */\n  MediaValidatedCommand.prototype.execute = function(notification) {\n    var media;\n    media = notification.getBody();\n    this.sendNotification(Notifications.MEDIA_CHANGE, media);\n    if (this.applicationState.getLocked() === false && this.facade.getAutoplay() === true) {\n      setTimeout(this.sendNotification.bind(this, Notifications.PLAY), 0);\n    }\n  };\n\n  /**\n   * The SeekCommand class.\n   *\n   * @constructor\n   * @private\n   * @extends {puremvc.SimpleCommand}\n  */\n  function SeekCommand() {\n    SeekCommand.__super__.constructor.call(this);\n  }\n\n\n  __extends(SeekCommand, PlayerCommand);\n\n\n  /**\n   * Executes the command.\n   *\n   * @param {puremvc.Notification} notification\n   *    The notification.\n   *\n   * @override\n  */\n  SeekCommand.prototype.execute = function(notification) {\n    var handler, time, video,\n      _this = this;\n    time = notification.getBody();\n    if (time === 0 && this.media.getType() === Utils.mimeTypes.m3u8) {\n      time = 0.25;\n    }\n    if (time === this.playback.getCurrentTime()) {\n      return;\n    }\n    this.sendNotification(Notifications.CHANGE_PLAY_STATE, PlayState.WAITING);\n    this.sendNotification(Notifications.DISPLAY_TIME, {\n      currentTime: time,\n      duration: this.playback.getDuration()\n    });\n    this.sendNotification(Notifications.CHANGE_ACTIVE_STATE, ActiveState.ACTIVE);\n    video = this.facade.getMediaElement();\n    this.applicationState.pausedBeforeSeek = video.paused;\n    if (video.readyState === 0) {\n      handler = function(event) {\n        video.removeEventListener(\"loadedmetadata\", handler, false);\n        _this.playback.setCurrentTime(time);\n      };\n      video.addEventListener(\"loadedmetadata\", handler, false);\n    } else {\n      this.playback.setCurrentTime(time);\n    }\n  };\n\n  /**\n   * The SeekingCommand class.\n   *\n   * @constructor\n   * @private\n   * @extends {puremvc.SimpleCommand}\n  */\n  function SeekingCommand() {\n    SeekingCommand.__super__.constructor.call(this);\n  }\n\n\n  __extends(SeekingCommand, PlayerEventCommand);\n\n\n  /**\n   * Executes the command.\n   *\n   * @param {puremvc.Notification} notification\n   *    The notification.\n   *\n   * @override\n  */\n  SeekingCommand.prototype.execute = function(notification) {\n    if (this.applicationState.getSeeking() === true) {\n      return;\n    }\n    this.applicationState.setSeeking(true);\n    SeekingCommand.__super__.execute.call(this, notification);\n  };\n\n  /**\n   * The SeekedCommand class.\n   *\n   * @constructor\n   * @private\n   * @extends {puremvc.SimpleCommand}\n  */\n  function SeekedCommand() {\n    SeekedCommand.__super__.constructor.call(this);\n  }\n\n\n  __extends(SeekedCommand, PlayerEventCommand);\n\n\n  /**\n   * Executes the command.\n   *\n   * @param {puremvc.Notification} notification\n   *    The notification.\n   *\n   * @override\n  */\n  SeekedCommand.prototype.execute = function(notification) {\n    var _this = this;\n    if (this.applicationState.getIsUserActive() === true) {\n      setTimeout(this.sendNotification.bind(this, notification.getName(), notification.getBody()), 100);\n      return;\n    }\n    setTimeout(function() {\n      var state;\n      _this.applicationState.setSeeking(false);\n      _this.dispatchEvent(notification);\n      state = _this.applicationState.pausedBeforeSeek === true ? PlayState.PAUSED : PlayState.PLAYING;\n      if (_this.applicationState.displayState === \"full-screen\" && _this.applicationState.device === \"ipad\" && _this.facade.retrieveProxy(PlaybackProxy.NAME).getPaused() !== _this.facade.getMediaElement().paused) {\n        state = _this.facade.getMediaElement().paused === true ? PlayState.PAUSED : PlayState.PLAYING;\n      }\n      _this.sendNotification(Notifications.CHANGE_PLAY_STATE, state);\n    }, 1);\n  };\n\n  /**\n   * The ReplayCommand class.\n   *\n   * @constructor\n   * @private\n   * @extends {amp.player.controller.PlayerCommand}\n  */\n  function ReplayCommand() {\n    ReplayCommand.__super__.constructor.call(this);\n  }\n\n\n  __extends(ReplayCommand, PlayerCommand);\n\n\n  /**\n   * Executes the command.\n   *\n   * @param {puremvc.Notification} notification\n   *    The notification.\n   *\n   * @override\n  */\n  ReplayCommand.prototype.execute = function(notification) {\n    if (typeof this.playback.replay === \"function\") {\n      this.playback.replay();\n      return;\n    }\n    this.sendNotification(Notifications.SET_MEDIA, this.media.getData());\n  };\n\n  /**\n   * The EndCommand class.\n   *\n   * @constructor\n   * @private\n   * @extends {amp.player.controller.PlayerCommand}\n  */\n  function EndCommand() {\n    EndCommand.__super__.constructor.call(this);\n  }\n\n\n  __extends(EndCommand, PlayerCommand);\n\n\n  /**\n   * Executes the command.\n   *\n   * @param {puremvc.Notification} notification\n   *    The notification.\n   *\n   * @override\n  */\n  EndCommand.prototype.execute = function(notification) {\n    if (this.applicationState.getEnded()) {\n      return;\n    }\n    this.playback.setEnabled(false);\n    this.playback.pause();\n    this.playback.seek(this.playback.getDuration()).then(this.sendNotification.bind(this, Notifications.ENDED));\n  };\n\n  /**\n   * The EndedCommand class.\n   *\n   * @constructor\n   * @private\n   * @extends {amp.player.controller.PlayerEventCommand}\n  */\n  function EndedCommand() {\n    EndedCommand.__super__.constructor.call(this);\n  }\n\n\n  __extends(EndedCommand, PlayerEventCommand);\n\n\n  /**\n   * Executes the command.\n   *\n   * @param {puremvc.Notification} notification\n   *    The notification.\n   *\n   * @override\n  */\n  EndedCommand.prototype.execute = function(notification) {\n    if (this.applicationState.getEnded()) {\n      return;\n    }\n    this.applicationState.setEnded(true);\n    EndedCommand.__super__.execute.call(this, notification);\n    if (this.config.getLoop() === true) {\n      this.sendNotification(Notifications.REPLAY);\n    } else if (this.applicationState.getHasPostContent() === false) {\n      this.sendNotification(Notifications.MEDIA_SEQUENCE_ENDED);\n    }\n  };\n\n  /**\n   * The StartCommand class.\n   *\n   * @constructor\n   * @private\n   * @extends {amp.player.controller.PlayerCommand}\n  */\n  function StartCommand() {\n    StartCommand.__super__.constructor.call(this);\n  }\n\n\n  __extends(StartCommand, PlayerCommand);\n\n\n  /**\n   * Executes the command.\n   *\n   * @param {puremvc.Notification} notification\n   *    The notification.\n   *\n   * @override\n  */\n  StartCommand.prototype.execute = function(notification) {\n    this.sendNotification(Notifications.PLAY_REQUEST);\n    this.sendNotification(Notifications.DISPLAY_TIME, {\n      currentTime: 0,\n      duration: this.media.getDuration()\n    });\n    this.sendNotification(Notifications.STARTED, notification.getBody());\n  };\n\n  /**\n   * The IsUserActiveCommand class.\n   *\n   * @constructor\n   * @private\n   * @extends {amp.player.controller.PlayerCommand}\n  */\n  function IsUserActiveCommand() {\n    IsUserActiveCommand.__super__.constructor.call(this);\n  }\n\n\n  __extends(IsUserActiveCommand, PlayerCommand);\n\n\n  /**\n   * Executes the command.\n   *\n   * @param {puremvc.Notification} notification\n   *    The notification.\n   *\n   * @override\n  */\n  IsUserActiveCommand.prototype.execute = function(notification) {\n    this.applicationState.setIsUserActive(notification.getBody());\n  };\n\n  /**\n   * The WaitingCommand class.\n   *\n   * @constructor\n   * @private\n   * @extends {puremvc.SimpleCommand}\n  */\n  function WaitingCommand() {\n    WaitingCommand.__super__.constructor.call(this);\n  }\n\n\n  __extends(WaitingCommand, PlayerCommand);\n\n\n  /**\n   * Executes the command.\n   *\n   * @param {puremvc.Notification} notification\n   *    The notification.\n   *\n   * @override\n  */\n  WaitingCommand.prototype.execute = function(notification) {\n    this.sendNotification(Notifications.CHANGE_PLAY_STATE, PlayState.WAITING);\n  };\n\n  /**\n   * The ChangeMutedCommand class.\n   *\n   * @constructor\n   * @private\n   * @extends {amp.player.controller.PlayerCommand}\n  */\n  function ChangeMutedCommand() {\n    ChangeMutedCommand.__super__.constructor.call(this);\n  }\n\n\n  __extends(ChangeMutedCommand, PlayerCommand);\n\n\n  /**\n   * Executes the command.\n   *\n   * @param {puremvc.Notification} notification\n   *    The notification.\n   *\n   * @override\n  */\n  ChangeMutedCommand.prototype.execute = function(notification) {\n    this.playback.setMuted(notification.getBody());\n  };\n\n  /**\n   * The AuthorizedCommand class.\n   *\n   * @constructor\n   * @private\n   * @extends {amp.player.controller.PlayerEventCommand}\n  */\n  function AuthorizedCommand() {\n    AuthorizedCommand.__super__.constructor.call(this);\n  }\n\n\n  __extends(AuthorizedCommand, PlayerEventCommand);\n\n\n  /**\n   * Executes the command.\n   *\n   * @param {puremvc.Notification} notification\n   *    The notification.\n   *\n   * @override\n  */\n  AuthorizedCommand.prototype.execute = function(notification) {\n    if (this.security.getSession() != null) {\n      return;\n    }\n    this.security.setSession(UI.createUID());\n    this.sendNotification(Notifications.MEDIA_VALIDATED, this.media.getData());\n    AuthorizedCommand.__super__.execute.call(this, notification);\n  };\n\n  /**\n   * The InitializedCommand class.\n   *\n   * @constructor\n   * @private\n   * @extends {amp.player.controller.PlayerCommand}\n  */\n  function InitializedCommand() {\n    InitializedCommand.__super__.constructor.call(this);\n  }\n\n\n  __extends(InitializedCommand, PlayerCommand);\n\n\n  /**\n   * Executes the command.\n   *\n   * @param {puremvc.Notification} notification\n   *    The notification.\n   *\n   * @override\n  */\n  InitializedCommand.prototype.execute = function(notification) {\n    this.playback.initialized = true;\n  };\n\n  /**\n   * The RegisterPlaybackCoreCommand class.\n   *\n   * @constructor\n   * @private\n   * @extends {amp.player.controller.PlayerCommand}\n  */\n  function RegisterPlaybackCoreCommand() {\n    RegisterPlaybackCoreCommand.__super__.constructor.call(this);\n  }\n\n\n  __extends(RegisterPlaybackCoreCommand, PlayerCommand);\n\n\n  /**\n   * Executes the command.\n   *\n   * @param {puremvc.Notification} notification\n   *    The notification.\n   *\n   * @override\n  */\n  RegisterPlaybackCoreCommand.prototype.execute = function(notification) {\n    this.playerCore.registerPlaybackCore(notification.getBody());\n  };\n\n  /**\n   * The RecordContentChangeCommand class.\n   *\n   * @constructor\n   * @private\n   * @extends {amp.player.controller.PlayerCommand}\n  */\n  function RecordContentChangeCommand() {\n    RecordContentChangeCommand.__super__.constructor.call(this);\n  }\n\n\n  __extends(RecordContentChangeCommand, PlayerCommand);\n\n\n  /**\n   * Executes the command.\n   *\n   * @param {puremvc.Notification} notification\n   *    The notification.\n   *\n   * @override\n  */\n  RecordContentChangeCommand.prototype.execute = function(notification) {\n    var content;\n    content = notification.getBody();\n    this.sendNotification(Notifications.CHANGE_CONTENT, {\n      from: this.media.getData(),\n      to: content\n    });\n    this.media.updateData(content);\n    this.sendNotification(Notifications.UPDATE_DATA_BINDINGS);\n    this.sendNotification(Notifications.CHANGE_CONTENT, this.media.getData());\n  };\n\n  /**\n   * The TimeupdateCommand class.\n   *\n   * @constructor\n   * @private\n   * @extends {puremvc.SimpleCommand}\n  */\n  function TimeUpdateCommand() {\n    TimeUpdateCommand.__super__.constructor.call(this);\n  }\n\n\n  __extends(TimeUpdateCommand, PlayerEventCommand);\n\n\n  /**\n   * Executes the command.\n   *\n   * @param {puremvc.Notification} notification\n   *    The notification.\n   *\n   * @override\n  */\n  TimeUpdateCommand.prototype.execute = function(notification) {\n    this.sendNotification(Notifications.DISPLAY_TIME, {\n      currentTime: this.playback.getCurrentTime(),\n      duration: this.playback.getDuration()\n    });\n    TimeUpdateCommand.__super__.execute.call(this, notification);\n  };\n\n  /**\n   * The ToggleMutedCommand class.\n   *\n   * @constructor\n   * @private\n   * @extends {amp.player.controller.PlayerCommand}\n  */\n  function ToggleMutedCommand() {\n    ToggleMutedCommand.__super__.constructor.call(this);\n  }\n\n\n  __extends(ToggleMutedCommand, PlayerCommand);\n\n\n  /**\n   * Executes the command.\n   *\n   * @param {puremvc.Notification} notification\n   *    The notification.\n   *\n   * @override\n  */\n  ToggleMutedCommand.prototype.execute = function(notification) {\n    this.playback.setMuted(!this.playback.getMuted());\n  };\n\n  /**\n   * The PlayRequestCommand class.\n   *\n   * @constructor\n   * @private\n   * @extends {amp.player.controller.PlayerEventCommand}\n  */\n  function PlayRequestCommand() {\n    PlayRequestCommand.__super__.constructor.call(this);\n  }\n\n\n  __extends(PlayRequestCommand, PlayerEventCommand);\n\n\n  /**\n   * Executes the command.\n   *\n   * @param {puremvc.Notification} notification\n   *    The notification.\n   *\n   * @override\n  */\n  PlayRequestCommand.prototype.execute = function(notification) {\n    if (this.media.started === true) {\n      return;\n    }\n    this.media.started = true;\n    PlayRequestCommand.__super__.execute.call(this, notification);\n    this.sendNotification(Notifications.MEDIA_SEQUENCE_STARTED);\n  };\n\n  /**\n   * The EnableVideoEventsCommand class.\n   *\n   * @constructor\n   * @private\n   * @extends {puremvc.SimpleCommand}\n  */\n  function EnableVideoEventsCommand() {\n    EnableVideoEventsCommand.__super__.constructor.call(this);\n  }\n\n\n  __extends(EnableVideoEventsCommand, PlayerCommand);\n\n\n  /**\n   * Executes the command.\n   *\n   * @param {puremvc.Notification} notification\n   *    The notification.\n   *\n   * @override\n  */\n  EnableVideoEventsCommand.prototype.execute = function(notification) {\n    var event, events, video, _i, _len;\n    video = this.player.getMediaElement();\n    events = notification.getBody();\n    for (_i = 0, _len = events.length; _i < _len; _i++) {\n      event = events[_i];\n      video.addEventListener(event, this.playback.handlers[event]);\n    }\n  };\n\n  /**\n   * The DisableVideoEventsCommand class.\n   *\n   * @constructor\n   * @private\n   * @extends {puremvc.SimpleCommand}\n  */\n  function DisableVideoEventsCommand() {\n    DisableVideoEventsCommand.__super__.constructor.call(this);\n  }\n\n\n  __extends(DisableVideoEventsCommand, PlayerCommand);\n\n\n  /**\n   * Executes the command.\n   *\n   * @param {puremvc.Notification} notification\n   *    The notification.\n   *\n   * @override\n  */\n  DisableVideoEventsCommand.prototype.execute = function(notification) {\n    var event, events, video, _i, _len;\n    video = this.player.getMediaElement();\n    events = notification.getBody();\n    for (_i = 0, _len = events.length; _i < _len; _i++) {\n      event = events[_i];\n      video.removeEventListener(event, this.playback.handlers[event]);\n    }\n  };\n\n  /**\n   * The PauseCommand class.\n   *\n   * @constructor\n   * @private\n   * @extends {amp.player.controller.PlayerEventCommand}\n  */\n  function VolumeChangeCommand() {\n    VolumeChangeCommand.__super__.constructor.call(this);\n  }\n\n\n  __extends(VolumeChangeCommand, PlayerEventCommand);\n\n\n  /**\n   * Executes the command.\n   *\n   * @param {puremvc.Notification} notification\n   *    The notification.\n   *\n   * @override\n  */\n  VolumeChangeCommand.prototype.execute = function(notification) {\n    this.applicationState.setVolume(notification.getBody());\n    VolumeChangeCommand.__super__.execute.call(this, notification);\n  };\n\n  /**\n   * The HasPostContentCommand class.\n   *\n   * @constructor\n   * @private\n   * @extends {amp.player.controller.PlayerCommand}\n  */\n  function HasPostContentCommand() {\n    HasPostContentCommand.__super__.constructor.call(this);\n  }\n\n\n  __extends(HasPostContentCommand, PlayerCommand);\n\n\n  /**\n   * Executes the command.\n   *\n   * @param {puremvc.Notification} notification\n   *    The notification.\n   *\n   * @override\n  */\n  HasPostContentCommand.prototype.execute = function(notification) {\n    this.applicationState.setHasPostContent(notification.getBody());\n  };\n\n  /**\n   * The EndedCommand class.\n   *\n   * @constructor\n   * @private\n   * @extends {amp.player.controller.PlayerEventCommand}\n  */\n  function MediaSequenceEndedCommand() {\n    MediaSequenceEndedCommand.__super__.constructor.call(this);\n  }\n\n\n  __extends(MediaSequenceEndedCommand, PlayerEventCommand);\n\n\n  /**\n   * Executes the command.\n   *\n   * @param {puremvc.Notification} notification\n   *    The notification.\n   *\n   * @override\n  */\n  MediaSequenceEndedCommand.prototype.execute = function(notification) {\n    if (this.config.getLoop() === true) {\n      MediaSequenceEndedCommand.__super__.execute.call(this, notification);\n      this.sendNotification(Notifications.REPLAY);\n    } else {\n      this.sendNotification(Notifications.CHANGE_PLAY_STATE, PlayState.ENDED);\n      this.sendNotification(Notifications.CHANGE_ACTIVE_STATE, ActiveState.ACTIVE);\n      MediaSequenceEndedCommand.__super__.execute.call(this, notification);\n    }\n  };\n\n  /**\n   * The LockCommand class.\n   *\n   * @constructor\n   * @private\n   * @extends {amp.player.controller.PlayerCommand}\n  */\n  function LockCommand() {\n    LockCommand.__super__.constructor.call(this);\n  }\n\n\n  __extends(LockCommand, PlayerCommand);\n\n\n  /**\n   * Executes the command.\n   *\n   * @param {puremvc.Notification} notification\n   *    The notification.\n   *\n   * @override\n  */\n  LockCommand.prototype.execute = function(notification) {\n    var locked, note;\n    locked = notification.getBody();\n    note = locked ? Notifications.ADD_APPLICATION_STATE : Notifications.REMOVE_APPLICATION_STATE;\n    this.sendNotification(note, \"locked\");\n    this.applicationState.setLocked(locked);\n  };\n\n  /**\n   * The ChangeActiveStateCommand class.\n   *\n   * @constructor\n   * @private\n   * @extends {amp.player.controller.PlayerCommand}\n  */\n  function ChangeActiveStateCommand() {\n    ChangeActiveStateCommand.__super__.constructor.call(this);\n  }\n\n\n  __extends(ChangeActiveStateCommand, PlayerCommand);\n\n\n  /**\n   * Executes the command.\n   *\n   * @param {puremvc.Notification} notification\n   *    The notification.\n   *\n   * @override\n  */\n  ChangeActiveStateCommand.prototype.execute = function(notification) {\n    var state;\n    state = this.config.getControls().mode !== ControlsMode.PERSISTENT ? notification.getBody() : ActiveState.ACTIVE;\n    this.applicationState.setActiveState(state);\n  };\n\n  /**\n   * The ChangeDisplayStateCommand class.\n   *\n   * @constructor\n   * @private\n   * @extends {amp.player.controller.PlayerEventCommand}\n  */\n  function ChangeDisplayStateCommand() {\n    ChangeDisplayStateCommand.__super__.constructor.call(this);\n    this.keyHandler = this.keypress.bind(this);\n  }\n\n\n  __extends(ChangeDisplayStateCommand, PlayerEventCommand);\n\n\n  ChangeDisplayStateCommand.interval = null;\n\n  ChangeDisplayStateCommand.keyHandler = null;\n\n  ChangeDisplayStateCommand.prototype.keypress = function(event) {\n    switch (event.keyCode || event.which || event.charCode) {\n      case 27:\n        break;\n      case 32:\n        if (!this.facade.getEnded()) {\n          if (this.facade.getPaused()) {\n            this.facade.play();\n          } else {\n            this.facade.pause();\n          }\n        }\n    }\n  };\n\n  /**\n   * Executes the command.\n   *\n   * @param {puremvc.Notification} notification\n   *    The notification.\n   *\n   * @override\n  */\n  ChangeDisplayStateCommand.prototype.execute = function(notification) {\n    var core, fullscreen, state, view,\n      _this = this;\n    state = notification.getBody();\n    this.applicationState.setDisplayState(state);\n    if (this.config.getFullscreen().mode === FullscreenMode.EXTERNAL) {\n      this.sendNotifications(state);\n      return;\n    }\n    core = this.facade.getMediaElement();\n    view = this.facade.getViewComponent();\n    fullscreen = {};\n    if (view.webkitRequestFullScreen != null) {\n      fullscreen.enter = view.webkitRequestFullScreen.bind(view);\n      fullscreen.exit = document.webkitExitFullscreen != null ? document.webkitExitFullscreen.bind(document) : document.webkitCancelFullScreen.bind(document);\n      fullscreen.event = \"onwebkitfullscreenchange\";\n      fullscreen.element = \"webkitFullscreenElement\";\n      fullscreen.error = \"webkitfullscreenerror\";\n    } else if (view.requestFullscreen != null) {\n      fullscreen.enter = view.requestFullscreen.bind(view);\n      fullscreen.exit = document.exitFullscreen != null ? document.exitFullscreen.bind(document) : document.cancelFullscreen.bind(document);\n      fullscreen.event = \"onfullscreenchange\";\n      fullscreen.element = \"fullscreenElement\";\n      fullscreen.error = \"fullscreenerror\";\n    } else if (view.mozRequestFullScreen != null) {\n      fullscreen.enter = view.mozRequestFullScreen.bind(view);\n      fullscreen.exit = document.mozCancelFullScreen.bind(document);\n      fullscreen.event = \"onmozfullscreenchange\";\n      fullscreen.element = \"mozFullscreenElement\";\n      fullscreen.error = \"mozfullscreenerror\";\n    } else if (view.msRequestFullscreen != null) {\n      fullscreen.enter = view.msRequestFullscreen.bind(view);\n      fullscreen.exit = document.msExitFullscreen.bind(document);\n      fullscreen.event = \"MSFullscreenChange\";\n      fullscreen.element = \"msFullscreenElement\";\n      fullscreen.error = \"MSFullscreenError\";\n    } else if (core.webkitEnterFullscreen != null) {\n      fullscreen.enter = core.webkitEnterFullscreen.bind(core);\n      fullscreen.exit = core.webkitExitFullscreen.bind(core);\n      fullscreen.event = null;\n      fullscreen.error = null;\n    }\n    if (state === DisplayState.FULL_SCREEN) {\n      if (fullscreen.event != null) {\n        if (view.mozRequestFullScreen != null) {\n          document[fullscreen.event] = function(event) {\n            if (!document.mozFullScreen) {\n              return _this.sendNotification(Notifications.CHANGE_DISPLAY_STATE, DisplayState.NORMAL);\n            }\n          };\n        } else {\n          view[fullscreen.event] = function(event) {\n            if (!(document[fullscreen.element] != null)) {\n              return _this.sendNotification(Notifications.CHANGE_DISPLAY_STATE, DisplayState.NORMAL);\n            }\n          };\n        }\n      } else {\n        clearInterval(ChangeDisplayStateCommand.interval);\n        ChangeDisplayStateCommand.interval = setInterval(function() {\n          if (core.webkitDisplayingFullscreen !== true) {\n            _this.sendNotification(Notifications.CHANGE_DISPLAY_STATE, DisplayState.NORMAL);\n            clearInterval(ChangeDisplayStateCommand.interval);\n          }\n        }, 100);\n      }\n      if (fullscreen.error != null) {\n        document.addEventListener(fullscreen.error, this.facade.logger.error.bind(this.facade.logger));\n      }\n      fullscreen.enter();\n      this.playback.keyHandler = this.keypress.bind(this);\n      window.addEventListener(\"keypress\", this.playback.keyHandler);\n    } else if (state === DisplayState.NORMAL) {\n      window.removeEventListener(\"keypress\", this.playback.keyHandler);\n      this.playback.keyHandler = null;\n      if (fullscreen != null) {\n        if (typeof fullscreen.exit === \"function\") {\n          fullscreen.exit();\n        }\n      }\n      core[fullscreen.event] = null;\n      clearInterval(ChangeDisplayStateCommand.interval);\n    }\n    this.sendNotifications(state);\n  };\n\n  ChangeDisplayStateCommand.prototype.sendNotifications = function(state) {\n    setTimeout(this.sendNotification.bind(this, Notifications.FULL_SCREEN_CHANGE, state), 100);\n    this.dispatchEvent(\"fullscreenchange\", state === DisplayState.FULL_SCREEN);\n  };\n\n  /**\n   * The PlayCommand class.\n   *\n   * @constructor\n   * @private\n   * @extends {amp.player.controller.PlayerEventCommand}\n  */\n  function PlayCommand() {\n    PlayCommand.__super__.constructor.call(this);\n  }\n\n\n  __extends(PlayCommand, PlayerEventCommand);\n\n\n  /**\n   * Executes the command.\n   *\n   * @param {puremvc.Notification} notification\n   *    The notification.\n   *\n   * @override\n  */\n  PlayCommand.prototype.execute = function(notification) {\n    var userInitiated;\n    if (this.applicationState.getLocked() === true) {\n      return;\n    }\n    userInitiated = notification.getBody();\n    if (userInitiated && this.playback.initialized !== true) {\n      this.sendNotification(Notifications.INITIALIZED);\n    }\n    if (this.playback.initialized !== true || (!this.media.getSrc() && !this.media.getSource())) {\n      return;\n    }\n    if (!this.playback.getStarted()) {\n      this.sendNotification(Notifications.START);\n    }\n    this.playback.play();\n    PlayCommand.__super__.execute.call(this, notification);\n  };\n\n  /**\n   * The ToggleActiveCommand class.\n   *\n   * @constructor\n   * @private\n   * @extends {amp.player.controller.PlayerCommand}\n  */\n  function ToggleActiveCommand() {\n    ToggleActiveCommand.__super__.constructor.call(this);\n  }\n\n\n  __extends(ToggleActiveCommand, PlayerCommand);\n\n\n  /**\n   * Executes the command.\n   *\n   * @param {puremvc.Notification} notification\n   *    The notification.\n   *\n   * @override\n  */\n  ToggleActiveCommand.prototype.execute = function(notification) {\n    var state;\n    state = this.applicationState.getActiveState() === ActiveState.ACTIVE ? ActiveState.INACTIVE : ActiveState.ACTIVE;\n    this.sendNotification(Notifications.CHANGE_ACTIVE_STATE, state);\n  };\n\n  function Track(data) {\n    this.data = data != null ? data : {};\n    Track.__super__.constructor.call(this);\n  }\n\n\n  __extends(Track, EventDispatcher);\n\n\n  Track.prototype.getKind = function() {\n    return this.data.kind;\n  };\n\n  Track.prototype.getLabel = function() {\n    return this.data.label;\n  };\n\n  Track.prototype.getLanguage = function() {\n    return this.data.language;\n  };\n\n  Track.prototype.getId = function() {\n    return this.data.id;\n  };\n\n  Track.prototype.setEnabled = function(value) {\n    if (value === this.data.enabled) {\n      return;\n    }\n    this.data.enabled = value;\n    this.changeEnabled(value);\n    this.dispatchEvent(\"change\");\n  };\n\n  Track.prototype.changeEnabled = function(value) {};\n\n  Track.prototype.getEnabled = function() {\n    return this.data.enabled;\n  };\n\n  function XMLUtils() {}\n\n  XMLUtils.createTextContent = function(xml, text) {\n    var node;\n    node = /[\\&<>]/.test(text) ? xml.createCDATASection(text) : xml.createTextNode(text);\n    return node;\n  };\n\n  XMLUtils.updateTextContent = function(node, str) {\n    var text;\n    text = XMLUtils.createTextContent(node.ownerDocument, str);\n    node.removeChild(node.childNodes[0]);\n    node.appendChild(text);\n    return node;\n  };\n\n  XMLUtils.serialize = function(xml) {\n    var serializer;\n    if (!(xml != null)) {\n      return;\n    }\n    if (typeof xml === \"string\") {\n      return xml;\n    }\n    try {\n      serializer = new XMLSerializer();\n      return serializer.serializeToString(xml);\n    } catch (err1) {\n      try {\n        serializer = document.implementation.createLSSerializer();\n        return xmlSerializer.writeToString(xml);\n      } catch (err3) {\n        try {\n          return xml.xml;\n        } catch (err2) {\n\n        }\n      }\n    }\n  };\n\n  XMLUtils.parse = function(text) {\n    var parser, xmlDoc;\n    if (window.DOMParser) {\n      parser = new DOMParser();\n      xmlDoc = parser.parseFromString(text, \"text/xml\");\n    } else {\n      xmlDoc = new ActiveXObject(\"Microsoft.XMLDOM\");\n      xmlDoc.async = false;\n      xmlDoc.loadXML(text);\n    }\n    return xmlDoc;\n  };\n\n  /**\n   * Creates a new instance of TracksProxy.\n   *\n   * @constructor\n   * @private\n   * @extends {DataBindingContext}\n  */\n  function TracksProxy() {\n    TracksProxy.__super__.constructor.call(this, null, {});\n    this.data.audioTracks = new TrackList();\n    this.data.videoTracks = new TrackList();\n    this.data.textTracks = new TrackList();\n  }\n\n\n  __extends(TracksProxy, puremvc.Proxy);\n\n\n  /** @static\n  */\n  TracksProxy.NAME = \"TracksProxy\";\n\n  TracksProxy.prototype.clear = function() {\n    this.data.audioTracks.clear();\n    this.data.videoTracks.clear();\n    this.data.textTracks.clear();\n  };\n\n  TracksProxy.prototype.getAudioTracks = function() {\n    return this.data.audioTracks;\n  };\n\n  TracksProxy.prototype.getVideoTracks = function() {\n    return this.data.videoTracks;\n  };\n\n  TracksProxy.prototype.getTextTracks = function() {\n    return this.data.textTracks;\n  };\n\n  /**\n   * The base player class.\n   *\n   * @param {Object} config\n   * @param {Object} viewComponent\n   * @constructor\n   * @private\n   * @extends {Module}\n  */\n  function Player(viewComponent) {\n    Player.__super__.constructor.call(this, viewComponent);\n    this.initTime = Date.now();\n  }\n\n\n  __extends(Player, Module);\n\n\n  Player.prototype.moduleName = \"amp\";\n\n  Player.prototype.playerType = null;\n\n  Player.prototype.hidden = false;\n\n  Player.prototype.l10n = null;\n\n  Player.prototype.appState = null;\n\n  Player.prototype.mediaProxy = null;\n\n  Player.prototype.bindings = null;\n\n  Player.prototype.configuration = null;\n\n  Player.prototype.params = null;\n\n  Player.prototype.security = null;\n\n  Player.prototype.createModel = function() {\n    this.appState = new ApplicationStateProxy();\n    this.registerProxy(this.appState);\n    this.bindings = new DataBindingProxy();\n    this.registerProxy(this.bindings);\n    this.security = new SecurityProxy();\n    this.registerProxy(this.security);\n    this.mediaProxy = new MediaProxy();\n    this.registerProxy(this.mediaProxy);\n    this.params = new ParamsProxy(this.config.params);\n    this.registerProxy(this.params);\n    this.configuration = new ConfigurationProxy(this.config);\n    this.registerProxy(this.configuration);\n  };\n\n  /** @override\n  */\n  Player.prototype.setViewComponent = function(viewComponent) {\n    viewComponent[\"amp\"] = this;\n    return Player.__super__.setViewComponent.call(this, viewComponent);\n  };\n\n  /**\n  */\n  Player.prototype.getPlayerType = function() {\n    return this.playerType;\n  };\n\n  /**\n  */\n  Player.prototype.getVersion = function() {\n    return AMP.getVersion();\n  };\n\n  /**\n  */\n  Player.prototype.createPlugins = function() {\n    this.sendNotification(PluginNotifications.REGISTER_PLUGINS, this.config);\n  };\n\n  /**\n  */\n  Player.prototype.createMediaElement = function() {\n    return null;\n  };\n\n  /** @override\n  */\n  Player.prototype.createFramework = function() {\n    Player.__super__.createFramework.call(this);\n    this.setMediaElement(this.createMediaElement());\n    this.createPlugins();\n  };\n\n  /**\n  */\n  Player.prototype.getLanguage = function() {\n    return this.retrieveProxy(LocalizationProxy.NAME).getLanguage();\n  };\n\n  /**\n  */\n  Player.prototype.setLanguage = function(value) {\n    this.retrieveProxy(LocalizationProxy.NAME).setLanguage(value);\n    return value;\n  };\n\n  /**\n   * @return {HTMLObject|HTMLMediaElement} The media playback DOM element.\n  */\n  Player.prototype.getMediaElement = function() {\n    return this.appState.getMediaElement();\n  };\n\n  /**\n  */\n  Player.prototype.setMediaElement = function(value) {\n    function isMobile() {\n      var check = false;\n      (function(a) {if(/(android|bb\\d+|meego).+mobile|avantgo|bada\\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\\-(n|u)|c55\\/|capi|ccwa|cdm\\-|cell|chtm|cldc|cmd\\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\\-s|devi|dica|dmob|do(c|p)o|ds(12|\\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\\-|_)|g1 u|g560|gene|gf\\-5|g\\-mo|go(\\.w|od)|gr(ad|un)|haie|hcit|hd\\-(m|p|t)|hei\\-|hi(pt|ta)|hp( i|ip)|hs\\-c|ht(c(\\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\\-(20|go|ma)|i230|iac( |\\-|\\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\\/)|klon|kpt |kwc\\-|kyo(c|k)|le(no|xi)|lg( g|\\/(k|l|u)|50|54|\\-[a-w])|libw|lynx|m1\\-w|m3ga|m50\\/|ma(te|ui|xo)|mc(01|21|ca)|m\\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\\-2|po(ck|rt|se)|prox|psio|pt\\-g|qa\\-a|qc(07|12|21|32|60|\\-[2-7]|i\\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\\-|oo|p\\-)|sdk\\/|se(c(\\-|0|1)|47|mc|nd|ri)|sgh\\-|shar|sie(\\-|m)|sk\\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\\-|v\\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\\-|tdg\\-|tel(i|m)|tim\\-|t\\-mo|to(pl|sh)|ts(70|m\\-|m3|m5)|tx\\-9|up(\\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\\-|your|zeto|zte\\-/i.test(a.substr(0, 4)))check = true})(navigator.userAgent||navigator.vendor||window.opera)\n      return check;\n    }\n    function isIpad() {\n      return navigator.userAgent.match(/iPad/i) !== null;\n    }\n    if((isMobile() && !isIpad())) {\n      value.setAttribute('playsinline', '');\n      value.setAttribute('controls', '');\n      console.log('dd', this.config.autoplay);\n      if(this.config.autoplay === true) {\n        function handleStart() {\n          var self = document.querySelector('video');\n          self.muted = false;\n          self.volume = 0.99;\n          self.removeEventListener('touchstart', handleStart, false);\n          window.inLineMutedState = false;\n          value.removeAttribute('autoplay');\n          value.removeAttribute('muted');\n        }\n        if(window.inLineMutedState !== false) {\n          value.setAttribute('autoplay', '');\n          value.setAttribute('muted', '');\n          value.addEventListener('touchstart', handleStart, false);\n        }\n      }\n    }\n    this.appState.setMediaElement(value);\n    return value;\n  };\n\n  /**\n   * @return {HTMLElement} The container div.\n  */\n  Player.prototype.getContainer = function() {\n    return this.getViewComponent();\n  };\n\n  /**\n   * @return {HTMLElement} The container div.\n  */\n  Player.prototype.getAudioTracks = function() {};\n\n  /**\n   * @param   {string}  binding\n   *    A data bound string to evaluate.\n   *\n   * @return {Object}\n   *    The evaluated result\n  */\n  Player.prototype.evaluateBinding = function(binding) {};\n\n  /**\n   * Determines if the core can play a given mimeType.\n   *\n   * @param   {string}  type\n   *    The mimetype to check.\n   *\n   * @return  {string}  \"\"\n   *    if the core can't play the mimeType\n  */\n  Player.prototype.canPlayType = function(type) {};\n\n  /**\n   * Loads the video.\n  */\n  Player.prototype.load = function() {};\n\n  /**\n   * Plays the currently loaded video.\n  */\n  Player.prototype.play = function() {};\n\n  /**\n   * Plays the currently loaded video from its start time.\n  */\n  Player.prototype.replay = function() {};\n\n  /**\n   * Pauses the currently loaded video.\n  */\n  Player.prototype.pause = function() {};\n\n  /**\n   * Ends video playback.\n  */\n  Player.prototype.end = function() {};\n\n  /**\n   * Sets user params.\n   *\n   * @param {Object} value The user params object.\n  */\n  Player.prototype.setParams = function(value) {};\n\n  /**\n   * Gets user params.\n   *\n   * @return {Object} The user params object.\n  */\n  Player.prototype.getParams = function() {};\n\n  /**\n   * Sets auto play flag.\n   *\n   * @param {boolean} value The autoplay flash.\n  */\n  Player.prototype.setAutoplay = function(value) {};\n\n  /**\n   * Gets auto play flag.\n   *\n   * @return {boolean} The autoplay flash.\n  */\n  Player.prototype.getAutoplay = function() {};\n\n  /**\n   * Sets player's loop flag.\n   *\n   * @param {boolean} value The loop flag.\n  */\n  Player.prototype.setLoop = function(value) {};\n\n  /**\n   * Gets player's loop flag.\n   *\n   * @return {boolean} The loop flag.\n  */\n  Player.prototype.getLoop = function() {};\n\n  /**\n   * Sets player's muted value.\n   *\n   * @param {boolean} value The muted value.\n  */\n  Player.prototype.setMuted = function(value) {};\n\n  /**\n   * Gets player's muted value.\n   *\n   * @return {boolean} The muted value.\n  */\n  Player.prototype.getMuted = function() {};\n\n  /**\n   * Mutes the player.\n  */\n  Player.prototype.mute = function() {\n    return this.setMuted(true);\n  };\n\n  /**\n   * Unmutes the player.\n  */\n  Player.prototype.unmute = function() {\n    return this.setMuted(false);\n  };\n\n  /**\n   * Sets the media object.\n   *\n   * @param {Object} value The media object for the video to play.\n  */\n  Player.prototype.setMedia = function(value) {\n    var source, src, _ref, _ref1;\n    src = value.src;\n    source = (_ref = value.source) != null ? (_ref1 = _ref[0]) != null ? _ref1.src : void 0 : void 0;\n    if ((!(src != null) || src === \"\") && (!(source != null) || source === \"\")) {\n      throw new Error(\"[AMP ERROR] Invalid Media\");\n    }\n  };\n\n  /**\n   * Gets the media object.\n   *\n   * @return {Object} The media object for the video to play.\n  */\n  Player.prototype.getMedia = function() {};\n\n  /**\n   * Sets the current time of the video.\n   *\n   * @param {number} value The desired time to seek to.\n  */\n  Player.prototype.setCurrentTime = function(value) {};\n\n  /**\n   * Gets the current time of the video.\n   *\n   * @return {number} The current playhead time.\n  */\n  Player.prototype.getCurrentTime = function() {};\n\n  /**\n   * Gets the current time of the video as a UTC timestamp.\n   *\n   * @return {number} The current playhead time as a UTC timestamp.\n  */\n  Player.prototype.getCurrentTimeUTC = function() {};\n\n  /**\n   * Gets the current time of the video.\n   *\n   * @return {number} The current time of the video.\n  */\n  Player.prototype.getDuration = function() {};\n\n  /**\n   * Sets the source url of video.\n   *\n   * @param {string} value The source url of the video to play.\n  */\n  Player.prototype.setSrc = function(value) {};\n\n  /**\n   * Gets the source url of video.\n   *\n   * @return {string} The source url of the video to play.\n  */\n  Player.prototype.getSrc = function() {};\n\n  /**\n   * Sets the source url of video.\n   *\n   * @param {Array.<Object>} value An array of source objects to choose from.\n  */\n  Player.prototype.setSource = function(value) {};\n\n  /**\n   * Gets the source url of video.\n   *\n   * @return {Array.<Object>} An array of source objects to choose from.\n  */\n  Player.prototype.getSource = function() {};\n\n  /**\n   * Sets the source url of video.\n   *\n   * @param {number} value The source url of the video to play.\n  */\n  Player.prototype.setVolume = function(value) {};\n\n  /**\n   * Gets the source url of video.\n   *\n   * @return {number} The volume a number between 0 and 1.\n  */\n  Player.prototype.getVolume = function() {};\n\n  /**\n   * Gets the source url of video.\n   *\n   * @return {boolean} The source url of the video.\n  */\n  Player.prototype.getSeeking = function() {};\n\n  /**\n   * Gets the source url of video.\n   *\n   * @return {boolean} The source url of the video.\n  */\n  Player.prototype.getPaused = function() {};\n\n  /**\n   * Gets the source url of video.\n   *\n   * @return {number} The source url of the video.\n  */\n  Player.prototype.getEnded = function() {};\n\n  /**\n   * Sets the player's display state.\n   *\n   * @param {DisplayState} value\n   *    The display state.\n  */\n  Player.prototype.setDisplayState = function(value) {};\n\n  /**\n   * Returns the player's display state.\n   *\n   * @return {DisplayState}\n   *    The display state.\n  */\n  Player.prototype.getDisplayState = function() {};\n\n  /**\n   * Returns the player error.\n   *\n   * @return {Error}\n   *    The Error\n  */\n  Player.prototype.getError = function() {};\n\n  /**\n   * Enters the player into full screen mode.\n  */\n  Player.prototype.enterFullScreen = function() {};\n\n  /**\n   * Exits the player out of full screen mode.\n  */\n  Player.prototype.exitFullScreen = function() {};\n\n  /**\n   * Show the player\n  */\n  Player.prototype.setHidden = function(value) {\n    var style;\n    if (value === this.appState.getHidden()) {\n      return;\n    }\n    this.appState.setHidden(value);\n    style = this.viewComponent.style;\n    if (value === true) {\n      this.hiddenData = {\n        width: style.width,\n        height: style.height,\n        paused: this.getPaused()\n      };\n      style.width = style.height = \"0px\";\n      if (this.hiddenData.paused === false) {\n        this.pause();\n      }\n    } else {\n      style.width = this.hiddenData.width;\n      style.height = this.hiddenData.height;\n      if (this.hiddenData.paused === false) {\n        this.play();\n      }\n      this.hiddenData = null;\n    }\n  };\n\n  /**\n   * Hide the player\n  */\n  Player.prototype.getHidden = function() {\n    return this.appState.getHidden();\n  };\n\n  /**\n   * Records a content change\n   *\n   * @param {Object} content\n   *    An object representing the new content\n  */\n  Player.prototype.recordContentChange = function(content) {};\n\n  /**\n   * Sets the rate of playback.\n  */\n  Player.prototype.setPlaybackRate = function() {};\n\n  /**\n   * Gets the rate of playback.\n  */\n  Player.prototype.getPlaybackRate = function() {};\n\n  /**\n   * Gets the play state.\n  */\n  Player.prototype.getPlaystate = function() {};\n\n  /**\n   * Gets the play state.\n  */\n  Player.prototype.authorize = function(authorization) {\n    return this.security.authorize(authorization);\n  };\n\n  /**\n   * The HTMLPlayer class.\n   *\n   * @param {Object} viewComponent\n   * @constructor\n   * @private\n   * @extends {Player}\n  */\n  function HTMLPlayer(viewComponent) {\n    HTMLPlayer.__super__.constructor.call(this, viewComponent);\n  }\n\n\n  __extends(HTMLPlayer, Player);\n\n\n  HTMLPlayer.prototype.playerType = \"html\";\n\n  HTMLPlayer.prototype.playerCore = null;\n\n  HTMLPlayer.prototype.tracks = null;\n\n  HTMLPlayer.prototype.mediator = null;\n\n  /** @override\n  */\n  HTMLPlayer.prototype.createMediaElement = function() {\n    var viewComponent;\n    this.mediator = new MediaElementMediator(\"html5\", \"video\");\n    this.sendNotification(Notifications.PLAYBACK_CORE_CHANGE, this.mediator);\n    viewComponent = this.mediator.getViewComponent();\n    if (viewComponent.dataset == null) {\n      viewComponent.dataset = {};\n    }\n    return viewComponent;\n  };\n\n  /** @override\n  */\n  HTMLPlayer.prototype.createModel = function() {\n    var playbackProxy;\n    HTMLPlayer.__super__.createModel.call(this);\n    this.registerProxy(new LocalizationProxy(this.config));\n    playbackProxy = new PlaybackCoreProxy();\n    this.registerProxy(playbackProxy);\n    this.playerCore = new PlayerProxy(playbackProxy, this.config.getPlaybackOrder);\n    this.registerProxy(this.playerCore);\n    this.tracks = new TracksProxy();\n    this.registerProxy(this.tracks);\n    this.appState.setRenderMode(RenderMode.HTML);\n    this.bindings.initialize();\n  };\n\n  /** @override\n  */\n  HTMLPlayer.prototype.createView = function() {\n    this.registerMediator(new PlayerMediator(\"html5\", this.getViewComponent()));\n    this.registerMediator(new PluginAdapter());\n    this.registerMediator(new VideoLayerMediator());\n    this.registerMediator(new OverlayLayerMediator());\n  };\n\n  /** @override\n  */\n  HTMLPlayer.prototype.createController = function() {\n    HTMLPlayer.__super__.createController.call(this);\n    this.registerCommand(PluginNotifications.PLUGINS_INITIALIZED, PluginsInitializedCommand);\n    this.registerCommand(Notifications.PLAY, PlayCommand);\n    this.registerCommand(Notifications.PLAYING, PlayingCommand);\n    this.registerCommand(Notifications.PAUSE, PauseCommand);\n    this.registerCommand(Notifications.CHANGE_PLAY_STATE, ChangePlayStateCommand);\n    this.registerCommand(Notifications.TOGGLE_FULL_SCREEN, ToggleFullScreenCommand);\n    this.registerCommand(Notifications.CHANGE_DISPLAY_STATE, ChangeDisplayStateCommand);\n    this.registerCommand(Notifications.TOGGLE_ACTIVE, ToggleActiveCommand);\n    this.registerCommand(Notifications.CHANGE_ACTIVE_STATE, ChangeActiveStateCommand);\n    this.registerCommand(Notifications.SET_MEDIA, SetMediaCommand);\n    this.registerCommand(Notifications.CHANGE_MEDIA, ChangeMediaCommand);\n    this.registerCommand(Notifications.MEDIA_VALIDATED, MediaValidatedCommand);\n    this.registerCommand(Notifications.MEDIA_CHANGE, MediaChangeCommand);\n    this.registerCommand(Notifications.UPDATE_DATA_BINDINGS, UpdateDataBindingsCommand);\n    this.registerCommand(Notifications.START, StartCommand);\n    this.registerCommand(Notifications.SEEK, SeekCommand);\n    this.registerCommand(Notifications.SEEKING, SeekingCommand);\n    this.registerCommand(Notifications.SEEKED, SeekedCommand);\n    this.registerCommand(Notifications.CHANGE_VOLUME, ChangeVolumeCommand);\n    this.registerCommand(Notifications.CHANGE_MUTED, ChangeMutedCommand);\n    this.registerCommand(Notifications.CHANGE_AUTOPLAY, ChangeAutoplayCommand);\n    this.registerCommand(Notifications.CHANGE_LOOP, ChangeLoopCommand);\n    this.registerCommand(Notifications.END, EndCommand);\n    this.registerCommand(Notifications.ENDED, EndedCommand);\n    this.registerCommand(Notifications.REPLAY, ReplayCommand);\n    this.registerCommand(Notifications.ERROR, ErrorCommand);\n    this.registerCommand(Notifications.READY, ReadyCommand);\n    this.registerCommand(Notifications.WAITING, WaitingCommand);\n    this.registerCommand(Notifications.CHANGE_DURATION, ChangeDurationCommand);\n    this.registerCommand(Notifications.CHANGE_PARAMS, ChangeParamsCommand);\n    this.registerCommand(Notifications.IS_USER_ACTIVE, IsUserActiveCommand);\n    this.registerCommand(SecurityNotifications.AUTHORIZED, AuthorizedCommand);\n    this.registerCommand(Notifications.INITIALIZED, InitializedCommand);\n    this.registerCommand(Notifications.REGISTER_PLAYBACK_CORE, RegisterPlaybackCoreCommand);\n    this.registerCommand(UserNotifications.TOGGLE_PLAY_PAUSE, TogglePlayPauseCommand);\n    this.registerCommand(UserNotifications.SEEK, SeekCommand);\n    this.registerCommand(Notifications.CHANGE_PLAYBACK_TARGET, ChangePlaybackTargetCommand);\n    this.registerCommand(Notifications.PLAYBACK_TARGET_CHANGE, PlaybackTargetChangeCommand);\n    this.registerCommand(Notifications.RECORD_CONTENT_CHANGE, RecordContentChangeCommand);\n    this.registerCommand(Notifications.TIME_UPDATE, TimeUpdateCommand);\n    this.registerCommand(Notifications.TOGGLE_MUTED, ToggleMutedCommand);\n    this.registerCommand(Notifications.VOLUME_CHANGE, VolumeChangeCommand);\n    this.registerCommand(Notifications.PLAY_REQUEST, PlayRequestCommand);\n    this.registerCommand(Notifications.HAS_POST_CONTENT, HasPostContentCommand);\n    this.registerCommand(Notifications.LOCK, LockCommand);\n    this.registerCommand(Notifications.PLAY_STATE_CHANGE, PlayerEventCommand);\n    this.registerCommand(Notifications.PROGRESS, PlayerEventCommand);\n    this.registerCommand(Notifications.CAN_PLAY, PlayerEventCommand);\n    this.registerCommand(Notifications.CAN_PLAY_THROUGH, PlayerEventCommand);\n    this.registerCommand(Notifications.LOAD_START, PlayerEventCommand);\n    this.registerCommand(Notifications.STARTED, PlayerEventCommand);\n    this.registerCommand(Notifications.LOADED_METADATA, PlayerEventCommand);\n    this.registerCommand(Notifications.DURATION_CHANGE, PlayerEventCommand);\n    this.registerCommand(Notifications.MEDIUM_CHANGE, PlayerEventCommand);\n    this.registerCommand(Notifications.TEMPORAL_TYPE_CHANGE, PlayerEventCommand);\n    this.registerCommand(Notifications.LANGUAGE_CHANGE, PlayerEventCommand);\n    this.registerCommand(Notifications.PLAYBACK_TARGET_AVAILABLE, PlayerEventCommand);\n    this.registerCommand(SecurityNotifications.AUTHORIZE, PlayerEventCommand);\n    this.registerCommand(SecurityNotifications.AUTHORIZATION_FAILED, PlayerEventCommand);\n    this.registerCommand(Notifications.FAIL_OVER_ATTEMPT, PlayerEventCommand);\n    this.registerCommand(Notifications.IS_LIVE, PlayerEventCommand);\n    this.registerCommand(Notifications.TIMED_METADATA, PlayerEventCommand);\n    this.registerCommand(Notifications.PAUSED, PlayerEventCommand);\n    this.registerCommand(Notifications.STALLED, PlayerEventCommand);\n    this.registerCommand(Notifications.MEDIA_SEQUENCE_STARTED, PlayerEventCommand);\n    this.registerCommand(Notifications.MEDIA_SEQUENCE_ENDED, MediaSequenceEndedCommand);\n    this.registerCommand(Notifications.ENABLE_VIDEO_EVENTS, EnableVideoEventsCommand);\n    this.registerCommand(Notifications.DISABLE_VIDEO_EVENTS, DisableVideoEventsCommand);\n  };\n\n  /** @override\n  */\n  HTMLPlayer.prototype.setMediaElement = function(value) {\n    var mediaElement;\n    mediaElement = this.getMediaElement();\n    if (mediaElement != null) {\n      mediaElement.removeEventListener(\"webkitpresentationmodechanged\", this.presentationModeChanged);\n    }\n    HTMLPlayer.__super__.setMediaElement.call(this, value);\n    value.playsInline = this.configuration.getPlaysInLine();\n    value.addEventListener(\"webkitpresentationmodechanged\", this.presentationModeChanged);\n    return value;\n  };\n\n  /**\n   * HACK: Fix for iOS 10 manipulating controls property incorrectly after leaving fullscreen\n  */\n  HTMLPlayer.prototype.presentationModeChanged = function(event) {\n    if (\"inline\" === event.target.webkitPresentationMode) {\n      event.target.controls = false;\n    }\n  };\n\n  HTMLPlayer.prototype.evaluateBinding = function(binding) {\n    return this.bindings.evaluateBinding(binding);\n  };\n\n  HTMLPlayer.prototype.recordContentChange = function(content) {\n    this.sendNotification(Notifications.RECORD_CONTENT_CHANGE, content);\n  };\n\n  HTMLPlayer.prototype.canPlayType = function(type) {\n    return this.retrieveProxy(PlaybackProxy.NAME).canPlayType(type);\n  };\n\n  HTMLPlayer.prototype.getAudioTracks = function() {\n    return this.retrieveProxy(TracksProxy.NAME).getAudioTracks();\n  };\n\n  HTMLPlayer.prototype.load = function() {\n    this.sendNotification(Notifications.LOAD);\n  };\n\n  HTMLPlayer.prototype.play = function() {\n    this.sendNotification(Notifications.PLAY, true);\n  };\n\n  HTMLPlayer.prototype.replay = function() {\n    this.sendNotification(Notifications.REPLAY);\n  };\n\n  HTMLPlayer.prototype.pause = function() {\n    this.sendNotification(Notifications.PAUSE);\n  };\n\n  HTMLPlayer.prototype.end = function() {\n    this.sendNotification(Notifications.END);\n  };\n\n  HTMLPlayer.prototype.setParams = function(value) {\n    this.sendNotification(Notifications.CHANGE_PARAMS, value);\n    return value;\n  };\n\n  HTMLPlayer.prototype.getParams = function() {\n    return this.params.getData();\n  };\n\n  HTMLPlayer.prototype.setAutoplay = function(value) {\n    this.sendNotification(Notifications.CHANGE_AUTOPLAY, value);\n    return value;\n  };\n\n  HTMLPlayer.prototype.getAutoplay = function() {\n    var autoPlay, playbackProxy, _ref;\n    playbackProxy = this.retrieveProxy(PlaybackProxy.NAME);\n    autoPlay = playbackProxy.initialized && (this.configuration.getAutoplay() || ((_ref = this.getMedia()) != null ? _ref.autoplay : void 0) === true);\n    return autoPlay;\n  };\n\n  HTMLPlayer.prototype.setLoop = function(value) {\n    this.sendNotification(Notifications.CHANGE_LOOP, value);\n    return value;\n  };\n\n  HTMLPlayer.prototype.getLoop = function() {\n    return this.configuration.getLoop();\n  };\n\n  HTMLPlayer.prototype.setMuted = function(value) {\n    this.sendNotification(Notifications.CHANGE_MUTED, value);\n    return value;\n  };\n\n  HTMLPlayer.prototype.getMuted = function() {\n    return this.retrieveProxy(PlaybackProxy.NAME).getMuted();\n  };\n\n  HTMLPlayer.prototype.setMedia = function(value) {\n    HTMLPlayer.__super__.setMedia.call(this, value);\n    this.sendNotification(Notifications.SET_MEDIA, value);\n    return value;\n  };\n\n  HTMLPlayer.prototype.getMedia = function() {\n    return this.mediaProxy.getData();\n  };\n\n  HTMLPlayer.prototype.setCurrentTime = function(value) {\n    this.sendNotification(Notifications.SEEK, value);\n    return value;\n  };\n\n  HTMLPlayer.prototype.getCurrentTime = function() {\n    return this.retrieveProxy(PlaybackProxy.NAME).getCurrentTime();\n  };\n\n  HTMLPlayer.prototype.getDuration = function() {\n    return this.mediaProxy.getDuration();\n  };\n\n  HTMLPlayer.prototype.setSrc = function(value) {\n    this.sendNotification(Notifications.SET_MEDIA, {\n      src: value\n    });\n    return value;\n  };\n\n  HTMLPlayer.prototype.getSrc = function() {\n    return this.mediaProxy.getSrc();\n  };\n\n  HTMLPlayer.prototype.setSource = function(value) {\n    this.sendNotification(Notifications.SET_MEDIA, {\n      source: value\n    });\n    return value;\n  };\n\n  HTMLPlayer.prototype.getSource = function() {\n    return this.mediaProxy.getSource();\n  };\n\n  HTMLPlayer.prototype.setVolume = function(value) {\n    this.sendNotification(Notifications.CHANGE_VOLUME, value);\n    return value;\n  };\n\n  HTMLPlayer.prototype.getVolume = function() {\n    return this.retrieveProxy(PlaybackProxy.NAME).getVolume();\n  };\n\n  HTMLPlayer.prototype.getSeeking = function() {\n    return this.retrieveProxy(PlaybackProxy.NAME).getSeeking();\n  };\n\n  HTMLPlayer.prototype.getPaused = function() {\n    return this.retrieveProxy(PlaybackProxy.NAME).getPaused();\n  };\n\n  HTMLPlayer.prototype.getEnded = function() {\n    return this.appState.getEnded();\n  };\n\n  HTMLPlayer.prototype.getError = function() {\n    return this.getMediaElement().error;\n  };\n\n  HTMLPlayer.prototype.setDisplayState = function(value) {\n    this.sendNotification(Notifications.CHANGE_DISPLAY_STATE, value);\n  };\n\n  HTMLPlayer.prototype.getDisplayState = function(value) {\n    return this.appState.getDisplayState();\n  };\n\n  HTMLPlayer.prototype.enterFullScreen = function() {\n    this.sendNotification(Notifications.CHANGE_DISPLAY_STATE, DisplayState.FULL_SCREEN);\n  };\n\n  HTMLPlayer.prototype.exitFullScreen = function() {\n    this.sendNotification(Notifications.CHANGE_DISPLAY_STATE, DisplayState.NORMAL);\n  };\n\n  HTMLPlayer.prototype.setPlaybackRate = function(value) {\n    this.getMediaElement().playbackRate = value;\n  };\n\n  HTMLPlayer.prototype.getPlaybackRate = function() {\n    return this.getMediaElement().playbackRate;\n  };\n\n  HTMLPlayer.prototype.getQualityLevels = function() {\n    return this.retrieveProxy(PlaybackProxy.NAME).getQualityLevels();\n  };\n\n  HTMLPlayer.prototype.setQuality = function(value) {\n    return this.retrieveProxy(PlaybackProxy.NAME).setQuality(value);\n  };\n\n  HTMLPlayer.prototype.getQuality = function() {\n    return this.retrieveProxy(PlaybackProxy.NAME).getQuality();\n  };\n\n  /**\n   * Gets the play state.\n  */\n  HTMLPlayer.prototype.getPlayState = function() {\n    return this.appState.getPlayState();\n  };\n\n  /**\n   * @override\n  */\n  HTMLPlayer.prototype.destroy = function() {\n    var _ref, _ref1;\n    if ((_ref = this.retrieveProxy(PlayerProxy.NAME)) != null) {\n      if ((_ref1 = _ref.activePlaybackCore) != null) {\n        if (typeof _ref1.destroy === \"function\") {\n          _ref1.destroy();\n        }\n      }\n    }\n    HTMLPlayer.__super__.destroy.call(this);\n  };\n\n  /**\n   * @enum {string}\n   * @const\n   * @private\n  */\n\n  var FlashNotifications = {\n    READY: \"jsApiReady\",\n    RESET: \"mediaPlayerReset\",\n    LOADING: \"mediaPlayerLoading\",\n    PLAYER_ERROR: \"mediaPlayerError\",\n    MEDIA_ERROR: \"mediaError\",\n    ERROR_STREAM_NOT_FOUND: \"mediaPlayerErrorStreamNotFound\",\n    CAPABILITY_CHANGE: \"mediaPlayerCapabilityChange\",\n    PLAYBACK_OPEN: \"mediaPlayerPlaybackOpen\",\n    PLAYBACK_CLOSE: \"mediaPlayerPlaybackClose\",\n    PLAYING: \"mediaPlayerPlaying\",\n    ENDED: \"mediaPlayerPlaybackClose\",\n    MEDIA_SEQUENCE_ENDED: \"mediaPlayerPlaybackSequenceComplete\",\n    PAUSED: \"mediaPlayerPaused\",\n    BUFFERING: \"mediaPlayerBuffering\",\n    DURATION_CHANGE: \"mediaPlayerDurationChange\",\n    TIME_UPDATE: \"mediaPlayerPlayheadUpdate\",\n    SEEKING_CHANGE: \"mediaPlayerSeekingChange\",\n    ERROR: \"error\",\n    VOLUME_CHANGE: \"mediaPlayerVolumeChanged\",\n    PLAY_STATE_CHANGE: \"mediaPlayerPlayStateChange\",\n    STATE_CHANGE: \"mediaPlayerStateChange\",\n    CAPTION_DATA_CHANGE: \"mediaPlayerCaptiondataChange\",\n    FAIL_OVER_ATTEMPT: \"mediaPlayerFailoverAttempt\",\n    ELEMENT_EVENT: \"mediaPlayerElementEvent\",\n    PLAY: \"mediaPlayerResumeOrPausePlayback\",\n    APPLICATION_STATE_CHANGE: \"mediaPlayerApplicationStateChange\",\n    INITIALIZED: \"mediaPlayerInitialized\",\n    FULLSCREEN_CHANGE: \"mediaPlayerFullscreenChange\",\n    AUTHORIZE: \"mediaPlayerAuthenticate\",\n    CAPTIONING_REQUEST: \"mediaPlayerCaptioningRequest\",\n    CAPTION_LANG_CHANGE: \"mediaPlayerCaptionLangChange\",\n    RECOMMENDATIONS_LOADED: \"mediaPlayerRecommendationsLoaded\",\n    RECOMMENDATION_SELECTED: \"mediaPlayerRecommendationSelected\",\n    SHARE: \"mediaPlayerShare\",\n    SHARE_REQUEST: \"mediaPlayerShareRequest\",\n    AUTO_ADVANCE: \"mediaPlayerAutoAdvance\",\n    CREATE_FLASH_VARS: \"createFlashVars\",\n    CREATE_XML: \"createXML\",\n    FLASH_CREATED: \"flashCreated\",\n    PLAY_REQUEST: \"mediaPlayerPlaybackSequenceInitiated\",\n    LOAD_FEED: \"mediaPlayerDataFeedRequested\",\n    FEED_UPDATED: \"mediaPlayerDataFeedUpdated\",\n    FEED_LOADED: \"mediaPlayerFeedLoaded\",\n    TIMED_METADATA: \"mediaPlayerSendCuePoint\"\n  };\n\n  /**\n   * PlaybackProxy constructor.\n   *\n   * @constructor\n   * @private\n   * @extends {puremvc.Proxy}\n  */\n  function PlaybackProxy() {\n    PlaybackProxy.__super__.constructor.call(this, PlaybackProxy.NAME);\n    this.data = {\n      core: null,\n      muted: false,\n      started: false,\n      volume: 1,\n      currentTime: 0,\n      duration: 0,\n      src: null,\n      ended: false,\n      paused: false,\n      seeking: false,\n      loading: false,\n      waiting: false\n    };\n    if (Utils.getDevice() === \"desktop\") {\n      this.initialized = true;\n    }\n    this.handlers = {\n      \"timeupdate\": this.ontimeupdate.bind(this),\n      \"durationchange\": this.ondurationchange.bind(this),\n      \"play\": this.onplay.bind(this),\n      \"playing\": this.onplaying.bind(this),\n      \"pause\": this.onpause.bind(this),\n      \"loadeddata\": this.onloadeddata.bind(this),\n      \"waiting\": this.onwaiting.bind(this),\n      \"seeking\": this.onseeking.bind(this),\n      \"seeked\": this.onseeked.bind(this),\n      \"ended\": this.onended.bind(this),\n      \"progress\": this.onprogress.bind(this),\n      \"error\": this.onerror.bind(this),\n      \"loadstart\": this.onloadstart.bind(this),\n      \"canplay\": this.oncanplay.bind(this),\n      \"canplaythrough\": this.oncanplaythrough.bind(this),\n      \"loadedmetadata\": this.onloadedmetadata.bind(this),\n      \"stalled\": this.onstalled.bind(this)\n    };\n    this.resume = {\n      event: \"canplaythrough\",\n      listener: this.resumestart.bind(this)\n    };\n    this.textTrackHandlers = {\n      \"addtrack\": this.onaddtrack.bind(this)\n    };\n  }\n\n\n  __extends(PlaybackProxy, puremvc.Proxy);\n\n\n  /**\n   * The name of the this Proxy.\n   *\n   * @static\n   * @type {string}\n  */\n  PlaybackProxy.NAME = \"PlaybackProxy\";\n\n  /** @private\n  */\n  PlaybackProxy.prototype.data = null;\n\n  PlaybackProxy.prototype.initialized = false;\n\n  PlaybackProxy.prototype.enabled = null;\n\n  PlaybackProxy.prototype.handlers = null;\n\n  PlaybackProxy.prototype.resume = null;\n\n  PlaybackProxy.prototype.playWhenLoaded = false;\n\n  PlaybackProxy.prototype.metadataloaded = false;\n\n  PlaybackProxy.prototype.activeCuesIndex = 0;\n\n  PlaybackProxy.prototype.id3CueType = null;\n\n  /**\n   * The current time of the video in seconds. Value must be between currentTime and duration.\n   *\n   * @param {Number} value\n   *    The new currentTime value in seconds\n   * @returns {Number}\n   *    The currentTime value in seconds\n   * @type {Number}\n  */\n  PlaybackProxy.prototype.getEnabled = function() {\n    return this.enabled;\n  };\n\n  PlaybackProxy.prototype.setEnabled = function(value) {\n    if (value === this.enabled) {\n      return;\n    }\n    this.enabled = value;\n    if (this.enabled === true) {\n      this.load();\n    } else {\n      this.applyHandlers(false);\n    }\n    return value;\n  };\n\n  /** @private\n  */\n  PlaybackProxy.prototype.applyHandlers = function(enabled) {\n    var action, handler, type, video, _ref;\n    if (enabled == null) {\n      enabled = true;\n    }\n    video = this.getMediaElement();\n    action = enabled ? \"addEventListener\" : \"removeEventListener\";\n    _ref = this.handlers;\n    for (type in _ref) {\n      handler = _ref[type];\n      video[action](type, handler);\n    }\n  };\n\n  /** @private\n  */\n  PlaybackProxy.prototype.resumestart = function(event) {\n    var video,\n      _this = this;\n    video = this.getMediaElement();\n    video.removeEventListener(this.resume.event, this.resume.listener);\n    this.handlers.durationchange(event);\n    if (this.data.currentTime > 0) {\n      setTimeout(function() {\n        _this.seek(_this.data.currentTime).then(_this.resumecomplete.bind(_this));\n      }, 50);\n    } else {\n      this.resumecomplete();\n    }\n  };\n\n  /** @private\n  */\n  PlaybackProxy.prototype.resumecomplete = function() {\n    this.data.loading = false;\n    this.applyHandlers(true);\n    if (this.playWhenLoaded === true) {\n      setTimeout(this.play.bind(this), 1);\n    }\n  };\n\n  /** @private\n  */\n  PlaybackProxy.prototype.onaddtrack = function(event) {\n    var track,\n      _this = this;\n    track = event.track;\n    if (track.kind !== \"metadata\") {\n      return;\n    }\n    track.mode = \"hidden\";\n    this.id3CueType = window.VTTCue ? \"VTTCue\" : \"textTrackCue\";\n    track.addEventListener(\"cuechange\", function(event) {\n      var cue, id3, _i, _len, _ref, _ref1, _ref2, _ref3, _ref4, _ref5;\n      if ((_ref = event.target) != null ? (_ref1 = _ref.activeCues) != null ? _ref1.length : void 0 : void 0) {\n        cue = event.target.activeCues[_this.activeCuesIndex++];\n        if (_this.activeCuesIndex === event.target.activeCues.length) {\n          _this.activeCuesIndex = 0;\n        }\n        if (!(cue.value != null) && (cue.text != null)) {\n          cue.value = JSON.parse(cue.text);\n        }\n        id3 = {\n          startTime: cue.startTime,\n          endTime: cue.endTime,\n          key: (_ref2 = cue.value) != null ? _ref2.key : void 0,\n          info: (_ref3 = cue.value) != null ? _ref3.info : void 0,\n          data: cue.value\n        };\n      } else if (_this.playbackCoreName === \"hls\" && _this.id3CueType === \"VTTCue\") {\n        _ref4 = event.target.cues;\n        for (_i = 0, _len = _ref4.length; _i < _len; _i++) {\n          cue = _ref4[_i];\n          if ((Math.round(cue['startTime']) <= (_ref5 = Math.round(_this.getMediaElement().currentTime)) && _ref5 <= Math.ceil(cue['endTime'])) && (id3 = JSON.parse(cue.text))) {\n            break;\n          }\n        }\n      }\n      if (!(id3 != null)) {\n        return;\n      }\n      return _this.sendNotification(Notifications.TIMED_METADATA, id3);\n    });\n  };\n\n  PlaybackProxy.prototype.ontimeupdate = function(event) {\n    var _ref;\n    if (((_ref = this.facade.ads) != null ? _ref.getInProgress() : void 0) === true) {\n      return;\n    }\n    this.data.currentTime = event.target.currentTime;\n    this.sendNotification(Notifications.TIME_UPDATE, this.data.currentTime);\n  };\n\n  PlaybackProxy.prototype.ondurationchange = function(event) {\n    var duration;\n    duration = event.target.duration;\n    if (duration === this.data.duration || duration === 0 || isNaN(duration)) {\n      return;\n    }\n    this.data.duration = duration;\n    if (/Android [4-6]/.test(navigator.userAgent) && this.getMediaElement().src.indexOf(\".m3u8\") !== -1 && duration === Infinity) {\n      return;\n    }\n    this.sendNotification(Notifications.CHANGE_DURATION, duration);\n  };\n\n  PlaybackProxy.prototype.onplay = function(event) {\n    this.data.paused = false;\n  };\n\n  PlaybackProxy.prototype.onplaying = function(event) {\n    this.data.paused = false;\n    this.data.seeking = false;\n    this.data.waiting = false;\n    this.sendNotification(Notifications.PLAYING);\n  };\n\n  PlaybackProxy.prototype.onpause = function(event) {\n    if (this.data.seeking === true || this.getMediaElement().ended === true) {\n      return;\n    }\n    if (this.data.waiting === true && this.playbackCoreName === \"hls\") {\n      return;\n    }\n    this.data.paused = true;\n    if (event.target.readyState > 0) {\n      this.sendNotification(Notifications.PAUSED);\n      this.sendNotification(Notifications.CHANGE_PLAY_STATE, PlayState.PAUSED);\n    }\n  };\n\n  PlaybackProxy.prototype.onloadeddata = function(event) {\n    this.sendNotification(Notifications.LOADED_DATA);\n  };\n\n  PlaybackProxy.prototype.onwaiting = function(event) {\n    this.data.waiting = true;\n    this.sendNotification(Notifications.WAITING);\n  };\n\n  PlaybackProxy.prototype.onstalled = function(event) {\n    this.sendNotification(Notifications.STALLED);\n  };\n\n  PlaybackProxy.prototype.onseeking = function(event) {\n    this.getMediaElement().removeEventListener(\"timeupdate\", this.handlers.timeupdate);\n    this.data.seeking = true;\n    this.sendNotification(Notifications.SEEKING);\n  };\n\n  PlaybackProxy.prototype.onseeked = function(event) {\n    this.data.seeking = false;\n    this.sendNotification(Notifications.SEEKED);\n    this.getMediaElement().addEventListener(\"timeupdate\", this.handlers.timeupdate);\n  };\n\n  PlaybackProxy.prototype.onended = function(event) {\n    this.data.ended = true;\n    this.sendNotification(Notifications.ENDED);\n  };\n\n  PlaybackProxy.prototype.onprogress = function(event) {\n    var buffered, video;\n    try {\n      video = this.getMediaElement();\n      buffered = video.buffered;\n      this.sendNotification(Notifications.PROGRESS, buffered.end(buffered.length - 1) / video.duration);\n    } catch (error) {\n\n    }\n  };\n\n  PlaybackProxy.prototype.onerror = function(event) {\n    this.sendNotification(Notifications.ERROR, this.getMediaElement().error);\n  };\n\n  PlaybackProxy.prototype.onloadstart = function(event) {\n    this.sendNotification(Notifications.LOAD_START);\n  };\n\n  PlaybackProxy.prototype.oncanplay = function(event) {\n    this.sendNotification(Notifications.CAN_PLAY);\n  };\n\n  PlaybackProxy.prototype.oncanplaythrough = function(event) {\n    this.sendNotification(Notifications.CAN_PLAY_THROUGH);\n    this.sendNotification(Notifications.PROGRESS, this.getDuration());\n  };\n\n  PlaybackProxy.prototype.onloadedmetadata = function(event) {\n    this.metadataloaded = true;\n    this.createTracks();\n    this.sendNotification(Notifications.ENABLE_FULL_SCREEN);\n    this.sendNotification(Notifications.LOADED_METADATA);\n    this.applyTextTrackHandlers(true);\n  };\n\n  PlaybackProxy.prototype.applyTextTrackHandlers = function(data) {\n    var action, _ref;\n    action = data === true ? \"addEventListener\" : \"removeEventListener\";\n    if ((_ref = this.getMediaElement().textTracks) != null) {\n      _ref[action](\"addtrack\", this.textTrackHandlers.addtrack);\n    }\n  };\n\n  /** @override\n  */\n  PlaybackProxy.prototype.createTracks = function() {\n    var audio, count, index, track, tracks, _i, _len;\n    audio = this.getMediaElement().audioTracks;\n    tracks = this.facade.retrieveProxy(TracksProxy.NAME).getAudioTracks();\n    if (audio != null) {\n      count = audio.length || 0;\n      for (index = _i = 0, _len = audio.length; _i < _len; index = ++_i) {\n        track = audio[index];\n        tracks.add(new Track(track), index + 1 === count);\n      }\n    }\n  };\n\n  /** @private\n  */\n  PlaybackProxy.prototype.reset = function() {\n    this.data.currentTime = 0;\n    this.data.duration = 0;\n    this.data.src = null;\n    this.data.ended = false;\n    this.data.paused = false;\n    this.data.seeking = false;\n    this.data.started = false;\n    this.data.loading = false;\n    this.applyTextTrackHandlers(false);\n  };\n\n  /**\n   * @return {boolean}\n  */\n  PlaybackProxy.prototype.getStarted = function() {\n    return this.data.started;\n  };\n\n  /**\n   * The playback core\n   *\n   * @param {HTMLVideoElement} value\n   *    The new playback core\n   * @returns {HTMLVideoElement}\n   *    The playback core\n   * @type {HTMLVideoElement}\n   *\n   * @private\n  */\n  PlaybackProxy.prototype.getMediaElement = function() {\n    return this.facade.getMediaElement();\n  };\n\n  /**\n   *\n  */\n  PlaybackProxy.prototype.canPlayTemporalType = function(temporalType) {\n    return temporalType !== \"dvr\";\n  };\n\n  /**\n   * Determines if the core can play a given mimeType.\n   *\n   * @return {String} \"\" if the core can't play the mimeType\n  */\n  PlaybackProxy.prototype.canPlayType = function(mimeType) {\n    var canPlay;\n    canPlay = document.createElement(\"video\").canPlayType(mimeType) || \"\";\n    if ((/Android (4\\.[1-9]|[5-6])/.test(navigator.userAgent) || /Silk\\/3/.test(navigator.userAgent)) && mimeType === Utils.mimeTypes.m3u8) {\n      canPlay = \"maybe\";\n    }\n    if (canPlay === \"probably\" && /video\\/f4m|x-flv/.test(mimeType) && /UCBrowser/.test(navigator.userAgent)) {\n      canPlay = \"\";\n    }\n    return canPlay;\n  };\n\n  /**\n   * Indicates whether or not the video is playing.\n   *\n   * @returns {Boolean}\n   *    The playing value\n   * @type {Boolean}\n  */\n  PlaybackProxy.prototype.getPaused = function() {\n    return this.data.paused;\n  };\n\n  /**\n   * Indicates whether or not the video is playing.\n   *\n   * @returns {Boolean}\n   *    The playing value\n   * @type {Boolean}\n  */\n  PlaybackProxy.prototype.getSeeking = function() {\n    return this.data.seeking;\n  };\n\n  /**\n   * The current time of the video in seconds. Value must be between currentTime and duration.\n   *\n   * @param {Number} value\n   *    The new currentTime value in seconds\n   * @returns {Number}\n   *    The currentTime value in seconds\n   * @type {Number}\n  */\n  PlaybackProxy.prototype.getCurrentTime = function() {\n    return this.data.currentTime;\n  };\n\n  PlaybackProxy.prototype.setCurrentTime = function(value) {\n    if (value === this.data.currentTime) {\n      return;\n    }\n    this.data.currentTime = value;\n    if (this.getStarted()) {\n      this.seek(value);\n    }\n    return value;\n  };\n\n  /** @private\n  */\n  PlaybackProxy.prototype.seek = function(time) {\n    var _this = this;\n    if (time == null) {\n      time = this.data.currentTime;\n    }\n    return new Promise(function(resolve, reject) {\n      var seeked, seekedTimeout, ua, video;\n      try {\n        video = _this.getMediaElement();\n        seeked = function() {\n          if (seekedTimeout) {\n            clearTimeout(seekedTimeout);\n          }\n          video.removeEventListener(\"seeked\", seeked);\n          setTimeout(resolve, 10);\n        };\n        video.addEventListener(\"seeked\", seeked);\n        video.currentTime = time;\n        ua = navigator.userAgent;\n        if (/Android.*Chrome/.test(ua)) {\n          seekedTimeout = setTimeout(seeked, 2000);\n        }\n      } catch (error) {\n        reject(error);\n      }\n    });\n  };\n\n  /**\n   * The current time of the video in seconds. Value must be between currentTime and duration.\n   *\n   * @param {Number} value\n   *    The new currentTime value in seconds\n   * @returns {Number}\n   *    The currentTime value in seconds\n   * @type {Number}\n  */\n  PlaybackProxy.prototype.getVolume = function() {\n    return this.getMediaElement().volume;\n  };\n\n  PlaybackProxy.prototype.setVolume = function(value) {\n    if (this.getMuted() && value > 0) {\n      this.setMuted(false);\n    } else if (!this.getMuted() && value === 0) {\n      this.setMuted(true);\n    }\n    if ((0 <= value && value <= 1) && value !== this.getMediaElement().volume) {\n      this.sendNotification(Notifications.VOLUME_CHANGE, this.getMediaElement().volume = value);\n    }\n    return value;\n  };\n\n  /**\n  */\n  PlaybackProxy.prototype.getMuted = function() {\n    return this.data.muted;\n  };\n\n  PlaybackProxy.prototype.setMuted = function(value) {\n    var volume;\n    this.data.muted = value;\n    this.getMediaElement().muted = value;\n    if (this.data.muted === true) {\n      this.data.volume = this.getVolume();\n      volume = 0;\n    } else {\n      volume = this.data.volume;\n    }\n    this.sendNotification(Notifications.CHANGE_VOLUME, volume);\n    return value;\n  };\n\n  /**\n   * The duration of the video in seconds.\n   *\n   * @returns {Number}\n   *    The duration of the video\n   * @type {Number}\n  */\n  PlaybackProxy.prototype.getDuration = function() {\n    return this.data.duration;\n  };\n\n  /**\n   * Instructs the core to play.\n  */\n  PlaybackProxy.prototype.play = function() {\n    if (this.data.started !== true) {\n      this.data.started = true;\n      this.setEnabled(true);\n      this.playWhenLoaded = true;\n      if (this.metadataloaded === false) {\n        return;\n      }\n    } else if (this.data.loading === true) {\n      this.playWhenLoaded = true;\n      return;\n    }\n    this.getMediaElement().play();\n  };\n\n  /**\n   * Instructs the core to pause.\n  */\n  PlaybackProxy.prototype.pause = function() {\n    this.data.paused = true;\n    this.getMediaElement().pause();\n  };\n\n  PlaybackProxy.prototype.getSrc = function() {\n    return this.facade.mediaProxy.getSrc();\n  };\n\n  /**\n   * Instructs the core to load.\n  */\n  PlaybackProxy.prototype.load = function() {\n    var element;\n    this.sendNotification(Notifications.WAITING);\n    this.data.loading = true;\n    this.playWhenLoaded = false;\n    this.metadataloaded = false;\n    element = this.getMediaElement();\n    element.addEventListener(this.resume.event, this.resume.listener);\n    element.addEventListener(\"loadedmetadata\", this.handlers.loadedmetadata);\n    element.addEventListener(\"durationchange\", this.handlers.durationchange);\n    element.addEventListener(\"canplaythrough\", this.handlers.canplaythrough);\n    element.addEventListener(\"error\", this.handlers.error);\n    this.applySrc();\n  };\n\n  PlaybackProxy.prototype.applySrc = function() {\n    var element, src, _ref;\n    src = this.getSrc();\n    if (!(src != null) || src === \"\") {\n      this.sendNotification(Notifications.ERROR, \"The value of src is not supported: \" + value);\n    }\n    element = this.getMediaElement();\n    element.src = src;\n    if (Utils.isIPad() && ((_ref = Utils.getIOSversion()) != null ? _ref[0] : void 0) < 8) {\n      setTimeout(element.load.bind(element), 100);\n    } else {\n      element.load();\n    }\n  };\n\n  PlaybackProxy.prototype.setQuality = function(value) {};\n\n  PlaybackProxy.prototype.getQuality = function() {};\n\n  PlaybackProxy.prototype.getQualityLevels = function() {\n    return [];\n  };\n\n  PlaybackProxy.prototype.destroy = function() {\n    var element, key, value, _ref;\n    element = this.getMediaElement();\n    _ref = this.handlers;\n    for (key in _ref) {\n      value = _ref[key];\n      element.removeEventListener(key, value);\n    }\n    element.removeEventListener(this.resume.event, this.resume.listener);\n  };\n\n  /**\n   * The FlashStartCommand class.\n   *\n   * @constructor\n   * @private\n   * @extends {amp.player.controller.PlayerCommand}\n  */\n  function FlashStartCommand() {\n    FlashStartCommand.__super__.constructor.call(this);\n  }\n\n\n  __extends(FlashStartCommand, PlayerCommand);\n\n\n  /**\n   * Executes the command.\n   *\n   * @param {puremvc.Notification} notification\n   *    The notification.\n   *\n   * @override\n  */\n  FlashStartCommand.prototype.execute = function(notification) {\n    this.player.started = true;\n    this.sendNotification(Notifications.STARTED, notification.getBody());\n    this.sendNotification(Notifications.PLAY, notification.getBody());\n  };\n\n  /**\n   * The RegisterPlaybackCoreCommand class.\n   *\n   * @constructor\n   * @private\n   * @extends {amp.player.controller.PlayerEventCommand}\n  */\n  function ChangePlaybackTargetCommand() {\n    ChangePlaybackTargetCommand.__super__.constructor.call(this);\n  }\n\n\n  __extends(ChangePlaybackTargetCommand, PlayerCommand);\n\n\n  /**\n   * Executes the command.\n   *\n   * @param {puremvc.Notification} notification\n   *    The notification.\n   *\n   * @override\n  */\n  ChangePlaybackTargetCommand.prototype.execute = function(notification) {\n    var target;\n    target = notification.getBody();\n    this.applicationState.setPlaybackTarget(target);\n    if (target !== \"amp\") {\n      if (this.applicationState.getPlayState() !== PlayState.PAUSED) {\n        this.facade.pause();\n      }\n    } else {\n      if (this.applicationState.getPlayState() === PlayState.PLAYING) {\n        this.facade.play();\n      }\n    }\n  };\n\n  function LocalizationWrapper(player, config) {\n    this.player = player;\n    this.config = config;\n    LocalizationWrapper.__super__.constructor.call(this, this.constructor.NAME);\n    this.proxy = new LocalizationProxy(this.config);\n    this.player.registerProxy(this.proxy);\n  }\n\n\n  __extends(LocalizationWrapper, puremvc.Mediator);\n\n\n  LocalizationWrapper.prototype.player = null;\n\n  LocalizationWrapper.prototype.config = null;\n\n  LocalizationWrapper.prototype.proxy = null;\n\n  LocalizationWrapper.NAME = \"LocalizationWrapper\";\n\n  /**\n  */\n  LocalizationWrapper.prototype.getString = function(key) {\n    return this.proxy.getString(key);\n  };\n\n  /** @override\n  */\n  LocalizationWrapper.prototype.listNotificationInterests = function() {\n    return [FlashNotifications.CREATE_FLASH_VARS, FlashNotifications.CREATE_XML];\n  };\n\n  /**\n  */\n  LocalizationWrapper.prototype.handleNotification = function(notification) {\n    var application, body, config, element, flashvars, key, lang, locale, locales, name, prop, text, value, xml, _ref;\n    LocalizationWrapper.__super__.handleNotification.call(this, notification);\n    name = notification.getName();\n    body = notification.getBody();\n    switch (name) {\n      case FlashNotifications.CREATE_FLASH_VARS:\n        flashvars = body.flashvars;\n        config = body.config;\n        flashvars.locale_setting = this.proxy.getLocaleId();\n        break;\n      case FlashNotifications.CREATE_XML:\n        xml = body.xml;\n        application = xml.firstChild;\n        locales = xml.getElementsByTagName(\"locales\")[0];\n        if (!(locales != null)) {\n          locales = xml.createElement(\"locales\");\n          application.appendChild(locales);\n        }\n        _ref = this.proxy.getLocales();\n        for (lang in _ref) {\n          locale = _ref[lang];\n          element = xml.createElement(\"locale\");\n          element.setAttribute(\"id\", lang);\n          locales.appendChild(element);\n          for (key in locale) {\n            value = locale[key];\n            prop = xml.createElement(\"property\");\n            prop.setAttribute(\"key\", key);\n            text = XMLUtils.createTextContent(xml, value);\n            prop.appendChild(text);\n            element.appendChild(prop);\n          }\n        }\n    }\n  };\n\n  /**\n   * The ModuleMediator class.\n   *\n   * @param {string} name\n   * @param {Object} viewComponent\n   * @constructor\n   * @private\n   * @extends {puremvc.Mediator}\n  */\n  function ModuleMediator(viewComponent) {\n    if (this.cssPrefix == null) {\n      this.cssPrefix = Namespace.PREFIX;\n    }\n    ModuleMediator.__super__.constructor.call(this, this.mediatorName, viewComponent);\n  }\n\n\n  __extends(ModuleMediator, puremvc.Mediator);\n\n\n  ModuleMediator.prototype.config = null;\n\n  ModuleMediator.prototype.cssPrefix = null;\n\n  ModuleMediator.prototype.classList = null;\n\n  /** @override\n  */\n  ModuleMediator.prototype.initializeNotifier = function(key) {\n    var base;\n    ModuleMediator.__super__.initializeNotifier.call(this, key);\n    base = this.facade.player || this.facade;\n    this.config = base.retrieveProxy(ModuleProxy.NAME);\n    this.classList = this.classList = new ClassList(this.viewComponent);\n  };\n\n  /**\n   * @constructor\n   * @private\n  */\n  function LocalizedMediator(viewComponent) {\n    LocalizedMediator.__super__.constructor.call(this, viewComponent);\n  }\n\n\n  __extends(LocalizedMediator, ModuleMediator);\n\n\n  LocalizedMediator.prototype.localizationManager = null;\n\n  /** @override\n  */\n  LocalizedMediator.prototype.initializeNotifier = function(key) {\n    var target;\n    LocalizedMediator.__super__.initializeNotifier.call(this, key);\n    target = this.facade.player || this.facade;\n    this.localizationManager = target.retrieveProxy(LocalizationProxy.NAME);\n  };\n\n  /**\n   * @constructor\n   * @extends {LocalizedMediator}\n   * @private\n  */\n  function ComponentMediator(componentName, componentType, parent, element) {\n    this.componentName = componentName != null ? componentName : this.componentName;\n    this.componentType = componentType != null ? componentType : this.componentType;\n    this.parent = parent;\n    this.element = element;\n    if (this.mediatorName == null) {\n      this.mediatorName = this.createMediatorName();\n    }\n    ComponentMediator.__super__.constructor.call(this, this.viewComponent);\n  }\n\n\n  __extends(ComponentMediator, LocalizedMediator);\n\n\n  ComponentMediator.prototype.componentName = null;\n\n  ComponentMediator.prototype.componentType = null;\n\n  ComponentMediator.prototype.parent = null;\n\n  ComponentMediator.prototype.element = null;\n\n  ComponentMediator.prototype.classList = null;\n\n  ComponentMediator.prototype.state = null;\n\n  ComponentMediator.prototype.disabled = false;\n\n  /**\n  */\n  ComponentMediator.prototype.onRegister = function() {\n    this.viewComponent = this.createViewComponent(this.parent, this.element);\n    this.classList = this.viewComponent._classList;\n    UI.bindEvents(this.viewComponent, this);\n  };\n\n  /**\n  */\n  ComponentMediator.prototype.createViewComponent = function(parent, element) {\n    var type;\n    type = this.getTypeList();\n    return UI.create(type, parent, element);\n  };\n\n  /**\n  */\n  ComponentMediator.prototype.createMediatorName = function() {\n    var type;\n    type = this.getTypeList();\n    type.push(\"mediator\");\n    type.push(UI.createUID());\n    return type.join(\"-\");\n  };\n\n  /**\n  */\n  ComponentMediator.prototype.getTypeList = function() {\n    var type;\n    type = [];\n    if (this.componentName != null) {\n      type.push(this.componentName);\n    }\n    if (this.componentType != null) {\n      type = type.concat(this.componentType);\n    }\n    return type;\n  };\n\n  /**\n  */\n  ComponentMediator.prototype.create = function(type, parent, element, text) {\n    if (parent == null) {\n      parent = this;\n    }\n    if (parent === false) {\n      parent = null;\n    }\n    return UI.create(type, parent, element, text);\n  };\n\n  /**\n  */\n  ComponentMediator.prototype.createText = function(type, text, parent, element) {\n    if (parent == null) {\n      parent = this;\n    }\n    return UI.create(type, parent, element, text);\n  };\n\n  /**\n  */\n  ComponentMediator.prototype.setState = function(value) {\n    if (value === this.state) {\n      return;\n    }\n    if (this.state != null) {\n      this.classList.remove(this.state);\n    }\n    this.state = value;\n    if (this.state != null) {\n      this.classList.add(this.state);\n    }\n    return value;\n  };\n\n  /**\n  */\n  ComponentMediator.prototype.getState = function() {\n    return this.state;\n  };\n\n  /**\n  */\n  ComponentMediator.prototype.setDisabled = function(value) {\n    if (value === this.disabled) {\n      return;\n    }\n    this.disabled = value;\n    if (this.disabled) {\n      this.classList.add(\"disabled\");\n    } else {\n      this.classList.remove(\"disabled\");\n    }\n    return value;\n  };\n\n  /**\n  */\n  ComponentMediator.prototype.getDisabled = function() {\n    return this.disabled;\n  };\n\n  /**\n   * @constructor\n   * @private\n   * @extends {ComponentMediator}\n  */\n  function MediaElementMediator(componentName, viewComponent) {\n    this.mediatorName = \"\" + this.componentType + \"-mediator\";\n    MediaElementMediator.__super__.constructor.call(this, componentName, null, null, viewComponent);\n  }\n\n\n  __extends(MediaElementMediator, ComponentMediator);\n\n\n  MediaElementMediator.prototype.componentType = \"media-element\";\n\n  MediaElementMediator.prototype.created = false;\n\n  MediaElementMediator.prototype.onRegister = function() {\n    if (this.created !== true) {\n      this.created = true;\n      MediaElementMediator.__super__.onRegister.call(this);\n    }\n  };\n\n  /**\n   * @constructor\n   * @private\n  */\n  function LayerMediator() {\n    LayerMediator.__super__.constructor.call(this);\n  }\n\n\n  __extends(LayerMediator, ComponentMediator);\n\n\n  LayerMediator.prototype.componentType = \"layer\";\n\n  /**\n   * Registers the layer\n   *\n   * @override\n  */\n  LayerMediator.prototype.onRegister = function() {\n    LayerMediator.__super__.onRegister.call(this);\n    this.registerLayer();\n  };\n\n  /**\n   * Removes the layer\n   *\n   * @override\n  */\n  LayerMediator.prototype.onRemove = function() {\n    LayerMediator.__super__.onRemove.call(this);\n    this.removeLayer();\n  };\n\n  /**\n   *\n  */\n  LayerMediator.prototype.registerLayer = function() {\n    this.sendNotification(Notifications.ADD_LAYER, this.viewComponent);\n  };\n\n  /**\n   *\n  */\n  LayerMediator.prototype.removeLayer = function() {\n    this.sendNotification(Notifications.REMOVE_LAYER, this.viewComponent);\n  };\n\n  /**\n   * @constructor\n   * @extends {LayerMediator}\n   * @private\n  */\n  function VideoLayerMediator() {\n    VideoLayerMediator.__super__.constructor.call(this);\n  }\n\n\n  __extends(VideoLayerMediator, LayerMediator);\n\n\n  VideoLayerMediator.prototype.componentName = \"video\";\n\n  /** @override\n  */\n  VideoLayerMediator.prototype.listNotificationInterests = function() {\n    return [Notifications.PLAYBACK_CORE_CHANGE];\n  };\n\n  VideoLayerMediator.prototype.mediator = null;\n\n  VideoLayerMediator.prototype.mediaElement = null;\n\n  /** @override\n  */\n  VideoLayerMediator.prototype.handleNotification = function(notification) {\n    var body, isMediator, name;\n    name = notification.getName();\n    body = notification.getBody();\n    switch (name) {\n      case Notifications.PLAYBACK_CORE_CHANGE:\n        if (this.mediaElement != null) {\n          this.viewComponent.removeChild(this.mediaElement);\n        }\n        if (this.mediator != null) {\n          this.facade.removeMediator(this.mediator.getMediatorName());\n        }\n        isMediator = (body != null ? body.getViewComponent : void 0) != null;\n        if (isMediator) {\n          this.facade.registerMediator(body);\n          this.mediator = body;\n          this.mediaElement = this.mediator.getViewComponent();\n        } else {\n          this.mediator = null;\n          this.mediaElement = body;\n        }\n        this.facade.setMediaElement(this.mediaElement);\n        if (this.mediaElement != null) {\n          this.viewComponent.appendChild(this.mediaElement);\n        }\n    }\n  };\n\n  /**\n   * @constructor\n   * @private\n   * @extends {ModuleMediator}\n  */\n  function PlayerMediator(componentName, viewComponent) {\n    this.componentName = componentName;\n    this.layers = [];\n    PlayerMediator.__super__.constructor.call(this, null, null, null, viewComponent);\n  }\n\n\n  __extends(PlayerMediator, ComponentMediator);\n\n\n  PlayerMediator.prototype.componentType = \"player\";\n\n  PlayerMediator.prototype.core = null;\n\n  PlayerMediator.prototype.medium = null;\n\n  PlayerMediator.prototype.layers = null;\n\n  PlayerMediator.prototype.ready = false;\n\n  /** @override\n  */\n  PlayerMediator.prototype.onRegister = function() {\n    var device;\n    PlayerMediator.__super__.onRegister.call(this);\n    device = Utils.getDevice();\n    if ((device != null)) {\n      this.classList.add(device);\n    }\n    if (Utils.isTouchDevice()) {\n      this.classList.add(\"touch\");\n    }\n  };\n\n  /** @override\n  */\n  PlayerMediator.prototype.listNotificationInterests = function() {\n    return [Notifications.DISPLAY_STATE_CHANGE, Notifications.ACTIVE_STATE_CHANGE, Notifications.PLAY_STATE_CHANGE, Notifications.ADD_APPLICATION_STATE, Notifications.REMOVE_APPLICATION_STATE, Notifications.MEDIUM_CHANGE, Notifications.DURATION_CHANGE, Notifications.TEMPORAL_TYPE_CHANGE, Notifications.IS_LIVE, Notifications.ADD_LAYER, Notifications.REMOVE_LAYER, Notifications.READY];\n  };\n\n  /** @override\n  */\n  PlayerMediator.prototype.handleNotification = function(notification) {\n    var body, name, previous, state, states, value;\n    name = notification.getName();\n    body = notification.getBody();\n    switch (name) {\n      case Notifications.ACTIVE_STATE_CHANGE:\n      case Notifications.PLAY_STATE_CHANGE:\n      case Notifications.DISPLAY_STATE_CHANGE:\n      case Notifications.MEDIUM_CHANGE:\n        states = body;\n        value = states.value;\n        previous = states.previous;\n        if ((previous != null) && this.classList.contains(previous)) {\n          this.classList.remove(previous);\n        }\n        if (value != null) {\n          this.classList.add(value);\n        }\n        break;\n      case Notifications.ADD_APPLICATION_STATE:\n        state = body;\n        this.classList.add(state);\n        break;\n      case Notifications.REMOVE_APPLICATION_STATE:\n        state = body;\n        this.classList.remove(state);\n        break;\n      case Notifications.TEMPORAL_TYPE_CHANGE:\n        if (body.previous) {\n          this.sendNotification(Notifications.REMOVE_APPLICATION_STATE, body.previous);\n        }\n        if (body.value) {\n          this.sendNotification(Notifications.ADD_APPLICATION_STATE, body.value);\n        }\n        break;\n      case Notifications.IS_LIVE:\n        if (body === true) {\n          this.sendNotification(Notifications.ADD_APPLICATION_STATE, \"is-live\");\n        } else {\n          this.sendNotification(Notifications.REMOVE_APPLICATION_STATE, \"is-live\");\n        }\n        break;\n      case Notifications.DURATION_CHANGE:\n        if (body > 3600) {\n          this.sendNotification(Notifications.ADD_APPLICATION_STATE, \"long-form\");\n        } else {\n          this.sendNotification(Notifications.REMOVE_APPLICATION_STATE, \"long-form\");\n        }\n        break;\n      case Notifications.ADD_LAYER:\n        this.addLayer(body);\n        break;\n      case Notifications.REMOVE_LAYER:\n        this.removeLayer(body);\n        break;\n      case Notifications.READY:\n        this.initialize();\n        this.viewCreated();\n    }\n  };\n\n  /**\n  */\n  PlayerMediator.prototype.initialize = function() {\n    var layer, _i, _len, _ref;\n    this.ready = true;\n    _ref = this.layers;\n    for (_i = 0, _len = _ref.length; _i < _len; _i++) {\n      layer = _ref[_i];\n      if (!this.viewComponent.contains(layer)) {\n        this.viewComponent.appendChild(layer);\n      }\n    }\n  };\n\n  PlayerMediator.prototype.viewCreated = function() {\n    this.sendNotification(Notifications.VIEW_CREATED);\n  };\n\n  /**\n  */\n  PlayerMediator.prototype.addLayer = function(layer) {\n    this.layers.push(layer);\n    if (this.ready) {\n      this.viewComponent.appendChild(layer);\n    }\n  };\n\n  /**\n  */\n  PlayerMediator.prototype.removeLayer = function(layer) {\n    var index;\n    if (this.viewComponent.contains(layer)) {\n      this.viewComponent.removeChild(layer);\n    }\n    index = this.layers.indexOf(layer);\n    if (index >= 0) {\n      this.layers.splice(index, 1);\n    }\n  };\n\n  /**\n   * @param {Object} viewComponent\n   * @constructor\n   * @private\n   * @extends {PlayerMeditator}\n  */\n  function FlashPlayerMediator(viewComponent) {\n    FlashPlayerMediator.__super__.constructor.call(this, this.type, viewComponent);\n  }\n\n\n  __extends(FlashPlayerMediator, PlayerMediator);\n\n\n  /**\n   * The name of the this Mediator.\n   *\n   * @static\n   * @type {String}\n  */\n  FlashPlayerMediator.NAME = \"FlashPlayerMediator\";\n\n  FlashPlayerMediator.prototype.type = \"flash\";\n\n  /** @override\n  */\n  FlashPlayerMediator.prototype.listNotificationInterests = function() {\n    return FlashPlayerMediator.__super__.listNotificationInterests.call(this).concat([PluginNotifications.PLUGINS_INITIALIZED]);\n  };\n\n  /** @override\n  */\n  FlashPlayerMediator.prototype.handleNotification = function(notification) {\n    var body, name;\n    name = notification.getName();\n    body = notification.getBody();\n    switch (name) {\n      case Notifications.READY:\n        this.viewCreated();\n        return;\n      case PluginNotifications.PLUGINS_INITIALIZED:\n        this.initialize();\n        return;\n    }\n    FlashPlayerMediator.__super__.handleNotification.call(this, notification);\n  };\n\n  /**\n   * The RegisterPlaybackCoreCommand class.\n   *\n   * @constructor\n   * @private\n   * @extends {amp.player.controller.PlayerEventCommand}\n  */\n  function PlaybackTargetChangeCommand() {\n    PlaybackTargetChangeCommand.__super__.constructor.call(this);\n  }\n\n\n  __extends(PlaybackTargetChangeCommand, PlayerEventCommand);\n\n\n  /**\n   * Executes the command.\n   *\n   * @param {puremvc.Notification} notification\n   *    The notification.\n   *\n   * @override\n  */\n  PlaybackTargetChangeCommand.prototype.execute = function(notification) {\n    var note, target;\n    target = notification.getBody().value;\n    if (target === \"amp\") {\n      note = Notifications.REMOVE_APPLICATION_STATE;\n    } else {\n      note = Notifications.ADD_APPLICATION_STATE;\n    }\n    this.sendNotification(note, \"remote-playback\");\n    PlaybackTargetChangeCommand.__super__.execute.call(this, notification);\n  };\n\n  /**\n   * The AISFlashAuthenticatedCommand class.\n   *\n   * @constructor\n   * @private\n   * @extends {puremvc.SimpleCommand}\n  */\n  function FlashAuthorizedCommand() {\n    FlashAuthorizedCommand.__super__.constructor.call(this);\n  }\n\n\n  __extends(FlashAuthorizedCommand, PlayerEventCommand);\n\n\n  /**\n   * Executes the command.\n   *\n   * @param {puremvc.Notification} notification\n   *    The notification.\n   *\n   * @override\n  */\n  FlashAuthorizedCommand.prototype.execute = function(notification) {\n    var src;\n    FlashAuthorizedCommand.__super__.execute.call(this, notification);\n    src = this.media.getData().src || \"\";\n    if (src.indexOf(\".smil\") === -1) {\n      this.facade.loadAuthorized();\n    } else {\n      this.facade.getMediaElement().authenticationComplete({\n        media: this.media.getData()\n      });\n    }\n  };\n\n  /**\n   * PlaybackCoreProxy constructor.\n   *\n   * @constructor\n   * @private\n   * @extends {PlaybackProxy}\n  */\n  function PlaybackCoreProxy(supportedTypes, config) {\n    this.supportedTypes = supportedTypes != null ? supportedTypes : this.supportedTypes;\n    this.config = config;\n    PlaybackCoreProxy.__super__.constructor.call(this);\n    this.temporalTypes = [\"vod\", \"live\", \"ondemand\"];\n  }\n\n\n  __extends(PlaybackCoreProxy, PlaybackProxy);\n\n\n  PlaybackCoreProxy.prototype.temporalTypes = null;\n\n  PlaybackCoreProxy.prototype.supportedTypes = null;\n\n  PlaybackCoreProxy.prototype.playbackCoreName = \"default\";\n\n  PlaybackCoreProxy.prototype.config = null;\n\n  /**\n  */\n  PlaybackCoreProxy.prototype.onRegister = function() {\n    this.mediaProxy = this.facade.retrieveProxy(MediaProxy.NAME);\n  };\n\n  /**\n  */\n  PlaybackCoreProxy.prototype.getPlaybackCoreName = function() {\n    return this.playbackCoreName;\n  };\n\n  /**\n  */\n  PlaybackCoreProxy.prototype.getSupportedTypes = function() {\n    return this.supportedTypes || [];\n  };\n\n  /**\n  */\n  PlaybackCoreProxy.prototype.setSupportedTypes = function(types) {\n    this.supportedTypes = types;\n    return types;\n  };\n\n  /**\n  */\n  PlaybackCoreProxy.prototype.getTemporalTypes = function() {\n    return this.temporalTypes || [];\n  };\n\n  /**\n  */\n  PlaybackCoreProxy.prototype.setTemporalTypes = function(types) {\n    this.temporalTypes = types;\n    return types;\n  };\n\n  /** @override\n  */\n  PlaybackCoreProxy.prototype.canPlayTemporalType = function(temporalType) {\n    return this.getTemporalTypes().indexOf(temporalType) !== -1;\n  };\n\n  /** @override\n  */\n  PlaybackCoreProxy.prototype.canPlayType = function(mimeType) {\n    if (this.supportedTypes != null) {\n      if (this.getSupportedTypes().indexOf(mimeType) !== -1) {\n        return \"maybe\";\n      } else {\n        return \"\";\n      }\n    } else {\n      return PlaybackCoreProxy.__super__.canPlayType.call(this, mimeType);\n    }\n  };\n\n  /**\n   * ChromeCastPlaybackProxy constructor.\n   *\n   * @constructor\n   * @extends {PlaybackCoreProxy}\n   * @private\n  */\n  function FlashPlaybackProxy(player) {\n    this.player = player;\n    FlashPlaybackProxy.__super__.constructor.call(this);\n  }\n\n\n  __extends(FlashPlaybackProxy, PlaybackCoreProxy);\n\n\n  /**\n   * The name of the this Proxy.\n   *\n   * @static\n   * @type {string}\n  */\n  FlashPlaybackProxy.NAME = PlaybackProxy.NAME;\n\n  FlashPlaybackProxy.prototype.player = null;\n\n  FlashPlaybackProxy.prototype.initialized = true;\n\n  FlashPlaybackProxy.prototype.playbackCoreName = \"flash\";\n\n  FlashPlaybackProxy.prototype.supportedTypes = [\"video/mp4\", \"video/x-flv\", \"video/f4m\", \"application/smil\", \"application/smil+xml\"];\n\n  /**\n   * Indicates whether or not the video is playing.\n   *\n   * @returns {Boolean}\n   *    The playing value\n   * @type {Boolean}\n  */\n  FlashPlaybackProxy.prototype.getPaused = function() {\n    return this.player.getPaused();\n  };\n\n  /**\n   * Indicates whether or not the video is playing.\n   *\n   * @returns {Boolean}\n   *    The playing value\n   * @type {Boolean}\n  */\n  FlashPlaybackProxy.prototype.getEnded = function() {\n    return this.player.getEnded();\n  };\n\n  /**\n   * Indicates whether or not the video is playing.\n   *\n   * @returns {Boolean}\n   *    The playing value\n   * @type {Boolean}\n  */\n  FlashPlaybackProxy.prototype.getSeeking = function() {\n    return this.player.getSeeking();\n  };\n\n  /**\n   * The current time of the video in seconds. Value must be between currentTime and duration.\n   *\n   * @param {Number} value\n   *    The new currentTime value in seconds\n   * @returns {Number}\n   *    The currentTime value in seconds\n   * @type {Number}\n  */\n  FlashPlaybackProxy.prototype.getCurrentTime = function() {\n    return this.player.getCurrentTime();\n  };\n\n  FlashPlaybackProxy.prototype.setCurrentTime = function(value) {\n    this.player.setCurrentTime(value);\n    return value;\n  };\n\n  /**\n   * The current time of the video in seconds. Value must be between currentTime and duration.\n   *\n   * @param {Number} value\n   *    The new currentTime value in seconds\n   * @returns {Number}\n   *    The currentTime value in seconds\n   * @type {Number}\n  */\n  FlashPlaybackProxy.prototype.getSrc = function() {\n    return this.player.getSrc();\n  };\n\n  FlashPlaybackProxy.prototype.setSrc = function(value) {\n    this.player.setSrc(value);\n    return value;\n  };\n\n  /**\n   * The current time of the video in seconds. Value must be between currentTime and duration.\n   *\n   * @param {Number} value\n   *    The new currentTime value in seconds\n   * @returns {Number}\n   *    The currentTime value in seconds\n   * @type {Number}\n  */\n  FlashPlaybackProxy.prototype.getVolume = function() {\n    return this.player.getVolume();\n  };\n\n  FlashPlaybackProxy.prototype.setVolume = function(value) {\n    this.player.setVolume(value);\n    return value;\n  };\n\n  /**\n  */\n  FlashPlaybackProxy.prototype.getMuted = function() {\n    return this.player.getMuted();\n  };\n\n  FlashPlaybackProxy.prototype.setMuted = function(value) {\n    this.player.setMuted(value);\n    return value;\n  };\n\n  /**\n   * The duration of the video in seconds.\n   *\n   * @returns {Number}\n   *    The duration of the video\n   * @type {Number}\n  */\n  FlashPlaybackProxy.prototype.getDuration = function(value) {\n    return this.player.getDuration();\n  };\n\n  /**\n   * Instructs the core to play.\n  */\n  FlashPlaybackProxy.prototype.play = function() {\n    this.player.play();\n  };\n\n  /**\n   * Instructs the core to pause.\n  */\n  FlashPlaybackProxy.prototype.pause = function() {\n    this.player.pause();\n  };\n\n  /**\n   * Instructs the core to load.\n  */\n  FlashPlaybackProxy.prototype.load = function() {\n    this.player.load();\n  };\n\n  /**\n   * The FlashPlayer class\n   *\n   * @param {Object} viewComponent\n   * @constructor\n   * @private\n   * @extends {Player}\n  */\n  function FlashPlayer(viewComponent) {\n    var _this = this;\n    this.flashObjectID += Date.now();\n    this.plugins = {};\n    this._displayState = DisplayState.NORMAL;\n    this.debug = /debug\\=true/.test(location.search);\n    FlashPlayer.__super__.constructor.call(this, viewComponent);\n    this.addEventListener(\"mediachange\", function(event) {\n      var item, mediaElement, textTracks, track, tracks, _i, _len;\n      tracks = event.detail.track;\n      mediaElement = _this.getMediaElement();\n      textTracks = mediaElement.textTracks = [];\n      if (!(tracks != null)) {\n        return;\n      }\n      for (_i = 0, _len = tracks.length; _i < _len; _i++) {\n        track = tracks[_i];\n        item = {\n          kind: track.kind,\n          label: track.label,\n          language: track.srclang,\n          _mode: track.mode\n        };\n        Object.defineProperty(item, \"mode\", {\n          get: function() {\n            return this._mode;\n          },\n          set: function(value) {\n            var visible;\n            this._mode = value;\n            visible = value === \"showing\";\n            if (visible) {\n              mediaElement.setTrackByLanguage(this.language);\n            }\n            mediaElement.setPlayerProperty(\"captionDisplay\", {\n              visible: visible\n            });\n          },\n          enumerable: true,\n          configurable: false\n        });\n        textTracks.push(item);\n      }\n    });\n  }\n\n\n  __extends(FlashPlayer, Player);\n\n\n  /**\n   * @override\n  */\n  FlashPlayer.prototype.initialize = function(config, parentModule) {\n    var _ref, _ref1;\n    this.config = config;\n    this.parentModule = parentModule;\n    this.createDefaults();\n    this.logEvents = ((_ref = this.config.flash) != null ? _ref.logEvents : void 0) === true || ((_ref1 = QueryString[\"amp-flash-log\"]) != null ? _ref1.toLowerCase() : void 0) === \"true\";\n    FlashPlayer.__super__.initialize.call(this, this.config, this.parentModule);\n  };\n\n  /** @override\n  */\n  FlashPlayer.prototype.createFramework = function() {\n    var attributes, expressInstallSWF, flash, params, swf, swfs, version, xml, _ref;\n    FlashPlayer.__super__.createFramework.call(this);\n    flash = this.config.flash || {};\n    swfs = ((_ref = flash[\"static\"]) != null ? _ref.enabled : void 0) === true ? flash[\"static\"] : flash;\n    swf = this.debug && (swfs.debug != null) ? swfs.debug : swfs.swf || \"amp.swf\";\n    version = flash.version || \"10.1\";\n    expressInstallSWF = this.evaluatePaths(flash.expressInstallSWF) || \"playerProductInstall.swf\";\n    params = this.createParams(flash);\n    attributes = this.createAttributes(flash);\n    this.flashvars = this.createFlashVars(flash);\n    if (!(this.flashvars.settings_url != null)) {\n      xml = this.createXML(this.config);\n      if (xml != null) {\n        this.flashvars.settings_xml = xml;\n      }\n    }\n    attributes.data = this.evaluatePaths(swf);\n    this.createdHandler(Utils.createFlashObject({\n      params: params,\n      attributes: attributes,\n      vars: this.flashvars\n    }));\n  };\n\n  FlashPlayer.prototype.playerType = \"flash\";\n\n  FlashPlayer.prototype.flashObjectID = \"flashObject\";\n\n  FlashPlayer.prototype.loaded = false;\n\n  FlashPlayer.prototype.flashvars = null;\n\n  FlashPlayer.prototype._paused = false;\n\n  FlashPlayer.prototype._ended = false;\n\n  FlashPlayer.prototype._muted = false;\n\n  FlashPlayer.prototype.plugins = null;\n\n  FlashPlayer.prototype.debug = false;\n\n  FlashPlayer.prototype.started = false;\n\n  FlashPlayer.prototype._displayState = null;\n\n  FlashPlayer.prototype.logEvents = false;\n\n  FlashPlayer.prototype._loop = false;\n\n  FlashPlayer.prototype.playback = null;\n\n  FlashPlayer.prototype.flashPlugins = [\n    {\n      id: \"AkamaiAdvancedStreamingPlugin\",\n      src: \"http://players.edgesuite.net/flash/plugins/osmf/advanced-streaming-plugin/v3.10/osmf2.0/AkamaiAdvancedStreamingPlugin.swf\",\n      absolute: true,\n      host: \"osmf\",\n      main: \"com.akamai.osmf.AkamaiAdvancedStreamingPluginInfo\",\n      type: \"application/x-shockwave-flash\"\n    }, {\n      id: \"ErrorMessagingPlugin\",\n      src: '#{paths.resources}plugins/ErrorMessagingPlugin.swf',\n      blocking: false,\n      host: \"akamai\",\n      main: \"ErrorMessagingPlugin\",\n      type: \"application/x-shockwave-flash\"\n    }, {\n      id: \"VideoMetricsViewPlugin\",\n      src: '#{paths.resources}plugins/VideoMetricsViewPlugin.swf',\n      blocking: false,\n      host: \"akamai\",\n      main: \"VideoMetricsViewPlugin\",\n      type: \"application/x-shockwave-flash\"\n    }, {\n      id: \"VideoStatsInfoOverlayPlugin\",\n      src: '#{paths.resources}plugins/VideoStatsInfoOverlayPlugin.swf',\n      blocking: false,\n      host: \"akamai\",\n      main: \"VideoStatsInfoOverlayPlugin\",\n      type: \"application/x-shockwave-flash\"\n    }\n  ];\n\n  FlashPlayer.prototype.flashView = null;\n\n  /** @override\n  */\n  FlashPlayer.prototype.createModel = function() {\n    FlashPlayer.__super__.createModel.call(this);\n    this.playback = new FlashPlaybackProxy(this);\n    this.registerProxy(this.playback);\n    this.appState.setRenderMode(RenderMode.FLASH);\n    this.bindings.initialize();\n  };\n\n  /** @override\n  */\n  FlashPlayer.prototype.createView = function() {\n    this.registerMediator(new FlashPlayerMediator(this.getViewComponent()));\n    this.registerMediator(new VideoLayerMediator());\n    this.registerMediator(new OverlayLayerMediator());\n    this.registerMediator(new LocalizationWrapper(this, this.config));\n  };\n\n  /** @override\n  */\n  FlashPlayer.prototype.createController = function() {\n    FlashPlayer.__super__.createController.call(this);\n    this.registerCommand(SecurityNotifications.AUTHORIZE, PlayerEventCommand);\n    this.registerCommand(SecurityNotifications.AUTHORIZED, FlashAuthorizedCommand);\n    this.registerCommand(Notifications.CHANGE_PLAY_STATE, ChangePlayStateCommand);\n    this.registerCommand(Notifications.PLAY_STATE_CHANGE, PlayerEventCommand);\n    this.registerCommand(Notifications.START, FlashStartCommand);\n    this.registerCommand(Notifications.STARTED, PlayerEventCommand);\n    this.registerCommand(Notifications.PLAY, PlayerEventCommand);\n    this.registerCommand(Notifications.PLAY_REQUEST, PlayerEventCommand);\n    this.registerCommand(FlashNotifications.FLASH_CREATED, PlayerEventCommand);\n    this.registerCommand(Notifications.CHANGE_PLAYBACK_TARGET, ChangePlaybackTargetCommand);\n    this.registerCommand(Notifications.PLAYBACK_TARGET_CHANGE, PlaybackTargetChangeCommand);\n    this.registerCommand(Notifications.UPDATE_DATA_BINDINGS, UpdateDataBindingsCommand);\n  };\n\n  /** @override\n  */\n  FlashPlayer.prototype.createMediaElement = function() {\n    var video, viewComponent;\n    video = new MediaElementMediator(\"flash\", \"div\");\n    this.sendNotification(Notifications.PLAYBACK_CORE_CHANGE, video);\n    viewComponent = video.getViewComponent();\n    viewComponent.id = viewComponent.name = this.flashObjectID;\n    return viewComponent;\n  };\n\n  /**\n  */\n  FlashPlayer.prototype.createDefaults = function() {\n    var plugin, resources, swf, _i, _len, _ref, _ref1, _ref2;\n    if (!((_ref = this.flashPlugins) != null ? _ref.length : void 0) > 0) {\n      return;\n    }\n    resources = this.config.resources || [];\n    if (((_ref1 = this.config.flash) != null ? _ref1.resources : void 0) != null) {\n      resources = resources.concat(this.config.flash.resources);\n    }\n    swf = Utils.mimeTypes.swf;\n    _ref2 = this.flashPlugins;\n    for (_i = 0, _len = _ref2.length; _i < _len; _i++) {\n      plugin = _ref2[_i];\n      if ((plugin != null) && resources.filter(function(resource) {\n        return resource.id === plugin.id;\n      }).length === 0) {\n        if (plugin.type == null) {\n          plugin.type = swf;\n        }\n        resources.push(plugin);\n      }\n    }\n    this.config.resources = resources;\n  };\n\n  /**\n  */\n  FlashPlayer.prototype.createParams = function(flash) {\n    var params;\n    params = {\n      allowFullScreen: true,\n      allowScriptAccess: \"always\",\n      wmode: \"direct\",\n      bgColor: \"#000000\"\n    };\n    if (flash.params != null) {\n      if (flash.params.allowFullScreen != null) {\n        params.allowFullScreen = flash.params.allowFullScreen;\n      }\n      if (flash.params.allowScriptAccess != null) {\n        params.allowScriptAccess = flash.params.allowScriptAccess;\n      }\n      if (flash.params.wmode != null) {\n        params.wmode = flash.params.wmode;\n      }\n      if (flash.params.bgColor != null) {\n        params.bgColor = flash.params.bgColor;\n      }\n    }\n    if (params.wmode === \"direct\" && /MSIE/.test(navigator.userAgent)) {\n      params.wmode = \"transparent\";\n    }\n    return params;\n  };\n\n  /** @override\n  */\n  FlashPlayer.prototype.getModules = function() {\n    return this.plugins;\n  };\n\n  /** @override\n  */\n  FlashPlayer.prototype.createPlugins = function() {\n    var def, feature, key, plugin, register, _ref;\n    _ref = AMP.plugins;\n    for (key in _ref) {\n      register = _ref[key];\n      if (!((key in this.config) && (this.config[key] != null) && !(this.config[key].enabled === false))) {\n        continue;\n      }\n      def = register[this.getPlayerType()];\n      if (!(def != null)) {\n        this.logger.debug(\"[AMP] Plugin could not be found: \" + key);\n        continue;\n      }\n      try {\n        plugin = this[key] = this.plugins[key] = new def(this, this.config[key]);\n        this.registerMediator(this.plugins[key]);\n        feature = typeof plugin.getFeatureName === \"function\" ? plugin.getFeatureName() : void 0;\n        if (feature != null) {\n          this[feature] = plugin;\n        }\n        if (plugin.flashView != null) {\n          this.flashView = Utils.override(this.flashView, plugin.flashView);\n        }\n        this.logger.debug(\"[AMP] Plugin registered: \" + key);\n      } catch (error) {\n        this.logger.error(\"[AMP] Plugin could not be created: \" + key + \". \" + error);\n        continue;\n      }\n    }\n    if (this.config.flash.view != null) {\n      this.flashView = Utils.override(this.flashView, this.config.flash.view);\n    }\n    this.sendNotification(PluginNotifications.PLUGINS_INITIALIZED, this.plugins);\n  };\n\n  /**\n  */\n  FlashPlayer.prototype.createAttributes = function(flash) {\n    var attributes;\n    attributes = {\n      id: this.flashObjectID,\n      name: this.flashObjectID\n    };\n    if (flash.attributes != null) {\n      if (flash.attributes.id != null) {\n        attributes.id = flash.attributes.id;\n      }\n      if (flash.attributes.name != null) {\n        attributes.name = flash.attributes.name;\n      }\n    }\n    return attributes;\n  };\n\n  /**\n  */\n  FlashPlayer.prototype.createFlashJSON = function(config, spacer) {\n    var prepJSON, prepValue;\n    if (config == null) {\n      config = this.config;\n    }\n    config = JSON.stringify(config);\n    config = this.evaluatePaths(config);\n    config = JSON.parse(config);\n    prepValue = function(config, key, value) {\n      switch (typeof value) {\n        case \"string\":\n          config[key] = escape(value);\n          break;\n        case \"object\":\n          prepJSON(value);\n      }\n    };\n    prepJSON = function(config) {\n      var key, value, _i, _len;\n      if (config instanceof Array) {\n        for (key = _i = 0, _len = config.length; _i < _len; key = ++_i) {\n          value = config[key];\n          prepValue(config, key, value);\n        }\n      } else if (typeof config === \"object\") {\n        for (key in config) {\n          value = config[key];\n          prepValue(config, key, value);\n        }\n      }\n    };\n    prepJSON(config);\n    return encodeURIComponent(JSON.stringify(config, null, spacer));\n  };\n\n  /**\n  */\n  FlashPlayer.prototype.createFlashVars = function(flash) {\n    var flashvars, loadingViewString, prop, settings, _ref, _ref1, _ref2, _ref3, _ref4, _ref5, _ref6;\n    flashvars = {};\n    settings = JSON.parse(JSON.stringify(this.config));\n    settings.flash = null;\n    delete settings.flash;\n    settings.locales = null;\n    delete settings.locales;\n    settings.params = null;\n    delete settings.params;\n    settings.rules = null;\n    delete settings.rules;\n    flashvars.settings_json = this.createFlashJSON(settings);\n    if (this.config.autoplay != null) {\n      flashvars.auto_play = this.config.autoplay;\n    }\n    if ((this.config.rules != null)) {\n      Utils.mergeRules(this.config.rules);\n    }\n    flashvars.hinting_rules = escape(JSON.stringify(Utils.rules));\n    if (this.config.volume != null) {\n      flashvars.volume = Utils.clamp(this.config.volume, 0, 1);\n    }\n    if ((this.config.target != null)) {\n      flashvars.external_target = this.config.target;\n    }\n    if ((this.config.name != null)) {\n      flashvars.core_player_name = this.config.name;\n    }\n    if ((this.config.domain != null)) {\n      flashvars.embed_domain = flashvars.domain = this.config.domain;\n    }\n    this._loop = flashvars.auto_replay = this.config.loop === true;\n    if (this.config.fullscreen != null) {\n      flashvars.fullscreen_enabled = this.config.fullscreen.enabled !== false && this.config.fullscreen.mode !== FullscreenMode.EXTERNAL;\n    }\n    if (this.config.titlebar != null) {\n      flashvars.titlebar_enabled = this.config.titlebar.enabled !== false;\n    }\n    if (this.config.params != null) {\n      flashvars.params = escape(JSON.stringify(this.config.params));\n    }\n    if (this.config.version != null) {\n      flashvars.context_menu_label = this.config.version;\n    }\n    if (((_ref = this.config.controls) != null ? _ref.displaySceneMarkers : void 0) != null) {\n      flashvars.displaySceneMarkers = this.config.controls.displaySceneMarkers;\n    }\n    if (this.config.media != null) {\n      this.mediaProxy.setData(this.config.media);\n      if (this.config.media.src != null) {\n        this.setSrc(this.config.media.src);\n        flashvars.video_url = escape(this.config.media.src);\n      }\n      if ((this.config.media.source != null) && this.config.media.source.length > 0) {\n        this.setSource(this.config.media.source);\n        flashvars.video_url = escape(this.mediaProxy.getSrc());\n      }\n      if (this.config.media.medium != null) {\n        this.setMedium(this.config.media.medium);\n        flashvars.medium = this.config.media.medium;\n      }\n      if (this.config.media.title != null) {\n        flashvars.title = encodeURIComponent(this.config.media.title);\n      }\n      if (this.config.media.poster != null) {\n        flashvars.poster = escape(this.config.media.poster);\n      }\n      if (this.config.media.temporalType != null) {\n        flashvars.temporalType = this.config.media.temporalType;\n      }\n    }\n    if (this.getMedium() === \"audio\") {\n      flashvars.controls = true;\n      flashvars.auto_hide = -1;\n    }\n    if (((_ref1 = this.config.ima) != null ? (_ref2 = _ref1.overlay) != null ? _ref2.delay : void 0 : void 0) != null) {\n      flashvars.overlay_ad_delay = this.config.ima.overlay.delay;\n    }\n    if ((this.config.ticker != null) && this.config.ticker.enabled !== false) {\n      if (this.config.ticker.url != null) {\n        flashvars.ticker_text_url = this.config.ticker.url;\n      }\n      if (this.config.ticker.interval != null) {\n        flashvars.ticker_polling_interval = this.config.ticker.interval;\n      }\n      if (this.config.ticker.speed != null) {\n        flashvars.ticker_speed = this.config.ticker.speed;\n      }\n    }\n    flashvars.show_play_button_overlay = false;\n    flashvars.auto_play_list = false;\n    flashvars.next_video_timer = 0;\n    if (flashvars.context_menu_mode == null) {\n      flashvars.context_menu_mode = this.debug === true ? \"long\" : \"short\";\n    }\n    if (((_ref3 = this.config.flash) != null ? (_ref4 = _ref3.view) != null ? (_ref5 = _ref4.elements) != null ? (_ref6 = _ref5.loadingView) != null ? _ref6.attributes : void 0 : void 0 : void 0 : void 0) != null) {\n      loadingViewString = \"\";\n      for (prop in this.config.flash.view.elements.loadingView.attributes) {\n        loadingViewString += prop + \":\" + this.config.flash.view.elements.loadingView.attributes[prop] + \" \";\n      }\n      flashvars.loadingView = loadingViewString;\n    }\n    this.sendNotification(FlashNotifications.CREATE_FLASH_VARS, {\n      flashvars: flashvars,\n      config: this.config\n    });\n    flashvars = Utils.override(flashvars, flash.vars);\n    return flashvars;\n  };\n\n  /**\n  */\n  FlashPlayer.prototype.createXML = function(config) {\n    var app, element, elements, isStatic, key, mode, node, parent, parseResources, parseView, plugin, plugins, str, swf, value, viewXML, xml, _i, _j, _len, _len1, _ref, _ref1, _ref2;\n    if (!((config != null ? (_ref = config.flash) != null ? _ref.xml : void 0 : void 0) != null)) {\n      if (config.flash == null) {\n        config.flash = {};\n      }\n      config.flash.xml = \"<application></application>\";\n    }\n    xml = XMLUtils.parse(config.flash.xml);\n    if (xml.childNodes.length > 1) {\n      xml.removeChild(xml.firstChild);\n    }\n    this.sendNotification(FlashNotifications.CREATE_XML, {\n      config: config,\n      xml: xml\n    });\n    parseResources = function(config) {\n      var key, plugins, resource, resources, value, _i, _len;\n      resources = config.resources;\n      plugins = [];\n      if ((resources instanceof Array) && ((resources != null ? resources.length : void 0) > 0)) {\n        for (_i = 0, _len = resources.length; _i < _len; _i++) {\n          resource = resources[_i];\n          if (!(resource.type === swf)) {\n            continue;\n          }\n          resource = Utils.clone(resource);\n          if (isStatic === true) {\n            if ((resource.main != null) && resource.main !== \"\") {\n              resource.src = resource.main;\n              resource.type = \"static\";\n            } else {\n              resource.type = \"dynamic\";\n            }\n          } else {\n            if ((resource.src != null) && resource.src !== \"\") {\n              resource.type = \"dynamic\";\n            } else {\n              resource.src = resource.main;\n              resource.type = \"static\";\n            }\n          }\n          delete resource.main;\n          plugins.push(resource);\n        }\n      }\n      for (key in config) {\n        value = config[key];\n        if (key !== \"flash\" && ((resources = value != null ? value.resources : void 0) != null) && (resources instanceof Array) && (resources.length > 0)) {\n          plugins = plugins.concat(parseResources(value));\n        }\n      }\n      return plugins;\n    };\n    swf = Utils.mimeTypes.swf;\n    plugins = parseResources(this.config);\n    isStatic = ((_ref1 = config.flash[\"static\"]) != null ? _ref1.enabled : void 0) === true;\n    if ((plugins != null ? plugins.length : void 0) > 0) {\n      parent = xml.getElementsByTagName(\"plugins\");\n      if (parent.length < 1) {\n        parent = xml.createElement(\"plugins\");\n        xml.firstChild.appendChild(parent);\n      } else {\n        parent = parent[0];\n      }\n      for (_i = 0, _len = plugins.length; _i < _len; _i++) {\n        plugin = plugins[_i];\n        if (!(plugin.enabled !== false)) {\n          continue;\n        }\n        node = xml.createElement(\"plugin\");\n        for (key in plugin) {\n          value = plugin[key];\n          if (key !== \"loaded\") {\n            if (key !== \"src\") {\n              node.setAttribute(key, \"\" + value);\n            } else {\n              if (key === \"id\" && value === \"AkamaiAdvancedStreamingPlugin\" && this.debug === true) {\n                value = value.replace(\"AkamaiAdvancedStreamingPlugin.swf\", \"AkamaiAdvancedStreamingPlugin-logging.swf\");\n              }\n              node.appendChild(XMLUtils.createTextContent(xml, value));\n            }\n          }\n        }\n        parent.appendChild(node);\n      }\n    }\n    parseView = function(view, node) {\n      var element, key, value, _ref2, _ref3, _ref4;\n      if (view.attributes != null) {\n        _ref2 = view.attributes;\n        for (key in _ref2) {\n          value = _ref2[key];\n          node.setAttribute(key, \"\" + value);\n        }\n      }\n      if (view.elements != null) {\n        _ref3 = view.elements;\n        for (key in _ref3) {\n          value = _ref3[key];\n          if (!(value != null)) {\n            continue;\n          }\n          element = xml.createElement(\"element\");\n          element.setAttribute(\"id\", key);\n          if (element.id === \"state\") {\n            continue;\n          }\n          parseView(value, element);\n          node.appendChild(element);\n        }\n      }\n      if (view.state != null) {\n        element = xml.createElement(\"state\");\n        if (view.state.attributes) {\n          _ref4 = view.state.attributes;\n          for (key in _ref4) {\n            value = _ref4[key];\n            if (value != null) {\n              element.setAttribute(key, \"\" + value);\n            }\n          }\n        }\n        node.appendChild(element);\n      }\n      return node;\n    };\n    viewXML = xml.getElementsByTagName(\"view\")[0];\n    if (!(viewXML != null)) {\n      viewXML = xml.createElement(\"view\");\n      xml.firstChild.appendChild(viewXML);\n    }\n    parseView(this.flashView, viewXML);\n    mode = (_ref2 = this.config.fullscreen) != null ? _ref2.mode : void 0;\n    if (mode != null) {\n      elements = xml.getElementsByTagName(\"element\");\n      for (_j = 0, _len1 = elements.length; _j < _len1; _j++) {\n        element = elements[_j];\n        if (element.getAttribute(\"id\") === \"fullscreenBtn\") {\n          element.setAttribute(\"action\", \"external\");\n        }\n      }\n    }\n    str = XMLUtils.serialize(xml);\n    app = str.match(/<application>[\\w\\W\\s\\S\\d\\D]*<\\/application>/)[0] || str;\n    app = app.replace(/[\\n\\r\\t]/g, \"\");\n    app = this.evaluatePaths(app);\n    return encodeURIComponent(app);\n  };\n\n  /**\n  */\n  FlashPlayer.prototype.createdHandler = function(obj) {\n    var element, mediaElement, parent,\n      _this = this;\n    element = this.getMediaElement();\n    parent = element.parentNode;\n    parent.removeChild(element);\n    parent.appendChild(obj);\n    mediaElement = obj;\n    this.setMediaElement(mediaElement);\n    mediaElement.className = Namespace.PREFIX + MediaElementMediator.prototype.componentType;\n    mediaElement.eventHandler = function(eventName, body) {\n      return _this.eventHandler(eventName, body);\n    };\n    this.sendNotification(FlashNotifications.FLASH_CREATED);\n    if (this.getMedium() != null) {\n      this.setMedium(this.getMedium());\n    }\n  };\n\n  /**\n  */\n  FlashPlayer.prototype.eventHandler = function(eventName, body) {\n    var error, event, helper, media, state, type, update, _ref, _ref1, _ref2, _ref3;\n    if (this.logEvents && !this.excludedFlashEvents.test(eventName)) {\n      this.logger.log(\"[AMP FLASH EVENT] \" + eventName, body);\n    }\n    try {\n      switch (eventName) {\n        case FlashNotifications.INITIALIZED:\n          type = state = \"ready\";\n          break;\n        case FlashNotifications.RESET:\n          if (!(body != null)) {\n            state = \"ready\";\n          }\n          this.started = false;\n          break;\n        case FlashNotifications.LOADING:\n          type = \"loadstart\";\n          break;\n        case FlashNotifications.PLAYER_ERROR:\n          type = state = \"error\";\n          break;\n        case FlashNotifications.MEDIA_ERROR:\n          type = state = \"error\";\n          break;\n        case FlashNotifications.FEED_LOADED:\n          body = JSON.parse(body);\n          helper = new MRSSHelper();\n          media = (_ref = helper.createFeed(body)) != null ? (_ref1 = _ref.item) != null ? _ref1[0] : void 0 : void 0;\n          if (media != null) {\n            this.mediaProxy.setData(media);\n          }\n          break;\n        case FlashNotifications.FEED_UPDATED:\n          type = \"mediachange\";\n          body = this.getMedia();\n          update = true;\n          break;\n        case FlashNotifications.ERROR_STREAM_NOT_FOUND:\n          type = state = \"error\";\n          break;\n        case FlashNotifications.CAPABILITY_CHANGE:\n          event = body.type;\n          if (event === \"canPlayChange\" && body.enabled === true) {\n            type = \"canplay\";\n            this.loaded = true;\n          } else if (event === \"canSeekChange\" && body.enabled === true) {\n            type = \"canplaythrough\";\n          } else if (event === \"temporalChange\" && body.enabled === true) {\n            type = \"loadedmetadata\";\n            if (!this.started) {\n              this.sendNotification(Notifications.START, body);\n            }\n          }\n          break;\n        case FlashNotifications.PLAYING:\n          if (!this.started) {\n            this.sendNotification(Notifications.START, body);\n          }\n          type = state = \"playing\";\n          this._ended = false;\n          this._paused = false;\n          if (this.appState.getSeeking() === true) {\n            this.appState.setSeeking(false);\n            this.sendNotification(Notifications.SEEKED);\n            this.sendNotification(Notifications.DISPATCH_EVENT, new Event(\"seeked\"));\n          }\n          break;\n        case FlashNotifications.ELEMENT_EVENT:\n          if (body.element === \"fullscreenBtn\" && body.type === \"click\" && ((_ref2 = this.config) != null ? (_ref3 = _ref2.fullscreen) != null ? _ref3.mode : void 0 : void 0) === FullscreenMode.EXTERNAL) {\n            state = this.getDisplayState() === DisplayState.FULL_SCREEN ? DisplayState.NORMAL : DisplayState.FULL_SCREEN;\n            this.setDisplayState(state);\n          }\n          break;\n        case FlashNotifications.PLAY_REQUEST:\n          this.sendNotification(Notifications.PLAY_REQUEST);\n          type = Notifications.MEDIA_SEQUENCE_STARTED;\n          this.loaded = true;\n          this._ended = false;\n          break;\n        case FlashNotifications.PLAY:\n          if (this.getPlayState() !== \"paused\" && this.started) {\n            this.sendNotification(Notifications.PLAY, body);\n          }\n          break;\n        case FlashNotifications.ENDED:\n          type = state = Notifications.ENDED;\n          this._ended = true;\n          break;\n        case FlashNotifications.MEDIA_SEQUENCE_ENDED:\n          type = Notifications.MEDIA_SEQUENCE_ENDED;\n          break;\n        case FlashNotifications.PAUSED:\n          type = \"pause\";\n          state = \"paused\";\n          this._paused = true;\n          break;\n        case FlashNotifications.BUFFERING:\n          if (this.className !== \"ended\") {\n            type = state = \"waiting\";\n          }\n          break;\n        case FlashNotifications.DURATION_CHANGE:\n          if (!isNaN(body.time)) {\n            type = \"durationchange\";\n            body = body.time;\n          }\n          break;\n        case FlashNotifications.VOLUME_CHANGE:\n          type = \"volumechange\";\n          break;\n        case FlashNotifications.TIME_UPDATE:\n          type = \"timeupdate\";\n          break;\n        case FlashNotifications.SEEKING_CHANGE:\n          if (this.appState.getSeeking() === false && body.seeking === false) {\n            return;\n          }\n          type = body.seeking ? \"seeking\" : \"seeked\";\n          this.appState.setSeeking(body.seeking);\n          if (body.seeking) {\n            state = \"seeking\";\n          }\n          break;\n        case FlashNotifications.FULLSCREEN_CHANGE:\n          type = \"fullscreenchange\";\n          body = body.displayState === \"fullScreen\";\n          this.applyDisplayState(body ? DisplayState.FULL_SCREEN : DisplayState.NORMAL);\n          break;\n        case FlashNotifications.FAIL_OVER_ATTEMPT:\n          type = \"failoverattempt\";\n          body = body;\n          break;\n        case FlashNotifications.ERROR:\n          eventName = null;\n          break;\n        case FlashNotifications.AUTHORIZE:\n          type = SecurityNotifications.AUTHORIZE;\n          break;\n        case FlashNotifications.TIMED_METADATA:\n          type = Notifications.TIMED_METADATA;\n          body = {\n            startTime: body.time,\n            endTime: body.time,\n            data: body\n          };\n      }\n      if ((eventName != null) && eventName !== type) {\n        event = new Event(eventName, body);\n        event.dispatcher = \"FLASH\";\n        this.sendNotification(Notifications.DISPATCH_EVENT, event);\n        this.sendNotification(eventName, body);\n      }\n      if (type != null) {\n        if (type === \"error\") {\n          error = body.error || body;\n          this.error(\"Flash Error\", error);\n        }\n        this.sendNotification(type, body);\n        this.sendNotification(Notifications.DISPATCH_EVENT, new Event(type, body));\n      }\n      if (update != null) {\n        this.sendNotification(Notifications.UPDATE_DATA_BINDINGS);\n      }\n      if (state != null) {\n        this.setPlayState(state);\n      }\n    } catch (error) {\n      this.error(\"Event Error: \" + eventName, error);\n    }\n  };\n\n  FlashPlayer.prototype.error = function(msg, error) {\n    this.logger.error(\"[AMP FLASH ERROR]\", msg, error);\n  };\n\n  /**\n  */\n  FlashPlayer.prototype.excludedFlashEvents = /(mediaPlayerPlayheadUpdate|mediaPlayerElementEvent|adComponentPlaybackProgress)/;\n\n  FlashPlayer.prototype.logFlashEvents = false;\n\n  FlashPlayer.prototype.logEvent = function(event) {\n    if ((event.dispatcher === \"FLASH\" && this.logFlashEvents === false) || this.excludedFlashEvents.test(event.type) === true) {\n      return;\n    }\n    FlashPlayer.__super__.logEvent.call(this, event);\n  };\n\n  /**\n   * Sets the player's play state and adds CSS class to player div\n  */\n  FlashPlayer.prototype.setPlayState = function(state) {\n    this.sendNotification(Notifications.CHANGE_PLAY_STATE, state);\n    return state;\n  };\n\n  FlashPlayer.prototype.getPlayState = function() {\n    return this.appState.getPlayState();\n  };\n\n  /**\n   * Initializes the player to a given set of parameters\n  */\n  FlashPlayer.prototype.setMedia = function(value) {\n    FlashPlayer.__super__.setMedia.call(this, value);\n    if (this.getPlayState() != null) {\n      this.setPlayState(\"ready\");\n    }\n    this.mediaProxy.setData(value);\n    if (value.src != null) {\n      this.setSrc(value.src);\n    }\n    if ((value.source != null) && value.source.length > 0) {\n      this.setSource(value.source);\n    }\n    this.sendNotification(Notifications.MEDIA_CHANGE, value);\n    this.load(this.mediaProxy.getData());\n    return value;\n  };\n\n  /**\n  */\n  FlashPlayer.prototype.getMedia = function() {\n    return this.mediaProxy.getData();\n  };\n\n  /**\n   * Loads the video.\n   *\n  */\n  FlashPlayer.prototype.load = function(data) {\n    var media;\n    if (data == null) {\n      data = {};\n    }\n    media = this.mediaProxy.getData();\n    if (data.autoplay == null) {\n      data.autoplay = this.config.autoplay;\n    }\n    this.loadAuthorized = this._loadAuthorized.bind(this, media, data);\n    this.security.setMedia(media);\n    if (this.security.getAuthorized()) {\n      this.loadAuthorized(data);\n    } else {\n      this.sendNotification(SecurityNotifications.AUTHORIZE, {\n        media: media,\n        data: data\n      });\n    }\n  };\n\n  /**\n  */\n  FlashPlayer.prototype._loadAuthorized = function(media, data) {\n    this.loaded = true;\n    this.getMediaElement().loadURL(this.mediaProxy.getSrc(), data);\n  };\n\n  /**\n   * Plays the currently loaded video.\n   *\n  */\n  FlashPlayer.prototype.play = function() {\n    if (!this.loaded) {\n      this.load();\n    }\n    this.getMediaElement().unpause();\n  };\n\n  /**\n  */\n  FlashPlayer.prototype.setMuted = function(value) {\n    this._muted = value;\n    try {\n      if (value === true) {\n        this.getMediaElement().mute();\n      } else {\n        this.getMediaElement().unmute();\n      }\n    } catch (error) {\n      this.error(\"Flash muted error\", error);\n    }\n    return value;\n  };\n\n  /**\n  */\n  FlashPlayer.prototype.getMuted = function() {\n    return this._muted;\n  };\n\n  /**\n  */\n  FlashPlayer.prototype.getLoop = function() {\n    return this._loop;\n  };\n\n  /**\n   * The source url of video.\n   *\n   * @param {String} value The source url of the video to play.\n  */\n  FlashPlayer.prototype.getSrc = function(value) {\n    return this.getMediaElement().getURL();\n  };\n\n  FlashPlayer.prototype.setSrc = function(value) {\n    this.mediaProxy.setSrc(value);\n    this.loaded = false;\n    this.setMedium(Utils.getMimeType(value));\n    return value;\n  };\n\n  /**\n  */\n  FlashPlayer.prototype.setAutoplay = function(value) {\n    this.getMediaElement().setPlayerProperty(\"autoplay\", value);\n    return value;\n  };\n\n  FlashPlayer.prototype.getAutoplay = function() {\n    return this.getMediaElement().getPlayerProperty(\"autoplay\");\n  };\n\n  /**\n   * The url to the video.\n   *\n   * @param {String} value\n   *    The new title of the video\n   * @returns {Boolean}\n   *    The title of the video\n   * @type {String}\n  */\n  FlashPlayer.prototype.getMedium = function() {\n    return this.mediaProxy.getData().medium;\n  };\n\n  FlashPlayer.prototype.setMedium = function(value) {\n    var media, previous;\n    media = this.mediaProxy.getData();\n    if (value === media.medium) {\n      return;\n    }\n    if (media.medium != null) {\n      previous = \"medium-\" + media.medium;\n    }\n    media.medium = /audio/.test(value) ? \"audio\" : \"video\";\n    this.sendNotification(Notifications.MEDIUM_CHANGE, {\n      value: \"medium-\" + media.medium,\n      previous: previous\n    });\n    return value;\n  };\n\n  /**\n   * Sets the source url of video.\n   *\n   * @param {String} value The source url of the video to play.\n  */\n  FlashPlayer.prototype.setSource = function(value) {\n    var item, media,\n      _this = this;\n    if (!(value != null) || value.length < 1) {\n      return;\n    }\n    media = this.mediaProxy.getData();\n    media.source = value;\n    this.loaded = false;\n    item = Utils.selectSource(value, function(type) {\n      return _this.canPlayType(type);\n    });\n    if (((item != null ? item.src : void 0) != null) && item.src !== \"\") {\n      this.setSrc(item.src);\n      if (typeof type !== \"undefined\" && type !== null) {\n        this.setMedium(type);\n      }\n    } else {\n      throw new Error(\"No valid source could be found\");\n    }\n    return value;\n  };\n\n  /**\n   * Gets the source url of video.\n   *\n   * @return {Number} The source url of the video.\n  */\n  FlashPlayer.prototype.getSource = function() {\n    return this.mediaProxy.getData().source;\n  };\n\n  /**\n   * Gets the source url of video.\n   *\n   * @return {Number} The source url of the video.\n  */\n  FlashPlayer.prototype.getSeeking = function() {\n    return this.appState.getSeeking();\n  };\n\n  /**\n   * Gets the source url of video.\n   *\n   * @return {Number} The source url of the video.\n  */\n  FlashPlayer.prototype.getPaused = function() {\n    return this._paused;\n  };\n\n  /**\n   * Gets the source url of video.\n   *\n   * @return {Number} The source url of the video.\n  */\n  FlashPlayer.prototype.getEnded = function() {\n    return this._ended;\n  };\n\n  /**\n  */\n  FlashPlayer.prototype.getFlashXML = function() {\n    var doc, xml;\n    xml = decodeURIComponent(this.flashvars.settings_xml);\n    doc = XMLUtils.parse(xml);\n    try {\n      doc.toString = function() {\n        return xml;\n      };\n    } catch (error) {\n\n    }\n    return doc;\n  };\n\n  /**\n  */\n  FlashPlayer.prototype.getFlashVars = function() {\n    return this.flashvars;\n  };\n\n  /**\n  */\n  FlashPlayer.prototype.getFlashJSON = function() {\n    return JSON.parse(decodeURIComponent(this.flashvars.settings_json));\n  };\n\n  FlashPlayer.prototype.evaluateBinding = function(str) {\n    var value;\n    value = this.getMediaElement().evaluateBinding(str);\n    if (value != null) {\n      try {\n        value = JSON.parse(value);\n      } catch (error) {\n\n      }\n    }\n    return value;\n  };\n\n  FlashPlayer.prototype.canPlayType = function(mimeType) {\n    if (__indexOf.call(Utils.flashTypes, mimeType) >= 0) {\n      return \"maybe\";\n    } else {\n      return \"\";\n    }\n  };\n\n  FlashPlayer.prototype.replay = function() {\n    this.getMediaElement().replay();\n  };\n\n  FlashPlayer.prototype.pause = function() {\n    this.getMediaElement().pause();\n  };\n\n  FlashPlayer.prototype.end = function() {\n    this.getMediaElement().stopPlayer();\n  };\n\n  FlashPlayer.prototype.getCurrentTime = function() {\n    return this.getMediaElement().getCurrentTime();\n  };\n\n  FlashPlayer.prototype.setCurrentTime = function(value) {\n    this.getMediaElement().jumpToTime(value);\n    return value;\n  };\n\n  FlashPlayer.prototype.getParams = function() {\n    return this.getMediaElement().getParams();\n  };\n\n  FlashPlayer.prototype.setParams = function(value) {\n    this.getMediaElement().setParams(value);\n    return value;\n  };\n\n  FlashPlayer.prototype.getVolume = function() {\n    return this.getMediaElement().getVolume();\n  };\n\n  FlashPlayer.prototype.setVolume = function(value, scope) {\n    this.getMediaElement().setVolume(value, scope || \"\");\n    return value;\n  };\n\n  FlashPlayer.prototype.getDuration = function() {\n    return this.getMediaElement().getDuration();\n  };\n\n  FlashPlayer.prototype.getDisplayState = function() {\n    return this._displayState;\n  };\n\n  FlashPlayer.prototype.setDisplayState = function(value) {\n    var _ref;\n    if (value === this._displayState) {\n      return;\n    }\n    this.applyDisplayState(value);\n    if (((_ref = this.config.fullscreen) != null ? _ref.mode : void 0) === FullscreenMode.EXTERNAL) {\n      return;\n    }\n    if (this._displayState === DisplayState.FULL_SCREEN) {\n      this.getMediaElement().enterFullScreen();\n    } else {\n      this.getMediaElement().exitFullScreen();\n    }\n    return value;\n  };\n\n  FlashPlayer.prototype.applyDisplayState = function(value) {\n    var states;\n    if (value === this._displayState) {\n      return;\n    }\n    states = {\n      value: value,\n      previous: this._displayState\n    };\n    this._displayState = value;\n    this.sendNotification(Notifications.DISPLAY_STATE_CHANGE, states);\n    this.sendNotification(Notifications.DISPATCH_EVENT, new Event(\"fullscreenchange\", this._displayState === DisplayState.FULL_SCREEN));\n  };\n\n  FlashPlayer.prototype.enterFullScreen = function() {\n    this.setDisplayState(DisplayState.FULL_SCREEN);\n  };\n\n  FlashPlayer.prototype.exitFullScreen = function() {\n    this.setDisplayState(DisplayState.NORMAL);\n  };\n\n  FlashPlayer.prototype.recordContentChange = function(content) {\n    this.getMediaElement().recordContentChange(content);\n  };\n\n  FlashPlayer.prototype.setQuality = function(value) {\n    return this.getMediaElement().setQuality(value);\n  };\n\n  FlashPlayer.prototype.getQuality = function() {\n    return this.getMediaElement().getQuality();\n  };\n\n  FlashPlayer.prototype.getQualityLevels = function() {\n    return this.getMediaElement().getQualityLevels();\n  };\n\n  /**\n   * The ModuleAdapter class.\n   *\n   * @param {Module} module\n   * @constructor\n   * @private\n   * @extends {puremvc.Mediator}\n  */\n  function ModuleAdapter(module) {\n    this.module = module;\n    ModuleAdapter.__super__.constructor.call(this, module.getModuleName(), this);\n  }\n\n\n  __extends(ModuleAdapter, puremvc.Mediator);\n\n\n  ModuleAdapter.prototype.module = null;\n\n  ModuleAdapter.prototype.mediator = null;\n\n  ModuleAdapter.prototype.initializeNotifier = function(key) {\n    var publications,\n      _this = this;\n    ModuleAdapter.__super__.initializeNotifier.call(this, key);\n    publications = this.module.listNotificationPublications();\n    if (publications != null) {\n      this.mediator = new puremvc.Mediator(this.facade.getModuleName());\n      this.mediator.listNotificationInterests = function() {\n        return publications;\n      };\n      this.mediator.handleNotification = function(notification) {\n        _this.facade.sendNotification(notification.getName(), notification.getBody(), notification.getType());\n      };\n    }\n  };\n\n  ModuleAdapter.prototype.onRegister = function() {\n    if (this.mediator != null) {\n      this.module.registerMediator(this.mediator);\n    }\n  };\n\n  ModuleAdapter.prototype.onRemove = function() {\n    if (this.mediator != null) {\n      this.module.removeMediator(this.mediator);\n    }\n  };\n\n  /**\n   * Overridden so this class may subscribe to all notifications\n   * @return An Array\n   *\n  */\n  ModuleAdapter.prototype.listNotificationInterests = function() {\n    return this.module.listNotificationInterests();\n  };\n\n  /**\n   * Handles notifications of interest to this mediator. Note that\n   * the default declaration is to allow the super to handle the\n   * note. This leaves the base JunctionMediator to handle things\n   * like ACCEPT_INPUT_PIPE and ACCEPT_OUTPUT_PIPE\n   * @param note An INotification\n   *\n  */\n  ModuleAdapter.prototype.handleNotification = function(notification) {\n    this.module.sendNotification(notification.getName(), notification.getBody(), notification.getType());\n  };\n\n  /**\n   * @enum {string}\n   * @const\n   * @private\n  */\n\n  var Notifications = {\n    STARTUP: \"startup\",\n    LOAD: \"load\",\n    PAUSE_REQUEST: \"pauserequest\",\n    TOGGLE_PLAY_PAUSE: \"togglePlayPause\",\n    CHANGE_PLAY_STATE: \"chageplaystate\",\n    PLAY_STATE_CHANGE: \"playstatechange\",\n    MEDIA_ELEMENT_CHANGE: \"mediaelementchange\",\n    HIDDEN_CHANGE: \"hiddenchange\",\n    TOGGLE_FULL_SCREEN: \"toggleFullScreen\",\n    CHANGE_DISPLAY_STATE: \"chageDisplayState\",\n    DISPLAY_STATE_CHANGE: \"displayStateChange\",\n    FULL_SCREEN_CHANGE: \"fullscreenchange\",\n    DISABLE_FULL_SCREEN: \"disableFullScreen\",\n    ENABLE_FULL_SCREEN: \"enableFullScreen\",\n    LANGUAGE_CHANGE: \"languagechange\",\n    TOGGLE_ACTIVE: \"toggleActive\",\n    CHANGE_ACTIVE_STATE: \"changeactivestate\",\n    ACTIVE_STATE_CHANGE: \"activestatechange\",\n    CHANGE_MEDIA: \"changeMedia\",\n    SET_MEDIA: \"setmedia\",\n    MEDIA_VALIDATED: \"mediavalidated\",\n    UPDATE_DATA_BINDINGS: \"updatedatabindings\",\n    CHANGE_VOLUME: \"changevolume\",\n    CHANGE_MUTED: \"changemuted\",\n    TOGGLE_MUTED: \"togglemuted\",\n    SEEK: \"seek\",\n    CHANGE_DURATION: \"changeduration\",\n    CHANGE_AUTOPLAY: \"changeAutoplay\",\n    CHANGE_LOOP: \"changeLoop\",\n    PLAYBACK_CORE_CHANGE: \"playbackCoreChange\",\n    START: \"start\",\n    END: \"end\",\n    REPLAY: \"replay\",\n    REGISTER_PLUGIN: \"registerPlugin\",\n    REGISTER_PLUGINS: \"registerPlugins\",\n    PLUGIN_REGISTERED: \"pluginRegistered\",\n    ADD_LAYER: \"addLayer\",\n    REMOVE_LAYER: \"removeLayer\",\n    ADD_OVERLAY: \"addOverlay\",\n    REMOVE_OVERLAY: \"removeOverlay\",\n    ADD_CONTROL: \"addControl\",\n    REMOVE_CONTROL: \"removeControl\",\n    ADD_CONTROL_STATE: \"addControlState\",\n    REMOVE_CONTROL_STATE: \"removeControlState\",\n    ADD_APPLICATION_STATE: \"addApplicationState\",\n    REMOVE_APPLICATION_STATE: \"removeApplicationState\",\n    DISPATCH_EVENT: \"dispatchEvent\",\n    CHANGE_PARAMS: \"changeParams\",\n    ADD_CUE_POINTS: \"addCuePoints\",\n    REMOVE_CUE_POINTS: \"removeCuePoints\",\n    INITIALIZED: \"initialized\",\n    REGISTER_PLAYBACK_CORE: \"registerPlaybackCore\",\n    REMOVE_PLAYBACK_CORE: \"removePlaybackCore\",\n    DISPLAY_TIME: \"displaytime\",\n    IS_USER_ACTIVE: \"isUserActive\",\n    CHANGE_PLAYBACK_TARGET: \"changeplaybacktarget\",\n    LOCK: \"lock\",\n    FRAGMENT_LOAD_START: \"fragmentloadstart\",\n    FRAGMENT_LOADED: \"fragmentloaded\",\n    BITRATE_SWITCH: \"bitrateswitch\",\n    LOADED_METADATA: \"loadedmetadata\",\n    READY: \"ready\",\n    ERROR: \"error\",\n    ENDED: \"ended\",\n    STARTED: \"started\",\n    DURATION_CHANGE: \"durationchange\",\n    SEEKING: \"seeking\",\n    SEEKED: \"seeked\",\n    TIME_UPDATE: \"timeupdate\",\n    LOAD_START: \"loadstart\",\n    LOADED_DATA: \"loadeddata\",\n    CAN_PLAY: \"canplay\",\n    CAN_PLAY_THROUGH: \"canplaythrough\",\n    PROGRESS: \"progress\",\n    MEDIA_CHANGE: \"mediachange\",\n    WAITING: \"waiting\",\n    STALLED: \"stalled\",\n    PLAY: \"play\",\n    PLAYING: \"playing\",\n    PAUSE: \"pause\",\n    PAUSED: \"paused\",\n    PLAY_REQUEST: \"playrequest\",\n    MEDIUM_CHANGE: \"mediumchange\",\n    TEMPORAL_TYPE_CHANGE: \"temporaltypechange\",\n    VOLUME_CHANGE: \"volumechange\",\n    FAIL_OVER_ATTEMPT: \"failoverattempt\",\n    PLAYBACK_TARGET_CHANGE: \"playbacktargetchange\",\n    PLAYBACK_TARGET_AVAILABLE: \"playbacktargetavailable\",\n    RECORD_CONTENT_CHANGE: \"recordcontentchange\",\n    IS_LIVE: \"islive\",\n    CHANGE_CONTENT: \"changecontent\",\n    CONTENT_CHANGED: \"contentchanged\",\n    ENABLE_VIDEO_EVENTS: \"enablevideoevents\",\n    DISABLE_VIDEO_EVENTS: \"disablevideoevents\",\n    MEDIA_SEQUENCE_STARTED: \"mediasequencestarted\",\n    MEDIA_SEQUENCE_ENDED: \"mediasequenceended\",\n    TIMED_METADATA: \"timedmetadata\",\n    VIEW_CREATED: \"viewcreated\",\n    HAS_POST_CONTENT: \"haspostcontent\"\n  };\n\n  /**\n   * @constructor\n  */\n  function DataBinding() {}\n\n  /**\n   * @private\n   * @type {RegExp}\n   * @const\n  */\n  DataBinding.SINGLE = /^\\s*#{([^#{}]+)}\\s*$/;\n\n  /**\n   * @private\n   * @type {RegExp}\n   * @const\n  */\n  DataBinding.TOKEN = /#{([^#}]*)}/g;\n\n  /**\n   * @private\n   * @type {string}\n   * @const\n  */\n  DataBinding.RETURN = \"return \";\n\n  /**\n   * @private\n   * @type {string}\n   * @const\n  */\n  DataBinding.EVENT = \"event\";\n\n  /**\n   * @private\n   * @type {string}\n   * @const\n  */\n  DataBinding.ELEMENT = \"element\";\n\n  /**\n   * @private\n   * @type {string}\n   * @const\n  */\n  DataBinding.PATHS = \"paths\";\n\n  /**\n   * Evaluate a data bound string.\n   *\n   * @param {string} binding\n   *   The data bound string.\n   *\n   * @param {?Object} context\n   *   The context object used as \"global\" when evaluating the binding.\n   *\n   * @param {?Object} event\n   *   An optional event object to expose to the binding.\n   *\n   * @return {string}\n   *   The evaluated result\n  */\n  DataBinding[\"eval\"] = function(binding, context, event, element, paths) {\n    var result, single, _ref;\n    if (!(binding != null)) {\n      return binding;\n    }\n    single = (_ref = this.SINGLE.exec(binding)) != null ? _ref[1] : null;\n    result = single != null ? this.evalBinding(single, context, event, element, paths) : this.evalString(binding, context, event, element, paths);\n    return result;\n  };\n\n  /**\n   * Evaluate a data bound string.\n   *\n   * @param {string} binding\n   *   The data bound string.\n   *\n   * @param {?Object} context\n   *   The context object used as \"global\" when evaluating the binding.\n   *\n   * @param {?Object} event\n   *   An optional event object to expose to the binding.\n   *\n   * @return {string}\n   *   The evaluated result\n   *\n   * @private\n  */\n  DataBinding.evalString = function(binding, context, event, element, paths) {\n    return binding.replace(this.TOKEN, this.replaceBinding.bind(this, context, event, element, paths));\n  };\n\n  /**\n   * @private\n  */\n  DataBinding.replaceBinding = function(context, event, element, paths, match, token, offset, string) {\n    return this.evalBinding(token, context, event, element, paths);\n  };\n\n  /**\n   * Evaluate a data bound string.\n   *\n   * @param {string} binding\n   *   The data bound string.\n   *\n   * @param {?Object} context\n   *   The context object used as \"this\" when evaluating the binding.\n   *\n   * @param {?Object} event\n   *   An optional event object to expose to the binding.\n   *\n   * @return {string}\n   *   The evaluated result\n   *\n   * @private\n  */\n  DataBinding.evalBinding = function(binding, context, event, element, paths) {\n    var result;\n    try {\n      result = this.exec(binding, context, event, element, paths);\n    } catch (error) {\n      result = '#{' + binding + '}';\n    }\n    return result;\n  };\n\n  /**\n   * Execute a data binding.\n   *\n   * @param {string} binding\n   *   The data bound string.\n   *\n   * @param {?Object} context\n   *   The context object used as \"this\" when evaluating the binding.\n   *\n   * @param {?Object} event\n   *   An optional event object to expose to the binding.\n   *\n   * @return {string}\n   *   The evaluated result\n   *\n   * @private\n  */\n  DataBinding.exec = function(binding, context, event, element, paths) {\n    return (new Function(this.EVENT, this.ELEMENT, this.PATHS, this.RETURN + binding)).bind(context)(event, element, paths);\n  };\n\n  /**\n   * The EndCommand class.\n   *\n   * @constructor\n   * @private\n   * @extends {puremvc.SimpleCommand}\n  */\n  function DispatchEventCommand() {\n    DispatchEventCommand.__super__.constructor.call(this);\n  }\n\n\n  __extends(DispatchEventCommand, puremvc.SimpleCommand);\n\n\n  /**\n   * Executes the command.\n   *\n   * @param {puremvc.Notification} notification\n   *    The notification.\n   *\n   * @override\n  */\n  DispatchEventCommand.prototype.execute = function(notification) {\n    var event;\n    event = notification.getBody();\n    event.player = this.facade.player || this.facade;\n    this.facade.dispatchEvent(event);\n  };\n\n  /**\n   * The Config class\n   *\n   * @param Object} overrides\n   *    Config overrides\n   *\n   * @constructor\n  */\n  function Config(overrides) {\n    var config, key, value;\n    if (overrides == null) {\n      overrides = {};\n    }\n    config = Utils.override(Config.defaults, overrides);\n    if (/amp\\-debug\\=true/.test(location.search.toLowerCase()) === true) {\n      config.debug = true;\n    }\n    config.mode = Utils.getPlaybackMode(config.mode);\n    config.version = AMP.getVersion();\n    for (key in config) {\n      value = config[key];\n      this[key] = value;\n    }\n  }\n\n  Config.create = function(overrides) {\n    return new Config(overrides);\n  };\n\n  Config.defaults = {\n    paths: {\n      player: \"../amp.premier/\",\n      resources: \"../resources/\"\n    },\n    resources: [\n      {\n        src: '#{paths.player}amp.premier.css',\n        type: \"text/css\"\n      }\n    ],\n    rules: {\n      android_4_gets_m3u8: {\n        regexp: \"Android 4\"\n      }\n    },\n    autoplay: true,\n    playsinline: false,\n    loop: false,\n    target: \"_blank\",\n    domain: \"akamai.com\",\n    fullscreen: {},\n    controls: {},\n    volumepanel: {\n      direction: \"vertical\"\n    },\n    captioning: {},\n    playoverlay: {},\n    hls: {\n      resources: [\n        {\n          type: \"text/javascript\",\n          src: '#{paths.resources}js/hls.min.js',\n          debug: '#{paths.resources}js/hls.js'\n        }\n      ],\n      quality: {\n        startLevel: -1\n      },\n      data: {\n        enableWorker: true,\n        enableSoftwareAES: true\n      }\n    },\n    dash: {\n      resources: [\n        {\n          type: \"text/javascript\",\n          src: \"//cdn.dashjs.org/v2.1.1/dash.all.min.js\",\n          debug: \"//cdn.dashjs.org/v2.1.1/dash.all.debug.js\"\n        }\n      ],\n      buffer: 1\n    },\n    flash: {\n      swf: '#{paths.player}AkamaiPremierPlayer.swf',\n      debug: '#{paths.player}AkamaiPremierPlayer-debug.swf',\n      expressInstallSWF: '#{paths.player}playerProductInstall.swf',\n      \"static\": {\n        enabled: false,\n        swf: '#{paths.player}AkamaiPremierPlayer-static.swf',\n        debug: '#{paths.player}AkamaiPremierPlayer-static-debug.swf'\n      },\n      vars: {\n        core_player_name: \"amp.premier\",\n        mbr_starting_index: 2,\n        use_last_known_bitrate: false,\n        use_netsession_client: false,\n        netsession_install_prompt_frequency_secs: -1,\n        ad_server_timeout: 20,\n        ad_control_enabled: true,\n        dvr_enabled: 1,\n        branding_preload: \"none\",\n        hds_live_low_latency: true,\n        fullscreen_enabled: true,\n        show_feature_bar: false,\n        suppress_events: \"mediaPlayerViewInitialized\",\n        hds_fragment_retry_data_gap_threshold: 20\n      },\n      view: {\n        attributes: {\n          skin: '#{paths.player}premier.assets.swf'\n        },\n        elements: {\n          infoOverlay: {\n            attributes: {\n              style: \"top: 0px;\"\n            }\n          },\n          adOptions: {\n            attributes: {\n              style: \"backgroundColor: 'rgba(0, 0, 0, 1)'\"\n            },\n            elements: {\n              adChoices: {\n                attributes: {\n                  target: \"http://www.akamai.com/\"\n                }\n              },\n              adCountdown: {},\n              adCount: {}\n            }\n          },\n          endSlate: {\n            attributes: {\n              enabled: \"true\",\n              hideElements: \"brandingLogo|viewAll\"\n            }\n          },\n          replayView: {},\n          bufferingView: {}\n        }\n      }\n    },\n    locales: {\n      en: {\n        MSG_TIME_SEPARATOR: \" / \",\n        MSG_EMAIL_TO: \"To\",\n        MSG_EMAIL_FROM: \"From\",\n        MSG_EMAIL_VIDEO: \"Email this video\",\n        MSG_EMAIL_MESSAGE_DEFAULT: \"Check out this video from xxx\",\n        MSG_EMAIL_MESSAGE: \"Message\",\n        MSG_EMAIL_ADDRESS_INVALID: \"Invalid Email Address\",\n        MSG_EMAIL_MESSAGE_INVALID: \"Please limit your message to 500 characters or less.\",\n        MSG_EMAIL_CHARACTERS_REMAINING_TEXT: \" characters left\",\n        MSG_EMAIL_SEND_FAILURE: \"Message could not be sent.\",\n        MSG_EMAIL_SEND_SUCCESS_MESSAGE: \"Your email has been sent!\",\n        MSG_SHARE_VIDEO_TEXT: \"Share this video...\",\n        MSG_POST_TEXT: \"Post\",\n        MSG_EMBED_TEXT: \"Embed\",\n        MSG_LINK_TEXT: \"Link\",\n        MSG_SHARE_CONNECT_FAILURE: \"Unable to connect. Please try again.\",\n        MSG_SHARE_CONTENT_DISABLED: \"Share and embed are disabled.\",\n        MSG_VERSION_TEXT: \"Version\",\n        MSG_BUFFERING_TEXT: \"buffering\",\n        MSG_CUSTOMIZE_CLIP_POINTS: \"Customize the start and end point of the video.\",\n        MSG_PAUSE: \"Pause\",\n        MSG_PREVIEW: \"Preview\",\n        MSG_CURRENT: \"Currrent\",\n        MSG_SEEK_TO: \"Seek to\",\n        MSG_LIVE: \"LIVE\",\n        MSG_DEFAULT_ERROR_MESSAGE: \"Sorry, we were unable to play the media you selected. Please try again, or select alternate media.\",\n        MSG_ERROR_PREFIX: \"Error encountered:\",\n        MSG_STREAM_NOT_FOUND: \"Stream not found\",\n        MSG_CURRENT_WORKING_BANDWIDTH: \"Current working bandwidth\",\n        MSG_CURRENT_BITRATE_PLAYING: \"Current bitrate playing\",\n        MSG_MAX_BITRATE_AVAILABLE: \"Max bitrate available\",\n        MSG_NOT_AVAILABLE: \"Not Available\",\n        MSG_GO_LIVE: \"GO LIVE\",\n        MSG_REPLAY: \"Replay\",\n        MSG_NEXT_VIDEO: \"Video starts in: \",\n        MSG_RECOMMENDED: \"Recommended\",\n        MSG_VIEW_ALL: \"View all \",\n        MSG_VIDEO: \" videos\",\n        MSG_CC: \"CC\",\n        MSG_CC_TITLE: \"Caption\",\n        MSG_CC_LANGUAGE: \"Track :\",\n        MSG_CC_PRESETS: \"Presets :\",\n        MSG_CC_FONT: \"Font :\",\n        MSG_CC_EDGE: \"Edge :\",\n        MSG_CC_SIZE: \"Size :\",\n        MSG_CC_SCROLL: \"Scroll :\",\n        MSG_CC_COLOR: \"Color :\",\n        MSG_CC_BACKGROUND: \"Background :\",\n        MSG_CC_WINDOW: \"Window :\",\n        MSG_CC_OPACITY: \"Opacity :\",\n        MSG_CC_SHOW_ADVANCED: \"Show Advanced Settings\",\n        MSG_CC_HIDE_ADVANCED: \"Hide Advanced Settings\",\n        MSG_NEXT_AD: \"Next ad starts in: \",\n        MSG_CC_RESET: \"Default\",\n        MSG_CC_CANCEL: \"Cancel\",\n        MSG_CC_APPLY: \"Apply\",\n        MSG_CC_PREVIEW_TEXT: \"Lorem ipsum dolor sit amet..\",\n        MSG_EN: \"English\",\n        MSG_ES: \"Spanish\",\n        MSG_DE: \"German\",\n        MSG_FR: \"French\",\n        MSG_IT: \"Italian\",\n        MSG_RU: \"Russian\",\n        MSG_ZH: \"Chinese\",\n        MSG_CHROMECAST_MESSAGE: \"Video playing on another screen\",\n        MSG_RETRY_MESSAGE: \"Content not yet available, retrying in\",\n        MSG_SECONDS: \"seconds\",\n        MSG_RETRY_FAILED: \"Retry failed\",\n        MSG_RECOMMENDATIONS_TITLE: \"Recommended\",\n        MSG_VIEWER_ID: \"Viewer ID: \"\n      },\n      es: {\n        MSG_TIME_SEPARATOR: \" / \",\n        MSG_EMAIL_TO: \"a\",\n        MSG_EMAIL_FROM: \"de\",\n        MSG_EMAIL_VIDEO: \"Enviar este vídeo\",\n        MSG_EMAIL_MESSAGE_DEFAULT: \"Echa un vistazo a este video de xxx\",\n        MSG_EMAIL_MESSAGE: \"mensaje\",\n        MSG_EMAIL_ADDRESS_INVALID: \"Dirección de correo electrónico no válida\",\n        MSG_EMAIL_MESSAGE_INVALID: \"Por favor limite su mensaje a 500 caracteres o menos.\",\n        MSG_EMAIL_CHARACTERS_REMAINING_TEXT: \"personajes de la izquierda\",\n        MSG_EMAIL_SEND_FAILURE: \"El mensaje no pudo ser enviado.\",\n        MSG_EMAIL_SEND_SUCCESS_MESSAGE: \"Tu email ha sido enviado!\",\n        MSG_SHARE_VIDEO_TEXT: \"Comparte este vídeo...\",\n        MSG_POST_TEXT: \"enviar\",\n        MSG_EMBED_TEXT: \"incrustar\",\n        MSG_LINK_TEXT: \"enlace\",\n        MSG_SHARE_CONNECT_FAILURE: \"No se puede conectar. Por favor, inténtelo de nuevo.\",\n        MSG_SHARE_CONTENT_DISABLED: \"Compartir e incrustar están desactivados.\",\n        MSG_VERSION_TEXT: \"versión\",\n        MSG_BUFFERING_TEXT: \"el almacenamiento en búfer\",\n        MSG_CUSTOMIZE_CLIP_POINTS: \"Personalizar el inicio y el punto final del video.\",\n        MSG_PAUSE: \"romper\",\n        MSG_PREVIEW: \"vista previa\",\n        MSG_CURRENT: \"corriente\",\n        MSG_SEEK_TO: \"Tratar de\",\n        MSG_LIVE: \"EN VIVO\",\n        MSG_DEFAULT_ERROR_MESSAGE: \"Lo sentimos, no hemos podido jugar los medios de comunicación seleccionados. Por favor, inténtelo de nuevo, o seleccionar los medios de comunicación alternativos.\",\n        MSG_ERROR_PREFIX: \"Se produjo un error:\",\n        MSG_STREAM_NOT_FOUND: \"Stream que no se encuentra\",\n        MSG_CURRENT_WORKING_BANDWIDTH: \"Ancho de banda actual de trabajo\",\n        MSG_CURRENT_BITRATE_PLAYING: \"Tasa de bits de reproducción actual\",\n        MSG_MAX_BITRATE_AVAILABLE: \"Tasa de bits máxima disponible\",\n        MSG_NOT_AVAILABLE: \"No está disponible\",\n        MSG_GO_LIVE: \"IR A VIVIR\",\n        MSG_REPLAY: \"Repetir\",\n        MSG_NEXT_VIDEO: \"El próximo video comienza en: \",\n        MSG_RECOMMENDED: \"Recomendado\",\n        MSG_CC: \"CC\",\n        MSG_VIEW_ALL: \"ver todo \",\n        MSG_VIDEO: \" vídeos.\",\n        MSG_EN: \"Inglés\",\n        MSG_ES: \"Español\",\n        MSG_DE: \"Alemán\",\n        MSG_FR: \"Francés\",\n        MSG_IT: \"Italiano\",\n        MSG_RU: \"Ruso\",\n        MSG_ZH: \"Chino\",\n        MSG_RETRY_MESSAGE: \"Content not yet available, retrying in\",\n        MSG_SECONDS: \"seconds\",\n        MSG_RETRY_FAILED: \"Retry failed\",\n        MSG_RECOMMENDATIONS_TITLE: \"Recomendado\",\n        MSG_VIEWER_ID: \"Viewer ID: \"\n      }\n    }\n  };\n\n  function ITokenized() {}\n\n  /**\n   * The tokenized data structure\n  */\n  ITokenized.prototype.data = null;\n\n  /**\n   * The literal value after compiliation\n  */\n  ITokenized.prototype.value = null;\n\n  /**\n   * The original data structure\n  */\n  ITokenized.prototype.source = null;\n\n  /**\n   *\n  */\n  ITokenized.prototype.parse = function(data) {};\n\n  /**\n   * Compiles the tokenized values in the data property\n   * and saves them to the value property. As a convenience\n   * this function returns the value property.\n   *\n   * @param context         An object who's properties can be called from within a token\n   * @param suppressErrors  Flag indicating wether or not to suppress errors. Useful when certain context items are known not to exist.\n   * @return                The compile value object.\n  */\n  ITokenized.prototype.compile = function(context, suppressErrors) {\n    if (context == null) {\n      context = {};\n    }\n    if (suppressErrors == null) {\n      suppressErrors = false;\n    }\n  };\n\n  /**\n   * @constructor\n   * @private\n   * @extends {ITokenized}\n   * @param {string} source\n  */\n  function TokenizedBase(source) {\n    if (source != null) {\n      this.parse(source);\n    }\n  }\n\n\n  __extends(TokenizedBase, ITokenized);\n\n\n  /**\n   * The tokenized data structure\n  */\n  TokenizedBase.prototype.data = null;\n\n  /**\n   * The literal value after compiliation\n  */\n  TokenizedBase.prototype.value = null;\n\n  /**\n   * The original data structure\n  */\n  TokenizedBase.prototype.source = null;\n\n  /**\n   * Populates the data property with tokenized values\n   *\n   * @param   {Array.<Object>|Object|string|number|boolean} source  The tokenized data structure.\n   * @return  {Object} The parsed data structure.\n  */\n  TokenizedBase.prototype.parse = function(source) {\n    var value;\n    if (source instanceof Array) {\n      value = new TokenizedArray(source);\n    } else if (source instanceof Object) {\n      value = new TokenizedObject(source);\n    } else {\n      value = new TokenizedValue(source);\n    }\n    return value;\n  };\n\n  /**\n   * @enum {string}\n   * @const\n   * @private\n  */\n\n  var SecurityNotifications = {\n    AUTHORIZATION_FAILED: \"authorizationfailed\",\n    AUTHORIZE: \"authorize\",\n    AUTHORIZED: \"authorized\"\n  };\n\n  /**\n   * Binds an event(s) to a handler function.\n   *\n   * @param {IEventDispatcher}    target  The event target\n   * @param {string|Array|number} type    The event to listen for\n   * @param {Function}            handler The handler function to call when the event is dispatched.\n   * @constructor\n   * @private\n  */\n  function EventHandler(target, type, handler) {\n    var _ref;\n    this.target = target;\n    this.type = type;\n    this.handler = handler;\n    this.trigger = __bind(this.trigger, this);\n\n    EventHandler.instances.push(this);\n    this.types = [];\n    if (_ref = this.type, __indexOf.call(EventHandler.EVENTS, _ref) >= 0) {\n      if (Utils.isTouchDevice()) {\n        this.types.push(EventHandler.TOUCH_EVENTS[this.type]);\n        if (this.type === EventHandler.TOUCH_EVENTS[1]) {\n          this.types.push(EventHandler.TOUCH_EVENTS[4]);\n        }\n      } else {\n        this.types.push(EventHandler.MOUSE_EVENTS[this.type]);\n      }\n    } else if (this.type instanceof Array) {\n      this.types = this.type;\n    } else {\n      this.types.push(this.type);\n    }\n    this.bind();\n  }\n\n  /**\n   * Represents the press user interaction\n   *\n   * @type {number}\n   * @static\n   * @const\n  */\n  EventHandler.PRESS = 0;\n\n  /**\n   * Represents the release user interaction\n   *\n   * @type {number}\n   * @static\n   * @const\n  */\n  EventHandler.RELEASE = 1;\n\n  /**\n   * Represents the move user interaction\n   *\n   * @type {number}\n   * @static\n   * @const\n  */\n  EventHandler.MOVE = 2;\n\n  /**\n   * Represents the click user interaction\n   *\n   * @type {number}\n   * @static\n   * @const\n  */\n  EventHandler.CLICK = 3;\n\n  /**\n   * Represents the right click (contextMenu) user interaction\n   *\n   * @type {number}\n   * @static\n   * @const\n  */\n  EventHandler.CONTEXTMENU = 4;\n\n  /**\n   * Represents the mouse over user interaction\n   *\n   * @type {number}\n   * @static\n   * @const\n  */\n  EventHandler.HOVER = 5;\n\n  /**\n   * Represents the mouse out user interaction\n   *\n   * @type {number}\n   * @static\n   * @const\n  */\n  EventHandler.HOVEROUT = 6;\n\n  /**\n   * The list of user interactions\n   *\n   * @type {Array.<number>}\n   * @static\n   * @const\n  */\n  EventHandler.EVENTS = [EventHandler.PRESS, EventHandler.RELEASE, EventHandler.MOVE, EventHandler.CLICK, EventHandler.CONTEXTMENU, EventHandler.HOVER, EventHandler.HOVEROUT];\n\n  /**\n   * The list of mouse interactions\n   *\n   * @type {Array.<string>}\n   * @static\n   * @const\n  */\n  EventHandler.MOUSE_EVENTS = [\"mousedown\", \"mouseup\", \"mousemove\", \"click\", \"contextmenu\", \"mouseover\", \"mouseout\"];\n\n  /**\n   * The list of touch interactions\n   *\n   * @type {Array.<string>}\n   * @static\n   * @const\n  */\n  EventHandler.TOUCH_EVENTS = [\"touchstart\", \"touchend\", \"touchmove\", \"click\", \"touchcancel\"];\n\n  /**\n   * An array of EventHandler instances.\n   *\n   * @type {Array.<EventHandler>}\n   * @static\n  */\n  EventHandler.instances = [];\n\n  /**\n   * Creates an EventHandler with the parameters provided.\n   *\n   * @param {IEventDispatcher}    target  The event target\n   * @param {string|Array|number} type    The event to listen for\n   * @param {Function}            handler The handler function to call when the event is dispatched.\n   * @static\n   * @return {EventHandler} the new EventHandler\n  */\n  EventHandler.create = function(target, type, handler) {\n    return new EventHandler(target, type, handler);\n  };\n\n  /**\n   * Binds all EventHandlers of the provided target.\n   *\n   * @param {IEventDispatcher} target\n   * @static\n  */\n  EventHandler.bind = function(target, type) {\n    var i, instance, _i, _len, _ref;\n    _ref = EventHandler.instances;\n    for (i = _i = 0, _len = _ref.length; _i < _len; i = ++_i) {\n      instance = _ref[i];\n      if (!(instance.target === target)) {\n        continue;\n      }\n      if ((type != null) && instance.type !== type) {\n        continue;\n      }\n      instance.bind();\n    }\n  };\n\n  /**\n   * Unbinds all EventHandlers of the provided target.\n   *\n   * @param {IEventDispatcher} target\n   * @static\n  */\n  EventHandler.unbind = function(target, type) {\n    var i, instance, _i, _len, _ref;\n    _ref = EventHandler.instances;\n    for (i = _i = 0, _len = _ref.length; _i < _len; i = ++_i) {\n      instance = _ref[i];\n      if (!(instance.target === target)) {\n        continue;\n      }\n      if ((type != null) && instance.type !== type) {\n        continue;\n      }\n      instance.unbind();\n    }\n  };\n\n  /**\n   * Clear all EventHandlers of the provided target.\n   *\n   * @param {IEventDispatcher} target\n   * @static\n  */\n  EventHandler.clear = function(target, type) {\n    var i, instance, _i, _len, _ref;\n    _ref = EventHandler.instances;\n    for (i = _i = 0, _len = _ref.length; _i < _len; i = ++_i) {\n      instance = _ref[i];\n      if (!((instance != null ? instance.target : void 0) === target)) {\n        continue;\n      }\n      if ((type != null) && instance.type !== type) {\n        continue;\n      }\n      instance.clear();\n      EventHandler.instances.splice(i, 1);\n    }\n  };\n\n  /**\n   * The system event types for this EventTarget\n   *\n   * @type {Array.<string>}\n  */\n  EventHandler.prototype.types = null;\n\n  /**\n   * Binds the target to the event\n  */\n  EventHandler.prototype.bind = function() {\n    var type, _i, _len, _ref;\n    _ref = this.types;\n    for (_i = 0, _len = _ref.length; _i < _len; _i++) {\n      type = _ref[_i];\n      if (this.target.addEventListener != null) {\n        this.target.addEventListener(type, this.trigger, false);\n      } else if (this.target.attachEvent != null) {\n        this.target.attachEvent(\"on\" + type, this.trigger);\n      }\n    }\n  };\n\n  /**\n   * Unbinds the target from the event\n  */\n  EventHandler.prototype.unbind = function() {\n    var type, _i, _len, _ref;\n    _ref = this.types;\n    for (_i = 0, _len = _ref.length; _i < _len; _i++) {\n      type = _ref[_i];\n      if (this.target.removeEventListener != null) {\n        this.target.removeEventListener(type, this.trigger);\n      } else if (this.target.attachEvent != null) {\n        this.target.removeEvent(\"on\" + type, this.trigger);\n      }\n    }\n  };\n\n  /**\n   * Clears the EventHandler\n  */\n  EventHandler.prototype.clear = function() {\n    this.unbind();\n    this.target = null;\n    this.handler = null;\n    this.type = null;\n    this.types = null;\n  };\n\n  /**\n   * Triggers the event handler\n  */\n  EventHandler.prototype.trigger = function(event) {\n    this.handler(event);\n  };\n\n  /**\n   * Used to track player configuration settings\n  */\n  /**\n   * Creates a new instance of MediaProxy.\n   *\n   * @constructor\n   * @private\n  */\n  function ConfigurationProxy(config) {\n    this.defaults = Config.defaults;\n    ConfigurationProxy.__super__.constructor.call(this, config);\n  }\n\n\n  __extends(ConfigurationProxy, ModuleProxy);\n\n\n  /** @static\n  */\n  ConfigurationProxy.NAME = ModuleProxy.NAME;\n\n  /**\n   * @override\n  */\n  ConfigurationProxy.prototype.getContextName = function() {\n    return \"paths\";\n  };\n\n  /**\n   * @override\n  */\n  ConfigurationProxy.prototype.getContextData = function() {\n    return this.getPaths();\n  };\n\n  /**\n  */\n  ConfigurationProxy.prototype.onRegister = function() {\n    this.facade.retrieveProxy(DataBindingProxy.NAME).registerContext(this);\n  };\n\n  /**\n   * @override\n  */\n  ConfigurationProxy.prototype.setData = function(value) {\n    if (value.rules != null) {\n      Utils.mergeRules(value.rules);\n    }\n    ConfigurationProxy.__super__.setData.call(this, value);\n    return value;\n  };\n\n  /**\n   * Plays iniline\n  */\n  ConfigurationProxy.prototype.getPlaysInLine = function() {\n    return this.data.playsinline;\n  };\n\n  /**\n   * Auto play.\n  */\n  ConfigurationProxy.prototype.getAutoplay = function() {\n    return this.data.autoplay;\n  };\n\n  ConfigurationProxy.prototype.setAutoplay = function(value) {\n    this.data.autoplay = value;\n    return value;\n  };\n\n  /**\n   * Auto play.\n  */\n  ConfigurationProxy.prototype.getLoop = function() {\n    return this.data.loop;\n  };\n\n  ConfigurationProxy.prototype.setLoop = function(value) {\n    this.data.loop = value;\n    return value;\n  };\n\n  /**\n   * End Slate.\n  */\n  ConfigurationProxy.prototype.getEndSlate = function() {\n    return this.data.endslate;\n  };\n\n  ConfigurationProxy.prototype.setEndSlate = function(value) {\n    this.data.endslate = value;\n    return value;\n  };\n\n  /**\n   * Domain\n  */\n  ConfigurationProxy.prototype.getDomain = function() {\n    return this.data.domain;\n  };\n\n  ConfigurationProxy.prototype.setDomain = function(value) {\n    this.data.domain = value;\n    return value;\n  };\n\n  /**\n   * Target.\n  */\n  ConfigurationProxy.prototype.getTarget = function() {\n    return this.data.target;\n  };\n\n  ConfigurationProxy.prototype.setTarget = function(value) {\n    this.data.target = value;\n    return value;\n  };\n\n  /**\n   * The player name.\n  */\n  ConfigurationProxy.prototype.getName = function() {\n    return this.data.name;\n  };\n\n  ConfigurationProxy.prototype.setName = function(value) {\n    this.data.name = value;\n    return value;\n  };\n\n  /**\n   * The player paths.\n  */\n  ConfigurationProxy.prototype.getPaths = function() {\n    return this.data.paths;\n  };\n\n  ConfigurationProxy.prototype.setPaths = function(value) {\n    this.data.paths = value;\n    return value;\n  };\n\n  /**\n   * The player version.\n  */\n  ConfigurationProxy.prototype.getVersion = function() {\n    return this.data.version;\n  };\n\n  /**\n   * Controls\n  */\n  ConfigurationProxy.prototype.getControls = function() {\n    return this.data.controls;\n  };\n\n  ConfigurationProxy.prototype.setControls = function(value) {\n    this.data.controls = value;\n    return value;\n  };\n\n  /**\n   * Fullscreen configuration\n  */\n  ConfigurationProxy.prototype.getFullscreen = function() {\n    return this.data.fullscreen || {};\n  };\n\n  ConfigurationProxy.prototype.setFullscreen = function(value) {\n    this.data.fullscreen = value;\n    return value;\n  };\n\n  /**\n   * AudioPlaybackProxy constructor.\n   *\n   * @constructor\n   * @private\n   * @extends {PlaybackCoreProxy}\n  */\n  function AudioPlaybackProxy() {\n    AudioPlaybackProxy.__super__.constructor.call(this);\n  }\n\n\n  __extends(AudioPlaybackProxy, PlaybackCoreProxy);\n\n\n  AudioPlaybackProxy.prototype.playbackCoreName = \"audio\";\n\n  /** @override\n  */\n  AudioPlaybackProxy.prototype.onRegister = function() {\n    var mediaElement;\n    mediaElement = new MediaElementMediator(\"html5\", \"audio\");\n    this.sendNotification(Notifications.PLAYBACK_CORE_CHANGE, mediaElement);\n  };\n\n  /** @override\n  */\n  AudioPlaybackProxy.prototype.onRemove = function() {\n    this.facade.createMediaElement();\n  };\n\n  /** @override\n  */\n  AudioPlaybackProxy.prototype.canPlayType = function(mimeType) {\n    if (/audio/.test(mimeType)) {\n      return \"maybe\";\n    }\n    return \"\";\n  };\n\n  /**\n   * @constructor\n   * @private\n   * @extends {TokenizedBase}\n   * @param {Array.<Object>} data\n  */\n  function TokenizedArray(data) {\n    TokenizedArray.__super__.constructor.call(this, data);\n  }\n\n\n  __extends(TokenizedArray, TokenizedBase);\n\n\n  /**\n   *\n  */\n  TokenizedArray.prototype.parse = function(data) {\n    var index, token, _i, _len;\n    this.data = [];\n    for (index = _i = 0, _len = data.length; _i < _len; index = ++_i) {\n      token = data[index];\n      this.data[index] = TokenizedArray.__super__.parse.call(this, token);\n    }\n    return this.data;\n  };\n\n  /**\n   *\n  */\n  TokenizedArray.prototype.compile = function(context, suppressErrors) {\n    var index, token, _i, _len, _ref;\n    if (context == null) {\n      context = {};\n    }\n    if (suppressErrors == null) {\n      suppressErrors = false;\n    }\n    this.value = [];\n    _ref = this.data;\n    for (index = _i = 0, _len = _ref.length; _i < _len; index = ++_i) {\n      token = _ref[index];\n      try {\n        this.value[index] = token.compile(context, suppressErrors);\n      } catch (error) {\n        this.value[index] = null;\n        if (!suppressErrors) {\n          Logger.error(error);\n        }\n      }\n    }\n    return this.value;\n  };\n\n  /**\n   * DVRPlaybackProxy constructor.\n   *\n   * @constructor\n   * @private\n   * @extends {PlaybackCoreProxy}\n  */\n  function DVRPlaybackProxy() {\n    DVRPlaybackProxy.__super__.constructor.call(this);\n  }\n\n\n  __extends(DVRPlaybackProxy, PlaybackCoreProxy);\n\n\n  DVRPlaybackProxy.prototype.playbackCoreName = \"dvr\";\n\n  DVRPlaybackProxy.prototype.interval = null;\n\n  /** @override\n  */\n  DVRPlaybackProxy.prototype.ondurationchange = function(event) {\n    this.updateDuration();\n  };\n\n  /** @override\n  */\n  DVRPlaybackProxy.prototype.ontimeupdate = function(event) {\n    this.updateCurrentTime();\n  };\n\n  /** @override\n  */\n  DVRPlaybackProxy.prototype.onplay = function(event) {\n    this.stopTimer();\n    DVRPlaybackProxy.__super__.onplay.call(this, event);\n  };\n\n  /** @override\n  */\n  DVRPlaybackProxy.prototype.onplaying = function(event) {\n    this.stopTimer();\n    DVRPlaybackProxy.__super__.onplaying.call(this, event);\n  };\n\n  /** @override\n  */\n  DVRPlaybackProxy.prototype.onpause = function(event) {\n    this.startTimer();\n    DVRPlaybackProxy.__super__.onpause.call(this, event);\n  };\n\n  /** @override\n  */\n  DVRPlaybackProxy.prototype.canPlayTemporalType = function(temporalType) {\n    return temporalType === \"dvr\";\n  };\n\n  /** @override\n  */\n  DVRPlaybackProxy.prototype.seek = function(value) {\n    if (value == null) {\n      value = this.data.currentTime;\n    }\n    this.getMediaElement().currentTime = value + this.getMediaElement().seekable.start(0);\n  };\n\n  /**\n  */\n  DVRPlaybackProxy.prototype.updateCurrentTime = function() {\n    var currentTime, seekable;\n    seekable = this.getMediaElement().seekable;\n    if (seekable.length === 0) {\n      return;\n    }\n    currentTime = this.getMediaElement().currentTime;\n    this.data.currentTime = currentTime - seekable.start(0);\n    this.sendNotification(Notifications.TIME_UPDATE, this.data.currentTime);\n    this.mediaProxy.setIsLive(currentTime >= seekable.end(0));\n  };\n\n  /**\n  */\n  DVRPlaybackProxy.prototype.updateDuration = function() {\n    var seekable;\n    seekable = this.getMediaElement().seekable;\n    if (seekable.length === 0) {\n      return;\n    }\n    this.data.duration = seekable.end(0) - seekable.start(0);\n    this.sendNotification(Notifications.CHANGE_DURATION, this.data.duration);\n  };\n\n  /**\n  */\n  DVRPlaybackProxy.prototype.startTimer = function() {\n    this.interval = setInterval(this.updateCurrentTime.bind(this), 1000);\n  };\n\n  /**\n  */\n  DVRPlaybackProxy.prototype.stopTimer = function() {\n    if (this.interval != null) {\n      clearInterval(this.interval);\n      this.interval = null;\n      this.updateCurrentTime();\n    }\n  };\n\n  /**\n   * Creates a new instance of Context.\n   *\n   * @constructor\n   * @private\n   * @extends {puremvc.Proxy}\n   * @implements {IDataBindingContext}\n  */\n  function DataBindingContext() {\n    DataBindingContext.__super__.constructor.call(this);\n    if (this.contextName == null) {\n      this.contextName = this.constructor.NAME;\n    }\n  }\n\n\n  __extends(DataBindingContext, puremvc.Proxy);\n\n\n  DataBindingContext.prototype.contextName = null;\n\n  DataBindingContext.prototype.contextData = null;\n\n  /**\n  */\n  DataBindingContext.prototype.onRegister = function() {\n    var base, bindings;\n    if (!(this.getContextName() != null)) {\n      return;\n    }\n    base = this.facade.player || this.facade;\n    bindings = base.retrieveProxy(DataBindingProxy.NAME);\n    bindings.registerContext(this);\n  };\n\n  /**\n  */\n  DataBindingContext.prototype.getContextName = function() {\n    return this.contextName;\n  };\n\n  /**\n  */\n  DataBindingContext.prototype.getContextData = function() {\n    return this.contextData;\n  };\n\n  /**\n   * Creates a new instance of PlayerProxy.\n   *\n   * @constructor\n   * @private\n   * @extends {DataBindingContext}\n  */\n  function PlayerProxy(defaultPlaybackCore, getPlaybackOrder) {\n    this.defaultPlaybackCore = defaultPlaybackCore;\n    this.getPlaybackOrder = getPlaybackOrder;\n    PlayerProxy.__super__.constructor.call(this);\n    this.playbackCoreMap = [];\n  }\n\n\n  __extends(PlayerProxy, DataBindingContext);\n\n\n  /** @static\n  */\n  PlayerProxy.NAME = \"PlayerProxy\";\n\n  PlayerProxy.prototype.contextName = \"player\";\n\n  PlayerProxy.prototype.getPlaybackOrder = null;\n\n  PlayerProxy.prototype.playbackCoreMap = null;\n\n  PlayerProxy.prototype.defaultPlaybackCore = null;\n\n  PlayerProxy.prototype.activePlaybackCore = null;\n\n  /**\n  */\n  PlayerProxy.prototype.onRegister = function() {\n    PlayerProxy.__super__.onRegister.call(this);\n    this.registerPlaybackCore(new DVRPlaybackProxy());\n    this.registerPlaybackCore(this.defaultPlaybackCore);\n    this.registerPlaybackCore(new AudioPlaybackProxy());\n    this.activePlaybackCore = this.defaultPlaybackCore;\n  };\n\n  PlayerProxy.prototype.ready = function() {\n    var order,\n      _this = this;\n    order = typeof this.getPlaybackOrder === \"function\" ? this.getPlaybackOrder(this.playbackCoreMap.map(function(core) {\n      return core.getPlaybackCoreName();\n    })) : void 0;\n    if (!(order != null)) {\n      return;\n    }\n    this.playbackCoreMap = this.playbackCoreMap.sort(function(a, b) {\n      a = order.indexOf(a.getPlaybackCoreName());\n      b = order.indexOf(b.getPlaybackCoreName());\n      if (a === b) {\n        return 0;\n      }\n      if (a === -1 && b !== -1) {\n        return 1;\n      }\n      if (a !== -1 && b === -1) {\n        return -1;\n      }\n      return a - b;\n    });\n  };\n\n  /**\n  */\n  PlayerProxy.prototype.getActivePlaybackCore = function() {\n    return this.activePlaybackCore;\n  };\n\n  /**\n  */\n  PlayerProxy.prototype.registerPlaybackCore = function(core) {\n    var name,\n      _this = this;\n    name = core.getPlaybackCoreName();\n    if (!(core != null) || this.playbackCoreMap.some(function(item) {\n      return item.getPlaybackCoreName() === name;\n    })) {\n      return;\n    }\n    this.playbackCoreMap.push(core);\n  };\n\n  /**\n  */\n  PlayerProxy.prototype.retrievePlaybackCore = function(name) {\n    var core, _i, _len, _ref;\n    _ref = this.playbackCoreMap;\n    for (_i = 0, _len = _ref.length; _i < _len; _i++) {\n      core = _ref[_i];\n      if (core.getPlaybackCoreName() === name) {\n        return core;\n      }\n    }\n  };\n\n  /**\n  */\n  PlayerProxy.prototype.removePlaybackCore = function(name) {\n    var core, index;\n    core = this.retrievePlaybackCore(name);\n    if (!(core != null)) {\n      return null;\n    }\n    index = this.playbackCoreMap.indexOf(core);\n    this.playbackCoreMap.splice(index, 1);\n    return core;\n  };\n\n  /**\n  */\n  PlayerProxy.prototype.setPlaybackCore = function(media) {\n    var core, playbackCore, playbackProxy, _i, _len, _ref;\n    _ref = this.playbackCoreMap;\n    for (_i = 0, _len = _ref.length; _i < _len; _i++) {\n      core = _ref[_i];\n      if (core.canPlayTemporalType(media.temporalType) === true && core.canPlayType(media.type) !== \"\") {\n        playbackCore = core;\n        break;\n      }\n    }\n    playbackProxy = this.facade.retrieveProxy(PlaybackProxy.NAME);\n    if (playbackProxy !== playbackCore) {\n      if (typeof playbackProxy.destroy === \"function\") {\n        playbackProxy.destroy();\n      }\n      this.facade.removeProxy(PlaybackProxy.NAME);\n      this.facade.registerProxy(playbackCore);\n      playbackCore.setData(playbackProxy.getData());\n    }\n    this.activePlaybackCore = playbackCore;\n    return media;\n  };\n\n  /**\n  */\n  PlayerProxy.prototype.canPlayType = function(type) {\n    var canPlay, core, _i, _len, _ref;\n    _ref = this.playbackCoreMap;\n    for (_i = 0, _len = _ref.length; _i < _len; _i++) {\n      core = _ref[_i];\n      canPlay = core.canPlayType(type);\n      if (canPlay !== \"\") {\n        return canPlay;\n      }\n    }\n    return \"\";\n  };\n\n  /**\n   * Gets the context data for this proxy.\n   *\n   * @returns {Object} The contenxt data for this proxy\n   * @override\n  */\n  PlayerProxy.prototype.getContextData = function() {\n    var configProxy, element, mediaProxy, playbackProxy;\n    configProxy = this.facade.retrieveProxy(ConfigurationProxy.NAME);\n    playbackProxy = this.facade.retrieveProxy(PlaybackProxy.NAME);\n    mediaProxy = this.facade.retrieveProxy(MediaProxy.NAME);\n    element = this.facade.getViewComponent();\n    return {\n      width: element.offsetWidth,\n      height: element.offsetHeight,\n      mode: \"html5\",\n      autoplay: configProxy.getAutoplay(),\n      domain: configProxy.getDomain(),\n      name: configProxy.getName(),\n      currentTime: playbackProxy.getCurrentTime(),\n      duration: playbackProxy.getDuration(),\n      version: configProxy.getVersion(),\n      timecode: {\n        duration: Utils.formatTimecode(mediaProxy.getDuration()),\n        currentTime: Utils.formatTimecode(playbackProxy.getCurrentTime())\n      }\n    };\n  };\n\n  /**\n   * Creates a new instance of MediaProxy. Used to track metadata associated with the video such as src, title and duration.\n   *\n   * @constructor\n   * @private\n   * @extends {DataBindingContext}\n  */\n  function MediaProxy() {\n    this.data = {\n      metadata: {}\n    };\n    MediaProxy.__super__.constructor.call(this);\n  }\n\n\n  __extends(MediaProxy, DataBindingContext);\n\n\n  /** @static\n  */\n  MediaProxy.NAME = \"MediaProxy\";\n\n  MediaProxy.prototype.contextName = \"media\";\n\n  /** @private\n  */\n  MediaProxy.prototype.data = null;\n\n  MediaProxy.prototype.value = null;\n\n  MediaProxy.prototype.started = false;\n\n  MediaProxy.prototype.authorized = true;\n\n  /**\n   * Gets the context data for this proxy.\n   *\n   * @returns {Object} The contenxt data for this proxy\n   * @override\n  */\n  MediaProxy.prototype.getContextData = function() {\n    return {\n      width: this.getWidth(),\n      height: this.getHeight(),\n      title: this.getTitle(),\n      description: this.getDescription(),\n      src: this.getSrc(),\n      duration: this.getDuration(),\n      guid: this.getGUID(),\n      isLive: this.getIsLive(),\n      metadata: this.getMetadata(),\n      temporalType: this.getTemporalType(),\n      poster: this.getPoster(),\n      category: this.getCategory(),\n      scenes: this.getScenes()\n    };\n  };\n\n  /**\n   * Sets the data for this proxy.\n   *\n   * @param {Object} value\n   *    The new data for this proxy\n   * @override\n  */\n  MediaProxy.prototype.setData = function(value) {\n    this.value = value;\n    this.started = false;\n    this.data.autoplay = value.autoplay;\n    this.data.type = value.type;\n    this.setIsLive(value.isLive);\n    this.setTemporalType(value.temporalType || \"vod\");\n    if (value.source != null) {\n      this.setSource(value.source);\n    }\n    if (value.src != null) {\n      this.setSrc(value.src);\n    }\n    this.data.title = value.title;\n    if (value.duration != null) {\n      this.setDuration(value.duration);\n    }\n    this.data.poster = value.poster;\n    this.data.guid = value.guid;\n    this.data.link = value.link;\n    this.data.embed = value.embed;\n    this.data.width = value.width;\n    this.data.height = value.height;\n    this.data.category = value.category;\n    this.data.startTime = value.startTime;\n    this.data.description = value.description;\n    this.data.status = value.status || {};\n    this.data.category = value.category;\n    this.data.metadata = value.metadata || {};\n    this.data.authorization = value.authorization;\n    if (value.medium != null) {\n      this.setMedium(value.medium);\n    }\n    this.setPubDate(value.pubDate);\n    this.setTrack(value.track);\n    this.setScenes(value.scenes);\n    this.setKeys(value.keys);\n    return value;\n  };\n\n  MediaProxy.prototype.updateData = function(data) {\n    var key, value;\n    for (key in data) {\n      value = data[key];\n      if (key in this.data) {\n        this.data[key] = value;\n      }\n    }\n  };\n\n  /**\n   * The global unique identifier for this to the video.\n   *\n   * @param {String} value\n   *    The new guid of the video\n   * @returns {String}\n   *    The guid of the video\n   * @type {String}\n  */\n  MediaProxy.prototype.getGUID = function() {\n    return this.data.guid;\n  };\n\n  MediaProxy.prototype.setGUID = function(value) {\n    return this.data.guid = value;\n  };\n\n  MediaProxy.prototype.getLink = function() {\n    return this.data.link;\n  };\n\n  MediaProxy.prototype.setLint = function(value) {\n    return this.data.link = value;\n  };\n\n  MediaProxy.prototype.getStartTime = function() {\n    return this.data.startTime || 0;\n  };\n\n  MediaProxy.prototype.getEmbed = function() {\n    return this.data.embed;\n  };\n\n  MediaProxy.prototype.setEmbed = function(value) {\n    return this.data.embed = value;\n  };\n\n  MediaProxy.prototype.getAutoplay = function() {\n    return this.data.autoplay;\n  };\n\n  MediaProxy.prototype.setAutoplay = function(value) {\n    return this.data.autoplay = value;\n  };\n\n  MediaProxy.prototype.getPubDate = function() {\n    return this.data.pubDate;\n  };\n\n  MediaProxy.prototype.setPubDate = function(value) {\n    return this.data.pubDate = value;\n  };\n\n  MediaProxy.prototype.getCategory = function() {\n    return this.data.category;\n  };\n\n  MediaProxy.prototype.setCategory = function(value) {\n    return this.data.category = value;\n  };\n\n  MediaProxy.prototype.getStatus = function() {\n    return this.data.status;\n  };\n\n  MediaProxy.prototype.setStatus = function(value) {\n    return this.data.status = value;\n  };\n\n  /**\n   * The url to the video.\n   *\n   * @param {String} value\n   *    The new title of the video\n   * @returns {Boolean}\n   *    The title of the video\n   * @type {String}\n  */\n  MediaProxy.prototype.getSrc = function() {\n    return this.facade.security.createURL(this.data.src);\n  };\n\n  MediaProxy.prototype.setSrc = function(value) {\n    this.data.src = value;\n    if ((this.data.src != null) && !(this.data.type != null)) {\n      return this.setType(Utils.getMimeType(this.data.src));\n    }\n  };\n\n  /**\n   * The mimeType of the video.\n  */\n  MediaProxy.prototype.getType = function() {\n    return this.data.type;\n  };\n\n  MediaProxy.prototype.setType = function(value) {\n    var medium;\n    this.data.type = value;\n    medium = /audio/.test(this.data.type) ? \"audio\" : \"video\";\n    return this.setMedium(medium);\n  };\n\n  /**\n   * The medium the video. ie audio, video, executable\n  */\n  MediaProxy.prototype.getMedium = function() {\n    return this.data.medium;\n  };\n\n  MediaProxy.prototype.setMedium = function(value) {\n    if (value === this.data.medium) {\n      return;\n    }\n    this.data.medium = value;\n    return this.facade.retrieveProxy(ApplicationStateProxy.NAME).setMedium(value);\n  };\n\n  /**\n   * Additional information about the vieo\n  */\n  MediaProxy.prototype.getMetadata = function() {\n    return this.data.metadata;\n  };\n\n  MediaProxy.prototype.setMetadata = function(value) {\n    return this.data.metadata = value;\n  };\n\n  /**\n   * The source object of the video.\n  */\n  MediaProxy.prototype.getSource = function() {\n    return this.data.source;\n  };\n\n  MediaProxy.prototype.setSource = function(value) {\n    var item, playerProxy,\n      _this = this;\n    if (!(value != null) || value.length < 1) {\n      return;\n    }\n    this.data.source = value;\n    playerProxy = this.facade.retrieveProxy(PlayerProxy.NAME) || this.facade;\n    if (playerProxy != null) {\n      item = Utils.selectSource(value, function(type) {\n        return playerProxy.canPlayType(type);\n      });\n    }\n    if (((item != null ? item.src : void 0) != null) && item.src !== \"\") {\n      this.setSrc(item.src);\n      return this.setType(item.type);\n    } else {\n      throw new Error(\"No valid source could be found\");\n    }\n  };\n\n  /**\n   * The source object of the video.\n  */\n  MediaProxy.prototype.getTrack = function() {\n    return this.data.track;\n  };\n\n  MediaProxy.prototype.setTrack = function(value) {\n    return this.data.track = value;\n  };\n\n  /**\n   * The title of the video.\n   *\n   * @param {String} value\n   *    The new title of the video\n   * @returns {Boolean}\n   *    The title of the video\n   * @type {String}\n  */\n  MediaProxy.prototype.getTitle = function() {\n    return this.data.title;\n  };\n\n  MediaProxy.prototype.setTitle = function(value) {\n    return this.data.title = value;\n  };\n\n  /**\n   * The native width of the video.\n  */\n  MediaProxy.prototype.getWidth = function() {\n    return this.data.width;\n  };\n\n  MediaProxy.prototype.setWidth = function(value) {\n    return this.data.width = value;\n  };\n\n  /**\n   * The native width of the video.\n  */\n  MediaProxy.prototype.getHeight = function() {\n    return this.data.height;\n  };\n\n  MediaProxy.prototype.setHeight = function(value) {\n    return this.data.height = value;\n  };\n\n  /**\n   * The description of the video.\n   *\n   * @param {String} value\n   *    The new description of the video\n   * @returns {Boolean}\n   *    The description of the video\n   * @type {String}\n  */\n  MediaProxy.prototype.getDescription = function() {\n    return this.data.description;\n  };\n\n  MediaProxy.prototype.setDescription = function(value) {\n    return this.data.description = value;\n  };\n\n  /**\n   *\n  */\n  MediaProxy.prototype.getCategory = function() {\n    return this.data.category;\n  };\n\n  MediaProxy.prototype.setCategory = function(value) {\n    return this.data.category = value;\n  };\n\n  /**\n   * The duration of the video. This property is used in situations where the\n   * duration cannot be determined from the video (i.e. before metadata is loaded)\n   *\n   * @param {Number} value\n   *    The new duration of the video\n   * @returns {Number}\n   *    The duration of the video\n   * @type {Number}\n  */\n  MediaProxy.prototype.getDuration = function(value) {\n    return this.data.duration;\n  };\n\n  MediaProxy.prototype.setDuration = function(value) {\n    var ua;\n    if (value === 0 || this.value.temporalType === \"live\") {\n      return;\n    }\n    ua = navigator.userAgent;\n    if (value === 1 && (/Android/.test(ua) && !/Android.*Chrome/.test(ua))) {\n      return;\n    }\n    if (value !== this.data.duration) {\n      this.data.duration = value;\n      this.sendNotification(Notifications.DURATION_CHANGE, value);\n    }\n    if (value === Infinity) {\n      this.setTemporalType(\"live\");\n    }\n    return value;\n  };\n\n  /**\n   * The poster image for the video.\n   *\n   * @param {String} value\n   *    The url of the new poster image\n   * @returns {String}\n   *    The url of the poster image\n   * @type {String}\n  */\n  MediaProxy.prototype.getPoster = function(value) {\n    return this.data.poster;\n  };\n\n  MediaProxy.prototype.setPoster = function(value) {\n    this.data.poster = value;\n    return value;\n  };\n\n  /**\n   *\n  */\n  MediaProxy.prototype.getIsLive = function() {\n    return this.data.isLive;\n  };\n\n  MediaProxy.prototype.setIsLive = function(value) {\n    var previous;\n    if (value === this.data.isLive) {\n      return;\n    }\n    previous = this.data.isLive;\n    this.data.isLive = value;\n    this.sendNotification(Notifications.IS_LIVE, value);\n    return value;\n  };\n\n  /**\n   *\n  */\n  MediaProxy.prototype.getTemporalType = function() {\n    return this.data.temporalType || \"vod\";\n  };\n\n  MediaProxy.prototype.setTemporalType = function(value) {\n    var previous;\n    if (value === this.data.temporalType) {\n      return;\n    }\n    previous = this.data.temporalType;\n    this.data.temporalType = value;\n    this.sendNotification(Notifications.TEMPORAL_TYPE_CHANGE, {\n      previous: previous,\n      value: value\n    });\n    this.setIsLive(this.data.temporalType === \"live\" || this.data.temporalType === \"dvr\");\n  };\n\n  /**\n   *\n  */\n  MediaProxy.prototype.getScenes = function() {\n    return this.data.scenes;\n  };\n\n  MediaProxy.prototype.setScenes = function(value) {\n    var index, scene, time, _i, _len;\n    if (!(value != null)) {\n      return;\n    }\n    for (index = _i = 0, _len = value.length; _i < _len; index = ++_i) {\n      scene = value[index];\n      scene.start = isNaN(time = Utils.flattenTimecode(scene.sceneStartTime)) ? 0 : time;\n      scene.end = isNaN(time = Utils.flattenTimecode(scene.sceneEndTime)) ? 0 : time;\n      scene.title = scene.sceneTitle || \"\";\n      scene.description = scene.sceneDescription || \"\";\n      scene.position = index + 1;\n    }\n    this.data.scenes = value;\n  };\n\n  /**\n   *\n  */\n  MediaProxy.prototype.getScene = function(currentTime) {\n    var index, scene, _i, _len, _ref;\n    if (!(this.data.scenes != null)) {\n      return;\n    }\n    _ref = this.data.scenes;\n    for (index = _i = 0, _len = _ref.length; _i < _len; index = ++_i) {\n      scene = _ref[index];\n      if ((scene.start <= currentTime && currentTime < scene.end)) {\n        return scene;\n      }\n    }\n  };\n\n  /**\n   *\n  */\n  MediaProxy.prototype.setKeys = function(value) {\n    this.data.keys = value;\n  };\n\n  MediaProxy.prototype.getKeys = function() {\n    return this.data.keys;\n  };\n\n  /**\n   * Creates a new instance of SecurityProxy.\n   *\n   * @constructor\n   * @private\n   * @extends {puremvc.Proxy}\n  */\n  function SecurityProxy() {\n    SecurityProxy.__super__.constructor.call(this, this.constructor.NAME, {});\n    this.setupHDN1();\n  }\n\n\n  __extends(SecurityProxy, puremvc.Proxy);\n\n\n  /** @static\n  */\n  SecurityProxy.NAME = \"SecurityProxy\";\n\n  SecurityProxy.prototype.authorized = true;\n\n  SecurityProxy.prototype.timeout = null;\n\n  /**\n  */\n  SecurityProxy.prototype.setupHDN1 = function() {\n    var _this = this;\n    return window.retrieveToken = function(guid, url) {\n      var token;\n      try {\n        _this.facade.logger.debug(\"[AMP AUTH] HDN1: Token Requested\", guid, url);\n        token = _this.getToken();\n        if (token != null) {\n          _this.facade.getMediaElement().tokenRetrievalSuccess(\"&primaryToken=\" + token);\n        } else {\n          _this.sendNotification(SecurityNotifications.AUTHORIZE);\n        }\n      } catch (error) {\n        _this.facade.logger.error(\"[AMP AUTH ERROR]: Token Retrival Error\", error);\n      }\n      return true;\n    };\n  };\n\n  /**\n  */\n  SecurityProxy.prototype.setMedia = function(media) {\n    this.setSession(null);\n    this.setAuthorized(media.status.state !== \"blocked\");\n    this.setAuthorization(media.authorization);\n  };\n\n  /**\n  */\n  SecurityProxy.prototype.authorize = function(authorization) {\n    this.setAuthorization(authorization);\n    this.sendNotification(SecurityNotifications.AUTHORIZED, authorization);\n  };\n\n  /**\n  */\n  SecurityProxy.prototype.getAuthorization = function() {\n    return this.data;\n  };\n\n  SecurityProxy.prototype.setAuthorization = function(value) {\n    this.data = value || {};\n    if (this.data.expiration != null) {\n      this.setExpiration(this.data.expiration);\n    }\n    return value;\n  };\n\n  /**\n  */\n  SecurityProxy.prototype.getKey = function() {\n    return this.data.key;\n  };\n\n  SecurityProxy.prototype.setKey = function(value) {\n    this.data.key = value;\n    return value;\n  };\n\n  /**\n  */\n  SecurityProxy.prototype.getToken = function() {\n    return this.data.token;\n  };\n\n  SecurityProxy.prototype.setToken = function(value) {\n    this.data.token = value;\n    return value;\n  };\n\n  /**\n  */\n  SecurityProxy.prototype.getExpiration = function() {\n    return this.data.expiration;\n  };\n\n  SecurityProxy.prototype.setExpiration = function(value) {\n    this.data.expiration = value;\n    if (this.data.expiration > Date.now()) {\n      this.startTimeout();\n    }\n    return value;\n  };\n\n  /**\n  */\n  SecurityProxy.prototype.startTimeout = function() {\n    var _this = this;\n    this.timeout = setTimeout(function() {\n      _this.sendNotification(SecurityNotifications.AUTHORIZE, {\n        media: _this.facade.getMedia()\n      });\n    }, this.getExpiration() - Date.now());\n  };\n\n  /**\n  */\n  SecurityProxy.prototype.stopTimeout = function() {\n    clearTimeout(this.timeout);\n  };\n\n  /**\n  */\n  SecurityProxy.prototype.getSecret = function() {\n    var secret;\n    if (!(this.data.token != null)) {\n      return null;\n    }\n    secret = \"\";\n    if (this.data.token != null) {\n      secret = \"\" + this.data.token;\n    }\n    if (this.data.key != null) {\n      secret = \"\" + this.data.key + \"=\" + secret;\n    }\n    return secret;\n  };\n\n  /**\n  */\n  SecurityProxy.prototype.createURL = function(url) {\n    var secret;\n    secret = this.getSecret();\n    if (secret != null) {\n      url += !/\\?/.test(url) ? \"?\" : \"&\";\n      url += secret;\n    }\n    return url;\n  };\n\n  /**\n  */\n  SecurityProxy.prototype.getAuthorized = function() {\n    return this.authorized;\n  };\n\n  SecurityProxy.prototype.setAuthorized = function(value) {\n    this.stopTimeout();\n    this.authorized = value;\n    return value;\n  };\n\n  /**\n  */\n  SecurityProxy.prototype.getSession = function() {\n    return this.session;\n  };\n\n  SecurityProxy.prototype.setSession = function(value) {\n    this.session = value;\n    return value;\n  };\n\n  /**\n   * @constructor\n   * @private\n   * @extends {Error}\n   * @param {string} msg\n  */\n  function TokenizationError(msg) {\n    this.message = TokenizationError.MESSAGE + msg;\n  }\n\n\n  __extends(TokenizationError, Error);\n\n\n  TokenizationError.MESSAGE = \"Tokenization Error: Could not find token value for: \";\n\n  /**\n   * @constructor\n   * @private\n   * @extends {TokenizedBase}\n   * @param {string|number|boolean} source\n  */\n  function Literal(source) {\n    Literal.__super__.constructor.call(this, source);\n  }\n\n\n  __extends(Literal, TokenizedBase);\n\n\n  /**\n   * Populates the data property with tokenized values\n   *\n   * @param   source  The tokenized data structure.\n   * @return          The parsed data structure.\n  */\n  Literal.prototype.parse = function(data) {\n    this.source = this.data = this.value = data;\n    return data;\n  };\n\n  /**\n   * Compiles the tokenized values in the data property\n   * and saves them to the value property. As a convenience\n   * this function returns the value property.\n   *\n   * @param context     An object who's properties can be called from within a token\n   * @param suppressErrors  Flag indicating wether or not to suppress errors. Useful when certain context items are known not to exist.\n   * @return          The compile value object.\n  */\n  Literal.prototype.compile = function(context, suppressErrors) {\n    if (context == null) {\n      context = null;\n    }\n    if (suppressErrors == null) {\n      suppressErrors = false;\n    }\n    return this.value;\n  };\n\n  /**\n   * @constructor\n   * @private\n   * @extends {TokenizedBase}\n   * @param {string} source\n  */\n  function Token(source) {\n    Token.__super__.constructor.call(this, source);\n  }\n\n\n  __extends(Token, TokenizedBase);\n\n\n  /**\n   * The function used to evaluate a token value\n  */\n  Token.prototype.exec = null;\n\n  /**\n   *\n  */\n  Token.prototype.parse = function(source) {\n    this.source = this.data = source;\n    this.exec = new Function(\"context\", 'var value; with(context){value = ' + this.data + ';}return value;');\n    return this.data;\n  };\n\n  /**\n   *\n  */\n  Token.prototype.compile = function(context, suppressErrors) {\n    if (context == null) {\n      context = {};\n    }\n    if (suppressErrors == null) {\n      suppressErrors = false;\n    }\n    if (!(this.exec != null)) {\n      return this.value;\n    }\n    try {\n      this.value = this.exec(context);\n    } catch (error) {\n      this.value = null;\n      if (!suppressErrors) {\n        throw new TokenizationError(this.data);\n      }\n    }\n    return this.value;\n  };\n\n  /**\n   * @constructor\n   * @private\n   * @extends {TokenizedBase}\n   * @param {string} source\n  */\n  function TokenizedValue(source) {\n    this.token = new RegExp(this.tokenStart.source + \"([^#]*)\" + this.tokenEnd.source, \"g\");\n    TokenizedValue.__super__.constructor.call(this, source);\n  }\n\n\n  __extends(TokenizedValue, TokenizedBase);\n\n\n  /**\n   * The function used to evaluate a token value\n  */\n  TokenizedValue.prototype.exec = null;\n\n  /**\n   * The literal value after compiliation\n  */\n  TokenizedValue.prototype.tokenStart = /#{/;\n\n  TokenizedValue.prototype.tokenEnd = /}/;\n\n  TokenizedValue.prototype.token = null;\n\n  /**\n   *\n  */\n  TokenizedValue.prototype.parse = function(source) {\n    var piece, pieces, placeholder, spacer, temp, token, tokens, _i, _len;\n    this.source = source;\n    this.data = [];\n    if (this.token.test(this.source)) {\n      tokens = [];\n      placeholder = \"<<>>\";\n      spacer = null;\n      temp = this.source.replace(this.token, function(match, token, offset, string) {\n        tokens.push(token);\n        spacer = placeholder;\n        if ((0 < offset && offset < string.length - match.length)) {\n          spacer += placeholder;\n        }\n        return spacer;\n      });\n      pieces = temp.split(placeholder);\n      token = 0;\n      for (_i = 0, _len = pieces.length; _i < _len; _i++) {\n        piece = pieces[_i];\n        if (piece === \"\" && tokens[token]) {\n          this.data.push(new Token(tokens[token]));\n          token++;\n        } else {\n          if (piece !== \"\") {\n            this.data.push(new Literal(piece));\n          }\n        }\n      }\n      if (this.data.length === 1) {\n        this.data = this.data[0];\n      }\n    } else {\n      this.data = new Literal(source);\n    }\n    return this.data;\n  };\n\n  /**\n   *\n  */\n  TokenizedValue.prototype.compile = function(context, suppressErrors) {\n    var token, _i, _len, _ref;\n    if (context == null) {\n      context = {};\n    }\n    if (suppressErrors == null) {\n      suppressErrors = false;\n    }\n    if (!(this.data != null)) {\n      return this.value;\n    }\n    try {\n      if (this.data instanceof ITokenized) {\n        this.value = this.data.compile(context, suppressErrors);\n      } else {\n        this.value = \"\";\n        _ref = this.data;\n        for (_i = 0, _len = _ref.length; _i < _len; _i++) {\n          token = _ref[_i];\n          this.value += token.compile(context, suppressErrors);\n        }\n      }\n    } catch (error) {\n      this.value = null;\n      if (!suppressErrors) {\n        throw new TokenizationError(this.source);\n      }\n    }\n    return this.value;\n  };\n\n  /**\n   * @constructor\n   * @private\n   * @extends {TokenizedBase}\n   * @param {Object} source\n  */\n  function TokenizedObject(source) {\n    TokenizedObject.__super__.constructor.call(this, source);\n  }\n\n\n  __extends(TokenizedObject, TokenizedBase);\n\n\n  /**\n   *\n  */\n  TokenizedObject.prototype.parse = function(source) {\n    var key, token;\n    this.source = source;\n    this.data = {};\n    for (key in source) {\n      token = source[key];\n      this.data[key] = TokenizedObject.__super__.parse.call(this, token);\n    }\n    return this.data;\n  };\n\n  /**\n   *\n  */\n  TokenizedObject.prototype.compile = function(context, suppressErrors) {\n    var key, value, _ref;\n    if (context == null) {\n      context = {};\n    }\n    if (suppressErrors == null) {\n      suppressErrors = false;\n    }\n    this.value = {};\n    _ref = this.data;\n    for (key in _ref) {\n      value = _ref[key];\n      try {\n        this.value[key] = value.compile(context, suppressErrors);\n      } catch (error) {\n        this.value[key] = null;\n        Logger.error(error);\n      }\n    }\n    return this.value;\n  };\n\n  /**\n   * @enum {string}\n   * @const\n   * @private\n  */\n\n  var DisplayState = {\n    /**\n     * Constant representing the normal display state\n    */\n\n    NORMAL: \"normal\",\n    /**\n     * Constant representing the full screen display state\n    */\n\n    FULL_SCREEN: \"full-screen\"\n  };\n\n  /**\n   * The DataBoundConfigurationProxy class.\n   *\n   * @constructor\n   * @private\n   * @extends {ModuleProxy}\n   * @param {Object} data\n  */\n  function DataBoundConfigurationProxy(data) {\n    DataBoundConfigurationProxy.__super__.constructor.call(this, data);\n  }\n\n\n  __extends(DataBoundConfigurationProxy, ModuleProxy);\n\n\n  /** @static\n  */\n  DataBoundConfigurationProxy.NAME = ModuleProxy.NAME;\n\n  DataBoundConfigurationProxy.prototype.bindings = null;\n\n  DataBoundConfigurationProxy.prototype.configurationName = null;\n\n  DataBoundConfigurationProxy.prototype.configurationData = null;\n\n  DataBoundConfigurationProxy.prototype.contextName = null;\n\n  DataBoundConfigurationProxy.prototype.contextData = null;\n\n  DataBoundConfigurationProxy.prototype.value = null;\n\n  DataBoundConfigurationProxy.prototype.getConfigurationName = function() {\n    return this.configurationName;\n  };\n\n  DataBoundConfigurationProxy.prototype.getConfigurationData = function() {\n    return this.configurationData.value || {};\n  };\n\n  DataBoundConfigurationProxy.prototype.getContextName = function() {\n    return this.contextName;\n  };\n\n  DataBoundConfigurationProxy.prototype.getContextData = function() {\n    return this.contextData;\n  };\n\n  DataBoundConfigurationProxy.prototype.onRegister = function() {\n    var base;\n    base = this.facade.player || this.facade;\n    if (!(this.getConfigurationName() != null)) {\n      this.configurationName = this.facade.moduleName;\n    }\n    this.bindings = base.retrieveProxy(DataBindingProxy.NAME);\n    this.bindings.registerConfiguration(this);\n    if (!(this.getContextName() != null)) {\n      return;\n    }\n    this.bindings.registerContext(this);\n  };\n\n  DataBoundConfigurationProxy.prototype.setData = function(data) {\n    var key, value, _ref;\n    if (data == null) {\n      data = {};\n    }\n    this.data = {};\n    _ref = this.getDefaults();\n    for (key in _ref) {\n      value = _ref[key];\n      this.data[key] = key in data ? data[key] : value;\n    }\n    this.configurationData = new TokenizedObject(this.data);\n    return this.data;\n  };\n\n  DataBoundConfigurationProxy.prototype.getValue = function(key) {\n    var _ref;\n    this.bindings.update();\n    this.value[key] = (_ref = this.configurationData.data[key]) != null ? _ref.compile(this.bindings.getData()) : void 0;\n    return this.value[key];\n  };\n\n  DataBoundConfigurationProxy.prototype.compile = function(context, suppressErrors) {\n    if (suppressErrors == null) {\n      suppressErrors = false;\n    }\n    if (!(this.configurationData != null)) {\n      return null;\n    }\n    if (!(context != null)) {\n      context = this.bindings.getData();\n    }\n    if ((this.contextName != null) && (this.contextData != null)) {\n      context = Utils.clone(context);\n      context[this.contextName] = this.contextData;\n    }\n    this.configurationData.compile(context, suppressErrors);\n    this.value = this.configurationData.value;\n    return this.configurationData.value;\n  };\n\n  /**\n   * @constructor\n   * @private\n  */\n  function ParamsProxy(data) {\n    ParamsProxy.__super__.constructor.call(this, data);\n  }\n\n\n  __extends(ParamsProxy, DataBoundConfigurationProxy);\n\n\n  /** @static\n  */\n  ParamsProxy.NAME = \"ParamsProxy\";\n\n  ParamsProxy.prototype.defaults = {};\n\n  ParamsProxy.prototype.configurationName = \"params\";\n\n  /** @override\n  */\n  ParamsProxy.prototype.setData = function(data) {\n    var key, value, _ref;\n    this.data = ((_ref = this.configurationData) != null ? _ref.source : void 0) || {};\n    for (key in data) {\n      value = data[key];\n      this.data[key] = data[key];\n    }\n    this.configurationData = new TokenizedObject(this.data);\n    return this.data;\n  };\n\n  /**\n   * @enum {string}\n   * @const\n   * @private\n  */\n\n  var PlayState = {\n    /**\n     * Constant representing the playing play state\n    */\n\n    READY: \"ready\",\n    /**\n     * Constant representing the playing play state\n    */\n\n    PLAYING: \"playing\",\n    /**\n     * Constant representing the paused play state\n    */\n\n    PAUSED: \"paused\",\n    /**\n     * Constant representing the ended play state\n    */\n\n    ENDED: \"ended\",\n    /**\n     * Constant representing the waiting play state\n    */\n\n    LOADING: \"loading\",\n    /**\n     * Constant representing the waiting play state\n    */\n\n    WAITING: \"waiting\",\n    /**\n     * Constant representing the waiting play state\n    */\n\n    ERROR: \"error\"\n  };\n\n  /**\n   * @constructor\n   * @private\n  */\n  function DataBindingProxy() {\n    DataBindingProxy.__super__.constructor.call(this, this.constructor.NAME, {});\n    this.data = {};\n    this.contextMap = {};\n    this.configurationMap = {};\n  }\n\n\n  __extends(DataBindingProxy, puremvc.Proxy);\n\n\n  /** @static\n  */\n  DataBindingProxy.NAME = \"DataBindingProxy\";\n\n  DataBindingProxy.prototype.contextMap = null;\n\n  DataBindingProxy.prototype.configurationMap = null;\n\n  DataBindingProxy.prototype.paramsProxy = null;\n\n  /**\n  */\n  DataBindingProxy.prototype.initialize = function() {\n    this.paramsProxy = this.facade.retrieveProxy(ParamsProxy.NAME);\n    this.update();\n  };\n\n  /**\n  */\n  DataBindingProxy.prototype.registerContext = function(context) {\n    if (!(context != null)) {\n      return;\n    }\n    this.contextMap[context.getContextName()] = context;\n  };\n\n  /**\n  */\n  DataBindingProxy.prototype.retrieveContext = function(name) {\n    return this.contextMap[name];\n  };\n\n  /**\n  */\n  DataBindingProxy.prototype.removeContext = function(name) {\n    var context;\n    context = this.contextMap[name];\n    delete this.contextMap[name];\n    return context;\n  };\n\n  /**\n  */\n  DataBindingProxy.prototype.registerConfiguration = function(config) {\n    if (!(config != null)) {\n      return;\n    }\n    this.configurationMap[config.getConfigurationName()] = config;\n    config.compile(this.context, true);\n  };\n\n  /**\n  */\n  DataBindingProxy.prototype.retrieveConfiguration = function(name) {\n    return this.configurationMap[name];\n  };\n\n  /**\n  */\n  DataBindingProxy.prototype.removeConfiguration = function(name) {\n    var config;\n    config = this.configurationMap[name];\n    delete this.configurationMap[name];\n    return config;\n  };\n\n  /**\n  */\n  DataBindingProxy.prototype.evaluateBinding = function(str) {\n    var tokenizedObject;\n    this.update();\n    tokenizedObject = new TokenizedValue(str);\n    tokenizedObject.compile(this.data);\n    return tokenizedObject.value;\n  };\n\n  /**\n  */\n  DataBindingProxy.prototype.update = function(contexts) {\n    var context, key, name, value, _ref, _ref1;\n    this.data.now = Date.now();\n    _ref = this.contextMap;\n    for (name in _ref) {\n      context = _ref[name];\n      if ((contexts != null ? typeof contexts.indexOf === \"function\" ? contexts.indexOf(name) : void 0 : void 0) === -1) {\n        continue;\n      }\n      this.data[name] = context.getContextData();\n    }\n    this.paramsProxy.compile(this.data);\n    _ref1 = this.paramsProxy.value;\n    for (key in _ref1) {\n      value = _ref1[key];\n      this.data[key] = value;\n    }\n    return this.data;\n  };\n\n  /**\n  */\n  DataBindingProxy.prototype.compile = function(contexts, suppressErrors) {\n    var config, context, name, paramsName, _ref;\n    if (suppressErrors == null) {\n      suppressErrors = false;\n    }\n    this.update(contexts);\n    context = Utils.clone(this.data);\n    paramsName = this.paramsProxy.getConfigurationName();\n    _ref = this.configurationMap;\n    for (name in _ref) {\n      config = _ref[name];\n      if (name !== paramsName) {\n        config.compile(context, suppressErrors);\n      }\n    }\n  };\n\n  /**\n   * @enum {string}\n   * @const\n   * @private\n  */\n\n  var RenderMode = {\n    /**\n     * Constant representing the flash renderer.\n    */\n\n    FLASH: \"flash\",\n    /**\n     * Constant representing the html renderer.\n    */\n\n    HTML: \"html\"\n  };\n\n  /**\n   * @enum {string}\n   * @const\n   * @private\n  */\n\n  var ActiveState = {\n    /**\n     * Constant representing the active state (controls on).\n    */\n\n    ACTIVE: \"active\",\n    /**\n     * Constant representing the inactive state (controls off).\n    */\n\n    INACTIVE: \"inactive\"\n  };\n\n  /**\n   * @enum {string}\n   * @const\n   * @private\n  */\n\n  var PluginNotifications = {\n    REGISTER_PLUGINS: \"registerPlugins\",\n    PLUGIN_REGISTERED: \"pluginRegistered\",\n    PLUGINS_INITIALIZED: \"pluginsinitialized\"\n  };\n\n  /**\n   * Used to track the various states of the player like full screen mode and active state (controls visible).\n   *\n   * @constructor\n   * @private\n   * @extends {puremvc.Proxy}\n  */\n  function ApplicationStateProxy() {\n    ApplicationStateProxy.__super__.constructor.call(this);\n    this.device = Utils.getDevice();\n  }\n\n\n  __extends(ApplicationStateProxy, puremvc.Proxy);\n\n\n  /** @static\n  */\n  ApplicationStateProxy.NAME = \"ApplicationStateProxy\";\n\n  /** @private\n  */\n  ApplicationStateProxy.prototype.displayState = null;\n\n  ApplicationStateProxy.prototype.playState = null;\n\n  ApplicationStateProxy.prototype.renderMode = null;\n\n  ApplicationStateProxy.prototype.activeState = null;\n\n  ApplicationStateProxy.prototype.seeking = false;\n\n  ApplicationStateProxy.prototype.isUserActive = false;\n\n  ApplicationStateProxy.prototype.device = null;\n\n  ApplicationStateProxy.prototype.volume = 1;\n\n  ApplicationStateProxy.prototype.playbackTarget = \"amp\";\n\n  ApplicationStateProxy.prototype.hasPostContent = false;\n\n  ApplicationStateProxy.prototype.locked = false;\n\n  ApplicationStateProxy.prototype.mediaElement = null;\n\n  ApplicationStateProxy.prototype.hidden = false;\n\n  ApplicationStateProxy.prototype.pausedBeforeSeek = false;\n\n  ApplicationStateProxy.prototype.ended = false;\n\n  /**\n   * Flag indicating whether or not the media will have additional\n   * content playback after the media playback is complete\n   *\n   * @param {Boolean} value\n   *    The post content flag\n   * @returns {Boolean}\n   *    The post content flag\n   * @type {Boolean}\n  */\n  ApplicationStateProxy.prototype.getHasPostContent = function() {\n    return this.hasPostContent;\n  };\n\n  ApplicationStateProxy.prototype.setHasPostContent = function(value) {\n    this.hasPostContent = value;\n  };\n\n  /**\n   * Flag indicating whether or not the media playback is complete\n   *\n   * @param {Boolean} value\n   *    The ended flag\n   * @returns {Boolean}\n   *    The ended flag\n   * @type {Boolean}\n  */\n  ApplicationStateProxy.prototype.getEnded = function() {\n    return this.ended;\n  };\n\n  ApplicationStateProxy.prototype.setEnded = function(value) {\n    this.ended = value;\n    if (this.ended === true && this.seeking === true) {\n      this.seeking = false;\n    }\n  };\n\n  /**\n   * The player's display state. Valid options are:\n   *\n   * ApplicationStateProxy.FULL_SCREEN\n   * ApplicationStateProxy.NORMAL\n   *\n   * @param {String} value\n   *    The new display state of the player\n   * @returns {String}\n   *    The display state of the player\n   * @type {String}\n  */\n  ApplicationStateProxy.prototype.getDisplayState = function() {\n    return this.displayState;\n  };\n\n  ApplicationStateProxy.prototype.setDisplayState = function(value) {\n    var previous;\n    if (value === this.displayState) {\n      return;\n    }\n    previous = this.displayState;\n    this.displayState = value;\n    this.sendNotification(Notifications.DISPLAY_STATE_CHANGE, {\n      previous: previous,\n      value: this.displayState\n    });\n  };\n\n  /**\n   * The player's display state. Valid options are:\n   *\n   * ApplicationStateProxy.FULL_SCREEN\n   * ApplicationStateProxy.NORMAL\n   *\n   * @param {String} value\n   *    The new display state of the player\n   * @returns {String}\n   *    The display state of the player\n   * @type {String}\n  */\n  ApplicationStateProxy.prototype.getPlayState = function() {\n    return this.playState;\n  };\n\n  ApplicationStateProxy.prototype.setPlayState = function(value) {\n    var previous,\n      _this = this;\n    if (value === this.playState) {\n      return;\n    }\n    previous = this.playState;\n    this.playState = value;\n    this.sendNotification(Notifications.PLAY_STATE_CHANGE, {\n      previous: previous,\n      value: this.playState\n    });\n    switch (value) {\n      case PlayState.PLAYING:\n        this.sendNotification(Notifications.DISPATCH_EVENT, new Event(\"playing\"));\n        break;\n      case PlayState.WAITING:\n        this.sendNotification(Notifications.DISPATCH_EVENT, new Event(\"waiting\"));\n        if (previous === PlayState.PLAYING) {\n          this.facade.once(\"timeupdate\", function() {\n            _this.sendNotification.bind(_this, Notifications.CHANGE_PLAY_STATE, previous);\n          });\n        }\n        break;\n      case PlayState.ENDED:\n        this.pausedBeforeSeek = false;\n    }\n  };\n\n  /**\n   * The player's device.\n   *\n   *\n   * @returns {String}\n   *    The display state of the player\n   * @type {String}\n  */\n  ApplicationStateProxy.prototype.getDevice = function() {\n    return this.device;\n  };\n\n  /**\n   * Indicates whether or not the player is seeking\n   *\n   * @param {String} value\n   *    The new currentTime value in seconds\n   * @returns {Number}\n   *    The currentTime value in seconds\n   * @type {Number}\n  */\n  ApplicationStateProxy.prototype.getSeeking = function() {\n    return this.seeking;\n  };\n\n  ApplicationStateProxy.prototype.setSeeking = function(value) {\n    if (value !== this.seeking) {\n      this.seeking = value;\n    }\n  };\n\n  /**\n   * Indicates whether or not the player is locked.\n   * A lock player will not autoplay even if configured\n   * to do so.\n   *\n   * @param {Boolean} value\n   *    The locked flag\n   * @returns {Boolean}\n   *    The locked flag\n   * @type {Boolean}\n  */\n  ApplicationStateProxy.prototype.getLocked = function() {\n    return this.locked;\n  };\n\n  ApplicationStateProxy.prototype.setLocked = function(value) {\n    this.locked = value;\n  };\n\n  /**\n   * Indicates whether or not the user is currently interacting with the player\n   *\n   * @param {Boolean} value\n   *\n   * @returns {Boolean}\n   *\n   * @type {Boolean}\n  */\n  ApplicationStateProxy.prototype.getIsUserActive = function() {\n    return this.isUserActive;\n  };\n\n  ApplicationStateProxy.prototype.setIsUserActive = function(value) {\n    if (value !== this.isUserActive) {\n      this.isUserActive = value;\n    }\n  };\n\n  /**\n   * The core type used for rendering the video.\n   *\n   * @param {String} value\n   *    The new currentTime value in seconds\n   * @returns {Number}\n   *    The currentTime value in seconds\n   * @type {Number}\n  */\n  ApplicationStateProxy.prototype.getRenderMode = function() {\n    return this.renderMode;\n  };\n\n  ApplicationStateProxy.prototype.setRenderMode = function(value) {\n    if (value !== this.renderMode) {\n      this.renderMode = value;\n    }\n  };\n\n  /**\n   * The medium the player is currently playing. Valid options are:\n   *\n   * \"audio\"\n   * \"video\"\n   *\n   * @param {String} value\n   *    The new medium\n   *\n   * @returns {String}\n   *    The current medium\n   *\n   * @type {String}\n  */\n  ApplicationStateProxy.prototype.getMedium = function() {\n    return this.medium;\n  };\n\n  ApplicationStateProxy.prototype.setMedium = function(value) {\n    var previous;\n    if (value === this.medium) {\n      return;\n    }\n    previous = this.medium != null ? \"medium-\" + this.medium : this.medium;\n    this.medium = value;\n    this.sendNotification(Notifications.MEDIUM_CHANGE, {\n      previous: previous,\n      value: \"medium-\" + this.medium\n    });\n  };\n\n  /**\n   * The player's volume as a value between 0 and 1.\n   *\n   * @param {Number} value\n   *    The new volume\n   *\n   * @returns {Number}\n   *    The current volume\n   *\n   * @type {Number}\n  */\n  ApplicationStateProxy.prototype.getVolume = function() {\n    return this.volume;\n  };\n\n  ApplicationStateProxy.prototype.setVolume = function(value) {\n    if (value === this.volume) {\n      return;\n    }\n    return this.volume = value;\n  };\n\n  /**\n   * The playback target. i.e. \"amp\", \"chromecast\", \"airplay\"\n   *\n   * @param {Number} value\n   *    The new volume\n   *\n   * @returns {Number}\n   *    The current volume\n   *\n   * @type {Number}\n  */\n  ApplicationStateProxy.prototype.getPlaybackTarget = function() {\n    return this.playbackTarget;\n  };\n\n  ApplicationStateProxy.prototype.setPlaybackTarget = function(value) {\n    var previous;\n    if (value === this.playbackTarget) {\n      return;\n    }\n    previous = this.playbackTarget;\n    this.playbackTarget = value;\n    this.sendNotification(Notifications.PLAYBACK_TARGET_CHANGE, {\n      previous: previous,\n      value: this.playbackTarget\n    });\n  };\n\n  /**\n   * The active state of the player. Used to display controls.\n   *\n   * @param {Boolean} value\n   *    The new active state of the video\n   * @returns {Boolean}\n   *    The active state of the video\n   * @type {Boolean}\n  */\n  ApplicationStateProxy.prototype.getActiveState = function() {\n    return this.activeState;\n  };\n\n  ApplicationStateProxy.prototype.setActiveState = function(value) {\n    var previous;\n    if (value === this.activeState) {\n      return;\n    }\n    previous = this.activeState;\n    this.activeState = value;\n    this.sendNotification(Notifications.ACTIVE_STATE_CHANGE, {\n      previous: previous,\n      value: this.activeState\n    });\n  };\n\n  /**\n   * The player's media element\n   *\n   * @param {HTMLElement} value\n   *    The new media element\n   * @returns {HTMLElement}\n   *    The media element\n   * @type {HTMLElement}\n  */\n  ApplicationStateProxy.prototype.getMediaElement = function() {\n    return this.mediaElement;\n  };\n\n  ApplicationStateProxy.prototype.setMediaElement = function(value) {\n    var previous;\n    if (value === this.mediaElement) {\n      return;\n    }\n    previous = this.mediaElement;\n    this.mediaElement = value;\n    this.sendNotification(Notifications.MEDIA_ELEMENT_CHANGE, {\n      previous: previous,\n      value: this.mediaElement\n    });\n  };\n\n  /**\n   * The player's hidden state\n   *\n   * @param {Boolean} value\n   *    The new hidden state\n   * @returns {Boolean}\n   *    The hidden state\n   * @type {Boolean}\n  */\n  ApplicationStateProxy.prototype.getHidden = function() {\n    return this.hidden;\n  };\n\n  ApplicationStateProxy.prototype.setHidden = function(value) {\n    var previous;\n    if (value === this.hidden) {\n      return;\n    }\n    previous = this.hidden;\n    this.hidden = value;\n    this.sendNotification(Notifications.HIDDEN_CHANGE, {\n      previous: previous,\n      value: this.hidden\n    });\n  };\n\n  /**\n   * The ExternalMediaProxy class.\n   *\n   * @constructor\n   * @private\n   * @extends {MediaProxy}\n  */\n  function ExternalMediaProxy() {\n    ExternalMediaProxy.__super__.constructor.call(this);\n  }\n\n\n  __extends(ExternalMediaProxy, MediaProxy);\n\n\n  /** @static\n  */\n  ExternalMediaProxy.NAME = \"MediaProxy\";\n\n  /**\n   * The source object of the video.\n  */\n  ExternalMediaProxy.prototype.setSource = function(value) {\n    if (!(value != null) || value.length < 1) {\n      return;\n    }\n    value = value.filter(function(item) {\n      return item.type === \"external\";\n    });\n    return ExternalMediaProxy.__super__.setSource.call(this, value);\n  };\n\n  /**\n   * The ExternalPlaybackProxy class.\n   *\n   * @constructor\n   * @private\n   * @extends {puremvc.Proxy}\n  */\n  function ExternalPlaybackProxy() {\n    ExternalPlaybackProxy.__super__.constructor.call(this);\n  }\n\n\n  __extends(ExternalPlaybackProxy, puremvc.Proxy);\n\n\n  /**\n   * The name of the this Proxy.\n   *\n   * @static\n   * @type {string}\n  */\n  ExternalPlaybackProxy.NAME = \"PlaybackProxy\";\n\n  /** @private\n  */\n  ExternalPlaybackProxy.prototype.src = null;\n\n  /**\n  */\n  ExternalPlaybackProxy.prototype.getPlaybackCoreName = function() {\n    return \"external\";\n  };\n\n  /**\n   * Determines if the core can play a given mimeType.\n   *\n   * @return {String} \"\" if the core can't play the mimeType\n  */\n  ExternalPlaybackProxy.prototype.canPlayType = function(mimeType) {\n    return mimeType === \"external\";\n  };\n\n  /**\n   *\n  */\n  ExternalPlaybackProxy.prototype.canPlayTemporalType = function(temporalType) {\n    return true;\n  };\n\n  /**\n   * The current time of the video in seconds. Value must be between currentTime and duration.\n   *\n   * @param {Number} value\n   *    The new currentTime value in seconds\n   * @returns {Number}\n   *    The currentTime value in seconds\n   * @type {Number}\n  */\n  ExternalPlaybackProxy.prototype.getSrc = function() {\n    return this.facade.mediaProxy.getSrc();\n  };\n\n  /**\n   * Instructs the core to play.\n  */\n  ExternalPlaybackProxy.prototype.play = function() {\n    window.open(this.getSrc(), \"_blank\");\n  };\n\n  ExternalPlaybackProxy.prototype.load = function() {};\n\n  ExternalPlaybackProxy.prototype.setVolume = function() {};\n\n  ExternalPlaybackProxy.prototype.pause = function() {};\n\n  ExternalPlaybackProxy.prototype.setEnabled = function() {};\n\n  ExternalPlaybackProxy.prototype.getCurrentTime = function() {\n    return 0;\n  };\n\n  ExternalPlaybackProxy.prototype.setCurrentTime = function(value) {};\n\n  ExternalPlaybackProxy.prototype.getDuration = function() {\n    return 0;\n  };\n\n  /**\n   * @enum {string}\n   * @const\n   * @private\n  */\n\n  var UserNotifications = {\n    TOGGLE_PLAY_PAUSE: \"usertogglePlayPause\",\n    PLAY: \"userplay\",\n    PAUSE: \"userpause\",\n    SEEK: \"userseek\"\n  };\n\n  /**\n   * The PluginProxy class.\n   *\n   * @param {Object} config\n   * @constructor\n   * @private\n   * @extends {DataBoundConfigurationProxy}\n  */\n  function PluginProxy(config) {\n    PluginProxy.__super__.constructor.call(this, config);\n  }\n\n\n  __extends(PluginProxy, DataBoundConfigurationProxy);\n\n\n  /** @static\n  */\n  PluginProxy.NAME = ModuleProxy.NAME;\n\n  PluginProxy.prototype.enabled = true;\n\n  PluginProxy.prototype.plugin = null;\n\n  PluginProxy.prototype.appState = null;\n\n  /**\n  */\n  PluginProxy.prototype.getDefaults = function() {\n    var defaults;\n    defaults = PluginProxy.__super__.getDefaults.call(this);\n    if (!(defaults.debug != null)) {\n      defaults.debug = null;\n    }\n    return defaults;\n  };\n\n  /** @override\n  */\n  PluginProxy.prototype.initializeNotifier = function(key) {\n    PluginProxy.__super__.initializeNotifier.call(this, key);\n    this.appState = this.facade.player.appState;\n  };\n\n  /**\n  */\n  PluginProxy.prototype.getMediaElement = function() {\n    return this.facade.player.getMediaElement();\n  };\n\n  /**\n  */\n  PluginProxy.prototype.setEnabled = function(value) {\n    this.enabled = value;\n    return value;\n  };\n\n  PluginProxy.prototype.getEnabled = function() {\n    return this.enabled;\n  };\n\n  /**\n  */\n  PluginProxy.prototype.getDebug = function(value) {\n    if (this.value.debug != null) {\n      return this.value.debug;\n    } else {\n      return this.facade.player.getConfig().debug === true;\n    }\n  };\n\n  /**\n  */\n  PluginProxy.prototype.createPlugin = function() {};\n\n  /**\n  */\n  PluginProxy.prototype.initialize = function() {\n    this.plugin = this.createPlugin();\n  };\n\n  /**\n  */\n  PluginProxy.prototype.error = function(err) {\n    this.facade.logger.error(\"[AMP \" + (this.facade.getModuleName().toUpperCase()) + \" Error]\", err);\n  };\n\n  /**\n   * @enum {string}\n   * @const\n   * @private\n  */\n\n  var Namespace = {\n    PREFIX: \"akamai-\"\n  };\n\n  /**\n   * The Plugin class. Acts as a base for plugins.\n   *\n   * @constructor\n   * @private\n   * @extends {Module}\n  */\n  function Plugin() {\n    Plugin.__super__.constructor.call(this);\n  }\n\n\n  __extends(Plugin, Module);\n\n\n  Plugin.prototype.player = null;\n\n  Plugin.prototype.proxy = null;\n\n  /**\n   * @override\n  */\n  Plugin.prototype.initialize = function(config, player) {\n    this.player = player;\n    this.logger = this.player.logger;\n    Plugin.__super__.initialize.call(this, config, player);\n  };\n\n  /**\n  */\n  Plugin.prototype.isAvailable = function() {\n    return true;\n  };\n\n  /**\n  */\n  Plugin.prototype.loadModuleResources = function() {\n    if (!this.isAvailable()) {\n      this.resourcesLoaded();\n      return;\n    }\n    Plugin.__super__.loadModuleResources.call(this);\n  };\n\n  /**\n   * @override\n  */\n  Plugin.prototype.resourcesLoaded = function() {\n    if (typeof this.oninitialized === \"function\") {\n      this.oninitialized(this);\n    }\n  };\n\n  /** @override\n  */\n  Plugin.prototype.onRegister = function() {\n    var _ref;\n    if (this.isAvailable()) {\n      this.createFramework();\n      if ((_ref = this.retrieveProxy(PluginProxy.NAME)) != null) {\n        if (typeof _ref.initialize === \"function\") {\n          _ref.initialize();\n        }\n      }\n    }\n    this.sendNotification(PluginNotifications.PLUGIN_REGISTERED, this);\n  };\n\n  /** @override\n  */\n  Plugin.prototype.logEvent = function(event) {\n    var prefix;\n    if (/(timeupdate|timeremaining)/.test(event.type) === true) {\n      return;\n    }\n    prefix = this.player.getModuleName().toUpperCase() + \" \" + this.getModuleName().toUpperCase();\n    if (event.dispatcher != null) {\n      prefix += \" \" + event.dispatcher;\n    }\n    this.logger.log(\"[\" + prefix + \" EVENT] \" + event.type, event);\n  };\n\n  /** @override\n  */\n  Plugin.prototype.listNotificationPublications = function() {\n    var key, notes, value;\n    notes = [Notifications.ADD_LAYER, Notifications.REMOVE_LAYER, Notifications.ADD_OVERLAY, Notifications.REMOVE_OVERLAY, Notifications.ADD_APPLICATION_STATE, Notifications.REMOVE_APPLICATION_STATE, Notifications.IS_USER_ACTIVE, Notifications.PLAYBACK_CORE_CHANGE];\n    return notes.concat((function() {\n      var _results;\n      _results = [];\n      for (key in PluginNotifications) {\n        value = PluginNotifications[key];\n        _results.push(value);\n      }\n      return _results;\n    })());\n  };\n\n  /**\n   * The ChangePlayStateCommand class.\n   *\n   * @constructor\n   * @private\n   * @extends {amp.player.controller.PlayerCommand}\n  */\n  function ChangePlayStateCommand() {\n    ChangePlayStateCommand.__super__.constructor.call(this);\n  }\n\n\n  __extends(ChangePlayStateCommand, PlayerCommand);\n\n\n  /**\n   * Executes the command.\n   *\n   * @param {puremvc.Notification} notification\n   *    The notification.\n   *\n   * @override\n  */\n  ChangePlayStateCommand.prototype.execute = function(notification) {\n    this.applicationState.setPlayState(notification.getBody());\n  };\n\n  /**\n   * The ChangeMediaCommand class.\n   *\n   * @constructor\n   * @private\n   * @extends {amp.player.controller.PlayerCommand}\n  */\n  function ChangeMediaCommand() {\n    ChangeMediaCommand.__super__.constructor.call(this);\n  }\n\n\n  __extends(ChangeMediaCommand, PlayerCommand);\n\n\n  /**\n   * Executes the command.\n   *\n   * @param {puremvc.Notification} notification\n   *    The notification.\n   *\n   * @override\n  */\n  ChangeMediaCommand.prototype.execute = function(notification) {\n    var media;\n    media = notification.getBody();\n    this.playback.setEnabled(false);\n    this.playback.pause();\n    this.sendNotification(Notifications.HAS_POST_CONTENT, false);\n    this.sendNotification(Notifications.CHANGE_PLAY_STATE, PlayState.READY);\n    this.sendNotification(Notifications.CHANGE_ACTIVE_STATE, ActiveState.ACTIVE);\n    try {\n      this.media.setData(media);\n    } catch (error) {\n      this.sendNotification(Notifications.ERROR, error.message);\n    }\n    this.sendNotification(Notifications.UPDATE_DATA_BINDINGS);\n  };\n\n  /**\n   * The SetMediaCommand class.\n   *\n   * @constructor\n   * @private\n   * @extends {amp.player.controller.PlayerCommand}\n  */\n  function SetMediaCommand() {\n    SetMediaCommand.__super__.constructor.call(this);\n  }\n\n\n  __extends(SetMediaCommand, PlayerCommand);\n\n\n  /**\n   * Executes the command.\n   *\n   * @param {puremvc.Notification} notification\n   *    The notification.\n   *\n   * @override\n  */\n  SetMediaCommand.prototype.execute = function(notification) {\n    var media;\n    media = notification.getBody();\n    this.applicationState.setEnded(false);\n    this.sendNotification(Notifications.CHANGE_MEDIA, media);\n    media = this.media.getData();\n    this.security.setMedia(media);\n    if (this.security.getAuthorized()) {\n      this.sendNotification(SecurityNotifications.AUTHORIZED, this.security.getAuthorization());\n    } else {\n      this.sendNotification(SecurityNotifications.AUTHORIZE, {\n        media: media\n      });\n    }\n  };\n\n  /**\n   * The ChangeDurationCommand class.\n   *\n   * @constructor\n   * @private\n   * @extends {amp.player.controller.PlayerCommand}\n  */\n  function ChangeDurationCommand() {\n    ChangeDurationCommand.__super__.constructor.call(this);\n  }\n\n\n  __extends(ChangeDurationCommand, PlayerCommand);\n\n\n  /**\n   * Executes the command.\n   *\n   * @param {puremvc.Notification} notification\n   *    The notification.\n   *\n   * @override\n  */\n  ChangeDurationCommand.prototype.execute = function(notification) {\n    var duration;\n    duration = notification.getBody();\n    if (this.media.getDuration() === duration) {\n      return;\n    }\n    this.media.setDuration(duration);\n  };\n\n  /**\n   * The ErrorCommand class.\n   *\n   * @constructor\n   * @private\n   * @extends {amp.player.controller.PlayerEventCommand}\n  */\n  function ErrorCommand() {\n    ErrorCommand.__super__.constructor.call(this);\n  }\n\n\n  __extends(ErrorCommand, PlayerEventCommand);\n\n\n  /**\n   * Executes the command.\n   *\n   * @param {puremvc.Notification} notification\n   *    The notification.\n   *\n   * @override\n  */\n  ErrorCommand.prototype.execute = function(notification) {\n    var core;\n    this.playback.destroy();\n    core = this.playback.getMediaElement();\n    EventHandler.clear(core);\n    this.logger.error(\"[AMP ERROR]\", notification.getBody());\n    this.sendNotification(Notifications.CHANGE_PLAY_STATE, PlayState.ERROR);\n    ErrorCommand.__super__.execute.call(this, notification);\n  };\n\n  /**\n   * The ReadyCommand class.\n   *\n   * @constructor\n   * @private\n   * @extends {puremvc.SimpleCommand}\n  */\n  function ReadyCommand() {\n    ReadyCommand.__super__.constructor.call(this);\n  }\n\n\n  __extends(ReadyCommand, PlayerEventCommand);\n\n\n  /**\n   * Executes the command.\n   *\n   * @param {puremvc.Notification} notification\n   *    The notification.\n   *\n   * @override\n  */\n  ReadyCommand.prototype.execute = function(notification) {\n    var volume, _ref;\n    volume = (_ref = this.facade.config) != null ? _ref.volume : void 0;\n    if (volume != null) {\n      this.sendNotification(Notifications.CHANGE_VOLUME, volume);\n    }\n    this.playerCore.ready();\n    if (this.facade.config.autoplay === true) {\n      this.sendNotification(Notifications.ADD_APPLICATION_STATE, \"autoplay\");\n    }\n    this.sendNotification(Notifications.CHANGE_DISPLAY_STATE, DisplayState.NORMAL);\n    this.sendNotification(Notifications.CHANGE_PLAY_STATE, PlayState.READY);\n    this.sendNotification(Notifications.CHANGE_ACTIVE_STATE, ActiveState.ACTIVE);\n    this.dispatchEventAfterCommand(notification);\n  };\n\n  /**\n   * The UpdateDataBindingsCommand class.\n   *\n   * @constructor\n   * @private\n   * @extends {amp.player.controller.PlayerCommand}\n  */\n  function UpdateDataBindingsCommand() {\n    UpdateDataBindingsCommand.__super__.constructor.call(this);\n  }\n\n\n  __extends(UpdateDataBindingsCommand, PlayerCommand);\n\n\n  /**\n   * Executes the command.\n   *\n   * @param {puremvc.Notification} notification\n   *    The notification.\n   *\n   * @override\n  */\n  UpdateDataBindingsCommand.prototype.execute = function(notification) {\n    var body;\n    body = notification.getBody() || {};\n    this.bindings.compile(body.contexts, body.suppressErrors);\n  };\n\n  /**\n   * The ChangeParamsCommand class.\n   *\n   * @constructor\n   * @private\n   * @extends {amp.player.controller.PlayerCommand}\n  */\n  function ChangeParamsCommand() {\n    ChangeParamsCommand.__super__.constructor.call(this);\n  }\n\n\n  __extends(ChangeParamsCommand, PlayerCommand);\n\n\n  /**\n   * Executes the command.\n   *\n   * @param {puremvc.Notification} notification\n   *    The notification.\n   *\n   * @override\n  */\n  ChangeParamsCommand.prototype.execute = function(notification) {\n    this.params.setData(notification.getBody());\n    this.sendNotification(Notifications.UPDATE_DATA_BINDINGS, {\n      suppressErrors: true\n    });\n  };\n\n  /**\n   * The MediaChangeCommand class.\n   *\n   * @constructor\n   * @private\n   * @extends {amp.player.controller.PlayerEventCommand}\n  */\n  function MediaChangeCommand() {\n    MediaChangeCommand.__super__.constructor.call(this);\n  }\n\n\n  __extends(MediaChangeCommand, PlayerEventCommand);\n\n\n  /**\n   * Executes the command.\n   *\n   * @param {puremvc.Notification} notification\n   *    The notification.\n   *\n   * @override\n  */\n  MediaChangeCommand.prototype.execute = function(notification) {\n    var media;\n    media = notification.getBody();\n    this.playerCore.setPlaybackCore(media);\n    this.playback.reset();\n    this.playback.setCurrentTime(media.startTime || 0);\n    MediaChangeCommand.__super__.execute.call(this, notification);\n  };\n\n  /**\n   * The OverlayLayerMediator class.\n   *\n   * @constructor\n   * @private\n   * @extends {LayerMediator}\n  */\n  function OverlayLayerMediator() {\n    OverlayLayerMediator.__super__.constructor.call(this);\n  }\n\n\n  __extends(OverlayLayerMediator, LayerMediator);\n\n\n  OverlayLayerMediator.prototype.componentName = \"overlays\";\n\n  OverlayLayerMediator.NAME = \"OverlayLayerMediator\";\n\n  /**\n  */\n  OverlayLayerMediator.prototype.createMediatorName = function() {\n    return OverlayLayerMediator.NAME;\n  };\n\n  /**\n   * Overridden so this class may subscribe to all notifications\n   * @return An Array\n   *\n   * @override\n  */\n  OverlayLayerMediator.prototype.listNotificationInterests = function() {\n    return [Notifications.ADD_OVERLAY, Notifications.REMOVE_OVERLAY];\n  };\n\n  /**\n   * Handles notifications of interest to this mediator. Note that\n   * the default declaration is to allow the super to handle the\n   * note. This leaves the base JunctionMediator to handle things\n   * like ACCEPT_INPUT_PIPE and ACCEPT_OUTPUT_PIPE\n   *\n   * @param note An INotification\n   * @override\n  */\n  OverlayLayerMediator.prototype.handleNotification = function(notification) {\n    var name, overlay;\n    name = notification.getName();\n    overlay = notification.getBody();\n    switch (name) {\n      case Notifications.ADD_OVERLAY:\n        this.viewComponent.appendChild(overlay);\n        break;\n      case Notifications.REMOVE_OVERLAY:\n        this.viewComponent.removeChild(overlay);\n    }\n  };\n\n  /**\n   * @constructor\n   * @private\n  */\n  function PluginAdapter() {\n    this.plugins = [];\n    this.registered = 0;\n    PluginAdapter.__super__.constructor.call(this, this.constructor.NAME, {});\n  }\n\n\n  __extends(PluginAdapter, puremvc.Mediator);\n\n\n  PluginAdapter.NAME = \"PluginAdapter\";\n\n  PluginAdapter.prototype.plugins = null;\n\n  PluginAdapter.prototype.registered = null;\n\n  /**\n   * Registers the appropriate pipes and listeners when\n   * this class is registered\n   *\n   * @override\n  */\n  PluginAdapter.prototype.onRegister = function() {\n    return PluginAdapter.__super__.onRegister.call(this);\n  };\n\n  /**\n   * Overridden so this class may subscribe to all notifications\n   * @return An Array\n   *\n   * @override\n  */\n  PluginAdapter.prototype.listNotificationInterests = function() {\n    return [PluginNotifications.REGISTER_PLUGINS, PluginNotifications.PLUGIN_REGISTERED];\n  };\n\n  /**\n   * Handles notifications of interest to this mediator. Note that\n   * the default declaration is to allow the super to handle the\n   * note. This leaves the base JunctionMediator to handle things\n   * like ACCEPT_INPUT_PIPE and ACCEPT_OUTPUT_PIPE\n   *\n   * @param note An INotification\n   * @override\n  */\n  PluginAdapter.prototype.handleNotification = function(notification) {\n    var body, config, def, feature, init, initialize, key, name, plugin, plugins, type, value, _ref;\n    name = notification.getName();\n    body = notification.getBody();\n    switch (name) {\n      case PluginNotifications.REGISTER_PLUGINS:\n        type = this.facade.getPlayerType();\n        config = body;\n        _ref = AMP.plugins;\n        for (key in _ref) {\n          value = _ref[key];\n          if (!(key in config)) {\n            continue;\n          }\n          init = config[key];\n          if (!(init != null) || init.enabled === false) {\n            continue;\n          }\n          def = value[type];\n          if (!(def != null)) {\n            this.facade.logger.debug(\"[AMP] Plugin could not be found: \" + key);\n            continue;\n          }\n          try {\n            plugin = new def();\n            plugin.oninitialized = this.onplugininitialized.bind(this, key);\n            plugin.onerror = this.onpluginerror.bind(this, key);\n            initialize = plugin.initialize.bind(plugin, init, this.facade);\n            this.plugins.push(initialize);\n          } catch (error) {\n            this.logger.error(\"[AMP] Plugin could not be created: \" + key + \". \" + error);\n            continue;\n          }\n        }\n        plugins = config.plugins || {};\n        for (key in plugins) {\n          init = plugins[key];\n          if (!((init != null) && init.enabled !== false)) {\n            continue;\n          }\n          initialize = function(player, config, key, resolve, reject) {\n            return AMP.loadResources(init.resources).then(function() {\n              def = AMP.plugins[key][type];\n              if (!(def != null)) {\n                reject(\"[AMP] Plugin could not be found: \" + key);\n              }\n              return def(player, config, key);\n            }).then(resolve)[\"catch\"](reject);\n          };\n          this.plugins.push(initialize.bind(null, this.facade, init, key, this.onpluginregistered.bind(this, key), this.onpluginerror.bind(this, key)));\n        }\n        this.plugins.forEach(function(item) {\n          return item();\n        });\n        break;\n      case PluginNotifications.PLUGIN_REGISTERED:\n        feature = typeof body.getFeatureName === \"function\" ? body.getFeatureName() : void 0;\n        if (feature != null) {\n          this.facade[feature] = body;\n        }\n        this.onpluginregistered(body.getModuleName(), body);\n    }\n  };\n\n  PluginAdapter.prototype.initializedCheck = function() {\n    if (this.registered === this.plugins.length) {\n      this.sendNotification(PluginNotifications.PLUGINS_INITIALIZED, this.plugins);\n    }\n  };\n\n  PluginAdapter.prototype.onplugininitialized = function(key, plugin) {\n    plugin.oninitialized = null;\n    plugin.onerror = null;\n    this.facade.registerModule(plugin);\n  };\n\n  PluginAdapter.prototype.onpluginerror = function(key, error) {\n    this.registered++;\n    this.facade.logger.error(\"[AMP] Plugin could not be registered: \" + key);\n    this.facade.logger.error(error);\n    this.initializedCheck();\n  };\n\n  PluginAdapter.prototype.onpluginregistered = function(key, plugin) {\n    this.registered++;\n    this.facade.logger.debug(\"[AMP] Plugin registered: \" + key);\n    this.facade[key] = plugin;\n    this.initializedCheck();\n  };\n\n  /**\n   * The ClassList class.\n   *\n   * @param {!DOMElement}  element\n   *    The DOM Element\n   *\n   * @constructor\n  */\n  function ClassList(element) {\n    this.element = element;\n  }\n\n  ClassList.prototype.element = null;\n\n  ClassList.prototype.prefix = Namespace.PREFIX;\n\n  /**\n  */\n  ClassList.prototype.contains = function(className) {\n    return this.constructor.contains(className, this.element, this.prefix);\n  };\n\n  /**\n  */\n  ClassList.prototype.add = function(className) {\n    this.constructor.add(className, this.element, this.prefix);\n  };\n\n  /**\n  */\n  ClassList.prototype.remove = function(className) {\n    this.constructor.remove(className, this.element, this.prefix);\n  };\n\n  /**\n  */\n  ClassList.prototype.toggle = function(className) {\n    return this.constructor.contains(className, this.element, this.prefix);\n  };\n\n  /**\n  */\n  ClassList.contains = function(className, element, prefix) {\n    var css, _ref;\n    if (prefix == null) {\n      prefix = \"\";\n    }\n    css = prefix + className;\n    if (((_ref = element.classList) != null ? _ref.contains : void 0) != null) {\n      return element.classList.contains(css);\n    } else {\n      return element.className.indexOf(css) !== -1;\n    }\n  };\n\n  /**\n  */\n  ClassList.add = function(className, element, prefix) {\n    var css, _ref;\n    if (prefix == null) {\n      prefix = \"\";\n    }\n    css = prefix + className;\n    if (((_ref = element.classList) != null ? _ref.add : void 0) != null) {\n      element.classList.add(css);\n    } else {\n      if (!this.contains(className, element)) {\n        if (element.className !== \"\") {\n          element.className += \" \" + css;\n        } else {\n          element.className = css;\n        }\n      }\n    }\n  };\n\n  /**\n  */\n  ClassList.remove = function(className, element, prefix) {\n    var css, regexp, _ref;\n    if (prefix == null) {\n      prefix = \"\";\n    }\n    css = prefix + className;\n    if (((_ref = element.classList) != null ? _ref.remove : void 0) != null) {\n      element.classList.remove(css);\n    } else {\n      if (this.contains(className, element)) {\n        regexp = new RegExp(\" ?\" + css);\n        element.className = element.className.replace(regexp, \"\");\n      }\n    }\n  };\n\n  /**\n  */\n  ClassList.toggle = function(className, element, prefix) {\n    var css, _ref;\n    if (prefix == null) {\n      prefix = \"\";\n    }\n    css = prefix + className;\n    if (((_ref = element.classList) != null ? _ref.toggle : void 0) != null) {\n      element.classList.toggle(this.prefix + className);\n    } else {\n      if (this.contains(className, element)) {\n        this.remome(className, element);\n      } else {\n        this.add(className, element);\n      }\n    }\n  };\n\n  /**\n   * The LocalizationProxy class. Used to track player localization settings.\n   *\n   * @constructor\n   * @private\n   * @extends {DataBindingContext}\n   * @param {Object}  init  The configuration object.\n  */\n  function LocalizationProxy(init) {\n    var key, lang;\n    LocalizationProxy.__super__.constructor.call(this);\n    this.data = {\n      language: navigator.language || navigator.browserLanguage,\n      locales: Config.defaults.locales\n    };\n    if (init != null) {\n      if (init.language != null) {\n        this.data.language = init.language;\n      }\n      if (init.locales != null) {\n        for (lang in init.locales) {\n          if (this.data.locales[lang] != null) {\n            for (key in init.locales[lang]) {\n              this.data.locales[lang][key] = init.locales[lang][key];\n            }\n          } else {\n            this.data.locales[lang] = init.locales[lang];\n          }\n        }\n      }\n    }\n  }\n\n\n  __extends(LocalizationProxy, DataBindingContext);\n\n\n  /** @static\n  */\n  LocalizationProxy.NAME = \"LocalizationProxy\";\n\n  LocalizationProxy.prototype.contextName = \"l10n\";\n\n  LocalizationProxy.prototype.locale = null;\n\n  LocalizationProxy.prototype.localeId = null;\n\n  /** @override\n  */\n  LocalizationProxy.prototype.onRegister = function() {\n    LocalizationProxy.__super__.onRegister.call(this);\n    this.setLocale(this.data.language);\n  };\n\n  /**\n   * Gets the context data for this proxy.\n   *\n   * @returns {Object} The contenxt data for this proxy\n   * @override\n  */\n  LocalizationProxy.prototype.getContextData = function() {\n    return this.locale;\n  };\n\n  /**\n   *\n  */\n  LocalizationProxy.prototype.getLanguage = function() {\n    return this.data.language;\n  };\n\n  LocalizationProxy.prototype.setLanguage = function(value) {\n    this.data.language = value;\n    this.setLocale(value);\n    this.sendNotification(Notifications.LANGUAGE_CHANGE, value);\n    return value;\n  };\n\n  /**\n   *\n  */\n  LocalizationProxy.prototype.setLocale = function(value) {\n    this.localeId = value;\n    this.locale = this.data.locales[this.localeId];\n    if (!(this.locale != null)) {\n      this.localeId = value.substring(0, 2);\n      this.locale = this.data.locales[this.localeId];\n    }\n    this.facade.l10n = this.locale;\n    return value;\n  };\n\n  LocalizationProxy.prototype.getLocaleId = function() {\n    return this.localeId;\n  };\n\n  /**\n   *\n  */\n  LocalizationProxy.prototype.getLocales = function() {\n    return this.data.locales;\n  };\n\n  LocalizationProxy.prototype.setLocales = function(value) {\n    this.data.locales = value;\n    return value;\n  };\n\n  /**\n   *\n  */\n  LocalizationProxy.prototype.getString = function(key) {\n    var locale;\n    locale = this.locale || this.data.locales.en;\n    return locale[key] || \"\";\n  };\n\n  /**\n   * Retrieves the full language name in the player's current language setting.\n   *\n   * @param   {string}  lang  The language code.\n   * @return  {string}        The full name of the language according to the player's current language setting.\n  */\n  LocalizationProxy.prototype.getLanguageString = function(lang) {\n    var key, str;\n    if (typeof lang !== \"string\" || !(lang != null) || lang === \"\") {\n      return \"\";\n    }\n    key = \"MSG_\" + (lang.toUpperCase());\n    str = this.getString(key);\n    if (str === \"\") {\n      lang = lang.split(\"-\").shift();\n      key = \"MSG_\" + (lang.toUpperCase());\n      str = this.getString(key);\n    }\n    return str;\n  };\n\n  function UI() {}\n\n  /**\n   * Creates an HTML element.\n   *\n   * @param   {?(string|Array.<string>)}  type\n   * @param   {?DOMElement}  parent\n   * @param   {?string|DOMElement}  element\n   * @param   {?string} text\n   * @return  {DOMElement}\n  */\n  UI.create = function(type, parent, element, text) {\n    var classList, item, viewComponent, _i, _len;\n    if (element == null) {\n      element = \"div\";\n    }\n    if (typeof element === \"string\") {\n      element = document.createElement(element);\n    }\n    classList = new ClassList(element);\n    if (type != null) {\n      if (typeof type === \"string\") {\n        type = [type];\n      }\n      for (_i = 0, _len = type.length; _i < _len; _i++) {\n        item = type[_i];\n        classList.add(item);\n      }\n    }\n    element._classList = classList;\n    if (text != null) {\n      if (element.innerText != null) {\n        element.innerText = text;\n      } else {\n        element.textContent = text;\n      }\n    }\n    if (parent != null) {\n      if (parent.getViewComponent != null) {\n        viewComponent = parent.getViewComponent();\n      }\n      if (viewComponent != null) {\n        parent = viewComponent;\n      }\n      parent.appendChild(element);\n    }\n    return element;\n  };\n\n  /**\n   * Binds a mediators event handlers to an element.\n   *\n   * @param {!DOMElement} element\n   * @param {!mediator} mediator\n  */\n  UI.bindEvents = function(element, handlers, exceptions) {\n    var key, value;\n    if (exceptions == null) {\n      exceptions = [\"onRemove\", \"onRegister\"];\n    }\n    for (key in handlers) {\n      value = handlers[key];\n      if (!(__indexOf.call(exceptions, key) >= 0) && /^on/.test(key) && ((value != null ? value.bind : void 0) != null)) {\n        element[key] = value.bind(handlers);\n      }\n    }\n  };\n\n  /**\n   * Creates a unique id.\n   *\n   * @param   {number=}   base\n   *    The base to use for representing a numeric value.\n   *\n   * @return  {string}\n   *    The unique id.\n  */\n  UI.createUID = function(base) {\n    var date, len, max, rand;\n    if (base == null) {\n      base = 16;\n    }\n    date = Date.now();\n    len = 2;\n    max = base * len - 1;\n    rand = Math.round(Math.random() * max + base);\n    return (rand.toString(16) + date.toString(16)).toUpperCase();\n  };\n\n  /**\n   * The ExternalPlayCommand class.\n   *\n   * @constructor\n   * @private\n   * @extends {puremvc.MacroCommand}\n  */\n  function ExternalPlayCommand() {\n    ExternalPlayCommand.__super__.constructor.call(this);\n  }\n\n\n  __extends(ExternalPlayCommand, PlayerEventCommand);\n\n\n  /**\n   * Executes the command.\n   *\n   * @param {puremvc.Notification} notification\n   *    The notification.\n   *\n   * @override\n  */\n  ExternalPlayCommand.prototype.execute = function(notification) {\n    this.sendNotification(Notifications.PLAY_REQUEST);\n    this.playback.play();\n    ExternalPlayCommand.__super__.execute.call(this, notification);\n  };\n\n  /**\n   * The ExternalPlayer class.\n   *\n   * @constructor\n   * @private\n   * @extends {Player}\n   * @param {Object} config\n   * @param {Object} viewComponent\n   * @param {EventDispatcher} dispatcher\n  */\n  function ExternalPlayer(config, viewComponent, dispatcher) {\n    ExternalPlayer.__super__.constructor.call(this, config, viewComponent, dispatcher);\n  }\n\n\n  __extends(ExternalPlayer, Player);\n\n\n  ExternalPlayer.prototype.playerType = \"external\";\n\n  /** @override\n  */\n  ExternalPlayer.prototype.createModel = function() {\n    var playbackProxy;\n    ExternalPlayer.__super__.createModel.call(this);\n    this.registerProxy(new LocalizationProxy(this.config));\n    playbackProxy = new ExternalPlaybackProxy();\n    this.registerProxy(playbackProxy);\n    this.playerCore = new PlayerProxy(playbackProxy);\n    this.registerProxy(this.playerCore);\n    this.bindings.initialize();\n  };\n\n  /** @override\n  */\n  ExternalPlayer.prototype.createView = function() {\n    var overlay,\n      _this = this;\n    this.registerMediator(new PlayerMediator(\"external\", this.getViewComponent()));\n    this.registerMediator(new PluginAdapter());\n    overlay = new OverlayLayerMediator();\n    this.registerMediator(overlay);\n    EventHandler.create(overlay.viewComponent, EventHandler.CLICK, function() {\n      return _this.sendNotification(Notifications.TOGGLE_ACTIVE);\n    });\n  };\n\n  /** @override\n  */\n  ExternalPlayer.prototype.createController = function() {\n    ExternalPlayer.__super__.createController.call(this);\n    this.registerCommand(Notifications.UPDATE_DATA_BINDINGS, UpdateDataBindingsCommand);\n    this.registerCommand(UserNotifications.TOGGLE_PLAY_PAUSE, ExternalPlayCommand);\n    this.registerCommand(Notifications.PLAY, ExternalPlayCommand);\n    this.registerCommand(Notifications.CHANGE_PLAY_STATE, ChangePlayStateCommand);\n    this.registerCommand(Notifications.SET_MEDIA, SetMediaCommand);\n    this.registerCommand(Notifications.CHANGE_MEDIA, ChangeMediaCommand);\n    this.registerCommand(Notifications.MEDIA_CHANGE, MediaChangeCommand);\n    this.registerCommand(Notifications.MEDIA_VALIDATED, MediaValidatedCommand);\n    this.registerCommand(Notifications.ERROR, ErrorCommand);\n    this.registerCommand(PluginNotifications.PLUGINS_INITIALIZED, PluginsInitializedCommand);\n    this.registerCommand(Notifications.READY, ReadyCommand);\n    this.registerCommand(Notifications.CHANGE_PARAMS, ChangeParamsCommand);\n  };\n\n  /** @override\n  */\n  ExternalPlayer.prototype.createMediaElement = function() {\n    return document.createElement(\"div\");\n  };\n\n  ExternalPlayer.prototype.evaluateBinding = function(str) {\n    var _ref;\n    return (_ref = this.retrieveProxy(DataBindingProxy.NAME)) != null ? _ref.evaluateBinding(str) : void 0;\n  };\n\n  ExternalPlayer.prototype.canPlayType = function(mimeType) {\n    return \"maybe\";\n  };\n\n  ExternalPlayer.prototype.play = function() {\n    this.sendNotification(Notifications.PLAY);\n  };\n\n  ExternalPlayer.prototype.setParams = function(value) {\n    this.sendNotification(Notifications.CHANGE_PARAMS, value);\n    return value;\n  };\n\n  ExternalPlayer.prototype.getParams = function() {\n    return this.retrieveProxy(ParamsProxy.NAME).getData();\n  };\n\n  ExternalPlayer.prototype.setAutoplay = function(value) {\n    return false;\n  };\n\n  ExternalPlayer.prototype.getAutoplay = function() {\n    return false;\n  };\n\n  ExternalPlayer.prototype.setLoop = function(value) {\n    return false;\n  };\n\n  ExternalPlayer.prototype.getLoop = function() {\n    return false;\n  };\n\n  ExternalPlayer.prototype.setMuted = function(value) {\n    return false;\n  };\n\n  ExternalPlayer.prototype.getMuted = function() {\n    return false;\n  };\n\n  ExternalPlayer.prototype.setMedia = function(value) {\n    this.sendNotification(Notifications.SET_MEDIA, value);\n    return value;\n  };\n\n  ExternalPlayer.prototype.getMedia = function(value) {\n    var _ref;\n    return (_ref = this.retrieveProxy(MediaProxy.NAME)) != null ? _ref.getData() : void 0;\n  };\n\n  ExternalPlayer.prototype.setCurrentTime = function(value) {\n    return 0;\n  };\n\n  ExternalPlayer.prototype.getCurrentTime = function(value) {\n    return 0;\n  };\n\n  ExternalPlayer.prototype.getDuration = function(value) {\n    return this.retrieveProxy(MediaProxy.NAME).getDuration();\n  };\n\n  ExternalPlayer.prototype.setSrc = function(value) {\n    this.sendNotification(Notifications.SET_MEDIA, {\n      src: value\n    });\n    return value;\n  };\n\n  ExternalPlayer.prototype.getSrc = function(value) {\n    return this.retrieveProxy(MediaProxy.NAME).getSrc();\n  };\n\n  ExternalPlayer.prototype.setSource = function(value) {\n    this.sendNotification(Notifications.SET_MEDIA, {\n      source: value\n    });\n    return value;\n  };\n\n  ExternalPlayer.prototype.getSource = function() {\n    return this.retrieveProxy(MediaProxy.NAME).getSource();\n  };\n\n  ExternalPlayer.prototype.setVolume = function(value) {\n    return value;\n  };\n\n  ExternalPlayer.prototype.getVolume = function(value) {\n    return 1;\n  };\n\n  ExternalPlayer.prototype.getSeeking = function() {\n    return false;\n  };\n\n  ExternalPlayer.prototype.getPaused = function() {\n    return false;\n  };\n\n  ExternalPlayer.prototype.getEnded = function() {\n    return false;\n  };\n\n  function FeedVO() {\n    this.item = [];\n    this.metadata = {};\n  }\n\n  FeedVO.prototype.title = null;\n\n  FeedVO.prototype.link = null;\n\n  FeedVO.prototype.description = null;\n\n  FeedVO.prototype.category = null;\n\n  FeedVO.prototype.pubDate = null;\n\n  FeedVO.prototype.language = null;\n\n  FeedVO.prototype.ttl = null;\n\n  FeedVO.prototype.item = null;\n\n  FeedVO.prototype.metadata = null;\n\n  function Resource() {\n    this.metadata = {};\n  }\n\n  /**\n   * The resource url.\n   *\n   * @type {String}\n  */\n  Resource.prototype.src = null;\n\n  /**\n   * The resource url to use in debug mode.\n   *\n   * @type {String}\n  */\n  Resource.prototype.debug = null;\n\n  /**\n   * The mime type.\n   *\n   * @type {String}\n  */\n  Resource.prototype.type = null;\n\n  /**\n   * @type {Object}\n  */\n  Resource.prototype.metadata = null;\n\n  /**\n   * @enum {string}\n   * @const\n  */\n\n  var PlaybackMode = {\n    /**\n     *\n    */\n\n    AUTO: \"auto\",\n    /**\n     *\n    */\n\n    HTML: \"html\",\n    /**\n     *\n    */\n\n    FLASH: \"flash\",\n    /**\n     *\n    */\n\n    EXTERNAL: \"external\",\n    /**\n     *\n    */\n\n    NONE: \"none\",\n    /**\n     *\n    */\n\n    HTML_AUTO: \"html-auto\"\n  };\n\n  function MediaVO() {\n    return MediaVO.__super__.constructor.apply(this, arguments);\n  }\n\n\n  __extends(MediaVO, Resource);\n\n\n  MediaVO.prototype.source = null;\n\n  MediaVO.prototype.title = null;\n\n  MediaVO.prototype.description = null;\n\n  MediaVO.prototype.link = null;\n\n  MediaVO.prototype.guid = null;\n\n  MediaVO.prototype.pubDate = null;\n\n  MediaVO.prototype.poster = null;\n\n  MediaVO.prototype.thumbnail = null;\n\n  MediaVO.prototype.embed = null;\n\n  MediaVO.prototype.category = null;\n\n  MediaVO.prototype.type = null;\n\n  MediaVO.prototype.medium = null;\n\n  MediaVO.prototype.duration = null;\n\n  MediaVO.prototype.track = null;\n\n  MediaVO.prototype.metadata = null;\n\n  MediaVO.prototype.scenes = null;\n\n  MediaVO.prototype.startTime = null;\n\n  /**\n   * Event constructor.\n   *\n   * @param {!string}  type  A string representing the event's type.\n   * @param {Object=} detail  Data to pass along with the event.\n   * @constructor\n   * @private\n  */\n  function Event(type, detail) {\n    this.type = type;\n    if (detail != null) {\n      this.detail = this.data = detail;\n    }\n  }\n\n  /**\n   * The event's type.\n   *\n   * @type {string}\n  */\n  Event.prototype.type = null;\n\n  /**\n   * The event's target\n   *\n   * @type {Object}\n  */\n  Event.prototype.target = null;\n\n  /**\n   * Collection of event specific details.\n   *\n   * @type {Object}\n  */\n  Event.prototype.detail = null;\n\n  /**\n   * @constructor\n   * @private\n  */\n  function MRSSHelper() {}\n\n  /**\n  */\n  MRSSHelper.prototype.getFeed = function(url, onload, onerror) {\n    return Utils.getJson(url, onload, onerror);\n  };\n\n  /**\n  */\n  MRSSHelper.prototype.getMediaNode = function(item, name, checkItem) {\n    var base, mediaContent, mediaName, node;\n    if (checkItem == null) {\n      checkItem = true;\n    }\n    mediaName = \"media-\" + name;\n    base = item['media-group'] || item;\n    mediaContent = base['media-content'];\n    if ((mediaContent != null) && (mediaContent[mediaName] != null)) {\n      node = mediaContent[mediaName];\n    } else if (base[mediaName] != null) {\n      node = base[mediaName];\n    } else if (item[mediaName] != null) {\n      node = item[mediaName];\n    } else if ((item[name] != null) && checkItem) {\n      node = item[name];\n    }\n    return node;\n  };\n\n  MRSSHelper.prototype.createEmbed = function(item) {\n    var embed, embedVO, param, _i, _len, _ref;\n    try {\n      embed = this.getMediaNode(item, \"embed\");\n      if (!(embed != null)) {\n        return embedVO;\n      }\n      embedVO = {};\n      embedVO.url = embed[\"@attributes\"].url;\n      embedVO.width = embed[\"@attributes\"].width;\n      embedVO.height = embed[\"@attributes\"].height;\n      embedVO.params = {};\n      if (!(embed[\"media-param\"] instanceof Array)) {\n        embed[\"media-param\"] = [embed[\"media-param\"]];\n      }\n      _ref = embed[\"media-param\"];\n      for (_i = 0, _len = _ref.length; _i < _len; _i++) {\n        param = _ref[_i];\n        embedVO.params[param[\"@attributes\"].name] = param[\"#text\"];\n      }\n    } catch (error) {\n      Logger.error(\"[AMP Feed Parse Error] embed parse error: \" + error.message, error);\n    }\n    return embedVO;\n  };\n\n  /**\n  */\n  MRSSHelper.prototype.createFeed = function(json) {\n    var channel, feedVO, item, items, key, mediaVO, value, _i, _len;\n    try {\n      channel = json.channel;\n      feedVO = new FeedVO();\n      if (channel != null) {\n        feedVO.title = channel.title;\n        feedVO.description = channel.description;\n        feedVO.language = channel.language;\n        feedVO.category = channel.category;\n        feedVO.pubDate = new Date(Date.parse(channel.pubDate));\n        feedVO.ttl = channel.ttl;\n        items = channel.item instanceof Array ? channel.item : [channel.item];\n        for (_i = 0, _len = items.length; _i < _len; _i++) {\n          item = items[_i];\n          mediaVO = this.createMedia(item);\n          feedVO.item.push(mediaVO);\n        }\n        for (key in channel) {\n          value = channel[key];\n          if (!(key in feedVO)) {\n            feedVO.metadata[key] = value;\n          }\n        }\n      }\n    } catch (error) {\n      Logger.error(\"[AMP Feed Parse Error] feed parse error: \" + error.message, error);\n    }\n    return feedVO;\n  };\n\n  /**\n  */\n  MRSSHelper.prototype.createMedia = function(item) {\n    var atts, category, content, key, label, mediaContent, mediaVO, node, source, track, value, _i, _j, _k, _len, _len1, _len2, _ref, _ref1, _ref2;\n    try {\n      mediaVO = new MediaVO();\n      mediaContent = this.getMediaNode(item, 'content');\n      if (mediaContent instanceof Array) {\n        mediaVO.source = [];\n        for (_i = 0, _len = mediaContent.length; _i < _len; _i++) {\n          content = mediaContent[_i];\n          source = {\n            src: content['@attributes'].url,\n            type: content['@attributes'].type\n          };\n          category = content[\"media-category\"];\n          if (category != null) {\n            atts = category[\"@attributes\"];\n            if (atts.schema === \"http://mrss.akamai.com/user_agent_hint\") {\n              label = atts.label || category[\"#text\"];\n              if ((label != null) && label !== \"\") {\n                if (source.rules == null) {\n                  source.rules = [];\n                }\n                source.rules.push(label);\n              }\n            }\n          }\n          mediaVO.source.push(source);\n          mediaVO.medium = content['@attributes'].medium;\n          mediaVO.duration = parseFloat(content['@attributes'].duration);\n        }\n      } else {\n        mediaVO.type = mediaContent['@attributes'].type;\n        mediaVO.src = mediaContent['@attributes'].url;\n        mediaVO.medium = mediaContent['@attributes'].medium;\n        mediaVO.duration = parseFloat(mediaContent['@attributes'].duration);\n      }\n      mediaVO.guid = item.guid;\n      mediaVO.title = this.getMediaNode(item, \"title\");\n      mediaVO.link = item.link;\n      mediaVO.description = this.getMediaNode(item, \"description\");\n      mediaVO.pubDate = new Date(Date.parse(item.pubDate));\n      mediaVO.thumbnail = mediaVO.poster = (_ref = this.getMediaNode(item, 'thumbnail')) != null ? (_ref1 = _ref['@attributes']) != null ? _ref1.url : void 0 : void 0;\n      mediaVO.embed = this.createEmbed(item);\n      mediaVO.scenes = (_ref2 = this.getMediaNode(item, \"scenes\")) != null ? _ref2['media-scene'] : void 0;\n      node = this.getMediaNode(item, \"status\", false);\n      if (node != null) {\n        mediaVO.status = {\n          state: node['@attributes'].state,\n          reason: node['@attributes'].reason\n        };\n      }\n      mediaVO.category = item.category;\n      if (!(mediaVO.category instanceof Array)) {\n        mediaVO.category = [mediaVO.category];\n      }\n      node = this.getMediaNode(item, \"category\", false);\n      if (node != null) {\n        for (_j = 0, _len1 = node.length; _j < _len1; _j++) {\n          category = node[_j];\n          if ((category[\"#text\"] != null) && category[\"#text\"] !== \"\") {\n            mediaVO.category.push(category[\"#text\"]);\n          }\n        }\n      }\n      if (mediaVO.category != null) {\n        mediaVO.category.sort(function(a, b) {\n          a = a.toLowerCase();\n          b = b.toLowerCase();\n          if (a > b) {\n            return 1;\n          } else if (a < b) {\n            return -1;\n          } else {\n            return 0;\n          }\n        });\n      }\n      node = this.getMediaNode(item, \"subTitle\");\n      if (node != null) {\n        if (mediaVO.track == null) {\n          mediaVO.track = [];\n        }\n        if (!(node instanceof Array)) {\n          node = [node];\n        }\n        for (_k = 0, _len2 = node.length; _k < _len2; _k++) {\n          track = node[_k];\n          if (track[\"@attributes\"] != null) {\n            mediaVO.track.push({\n              src: track[\"@attributes\"].href,\n              type: track[\"@attributes\"].type,\n              kind: \"captions\",\n              srclang: track[\"@attributes\"].lang || \"en\"\n            });\n          }\n        }\n      }\n      category = item.category;\n      if (!(category instanceof Array)) {\n        category = [category];\n      }\n      mediaVO.isLive = item.temporalType === \"live\" || ((category != null) && category.join(\",\").indexOf(\"live_stream\") !== -1);\n      mediaVO.temporalType = mediaVO.isLive ? \"live\" : \"vod\";\n      for (key in item) {\n        value = item[key];\n        if (!(key in mediaVO)) {\n          mediaVO.metadata[key] = value;\n        }\n      }\n    } catch (error) {\n      Logger.error(\"[AMP Feed Parse Error] media parse error: \" + error.message, error);\n    }\n    return mediaVO;\n  };\n\n  function Logger() {}\n\n  Logger.enabled = false;\n\n  Logger.enable = function(enabled) {\n    if (enabled == null) {\n      enabled = /debug\\=true/.test(location.search.toLowerCase());\n    }\n    this.enabled = enabled;\n    if (!this.enabled) {\n      this.log = this.trace = this.debug = this.info = this.warn = this.error = this.fatal = function() {};\n    }\n    return enabled;\n  };\n\n  Logger.log = function() {\n    try {\n      if (arguments.length > 1 && (arguments[1] != null)) {\n        console.log.apply(console, arguments);\n      } else {\n        console.log(arguments[0]);\n      }\n    } catch (error) {\n\n    }\n  };\n\n  Logger.trace = function() {\n    try {\n      console.trace.apply(console, arguments);\n    } catch (error) {\n\n    }\n  };\n\n  Logger.debug = function() {\n    try {\n      console.log.apply(console, arguments);\n    } catch (error) {\n      this.log.apply(this, arguments);\n    }\n  };\n\n  Logger.info = function() {\n    try {\n      console.info.apply(console, arguments);\n    } catch (error) {\n\n    }\n  };\n\n  Logger.warn = function() {\n    try {\n      console.warn.apply(console, arguments);\n    } catch (error) {\n\n    }\n  };\n\n  Logger.error = function() {\n    try {\n      console.error.apply(console, arguments);\n    } catch (error) {\n      this.log.apply(this, arguments);\n    }\n  };\n\n  Logger.fatal = function() {\n    try {\n      console.fatal.apply(console, arguments);\n    } catch (error) {\n\n    }\n  };\n\n  /**\n   * @constructor\n   * @private\n   * @extends {EventDispatcher}\n  */\n  function XHR() {\n    XHR.__super__.constructor.call(this);\n  }\n\n\n  __extends(XHR, EventDispatcher);\n\n\n  XHR.prototype.xhr = null;\n\n  XHR.prototype.headers = null;\n\n  XHR.prototype.response = null;\n\n  XHR.prototype.responseXML = null;\n\n  XHR.prototype.responseText = null;\n\n  XHR.prototype.responseType = null;\n\n  XHR.prototype.withCredentials = false;\n\n  XHR.prototype.readyState = 0;\n\n  XHR.prototype.status = null;\n\n  XHR.prototype.open = function(method, url) {\n    var xdr, xhr,\n      _this = this;\n    try {\n      xhr = new XMLHttpRequest();\n    } catch (error) {\n      xhr = new window.ActiveXObject(\"Microsoft.XMLHTTP\");\n    }\n    if (XHR.isCORS(url)) {\n      if (Object.prototype.hasOwnProperty.call(xhr, \"withCredentials\")) {\n        try {\n          xhr.withCredentials = this.withCredentials;\n        } catch (error) {\n          Logger.warn(\"[AMP XHR WARNING]\", \"withCredentials not properly supported in this browser.\", error);\n        }\n      } else if (typeof XDomainRequest !== \"undefined\") {\n        xdr = true;\n        xhr = new XDomainRequest();\n      }\n    }\n    if (xhr != null) {\n      if (xdr) {\n        xhr.onprogress = function() {};\n        xhr.ontimeout = function() {};\n        xhr.onerror = function() {};\n        xhr.onload = function(event) {\n          if (typeof xhr.onreadystatechange === 'function') {\n            xhr.readyState = 4;\n            xhr.status = 200;\n            if (xhr.contentType.match(/\\/xml/)) {\n              xhr.responseXML = new ActiveXObject('Microsoft.XMLDOM');\n              xhr.responseXML.async = false;\n              xhr.responseXML.loadXML(xhr.responseText);\n            }\n            xhr.onreadystatechange.call(xhr, event, false);\n          }\n        };\n      }\n      xhr.onreadystatechange = function(event) {\n        var _ref, _ref1;\n        _this.readyState = xhr.readyState;\n        _this.dispatchEvent(new Event(\"readystatechange\", xhr));\n        if (xhr.readyState === 4) {\n          _this.status = xhr.status;\n          if ((199 < (_ref = _this.status) && _ref < 400) || _this.status === 0) {\n            if (xhr.responseText == null) {\n              xhr.responseText = xhr.text;\n            }\n            _this.responseText = xhr.responseText;\n            if ((xhr.responseXML != null) && ((_ref1 = xhr.responseXML.childNodes) != null ? _ref1.length : void 0) > 0) {\n              _this.response = _this.responseXML = xhr.responseXML;\n              _this.responseType = \"document\";\n            } else {\n              try {\n                _this.response = JSON.parse(xhr.responseText);\n                _this.responseType = \"json\";\n              } catch (error) {\n                _this.response = xhr.responseText;\n                _this.responseType = \"text\";\n              }\n            }\n            _this.dispatchEvent(new Event(\"load\", _this));\n          } else {\n            if (_this.status !== 0) {\n              _this.dispatchEvent(new Event(\"error\", _this));\n            }\n          }\n        }\n      };\n      try {\n        if (typeof xhr.onerror !== \"undefined\") {\n          xhr.onerror = function(event) {\n            _this.dispatchEvent(new Event(\"error\", _this));\n          };\n        }\n      } catch (error) {\n\n      }\n      xhr.open(method, url);\n    }\n    this.xhr = xhr;\n  };\n\n  XHR.prototype.send = function(data) {\n    var key, value, _ref,\n      _this = this;\n    if (this.headers != null) {\n      _ref = this.headers;\n      for (key in _ref) {\n        value = _ref[key];\n        if ((key != null) && (value != null)) {\n          this.xhr.setRequestHeader(key, value);\n        }\n      }\n    }\n    setTimeout(function() {\n      _this.xhr.send(data);\n    }, 0);\n  };\n\n  XHR.prototype.setRequestHeader = function(key, value) {\n    if (!(key != null) || !(value != null)) {\n      return;\n    }\n    if (this.headers == null) {\n      this.headers = {};\n    }\n    this.headers[key] = value;\n  };\n\n  XHR.prototype.setRequestHeaders = function(headers) {\n    this.headers = headers;\n    return headers;\n  };\n\n  XHR.prototype.getResponseHeader = function(name) {\n    var _ref;\n    return (_ref = this.xhr) != null ? typeof _ref.getResponseHeader === \"function\" ? _ref.getResponseHeader(name) : void 0 : void 0;\n  };\n\n  XHR.prototype.getAllResponseHeaders = function() {\n    var _ref;\n    return (_ref = this.xhr) != null ? typeof _ref.getAllResponseHeaders === \"function\" ? _ref.getAllResponseHeaders() : void 0 : void 0;\n  };\n\n  XHR.isCORS = function(url) {\n    var hostname, parser, port, protocol;\n    parser = document.createElement('a');\n    parser.href = url;\n    hostname = parser.hostname !== \"\" ? parser.hostname : location.hostname;\n    port = parser.port !== \"0\" ? parser.port : location.port;\n    protocol = parser.protocol !== \":\" ? parser.protocol : location.protocol;\n    return location.protocol !== protocol || location.hostname !== hostname || location.port !== port && !(location.port === \"\" && port === \"80\");\n  };\n\n  function Utils() {}\n\n  Utils.blankImage = \"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAMAAAAoyzS7AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyJpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuMC1jMDYwIDYxLjEzNDc3NywgMjAxMC8wMi8xMi0xNzozMjowMCAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENTNSBNYWNpbnRvc2giIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6NjI2QkJDQTBCMzQ4MTFFMUFERDJBRkRGQUQwNTcxRTIiIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6NjI2QkJDQTFCMzQ4MTFFMUFERDJBRkRGQUQwNTcxRTIiPiA8eG1wTU06RGVyaXZlZEZyb20gc3RSZWY6aW5zdGFuY2VJRD0ieG1wLmlpZDowODg4NjdFQkIzNDgxMUUxQUREMkFGREZBRDA1NzFFMiIgc3RSZWY6ZG9jdW1lbnRJRD0ieG1wLmRpZDowODg4NjdFQ0IzNDgxMUUxQUREMkFGREZBRDA1NzFFMiIvPiA8L3JkZjpEZXNjcmlwdGlvbj4gPC9yZGY6UkRGPiA8L3g6eG1wbWV0YT4gPD94cGFja2V0IGVuZD0iciI/Pu0++ecAAAAGUExURf///wAAAFXC034AAAABdFJOUwBA5thmAAAADElEQVR42mJgAAgwAAACAAFPbVnhAAAAAElFTkSuQmCC\";\n\n  Utils.mimeTypes = {\n    mp4: \"video/mp4\",\n    flv: \"video/x-flv\",\n    f4m: \"video/f4m\",\n    smil: \"application/smil\",\n    smilxml: \"application/smil+xml\",\n    m3u8: \"application/x-mpegURL\",\n    mp3: \"audio/mpeg\",\n    json: \"application/json\",\n    txt: \"text/plain\",\n    xml: \"application/xml\",\n    ogv: \"video/ogg\",\n    webm: \"video/webm\",\n    mpd: \"application/dash+xml\",\n    ism: \"application/vnd.ms-sstr+xml\",\n    js: \"text/javascript\",\n    css: \"text/css\",\n    swf: \"application/x-shockwave-flash\",\n    vtt: \"text/vtt\",\n    ttml: \"application/ttml+xml\",\n    srt: \"application/x-subrip\",\n    cea608: \"text/cea-608\",\n    cea708: \"text/cea-708\"\n  };\n\n  Utils.flashTypes = [Utils.mimeTypes.mp4, Utils.mimeTypes.flv, Utils.mimeTypes.f4m, Utils.mimeTypes.smil, Utils.mimeTypes.smilxml];\n\n  Utils.rules = {\n    flashTablets: {\n      label: \"Android 2 & 3 or Kindle Fire 1\",\n      regexp: \"Android [23]|Silk\\/1\"\n    },\n    html5Phones: {\n      label: \"iPhone\",\n      regexp: \"iPhone\"\n    },\n    html5Tablets: {\n      label: \"HTML5 Tablets\",\n      regexp: \"iPad|Android [4-9]|Silk\\/2\"\n    },\n    desktop: {\n      label: \"Desktop\",\n      regexp: \"^((?!iPad|iPhone|Android|BlackBerry|PlayBook|Silk).)*$\"\n    }\n  };\n\n  Utils.getPlaybackMode = function(mode) {\n    var key, valid, value, _ref;\n    if (mode == null) {\n      mode = ((_ref = QueryString[\"amp-mode\"]) != null ? _ref.toLowerCase() : void 0) || PlaybackMode.HTML_AUTO;\n    }\n    valid = false;\n    for (key in PlaybackMode) {\n      value = PlaybackMode[key];\n      if (value === mode) {\n        valid = true;\n        break;\n      }\n    }\n    if (!valid) {\n      mode = PlaybackMode.AUTO;\n    }\n    if (mode === PlaybackMode.HTML_AUTO) {\n      mode = this.isHTMLFirst() ? PlaybackMode.HTML : PlaybackMode.AUTO;\n    }\n    if (mode !== PlaybackMode.AUTO) {\n      if (mode === PlaybackMode.FLASH && !this.hasFlash()) {\n        mode = PlaybackMode.NONE;\n      }\n      return mode;\n    }\n    if (!this.hasFlash()) {\n      mode = this.supportsHTML5Video() ? PlaybackMode.HTML : PlaybackMode.NONE;\n    }\n    if (mode === PlaybackMode.AUTO) {\n      mode = this.isHTML5() ? PlaybackMode.HTML : PlaybackMode.FLASH;\n    }\n    return mode;\n  };\n\n  Utils.getIEVersion = function() {\n    var re, rv, ua;\n    rv = -1;\n    ua = navigator.userAgent;\n    if (navigator.appName === 'Microsoft Internet Explorer') {\n      re = new RegExp(\"MSIE ([0-9]{1,}[\\.0-9]{0,})\");\n    } else if (navigator.appName === 'Netscape') {\n      re = new RegExp(\"Trident/.*rv:([0-9]{1,}[\\.0-9]{0,})\");\n    } else if (/Edge\\/[0-9\\.]+$/.test(ua)) {\n      re = /Edge\\/([0-9\\.]+)/;\n    }\n    if ((re != null ? re.exec(ua) : void 0) != null) {\n      rv = parseFloat(RegExp.$1);\n    }\n    return rv;\n  };\n\n  Utils.getFFVersion = function() {\n    var rv, ua;\n    rv = -1;\n    ua = navigator.userAgent;\n    if (/Firefox\\/([0-9\\.]+)$/.exec(ua)) {\n      rv = parseFloat(RegExp.$1);\n    }\n    return rv;\n  };\n\n  Utils.getSafariVersion = function() {\n    var rv, ua;\n    rv = -1;\n    ua = navigator.userAgent;\n    if (/Safari\\/[0-9\\.]+$/.test(ua) && (/Version\\/([0-9])/.exec(ua) != null)) {\n      rv = parseFloat(RegExp.$1);\n    }\n    return rv;\n  };\n\n  Utils.isChrome = function() {\n    return /Chrom(e|ium)/.test(navigator.userAgent);\n  };\n\n  Utils.isHTMLFirst = function() {\n    return window.MediaSource != null;\n  };\n\n  Utils.mergeRules = function(rules) {\n    var id, rule, _results;\n    _results = [];\n    for (id in rules) {\n      rule = rules[id];\n      _results.push(Utils.rules[id] = rule);\n    }\n    return _results;\n  };\n\n  Utils.checkRules = function(rules) {\n    var id, regExp, rule, _i, _len;\n    if ((rules != null) && rules.length > 0) {\n      for (_i = 0, _len = rules.length; _i < _len; _i++) {\n        id = rules[_i];\n        if (!(rule = Utils.rules[id])) {\n          continue;\n        }\n        regExp = new RegExp(rule.regexp);\n        if (regExp.test(navigator.userAgent)) {\n          return true;\n        }\n      }\n    }\n    return false;\n  };\n\n  Utils.selectSource = function(sources, canPlayType) {\n    var item, _i, _j, _len, _len1;\n    for (_i = 0, _len = sources.length; _i < _len; _i++) {\n      item = sources[_i];\n      if (Utils.checkRules(item.rules)) {\n        return item;\n      }\n    }\n    for (_j = 0, _len1 = sources.length; _j < _len1; _j++) {\n      item = sources[_j];\n      if (canPlayType(item.type || Utils.getMimeType(item.src)) !== \"\") {\n        return item;\n      }\n    }\n    return null;\n  };\n\n  Utils.getMimeType = function(file) {\n    return this.mimeTypes[Utils.getFileExtension(file)];\n  };\n\n  Utils.selectTrack = function(tracks, kind) {\n    var item, track, _i, _len;\n    for (_i = 0, _len = tracks.length; _i < _len; _i++) {\n      item = tracks[_i];\n      if (!(item.kind === kind)) {\n        continue;\n      }\n      track = item;\n      break;\n    }\n    return track;\n  };\n\n  Utils.isIPhone = function() {\n    return /iPhone/.test(navigator.platform) || /iPhone/.test(navigator.userAgent);\n  };\n\n  Utils.isIPad = function() {\n    return /iPad/.test(navigator.platform) || /iPad/.test(navigator.userAgent);\n  };\n\n  Utils.isAndroid = function() {\n    return /Android [4-9]/.test(navigator.userAgent);\n  };\n\n  Utils.isKindleFireHD = function() {\n    return /Silk\\/2/.test(navigator.userAgent);\n  };\n\n  Utils.isKindleFire = function() {\n    return /Silk\\/1/.test(navigator.userAgent);\n  };\n\n  Utils.isBlackBerry = function() {\n    return /BlackBerry;|PlayBook|BB10/.test(navigator.userAgent);\n  };\n\n  Utils.isFirefoxOS = function() {\n    return /\\(Mobile;.*Firefox\\//.test(navigator.userAgent);\n  };\n\n  Utils.supportsHTML5Video = function() {\n    var video;\n    video = document.createElement(\"video\");\n    return video.canPlayType != null;\n  };\n\n  Utils.isHTML5 = function() {\n    return this.isIOS() || this.isAndroid() || this.isKindleFireHD() || this.isBlackBerry() || this.isFirefoxOS();\n  };\n\n  Utils.isIOS = function() {\n    var iOSRegEx, isIOS;\n    iOSRegEx = /iPad|iPhone|iPod/i;\n    return isIOS = iOSRegEx.test(navigator.platform) || iOSRegEx.test(navigator.userAgent);\n  };\n\n  Utils.getIOSversion = function() {\n    var ver;\n    if (/iP(hone|od|ad)/.test(navigator.platform)) {\n      ver = navigator.appVersion.match(/OS (\\d+)_(\\d+)_?(\\d+)?/);\n      return [parseInt(ver[1], 10), parseInt(ver[2], 10), parseInt(ver[3] || 0, 10)];\n    }\n  };\n\n  Utils.hasFlash = function() {\n    var hasFlash;\n    try {\n      hasFlash = Boolean(new ActiveXObject(\"ShockwaveFlash.ShockwaveFlash\"));\n    } catch (error) {\n      hasFlash = \"undefined\" !== typeof navigator.mimeTypes[\"application/x-shockwave-flash\"];\n    }\n    return hasFlash;\n  };\n\n  Utils.isFullscreenDevice = function() {\n    return this.isKindleFireHD() || this.isIPhone();\n  };\n\n  Utils.getDevice = function() {\n    var device;\n    device = \"desktop\";\n    if (this.isIPhone()) {\n      device = \"iphone\";\n    } else if (this.isIPad()) {\n      device = \"ipad\";\n    } else if (/Android/.test(navigator.userAgent)) {\n      device = \"android\";\n    } else if (this.isKindleFireHD()) {\n      device = \"kindlefirehd\";\n    } else if (this.isKindleFire()) {\n      device = \"kindlefire\";\n    }\n    return device;\n  };\n\n  Utils.xmlToJson = function(xml) {\n    var attribute, child, element, index, nodeName, obj, _i, _j, _len, _len1, _ref, _ref1;\n    obj = {};\n    if (xml.nodeType === 9) {\n      xml = xml.firstChild;\n    }\n    if (xml.nodeType === 1) {\n      if (xml.attributes.length > 0) {\n        obj[\"@attributes\"] = {};\n        _ref = xml.attributes;\n        for (index = _i = 0, _len = _ref.length; _i < _len; index = ++_i) {\n          attribute = _ref[index];\n          obj[\"@attributes\"][attribute.nodeName] = attribute.nodeValue;\n        }\n      }\n    } else if (xml.nodeType === 3 || xml.nodeType === 4) {\n      obj = xml.nodeValue;\n    }\n    if (xml.hasChildNodes()) {\n      _ref1 = xml.childNodes;\n      for (index = _j = 0, _len1 = _ref1.length; _j < _len1; index = ++_j) {\n        child = _ref1[index];\n        if (child.nodeType === 3 && !/\\S/.test(child.nodeValue)) {\n          continue;\n        }\n        nodeName = child.nodeName.replace(/:/, \"-\");\n        element = this.xmlToJson(child);\n        if (!(element[\"@attributes\"] != null) && (element[\"#text\"] != null)) {\n          element = element[\"#text\"];\n        }\n        if (!(obj[nodeName] != null)) {\n          obj[nodeName] = element;\n        } else {\n          if (!(obj[nodeName] instanceof Array)) {\n            obj[nodeName] = [obj[nodeName]];\n          }\n          obj[nodeName].push(element);\n        }\n      }\n    }\n    return obj;\n  };\n\n  /**\n   * Returns a platform specific XHR object.\n   *\n   * @static\n  */\n  Utils.getXHR = function() {\n    return new XHR();\n  };\n\n  /**\n   * Retrieves a remote text file\n   *\n   * @static\n  */\n  Utils.get = function(url, client, headers) {\n    var xhr;\n    if (client == null) {\n      client = {};\n    }\n    if (headers == null) {\n      headers = null;\n    }\n    xhr = Utils.getXHR();\n    if (client != null) {\n      if (client.withCredentials != null) {\n        xhr.withCredentials = client.withCredentials;\n      }\n      if (client.onload != null) {\n        xhr.onload = client.onload;\n      }\n      if (client.onerror != null) {\n        xhr.onerror = client.onerror;\n      }\n    }\n    xhr.open(\"GET\", url);\n    if (headers != null) {\n      xhr.setRequestHeaders(headers);\n    }\n    xhr.send();\n    return xhr;\n  };\n\n  /**\n   * Retrieves a remote text file\n   *\n   * @static\n  */\n  Utils.getUTC = function(oncomplete, onerror) {\n    var client,\n      _this = this;\n    if (typeof oncomplete !== \"function\") {\n      return;\n    }\n    try {\n      client = {\n        onload: function(event) {\n          oncomplete(parseInt(event.target.responseText) * 1000);\n        },\n        onerror: onerror\n      };\n      this.get(\"//time.akamai.com\", client);\n    } catch (error) {\n      onerror(error);\n    }\n  };\n\n  /**\n   * Posts a string to NetStorage.\n   *\n   * @static\n  */\n  Utils.send = function(url, data, client, headers) {\n    var xhr;\n    if (client == null) {\n      client = {};\n    }\n    if (headers == null) {\n      headers = {\n        \"Content-Type\": \"String\"\n      };\n    }\n    xhr = Utils.getXHR();\n    if (client.onload != null) {\n      xhr.onload = client.onload;\n    }\n    if (client.onerror != null) {\n      xhr.onerror = client.onerror;\n    }\n    xhr.open(\"POST\", url);\n    if (headers != null) {\n      xhr.setRequestHeaders(headers);\n    }\n    xhr.send(data);\n    return xhr;\n  };\n\n  /**\n   * Request an http resource\n   *\n   * @static\n  */\n  Utils.request = function(options) {\n    var _this = this;\n    if (options == null) {\n      options = {};\n    }\n    return new Promise(function(resolve, reject) {\n      var xhr;\n      if (typeof options === \"string\") {\n        options = {\n          url: options\n        };\n      }\n      if (!(options.method != null)) {\n        options.method = \"GET\";\n      }\n      xhr = Utils.getXHR();\n      xhr.withCredentials = options.withCredentials;\n      xhr.onload = function() {\n        return resolve(xhr);\n      };\n      xhr.onerror = reject;\n      xhr.open(options.method, options.url);\n      if (options.headers != null) {\n        xhr.setRequestHeaders(options.headers);\n      }\n      return xhr.send(options.data);\n    });\n  };\n\n  /**\n   * Attaches a JavaScript file to the head of the document.\n   *\n   * @static\n  */\n  Utils.loadScript = function(src, onload, parent, onerror) {\n    var head, script;\n    head = parent || document.getElementsByTagName(\"head\")[0];\n    script = document.createElement(\"script\");\n    script.type = 'text/javascript';\n    if (onload != null) {\n      if (script.addEventListener) {\n        script.onload = onload;\n        if (onerror != null) {\n          script.onerror = onerror;\n        }\n      } else if (script.readyState) {\n        script.onreadystatechange = function(event) {\n          if (this.readyState === 'loaded' || this.readyState === 'complete') {\n            this.onreadystatechange = null;\n            onload();\n          }\n        };\n      }\n    }\n    script.src = src;\n    head.appendChild(script);\n    return script;\n  };\n\n  /**\n   * Attaches a CSS file to the head of the document.\n   *\n   * @static\n  */\n  Utils.loadStyleSheet = function(href) {\n    var head, link;\n    head = document.getElementsByTagName(\"head\")[0];\n    link = document.createElement(\"link\");\n    link.rel = \"stylesheet\";\n    link.type = 'text/css';\n    link.href = href;\n    return head.appendChild(link);\n  };\n\n  Utils.read = function(url, client, type, headers) {\n    var text, xhr;\n    if (client == null) {\n      client = {};\n    }\n    if (type == null) {\n      type = \"\";\n    }\n    if (headers == null) {\n      headers = [];\n    }\n    try {\n      xhr = this.get(url, client, headers);\n      text = xhr.responseText || xhr.text;\n      if (type === Utils.mimeTypes.json) {\n        return JSON.parse(text);\n      } else if ((type === Utils.mimeTypes.xml) && (xhr.responseXML != null)) {\n        return xhr.responseXML;\n      } else {\n        return text;\n      }\n    } catch (error) {\n      if (typeof console !== \"undefined\" && console !== null) {\n        if (typeof console.error === \"function\") {\n          console.error(\"Read Error: \", error);\n        }\n      }\n      return null;\n    }\n  };\n\n  Utils.getFileExtension = function(url) {\n    return url.replace(/\\?.*/, \"\").split('.').pop();\n  };\n\n  Utils.getResponseHeader = function(url, header, client) {\n    var xhr;\n    if (client == null) {\n      client = {};\n    }\n    xhr = Utils.getXHR();\n    if (client.onerror != null) {\n      xhr.onerror = client.onerror;\n    }\n    xhr.open(\"HEAD\", url, false);\n    xhr.send();\n    return xhr.getResponseHeader(header);\n  };\n\n  Utils.getResponseHeaders = function(url, headers, client) {\n    var header, results, xhr, _i, _len;\n    if (client == null) {\n      client = {};\n    }\n    xhr = Utils.getXHR();\n    if (client.onerror != null) {\n      xhr.onerror = client.onerror;\n    }\n    xhr.open(\"HEAD\", url, false);\n    xhr.send();\n    results = {};\n    if (!(headers != null)) {\n      return xhr.getAllResponseHeaders();\n    }\n    for (_i = 0, _len = headers.length; _i < _len; _i++) {\n      header = headers[_i];\n      results[header] = xhr.getResponseHeader(header);\n    }\n    return results;\n  };\n\n  /**\n   * Determines if the device supports touch events\n   *\n   * @static\n  */\n  Utils.isTouch = null;\n\n  /**\n   * Determines if the device supports touch events\n   *\n   * @static\n  */\n  Utils.isTouchDevice = function() {\n    if (!(this.isTouch != null)) {\n      try {\n        document.createEvent(\"TouchEvent\");\n        this.isTouch = true;\n      } catch (error) {\n        this.isTouch = false;\n      }\n    }\n    return this.isTouch;\n  };\n\n  /**\n   * Forces a number between a min and a max\n   *\n   * @static\n  */\n  Utils.clamp = function(value, min, max) {\n    if (value < min) {\n      value = min;\n    }\n    if (value > max) {\n      value = max;\n    }\n    return value;\n  };\n\n  /**\n   * Beacons a url via an img tag\n   *\n   * @static\n  */\n  Utils.beacon = function(url, beaconId) {\n    var beaconImg;\n    if (beaconId == null) {\n      beaconId = \"beaconId\";\n    }\n    beaconImg = document.getElementById(beaconId);\n    if (!(beaconImg != null)) {\n      beaconImg = document.createElement(\"img\");\n      beaconImg.setAttribute(\"id\", beaconId);\n      beaconImg.setAttribute(\"height\", 0);\n      beaconImg.setAttribute(\"width\", 0);\n      document.body.appendChild(beaconImg);\n      beaconImg.style.display = \"none\";\n    }\n    beaconImg.setAttribute(\"src\", url);\n    return beaconImg;\n  };\n\n  /**\n   * Calculates offset Left and Top\n   *\n   * @static\n  */\n  Utils.getElementOffset = function(element, root) {\n    var height, left, scrollLeft, scrollTop, top, width;\n    if (root == null) {\n      root = document.fullscreenElement || document.webkitFullscreenElement || document.mozFullscreenElement;\n    }\n    left = 0;\n    top = 0;\n    width = element.offsetWidth;\n    height = element.offsetHeight;\n    while (element && element !== root) {\n      if (element.tagName === \"BODY\") {\n        scrollLeft = element.scrollLeft || document.documentElement.scrollLeft;\n        scrollTop = element.scrollTop || document.documentElement.scrollTop;\n        left += element.offsetLeft - scrollLeft + element.clientLeft;\n        top += element.offsetTop - scrollTop + element.clientTop;\n      } else {\n        left += element.offsetLeft - element.scrollLeft + element.clientLeft;\n        top += element.offsetTop - element.scrollTop + element.clientTop;\n      }\n      element = element.offsetParent;\n    }\n    return {\n      left: left,\n      top: top,\n      width: width,\n      height: height\n    };\n  };\n\n  /**\n   * Override the properties of a base object with the values\n   * of an override object.\n   *\n   * @param {Object} base     The base object.\n   * @param {Object} overrides  key/value overrides\n   * @return {Object}\n   * @static\n  */\n  Utils.override = function(base, overrides, clone) {\n    var key, value;\n    if (clone == null) {\n      clone = true;\n    }\n    if (!(base != null)) {\n      return overrides;\n    }\n    if (!(overrides != null)) {\n      return base;\n    }\n    if (clone === true) {\n      base = Utils.clone(base);\n      overrides = Utils.clone(overrides);\n    }\n    for (key in overrides) {\n      value = overrides[key];\n      if (typeof value === \"object\" && value !== null) {\n        if (base[key] == null) {\n          base[key] = value instanceof Array ? [] : {};\n        }\n        base[key] = Utils.override(base[key], value, false);\n      } else {\n        base[key] = value;\n      }\n    }\n    return base;\n  };\n\n  /**\n   * Clones an object.\n   *\n   * @param {Object} obj The object to be cloned.\n   * @return {Object}\n   * @static\n  */\n  Utils.clone = function(obj, deepCopy) {\n    var clone, item, k, key, v, value, _i, _len;\n    if (deepCopy == null) {\n      deepCopy = true;\n    }\n    if (!(obj != null)) {\n      return obj;\n    }\n    if (typeof obj !== \"object\") {\n      clone = obj;\n    } else {\n      if (obj instanceof Array) {\n        clone = [];\n      } else {\n        clone = {};\n      }\n      for (key in obj) {\n        value = obj[key];\n        if (typeof value === \"object\" && value !== null && deepCopy === true) {\n          if (value instanceof Array) {\n            clone[key] = [];\n            for (_i = 0, _len = value.length; _i < _len; _i++) {\n              item = value[_i];\n              clone[key].push(this.clone(item));\n            }\n          } else {\n            clone[key] = {};\n            for (k in value) {\n              v = value[k];\n              clone[key][k] = this.clone(v);\n            }\n          }\n        } else {\n          clone[key] = value;\n        }\n      }\n    }\n    return clone;\n  };\n\n  /**\n   * Takes a time in seconds and converts it to timecode.\n   *\n   * @param   {Number}  time  The time in seconds to be formatted.\n   * @return  {String}  A SMTP formatted string.\n  */\n  Utils.formatTimecode = function(time, duration) {\n    var strTime;\n    time = parseInt(time);\n    if (isNaN(time)) {\n      return \"00:00\";\n    }\n    strTime = Utils.formatZeroFill(time % 60);\n    time = parseInt(time / 60);\n    strTime = Utils.formatZeroFill(time % 60) + \":\" + strTime;\n    time = parseInt(time / 60);\n    if (time > 0) {\n      strTime = Utils.formatZeroFill(time) + \":\" + strTime;\n    }\n    if (duration >= 3600 && strTime.length === 5) {\n      strTime = \"00:\" + strTime;\n    }\n    return strTime;\n  };\n\n  /**\n   * Converts a time in seconds to a string and adds a zero in front of any number lower than 10.\n   *\n   * @param Number time The number to be zero filled.\n  */\n  Utils.formatZeroFill = function(time) {\n    var str;\n    str = time.toString();\n    if (time < 10) {\n      str = \"0\" + str;\n    }\n    return str;\n  };\n\n  /**\n   * Converts timecode to seconds.\n   *\n   * @param   {string}  timeCode        A SMTP formatted string.\n   * @param   {number}  [framerate=30]  The frame rate. Used to calculate milliseconds.\n   * @return  {number}                  The number of seconds represented by the time code\n  */\n  Utils.flattenTimecode = function(timeCode, framerate) {\n    var ms, parts, pieces, time;\n    if (framerate == null) {\n      framerate = 30;\n    }\n    if (!(timeCode != null) || timeCode === \"\") {\n      return NaN;\n    }\n    pieces = timeCode.split(\":\");\n    ms = 0;\n    if (pieces.length === 4) {\n      ms = parseInt(pieces.pop()) / framerate;\n    } else if (pieces.length === 3) {\n      pieces[2] = pieces[2].replace(\",\", \".\");\n      if (pieces[2].indexOf(\".\") !== -1) {\n        parts = pieces[2].split(\".\");\n      }\n      if ((parts != null ? parts.length : void 0) > 1) {\n        pieces[2] = parts[0];\n        ms = parseInt(parts[1]) / 1000;\n      }\n    }\n    time = parseInt(pieces.pop());\n    while (pieces.length > 0) {\n      time += Math.pow(60, pieces.length) * parseInt(pieces.shift());\n    }\n    return time + ms;\n  };\n\n  /**\n   * Adds a cache busting query string parameter to a url.\n   *\n   * @param String url The url.\n   * @param String key The name of the query string variable\n   * @param Object value The value of the query string variable\n  */\n  Utils.cacheBust = function(url, key, value) {\n    var op;\n    if (key == null) {\n      key = \"cacheBust\";\n    }\n    if (value == null) {\n      value = Date.now();\n    }\n    op = url.indexOf('?') === -1 ? \"?\" : \"&\";\n    return url + op + key + \"=\" + value;\n  };\n\n  /**\n   * Converts a camel case string in to a CSS proptery name.\n  */\n  Utils.formatStyleName = function(styleName) {\n    return styleName.replace(/([A-Z])/, \"-$1\").toLowerCase();\n  };\n\n  /**\n   * Trims whitespace from the beginning and end of a string\n  */\n  Utils.trim = function(str) {\n    var trim;\n    trim = str.replace(/^\\s*(.*)/, \"$1\");\n    return trim.replace(/(.*)\\s*$/, \"$1\");\n  };\n\n  /**\n  */\n  Utils.getJson = function(url, onload, onerror) {\n    var xhr;\n    xhr = Utils.getXHR();\n    xhr.open(\"GET\", url);\n    xhr.onload = function(event) {\n      var feed;\n      if (xhr.responseType === \"document\") {\n        feed = Utils.xmlToJson(xhr.responseXML);\n      } else {\n        feed = xhr.response;\n      }\n      if (typeof onload === \"function\") {\n        onload(feed);\n      }\n    };\n    xhr.onerror = function(event) {\n      if (typeof onerror === \"function\") {\n        onerror(event);\n      }\n    };\n    xhr.send();\n    return xhr;\n  };\n\n  /**\n  */\n  Utils.getSource = function(url, onload, onerror) {\n    var feedloadedHandler, mode;\n    mode = Utils.getPlaybackMode();\n    feedloadedHandler = function(feed) {\n      var canPlayType, helper, source, _ref;\n      helper = new MRSSHelper();\n      feed = helper.createFeed(feed);\n      if ((feed != null ? (_ref = feed.item) != null ? _ref.length : void 0 : void 0) > 0) {\n        canPlayType = function(type) {\n          if ((mode === \"flash\" && Utils.flashTypes.indexOf(type) !== -1) || (mode === \"html\" && Utils.flashTypes.indexOf(type) === -1)) {\n            return \"maybe\";\n          } else {\n            return \"\";\n          }\n        };\n        source = Utils.selectSource(feed.item[0].source, canPlayType);\n      }\n      if (typeof onload === \"function\") {\n        onload(source);\n      }\n    };\n    Utils.getJson(url, feedloadedHandler, onerror);\n  };\n\n  /**\n  */\n  Utils.trackMouse = function() {\n    try {\n      if (document.addEventListener != null) {\n        document.addEventListener(\"mousemove\", this.mouseTracker);\n      } else if (document.attachEvent != null) {\n        document.attachEvent(\"mousemove\", this.mouseTracker);\n      }\n    } catch (error) {\n\n    }\n  };\n\n  Utils.clientX = 0;\n\n  Utils.clientY = 0;\n\n  Utils.pageX = 0;\n\n  Utils.pageY = 0;\n\n  /**\n  */\n  Utils.mouseTracker = function(event) {\n    Utils.clientX = event.clientX;\n    Utils.clientY = event.clientY;\n    Utils.pageX = event.pageX;\n    Utils.pageY = event.pageY;\n  };\n\n  /**\n  */\n  Utils.isMouseOverElement = function(element) {\n    var isOver;\n    isOver = false;\n    if (!(element != null)) {\n      return isOver;\n    }\n    try {\n      isOver = element.contains(document.elementFromPoint(Utils.clientX, Utils.clientY));\n    } catch (error) {\n      isOver = false;\n    }\n    return isOver;\n  };\n\n  Utils.trackMouse();\n\n  /** Function to get Outer Dimensions\n  */\n  Utils.getActualSize = function(element, margin) {\n    var height, style, width;\n    if (margin == null) {\n      margin = true;\n    }\n    width = element.offsetWidth;\n    height = element.offsetHeight;\n    if (margin === true) {\n      style = getComputedStyle(element);\n      width += parseInt(style.marginLeft) + parseInt(style.marginRight);\n      height += parseInt(style.marginTop) + parseInt(style.marginBottom);\n    }\n    return {\n      \"width\": width,\n      \"height\": height\n    };\n  };\n\n  Utils.isVolumeSettable = function() {\n    var noVolume, ua;\n    ua = navigator.userAgent.toLowerCase();\n    noVolume = /ipad|iphone|ipod|android|blackberry|windows ce|windows phone|webos|playbook/.exec(ua);\n    if (noVolume != null) {\n      if (noVolume[0] === \"android\" && /Firefox/.test(ua)) {\n        return true;\n      } else {\n        return false;\n      }\n    }\n    return true;\n  };\n\n  /**\n   * Creates a flash object tag.\n   *\n   * @param {string} swf\n   *    The number to be zero filled.\n   *\n   * @param {Object} flashvars\n   *\n   * @return {HTMLObjectElement}\n   *    The flash object tag.\n   *\n   * @static\n  */\n  Utils.createFlashObject = function(flash) {\n    var atts, id, key, object, param, params, value, vars, _ref, _ref1;\n    if (!(flash != null)) {\n      return;\n    }\n    params = {\n      allowFullScreen: true,\n      allowScriptAccess: \"always\",\n      wmode: \"direct\",\n      bgColor: \"#000000\"\n    };\n    Utils.override(params, flash.params, false);\n    if (params.wmode === \"direct\" && /MSIE/.test(navigator.userAgent)) {\n      params.wmode = \"transparent\";\n    }\n    id = ((_ref = flash.attributes) != null ? _ref.id : void 0) || this.createUUID();\n    atts = {\n      id: id,\n      name: id,\n      width: \"100%\",\n      height: \"100%\",\n      type: \"application/x-shockwave-flash\"\n    };\n    Utils.override(atts, flash.attributes, false);\n    object = document.createElement(\"object\");\n    for (key in atts) {\n      value = atts[key];\n      object.setAttribute(key, value);\n    }\n    for (key in params) {\n      value = params[key];\n      value = params[key];\n      param = document.createElement(\"param\");\n      param.setAttribute(\"name\", key);\n      param.setAttribute(\"value\", value);\n      object.appendChild(param);\n    }\n    if (flash.vars != null) {\n      vars = [];\n      _ref1 = flash.vars;\n      for (key in _ref1) {\n        value = _ref1[key];\n        vars.push(\"\" + key + \"=\" + value);\n      }\n      value = vars.join(\"&\");\n      param = document.createElement(\"param\");\n      param.setAttribute(\"name\", \"flashvars\");\n      param.setAttribute(\"value\", value);\n      object.appendChild(param);\n    }\n    return object;\n  };\n\n  /**\n   * The AMPConfig class\n   *\n   * @constructor\n   * @private\n   * @extends {EventDispatcher}\n  */\n  function AMPConfig() {\n    AMPConfig.__super__.constructor.call(this, this, false);\n  }\n\n\n  __extends(AMPConfig, EventDispatcher);\n\n\n  AMPConfig.UNINITIALIZED = 0;\n\n  AMPConfig.LOADING = 1;\n\n  AMPConfig.LOADED = 2;\n\n  /**\n   * Converst XML to a native JS object\n   *\n   * @param   {Element} xml   The XML to convert\n   * @return  {Object}\n   * @static\n  */\n  AMPConfig.parseModule = function(xml) {\n    var child, childNodes, count, i, k, node, obj, _i, _len;\n    obj = {};\n    i = 0;\n    childNodes = xml.childNodes;\n    count = childNodes.length;\n    k = 0;\n    node = null;\n    child = null;\n    for (_i = 0, _len = childNodes.length; _i < _len; _i++) {\n      node = childNodes[_i];\n      if ((node != null ? node.nodeType : void 0) === 1) {\n        obj[node.nodeName] = this.parseItem(node);\n      }\n    }\n    return obj;\n  };\n\n  AMPConfig.parseItem = function(node) {\n    var child, children, type, value, _i, _len;\n    type = (\"\" + (node.getAttribute('type'))).toLowerCase();\n    value = node.textContent || node.text || node.innerText;\n    if (type !== \"object\" && type !== \"array\" && /#\\{.*\\}/.test(value)) {\n      return value;\n    }\n    switch (type) {\n      case \"object\":\n        value = this.parseModule(node);\n        break;\n      case \"array\":\n        value = [];\n        children = node.childNodes;\n        for (_i = 0, _len = children.length; _i < _len; _i++) {\n          child = children[_i];\n          if (child.nodeType !== 1) {\n            continue;\n          }\n          value.push(this.parseItem(child));\n        }\n        break;\n      case \"boolean\":\n        value = value.toLowerCase() === \"true\";\n        break;\n      case \"number\":\n        value = parseFloat(value);\n    }\n    return value;\n  };\n\n  AMPConfig.prototype.url = null;\n\n  AMPConfig.prototype.data = null;\n\n  AMPConfig.prototype.xml = null;\n\n  AMPConfig.prototype.readyState = AMPConfig.UNINITIALIZED;\n\n  AMPConfig.prototype.loaded = false;\n\n  AMPConfig.prototype.flash = {\n    PlaybackMetricsPlugin: {\n      src: '#{paths.resources}plugins/PlaybackMetricsPlugin.swf',\n      blocking: false,\n      host: \"akamai\",\n      main: \"PlaybackMetricsPlugin\"\n    },\n    SubclipMonitorPlugin: {\n      src: '#{paths.resources}plugins/SubclipMonitorPlugin.swf',\n      blocking: false,\n      host: \"akamai\",\n      main: \"SubclipMonitorPlugin\"\n    },\n    NetSessionClientPlugin: {\n      src: '#{paths.resources}plugins/NetSessionClientPlugin.swf',\n      blocking: false,\n      host: \"akamai\",\n      main: \"NetSessionClientPlugin\"\n    }\n  };\n\n  /**\n  */\n  AMPConfig.prototype.loadURL = function(url, withCredentials) {\n    var xhr,\n      _this = this;\n    if (withCredentials == null) {\n      withCredentials = false;\n    }\n    this.url = url;\n    this.setReadyState(AMPConfig.LOADING);\n    xhr = Utils.get(url, {\n      withCredentials: withCredentials,\n      onload: function(event) {\n        var data, firstChild, xmlhttp;\n        xmlhttp = event.detail;\n        if (xmlhttp.responseType === \"document\") {\n          _this.xml = xmlhttp.responseXML;\n          firstChild = _this.xml.firstChild.nodeType !== 7 ? _this.xml.firstChild : _this.xml.childNodes[1];\n          data = AMPConfig.parseModule(firstChild);\n        } else {\n          data = xmlhttp.response;\n          if (typeof data === \"string\") {\n            data = JSON.parse(data);\n          }\n        }\n        _this.loadData(data);\n      },\n      onerror: function(event) {\n        _this.dispatchEvent(new Event(\"error\", event));\n        Logger.error(event);\n      }\n    });\n  };\n\n  /**\n  */\n  AMPConfig.prototype.loadData = function(data) {\n    Config.defaults = data;\n    this.setReadyState(AMPConfig.LOADED);\n  };\n\n  /**\n  */\n  AMPConfig.prototype.load = function(resource, withCredentials) {\n    if (withCredentials == null) {\n      withCredentials = false;\n    }\n    switch (typeof resource) {\n      case \"object\":\n        this.loadData(resource);\n        break;\n      case \"string\":\n        this.loadURL(resource, withCredentials);\n        break;\n      default:\n        throw new Error(\"[AMP ERROR] Invalid default configuration resource\");\n    }\n  };\n\n  /**\n  */\n  AMPConfig.prototype.setReadyState = function(state) {\n    this.readyState = state;\n    this.dispatchEvent(new Event(\"readystatechange\", state));\n    if (state === AMPConfig.LOADED && !this.loaded) {\n      this.loaded = true;\n      this.dispatchEvent(new Event(\"load\", this.data));\n    }\n  };\n\n  /**\n   * @constructor\n   * @private\n  */\n  function OverlayMediator() {\n    OverlayMediator.__super__.constructor.call(this, null, null, null, null);\n  }\n\n\n  __extends(OverlayMediator, ComponentMediator);\n\n\n  OverlayMediator.prototype.componentType = \"overlay\";\n\n  /**\n   * Registers the overlay.\n   *\n   * @override\n  */\n  OverlayMediator.prototype.onRegister = function() {\n    OverlayMediator.__super__.onRegister.call(this);\n    this.registerOverlay();\n  };\n\n  /**\n   * Removes the overlay.\n   *\n   * @override\n  */\n  OverlayMediator.prototype.onRemove = function() {\n    OverlayMediator.__super__.onRemove.call(this);\n    this.removeOverlay();\n  };\n\n  /**\n   *\n  */\n  OverlayMediator.prototype.registerOverlay = function() {\n    this.sendNotification(Notifications.ADD_OVERLAY, this.viewComponent);\n  };\n\n  /**\n   *\n  */\n  OverlayMediator.prototype.removeOverlay = function() {\n    this.sendNotification(Notifications.REMOVE_OVERLAY, this.viewComponent);\n  };\n\n  function IdleUtil(element, timeout) {\n    this.element = element;\n    this.timeout = timeout;\n    IdleUtil.__super__.constructor.call(this);\n    this.resetHandler = this.reset.bind(this);\n  }\n\n\n  __extends(IdleUtil, EventDispatcher);\n\n\n  IdleUtil.prototype.events = [\"mousemove\", \"mousedown\", \"keypress\", \"DOMMouseScroll\", \"mousewheel\", \"touchmove\", \"MSPointerMove\"];\n\n  IdleUtil.prototype.resetHandler = null;\n\n  IdleUtil.prototype.element = null;\n\n  IdleUtil.prototype.timeout = null;\n\n  IdleUtil.prototype.active = true;\n\n  IdleUtil.prototype.timeoutId = null;\n\n  IdleUtil.prototype.applyListeners = function(action) {\n    var event, _i, _len, _ref;\n    if (action == null) {\n      action = \"add\";\n    }\n    _ref = this.events;\n    for (_i = 0, _len = _ref.length; _i < _len; _i++) {\n      event = _ref[_i];\n      this.element[\"\" + action + \"EventListener\"](event, this.resetHandler);\n    }\n  };\n\n  IdleUtil.prototype.start = function(timeout) {\n    if (timeout != null) {\n      this.timeout = timeout;\n    }\n    this.stop();\n    this.applyListeners(\"add\");\n    this.timeoutId = setTimeout(this.setActive.bind(this, false), this.timeout);\n  };\n\n  IdleUtil.prototype.stop = function() {\n    this.applyListeners(\"remove\");\n    clearTimeout(this.timeoutId);\n  };\n\n  IdleUtil.prototype.reset = function() {\n    this.setActive(true);\n    this.start();\n  };\n\n  IdleUtil.prototype.setActive = function(value) {\n    if (value === this.active) {\n      return;\n    }\n    this.active = value;\n    this.dispatchEvent(new Event(\"activechange\", {\n      active: this.active\n    }));\n    return value;\n  };\n\n  IdleUtil.prototype.getActive = function() {\n    return this.active;\n  };\n\n  function LocalizationConstants() {}\n\n  LocalizationConstants.MSG_LIVE = \"MSG_LIVE\";\n\n  LocalizationConstants.MSG_REPLAY = \"MSG_REPLAY\";\n\n  LocalizationConstants.MSG_BUFFERING = \"MSG_BUFFERING_TEXT\";\n\n  LocalizationConstants.MSG_CC = \"MSG_CC\";\n\n  LocalizationConstants.MSG_CC_TITLE = \"MSG_CC_TITLE\";\n\n  LocalizationConstants.MSG_CC_LANGUAGE = \"MSG_CC_LANGUAGE\";\n\n  LocalizationConstants.MSG_CC_PRESETS = \"MSG_CC_PRESETS\";\n\n  LocalizationConstants.MSG_CC_FONT = \"MSG_CC_FONT\";\n\n  LocalizationConstants.MSG_CC_EDGE = \"MSG_CC_EDGE\";\n\n  LocalizationConstants.MSG_CC_SIZE = \"MSG_CC_SIZE\";\n\n  LocalizationConstants.MSG_CC_SCROLL = \"MSG_CC_SCROLL\";\n\n  LocalizationConstants.MSG_CC_COLOR = \"MSG_CC_COLOR\";\n\n  LocalizationConstants.MSG_CC_BACKGROUND = \"MSG_CC_BACKGROUND\";\n\n  LocalizationConstants.MSG_CC_EDGE = \"MSG_CC_EDGE\";\n\n  LocalizationConstants.MSG_CC_WINDOW = \"MSG_CC_WINDOW\";\n\n  LocalizationConstants.MSG_CC_OPACITY = \"MSG_CC_OPACITY\";\n\n  LocalizationConstants.MSG_CC_SHOW_ADVANCED = \"MSG_CC_SHOW_ADVANCED\";\n\n  LocalizationConstants.MSG_CC_HIDE_ADVANCED = \"MSG_CC_HIDE_ADVANCED\";\n\n  LocalizationConstants.MSG_CC_RESET = \"MSG_CC_RESET\";\n\n  LocalizationConstants.MSG_CC_CANCEL = \"MSG_CC_CANCEL\";\n\n  LocalizationConstants.MSG_CC_APPLY = \"MSG_CC_APPLY\";\n\n  LocalizationConstants.MSG_CC_PREVIEW_TEXT = \"MSG_CC_PREVIEW_TEXT\";\n\n  LocalizationConstants.MSG_SECONDS = \"MSG_SECONDS\";\n\n  LocalizationConstants.MSG_RECOMMENDATIONS_TITLE = \"MSG_RECOMMENDATIONS_TITLE\";\n\n  LocalizationConstants.MSG_NEXT_VIDEO = \"MSG_NEXT_VIDEO\";\n\n  LocalizationConstants.MSG_NEXT_AD = \"MSG_NEXT_AD\";\n\n  LocalizationConstants.MSG_TIME_SEPARATOR = \"MSG_TIME_SEPARATOR\";\n\n  LocalizationConstants.MSG_VIEW_ALL = \"MSG_VIEW_ALL\";\n\n  LocalizationConstants.MSG_VIDEO = \"MSG_VIDEO\";\n\n  /**\n   * @param {FlashPlayer} player\n   * @param {Object} config\n   * @constructor\n   * @private\n   * @extends {puremvc.Mediator}\n  */\n  function PluginWrapper(player, config) {\n    this.player = player;\n    this.config = config;\n    PluginWrapper.__super__.constructor.call(this);\n    this.dispatcher = new EventDispatcher(this);\n    this.createDefaults();\n  }\n\n\n  __extends(PluginWrapper, puremvc.Mediator);\n\n\n  PluginWrapper.NAME = \"PluginWrapper\";\n\n  PluginWrapper.prototype.player = null;\n\n  PluginWrapper.prototype.config = null;\n\n  PluginWrapper.prototype.dispatcher = null;\n\n  PluginWrapper.prototype.flashPlugins = null;\n\n  PluginWrapper.prototype.createFlashVars = null;\n\n  PluginWrapper.prototype.createXML = null;\n\n  PluginWrapper.prototype.createDefaults = function() {\n    this.player.createDefaults.call(this);\n  };\n\n  /**\n  */\n  PluginWrapper.prototype.addEventListener = function(type, func) {\n    this.dispatcher.addEventListener(type, func);\n  };\n\n  PluginWrapper.prototype.logEvent = function(event) {};\n\n  /**\n  */\n  PluginWrapper.prototype.dispatchEvent = function(event) {\n    if (event.type !== \"timeupdate\" && event.type !== \"timeremaining\") {\n      this.player.logger.log(\"[AMP \" + (this.constructor.NAME.replace('Wrapper', '').toUpperCase()) + \" EVENT] \" + event.type, event);\n    }\n    event.player = this.player;\n    this.dispatcher.dispatchEvent(event);\n  };\n\n  /**\n  */\n  PluginWrapper.prototype.removeEventListener = function(type, func) {\n    this.dispatcher.removeEventListener(type, func);\n  };\n\n  /**\n  */\n  PluginWrapper.prototype.createElement = function(xml, id, parent) {\n    var element;\n    element = xml.createElement(\"element\");\n    element.setAttribute(\"id\", id);\n    if (!(parent != null)) {\n      parent = this.getControls(xml).controls;\n    }\n    if (parent != null) {\n      parent.appendChild(element);\n    }\n    return element;\n  };\n\n  /**\n  */\n  PluginWrapper.prototype.createProperty = function(xml, key, value, parent) {\n    var property, text, val;\n    property = xml.createElement(\"property\");\n    property.setAttribute(\"key\", key);\n    if (parent != null) {\n      parent.appendChild(property);\n    }\n    if (value != null) {\n      if (typeof value === \"object\" && !(value instanceof Array)) {\n        for (key in value) {\n          val = value[key];\n          this.createProperty(xml, key, val, property);\n        }\n      } else {\n        text = XMLUtils.createTextContent(xml, value.toString());\n        property.appendChild(text);\n      }\n    }\n    return property;\n  };\n\n  /** @override\n  */\n  PluginWrapper.prototype.listNotificationInterests = function() {\n    return [FlashNotifications.CREATE_FLASH_VARS, FlashNotifications.CREATE_XML];\n  };\n\n  /**\n  */\n  PluginWrapper.prototype.handleNotification = function(notification) {\n    var body, name;\n    name = notification.getName();\n    body = notification.getBody();\n    switch (name) {\n      case FlashNotifications.CREATE_FLASH_VARS:\n        if (typeof this.createFlashVars === \"function\") {\n          this.createFlashVars(body.flashvars);\n        }\n        break;\n      case FlashNotifications.CREATE_XML:\n        if (typeof this.createXML === \"function\") {\n          this.createXML(body.xml);\n        }\n    }\n  };\n\n  /**\n  */\n  PluginWrapper.prototype.destroy = function() {};\n\n  /**\n   * The ControlsPlayCommand class.\n   *\n   * @constructor\n   * @private\n   * @extends {puremvc.SimpleCommand}\n  */\n  function ControlsPlayCommand() {\n    ControlsPlayCommand.__super__.constructor.call(this);\n  }\n\n\n  __extends(ControlsPlayCommand, puremvc.SimpleCommand);\n\n\n  /**\n   * Executes the command.\n   *\n   * @param {puremvc.Notification} notification\n   *    The notification.\n   *\n   * @override\n  */\n  ControlsPlayCommand.prototype.execute = function(notification) {\n    var controls;\n    controls = this.facade.retrieveProxy(ControlsProxy.NAME);\n    controls.start();\n  };\n\n  /**\n   * The ControlsPauseCommand class.\n   *\n   * @constructor\n   * @private\n   * @extends {puremvc.SimpleCommand}\n  */\n  function ControlsPauseCommand() {\n    ControlsPauseCommand.__super__.constructor.call(this);\n  }\n\n\n  __extends(ControlsPauseCommand, puremvc.SimpleCommand);\n\n\n  /**\n   * Executes the command.\n   *\n   * @param {puremvc.Notification} notification\n   *    The notification.\n   *\n   * @override\n  */\n  ControlsPauseCommand.prototype.execute = function(notification) {\n    var controls;\n    controls = this.facade.retrieveProxy(ControlsProxy.NAME);\n    controls.stop();\n  };\n\n  /**\n   * The ControlsActiveStateChangeCommand class.\n   *\n   * @constructor\n   * @private\n   * @extends {puremvc.SimpleCommand}\n  */\n  function ControlsActiveStateChangeCommand() {\n    ControlsActiveStateChangeCommand.__super__.constructor.call(this);\n  }\n\n\n  __extends(ControlsActiveStateChangeCommand, puremvc.SimpleCommand);\n\n\n  /**\n   * Executes the command.\n   *\n   * @param {puremvc.Notification} notification\n   *    The notification.\n   *\n   * @override\n  */\n  ControlsActiveStateChangeCommand.prototype.execute = function(notification) {\n    var app, body, controls;\n    controls = this.facade.retrieveProxy(ControlsProxy.NAME);\n    app = this.facade.player.retrieveProxy(ApplicationStateProxy.NAME);\n    body = notification.getBody();\n    if (body.value === ActiveState.ACTIVE && app.getPlayState() !== PlayState.READY && Utils.getDevice() !== \"desktop\") {\n      controls.start();\n    }\n  };\n\n  /**\n   * @constructor\n   * @private\n   * @extends {amp.player.controller.PlayerCommand}\n  */\n  function PluginCommand() {\n    PluginCommand.__super__.constructor.call(this);\n  }\n\n\n  __extends(PluginCommand, PlayerCommand);\n\n\n  PluginCommand.prototype.plugin = null;\n\n  PluginCommand.prototype.proxy = null;\n\n  /** @override\n  */\n  PluginCommand.prototype.initializeNotifier = function(key) {\n    PluginCommand.__super__.initializeNotifier.call(this, key);\n    this.proxy = this.facade.retrieveProxy(ModuleProxy.NAME);\n    this.plugin = this.facade;\n  };\n\n  /**\n   * The ControlsAdBreakEndCommand class.\n   *\n   * @constructor\n   * @private\n   * @extends {puremvc.SimpleCommand}\n  */\n  function ControlsAdBreakEndCommand() {\n    ControlsAdBreakEndCommand.__super__.constructor.call(this);\n  }\n\n\n  __extends(ControlsAdBreakEndCommand, PluginCommand);\n\n\n  /**\n   * Executes the command.\n   *\n   * @param {puremvc.Notification} notification\n   *    The notification.\n   *\n   * @override\n  */\n  ControlsAdBreakEndCommand.prototype.execute = function(notification) {\n    if (this.plugin.config[\"native\"] === true) {\n      this.player.getMediaElement().controls = true;\n    } else {\n      this.proxy.adBreakEnd();\n    }\n  };\n\n  /**\n   * The ControlsMediaValidatedCommand class.\n   *\n   * @constructor\n   * @private\n   * @extends {puremvc.SimpleCommand}\n  */\n  function ControlsMediaValidatedCommand() {\n    ControlsMediaValidatedCommand.__super__.constructor.call(this);\n  }\n\n\n  __extends(ControlsMediaValidatedCommand, puremvc.SimpleCommand);\n\n\n  /**\n   * Executes the command.\n   *\n   * @param {puremvc.Notification} notification\n   *    The notification.\n   *\n   * @override\n  */\n  ControlsMediaValidatedCommand.prototype.execute = function(notification) {\n    var element, media, src;\n    media = notification.getBody();\n    src = media.poster;\n    element = this.facade.player.getMediaElement();\n    if ((src != null) && src !== \"\") {\n      element.poster = src;\n    }\n    console.log('emlement', element);\n    element.src = media.src;\n    if (this.facade.player.getAutoplay() !== true) {\n      this.facade.applyClickHandler();\n    }\n  };\n\n  /**\n   * The ControlsStartedCommand class.\n   *\n   * @constructor\n   * @private\n   * @extends {puremvc.SimpleCommand}\n  */\n  function ControlsStartedCommand() {\n    ControlsStartedCommand.__super__.constructor.call(this);\n  }\n\n\n  __extends(ControlsStartedCommand, puremvc.SimpleCommand);\n\n\n  /**\n   * Executes the command.\n   *\n   * @param {puremvc.Notification} notification\n   *    The notification.\n   *\n   * @override\n  */\n  ControlsStartedCommand.prototype.execute = function(notification) {\n    this.facade.applyClickHandler(false);\n  };\n\n  /**\n   * The ControlsActiveStateChangeCommand class.\n   *\n   * @constructor\n   * @private\n   * @extends {puremvc.SimpleCommand}\n  */\n  function ControlsStartCommand() {\n    ControlsStartCommand.__super__.constructor.call(this);\n  }\n\n\n  __extends(ControlsStartCommand, puremvc.SimpleCommand);\n\n\n  /**\n   * Executes the command.\n   *\n   * @param {puremvc.Notification} notification\n   *    The notification.\n   *\n   * @override\n  */\n  ControlsStartCommand.prototype.execute = function(notification) {\n    var controls;\n    controls = this.facade.retrieveProxy(ControlsProxy.NAME);\n    controls.start();\n  };\n\n  /**\n   * The ControlsAdBreakStartCommand class.\n   *\n   * @constructor\n   * @private\n   * @extends {puremvc.SimpleCommand}\n  */\n  function ControlsAdBreakStartCommand() {\n    ControlsAdBreakStartCommand.__super__.constructor.call(this);\n  }\n\n\n  __extends(ControlsAdBreakStartCommand, PluginCommand);\n\n\n  /**\n   * Executes the command.\n   *\n   * @param {puremvc.Notification} notification\n   *    The notification.\n   *\n   * @override\n  */\n  ControlsAdBreakStartCommand.prototype.execute = function(notification) {\n    if (this.plugin.config[\"native\"] === true) {\n      this.player.getMediaElement().controls = false;\n    } else {\n      this.proxy.adBreakStart();\n    }\n  };\n\n  /**\n   * The ControlsWrapper class.\n   *\n   * @constructor\n   * @private\n   * @extends {PluginWrapper}\n   * @param   {FlashPlayer}   player  The FlashPlayer\n   * @param   {Object}        config  The plugin config\n  */\n  function ControlsWrapper(player, config) {\n    ControlsWrapper.__super__.constructor.call(this, player, config);\n  }\n\n\n  __extends(ControlsWrapper, PluginWrapper);\n\n\n  ControlsWrapper.NAME = \"ControlsWrapper\";\n\n  ControlsWrapper.prototype.mode = \"auto\";\n\n  ControlsWrapper.prototype.autoHide = 5;\n\n  ControlsWrapper.prototype.flashView = {\n    elements: {\n      controls: {\n        attributes: {\n          height: \"28\",\n          itemMargin: \"5\",\n          scrubPosition: \"inline\"\n        },\n        elements: {\n          replayBtn: {},\n          playPauseBtn: {},\n          streamTimeIndicator: {\n            attributes: {\n              exclude: \"live\"\n            },\n            elements: {\n              streamTime: {},\n              streamDuration: {}\n            }\n          },\n          rewindBtn: {},\n          scrubBar: {\n            attributes: {\n              style: \"height: 18px;\"\n            }\n          },\n          progressBar: {\n            attributes: {\n              style: \"background: linear-gradient(90deg, #FF0000, #1B1B1B);\"\n            }\n          },\n          loadedBar: {\n            attributes: {\n              style: \"background: linear-gradient(90deg, #00FF00, #1B1B1B);\"\n            }\n          },\n          liveIndicator: {},\n          timeLocationIndicator: {},\n          goLiveBtn: {},\n          statsBtn: {},\n          volumeBar: {\n            attributes: {\n              color: \"#CA2127\"\n            }\n          },\n          volumeBtn: {},\n          fullscreenBtn: {}\n        }\n      }\n    }\n  };\n\n  /** @override\n  */\n  ControlsWrapper.prototype.listNotificationInterests = function() {\n    return ControlsWrapper.__super__.listNotificationInterests.apply(this, arguments).concat([Notifications.MEDIUM_CHANGE]);\n  };\n\n  /**\n  */\n  ControlsWrapper.prototype.handleNotification = function(notification) {\n    var body, mode, name;\n    ControlsWrapper.__super__.handleNotification.call(this, notification);\n    name = notification.getName();\n    body = notification.getBody();\n    switch (name) {\n      case Notifications.MEDIUM_CHANGE:\n        mode = /audio/.test(body) ? \"persistent\" : this.mode;\n        this.setMode(mode);\n    }\n  };\n\n  /** @override\n  */\n  ControlsWrapper.prototype.createFlashVars = function(flashvars) {\n    if (this.config.mode != null) {\n      this.mode = flashvars.controls_mode = this.config.mode;\n    }\n    if ((this.config.admode != null) && this.config.admode !== this.config.mode) {\n      flashvars.ads_auto_fit = true;\n    }\n    return flashvars;\n  };\n\n  ControlsWrapper.prototype.createXML = function(xml) {\n    var controls, _ref, _ref1;\n    controls = (_ref = this.player.flashView) != null ? (_ref1 = _ref.elements) != null ? _ref1.controls : void 0 : void 0;\n    if (!(controls != null)) {\n      return;\n    }\n    if (controls.attributes[\"autoHideDelay\"] != null) {\n      this.autoHide = controls.attributes[\"autoHideDelay\"];\n    } else {\n      if (this.config.autoHide != null) {\n        this.autoHide = this.config.autoHide;\n        controls.attributes[\"autoHideDelay\"] = this.config.autoHide;\n      }\n    }\n    return xml;\n  };\n\n  /**\n  */\n  ControlsWrapper.prototype.getMode = function() {\n    return this.mode;\n  };\n\n  ControlsWrapper.prototype.setMode = function(value) {\n    if (value === this.mode) {\n      return;\n    }\n    try {\n      this.mode = value;\n      this.player.mediaElement.setPlayerProperty(\"controlsMode\", value);\n    } catch (error) {\n      this.facade.logger.error(\"[AMP CONTROLS ERROR]\", error);\n    }\n    return value;\n  };\n\n  ControlsWrapper.prototype.getAutoHide = function() {\n    return this.autoHide;\n  };\n\n  /**\n   * @constructor\n   * @private\n  */\n  function ControlsProxy(config) {\n    ControlsProxy.__super__.constructor.call(this, config);\n  }\n\n\n  __extends(ControlsProxy, ModuleProxy);\n\n\n  ControlsProxy.NAME = ModuleProxy.NAME;\n\n  ControlsProxy.prototype.defaults = {\n    mode: \"auto\",\n    autoHide: 3,\n    admode: null\n  };\n\n  ControlsProxy.prototype.timeout = null;\n\n  ControlsProxy.prototype.appState = null;\n\n  ControlsProxy.prototype.controls = null;\n\n  ControlsProxy.prototype.interactiveElement = null;\n\n  ControlsProxy.prototype.idleUtil = null;\n\n  ControlsProxy.prototype.initializeNotifier = function(key) {\n    ControlsProxy.__super__.initializeNotifier.call(this, key);\n    this.appState = this.facade.player.retrieveProxy(ApplicationStateProxy.NAME);\n    this.controls = this.facade.retrieveMediator(ApplicationStateProxy.NAME);\n  };\n\n  ControlsProxy.prototype.onRegister = function() {\n    var _this = this;\n    ControlsProxy.__super__.onRegister.call(this);\n    if (this.config.mode != null) {\n      this.changeMode(this.config.mode);\n    }\n    this.interactiveElement = this.facade.player.getContainer();\n    if (Utils.getDevice() === \"desktop\") {\n      EventHandler.create(this.interactiveElement, \"mouseenter\", function() {\n        _this.stop();\n        if (_this.appState.activeState !== ActiveState.ACTIVE) {\n          _this.sendNotification(Notifications.CHANGE_ACTIVE_STATE, ActiveState.ACTIVE);\n        }\n      });\n      EventHandler.create(this.interactiveElement, \"mouseleave\", function() {\n        _this.start();\n      });\n      this.idleUtil = new IdleUtil(this.facade.player.getViewComponent(), this.data.autoHide * 1000);\n      this.idleUtil.addEventListener(\"activechange\", function(event) {\n        var state;\n        state = event.detail.active !== true ? ActiveState.INACTIVE : ActiveState.ACTIVE;\n        _this.sendNotification(Notifications.CHANGE_ACTIVE_STATE, state);\n      });\n      this.idleUtil.start();\n      EventHandler.create(this.facade.player.getMediaElement(), \"click\", function() {\n        _this.sendNotification(UserNotifications.TOGGLE_PLAY_PAUSE);\n      });\n    } else {\n      EventHandler.create(this.interactiveElement, EventHandler.CLICK, function() {\n        _this.sendNotification(Notifications.TOGGLE_ACTIVE);\n      });\n    }\n  };\n\n  ControlsProxy.prototype.setMode = function(value) {\n    if (this.data.mode === value) {\n      return value;\n    }\n    this.changeMode(value);\n    return value;\n  };\n\n  ControlsProxy.prototype.changeMode = function(value) {\n    if (this.data.mode === \"auto\") {\n      this.stop();\n    }\n    this.facade.sendNotification(Notifications.REMOVE_APPLICATION_STATE, \"controls-\" + this.data.mode);\n    this.data.mode = value;\n    this.facade.sendNotification(Notifications.ADD_APPLICATION_STATE, \"controls-\" + this.data.mode);\n  };\n\n  ControlsProxy.prototype.getMode = function() {\n    return this.data.mode;\n  };\n\n  ControlsProxy.prototype.setAutoHide = function(value) {\n    this.data.autoHide = value;\n    return value;\n  };\n\n  ControlsProxy.prototype.getAutoHide = function() {\n    return this.data.autoHide;\n  };\n\n  ControlsProxy.prototype.adBreakStart = function() {\n    if (this.data.admode != null) {\n      this.config.mode = this.getMode();\n      this.setMode(this.data.admode);\n    }\n  };\n\n  ControlsProxy.prototype.adBreakEnd = function() {\n    if (this.data.admode != null) {\n      this.setMode(this.config.mode);\n    }\n  };\n\n  ControlsProxy.prototype.start = function() {\n    this.stop();\n    if (this.data.mode !== \"auto\") {\n      return;\n    }\n    this.timeout = setTimeout(this.hide.bind(this), this.data.autoHide * 1000);\n  };\n\n  ControlsProxy.prototype.stop = function() {\n    clearTimeout(this.timeout);\n    this.timeout = null;\n  };\n\n  ControlsProxy.prototype.hide = function() {\n    if (this.data.mode !== \"auto\") {\n      return;\n    }\n    if ((this.appState.getIsUserActive() === true || Utils.isMouseOverElement(this.facade.viewComponent)) && this.appState.getDisplayState() !== DisplayState.FULL_SCREEN) {\n      this.start();\n      return;\n    }\n    this.facade.sendNotification(Notifications.CHANGE_ACTIVE_STATE, ActiveState.INACTIVE);\n  };\n\n  /**\n   * @constructor\n   * @private\n   * @extends {OverlayMediator}\n  */\n  function TitleBarMediator() {\n    TitleBarMediator.__super__.constructor.call(this);\n  }\n\n\n  __extends(TitleBarMediator, OverlayMediator);\n\n\n  TitleBarMediator.prototype.componentName = \"title-bar\";\n\n  TitleBarMediator.prototype.title = null;\n\n  TitleBarMediator.prototype.description = null;\n\n  /**\n   * @override\n  */\n  TitleBarMediator.prototype.onRegister = function() {\n    TitleBarMediator.__super__.onRegister.call(this);\n    this.title = this.create(\"title-text\");\n    this.description = this.create(\"description-text\");\n  };\n\n  /**\n   * @override\n  */\n  TitleBarMediator.prototype.listNotificationInterests = function() {\n    return [Notifications.CHANGE_MEDIA];\n  };\n\n  /**\n   * @override\n  */\n  TitleBarMediator.prototype.handleNotification = function(notification) {\n    var metadata, title;\n    switch (notification.getName()) {\n      case Notifications.CHANGE_MEDIA:\n        metadata = notification.getBody();\n        title = this.facade.player.evaluateBinding(metadata.title);\n        if (!(title != null) || title === \"\" || title === \"undefined\") {\n          this.classList.add(\"hidden\");\n        } else {\n          this.title.innerHTML = title;\n          this.description.innerHTML = metadata.description ? metadata.description : \"\";\n          this.classList.remove(\"hidden\");\n        }\n    }\n  };\n\n  /**\n   * ErrorLayerMediator class.\n   *\n   * @constructor\n   * @extends {LayerMediator}\n   * @private\n  */\n  function ErrorLayerMediator() {\n    ErrorLayerMediator.__super__.constructor.call(this);\n  }\n\n\n  __extends(ErrorLayerMediator, LayerMediator);\n\n\n  ErrorLayerMediator.prototype.message = null;\n\n  ErrorLayerMediator.prototype.componentName = \"error\";\n\n  /**\n   * @override\n  */\n  ErrorLayerMediator.prototype.onRegister = function() {\n    ErrorLayerMediator.__super__.onRegister.call(this);\n    this.message = this.create(\"error-message\");\n  };\n\n  /**\n   * @override\n  */\n  ErrorLayerMediator.prototype.listNotificationInterests = function() {\n    return [Notifications.ERROR];\n  };\n\n  /**\n   * @override\n  */\n  ErrorLayerMediator.prototype.handleNotification = function(notification) {\n    var error, msg;\n    switch (notification.getName()) {\n      case Notifications.ERROR:\n        error = notification.getBody();\n        msg = \"Error: \";\n        switch (error.code) {\n          case MediaError.MEDIA_ERR_ABORTED:\n            msg += \"Media was aborted.\";\n            break;\n          case MediaError.MEDIA_ERR_DECODE:\n            msg += \"Decode Error.\";\n            break;\n          case MediaError.MEDIA_ERR_NETWORK:\n            msg += \"Network Error.\";\n            break;\n          case MediaError.MEDIA_ERR_SRC_NOT_SUPPORTED:\n            msg += \"Source not supported.\";\n            break;\n          default:\n            msg += error;\n        }\n        this.message.textContent = msg;\n    }\n  };\n\n  /**\n   * @constructor\n   * @extends {OverlayMediator}\n   * @private\n  */\n  function LoadingOverlayMediator() {\n    LoadingOverlayMediator.__super__.constructor.call(this);\n  }\n\n\n  __extends(LoadingOverlayMediator, OverlayMediator);\n\n\n  LoadingOverlayMediator.prototype.componentName = \"loading\";\n\n  /**\n   * @constructor\n   * @private\n   * @extends {OverlayMediator}\n  */\n  function WaitingOverlayMediator() {\n    WaitingOverlayMediator.__super__.constructor.call(this);\n  }\n\n\n  __extends(WaitingOverlayMediator, OverlayMediator);\n\n\n  WaitingOverlayMediator.prototype.componentName = \"waiting\";\n\n  WaitingOverlayMediator.prototype.bar = null;\n\n  WaitingOverlayMediator.prototype.text = null;\n\n  WaitingOverlayMediator.prototype.onRegister = function() {\n    WaitingOverlayMediator.__super__.onRegister.call(this);\n    this.bar = this.create(\"waiting-bar\");\n    this.text = this.createText(\"waiting-text\", this.localizationManager.getString(LocalizationConstants.MSG_BUFFERING));\n  };\n\n  /**\n   * @constructor\n   * @private\n   * @extends {LayerMediator}\n  */\n  function PosterMediator() {\n    PosterMediator.__super__.constructor.call(this);\n  }\n\n\n  __extends(PosterMediator, OverlayMediator);\n\n\n  PosterMediator.prototype.componentName = \"poster\";\n\n  PosterMediator.prototype.poster = null;\n\n  PosterMediator.prototype.clickHandler = null;\n\n  /**\n   * @override\n  */\n  PosterMediator.prototype.onRegister = function() {\n    PosterMediator.__super__.onRegister.call(this);\n    this.poster = this.create(\"poster-content\");\n    this.poster.onclick = this.onclick.bind(this);\n  };\n\n  /**\n  */\n  PosterMediator.prototype.onclick = function(event) {\n    event.stopImmediatePropagation();\n    event.preventDefault();\n    this.sendNotification(UserNotifications.TOGGLE_PLAY_PAUSE, true);\n    return false;\n  };\n\n  /**\n   * @override\n  */\n  PosterMediator.prototype.listNotificationInterests = function() {\n    return [Notifications.CHANGE_MEDIA];\n  };\n\n  /**\n   * @override\n  */\n  PosterMediator.prototype.handleNotification = function(notification) {\n    var html, src;\n    switch (notification.getName()) {\n      case Notifications.CHANGE_MEDIA:\n        src = notification.getBody().poster;\n        html = (src != null) && src !== \"\" ? \"<img src=\\\"\" + src + \"\\\" class=\\\"\" + this.cssPrefix + \"poster-image\\\" />\" : \"\";\n        this.poster.innerHTML = html;\n    }\n  };\n\n  /**\n  */\n  /**\n   * @constructor\n   * @private\n  */\n  function EndSlateMediator() {\n    EndSlateMediator.__super__.constructor.call(this);\n  }\n\n\n  __extends(EndSlateMediator, OverlayMediator);\n\n\n  EndSlateMediator.prototype.componentName = \"end-slate\";\n\n  /**\n   * @override\n  */\n  EndSlateMediator.prototype.onRegister = function() {\n    if (this.config.getEndSlate() != null) {\n      EndSlateMediator.__super__.onRegister.call(this);\n    }\n  };\n\n  EndSlateMediator.prototype.listNotificationInterests = function() {\n    return [Notifications.MEDIA_CHANGE];\n  };\n\n  EndSlateMediator.prototype.handleNotification = function(notification) {\n    var endslate, html, media, src, viewComponent;\n    switch (notification.getName()) {\n      case Notifications.MEDIA_CHANGE:\n        media = notification.getBody();\n        endslate = this.config.getEndSlate();\n        viewComponent = this.getViewComponent();\n        html = \"\";\n        if (endslate != null) {\n          src = endslate.usePoster === true ? media.poster : endslate.url;\n          if ((src != null) && src !== \"\") {\n            html = \"<img src=\\\"\" + src + \"\\\" class=\\\"end-slate-image\\\" />\";\n          }\n        }\n        if (viewComponent != null) {\n          viewComponent.innerHTML = html;\n        }\n    }\n  };\n\n  /**\n   * @constructor\n   * @private\n  */\n  function ButtonMediator(labelText, parent, element, componentName, onclick) {\n    this.labelText = labelText;\n    this.onclick = onclick != null ? onclick : this.onclick;\n    ButtonMediator.__super__.constructor.call(this, componentName, null, parent, element);\n  }\n\n\n  __extends(ButtonMediator, ComponentMediator);\n\n\n  ButtonMediator.prototype.componentType = \"button\";\n\n  ButtonMediator.prototype.icon = null;\n\n  ButtonMediator.prototype.label = null;\n\n  ButtonMediator.prototype.onclick = null;\n\n  ButtonMediator.prototype.labelText = null;\n\n  ButtonMediator.prototype.onRegister = function() {\n    ButtonMediator.__super__.onRegister.call(this);\n    this.icon = this.create(\"icon\");\n    this.createLabel(this.labelText);\n  };\n\n  ButtonMediator.prototype.createLabel = function(label) {\n    if (label != null) {\n      this.label = this.createText(\"label\", label);\n    }\n  };\n\n  ButtonMediator.prototype.setLabel = function(value) {\n    if (!(this.label != null)) {\n      this.createLabel(value);\n    } else {\n      this.label.textContent = value;\n    }\n    return value;\n  };\n\n  ButtonMediator.prototype.getLabel = function() {\n    var _ref;\n    return (_ref = this.label) != null ? _ref.textContent : void 0;\n  };\n\n  /**\n   * The LogoMediator class.\n   *\n   * @constructor\n   * @private\n   * @extends {LocalizedMediator}\n   * @param {Object} viewComponent\n  */\n  function LogoMediator(parent) {\n    LogoMediator.__super__.constructor.call(this, null, null, parent);\n  }\n\n\n  __extends(LogoMediator, ComponentMediator);\n\n\n  /**\n   * The name of the this Mediator.\n   *\n   * @static\n   * @type {string}\n  */\n  LogoMediator.prototype.componentName = \"logo\";\n\n  LogoMediator.prototype.url = null;\n\n  /**\n   * @override\n  */\n  LogoMediator.prototype.onRegister = function() {\n    LogoMediator.__super__.onRegister.call(this);\n    this.sendNotification(Notifications.ADD_CONTROL_STATE, this.componentName + \"-enabled\");\n  };\n\n  LogoMediator.prototype.onclick = function(event) {\n    event.stopImmediatePropagation();\n    this.sendNotification(Notifications.DISPATCH_EVENT, new Event(\"controlsLogoClicked\"));\n    return false;\n  };\n\n  /**\n   * The FullScreenMediator class.\n   *\n   * @constructor\n   * @private\n   * @extends {ModuleMediator}\n   * @param {Object} viewComponent\n  */\n  function FullScreenMediator(parent) {\n    FullScreenMediator.__super__.constructor.call(this, null, parent);\n  }\n\n\n  __extends(FullScreenMediator, ButtonMediator);\n\n\n  FullScreenMediator.prototype.componentName = \"full-screen\";\n\n  FullScreenMediator.prototype.onRegister = function() {\n    FullScreenMediator.__super__.onRegister.call(this);\n    this.sendNotification(Notifications.ADD_CONTROL_STATE, this.componentName + \"-enabled\");\n  };\n\n  FullScreenMediator.prototype.onclick = function(event) {\n    event.stopImmediatePropagation();\n    this.sendNotification(Notifications.TOGGLE_FULL_SCREEN);\n    return false;\n  };\n\n  /**\n   * @override\n  */\n  FullScreenMediator.prototype.listNotificationInterests = function() {\n    return [Notifications.DISABLE_FULL_SCREEN, Notifications.ENABLE_FULL_SCREEN];\n  };\n\n  /**\n   * @override\n  */\n  FullScreenMediator.prototype.handleNotification = function(notification) {\n    var body, name;\n    name = notification.getName();\n    body = notification.getBody();\n    switch (name) {\n      case Notifications.DISABLE_FULL_SCREEN:\n        this.setDisabled(true);\n        break;\n      case Notifications.ENABLE_FULL_SCREEN:\n        this.setDisabled(false);\n    }\n  };\n\n  /**\n   * The VolumeMediator class.\n   *\n   * @constructor\n   * @private\n   * @extends {ModuleMediator}\n   * @param {Object} viewComponent\n  */\n  function SliderMediator(parent, direction) {\n    this.direction = direction != null ? direction : this.direction;\n    SliderMediator.__super__.constructor.call(this, null, null, parent);\n  }\n\n\n  __extends(SliderMediator, ComponentMediator);\n\n\n  SliderMediator.prototype.componentType = \"slider\";\n\n  SliderMediator.prototype.trackView = null;\n\n  SliderMediator.prototype.handleView = null;\n\n  SliderMediator.prototype.valueView = null;\n\n  SliderMediator.prototype.startCapView = null;\n\n  SliderMediator.prototype.endCapView = null;\n\n  SliderMediator.prototype.clickView = null;\n\n  SliderMediator.prototype.min = 0;\n\n  SliderMediator.prototype.max = 1;\n\n  SliderMediator.prototype.value = 0;\n\n  SliderMediator.prototype.draggable = false;\n\n  SliderMediator.prototype.dragging = false;\n\n  SliderMediator.prototype.draggingInterval = null;\n\n  SliderMediator.prototype.draggingDelay = 250;\n\n  SliderMediator.prototype.direction = \"vertical\";\n\n  SliderMediator.prototype.pressHandler = null;\n\n  SliderMediator.prototype.releaseHandler = null;\n\n  SliderMediator.prototype.moveHandler = null;\n\n  SliderMediator.prototype.clickHandler = null;\n\n  /**\n   * @override\n  */\n  SliderMediator.prototype.onRegister = function() {\n    SliderMediator.__super__.onRegister.call(this);\n    this.startCapView = this.create(\"start-cap\");\n    this.endCapView = this.create(\"end-cap\");\n    this.trackView = this.create(\"track\");\n    this.valueView = this.create(\"value\", this.trackView);\n    this.clickView = this.create(\"click\", this.trackView);\n    this.handleView = this.create(\"handle\", this.trackView);\n    this.pressHandler = EventHandler.create(this.handleView, EventHandler.PRESS, this.handlePressHandler.bind(this));\n    this.releaseHandler = EventHandler.create(window, EventHandler.RELEASE, this.handleReleaseHandler.bind(this));\n    this.releaseHandler.unbind();\n    this.moveHandler = EventHandler.create(window, EventHandler.MOVE, this.updateHandler.bind(this, this.draggable));\n    this.moveHandler.unbind();\n    this.clickHandler = EventHandler.create(this.clickView, EventHandler.CLICK, this.updateHandler.bind(this, true));\n  };\n\n  /** sets the value\n  */\n  SliderMediator.prototype.setDirection = function(value) {\n    this.direction = value;\n    return value;\n  };\n\n  SliderMediator.prototype.getDirection = function() {\n    return this.direction;\n  };\n\n  /** sets the value\n  */\n  SliderMediator.prototype.setValue = function(value) {\n    this.updateValue(value);\n    this.valueChanged();\n    return value;\n  };\n\n  SliderMediator.prototype.getValue = function() {\n    return this.value;\n  };\n\n  SliderMediator.prototype.setDragging = function(value) {\n    if (value === this.dragging) {\n      return;\n    }\n    this.dragging = value;\n    this.sendNotification(Notifications.IS_USER_ACTIVE, this.dragging);\n    if (this.dragging === true) {\n      this.draggingInterval = setInterval(this.valueChanged.bind(this), this.draggingDelay);\n    } else {\n      clearInterval(this.draggingInterval);\n      this.valueChanged();\n    }\n    return this.dragging;\n  };\n\n  SliderMediator.prototype.getDragging = function() {\n    return this.dragging;\n  };\n\n  SliderMediator.prototype.setDraggable = function(value) {\n    if (value === this.draggable) {\n      return;\n    }\n    this.draggable = value;\n    return value;\n  };\n\n  SliderMediator.prototype.getDraggable = function() {\n    return this.draggable;\n  };\n\n  /** updates the view\n  */\n  SliderMediator.prototype.updateValue = function(value) {\n    var handle;\n    if (value === this.value) {\n      return;\n    }\n    this.value = Utils.clamp(value, this.min, this.max);\n    if (this.direction === \"vertical\") {\n      value = \"height\";\n      handle = \"bottom\";\n    } else {\n      value = \"width\";\n      handle = \"left\";\n    }\n    this.valueView.style[value] = this.handleView.style[handle] = \"\" + (this.value * 100) + \"%\";\n  };\n\n  /** calculates the value based on mouse/touch point\n  */\n  SliderMediator.prototype.calculateValue = function(event) {\n    var offset, pos, value;\n    pos = {\n      x: event.clientX || event.targetTouches[0].clientX,\n      y: event.clientY || event.targetTouches[0].clientY\n    };\n    offset = Utils.getElementOffset(this.viewComponent);\n    if (this.getDirection() === \"vertical\") {\n      value = 1 - ((pos.y - offset.top) / offset.height);\n    } else {\n      value = (pos.x - offset.left) / offset.width;\n    }\n    return Utils.clamp(value, 0, 1);\n  };\n\n  SliderMediator.prototype.handlePressHandler = function(event) {\n    this.moveHandler.bind();\n    this.releaseHandler.bind();\n    this.clickHandler.unbind();\n    this.setDragging(true);\n    if (event != null) {\n      event.stopImmediatePropagation();\n    }\n    return false;\n  };\n\n  SliderMediator.prototype.handleReleaseHandler = function(event) {\n    this.moveHandler.unbind();\n    this.releaseHandler.unbind();\n    this.clickHandler.bind();\n    this.setDragging(false);\n    if (event != null) {\n      event.stopImmediatePropagation();\n    }\n    return false;\n  };\n\n  SliderMediator.prototype.updateHandler = function(setValue, event) {\n    var value;\n    if (event != null) {\n      event.stopImmediatePropagation();\n    }\n    value = this.calculateValue(event);\n    if (setValue === true) {\n      this.setValue(value);\n    } else {\n      this.updateValue(value);\n    }\n    return false;\n  };\n\n  SliderMediator.prototype.valueChanged = function() {};\n\n  /**\n   * @enum {string}\n   * @const\n   * @private\n  */\n\n  var PanelNotifications = {\n    ADD_PANEL: \"addPanel\",\n    REMOVE_PANEL: \"removePanel\",\n    OPEN_PANEL: \"openPanel\",\n    CLOSE_PANEL: \"closePanel\",\n    TOGGLE_PANEL: \"togglePanel\",\n    CLOSE_ALL_PANELS: \"closeAllPanels\"\n  };\n\n  /**\n   * The TimeDisplayMediator class.\n   *\n   * @constructor\n   * @private\n   * @extends {LocalizedMediator}\n   * @param {Object} viewComponent\n  */\n  function TimeDisplayMediator(parent) {\n    TimeDisplayMediator.__super__.constructor.call(this, null, null, parent);\n  }\n\n\n  __extends(TimeDisplayMediator, ComponentMediator);\n\n\n  /**\n   * The name of the this Mediator.\n   *\n   * @static\n   * @type {string}\n  */\n  TimeDisplayMediator.prototype.componentName = \"time-display\";\n\n  TimeDisplayMediator.prototype.duration = null;\n\n  TimeDisplayMediator.prototype.currentTimeDisplay = null;\n\n  TimeDisplayMediator.prototype.separatorDisplay = null;\n\n  TimeDisplayMediator.prototype.durationDisplay = null;\n\n  TimeDisplayMediator.prototype.liveDisplay = null;\n\n  /**\n   * @override\n  */\n  TimeDisplayMediator.prototype.onRegister = function() {\n    TimeDisplayMediator.__super__.onRegister.call(this);\n    this.liveDisplay = this.createText(\"live-display\", this.localizationManager.getString(LocalizationConstants.MSG_LIVE));\n    this.currentTimeDisplay = this.createText(\"current-time-display\", \"00:00\", this, \"span\");\n    this.separatorDisplay = this.createText(\"separator-display\", this.localizationManager.getString(LocalizationConstants.MSG_TIME_SEPARATOR), this, \"span\");\n    this.durationDisplay = this.createText(\"duration-display\", \"00:00\", this, \"span\");\n  };\n\n  /**\n   * @override\n  */\n  TimeDisplayMediator.prototype.listNotificationInterests = function() {\n    return [Notifications.PLAY, Notifications.DURATION_CHANGE, Notifications.ENDED, Notifications.DISPLAY_TIME];\n  };\n\n  /**\n   * @override\n  */\n  TimeDisplayMediator.prototype.handleNotification = function(notification) {\n    var body, name;\n    name = notification.getName();\n    body = notification.getBody();\n    switch (name) {\n      case Notifications.PLAY:\n        this.updateDuration();\n        break;\n      case Notifications.DURATION_CHANGE:\n        this.duration = body;\n        this.updateCurrentTime();\n        this.updateDuration();\n        break;\n      case Notifications.ENDED:\n        this.updateCurrentTime(this.duration);\n        this.updateDuration();\n        break;\n      case Notifications.DISPLAY_TIME:\n        this.updateCurrentTime(body.currentTime, body.duration);\n        this.updateDuration(body.duration);\n    }\n  };\n\n  TimeDisplayMediator.prototype.updateCurrentTime = function(currentTime, duration) {\n    if (currentTime == null) {\n      currentTime = this.currentTime;\n    }\n    if (duration == null) {\n      duration = this.duration;\n    }\n    this.currentTimeDisplay.textContent = Utils.formatTimecode(currentTime, duration);\n  };\n\n  TimeDisplayMediator.prototype.updateDuration = function(duration) {\n    if (duration == null) {\n      duration = this.duration;\n    }\n    this.durationDisplay.textContent = Utils.formatTimecode(duration);\n  };\n\n  /**\n   * The PlayPauseMediator class.\n   *\n   * @constructor\n   * @private\n   * @extends {ButtonMediator}\n  */\n  function GoLiveMediator(parent) {\n    GoLiveMediator.__super__.constructor.call(this, null, parent);\n  }\n\n\n  __extends(GoLiveMediator, ButtonMediator);\n\n\n  GoLiveMediator.prototype.componentName = \"go-live\";\n\n  GoLiveMediator.prototype.onRegister = function() {\n    GoLiveMediator.__super__.onRegister.call(this);\n    this.createLabel(this.localizationManager.getString(\"MSG_LIVE\"));\n  };\n\n  /**\n   * @override\n  */\n  GoLiveMediator.prototype.listNotificationInterests = function() {\n    return [Notifications.IS_LIVE];\n  };\n\n  /**\n   * @override\n  */\n  GoLiveMediator.prototype.handleNotification = function(notification) {\n    var body, name;\n    name = notification.getName();\n    body = notification.getBody();\n    switch (name) {\n      case Notifications.IS_LIVE:\n        this.setLabel(body === true ? this.localizationManager.getString(\"MSG_LIVE\") : this.localizationManager.getString(\"MSG_GO_LIVE\"));\n    }\n  };\n\n  /**\n  */\n  GoLiveMediator.prototype.onclick = function(event) {\n    event.stopImmediatePropagation();\n    event.preventDefault();\n    return false;\n  };\n\n  /**\n   * The PanelsMediator class.\n   *\n   * @constructor\n   * @private\n   * @extends {LayerMediator}\n  */\n  function PanelsMediator(parent) {\n    this.panels = [];\n    this.closeHandler = this.mouseupHandler.bind(this);\n    PanelsMediator.__super__.constructor.call(this, null, null, parent);\n  }\n\n\n  __extends(PanelsMediator, ComponentMediator);\n\n\n  PanelsMediator.prototype.componentName = \"panels\";\n\n  PanelsMediator.prototype.activePanel = null;\n\n  PanelsMediator.prototype.panels = null;\n\n  PanelsMediator.prototype.closeHandler = null;\n\n  /**\n   * @override\n  */\n  PanelsMediator.prototype.listNotificationInterests = function() {\n    var key, value;\n    return ((function() {\n      var _results;\n      _results = [];\n      for (key in PanelNotifications) {\n        value = PanelNotifications[key];\n        _results.push(value);\n      }\n      return _results;\n    })()).concat([]);\n  };\n\n  /**\n   * @override\n  */\n  PanelsMediator.prototype.handleNotification = function(notification) {\n    var body, name;\n    name = notification.getName();\n    body = notification.getBody();\n    switch (name) {\n      case PanelNotifications.ADD_PANEL:\n        this.addPanel(body);\n        break;\n      case PanelNotifications.REMOVE_PANEL:\n        this.removePanel(body);\n        break;\n      case PanelNotifications.OPEN_PANEL:\n        this.openPanel(body);\n        break;\n      case PanelNotifications.CLOSE_PANEL:\n        this.closePanel(body);\n        break;\n      case PanelNotifications.CLOSE_ALL_PANELS:\n        this.closeAllPanels(body);\n        break;\n      case PanelNotifications.TOGGLE_PANEL:\n        this.togglePanel(body);\n    }\n  };\n\n  PanelsMediator.prototype.addPanel = function(panel) {\n    this.panels.push(panel);\n    this.viewComponent.appendChild(panel.getViewComponent());\n  };\n\n  PanelsMediator.prototype.removePanel = function(panel) {\n    this.panels.splice(this.panels.indexOf(panel), 1);\n    this.viewComponent.removeChild(panel.getViewComponent());\n  };\n\n  PanelsMediator.prototype.openPanel = function(panel) {\n    if (panel === this.activePanel || !(panel != null)) {\n      return;\n    }\n    this.closeAllPanels();\n    this.activePanel = panel;\n    this.activePanel.classList.add(\"active\");\n    if (Utils.getDevice() !== \"desktop\") {\n      this.sendNotification(Notifications.IS_USER_ACTIVE, true);\n    }\n    document.addEventListener(\"mouseup\", this.closeHandler);\n  };\n\n  PanelsMediator.prototype.closePanel = function(panel) {\n    panel.classList.remove(\"active\");\n    if (this.activePanel != null) {\n      this.activePanel = null;\n      if (Utils.getDevice() !== \"desktop\") {\n        this.sendNotification(Notifications.IS_USER_ACTIVE, false);\n      }\n      document.removeEventListener(\"mouseup\", this.closeHandler);\n    }\n  };\n\n  PanelsMediator.prototype.togglePanel = function(panel) {\n    if (panel === this.activePanel) {\n      this.closePanel(panel);\n    } else {\n      this.openPanel(panel);\n    }\n  };\n\n  PanelsMediator.prototype.closeAllPanels = function() {\n    var panel, _i, _len, _ref;\n    _ref = this.panels;\n    for (_i = 0, _len = _ref.length; _i < _len; _i++) {\n      panel = _ref[_i];\n      this.closePanel(panel);\n    }\n  };\n\n  PanelsMediator.prototype.mouseupHandler = function(event) {\n    var button, element, panel;\n    element = document.elementFromPoint(event.clientX, event.clientY);\n    panel = this.activePanel.getViewComponent();\n    button = this.activePanel.control.getViewComponent();\n    if (element !== panel && panel.contains(element) === false && element !== button && button.contains(element) === false) {\n      this.closeAllPanels();\n    }\n  };\n\n  /**\n   * The ProgressMediator class.\n   *\n   * @constructor\n   * @private\n   * @extends {ModuleMediator}\n   * @param {Object} viewComponent\n  */\n  function ProgressMediator(parent) {\n    ProgressMediator.__super__.constructor.call(this, parent, \"horizontal\");\n  }\n\n\n  __extends(ProgressMediator, SliderMediator);\n\n\n  /**\n   * The name of the this Mediator.\n   *\n   * @static\n   * @type {string}\n  */\n  ProgressMediator.prototype.componentName = \"progress\";\n\n  ProgressMediator.prototype.bufferValue = null;\n\n  ProgressMediator.prototype.scrubTime = null;\n\n  ProgressMediator.prototype.scrubTimeSeparator = null;\n\n  ProgressMediator.prototype.cuePoints = null;\n\n  ProgressMediator.prototype.cues = null;\n\n  ProgressMediator.prototype.duration = 0;\n\n  ProgressMediator.prototype.isLive = false;\n\n  ProgressMediator.prototype.seeking = false;\n\n  ProgressMediator.prototype.previewData = {\n    src: null,\n    previewWidth: null,\n    previewHeight: null,\n    imgWidth: null,\n    imgHeight: null,\n    count: null\n  };\n\n  ProgressMediator.prototype.hoverHandler = null;\n\n  ProgressMediator.prototype.mouseoutHandler = null;\n\n  ProgressMediator.prototype.mouseMoveHandler = null;\n\n  ProgressMediator.prototype.previewMoveHandler = null;\n\n  /**\n   * @override\n  */\n  ProgressMediator.prototype.onRegister = function() {\n    ProgressMediator.__super__.onRegister.call(this);\n    this.bufferValue = this.create(\"buffer-value\", false);\n    this.trackView.insertBefore(this.bufferValue, this.trackView.lastChild);\n    this.cuePoints = this.create(\"cue-points\", this.trackView);\n    this.scrubTimeSeparator = this.create(\"scrub-time-separator\");\n    this.scrubTime = this.create(\"scrub-time\");\n    this.thumbPreview = this.create(\"thumb-preview\", this.trackView);\n    this.previewMoveHandler = EventHandler.create(this.clickView, EventHandler.MOVE, this.updatePreviewHandler.bind(this));\n    this.previewMoveHandler.unbind();\n    this.hoverHandler = EventHandler.create(this.clickView, EventHandler.HOVER, this.handlehoverHandler.bind(this));\n    this.mouseoutHandler = EventHandler.create(this.clickView, EventHandler.HOVEROUT, this.handlemouseoutHandler.bind(this));\n    this.mouseoutHandler.unbind();\n    EventHandler.create(this.clickView, EventHandler.HOVER, this.mouseOverHandler.bind(this));\n    EventHandler.create(this.clickView, EventHandler.HOVEROUT, this.mouseOutHandler.bind(this));\n    this.mouseMoveBinding = EventHandler.create(document, EventHandler.MOVE, this.mouseMoveHandler.bind(this));\n    this.mouseMoveBinding.unbind();\n  };\n\n  /**\n   * @override\n  */\n  ProgressMediator.prototype.listNotificationInterests = function() {\n    return [Notifications.ENDED, Notifications.MEDIA_CHANGE, Notifications.DURATION_CHANGE, Notifications.PROGRESS, Notifications.ADD_CUE_POINTS, Notifications.REMOVE_CUE_POINTS, Notifications.DISPLAY_TIME];\n  };\n\n  /**\n   * @override\n  */\n  ProgressMediator.prototype.handleNotification = function(notification) {\n    var body, name, value;\n    name = notification.getName();\n    body = notification.getBody();\n    switch (name) {\n      case Notifications.MEDIA_CHANGE:\n        this.isLive = body.temporalType === \"live\";\n        this.updateValue(0);\n        this.bufferValue.style.width = \"0%\";\n        this.updatePreview(body.metadata);\n        break;\n      case Notifications.PROGRESS:\n        value = Utils.clamp(body / this.duration * 100, 0, 100);\n        this.bufferValue.style.width = value + \"%\";\n        break;\n      case Notifications.DURATION_CHANGE:\n        this.duration = body;\n        this.updateCuePoints();\n        break;\n      case Notifications.ENDED:\n        this.updateValue(1.0);\n        break;\n      case Notifications.ADD_CUE_POINTS:\n        this.cues = body;\n        this.updateCuePoints();\n        break;\n      case Notifications.REMOVE_CUE_POINTS:\n        this.removeCuePoints();\n        break;\n      case Notifications.DISPLAY_TIME:\n        if (this.dragging === false) {\n          this.updateValue(body.currentTime / body.duration, body.duration);\n        }\n    }\n  };\n\n  ProgressMediator.prototype.updateCuePoints = function() {\n    var cue, cuePoint, _i, _len, _ref, _ref1, _ref2;\n    if (!(this.cues != null) || this.cues.length === 0) {\n      return;\n    }\n    if (((_ref = this.facade.player.config) != null ? (_ref1 = _ref.controls) != null ? _ref1.displaySceneMarkers : void 0 : void 0) != null) {\n      if (this.facade.player.config.controls.displaySceneMarkers === false) {\n        return;\n      }\n    }\n    this.removeCuePoints();\n    _ref2 = this.cues;\n    for (_i = 0, _len = _ref2.length; _i < _len; _i++) {\n      cue = _ref2[_i];\n      if (!(cue !== 0 && cue !== -1)) {\n        continue;\n      }\n      cuePoint = this.create(\"cue-point\", this.cuePoints);\n      cuePoint.style.left = (cue / this.duration * 100) + \"%\";\n    }\n  };\n\n  ProgressMediator.prototype.preloadPreviewImages = function(metadata) {\n    var i, image;\n    i = 1;\n    while (i < metadata.previewThumbnailCount) {\n      image = new Image;\n      image.src = metadata.previewThumbnailSrc + \"out\" + i + \".png\";\n      i++;\n    }\n  };\n\n  ProgressMediator.prototype.updatePreview = function(metadata) {\n    this.preloadPreviewImages(metadata);\n    this.previewData.src = metadata.previewThumbnailSrc;\n    this.previewData.previewHeight = metadata.previewThumbnailHeight;\n    this.previewData.previewWidth = metadata.previewThumbnailWidth;\n    this.previewData.count = metadata.previewThumbnailCount;\n    if (this.previewData.src === void 0) {\n      this.hoverHandler.unbind();\n    }\n  };\n\n  ProgressMediator.prototype.handlehoverHandler = function(event) {\n    this.previewMoveHandler.bind();\n    this.mouseoutHandler.bind();\n    this.hoverHandler.unbind();\n    this.updatePreviewHandler(event);\n    event.stopImmediatePropagation();\n    return false;\n  };\n\n  ProgressMediator.prototype.handlemouseoutHandler = function(event) {\n    this.previewMoveHandler.unbind();\n    this.mouseoutHandler.unbind();\n    this.hoverHandler.bind();\n    event.stopImmediatePropagation();\n    return false;\n  };\n\n  ProgressMediator.prototype.mouseOverHandler = function(event) {\n    this.mouseOver = true;\n    this.classList.add(\"active\");\n    this.mouseMoveBinding.bind();\n  };\n\n  ProgressMediator.prototype.mouseOutHandler = function(event) {\n    this.mouseOver = false;\n    if (this.getDragging() === true) {\n      return;\n    }\n    this.classList.remove(\"active\");\n    this.mouseMoveBinding.unbind();\n  };\n\n  ProgressMediator.prototype.mouseMoveHandler = function(event) {\n    var value;\n    value = this.calculateValue(event);\n    this.scrubTime.textContent = Utils.formatTimecode(Math.round(value * this.duration));\n    this.scrubTime.style.left = this.scrubTimeSeparator.style.left = \"\" + ((value * 100).toFixed(2)) + \"%\";\n  };\n\n  ProgressMediator.prototype.updatePreviewHandler = function(event) {\n    var thumbPreviewPos, value;\n    value = this.calculateValue(event);\n    this.previewInterval = this.duration / this.previewData.count;\n    this.previewImgIndex = Math.floor(value * this.duration / this.previewInterval);\n    if (this.previewData.src) {\n      this.thumbPreview.style.backgroundImage = \"url(\" + this.previewData.src + \"out\" + (this.previewImgIndex + 1) + \".png)\";\n    }\n    this.thumbPreview.style.width = this.previewData.previewWidth + \"px\";\n    this.thumbPreview.style.height = this.previewData.previewHeight + \"px\";\n    thumbPreviewPos = Utils.clamp(((value * 100) - 10).toFixed(2), 1, 80);\n    this.thumbPreview.style.left = \"\" + thumbPreviewPos + \"%\";\n  };\n\n  ProgressMediator.prototype.removeCuePoints = function() {\n    if (!(this.cuePoints != null)) {\n      return;\n    }\n    this.cuePoints.innerHTML = \"\";\n  };\n\n  /**\n   * @override\n  */\n  ProgressMediator.prototype.valueChanged = function() {\n    this.sendNotification(UserNotifications.SEEK, this.value * this.facade.player.retrieveProxy(MediaProxy.NAME).getDuration());\n  };\n\n  /** updates the view\n  */\n  ProgressMediator.prototype.updateValue = function(value) {\n    if (value === this.value) {\n      return;\n    }\n    if (this.isLive === true) {\n      value = 1;\n    }\n    if (isNaN(value) === true) {\n      value = 0;\n    }\n    ProgressMediator.__super__.updateValue.call(this, value);\n    if (this.getDragging() && this.value >= this.max) {\n      this.handleReleaseHandler();\n      this.sendNotification(Notifications.END);\n    }\n  };\n\n  ProgressMediator.prototype.updateHandler = function(setValue, event) {\n    ProgressMediator.__super__.updateHandler.call(this, setValue, event);\n    this.mouseMoveHandler(event);\n  };\n\n  ProgressMediator.prototype.handlePressHandler = function(event) {\n    ProgressMediator.__super__.handlePressHandler.call(this, event);\n    this.classList.add(\"scrubbing\");\n  };\n\n  ProgressMediator.prototype.handleReleaseHandler = function(event) {\n    ProgressMediator.__super__.handleReleaseHandler.call(this, event);\n    this.classList.remove(\"scrubbing\");\n    if (this.mouseOver === false) {\n      this.mouseOutHandler();\n    }\n  };\n\n  /**\n   * The PlayPauseMediator class.\n   *\n   * @constructor\n   * @private\n   * @extends {ButtonMediator}\n  */\n  function PlayPauseMediator(parent) {\n    PlayPauseMediator.__super__.constructor.call(this, null, parent);\n  }\n\n\n  __extends(PlayPauseMediator, ButtonMediator);\n\n\n  PlayPauseMediator.prototype.componentName = \"play-pause\";\n\n  PlayPauseMediator.prototype.onclick = function(event) {\n    event.stopImmediatePropagation();\n    event.preventDefault();\n    this.sendNotification(UserNotifications.TOGGLE_PLAY_PAUSE);\n    return false;\n  };\n\n  /**\n   * @constructor\n   * @private\n   * @extends {OverlayMediator}\n  */\n  function ReplayOverlayMediator() {\n    ReplayOverlayMediator.__super__.constructor.call(this);\n  }\n\n\n  __extends(ReplayOverlayMediator, OverlayMediator);\n\n\n  ReplayOverlayMediator.prototype.componentName = \"replay\";\n\n  ReplayOverlayMediator.prototype.replay = null;\n\n  ReplayOverlayMediator.prototype.icon = null;\n\n  ReplayOverlayMediator.prototype.label = null;\n\n  /**\n   * @override\n  */\n  ReplayOverlayMediator.prototype.onRegister = function() {\n    ReplayOverlayMediator.__super__.onRegister.call(this);\n    this.replay = this.create(\"replay-button\");\n    this.replay.onclick = this.onclick.bind(this);\n    this.icon = this.create(\"replay-icon\", this.replay);\n    this.label = this.createText(\"replay-label\", this.localizationManager.getString(LocalizationConstants.MSG_REPLAY), this.replay);\n  };\n\n  /**\n  */\n  ReplayOverlayMediator.prototype.onclick = function(event) {\n    event.stopImmediatePropagation();\n    this.sendNotification(Notifications.REPLAY);\n    return false;\n  };\n\n  /**\n   * @constructor\n   * @private\n   * @extends {contextMenuMediator}\n  */\n  function contextMenuMediator() {\n    contextMenuMediator.__super__.constructor.call(this);\n  }\n\n\n  __extends(contextMenuMediator, OverlayMediator);\n\n\n  contextMenuMediator.prototype.componentName = \"context-menu\";\n\n  contextMenuMediator.prototype.contextMenu = null;\n\n  /**\n   * @override\n  */\n  contextMenuMediator.prototype.onRegister = function() {\n    var _this = this;\n    contextMenuMediator.__super__.onRegister.call(this);\n    EventHandler.create(this.facade.player.viewComponent, EventHandler.CONTEXTMENU, function(event) {\n      event.preventDefault();\n      _this.contextMenuHandler(event);\n      return false;\n    });\n  };\n\n  /** Context Menu Click Handler\n  */\n  contextMenuMediator.prototype.contextMenuHandler = function(event) {\n    var id, item,\n      _this = this;\n    if (this.contextMenu) {\n      this.removeContextMenu();\n    }\n    this.contextMenu = UI.create(\"context-menu\", document.body, \"ul\");\n    UI.create(\"context-item\", this.contextMenu, \"li\", this.facade.player.getVersion());\n    if (typeof akamaiGetViewerId !== \"undefined\" && akamaiGetViewerId !== null) {\n      id = akamaiGetViewerId();\n      item = UI.create(\"context-item\", this.contextMenu, \"li\", \"\" + (this.localizationManager.getString(\"MSG_VIEWER_ID\") || \"Viewer ID: \"));\n      UI.create(\"selectable\", item, \"span\", \"\" + (id != null ? id : \"N/A\"));\n    }\n    this.contextMenu.style.top = event.pageY + \"px\";\n    this.contextMenu.style.left = event.pageX + \"px\";\n    EventHandler.create(document.body, EventHandler.CLICK, function(event) {\n      if (/selectable/.test(event.target.className)) {\n        return false;\n      }\n      _this.removeContextMenu(event);\n      return false;\n    });\n  };\n\n  /** Remove ContextMenu Handler and DOM Object\n  */\n  contextMenuMediator.prototype.removeContextMenu = function(event) {\n    try {\n      EventHandler.clear(document.body, EventHandler.CLICK);\n      document.body.removeChild(this.contextMenu);\n      this.contextMenu = null;\n    } catch (_error) {}\n  };\n\n  /**\n   * @enum {string}\n   * @const\n   * @private\n  */\n\n  var AdNotifications = {\n    BREAK_START: \"adsbreakstart\",\n    BREAK_END: \"adsbreakend\",\n    BREAK_SKIPPED: \"adsbreakskipped\",\n    AD_CONTAINER_CREATED: \"adscontainercreated\",\n    AD_LOADED: \"adsloaded\",\n    AD_MANAGER_LOADED: \"adsmanagerloaded\",\n    AD_STARTED: \"adsstarted\",\n    AD_TIME_UPDATE: \"adstimeupdate\",\n    AD_TIME_REMAINING: \"adstimeremaining\",\n    AD_DURATION_CHANGE: \"adsdurationchange\",\n    AD_ENDED: \"adsended\",\n    AD_ERROR: \"adserror\",\n    AD_PLAY: \"adsplay\",\n    AD_PAUSE: \"adspause\",\n    AD_PAUSED: \"adspaused\",\n    AD_RESUME: \"adsresume\",\n    AD_CLICKED: \"adclicked\",\n    AD_COMPANION: \"adscompanion\",\n    FIRST_QUARTILE: \"adsfirstquartile\",\n    MIDPOINT: \"adsmidpoint\",\n    THIRD_QUARTILE: \"adsthirdquartile\",\n    LOG: \"adslog\",\n    REQUEST: \"adsrequest\",\n    REQUEST_COMPLETE: \"adsrequestcomplete\",\n    RESPONSE: \"adsresponse\",\n    SKIPPED: \"adsskipped\",\n    IMPRESSION: \"adsimpression\"\n  };\n\n  /**\n   * The ControlsMediator class.\n   *\n   * @constructor\n   * @private\n   * @extends {LayerMediator}\n  */\n  function ControlsMediator() {\n    ControlsMediator.__super__.constructor.call(this);\n  }\n\n\n  __extends(ControlsMediator, LayerMediator);\n\n\n  ControlsMediator.prototype.componentName = \"controls\";\n\n  ControlsMediator.prototype.activeControlPanel = null;\n\n  ControlsMediator.prototype.controlBar = null;\n\n  ControlsMediator.prototype.panels = null;\n\n  /**\n   * @override\n  */\n  ControlsMediator.prototype.onRegister = function() {\n    var separator, _ref;\n    this.facade.registerMediator(new ErrorLayerMediator());\n    if (this.facade.player.config.debug !== true) {\n      this.facade.registerMediator(new contextMenuMediator());\n    }\n    ControlsMediator.__super__.onRegister.call(this);\n    this.facade.viewComponent = this.viewComponent;\n    this.facade.registerMediator(new PosterMediator());\n    this.facade.registerMediator(new LoadingOverlayMediator());\n    this.facade.registerMediator(new WaitingOverlayMediator());\n    this.facade.registerMediator(new ReplayOverlayMediator());\n    this.facade.registerMediator(new EndSlateMediator());\n    if (((_ref = this.config.titlebar) != null ? _ref.enabled : void 0) !== false) {\n      this.facade.registerMediator(new TitleBarMediator());\n    }\n    this.controlBar = this.create(\"control-bar\");\n    this.facade.registerMediator(new PanelsMediator(this.viewComponent));\n    this.facade.registerMediator(new PlayPauseMediator(this.controlBar));\n    this.facade.registerMediator(new TimeDisplayMediator(this.controlBar));\n    this.facade.registerMediator(new ProgressMediator(this.controlBar));\n    if (this.facade.config.logo != null) {\n      this.facade.registerMediator(new LogoMediator(this.controlBar));\n    }\n    this.facade.registerMediator(new GoLiveMediator(this.controlBar));\n    separator = this.create(\"separator\", this.controlBar);\n  };\n\n  /**\n   * @override\n  */\n  ControlsMediator.prototype.listNotificationInterests = function() {\n    return [Notifications.READY, Notifications.ADD_CONTROL, Notifications.REMOVE_CONTROL, Notifications.ADD_CONTROL_STATE, Notifications.REMOVE_CONTROL_STATE];\n  };\n\n  /**\n   * @override\n  */\n  ControlsMediator.prototype.handleNotification = function(notification) {\n    var body, name, _ref;\n    name = notification.getName();\n    body = notification.getBody();\n    switch (name) {\n      case Notifications.READY:\n        if (((_ref = body.fullscreen) != null ? _ref.enabled : void 0) !== false) {\n          this.facade.registerMediator(new FullScreenMediator(this.controlBar));\n        }\n        break;\n      case Notifications.ADD_CONTROL_STATE:\n        this.classList.add(body);\n        break;\n      case Notifications.REMOVE_CONTROL_STATE:\n        this.classList.remove(body);\n        break;\n      case Notifications.ADD_CONTROL:\n        this.controlBar.appendChild(body);\n        break;\n      case Notifications.REMOVE_CONTROL:\n        if (this.controlBar.contains(body)) {\n          this.controlBar.removeChild(body);\n        }\n    }\n  };\n\n  /**\n   * @constructor\n  */\n  function AMP() {}\n\n  /**\n   * Create a player based on the configuration object and container.\n   *\n   * @param {string|HTMLElement} container\n   *    The id of the div the player will be attached to.\n   *\n   * @param {?(Object|string)} config\n   *    The configuration override object.\n   *\n   * @param {?Function} onready\n   *    Optional ready handler.\n   *\n   * @return {Player}\n   *\n  */\n  AMP.create = function(container, config, onready) {\n    var element, player, version;\n    if (typeof container === \"string\") {\n      element = document.getElementById(container);\n      if (!(element != null)) {\n        element = document.querySelector(container);\n      }\n    } else {\n      element = container;\n    }\n    if (!(element != null)) {\n      throw new Error(\"[AMP ERROR] Invalid container. Could not find DOM element: \" + container);\n    }\n    config = config instanceof Config ? config : Config.create(config);\n    Logger.enable(config.debug);\n    version = this.getVersion();\n    if (element.dataset == null) {\n      element.dataset = {};\n    }\n    element.dataset[\"amp.version\"] = version;\n    Logger.log(\"[AMP] \" + version);\n    player = this.createPlayer(config, element);\n    try {\n      Object.defineProperties(player, {\n        src: {\n          get: player.getSrc,\n          set: player.setSrc,\n          enumerable: true,\n          configurable: false\n        },\n        media: {\n          get: player.getMedia,\n          set: player.setMedia,\n          enumerable: true,\n          configurable: false\n        },\n        currentTime: {\n          get: player.getCurrentTime,\n          set: player.setCurrentTime,\n          enumerable: true,\n          configurable: false\n        },\n        autoplay: {\n          get: player.getAutoplay,\n          set: player.setAutoplay,\n          enumerable: true,\n          configurable: false\n        },\n        duration: {\n          get: player.getDuration,\n          enumerable: true,\n          configurable: false\n        },\n        playState: {\n          get: player.getPlayState,\n          enumerable: true,\n          configurable: false\n        },\n        seeking: {\n          get: player.getSeeking,\n          enumerable: true,\n          configurable: false\n        },\n        paused: {\n          get: player.getPaused,\n          enumerable: true,\n          configurable: false\n        },\n        ended: {\n          get: player.getEnded,\n          enumerable: true,\n          configurable: false\n        },\n        volume: {\n          get: player.getVolume,\n          set: player.setVolume,\n          enumerable: true,\n          configurable: false\n        },\n        muted: {\n          get: player.getMuted,\n          set: player.setMuted,\n          enumerable: true,\n          configurable: false\n        },\n        mediaElement: {\n          get: player.getMediaElement,\n          enumerable: true,\n          configurable: false\n        },\n        textTracks: {\n          get: (function() {\n            return player.getMediaElement().textTracks;\n          }),\n          enumerable: true,\n          configurable: false\n        },\n        container: {\n          get: player.getContainer,\n          enumerable: true,\n          configurable: false\n        },\n        loop: {\n          get: player.getLoop,\n          set: player.setLoop,\n          enumerable: true,\n          configurable: false\n        },\n        displayState: {\n          get: player.getDisplayState,\n          set: player.setDisplayState,\n          enumerable: true,\n          configurable: false\n        },\n        playbackRate: {\n          get: player.getPlaybackRate,\n          set: player.setPlaybackRate,\n          enumerable: true,\n          configurable: false\n        },\n        language: {\n          get: player.getLanguage,\n          enumerable: true,\n          configurable: false\n        },\n        localization: {\n          get: (function() {\n            return player.retrieveProxy(LocalizationProxy.NAME);\n          }),\n          enumerable: true,\n          configurable: false\n        },\n        version: {\n          get: player.getVersion,\n          enumerable: true,\n          configurable: false\n        },\n        error: {\n          get: player.getError,\n          enumerable: true,\n          configurable: false\n        },\n        hidden: {\n          get: player.getHidden,\n          set: player.setHidden,\n          enumerable: true,\n          configurable: false\n        }\n      });\n    } catch (error) {\n      console.error(error);\n    }\n    element.amp = player;\n    player.request = this.request.bind(this);\n    player.loadResources = this.loadResources.bind(this);\n    player.onready = onready;\n    player.initialize(config);\n    return player;\n  };\n\n  /**\n   *\n  */\n  AMP.createPlayer = function(config, container) {\n    var player;\n    player = this.players[config.mode];\n    if (player != null) {\n      player = new player(container);\n    }\n    return player;\n  };\n\n  /**\n   * Returns the version string for this player library.\n   *\n   * @return {string} The version string.\n  */\n  AMP.getVersion = function() {\n    return this.VERSION;\n  };\n\n  /**\n   * The player version string\n   *\n   * @type {string}\n   * @private\n   * @static\n  */\n  AMP.VERSION = \"AMP - Premier : WebMD v0.65.0.0005\";\n\n  /**\n   * @private\n  */\n  AMP.defaults = new AMPConfig();\n\n  /**\n   * @private\n  */\n  AMP.plugins = [];\n\n  /**\n   * @private\n  */\n  AMP.players = {};\n\n  /**\n   * Loads a default configuration object from a url.\n   *\n   * @param {string} url\n   *    A url to a configuration json file to use at the defaults object.\n   *\n   * @param {?Function} loaded\n   *    Callback function triggered when the file has been loaded and\n   *    sucessfully parsed.\n   *\n   * @param {?Function} error\n   *    Callback function triggered when the file has failed to load\n   *    or cannot be parsed.\n   *\n   * @param {boolean} [withCredentials=false]\n   *    Whether or not to use credntials when making XMLHttpRequest.\n   *\n   * @static\n  */\n  AMP.loadDefaults = function(url, loaded, error, withCredentials) {\n    if (withCredentials == null) {\n      withCredentials = false;\n    }\n    if (loaded != null) {\n      this.defaults.addEventListener(\"load\", loaded);\n    }\n    if (error != null) {\n      this.defaults.addEventListener(\"error\", error);\n    }\n    this.defaults.load(url, withCredentials);\n  };\n\n  /**\n   * Returns the playback mode best suited for the current environment.\n   *\n   * @return {PlaybackMode}\n   *    The playback mode.\n   *\n   * @static\n  */\n  AMP.getPlaybackMode = function() {\n    return Utils.getPlaybackMode();\n  };\n\n  /**\n   * @private\n   * @static\n  */\n  AMP.registerPlayer = function(mode, player) {\n    this.players[mode] = player;\n  };\n\n  /**\n   * Registers a plugin factory function. This function is\n   * called when akamai.amp.AMP.create is called and the\n   * config object contains the plugin key.\n   *\n   * @param {String} key\n   *    The plugin key. Used to configure the plugin.\n   *\n   * @param {String|Array.<String>} mode\n   *    The player mode(s) in which the plugin can be used.\n   *\n   * @param {Function} factory\n   *\n   * @static\n  */\n  AMP.registerPlugin = function(id, mode, plugin) {\n    var item, _base, _i, _len, _ref;\n    if ((_base = this.plugins)[id] == null) {\n      _base[id] = {};\n    }\n    if (typeof mode === \"function\") {\n      _ref = [plugin, mode], mode = _ref[0], plugin = _ref[1];\n    }\n    if (typeof mode === \"string\") {\n      mode = [mode];\n    }\n    if (!(mode != null)) {\n      mode = [\"html\", \"flash\"];\n    }\n    for (_i = 0, _len = mode.length; _i < _len; _i++) {\n      item = mode[_i];\n      this.plugins[id][item] = plugin;\n    }\n  };\n\n  /**\n   * @type {akamai.amp.ResourceManager}\n   * @private\n  */\n  AMP.resourceManager = null;\n\n  /**\n   * Short cut getter for the global renderer manager\n   *\n   * @return {akamai.amp.ResourceManager}\n   *\n   * @static\n   * @private\n  */\n  AMP.getResourceManager = function() {\n    if (!(this.resourceManager != null)) {\n      this.resourceManager = new ResourceManager();\n    }\n    return this.resourceManager;\n  };\n\n  /**\n   * @param {akamai.amp.Resource} resource\n   *    The resource definition\n   *\n   * @param {Function} callback\n   *\n   * @static\n   * @private\n  */\n  AMP.addResource = function(resource, callback, onerror) {\n    return this.getResourceManager().add(resource, callback, onerror);\n  };\n\n  /**\n   * @param {Array.<akamai.amp.Resource>} resources\n   *    The list of resources\n   *\n   * @param {Function} callback\n   *\n   * @static\n   * @private\n  */\n  AMP.addResources = function(resources, callback, onerror) {\n    return this.getResourceManager().addResources(resources, callback, onerror);\n  };\n\n  /**\n   * Loads a list of JS and CSS resources.\n   *\n   * @param {Array.<akamai.amp.Resource>} resources\n   *    The list of js and css resources\n   *\n   * @param {Function} callback\n   *\n   * @return {Promise}\n   *   Promise which resolves once all resources have been loaded.\n   *\n   * @static\n  */\n  AMP.loadResources = function(resources) {\n    var _this = this;\n    return new Promise(function(resolve, reject) {\n      return _this.addResources(resources, resolve, reject);\n    });\n  };\n\n  /**\n   * Request a http resource.\n   *\n   * @param {String|Object} options\n   *    A url string or an object containing the following properties:\n   *\n   * @return {Promise.<XHR>}\n   *     Promise which resolves to a XHR object\n   *\n   * @static\n  */\n  AMP.request = function(options) {\n    return Utils.request(options);\n  };\n\n  /**\n   * @param {!string} key\n   *     The resource's key\n   *\n   * @return {akamai.amp.Resource}\n   *     The resource definition\n   *\n   * @static\n   * @private\n  */\n  AMP.getResource = function(key) {\n    return this.getResourceManager().item(key);\n  };\n\n  /**\n   * @param {!string} key\n   *     The resource's key\n   *\n   * @return {Function}\n   *     The resource's constructor\n   *\n   * @static\n   * @private\n  */\n  AMP.removeResource = function(key) {\n    return this.getResourceManager().remove(key);\n  };\n\n\n  AMP.registerPlayer(\"html\", HTMLPlayer);\n  AMP.registerPlayer(\"flash\", FlashPlayer);\n  AMP.registerPlayer(\"none\", InstallPlayer);\n  AMP.registerPlayer(\"external\", ExternalPlayer);\n\n  function PlayOverlayWrapper() {\n    return PlayOverlayWrapper.__super__.constructor.apply(this, arguments);\n  }\n\n\n  __extends(PlayOverlayWrapper, PluginWrapper);\n\n\n  PlayOverlayWrapper.NAME = \"PlayOverlayWrapper\";\n\n  /**\n  */\n  PlayOverlayWrapper.prototype.createFlashVars = function(flashvars) {\n    flashvars.show_play_button_overlay = this.config.enabled != null ? this.config.enabled : true;\n    return flashvars;\n  };\n\n\n  AMP.registerPlugin(\"playoverlay\", \"flash\", PlayOverlayWrapper);\n\n  /**\n   * @constructor\n   * @private\n  */\n  function PlayOverlayMediator() {\n    PlayOverlayMediator.__super__.constructor.call(this);\n  }\n\n\n  __extends(PlayOverlayMediator, OverlayMediator);\n\n\n  PlayOverlayMediator.prototype.componentName = \"play\";\n\n  PlayOverlayMediator.prototype.onclick = function(event) {\n    event.stopImmediatePropagation();\n    event.preventDefault();\n    this.sendNotification(UserNotifications.TOGGLE_PLAY_PAUSE);\n    return false;\n  };\n\n  /**\n   * @enum {string}\n   * @const\n   * @private\n  */\n\n  var MediaAnalyticsNotifications = {\n    SET_DIMENSIONS: \"mediaanalytics:setDimensions\"\n  };\n\n  /**\n   * The AdContentStartedCommand class.\n   *\n   * @constructor\n   * @private\n   * @extends {AdCommand}\n  */\n  function AdContentStartedCommand() {\n    AdContentStartedCommand.__super__.constructor.call(this);\n  }\n\n\n  __extends(AdContentStartedCommand, PluginCommand);\n\n\n  /**\n   * Executes the command.\n   *\n   * @param {puremvc.Notification} notification\n   *    The notification.\n   *\n   * @override\n  */\n  AdContentStartedCommand.prototype.execute = function(notification) {\n    this.proxy.contentStarted();\n  };\n\n  /**\n   * The AdContentEndedCommand class.\n   *\n   * @constructor\n   * @private\n   * @extends {AdCommand}\n  */\n  function AdContentEndedCommand() {\n    AdContentEndedCommand.__super__.constructor.call(this);\n  }\n\n\n  __extends(AdContentEndedCommand, PluginCommand);\n\n\n  /**\n   * Executes the command.\n   *\n   * @param {puremvc.Notification} notification\n   *    The notification.\n   *\n   * @override\n  */\n  AdContentEndedCommand.prototype.execute = function(notification) {\n    this.proxy.contentEnded();\n  };\n\n  /**\n   * @constructor\n   * @private\n   * @extends {amp.player.controller.PlayerCommand}\n  */\n  function PluginEventCommand() {\n    PluginEventCommand.__super__.constructor.call(this);\n  }\n\n\n  __extends(PluginEventCommand, PluginCommand);\n\n\n  /**\n   *\n  */\n  PluginEventCommand.prototype.dispatchEvent = function(type, detail) {\n    var event, name, _base;\n    if (typeof type !== \"string\") {\n      detail = type.getBody();\n      if (!(detail != null)) {\n        detail = {};\n      }\n      type = type.getName();\n    }\n    name = typeof (_base = this.plugin).getFeatureName === \"function\" ? _base.getFeatureName() : void 0;\n    if (name != null) {\n      type = type.replace(new RegExp(\"^(\" + name + \")\"), \"\");\n    }\n    name = this.plugin.getModuleName();\n    type = type.replace(new RegExp(\"^(\" + name + \")\"), \"\");\n    event = new Event(type, detail);\n    this.sendNotification(Notifications.DISPATCH_EVENT, event);\n  };\n\n  /**\n   *\n  */\n  PluginEventCommand.prototype.dispatchEventAfterCommand = function(type, detail) {\n    setTimeout(this.dispatchEvent.bind(this, type, detail), 0);\n  };\n\n  /**\n   * Executes the command.\n   *\n   * @param {puremvc.Notification} notification\n   *    The notification.\n   *\n   * @override\n  */\n  PluginEventCommand.prototype.execute = function(notification) {\n    this.dispatchEvent(notification);\n  };\n\n  /**\n   * The MediaAnalyticsChangeMediaCommand class.\n   *\n   * @constructor\n   * @private\n   * @extends {puremvc.SimpleCommand}\n  */\n  function MediaAnalyticsChangeMediaCommand() {\n    MediaAnalyticsChangeMediaCommand.__super__.constructor.call(this);\n  }\n\n\n  __extends(MediaAnalyticsChangeMediaCommand, PluginCommand);\n\n\n  /**\n   * Executes the command.\n   *\n   * @param {puremvc.Notification} notification\n   *    The notification.\n   *\n   * @override\n  */\n  MediaAnalyticsChangeMediaCommand.prototype.execute = function(notification) {\n    this.proxy.setMedia(notification.getBody());\n  };\n\n  /**\n   * The MediaAnalyticsAdBreakStartCommand class.\n   *\n   * @constructor\n   * @private\n   * @extends {puremvc.SimpleCommand}\n  */\n  function MediaAnalyticsAdBreakStartCommand() {\n    MediaAnalyticsAdBreakStartCommand.__super__.constructor.call(this);\n  }\n\n\n  __extends(MediaAnalyticsAdBreakStartCommand, puremvc.SimpleCommand);\n\n\n  /**\n   * Executes the command.\n   *\n   * @param {puremvc.Notification} notification\n   *    The notification.\n   *\n   * @override\n  */\n  MediaAnalyticsAdBreakStartCommand.prototype.execute = function(notification) {\n    this.facade.player.getMediaElement().dataset.isad = true;\n  };\n\n  /**\n   * The MediaAnalyticsAdBreakEndCommand class.\n   *\n   * @constructor\n   * @private\n   * @extends {puremvc.SimpleCommand}\n  */\n  function MediaAnalyticsAdBreakEndCommand() {\n    MediaAnalyticsAdBreakEndCommand.__super__.constructor.call(this);\n  }\n\n\n  __extends(MediaAnalyticsAdBreakEndCommand, puremvc.SimpleCommand);\n\n\n  /**\n   * Executes the command.\n   *\n   * @param {puremvc.Notification} notification\n   *    The notification.\n   *\n   * @override\n  */\n  MediaAnalyticsAdBreakEndCommand.prototype.execute = function(notification) {\n    this.facade.player.getMediaElement().dataset.isad = false;\n  };\n\n  /**\n   * The MediaAnalyticsAdLoadedCommand class.\n   *\n   * @constructor\n   * @private\n   * @extends {puremvc.SimpleCommand}\n  */\n  function MediaAnalyticsAdLoadedCommand() {\n    MediaAnalyticsAdLoadedCommand.__super__.constructor.call(this);\n  }\n\n\n  __extends(MediaAnalyticsAdLoadedCommand, puremvc.SimpleCommand);\n\n\n  /**\n   * Executes the command.\n   *\n   * @param {puremvc.Notification} notification\n   *    The notification.\n   *\n   * @override\n  */\n  MediaAnalyticsAdLoadedCommand.prototype.execute = function(notification) {\n    var adObject, adVO;\n    try {\n      adVO = notification.getBody();\n      adObject = {\n        adDuration: adVO.duration,\n        adPartnerId: adVO.partner,\n        adTitle: adVO.title,\n        adId: adVO.id\n      };\n      if (typeof akamaiHandleAdLoaded === \"function\") {\n        akamaiHandleAdLoaded(adObject);\n      }\n    } catch (error) {\n      this.facade.logger.error(\"[AMP MEDIA ANALYTICS ERROR]\", error);\n    }\n  };\n\n  /**\n   * The MediaAnalyticsAdStartCommand class.\n   *\n   * @constructor\n   * @private\n   * @extends {puremvc.SimpleCommand}\n  */\n  function MediaAnalyticsAdStartCommand() {\n    MediaAnalyticsAdStartCommand.__super__.constructor.call(this);\n  }\n\n\n  __extends(MediaAnalyticsAdStartCommand, PluginCommand);\n\n\n  /**\n   * Executes the command.\n   *\n   * @param {puremvc.Notification} notification\n   *    The notification.\n   *\n   * @override\n  */\n  MediaAnalyticsAdStartCommand.prototype.execute = function(notification) {\n    try {\n      if (typeof akamaiHandleAdStarted === \"function\") {\n        akamaiHandleAdStarted();\n      }\n    } catch (error) {\n      this.facade.logger.error(\"[AMP MEDIA ANALYTICS ERROR]\", error);\n    }\n  };\n\n  /**\n   * The MediaAnalyticsTimeUpdateCommand class.\n   *\n   * @constructor\n   * @private\n   * @extends {puremvc.SimpleCommand}\n  */\n  function MediaAnalyticsAdTimeUpdateCommand() {\n    MediaAnalyticsAdTimeUpdateCommand.__super__.constructor.call(this);\n  }\n\n\n  __extends(MediaAnalyticsAdTimeUpdateCommand, PluginCommand);\n\n\n  /**\n   * Executes the command.\n   *\n   * @param {puremvc.Notification} notification\n   *    The notification.\n   *\n   * @override\n  */\n  MediaAnalyticsAdTimeUpdateCommand.prototype.execute = function(notification) {\n    var core, percent;\n    core = notification.getBody();\n    percent = Math.round(core.currentTime / core.duration * 100);\n    try {\n      if (percent >= 25 && this.proxy.percent < 25) {\n        this.facade.logger.debug(\"MediaAnalytics: First Quartile\");\n        if (typeof akamaiHandleAdFirstQuartile === \"function\") {\n          akamaiHandleAdFirstQuartile();\n        }\n      } else if (percent >= 50 && this.proxy.percent < 50) {\n        this.facade.logger.debug(\"MediaAnalytics: Second Quartile\");\n        if (typeof akamaiHandleAdMidpoint === \"function\") {\n          akamaiHandleAdMidpoint();\n        }\n      } else if (percent >= 75 && this.proxy.percent < 75) {\n        this.facade.logger.debug(\"MediaAnalytics: Third Quartile\");\n        if (typeof akamaiHandleAdThirdQuartile === \"function\") {\n          akamaiHandleAdThirdQuartile();\n        }\n      }\n    } catch (error) {\n      this.facade.logger.error(\"[AMP MEDIA ANALYTICS ERROR]\", error);\n    }\n    this.proxy.percent = percent;\n  };\n\n  /**\n   * The MediaAnalyticsAdEndCommand class.\n   *\n   * @constructor\n   * @private\n   * @extends {puremvc.SimpleCommand}\n  */\n  function MediaAnalyticsAdEndCommand() {\n    MediaAnalyticsAdEndCommand.__super__.constructor.call(this);\n  }\n\n\n  __extends(MediaAnalyticsAdEndCommand, puremvc.SimpleCommand);\n\n\n  /**\n   * Executes the command.\n   *\n   * @param {puremvc.Notification} notification\n   *    The notification.\n   *\n   * @override\n  */\n  MediaAnalyticsAdEndCommand.prototype.execute = function(notification) {\n    try {\n      if (typeof akamaiHandleAdCompleted === \"function\") {\n        akamaiHandleAdCompleted();\n      }\n    } catch (error) {\n      this.facade.logger.error(\"[AMP MEDIA ANALYTICS ERROR]\", error);\n    }\n    this.facade.player.getMediaElement().dataset.isad = true;\n  };\n\n  /**\n   * The MediaAnalyticsSetDimensionsCommand class.\n   *\n   * @constructor\n   * @private\n   * @extends {puremvc.SimpleCommand}\n  */\n  function MediaAnalyticsSetDimensionsCommand() {\n    MediaAnalyticsSetDimensionsCommand.__super__.constructor.call(this);\n  }\n\n\n  __extends(MediaAnalyticsSetDimensionsCommand, PluginCommand);\n\n\n  /**\n   * Executes the command.\n   *\n   * @param {puremvc.Notification} notification\n   *    The notification.\n   *\n   * @override\n  */\n  MediaAnalyticsSetDimensionsCommand.prototype.execute = function(notification) {\n    var dimensions;\n    dimensions = notification.getBody();\n    this.proxy.setDimensions(dimensions);\n  };\n\n  /**\n   * The MediaAnalyticsContentChangedCommand class.\n   *\n   * @constructor\n   * @private\n   * @extends {puremvc.SimpleCommand}\n  */\n  function MediaAnalyticsContentChangedCommand() {\n    MediaAnalyticsContentChangedCommand.__super__.constructor.call(this);\n  }\n\n\n  __extends(MediaAnalyticsContentChangedCommand, PluginCommand);\n\n\n  /**\n   * Executes the command.\n   *\n   * @param {puremvc.Notification} notification\n   *    The notification.\n   *\n   * @override\n  */\n  MediaAnalyticsContentChangedCommand.prototype.execute = function(notification) {\n    this.proxy.updatedMedia(notification.getBody());\n  };\n\n  /**\n   * The MediaAnalyticsFragmentLoadStartCommand class.\n   *\n   * @constructor\n   * @private\n   * @extends {puremvc.SimpleCommand}\n  */\n  function MediaAnalyticsFragmentLoadStartCommand() {\n    MediaAnalyticsFragmentLoadStartCommand.__super__.constructor.call(this);\n  }\n\n\n  __extends(MediaAnalyticsFragmentLoadStartCommand, PluginCommand);\n\n\n  /**\n   * Executes the command.\n   *\n   * @param {puremvc.Notification} notification\n   *    The notification.\n   *\n   * @override\n  */\n  MediaAnalyticsFragmentLoadStartCommand.prototype.execute = function(notification) {\n    this.proxy.fragmentLoadStart(notification.getBody());\n  };\n\n  /**\n   * The MediaAnalyticsFragmentLoadedCommand class.\n   *\n   * @constructor\n   * @private\n   * @extends {puremvc.SimpleCommand}\n  */\n  function MediaAnalyticsFragmentLoadedCommand() {\n    MediaAnalyticsFragmentLoadedCommand.__super__.constructor.call(this);\n  }\n\n\n  __extends(MediaAnalyticsFragmentLoadedCommand, PluginCommand);\n\n\n  /**\n   * Executes the command.\n   *\n   * @param {puremvc.Notification} notification\n   *    The notification.\n   *\n   * @override\n  */\n  MediaAnalyticsFragmentLoadedCommand.prototype.execute = function(notification) {\n    this.proxy.fragmentLoaded(notification.getBody());\n  };\n\n  /**\n   * The MediaAnalyticsBitrateSwitchCommand class.\n   *\n   * @constructor\n   * @private\n   * @extends {puremvc.SimpleCommand}\n  */\n  function MediaAnalyticsBitrateSwitchCommand() {\n    MediaAnalyticsBitrateSwitchCommand.__super__.constructor.call(this);\n  }\n\n\n  __extends(MediaAnalyticsBitrateSwitchCommand, PluginCommand);\n\n\n  /**\n   * Executes the command.\n   *\n   * @param {puremvc.Notification} notification\n   *    The notification.\n   *\n   * @override\n  */\n  MediaAnalyticsBitrateSwitchCommand.prototype.execute = function(notification) {\n    this.proxy.bitrateSwitch(notification.getBody());\n  };\n\n  /**\n   * The AdPlayCommand class.\n   *\n   * @constructor\n   * @private\n   * @extends {AdCommand}\n  */\n  function AdPlayCommand() {\n    AdPlayCommand.__super__.constructor.call(this);\n  }\n\n\n  __extends(AdPlayCommand, PluginCommand);\n\n\n  /**\n   * Executes the command.\n   *\n   * @param {puremvc.Notification} notification\n   *    The notification.\n   *\n   * @override\n  */\n  AdPlayCommand.prototype.execute = function(notification) {\n    if (this.applicationState.getLocked() === true) {\n      return;\n    }\n    this.sendNotification(Notifications.PLAY_REQUEST);\n    if (this.proxy.getStarted() === false) {\n      this.sendNotification(Notifications.START, true);\n      return;\n    }\n    this.proxy.play();\n    this.facade.player.sendNotification(Notifications.CHANGE_PLAY_STATE, PlayState.PLAYING);\n  };\n\n  /**\n   * The AdPauseCommand class.\n   *\n   * @constructor\n   * @private\n   * @extends {AdCommand}\n  */\n  function AdPauseCommand() {\n    AdPauseCommand.__super__.constructor.call(this);\n  }\n\n\n  __extends(AdPauseCommand, PluginCommand);\n\n\n  /**\n   * Executes the command.\n   *\n   * @param {puremvc.Notification} notification\n   *    The notification.\n   *\n   * @override\n  */\n  AdPauseCommand.prototype.execute = function(notification) {\n    this.proxy.pause();\n    this.player.sendNotification(Notifications.CHANGE_PLAY_STATE, PlayState.PAUSED);\n  };\n\n  /**\n   * The AdTogglePlayPauseCommand class.\n   *\n   * @constructor\n   * @private\n   * @extends {AdCommand}\n  */\n  function AdTogglePlayPauseCommand() {\n    AdTogglePlayPauseCommand.__super__.constructor.call(this);\n  }\n\n\n  __extends(AdTogglePlayPauseCommand, PluginEventCommand);\n\n\n  /**\n   * Executes the command.\n   *\n   * @param {puremvc.Notification} notification\n   *    The notification.\n   *\n   * @override\n  */\n  AdTogglePlayPauseCommand.prototype.execute = function(notification) {\n    var note;\n    if (this.proxy.getPaused() || this.proxy.getStarted() === false) {\n      note = Notifications.PLAY;\n    } else {\n      note = Notifications.PAUSE;\n    }\n    this.sendNotification(note, true);\n  };\n\n  /**\n   * The AdVolumeChangeCommand class.\n   *\n   * @constructor\n   * @private\n   * @extends {AdCommand}\n  */\n  function AdVolumeChangeCommand() {\n    AdVolumeChangeCommand.__super__.constructor.call(this);\n  }\n\n\n  __extends(AdVolumeChangeCommand, PluginEventCommand);\n\n\n  /**\n   * Executes the command.\n   *\n   * @param {puremvc.Notification} notification\n   *    The notification.\n   *\n   * @override\n  */\n  AdVolumeChangeCommand.prototype.execute = function(notification) {\n    this.proxy.setVolume(notification.getBody());\n    AdVolumeChangeCommand.__super__.execute.call(this, notification);\n  };\n\n  /**\n   * The AdPlayStateChangeCommand class.\n   *\n   * @constructor\n   * @private\n   * @extends {AdCommand}\n  */\n  function AdPlayStateChangeCommand() {\n    AdPlayStateChangeCommand.__super__.constructor.call(this);\n  }\n\n\n  __extends(AdPlayStateChangeCommand, PluginEventCommand);\n\n\n  /**\n   * Executes the command.\n   *\n   * @param {puremvc.Notification} notification\n   *    The notification.\n   *\n   * @override\n  */\n  AdPlayStateChangeCommand.prototype.execute = function(notification) {\n    if (notification.getBody().value === \"playing\") {\n      this.dispatchEvent(\"playing\", this.proxy.adVO);\n    }\n  };\n\n  /**\n   * The AdStartCommand class.\n   *\n   * @constructor\n   * @private\n   * @extends {puremvc.MacroCommand}\n  */\n  function AdStartCommand() {\n    AdStartCommand.__super__.constructor.call(this);\n  }\n\n\n  __extends(AdStartCommand, PluginEventCommand);\n\n\n  /**\n   * Executes the command.\n   *\n   * @param {puremvc.Notification} notification\n   *    The notification.\n   *\n   * @override\n  */\n  AdStartCommand.prototype.execute = function(notification) {\n    this.sendNotification(Notifications.PLAY_REQUEST);\n    if (this.playback.initialized === false) {\n      this.player.sendNotification(Notifications.INITIALIZED);\n    }\n    this.proxy.start();\n    AdStartCommand.__super__.execute.call(this, notification);\n  };\n\n  /**\n   * The ControlsPlugin class.\n   *\n   * @param {Module}  app     The parent module of this plugin.\n   * @constructor\n   * @private\n   * @extends {Plugin}\n  */\n  function ControlsPlugin() {\n    ControlsPlugin.__super__.constructor.call(this);\n  }\n\n\n  __extends(ControlsPlugin, Plugin);\n\n\n  ControlsPlugin.prototype.moduleName = \"controls\";\n\n  /** @override\n  */\n  ControlsPlugin.prototype.createFramework = function() {\n    if (this.config[\"native\"] === true) {\n      this.player.getMediaElement().controls = true;\n      this.player.sendNotification(Notifications.ADD_APPLICATION_STATE, \"controls-native\");\n      this.registerCommand(Notifications.MEDIA_VALIDATED, ControlsMediaValidatedCommand);\n      this.registerCommand(AdNotifications.BREAK_START, ControlsAdBreakStartCommand);\n      this.registerCommand(AdNotifications.BREAK_END, ControlsAdBreakEndCommand);\n      this.registerCommand(Notifications.PLAY_REQUEST, ControlsStartedCommand);\n      this.createView = function() {};\n      return;\n    } else {\n      ControlsPlugin.__super__.createFramework.call(this);\n    }\n  };\n\n  /**\n  */\n  ControlsPlugin.prototype.applyClickHandler = function(apply) {\n    if (apply == null) {\n      apply = true;\n    }\n    this.player.getMediaElement().onclick = apply ? this.clickHandler.bind(this) : null;\n    this.player.getMediaElement().onplay = apply ? this.clickHandler.bind(this) : null;\n  };\n\n  /**\n  */\n  ControlsPlugin.prototype.clickHandler = function(event) {\n    this.sendNotification(UserNotifications.TOGGLE_PLAY_PAUSE, true);\n  };\n\n  /** @override\n  */\n  ControlsPlugin.prototype.createController = function() {\n    ControlsPlugin.__super__.createController.call(this);\n    this.registerCommand(Notifications.START, ControlsStartCommand);\n    this.registerCommand(Notifications.PLAY, ControlsPlayCommand);\n    this.registerCommand(Notifications.PAUSE, ControlsPauseCommand);\n    this.registerCommand(Notifications.ACTIVE_STATE_CHANGE, ControlsActiveStateChangeCommand);\n    this.registerCommand(AdNotifications.BREAK_START, ControlsAdBreakStartCommand);\n    this.registerCommand(AdNotifications.BREAK_END, ControlsAdBreakEndCommand);\n  };\n\n  /** @override\n  */\n  ControlsPlugin.prototype.createModel = function() {\n    this.proxy = new ControlsProxy(this.config);\n    this.registerProxy(this.proxy);\n  };\n\n  /** @override\n  */\n  ControlsPlugin.prototype.createView = function() {\n    this.registerMediator(new ControlsMediator());\n  };\n\n  /**\n  */\n  ControlsPlugin.prototype.listNotificationInterests = function() {\n    var key, value;\n    return ((function() {\n      var _results;\n      _results = [];\n      for (key in PanelNotifications) {\n        value = PanelNotifications[key];\n        _results.push(value);\n      }\n      return _results;\n    })()).concat([Notifications.MEDIA_CHANGE, Notifications.TIME_UPDATE, Notifications.DURATION_CHANGE, Notifications.PROGRESS, Notifications.ENDED, Notifications.ADD_CUE_POINTS, Notifications.REMOVE_CUE_POINTS, Notifications.DISABLE_FULL_SCREEN, Notifications.ENABLE_FULL_SCREEN, Notifications.READY, Notifications.ADD_CONTROL, Notifications.REMOVE_CONTROL, Notifications.ADD_CONTROL_STATE, Notifications.REMOVE_CONTROL_STATE, Notifications.ACTIVE_STATE_CHANGE, Notifications.START, Notifications.PLAY, Notifications.PAUSE, Notifications.ERROR, AdNotifications.BREAK_START, AdNotifications.BREAK_END, Notifications.CHANGE_MEDIA, Notifications.DISPLAY_TIME, Notifications.MEDIA_VALIDATED, Notifications.STARTED, Notifications.PLAY_REQUEST, Notifications.IS_LIVE]);\n  };\n\n  /**\n  */\n  ControlsPlugin.prototype.listNotificationPublications = function() {\n    return ControlsPlugin.__super__.listNotificationPublications.call(this).concat([Notifications.CHANGE_ACTIVE_STATE, Notifications.TOGGLE_FULL_SCREEN, UserNotifications.SEEK, Notifications.TOGGLE_ACTIVE, UserNotifications.TOGGLE_PLAY_PAUSE, Notifications.END, Notifications.REPLAY]);\n  };\n\n  /**\n   * @param {string} value The contorls mode.\n   * @expose\n  */\n  ControlsPlugin.prototype.setMode = function(value) {\n    this.proxy.setMode(value);\n    return value;\n  };\n\n  /**\n   * @return {string} The controls mode.\n   * @expose\n  */\n  ControlsPlugin.prototype.getMode = function() {\n    return this.proxy.getMode();\n  };\n\n  /**\n   * @param {boolean} value The autohide flag.\n   * @expose\n  */\n  ControlsPlugin.prototype.setAutoHide = function(value) {\n    this.proxy.setAutoHide(value);\n    return value;\n  };\n\n  /**\n   * @return {boolean} The autohide flag.\n   * @expose\n  */\n  ControlsPlugin.prototype.getAutoHide = function() {\n    return this.proxy.getAutoHide();\n  };\n\n\n  AMP.registerPlugin(\"controls\", \"html\", ControlsPlugin);\n  AMP.registerPlugin(\"controls\", \"flash\", ControlsWrapper);\n  AMP.registerPlugin(\"controls\", \"external\", ControlsPlugin);\n\n  /**\n   * @enum {string}\n   * @const\n   * @private\n  */\n\n  var IMANotifications = {\n    INITIALIZED: \"ima/initialize\",\n    ADD_OVERLAY: \"ima/addOverlay\",\n    REMOVE_OVERLAY: \"ima/removeOverlay\"\n  };\n\n  /**\n   * @constructor\n  */\n  function AdVO(id, title, duration, position, type, partner, advertiser, companions, request, metadata, totalAds, time) {\n    this.id = id;\n    this.title = title;\n    this.duration = duration;\n    this.position = position;\n    this.type = type;\n    this.partner = partner;\n    this.advertiser = advertiser;\n    this.companions = companions;\n    this.request = request;\n    this.metadata = metadata;\n    this.totalAds = totalAds;\n    this.time = time;\n  }\n\n  AdVO.prototype.id = null;\n\n  AdVO.prototype.title = null;\n\n  AdVO.prototype.duration = NaN;\n\n  AdVO.prototype.position = NaN;\n\n  AdVO.prototype.totalAds = NaN;\n\n  AdVO.prototype.type = null;\n\n  AdVO.prototype.partner = null;\n\n  AdVO.prototype.advertiser = null;\n\n  AdVO.prototype.companions = null;\n\n  AdVO.prototype.metadata = null;\n\n  AdVO.prototype.request = null;\n\n  AdVO.prototype.error = null;\n\n  AdVO.prototype.time = null;\n\n  /**\n   * Used to trigger overlay ads for Google IMA\n   *\n   * @constructor\n   * @private\n  */\n  function IMAOverlayProxy(config) {\n    IMAOverlayProxy.__super__.constructor.call(this, config);\n  }\n\n\n  __extends(IMAOverlayProxy, DataBoundConfigurationProxy);\n\n\n  IMAOverlayProxy.prototype.configurationName = \"imaoverlay\";\n\n  /** @static\n  */\n  IMAOverlayProxy.NAME = \"IMAOveralyProxy\";\n\n  IMAOverlayProxy.prototype.defaults = {\n    adTagUrl: null,\n    duration: 15,\n    interval: 30,\n    delay: 30\n  };\n\n  IMAOverlayProxy.prototype.durationTimer = null;\n\n  IMAOverlayProxy.prototype.intervalTimer = null;\n\n  IMAOverlayProxy.prototype.delayTimer = null;\n\n  /** Stops polling and clears the ad\n  */\n  IMAOverlayProxy.prototype.stop = function() {\n    clearTimeout(this.durationTimer);\n    clearTimeout(this.delayTimer);\n    clearTimeout(this.intervalTimer);\n  };\n\n  /** Starts polling and load the first ad\n  */\n  IMAOverlayProxy.prototype.play = function() {\n    var _this = this;\n    this.stop();\n    this.delayTimer = setTimeout(function() {\n      return _this.requestAd();\n    }, this.value.delay * 1000);\n  };\n\n  /** Retrieves an ad image from VAST XML\n  */\n  IMAOverlayProxy.prototype.requestAd = function() {\n    var adTagUrl, xhr;\n    adTagUrl = this.getValue(\"adTagUrl\");\n    if (adTagUrl != null) {\n      adTagUrl = adTagUrl.replace(\"[timestamp]\", new Date().getTime());\n      adTagUrl = adTagUrl.replace(\"__random-number__\", new Date().getTime());\n    }\n    xhr = Utils.get(adTagUrl, {\n      withCredentials: true,\n      onload: this.vastLoadHandler.bind(this),\n      onerror: this.error.bind(this)\n    }, false);\n  };\n\n  IMAOverlayProxy.prototype.vastLoadHandler = function(xhr) {\n    var ad, clickThroughHref, creativeView, img, impression, xml;\n    xml = xhr.target.responseXML;\n    if (xml != null) {\n      try {\n        ad = xml.querySelector(\"NonLinear\");\n        if (ad != null) {\n          impression = xml.querySelector(\"Impression\") != null ? xml.querySelector(\"Impression\").textContent : \"\";\n          creativeView = xml.querySelector(\"Tracking[event=creativeView]\") != null ? xml.querySelector(\"Tracking[event=creativeView]\").textContent : \"\";\n          clickThroughHref = ad.querySelector(\"NonLinearClickThrough\") != null ? ad.querySelector(\"NonLinearClickThrough\").textContent : \"\";\n          img = {\n            src: ad.querySelector(\"StaticResource\").textContent,\n            width: ad.getAttribute(\"width\"),\n            height: ad.getAttribute(\"height\"),\n            tracking: [impression, creativeView],\n            href: clickThroughHref\n          };\n          this.displayAd(img);\n        } else {\n          this.error(\"No overlay was returned\");\n        }\n      } catch (error) {\n        this.error(error);\n      }\n    }\n  };\n\n  IMAOverlayProxy.prototype.error = function(error) {\n    this.facade.logger.error(\"[AMP IMA OVERLAY ERROR]\", error);\n    this.stop();\n  };\n\n  /** Notifies the application that a new overlay is ready to display\n  */\n  IMAOverlayProxy.prototype.displayAd = function(ad) {\n    var _this = this;\n    this.sendNotification(IMANotifications.ADD_OVERLAY, ad);\n    this.durationTimer = setTimeout(function() {\n      _this.sendNotification(IMANotifications.REMOVE_OVERLAY);\n      return _this.intervalTimer = setTimeout(function() {\n        return _this.requestAd();\n      }, _this.value.interval * 1000);\n    }, this.value.duration * 1000);\n  };\n\n  /**\n   * The AdProxy class.\n   *\n   * @constructor\n   * @private\n   * @extends {PluginProxy}\n   * @param {Object} config\n   * @implements {IDataBindingContext}\n  */\n  function AdProxy(config) {\n    AdProxy.__super__.constructor.call(this, config);\n    this.pods = [];\n  }\n\n\n  __extends(AdProxy, PluginProxy);\n\n\n  /** @static\n  */\n  AdProxy.NAME = PluginProxy.NAME;\n\n  AdProxy.prototype.inprogress = false;\n\n  AdProxy.prototype.paused = false;\n\n  AdProxy.prototype.started = false;\n\n  AdProxy.prototype.adVO = null;\n\n  AdProxy.prototype.contextName = \"ad\";\n\n  AdProxy.prototype.container = null;\n\n  AdProxy.prototype.partner = null;\n\n  AdProxy.prototype.pods = null;\n\n  AdProxy.prototype.createDefaultAdVO = function() {\n    return new AdVO(null, null, null, null, null, this.partner, null, null, null, null, null);\n  };\n\n  /**\n   * Gets the context data for this proxy.\n   *\n   * @returns {Object} The contenxt data for this proxy\n  */\n  AdProxy.prototype.getContextData = function() {\n    return this.adVO || {};\n  };\n\n  /**\n  */\n  AdProxy.prototype.setCompanions = function(value) {\n    this.adVO.companions = value;\n    this.sendNotification(AdNotifications.AD_COMPANION, this.adVO);\n    return value;\n  };\n\n  AdProxy.prototype.getCompanions = function() {\n    var _ref;\n    return (_ref = this.adVO) != null ? _ref.companions : void 0;\n  };\n\n  /**\n  */\n  AdProxy.prototype.getInProgress = function() {\n    return this.inprogress;\n  };\n\n  AdProxy.prototype.setInProgress = function(value) {\n    this.inprogress = value;\n    return value;\n  };\n\n  /**\n  */\n  AdProxy.prototype.getStarted = function() {\n    return this.started;\n  };\n\n  /**\n  */\n  AdProxy.prototype.setStarted = function(value) {\n    this.started = value;\n    return value;\n  };\n\n  /**\n  */\n  AdProxy.prototype.getPaused = function() {\n    return this.paused;\n  };\n\n  AdProxy.prototype.setPaused = function(value) {\n    this.paused = value;\n    return value;\n  };\n\n  /**\n  */\n  AdProxy.prototype.play = function() {\n    this.setPaused(false);\n    this.sendNotification(AdNotifications.AD_PLAY, this.adVO);\n  };\n\n  /**\n  */\n  AdProxy.prototype.pause = function() {\n    this.setPaused(true);\n    this.sendNotification(AdNotifications.AD_PAUSE, this.adVO);\n  };\n\n  /**\n  */\n  AdProxy.prototype.breakStart = function() {\n    this.setInProgress(true);\n  };\n\n  /**\n  */\n  AdProxy.prototype.breakEnd = function() {\n    this.setInProgress(false);\n    this.reset();\n  };\n\n  /**\n  */\n  AdProxy.prototype.error = function(err, breakEnd) {\n    var msg;\n    if (breakEnd == null) {\n      breakEnd = true;\n    }\n    msg = (typeof err.getMessage === \"function\" ? err.getMessage() : void 0) || err.message;\n    this.facade.logger.error(\"[AMP AD ERROR]\", \"\" + msg + \" Skipping ad content.\", err);\n    if (this.adVO == null) {\n      this.adVO = {};\n    }\n    this.adVO.error = err;\n    this.sendNotification(AdNotifications.AD_ERROR, this.adVO);\n    if (breakEnd === true) {\n      this.endBreak();\n    }\n  };\n\n  /**\n  */\n  AdProxy.prototype.engage = function(media) {\n    if (this.getEnabled() === false) {\n      return;\n    }\n    this.setStarted(false);\n    if (this.getInProgress()) {\n      this.reset();\n      this.facade.player.sendNotification(Notifications.REMOVE_APPLICATION_STATE, \"ad-mode\");\n    }\n    this.engageAds();\n  };\n\n  /**\n  */\n  AdProxy.prototype.engageAds = function() {\n    this.facade.player.removeCommand(Notifications.START);\n    this.facade.player.removeCommand(Notifications.PLAY);\n    this.facade.player.removeCommand(Notifications.PAUSE);\n    this.facade.player.removeCommand(Notifications.ENDED);\n    this.facade.player.removeCommand(UserNotifications.PLAY);\n    this.facade.player.removeCommand(UserNotifications.PAUSE);\n    this.facade.player.removeCommand(UserNotifications.TOGGLE_PLAY_PAUSE);\n    if (this.facade.isFullscreenDevice()) {\n      this.facade.player.removeCommand(Notifications.CHANGE_DURATION);\n    }\n    this.facade.removeCommand(Notifications.STARTED);\n    this.facade.removeCommand(Notifications.ENDED);\n    this.facade.registerCommand(Notifications.START, AdStartCommand);\n    this.facade.registerCommand(Notifications.PLAY, AdPlayCommand);\n    this.facade.registerCommand(Notifications.PAUSE, AdPauseCommand);\n    this.facade.registerCommand(UserNotifications.PLAY, AdPlayCommand);\n    this.facade.registerCommand(UserNotifications.PAUSE, AdPauseCommand);\n    this.facade.registerCommand(UserNotifications.TOGGLE_PLAY_PAUSE, AdTogglePlayPauseCommand);\n    this.facade.registerCommand(Notifications.VOLUME_CHANGE, AdVolumeChangeCommand);\n    this.facade.registerCommand(Notifications.PLAY_STATE_CHANGE, AdPlayStateChangeCommand);\n  };\n\n  /**\n  */\n  AdProxy.prototype.reset = function() {\n    this.facade.removeCommand(Notifications.START);\n    this.facade.removeCommand(Notifications.PLAY);\n    this.facade.removeCommand(Notifications.PAUSE);\n    this.facade.removeCommand(UserNotifications.PLAY);\n    this.facade.removeCommand(UserNotifications.PAUSE);\n    this.facade.removeCommand(UserNotifications.TOGGLE_PLAY_PAUSE);\n    this.facade.removeCommand(Notifications.VOLUME_CHANGE);\n    this.facade.removeCommand(Notifications.PLAY_STATE_CHANGE);\n    this.facade.player.registerCommand(Notifications.START, StartCommand);\n    this.facade.player.registerCommand(Notifications.PLAY, PlayCommand);\n    this.facade.player.registerCommand(Notifications.PAUSE, PauseCommand);\n    this.facade.player.registerCommand(Notifications.ENDED, EndedCommand);\n    this.facade.player.registerCommand(UserNotifications.PLAY, PlayCommand);\n    this.facade.player.registerCommand(UserNotifications.PAUSE, PauseCommand);\n    this.facade.player.registerCommand(UserNotifications.TOGGLE_PLAY_PAUSE, TogglePlayPauseCommand);\n    if (this.facade.isFullscreenDevice()) {\n      this.facade.player.registerCommand(Notifications.CHANGE_DURATION, ChangeDurationCommand);\n    }\n    this.facade.registerCommand(Notifications.STARTED, AdContentStartedCommand);\n    this.facade.registerCommand(Notifications.ENDED, AdContentEndedCommand);\n  };\n\n  /**\n  */\n  AdProxy.prototype.requestAd = function() {\n    this.sendNotification(AdNotifications.REQUEST, this.adVO);\n  };\n\n  /**\n  */\n  AdProxy.prototype.getPodById = function(id) {\n    var pod, _i, _len, _ref;\n    _ref = this.pods;\n    for (_i = 0, _len = _ref.length; _i < _len; _i++) {\n      pod = _ref[_i];\n      if (pod.id === id) {\n        return pod;\n      }\n    }\n  };\n\n  /**\n  */\n  AdProxy.prototype.setPodLocks = function(pods) {\n    var pod, _i, _len, _ref;\n    for (_i = 0, _len = pods.length; _i < _len; _i++) {\n      pod = pods[_i];\n      if ((_ref = this.getPodById(pod.id)) != null) {\n        _ref.locked = pod.locked;\n      }\n    }\n  };\n\n  /**\n  */\n  AdProxy.prototype.startBreak = function() {\n    this.setStarted(true);\n    this.sendNotification(AdNotifications.BREAK_START, this.adVO);\n    if (this.getEnabled() === false) {\n      this.endBreak();\n      return false;\n    }\n    return true;\n  };\n\n  /**\n  */\n  AdProxy.prototype.endBreak = function() {\n    this.sendNotification(AdNotifications.BREAK_END, this.adVO);\n  };\n\n  /**\n  */\n  AdProxy.prototype.start = function() {\n    this.startBreak();\n  };\n\n  /**\n  */\n  AdProxy.prototype.contentPlay = function() {\n    this.facade.player.sendNotification(Notifications.PLAY, true);\n  };\n\n  /**\n  */\n  AdProxy.prototype.contentPause = function() {\n    var pause, video,\n      _this = this;\n    video = this.facade.player.mediaElement;\n    pause = function() {\n      video.removeEventListener(\"seeked\", pause);\n      video.pause();\n    };\n    if (video.seeking === true) {\n      video.addEventListener(\"seeked\", pause);\n    } else {\n      pause();\n    }\n  };\n\n  /**\n  */\n  AdProxy.prototype.contentStarted = function() {};\n\n  /**\n  */\n  AdProxy.prototype.contentSeek = function(time) {};\n\n  /**\n  */\n  AdProxy.prototype.contentEnded = function() {};\n\n  /**\n  */\n  AdProxy.prototype.setVolume = function(value) {};\n\n  /**\n  */\n  AdProxy.prototype.getVolume = function() {};\n\n  /**\n  */\n  AdProxy.prototype.terminateAd = function() {};\n\n  /**\n  */\n  AdProxy.prototype.terminateAllAds = function() {};\n\n  /**\n   * The IMAProxy class.\n   *\n   * @constructor\n   * @private\n   * @extends {AdProxy}\n   * @param {Object} config\n  */\n  function IMAProxy(config) {\n    IMAProxy.__super__.constructor.call(this, config);\n    this.intervals = [];\n    this.loadedmetadata = this.onLoadedMetadata.bind(this);\n    this.adVO = this.createDefaultAdVO();\n  }\n\n\n  __extends(IMAProxy, AdProxy);\n\n\n  /** @static\n  */\n  IMAProxy.NAME = AdProxy.NAME;\n\n  IMAProxy.prototype.defaults = {\n    adTagUrl: null,\n    overlay: null,\n    width: null,\n    height: null,\n    maxBitrate: -1,\n    ppid: null,\n    companions: null,\n    logEventsEnabled: false\n  };\n\n  IMAProxy.prototype.partner = \"ima\";\n\n  IMAProxy.prototype.key = \"ima\";\n\n  IMAProxy.prototype.intervals = null;\n\n  IMAProxy.prototype.adDisplayContainer = null;\n\n  IMAProxy.prototype.adDisplayContainerInitialized = false;\n\n  IMAProxy.prototype.adsLoader = null;\n\n  IMAProxy.prototype.adsRenderingSettings = null;\n\n  IMAProxy.prototype.adsManagerLoaded = false;\n\n  IMAProxy.prototype.adsManager = null;\n\n  IMAProxy.prototype.cuepoints = null;\n\n  IMAProxy.prototype.adLoaded = false;\n\n  IMAProxy.prototype.playWhenLoaded = false;\n\n  IMAProxy.prototype.contentHasEnded = false;\n\n  IMAProxy.prototype.adTagUrl = null;\n\n  IMAProxy.prototype.viewMode = null;\n\n  IMAProxy.prototype.playbackCore = null;\n\n  IMAProxy.prototype.loadedmetadata = null;\n\n  /**\n  */\n  IMAProxy.prototype.setEnabled = function(value) {\n    var _ref;\n    IMAProxy.__super__.setEnabled.call(this, value);\n    if (value === false) {\n      if ((_ref = this.adsManager) != null) {\n        if (typeof _ref.destroy === \"function\") {\n          _ref.destroy();\n        }\n      }\n      if (this.getInProgress()) {\n        this.contentPlay();\n      }\n    }\n    return value;\n  };\n\n  /** @override\n  */\n  IMAProxy.prototype.onLoadedMetadata = function(event) {\n    event.target.removeEventListener(\"loadedmetadata\", this.loadedmetadata);\n    if (this.canPlay() && this.playWhenLoaded === true) {\n      this.startAd();\n    }\n  };\n\n  /** @override\n  */\n  IMAProxy.prototype.initialize = function() {};\n\n  /** @override\n  */\n  IMAProxy.prototype.ready = function() {\n    var mode;\n    this.viewMode = google.ima.ViewMode.NORMAL;\n    window.addEventListener(\"resize\", this.resize.bind(this));\n    if (this.config.vpaidAllowed != null) {\n      google.ima.settings.setVpaidAllowed(this.config.vpaidAllowed);\n    }\n    if ((this.config.vpaidMode != null) && ((mode = google.ima.ImaSdkSettings.VpaidMode[this.config.vpaidMode.toUpperCase()]) != null)) {\n      google.ima.settings.setVpaidMode(mode);\n    }\n    this.adDisplayContainer = this.createPlugin();\n    this.adsLoader = new google.ima.AdsLoader(this.adDisplayContainer);\n    this.adsRenderingSettings = new google.ima.AdsRenderingSettings();\n    this.adsLoader.addEventListener(google.ima.AdsManagerLoadedEvent.Type.ADS_MANAGER_LOADED, this.onAdsManagerLoaded.bind(this), false);\n    this.adsLoader.addEventListener(google.ima.AdErrorEvent.Type.AD_ERROR, this.onAdError.bind(this), false);\n  };\n\n  /** @override\n  */\n  IMAProxy.prototype.createPlugin = function() {\n    return new google.ima.AdDisplayContainer(this.facade.getViewComponent().container);\n  };\n\n  /** @override\n  */\n  IMAProxy.prototype.engage = function(override) {\n    var _ref, _ref1;\n    if (override == null) {\n      override = true;\n    }\n    if (this.getEnabled() === false) {\n      return;\n    }\n    IMAProxy.__super__.engage.call(this);\n    if (this.adsManagerLoaded === true && this.contentHasEnded === false || this.contentHasEnded === true && ((_ref = this.adVO) != null ? _ref.type : void 0) === \"postroll\") {\n      if ((_ref1 = this.adsManager) != null) {\n        if (typeof _ref1.destroy === \"function\") {\n          _ref1.destroy();\n        }\n      }\n    }\n    this.adsManagerLoaded = false;\n    this.contentHasEnded = false;\n    this.adsManagerLoaded = false;\n    this.playWhenLoaded = false;\n  };\n\n  /**\n  */\n  IMAProxy.prototype.setVolume = function(value) {\n    var _ref;\n    if ((_ref = this.adsManager) != null) {\n      _ref.setVolume(value);\n    }\n    return value;\n  };\n\n  /**\n  */\n  IMAProxy.prototype.getVolume = function() {\n    var _ref;\n    return (_ref = this.adsManager) != null ? _ref.getVolume() : void 0;\n  };\n\n  /** @override\n  */\n  IMAProxy.prototype.requestAd = function() {\n    var adsRequest, adsResponse, height, settings, width, _ref, _ref1;\n    IMAProxy.__super__.requestAd.call(this);\n    width = this.facade.player.getViewComponent().clientWidth;\n    height = this.facade.player.getViewComponent().clientHeight;\n    adsRequest = new google.ima.AdsRequest();\n    this.adTagUrl = this.getValue(\"adTagUrl\");\n    adsResponse = this.getValue(\"adsResponse\");\n    if ((adsResponse != null) && adsResponse !== \"\") {\n      adsRequest.adsResponse = Utils.read(adsResponse, null, Utils.mimeTypes.txt);\n    } else {\n      adsRequest.adTagUrl = this.adTagUrl;\n    }\n    if (!(adsRequest.adsResponse != null) && !(adsRequest.adTagUrl != null)) {\n      this.onAdError(\"No valid adTagUrl or adsResponse provided.\");\n      return;\n    }\n    adsRequest.linearAdSlotWidth = width;\n    adsRequest.linearAdSlotHeight = height;\n    adsRequest.nonLinearAdSlotWidth = ((_ref = this.value.overlay) != null ? _ref.width : void 0) || width;\n    adsRequest.nonLinearAdSlotHeight = ((_ref1 = this.value.overlay) != null ? _ref1.height : void 0) || height;\n    settings = this.adsLoader.getSettings();\n    if (this.config.ppid != null) {\n      settings.setPpid(this.getValue(\"ppid\"));\n    }\n    this.adsLoader.requestAds(adsRequest);\n  };\n\n  /** @override\n  */\n  IMAProxy.prototype.requestOverlay = function() {\n    var adsRequest, overlay;\n    overlay = this.value.overlay;\n    if (!(overlay != null)) {\n      return;\n    }\n    adsRequest = new google.ima.AdsRequest();\n    adsRequest.adTagUrl = overlay.adTagUrl;\n    adsRequest.nonLinearAdSlotWidth = overlay.width || 300;\n    adsRequest.nonLinearAdSlotHeight = overlay.height || 50;\n    this.adsLoader.requestAds(adsRequest);\n  };\n\n  /** @override\n  */\n  IMAProxy.prototype.start = function(load) {\n    var video;\n    if (load == null) {\n      load = true;\n    }\n    if (load === true) {\n      this.playbackCore = this.facade.player.retrieveProxy(PlayerProxy.NAME).getActivePlaybackCore();\n      video = this.getMediaElement();\n      this.playbackCore.setEnabled(false);\n      video.src = this.playbackCore.getSrc();\n      video.addEventListener(\"loadedmetadata\", this.loadedmetadata);\n      video.load();\n    } else {\n      this.engage();\n    }\n    if (IMAProxy.__super__.start.call(this) === false) {\n      return false;\n    }\n    this.isLiveMidroll = (load === false) && (this.facade.player.retrieveProxy(MediaProxy.NAME).getTemporalType() === \"live\");\n    if (this.adDisplayContainerInitialized !== true) {\n      this.adDisplayContainer.initialize();\n      this.adDisplayContainerInitialized = true;\n    }\n    if (this.canPlay() === true && load === true) {\n      this.startAd();\n    } else {\n      this.playWhenLoaded = true;\n      this.requestAd();\n    }\n  };\n\n  /**\n  */\n  IMAProxy.prototype.canPlay = function() {\n    return this.adsManagerLoaded === true;\n  };\n\n  /**\n  */\n  IMAProxy.prototype.startAd = function() {\n    this.playWhenLoaded = false;\n    try {\n      if (this.viewMode == null) {\n        this.viewMode = google.ima.ViewMode.NORMAL;\n      }\n      this.adsManager.init(this.facade.player.getViewComponent().clientWidth, this.facade.player.getViewComponent().clientHeight, this.viewMode);\n      this.adsManager.start();\n    } catch (adError) {\n      this.error(adError);\n    }\n  };\n\n  IMAProxy.prototype.resize = function(state) {\n    var _ref;\n    if (state != null) {\n      this.viewMode = state === DisplayState.FULL_SCREEN ? google.ima.ViewMode.FULLSCREEN : google.ima.ViewMode.NORMAL;\n    }\n    if ((_ref = this.adsManager) != null) {\n      _ref.resize(this.container.container.clientWidth, this.container.container.clientHeight, this.viewMode);\n    }\n  };\n\n  /**\n  */\n  IMAProxy.prototype.onAdsManagerLoaded = function(adsManagerLoadedEvent) {\n    var adEventHandler, _ref;\n    this.adsRenderingSettings.bitrate = this.getValue(\"maxBitrate\");\n    this.adsRenderingSettings.autoAlign = true;\n    this.adsRenderingSettings.useStyledNonLinearAds = true;\n    if ((_ref = this.adsManager) != null) {\n      if (typeof _ref.destroy === \"function\") {\n        _ref.destroy();\n      }\n    }\n    this.adsManager = adsManagerLoadedEvent.getAdsManager(this.facade.player.mediaElement, this.adsRenderingSettings);\n    this.facade.player.sendNotification(AdNotifications.AD_MANAGER_LOADED, {\n      \"adManager\": this.adsManager,\n      \"viewMode\": google.ima.ViewMode.NORMAL,\n      \"adContainer\": this.facade.getViewComponent()\n    });\n    this.adsManagerLoaded = true;\n    this.cuePoints = this.adsManager.getCuePoints();\n    this.sendNotification(Notifications.ADD_CUE_POINTS, this.cuePoints);\n    if (this.cuePoints.indexOf(-1) !== -1) {\n      this.sendNotification(Notifications.HAS_POST_CONTENT, true);\n    }\n    adEventHandler = this.onAdEvent.bind(this);\n    this.adsManager.addEventListener(google.ima.AdErrorEvent.Type.AD_ERROR, this.onAdError.bind(this));\n    this.adsManager.addEventListener(google.ima.AdEvent.Type.CONTENT_PAUSE_REQUESTED, this.contentPause.bind(this));\n    this.adsManager.addEventListener(google.ima.AdEvent.Type.CONTENT_RESUME_REQUESTED, this.contentPlay.bind(this));\n    this.adsManager.addEventListener(google.ima.AdEvent.Type.ALL_ADS_COMPLETED, adEventHandler);\n    this.adsManager.addEventListener(google.ima.AdEvent.Type.LOADED, adEventHandler);\n    this.adsManager.addEventListener(google.ima.AdEvent.Type.STARTED, adEventHandler);\n    this.adsManager.addEventListener(google.ima.AdEvent.Type.RESUMED, this.onAdResumed.bind(this));\n    this.adsManager.addEventListener(google.ima.AdEvent.Type.PAUSED, this.onAdPaused.bind(this));\n    this.adsManager.addEventListener(google.ima.AdEvent.Type.COMPLETE, adEventHandler);\n    this.adsManager.addEventListener(google.ima.AdEvent.Type.CLICK, this.onAdClick.bind(this));\n    this.adsManager.addEventListener(google.ima.AdEvent.Type.IMPRESSION, adEventHandler);\n    this.adsManager.addEventListener(google.ima.AdEvent.Type.FIRST_QUARTILE, adEventHandler);\n    this.adsManager.addEventListener(google.ima.AdEvent.Type.MIDPOINT, adEventHandler);\n    this.adsManager.addEventListener(google.ima.AdEvent.Type.THIRD_QUARTILE, adEventHandler);\n    this.adsManager.addEventListener(google.ima.AdEvent.Type.SKIPPED, adEventHandler);\n    if (this.getValue(\"logEventsEnabled\") === true) {\n      this.adsManager.addEventListener(google.ima.AdEvent.Type.LOG, adEventHandler);\n    }\n    this.sendNotification(AdNotifications.REQUEST_COMPLETE, {\n      pods: this.cuePoints\n    });\n    this.sendNotification(AdNotifications.RESPONSE, {\n      pods: this.cuePoints,\n      response: adsManagerLoadedEvent,\n      adsManager: this.adsManager\n    });\n    if (this.canPlay() && this.playWhenLoaded === true) {\n      this.startAd();\n    }\n  };\n\n  /**\n  */\n  IMAProxy.prototype.onAdClick = function(adEvent) {\n    if ((adEvent != null ? adEvent.getAd().isLinear() : void 0) === false) {\n      this.facade.player.sendNotification(Notifications.PAUSE);\n      return;\n    }\n    if (!this.getPaused()) {\n      this.pause();\n    }\n    this.sendNotification(AdNotifications.AD_CLICKED, this.adVO);\n  };\n\n  /**\n  */\n  IMAProxy.prototype.onAdPaused = function(adEvent) {\n    this.setPaused(true);\n    this.facade.player.sendNotification(Notifications.CHANGE_PLAY_STATE, PlayState.PAUSED);\n    this.facade.player.sendNotification(Notifications.CHANGE_ACTIVE_STATE, ActiveState.ACTIVE);\n    this.facade.player.sendNotification(AdNotifications.AD_PAUSED, this.adVO);\n  };\n\n  /**\n  */\n  IMAProxy.prototype.onAdResumed = function(adEvent) {\n    this.setPaused(false);\n    this.facade.player.sendNotification(Notifications.CHANGE_PLAY_STATE, PlayState.PLAYING);\n  };\n\n  /**\n  */\n  IMAProxy.prototype.onAdEvent = function(adEvent) {\n    var ad, companion, companions, config, pos, type, _i, _len, _ref;\n    ad = adEvent.getAd();\n    if (this.adVO != null) {\n      if (ad != null) {\n        ad.wrapperAdIds = typeof ad.getWrapperAdIds === \"function\" ? ad.getWrapperAdIds() : void 0;\n        ad.wrapperAdSystems = typeof ad.getWrapperAdSystems === \"function\" ? ad.getWrapperAdSystems() : void 0;\n      }\n      this.adVO.metadata = ad;\n    }\n    switch (adEvent.type) {\n      case google.ima.AdEvent.Type.IMPRESSION:\n        this.sendNotification(AdNotifications.IMPRESSION, this.adVO);\n        break;\n      case google.ima.AdEvent.Type.LOADED:\n        if (ad.isLinear()) {\n          pos = ad.getAdPodInfo().getPodIndex();\n          type = pos === 0 ? \"preroll\" : pos === -1 ? \"postroll\" : \"midroll\";\n          this.adVO = new AdVO(ad.getAdId(), ad.getAdId(), ad.getDuration(), pos, type, \"ima\", null, null, this.adTagUrl, ad, ad.getAdPodInfo().getTotalAds());\n          if (!this.getInProgress() && type === \"midroll\" || type === \"postroll\") {\n            this.startBreak();\n            this.engageAds();\n          }\n          this.resize();\n          this.sendNotification(AdNotifications.AD_LOADED, this.adVO);\n          this.sendNotification(AdNotifications.AD_DURATION_CHANGE, this.adVO);\n          this.setVolume(this.facade.player.getVolume());\n        } else {\n          this.facade.player.sendNotification(Notifications.ADD_APPLICATION_STATE, \"ad-overlaymode\");\n          this.contentPlay();\n        }\n        break;\n      case google.ima.AdEvent.Type.STARTED:\n        if (ad.isLinear()) {\n          this.adVO.position = ad.getAdPodInfo().getAdPosition();\n          this.sendNotification(AdNotifications.AD_STARTED, this.adVO);\n          this.intervals.push(setInterval(this.onAdTimeUpdate.bind(this), 300));\n          this.facade.player.sendNotification(Notifications.CHANGE_PLAY_STATE, PlayState.PLAYING);\n          this.sendNotification(AdNotifications.AD_PLAY, this.adVO);\n        }\n        try {\n          companions = [];\n          config = (typeof this.getConfigurationData === \"function\" ? (_ref = this.getConfigurationData()) != null ? _ref.companions : void 0 : void 0) || [];\n          for (_i = 0, _len = config.length; _i < _len; _i++) {\n            companion = config[_i];\n            companions = companions.concat(ad.getCompanionAds(companion.width, companion.height));\n          }\n          if ((companions != null ? companions.length : void 0) > 0) {\n            this.setCompanions(companions);\n          }\n        } catch (error) {\n          this.facade.logger.error(\"[AMP IMA ERROR]\", \"Could not retrieve companion ads:\", error);\n        }\n        break;\n      case google.ima.AdEvent.Type.COMPLETE:\n        if (ad.isLinear()) {\n          this.sendNotification(AdNotifications.AD_ENDED, this.adVO);\n        }\n        break;\n      case google.ima.AdEvent.Type.FIRST_QUARTILE:\n        this.sendNotification(AdNotifications.FIRST_QUARTILE, this.adVO);\n        break;\n      case google.ima.AdEvent.Type.MIDPOINT:\n        this.sendNotification(AdNotifications.MIDPOINT, this.adVO);\n        break;\n      case google.ima.AdEvent.Type.THIRD_QUARTILE:\n        this.sendNotification(AdNotifications.THIRD_QUARTILE, this.adVO);\n        break;\n      case google.ima.AdEvent.Type.LOG:\n        this.sendNotification(AdNotifications.LOG, this.adVO);\n        break;\n      case google.ima.AdEvent.Type.SKIPPED:\n        this.sendNotification(AdNotifications.SKIPPED, this.adVO);\n        break;\n      case google.ima.AdEvent.Type.ALL_ADS_COMPLETED:\n        if (this.appState.getHasPostContent() === true) {\n          this.sendNotification(Notifications.MEDIA_SEQUENCE_ENDED);\n        }\n        if (this.getInProgress() === true) {\n          this.endBreak();\n        }\n    }\n  };\n\n  /**\n  */\n  IMAProxy.prototype.onAdTimeUpdate = function(adErrorEvent) {\n    var remaining;\n    remaining = this.adsManager.getRemainingTime();\n    this.sendNotification(AdNotifications.AD_TIME_UPDATE, this.adVO.duration - remaining);\n    this.sendNotification(AdNotifications.AD_TIME_REMAINING, remaining);\n  };\n\n  /**\n  */\n  IMAProxy.prototype.onAdError = function(adErrorEvent) {\n    var error;\n    error = (adErrorEvent != null ? typeof adErrorEvent.getError === \"function\" ? adErrorEvent.getError() : void 0 : void 0) || adErrorEvent;\n    this.error(error);\n    this.contentPlay();\n  };\n\n  /**\n  */\n  IMAProxy.prototype.play = function() {\n    var _ref;\n    IMAProxy.__super__.play.call(this);\n    try {\n      if ((_ref = this.adsManager) != null) {\n        _ref.resume();\n      }\n      this.sendNotification(AdNotifications.AD_RESUME);\n    } catch (error) {\n      this.facade.logger.error(\"[AMP IMA ERROR]\", \"resume\", error);\n    }\n  };\n\n  /**\n  */\n  IMAProxy.prototype.pause = function() {\n    IMAProxy.__super__.pause.call(this);\n    if (this.adsManager != null) {\n      try {\n        this.adsManager.pause();\n      } catch (error) {\n        this.facade.logger.error(\"[AMP IMA ERROR]\", \"pause\", error);\n      }\n    } else {\n      this.playWhenLoaded = false;\n    }\n  };\n\n  /**\n  */\n  IMAProxy.prototype.breakEnd = function() {\n    var interval, overlayProxy, _i, _len, _ref;\n    _ref = this.intervals;\n    for (_i = 0, _len = _ref.length; _i < _len; _i++) {\n      interval = _ref[_i];\n      clearInterval(this.intervals.pop());\n    }\n    IMAProxy.__super__.breakEnd.call(this);\n    overlayProxy = this.facade.retrieveProxy(IMAOverlayProxy.NAME);\n    if (overlayProxy != null) {\n      overlayProxy.play();\n    }\n  };\n\n  /**\n  */\n  IMAProxy.prototype.setCompanions = function(value) {\n    var companion, companions, _i, _len, _ref;\n    companions = [];\n    for (_i = 0, _len = value.length; _i < _len; _i++) {\n      companion = value[_i];\n      companions.push({\n        data: companion.getContent(),\n        type: (_ref = companion.getContentType()) != null ? _ref.toLowerCase() : void 0,\n        width: companion.getWidth(),\n        height: companion.getHeight(),\n        metadata: companion\n      });\n    }\n    IMAProxy.__super__.setCompanions.call(this, companions);\n    return value;\n  };\n\n  /**\n  */\n  IMAProxy.prototype.contentPause = function() {\n    this.sendNotification(Notifications.DISABLE_VIDEO_EVENTS, [\"pause\", \"seeked\", \"waiting\", \"playing\", \"ended\", \"durationchange\", \"error\"]);\n    if (this.isLiveMidroll === true) {\n      this.getMediaElement().volume = 0;\n      return;\n    }\n    IMAProxy.__super__.contentPause.call(this);\n  };\n\n  /**\n  */\n  IMAProxy.prototype.contentPlay = function() {\n    var _ref, _ref1;\n    if (this.getInProgress() === true) {\n      this.endBreak();\n    }\n    this.sendNotification(Notifications.ENABLE_VIDEO_EVENTS, [\"pause\", \"seeked\", \"waiting\", \"playing\", \"ended\", \"durationchange\", \"error\"]);\n    if (((_ref = this.adVO) != null ? _ref.type : void 0) === \"postroll\") {\n      return;\n    }\n    if (this.isLiveMidroll === true) {\n      this.getMediaElement().volume = this.facade.player.retrieveProxy(ApplicationStateProxy.NAME).getVolume();\n      if (Utils.getDevice() === \"ipad\") {\n        this.getMediaElement().load();\n      } else {\n        return;\n      }\n    }\n    IMAProxy.__super__.contentPlay.call(this);\n    if (((_ref1 = this.adVO) != null ? _ref1.type : void 0) === \"midroll\" && Utils.getDevice() === \"desktop\") {\n      this.facade.player.setCurrentTime(Math.floor(this.facade.player.getCurrentTime()));\n    }\n  };\n\n  /**\n  */\n  IMAProxy.prototype.contentEnded = function() {\n    var _ref;\n    this.contentHasEnded = true;\n    try {\n      if ((_ref = this.adsLoader) != null) {\n        if (typeof _ref.contentComplete === \"function\") {\n          _ref.contentComplete();\n        }\n      }\n    } catch (error) {\n      this.facade.logger.error(\"[AMP IMA ERROR]\", \"contentComplete\", error);\n    }\n  };\n\n  /**\n  */\n  IMAProxy.prototype.terminateAd = function() {\n    var _ref;\n    try {\n      if ((_ref = this.adsManager) != null) {\n        _ref.stop();\n      }\n    } catch (error) {\n      this.facade.logger.error(\"[AMP IMA ERROR]\", \"terminateAd\", error);\n    }\n    this.endBreak();\n    this.contentPlay();\n  };\n\n  /**\n  */\n  IMAProxy.prototype.terminateAllAds = function() {\n    var _ref;\n    try {\n      if ((_ref = this.adsManager) != null) {\n        _ref.destroy();\n      }\n    } catch (error) {\n      this.facade.logger.error(\"[AMP IMA ERROR]\", \"terminateAllAds\", error);\n    }\n    this.endBreak();\n    this.contentPlay();\n  };\n\n  /**\n  */\n  IMAProxy.prototype.destroy = function() {\n    var _ref;\n    if ((_ref = this.adsManager) != null) {\n      if (typeof _ref.destroy === \"function\") {\n        _ref.destroy();\n      }\n    }\n  };\n\n  /**\n   * @constructor\n   * @private\n  */\n  function MediaAnalyticsProxy(config) {\n    MediaAnalyticsProxy.__super__.constructor.call(this, config);\n  }\n\n\n  __extends(MediaAnalyticsProxy, PluginProxy);\n\n\n  /** @static\n  */\n  MediaAnalyticsProxy.NAME = ModuleProxy.NAME;\n\n  MediaAnalyticsProxy.prototype.defaults = {\n    config: null,\n    dimensions: null\n  };\n\n  /**\n  */\n  MediaAnalyticsProxy.prototype.ready = function() {\n    try {\n      if (this.getDebug() === true) {\n        window.AkamaiAnalytics_debug = 1;\n      }\n      window.akamaiSetVideoObject(this.facade.player.getMediaElement());\n    } catch (error) {\n      this.facade.logger.error(\"[AMP MEDIA ANALYTICS ERROR]\", \"Could not set video tag\", error);\n    }\n  };\n\n  /**\n  */\n  MediaAnalyticsProxy.prototype.setDimensions = function(value) {\n    var dimensions, key, val;\n    dimensions = this.configurationData.source.dimensions;\n    for (key in value) {\n      val = value[key];\n      if (val != null) {\n        dimensions[key] = val;\n      }\n    }\n    this.configurationData.parse(this.configurationData.source);\n    this.applyDimensions(dimensions);\n    return value;\n  };\n\n  /**\n  */\n  MediaAnalyticsProxy.prototype.applyDimensions = function(dimensions) {\n    var key, value;\n    if (!(window.setAkamaiMediaAnalyticsData != null)) {\n      return;\n    }\n    try {\n      for (key in dimensions) {\n        value = dimensions[key];\n        setAkamaiMediaAnalyticsData(key, value);\n      }\n    } catch (error) {\n      this.facade.logger.error(\"[AMP MEDIA ANALYTICS ERROR]\", \"Could not set dimensions:\", error);\n    }\n  };\n\n  /**\n  */\n  MediaAnalyticsProxy.prototype.setMedia = function(media) {\n    var dimensions, viewerId, _ref;\n    if (typeof akamaiSetStreamURL === \"function\") {\n      akamaiSetStreamURL(media.src, false);\n    }\n    viewerId = this.value.viewerId || this.value.viewerID || this.value[\"std:viewerId\"];\n    if (viewerId != null) {\n      akamaiSetViewerId(viewerId);\n    }\n    if (((_ref = media.mediaanalytics) != null ? _ref.dimensions : void 0) != null) {\n      dimensions = Utils.override(this.value.dimensions, media.mediaanalytics.dimensions);\n    } else {\n      dimensions = this.value.dimensions;\n    }\n    akamaiHandleStreamSwitch();\n    this.applyDimensions(dimensions);\n    return media;\n  };\n\n  /**\n  */\n  MediaAnalyticsProxy.prototype.udpateMedia = function(media) {\n    if (typeof akamaiHandleTitleSwitch === \"function\") {\n      akamaiHandleTitleSwitch(media);\n    }\n    return media;\n  };\n\n  /**\n  */\n  MediaAnalyticsProxy.prototype.fragmentLoadStart = function(bitrate) {\n    if (typeof fragmentDownloadStarted === \"function\") {\n      fragmentDownloadStarted(bitrate);\n    }\n  };\n\n  /**\n  */\n  MediaAnalyticsProxy.prototype.fragmentLoaded = function(bitrate) {\n    if (typeof fragmentDownloadCompleted === \"function\") {\n      fragmentDownloadCompleted(bitrate);\n    }\n  };\n\n  /**\n  */\n  MediaAnalyticsProxy.prototype.bitrateSwitch = function(data) {\n    if (typeof akamaiHandleBitRateSwitch === \"function\") {\n      akamaiHandleBitRateSwitch(data.bitrate);\n    }\n  };\n\n  /**\n   * The MediaAnalyticsReadyCommand class.\n   *\n   * @constructor\n   * @private\n   * @extends {puremvc.SimpleCommand}\n  */\n  function MediaAnalyticsReadyCommand() {\n    MediaAnalyticsReadyCommand.__super__.constructor.call(this);\n  }\n\n\n  __extends(MediaAnalyticsReadyCommand, puremvc.SimpleCommand);\n\n\n  /**\n   * Executes the command.\n   *\n   * @param {puremvc.Notification} notification\n   *    The notification.\n   *\n   * @override\n  */\n  MediaAnalyticsReadyCommand.prototype.execute = function(notification) {\n    this.facade.retrieveProxy(MediaAnalyticsProxy.NAME).ready();\n  };\n\n  function MediaAnalyticsWrapper(player, config) {\n    MediaAnalyticsWrapper.__super__.constructor.call(this, player, config);\n  }\n\n\n  __extends(MediaAnalyticsWrapper, PluginWrapper);\n\n\n  MediaAnalyticsWrapper.NAME = \"MediaAnalyticsWrapper\";\n\n  MediaAnalyticsWrapper.prototype.flashPlugins = [\n    {\n      id: \"OSMFCSMALoader\",\n      host: \"osmf\",\n      main: \"com.akamai.playeranalytics.osmf.OSMFCSMALoaderInfo\",\n      type: \"application/x-shockwave-flash\"\n    }\n  ];\n\n  /** @override\n  */\n  MediaAnalyticsWrapper.prototype.listNotificationInterests = function() {\n    return MediaAnalyticsWrapper.__super__.listNotificationInterests.call(this).concat([Notifications.MEDIA_CHANGE, MediaAnalyticsNotifications.SET_DIMENSIONS]);\n  };\n\n  MediaAnalyticsWrapper.prototype.createFlashVars = function(flashvars) {\n    var dimensions, key, value, _ref, _ref1;\n    dimensions = (_ref = this.player.config) != null ? (_ref1 = _ref.media) != null ? _ref1.mediaanalytics : void 0 : void 0;\n    if (dimensions != null) {\n      for (key in dimensions) {\n        value = dimensions[key];\n        flashvars[\"report_\" + key] = value;\n      }\n    }\n    return flashvars;\n  };\n\n  MediaAnalyticsWrapper.prototype.createXML = function(xml) {\n    var application, dimensions, element, key, metrics, path, value, vendor, _ref, _ref1;\n    application = xml.firstChild;\n    metrics = xml.getElementsByTagName(\"metrics\")[0];\n    if (!(metrics != null)) {\n      metrics = xml.createElement(\"metrics\");\n      application.appendChild(metrics);\n    }\n    vendor = xml.createElement(\"vendor\");\n    vendor.setAttribute(\"id\", \"akamai\");\n    metrics.appendChild(vendor);\n    if (this.config.config != null) {\n      element = xml.createElement(\"property\");\n      element.setAttribute(\"key\", \"MEDIA_ANALYTICS_BEACON\");\n      element.appendChild(XMLUtils.createTextContent(xml, this.config.config));\n      vendor.appendChild(element);\n      path = ((_ref = this.config.plugin) != null ? _ref.swf : void 0) || \"http://79423.analytics.edgesuite.net/csma/plugin/csma.swf\";\n      element = xml.createElement(\"property\");\n      element.setAttribute(\"key\", \"MEDIA_ANALYTICS_PLUGIN_PATH\");\n      element.appendChild(XMLUtils.createTextContent(xml, path));\n      vendor.appendChild(element);\n    }\n    if (this.config.dimensions != null) {\n      dimensions = xml.createElement(\"property\");\n      dimensions.setAttribute(\"key\", \"dimensions\");\n      vendor.appendChild(dimensions);\n      _ref1 = this.config.dimensions;\n      for (key in _ref1) {\n        value = _ref1[key];\n        element = xml.createElement(\"property\");\n        element.setAttribute(\"key\", key);\n        element.appendChild(XMLUtils.createTextContent(xml, value));\n        dimensions.appendChild(element);\n      }\n    }\n    return xml;\n  };\n\n  MediaAnalyticsWrapper.prototype.handleNotification = function(notification) {\n    var body, key, media, name, value, _ref, _ref1;\n    MediaAnalyticsWrapper.__super__.handleNotification.call(this, notification);\n    name = notification.getName();\n    body = notification.getBody();\n    switch (name) {\n      case Notifications.MEDIA_CHANGE:\n        media = body;\n        if (((_ref = media.mediaanalytics) != null ? _ref.dimensions : void 0) != null) {\n          media.dimensions = [];\n          _ref1 = media.mediaanalytics.dimensions;\n          for (key in _ref1) {\n            value = _ref1[key];\n            media.dimensions.push({\n              key: key,\n              value: value\n            });\n          }\n        }\n        break;\n      case MediaAnalyticsNotifications.SET_DIMENSIONS:\n        this.setDimensions(body);\n    }\n  };\n\n  /**\n  */\n  MediaAnalyticsWrapper.prototype.setDimensions = function(value) {\n    this.player.mediaElement.setPlayerProperty(\"maDimensions\", value);\n    return value;\n  };\n\n  /**\n   * The PlayOverlayPlugin class.\n   *\n   * @param {Module}  app     The parent module of this plugin.\n   * @constructor\n   * @private\n   * @extends {Plugin}\n  */\n  function PlayOverlayPlugin() {\n    PlayOverlayPlugin.__super__.constructor.call(this);\n  }\n\n\n  __extends(PlayOverlayPlugin, Plugin);\n\n\n  PlayOverlayPlugin.prototype.moduleName = \"playoverlay\";\n\n  /** @override\n  */\n  PlayOverlayPlugin.prototype.createModel = function() {};\n\n  /** @override\n  */\n  PlayOverlayPlugin.prototype.createView = function() {\n    this.registerMediator(new PlayOverlayMediator());\n  };\n\n  /** @override\n  */\n  PlayOverlayPlugin.prototype.listNotificationPublications = function() {\n    return PlayOverlayPlugin.__super__.listNotificationPublications.call(this).concat([UserNotifications.TOGGLE_PLAY_PAUSE]);\n  };\n\n\n  AMP.registerPlugin(\"playoverlay\", \"html\", PlayOverlayPlugin);\n  AMP.registerPlugin(\"playoverlay\", \"external\", PlayOverlayPlugin);\n\n  /**\n   * @enum {string}\n   * @const\n   * @private\n  */\n\n  var EventManagementNotifications = {\n    EVENT_STATE_CHANGED: \"eventStateChanged\"\n  };\n\n  /**\n   * Poller class\n   *\n   * @constructor\n   * @private\n   * @extends {EventDispatcher}\n   * @param {string} url\n   * @param {number} interval\n   * @param {string} type\n   * @param {Object} headers\n  */\n  function Poller(url, interval, type, headers) {\n    this.url = url;\n    this.interval = interval != null ? interval : 10000;\n    this.type = type != null ? type : null;\n    this.headers = headers != null ? headers : null;\n    Poller.__super__.constructor.call(this);\n  }\n\n\n  __extends(Poller, EventDispatcher);\n\n\n  Poller.prototype.timeout = null;\n\n  Poller.prototype.interval = null;\n\n  Poller.prototype.url = null;\n\n  Poller.prototype.lastModified = null;\n\n  Poller.prototype.contentLenght = null;\n\n  Poller.prototype.data = null;\n\n  Poller.prototype.text = null;\n\n  Poller.prototype.type = null;\n\n  Poller.prototype.headers = null;\n\n  Poller.prototype.useHeadRequest = true;\n\n  Poller.prototype.xhr = null;\n\n  /**\n  */\n  Poller.prototype.start = function() {\n    if ((this.url != null) && this.url !== \"\") {\n      this.poll();\n    }\n  };\n\n  /**\n  */\n  Poller.prototype.poll = function() {\n    var xhr,\n      _this = this;\n    xhr = Utils.getXHR();\n    if (!this.useHeadRequest) {\n      this.updateData();\n    } else {\n      xhr.onload = function(event) {\n        var contentLength, lastModified;\n        if (xhr.status === 304) {\n          _this.invoke();\n          return;\n        }\n        lastModified = xhr.getResponseHeader(\"Last-Modified\");\n        contentLength = xhr.getResponseHeader(\"Content-Length\");\n        if ((!(lastModified != null) && !(contentLength != null)) || ((lastModified != null) && lastModified !== _this.lastModified) || ((contentLength != null) && contentLength !== _this.contentLength)) {\n          _this.lastModified = lastModified;\n          _this.contentLength = contentLength;\n          _this.updateData();\n        } else {\n          _this.invoke();\n        }\n      };\n      xhr.onerror = function(event) {\n        _this.error(event);\n      };\n      xhr.open(\"HEAD\", Utils.cacheBust(this.url), false);\n      this.applyHeaders();\n      if (this.lastModified != null) {\n        xhr.setRequestHeader(\"If-Modified-Since\", this.lastModified);\n      }\n      xhr.send();\n    }\n  };\n\n  /**\n  */\n  Poller.prototype.applyHeaders = function() {\n    if (!(this.headers != null)) {\n      return;\n    }\n    this.xhr.setRequestHeaders(this.headers);\n  };\n\n  /**\n  */\n  Poller.prototype.updateData = function() {\n    var xhr,\n      _this = this;\n    xhr = Utils.getXHR();\n    xhr.open(\"GET\", Utils.cacheBust(this.url), true);\n    xhr.onload = function(event) {\n      var text;\n      text = xhr.responseText;\n      _this.setText(text);\n      _this.invoke();\n    };\n    xhr.onerror = function(event) {\n      _this.error(event);\n    };\n    this.applyHeaders();\n    return xhr.send();\n  };\n\n  /**\n  */\n  Poller.prototype.setText = function(value) {\n    var data;\n    if (value !== this.text) {\n      this.text = value;\n      data = this.text;\n      if (this.type === Utils.mimeTypes.json) {\n        try {\n          data = this.xhr.response;\n        } catch (error) {\n          data = this.text;\n        }\n      }\n      this.setData(data);\n    }\n    return value;\n  };\n\n  /**\n  */\n  Poller.prototype.setData = function(value) {\n    if (value !== this.data) {\n      this.data = value;\n      this.dispatchEvent(new Event(\"datachanged\", this.data));\n    }\n    return value;\n  };\n\n  /**\n  */\n  Poller.prototype.error = function(error) {\n    Logger.error(event);\n    this.stop();\n  };\n\n  /**\n  */\n  Poller.prototype.invoke = function() {\n    var _this = this;\n    this.stop();\n    this.timeout = setTimeout(function() {\n      _this.poll();\n    }, this.interval);\n  };\n\n  /**\n  */\n  Poller.prototype.stop = function() {\n    clearTimeout(this.timeout);\n  };\n\n  function EventManagementWrapper() {\n    return EventManagementWrapper.__super__.constructor.apply(this, arguments);\n  }\n\n\n  __extends(EventManagementWrapper, PluginWrapper);\n\n\n  EventManagementWrapper.NAME = \"EventManagementWrapper\";\n\n  /** @override\n  */\n  EventManagementWrapper.prototype.createFlashVars = function(flashvars) {\n    if (this.config.enabled != null) {\n      flashvars.eventmanagementstates_enabled = this.config.enabled;\n    }\n    if (this.config.url != null) {\n      flashvars.eventmanagementstates_status_url = this.config.url;\n    }\n    if (this.config.interval != null) {\n      flashvars.eventmanagementstates_status_interval = this.config.interval;\n    }\n    return flashvars;\n  };\n\n  /** @override\n  */\n  EventManagementWrapper.prototype.createXML = function(xml) {\n    var application, eventmanagementstates, node, property, state, states, _i, _len, _ref;\n    application = xml.firstChild;\n    eventmanagementstates = xml.getElementsByTagName(\"eventmanagementstates\");\n    if (!(eventmanagementstates != null) || eventmanagementstates.length === 0) {\n      eventmanagementstates = xml.createElement(\"eventmanagementstates\");\n      application.appendChild(eventmanagementstates);\n    } else {\n      eventmanagementstates = eventmanagementstates[0];\n    }\n    states = xml.createElement(\"states\");\n    eventmanagementstates.appendChild(states);\n    _ref = this.config.states;\n    for (_i = 0, _len = _ref.length; _i < _len; _i++) {\n      state = _ref[_i];\n      node = xml.createElement(\"state\");\n      states.appendChild(node);\n      property = xml.createElement(\"property\");\n      property.setAttribute(\"key\", \"ID\");\n      property.appendChild(XMLUtils.createTextContent(xml, state.id));\n      node.appendChild(property);\n      property = xml.createElement(\"property\");\n      property.setAttribute(\"key\", \"POSTER_SRC\");\n      property.appendChild(XMLUtils.createTextContent(xml, state.poster));\n      node.appendChild(property);\n      if (state.url != null) {\n        property = xml.createElement(\"property\");\n        property.setAttribute(\"key\", \"URL\");\n        property.appendChild(XMLUtils.createTextContent(xml, state.url));\n        node.appendChild(property);\n      }\n    }\n    return xml;\n  };\n\n  /**\n   * The EventManagementMediator class.\n   *\n   * @constructor\n   * @private\n   * @extends {OverlayMediator}\n   * @param {Object} viewComponent\n  */\n  function EventManagementMediator() {\n    EventManagementMediator.__super__.constructor.call(this);\n  }\n\n\n  __extends(EventManagementMediator, OverlayMediator);\n\n\n  EventManagementMediator.prototype.componentName = \"event-management\";\n\n  EventManagementMediator.prototype.poster = null;\n\n  /**\n   * @override\n  */\n  EventManagementMediator.prototype.onRegister = function() {\n    EventManagementMediator.__super__.onRegister.call(this);\n    this.classList.add(\"hidden\");\n    this.poster = this.create(\"event-poster\", false, \"img\");\n  };\n\n  /**\n   * @override\n  */\n  EventManagementMediator.prototype.listNotificationInterests = function() {\n    return [EventManagementNotifications.EVENT_STATE_CHANGED];\n  };\n\n  /**\n   * @override\n  */\n  EventManagementMediator.prototype.handleNotification = function(notification) {\n    var state;\n    switch (notification.getName()) {\n      case EventManagementNotifications.EVENT_STATE_CHANGED:\n        state = notification.getBody();\n        if (state.id !== \"on\") {\n          if (state.poster != null) {\n            this.poster.src = state.poster;\n            this.viewComponent.appendChild(this.poster);\n          }\n          this.classList.remove(\"hidden\");\n          this.sendNotification(Notifications.PAUSE);\n          this.sendNotification(Notifications.CHANGE_DISPLAY_STATE, DisplayState.NORMAL);\n        } else {\n          if (this.viewComponent.contains(this.poster)) {\n            this.viewComponent.removeChild(this.poster);\n          }\n          this.classList.add(\"hidden\");\n        }\n    }\n  };\n\n  /**\n   * The EventManagementStateChangeCommand class.\n   *\n   * @constructor\n   * @private\n   * @extends {amp.plugins.PluginCommand}\n  */\n  function EventManagementStateChangeCommand() {\n    EventManagementStateChangeCommand.__super__.constructor.call(this);\n  }\n\n\n  __extends(EventManagementStateChangeCommand, PluginEventCommand);\n\n\n  /**\n   * Executes the command.\n   *\n   * @param {puremvc.Notification} notification\n   *    The notification.\n   *\n   * @override\n  */\n  EventManagementStateChangeCommand.prototype.execute = function(notification) {\n    var locked;\n    locked = notification.getBody().id !== EventManagementProxy.ON.id;\n    this.sendNotification(Notifications.LOCK, locked);\n    EventManagementStateChangeCommand.__super__.execute.call(this, notification);\n    if (locked === false && this.facade.player.getAutoplay() === true) {\n      this.sendNotification(Notifications.PLAY);\n    }\n  };\n\n  /**\n   * @constructor\n   * @private\n  */\n  function EventManagementProxy(config) {\n    var _this = this;\n    EventManagementProxy.__super__.constructor.call(this, config);\n    this.poller = new Poller();\n    this.poller.ondatachanged = function(event) {\n      var id, state, _i, _len, _ref;\n      id = event.detail;\n      if (id === \"on\") {\n        state = EventManagementProxy.ON;\n      } else {\n        _ref = _this.data.states;\n        for (_i = 0, _len = _ref.length; _i < _len; _i++) {\n          state = _ref[_i];\n          if (state.id === id) {\n            break;\n          }\n        }\n      }\n      if (state != null) {\n        return _this.setState(state);\n      }\n    };\n  }\n\n\n  __extends(EventManagementProxy, ModuleProxy);\n\n\n  EventManagementProxy.NAME = ModuleProxy.NAME;\n\n  EventManagementProxy.ON = {\n    id: \"on\"\n  };\n\n  EventManagementProxy.prototype.defaults = {\n    url: null,\n    interval: null,\n    states: null,\n    enabled: false\n  };\n\n  EventManagementProxy.prototype.poller = null;\n\n  EventManagementProxy.prototype.state = null;\n\n  EventManagementProxy.prototype.initialize = function() {\n    if (this.data.enabled === true) {\n      this.setURL(this.data.url);\n      this.setInterval(this.data.interval);\n      this.poller.start();\n    }\n  };\n\n  EventManagementProxy.prototype.setURL = function(value) {\n    this.data.url = this.poller.url = value;\n    return value;\n  };\n\n  EventManagementProxy.prototype.getURL = function() {\n    return this.data.url;\n  };\n\n  /**\n   *\n  */\n  EventManagementProxy.prototype.getInterval = function() {\n    return this.data.interval;\n  };\n\n  EventManagementProxy.prototype.setInterval = function(value) {\n    this.data.interval = this.poller.interval = value * 1000;\n    return value;\n  };\n\n  EventManagementProxy.prototype.setState = function(value) {\n    this.state = value;\n    this.sendNotification(EventManagementNotifications.EVENT_STATE_CHANGED, value);\n    return value;\n  };\n\n  EventManagementProxy.prototype.getState = function() {\n    return this.state;\n  };\n\n  /**\n   * The MediaAnalyticsPlugin class.\n   *\n   * @param {Module}  app     The parent module of this plugin.\n   * @constructor\n   * @private\n   * @extends {Plugin}\n  */\n  function MediaAnalyticsPlugin() {\n    MediaAnalyticsPlugin.__super__.constructor.call(this);\n  }\n\n\n  __extends(MediaAnalyticsPlugin, Plugin);\n\n\n  MediaAnalyticsPlugin.prototype.moduleName = \"mediaanalytics\";\n\n  /** @override\n  */\n  MediaAnalyticsPlugin.prototype.initialize = function(config, player) {\n    window.AKAMAI_MEDIA_ANALYTICS_CONFIG_FILE_PATH = config.config;\n    MediaAnalyticsPlugin.__super__.initialize.call(this, config, player);\n  };\n\n  /** @override\n  */\n  MediaAnalyticsPlugin.prototype.createModel = function() {\n    this.proxy = new MediaAnalyticsProxy(this.config);\n    this.registerProxy(this.proxy);\n  };\n\n  /** @override\n  */\n  MediaAnalyticsPlugin.prototype.createController = function() {\n    MediaAnalyticsPlugin.__super__.createController.call(this);\n    this.registerCommand(Notifications.READY, MediaAnalyticsReadyCommand);\n    this.registerCommand(Notifications.MEDIA_CHANGE, MediaAnalyticsChangeMediaCommand);\n    this.registerCommand(AdNotifications.BREAK_START, MediaAnalyticsAdBreakStartCommand);\n    this.registerCommand(AdNotifications.BREAK_END, MediaAnalyticsAdBreakEndCommand);\n    this.registerCommand(AdNotifications.AD_LOADED, MediaAnalyticsAdLoadedCommand);\n    this.registerCommand(AdNotifications.AD_STARTED, MediaAnalyticsAdStartCommand);\n    this.registerCommand(AdNotifications.AD_TIME_UPDATE, MediaAnalyticsAdTimeUpdateCommand);\n    this.registerCommand(AdNotifications.AD_ENDED, MediaAnalyticsAdEndCommand);\n    this.registerCommand(MediaAnalyticsNotifications.SET_DIMENSIONS, MediaAnalyticsSetDimensionsCommand);\n    this.registerCommand(Notifications.CONTENT_CHANGED, MediaAnalyticsContentChangedCommand);\n    this.registerCommand(Notifications.FRAGMENT_LOAD_START, MediaAnalyticsFragmentLoadStartCommand);\n    this.registerCommand(Notifications.FRAGMENT_LOADED, MediaAnalyticsFragmentLoadedCommand);\n    this.registerCommand(Notifications.BITRATE_SWITCH, MediaAnalyticsBitrateSwitchCommand);\n  };\n\n  /**\n  */\n  MediaAnalyticsPlugin.prototype.listNotificationInterests = function() {\n    return [Notifications.READY, Notifications.MEDIA_CHANGE, AdNotifications.BREAK_START, AdNotifications.BREAK_END, AdNotifications.AD_LOADED, AdNotifications.AD_STARTED, AdNotifications.AD_TIME_UPDATE, AdNotifications.AD_ENDED, MediaAnalyticsNotifications.SET_DIMENSIONS, Notifications.CONTENT_CHANGED, Notifications.FRAGMENT_LOAD_START, Notifications.FRAGMENT_LOADED, Notifications.BITRATE_SWITCH];\n  };\n\n  /**\n   * Sets the media analytics dimensions.\n   *\n   * @param {Object} value The hash representing dimensions.\n   * @expose\n  */\n  MediaAnalyticsPlugin.prototype.setDimensions = function(value) {\n    this.retrieveProxy(MediaAnalyticsProxy.NAME).setDimensions(value);\n    return value;\n  };\n\n\n  AMP.registerPlugin(\"mediaanalytics\", \"html\", MediaAnalyticsPlugin);\n  AMP.registerPlugin(\"mediaanalytics\", \"flash\", MediaAnalyticsWrapper);\n\n  function BrandingWrapper() {\n    return BrandingWrapper.__super__.constructor.apply(this, arguments);\n  }\n\n\n  __extends(BrandingWrapper, PluginWrapper);\n\n\n  BrandingWrapper.NAME = \"BrandingWrapper\";\n\n  BrandingWrapper.prototype.flashView = {\n    elements: {\n      logoOverlay: {\n        attributes: {\n          style: \"width: 150px; height: 53px; right: 15px; top: 15px; opacity: 0.5;\"\n        }\n      }\n    }\n  };\n\n  BrandingWrapper.prototype.createFlashVars = function(flashvars) {\n    if (this.config.id != null) {\n      flashvars.branding = this.config.id;\n    }\n    return flashvars;\n  };\n\n  BrandingWrapper.prototype.createXML = function(xml) {\n    var backgroundImage, style, view, _ref, _ref1, _ref2;\n    view = this.player.flashView;\n    if ((((_ref = this.config) != null ? _ref.logo : void 0) != null) && (view != null)) {\n      backgroundImage = \"background-image: url('\" + this.config.logo + \"');\";\n      style = ((_ref1 = view.elements.logoOverlay) != null ? (_ref2 = _ref1.attributes) != null ? _ref2.style : void 0 : void 0) || \"\";\n      if (style.indexOf(\"background-image:\") !== -1) {\n        style = style.replace(/background-image: [A-Za-z0-9_\\-\\.\\/\\\\;\\(\\)\"'#{}]+/, backgroundImage);\n      } else {\n        style = backgroundImage + style;\n      }\n      view.elements.logoOverlay.attributes.style = style;\n    }\n    return xml;\n  };\n\n  /**\n   * The AdChoicesMediator class.\n   *\n   * @constructor\n   * @private\n   * @extends {OverlayMediator}\n   * @param {Object} viewComponent\n  */\n  function BrandingMediator() {\n    BrandingMediator.__super__.constructor.call(this);\n  }\n\n\n  __extends(BrandingMediator, OverlayMediator);\n\n\n  BrandingMediator.prototype.componentName = \"branding\";\n\n  BrandingMediator.prototype.logo = null;\n\n  BrandingMediator.prototype.text = null;\n\n  BrandingMediator.prototype.container = null;\n\n  BrandingMediator.prototype.onRegister = function() {\n    BrandingMediator.__super__.onRegister.call(this);\n    this.container = this.create(\"branding-container\");\n    this.logo = this.create([\"branding-image\", \"hidden\"], this.container, \"img\");\n    this.text = this.create(\"branding-text\", this.container);\n  };\n\n  /**\n   * @override\n  */\n  BrandingMediator.prototype.listNotificationInterests = function() {\n    return [Notifications.READY];\n  };\n\n  /**\n   * @override\n  */\n  BrandingMediator.prototype.handleNotification = function(notification) {\n    var branding, href;\n    switch (notification.getName()) {\n      case Notifications.READY:\n        branding = notification.getBody().branding;\n        if (!(branding != null)) {\n          return;\n        }\n        if (branding.logo != null) {\n          this.logo.src = this.facade.evaluatePaths(branding.logo);\n          ClassList.remove(\"hidden\", this.logo, Namespace.PREFIX);\n        } else {\n          ClassList.add(\"hidden\", this.logo, Namespace.PREFIX);\n        }\n        href = this.config.getDomain();\n        if ((href != null) && href.indexOf(\"http\") !== 0) {\n          href = location.protocol + \"//\" + href;\n          this.text.innerHTML = \"<span>\" + (this.localizationManager.getString(LocalizationConstants.MSG_VIEW_ALL)) + \"<a href=\\\"\" + href + \"\\\" target=\\\"\" + (this.config.getTarget()) + \"\\\">\" + (this.config.getDomain()) + \"</a> \" + (this.localizationManager.getString(LocalizationConstants.MSG_VIDEO)) + \".\";\n        }\n    }\n  };\n\n  /**\n   * @constructor\n   * @private\n  */\n  function BrandingProxy(config) {\n    BrandingProxy.__super__.constructor.call(this, config);\n  }\n\n\n  __extends(BrandingProxy, ModuleProxy);\n\n\n  /** @static\n  */\n  BrandingProxy.NAME = ModuleProxy.NAME;\n\n  BrandingProxy.prototype.defaults = {\n    id: null,\n    title: null,\n    link: null,\n    logo: null,\n    target: null\n  };\n\n  /**\n   *\n  */\n  BrandingProxy.prototype.getID = function() {\n    return this.data.id;\n  };\n\n  BrandingProxy.prototype.setID = function(value) {\n    return this.data.id = value;\n  };\n\n  /**\n   *\n  */\n  BrandingProxy.prototype.getTarget = function() {\n    return this.data.target;\n  };\n\n  BrandingProxy.prototype.setTarget = function(value) {\n    return this.data.target = value;\n  };\n\n  /**\n   *\n  */\n  BrandingProxy.prototype.getTitle = function() {\n    return this.data.title;\n  };\n\n  BrandingProxy.prototype.setTitle = function(value) {\n    return this.data.title = value;\n  };\n\n  /**\n   *\n  */\n  BrandingProxy.prototype.getLink = function() {\n    return this.data.link;\n  };\n\n  BrandingProxy.prototype.setLink = function(value) {\n    return this.data.link = value;\n  };\n\n  /**\n   *\n  */\n  BrandingProxy.prototype.getLogo = function() {\n    return this.data.logo;\n  };\n\n  BrandingProxy.prototype.setLogo = function(value) {\n    return this.data.logo = value;\n  };\n\n  /**\n   * @enum {string}\n   * @const\n   * @private\n  */\n\n  var FeedNotifications = {\n    LOAD_FEED: \"loadfeed\",\n    FEED_CHANGED: \"feedchanged\",\n    FEED_LOADED: \"feedloaded\",\n    FEED_ERROR: \"feederror\"\n  };\n\n  /**\n   * The EventManagementPlugin class.\n   *\n   * @param {Module}  app     The parent module of this plugin.\n   * @constructor\n   * @extends {Plugin}\n   * @private\n  */\n  function EventManagementPlugin() {\n    EventManagementPlugin.__super__.constructor.call(this);\n  }\n\n\n  __extends(EventManagementPlugin, Plugin);\n\n\n  EventManagementPlugin.prototype.moduleName = \"eventmanagement\";\n\n  /** @override\n  */\n  EventManagementPlugin.prototype.createModel = function() {\n    this.registerProxy(new EventManagementProxy(this.config));\n  };\n\n  /** @override\n  */\n  EventManagementPlugin.prototype.createController = function() {\n    EventManagementPlugin.__super__.createController.call(this);\n    this.registerCommand(EventManagementNotifications.EVENT_STATE_CHANGED, EventManagementStateChangeCommand);\n  };\n\n  EventManagementPlugin.prototype.createView = function() {\n    this.registerMediator(new EventManagementMediator());\n  };\n\n  /** @override\n  */\n  EventManagementPlugin.prototype.listNotificationPublications = function() {\n    return EventManagementPlugin.__super__.listNotificationPublications.call(this).concat([Notifications.CHANGE_DISPLAY_STATE, Notifications.PLAY, Notifications.PAUSE, Notifications.LOCK, EventManagementNotifications.EVENT_STATE_CHANGED]);\n  };\n\n\n  AMP.registerPlugin(\"eventmanagement\", \"html\", EventManagementPlugin);\n  AMP.registerPlugin(\"eventmanagement\", \"flash\", EventManagementWrapper);\n\n  /**\n   * The FeedProxy class.\n   *\n   * @constructor\n   * @private\n   * @extends {ModuleProxy}\n   * @param {Object} config The configuration object.\n  */\n  function FeedProxy(config) {\n    FeedProxy.__super__.constructor.call(this, config);\n    this.helper = new MRSSHelper();\n  }\n\n\n  __extends(FeedProxy, ModuleProxy);\n\n\n  FeedProxy.NAME = ModuleProxy.NAME;\n\n  FeedProxy.prototype.defaults = {\n    url: null,\n    data: null\n  };\n\n  FeedProxy.prototype.feed = null;\n\n  FeedProxy.prototype.helper = null;\n\n  FeedProxy.prototype.setURL = function(value) {\n    var _this = this;\n    this.data.url = this.facade.evaluatePaths(value);\n    this.sendNotification(Notifications.DISPATCH_EVENT, new Event(\"request\", this.data.url));\n    this.helper.getFeed(this.data.url, function(feed) {\n      _this.sendNotification(FeedNotifications.FEED_LOADED, feed);\n      _this.sendNotification(FeedNotifications.CHANGE_FEED, feed);\n    }, function(error) {\n      _this.sendNotification(FeedNotifications.FEED_ERROR, {\n        error: error,\n        url: value\n      });\n      Logger.error(\"[AMP Feed Load Error]\", _this.data.url, error);\n    });\n    return value;\n  };\n\n  FeedProxy.prototype.getURL = function() {\n    return this.data.url;\n  };\n\n  FeedProxy.prototype.setFeedData = function(value) {\n    this.data.data = value;\n    this.feed = this.helper.createFeed(value);\n    this.sendNotification(FeedNotifications.FEED_CHANGED, this.feed);\n    return value;\n  };\n\n  FeedProxy.prototype.getFeedData = function() {\n    return this.data.data;\n  };\n\n  FeedProxy.prototype.invoke = function() {\n    if ((this.data.url != null) && this.data.url !== \"\") {\n      this.sendNotification(FeedNotifications.LOAD_FEED, this.data.url);\n    } else if (this.data.data != null) {\n      setTimeout(this.sendNotification.bind(this, FeedNotifications.CHANGE_FEED, this.data.data), 1);\n    }\n  };\n\n  /**\n   * The LoadFeedCommand class.\n   *\n   * @constructor\n   * @private\n   * @extends {puremvc.SimpleCommand}\n  */\n  function LoadFeedCommand() {\n    LoadFeedCommand.__super__.constructor.call(this);\n  }\n\n\n  __extends(LoadFeedCommand, puremvc.SimpleCommand);\n\n\n  /**\n   * Executes the command.\n   *\n   * @param {puremvc.Notification} notification\n   *    The notification.\n   *\n   * @override\n  */\n  LoadFeedCommand.prototype.execute = function(notification) {\n    var feedProxy;\n    feedProxy = this.facade.retrieveProxy(FeedProxy.NAME);\n    feedProxy.setURL(notification.getBody());\n  };\n\n  /**\n   * The ChangeFeedCommand class.\n   *\n   * @constructor\n   * @private\n   * @extends {puremvc.SimpleCommand}\n  */\n  function ChangeFeedCommand() {\n    ChangeFeedCommand.__super__.constructor.call(this);\n  }\n\n\n  __extends(ChangeFeedCommand, puremvc.SimpleCommand);\n\n\n  /**\n   * Executes the command.\n   *\n   * @param {puremvc.Notification} notification\n   *    The notification.\n   *\n   * @override\n  */\n  ChangeFeedCommand.prototype.execute = function(notification) {\n    var feedProxy;\n    feedProxy = this.facade.retrieveProxy(FeedProxy.NAME);\n    feedProxy.setFeedData(notification.getBody());\n  };\n\n  /**\n   * The FeedChangedCommand class.\n   *\n   * @constructor\n   * @private\n   * @extends {amp.plugins.PluginEventCommand}\n  */\n  function FeedChangedCommand() {\n    FeedChangedCommand.__super__.constructor.call(this);\n  }\n\n\n  __extends(FeedChangedCommand, PluginEventCommand);\n\n\n  /**\n   * Executes the command.\n   *\n   * @param {puremvc.Notification} notification\n   *    The notification.\n   *\n   * @override\n  */\n  FeedChangedCommand.prototype.execute = function(notification) {\n    var feed, mediaVO;\n    FeedChangedCommand.__super__.execute.call(this, notification);\n    this.player.sendNotification(Notifications.CHANGE_PLAY_STATE, PlayState.READY);\n    feed = notification.getBody();\n    mediaVO = feed.item[0];\n    this.player.sendNotification(Notifications.SET_MEDIA, mediaVO);\n  };\n\n  /**\n   * The FeedInitializedCommand class.\n   *\n   * @constructor\n   * @private\n   * @extends {puremvc.SimpleCommand}\n  */\n  function FeedInitializedCommand() {\n    FeedInitializedCommand.__super__.constructor.call(this);\n  }\n\n\n  __extends(FeedInitializedCommand, puremvc.SimpleCommand);\n\n\n  /**\n   * Executes the command.\n   *\n   * @param {puremvc.Notification} notification\n   *    The notification.\n   *\n   * @override\n  */\n  FeedInitializedCommand.prototype.execute = function(notification) {\n    var feedProxy;\n    feedProxy = this.facade.retrieveProxy(FeedProxy.NAME);\n    feedProxy.invoke();\n  };\n\n  function FeedWrapper(player, config) {\n    if (config == null) {\n      config = {};\n    }\n    FeedWrapper.__super__.constructor.call(this, player, config);\n    if (config.url != null) {\n      this.url = config.url;\n    }\n    if (config.data != null) {\n      this.data = config.data;\n    }\n    this.player.load = function() {};\n  }\n\n\n  __extends(FeedWrapper, PluginWrapper);\n\n\n  FeedWrapper.NAME = \"FeedWrapper\";\n\n  FeedWrapper.prototype.url = null;\n\n  FeedWrapper.prototype.data = null;\n\n  FeedWrapper.prototype.updateData = true;\n\n  /** @override\n  */\n  FeedWrapper.prototype.createFlashVars = function(flashvars) {\n    if ((this.url != null) && this.url !== \"\") {\n      flashvars.data_feed_url = escape(this.facade.evaluatePaths(this.url));\n    }\n  };\n\n  /** @override\n  */\n  FeedWrapper.prototype.listNotificationInterests = function() {\n    return FeedWrapper.__super__.listNotificationInterests.apply(this, arguments).concat([FlashNotifications.READY, FlashNotifications.FEED_LOADED, FlashNotifications.LOAD_FEED]);\n  };\n\n  /**\n  */\n  FeedWrapper.prototype.handleNotification = function(notification) {\n    var body, name, type,\n      _this = this;\n    FeedWrapper.__super__.handleNotification.call(this, notification);\n    name = notification.getName();\n    body = notification.getBody();\n    switch (name) {\n      case FlashNotifications.FEED_LOADED:\n        this.sendNotification(FeedNotifications.FEED_CHANGED, this.data);\n        break;\n      case FlashNotifications.LOAD_FEED:\n        type = \"request\";\n        break;\n      case FlashNotifications.READY:\n        if (this.data != null) {\n          setTimeout(function() {\n            _this.setData(_this.data);\n          }, 25);\n        } else if ((this.url != null) && this.url !== \"\") {\n          this.sendNotification(FeedNotifications.LOAD_FEED, this.url);\n        }\n    }\n    if (type != null) {\n      this.dispatchEvent(new Event(type, body));\n    }\n  };\n\n  /**\n  */\n  FeedWrapper.prototype.setURL = function(value) {\n    if ((value != null) && value !== \"\") {\n      this.url = value;\n      this.player.mediaElement.playFile(this.url, this.player.getAutoplay());\n      this.sendNotification(FeedNotifications.LOAD_FEED, this.url);\n    }\n    return value;\n  };\n\n  FeedWrapper.prototype.getURL = function() {\n    return this.url;\n  };\n\n  /**\n  */\n  FeedWrapper.prototype.setData = function(value) {\n    this.data = value;\n    this.updateData = false;\n    this.player.mediaElement.playFile(this.data, this.player.getAutoplay());\n    return value;\n  };\n\n  FeedWrapper.prototype.getData = function() {\n    return this.data;\n  };\n\n  /**\n   * The BrandingPlugin class.\n   *\n   * @param {Module}  app     The parent module of this plugin.\n   * @constructor\n   * @private\n   * @extends {Plugin}\n  */\n  function BrandingPlugin() {\n    BrandingPlugin.__super__.constructor.call(this);\n  }\n\n\n  __extends(BrandingPlugin, Plugin);\n\n\n  BrandingPlugin.NAME = \"BrandingPlugin\";\n\n  BrandingPlugin.prototype.moduleName = \"branding\";\n\n  /** @override\n  */\n  BrandingPlugin.prototype.createModel = function() {\n    this.registerProxy(new BrandingProxy(this.config));\n  };\n\n  BrandingPlugin.prototype.createView = function() {\n    this.registerMediator(new BrandingMediator());\n  };\n\n  /** @override\n  */\n  BrandingPlugin.prototype.onRegister = function() {\n    if (this.config.id != null) {\n      this.sendNotification(Notifications.ADD_APPLICATION_STATE, \"branding-\" + this.config.id);\n    }\n    BrandingPlugin.__super__.onRegister.call(this);\n  };\n\n  /**\n  */\n  BrandingPlugin.prototype.listNotificationInterests = function() {\n    return [Notifications.READY];\n  };\n\n\n  AMP.registerPlugin(\"branding\", \"html\", BrandingPlugin);\n  AMP.registerPlugin(\"branding\", \"flash\", BrandingWrapper);\n  AMP.registerPlugin(\"branding\", \"external\", BrandingPlugin);\n\n  /**\n   * @enum {string}\n   * @const\n   * @private\n  */\n\n  var FeatureNotifications = {\n    REGISTER_FEATURE: \"registerfeature\"\n  };\n\n  /**\n   * The Feature class. Acts as a base for features.\n   *\n   * @param {Module}  app     The parent module of this plugin.\n   * @param {Object}  config  The plugin's configuration object.\n   * @constructor\n   * @private\n   * @extends {Plugin}\n  */\n  function Feature() {\n    Feature.__super__.constructor.call(this);\n  }\n\n\n  __extends(Feature, Plugin);\n\n\n  Feature.NAME = \"Feature\";\n\n  Feature.prototype.featureName = null;\n\n  /**\n  */\n  Feature.prototype.getFeatureName = function() {\n    return this.featureName;\n  };\n\n  /**\n  */\n  Feature.prototype.registerFeature = function() {\n    if (this.getFeatureName() != null) {\n      this.player.sendNotification(FeatureNotifications.REGISTER_FEATURE, this);\n    }\n  };\n\n  /** @override\n  */\n  Feature.prototype.onRegister = function() {\n    this.registerFeature();\n    Feature.__super__.onRegister.call(this);\n  };\n\n  /** @override\n  */\n  Feature.prototype.listNotificationPublications = function() {\n    return Feature.__super__.listNotificationPublications.call(this).concat([FeatureNotifications.REGISTER_FEATURE]);\n  };\n\n  /**\n   * The FeedPlugin class.\n   *\n   * @param {Module}  app     The parent module of this plugin.\n   * @constructor\n   * @private\n   * @extends {Plugin}\n  */\n  function FeedPlugin() {\n    FeedPlugin.__super__.constructor.call(this);\n  }\n\n\n  __extends(FeedPlugin, Plugin);\n\n\n  FeedPlugin.prototype.moduleName = \"feed\";\n\n  /** @override\n  */\n  FeedPlugin.prototype.createModel = function() {\n    this.proxy = new FeedProxy(this.config);\n    this.registerProxy(this.proxy);\n  };\n\n  /** @override\n  */\n  FeedPlugin.prototype.createController = function() {\n    FeedPlugin.__super__.createController.call(this);\n    this.registerCommand(Notifications.READY, FeedInitializedCommand);\n    this.registerCommand(FeedNotifications.LOAD_FEED, LoadFeedCommand);\n    this.registerCommand(FeedNotifications.CHANGE_FEED, ChangeFeedCommand);\n    this.registerCommand(FeedNotifications.FEED_CHANGED, FeedChangedCommand);\n    this.registerCommand(FeedNotifications.FEED_LOADED, PluginEventCommand);\n    this.registerCommand(FeedNotifications.FEED_ERROR, PluginEventCommand);\n  };\n\n  /** @override\n  */\n  FeedPlugin.prototype.listNotificationInterests = function() {\n    return FeedPlugin.__super__.listNotificationInterests.call(this).concat([Notifications.READY]);\n  };\n\n  /** @override\n  */\n  FeedPlugin.prototype.listNotificationPublications = function() {\n    var key, value;\n    return FeedPlugin.__super__.listNotificationPublications.call(this).concat((function() {\n      var _results;\n      _results = [];\n      for (key in FeedNotifications) {\n        value = FeedNotifications[key];\n        _results.push(value);\n      }\n      return _results;\n    })());\n  };\n\n  /**\n   * @param {string} value The url of the feed.\n   * @expose\n  */\n  FeedPlugin.prototype.setURL = function(value) {\n    this.sendNotification(FeedNotifications.LOAD_FEED, value);\n    return value;\n  };\n\n  /**\n   * @return {string} The url of the feed.\n   * @expose\n  */\n  FeedPlugin.prototype.getURL = function() {\n    return this.proxy.getURL();\n  };\n\n  /**\n   * @param {Object} value The MRSS feed object\n   * @expose\n  */\n  FeedPlugin.prototype.setData = function(value) {\n    this.sendNotification(FeedNotifications.CHANGE_FEED, value);\n    return value;\n  };\n\n  /**\n   * @return {Object} The MRSS feed object.\n   * @expose\n  */\n  FeedPlugin.prototype.getData = function() {\n    return this.proxy.getFeedData();\n  };\n\n\n  AMP.registerPlugin(\"feed\", \"html\", FeedPlugin);\n  AMP.registerPlugin(\"feed\", \"flash\", FeedWrapper);\n\n  /**\n   * @constructor\n   * @private\n   * @extends {OverlayMediator}\n  */\n  function AdMediator() {\n    AdMediator.__super__.constructor.call(this);\n  }\n\n\n  __extends(AdMediator, OverlayMediator);\n\n\n  AdMediator.prototype.duration = null;\n\n  AdMediator.prototype.currentTime = null;\n\n  AdMediator.prototype.container = null;\n\n  AdMediator.prototype.banner = null;\n\n  AdMediator.prototype.text = null;\n\n  AdMediator.prototype.adText = null;\n\n  AdMediator.prototype.bg = null;\n\n  AdMediator.prototype.totalAds = null;\n\n  AdMediator.prototype.adPosition = null;\n\n  AdMediator.prototype.adContainerRequired = true;\n\n  AdMediator.prototype.componentName = \"ads\";\n\n  /**\n   * @override\n  */\n  AdMediator.prototype.onRegister = function() {\n    AdMediator.__super__.onRegister.call(this);\n    if (this.adContainerRequired) {\n      this.container = this.create(\"ad-container\");\n    }\n    this.banner = this.create(\"ad-banner\");\n    this.bg = this.create(\"ad-text-bg\", this.banner);\n    this.adText = this.create(\"ad-text-title\", this.banner);\n    this.text = this.create(\"ad-text\", this.banner);\n    if (this.adContainerRequired) {\n      this.viewComponent.container = this.container;\n    }\n    this.sendNotification(AdNotifications.AD_CONTAINER_CREATED, this.viewComponent);\n    this.facade.setViewComponent(this.viewComponent);\n  };\n\n  /**\n   * @override\n  */\n  AdMediator.prototype.listNotificationInterests = function() {\n    return [AdNotifications.BREAK_START, AdNotifications.BREAK_END, AdNotifications.AD_TIME_REMAINING, AdNotifications.AD_STARTED];\n  };\n\n  /**\n   * @override\n  */\n  AdMediator.prototype.handleNotification = function(notification) {\n    var adVO, msg, time;\n    switch (notification.getName()) {\n      case AdNotifications.BREAK_END:\n        this.text.textContent = \"\";\n        this.adText.textContent = \"\";\n        break;\n      case AdNotifications.AD_TIME_REMAINING:\n        time = Math.round(notification.getBody());\n        if ((this.totalAds != null) && this.totalAds > 0 && (this.adPosition != null) && this.adPosition !== this.totalAds) {\n          msg = time > 0 ? \"\" + (this.localizationManager.getString(LocalizationConstants.MSG_NEXT_AD)) + time + \" \" + (this.localizationManager.getString(LocalizationConstants.MSG_SECONDS)) : \"\";\n        } else {\n          msg = time > 0 ? \"\" + (this.localizationManager.getString(LocalizationConstants.MSG_NEXT_VIDEO)) + time + \" \" + (this.localizationManager.getString(LocalizationConstants.MSG_SECONDS)) : \"\";\n        }\n        this.text.textContent = msg;\n        break;\n      case AdNotifications.AD_STARTED:\n        adVO = notification.getBody();\n        this.totalAds = adVO.totalAds;\n        this.adPosition = adVO.position;\n        msg = \"Ad \" + adVO.position + \" of \" + adVO.totalAds;\n        if ((adVO.position != null) && (adVO.totalAds != null) && adVO.totalAds >= 1) {\n          this.adText.textContent = msg;\n        }\n    }\n  };\n\n  /**\n   * The AdMediaChangeCommand class.\n   *\n   * @constructor\n   * @private\n   * @extends {AdCommand}\n  */\n  function AdMediaChangeCommand() {\n    AdMediaChangeCommand.__super__.constructor.call(this);\n  }\n\n\n  __extends(AdMediaChangeCommand, PluginCommand);\n\n\n  /**\n   * Executes the command.\n   *\n   * @param {puremvc.Notification} notification\n   *    The notification.\n   *\n   * @override\n  */\n  AdMediaChangeCommand.prototype.execute = function(notification) {\n    if (this.proxy.getEnabled() === false) {\n      return;\n    }\n    this.proxy.engage(notification.getBody());\n  };\n\n  /**\n   * The AdLoadedCommand class.\n   *\n   * @constructor\n   * @private\n   * @extends {AdCommand}\n  */\n  function AdLoadedCommand() {\n    AdLoadedCommand.__super__.constructor.call(this);\n  }\n\n\n  __extends(AdLoadedCommand, PluginEventCommand);\n\n\n  /**\n   * Executes the command.\n   *\n   * @param {puremvc.Notification} notification\n   *    The notification.\n   *\n   * @override\n  */\n  AdLoadedCommand.prototype.execute = function(notification) {\n    this.sendNotification(Notifications.UPDATE_DATA_BINDINGS, {\n      contexts: [this.proxy.getContextName()]\n    });\n    AdLoadedCommand.__super__.execute.call(this, notification);\n  };\n\n  /**\n   * The AdBreakStartCommand class.\n   *\n   * @constructor\n   * @private\n   * @extends {AdCommand}\n  */\n  function AdBreakStartCommand() {\n    AdBreakStartCommand.__super__.constructor.call(this);\n  }\n\n\n  __extends(AdBreakStartCommand, PluginEventCommand);\n\n\n  /**\n   * Executes the command.\n   *\n   * @param {puremvc.Notification} notification\n   *    The notification.\n   *\n   * @override\n  */\n  AdBreakStartCommand.prototype.execute = function(notification) {\n    this.player.sendNotification(Notifications.ADD_APPLICATION_STATE, \"ad-mode\");\n    AdBreakStartCommand.__super__.execute.call(this, notification);\n    this.proxy.breakStart();\n  };\n\n  /**\n   * The AdBreakEndCommand class.\n   *\n   * @constructor\n   * @private\n   * @extends {AdCommand}\n  */\n  function AdBreakEndCommand() {\n    AdBreakEndCommand.__super__.constructor.call(this);\n  }\n\n\n  __extends(AdBreakEndCommand, PluginEventCommand);\n\n\n  /**\n   * Executes the command.\n   *\n   * @param {puremvc.Notification} notification\n   *    The notification.\n   *\n   * @override\n  */\n  AdBreakEndCommand.prototype.execute = function(notification) {\n    AdBreakEndCommand.__super__.execute.call(this, notification);\n    this.proxy.breakEnd();\n    this.player.sendNotification(Notifications.REMOVE_APPLICATION_STATE, \"ad-mode\");\n  };\n\n  /**\n   * The AdSeekCommand class.\n   *\n   * @constructor\n   * @private\n   * @extends {AdCommand}\n  */\n  function AdSeekCommand() {\n    AdSeekCommand.__super__.constructor.call(this);\n  }\n\n\n  __extends(AdSeekCommand, PluginCommand);\n\n\n  /**\n   * Executes the command.\n   *\n   * @param {puremvc.Notification} notification\n   *    The notification.\n   *\n   * @override\n  */\n  AdSeekCommand.prototype.execute = function(notification) {\n    this.proxy.contentSeek(notification.getBody());\n  };\n\n  /**\n   * @enum {string}\n   * @const\n   * @private\n  */\n\n  var FlashAdNotifications = {\n    BREAK_START: \"adComponentBreakInitiated\",\n    BREAK_END: \"adComponentBreakComplete\",\n    BREAK_SKIPPED: \"adComponentBreakSkipped\",\n    AD_LOADED: \"adComponentLoaded\",\n    AD_STARTED: \"adComponentAdBegin\",\n    AD_TIME_UPDATE: \"adComponentPlaybackProgress\",\n    AD_TIME_REMAINING: \"adComponentTimeElapsed\",\n    AD_DURATION_CHANGE: \"addurationchange\",\n    AD_ENDED: \"adComponentAdComplete\",\n    AD_ERROR: \"adComponentInitFailed\",\n    AD_PLAY: \"adComponentPlaybackResumed\",\n    AD_PAUSE: \"adComponentPlaybackPaused\",\n    AD_LOG: \"adComponentLog\",\n    AD_COMPANION: \"adComponentCompanion\",\n    AD_PLAYBACK_FAILED: \"adComponentPlaybackFailed\",\n    AD_PLAYBACK_TERMINATED: \"adComponentPlaybackTerminated\",\n    AD_MEDIA_LOADED: \"adComponentMediaLoaded\",\n    AD_CLICKED: \"adComponentClicked\",\n    AD_FIRST_QUARTILE: \"adComponentFirstQuartile\",\n    AD_MIDPOINT: \"adComponentMidpoint\",\n    AD_THIRD_QUARTILE: \"adComponentThirdQuartile\",\n    AD_REQUEST: \"adComponentAdsRequest\",\n    AD_REQUEST_COMPLETE: \"adComponentAdsRequestComplete\",\n    AD_SKIPPED: \"adComponentAdSkipped\",\n    AD_IMPRESSION: \"adComponentImpression\"\n  };\n\n  /**\n   * The AdPlayCommand class.\n   *\n   * @constructor\n   * @private\n   * @extends {AdCommand}\n  */\n  function AdContainerCreatedCommand() {\n    AdContainerCreatedCommand.__super__.constructor.call(this);\n  }\n\n\n  __extends(AdContainerCreatedCommand, PluginEventCommand);\n\n\n  /**\n   * Executes the command.\n   *\n   * @param {puremvc.Notification} notification\n   *    The notification.\n   *\n   * @override\n  */\n  AdContainerCreatedCommand.prototype.execute = function(notification) {\n    this.proxy.container = notification.getBody();\n    AdContainerCreatedCommand.__super__.execute.call(this, notification);\n  };\n\n  /**\n   * The AuditudeProxy class.\n   *\n   * @constructor\n   * @private\n   * @extends {AdProxy}\n   * @param {Object} config\n  */\n  function AuditudeProxy(config) {\n    AuditudeProxy.__super__.constructor.call(this, config);\n  }\n\n\n  __extends(AuditudeProxy, AdProxy);\n\n\n  /** @static\n  */\n  AuditudeProxy.NAME = AdProxy.NAME;\n\n  AuditudeProxy.prototype.defaults = {\n    videoId: null,\n    defaultId: null,\n    domain: null,\n    zoneId: null,\n    companion: null,\n    userData: null,\n    params: null\n  };\n\n  AuditudeProxy.prototype.key = \"auditude\";\n\n  AuditudeProxy.prototype.session = null;\n\n  AuditudeProxy.prototype.options = null;\n\n  /** @override\n  */\n  AuditudeProxy.prototype.initialize = function() {\n    var _this = this;\n    this.options = {\n      controls: false,\n      auditudeHandlesChapterBreaks: false,\n      style: {\n        backgroundColor: '#000',\n        width: this.facade.player.mediaElement.clientWidth,\n        height: this.facade.player.mediaElement.clientHeight\n      },\n      handlers: {\n        play: function() {\n          _this.facade.logger.debug('ad play');\n        },\n        timeupdate: function(event, audPlayer, video) {\n          _this.facade.sendNotification(AdNotifications.AD_TIME_REMAINING, video.duration - video.currentTime);\n        },\n        error: function(err) {\n          _this.facade.logger.debug('ad error:', err);\n          _this.error();\n        },\n        pause: function() {\n          _this.facade.logger.debug('ad pause');\n        },\n        loadedmetadata: function(evt, player, video) {\n          _this.facade.logger.debug('ad loadedmetadata');\n        },\n        end: function() {\n          _this.facade.logger.debug('ad end');\n        }\n      }\n    };\n    try {\n      this.plugin = this.createPlugin();\n      this.plugin.subscribe(aud.events.init_complete, function(event, plugin) {\n        _this.facade.logger.debug('init_complete:', event, plugin);\n        try {\n          _this.plugin.publish(aud.notifications.break_begin);\n        } catch (err) {\n          _this.error(err);\n        }\n      });\n      this.plugin.subscribe(aud.events.init_failed, function(event, plugin) {\n        _this.error(event);\n      });\n      this.plugin.subscribe(aud.events.break_begin, function(event, plugin) {\n        _this.facade.logger.debug('break_begin:', event, plugin);\n      });\n      this.plugin.subscribe(aud.events.pause_playback, function(event, plugin) {\n        _this.facade.logger.debug('pause_playback: ' + event + \", \" + plugin);\n        _this.contentPause(event, plugin);\n      });\n      this.plugin.subscribe(aud.events.resume_playback, function(event, plugin) {\n        _this.facade.logger.debug('resume_playback: ', event, plugin);\n        _this.contentPlay(event, plugin);\n      });\n      this.plugin.subscribe(aud.events.linear_ad_begin, function(event, plugin, ctx) {\n        var id, title, xml;\n        _this.facade.logger.debug('linear ad begin:', event, plugin, ctx);\n        xml = plugin._xmlDoc.querySelector(\"ad[id]\");\n        if (xml != null) {\n          id = xml.getAttribute(\"id\");\n        }\n        xml = plugin._xmlDoc.querySelector(\"inLine[adTitle]\");\n        if (xml != null) {\n          title = xml.getAttribute(\"adTitle\");\n        }\n        _this.adVO = new AdVO(id, title, ctx.asset.duration, 1, \"preroll\", \"auditude\", null, ctx.banners, null, ctx);\n        _this.sendNotification(AdNotifications.AD_LOADED, _this.adVO);\n        _this.sendNotification(AdNotifications.AD_DURATION_CHANGE, _this.adVO);\n        _this.facade.player.sendNotification(Notifications.CHANGE_PLAY_STATE, PlayState.PLAYING);\n        _this.sendNotification(AdNotifications.AD_PLAY);\n        _this.setInProgress(true);\n        _this.setCompanions(ctx.banners);\n        _this.session = ctx.session;\n        _this.sendNotification(AdNotifications.AD_STARTED);\n      });\n      this.plugin.subscribe(aud.events.linear_ad_end, function(event, plugin, ctx) {\n        _this.facade.logger.debug('linear ad end:', event, plugin, ctx);\n        _this.sendNotification(AdNotifications.AD_ENDED);\n      });\n      this.plugin.subscribe(aud.events.break_end, function(event, plugin) {\n        _this.facade.logger.debug('break_end:', event, plugin);\n        _this.end();\n      });\n      this.plugin.subscribe(aud.events.non_linear_ad_begin, function(event, plugin, ctx) {\n        _this.facade.logger.debug('non linear ad begin');\n        _this.setCompanions(ctx.banners);\n      });\n      this.plugin.subscribe(aud.events.non_linear_ad_end, function(event, plugin, ctx) {\n        _this.facade.logger.debug('non linear ad end');\n      });\n    } catch (err) {\n      this.error(err);\n    }\n  };\n\n  /**\n  */\n  AuditudeProxy.prototype.createPlugin = function() {\n    return aud.html5.AdPlayer(this.facade.container.container, null, this.value.domain, this.value.zoneId, this.options);\n  };\n\n  /**\n  */\n  AuditudeProxy.prototype.start = function() {\n    var defaultId, id, key, params, userData, value, _ref;\n    if (AuditudeProxy.__super__.start.call(this) === false) {\n      return false;\n    }\n    try {\n      params = this.value.params || {};\n      userData = \"\";\n      if (this.value.userData != null) {\n        _ref = this.value.userData;\n        for (key in _ref) {\n          value = _ref[key];\n          userData += \"\" + key + \"=\" + value + \";\";\n        }\n      }\n      if (params.userData != null) {\n        userData += params.userData;\n      }\n      if (userData !== \"\") {\n        params.userData = userData;\n      }\n      id = this.value.videoId + \"\";\n      if (this.value.defaultId != null) {\n        defaultId = this.value.defaultId + \"\";\n        id = id != null ? [id, defaultId] : defaultId;\n      }\n      this.facade.logger.log(\"Auditude init: \", id, params);\n      this.plugin.init(id, params);\n    } catch (err) {\n      this.error(err);\n    }\n  };\n\n  /**\n  */\n  AuditudeProxy.prototype.play = function() {\n    AuditudeProxy.__super__.play.call(this);\n    this.session.notifyResume();\n  };\n\n  /**\n  */\n  AuditudeProxy.prototype.pause = function() {\n    AuditudeProxy.__super__.pause.call(this);\n    this.session.notifyPause();\n  };\n\n  /**\n  */\n  AuditudeProxy.prototype.breakStart = function() {};\n\n  /**\n  */\n  AuditudeProxy.prototype.setCompanions = function(ads) {\n    var ad, banner, companions, slot, _i, _j, _len, _len1;\n    if (!(ads != null) || ads.length < 1) {\n      return;\n    }\n    companions = [];\n    for (_i = 0, _len = ads.length; _i < _len; _i++) {\n      ad = ads[_i];\n      companions.push({\n        data: ad.data,\n        type: ad.resourceType,\n        width: parseInt(ad.width),\n        height: parseInt(ad.height),\n        metadata: ad\n      });\n    }\n    AuditudeProxy.__super__.setCompanions.call(this, companions);\n    if (!(this.value.companion != null)) {\n      return;\n    }\n    banner = this.value.companion;\n    slot = document.getElementById(banner.id);\n    if (!(slot != null)) {\n      return;\n    }\n    for (_j = 0, _len1 = ads.length; _j < _len1; _j++) {\n      ad = ads[_j];\n      if (!(banner.width === parseInt(ad.width) && banner.height === parseInt(ad.height))) {\n        continue;\n      }\n      slot.innerHTML = ad.data;\n      break;\n    }\n  };\n\n  /**\n  */\n  AuditudeProxy.prototype.contentStarted = function() {\n    this.plugin.publish(aud.notifications.video_playback_started);\n  };\n\n  /**\n  */\n  AuditudeProxy.prototype.contentEnded = function() {\n    this.plugin.publish(aud.notifications.video_playback_complete);\n  };\n\n  /**\n   * @constructor\n   * @private\n  */\n  function AuditudeFullscreenProxy(config) {\n    AuditudeFullscreenProxy.__super__.constructor.call(this, config);\n  }\n\n\n  __extends(AuditudeFullscreenProxy, AuditudeProxy);\n\n\n  /** @static\n  */\n  AuditudeFullscreenProxy.NAME = AuditudeProxy.NAME;\n\n  /**\n  */\n  AuditudeFullscreenProxy.prototype.createPlugin = function() {\n    return aud.html5.AdPlayer(this.facade.player.mediaElement, null, this.value.domain, this.value.zoneId, this.options);\n  };\n\n  /** @override\n  */\n  AuditudeFullscreenProxy.prototype.engage = function(media) {\n    AuditudeFullscreenProxy.__super__.engage.call(this, media);\n    this.sendNotification(Notifications.DISABLE_VIDEO_EVENTS, [\"ended\"]);\n  };\n\n  /** @override\n  */\n  AuditudeFullscreenProxy.prototype.reset = function(media) {\n    AuditudeFullscreenProxy.__super__.reset.call(this, media);\n    this.sendNotification(Notifications.ENABLE_VIDEO_EVENTS, [\"ended\"]);\n  };\n\n  /** @override\n  */\n  AuditudeFullscreenProxy.prototype.play = function() {\n    AuditudeFullscreenProxy.__super__.play.call(this);\n    this.facade.player.mediaElement.play();\n  };\n\n  /** @override\n  */\n  AuditudeFullscreenProxy.prototype.pause = function() {\n    AuditudeFullscreenProxy.__super__.pause.call(this);\n    this.facade.player.mediaElement.pause();\n  };\n\n  /** @override\n  */\n  AuditudeFullscreenProxy.prototype.contentPause = function() {\n    this.facade.player.mediaElement.pause();\n  };\n\n  /**\n   * @constructor\n   * @private\n  */\n  function AdWrapper(player, init) {\n    AdWrapper.__super__.constructor.call(this, player, init);\n  }\n\n\n  __extends(AdWrapper, PluginWrapper);\n\n\n  AdWrapper.NAME = \"AdWrapper\";\n\n  AdWrapper.prototype.enabled = true;\n\n  AdWrapper.prototype.paused = false;\n\n  AdWrapper.prototype.started = false;\n\n  AdWrapper.prototype.adVO = null;\n\n  AdWrapper.prototype.partner = null;\n\n  /**\n  */\n  AdWrapper.prototype.getFeatureName = function() {\n    return \"ads\";\n  };\n\n  AdWrapper.prototype.getInProgress = function() {\n    return this.player.mediaElement.getPlayerProperty(\"adInProgress\");\n  };\n\n  AdWrapper.prototype.getStarted = function() {\n    return this.started;\n  };\n\n  AdWrapper.prototype.getPaused = function() {\n    return this.paused;\n  };\n\n  AdWrapper.prototype.getCompanions = function() {\n    var _ref;\n    return (_ref = this.adVO) != null ? _ref.companions : void 0;\n  };\n\n  AdWrapper.prototype.setEnabled = function(value) {\n    this.enabled = value;\n    this.player.mediaElement.setPlayerProperty(\"adsEnabled\", value);\n    return value;\n  };\n\n  AdWrapper.prototype.getEnabled = function() {\n    return this.enabled;\n  };\n\n  AdWrapper.prototype.enable = function() {\n    this.setEnabled(true);\n  };\n\n  AdWrapper.prototype.disable = function() {\n    this.setEnabled(false);\n  };\n\n  /**\n  */\n  AdWrapper.prototype.createFlashVars = function(flashvars) {\n    flashvars.core_ads_enabled = true;\n    return flashvars;\n  };\n\n  /**\n  */\n  AdWrapper.prototype.listNotificationInterests = function() {\n    var key, value;\n    return AdWrapper.__super__.listNotificationInterests.call(this).concat((function() {\n      var _results;\n      _results = [];\n      for (key in FlashAdNotifications) {\n        value = FlashAdNotifications[key];\n        _results.push(value);\n      }\n      return _results;\n    })());\n  };\n\n  /** @override\n  */\n  AdWrapper.prototype.handleNotification = function(notification) {\n    var body, cues, event, name, pods, scene, target, type, _i, _len;\n    AdWrapper.__super__.handleNotification.call(this, notification);\n    name = notification.getName();\n    body = notification.getBody();\n    this.adVO = this.createAdVO(body);\n    target = this;\n    switch (name) {\n      case FlashAdNotifications.BREAK_START:\n        type = AdNotifications.BREAK_START;\n        break;\n      case FlashAdNotifications.BREAK_END:\n        type = AdNotifications.BREAK_END;\n        break;\n      case FlashAdNotifications.BREAK_SKIPPED:\n        type = AdNotifications.BREAK_SKIPPED;\n        break;\n      case FlashAdNotifications.AD_MEDIA_LOADED:\n        type = AdNotifications.AD_LOADED;\n        this.start = false;\n        break;\n      case FlashAdNotifications.AD_STARTED:\n        type = AdNotifications.AD_STARTED;\n        this.started = true;\n        this.sendNotification(Notifications.ADD_APPLICATION_STATE, \"ad-mode\");\n        break;\n      case FlashAdNotifications.AD_TIME_UPDATE:\n        type = AdNotifications.AD_TIME_UPDATE;\n        break;\n      case FlashAdNotifications.AD_TIME_REMAINING:\n        type = AdNotifications.AD_TIME_REMAINING;\n        break;\n      case FlashAdNotifications.AD_ERROR:\n      case FlashAdNotifications.AD_PLAYBACK_FAILED:\n        type = AdNotifications.AD_ERROR;\n        this.start = false;\n        this.sendNotification(Notifications.REMOVE_APPLICATION_STATE, \"ad-mode\");\n        break;\n      case FlashAdNotifications.AD_ENDED:\n      case FlashAdNotifications.AD_PLAYBACK_TERMINATED:\n        type = AdNotifications.AD_ENDED;\n        this.sendNotification(Notifications.REMOVE_APPLICATION_STATE, \"ad-mode\");\n        break;\n      case FlashAdNotifications.AD_CLICKED:\n        type = AdNotifications.AD_CLICKED;\n        break;\n      case FlashAdNotifications.AD_COMPANION:\n        type = AdNotifications.AD_COMPANION;\n        if ((this.adVO != null) && (body != null)) {\n          this.adVO.companions = body;\n        }\n        break;\n      case FlashAdNotifications.AD_PAUSE:\n        type = AdNotifications.AD_PAUSE;\n        target = this.player;\n        this.paused = true;\n        this.player.setPlayState(\"paused\");\n        break;\n      case FlashAdNotifications.AD_PLAY:\n        type = AdNotifications.AD_PLAY;\n        this.paused = false;\n        this.player.setPlayState(\"playing\");\n        break;\n      case FlashAdNotifications.AD_LOG:\n        type = AdNotifications.AD_LOG;\n        break;\n      case FlashAdNotifications.AD_FIRST_QUARTILE:\n        type = AdNotifications.FIRST_QUARTILE;\n        break;\n      case FlashAdNotifications.AD_MIDPOINT:\n        type = AdNotifications.MIDPOINT;\n        break;\n      case FlashAdNotifications.AD_THIRD_QUARTILE:\n        type = AdNotifications.THIRD_QUARTILE;\n        break;\n      case FlashAdNotifications.AD_REQUEST:\n        type = AdNotifications.REQUEST;\n        break;\n      case FlashAdNotifications.AD_REQUEST_COMPLETE:\n        type = AdNotifications.REQUEST_COMPLETE;\n        pods = [];\n        cues = body.cuePoints || [];\n        for (_i = 0, _len = cues.length; _i < _len; _i++) {\n          scene = cues[_i];\n          pods.push(new AdVO(scene.sceneId, scene.sceneTitle, scene.sceneDuration, scene.scenePodIndex, scene.scenePodPosition, this.partner, null, null, null, {}, scene.sceneSubCount, scene.sceneEndSeconds));\n        }\n        this.adVO = {\n          pods: pods\n        };\n        event = new Event(\"response\", this.adVO);\n        event.player = this.player;\n        target.dispatchEvent(event);\n        break;\n      case FlashAdNotifications.AD_SKIPPED:\n        type = AdNotifications.SKIPPED;\n        break;\n      case FlashAdNotifications.AD_IMPRESSION:\n        type = AdNotifications.IMPRESSION;\n    }\n    if (type != null) {\n      this.sendNotification(type, this.adVO);\n      if (type === AdNotifications.AD_TIME_REMAINING) {\n        event = new Event(type.replace(/^ads/, \"\"), body.timeElapsed);\n      } else {\n        event = new Event(type.replace(/^ads/, \"\"), this.adVO);\n      }\n      event.player = this.player;\n      target.dispatchEvent(event);\n    }\n  };\n\n  /**\n  */\n  AdWrapper.prototype.createAdVO = function(ad) {\n    if (!(ad != null)) {\n      return null;\n    }\n    return new AdVO(ad.id, ad.title, ad.duration, ad.adIndex, ad.podPosition, ad.adPlatform, null, null, ad.requestURL, ad.metadata, ad.totalAds, ad.currentTime);\n  };\n\n  /**\n   * @expose\n  */\n  AdWrapper.prototype.setPodLocks = function(pods) {\n    var pod, scenes, _i, _len;\n    scenes = [];\n    for (_i = 0, _len = pods.length; _i < _len; _i++) {\n      pod = pods[_i];\n      scenes.push({\n        sceneId: pod.id,\n        sceneLocked: pod.locked,\n        sceneTitle: pod.title,\n        sceneStartSeconds: pod.time,\n        sceneEndSeconds: pod.duration + pod.time,\n        scenePodIndex: pod.position,\n        scenePodPosition: pod.type\n      });\n    }\n    this.player.mediaElement.setAdPodLocks(scenes);\n  };\n\n  /**\n   * @expose\n  */\n  AdWrapper.prototype.terminateAd = function() {\n    this.player.mediaElement.terminateAd();\n  };\n\n  /**\n   * @expose\n  */\n  AdWrapper.prototype.terminateAllAds = function() {\n    this.player.mediaElement.terminateAllAds();\n  };\n\n  /**\n   * @expose\n  */\n  AdWrapper.prototype.requestAd = function() {\n    this.player.mediaElement.triggerAd();\n  };\n\n  function AuditudeWrapper() {\n    return AuditudeWrapper.__super__.constructor.apply(this, arguments);\n  }\n\n\n  __extends(AuditudeWrapper, AdWrapper);\n\n\n  AuditudeWrapper.NAME = \"AuditudeWrapper\";\n\n  AuditudeWrapper.prototype.flashPlugins = [\n    {\n      id: \"AuditudePlugin\",\n      src: '#{paths.resources}plugins/AuditudeStandardPlugin.swf',\n      host: \"akamai\",\n      main: '#{paths.resources}plugins/AuditudeStandardPlugin.swf',\n      type: \"application/x-shockwave-flash\"\n    }\n  ];\n\n  /**\n  */\n  AuditudeWrapper.prototype.createFlashVars = function(flashvars) {\n    if ((this.config.companion != null)) {\n      flashvars.ad_partner_companion_size = \"\" + this.config.companion.width + \"x\" + this.config.companion.height;\n    }\n    return flashvars;\n  };\n\n  AuditudeWrapper.prototype.createXML = function(xml) {\n    var admedia, application, companion, companions, ids, prop, props, vendor, _i, _j, _len, _len1, _ref;\n    application = xml.firstChild;\n    admedia = xml.getElementsByTagName(\"admedia\")[0];\n    if (!(admedia != null)) {\n      admedia = xml.createElement(\"admedia\");\n      application.appendChild(admedia);\n    }\n    vendor = xml.createElement(\"vendor\");\n    vendor.setAttribute(\"id\", \"auditude\");\n    admedia.appendChild(vendor);\n    props = [\n      {\n        value: this.config.domain,\n        key: \"AUDITUDE_DOMAIN\"\n      }, {\n        value: this.config.videoId,\n        key: \"AUDITUDE_MEDIA_ID\"\n      }, {\n        value: this.config.defaultId,\n        key: \"AUDITUDE_DEFAULT_MEDIA_ID\"\n      }, {\n        value: this.config.zoneId,\n        key: \"AUDITUDE_ZONE_ID\"\n      }, {\n        value: this.config.prerollId,\n        key: \"AUDITUDE_PREROLL_MEDIA_ID\"\n      }, {\n        value: this.config.midrollId,\n        key: \"AUDITUDE_MIDROLL_MEDIA_ID\"\n      }, {\n        value: this.config.audienceManagerURL,\n        key: \"AUDITUDE_AUDIENCE_MGR_URL\"\n      }, {\n        value: this.config.version,\n        key: \"AUDITUDE_VERSION\"\n      }\n    ];\n    for (_i = 0, _len = props.length; _i < _len; _i++) {\n      prop = props[_i];\n      if (prop.value != null) {\n        this.createProperty(xml, prop.key, prop.value, vendor);\n      }\n    }\n    if (this.config.position != null) {\n      vendor.setAttribute(\"position\", this.config.position);\n    }\n    if (this.config.companions != null) {\n      companions = [];\n      ids = [];\n      _ref = this.config.companions;\n      for (_j = 0, _len1 = _ref.length; _j < _len1; _j++) {\n        companion = _ref[_j];\n        companions.push(companion.width + \"x\" + companion.height);\n        ids.push(companion.id);\n      }\n      this.createProperty(xml, \"AUDITUDE_COMPANION_SIZE\", companions.join(\",\"), vendor);\n      this.createProperty(xml, \"AUDITUDE_COMPANION_ID\", companions.join(\",\"), vendor);\n    }\n    if (this.config.params != null) {\n      this.createProperty(xml, \"AUDITUDE_PARAMS\", this.config.params, vendor);\n    }\n    if (this.config.userData != null) {\n      this.createProperty(xml, \"AUDITUDE_USER_DATA\", this.config.userData, vendor);\n    }\n    return xml;\n  };\n\n  /**\n   * The AdPlugin class.\n   *\n   * @param {Module}  app     The parent module of this plugin.\n   * @constructor\n   * @private\n   * @extends {Feature}\n  */\n  function AdPlugin() {\n    AdPlugin.__super__.constructor.call(this);\n  }\n\n\n  __extends(AdPlugin, Feature);\n\n\n  AdPlugin.NAME = \"AdPlugin\";\n\n  AdPlugin.prototype.container = null;\n\n  AdPlugin.prototype.featureName = \"ads\";\n\n  /** @override\n  */\n  AdPlugin.prototype.createModel = function() {\n    this.proxy = this.isFullscreenDevice() ? this.createFullscreenProxy() : this.createProxy();\n    this.registerProxy(this.proxy);\n  };\n\n  /** @override\n  */\n  AdPlugin.prototype.createController = function() {\n    AdPlugin.__super__.createController.call(this);\n    this.registerCommand(Notifications.MEDIA_CHANGE, AdMediaChangeCommand);\n    this.registerCommand(AdNotifications.BREAK_START, AdBreakStartCommand);\n    this.registerCommand(AdNotifications.AD_LOADED, AdLoadedCommand);\n    this.registerCommand(AdNotifications.BREAK_END, AdBreakEndCommand);\n    this.registerCommand(Notifications.SEEK, AdSeekCommand);\n    this.registerCommand(UserNotifications.SEEK, AdSeekCommand);\n    this.registerCommand(AdNotifications.AD_CONTAINER_CREATED, AdContainerCreatedCommand);\n    this.registerCommand(AdNotifications.AD_STARTED, PluginEventCommand);\n    this.registerCommand(AdNotifications.SKIPPED, PluginEventCommand);\n    this.registerCommand(AdNotifications.AD_MANAGER_LOADED, PluginEventCommand);\n    this.registerCommand(AdNotifications.AD_TIME_UPDATE, PluginEventCommand);\n    this.registerCommand(AdNotifications.AD_TIME_REMAINING, PluginEventCommand);\n    this.registerCommand(AdNotifications.AD_DURATION_CHANGE, PluginEventCommand);\n    this.registerCommand(AdNotifications.AD_ENDED, PluginEventCommand);\n    this.registerCommand(AdNotifications.AD_ERROR, PluginEventCommand);\n    this.registerCommand(AdNotifications.AD_COMPANION, PluginEventCommand);\n    this.registerCommand(AdNotifications.FIRST_QUARTILE, PluginEventCommand);\n    this.registerCommand(AdNotifications.MIDPOINT, PluginEventCommand);\n    this.registerCommand(AdNotifications.THIRD_QUARTILE, PluginEventCommand);\n    this.registerCommand(AdNotifications.LOG, PluginEventCommand);\n    this.registerCommand(AdNotifications.REQUEST, PluginEventCommand);\n    this.registerCommand(AdNotifications.AD_RESUME, PluginEventCommand);\n    this.registerCommand(AdNotifications.AD_PLAY, PluginEventCommand);\n    this.registerCommand(AdNotifications.AD_PAUSE, PluginEventCommand);\n    this.registerCommand(AdNotifications.AD_PAUSED, PluginEventCommand);\n    this.registerCommand(AdNotifications.IMPRESSION, PluginEventCommand);\n    this.registerCommand(AdNotifications.AD_CLICKED, PluginEventCommand);\n    this.registerCommand(AdNotifications.REQUEST_COMPLETE, PluginEventCommand);\n    this.registerCommand(AdNotifications.RESPONSE, PluginEventCommand);\n    this.registerCommand(AdNotifications.BREAK_SKIPPED, PluginEventCommand);\n  };\n\n  /** @override\n  */\n  AdPlugin.prototype.createView = function() {\n    return this.registerMediator(new AdMediator());\n  };\n\n  AdPlugin.prototype.isFullscreenDevice = function() {\n    return Utils.isFullscreenDevice();\n  };\n\n  AdPlugin.prototype.createProxy = function() {};\n\n  AdPlugin.prototype.createFullscreenProxy = function() {};\n\n  /**\n  */\n  AdPlugin.prototype.listNotificationInterests = function() {\n    return [Notifications.MEDIA_CHANGE, Notifications.PLAY, Notifications.PAUSE, Notifications.PAUSED, Notifications.START, Notifications.STARTED, Notifications.ENDED, Notifications.READY, Notifications.SEEK, Notifications.VOLUME_CHANGE, Notifications.FULL_SCREEN_CHANGE, Notifications.CHANGE_ACTIVE_STATE, Notifications.PLAY_STATE_CHANGE, UserNotifications.PLAY, UserNotifications.PAUSE, UserNotifications.SEEK, UserNotifications.TOGGLE_PLAY_PAUSE];\n  };\n\n  /**\n  */\n  AdPlugin.prototype.listNotificationPublications = function() {\n    var key, value;\n    return AdPlugin.__super__.listNotificationPublications.call(this).concat((function() {\n      var _results;\n      _results = [];\n      for (key in AdNotifications) {\n        value = AdNotifications[key];\n        _results.push(value);\n      }\n      return _results;\n    })()).concat([Notifications.PLAY_REQUEST, Notifications.UPDATE_DATA_BINDINGS, Notifications.DISPLAY_TIME, Notifications.ADD_CUE_POINTS, Notifications.DISABLE_FULL_SCREEN, Notifications.ENABLE_VIDEO_EVENTS, Notifications.DISABLE_VIDEO_EVENTS, Notifications.HAS_POST_CONTENT, Notifications.MEDIA_SEQUENCE_ENDED, Notifications.CHANGE_PLAY_STATE]);\n  };\n\n  /**\n   * @param {boolean} value The enabled flag.\n   * @expose\n  */\n  AdPlugin.prototype.setEnabled = function(value) {\n    this.proxy.setEnabled(value);\n  };\n\n  /**\n   * @return {boolean} The enabled flag.\n   * @expose\n  */\n  AdPlugin.prototype.getEnabled = function() {\n    return this.proxy.getEnabled();\n  };\n\n  /**\n   * @return {boolean} The in progress flag.\n   * @expose\n  */\n  AdPlugin.prototype.getInProgress = function() {\n    return this.proxy.getInProgress();\n  };\n\n  /**\n   * @return {boolean} The started flag.\n   * @expose\n  */\n  AdPlugin.prototype.getStarted = function() {\n    return this.proxy.getStarted();\n  };\n\n  /**\n   * @return {boolean} The paused flag.\n   * @expose\n  */\n  AdPlugin.prototype.getPaused = function() {\n    return this.proxy.getPaused();\n  };\n\n  /**\n   * @return {Array.<Object>} The list of companion ads.\n   * @expose\n  */\n  AdPlugin.prototype.getCompanions = function() {\n    return this.proxy.getCompanions();\n  };\n\n  /**\n   * @expose\n  */\n  AdPlugin.prototype.setPodLocks = function(pods) {\n    this.proxy.setPodLocks(pods);\n  };\n\n  /**\n   * @expose\n  */\n  AdPlugin.prototype.terminateAd = function() {\n    this.proxy.terminateAd();\n  };\n\n  /**\n   * @expose\n  */\n  AdPlugin.prototype.terminateAllAds = function() {\n    this.proxy.terminateAllAds();\n  };\n\n  /**\n   * @expose\n  */\n  AdPlugin.prototype.requestAd = function() {\n    this.proxy.start(false);\n  };\n\n  /**\n   * @enum {string}\n   * @const\n   * @private\n  */\n\n  var AutoAdvanceNotifications = {\n    TIME_UPDATE: \"autoadvancetimeupdate\",\n    START: \"autoadvancestart\",\n    STOP: \"autoadvancestop\",\n    ADVANCE: \"autoadvanceadvance\"\n  };\n\n  /**\n   * @constructor\n   * @private\n  */\n  function AutoAdvanceWrapper(player, config) {\n    if (config == null) {\n      config = {};\n    }\n    AutoAdvanceWrapper.__super__.constructor.call(this, player, config);\n    if (config.interval != null) {\n      this.interval = config.interval;\n    }\n    if (config.handler != null) {\n      this.handler = config.handler;\n    }\n  }\n\n\n  __extends(AutoAdvanceWrapper, PluginWrapper);\n\n\n  AutoAdvanceWrapper.NAME = \"AutoAdvanceWrapper\";\n\n  AutoAdvanceWrapper.prototype.interval = null;\n\n  AutoAdvanceWrapper.prototype.handler = null;\n\n  AutoAdvanceWrapper.prototype.getInterval = function() {\n    return this.interval;\n  };\n\n  AutoAdvanceWrapper.prototype.setInterval = function(value) {\n    return this.interval = value;\n  };\n\n  AutoAdvanceWrapper.prototype.getHandler = function() {\n    return this.handler;\n  };\n\n  AutoAdvanceWrapper.prototype.setHandler = function(value) {\n    return this.handler = value;\n  };\n\n  /** @override\n  */\n  AutoAdvanceWrapper.prototype.listNotificationInterests = function() {\n    return [FlashNotifications.CREATE_FLASH_VARS, FlashNotifications.AUTO_ADVANCE];\n  };\n\n  /**\n  */\n  AutoAdvanceWrapper.prototype.handleNotification = function(notification) {\n    var body, flashvars, name, type, _base;\n    name = notification.getName();\n    body = notification.getBody();\n    switch (name) {\n      case FlashNotifications.CREATE_FLASH_VARS:\n        flashvars = body.flashvars;\n        if (this.interval != null) {\n          flashvars.next_video_timer = this.interval;\n          flashvars.auto_play_list = true;\n        }\n        break;\n      case FlashNotifications.AUTO_ADVANCE:\n        if (typeof (_base = this.config).handler === \"function\") {\n          _base.handler();\n        }\n        type = \"advance\";\n    }\n    if (type != null) {\n      this.dispatchEvent(new Event(type));\n    }\n  };\n\n  /**\n   * @constructor\n   * @private\n  */\n  function AutoAdvanceProxy(config) {\n    AutoAdvanceProxy.__super__.constructor.call(this, config);\n  }\n\n\n  __extends(AutoAdvanceProxy, ModuleProxy);\n\n\n  /** @static\n  */\n  AutoAdvanceProxy.NAME = ModuleProxy.NAME;\n\n  AutoAdvanceProxy.prototype.defaults = {\n    interval: 15,\n    handler: null\n  };\n\n  AutoAdvanceProxy.prototype.currentTime = 0;\n\n  AutoAdvanceProxy.prototype.timeout = null;\n\n  AutoAdvanceProxy.prototype.start = function() {\n    var _this = this;\n    this.currentTime = this.data.interval;\n    this.timeout = setInterval(function() {\n      _this.updateTime();\n    }, 1000);\n    this.sendNotification(AutoAdvanceNotifications.TIME_UPDATE, this.currentTime);\n  };\n\n  AutoAdvanceProxy.prototype.stop = function() {\n    clearInterval(this.timeout);\n  };\n\n  AutoAdvanceProxy.prototype.updateTime = function() {\n    this.currentTime--;\n    this.sendNotification(AutoAdvanceNotifications.TIME_UPDATE, this.currentTime);\n    if (this.currentTime <= 0) {\n      this.stop();\n      this.sendNotification(AutoAdvanceNotifications.ADVANCE, this.data.handler);\n    }\n  };\n\n  /**\n   * The AutoAdvanceStartCommand class.\n   *\n   * @constructor\n   * @private\n   * @extends {amp.plugins.PluginEventCommand}\n  */\n  function AutoAdvanceStartCommand() {\n    AutoAdvanceStartCommand.__super__.constructor.call(this);\n  }\n\n\n  __extends(AutoAdvanceStartCommand, PluginEventCommand);\n\n\n  /**\n   * Executes the command.\n   *\n   * @param {puremvc.Notification} notification\n   *    The notification.\n   *\n   * @override\n  */\n  AutoAdvanceStartCommand.prototype.execute = function(notification) {\n    this.sendNotification(Notifications.ADD_APPLICATION_STATE, \"autoadvance-mode\");\n    this.proxy.start();\n    AutoAdvanceStartCommand.__super__.execute.call(this, notification);\n  };\n\n  /**\n   * The AutoAdvanceAdvanceCommand class.\n   *\n   * @constructor\n   * @private\n   * @extends {amp.plugins.PluginEventCommand}\n  */\n  function AutoAdvanceAdvanceCommand() {\n    AutoAdvanceAdvanceCommand.__super__.constructor.call(this);\n  }\n\n\n  __extends(AutoAdvanceAdvanceCommand, PluginEventCommand);\n\n\n  /**\n   * Executes the command.\n   *\n   * @param {puremvc.Notification} notification\n   *    The notification.\n   *\n   * @override\n  */\n  AutoAdvanceAdvanceCommand.prototype.execute = function(notification) {\n    var handler;\n    handler = notification.getBody();\n    if ((handler != null)) {\n      if (typeof handler === \"string\") {\n        eval(\"\" + handler + \"()\");\n      } else if (typeof handler === \"function\") {\n        handler();\n      }\n    }\n    this.sendNotification(Notifications.REMOVE_APPLICATION_STATE, \"autoadvance-mode\");\n    AutoAdvanceAdvanceCommand.__super__.execute.call(this, notification);\n  };\n\n  /**\n   * The AutoAdvanceEndedCommand class.\n   *\n   * @constructor\n   * @private\n   * @extends {amp.plugins.PluginCommand}\n  */\n  function AutoAdvanceEndedCommand() {\n    AutoAdvanceEndedCommand.__super__.constructor.call(this);\n  }\n\n\n  __extends(AutoAdvanceEndedCommand, PluginCommand);\n\n\n  /**\n   * Executes the command.\n   *\n   * @param {puremvc.Notification} notification\n   *    The notification.\n   *\n   * @override\n  */\n  AutoAdvanceEndedCommand.prototype.execute = function(notification) {\n    if (this.proxy.getData().interval != null) {\n      this.sendNotification(AutoAdvanceNotifications.START, notification.getBody());\n    }\n  };\n\n  /**\n   * The AutoAdvanceStopCommand class.\n   *\n   * @constructor\n   * @private\n   * @extends {amp.plugins.PluginCommand}\n  */\n  function AutoAdvanceStopCommand() {\n    AutoAdvanceStopCommand.__super__.constructor.call(this);\n  }\n\n\n  __extends(AutoAdvanceStopCommand, PluginCommand);\n\n\n  /**\n   * Executes the command.\n   *\n   * @param {puremvc.Notification} notification\n   *    The notification.\n   *\n   * @override\n  */\n  AutoAdvanceStopCommand.prototype.execute = function(notification) {\n    this.proxy.stop();\n  };\n\n  /**\n   * The AutoAdvanceMediator class.\n   *\n   * @constructor\n   * @private\n   * @extends {OverlayMediator}\n   * @param {Object} viewComponent\n  */\n  function AutoAdvanceMediator() {\n    AutoAdvanceMediator.__super__.constructor.call(this);\n  }\n\n\n  __extends(AutoAdvanceMediator, OverlayMediator);\n\n\n  AutoAdvanceMediator.prototype.componentName = \"autoadvance\";\n\n  AutoAdvanceMediator.prototype.text = null;\n\n  AutoAdvanceMediator.prototype.onRegister = function() {\n    AutoAdvanceMediator.__super__.onRegister.call(this);\n    this.text = this.create(\"autoadvance-text\");\n  };\n\n  /**\n   * @override\n  */\n  AutoAdvanceMediator.prototype.listNotificationInterests = function() {\n    return [AutoAdvanceNotifications.TIME_UPDATE];\n  };\n\n  /**\n   * @override\n  */\n  AutoAdvanceMediator.prototype.handleNotification = function(notification) {\n    var time;\n    switch (notification.getName()) {\n      case AutoAdvanceNotifications.TIME_UPDATE:\n        time = notification.getBody();\n        this.text.textContent = \"\" + (this.localizationManager.getString('MSG_NEXT_VIDEO')) + \" \" + time + \" \" + (this.localizationManager.getString('MSG_SECONDS'));\n    }\n  };\n\n  /**\n   * The AuditudePlugin class.\n   *\n   * @param {Module}  app     The parent module of this plugin.\n   * @constructor\n   * @private\n   * @extends {AdPlugin}\n  */\n  function AuditudePlugin() {\n    AuditudePlugin.__super__.constructor.call(this);\n  }\n\n\n  __extends(AuditudePlugin, AdPlugin);\n\n\n  AuditudePlugin.NAME = \"AuditudePlugin\";\n\n  AuditudePlugin.prototype.moduleName = \"auditude\";\n\n  AuditudePlugin.prototype.featureName = \"ads\";\n\n  AuditudePlugin.prototype.createFullscreenProxy = function() {\n    return new AuditudeFullscreenProxy(this.config);\n  };\n\n  AuditudePlugin.prototype.createProxy = function() {\n    return new AuditudeProxy(this.config);\n  };\n\n  AuditudePlugin.prototype.isFullscreenDevice = function() {\n    return true;\n  };\n\n\n  AMP.registerPlugin(\"auditude\", \"html\", AuditudePlugin);\n  AMP.registerPlugin(\"auditude\", \"flash\", AuditudeWrapper);\n\n  /**\n   * @enum {string}\n   * @const\n   * @private\n  */\n\n  var RecommendationsNotifications = {\n    RECOMMENDATIONS_LOADED: \"recommendationsloaded\",\n    RECOMMENDATION_SELECTED: \"recommendationsselected\"\n  };\n\n  function RecommendationVO(guid, link, title, description, thumbnail, duration, pubDate, target, metadata) {\n    this.guid = guid;\n    this.link = link;\n    this.title = title;\n    this.description = description;\n    this.thumbnail = thumbnail;\n    this.duration = duration;\n    this.pubDate = pubDate;\n    this.target = target;\n    this.metadata = metadata != null ? metadata : {};\n  }\n\n  RecommendationVO.prototype.guid = null;\n\n  RecommendationVO.prototype.link = null;\n\n  RecommendationVO.prototype.title = null;\n\n  RecommendationVO.prototype.description = null;\n\n  RecommendationVO.prototype.thumbnail = null;\n\n  RecommendationVO.prototype.duration = null;\n\n  RecommendationVO.prototype.pubDate = null;\n\n  RecommendationVO.prototype.target = null;\n\n  RecommendationVO.prototype.metadata = null;\n\n  /**\n   * @constructor\n   * @private\n   * @extends {PluginWrapper}\n  */\n  function RecommendationsWrapper(player, config) {\n    if (config == null) {\n      config = {};\n    }\n    RecommendationsWrapper.__super__.constructor.call(this, player, config);\n    if (config.url != null) {\n      this.url = config.url;\n    }\n    if (config.target != null) {\n      this.target = config.target;\n    }\n  }\n\n\n  __extends(RecommendationsWrapper, PluginWrapper);\n\n\n  RecommendationsWrapper.NAME = \"RecommendationsWrapper\";\n\n  RecommendationsWrapper.prototype.flashPlugins = [\n    {\n      id: \"RecommendationsPlugin\",\n      src: '#{paths.resources}plugins/RecommendationsPlugin.swf',\n      blocking: false,\n      host: \"akamai\",\n      main: \"RecommendationsPlugin\",\n      type: \"application/x-shockwave-flash\"\n    }\n  ];\n\n  RecommendationsWrapper.prototype.flashView = {\n    elements: {\n      recommendationSlate: {\n        attributes: {\n          items: \"5\",\n          viewMode: \"grid\"\n        }\n      }\n    }\n  };\n\n  RecommendationsWrapper.prototype.url = null;\n\n  RecommendationsWrapper.prototype.target = null;\n\n  RecommendationsWrapper.prototype.recommendations = null;\n\n  /**\n  */\n  RecommendationsWrapper.prototype.getFeatureName = function() {\n    return \"recommendations\";\n  };\n\n  /**\n  */\n  RecommendationsWrapper.prototype.getData = function() {\n    return this.recommendations;\n  };\n\n  RecommendationsWrapper.prototype.setData = function(value) {\n    return this.recommendations = value;\n  };\n\n  /**\n  */\n  RecommendationsWrapper.prototype.getTarget = function() {\n    var _ref, _ref1;\n    return this.target || ((_ref = this.player) != null ? (_ref1 = _ref.config) != null ? _ref1.target : void 0 : void 0);\n  };\n\n  /**\n  */\n  RecommendationsWrapper.prototype.getURL = function() {\n    return this.url;\n  };\n\n  /**\n  */\n  RecommendationsWrapper.prototype.createFlashVars = function(flashvars) {\n    flashvars.recommendations_partner = \"mrss\";\n    if (this.config.target != null) {\n      flashvars.external_target = this.config.target;\n    }\n  };\n\n  /**\n  */\n  RecommendationsWrapper.prototype.createXML = function(xml) {\n    var application, recommendations, vendor;\n    application = xml.firstChild;\n    recommendations = xml.getElementsByTagName(\"recommendations\")[0];\n    if (!(recommendations != null)) {\n      recommendations = xml.createElement(\"recommendations\");\n      application.appendChild(recommendations);\n    }\n    vendor = xml.createElement(\"vendor\");\n    vendor.setAttribute(\"id\", \"mrss\");\n    recommendations.appendChild(vendor);\n    this.createProperty(xml, \"RECOMMENDATIONS_MRSS_URL\", this.url, vendor);\n  };\n\n  /** @override\n  */\n  RecommendationsWrapper.prototype.listNotificationInterests = function() {\n    return RecommendationsWrapper.__super__.listNotificationInterests.apply(this, arguments).concat([FlashNotifications.RECOMMENDATION_SELECTED, FlashNotifications.RECOMMENDATIONS_LOADED]);\n  };\n\n  /**\n  */\n  RecommendationsWrapper.prototype.handleNotification = function(notification) {\n    var body, name, type;\n    RecommendationsWrapper.__super__.handleNotification.call(this, notification);\n    name = notification.getName();\n    body = notification.getBody();\n    switch (name) {\n      case FlashNotifications.RECOMMENDATIONS_LOADED:\n        type = \"loaded\";\n        this.recommendations = body;\n        break;\n      case FlashNotifications.RECOMMENDATION_SELECTED:\n        type = \"selected\";\n    }\n    if (type != null) {\n      this.dispatchEvent(new Event(type, body));\n    }\n  };\n\n  /**\n   * The RecommendationsSelectedCommand class.\n   *\n   * @constructor\n   * @private\n   * @extends {amp.plugins.PluginEventCommand}\n  */\n  function RecommendationSelectedCommand() {\n    RecommendationSelectedCommand.__super__.constructor.call(this);\n  }\n\n\n  __extends(RecommendationSelectedCommand, PluginEventCommand);\n\n\n  /**\n   * Executes the command.\n   *\n   * @param {puremvc.Notification} notification\n   *    The notification.\n   *\n   * @override\n  */\n  RecommendationSelectedCommand.prototype.execute = function(notification) {\n    var rec;\n    RecommendationSelectedCommand.__super__.execute.call(this, notification);\n    rec = notification.getBody();\n    if (rec.target !== \"none\" && rec.target !== \"player\") {\n      window.open(rec.link, rec.target);\n    }\n  };\n\n  /**\n   * The RecommendationsPlayCommand class.\n   *\n   * @constructor\n   * @private\n   * @extends {amp.plugins.PluginCommand}\n  */\n  function RecommendationsPlayCommand() {\n    RecommendationsPlayCommand.__super__.constructor.call(this);\n  }\n\n\n  __extends(RecommendationsPlayCommand, PluginCommand);\n\n\n  /**\n   * Executes the command.\n   *\n   * @param {puremvc.Notification} notification\n   *    The notification.\n   *\n   * @override\n  */\n  RecommendationsPlayCommand.prototype.execute = function(notification) {\n    this.proxy.invoke();\n  };\n\n  /**\n   * The RecommendationsPlayStateChangeCommand class.\n   *\n   * @constructor\n   * @private\n   * @extends {amp.plugins.PluginCommand}\n  */\n  function RecommendationsPlayStateChangeCommand() {\n    RecommendationsPlayStateChangeCommand.__super__.constructor.call(this);\n  }\n\n\n  __extends(RecommendationsPlayStateChangeCommand, PluginCommand);\n\n\n  /**\n   * Executes the command.\n   *\n   * @param {puremvc.Notification} notification\n   *    The notification.\n   *\n   * @override\n  */\n  RecommendationsPlayStateChangeCommand.prototype.execute = function(notification) {\n    var recommendations, states;\n    recommendations = this.proxy.getRecommendations();\n    states = notification.getBody();\n    if (states.value === PlayState.ENDED) {\n      if ((recommendations != null ? recommendations.length : void 0) > 0) {\n        this.sendNotification(Notifications.ADD_APPLICATION_STATE, \"recommendations-mode\");\n      }\n    } else if (states.previous === PlayState.ENDED) {\n      if ((recommendations != null ? recommendations.length : void 0) > 0) {\n        this.sendNotification(Notifications.REMOVE_APPLICATION_STATE, \"recommendations-mode\");\n      }\n    }\n  };\n\n  /**\n   * Proxy for recommendations feature\n   *\n   * @constructor\n   * @private\n  */\n  function RecommendationsProxy(config) {\n    RecommendationsProxy.__super__.constructor.call(this, config);\n    this.helper = new MRSSHelper();\n  }\n\n\n  __extends(RecommendationsProxy, PluginProxy);\n\n\n  /** @static\n  */\n  RecommendationsProxy.NAME = ModuleProxy.NAME;\n\n  RecommendationsProxy.prototype.defaults = {\n    url: null,\n    target: \"_blank\"\n  };\n\n  RecommendationsProxy.prototype.loaded = true;\n\n  RecommendationsProxy.prototype.recommendations = null;\n\n  RecommendationsProxy.prototype.helper = null;\n\n  /** Getter/Setter for RecommendationVO.\n  */\n  RecommendationsProxy.prototype.getRecommendations = function() {\n    return this.recommendations;\n  };\n\n  RecommendationsProxy.prototype.setRecommendations = function(value) {\n    this.recommendations = value;\n    this.sendNotification(RecommendationsNotifications.RECOMMENDATIONS_LOADED, this.recommendations);\n    return value;\n  };\n\n  RecommendationsProxy.prototype.getURL = function() {\n    return this.getConfigurationData().url;\n  };\n\n  RecommendationsProxy.prototype.setURL = function(value) {\n    this.data.url = value;\n    this.invoke();\n    return value;\n  };\n\n  RecommendationsProxy.prototype.getTarget = function() {\n    return this.getConfigurationData().target || this.facade.player.retrieveProxy(ConfigurationProxy.NAME).getTarget();\n  };\n\n  RecommendationsProxy.prototype.setTarget = function(value) {\n    this.data.target = value;\n    return value;\n  };\n\n  /**\n   *\n   *\n   * @param {String} value\n   *    The new display state of the player\n   * @returns {String}\n   *    The display state of the player\n   * @type {String}\n  */\n  RecommendationsProxy.prototype.invoke = function() {\n    var url, xhr;\n    url = this.getURL();\n    if (!(url != null) || url === \"\") {\n      this.facade.logger.error(\"[AMP RECOMMENDATIONS ERROR]\", \"Load Error: No url provided\");\n      return;\n    }\n    xhr = Utils.getJson(url, this.onload.bind(this), this.onerror.bind(this));\n  };\n\n  RecommendationsProxy.prototype.onload = function(json) {\n    var recs;\n    recs = this.createRecommendations(json);\n    this.setRecommendations(recs);\n  };\n\n  RecommendationsProxy.prototype.onerror = function(error) {\n    this.facade.logger.error(\"[AMP RECOMMENDATIONS ERROR]\", \"Load Error:\", error);\n  };\n\n  /**\n  */\n  RecommendationsProxy.prototype.createRecommendations = function(feed) {\n    var item, rec, recs, _i, _len, _ref;\n    feed = this.helper.createFeed(feed);\n    recs = [];\n    _ref = feed.item;\n    for (_i = 0, _len = _ref.length; _i < _len; _i++) {\n      item = _ref[_i];\n      rec = new RecommendationVO(item.guid, item.link, item.title, item.description, item.thumbnail, item.duration, item.pubDate, this.getTarget(), item);\n      recs.push(rec);\n    }\n    return recs;\n  };\n\n  /**\n   * The RecommendationsMediator class.\n   *\n   * @constructor\n   * @private\n   * @extends {OverlayMediator}\n  */\n  function RecommendationsMediator() {\n    RecommendationsMediator.__super__.constructor.call(this);\n  }\n\n\n  __extends(RecommendationsMediator, OverlayMediator);\n\n\n  RecommendationsMediator.prototype.componentName = \"recommendations\";\n\n  RecommendationsMediator.prototype.listArea = null;\n\n  /**\n   * @override\n  */\n  RecommendationsMediator.prototype.onRegister = function() {\n    var label;\n    RecommendationsMediator.__super__.onRegister.call(this);\n    label = this.createText(\"recommendations-label\", \"Recommended\");\n    this.listArea = this.create(\"recommendations-list-area\");\n  };\n\n  /**\n   * @override\n  */\n  RecommendationsMediator.prototype.listNotificationInterests = function() {\n    return [RecommendationsNotifications.RECOMMENDATIONS_LOADED];\n  };\n\n  /**\n   * @override\n  */\n  RecommendationsMediator.prototype.handleNotification = function(notification) {\n    var rec, recs, _i, _len;\n    switch (notification.getName()) {\n      case RecommendationsNotifications.RECOMMENDATIONS_LOADED:\n        this.listArea.innerHTML = \"\";\n        recs = notification.getBody();\n        if ((recs != null) && recs.length > 0) {\n          for (_i = 0, _len = recs.length; _i < _len; _i++) {\n            rec = recs[_i];\n            this.addElement(rec);\n          }\n        }\n    }\n  };\n\n  RecommendationsMediator.prototype.addElement = function(recommendation) {\n    var listItem,\n      _this = this;\n    listItem = this.create(\"recommendation\", this.listArea);\n    if (listItem.dataset == null) {\n      listItem.dataset = {};\n    }\n    listItem.dataset.link = recommendation.link;\n    listItem.dataset.target = recommendation.target;\n    listItem.innerHTML = \"<img src='\" + recommendation.thumbnail + \"' class='\" + this.cssPrefix + \"recommendation-thumbnail' /> <span class='\" + this.cssPrefix + \"recommendation-text'>\" + recommendation.description + \"</span>\";\n    listItem.onclick = function(event) {\n      event.stopImmediatePropagation();\n      _this.sendNotification(RecommendationsNotifications.RECOMMENDATION_SELECTED, event.currentTarget.dataset);\n      return false;\n    };\n  };\n\n  /**\n   * The AutoadvancePlugin class.\n   *\n   * @param {Module}  app     The parent module of this plugin.\n   * @constructor\n   * @private\n   * @extends {Plugin}\n  */\n  function AutoAdvancePlugin() {\n    AutoAdvancePlugin.__super__.constructor.call(this);\n  }\n\n\n  __extends(AutoAdvancePlugin, Plugin);\n\n\n  AutoAdvancePlugin.NAME = \"AutoAdvancePlugin\";\n\n  AutoAdvancePlugin.prototype.moduleName = \"autoadvance\";\n\n  /** @override\n  */\n  AutoAdvancePlugin.prototype.createController = function() {\n    AutoAdvancePlugin.__super__.createController.call(this);\n    this.registerCommand(AutoAdvanceNotifications.START, AutoAdvanceStartCommand);\n    this.registerCommand(AutoAdvanceNotifications.ADVANCE, AutoAdvanceAdvanceCommand);\n    this.registerCommand(Notifications.MEDIA_SEQUENCE_ENDED, AutoAdvanceEndedCommand);\n    this.registerCommand(Notifications.CHANGE_MEDIA, AutoAdvanceStopCommand);\n    this.registerCommand(Notifications.PLAY, AutoAdvanceStopCommand);\n    this.registerCommand(Notifications.PLAYING, AutoAdvanceStopCommand);\n    this.registerCommand(Notifications.REPLAY, AutoAdvanceStopCommand);\n    this.registerCommand(Notifications.SEEK, AutoAdvanceStopCommand);\n    this.registerCommand(UserNotifications.SEEK, AutoAdvanceStopCommand);\n    this.registerCommand(Notifications.TIME_UPDATE, PluginEventCommand);\n    this.registerCommand(Notifications.STOP, PluginEventCommand);\n  };\n\n  /** @override\n  */\n  AutoAdvancePlugin.prototype.createModel = function() {\n    this.registerProxy(new AutoAdvanceProxy(this.config));\n  };\n\n  /** @override\n  */\n  AutoAdvancePlugin.prototype.createView = function() {\n    this.registerMediator(new AutoAdvanceMediator());\n  };\n\n  /** @override\n  */\n  AutoAdvancePlugin.prototype.listNotificationInterests = function() {\n    return [Notifications.CHANGE_MEDIA, Notifications.PLAY, Notifications.PLAYING, Notifications.REPLAY, Notifications.MEDIA_SEQUENCE_ENDED, Notifications.SEEK, UserNotifications.SEEK];\n  };\n\n  /**\n  */\n  AutoAdvancePlugin.prototype.listNotificationPublications = function() {\n    var key, value;\n    return AutoAdvancePlugin.__super__.listNotificationPublications.call(this).concat((function() {\n      var _results;\n      _results = [];\n      for (key in AutoAdvanceNotifications) {\n        value = AutoAdvanceNotifications[key];\n        _results.push(value);\n      }\n      return _results;\n    })());\n  };\n\n\n  AMP.registerPlugin(\"autoadvance\", \"html\", AutoAdvancePlugin);\n  AMP.registerPlugin(\"autoadvance\", \"flash\", AutoAdvanceWrapper);\n\n  /**\n   * The AdChoicesMediator class.\n   *\n   * @constructor\n   * @private\n   * @extends {LocalizedMediator}\n  */\n  function RecommendationsGridMediator() {\n    RecommendationsGridMediator.__super__.constructor.call(this);\n  }\n\n\n  __extends(RecommendationsGridMediator, OverlayMediator);\n\n\n  RecommendationsGridMediator.prototype.componentName = \"recommendations-grid\";\n\n  RecommendationsGridMediator.prototype.grid = null;\n\n  RecommendationsGridMediator.prototype.onRegister = function() {\n    var label;\n    RecommendationsGridMediator.__super__.onRegister.call(this);\n    label = this.createText(\"recommendations-grid-label\", this.localizationManager.getString(LocalizationConstants.MSG_RECOMMENDATIONS_TITLE));\n    this.grid = this.create(\"recommendations-grid-table-grid\", this, \"table\");\n  };\n\n  /**\n   * @override\n  */\n  RecommendationsGridMediator.prototype.listNotificationInterests = function() {\n    return [RecommendationsNotifications.RECOMMENDATIONS_LOADED];\n  };\n\n  /**\n   * @override\n  */\n  RecommendationsGridMediator.prototype.handleNotification = function(notification) {\n    var rec, recs, _i, _len;\n    switch (notification.getName()) {\n      case RecommendationsNotifications.RECOMMENDATIONS_LOADED:\n        this.grid.innerHTML = \"\";\n        this.create(\"recommendations-grid-row\", this.grid, \"tr\");\n        this.create(\"recommendations-grid-row\", this.grid, \"tr\");\n        recs = notification.getBody();\n        if ((recs != null) && recs.length > 0) {\n          for (_i = 0, _len = recs.length; _i < _len; _i++) {\n            rec = recs[_i];\n            this.addElement(rec, _i);\n          }\n        }\n    }\n  };\n\n  RecommendationsGridMediator.prototype.addElement = function(recommendation, recommendedIndex) {\n    var gridRowIndex, td,\n      _this = this;\n    gridRowIndex = (recommendedIndex % 4) < 2 ? 0 : 1;\n    td = this.create(\"recommendations-grid-item\", this.grid.childNodes[gridRowIndex], \"td\");\n    if (td.dataset == null) {\n      td.dataset = {};\n    }\n    td.dataset.link = recommendation.link;\n    td.dataset.target = this.config.getTarget();\n    td.innerHTML = \"<img src='\" + recommendation.thumbnail + \"' class='\" + this.cssPrefix + \"recommendations-grid-thumbnail' /> <span class='\" + this.cssPrefix + \"recommendations-grid-text'>\" + recommendation.description + \"</span>\";\n    td.onclick = function(event) {\n      event.stopImmediatePropagation();\n      _this.sendNotification(RecommendationsNotifications.RECOMMENDATION_SELECTED, event.currentTarget.dataset);\n      return false;\n    };\n  };\n\n  /**\n   * The RecommendationsFluidGridMediator class.\n   *\n   * @constructor\n   * @private\n   * @extends {LocalizedMediator}\n  */\n  function RecommendationsFluidGridMediator() {\n    RecommendationsFluidGridMediator.__super__.constructor.call(this);\n  }\n\n\n  __extends(RecommendationsFluidGridMediator, OverlayMediator);\n\n\n  RecommendationsFluidGridMediator.prototype.componentName = \"recommendations-fluid-grid\";\n\n  RecommendationsFluidGridMediator.prototype.grid = null;\n\n  RecommendationsFluidGridMediator.prototype.timeout = null;\n\n  RecommendationsFluidGridMediator.prototype.gridBounds = {\n    width: 0,\n    height: 0\n  };\n\n  RecommendationsFluidGridMediator.prototype.onRegister = function() {\n    RecommendationsFluidGridMediator.__super__.onRegister.call(this);\n    this.grid = this.viewComponent;\n    window.addEventListener(\"orientationchange\", this.delayedResizeGridHanlder.bind(this));\n  };\n\n  /**\n   * @override\n  */\n  RecommendationsFluidGridMediator.prototype.listNotificationInterests = function() {\n    return [RecommendationsNotifications.RECOMMENDATIONS_LOADED, Notifications.ENDED, Notifications.CHANGE_MEDIA, Notifications.PLAY, Notifications.PLAYING, Notifications.REPLAY];\n  };\n\n  RecommendationsFluidGridMediator.prototype.delayedResizeGridHanlder = function(event) {\n    try {\n      clearTimeout(this.timeout);\n    } catch (_error) {}\n    this.timeout = setTimeout(this.resizeGridHandler.bind(this, true), 100);\n  };\n\n  RecommendationsFluidGridMediator.prototype.resizeGridHandler = function(isOrientation) {\n    var currentGridBounds, item, _i, _j, _len, _len1, _ref, _ref1;\n    if (isOrientation == null) {\n      isOrientation = false;\n    }\n    currentGridBounds = this.grid.getBoundingClientRect();\n    if (this.gridBounds.width !== currentGridBounds.width || this.gridBounds.height !== currentGridBounds.height || isOrientation) {\n      this.grid.setAttribute(\"style\", \"align-content:flex-start; -webkit-align-content:flex-start; -ms-flex-align: flex-start;opacity:0;\");\n      this.gridBounds = currentGridBounds;\n      _ref = this.grid.childNodes;\n      for (_i = 0, _len = _ref.length; _i < _len; _i++) {\n        item = _ref[_i];\n        item.style.display = \"block\";\n      }\n      _ref1 = this.grid.childNodes;\n      for (_j = 0, _len1 = _ref1.length; _j < _len1; _j++) {\n        item = _ref1[_j];\n        if (item.getBoundingClientRect().bottom > this.gridBounds.bottom) {\n          item.style.display = \"none\";\n        }\n      }\n      this.grid.setAttribute(\"style\", \"align-content:center; -webkit-align-content:center; -ms-flex-align: center;opacity:1;\");\n    }\n  };\n\n  /**\n   * @override\n  */\n  RecommendationsFluidGridMediator.prototype.handleNotification = function(notification) {\n    var rec, recs, _i, _len,\n      _this = this;\n    switch (notification.getName()) {\n      case Notifications.CHANGE_MEDIA:\n      case Notifications.PLAY:\n      case Notifications.PLAYING:\n      case Notifications.REPLAY:\n        try {\n          clearInterval(this.timeout);\n        } catch (_error) {}\n        break;\n      case Notifications.ENDED:\n        this.timeout = setInterval(function() {\n          _this.resizeGridHandler();\n        }, 500);\n        break;\n      case RecommendationsNotifications.RECOMMENDATIONS_LOADED:\n        this.grid.innerHTML = \"\";\n        recs = notification.getBody();\n        if ((recs != null) && recs.length > 0) {\n          for (_i = 0, _len = recs.length; _i < _len; _i++) {\n            rec = recs[_i];\n            this.addElement(rec, _i);\n          }\n        }\n    }\n  };\n\n  RecommendationsFluidGridMediator.prototype.addElement = function(recommendation, recommendedIndex) {\n    var tile, _ref, _ref1,\n      _this = this;\n    tile = this.create(\"recommendations-fluid-grid-tile\", this.grid);\n    tile.style.backgroundImage = \"url(\" + recommendation.thumbnail + \")\";\n    if (((_ref = this.facade.getConfig().responsive) != null ? _ref.rows : void 0) != null) {\n      tile.style.height = \"calc(\" + 100 / this.facade.getConfig().responsive.rows + \"%)\";\n    }\n    if (((_ref1 = this.facade.getConfig().responsive) != null ? _ref1.column : void 0) != null) {\n      tile.style.width = \"calc(\" + 100 / this.facade.getConfig().responsive.columns + \"%)\";\n    }\n    tile.dataset.link = recommendation.link;\n    tile.dataset.target = this.facade.getConfig().target;\n    EventHandler.create(tile, EventHandler.CLICK, function(event) {\n      event.stopImmediatePropagation();\n      _this.sendNotification(RecommendationsNotifications.RECOMMENDATION_SELECTED, event.currentTarget.dataset);\n      return false;\n    });\n    this.create(\"recommendations-fluid-grid-tile-caption\", tile, \"span\", recommendation.description);\n  };\n\n  /**\n   * The RecommendationsPlugin class.\n   *\n   * @param {Module}  app     The parent module of this plugin.\n   * @constructor\n   * @private\n   * @extends {Plugin}\n  */\n  function RecommendationsPlugin() {\n    RecommendationsPlugin.__super__.constructor.call(this);\n  }\n\n\n  __extends(RecommendationsPlugin, Feature);\n\n\n  RecommendationsPlugin.prototype.featureName = \"recommendations\";\n\n  RecommendationsPlugin.prototype.moduleName = \"recommendations\";\n\n  /** @override\n  */\n  RecommendationsPlugin.prototype.createController = function() {\n    this.registerCommand(RecommendationsNotifications.RECOMMENDATION_SELECTED, RecommendationSelectedCommand);\n    this.registerCommand(Notifications.START, RecommendationsPlayCommand);\n    this.registerCommand(Notifications.PLAY_STATE_CHANGE, RecommendationsPlayStateChangeCommand);\n    this.registerCommand(RecommendationsNotifications.RECOMMENDATIONS_LOADED, PluginEventCommand);\n  };\n\n  /** @override\n  */\n  RecommendationsPlugin.prototype.createModel = function() {\n    this.proxy = new RecommendationsProxy(this.config);\n    this.registerProxy(this.proxy);\n  };\n\n  /** @override\n  */\n  RecommendationsPlugin.prototype.createView = function() {\n    this.registerMediator(new RecommendationsMediator());\n  };\n\n  /**\n  */\n  RecommendationsPlugin.prototype.listNotificationInterests = function() {\n    return [Notifications.START, Notifications.PLAY_STATE_CHANGE];\n  };\n\n  /**\n  */\n  RecommendationsPlugin.prototype.listNotificationPublications = function() {\n    var key, value;\n    return RecommendationsPlugin.__super__.listNotificationPublications.call(this).concat((function() {\n      var _results;\n      _results = [];\n      for (key in RecommendationsNotifications) {\n        value = RecommendationsNotifications[key];\n        _results.push(value);\n      }\n      return _results;\n    })());\n  };\n\n  /**\n   * @param {string} value The url of the feed.\n   * @expose\n  */\n  RecommendationsPlugin.prototype.setURL = function(value) {\n    this.proxy.set(value);\n  };\n\n  /**\n   * @return {string} The url of the feed.\n   * @expose\n  */\n  RecommendationsPlugin.prototype.getURL = function() {\n    return this.proxy.getURL();\n  };\n\n  /**\n   * @return {Object} The MRSS feed object.\n   * @expose\n  */\n  RecommendationsPlugin.prototype.getData = function() {\n    return this.proxy.getData();\n  };\n\n  /**\n   * @param {Object} value The MRSS feed object\n   * @expose\n  */\n  RecommendationsPlugin.prototype.setData = function(value) {\n    this.proxy.setData(value);\n  };\n\n  /**\n   * @return {string} The window target for recommendations.\n   * @expose\n  */\n  RecommendationsPlugin.prototype.getTarget = function() {\n    return this.proxy.getTarget();\n  };\n\n  /**\n   * @param {string} value The window target for recommendations.\n   * @expose\n  */\n  RecommendationsPlugin.prototype.setTarget = function(value) {\n    this.proxy.setTarget(value);\n  };\n\n\n  AMP.registerPlugin(\"recommendations\", \"html\", RecommendationsPlugin);\n  AMP.registerPlugin(\"recommendations\", \"flash\", RecommendationsWrapper);\n\n  /**\n   * @constructor\n   * @private\n  */\n  function NielsenProxy(config) {\n    NielsenProxy.__super__.constructor.call(this, config);\n  }\n\n\n  __extends(NielsenProxy, DataBoundConfigurationProxy);\n\n\n  NielsenProxy.prototype.configurationName = \"nielsen\";\n\n  /** @static\n  */\n  NielsenProxy.NAME = ModuleProxy.NAME;\n\n  NielsenProxy.cg = \"OnDemand\";\n\n  NielsenProxy.url = \"http://secure-us.imrworldwide.com/cgi-bin/m\";\n\n  NielsenProxy.prototype.defaults = {\n    url: null,\n    data: {\n      ci: null,\n      c6: null,\n      cg: null,\n      tl: null\n    },\n    events: null\n  };\n\n  NielsenProxy.prototype.getTitle = function() {\n    return this.title;\n  };\n\n  NielsenProxy.prototype.setTitle = function(value) {\n    return this.title = value;\n  };\n\n  /**\n  */\n  NielsenProxy.prototype.start = function() {\n    var url;\n    url = this.constructURL(\"video\", \"started\");\n    Utils.beacon(url, \"nielsenBeacon\");\n  };\n\n  NielsenProxy.prototype.end = function() {\n    var url;\n    url = this.constructURL(\"video\", \"ended\");\n    Utils.beacon(url, \"nielsenBeacon\");\n  };\n\n  NielsenProxy.prototype.constructURL = function(target, type) {\n    var c6, cg, ci, event, events, item, tl, url, _i, _len, _ref, _ref1, _ref2, _ref3, _ref4;\n    url = this.url || NielsenProxy.url;\n    events = (_ref = this.value.events) != null ? _ref[target] : void 0;\n    if (events != null) {\n      for (_i = 0, _len = events.length; _i < _len; _i++) {\n        item = events[_i];\n        if (item.type === type) {\n          event = item;\n        }\n      }\n    }\n    ci = (event != null ? (_ref1 = event.data) != null ? _ref1.ci : void 0 : void 0) || this.value.data.ci;\n    c6 = (event != null ? (_ref2 = event.data) != null ? _ref2.c6 : void 0 : void 0) || this.value.data.c6;\n    cg = (event != null ? (_ref3 = event.data) != null ? _ref3.cg : void 0 : void 0) || this.value.data.cg || NielsenProxy.cg;\n    tl = (event != null ? (_ref4 = event.data) != null ? _ref4.tl : void 0 : void 0) || this.value.data.tl;\n    return \"\" + url + \"?ci=\" + ci + \"&c6=\" + c6 + \"&cc=1&tl=\" + tl + \"&cg=\" + cg + \"&rnd=\" + (Date.now());\n  };\n\n  function NielsenWrapper() {\n    return NielsenWrapper.__super__.constructor.apply(this, arguments);\n  }\n\n\n  __extends(NielsenWrapper, PluginWrapper);\n\n\n  NielsenWrapper.NAME = \"NielsenWrapper\";\n\n  NielsenWrapper.prototype.flashPlugins = [\n    {\n      id: \"NielsenPlugin\",\n      src: '#{paths.resources}plugins/NielsenPlugin.swf',\n      blocking: false,\n      host: \"akamai\",\n      main: \"NielsenPlugin\",\n      type: \"application/x-shockwave-flash\"\n    }\n  ];\n\n  /** @override\n  */\n  NielsenWrapper.prototype.createXML = function(xml) {\n    var application, element, event, events, map, metrics, node, prop, props, text, txtTest, type, urlElement, vendor, _i, _j, _len, _len1, _ref, _ref1, _ref2, _ref3;\n    if (!(((_ref = this.config) != null ? _ref.events : void 0) != null)) {\n      return;\n    }\n    application = xml.firstChild;\n    metrics = xml.getElementsByTagName(\"metrics\")[0];\n    if (!(metrics != null)) {\n      metrics = xml.createElement(\"metrics\");\n      application.appendChild(metrics);\n    }\n    vendor = xml.createElement(\"vendor\");\n    vendor.setAttribute(\"id\", \"nielsen\");\n    metrics.appendChild(vendor);\n    map = {\n      ads: {\n        started: \"adStart\",\n        ended: \"adComplete\"\n      },\n      video: {\n        started: \"videoStart\",\n        ended: \"videoComplete\"\n      }\n    };\n    props = [\n      {\n        value: \"ci\",\n        key: \"NIELSEN_CI\"\n      }, {\n        value: \"cg\",\n        key: \"NIELSEN_CG\"\n      }, {\n        value: \"tl\",\n        key: \"NIELSEN_TL\"\n      }, {\n        value: \"c6\",\n        key: \"NIELSEN_C6\"\n      }\n    ];\n    if (this.config.url != null) {\n      urlElement = xml.createElement(\"property\");\n      urlElement.setAttribute(\"key\", \"serviceURL\");\n      txtTest = XMLUtils.createTextContent(xml, this.config.url.toString());\n      urlElement.appendChild(txtTest);\n      vendor.appendChild(urlElement);\n    }\n    _ref1 = this.config.events;\n    for (type in _ref1) {\n      events = _ref1[type];\n      if ((events != null) && events.length > 0) {\n        for (_i = 0, _len = events.length; _i < _len; _i++) {\n          event = events[_i];\n          node = xml.createElement(\"property\");\n          node.setAttribute(\"key\", map[type][event.type]);\n          vendor.appendChild(node);\n          for (_j = 0, _len1 = props.length; _j < _len1; _j++) {\n            prop = props[_j];\n            text = ((_ref2 = event.data) != null ? _ref2[prop.value] : void 0) || ((_ref3 = this.config.data) != null ? _ref3[prop.value] : void 0);\n            if ((text != null) && text !== \"\") {\n              element = xml.createElement(\"property\");\n              element.setAttribute(\"key\", prop.key);\n              text = XMLUtils.createTextContent(xml, text);\n              element.appendChild(text);\n              node.appendChild(element);\n            }\n          }\n        }\n      }\n    }\n    return xml;\n  };\n\n  /**\n   * The NielsenEndCommand class.\n   *\n   * @constructor\n   * @private\n   * @extends {puremvc.SimpleCommand}\n  */\n  function NielsenEndCommand() {\n    NielsenEndCommand.__super__.constructor.call(this);\n  }\n\n\n  __extends(NielsenEndCommand, puremvc.SimpleCommand);\n\n\n  /**\n   * Executes the command.\n   *\n   * @param {puremvc.Notification} notification\n   *    The notification.\n   *\n   * @override\n  */\n  NielsenEndCommand.prototype.execute = function(notification) {\n    var nielsen;\n    nielsen = this.facade.retrieveProxy(NielsenProxy.NAME);\n    nielsen.end();\n  };\n\n  /**\n   * The NielsenStartCommand class.\n   *\n   * @constructor\n   * @private\n   * @extends {puremvc.SimpleCommand}\n  */\n  function NielsenStartCommand() {\n    NielsenStartCommand.__super__.constructor.call(this);\n  }\n\n\n  __extends(NielsenStartCommand, puremvc.SimpleCommand);\n\n\n  /**\n   * Executes the command.\n   *\n   * @param {puremvc.Notification} notification\n   *    The notification.\n   *\n   * @override\n  */\n  NielsenStartCommand.prototype.execute = function(notification) {\n    var nielsen;\n    nielsen = this.facade.retrieveProxy(NielsenProxy.NAME);\n    nielsen.start();\n  };\n\n  /**\n   * The RecommendationsGridPlugin class.\n   *\n   * @param {Module}  app     The parent module of this plugin.\n   * @constructor\n   * @private\n   * @extends {RecommendationsPlugin}\n  */\n  function RecommendationsGridPlugin() {\n    RecommendationsGridPlugin.__super__.constructor.call(this);\n  }\n\n\n  __extends(RecommendationsGridPlugin, RecommendationsPlugin);\n\n\n  RecommendationsGridPlugin.prototype.moduleName = \"recommendationsgrid\";\n\n  /** @override\n  */\n  RecommendationsGridPlugin.prototype.createView = function() {\n    if (this.config.view === \"tile\") {\n      this.registerMediator(new RecommendationsFluidGridMediator());\n    } else {\n      this.registerMediator(new RecommendationsGridMediator());\n    }\n  };\n\n  /**\n  */\n  RecommendationsGridPlugin.prototype.listNotificationInterests = function() {\n    return RecommendationsGridPlugin.__super__.listNotificationInterests.call(this).concat([Notifications.ENDED, Notifications.CHANGE_MEDIA, Notifications.PLAY, Notifications.PLAYING, Notifications.REPLAY]);\n  };\n\n\n  AMP.registerPlugin(\"recommendationsgrid\", \"html\", RecommendationsGridPlugin);\n  AMP.registerPlugin(\"recommendationsgrid\", \"flash\", RecommendationsWrapper);\n\n  function NielsensdkWrapper() {\n    return NielsensdkWrapper.__super__.constructor.apply(this, arguments);\n  }\n\n\n  __extends(NielsensdkWrapper, PluginWrapper);\n\n\n  NielsensdkWrapper.NAME = \"NielsensdkWrapper\";\n\n  NielsensdkWrapper.prototype.flashPlugins = [\n    {\n      id: \"NielsenSDKPlugin\",\n      src: '#{paths.resources}plugins/NielsenSDKPlugin.swf',\n      blocking: false,\n      host: \"akamai\",\n      main: \"NielsenSDKPlugin\"\n    }\n  ];\n\n  /** @override\n  */\n  NielsensdkWrapper.prototype.createXML = function(xml) {\n    var application, element, event, events, map, metrics, node, pluginProp, pluginProps, prop, props, text, type, vendor, _i, _j, _k, _len, _len1, _len2, _ref, _ref1, _ref2, _ref3;\n    if (!(((_ref = this.config) != null ? _ref.events : void 0) != null)) {\n      return;\n    }\n    application = xml.firstChild;\n    metrics = xml.getElementsByTagName(\"metrics\")[0];\n    if (!(metrics != null)) {\n      metrics = xml.createElement(\"metrics\");\n      application.appendChild(metrics);\n    }\n    vendor = xml.createElement(\"vendor\");\n    vendor.setAttribute(\"id\", \"nielsenSDK\");\n    metrics.appendChild(vendor);\n    map = {\n      ads: {\n        started: \"adStart\",\n        ended: \"adComplete\"\n      },\n      video: {\n        started: \"videoStart\",\n        resume: \"videoResume\",\n        ended: \"videoComplete\"\n      }\n    };\n    props = [\n      {\n        value: \"censusCategory\",\n        key: \"NIELSEN_CENSUS_CATEGORY\"\n      }, {\n        value: \"category\",\n        key: \"NIELSEN_CATEGORY\"\n      }, {\n        value: \"episodeTitle\",\n        key: \"NIELSEN_EPISODE_TITLE\"\n      }, {\n        value: \"videoType\",\n        key: \"NIELSEN_VIDEO_TYPE\"\n      }, {\n        value: \"length\",\n        key: \"NIELSEN_LENGTH\"\n      }, {\n        value: \"assetId\",\n        key: \"NIELSEN_ASSET_ID\"\n      }, {\n        value: \"dprFlag\",\n        key: \"NIELSEN_DPR_FLAG\"\n      }\n    ];\n    pluginProps = [\n      {\n        value: \"apid\",\n        key: \"NIELSEN_APID\"\n      }, {\n        value: \"sfcode\",\n        key: \"NIELSEN_SF_CODE\"\n      }, {\n        value: \"apn\",\n        key: \"NIELSEN_APN\"\n      }, {\n        value: \"fbTag\",\n        key: \"NIELSEN_FBTAG\"\n      }\n    ];\n    for (_i = 0, _len = pluginProps.length; _i < _len; _i++) {\n      pluginProp = pluginProps[_i];\n      if (this.config.data[pluginProp.value] != null) {\n        this.createProperty(xml, pluginProp.key, this.config.data[pluginProp.value], vendor);\n      }\n    }\n    _ref1 = this.config.events;\n    for (type in _ref1) {\n      events = _ref1[type];\n      if ((events != null) && events.length > 0) {\n        for (_j = 0, _len1 = events.length; _j < _len1; _j++) {\n          event = events[_j];\n          node = xml.createElement(\"property\");\n          node.setAttribute(\"key\", map[type][event.type]);\n          vendor.appendChild(node);\n          for (_k = 0, _len2 = props.length; _k < _len2; _k++) {\n            prop = props[_k];\n            text = ((_ref2 = event.data) != null ? _ref2[prop.value] : void 0) || ((_ref3 = this.config.data) != null ? _ref3[prop.value] : void 0);\n            if ((text != null) && text !== \"\") {\n              element = xml.createElement(\"property\");\n              element.setAttribute(\"key\", prop.key);\n              text = XMLUtils.createTextContent(xml, text);\n              element.appendChild(text);\n              node.appendChild(element);\n            }\n          }\n        }\n      }\n    }\n    return xml;\n  };\n\n  /**\n   * @constructor\n   * @private\n  */\n  function NielsensdkProxy(config) {\n    NielsensdkProxy.__super__.constructor.call(this, config);\n  }\n\n\n  __extends(NielsensdkProxy, PluginProxy);\n\n\n  /** @static\n  */\n  NielsensdkProxy.NAME = ModuleProxy.NAME;\n\n  NielsensdkProxy.prototype.defaults = {\n    data: null,\n    events: null,\n    plugin: {\n      js: \"http://secure-us.imrworldwide.com/novms/js/2/ggcmb400.js\"\n    }\n  };\n\n  NielsensdkProxy.prototype.nielsensdkSDK = null;\n\n  NielsensdkProxy.prototype.cur_position = 0;\n\n  NielsensdkProxy.prototype.timer = null;\n\n  NielsensdkProxy.prototype.queryInterval = 2;\n\n  NielsensdkProxy.prototype.isLive = null;\n\n  /** Overrides\n  */\n  NielsensdkProxy.prototype.initialize = function() {\n    NielsensdkProxy.__super__.initialize.call(this);\n    this.nielsensdkSDK = new NOLCMB.ggInitialize(this.value.data);\n  };\n\n  /** Populate Nielsen VO\n  */\n  NielsensdkProxy.prototype.generateNielsenVO = function(adVO, eventName) {\n    var event, events, key, media, type, vo, _i, _len, _ref;\n    if (adVO == null) {\n      adVO = null;\n    }\n    if (eventName == null) {\n      eventName = null;\n    }\n    vo = new Object();\n    media = this.facade.player.getMedia();\n    this.isLive = media.isLive;\n    vo.assetid = media.guid;\n    vo.category = media.category;\n    vo.censuscategory = media.category;\n    vo.dprflag = \"true\";\n    vo.episodetitle = media.title ? media.title : episode_url;\n    vo.length = adVO != null ? adVO.duration : String(media.duration.toFixed(1)) === \"NaN\" ? 86400 : String(media.duration.toFixed(1));\n    vo.videotype = adVO != null ? adVO.type : \"content\";\n    _ref = this.value.events;\n    for (type in _ref) {\n      events = _ref[type];\n      if ((eventName != null) && (events != null) && events.length > 0) {\n        for (_i = 0, _len = events.length; _i < _len; _i++) {\n          event = events[_i];\n          if ((event != null ? event.type : void 0) === eventName) {\n            for (key in event.data) {\n              vo[key.toLowerCase()] = event.data[key];\n            }\n          }\n        }\n      }\n    }\n    return vo;\n  };\n\n  /** MetaData Loaded\n  */\n  NielsensdkProxy.prototype.metaLoad = function() {\n    this.nielsensdkSDK.ggPM(\"15\", this.generateNielsenVO());\n    this.facade.logger.log(\"[AMP Nielsensdk Event] : loadMetadata\");\n  };\n\n  NielsensdkProxy.prototype.adStart = function(adVO) {\n    if ((adVO != null ? adVO.type : void 0) === \"midroll\") {\n      this.nielsensdkSDK.ggPM(\"7\", this.generateNielsenVO());\n      this.facade.logger.log(\"[AMP Nielsensdk Event] : stop\");\n    }\n    this.nielsensdkSDK.ggPM(\"15\", this.generateNielsenVO(adVO));\n    this.facade.logger.log(\"[AMP Nielsensdk Event] : Ad Start\");\n  };\n\n  NielsensdkProxy.prototype.adEnd = function(adVO) {\n    this.nielsensdkSDK.ggPM(\"7\", this.generateNielsenVO(adVO));\n    this.facade.logger.log(\"[AMP Nielsensdk Event] : Ad End\");\n    if ((adVO != null ? adVO.type : void 0) === \"midroll\") {\n      this.nielsensdkSDK.ggPM(\"15\", this.generateNielsenVO());\n      this.facade.logger.log(\"[AMP Nielsensdk Event] : Video Resume\");\n    }\n  };\n\n  /** Media Started\n  */\n  NielsensdkProxy.prototype.start = function(adVO) {\n    if (adVO == null) {\n      adVO = null;\n    }\n    if ((adVO != null ? adVO.type : void 0) === \"midroll\") {\n      this.nielsensdkSDK.ggPM(\"15\", this.generateNielsenVO(adVO, 'resume'));\n      this.facade.logger.log(\"[AMP Nielsensdk Event] : Content Resume\");\n    } else {\n      this.nielsensdkSDK.ggPM(\"15\", this.generateNielsenVO(null, 'started'));\n      this.facade.logger.log(\"[AMP Nielsensdk Event] : Content Play\");\n    }\n  };\n\n  /** Media Ended\n  */\n  NielsensdkProxy.prototype.end = function() {\n    var currentTime;\n    currentTime = this.facade.player.getCurrentTime().toFixed(1);\n    this.nielsensdkSDK.ggPM(\"57\", currentTime);\n    this.facade.logger.log(\"[AMP Nielsensdk Event] : Video Ended\");\n    this.cur_position = 0;\n  };\n\n  /** Time update\n  */\n  NielsensdkProxy.prototype.timeupdate = function() {\n    if (this.isLive) {\n      this.nielsensdkSDK.ggPM(\"49\", Math.floor(Date.now() / 1000));\n      this.facade.logger.log(\"[AMP nielsensdk Event] : timeupdate Live\");\n    } else {\n      this.cur_position = this.facade.player.getCurrentTime().toFixed(1);\n      if (Math.abs(this.timer - this.cur_position) > this.queryInterval) {\n        this.timer = this.cur_position;\n        this.nielsensdkSDK.ggPM(\"49\", this.cur_position);\n        this.facade.logger.log(\"[AMP Nielsensdk Event] : timeupdate\", this.cur_position);\n      }\n    }\n  };\n\n  /**\n   * The NielsensdkStartCommand class.\n   *\n   * @constructor\n   * @private\n   * @extends {puremvc.SimpleCommand}\n  */\n  function NielsensdkStartCommand() {\n    NielsensdkStartCommand.__super__.constructor.call(this);\n  }\n\n\n  __extends(NielsensdkStartCommand, puremvc.SimpleCommand);\n\n\n  /**\n   * Executes the command.\n   *\n   * @param {puremvc.Notification} notification\n   *    The notification.\n   *\n   * @override\n  */\n  NielsensdkStartCommand.prototype.execute = function(notification) {\n    var nielsensdk;\n    nielsensdk = this.facade.retrieveProxy(NielsensdkProxy.NAME);\n    nielsensdk.start();\n  };\n\n  /**\n   * The NielsensdkAdStartCommand class.\n   *\n   * @constructor\n   * @private\n   * @extends {puremvc.SimpleCommand}\n  */\n  function NielsensdkAdStartCommand() {\n    NielsensdkAdStartCommand.__super__.constructor.call(this);\n  }\n\n\n  __extends(NielsensdkAdStartCommand, puremvc.SimpleCommand);\n\n\n  /**\n   * Executes the command.\n   *\n   * @param {puremvc.Notification} notification\n   *    The notification.\n   *\n   * @override\n  */\n  NielsensdkAdStartCommand.prototype.execute = function(notification) {\n    var nielsensdk;\n    nielsensdk = this.facade.retrieveProxy(NielsensdkProxy.NAME);\n    nielsensdk.adStart(notification.body);\n  };\n\n  /**\n   * The NielsensdkAdEndCommand class.\n   *\n   * @constructor\n   * @private\n   * @extends {puremvc.SimpleCommand}\n  */\n  function NielsensdkAdEndCommand() {\n    NielsensdkAdEndCommand.__super__.constructor.call(this);\n  }\n\n\n  __extends(NielsensdkAdEndCommand, puremvc.SimpleCommand);\n\n\n  /**\n   * Executes the command.\n   *\n   * @param {puremvc.Notification} notification\n   *    The notification.\n   *\n   * @override\n  */\n  NielsensdkAdEndCommand.prototype.execute = function(notification) {\n    var nielsensdk;\n    nielsensdk = this.facade.retrieveProxy(NielsensdkProxy.NAME);\n    nielsensdk.adEnd(notification.body);\n  };\n\n  /**\n   * The NielsensdkEndCommand class.\n   *\n   * @constructor\n   * @private\n   * @extends {puremvc.SimpleCommand}\n  */\n  function NielsensdkEndCommand() {\n    NielsensdkEndCommand.__super__.constructor.call(this);\n  }\n\n\n  __extends(NielsensdkEndCommand, puremvc.SimpleCommand);\n\n\n  /**\n   * Executes the command.\n   *\n   * @param {puremvc.Notification} notification\n   *    The notification.\n   *\n   * @override\n  */\n  NielsensdkEndCommand.prototype.execute = function(notification) {\n    var nielsensdk;\n    nielsensdk = this.facade.retrieveProxy(NielsensdkProxy.NAME);\n    nielsensdk.end();\n  };\n\n  /**\n   * The NielsensdkMetaloadCommand class.\n   *\n   * @constructor\n   * @private\n   * @extends {puremvc.SimpleCommand}\n  */\n  function NielsensdkMetaloadCommand() {\n    NielsensdkMetaloadCommand.__super__.constructor.call(this);\n  }\n\n\n  __extends(NielsensdkMetaloadCommand, puremvc.SimpleCommand);\n\n\n  /**\n   * Executes the command.\n   *\n   * @param {puremvc.Notification} notification\n   *    The notification.\n   *\n   * @override\n  */\n  NielsensdkMetaloadCommand.prototype.execute = function(notification) {\n    var nielsensdk;\n    nielsensdk = this.facade.retrieveProxy(NielsensdkProxy.NAME);\n    nielsensdk.metaLoad();\n  };\n\n  /**\n   * The NielsensdkTimeupdateCommand class.\n   *\n   * @constructor\n   * @private\n   * @extends {puremvc.SimpleCommand}\n  */\n  function NielsensdkTimeupdateCommand() {\n    NielsensdkTimeupdateCommand.__super__.constructor.call(this);\n  }\n\n\n  __extends(NielsensdkTimeupdateCommand, puremvc.SimpleCommand);\n\n\n  /**\n   * Executes the command.\n   *\n   * @param {puremvc.Notification} notification\n   *    The notification.\n   *\n   * @override\n  */\n  NielsensdkTimeupdateCommand.prototype.execute = function(notification) {\n    var nielsensdk;\n    nielsensdk = this.facade.retrieveProxy(NielsensdkProxy.NAME);\n    nielsensdk.timeupdate();\n  };\n\n  /**\n   * The NielsenPlugin class.\n   *\n   * @param {Module}  app     The parent module of this plugin.\n   * @constructor\n   * @private\n   * @extends {Plugin}\n  */\n  function NielsenPlugin() {\n    NielsenPlugin.__super__.constructor.call(this);\n  }\n\n\n  __extends(NielsenPlugin, Plugin);\n\n\n  NielsenPlugin.prototype.moduleName = \"nielsen\";\n\n  /** @override\n  */\n  NielsenPlugin.prototype.createController = function() {\n    var event, events, _i, _len, _ref, _ref1;\n    NielsenPlugin.__super__.createController.call(this);\n    events = (_ref = this.config) != null ? (_ref1 = _ref.events) != null ? _ref1.video : void 0 : void 0;\n    if (!(events != null)) {\n      return;\n    }\n    for (_i = 0, _len = events.length; _i < _len; _i++) {\n      event = events[_i];\n      if (event.type === \"started\") {\n        this.registerCommand(Notifications.STARTED, NielsenStartCommand);\n        this.registerCommand(Notifications.CONTENT_CHANGED, NielsenStartCommand);\n      }\n      if (event.type === \"ended\") {\n        this.registerCommand(Notifications.ENDED, NielsenEndCommand);\n        this.registerCommand(Notifications.CHANGE_CONTENT, NielsenEndCommand);\n      }\n    }\n  };\n\n  /** @override\n  */\n  NielsenPlugin.prototype.createModel = function() {\n    this.registerProxy(new NielsenProxy(this.config));\n  };\n\n  /** @override\n  */\n  NielsenPlugin.prototype.listNotificationInterests = function() {\n    return [Notifications.STARTED, Notifications.ENDED, Notifications.CONTENT_CHANGED, Notifications.CHANGE_CONTENT];\n  };\n\n\n  AMP.registerPlugin(\"nielsen\", \"html\", NielsenPlugin);\n  AMP.registerPlugin(\"nielsen\", \"flash\", NielsenWrapper);\n\n  function ComscoreStreamsenseWrapper() {\n    return ComscoreStreamsenseWrapper.__super__.constructor.apply(this, arguments);\n  }\n\n\n  __extends(ComscoreStreamsenseWrapper, PluginWrapper);\n\n\n  ComscoreStreamsenseWrapper.NAME = \"ComscoreStreamsenseWrapper\";\n\n  ComscoreStreamsenseWrapper.prototype.flashPlugins = [\n    {\n      id: \"ComscoreStreamSensePlugin\",\n      src: '#{paths.resources}plugins/ComscoreStreamSensePlugin.swf',\n      blocking: false,\n      host: \"akamai\",\n      main: \"ComscoreStreamSensePlugin\"\n    }\n  ];\n\n  /** @override\n  */\n  ComscoreStreamsenseWrapper.prototype.createXML = function(xml) {\n    var application, metrics, prop, props, vendor, _i, _len;\n    application = xml.firstChild;\n    metrics = xml.getElementsByTagName(\"metrics\")[0];\n    if (!(metrics != null)) {\n      metrics = xml.createElement(\"metrics\");\n      application.appendChild(metrics);\n    }\n    vendor = xml.createElement(\"vendor\");\n    vendor.setAttribute(\"id\", \"comscoreStreamSense\");\n    metrics.appendChild(vendor);\n    props = [\n      {\n        value: this.config.data.clientId,\n        key: \"C2\"\n      }, {\n        value: this.config.data.publisherSecret,\n        key: \"PUBLISHER_SECRET\"\n      }, {\n        value: this.config.data.appVersion,\n        key: \"APP_VERSION\"\n      }, {\n        value: this.config.data.metadata,\n        key: \"metadata\"\n      }\n    ];\n    for (_i = 0, _len = props.length; _i < _len; _i++) {\n      prop = props[_i];\n      if (prop.value != null) {\n        this.createProperty(xml, prop.key, prop.value, vendor);\n      }\n    }\n    return xml;\n  };\n\n  /**\n   * @constructor\n   * @private\n  */\n  function ComscoreStreamsenseProxy(config) {\n    ComscoreStreamsenseProxy.__super__.constructor.call(this, config);\n  }\n\n\n  __extends(ComscoreStreamsenseProxy, PluginProxy);\n\n\n  /** @static\n  */\n  ComscoreStreamsenseProxy.NAME = ModuleProxy.NAME;\n\n  ComscoreStreamsenseProxy.prototype.defaults = {\n    plugin: {\n      js: null\n    },\n    data: {\n      clientId: null,\n      publisherSecret: null,\n      appVersion: null,\n      metadata: null\n    }\n  };\n\n  ComscoreStreamsenseProxy.prototype.myStreamingTag = null;\n\n  ComscoreStreamsenseProxy.prototype.sdk = null;\n\n  /** Overrides\n  */\n  ComscoreStreamsenseProxy.prototype.getScript = function() {\n    return this.config.plugin.js;\n  };\n\n  /** Overrides\n  */\n  ComscoreStreamsenseProxy.prototype.initialize = function() {\n    ComscoreStreamsenseProxy.__super__.initialize.call(this);\n    this.sdk = akamai[\"amp\"].ns_;\n    if ((this.sdk != null) && this.myStreamingTag === null) {\n      this.myStreamingTag = new this.sdk.StreamingTag({\n        customerC2: this.value.data.clientId\n      });\n    }\n  };\n\n  ComscoreStreamsenseProxy.prototype.mediaChange = function() {\n    if (this.myStreamingTag != null) {\n      this.myStreamingTag.stop();\n    }\n    this.myStreamingTag = null;\n    this.myStreamingTag = new this.sdk.StreamingTag({\n      customerC2: this.value.data.clientId\n    });\n    this.facade.logger.log(\"[AMP ComscoreStreamsense Event] : Media Change, StreamTag ReInitialize\");\n  };\n\n  ComscoreStreamsenseProxy.prototype.adStart = function(adVO) {\n    if (adVO == null) {\n      adVO = null;\n    }\n    this.myStreamingTag.playVideoAdvertisement(this.getMetaData(true));\n    this.facade.logger.log(\"[AMP ComscoreStreamsense Event] : Ad Start\");\n  };\n\n  /** Media Started\n  */\n  ComscoreStreamsenseProxy.prototype.start = function(adVO) {\n    var _ref;\n    if (adVO == null) {\n      adVO = null;\n    }\n    if ((_ref = this.facade.player.ads) != null ? _ref.getInProgress() : void 0) {\n      return;\n    }\n    this.myStreamingTag.playVideoContentPart(this.getMetaData());\n    this.facade.logger.log(\"[AMP ComscoreStreamsense Event] : Content Play\");\n  };\n\n  /** Media Stop\n  */\n  ComscoreStreamsenseProxy.prototype.stop = function() {\n    this.myStreamingTag.stop();\n    this.facade.logger.log(\"[AMP ComscoreStreamsense Event] : Stop\");\n  };\n\n  /** Media Ended\n  */\n  ComscoreStreamsenseProxy.prototype.ended = function() {\n    this.myStreamingTag.stop();\n    this.facade.logger.log(\"[AMP ComscoreStreamsense Event] : End\");\n    this.myStreamingTag = null;\n    this.myStreamingTag = new this.sdk.StreamingTag({\n      customerC2: this.value.data.clientId\n    });\n  };\n\n  /** Get MetaData\n  */\n  ComscoreStreamsenseProxy.prototype.getMetaData = function(ads) {\n    var key, metadata, object, value;\n    if (ads == null) {\n      ads = false;\n    }\n    metadata = {};\n    object = ads ? this.value.data.metadata.ads : this.value.data.metadata.video;\n    for (key in object) {\n      value = object[key];\n      if (value !== \"null\") {\n        metadata[key] = value;\n      }\n    }\n    return metadata;\n  };\n\n  /**\n   * The ComscoreStreamsenseStartedCommand class.\n   *\n   * @constructor\n   * @private\n   * @extends {puremvc.SimpleCommand}\n  */\n  function ComscoreStreamsenseStartedCommand() {\n    ComscoreStreamsenseStartedCommand.__super__.constructor.call(this);\n  }\n\n\n  __extends(ComscoreStreamsenseStartedCommand, puremvc.SimpleCommand);\n\n\n  /**\n   * Executes the command.\n   *\n   * @param {puremvc.Notification} notification\n   *    The notification.\n   *\n   * @override\n  */\n  ComscoreStreamsenseStartedCommand.prototype.execute = function(notification) {\n    var comscoreProxy;\n    comscoreProxy = this.facade.retrieveProxy(ComscoreStreamsenseProxy.NAME);\n    comscoreProxy.start(notification.body);\n  };\n\n  /**\n   * The ComscoreStreamsenseAdStartedCommand class.\n   *\n   * @constructor\n   * @private\n   * @extends {puremvc.SimpleCommand}\n  */\n  function ComscoreStreamsenseAdStartedCommand() {\n    ComscoreStreamsenseAdStartedCommand.__super__.constructor.call(this);\n  }\n\n\n  __extends(ComscoreStreamsenseAdStartedCommand, puremvc.SimpleCommand);\n\n\n  /**\n   * Executes the command.\n   *\n   * @param {puremvc.Notification} notification\n   *    The notification.\n   *\n   * @override\n  */\n  ComscoreStreamsenseAdStartedCommand.prototype.execute = function(notification) {\n    var comscoreProxy;\n    comscoreProxy = this.facade.retrieveProxy(ComscoreStreamsenseProxy.NAME);\n    comscoreProxy.adStart(notification.body);\n  };\n\n  /**\n   * The ComscoreStreamsenseStopCommand class.\n   *\n   * @constructor\n   * @private\n   * @extends {puremvc.SimpleCommand}\n  */\n  function ComscoreStreamsenseStopCommand() {\n    ComscoreStreamsenseStopCommand.__super__.constructor.call(this);\n  }\n\n\n  __extends(ComscoreStreamsenseStopCommand, puremvc.SimpleCommand);\n\n\n  /**\n   * Executes the command.\n   *\n   * @param {puremvc.Notification} notification\n   *    The notification.\n   *\n   * @override\n  */\n  ComscoreStreamsenseStopCommand.prototype.execute = function(notification) {\n    var comscoreProxy;\n    comscoreProxy = this.facade.retrieveProxy(ComscoreStreamsenseProxy.NAME);\n    comscoreProxy.stop(notification.body);\n  };\n\n  /**\n   * The ComscoreStreamsenseAdErrorCommand class.\n   *\n   * @constructor\n   * @private\n   * @extends {puremvc.SimpleCommand}\n  */\n  function ComscoreStreamsenseAdErrorCommand() {\n    ComscoreStreamsenseAdErrorCommand.__super__.constructor.call(this);\n  }\n\n\n  __extends(ComscoreStreamsenseAdErrorCommand, puremvc.SimpleCommand);\n\n\n  /**\n   * Executes the command.\n   *\n   * @param {puremvc.Notification} notification\n   *    The notification.\n   *\n   * @override\n  */\n  ComscoreStreamsenseAdErrorCommand.prototype.execute = function(notification) {\n    var comscoreProxy;\n    comscoreProxy = this.facade.retrieveProxy(ComscoreStreamsenseProxy.NAME);\n    comscoreProxy.adStart(notification.body);\n    comscoreProxy.stop(notification.body);\n  };\n\n  /**\n   * The ComscoreStreamsenseChangeMediaCommand class.\n   *\n   * @constructor\n   * @private\n   * @extends {puremvc.SimpleCommand}\n  */\n  function ComscoreStreamsenseChangeMediaCommand() {\n    ComscoreStreamsenseChangeMediaCommand.__super__.constructor.call(this);\n  }\n\n\n  __extends(ComscoreStreamsenseChangeMediaCommand, puremvc.SimpleCommand);\n\n\n  /**\n   * Executes the command.\n   *\n   * @param {puremvc.Notification} notification\n   *    The notification.\n   *\n   * @override\n  */\n  ComscoreStreamsenseChangeMediaCommand.prototype.execute = function(notification) {\n    var comscoreProxy;\n    comscoreProxy = this.facade.retrieveProxy(ComscoreStreamsenseProxy.NAME);\n    comscoreProxy.mediaChange();\n  };\n\n  /**\n   * The ComscoreStreamsenseEndedCommand class.\n   *\n   * @constructor\n   * @private\n   * @extends {puremvc.SimpleCommand}\n  */\n  function ComscoreStreamsenseEndedCommand() {\n    ComscoreStreamsenseEndedCommand.__super__.constructor.call(this);\n  }\n\n\n  __extends(ComscoreStreamsenseEndedCommand, puremvc.SimpleCommand);\n\n\n  /**\n   * Executes the command.\n   *\n   * @param {puremvc.Notification} notification\n   *    The notification.\n   *\n   * @override\n  */\n  ComscoreStreamsenseEndedCommand.prototype.execute = function(notification) {\n    var comscoreProxy;\n    comscoreProxy = this.facade.retrieveProxy(ComscoreStreamsenseProxy.NAME);\n    comscoreProxy.ended();\n  };\n\n  /**\n   * The NielsenPlugin class.\n   *\n   * @param {Module}  app     The parent module of this plugin.\n   * @constructor\n   * @private\n   * @extends {Plugin}\n  */\n  function NielsensdkPlugin() {\n    NielsensdkPlugin.__super__.constructor.call(this);\n  }\n\n\n  __extends(NielsensdkPlugin, Plugin);\n\n\n  NielsensdkPlugin.prototype.moduleName = \"nielsensdk\";\n\n  /** @override\n  */\n  NielsensdkPlugin.prototype.createModel = function() {\n    this.registerProxy(new NielsensdkProxy(this.config));\n  };\n\n  /** @override\n  */\n  NielsensdkPlugin.prototype.createController = function() {\n    NielsensdkPlugin.__super__.createController.call(this);\n    this.registerCommand(AdNotifications.BREAK_END, NielsensdkAdEndCommand);\n    this.registerCommand(AdNotifications.AD_STARTED, NielsensdkAdStartCommand);\n    this.registerCommand(Notifications.STARTED, NielsensdkStartCommand);\n    this.registerCommand(Notifications.ENDED, NielsensdkEndCommand);\n    this.registerCommand(Notifications.TIME_UPDATE, NielsensdkTimeupdateCommand);\n    this.registerCommand(AdNotifications.AD_TIME_REMAINING, NielsensdkTimeupdateCommand);\n  };\n\n  /** @override\n  */\n  NielsensdkPlugin.prototype.listNotificationInterests = function() {\n    return [AdNotifications.AD_STARTED, AdNotifications.BREAK_END, Notifications.STARTED, Notifications.ENDED, Notifications.LOADED_METADATA, Notifications.TIME_UPDATE, Notifications.CONTENT_CHANGED, Notifications.CHANGE_CONTENT, AdNotifications.AD_TIME_REMAINING];\n  };\n\n\n  AMP.registerPlugin(\"nielsensdk\", \"html\", NielsensdkPlugin);\n  AMP.registerPlugin(\"nielsensdk\", \"flash\", NielsensdkWrapper);\n\n  /**\n   * @constructor\n   * @private\n  */\n  function ComscoreProxy(config) {\n    ComscoreProxy.__super__.constructor.call(this, config);\n  }\n\n\n  __extends(ComscoreProxy, DataBoundConfigurationProxy);\n\n\n  ComscoreProxy.prototype.configurationName = \"comscore\";\n\n  /** @static\n  */\n  ComscoreProxy.NAME = ModuleProxy.NAME;\n\n  ComscoreProxy.prototype.defaults = {\n    url: \"http://b.scorecardresearch.com/b\",\n    events: {\n      ads: null,\n      video: null\n    },\n    data: {\n      c1: null,\n      c2: null,\n      c3: null,\n      c4: null,\n      c5: null,\n      c6: null,\n      c7: null,\n      c8: null,\n      c9: null,\n      c10: null,\n      c14: null\n    }\n  };\n\n  /**\n   *\n  */\n  ComscoreProxy.prototype.adStart = function() {\n    var url;\n    url = this.constructURL(\"ads\", \"started\");\n    Utils.beacon(url);\n  };\n\n  /**\n   *\n  */\n  ComscoreProxy.prototype.videoStart = function() {\n    var url;\n    url = this.constructURL(\"video\", \"started\");\n    Utils.beacon(url);\n  };\n\n  /**\n   *\n  */\n  ComscoreProxy.prototype.constructURL = function(target, type) {\n    var data, event, events, item, key, query, url, value, _i, _len, _ref, _ref1, _ref2;\n    data = {};\n    events = (_ref = this.value.events) != null ? _ref[target] : void 0;\n    if (events != null) {\n      for (_i = 0, _len = events.length; _i < _len; _i++) {\n        item = events[_i];\n        if (item.type === type) {\n          event = item;\n        }\n      }\n    }\n    _ref1 = this.value.data;\n    for (key in _ref1) {\n      value = _ref1[key];\n      data[key] = (event != null ? (_ref2 = event.data) != null ? _ref2[key] : void 0 : void 0) || value;\n    }\n    if (data.c7 == null) {\n      data.c7 = document.location.href.substr(0, 512);\n    }\n    if (data.c8 == null) {\n      data.c8 = document.referrer.substr(0, 512);\n    }\n    if (data.c9 == null) {\n      data.c9 = document.title;\n    }\n    if (data.cv == null) {\n      data.cv = \"2.0\";\n    }\n    data.rn = Date.now();\n    url = this.value.url;\n    query = [];\n    for (key in data) {\n      value = data[key];\n      if ((value != null) && value !== \"\") {\n        query.push(key + \"=\" + escape(value));\n      }\n    }\n    if (query.length > 0) {\n      url += \"?\" + query.join(\"&\");\n    }\n    return url.substr(0, 2080);\n  };\n\n  function ComscoreWrapper() {\n    return ComscoreWrapper.__super__.constructor.apply(this, arguments);\n  }\n\n\n  __extends(ComscoreWrapper, PluginWrapper);\n\n\n  ComscoreWrapper.NAME = \"ComscoreWrapper\";\n\n  ComscoreWrapper.prototype.flashPlugins = [\n    {\n      id: \"ComscorePlugin\",\n      src: '#{paths.resources}plugins/ComscorePlugin.swf',\n      blocking: false,\n      host: \"akamai\",\n      main: \"ComscorePlugin\",\n      type: \"application/x-shockwave-flash\"\n    }\n  ];\n\n  /** @override\n  */\n  ComscoreWrapper.prototype.createXML = function(xml) {\n    var application, element, event, events, map, metrics, node, prop, props, text, type, vendor, _i, _j, _len, _len1, _ref, _ref1, _ref2;\n    application = xml.firstChild;\n    metrics = xml.getElementsByTagName(\"metrics\")[0];\n    if (!(metrics != null)) {\n      metrics = xml.createElement(\"metrics\");\n      application.appendChild(metrics);\n    }\n    vendor = xml.createElement(\"vendor\");\n    vendor.setAttribute(\"id\", \"comscore\");\n    metrics.appendChild(vendor);\n    map = {\n      ads: {\n        started: \"adStart\",\n        ended: \"adComplete\"\n      },\n      video: {\n        started: \"videoStart\",\n        ended: \"videoComplete\"\n      }\n    };\n    props = [\n      {\n        value: \"c1\",\n        key: \"COMSCORE_CSC1\"\n      }, {\n        value: \"c2\",\n        key: \"COMSCORE_CSC2\"\n      }, {\n        value: \"c3\",\n        key: \"COMSCORE_CSC3\"\n      }, {\n        value: \"c4\",\n        key: \"COMSCORE_CSC4\"\n      }, {\n        value: \"c5\",\n        key: \"COMSCORE_CSC5\"\n      }, {\n        value: \"c6\",\n        key: \"COMSCORE_CSC6\"\n      }, {\n        value: \"c7\",\n        key: \"COMSCORE_CSC7\"\n      }, {\n        value: \"c8\",\n        key: \"COMSCORE_CSC8\"\n      }, {\n        value: \"c9\",\n        key: \"COMSCORE_CSC9\"\n      }, {\n        value: \"c10\",\n        key: \"COMSCORE_CSC10\"\n      }, {\n        value: \"c11\",\n        key: \"COMSCORE_CSC14\"\n      }\n    ];\n    _ref = this.config.events;\n    for (type in _ref) {\n      events = _ref[type];\n      if ((events != null) && events.length > 0) {\n        for (_i = 0, _len = events.length; _i < _len; _i++) {\n          event = events[_i];\n          node = xml.createElement(\"property\");\n          node.setAttribute(\"key\", map[type][event.type]);\n          vendor.appendChild(node);\n          element = xml.createElement(\"property\");\n          element.setAttribute(\"key\", \"COMSCORE_CSURL\");\n          text = XMLUtils.createTextContent(xml, this.config.url);\n          element.appendChild(text);\n          node.appendChild(element);\n          for (_j = 0, _len1 = props.length; _j < _len1; _j++) {\n            prop = props[_j];\n            text = ((_ref1 = event.data) != null ? _ref1[prop.value] : void 0) || ((_ref2 = this.config.data) != null ? _ref2[prop.value] : void 0);\n            if ((text != null) && text !== \"\") {\n              element = xml.createElement(\"property\");\n              element.setAttribute(\"key\", prop.key);\n              text = XMLUtils.createTextContent(xml, text);\n              element.appendChild(text);\n              node.appendChild(element);\n            }\n          }\n        }\n      }\n    }\n    return xml;\n  };\n\n  /**\n   * The ComscoreAdStartCommand class.\n   *\n   * @constructor\n   * @private\n   * @extends {puremvc.SimpleCommand}\n  */\n  function ComscoreAdStartCommand() {\n    ComscoreAdStartCommand.__super__.constructor.call(this);\n  }\n\n\n  __extends(ComscoreAdStartCommand, puremvc.SimpleCommand);\n\n\n  /**\n   * Executes the command.\n   *\n   * @param {puremvc.Notification} notification\n   *    The notification.\n   *\n   * @override\n  */\n  ComscoreAdStartCommand.prototype.execute = function(notification) {\n    var comscore;\n    comscore = this.facade.retrieveProxy(ComscoreProxy.NAME);\n    comscore.adStart();\n  };\n\n  /**\n   * The ComscoreStartCommand class.\n   *\n   * @constructor\n   * @private\n   * @extends {puremvc.SimpleCommand}\n  */\n  function ComscoreStartCommand() {\n    ComscoreStartCommand.__super__.constructor.call(this);\n  }\n\n\n  __extends(ComscoreStartCommand, puremvc.SimpleCommand);\n\n\n  /**\n   * Executes the command.\n   *\n   * @param {puremvc.Notification} notification\n   *    The notification.\n   *\n   * @override\n  */\n  ComscoreStartCommand.prototype.execute = function(notification) {\n    var comscore;\n    comscore = this.facade.retrieveProxy(ComscoreProxy.NAME);\n    comscore.videoStart();\n  };\n\n  /**\n   * The ComscoreStreamsensePlugin class.\n   *\n   * @param {Module}  app     The parent module of this plugin.\n   * @constructor\n   * @private\n   * @extends {Plugin}\n  */\n  function ComscoreStreamsensePlugin() {\n    ComscoreStreamsensePlugin.__super__.constructor.call(this);\n  }\n\n\n  __extends(ComscoreStreamsensePlugin, Plugin);\n\n\n  ComscoreStreamsensePlugin.prototype.moduleName = \"comscorestreamsense\";\n\n  /** @override\n  */\n  ComscoreStreamsensePlugin.prototype.createModel = function() {\n    this.registerProxy(new ComscoreStreamsenseProxy(this.config));\n  };\n\n  /** @override\n  */\n  ComscoreStreamsensePlugin.prototype.createController = function() {\n    ComscoreStreamsensePlugin.__super__.createController.call(this);\n    this.registerCommand(Notifications.MEDIA_CHANGE, ComscoreStreamsenseChangeMediaCommand);\n    this.registerCommand(AdNotifications.AD_STARTED, ComscoreStreamsenseAdStartedCommand);\n    this.registerCommand(AdNotifications.AD_ENDED, ComscoreStreamsenseStopCommand);\n    this.registerCommand(AdNotifications.SKIPPED, ComscoreStreamsenseStopCommand);\n    this.registerCommand(AdNotifications.AD_ERROR, ComscoreStreamsenseAdErrorCommand);\n    this.registerCommand(Notifications.PLAYING, ComscoreStreamsenseStartedCommand);\n    this.registerCommand(Notifications.PAUSED, ComscoreStreamsenseStopCommand);\n    this.registerCommand(Notifications.ENDED, ComscoreStreamsenseEndedCommand);\n  };\n\n  /** @override\n  */\n  ComscoreStreamsensePlugin.prototype.listNotificationInterests = function() {\n    return [Notifications.MEDIA_CHANGE, AdNotifications.AD_STARTED, AdNotifications.AD_ENDED, AdNotifications.AD_ERROR, AdNotifications.SKIPPED, Notifications.ENDED, Notifications.PAUSED, Notifications.PLAYING];\n  };\n\n\n  AMP.registerPlugin(\"comscorestreamsense\", \"html\", ComscoreStreamsensePlugin);\n  AMP.registerPlugin(\"comscorestreamsense\", \"flash\", ComscoreStreamsenseWrapper);\n\n  /**\n   * @constructor\n   * @private\n   * @extends {PluginWrapper}\n  */\n  function OmnitureWrapper(player, config) {\n    if (config.heartbeat.enabled === true || config.useJS === true) {\n      this.createXML = function() {};\n      this.flashPlugins = [];\n      this.plugin = new OmniturePlugin();\n      this.plugin.oninitialized = player.registerModule.bind(player, this.plugin);\n      this.plugin.initialize(config, player);\n    }\n    OmnitureWrapper.__super__.constructor.call(this, player, config);\n  }\n\n\n  __extends(OmnitureWrapper, PluginWrapper);\n\n\n  OmnitureWrapper.NAME = \"OmnitureWrapper\";\n\n  OmnitureWrapper.prototype.flashPlugins = [\n    {\n      id: \"OmniturePlugin\",\n      src: '#{paths.resources}plugins/OmniturePlugin.swf',\n      blocking: false,\n      host: \"akamai\",\n      main: \"OmniturePlugin\"\n    }\n  ];\n\n  /** @override\n  */\n  OmnitureWrapper.prototype.createXML = function(xml) {\n    var application, contextData, contextDataMapping, event, events, intervalProp, intervalReached, intervals, key, linkTracking, linkTrackingData, media, metrics, milestone, milestones, prop, property, props, trackMilestone, trackMilestones, type, value, vendor, _i, _j, _k, _l, _len, _len1, _len2, _len3, _len4, _len5, _len6, _m, _n, _o, _ref, _ref1, _ref2;\n    if (this.config.useJS === true) {\n      return;\n    }\n    application = xml.firstChild;\n    metrics = xml.getElementsByTagName(\"metrics\")[0];\n    if (!(metrics != null)) {\n      metrics = xml.createElement(\"metrics\");\n      application.appendChild(metrics);\n    }\n    vendor = xml.createElement(\"vendor\");\n    vendor.setAttribute(\"id\", \"omniture\");\n    metrics.appendChild(vendor);\n    props = [\n      {\n        value: this.config.channel,\n        key: \"OMNITURE_CHANNEL\"\n      }, {\n        value: this.config.account,\n        key: \"OMNITURE_ACCOUNT\"\n      }, {\n        value: this.config.debugTracking,\n        key: \"OMNITURE_DEBUG_TRACKING\"\n      }, {\n        value: this.config.trackLocal,\n        key: \"OMNITURE_TRACK_LOCAL\"\n      }, {\n        value: this.config.visitorNamespace,\n        key: \"OMNITURE_VISITOR_NAMESPACE\"\n      }, {\n        value: this.config.trackingServer,\n        key: \"OMNITURE_TRACKING_SERVER\"\n      }, {\n        value: this.config.trackingServerSecure,\n        key: \"OMNITURE_TRACKING_SERVER_SECURE\"\n      }, {\n        value: this.config.currencyCode,\n        key: \"OMNITURE_CURRENCY_CODE\"\n      }, {\n        value: this.config.trackWhilePlaying,\n        key: \"OMNITURE_TRACK_WHILE_PLAYING\"\n      }, {\n        value: this.config.trackMediaMethods,\n        key: \"OMNITURE_TRACK_MEDIA_METHODS\"\n      }, {\n        value: this.config.mediaName,\n        key: \"OMNITURE_MEDIA_NAME\"\n      }, {\n        value: this.config.playerName,\n        key: \"OMNITURE_PLAYER_NAME\"\n      }\n    ];\n    for (_i = 0, _len = props.length; _i < _len; _i++) {\n      prop = props[_i];\n      if (prop.value != null) {\n        this.createProperty(xml, prop.key, prop.value, vendor);\n      }\n    }\n    media = this.config.Media;\n    if (media != null) {\n      props = [\n        {\n          value: media.autoTrack,\n          key: \"OMNITURE_AUTO_TRACK\"\n        }, {\n          value: media.segmentByMilestones,\n          key: \"OMNITURE_SEGMENT_MILESTONES\"\n        }, {\n          value: media.trackVars,\n          key: \"OMNITURE_TRACKVARS\"\n        }, {\n          value: media.trackEvents,\n          key: \"OMNITURE_TRACKEVENTS\"\n        }, {\n          value: media.trackUsingContextData,\n          key: \"OMNITURE_TRACK_CONTEXT_DATA\"\n        }, {\n          value: media.trackSecondIntervals,\n          key: \"OMNITURE_TRACKSECOND_INTERVALS\"\n        }\n      ];\n      for (_j = 0, _len1 = props.length; _j < _len1; _j++) {\n        prop = props[_j];\n        if (prop.value != null) {\n          this.createProperty(xml, prop.key, prop.value, vendor);\n        }\n      }\n      if (media.trackMilestones != null) {\n        trackMilestones = this.createProperty(xml, \"OMNITURE_TRACK_MILESTONES\", null, vendor);\n        milestones = media.trackMilestones;\n        for (_k = 0, _len2 = milestones.length; _k < _len2; _k++) {\n          milestone = milestones[_k];\n          trackMilestone = this.createProperty(xml, milestone.percent, null, trackMilestones);\n          for (key in milestone) {\n            value = milestone[key];\n            if (key !== \"percent\") {\n              this.createProperty(xml, key, value, trackMilestone);\n            }\n          }\n        }\n      }\n      contextDataMapping = media.contextDataMapping;\n      if (contextDataMapping != null) {\n        contextData = this.createProperty(xml, \"OMNITURE_CONTEXT_DATA\", null, vendor);\n        for (key in contextDataMapping) {\n          value = contextDataMapping[key];\n          if (typeof value === \"string\") {\n            this.createProperty(xml, key, value, contextData);\n          }\n          if (value instanceof Array) {\n            property = this.createProperty(xml, key, null, contextData);\n            for (_l = 0, _len3 = value.length; _l < _len3; _l++) {\n              milestone = value[_l];\n              this.createProperty(xml, milestone.percent, milestone.events, property);\n            }\n          }\n        }\n      }\n    }\n    linkTracking = this.config.customLinkTracking;\n    if (linkTracking != null) {\n      linkTrackingData = this.createProperty(xml, \"OMNITURE_CUSTOM_LINK_TRACKING\", null, vendor);\n      for (key in linkTracking) {\n        if (key === \"intervalReached\") {\n          intervalReached = this.createProperty(xml, key, null, linkTrackingData);\n          _ref = linkTracking[key];\n          for (_m = 0, _len4 = _ref.length; _m < _len4; _m++) {\n            intervals = _ref[_m];\n            intervalProp = this.createProperty(xml, intervals.interval, null, intervalReached);\n            for (key in intervals) {\n              if (key !== \"interval\") {\n                this.createProperty(xml, key, intervals[key], intervalProp);\n              }\n            }\n          }\n        } else {\n          this.createProperty(xml, key, linkTracking[key], linkTrackingData);\n        }\n      }\n    }\n    events = (_ref1 = this.config.events) != null ? _ref1.video : void 0;\n    if (events != null) {\n      for (_n = 0, _len5 = events.length; _n < _len5; _n++) {\n        event = events[_n];\n        switch (event.type) {\n          case \"started\":\n            type = \"videoStart\";\n            break;\n          case \"ended\":\n            type = \"videoComplete\";\n            break;\n          case \"play\":\n            type = \"videoResume\";\n            break;\n          case \"pause\":\n            type = \"videoPause\";\n            break;\n          default:\n            type = event.type;\n        }\n        this.createProperty(xml, type, event.data, vendor);\n      }\n    }\n    events = (_ref2 = this.config.events) != null ? _ref2.ads : void 0;\n    if (events != null) {\n      for (_o = 0, _len6 = events.length; _o < _len6; _o++) {\n        event = events[_o];\n        type = event.type === \"started\" ? 'adStart' : event.type === \"ended\" ? 'adComplete' : event.type;\n        this.createProperty(xml, type, event.data, vendor);\n      }\n    }\n  };\n\n  /**\n   * The OmnitureProxy class.\n   *\n   * @param {Object} config\n   * @constructor\n   * @private\n   * @extends {PluginProxy}\n  */\n  function OmnitureProxy(config) {\n    OmnitureProxy.__super__.constructor.call(this, config);\n  }\n\n\n  __extends(OmnitureProxy, PluginProxy);\n\n\n  /** @static\n  */\n  OmnitureProxy.NAME = ModuleProxy.NAME;\n\n  OmnitureProxy.prototype.defaults = {\n    main: \"s\",\n    heartbeat: null,\n    account: null,\n    playerName: null,\n    mediaName: null,\n    trackingServer: null,\n    visitorNamespace: null,\n    visitor: null,\n    visitorID: null,\n    pageName: null\n  };\n\n  OmnitureProxy.prototype.media = null;\n\n  OmnitureProxy.prototype.started = false;\n\n  OmnitureProxy.prototype.ad = null;\n\n  OmnitureProxy.prototype.adCurrentTime = null;\n\n  OmnitureProxy.prototype.adStarted = false;\n\n  OmnitureProxy.prototype.adsEnabled = false;\n\n  OmnitureProxy.prototype.getMediaName = function() {\n    return this.getConfigurationData().mediaName || this.media.getTitle();\n  };\n\n  OmnitureProxy.prototype.getPlayerName = function() {\n    var _ref;\n    return this.getConfigurationData().playerName || ((_ref = this.facade.player.retrieveProxy(ConfigurationProxy.NAME)) != null ? _ref.getName() : void 0) || this.facade.player.config.name || \"amp\";\n  };\n\n  OmnitureProxy.prototype.getPlaybackCore = function() {\n    var _ref;\n    return ((_ref = this.facade.player.retrieveProxy(PlayerProxy.NAME)) != null ? _ref.getActivePlaybackCore() : void 0) || this.facade.player.playback;\n  };\n\n  /**\n  */\n  OmnitureProxy.prototype.initialize = function() {\n    var _ref, _ref1;\n    OmnitureProxy.__super__.initialize.call(this);\n    this.media = this.facade.player.retrieveProxy(MediaProxy.NAME);\n    this.adsEnabled = (_ref = this.facade.player.ads) != null ? _ref.getEnabled() : void 0;\n    if (this.plugin != null) {\n      try {\n        if (!(this.plugin.Media != null)) {\n          this.plugin.loadModule(\"Media\");\n        }\n      } catch (error) {\n        this.error(\"initialize\", error);\n      }\n      if (!(((_ref1 = this.plugin.Media) != null ? _ref1.openAd : void 0) != null)) {\n        this.adStart = this.adEnded = this.adPlay = this.adPause = this.adCurrentTime = function() {};\n      }\n    }\n  };\n\n  /**\n  */\n  OmnitureProxy.prototype.createPlugin = function() {\n    return window[this.getConfigurationData().main];\n  };\n\n  /**\n  */\n  OmnitureProxy.prototype.mediaChange = function() {\n    var _ref;\n    this.started = false;\n    this.adsEnabled = (_ref = this.facade.player.ads) != null ? _ref.getEnabled() : void 0;\n  };\n\n  /**\n  */\n  OmnitureProxy.prototype.start = function() {\n    if (this.started === true) {\n      return;\n    }\n    try {\n      this.started = true;\n      this.plugin.Media.open(this.getMediaName(), this.media.getDuration(), this.getPlayerName());\n    } catch (error) {\n      this.error(error);\n    }\n    if (this.adsEnabled !== true) {\n      this.play();\n    }\n  };\n\n  /**\n  */\n  OmnitureProxy.prototype.play = function() {\n    if (this.started !== true) {\n      this.start();\n      return;\n    }\n    if (this.adStarted === true) {\n      return;\n    }\n    try {\n      this.plugin.Media.play(this.getMediaName(), this.getPlaybackCore().getCurrentTime() || 0);\n    } catch (error) {\n      this.error(error);\n    }\n  };\n\n  /**\n  */\n  OmnitureProxy.prototype.pause = function() {\n    if (this.adStarted === true) {\n      return;\n    }\n    try {\n      this.plugin.Media.stop(this.getMediaName(), this.getPlaybackCore().getCurrentTime());\n    } catch (error) {\n      this.error(error);\n    }\n  };\n\n  /**\n  */\n  OmnitureProxy.prototype.seeking = function() {\n    try {\n      this.plugin.Media.stop(this.getMediaName(), this.getPlaybackCore().getCurrentTime());\n    } catch (error) {\n      this.error(error);\n    }\n  };\n\n  /**\n  */\n  OmnitureProxy.prototype.seeked = function() {\n    try {\n      this.plugin.Media.play(this.getMediaName(), this.getPlaybackCore().getCurrentTime());\n    } catch (error) {\n      this.error(error);\n    }\n  };\n\n  /**\n  */\n  OmnitureProxy.prototype.ended = function() {\n    try {\n      this.plugin.Media.stop(this.getMediaName(), this.getPlaybackCore().getCurrentTime());\n      this.plugin.Media.close(this.getMediaName());\n      this.started = false;\n    } catch (error) {\n      this.error(error);\n    }\n  };\n\n  /** Pluging.\n  */\n  OmnitureProxy.prototype.getAd = function() {\n    return this.ad;\n  };\n\n  OmnitureProxy.prototype.setAd = function(value) {\n    this.adStarted = false;\n    this.adCurrentTime = 0;\n    return this.ad = value;\n  };\n\n  /**\n  */\n  OmnitureProxy.prototype.adStart = function() {\n    try {\n      this.adStarted = true;\n      this.plugin.Media.openAd(this.ad.title, this.ad.duration, this.getPlayerName(), this.getMediaName(), this.ad.type, this.ad.position, this.ad.cpm);\n      this.adPlay();\n    } catch (error) {\n      this.error(\"ad start\", error);\n    }\n  };\n\n  /**\n  */\n  OmnitureProxy.prototype.adPlay = function() {\n    if (this.adStarted !== true) {\n      this.adStart();\n    }\n    try {\n      this.plugin.Media.play(this.ad.title, this.adCurrentTime || 0);\n    } catch (error) {\n      this.error(\"ad play\", error);\n    }\n  };\n\n  /**\n  */\n  OmnitureProxy.prototype.adPause = function() {\n    try {\n      this.plugin.Media.stop(this.ad.title, this.adCurrentTime);\n    } catch (error) {\n      this.error(\"ad pause\", error);\n    }\n  };\n\n  /**\n  */\n  OmnitureProxy.prototype.adCurrentTime = function(value) {\n    this.adCurrentTime = value;\n  };\n\n  /**\n  */\n  OmnitureProxy.prototype.adEnded = function() {\n    if (this.adStarted === false) {\n      return;\n    }\n    try {\n      this.adStarted = false;\n      this.plugin.Media.stop(this.ad.title, this.ad.duration);\n      this.plugin.Media.close(this.ad.title);\n    } catch (error) {\n      this.error(\"ad end\", error);\n    }\n    this.play();\n  };\n\n  /**\n   * The HeartbeatProxy class.\n   *\n   * @param {Object} config\n   * @constructor\n   * @private\n   * @extends {PluginProxy}\n  */\n  function HeartbeatProxy(config) {\n    HeartbeatProxy.__super__.constructor.call(this, config);\n  }\n\n\n  __extends(HeartbeatProxy, OmnitureProxy);\n\n\n  /** @static\n  */\n  HeartbeatProxy.NAME = ModuleProxy.NAME;\n\n  HeartbeatProxy.prototype.aaPlugin = null;\n\n  HeartbeatProxy.prototype.playerPlugin = null;\n\n  HeartbeatProxy.prototype.heartbeat = null;\n\n  HeartbeatProxy.prototype.resumed = false;\n\n  HeartbeatProxy.prototype.liveLinear = null;\n\n  /**\n  */\n  HeartbeatProxy.prototype.initialize = function() {\n    var ahPlugin, appMeasurement, config, delegate, pluginConfig, plugins, visitor,\n      _this = this;\n    HeartbeatProxy.__super__.initialize.call(this);\n    config = this.getConfigurationData();\n    if (config.heartbeat.liveLinear != null) {\n      this.calculateLiveLinear();\n    }\n    if (typeof Visitor !== \"undefined\" && Visitor !== null) {\n      visitor = new Visitor(config.visitor.marketingCloudOrgId);\n      visitor.trackingServer = config.visitor.trackingServer;\n    }\n    appMeasurement = new AppMeasurement();\n    appMeasurement.account = config.account;\n    appMeasurement.trackingServer = config.trackingServer;\n    appMeasurement.visitor = visitor;\n    appMeasurement.pageName = config.pageName;\n    appMeasurement.charSet = \"UTF-8\";\n    appMeasurement.visitorID = config.visitorID;\n    delegate = this.createDelegate();\n    this.playerPlugin = new ADB.va.plugins.videoplayer.VideoPlayerPlugin(delegate);\n    pluginConfig = new ADB.va.plugins.videoplayer.VideoPlayerPluginConfig();\n    pluginConfig.debugLogging = this.facade.logger.enabled;\n    this.playerPlugin.configure(pluginConfig);\n    delegate = new ADB.va.plugins.aa.AdobeAnalyticsPluginDelegate();\n    delegate.onError = function(errorInfo) {\n      _this.facade.logger.error(\"AdobeAnalyticsPlugin error: \" + errorInfo.getMessage() + \" | \" + errorInfo.getDetails());\n    };\n    this.aaPlugin = new ADB.va.plugins.aa.AdobeAnalyticsPlugin(appMeasurement, delegate);\n    pluginConfig = new ADB.va.plugins.aa.AdobeAnalyticsPluginConfig();\n    pluginConfig.channel = config.heartbeat.channel;\n    pluginConfig.debugLogging = this.facade.logger.enabled;\n    this.aaPlugin.configure(pluginConfig);\n    delegate = new ADB.va.plugins.ah.AdobeHeartbeatPluginDelegate();\n    delegate.onError = function(errorInfo) {\n      _this.facade.logger.error(\"AdobeHeartbeatPlugin error: \" + errorInfo.getMessage() + \" | \" + errorInfo.getDetails());\n    };\n    ahPlugin = new ADB.va.plugins.ah.AdobeHeartbeatPlugin(delegate);\n    pluginConfig = new ADB.va.plugins.ah.AdobeHeartbeatPluginConfig(config.heartbeat.trackingServer, config.heartbeat.publisher);\n    pluginConfig.ovp = config.heartbeat.ovp;\n    pluginConfig.sdk = config.heartbeat.sdk;\n    pluginConfig.ssl = config.heartbeat.ssl === true;\n    pluginConfig.debugLogging = this.facade.logger.enabled;\n    ahPlugin.configure(pluginConfig);\n    plugins = [this.playerPlugin, this.aaPlugin, ahPlugin];\n    delegate = new ADB.va.HeartbeatDelegate();\n    delegate.onError = function(errorInfo) {\n      _this.facade.logger.error(\"Heartbeat error: \" + errorInfo.getMessage() + \" | \" + errorInfo.getDetails());\n    };\n    this.heartbeat = new ADB.va.Heartbeat(delegate, plugins);\n    pluginConfig = new ADB.va.HeartbeatConfig();\n    pluginConfig.debugLogging = this.facade.logger.enabled;\n    this.heartbeat.configure(pluginConfig);\n  };\n\n  /**\n  */\n  HeartbeatProxy.prototype.calculateLiveLinear = function() {\n    var liveLinear, start,\n      _this = this;\n    if (this.liveLinear == null) {\n      this.liveLinear = {};\n    }\n    if (this.liveLinear.updating === true) {\n      return;\n    }\n    this.liveLinear.updating = true;\n    liveLinear = {\n      updating: false\n    };\n    start = Date.now();\n    Utils.getUTC(function(utc) {\n      var date, day, end, timezone;\n      end = Date.now();\n      date = new Date(utc);\n      day = date.toJSON().replace(/([^T]+T).+/, \"$1\");\n      timezone = _this.getConfigurationData().heartbeat.liveLinear.timezone || \"Z\";\n      liveLinear.utc = utc;\n      date = new Date(start + ((end - start) / 2));\n      liveLinear.client = date.getTime();\n      liveLinear.offset = liveLinear.client - utc;\n      date = new Date(day + \"00:00:00.000\" + timezone);\n      liveLinear.start = date.getTime();\n      date = new Date(day + \"23:59:59.999\" + timezone);\n      liveLinear.end = date.getTime();\n      liveLinear.duration = Math.round((liveLinear.end - liveLinear.start) / 1000);\n      _this.liveLinear = liveLinear;\n    });\n  };\n\n  /**\n  */\n  HeartbeatProxy.prototype.calculateLiveLinearTime = function() {\n    var now, time;\n    now = Date.now() - this.liveLinear.offset;\n    time = Math.round((now - this.liveLinear.start) / 1000);\n    if (time > this.liveLinear.duration) {\n      time = time - this.liveLinear.duration;\n      this.calculateLiveLinear();\n    }\n    return time;\n  };\n\n  /**\n  */\n  HeartbeatProxy.prototype.createDelegate = function() {\n    var delegate,\n      _this = this;\n    delegate = new ADB.va.plugins.videoplayer.VideoPlayerPluginDelegate();\n    delegate.getVideoInfo = function() {\n      var config, playbackCore, time, videoInfo;\n      playbackCore = _this.getPlaybackCore();\n      videoInfo = new ADB.va.plugins.videoplayer.VideoInfo();\n      videoInfo.id = _this.media.getGUID() || _this.media.getTitle();\n      videoInfo.playerName = _this.getPlayerName();\n      videoInfo.name = _this.getMediaName();\n      videoInfo.resumed = _this.resumed;\n      config = _this.getConfigurationData().heartbeat;\n      if (config.liveLinear.enabled === true) {\n        videoInfo.length = _this.liveLinear.duration;\n        videoInfo.streamType = ADB.va.plugins.videoplayer.AssetType.ASSET_TYPE_LIVE;\n        videoInfo.playhead = _this.calculateLiveLinearTime();\n      } else if (_this.media.getTemporalType() === \"live\") {\n        videoInfo.length = -1;\n        videoInfo.streamType = ADB.va.plugins.videoplayer.AssetType.ASSET_TYPE_LIVE;\n        videoInfo.playhead = 0;\n      } else {\n        videoInfo.length = _this.media.getDuration();\n        videoInfo.streamType = ADB.va.plugins.videoplayer.AssetType.ASSET_TYPE_VOD;\n        time = playbackCore != null ? typeof playbackCore.getCurrentTime === \"function\" ? playbackCore.getCurrentTime() : void 0 : void 0;\n        videoInfo.playhead = !(time != null) || isNaN(time) ? 0 : time;\n      }\n      return videoInfo;\n    };\n    delegate.getAdInfo = function() {\n      var adInfo, duration;\n      adInfo = new ADB.va.plugins.videoplayer.AdInfo();\n      if (!(_this.ad != null)) {\n        return null;\n      }\n      adInfo.id = _this.ad.id;\n      duration = _this.ad.duration;\n      adInfo.length = isNaN(duration) || duration === 0 ? -1 : duration;\n      adInfo.position = _this.ad.position;\n      adInfo.name = _this.ad.title;\n      return adInfo;\n    };\n    delegate.getAdBreakInfo = function() {\n      var adBreakInfo;\n      adBreakInfo = new ADB.va.plugins.videoplayer.AdBreakInfo();\n      if (!(_this.ad != null)) {\n        return null;\n      }\n      adBreakInfo.name = _this.ad.type;\n      adBreakInfo.position = _this.ad.position;\n      adBreakInfo.playerName = _this.getPlayerName();\n      adBreakInfo.startTime = _this.getPlaybackCore().getCurrentTime();\n      return adBreakInfo;\n    };\n    delegate.getChapterInfo = function() {\n      var chapterInfo, currentScene;\n      currentScene = _this.media.getScene(_this.getPlaybackCore().getCurrentTime());\n      if (!(currentScene != null)) {\n        return null;\n      }\n      chapterInfo = new ADB.va.plugins.videoplayer.ChapterInfo();\n      chapterInfo.name = currentScene.title;\n      chapterInfo.length = currentScene.end - currentScene.start;\n      chapterInfo.position = currentScene.position;\n      chapterInfo.startTime = currentScene.start;\n      return chapterInfo;\n    };\n    delegate.onError = function(error) {\n      _this.facade.logger.error(\"Heartbeat Error:\", error);\n    };\n    delegate.getQoSInfo = function() {\n      var qosInfo;\n      qosInfo = new ADB.va.plugins.videoplayer.QoSInfo();\n      return null;\n    };\n    return delegate;\n  };\n\n  /**\n  */\n  HeartbeatProxy.prototype.mediaChange = function() {\n    var metadata, _ref;\n    HeartbeatProxy.__super__.mediaChange.call(this);\n    this.resumed = false;\n    metadata = (_ref = this.getValue(\"heartbeat\").metadata) != null ? _ref.video : void 0;\n    if (metadata != null) {\n      this.aaPlugin.setVideoMetadata(metadata);\n    }\n  };\n\n  /**\n  */\n  HeartbeatProxy.prototype.start = function() {\n    if (this.started === true) {\n      return;\n    }\n    try {\n      this.playerPlugin.trackVideoLoad();\n      this.started = true;\n    } catch (error) {\n      this.error(error);\n    }\n    this.play();\n  };\n\n  /**\n  */\n  HeartbeatProxy.prototype.play = function() {\n    if (this.started !== true) {\n      this.start();\n    }\n    try {\n      this.playerPlugin.trackPlay();\n    } catch (error) {\n      this.error(error);\n    }\n  };\n\n  /**\n  */\n  HeartbeatProxy.prototype.pause = function() {\n    try {\n      this.playerPlugin.trackPause();\n      this.resumed = true;\n    } catch (error) {\n      this.error(error);\n    }\n  };\n\n  /**\n  */\n  HeartbeatProxy.prototype.seeking = function() {\n    try {\n      this.playerPlugin.trackSeekStart();\n    } catch (error) {\n      this.error(error);\n    }\n  };\n\n  /**\n  */\n  HeartbeatProxy.prototype.seeked = function() {\n    try {\n      this.playerPlugin.trackSeekComplete();\n    } catch (error) {\n      this.error(error);\n    }\n  };\n\n  /**\n  */\n  HeartbeatProxy.prototype.ended = function() {\n    try {\n      this.playerPlugin.trackComplete();\n      this.playerPlugin.trackVideoUnload();\n      this.started = false;\n      this.aaPlugin.setVideoMetadata(null);\n    } catch (error) {\n      this.error(error);\n    }\n  };\n\n  /**\n  */\n  HeartbeatProxy.prototype.adStart = function() {\n    var metadata, _ref;\n    if (this.started !== true) {\n      metadata = (_ref = this.getValue(\"heartbeat\").metadata) != null ? _ref.ad : void 0;\n      if (metadata != null) {\n        this.aaPlugin.setAdMetadata(metadata);\n      }\n      this.start();\n      setTimeout(this.adStart.bind(this), 0);\n      return;\n    }\n    try {\n      this.playerPlugin.trackAdStart();\n    } catch (error) {\n      this.error(error);\n    }\n  };\n\n  /**\n  */\n  HeartbeatProxy.prototype.adEnded = function() {\n    try {\n      this.playerPlugin.trackAdComplete();\n      this.aaPlugin.setAdMetadata(null);\n    } catch (error) {\n      this.error(error);\n    }\n  };\n\n  HeartbeatProxy.prototype.adPlay = function() {};\n\n  HeartbeatProxy.prototype.adPause = function() {};\n\n  /**\n   * The OmnitureStartCommand class.\n   *\n   * @constructor\n   * @private\n   * @extends {PluginCommand}\n  */\n  function OmnitureStartCommand() {\n    OmnitureStartCommand.__super__.constructor.call(this);\n  }\n\n\n  __extends(OmnitureStartCommand, PluginCommand);\n\n\n  /**\n   * Executes the command.\n   *\n   * @param {puremvc.Notification} notification\n   *    The notification.\n   *\n   * @override\n  */\n  OmnitureStartCommand.prototype.execute = function(notification) {\n    this.proxy.start();\n  };\n\n  /**\n   * The OmniturePlayCommand class.\n   *\n   * @constructor\n   * @private\n   * @extends {PluginCommand}\n  */\n  function OmniturePlayCommand() {\n    OmniturePlayCommand.__super__.constructor.call(this);\n  }\n\n\n  __extends(OmniturePlayCommand, PluginCommand);\n\n\n  /**\n   * Executes the command.\n   *\n   * @param {puremvc.Notification} notification\n   *    The notification.\n   *\n   * @override\n  */\n  OmniturePlayCommand.prototype.execute = function(notification) {\n    this.proxy.play();\n  };\n\n  /**\n   * The OmniturePauseCommand class.\n   *\n   * @constructor\n   * @private\n   * @extends {PluginCommand}\n  */\n  function OmniturePauseCommand() {\n    OmniturePauseCommand.__super__.constructor.call(this);\n  }\n\n\n  __extends(OmniturePauseCommand, PluginCommand);\n\n\n  /**\n   * Executes the command.\n   *\n   * @param {puremvc.Notification} notification\n   *    The notification.\n   *\n   * @override\n  */\n  OmniturePauseCommand.prototype.execute = function(notification) {\n    this.proxy.pause();\n  };\n\n  /**\n   * The OmnitureSeekingCommand class.\n   *\n   * @constructor\n   * @private\n   * @extends {PluginCommand}\n  */\n  function OmnitureSeekingCommand() {\n    OmnitureSeekingCommand.__super__.constructor.call(this);\n  }\n\n\n  __extends(OmnitureSeekingCommand, PluginCommand);\n\n\n  /**\n   * Executes the command.\n   *\n   * @param {puremvc.Notification} notification\n   *    The notification.\n   *\n   * @override\n  */\n  OmnitureSeekingCommand.prototype.execute = function(notification) {\n    this.proxy.seeking();\n  };\n\n  /**\n   * The OmnitureSeekedCommand class.\n   *\n   * @constructor\n   * @private\n   * @extends {PluginCommand}\n  */\n  function OmnitureSeekedCommand() {\n    OmnitureSeekedCommand.__super__.constructor.call(this);\n  }\n\n\n  __extends(OmnitureSeekedCommand, PluginCommand);\n\n\n  /**\n   * Executes the command.\n   *\n   * @param {puremvc.Notification} notification\n   *    The notification.\n   *\n   * @override\n  */\n  OmnitureSeekedCommand.prototype.execute = function(notification) {\n    this.proxy.seeked();\n  };\n\n  /**\n   * The OmnitureEndedCommand class.\n   *\n   * @constructor\n   * @private\n   * @extends {PluginCommand}\n  */\n  function OmnitureEndedCommand() {\n    OmnitureEndedCommand.__super__.constructor.call(this);\n  }\n\n\n  __extends(OmnitureEndedCommand, PluginCommand);\n\n\n  /**\n   * Executes the command.\n   *\n   * @param {puremvc.Notification} notification\n   *    The notification.\n   *\n   * @override\n  */\n  OmnitureEndedCommand.prototype.execute = function(notification) {\n    this.proxy.ended();\n  };\n\n  /**\n   * The OmnitureChangeMediaCommand class.\n   *\n   * @constructor\n   * @private\n   * @extends {PluginCommand}\n  */\n  function OmnitureContentChangedCommand() {\n    OmnitureContentChangedCommand.__super__.constructor.call(this);\n  }\n\n\n  __extends(OmnitureContentChangedCommand, PluginCommand);\n\n\n  /**\n   * Executes the command.\n   *\n   * @param {puremvc.Notification} notification\n   *    The notification.\n   *\n   * @override\n  */\n  OmnitureContentChangedCommand.prototype.execute = function(notification) {\n    this.proxy.setMedia(notification.getBody());\n    this.proxy.start();\n  };\n\n  /**\n   * The OmnitureAdLoadedCommand class.\n   *\n   * @constructor\n   * @private\n   * @extends {PluginCommand}\n  */\n  function OmnitureAdLoadedCommand() {\n    OmnitureAdLoadedCommand.__super__.constructor.call(this);\n  }\n\n\n  __extends(OmnitureAdLoadedCommand, PluginCommand);\n\n\n  /**\n   * Executes the command.\n   *\n   * @param {puremvc.Notification} notification\n   *    The notification.\n   *\n   * @override\n  */\n  OmnitureAdLoadedCommand.prototype.execute = function(notification) {\n    this.proxy.setAd(notification.getBody());\n  };\n\n  /**\n   * The OmnitureAdStartedCommand class.\n   *\n   * @constructor\n   * @private\n   * @extends {PluginCommand}\n  */\n  function OmnitureAdStartedCommand() {\n    OmnitureAdStartedCommand.__super__.constructor.call(this);\n  }\n\n\n  __extends(OmnitureAdStartedCommand, PluginCommand);\n\n\n  /**\n   * Executes the command.\n   *\n   * @param {puremvc.Notification} notification\n   *    The notification.\n   *\n   * @override\n  */\n  OmnitureAdStartedCommand.prototype.execute = function(notification) {\n    this.proxy.adStart();\n  };\n\n  /**\n   * The OmnitureAdPlayCommand class.\n   *\n   * @constructor\n   * @private\n   * @extends {PluginCommand}\n  */\n  function OmnitureAdPlayCommand() {\n    OmnitureAdPlayCommand.__super__.constructor.call(this);\n  }\n\n\n  __extends(OmnitureAdPlayCommand, PluginCommand);\n\n\n  /**\n   * Executes the command.\n   *\n   * @param {puremvc.Notification} notification\n   *    The notification.\n   *\n   * @override\n  */\n  OmnitureAdPlayCommand.prototype.execute = function(notification) {\n    this.proxy.adPlay();\n  };\n\n  /**\n   * The OmnitureAdPauseCommand class.\n   *\n   * @constructor\n   * @private\n   * @extends {PluginCommand}\n  */\n  function OmnitureAdPauseCommand() {\n    OmnitureAdPauseCommand.__super__.constructor.call(this);\n  }\n\n\n  __extends(OmnitureAdPauseCommand, PluginCommand);\n\n\n  /**\n   * Executes the command.\n   *\n   * @param {puremvc.Notification} notification\n   *    The notification.\n   *\n   * @override\n  */\n  OmnitureAdPauseCommand.prototype.execute = function(notification) {\n    this.proxy.adPause();\n  };\n\n  /**\n   * The OmnitureAdBreakEndCommand class.\n   *\n   * @constructor\n   * @private\n   * @extends {PluginCommand}\n  */\n  function OmnitureAdBreakEndCommand() {\n    OmnitureAdBreakEndCommand.__super__.constructor.call(this);\n  }\n\n\n  __extends(OmnitureAdBreakEndCommand, PluginCommand);\n\n\n  /**\n   * Executes the command.\n   *\n   * @param {puremvc.Notification} notification\n   *    The notification.\n   *\n   * @override\n  */\n  OmnitureAdBreakEndCommand.prototype.execute = function(notification) {\n    this.proxy.adEnded();\n    this.proxy.setAd(null);\n  };\n\n  /**\n   * The OmnitureAdTimeRemainingCommand class.\n   *\n   * @constructor\n   * @private\n   * @extends {PluginCommand}\n  */\n  function OmnitureAdTimeUpdateCommand() {\n    OmnitureAdTimeUpdateCommand.__super__.constructor.call(this);\n  }\n\n\n  __extends(OmnitureAdTimeUpdateCommand, PluginCommand);\n\n\n  /**\n   * Executes the command.\n   *\n   * @param {puremvc.Notification} notification\n   *    The notification.\n   *\n   * @override\n  */\n  OmnitureAdTimeUpdateCommand.prototype.execute = function(notification) {\n    this.proxy.adCurrentTime(notification.getBody());\n  };\n\n  /**\n   * The OmnitureMediaChangeCommand class.\n   *\n   * @constructor\n   * @private\n   * @extends {PluginCommand}\n  */\n  function OmnitureMediaChangeCommand() {\n    OmnitureMediaChangeCommand.__super__.constructor.call(this);\n  }\n\n\n  __extends(OmnitureMediaChangeCommand, PluginCommand);\n\n\n  /**\n   * Executes the command.\n   *\n   * @param {puremvc.Notification} notification\n   *    The notification.\n   *\n   * @override\n  */\n  OmnitureMediaChangeCommand.prototype.execute = function(notification) {\n    this.proxy.mediaChange();\n  };\n\n  /**\n   * The CaptionCue class.\n   *\n   * @constructor\n   * @private\n   * @param {number} startTime  The start time of the cue in seconds\n   * @param {number} endTime    The end time of the cue in seconds\n   * @param {number} text       The text of the cue\n  */\n  function CaptionCue(startTime, endTime, id) {\n    this.startTime = startTime;\n    this.endTime = endTime;\n    this.id = id;\n  }\n\n  CaptionCue.prototype.id = null;\n\n  CaptionCue.prototype.startTime = null;\n\n  CaptionCue.prototype.endTime = null;\n\n  CaptionCue.prototype.text = null;\n\n  CaptionCue.prototype.html = null;\n\n  CaptionCue.prototype.align = null;\n\n  /**\n   * The ComscorePlugin class.\n   *\n   * @param {Module}  app     The parent module of this plugin.\n   * @constructor\n   * @private\n   * @extends {Plugin}\n  */\n  function ComscorePlugin() {\n    ComscorePlugin.__super__.constructor.call(this);\n  }\n\n\n  __extends(ComscorePlugin, Plugin);\n\n\n  ComscorePlugin.prototype.moduleName = \"comscore\";\n\n  /** @override\n  */\n  ComscorePlugin.prototype.createController = function() {\n    ComscorePlugin.__super__.createController.call(this);\n    this.registerCommand(Notifications.STARTED, ComscoreStartCommand);\n    this.registerCommand(Notifications.CONTENT_CHANGED, ComscoreStartCommand);\n    this.registerCommand(AdNotifications.AD_STARTED, ComscoreAdStartCommand);\n  };\n\n  /** @override\n  */\n  ComscorePlugin.prototype.createModel = function() {\n    this.registerProxy(new ComscoreProxy(this.config));\n  };\n\n  /** @override\n  */\n  ComscorePlugin.prototype.listNotificationInterests = function() {\n    return [Notifications.STARTED, AdNotifications.AD_STARTED, Notifications.CONTENT_CHANGED];\n  };\n\n\n  AMP.registerPlugin(\"comscore\", \"html\", ComscorePlugin);\n  AMP.registerPlugin(\"comscore\", \"flash\", ComscoreWrapper);\n\n  function SRTParser() {}\n\n  /**\n   * Parses a SRT (subrip) file into CaptionCue objects and attaches them to a given track.\n   *\n   * @param   {CaptionTrack}  track The caption track to populate\n   * @param   {String}        txt   The text of the srt file\n   * @return  {CaptionTrack}        The populated caption track\n  */\n  SRTParser.prototype.parse = function(track, txt) {\n    var caption, captions, cue, end, index, parts, start, text, times, _i, _len;\n    txt = txt.replace(/\\r/g, '');\n    captions = txt.split(\"\\n\\n\");\n    for (_i = 0, _len = captions.length; _i < _len; _i++) {\n      caption = captions[_i];\n      parts = caption.split(\"\\n\");\n      try {\n        index = parts[0];\n        times = parts[1].match(/([0-9:\\,]+)\\s*-->\\s*([0-9:\\,]+)/).slice(1);\n        start = Utils.flattenTimecode(times[0]);\n        end = Utils.flattenTimecode(times[1]);\n        text = parts.slice(2);\n      } catch (err) {\n        Logger.warn(\"SRT Parsing Warning\");\n      }\n      cue = new CaptionCue(start, end, \"cue_\" + index);\n      cue.html = \"<p>\" + text.join(\"<br />\") + \"</p>\";\n      cue.text = text.join(\"\\n\");\n      track.cues.push(cue);\n    }\n    return track;\n  };\n\n  function WebVTTParser() {}\n\n  /**\n   * Parses a SRT (subrip) file into CaptionCue objects and attaches them to a given track.\n   *\n   * @param   {CaptionTrack}  track The caption track to populate\n   * @param   {String}        txt   The text of the srt file\n   * @return  {CaptionTrack}        The populated caption track\n  */\n  WebVTTParser.prototype.parse = function(track, txt) {\n    var caption, captions, cue, end, index, parts, settings, start, text, times, _i, _len;\n    txt = txt.replace(/\\r/g, '');\n    captions = txt.split(\"\\n\\n\");\n    index = 0;\n    if (/^WEBVTT/.test(captions[0])) {\n      captions.shift();\n    }\n    for (_i = 0, _len = captions.length; _i < _len; _i++) {\n      caption = captions[_i];\n      if (!(caption !== \"\")) {\n        continue;\n      }\n      parts = caption.split(\"\\n\");\n      try {\n        index = /^[0-9]+$/.test(parts[0]) ? parts.shift() : ++index;\n        times = parts[0].match(/([0-9:\\.]+)\\s*-->\\s*([0-9:\\.]+)([^\\n]*)/).slice(1);\n        settings = times[2];\n        start = Utils.flattenTimecode(times[0]);\n        end = Utils.flattenTimecode(times[1]);\n        text = parts.slice(1);\n      } catch (err) {\n        Logger.error(\"WebVTT Parse Error\");\n      }\n      cue = new CaptionCue(start, end, \"cue_\" + index);\n      cue.html = \"<p>\" + text.join(\"<br />\") + \"</p>\";\n      cue.text = text.join(\"\\n\");\n      if (settings != null) {\n        settings.replace(/\\s*([A-Za-z]+)\\s*:\\s*([\\w\\-\\%]+)/g, function(match, $1, $2) {\n          cue[$1] = $2;\n          return \"\";\n        });\n      }\n      track.cues.push(cue);\n    }\n    return track;\n  };\n\n  function SMPTETTParser() {}\n\n  /**\n   * Parses a SMPTETT file into CaptionCue objects and attaches them to a given track.\n   *\n   * @param   {CaptionTrack}  track The caption track to populate\n   * @param   {XMLDocument}   xml   The SMPTETT xml document\n   * @return  {CaptionTrack}        The populated caption track\n  */\n  SMPTETTParser.prototype.parse = function(track, xml) {\n    var captions, lang, styledElements, styles, tt,\n      _this = this;\n    if (typeof xml === \"string\") {\n      xml = XMLUtils.parse(xml);\n    }\n    styles = Array.prototype.slice.call(xml.querySelectorAll(\"styling style\"));\n    styles.forEach(function(item, index, list) {\n      var attributes, id, style;\n      style = \"\";\n      id = item.getAttribute(\"id\") || item.getAttribute(\"xml:id\");\n      attributes = Array.prototype.slice.call(item.attributes);\n      attributes.forEach(function(item, index, array) {\n        if (item.prefix === \"tts\") {\n          return style += Utils.formatStyleName(item.localName) + \":\" + item.nodeValue + \";\";\n        }\n      });\n      track.styles[id] = style;\n    });\n    styledElements = Array.prototype.slice.call(xml.querySelectorAll(\"body [style]\"));\n    styledElements.forEach(function(item, index, array) {\n      var id;\n      id = item.getAttribute(\"style\");\n      item.setAttribute(\"style\", track.styles[id]);\n    });\n    tt = xml.querySelector(\"tt\");\n    lang = tt.getAttribute(\"lang\") || tt.getAttribute(\"xml:lang\");\n    if (track.language === void 0 || track.language === null) {\n      track.language = lang;\n    }\n    captions = Array.prototype.slice.call(xml.querySelectorAll(\"body p[begin]\"));\n    captions.forEach(function(item, index, array) {\n      var align, cue, end, start, text;\n      start = item.getAttribute(\"begin\");\n      item.removeAttribute(\"begin\");\n      if (item.getAttribute(\"end\") != null) {\n        end = item.getAttribute(\"end\");\n        item.removeAttribute(\"end\");\n      } else if (captions[index + 1] != null) {\n        end = captions[index + 1].getAttribute(\"begin\");\n      }\n      cue = new CaptionCue(Utils.flattenTimecode(start), Utils.flattenTimecode(end), \"cue_\" + index);\n      align = item.getAttributeNS(\"http://www.w3.org/ns/ttml#styling\", \"textAlign\");\n      if (align != null) {\n        cue.align = align === \"center\" ? \"middle\" : align;\n        item.removeAttributeNS(\"http://www.w3.org/ns/ttml#styling\", \"textAlign\");\n      }\n      text = XMLUtils.serialize(item);\n      text = text.replace(/\\s*xmlns=\"[^\"]*\"/, \"\");\n      cue.html = text;\n      text = text.replace(/^<p[^>]*>/, \"\");\n      text = text.replace(/<\\/p>$/, \"\");\n      text = text.replace(/<br\\/>/, \"\\n\");\n      text = text.replace(/<span style=\"([^\"]*)\"/, \"<c.$1\");\n      text = text.replace(/<\\/span>/, \"</c>\");\n      cue.text = text;\n      track.cues.push(cue);\n    });\n    return track;\n  };\n\n  /**\n   * @constructor\n   * @private\n  */\n  function LiveCaptionProxy() {\n    var com,\n      _this = this;\n    this.captions = [];\n    this.head = document.getElementsByTagName(\"head\")[0];\n    com = window.com || {};\n    com.akamai = com.akamai || {};\n    com.akamai.amp = com.akamai.amp || {};\n    com.akamai.amp.plugins = com.akamai.amp.plugins || {};\n    com.akamai.amp.plugins.subply = com.akamai.amp.plugins.subply || {};\n    com.akamai.amp.plugins.subply.response = function(json) {\n      _this.parse(json);\n      _this.poll();\n    };\n    if (!(window.com != null)) {\n      window.com = com;\n    }\n    LiveCaptionProxy.__super__.constructor.call(this, this.constructor.NAME);\n  }\n\n\n  __extends(LiveCaptionProxy, puremvc.Proxy);\n\n\n  /** @static\n  */\n  LiveCaptionProxy.NAME = \"LiveCaptionProxy\";\n\n  LiveCaptionProxy.prototype.data = {\n    base: \"http://test.plymedia.com.s3.amazonaws.com/online/Akamai_\",\n    interval: 1000\n  };\n\n  LiveCaptionProxy.prototype.caption = null;\n\n  LiveCaptionProxy.prototype.head = null;\n\n  LiveCaptionProxy.prototype.script = null;\n\n  LiveCaptionProxy.prototype.timeout = null;\n\n  /**\n   *\n  */\n  LiveCaptionProxy.prototype.getURL = function() {\n    return this.data.url;\n  };\n\n  LiveCaptionProxy.prototype.setURL = function(value) {\n    this.data.url = value;\n    return value;\n  };\n\n  LiveCaptionProxy.prototype.start = function() {\n    this.send();\n  };\n\n  LiveCaptionProxy.prototype.poll = function() {\n    var timeout,\n      _this = this;\n    timeout = setTimeout(function() {\n      _this.send();\n    }, this.data.interval || 1000);\n  };\n\n  LiveCaptionProxy.prototype.send = function() {\n    if (this.script != null) {\n      this.head.removeChild(this.script);\n    }\n    this.script = Utils.loadScript(this.data.base + this.data.url + \".js?nocache=\" + Date.now());\n  };\n\n  LiveCaptionProxy.prototype.stop = function() {\n    clearTimeout(timeout);\n  };\n\n  /**\n   *\n  */\n  LiveCaptionProxy.prototype.parse = function(response) {\n    var html, text, _i, _len, _ref;\n    if (response.Stream !== this.data.url) {\n      return;\n    }\n    if ((this.caption != null) && this.caption.id >= response.Ticks) {\n      return;\n    }\n    this.caption = new CaptionCue(Utils.flattenTimecode(response.From), Utils.flattenTimecode(response.To), response.Ticks);\n    this.caption.text = response.Text;\n    html = \"\";\n    _ref = response.Text.split(\"\\n\");\n    for (_i = 0, _len = _ref.length; _i < _len; _i++) {\n      text = _ref[_i];\n      if (html !== \"\") {\n        html += \"<br />\";\n      }\n      html += \"<span>\" + text + \"</span>\";\n    }\n    this.caption.html = \"<p>\" + html + \"</p>\";\n    this.sendNotification(CaptioningNotifications.CUE_CHANGE, [this.caption]);\n    return this.caption;\n  };\n\n  /**\n   * The CaptioningWrapper class.\n   *\n   * @constructor\n   * @private\n   * @extends {PluginWrapper}\n   * @param {FlashPlayer}     player  The FlashPlayer\n   * @param {Object}          config  The plugin config\n  */\n  function CaptioningWrapper(player, config) {\n    CaptioningWrapper.__super__.constructor.call(this, player, config);\n  }\n\n\n  __extends(CaptioningWrapper, PluginWrapper);\n\n\n  CaptioningWrapper.NAME = \"CaptioningWrapper\";\n\n  CaptioningWrapper.prototype.flashPlugins = [\n    {\n      id: \"AdobeCaptionPlugin\",\n      src: '#{paths.resources}plugins/AdobeCaptionPlugin.swf',\n      blocking: false,\n      host: \"akamai\",\n      main: \"AdobeCaptionPlugin\",\n      type: \"application/x-shockwave-flash\"\n    }, {\n      id: \"AMPCaptionPlugin\",\n      src: '#{paths.resources}plugins/AMPCaptionPlugin.swf',\n      blocking: false,\n      host: \"akamai\",\n      main: \"AMPCaptionPlugin\",\n      type: \"application/x-shockwave-flash\"\n    }, {\n      id: \"CaptionSettingsPlugin\",\n      src: '#{paths.resources}plugins/CaptionSettingsPlugin.swf',\n      blocking: false,\n      host: \"akamai\",\n      main: \"CaptionSettingsPlugin\",\n      type: \"application/x-shockwave-flash\"\n    }\n  ];\n\n  CaptioningWrapper.prototype.flashView = {\n    elements: {\n      captionDisplay: {\n        attributes: {\n          defaultMessage: \"Sorry! No captions available for this stream\",\n          initState: \"cookie\",\n          position: \"relative\",\n          settingsEnabled: \"true\",\n          style: \"bottom: 0px; windowColor :0x000000; windowOpacity: 0; font: Monospaced Serif; fontColor: 0xffffff; fontOpacity: 1; fontBGColor: 0x000000; fontBGOpacity: 0; edgeType: none; edgeColor: 0x000000; edgeOpacity: 1; scroll: Pop-Out; fontSize: 12;\"\n        }\n      },\n      controls: {\n        elements: {\n          captionBtn: {}\n        }\n      }\n    }\n  };\n\n  CaptioningWrapper.prototype.hidden = true;\n\n  /** @override\n  */\n  CaptioningWrapper.prototype.createXML = function(xml) {\n    var application, player, subply, _ref;\n    subply = (_ref = this.config.flash) != null ? _ref.subply : void 0;\n    if (subply != null) {\n      try {\n        if (subply.timeMethod != null) {\n          player = xml.getElementsByTagName(\"player\")[0];\n          player.setAttribute(\"subply_time_method\", subply.timeMethod);\n        }\n        if (subply.plugin != null) {\n          application = xml.firstChild;\n          subply = xml.getElementsByTagName(\"subply\")[0];\n          if (!(subply != null)) {\n            subply = xml.createElement(\"subply\");\n            application.appendChild(subply);\n          }\n          this.createProperty(xml, \"SUBPLY_URL\", this.config.flash.subply.plugin, subply);\n        }\n      } catch (error) {\n        this.facade.logger.error(\"[AMP CAPTIONING ERROR]\", error);\n      }\n    }\n  };\n\n  /** @override\n  */\n  CaptioningWrapper.prototype.createFlashVars = function(flashvars) {\n    var captionLangArr, captionUrlArr, config, track, _i, _len, _ref, _ref1;\n    config = this.player.config;\n    if (((_ref = config.media) != null ? _ref.track : void 0) != null) {\n      track = Utils.selectTrack(config.media.track, \"captions\");\n      if ((track.src != null) && track.src !== \"\") {\n        flashvars.caption_url = track.src;\n      }\n      if (config.media.track.length > 0) {\n        captionUrlArr = [];\n        captionLangArr = [];\n        _ref1 = config.media.track;\n        for (_i = 0, _len = _ref1.length; _i < _len; _i++) {\n          track = _ref1[_i];\n          captionUrlArr.push(track.src);\n          captionLangArr.push(track.srclang);\n        }\n        flashvars.caption_url = captionUrlArr.join(\",\");\n        flashvars.caption_language = captionLangArr.join(\",\");\n      }\n      flashvars.caption_type = track.type != null ? encodeURIComponent(track.type) : \"application/ttml+xml\";\n    }\n    if (flashvars.caption_language == null) {\n      flashvars.caption_language = \"en-us\";\n    }\n  };\n\n  /** @override\n  */\n  CaptioningWrapper.prototype.listNotificationInterests = function() {\n    return CaptioningWrapper.__super__.listNotificationInterests.apply(this, arguments).concat([Notifications.MEDIA_CHANGE, FlashNotifications.CAPTIONING_REQUEST, FlashNotifications.CAPTION_LANG_CHANGE, FlashNotifications.INITIALIZED]);\n  };\n\n  /**\n  */\n  CaptioningWrapper.prototype.handleNotification = function(notification) {\n    var body, media, name, track, type;\n    CaptioningWrapper.__super__.handleNotification.call(this, notification);\n    name = notification.getName();\n    body = notification.getBody();\n    switch (name) {\n      case FlashNotifications.CAPTION_LANG_CHANGE:\n        type = \"\";\n        break;\n      case FlashNotifications.CAPTIONING_REQUEST:\n        type = \"visibilitychange\";\n        body = body.enabled;\n        this.hidden = !body;\n        break;\n      case Notifications.MEDIA_CHANGE:\n        media = body;\n        if (media.track != null) {\n          track = Utils.selectTrack(media.track, \"captions\");\n          if (!(track != null)) {\n            return;\n          }\n          if ((track.src != null) && track.src !== \"\") {\n            media.captioningUrl = track.src;\n          }\n          if (track.type != null) {\n            media.captioningType = track.type || \"application/ttml+xml\";\n          }\n        }\n        break;\n      case FlashNotifications.INITIALIZED:\n        this.hidden = !this.player.getMediaElement().getPlayerProperty(\"isCaptionVisible\");\n    }\n    if ((type != null) && type !== \"\") {\n      this.dispatchEvent(new Event(type, body));\n    }\n  };\n\n  /**\n  */\n  CaptioningWrapper.prototype.getHidden = function() {\n    return this.hidden;\n  };\n\n  CaptioningWrapper.prototype.setHidden = function(value) {\n    this.hidden = value;\n    this.facade.getMediaElement().setPlayerProperty(\"captionDisplay\", {\n      visible: !value\n    });\n    return value;\n  };\n\n  /**\n   * Selects a caption track by its index in the getTracks array.\n   *\n   * @param {number}        index   The index to select\n   * @return {CaptionTrack}         The selected caption track.\n   * @expose\n  */\n  CaptioningWrapper.prototype.selectTrackByIndex = function(index) {};\n\n  /**\n   * Selects a caption track by it's language property.\n   *\n   * @param {string}        lang  The language to select\n   * @return {CaptionTrack}       The selected caption track.\n   * @expose\n  */\n  CaptioningWrapper.prototype.selectTrackByLanguage = function(lang) {\n    this.facade.getMediaElement().setTrackByLanguage(lang);\n  };\n\n  /**\n   * Sets a caption Settings Object (styles)\n   *\n   * @param {Object}  object  The caption settings object.\n   * @expose\n  */\n  CaptioningWrapper.prototype.changeSettings = function(object) {\n    if (((object != null ? object.fontFamily : void 0) != null) && typeof object.fontFamily === \"object\") {\n      return this.facade.getMediaElement().setPlayerProperty(\"captionSettingsUI\", object);\n    }\n    this.hidden = !object.visible;\n    this.facade.getMediaElement().setPlayerProperty(\"captionDisplay\", {\n      'visible': object.visible,\n      'style': this.parseObject(object)\n    });\n  };\n\n  /**\n   * Parse Object\n   *\n  */\n  CaptioningWrapper.prototype.parseObject = function(object) {\n    var flashObject, keyString, prop, _ref;\n    flashObject = {};\n    try {\n      for (prop in object) {\n        switch (prop) {\n          case \"fontFamily\":\n            flashObject['font'] = object[prop];\n            break;\n          case \"fontColor\":\n          case \"backgroundColor\":\n          case \"edgeColor\":\n          case \"windowColor\":\n            keyString = prop === \"fontColor\" ? \"font\" : prop === \"backgroundColor\" ? \"fontBG\" : prop === \"edgeColor\" ? \"edge\" : \"window\";\n            if (((_ref = object[prop]) != null ? _ref.indexOf('rgba') : void 0) !== -1) {\n              flashObject[keyString + 'Color'] = this.parseRGBA(object[prop]);\n              flashObject[keyString + 'Opacity'] = object[prop].replace(/^.*,(.+)\\)/, '$1');\n            }\n            break;\n          default:\n            flashObject[prop] = object[prop];\n        }\n      }\n      delete flashObject['visible'];\n    } catch (error) {\n      this.facade.logger.error('Captioning Settings Parse Error', error);\n    }\n    return flashObject;\n  };\n\n  CaptioningWrapper.prototype.parseRGBA = function(rgb) {\n    rgb = rgb.match(/^rgba?[\\s+]?\\([\\s+]?(\\d+)[\\s+]?,[\\s+]?(\\d+)[\\s+]?,[\\s+]?(\\d+)[\\s+]?/i);\n    if (rgb && rgb.length === 4) {\n      return \"0x\" + (\"0\" + parseInt(rgb[1], 10).toString(16)).slice(-2) + (\"0\" + parseInt(rgb[2], 10).toString(16)).slice(-2) + (\"0\" + parseInt(rgb[3], 10).toString(16)).slice(-2);\n    }\n    return \"\";\n  };\n\n\n  AMP.registerPlugin(\"captioning\", \"flash\", CaptioningWrapper);\n\n  /**\n   * The CaptioningTimeUpdateCommand class.\n   *\n   * @constructor\n   * @private\n   * @extends {amp.plugins.PluginCommand}\n  */\n  function CaptioningTimeUpdateCommand() {\n    CaptioningTimeUpdateCommand.__super__.constructor.call(this);\n  }\n\n\n  __extends(CaptioningTimeUpdateCommand, PluginCommand);\n\n\n  /**\n   * Executes the command.\n   *\n   * @param {puremvc.Notification} notification\n   *    The notification.\n   *\n   * @override\n  */\n  CaptioningTimeUpdateCommand.prototype.execute = function(notification) {\n    var active, changed, cue, cues, index, time, track, _i, _len;\n    time = notification.getBody();\n    track = this.proxy.getTrack();\n    if (!(track != null)) {\n      return;\n    }\n    active = track.activeCues;\n    cues = track.cues;\n    changed = false;\n    for (_i = 0, _len = cues.length; _i < _len; _i++) {\n      cue = cues[_i];\n      if (time >= cue.startTime && time < cue.endTime) {\n        if (!(__indexOf.call(active, cue) >= 0)) {\n          active.push(cue);\n          changed = true;\n        }\n      } else {\n        index = active.indexOf(cue);\n        if (index !== -1) {\n          active.splice(index, 1);\n          changed = true;\n        }\n      }\n    }\n    if (changed === true) {\n      this.sendNotification(CaptioningNotifications.CUE_CHANGE, active);\n    }\n  };\n\n  /**\n   * The CaptioningChangeMediaCommand class.\n   *\n   * @constructor\n   * @private\n   * @extends {amp.plugins.PluginCommand}\n  */\n  function CaptioningChangeMediaCommand() {\n    CaptioningChangeMediaCommand.__super__.constructor.call(this);\n  }\n\n\n  __extends(CaptioningChangeMediaCommand, PluginCommand);\n\n\n  /**\n   * Executes the command.\n   *\n   * @param {puremvc.Notification} notification\n   *    The notification.\n   *\n   * @override\n  */\n  CaptioningChangeMediaCommand.prototype.execute = function(notification) {\n    var media, track;\n    media = notification.getBody();\n    track = notification.getBody().track;\n    this.proxy.setTracks(track);\n    if (!(track != null)) {\n      this.sendNotification(CaptioningNotifications.ENABLED, false);\n      return;\n    }\n    this.proxy.selectRenderer(media);\n    this.sendNotification(CaptioningNotifications.ENABLED, true);\n  };\n\n  /**\n   * The ChangeVisibilityCommand class.\n   *\n   * @constructor\n   * @private\n   * @extends {amp.plugins.PluginEventCommand}\n  */\n  function CaptioningVisibilityChangeCommand() {\n    CaptioningVisibilityChangeCommand.__super__.constructor.call(this);\n  }\n\n\n  __extends(CaptioningVisibilityChangeCommand, PluginEventCommand);\n\n\n  /**\n   * Executes the command.\n   *\n   * @param {puremvc.Notification} notification\n   *    The notification.\n   *\n   * @override\n  */\n  CaptioningVisibilityChangeCommand.prototype.execute = function(notification) {\n    this.proxy.setHidden(!notification.getBody());\n    CaptioningVisibilityChangeCommand.__super__.execute.call(this, notification);\n  };\n\n  /**\n   * @enum {string}\n   * @const\n   * @private\n  */\n\n  var UserSettingsNotifications = {\n    SETTING_CHANGE: \"settingchange\",\n    UPDATE_SETTINGS: \"updatesettings\"\n  };\n\n  /**\n   * The CaptioningStartedCommand class.\n   *\n   * @constructor\n   * @private\n   * @extends {puremvc.SimpleCommand}\n  */\n  function CaptioningStartedCommand() {\n    CaptioningStartedCommand.__super__.constructor.call(this);\n  }\n\n\n  __extends(CaptioningStartedCommand, puremvc.SimpleCommand);\n\n\n  /**\n   * Executes the command.\n   *\n   * @param {puremvc.Notification} notification\n   *    The notification.\n   *\n   * @override\n  */\n  CaptioningStartedCommand.prototype.execute = function(notification) {\n    var proxy, track, _ref;\n    proxy = this.facade.retrieveProxy(CaptioningProxy.NAME);\n    track = proxy.getTrack();\n    if (!(track != null) && ((_ref = proxy.getTracks()) != null ? _ref.length : void 0) > 0) {\n      track = proxy.autoSelectTrack();\n    }\n    if ((track != null ? track.isLive : void 0) === true) {\n      this.facade.removeCommand(Notifications.TIME_UPDATE);\n      proxy = this.facade.retrieveProxy(LiveCaptionProxy.NAME);\n      if (!(proxy != null)) {\n        proxy = new LiveCaptionProxy();\n        this.facade.registerProxy(proxy);\n      }\n      proxy.setURL(track.src);\n      proxy.start();\n    }\n  };\n\n  /**\n   * @private\n  */\n\n  CaptionParsers = {\n    \"application/ttml+xml\": new SMPTETTParser(),\n    \"application/x-subrip\": new SRTParser(),\n    \"text/vtt\": new WebVTTParser(),\n    undefined: new SMPTETTParser()\n  };\n\n  /**\n   * @enum {string}\n   * @const\n   * @private\n  */\n\n  var CaptioningNotifications = {\n    VISIBILITY_CHANGE: \"captioningvisibilitychange\",\n    ENABLED: \"captioningenabled\",\n    TRACKS_LOADED: \"captioningtracksloaded\",\n    TRACK_SELECTED: \"captioningtrackselected\",\n    CUE_CHANGE: \"captioningcuechange\",\n    SETTINGS_VISIBILITY_CHANGE: \"captioningsettingsvisibility\",\n    TOGGLE_SETTINGS_VISIBILITY: \"togglesettingsvisibility\",\n    SETTINGS_CHANGE: \"captioningsettingschange\"\n  };\n\n  /**\n   * The CaptionTrack class.\n   *\n   * @constructor\n   * @private\n   * @param {?Object} track A generic track object.\n  */\n  function CaptionTrack(track, onload) {\n    var xhr,\n      _this = this;\n    this.kind = track.kind;\n    this.type = track.type;\n    this.src = track.src;\n    this.language = track.srclang;\n    this.label = track.label || this.srclang || this.kind;\n    this.cues = track.cues || [];\n    this.styles = track.styles || {};\n    this.activeCues = [];\n    this.isLive = /live-subply/.test(this.type);\n    if ((this.src != null) && this.src !== \"\" && !this.isLive) {\n      xhr = Utils.get(this.src, {\n        onload: function() {\n          try {\n            CaptionParsers[_this.type].parse(_this, xhr.response);\n          } catch (error) {\n            Logger.error(\"Could not parse caption track: \" + _this.src);\n            return;\n          }\n          if (typeof onload === \"function\") {\n            onload();\n          }\n        },\n        onerror: function() {\n          Logger.error(\"Could not load caption track: \" + _this.src);\n        }\n      });\n    } else {\n      setTimeout(onload, 1);\n    }\n  }\n\n  CaptionTrack.prototype.kind = null;\n\n  CaptionTrack.prototype.src = null;\n\n  CaptionTrack.prototype.language = null;\n\n  CaptionTrack.prototype.cues = null;\n\n  CaptionTrack.prototype.label = null;\n\n  CaptionTrack.prototype.activeCues = null;\n\n  CaptionTrack.prototype.type = null;\n\n  CaptionTrack.prototype.styles = null;\n\n  CaptionTrack.prototype.isLive = false;\n\n  /**\n   * PluginMediator class.\n   *\n   * @constructor\n   * @private\n   * @extends {OverlayMediator}\n  */\n  function PluginComponentMediator(componentName, componentType, parent, element) {\n    PluginComponentMediator.__super__.constructor.call(this, componentName, componentType, parent, element);\n  }\n\n\n  __extends(PluginComponentMediator, ComponentMediator);\n\n\n  /** @override\n  */\n  PluginComponentMediator.prototype.initializeNotifier = function(key) {\n    PluginComponentMediator.__super__.initializeNotifier.call(this, key);\n    this.plugin = this.facade.retrieveProxy(ModuleProxy.NAME);\n    this.media = this.facade.player.retrieveProxy(MediaProxy.NAME);\n  };\n\n  /**\n   * The CaptioningProxy class\n   *\n   * @constructor\n   * @private\n   * @extends {PluginProxy}\n   * @param   {Object}  config  The configuration object.\n  */\n  function CaptioningProxy(config) {\n    this.activeCaptions = [];\n    this.providers = {};\n    this.tracks = [];\n    this.rendererMap = [];\n    this.settings = {};\n    CaptioningProxy.__super__.constructor.call(this, config);\n  }\n\n\n  __extends(CaptioningProxy, PluginProxy);\n\n\n  /** @static\n  */\n  CaptioningProxy.NAME = ModuleProxy.NAME;\n\n  CaptioningProxy.TEXT_TRACK_RENDERER = \"caption-text\";\n\n  CaptioningProxy.prototype.defaults = {\n    useNative: false,\n    crossorigin: null\n  };\n\n  CaptioningProxy.prototype.hidden = true;\n\n  CaptioningProxy.prototype.tracks = null;\n\n  CaptioningProxy.prototype.track = null;\n\n  CaptioningProxy.prototype.activeCaptions = null;\n\n  CaptioningProxy.prototype.captions = null;\n\n  CaptioningProxy.prototype.loaded = true;\n\n  CaptioningProxy.prototype.rendererMap = null;\n\n  CaptioningProxy.prototype.settings = null;\n\n  CaptioningProxy.prototype.getSettings = function() {\n    return this.settings;\n  };\n\n  CaptioningProxy.prototype.setSettings = function(value) {\n    this.settings = value;\n  };\n\n  /**\n   *\n  */\n  CaptioningProxy.prototype.getUseNative = function() {\n    return this.getValue(\"useNative\");\n  };\n\n  /**\n   *\n  */\n  CaptioningProxy.prototype.getCrossOrigin = function() {\n    return this.getValue(\"crossorigin\");\n  };\n\n  /**\n   *\n  */\n  CaptioningProxy.prototype.getTracks = function() {\n    return this.tracks;\n  };\n\n  CaptioningProxy.prototype.setTracks = function(value) {\n    var count, item, loaded, track, trackLoaded, _i, _len,\n      _this = this;\n    this.tracks = [];\n    this.track = null;\n    if (!(value != null)) {\n      return;\n    }\n    count = value.length;\n    loaded = 0;\n    trackLoaded = function() {\n      loaded++;\n      if (loaded === count) {\n        _this.sendNotification(CaptioningNotifications.TRACKS_LOADED, _this.tracks);\n        _this.autoSelectTrack();\n      }\n    };\n    for (_i = 0, _len = value.length; _i < _len; _i++) {\n      item = value[_i];\n      track = new CaptionTrack(item, trackLoaded);\n      this.tracks.push(track);\n    }\n    return value;\n  };\n\n  /**\n  */\n  CaptioningProxy.prototype.registerRenderer = function(value) {\n    if (!(value != null)) {\n      return;\n    }\n    value.proxy = this;\n    this.rendererMap.push(value);\n  };\n\n  /**\n  */\n  CaptioningProxy.prototype.retrieveRenderer = function(name) {\n    var value, _i, _len, _ref;\n    _ref = this.rendererMap;\n    for (_i = 0, _len = _ref.length; _i < _len; _i++) {\n      value = _ref[_i];\n      if (value.getRendererName() === name) {\n        return value;\n      }\n    }\n  };\n\n  /**\n  */\n  CaptioningProxy.prototype.removeRenderer = function(name) {\n    var index, value;\n    value = this.retrieveRenderer(name);\n    value.proxy = null;\n    if (!(value != null)) {\n      return null;\n    }\n    index = this.rendererMap.indexOf(value);\n    this.rendererMap.splice(index, 1);\n    return value;\n  };\n\n  /**\n   *\n  */\n  CaptioningProxy.prototype.getRenderer = function() {\n    return this.renderer;\n  };\n\n  CaptioningProxy.prototype.setRenderer = function(value) {\n    if (value === this.renderer) {\n      return value;\n    }\n    if (this.renderer != null) {\n      this.facade.removeMediator(CaptioningProxy.TEXT_TRACK_RENDERER);\n    }\n    this.renderer = value;\n    if (this.renderer != null) {\n      this.facade.registerMediator(this.renderer);\n    }\n    return value;\n  };\n\n  /**\n   *\n  */\n  CaptioningProxy.prototype.selectRenderer = function(media) {\n    var item, renderer, track, tracks, _i, _j, _len, _len1, _ref;\n    renderer = null;\n    tracks = media.track;\n    if (!(tracks != null)) {\n      return;\n    }\n    for (_i = 0, _len = tracks.length; _i < _len; _i++) {\n      track = tracks[_i];\n      _ref = this.rendererMap;\n      for (_j = 0, _len1 = _ref.length; _j < _len1; _j++) {\n        item = _ref[_j];\n        if (!(item.canUseResource(track) === true)) {\n          continue;\n        }\n        renderer = item;\n        break;\n      }\n      if (renderer != null) {\n        break;\n      }\n    }\n    this.setRenderer(renderer);\n    return renderer;\n  };\n\n  /**\n   *\n  */\n  CaptioningProxy.prototype.getTrack = function() {\n    return this.track;\n  };\n\n  CaptioningProxy.prototype.setTrack = function(value) {\n    this.track = value;\n    this.captions = this.track.cues;\n    this.activeCaptions = [];\n    this.sendNotification(CaptioningNotifications.TRACK_SELECTED, this.track);\n    return value;\n  };\n\n  /**\n   *\n  */\n  CaptioningProxy.prototype.selectTrackByIndex = function(index) {\n    var track;\n    if ((0 <= index && index < this.tracks.length)) {\n      track = this.tracks[index];\n      this.setTrack(track);\n    }\n    return track;\n  };\n\n  /**\n   *\n  */\n  CaptioningProxy.prototype.selectTrackByLanguage = function(lang) {\n    var item, track, _i, _len, _ref;\n    _ref = this.tracks;\n    for (_i = 0, _len = _ref.length; _i < _len; _i++) {\n      item = _ref[_i];\n      if (!(item.language === lang)) {\n        continue;\n      }\n      track = item;\n      break;\n    }\n    if (track != null) {\n      this.setTrack(track);\n    }\n    return track;\n  };\n\n  /**\n   *\n  */\n  CaptioningProxy.prototype.getHidden = function() {\n    return this.hidden;\n  };\n\n  CaptioningProxy.prototype.setHidden = function(value) {\n    this.hidden = value;\n    try {\n      localStorage.setItem(Namespace.PREFIX + \"caption-enabled\", !this.hidden);\n    } catch (localStorageError) {\n      this.facade.logger.error(\"LocalStorage Not Supported on this Browser\", localStorageError);\n    }\n    return value;\n  };\n\n  /**\n   *\n  */\n  CaptioningProxy.prototype.autoSelectTrack = function() {\n    var lang, track, _ref;\n    lang = (_ref = this.facade.player.retrieveProxy(LocalizationProxy.NAME)) != null ? _ref.getLanguage() : void 0;\n    if (lang != null) {\n      lang = lang.split(\"-\").shift();\n      track = this.selectTrackByLanguage(lang);\n    }\n    if (!(track != null)) {\n      track = this.tracks[0];\n      this.setTrack(track);\n    }\n    return track;\n  };\n\n  /**\n   * The CaptioningHTMLMediator class.\n   *\n   * @constructor\n   * @private\n   * @extends {LocalizedMediator}\n   * @param {Object} viewComponent\n  */\n  function CaptioningHTMLMediator(viewComponent) {\n    CaptioningHTMLMediator.__super__.constructor.call(this, null, null, viewComponent, null);\n  }\n\n\n  __extends(CaptioningHTMLMediator, PluginComponentMediator);\n\n\n  CaptioningHTMLMediator.prototype.componentName = CaptioningProxy.TEXT_TRACK_RENDERER;\n\n  CaptioningHTMLMediator.prototype.captionText = null;\n\n  /**\n  */\n  CaptioningHTMLMediator.prototype.getRendererName = function() {\n    return \"html\";\n  };\n\n  /**\n  */\n  CaptioningHTMLMediator.prototype.canUseResource = function(resource) {\n    var types;\n    if (!(resource != null)) {\n      return false;\n    }\n    types = [Utils.mimeTypes.srt, Utils.mimeTypes.ttml, Utils.mimeTypes.vtt];\n    return types.indexOf(resource.type) !== -1;\n  };\n\n  /* Get Caption Container Display Height\n  */\n  CaptioningHTMLMediator.prototype.getCaptionDisplayHeight = function() {\n    var height, i, length;\n    height = 0;\n    i = length = this.viewComponent.childNodes.length;\n    while (i) {\n      --i;\n      if (length === 3 && i === 0) {\n        break;\n      }\n      height += Utils.getActualSize(this.viewComponent.childNodes[i]).height;\n    }\n    return height + \"px\";\n  };\n\n  /* Scroll Captions\n  */\n  CaptioningHTMLMediator.prototype.scrollCaptions = function(scrollHeight, scrollTop, steps) {\n    var scroll, stepSize,\n      _this = this;\n    if (scrollHeight == null) {\n      scrollHeight = this.viewComponent.scrollHeight;\n    }\n    if (scrollTop == null) {\n      scrollTop = this.viewComponent.scrollTop;\n    }\n    if (steps == null) {\n      steps = 20;\n    }\n    stepSize = (scrollHeight - scrollTop) / steps;\n    scroll = function() {\n      var _results;\n      if (scrollTop < scrollHeight) {\n        _this.viewComponent.scrollTop = scrollTop += stepSize;\n        return setTimeout(scroll, 20);\n      } else {\n        _results = [];\n        while (_this.viewComponent.childNodes.length > 2) {\n          _results.push(_this.viewComponent.removeChild(_this.viewComponent.firstChild));\n        }\n        return _results;\n      }\n    };\n    scroll();\n  };\n\n  /**\n   * @override\n  */\n  CaptioningHTMLMediator.prototype.listNotificationInterests = function() {\n    return [CaptioningNotifications.CUE_CHANGE, Notifications.CHANGE_MEDIA];\n  };\n\n  /**\n   * @override\n  */\n  CaptioningHTMLMediator.prototype.handleNotification = function(notification) {\n    var body, captions, childNode, cue, i, name, temp, _i, _j, _len, _len1, _ref;\n    name = notification.getName();\n    body = notification.getBody();\n    switch (name) {\n      case Notifications.CHANGE_MEDIA:\n        this.viewComponent.innerHTML = \"\";\n        break;\n      case CaptioningNotifications.CUE_CHANGE:\n        captions = \"\";\n        for (_i = 0, _len = body.length; _i < _len; _i++) {\n          cue = body[_i];\n          captions += cue.html;\n        }\n        switch (this.plugin.getSettings().scroll) {\n          case \"popout\":\n            this.viewComponent.innerHTML = captions;\n            break;\n          case \"rollon\":\n          case \"painton\":\n            temp = document.createElement(\"div\");\n            temp.innerHTML = captions;\n            _ref = temp.childNodes;\n            for (i = _j = 0, _len1 = _ref.length; _j < _len1; i = ++_j) {\n              childNode = _ref[i];\n              this.viewComponent.appendChild(childNode);\n            }\n            this.viewComponent.style.maxHeight = this.getCaptionDisplayHeight();\n            this.scrollCaptions();\n        }\n    }\n  };\n\n  /**\n   * The CaptioningMediator class.\n   *\n   * @constructor\n   * @private\n   * @extends {PluginMediator}\n   * @param {Object} viewComponent\n  */\n  function CaptioningNativeMediator(viewComponent) {\n    CaptioningNativeMediator.__super__.constructor.call(this, viewComponent);\n  }\n\n\n  __extends(CaptioningNativeMediator, LocalizedMediator);\n\n\n  CaptioningNativeMediator.prototype.video = null;\n\n  CaptioningNativeMediator.prototype.index = -1;\n\n  CaptioningNativeMediator.prototype.plugin = null;\n\n  CaptioningNativeMediator.NAME = CaptioningProxy.TEXT_TRACK_RENDERER;\n\n  /**\n  */\n  CaptioningNativeMediator.prototype.getRendererName = function() {\n    return \"native\";\n  };\n\n  /**\n  */\n  CaptioningNativeMediator.prototype.canUseResource = function(resource) {\n    var hasNative, type, types, useNative;\n    if (!(resource != null)) {\n      return false;\n    }\n    hasNative = document.createElement(\"video\").textTracks != null;\n    if (!hasNative) {\n      return false;\n    }\n    types = [Utils.mimeTypes.vtt, Utils.mimeTypes.cea608, Utils.mimeTypes.cea708];\n    type = resource.type;\n    if (type === types[1] || type === types[2]) {\n      return true;\n    }\n    useNative = /iphone|ipad/.test(Utils.getDevice()) || this.proxy.getUseNative();\n    if (!useNative) {\n      return false;\n    }\n    return types.indexOf(resource.type) !== -1;\n  };\n\n  /**\n   * @override\n  */\n  CaptioningNativeMediator.prototype.onRegister = function() {\n    this.plugin = this.facade.retrieveProxy(CaptioningProxy.NAME);\n    this.facade.player.getMediaElement().textTracks.addEventListener(\"addtrack\", this.updateTrack.bind(this));\n  };\n\n  /**\n   * @override\n  */\n  CaptioningNativeMediator.prototype.listNotificationInterests = function() {\n    return [CaptioningNotifications.VISIBILITY_CHANGE, CaptioningNotifications.TRACK_SELECTED, CaptioningNotifications.TRACKS_LOADED, Notifications.LOADED_METADATA, Notifications.CAN_PLAY_THROUGH];\n  };\n\n  /**\n   * @override\n  */\n  CaptioningNativeMediator.prototype.handleNotification = function(notification) {\n    var body, crossorigin, element, track, video, _i, _len, _ref;\n    body = notification.getBody();\n    switch (notification.getName()) {\n      case CaptioningNotifications.TRACKS_LOADED:\n        this.tracks = body;\n        break;\n      case CaptioningNotifications.TRACK_SELECTED:\n        if (this.facade.player.getMediaElement().textTracks.length) {\n          track = this.facade.player.getMediaElement().textTracks[this.index];\n        }\n        if (track != null) {\n          track.mode = \"hidden\";\n        }\n        this.index = this.plugin.getTracks().indexOf(body);\n        this.lang = body.language;\n        this.updateTrack();\n        break;\n      case CaptioningNotifications.VISIBILITY_CHANGE:\n      case Notifications.CAN_PLAY_THROUGH:\n        this.updateTrack();\n        break;\n      case Notifications.LOADED_METADATA:\n        if (!(this.tracks != null)) {\n          return;\n        }\n        video = this.facade.player.getMediaElement();\n        crossorigin = this.plugin.getCrossOrigin();\n        if (crossorigin != null) {\n          video.setAttribute(\"crossorigin\", crossorigin);\n        }\n        _ref = this.tracks;\n        for (_i = 0, _len = _ref.length; _i < _len; _i++) {\n          track = _ref[_i];\n          if (!(track.type === Utils.mimeTypes.vtt)) {\n            continue;\n          }\n          element = document.createElement(\"track\");\n          element.src = track.src;\n          if (track.kind != null) {\n            element.kind = track.kind;\n          }\n          if (track.language != null) {\n            element.srclang = track.language;\n          }\n          if (track.label != null) {\n            element.label = track.label;\n          }\n          element[\"default\"] = \"default\" in track;\n          video.appendChild(element);\n        }\n        this.tracks = null;\n    }\n  };\n\n  CaptioningNativeMediator.prototype.updateTrack = function() {\n    var i, track, _i, _len, _ref;\n    _ref = this.facade.player.getMediaElement().textTracks;\n    for (i = _i = 0, _len = _ref.length; _i < _len; i = ++_i) {\n      track = _ref[i];\n      if (!(/subtitles|captions/.test(track.kind) && (track.language === this.lang || !track.language.length))) {\n        continue;\n      }\n      if (!(track != null)) {\n        return;\n      }\n      this.index = i;\n      track.mode = this.plugin.getHidden() ? \"hidden\" : \"showing\";\n    }\n  };\n\n  /**\n   * The CaptioningSettingsMediator class.\n   *\n   * @constructor\n   * @private\n   * @extends {LocalizedMediator}\n   * @param {Object} viewComponent\n  */\n  function CaptioningSettingsMediator(viewComponent) {\n    this.list = {\n      font: null,\n      language: null,\n      edge: null,\n      size: null,\n      scroll: null\n    };\n    this.picker = {\n      color: null,\n      background: null,\n      edge: null,\n      window: null\n    };\n    this.toggle = {\n      ON: null,\n      OFF: null,\n      disabled: false\n    };\n    this.captioningObject = {\n      \"default\": {\n        fontFamily: \"'Courier New', Courier, 'Nimbus Mono L', 'Cutive Mono', monospace\",\n        size: \"small\",\n        scroll: \"popout\",\n        fontColor: \"rgba(255,255,255,1)\",\n        edgeType: \"text-shadow: 0px 0px 0px\",\n        edgeColor: \"rgba(0, 0, 0, 0)\",\n        backgroundColor: \"rgba(0,0,0,0)\",\n        windowColor: \"rgba(0,0,0,0.5)\"\n      },\n      appliedStyleText: \"\",\n      selected: {\n        fontFamily: null,\n        size: null,\n        fontColor: null,\n        edgeType: null,\n        edgeColor: null,\n        backgroundColor: null,\n        windowColor: null\n      },\n      preset1: {\n        fontFamily: \"'Courier New', Courier, 'Nimbus Mono L', 'Cutive Mono', monospace\",\n        size: \"medium\",\n        fontColor: \"rgba(255,255,255,1)\",\n        edgeType: \"text-shadow: 0px 0px 0px\",\n        edgeColor: \"rgba(0, 0, 0, 0)\",\n        backgroundColor: \"rgba(0,0,0,0)\",\n        windowColor: \"rgba(0,0,0,0)\"\n      },\n      preset2: {\n        fontFamily: \"'Courier New', Courier, 'Nimbus Mono L', 'Cutive Mono', monospace\",\n        size: \"medium\",\n        fontColor: \"rgba(255,255,0,1)\",\n        edgeType: \"text-shadow: 0px 0px 0px\",\n        edgeColor: \"rgba(0, 0, 0, 0)\",\n        backgroundColor: \"rgba(0,0,0,0)\",\n        windowColor: \"rgba(0,0,0,0)\"\n      },\n      preset3: {\n        fontFamily: \"'Courier New', Courier, 'Nimbus Mono L', 'Cutive Mono', monospace\",\n        size: \"medium\",\n        fontColor: \"rgba(255,255,255,1)\",\n        edgeType: \"text-shadow: 0px 0px 0px\",\n        edgeColor: \"rgba(0, 0, 0, 0)\",\n        backgroundColor: \"rgba(0,0,0,1)\",\n        windowColor: \"rgba(0,0,0,0)\"\n      },\n      preset4: {\n        fontFamily: \"'Courier New', Courier, 'Nimbus Mono L', 'Cutive Mono', monospace\",\n        size: \"medium\",\n        fontColor: \"rgba(255,255,0,1)\",\n        edgeType: \"text-shadow: 0px 0px 0px\",\n        edgeColor: \"rgba(0, 0, 0, 1)\",\n        backgroundColor: \"rgba(0,0,0,0)\",\n        windowColor: \"rgba(0,0,0,0.5)\"\n      },\n      instance: null\n    };\n    CaptioningSettingsMediator.__super__.constructor.call(this, null, null, viewComponent, null);\n  }\n\n\n  __extends(CaptioningSettingsMediator, PluginComponentMediator);\n\n\n  CaptioningSettingsMediator.prototype.componentName = \"captioning-settings\";\n\n  CaptioningSettingsMediator.prototype.settingsUiVisible = false;\n\n  CaptioningSettingsMediator.prototype.captionningStyle = null;\n\n  CaptioningSettingsMediator.prototype.swatchColorCurr = null;\n\n  CaptioningSettingsMediator.prototype.swatchOpacityCurr = null;\n\n  CaptioningSettingsMediator.prototype.colorPicker = null;\n\n  CaptioningSettingsMediator.prototype.colorPickerOpacity = null;\n\n  CaptioningSettingsMediator.prototype.advancedSettingContainer = null;\n\n  CaptioningSettingsMediator.prototype.scroll = {\n    type: \"popout\",\n    typeSpeed: 5,\n    lines: 2,\n    scrollTimer: [],\n    speed: 10,\n    popout: null,\n    rollup: null,\n    painton: null\n  };\n\n  /**\n   * @override\n  */\n  CaptioningSettingsMediator.prototype.onRegister = function() {\n    var applyButton, cancelButton, captionContainer, captionLabel, clonedSwatch, color, colorArray, isDefault, preset1, preset2, preset3, preset4, previewContainer, previewPara, resetButton, swatch, titleBar, titleText, toggleAdvancedButton, _i, _len,\n      _this = this;\n    CaptioningSettingsMediator.__super__.onRegister.call(this);\n    titleBar = this.create(\"captioning-titlebar\");\n    titleText = this.create(\"captioning-title\", titleBar, \"span\", this.localizationManager.getString(LocalizationConstants.MSG_CC_TITLE));\n    this.toggle.OFF = this.create(\"captioning-toggle-btn\", titleBar, \"div\", \"OFF\");\n    this.toggle.ON = this.create(\"captioning-toggle-btn\", titleBar, \"div\", \"ON\");\n    EventHandler.create(this.toggle.ON, EventHandler.CLICK, function(event) {\n      event.stopImmediatePropagation();\n      if (!_this.toggle.disabled) {\n        _this.toggleButtonHandler(true);\n      }\n      return false;\n    });\n    if (!this.toggle.disabled) {\n      ClassList.add(\"captioning-floater-btnselected\", this.toggle.OFF, this.classList.prefix);\n    }\n    EventHandler.create(this.toggle.OFF, EventHandler.CLICK, function(event) {\n      event.stopImmediatePropagation();\n      if (!_this.toggle.disabled) {\n        _this.toggleButtonHandler(false);\n      }\n      return false;\n    });\n    captionContainer = this.create(\"captioning-row\");\n    captionLabel = this.create(\"captioning-label\", captionContainer, \"span\", this.localizationManager.getString(LocalizationConstants.MSG_CC_LANGUAGE));\n    this.list.language = this.create(\"captioning-dropdown\", captionContainer, \"select\");\n    this.languageListPopulate();\n    EventHandler.create(this.list.language, \"change\", function(event) {\n      var langIsSelected;\n      event.stopImmediatePropagation();\n      langIsSelected = event.target.selectedValue !== \"None\";\n      _this.sendNotification(CaptioningNotifications.VISIBILITY_CHANGE, langIsSelected);\n      if (langIsSelected) {\n        _this.facade.setTrack(_this.facade.selectTrackByIndex(event.target.selectedIndex));\n      }\n      return false;\n    });\n    captionLabel = this.create(\"captioning-label\", captionContainer, \"span\", this.localizationManager.getString(LocalizationConstants.MSG_CC_PRESETS));\n    preset1 = this.create([\"captioning-preset\", \"captioning-preset1\"], captionContainer, null, \"Aa\");\n    preset2 = this.create([\"captioning-preset\", \"captioning-preset2\"], captionContainer, null, \"Aa\");\n    preset3 = this.create([\"captioning-preset\", \"captioning-preset3\"], captionContainer, null, \"Aa\");\n    preset4 = this.create([\"captioning-preset\", \"captioning-preset4\"], captionContainer, null, \"Aa\");\n    EventHandler.create(preset1, EventHandler.CLICK, function(event) {\n      event.stopImmediatePropagation();\n      _this.captioningObject.selected = _this.cloneObject(_this.captioningObject.preset1);\n      _this.applyCaptioningStyle();\n      return false;\n    });\n    EventHandler.create(preset2, EventHandler.CLICK, function(event) {\n      event.stopImmediatePropagation();\n      _this.captioningObject.selected = _this.cloneObject(_this.captioningObject.preset2);\n      _this.applyCaptioningStyle();\n      return false;\n    });\n    EventHandler.create(preset3, EventHandler.CLICK, function(event) {\n      event.stopImmediatePropagation();\n      _this.captioningObject.selected = _this.cloneObject(_this.captioningObject.preset3);\n      _this.applyCaptioningStyle();\n      return false;\n    });\n    EventHandler.create(preset4, EventHandler.CLICK, function(event) {\n      event.stopImmediatePropagation();\n      _this.captioningObject.selected = _this.cloneObject(_this.captioningObject.preset4);\n      _this.applyCaptioningStyle();\n      return false;\n    });\n    this.advancedSettingContainer = this.create(\"captioning-advanced-container\");\n    captionContainer = this.create(\"captioning-row\", this.advancedSettingContainer);\n    captionLabel = this.create(\"captioning-label\", captionContainer, \"span\", this.localizationManager.getString(LocalizationConstants.MSG_CC_FONT));\n    this.list.font = this.create(\"captioning-dropdown\", captionContainer, \"select\");\n    this.create(null, this.list.font, \"option\", \"Monospaced Serif\").value = \"'Courier New', Courier, 'Nimbus Mono L', 'Cutive Mono', monospace\";\n    this.create(null, this.list.font, \"option\", \"Proportional Serif\").value = \"'Times New Roman', Times, Georgia, Cambria, 'PT Serif Caption', serif\";\n    this.create(null, this.list.font, \"option\", \"Monospaced Sans-Serif\").value = \"'Deja Vu Sans Mono', 'Lucida Console', Monaco, Consolas, 'PT Mono', monospace\";\n    this.create(null, this.list.font, \"option\", \"Proportional Sans-Serif\").value = \"Roboto, 'Arial Unicode Ms', Arial, Helvetica, Verdana, 'PT Sans Caption', sans-serif\";\n    this.create(null, this.list.font, \"option\", \"Casual\").value = \"'Comic Sans MS', Impact, Handlee, fantasy\";\n    this.create(null, this.list.font, \"option\", \"Cursive\").value = \"'Monotype Corsiva', 'URW Chancery L', 'Apple Chancery', 'Dancing Script', cursive\";\n    this.create(null, this.list.font, \"option\", \"Small Capitals\").value = \"'Arial Unicode Ms', Arial, Helvetica, Verdana, 'Marcellus SC', sans-serif; font-variant: small-caps\";\n    EventHandler.create(this.list.font, \"change\", function(event) {\n      event.stopImmediatePropagation();\n      _this.captioningObject.selected.fontFamily = event.target.value;\n      _this.applyCaptioningStyle(false);\n      return false;\n    });\n    captionContainer.appendChild(this.list.font);\n    captionLabel = this.create(\"captioning-label\", captionContainer, \"span\", this.localizationManager.getString(LocalizationConstants.MSG_CC_EDGE));\n    this.list.edge = this.create(\"captioning-dropdown\", captionContainer, \"select\");\n    this.create(null, this.list.edge, \"option\", \"None\").value = \"text-shadow: 0px 0px 0px\";\n    this.create(null, this.list.edge, \"option\", \"Depressed\").value = \"text-shadow: 0px 1px 0px\";\n    this.create(null, this.list.edge, \"option\", \"Left Drop Shadow\").value = \"text-shadow: -3px 3px 2px\";\n    this.create(null, this.list.edge, \"option\", \"Raised\").value = \"text-shadow: 0px 1px 1px\";\n    this.create(null, this.list.edge, \"option\", \"Right Drop Shadow\").value = \"text-shadow: 3px 3px 2px\";\n    this.create(null, this.list.edge, \"option\", \"Uniform\").value = \"text-shadow: 0px 0px 4px\";\n    EventHandler.create(this.list.edge, \"change\", function(event) {\n      event.stopImmediatePropagation();\n      _this.captioningObject.selected.edgeType = event.target.value;\n      _this.applyCaptioningStyle(false);\n      return false;\n    });\n    captionContainer = this.create(\"captioning-row\", this.advancedSettingContainer);\n    this.create(\"captioning-label\", captionContainer, \"span\", this.localizationManager.getString(LocalizationConstants.MSG_CC_SIZE));\n    this.list.size = this.create(\"captioning-dropdown\", captionContainer, \"select\");\n    this.create(null, this.list.size, \"option\", \"Small\").value = \"small\";\n    this.create(null, this.list.size, \"option\", \"Medium\").value = \"medium\";\n    this.create(null, this.list.size, \"option\", \"Large\").value = \"large\";\n    this.create(null, this.list.size, \"option\", \"Extra Large\").value = \"x-large\";\n    this.list.size.selectedIndex = 1;\n    EventHandler.create(this.list.size, \"change\", function(event) {\n      event.stopImmediatePropagation();\n      _this.captioningObject.selected.size = event.target.value;\n      _this.applyCaptioningStyle(false);\n      return false;\n    });\n    this.create(\"captioning-label\", captionContainer, \"span\", this.localizationManager.getString(LocalizationConstants.MSG_CC_SCROLL));\n    this.list.scroll = this.create(\"captioning-dropdown\", captionContainer, \"select\");\n    this.create(null, this.list.scroll, \"option\", \"Pop-Out\").value = \"popout\";\n    this.create(null, this.list.scroll, \"option\", \"Roll-On\").value = \"rollon\";\n    this.create(null, this.list.scroll, \"option\", \"Paint-On\").value = \"painton\";\n    EventHandler.create(this.list.scroll, \"change\", function(event) {\n      event.stopImmediatePropagation();\n      _this.onScrollListChange(event.target.value);\n      return false;\n    });\n    captionContainer = this.create(\"captioning-row\", this.advancedSettingContainer);\n    this.create(\"captioning-label-small\", captionContainer, \"span\", this.localizationManager.getString(LocalizationConstants.MSG_CC_COLOR));\n    this.picker.color = this.create(\"captioning-color-picker\", captionContainer);\n    this.picker.color.style.backgroundColor = this.captioningObject[\"default\"].fontColor;\n    EventHandler.create(this.picker.color, EventHandler.CLICK, function(event) {\n      var alpha, _ref;\n      event.stopImmediatePropagation();\n      _this.colorPickerHandler();\n      _this.colorPicker.style.display = _this.colorPicker.style.display === \"block\" ? \"none\" : \"block\";\n      if (_this.colorPicker.style.display === \"block\") {\n        if ((_ref = _this.swatchColorCurr) != null) {\n          _ref.style.borderColor = \"rgba(0,0,0,0.3)\";\n        }\n        _this.colorPicker.style.left = \"152px\";\n        _this.colorPicker.name = \"fontColor\";\n        _this.captioningObject.instance = _this.picker.color;\n        if (_this.picker.color.style.backgroundColor.indexOf('rgba') !== -1) {\n          alpha = _this.picker.color.style.backgroundColor.replace(/^rgba?\\(|\\s+|\\)$/g, '').split(',')[3];\n        }\n        _this.colorPickerOpacity.value = alpha != null ? alpha : 1;\n      }\n      return false;\n    });\n    this.create(\"captioning-label-small\", captionContainer, \"span\", this.localizationManager.getString(LocalizationConstants.MSG_CC_BACKGROUND));\n    this.picker.background = this.create(\"captioning-color-picker\", captionContainer);\n    this.picker.background.style.backgroundColor = this.captioningObject[\"default\"].backgroundColor;\n    EventHandler.create(this.picker.background, EventHandler.CLICK, function(event) {\n      var alpha, _ref;\n      event.stopImmediatePropagation();\n      _this.colorPickerHandler();\n      _this.colorPicker.style.display = _this.colorPicker.style.display === \"block\" ? \"none\" : \"block\";\n      if (_this.colorPicker.style.display === \"block\") {\n        if ((_ref = _this.swatchColorCurr) != null) {\n          _ref.style.borderColor = \"rgba(0,0,0,0.3)\";\n        }\n        _this.colorPicker.style.left = \"264px\";\n        _this.colorPicker.name = \"backgroundColor\";\n        _this.captioningObject.instance = _this.picker.background;\n        if (_this.picker.background.style.backgroundColor.indexOf('rgba') !== -1) {\n          alpha = _this.picker.background.style.backgroundColor.replace(/^rgba?\\(|\\s+|\\)$/g, '').split(',')[3];\n        }\n        _this.colorPickerOpacity.value = alpha != null ? alpha : 1;\n      }\n      return false;\n    });\n    this.create(\"captioning-label-small\", captionContainer, \"span\", this.localizationManager.getString(LocalizationConstants.MSG_CC_EDGE));\n    this.picker.edge = this.create(\"captioning-color-picker\", captionContainer);\n    this.picker.edge.style.backgroundColor = this.captioningObject[\"default\"].edgeColor;\n    EventHandler.create(this.picker.edge, EventHandler.CLICK, function(event) {\n      var alpha, _ref;\n      event.stopImmediatePropagation();\n      _this.colorPickerHandler();\n      _this.colorPicker.style.display = _this.colorPicker.style.display === \"block\" ? \"none\" : \"block\";\n      if (_this.colorPicker.style.display === \"block\") {\n        if ((_ref = _this.swatchColorCurr) != null) {\n          _ref.style.borderColor = \"rgba(0,0,0,0.3)\";\n        }\n        _this.colorPicker.style.left = \"212px\";\n        _this.colorPicker.name = \"edgeColor\";\n        _this.captioningObject.instance = _this.picker.edge;\n        if (_this.picker.edge.style.backgroundColor.indexOf('rgba') !== -1) {\n          alpha = _this.picker.edge.style.backgroundColor.replace(/^rgba?\\(|\\s+|\\)$/g, '').split(',')[3];\n        }\n        _this.colorPickerOpacity.value = alpha != null ? alpha : 1;\n      }\n      return false;\n    });\n    this.create(\"captioning-label-small\", captionContainer, \"span\", this.localizationManager.getString(LocalizationConstants.MSG_CC_WINDOW));\n    this.picker.window = this.create(\"captioning-color-picker\", captionContainer);\n    this.picker.window.style.backgroundColor = this.captioningObject[\"default\"].windowColor;\n    EventHandler.create(this.picker.window, EventHandler.CLICK, function(event) {\n      var alpha, _ref;\n      event.stopImmediatePropagation();\n      _this.colorPickerHandler();\n      _this.colorPicker.style.display = _this.colorPicker.style.display === \"block\" ? \"none\" : \"block\";\n      if (_this.colorPicker.style.display === \"block\") {\n        if ((_ref = _this.swatchColorCurr) != null) {\n          _ref.style.borderColor = \"rgba(0,0,0,0.3)\";\n        }\n        _this.colorPicker.style.left = \"300px\";\n        _this.colorPicker.name = \"windowColor\";\n        _this.captioningObject.instance = _this.picker.window;\n        if (_this.picker.window.style.backgroundColor.indexOf('rgba') !== -1) {\n          alpha = _this.picker.window.style.backgroundColor.replace(/^rgba?\\(|\\s+|\\)$/g, '').split(',')[3];\n        }\n        _this.colorPickerOpacity.value = alpha != null ? alpha : 1;\n      }\n      return false;\n    });\n    previewContainer = this.create([\"caption-text\", \"caption-text-preview\"]);\n    previewPara = this.create(null, previewContainer, \"p\", this.localizationManager.getString(LocalizationConstants.MSG_CC_PREVIEW_TEXT));\n    captionContainer = this.create(\"captioning-footer-container\");\n    applyButton = this.create(\"captioning-footer-button\", captionContainer, \"div\", this.localizationManager.getString(LocalizationConstants.MSG_CC_APPLY));\n    cancelButton = this.create(\"captioning-footer-button\", captionContainer, \"div\", this.localizationManager.getString(LocalizationConstants.MSG_CC_CANCEL));\n    resetButton = this.create(\"captioning-footer-button\", captionContainer, \"div\", this.localizationManager.getString(LocalizationConstants.MSG_CC_RESET));\n    if (this.facade.getViewComponent().clientWidth >= 0) {\n      toggleAdvancedButton = this.create(\"captioning-advanced-button\", captionContainer, \"div\", this.localizationManager.getString(LocalizationConstants.MSG_CC_SHOW_ADVANCED));\n      EventHandler.create(toggleAdvancedButton, EventHandler.CLICK, function(event) {\n        event.stopImmediatePropagation();\n        if (_this.advancedSettingContainer.style.display === \"block\") {\n          event.target.innerHTML = _this.localizationManager.getString(LocalizationConstants.MSG_CC_SHOW_ADVANCED);\n          _this.advancedSettingContainer.style.display = \"none\";\n          _this.colorPicker.style.display = \"none\";\n        } else {\n          event.target.innerHTML = _this.localizationManager.getString(LocalizationConstants.MSG_CC_HIDE_ADVANCED);\n          _this.advancedSettingContainer.style.display = \"block\";\n        }\n        return false;\n      });\n    }\n    EventHandler.create(applyButton, EventHandler.CLICK, function(event) {\n      event.stopImmediatePropagation();\n      _this.sendNotification(CaptioningNotifications.SETTINGS_VISIBILITY_CHANGE, _this.settingsUiVisible);\n      _this.applyCaptioningStyle(false, true);\n      _this.sendNotification(CaptioningNotifications.SETTINGS_CHANGE, _this.captioningObject.selected);\n      return false;\n    });\n    EventHandler.create(cancelButton, EventHandler.CLICK, function(event) {\n      event.stopImmediatePropagation();\n      _this.sendNotification(CaptioningNotifications.SETTINGS_VISIBILITY_CHANGE, _this.settingsUiVisible);\n      return false;\n    });\n    EventHandler.create(resetButton, EventHandler.CLICK, function(event) {\n      event.stopImmediatePropagation();\n      _this.colorPicker.style.display = \"none\";\n      _this.applyCaptioningStyle(true);\n      return false;\n    });\n    this.captionningStyle = this.create(null, document.getElementsByTagName('head')[0], \"style\");\n    this.captionningStyle.type = 'text/css';\n    colorArray = [\"#000000\", \"#660000\", \"#990000\", \"#ff0000\", \"#000066\", \"#660066\", \"#990066\", \"#ff0066\", \"#006600\", \"#666600\", \"#996600\", \"#ff6600\", \"#006666\", \"#666666\", \"#996666\", \"#ff6666\", \"#009900\", \"#669966\", \"#999900\", \"#ff9900\", \"#009966\", \"#669966\", \"#999966\", \"#ff9966\", \"#00ff00\", \"#66ff00\", \"#99ff00\", \"#ffff00\", \"#00ff66\", \"#66ff66\", \"#99ff66\", \"#ffff66\", \"#000099\", \"#660099\", \"#990099\", \"#ff0099\", \"#0000ff\", \"#6600ff\", \"#9900ff\", \"#ff00ff\", \"#006699\", \"#666699\", \"#996699\", \"#ff6699\", \"#0066ff\", \"#6666ff\", \"#9966ff\", \"#ff66ff\", \"#009999\", \"#669999\", \"#999999\", \"#ff9999\", \"#0099ff\", \"#6699ff\", \"#9999ff\", \"#ff99ff\", \"#0099ff\", \"#66ff99\", \"#99ff99\", \"#ffff99\", \"#00ffff\", \"#66ffff\", \"#99ffff\", \"#ffffff\"];\n    this.colorPicker = this.create(\"colorpicker-palette\", this.viewComponent.parentElement);\n    swatch = this.create(\"colorpicker-swatch\", false, null, \"&nbsp;\");\n    for (_i = 0, _len = colorArray.length; _i < _len; _i++) {\n      color = colorArray[_i];\n      swatch.style.backgroundColor = color;\n      clonedSwatch = swatch.cloneNode();\n      EventHandler.create(clonedSwatch, EventHandler.CLICK, function(event) {\n        event.stopImmediatePropagation();\n        if (_this.swatchColorCurr !== null) {\n          _this.swatchColorCurr.style.borderColor = \"rgba(0,0,0,0.3)\";\n        }\n        _this.swatchColorCurr = event.target;\n        _this.swatchColorCurr.style.borderColor = \"rgba(255, 50, 50, 1)\";\n        _this.captioningObject.instance.style.backgroundColor = _this.captioningObject.selected[_this.colorPicker.name] = _this.toRGBA(event.target.style.backgroundColor);\n        _this.applyCaptioningStyle(false);\n        return false;\n      });\n      this.colorPicker.appendChild(clonedSwatch);\n    }\n    this.create(\"opacity-label\", this.colorPicker, \"span\", this.localizationManager.getString(LocalizationConstants.MSG_CC_OPACITY));\n    this.colorPickerOpacity = this.create(\"colorpicker-slider\", this.colorPicker, \"input\");\n    this.colorPickerOpacity.type = \"range\";\n    this.colorPickerOpacity.min = 0;\n    this.colorPickerOpacity.max = 1;\n    this.colorPickerOpacity.step = .1;\n    this.colorPickerOpacity.value = 1;\n    EventHandler.create(this.colorPickerOpacity, \"change\", function(event) {\n      event.stopImmediatePropagation();\n      _this.captioningObject.instance.style.backgroundColor = _this.captioningObject.selected[_this.colorPicker.name] = _this.toRGBA(_this.captioningObject.instance.style.backgroundColor);\n      _this.applyCaptioningStyle(false);\n      return false;\n    });\n    this.swatchOpacityCurr = this.colorPickerOpacity;\n    try {\n      if (localStorage.getItem(Namespace.PREFIX + \"captioningDefault\") != null) {\n        this.captioningObject.selected = JSON.parse(localStorage.getItem(Namespace.PREFIX + \"captioningDefault\"));\n        this.applyCaptioningStyle(false, !this.facade.getHidden());\n      } else {\n        isDefault = !((this.facade.config.style != null) || this.facade.config.style !== \"undefined\");\n        if (!isDefault) {\n          this.captioningObject.selected = this.cloneObject(this.facade.config.style);\n        }\n        this.applyCaptioningStyle(isDefault);\n      }\n    } catch (_error) {}\n    this.plugin.setSettings(Object.keys(this.captioningObject.selected).length > 0 ? this.captioningObject.selected : this.captioningObject[\"default\"]);\n    this.toggleButtonHandler(!this.facade.getHidden(), false);\n  };\n\n  CaptioningSettingsMediator.prototype.toRGBA = function(colorCode) {\n    var rbga, rgb;\n    rgb = colorCode.replace(/^rgba?\\(|\\s+|\\)$/g, '').split(',');\n    rbga = 'rgba(' + rgb[0] + \",\" + rgb[1] + \",\" + rgb[2] + \",\" + this.swatchOpacityCurr.value + ')';\n    return rbga;\n  };\n\n  CaptioningSettingsMediator.prototype.onScrollListChange = function(value) {\n    this.captioningObject.selected.scroll = this.scroll.type = value;\n    this.plugin.setSettings({\n      scroll: this.scroll.type\n    });\n    try {\n      if (value === \"painton\") {\n        ClassList.add(\"akamai-captioning-typed\", this.facade.proxy.renderer.viewComponent);\n      } else {\n        ClassList.remove(\"akamai-captioning-typed\", this.facade.proxy.renderer.viewComponent);\n      }\n    } catch (error) {\n      this.facade.logger.error(\"AMP Captioning Error\", error);\n    }\n  };\n\n  CaptioningSettingsMediator.prototype.languageListPopulate = function() {\n    var language, track, tracks, _i, _len, _ref;\n    tracks = this.facade.getTracks();\n    if (!(tracks != null)) {\n      return;\n    }\n    this.list.language.innerHTML = \"\";\n    for (_i = 0, _len = tracks.length; _i < _len; _i++) {\n      track = tracks[_i];\n      language = track.language;\n      language = this.facade.player.retrieveProxy(LocalizationProxy.NAME).getLanguageString(language);\n      if ((language != null) && language !== \"\") {\n        this.create(null, this.list.language, \"option\", language).value = track.language;\n      }\n    }\n    this.toggle.disabled = this.list.language.childElementCount === 0;\n    if (this.toggle.disabled) {\n      this.create(null, this.list.language, \"option\", \"None\");\n    }\n    this.list.language.value = (_ref = this.facade.getTrack()) != null ? _ref.language : void 0;\n  };\n\n  CaptioningSettingsMediator.prototype.colorPickerHandler = function(unbind) {\n    var _this = this;\n    if (unbind == null) {\n      unbind = false;\n    }\n    if (unbind) {\n      return EventHandler.unbind(document, EventHandler.CLICK);\n    }\n    EventHandler.create(document, EventHandler.CLICK, function(event) {\n      event.stopImmediatePropagation();\n      _this.colorPickerHandler(true);\n      if (event.target.className !== \"akamai-colorpicker-palette\" && event.target.className !== \"akamai-opacity-label\" && event.target.className !== \"akamai-colorpicker-slider\" && _this.colorPicker.style.display !== \"none\") {\n        _this.colorPicker.style.display = \"none\";\n      }\n      return false;\n    });\n  };\n\n  CaptioningSettingsMediator.prototype.cloneObject = function(clone) {\n    var cloned, key;\n    cloned = {};\n    for (key in clone) {\n      cloned[key] = clone[key];\n    }\n    return cloned;\n  };\n\n  CaptioningSettingsMediator.prototype.applyCaptioningStyle = function(isDefault, isApply, settingsDefault) {\n    var backgroundColor, color, edgeType, fontFamily, fontSize, windowColor;\n    if (isDefault == null) {\n      isDefault = false;\n    }\n    if (isApply == null) {\n      isApply = false;\n    }\n    if (settingsDefault == null) {\n      settingsDefault = false;\n    }\n    if (isDefault) {\n      this.captioningObject.selected = this.cloneObject(this.captioningObject[\"default\"]);\n      this.list.font.value = this.captioningObject[\"default\"].fontFamily;\n      this.list.edge.value = this.captioningObject[\"default\"].edgeType != null ? this.captioningObject[\"default\"].edgeType : \"text-shadow: 0px 0px 0px\";\n      this.list.size.value = this.captioningObject[\"default\"].size;\n      this.list.scroll.value = this.captioningObject[\"default\"].scroll;\n      this.picker.color.style.backgroundColor = this.captioningObject[\"default\"].fontColor;\n      this.picker.background.style.backgroundColor = this.captioningObject[\"default\"].backgroundColor;\n      this.picker.edge.style.backgroundColor = this.captioningObject[\"default\"].edgeColor;\n      this.picker.window.style.backgroundColor = this.captioningObject[\"default\"].windowColor;\n    } else {\n      if ((this.captioningObject.selected.fontFamily != null) && !settingsDefault) {\n        this.list.font.value = this.captioningObject.selected.fontFamily;\n      }\n      this.list.edge.value = this.captioningObject.selected.edgeType != null ? this.captioningObject.selected.edgeType : \"text-shadow: 0px 0px 0px\";\n      if (this.captioningObject.selected.size != null) {\n        this.list.size.value = this.captioningObject.selected.size;\n      }\n      if (this.captioningObject.selected.scroll != null) {\n        this.list.scroll.value = this.captioningObject.selected.scroll;\n      } else {\n        this.captioningObject.selected.scroll = this.list.scroll.value;\n      }\n      this.picker.color.style.backgroundColor = this.captioningObject.selected.fontColor;\n      if (this.captioningObject.selected.backgroundColor != null) {\n        this.picker.background.style.backgroundColor = this.captioningObject.selected.backgroundColor;\n      }\n      if (this.captioningObject.selected.edgeColor != null) {\n        this.picker.edge.style.backgroundColor = this.captioningObject.selected.edgeColor;\n      }\n      if (this.captioningObject.selected.windowColor != null) {\n        this.picker.window.style.backgroundColor = this.captioningObject.selected.windowColor;\n      }\n    }\n    fontFamily = \"font-family: \" + (isDefault ? this.captioningObject[\"default\"].fontFamily : settingsDefault ? this.captioningObject.selected.fontFamily : this.list.font.value) + \" !important;\";\n    edgeType = (isDefault ? this.captioningObject[\"default\"].edgeType + this.captioningObject[\"default\"].edgeColor : this.list.edge.value + \" \" + this.picker.edge.style.backgroundColor) + \" !important;\";\n    fontSize = \"font-size: \" + (isDefault ? this.captioningObject[\"default\"].size : this.list.size.value) + \" !important;\";\n    color = \"color: \" + (isDefault ? this.captioningObject[\"default\"].fontColor : this.picker.color.style.backgroundColor) + \" !important;\";\n    backgroundColor = \"background-color: \" + (isDefault ? this.captioningObject[\"default\"].backgroundColor : this.picker.background.style.backgroundColor) + \" !important;\";\n    windowColor = \"background-color: \" + (isDefault ? this.captioningObject[\"default\"].windowColor : this.picker.window.style.backgroundColor) + \" !important;\";\n    if (isApply) {\n      this.captionningStyle.innerHTML = this.captioningObject.appliedStyleText = '#' + this.facade.player.viewComponent.id + ' .akamai-caption-text { ' + fontFamily + fontSize + edgeType + windowColor + ' } #' + this.facade.player.viewComponent.id + ' .akamai-caption-text p { ' + color + backgroundColor + ' } ' + 'video::-webkit-media-text-track-display-backdrop { ' + windowColor + ' } video::-webkit-media-text-track-display-backdrop span { ' + fontFamily + fontSize + edgeType + backgroundColor + ' } video::-webkit-media-text-track-display-backdrop { ' + windowColor + ' } video::cue { ' + color + fontFamily + fontSize + edgeType + backgroundColor + ' }';\n      try {\n        if (isDefault === false && !settingsDefault) {\n          localStorage.setItem(Namespace.PREFIX + \"captioningDefault\", JSON.stringify(this.captioningObject.selected));\n        }\n      } catch (localStorageError) {\n        this.facade.logger.error(\"LocalStorage Not Supported on this Browser\", localStorageError);\n      }\n    } else {\n      this.captionningStyle.innerHTML = this.captioningObject.appliedStyleText + '.akamai-caption-text-preview { ' + fontFamily + fontSize + edgeType + windowColor + ' }' + '.akamai-caption-text-preview p { ' + color + backgroundColor + ' }';\n    }\n  };\n\n  CaptioningSettingsMediator.prototype.toggleButtonHandler = function(isON, isTargetButton) {\n    if (isON == null) {\n      isON = false;\n    }\n    if (isTargetButton == null) {\n      isTargetButton = true;\n    }\n    if (isON) {\n      ClassList.add(\"captioning-floater-btnselected\", this.toggle.ON, this.classList.prefix);\n      ClassList.remove(\"captioning-floater-btnselected\", this.toggle.OFF, this.classList.prefix);\n    } else {\n      ClassList.add(\"captioning-floater-btnselected\", this.toggle.OFF, this.classList.prefix);\n      ClassList.remove(\"captioning-floater-btnselected\", this.toggle.ON, this.classList.prefix);\n    }\n    if (isTargetButton) {\n      this.sendNotification(CaptioningNotifications.VISIBILITY_CHANGE, isON);\n    }\n    this.sendNotification(UserSettingsNotifications.UPDATE_SETTINGS, {\n      captioning: {\n        hidden: !isON\n      }\n    });\n  };\n\n  /**\n   * @override\n  */\n  CaptioningSettingsMediator.prototype.listNotificationInterests = function() {\n    return [CaptioningNotifications.SETTINGS_VISIBILITY_CHANGE, CaptioningNotifications.TOGGLE_SETTINGS_VISIBILITY, CaptioningNotifications.SETTINGS_CHANGE, CaptioningNotifications.TRACK_SELECTED, CaptioningNotifications.VISIBILITY_CHANGE];\n  };\n\n  /**\n   * @override\n  */\n  CaptioningSettingsMediator.prototype.handleNotification = function(notification) {\n    var body, fName, fValue, i, isDefault, k, listString, name, note, option, state, v, _i, _len, _ref;\n    name = notification.getName();\n    body = notification.getBody();\n    switch (name) {\n      case CaptioningNotifications.SETTINGS_VISIBILITY_CHANGE:\n      case CaptioningNotifications.TOGGLE_SETTINGS_VISIBILITY:\n        if (this.settingsUiVisible) {\n          this.colorPicker.style.display = \"none\";\n        }\n        this.settingsUiVisible = !this.settingsUiVisible;\n        if (this.settingsUiVisible && this.list.language.length === 1) {\n          this.languageListPopulate();\n        }\n        note = this.settingsUiVisible ? Notifications.ADD_APPLICATION_STATE : Notifications.REMOVE_APPLICATION_STATE;\n        state = \"cc-setting-active\";\n        this.sendNotification(note, state);\n        break;\n      case CaptioningNotifications.SETTINGS_CHANGE:\n        isDefault = false;\n        for (k in body) {\n          v = body[k];\n          switch (k) {\n            case \"fontFamily\":\n            case \"fontSize\":\n            case \"scroll\":\n            case \"edgeType\":\n              listString = k === \"fontFamily\" ? \"font\" : k === \"fontSize\" ? \"size\" : k === \"edgeType\" ? \"edge\" : \"scroll\";\n              _ref = this.list[listString].options;\n              for (i = _i = 0, _len = _ref.length; _i < _len; i = ++_i) {\n                option = _ref[i];\n                if (k === \"fontFamily\" && typeof v === \"object\") {\n                  for (fName in v) {\n                    fValue = v[fName];\n                    if (fName === \"default\") {\n                      this.captioningObject.selected.fontFamily = fValue;\n                      isDefault = true;\n                    }\n                    if ((new RegExp(fName, \"i\")).test(option.label)) {\n                      if (!(new RegExp(\"^\" + fValue)).test(option.value)) {\n                        option.value = fValue + \",\" + option.value;\n                      }\n                      if (option.selected) {\n                        this.captioningObject.selected.fontFamily = option.value;\n                      }\n                    }\n                  }\n                } else if ((new RegExp(\"^\" + v + \"$\", \"i\")).test(option.label)) {\n                  this.list[listString].selectedIndex = i;\n                  if (k === \"fontSize\") {\n                    k = \"size\";\n                  }\n                  this.captioningObject.selected[k] = option.value;\n                  if (k === \"scroll\") {\n                    this.scroll.type = this.captioningObject.selected.scroll = option.value;\n                    this.plugin.setSettings({\n                      scroll: this.scroll.type\n                    });\n                    try {\n                      if (option.value === \"painton\") {\n                        ClassList.add(\"akamai-captioning-typed\", this.facade.proxy.renderer.viewComponent);\n                      } else {\n                        ClassList.remove(\"akamai-captioning-typed\", this.facade.proxy.renderer.viewComponent);\n                      }\n                    } catch (error) {\n                      this.facade.logger.error(\"AMP Captioning Error\", error);\n                    }\n                  }\n                }\n              }\n              break;\n            case \"backgroundColor\":\n            case \"edgeColor\":\n            case \"fontColor\":\n            case \"windowColor\":\n              this.captioningObject.selected[k] = v;\n          }\n        }\n        this.applyCaptioningStyle(false, true, isDefault);\n        if ((body.visible != null) && body.visible !== !this.facade.getHidden()) {\n          this.facade.setHidden(!body.visible);\n        }\n        break;\n      case CaptioningNotifications.TRACK_SELECTED:\n        this.list.language.value = notification.body.language;\n        this.onScrollListChange(this.captioningObject.selected.scroll);\n        break;\n      case CaptioningNotifications.VISIBILITY_CHANGE:\n        this.toggleButtonHandler(body, false);\n    }\n  };\n\n  /**\n   * PluginMediator class.\n   *\n   * @constructor\n   * @private\n   * @extends {OverlayMediator}\n  */\n  function PluginMediator() {\n    PluginMediator.__super__.constructor.call(this);\n  }\n\n\n  __extends(PluginMediator, OverlayMediator);\n\n\n  /** @override\n  */\n  PluginMediator.prototype.initializeNotifier = function(key) {\n    PluginMediator.__super__.initializeNotifier.call(this, key);\n    this.plugin = this.facade.retrieveProxy(ModuleProxy.NAME);\n    this.media = this.facade.player.retrieveProxy(MediaProxy.NAME);\n  };\n\n  /** @override\n  */\n  PluginMediator.prototype.onRegister = function() {\n    PluginMediator.__super__.onRegister.call(this);\n    this.facade.viewComponent = this.viewComponent;\n  };\n\n  /**\n   * The CaptioningMediator class.\n   *\n   * @constructor\n   * @private\n   * @extends {PluginMediator}\n   * @param {Object} viewComponent\n  */\n  function CaptioningMediator(viewComponent) {\n    CaptioningMediator.__super__.constructor.call(this, viewComponent);\n  }\n\n\n  __extends(CaptioningMediator, PluginMediator);\n\n\n  CaptioningMediator.prototype.componentName = \"captioning\";\n\n  CaptioningMediator.prototype.captionButton = null;\n\n  /**\n   * @override\n  */\n  CaptioningMediator.prototype.onRegister = function() {\n    var button;\n    button = new ButtonMediator(this.localizationManager.getString(LocalizationConstants.MSG_CC), this.viewComponent, null, \"caption\", this.onclick.bind(this));\n    this.facade.registerMediator(button);\n    this.captionButton = button.getViewComponent();\n    this.sendNotification(Notifications.ADD_CONTROL, this.captionButton);\n    CaptioningMediator.__super__.onRegister.call(this);\n    try {\n      if ((typeof localStorage !== \"undefined\" && localStorage !== null ? localStorage.getItem(Namespace.PREFIX + \"caption-enabled\") : void 0) === \"true\") {\n        this.facade.setHidden(false);\n      }\n    } catch (_error) {}\n  };\n\n  /**\n  */\n  CaptioningMediator.prototype.onclick = function(event) {\n    var _ref;\n    event.stopImmediatePropagation();\n    if (((_ref = this.plugin.getTrack()) != null ? _ref.type : void 0) === \"embedded\") {\n      this.sendNotification(CaptioningNotifications.VISIBILITY_CHANGE, this.plugin.getHidden());\n    } else if (event.currentTarget === this.captionButton) {\n      this.sendNotification(CaptioningNotifications.SETTINGS_VISIBILITY_CHANGE, this.plugin.getHidden());\n    }\n    return false;\n  };\n\n  /**\n   * @override\n  */\n  CaptioningMediator.prototype.listNotificationInterests = function() {\n    return [CaptioningNotifications.VISIBILITY_CHANGE, CaptioningNotifications.ENABLED, CaptioningNotifications.TRACK_SELECTED];\n  };\n\n  /**\n   * @override\n  */\n  CaptioningMediator.prototype.handleNotification = function(notification) {\n    var body, note, state;\n    body = notification.getBody();\n    note = body ? Notifications.ADD_APPLICATION_STATE : Notifications.REMOVE_APPLICATION_STATE;\n    switch (notification.getName()) {\n      case CaptioningNotifications.TRACK_SELECTED:\n        state = \"cc-embedded\";\n        note = body.type === \"embedded\" ? Notifications.ADD_APPLICATION_STATE : Notifications.REMOVE_APPLICATION_STATE;\n        break;\n      case CaptioningNotifications.VISIBILITY_CHANGE:\n        state = \"cc-active\";\n        break;\n      case CaptioningNotifications.ENABLED:\n        note = body ? Notifications.ADD_CONTROL_STATE : Notifications.REMOVE_CONTROL_STATE;\n        state = \"cc-enabled\";\n        if (!body) {\n          this.sendNotification(Notifications.REMOVE_APPLICATION_STATE, \"cc-active\");\n        }\n    }\n    this.sendNotification(note, state);\n  };\n\n  /**\n   * The OmniturePlugin class.\n   *\n   * @param {Module}  app     The parent module of this plugin.\n   * @constructor\n   * @private\n   * @extends {Plugin}\n  */\n  function OmniturePlugin() {\n    OmniturePlugin.__super__.constructor.call(this);\n  }\n\n\n  __extends(OmniturePlugin, Plugin);\n\n\n  OmniturePlugin.prototype.moduleName = \"omniture\";\n\n  /** @override\n  */\n  OmniturePlugin.prototype.createController = function() {\n    this.registerCommand(Notifications.MEDIA_CHANGE, OmnitureMediaChangeCommand);\n    this.registerCommand(Notifications.ENDED, OmnitureEndedCommand);\n    this.registerCommand(Notifications.STARTED, OmnitureStartCommand);\n    this.registerCommand(Notifications.PLAY, OmniturePlayCommand);\n    this.registerCommand(Notifications.PAUSE, OmniturePauseCommand);\n    this.registerCommand(Notifications.SEEKING, OmnitureSeekingCommand);\n    this.registerCommand(Notifications.SEEKED, OmnitureSeekedCommand);\n    this.registerCommand(Notifications.CHANGE_CONTENT, OmnitureEndedCommand);\n    this.registerCommand(Notifications.CONTENT_CHANGED, OmnitureContentChangedCommand);\n    this.registerCommand(AdNotifications.AD_LOADED, OmnitureAdLoadedCommand);\n    this.registerCommand(AdNotifications.AD_STARTED, OmnitureAdStartedCommand);\n    this.registerCommand(AdNotifications.AD_PLAY, OmnitureAdPlayCommand);\n    this.registerCommand(AdNotifications.AD_PAUSE, OmnitureAdPauseCommand);\n    this.registerCommand(AdNotifications.AD_TIME_UPDATE, OmnitureAdTimeUpdateCommand);\n    this.registerCommand(AdNotifications.BREAK_END, OmnitureAdBreakEndCommand);\n  };\n\n  /** @override\n  */\n  OmniturePlugin.prototype.createModel = function() {\n    var _ref;\n    if (((_ref = this.config.heartbeat) != null ? _ref.enabled : void 0) === true) {\n      this.registerProxy(new HeartbeatProxy(this.config));\n    } else {\n      this.registerProxy(new OmnitureProxy(this.config));\n    }\n  };\n\n  /**\n  */\n  OmniturePlugin.prototype.listNotificationInterests = function() {\n    return [Notifications.CHANGE_MEDIA, Notifications.MEDIA_CHANGE, Notifications.CHANGE_CONTENT, Notifications.CONTENT_CHANGED, Notifications.TIME_UPDATE, Notifications.ENDED, Notifications.STARTED, Notifications.PLAY, Notifications.PAUSE, Notifications.SEEKING, Notifications.SEEKED, AdNotifications.AD_LOADED, AdNotifications.AD_STARTED, AdNotifications.AD_PLAY, AdNotifications.AD_PAUSE, AdNotifications.AD_TIME_REMAINING, AdNotifications.BREAK_START, AdNotifications.BREAK_END];\n  };\n\n\n  AMP.registerPlugin(\"omniture\", \"html\", OmniturePlugin);\n  AMP.registerPlugin(\"omniture\", \"flash\", OmnitureWrapper);\n\n  /**\n   * @constructor\n   * @private\n  */\n  function InfoWrapper(player, config) {\n    if (config == null) {\n      config = {};\n    }\n    InfoWrapper.__super__.constructor.call(this, player, config);\n  }\n\n\n  __extends(InfoWrapper, PluginWrapper);\n\n\n  InfoWrapper.NAME = \"InfoWrapper\";\n\n  /** @override\n  */\n  InfoWrapper.prototype.listNotificationInterests = function() {\n    return [FlashNotifications.CREATE_FLASH_VARS, FlashNotifications.CREATE_XML, FlashNotifications.SHARE, FlashNotifications.SHARE_REQUEST];\n  };\n\n  /**\n  */\n  InfoWrapper.prototype.handleNotification = function(notification) {\n    var application, body, data, element, elements, flashvars, info, name, property, provider, text, type, view, xml, _i, _len;\n    name = notification.getName();\n    body = notification.getBody();\n    switch (name) {\n      case FlashNotifications.CREATE_FLASH_VARS:\n        flashvars = body.flashvars;\n        break;\n      case FlashNotifications.CREATE_XML:\n        xml = body.xml;\n        application = xml.firstChild;\n        view = xml.getElementsByTagName(\"view\")[0];\n        elements = xml.getElementsByTagName(\"element\");\n        for (_i = 0, _len = elements.length; _i < _len; _i++) {\n          element = elements[_i];\n          if (!(element.getAttribute(\"id\") === \"infoOverlayAdvanced\")) {\n            continue;\n          }\n          info = element;\n          break;\n        }\n        if (!(view != null)) {\n          return;\n        }\n        if (!(info != null)) {\n          info = xml.createElement(\"element\");\n          info.setAttribute(\"id\", \"infoOverlayAdvanced\");\n          info.setAttribute(\"displayStates\", \"preplay,paused,ns,fs,mouseover\");\n          view.insertBefore(info, view.childNodes[0]);\n        }\n        data = xml.createElement(\"data\");\n        info.appendChild(data);\n        if (this.config.title != null) {\n          property = xml.createElement(\"property\");\n          property.setAttribute(\"key\", \"title\");\n          text = XMLUtils.createTextContent(xml, this.config.title);\n          property.appendChild(text);\n          data.appendChild(property);\n        }\n        if (this.config.description != null) {\n          property = xml.createElement(\"property\");\n          property.setAttribute(\"key\", \"description\");\n          text = XMLUtils.createTextContent(xml, this.config.description);\n          property.appendChild(text);\n          data.appendChild(property);\n        }\n        if (this.config.more != null) {\n          property = xml.createElement(\"property\");\n          property.setAttribute(\"key\", \"more\");\n          text = XMLUtils.createTextContent(xml, this.config.more);\n          property.appendChild(text);\n          data.appendChild(property);\n        }\n        if (this.config.less != null) {\n          property = xml.createElement(\"property\");\n          property.setAttribute(\"key\", \"less\");\n          text = XMLUtils.createTextContent(xml, this.config.less);\n          property.appendChild(text);\n          data.appendChild(property);\n        }\n        if (this.config.provider != null) {\n          provider = xml.createElement(\"property\");\n          provider.setAttribute(\"key\", \"provider\");\n          data.appendChild(provider);\n          if (this.config.provider.name != null) {\n            property = xml.createElement(\"property\");\n            property.setAttribute(\"key\", \"name\");\n            text = XMLUtils.createTextContent(xml, this.config.provider.name);\n            property.appendChild(text);\n            provider.appendChild(property);\n          }\n          if (this.config.provider.image != null) {\n            property = xml.createElement(\"property\");\n            property.setAttribute(\"key\", \"image\");\n            text = XMLUtils.createTextContent(xml, this.config.provider.image);\n            property.appendChild(text);\n            provider.appendChild(property);\n          }\n        }\n        break;\n      case FlashNotifications.SHARE:\n      case FlashNotifications.SHARE_REQUEST:\n        type = \"share\";\n    }\n    if (type != null) {\n      return this.dispatchEvent(new Event(type, body));\n    }\n  };\n\n\n  AMP.registerPlugin(\"info\", \"flash\", InfoWrapper);\n\n  /**\n   * The InfoMediator class.\n   *\n   * @constructor\n   * @private\n   * @extends {PluginMediator}\n  */\n  function InfoMediator() {\n    InfoMediator.__super__.constructor.call(this);\n  }\n\n\n  __extends(InfoMediator, PluginMediator);\n\n\n  InfoMediator.prototype.componentName = \"info\";\n\n  InfoMediator.prototype.title = null;\n\n  InfoMediator.prototype.shortDescription = null;\n\n  InfoMediator.prototype.icon = null;\n\n  InfoMediator.prototype.provider = null;\n\n  /**\n   * @override\n  */\n  InfoMediator.prototype.onRegister = function() {\n    InfoMediator.__super__.onRegister.call(this);\n    this.title = this.create(\"info-title\");\n    this.provider = this.create(\"info-provider\");\n    this.shortDescription = this.create(\"info-short-description\");\n    this.icon = this.create(\"info-icon\", this, \"img\");\n    this.dataChangedHandler();\n  };\n\n  /**\n   * @override\n  */\n  InfoMediator.prototype.listNotificationInterests = function() {\n    return [Notifications.MEDIA_CHANGE];\n  };\n\n  /**\n   * @override\n  */\n  InfoMediator.prototype.handleNotification = function(notification) {\n    var body, name;\n    name = notification.getName();\n    body = notification.getBody();\n    switch (name) {\n      case Notifications.MEDIA_CHANGE:\n        this.dataChangedHandler();\n    }\n  };\n\n  InfoMediator.prototype.moreClicked = function(event) {\n    return this.classList.add(\"open\");\n  };\n\n  InfoMediator.prototype.closeClicked = function(event) {\n    return this.classList.remove(\"open\");\n  };\n\n  InfoMediator.prototype.dataChangedHandler = function() {\n    var styles, _ref;\n    if (this.plugin.value.title != null) {\n      this.title.textContent = this.plugin.value.title;\n    }\n    if (((_ref = this.plugin.value.provider) != null ? _ref.image : void 0) != null) {\n      this.icon.src = this.plugin.value.provider.image;\n    }\n    styles = getComputedStyle(this.title);\n    if (this.title.clientHeight > parseInt(styles.lineHeight)) {\n      this.classList.add(\"info-small\");\n      this.shortDescription.innerHTML = this.provider.innerHTML = \"\";\n      return;\n    } else {\n      this.classList.remove(\"info-small\");\n    }\n    this.truncateDescription(this.plugin.value.description, this.plugin.value.more);\n    this.provider.textContent = this.plugin.value.provider.name != null ? \"\" + this.plugin.value.provider.name : \"\";\n  };\n\n  InfoMediator.prototype.truncateDescription = function(desc) {\n    var character, ellp, index, text, tf, _i, _len;\n    ellp = \"...\";\n    text = \"\";\n    tf = this.shortDescription;\n    tf.textContent = \"\";\n    if (!(desc != null)) {\n      return;\n    }\n    for (index = _i = 0, _len = desc.length; _i < _len; index = ++_i) {\n      character = desc[index];\n      tf.textContent = text + character + ellp;\n      if (tf.scrollHeight > tf.clientHeight) {\n        tf.textContent = text + ellp;\n        break;\n      } else {\n        text += character;\n      }\n    }\n  };\n\n  /**\n   * The InfoProxy class.\n   *\n   * @constructor\n   * @private\n   * @extends {DataBoundConfigurationProxy}\n   * @param {Object} data\n  */\n  function InfoProxy(data) {\n    InfoProxy.__super__.constructor.call(this, data);\n  }\n\n\n  __extends(InfoProxy, DataBoundConfigurationProxy);\n\n\n  InfoProxy.prototype.configurationName = \"info\";\n\n  /** @static\n  */\n  InfoProxy.NAME = ModuleProxy.NAME;\n\n  InfoProxy.prototype.defaults = {\n    title: '#{media.title}',\n    description: '#{media.description}',\n    provider: {},\n    more: \"read more\",\n    less: \"less\"\n  };\n\n  /**\n   * The CaptioningPlugin class.\n   *\n   * @param {Module}  app     The parent module of this plugin.\n   * @constructor\n   * @private\n   * @extends {Feature}\n  */\n  function CaptioningPlugin() {\n    CaptioningPlugin.__super__.constructor.call(this);\n  }\n\n\n  __extends(CaptioningPlugin, Feature);\n\n\n  CaptioningPlugin.prototype.featureName = \"captioning\";\n\n  CaptioningPlugin.prototype.moduleName = \"captioning\";\n\n  /** @override\n  */\n  CaptioningPlugin.prototype.createController = function() {\n    CaptioningPlugin.__super__.createController.call(this);\n    this.registerCommand(Notifications.CHANGE_MEDIA, CaptioningChangeMediaCommand);\n    this.registerCommand(Notifications.STARTED, CaptioningStartedCommand);\n    this.registerCommand(Notifications.TIME_UPDATE, CaptioningTimeUpdateCommand);\n    this.registerCommand(CaptioningNotifications.VISIBILITY_CHANGE, CaptioningVisibilityChangeCommand);\n    this.registerCommand(CaptioningNotifications.ENABLED, PluginEventCommand);\n    this.registerCommand(CaptioningNotifications.TRACK_SELECTED, PluginEventCommand);\n    this.registerCommand(CaptioningNotifications.TRACKS_LOADED, PluginEventCommand);\n    this.registerCommand(CaptioningNotifications.CUE_CHANGE, PluginEventCommand);\n  };\n\n  /** @override\n  */\n  CaptioningPlugin.prototype.createModel = function() {\n    this.proxy = new CaptioningProxy(this.config);\n    this.registerProxy(this.proxy);\n  };\n\n  /** @override\n  */\n  CaptioningPlugin.prototype.createView = function() {\n    var mediator, viewComponent;\n    mediator = new CaptioningMediator();\n    this.registerMediator(mediator);\n    viewComponent = mediator.viewComponent;\n    this.registerMediator(new CaptioningSettingsMediator(viewComponent));\n    this.proxy.registerRenderer(new CaptioningNativeMediator(viewComponent));\n    this.proxy.registerRenderer(new CaptioningHTMLMediator(viewComponent));\n  };\n\n  /**\n  */\n  CaptioningPlugin.prototype.listNotificationInterests = function() {\n    return [Notifications.LOADED_METADATA, Notifications.CAN_PLAY_THROUGH, Notifications.CHANGE_MEDIA, Notifications.STARTED, Notifications.TIME_UPDATE, CaptioningNotifications.TOGGLE_SETTINGS_VISIBILITY];\n  };\n\n  /**\n  */\n  CaptioningPlugin.prototype.listNotificationPublications = function() {\n    var key, value;\n    return CaptioningPlugin.__super__.listNotificationPublications.call(this).concat((function() {\n      var _results;\n      _results = [];\n      for (key in CaptioningNotifications) {\n        value = CaptioningNotifications[key];\n        if (value !== CaptioningNotifications.TOGGLE_SETTINGS_VISIBILITY) {\n          _results.push(value);\n        }\n      }\n      return _results;\n    })()).concat([Notifications.ADD_CONTROL, Notifications.REMOVE_CONTROL, UserSettingsNotifications.UPDATE_SETTINGS, Notifications.ADD_CONTROL_STATE, Notifications.REMOVE_CONTROL_STATE]);\n  };\n\n  /**\n   * @return {boolean} The hidden flag.\n   * @expose\n  */\n  CaptioningPlugin.prototype.getHidden = function() {\n    return this.proxy.getHidden();\n  };\n\n  /**\n   * @param {boolean} value The hidden flag.\n   * @expose\n  */\n  CaptioningPlugin.prototype.setHidden = function(value) {\n    this.sendNotification(CaptioningNotifications.VISIBILITY_CHANGE, !value);\n    return value;\n  };\n\n  /**\n   * Returns an array of caption tracks\n   *\n   * @return {Array.<CaptionTrack>} The list of text tracks.\n   * @expose\n  */\n  CaptioningPlugin.prototype.getTracks = function() {\n    return this.proxy.getTracks();\n  };\n\n  /**\n   * Returns the currently selected track.\n   *\n   * @return {CaptionTrack} The currently selected caption track.\n   * @expose\n  */\n  CaptioningPlugin.prototype.getTrack = function() {\n    return this.proxy.getTrack();\n  };\n\n  /**\n   * Selects a caption track\n   *\n   * @param {CaptionTrack} value The caption track to select\n   * @expose\n  */\n  CaptioningPlugin.prototype.setTrack = function(value) {\n    this.proxy.setTrack(value);\n    return value;\n  };\n\n  /**\n   * Selects a caption track by its index in the getTracks array.\n   *\n   * @param {number}        index   The index to select\n   * @return {CaptionTrack}         The selected caption track.\n   * @expose\n  */\n  CaptioningPlugin.prototype.selectTrackByIndex = function(index) {\n    return this.proxy.selectTrackByIndex(index);\n  };\n\n  /**\n   * Selects a caption track by it's language property.\n   *\n   * @param {string}        lang  The language to select\n   * @return {CaptionTrack}       The selected caption track.\n   * @expose\n  */\n  CaptioningPlugin.prototype.selectTrackByLanguage = function(lang) {\n    return this.proxy.selectTrackByLanguage(lang);\n  };\n\n  /**\n   * Sets a caption Settings Object (styles)\n   *\n   * @param {Object}  object  The caption settings object.\n   * @expose\n  */\n  CaptioningPlugin.prototype.changeSettings = function(object) {\n    this.sendNotification(CaptioningNotifications.SETTINGS_CHANGE, object);\n    return object;\n  };\n\n\n  AMP.registerPlugin(\"captioning\", \"html\", CaptioningPlugin);\n\n  function IMAWrapper() {\n    return IMAWrapper.__super__.constructor.apply(this, arguments);\n  }\n\n\n  __extends(IMAWrapper, AdWrapper);\n\n\n  IMAWrapper.NAME = \"IMAWrapper\";\n\n  IMAWrapper.prototype.partner = \"ima\";\n\n  IMAWrapper.prototype.flashPlugins = [\n    {\n      id: \"GoogleIMAPlugin\",\n      src: '#{paths.resources}plugins/GoogleIMAPlugin.swf',\n      blocking: false,\n      host: \"akamai\",\n      main: \"GoogleIMAPlugin\",\n      type: \"application/x-shockwave-flash\"\n    }, {\n      id: \"IMAOverlayAdPlugin\",\n      src: '#{paths.resources}plugins/IMAOverlayAdPlugin.swf',\n      blocking: false,\n      host: \"akamai\",\n      main: \"IMAOverlayAdPlugin\",\n      type: \"application/x-shockwave-flash\"\n    }, {\n      id: \"AdOptionsPlugin\",\n      src: '#{paths.resources}plugins/AdOptionsPlugin.swf',\n      blocking: false,\n      host: \"akamai\",\n      main: \"AdOptionsPlugin\",\n      type: \"application/x-shockwave-flash\"\n    }\n  ];\n\n  /**\n  */\n  IMAWrapper.prototype.createXML = function(xml) {\n    var admedia, application, companion, companions, ids, overlay, prop, props, vendor, _i, _j, _k, _len, _len1, _len2, _ref;\n    application = xml.firstChild;\n    admedia = xml.getElementsByTagName(\"admedia\")[0];\n    if (!(admedia != null)) {\n      admedia = xml.createElement(\"admedia\");\n      application.appendChild(admedia);\n    }\n    vendor = xml.createElement(\"vendor\");\n    vendor.setAttribute(\"id\", \"dfp\");\n    admedia.appendChild(vendor);\n    props = [\n      {\n        value: this.config.adTagUrl,\n        key: \"DFP_AD_TAG_URL\"\n      }, {\n        value: this.config.maxBitrate,\n        key: \"DFP_MAX_BITRATE\"\n      }, {\n        value: this.config.sceneMarkers,\n        key: \"displaySceneMarkers\"\n      }, {\n        value: this.config.ppid,\n        key: \"DFP_PPID\"\n      }\n    ];\n    for (_i = 0, _len = props.length; _i < _len; _i++) {\n      prop = props[_i];\n      if (prop.value != null) {\n        this.createProperty(xml, prop.key, prop.value, vendor);\n      }\n    }\n    if (this.config.position != null) {\n      vendor.setAttribute(\"position\", this.config.position);\n    }\n    if (this.config.params != null) {\n      if (this.config.params.adTag != null) {\n        this.createProperty(xml, \"DFP_AD_TAG_PARAMS\", this.config.params.adTag, vendor);\n      }\n      if (this.config.params.manual != null) {\n        this.createProperty(xml, \"DFP_MANUAL_PARAMS\", this.config.params.manual, vendor);\n      }\n    }\n    if (this.config.companions != null) {\n      companions = [];\n      ids = [];\n      _ref = this.config.companions;\n      for (_j = 0, _len1 = _ref.length; _j < _len1; _j++) {\n        companion = _ref[_j];\n        companions.push(companion.width + \"x\" + companion.height);\n        ids.push(companion.id);\n      }\n      this.createProperty(xml, \"DFP_SIZE\", companions.join(\",\"), vendor);\n      this.createProperty(xml, \"COMPANION_ID\", ids.join(\",\"), vendor);\n    }\n    if (this.config.disableCompanionAds != null) {\n      this.createProperty(xml, \"disableCompanionAds\", this.config.disableCompanionAds, vendor);\n    }\n    if (this.config.overlay != null) {\n      if (this.config.overlay.enabled === true) {\n        overlay = xml.createElement(\"overlay\");\n        admedia.appendChild(overlay);\n      }\n      props = [\n        {\n          value: \"dfp\",\n          key: \"OVERLAY_AD_PARTNER\"\n        }, {\n          value: this.config.overlay.adTagUrl,\n          key: \"OVERLAY_AD_BASE_URL\"\n        }, {\n          value: this.config.overlay.delay,\n          key: \"OVERLAY_AD_DELAY\"\n        }, {\n          value: this.config.overlay.interval,\n          key: \"OVERLAY_AD_INTERVAL\"\n        }, {\n          value: this.config.overlay.duration,\n          key: \"OVERLAY_AD_DURATION\"\n        }, {\n          value: \"\" + this.config.overlay.width + \"x\" + this.config.overlay.height,\n          key: \"OVERLAY_AD_SIZE\"\n        }\n      ];\n      for (_k = 0, _len2 = props.length; _k < _len2; _k++) {\n        prop = props[_k];\n        if (prop.value != null) {\n          this.createProperty(xml, prop.key, prop.value, overlay);\n        }\n      }\n    }\n    return xml;\n  };\n\n  /**\n   * The IMAFullscreenProxy class.\n   *\n   * @constructor\n   * @private\n   * @extends {IMAProxy}\n   * @param   {Object}    config  The configuration object.\n  */\n  function IMAFullscreenProxy(config) {\n    IMAFullscreenProxy.__super__.constructor.call(this, config);\n  }\n\n\n  __extends(IMAFullscreenProxy, IMAProxy);\n\n\n  /** @static\n  */\n  IMAFullscreenProxy.NAME = IMAProxy.NAME;\n\n  /**\n  */\n  IMAFullscreenProxy.prototype.createPlugin = function() {\n    return new google.ima.AdDisplayContainer(this.facade.getViewComponent().container, this.facade.player.getMediaElement(), this.facade.getViewComponent().container);\n  };\n\n  /** @override\n  */\n  IMAFullscreenProxy.prototype.engage = function(media) {\n    IMAFullscreenProxy.__super__.engage.call(this, media);\n    this.sendNotification(Notifications.DISABLE_VIDEO_EVENTS, [\"paused\", \"ended\", \"durationchange\", \"error\"]);\n  };\n\n  /** @override\n  */\n  IMAFullscreenProxy.prototype.reset = function(media) {\n    IMAFullscreenProxy.__super__.reset.call(this, media);\n    this.sendNotification(Notifications.ENABLE_VIDEO_EVENTS, [\"paused\", \"ended\", \"durationchange\", \"error\"]);\n  };\n\n  /** @override\n  */\n  IMAFullscreenProxy.prototype.breakStart = function() {\n    this.playbackCore = this.facade.player.retrieveProxy(PlayerProxy.NAME).getActivePlaybackCore();\n    this.playbackCore.setEnabled(false);\n    this.setInProgress(true);\n  };\n\n  /** @override\n  */\n  IMAFullscreenProxy.prototype.breakEnd = function() {\n    IMAFullscreenProxy.__super__.breakEnd.call(this);\n    this.playbackCore.setEnabled(true);\n  };\n\n  /**\n   * The IMAAddOverlayCommand class.\n   *\n   * @constructor\n   * @private\n   * @extends {puremvc.SimpleCommand}\n  */\n  function IMAAddOverlayCommand() {\n    IMAAddOverlayCommand.__super__.constructor.call(this);\n  }\n\n\n  __extends(IMAAddOverlayCommand, puremvc.SimpleCommand);\n\n\n  /**\n   * Executes the command.\n   *\n   * @param {puremvc.Notification} notification\n   *    The notification.\n   *\n   * @override\n  */\n  IMAAddOverlayCommand.prototype.execute = function(notification) {\n    this.facade.sendNotification(Notifications.ADD_APPLICATION_STATE, \"ad-overlay-mode\");\n  };\n\n  /**\n   * The IMARemoveOverlayCommand class.\n   *\n   * @constructor\n   * @private\n   * @extends {puremvc.SimpleCommand}\n  */\n  function IMARemoveOverlayCommand() {\n    IMARemoveOverlayCommand.__super__.constructor.call(this);\n  }\n\n\n  __extends(IMARemoveOverlayCommand, puremvc.SimpleCommand);\n\n\n  /**\n   * Executes the command.\n   *\n   * @param {puremvc.Notification} notification\n   *    The notification.\n   *\n   * @override\n  */\n  IMARemoveOverlayCommand.prototype.execute = function(notification) {\n    var proxy;\n    proxy = this.facade.retrieveProxy(IMAOverlayProxy.NAME);\n    proxy.stop();\n    this.facade.player.sendNotification(Notifications.REMOVE_APPLICATION_STATE, \"ad-overlay-mode\");\n  };\n\n  /**\n   * The IMAOverlayMediator class.\n   *\n   * @constructor\n   * @private\n   * @extends {OverlayMediator}\n   * @param {Object} viewComponent\n  */\n  function IMAOverlayMediator() {\n    IMAOverlayMediator.__super__.constructor.call(this);\n  }\n\n\n  __extends(IMAOverlayMediator, OverlayMediator);\n\n\n  IMAOverlayMediator.prototype.componentName = \"ad-overlay\";\n\n  IMAOverlayMediator.prototype.anchor = null;\n\n  IMAOverlayMediator.prototype.image = null;\n\n  IMAOverlayMediator.prototype.tracker = null;\n\n  IMAOverlayMediator.prototype.tracker2 = null;\n\n  IMAOverlayMediator.prototype.closeButton = null;\n\n  IMAOverlayMediator.prototype.closeText = null;\n\n  /**\n   * @override\n  */\n  IMAOverlayMediator.prototype.onRegister = function() {\n    var _this = this;\n    IMAOverlayMediator.__super__.onRegister.call(this);\n    this.anchor = this.create(\"ad-overlay-anchor\");\n    this.anchor.target = \"_blank\";\n    this.image = this.create(\"ad-overlay-img\", this.anchor, \"img\");\n    this.tracker = this.create();\n    this.tracker.width = 0;\n    this.tracker.height = 0;\n    this.tracker2 = this.create(null, this, \"img\");\n    this.tracker2.width = 0;\n    this.tracker2.height = 0;\n    this.closeButton = this.create(\"ad-close-button\", this.anchor);\n    this.closeButton.onclick = function(event) {\n      event.stopImmediatePropagation();\n      _this.sendNotification(IMANotifications.REMOVE_OVERLAY);\n      return false;\n    };\n    this.closeText = this.createText(\"ad-close-text\", \"x\", this.closeButton);\n  };\n\n  /**\n   * @override\n  */\n  IMAOverlayMediator.prototype.listNotificationInterests = function() {\n    return [IMANotifications.ADD_OVERLAY, IMANotifications.REMOVE_OVERLAY];\n  };\n\n  /**\n   * @override\n  */\n  IMAOverlayMediator.prototype.handleNotification = function(notification) {\n    var ad;\n    switch (notification.getName()) {\n      case IMANotifications.ADD_OVERLAY:\n        ad = notification.getBody();\n        this.image.src = ad.src;\n        this.anchor.href = ad.href;\n        this.tracker.src = ad.tracking[0];\n        this.tracker2.src = ad.tracking[1];\n    }\n  };\n\n  /**\n   * The IMAReadyCommand class.\n   *\n   * @constructor\n   * @private\n   * @extends {puremvc.SimpleCommand}\n  */\n  function IMAReadyCommand() {\n    IMAReadyCommand.__super__.constructor.call(this);\n  }\n\n\n  __extends(IMAReadyCommand, puremvc.SimpleCommand);\n\n\n  /**\n   * Executes the command.\n   *\n   * @param {puremvc.Notification} notification\n   *    The notification.\n   *\n   * @override\n  */\n  IMAReadyCommand.prototype.execute = function(notification) {\n    this.facade.retrieveProxy(IMAProxy.NAME).ready();\n  };\n\n  /**\n   * The IMADisplayStateChangeCommand class.\n   *\n   * @constructor\n   * @private\n   * @extends {puremvc.SimpleCommand}\n  */\n  function IMADisplayStateChangeCommand() {\n    IMADisplayStateChangeCommand.__super__.constructor.call(this);\n  }\n\n\n  __extends(IMADisplayStateChangeCommand, puremvc.SimpleCommand);\n\n\n  /**\n   * Executes the command.\n   *\n   * @param {puremvc.Notification} notification\n   *    The notification.\n   *\n   * @override\n  */\n  IMADisplayStateChangeCommand.prototype.execute = function(notification) {\n    this.facade.retrieveProxy(IMAProxy.NAME).resize(notification.getBody());\n  };\n\n  /**\n   * The IMAActiveStateChangeCommand class.\n   *\n   * @constructor\n   * @private\n   * @extends {puremvc.SimpleCommand}\n  */\n  function IMAActiveStateChangeCommand() {\n    IMAActiveStateChangeCommand.__super__.constructor.call(this);\n  }\n\n\n  __extends(IMAActiveStateChangeCommand, puremvc.SimpleCommand);\n\n\n  /**\n   * Executes the command.\n   *\n   * @param {puremvc.Notification} notification\n   *    The notification.\n   *\n   * @override\n  */\n  IMAActiveStateChangeCommand.prototype.execute = function(notification) {\n    this.facade.retrieveProxy(IMAProxy.NAME).resize(notification.getBody());\n  };\n\n  /**\n   * @enum {string}\n   * @const\n   * @private\n  */\n\n  var StatsNotifications = {\n    VISIBILITY_CHANGE: \"statsvisibilitychange\",\n    BITRATES_UPDATE: \"bitratesUpdate\"\n  };\n\n  /**\n   * The InfoPlugin class.\n   *\n   * @param {Module}  app     The parent module of this plugin.\n   * @constructor\n   * @private\n   * @extends {Plugin}\n  */\n  function InfoPlugin() {\n    InfoPlugin.__super__.constructor.call(this);\n  }\n\n\n  __extends(InfoPlugin, Plugin);\n\n\n  InfoPlugin.prototype.moduleName = \"info\";\n\n  /** @override\n  */\n  InfoPlugin.prototype.createModel = function() {\n    this.registerProxy(new InfoProxy(this.config));\n  };\n\n  /** @override\n  */\n  /** @override\n  */\n  InfoPlugin.prototype.createView = function() {\n    this.registerMediator(new InfoMediator());\n  };\n\n  /** @override\n  */\n  InfoPlugin.prototype.listNotificationInterests = function() {\n    return [Notifications.MEDIA_CHANGE];\n  };\n\n\n  AMP.registerPlugin(\"info\", \"html\", InfoPlugin);\n  AMP.registerPlugin(\"info\", \"external\", InfoPlugin);\n\n  /**\n   * @constructor\n   * @private\n  */\n  function StatsProxy(config) {\n    StatsProxy.__super__.constructor.call(this, config);\n  }\n\n\n  __extends(StatsProxy, ModuleProxy);\n\n\n  /** @static\n  */\n  StatsProxy.NAME = ModuleProxy.NAME;\n\n  StatsProxy.prototype.defaults = {\n    url: null\n  };\n\n  StatsProxy.prototype.hidden = true;\n\n  StatsProxy.prototype.getURL = function() {\n    return this.data.url;\n  };\n\n  StatsProxy.prototype.setURL = function(value) {\n    return this.data.url = value;\n  };\n\n  StatsProxy.prototype.getHidden = function() {\n    return this.hidden;\n  };\n\n  StatsProxy.prototype.setHidden = function(value) {\n    return this.hidden = value;\n  };\n\n  StatsProxy.prototype.invoke = function() {\n    var xhr,\n      _this = this;\n    if (this.data.url != null) {\n      return xhr = Utils.get(this.data.url, {\n        onload: function() {\n          if (xhr.response != null) {\n            _this.sendNotification(StatsNotifications.BITRATES_UPDATE, xhr.response);\n          }\n        },\n        onerror: function(error) {\n          return _this.sendNotification(StatsNotifications.BITRATES_UPDATE, null);\n        }\n      });\n    }\n  };\n\n  /**\n   * The StatsVisibilityChangeCommand class.\n   *\n   * @constructor\n   * @private\n   * @extends {puremvc.SimpleCommand}\n  */\n  function StatsVisibilityChangeCommand() {\n    StatsVisibilityChangeCommand.__super__.constructor.call(this);\n  }\n\n\n  __extends(StatsVisibilityChangeCommand, puremvc.SimpleCommand);\n\n\n  /**\n   * Executes the command.\n   *\n   * @param {puremvc.Notification} notification\n   *    The notification.\n   *\n   * @override\n  */\n  StatsVisibilityChangeCommand.prototype.execute = function(notification) {\n    var statsProxy;\n    statsProxy = this.facade.retrieveProxy(StatsProxy.NAME);\n    statsProxy.setHidden(notification.getBody());\n    statsProxy.setURL(\"\" + (this.facade.player.getSrc()));\n    if (notification.getBody() === false) {\n      statsProxy.invoke();\n    }\n  };\n\n  /**\n   * The StatsMediator class.\n   *\n   * @constructor\n   * @private\n   * @extends {PluginMediator}\n   * @param {Object} viewComponent\n  */\n  function StatsMediator() {\n    StatsMediator.__super__.constructor.call(this);\n  }\n\n\n  __extends(StatsMediator, PluginMediator);\n\n\n  /**\n   * Stats Mediator\n   *\n   * @static\n   * @type {string}\n  */\n  StatsMediator.prototype.componentName = \"stats\";\n\n  StatsMediator.prototype.container = null;\n\n  StatsMediator.prototype.statsText = null;\n\n  StatsMediator.prototype.statsButton = null;\n\n  StatsMediator.prototype.bitrateText = null;\n\n  StatsMediator.prototype.bitrateArr = null;\n\n  /**\n   * @override\n  */\n  StatsMediator.prototype.onRegister = function() {\n    var _this = this;\n    StatsMediator.__super__.onRegister.call(this);\n    this.sendNotification(Notifications.ADD_CONTROL_STATE, \"stats-enabled\");\n    this.classList.add(\"hidden\");\n    this.statsFormat = this.create(\"stats-text\");\n    this.statsQuality = this.create(\"stats-text\");\n    this.statsBitRate = this.create(\"stats-text\");\n    this.statsPlayBack = this.create(\"stats-text\");\n    this.statsAnalytics = this.create(\"stats-text\");\n    this.statsButton = this.create(\"stats-button\", false);\n    EventHandler.create(this.statsButton, EventHandler.CLICK, function(event) {\n      event.stopImmediatePropagation();\n      _this.sendNotification(StatsNotifications.VISIBILITY_CHANGE, !_this.facade.getHidden());\n      return false;\n    });\n    this.sendNotification(Notifications.ADD_CONTROL, this.statsButton);\n  };\n\n  /**\n   * @override\n  */\n  StatsMediator.prototype.listNotificationInterests = function() {\n    return [StatsNotifications.VISIBILITY_CHANGE, Notifications.PLAYING, Notifications.TIME_UPDATE];\n  };\n\n  /**\n   * @override\n  */\n  StatsMediator.prototype.handleNotification = function(notification) {\n    var body, levels, name;\n    name = notification.getName();\n    body = notification.getBody();\n    switch (name) {\n      case StatsNotifications.VISIBILITY_CHANGE:\n        if (this.plugin.getHidden()) {\n          this.classList.add(\"hidden\");\n        } else {\n          this.classList.remove(\"hidden\");\n          this.statsBitRate.innerHTML = \"<p><b class='\" + this.classList.prefix + \"stats-header'>Adaptive Bitrate Renditions</b></p><p>Loading...</p>\";\n          this.renderStats();\n        }\n        break;\n      case Notifications.TIME_UPDATE:\n        this.renderQuality();\n        break;\n      case Notifications.PLAYING:\n        levels = this.facade.player.getQualityLevels();\n        if ((levels != null ? levels.length : void 0) > 0) {\n          this.constructBitrateText(levels);\n        } else {\n          this.statsBitRate.innerHTML = \"<p><b class='\" + this.classList.prefix + \"stats-header'>Adaptive Bitrate Renditions</b></p><p>Not Available</p>\";\n        }\n    }\n  };\n\n  /*  Render Stats UI\n  */\n  StatsMediator.prototype.renderQuality = function() {\n    var quality;\n    quality = this.facade.player.getQuality();\n    if (this.quality === quality) {\n      return;\n    }\n    this.statsQuality.innerHTML = \"<p><b class='\" + this.classList.prefix + \"stats-header'>Quality</b></p><p>\" + this.createBitrateText(this.facade.player.getQualityLevels()[quality], quality) + \"</p>\";\n  };\n\n  /*  Render Stats UI\n  */\n  StatsMediator.prototype.renderStats = function() {\n    var analyticsVal, device, formatVal, isDash, playbackVal, player, urlVal, _ref;\n    try {\n      player = this.facade.player;\n      formatVal = player.getMedia() === void 0 ? \"Not Available\" : player.getMedia().type;\n      urlVal = player.getSrc() === \"\" || player.getSrc() === null ? \"Not Available\" : player.getSrc();\n      device = Utils.getDevice();\n      if (device == null) {\n        device = \"\";\n      }\n      playbackVal = this.facade.player.getConfig().mode !== \"\" && this.facade.player.getConfig().mode !== null && this.facade.player.getConfig().mode.indexOf(\"html\") !== -1 ? this.facade.player.getVersion() + \", HTML5 Video: \" + device : \"Not Available\";\n      isDash = (_ref = this.facade.player.retrieveProxy(PlayerProxy.NAME).getActivePlaybackCore()) != null ? _ref.proxyName.indexOf(\"dash\") : void 0;\n      if (isDash > -1) {\n        playbackVal += \", dash.js\";\n      }\n      analyticsVal = this.facade.player.getConfig().mediaanalytics === void 0 || this.facade.player.getConfig().mediaanalytics.config === \"\" || this.facade.player.getConfig().mediaanalytics.config === null ? \"Not Available\" : this.facade.player.getConfig().mediaanalytics.config;\n      this.statsFormat.innerHTML = \"<p><b class='\" + this.classList.prefix + \"stats-header'>Stream</b></p><p>Format: \" + formatVal + \"</p><p>URL: \" + urlVal + \"</p>\";\n      this.statsPlayBack.innerHTML = \"<p><b class='\" + this.classList.prefix + \"stats-header'>Playback</b></p>\" + playbackVal;\n      this.statsAnalytics.innerHTML = \"<p><b class='\" + this.classList.prefix + \"stats-header'>Analytics</b></p>\" + analyticsVal;\n    } catch (error) {\n      this.facade.logger.error(\"[AMP Stats Render Error]:\", error);\n    }\n  };\n\n  /*  Format Bitrate HTML Text\n  */\n  StatsMediator.prototype.constructBitrateText = function(bitrateArr) {\n    var index, item, _i, _len, _ref;\n    this.bitrateArr = bitrateArr;\n    this.bitrateText = '';\n    this.bitrateArr.sort(function(a, b) {\n      var aBitrate, bBitrate;\n      aBitrate = parseInt(a.bitrate);\n      bBitrate = parseInt(b.bitrate);\n      if (aBitrate < bBitrate) {\n        return -1;\n      } else if (aBitrate > bBitrate) {\n        return 1;\n      } else {\n        return 0;\n      }\n    });\n    _ref = this.bitrateArr;\n    for (index = _i = 0, _len = _ref.length; _i < _len; index = ++_i) {\n      item = _ref[index];\n      this.bitrateText += this.createBitrateText(item, index);\n    }\n    if (this.bitrateText === \"\") {\n      this.bitrateText = \"<p>Not Available</p>\";\n    }\n    this.statsBitRate.innerHTML = \"<p><b class='\" + this.classList.prefix + \"stats-header'>Adaptive Bitrate Renditions</b></p>\" + this.bitrateText;\n  };\n\n  /**\n  */\n  StatsMediator.prototype.createBitrateText = function(item, index) {\n    return \"<p>\" + (index + 1) + \". \" + ((item.bitrate / 1000).toFixed(0)) + \" kbps \" + item.width + \"x\" + item.height + \"</p>\";\n  };\n\n  /**\n   * @enum {string}\n   * @const\n   * @private\n  */\n\n  var AISNotifications = {\n    START_AUTHENTICATION: \"aisauthenticationstarted\",\n    AUTHENTICATED: \"aisauthenticated\",\n    AUTHENTICATING: \"aisauthenticating\",\n    AUTHENTICATION_COMPLETE: \"aisauthenticationcomplete\",\n    CHOOSE_AUTH_PROVIDER: \"aischooseprovider\",\n    CHOOSE_PLAY_OPTIONS: \"aischooseplayoptions\",\n    LAUNCH_IDP_LOGIN: \"aislaunchidplogin\"\n  };\n\n  /**\n   * The AISLaunchIDPLoginCommand class.\n   *\n   * @constructor\n   * @private\n   * @extends {amp.plugins.PluginEventCommand}\n  */\n  function AISLaunchIDPLoginCommand() {\n    AISLaunchIDPLoginCommand.__super__.constructor.call(this);\n  }\n\n\n  __extends(AISLaunchIDPLoginCommand, PluginEventCommand);\n\n\n  /**\n   * Executes the command.\n   *\n   * @param {puremvc.Notification} notification\n   *    The notification.\n   *\n   * @override\n  */\n  AISLaunchIDPLoginCommand.prototype.execute = function(notification) {\n    AISLaunchIDPLoginCommand.__super__.execute.call(this, notification);\n    this.proxy.launchIDPLogin(notification.getBody());\n  };\n\n  /**\n   * The AISChooserMediator class.\n   *\n   * @constructor\n   * @private\n   * @extends {LocalizedMediator}\n  */\n  function AISChooserMediator(parent) {\n    AISChooserMediator.__super__.constructor.call(this, null, null, parent);\n  }\n\n\n  __extends(AISChooserMediator, ComponentMediator);\n\n\n  AISChooserMediator.prototype.componentName = \"ais-chooser\";\n\n  AISChooserMediator.prototype.menu = null;\n\n  AISChooserMediator.prototype.label = null;\n\n  AISChooserMediator.prototype.grid = null;\n\n  AISChooserMediator.prototype.select = null;\n\n  AISChooserMediator.prototype.login = null;\n\n  AISChooserMediator.prototype.title = null;\n\n  /**\n   * @override\n  */\n  AISChooserMediator.prototype.onRegister = function() {\n    var _this = this;\n    AISChooserMediator.__super__.onRegister.call(this);\n    this.classList.add(\"hidden\");\n    this.title = this.createText(\"ais-chooser-title\", \"Choose your provider\");\n    this.grid = this.create(\"ais-chooser-grid\");\n    this.menu = this.create(\"ais-chooser-menu\");\n    this.label = this.createText(\"ais-chooser-label\", \"Providers: \", this.menu);\n    this.select = this.create(\"ais-chooser-select\", this.menu, \"select\");\n    this.login = this.create(\"ais-chooser-login\", false, \"input\");\n    this.login.type = \"button\";\n    this.login.value = \"Login\";\n    EventHandler.create(this.login, EventHandler.CLICK, function(event) {\n      var idpID;\n      if (typeof event.stopImmediatePropagation === \"function\") {\n        event.stopImmediatePropagation();\n      }\n      idpID = _this.select.options[_this.select.selectedIndex].value;\n      _this.sendNotification(AISNotifications.LAUNCH_IDP_LOGIN, idpID);\n      return false;\n    });\n    this.menu.appendChild(this.login);\n  };\n\n  /**\n   * @override\n  */\n  AISChooserMediator.prototype.listNotificationInterests = function() {\n    return [AISNotifications.CHOOSE_AUTH_PROVIDER, AISNotifications.AUTHENTICATING];\n  };\n\n  /**\n   * @override\n  */\n  AISChooserMediator.prototype.handleNotification = function(notification) {\n    var baseURL, div, featuredGroup, footprints, group, groups, idp, idps, img, index, key, logos, member, option, options, proxy, resp, span, src, value, _i, _j, _k, _l, _len, _len1, _len2, _len3, _ref, _ref1,\n      _this = this;\n    switch (notification.getName()) {\n      case AISNotifications.CHOOSE_AUTH_PROVIDER:\n        resp = notification.getBody();\n        idps = resp.possible_idps;\n        footprints = resp.footprints || [];\n        groups = resp.grouped_idps || [];\n        proxy = this.facade.retrieveProxy(ModuleProxy.NAME);\n        logos = proxy.value.logos;\n        baseURL = logos != null ? logos.base : void 0;\n        this.grid.innerHTML = \"\";\n        if ((groups != null) && ((logos != null ? logos.group : void 0) != null)) {\n          for (_i = 0, _len = groups.length; _i < _len; _i++) {\n            group = groups[_i];\n            if (!(group.name === logos.group)) {\n              continue;\n            }\n            featuredGroup = group;\n            break;\n          }\n          if (featuredGroup != null) {\n            _ref = featuredGroup.members;\n            for (index = _j = 0, _len1 = _ref.length; _j < _len1; index = ++_j) {\n              member = _ref[index];\n              idp = idps[member];\n              div = this.create([\"ais-chooser-grid-item\", \"ais-chooser-grid-index-\" + (index + 1)], this.grid);\n              if (div.dataset == null) {\n                div.dataset = {};\n              }\n              div.dataset.key = member;\n              div.onclick = function(event) {\n                var idpID, target;\n                if (typeof event.stopImmediatePropagation === \"function\") {\n                  event.stopImmediatePropagation();\n                }\n                target = (event.currentTarget != null) ? event.currentTarget : event.srcElement;\n                idpID = target.dataset.key;\n                _this.sendNotification(AISNotifications.LAUNCH_IDP_LOGIN, idpID);\n                return false;\n              };\n              if (((_ref1 = idps[member].logos) != null ? _ref1[logos.key] : void 0) != null) {\n                img = this.create(\"ais-chooser-grid-cell-img\", div, \"img\");\n                img.alt = idp.display_name;\n                src = idp.logos[logos.key];\n                if (src.indexOf(\"http\") === -1) {\n                  src = baseURL + src;\n                }\n                img.src = src;\n                if (img.dataset == null) {\n                  img.dataset = {};\n                }\n                img.dataset.key = member;\n                span = this.create(\"ais-chooser-grid-cell-label\", div, \"span\");\n                span.innerHTML = idp.display_name;\n              } else {\n                div.innerHTML = idp.display_name;\n              }\n            }\n          }\n        }\n        if (this.grid.innerHTML !== \"\") {\n          this.classList.add(\"ais-chooser-featured\");\n          this.label.textContent = \"Other \";\n        }\n        options = this.select.options;\n        for (index = _k = 0, _len2 = options.length; _k < _len2; index = ++_k) {\n          option = options[index];\n          this.select.options.remove(index);\n        }\n        if (footprints.length > 0) {\n          for (_l = 0, _len3 = footprints.length; _l < _len3; _l++) {\n            key = footprints[_l];\n            options[options.length] = new Option(\"\" + idps[key].display_name, \"\" + key);\n          }\n        }\n        for (key in idps) {\n          value = idps[key];\n          options[options.length] = new Option(\"\" + value.display_name, \"\" + key);\n        }\n        this.classList.remove(\"hidden\");\n        break;\n      case AISNotifications.AUTHENTICATING:\n        this.classList.add(\"hidden\");\n    }\n  };\n\n  /**\n   * The AISPlayMediator class.\n   *\n   * @constructor\n   * @private\n   * @extends {LocalizedMediator}\n   * @param {Object} viewComponent\n  */\n  function AISPlayMediator(parent) {\n    AISPlayMediator.__super__.constructor.call(this, null, null, parent);\n  }\n\n\n  __extends(AISPlayMediator, ComponentMediator);\n\n\n  AISPlayMediator.prototype.componentName = \"ais-play\";\n\n  AISPlayMediator.prototype.menu = null;\n\n  AISPlayMediator.prototype.restart = null;\n\n  AISPlayMediator.prototype.resume = null;\n\n  AISPlayMediator.prototype.resumeTime = null;\n\n  /**\n   * @override\n  */\n  AISPlayMediator.prototype.onRegister = function() {\n    var _this = this;\n    AISPlayMediator.__super__.onRegister.call(this);\n    this.classList.add(\"hidden\");\n    this.menu = this.create(\"ais-play-menu\");\n    this.restart = this.create(\"ais-play-restart\", this.menu);\n    this.restart.type = \"button\";\n    this.restart.textContent = \"Restart\";\n    this.restart.onclick = function(event) {\n      if (typeof event.stopImmediatePropagation === \"function\") {\n        event.stopImmediatePropagation();\n      }\n      _this.play();\n      return false;\n    };\n    this.resume = this.create(\"ais-play-resume\", this.menu);\n    this.resume.type = \"button\";\n    this.resume.value = \"Resume\";\n    this.restart.onclick = function(event) {\n      if (typeof event.stopImmediatePropagation === \"function\") {\n        event.stopImmediatePropagation();\n      }\n      _this.play(_this.resumeTime);\n      return false;\n    };\n  };\n\n  AISPlayMediator.prototype.play = function(time) {\n    var proxy;\n    proxy = this.facade.retrieveProxy(AISProxy.NAME);\n    proxy.play(time);\n  };\n\n  /**\n   * @override\n  */\n  AISPlayMediator.prototype.listNotificationInterests = function() {\n    return [AISNotifications.CHOOSE_PLAY_OPTIONS];\n  };\n\n  /**\n   * @override\n  */\n  AISPlayMediator.prototype.handleNotification = function(notification) {\n    switch (notification.getName()) {\n      case AISNotifications.CHOOSE_PLAY_OPTIONS:\n        this.resumeTime = notification.getBody();\n        this.classList.remove(\"hidden\");\n    }\n  };\n\n  /**\n   * The AISAuthenticateMediaCommand class.\n   *\n   * @constructor\n   * @private\n   * @extends {amp.plugins.PluginCommand}\n  */\n  function AISAuthorizeCommand() {\n    AISAuthorizeCommand.__super__.constructor.call(this);\n  }\n\n\n  __extends(AISAuthorizeCommand, PluginCommand);\n\n\n  /**\n   * Executes the command.\n   *\n   * @param {puremvc.Notification} notification\n   *    The notification.\n   *\n   * @override\n  */\n  AISAuthorizeCommand.prototype.execute = function(notification) {\n    var reason;\n    reason = this.media.getData().status.reason;\n    if (reason === \"ais\" || reason === \"token\") {\n      this.proxy.authorize();\n    }\n  };\n\n  /**\n   * The AISAuthenticatingMediator class.\n   *\n   * @constructor\n   * @private\n   * @extends {LocalizedMediator}\n  */\n  function AISAuthenticatingMediator(parent) {\n    AISAuthenticatingMediator.__super__.constructor.call(this, null, null, parent);\n  }\n\n\n  __extends(AISAuthenticatingMediator, ComponentMediator);\n\n\n  AISAuthenticatingMediator.prototype.componentName = \"ais-authenticating\";\n\n  AISAuthenticatingMediator.prototype.retry = null;\n\n  /**\n   * @override\n  */\n  AISAuthenticatingMediator.prototype.onRegister = function() {\n    AISAuthenticatingMediator.__super__.onRegister.call(this);\n    this.classList.add(\"hidden\");\n    this.retry = this.create(\"ais-authenticating-button\");\n    this.retry.type = \"button\";\n    this.retry.value = \"Back to Providers\";\n    this.retry.onclick = this.onclick.bind(this);\n  };\n\n  /**\n  */\n  AISAuthenticatingMediator.prototype.onclick = function(event) {\n    if (typeof event.stopImmediatePropagation === \"function\") {\n      event.stopImmediatePropagation();\n    }\n    this.classList.add(\"hidden\");\n    this.sendNotification(AISNotifications.START_AUTHENTICATION);\n    return false;\n  };\n\n  /**\n   * @override\n  */\n  AISAuthenticatingMediator.prototype.listNotificationInterests = function() {\n    return [AISNotifications.AUTHENTICATING];\n  };\n\n  /**\n   * @override\n  */\n  AISAuthenticatingMediator.prototype.handleNotification = function(notification) {\n    switch (notification.getName()) {\n      case AISNotifications.AUTHENTICATING:\n        if (notification.getBody() === true) {\n          this.classList.remove(\"hidden\");\n        } else {\n          this.classList.add(\"hidden\");\n        }\n    }\n  };\n\n  /**\n   * The AISStartAuthenticationCommand class.\n   *\n   * @constructor\n   * @private\n   * @extends {amp.plugins.PluginEventCommand}\n  */\n  function AISStartAuthenticationCommand() {\n    AISStartAuthenticationCommand.__super__.constructor.call(this);\n  }\n\n\n  __extends(AISStartAuthenticationCommand, PluginEventCommand);\n\n\n  /**\n   * Executes the command.\n   *\n   * @param {puremvc.Notification} notification\n   *    The notification.\n   *\n   * @override\n  */\n  AISStartAuthenticationCommand.prototype.execute = function(notification) {\n    this.proxy.bounce();\n    AISStartAuthenticationCommand.__super__.execute.call(this, notification);\n  };\n\n  /**\n   * @constructor\n   * @private\n  */\n  function AISMediator() {\n    AISMediator.__super__.constructor.call(this);\n  }\n\n\n  __extends(AISMediator, OverlayMediator);\n\n\n  AISMediator.prototype.componentName = \"ais\";\n\n  AISMediator.prototype.chooser = null;\n\n  AISMediator.prototype.auth = null;\n\n  AISMediator.prototype.play = null;\n\n  AISMediator.prototype.onRegister = function() {\n    var _this = this;\n    AISMediator.__super__.onRegister.call(this);\n    this.classList.add(\"hidden\");\n    setTimeout(function() {\n      _this.chooser = new AISChooserMediator(_this);\n      _this.facade.registerMediator(_this.chooser);\n      _this.auth = new AISAuthenticatingMediator(_this);\n      _this.facade.registerMediator(_this.auth);\n      _this.play = new AISPlayMediator(_this);\n      return _this.facade.registerMediator(_this.play);\n    }, 20);\n  };\n\n  AISMediator.prototype.listNotificationInterests = function() {\n    return [AISNotifications.START_AUTHENTICATION, AISNotifications.AUTHENTICATION_COMPLETE, AISNotifications.CHOOSE_PLAY_OPTIONS, Notifications.MEDIA_CHANGE];\n  };\n\n  AISMediator.prototype.handleNotification = function(notification) {\n    switch (notification.getName()) {\n      case AISNotifications.CHOOSE_PLAY_OPTIONS:\n      case AISNotifications.START_AUTHENTICATION:\n        this.classList.remove(\"hidden\");\n        break;\n      case AISNotifications.AUTHENTICATION_COMPLETE:\n      case Notifications.MEDIA_CHANGE:\n        this.classList.add(\"hidden\");\n        this.facade.player.sendNotification(Notifications.REMOVE_APPLICATION_STATE, \"authenticating\");\n    }\n  };\n\n  /**\n   * The AISPlugin class.\n   *\n   * @param {Module}  app\n   *    The parent module of this plugin.\n   *\n   * @constructor\n   * @private\n   * @extends {Feature}\n  */\n  function AISPlugin() {\n    AISPlugin.__super__.constructor.call(this);\n  }\n\n\n  __extends(AISPlugin, Feature);\n\n\n  AISPlugin.NAME = \"AISPlugin\";\n\n  AISPlugin.prototype.moduleName = \"ais\";\n\n  AISPlugin.prototype.featureName = \"auth\";\n\n  AISPlugin.prototype.idps = null;\n\n  /** @override\n  */\n  AISPlugin.prototype.createController = function() {\n    AISPlugin.__super__.createController.call(this);\n    this.registerCommand(SecurityNotifications.AUTHORIZE, AISAuthorizeCommand);\n    this.registerCommand(AISNotifications.LAUNCH_IDP_LOGIN, AISLaunchIDPLoginCommand);\n    this.registerCommand(AISNotifications.START_AUTHENTICATION, AISStartAuthenticationCommand);\n    this.registerCommand(AISNotifications.AUTHENTICATED, PluginEventCommand);\n    this.registerCommand(AISNotifications.AUTHENTICATING, PluginEventCommand);\n    this.registerCommand(AISNotifications.AUTHENTICATION_COMPLETE, PluginEventCommand);\n    this.registerCommand(AISNotifications.CHOOSE_AUTH_PROVIDER, PluginEventCommand);\n    this.registerCommand(AISNotifications.CHOOSE_PLAY_OPTIONS, PluginEventCommand);\n    this.registerCommand(SecurityNotifications.AUTHORIZATION_FAILED, PluginEventCommand);\n  };\n\n  /** @override\n  */\n  AISPlugin.prototype.createModel = function() {\n    this.proxy = new AISProxy(this.config);\n    this.registerProxy(this.proxy);\n  };\n\n  /** @override\n  */\n  AISPlugin.prototype.createView = function() {\n    this.registerMediator(new AISMediator());\n  };\n\n  /** @override\n  */\n  AISPlugin.prototype.createNotificationEvent = function(notificationName, body, type) {\n    var event;\n    event = Module.prototype.createNotificationEvent.call(this, notificationName, body, type);\n    if (!(event != null)) {\n      return;\n    }\n    event.type = event.type.replace(new RegExp(\"^\" + (this.getModuleName())), \"\");\n    return event;\n  };\n\n  /** @override\n  */\n  AISPlugin.prototype.listNotificationInterests = function() {\n    return AISPlugin.__super__.listNotificationInterests.call(this).concat([Notifications.MEDIA_CHANGE, SecurityNotifications.AUTHORIZE]);\n  };\n\n  /**\n  */\n  AISPlugin.prototype.listNotificationPublications = function() {\n    return AISPlugin.__super__.listNotificationPublications.call(this).concat([SecurityNotifications.AUTHORIZED, SecurityNotifications.AUTHORIZATION_FAILED, Notifications.INITIALIZED, Notifications.PLAY, Notifications.SEEK]);\n  };\n\n  /**\n   * @expose\n  */\n  AISPlugin.prototype.authorize = function(media) {\n    this.proxy.authorize(media);\n    return media;\n  };\n\n  /**\n   * @expose\n  */\n  AISPlugin.prototype.logout = function() {\n    this.proxy.logout();\n  };\n\n  /**\n   * @return {Array.<Object>} The list of IDPs.\n   * @expose\n  */\n  AISPlugin.prototype.getIdps = function() {\n    return this.idps;\n  };\n\n\n  AMP.registerPlugin(\"ais\", \"html\", AISPlugin);\n\n  /**\n   * The AISFlashPlugin class.\n   *\n   * @param {Module}  app     The parent module of this plugin.\n   * @constructor\n   * @private\n   * @extends {Plugin}\n  */\n  function AISFlashPlugin() {\n    AISFlashPlugin.__super__.constructor.call(this);\n  }\n\n\n  __extends(AISFlashPlugin, AISPlugin);\n\n\n  AISFlashPlugin.NAME = \"AISFlashPlugin\";\n\n  AISFlashPlugin.prototype.proxy = null;\n\n  AISFlashPlugin.prototype.startTime = null;\n\n  /**\n  */\n  AISFlashPlugin.prototype.createController = function() {\n    this.registerCommand(Notifications.DISPATCH_EVENT, DispatchEventCommand);\n    this.registerCommand(AISNotifications.LAUNCH_IDP_LOGIN, AISLaunchIDPLoginCommand);\n    this.registerCommand(AISNotifications.START_AUTHENTICATION, AISStartAuthenticationCommand);\n    this.registerCommand(AISNotifications.AUTHENTICATED, PluginEventCommand);\n    this.registerCommand(AISNotifications.AUTHENTICATING, PluginEventCommand);\n    this.registerCommand(AISNotifications.AUTHENTICATION_COMPLETE, PluginEventCommand);\n    this.registerCommand(AISNotifications.CHOOSE_AUTH_PROVIDER, PluginEventCommand);\n    this.registerCommand(AISNotifications.CHOOSE_PLAY_OPTIONS, PluginEventCommand);\n    this.registerCommand(SecurityNotifications.AUTHORIZATION_FAILED, PluginEventCommand);\n  };\n\n  /**\n  */\n  AISFlashPlugin.prototype.setData = function(data) {\n    var proxy;\n    proxy = this.retrieveProxy(AISProxy.NAME);\n    proxy.data.platformID = data.platformID;\n    proxy.data.resourceID = data.resourceID;\n    proxy.data.contentID = data.contentID;\n  };\n\n  /**\n  */\n  AISFlashPlugin.prototype.authorize = function(media) {\n    this.retrieveProxy(AISProxy.NAME).authorize(media);\n  };\n\n  /**\n   * The AISTimeUpdateCommand class.\n   *\n   * @constructor\n   * @private\n   * @extends {amp.plugins.PluginCommand}\n  */\n  function AISTimeUpdateCommand() {\n    AISTimeUpdateCommand.__super__.constructor.call(this);\n  }\n\n\n  __extends(AISTimeUpdateCommand, PluginCommand);\n\n\n  /**\n   * Executes the command.\n   *\n   * @param {puremvc.Notification} notification\n   *    The notification.\n   *\n   * @override\n  */\n  AISTimeUpdateCommand.prototype.execute = function(notification) {\n    var currentTime;\n    currentTime = Math.floor(notification.getBody());\n    if (currentTime !== 0 && currentTime % 30 === 0 && currentTime !== this.proxy.currentTime) {\n      this.proxy.vcsSet(currentTime);\n    }\n    this.proxy.currentTime = currentTime;\n  };\n\n  /**\n   * @constructor\n   * @private\n   * @extends {PluginWrapper}\n  */\n  function AISWrapper(player, config) {\n    var dispatchEvent, key, value;\n    AISWrapper.__super__.constructor.call(this, player, config);\n    this.plugin = new AISFlashPlugin();\n    dispatchEvent = this.dispatcher.dispatchEvent.bind(this.dispatcher);\n    for (key in AISNotifications) {\n      value = AISNotifications[key];\n      this.plugin.addEventListener(value.replace(/^(ais)/, \"\"), dispatchEvent);\n    }\n    for (key in SecurityNotifications) {\n      value = SecurityNotifications[key];\n      this.plugin.addEventListener(value.replace(/^(auth)/, \"\"), dispatchEvent);\n    }\n    this.plugin.oninitialized = this.player.registerModule.bind(this.player, this.plugin);\n    this.plugin.initialize(config, this.player);\n  }\n\n\n  __extends(AISWrapper, PluginWrapper);\n\n\n  AISWrapper.NAME = \"AISWrapper\";\n\n  AISWrapper.prototype.plugin = null;\n\n  /**\n  */\n  AISWrapper.prototype.getFeatureName = function() {\n    return \"auth\";\n  };\n\n  /**\n  */\n  AISWrapper.prototype.createXML = function(xml) {\n    var application, auth, element, prop, props, text, vendor, _i, _len;\n    application = xml.firstChild;\n    auth = xml.getElementsByTagName(\"authentication\");\n    if (!(auth != null) || auth.length === 0) {\n      auth = xml.createElement(\"authentication\");\n      application.appendChild(auth);\n    } else {\n      auth = auth[0];\n    }\n    vendor = xml.createElement(\"vendor\");\n    vendor.setAttribute(\"id\", \"ais\");\n    auth.appendChild(vendor);\n    props = [\n      {\n        value: this.config.platformID,\n        key: \"platformID\"\n      }, {\n        value: this.config.resourceID,\n        key: \"resourceID\"\n      }, {\n        value: this.config.contentID,\n        key: \"contentID\"\n      }\n    ];\n    for (_i = 0, _len = props.length; _i < _len; _i++) {\n      prop = props[_i];\n      if (!(prop.value != null)) {\n        continue;\n      }\n      element = xml.createElement(\"property\");\n      element.setAttribute(\"key\", prop.key);\n      text = XMLUtils.createTextContent(xml, prop.value);\n      element.appendChild(text);\n      vendor.appendChild(element);\n    }\n    return xml;\n  };\n\n  /**\n  */\n  AISWrapper.prototype.listNotificationInterests = function() {\n    return AISWrapper.__super__.listNotificationInterests.apply(this, arguments).concat([SecurityNotifications.AUTHORIZE, FlashNotifications.TIME_UPDATE, FlashNotifications.ENDED, FlashNotifications.PAUSED, FlashNotifications.CAPABILITY_CHANGE, FlashNotifications.RESET]);\n  };\n\n  /**\n  */\n  AISWrapper.prototype.handleNotification = function(notification) {\n    var body, mediaProxy, name;\n    AISWrapper.__super__.handleNotification.call(this, notification);\n    name = notification.getName();\n    body = notification.getBody();\n    switch (name) {\n      case SecurityNotifications.AUTHORIZE:\n        this.plugin.startTime = null;\n        this.plugin.setData(body);\n        mediaProxy = this.player.retrieveProxy(MediaProxy.NAME);\n        if (!(mediaProxy.getSrc() != null)) {\n          mediaProxy.setSrc(body.media.src);\n        }\n        this.plugin.authorize();\n        break;\n      case FlashNotifications.TIME_UPDATE:\n        this.plugin.sendNotification(Notifications.TIME_UPDATE, body);\n        break;\n      case FlashNotifications.ENDED:\n        this.plugin.sendNotification(Notifications.ENDED, body);\n        break;\n      case FlashNotifications.PAUSED:\n        this.plugin.sendNotification(Notifications.PAUSE, body);\n        break;\n      case FlashNotifications.RESET:\n        this.plugin.sendNotification(Notifications.MEDIA_CHANGE, body);\n        break;\n      case FlashNotifications.CAPABILITY_CHANGE:\n        if ((this.plugin.startTime != null) && body.type === \"canSeekChange\" && body.enabled) {\n          this.player.setCurrentTime(this.plugin.startTime);\n        }\n    }\n  };\n\n  /**\n   * @expose\n  */\n  AISWrapper.prototype.authorize = function(media) {\n    this.plugin.authorize(media);\n    return media;\n  };\n\n  /**\n   * @expose\n  */\n  AISWrapper.prototype.logout = function() {\n    this.plugin.logout();\n  };\n\n  /**\n   * @return {Array.<Object>} The list of IDPs.\n   * @expose\n  */\n  AISWrapper.prototype.getIdps = function() {\n    return this.plugin.getIdps();\n  };\n\n\n  AMP.registerPlugin(\"ais\", \"flash\", AISWrapper);\n\n  /**\n   * The AISPauseCommand class.\n   *\n   * @constructor\n   * @private\n   * @extends {amp.plugins.PluginCommand}\n  */\n  function AISPauseCommand() {\n    AISPauseCommand.__super__.constructor.call(this);\n  }\n\n\n  __extends(AISPauseCommand, PluginCommand);\n\n\n  /**\n   * Executes the command.\n   *\n   * @param {puremvc.Notification} notification\n   *    The notification.\n   *\n   * @override\n  */\n  AISPauseCommand.prototype.execute = function(notification) {\n    this.proxy.vcsSet(this.proxy.currentTime);\n  };\n\n  /**\n   * The AISEndedCommand class.\n   *\n   * @constructor\n   * @private\n   * @extends {amp.plugins.PluginCommand}\n  */\n  function AISEndedCommand() {\n    AISEndedCommand.__super__.constructor.call(this);\n  }\n\n\n  __extends(AISEndedCommand, PluginCommand);\n\n\n  /**\n   * Executes the command.\n   *\n   * @param {puremvc.Notification} notification\n   *    The notification.\n   *\n   * @override\n  */\n  AISEndedCommand.prototype.execute = function(notification) {\n    this.proxy.vcsSet(0);\n  };\n\n  function Cookies() {}\n\n  Cookies.setCookie = function(name, value, days, path, domain) {\n    var expires;\n    value = escape(value);\n    if (days != null) {\n      expires = new Date();\n      expires.setDate(expires.getDate() + days);\n      value += \"; expires=\" + expires.toUTCString();\n    }\n    if (domain != null) {\n      value += \"; domain=\" + domain;\n    }\n    if (path != null) {\n      value += \"; path=\" + path;\n    }\n    return document.cookie = name + \"=\" + value;\n  };\n\n  Cookies.getCookie = function(name) {\n    var cookie, cookies, index, key, value, _i, _len;\n    cookies = document.cookie.split(\";\");\n    for (_i = 0, _len = cookies.length; _i < _len; _i++) {\n      cookie = cookies[_i];\n      index = cookie.indexOf(\"=\");\n      key = cookie.substr(0, index).replace(/^\\s+|\\s+$/g, \"\");\n      value = unescape(cookie.substr(index + 1));\n      if (key === name) {\n        return value;\n      }\n    }\n  };\n\n  Cookies.deleteCookie = function(name) {\n    return this.setCookie(name, \"\", -1);\n  };\n\n  /**\n   * The IMAPlugin class.\n   *\n   * @param {Module}  app     The parent module of this plugin.\n   * @constructor\n   * @private\n   * @extends {AdPlugin}\n  */\n  function IMAPlugin() {\n    IMAPlugin.__super__.constructor.call(this);\n  }\n\n\n  __extends(IMAPlugin, AdPlugin);\n\n\n  IMAPlugin.prototype.moduleName = \"ima\";\n\n  IMAPlugin.prototype.createFullscreenProxy = function() {\n    return new IMAFullscreenProxy(this.config);\n  };\n\n  IMAPlugin.prototype.createProxy = function() {\n    return new IMAProxy(this.config);\n  };\n\n  IMAPlugin.prototype.isFullscreenDevice = function() {\n    var ua;\n    ua = navigator.userAgent;\n    return Utils.isFullscreenDevice() || /Android 4\\.[0-1]/.test(ua) || /CrKey/.test(ua);\n  };\n\n  /** @override\n  */\n  IMAPlugin.prototype.createModel = function() {\n    IMAPlugin.__super__.createModel.call(this);\n    if (this.config.overlay != null) {\n      this.registerProxy(new IMAOverlayProxy(this.config.overlay));\n    }\n  };\n\n  /** @override\n  */\n  IMAPlugin.prototype.createController = function() {\n    IMAPlugin.__super__.createController.call(this);\n    if (this.config.overlay != null) {\n      this.registerCommand(IMANotifications.ADD_OVERLAY, IMAAddOverlayCommand);\n      this.registerCommand(IMANotifications.REMOVE_OVERLAY, IMARemoveOverlayCommand);\n    }\n    this.registerCommand(Notifications.READY, IMAReadyCommand);\n    this.registerCommand(Notifications.FULL_SCREEN_CHANGE, IMADisplayStateChangeCommand);\n    this.registerCommand(Notifications.CHANGE_ACTIVE_STATE, IMAActiveStateChangeCommand);\n  };\n\n  /** @override\n  */\n  IMAPlugin.prototype.createView = function() {\n    IMAPlugin.__super__.createView.call(this);\n    if (this.config.overlay != null) {\n      this.registerMediator(new IMAOverlayMediator());\n    }\n  };\n\n\n  AMP.registerPlugin(\"ima\", \"html\", IMAPlugin);\n  AMP.registerPlugin(\"ima\", \"flash\", IMAWrapper);\n\n  /**\n   * The AdContentPausedCommand class.\n   *\n   * @constructor\n   * @private\n   * @extends {AdCommand}\n  */\n  function AdContentPausedCommand() {\n    AdContentPausedCommand.__super__.constructor.call(this);\n  }\n\n\n  __extends(AdContentPausedCommand, PluginCommand);\n\n\n  /**\n   * Executes the command.\n   *\n   * @param {puremvc.Notification} notification\n   *    The notification.\n   *\n   * @override\n  */\n  AdContentPausedCommand.prototype.execute = function(notification) {\n    var fw;\n    fw = this.facade.retrieveProxy(AdProxy.NAME);\n    fw.contentPaused();\n  };\n\n  /**\n   * @constructor\n   * @private\n   * @extends {PluginProxy}\n  */\n  function AISProxy(config) {\n    AISProxy.__super__.constructor.call(this, config);\n  }\n\n\n  __extends(AISProxy, PluginProxy);\n\n\n  /** @static\n  */\n  AISProxy.NAME = ModuleProxy.NAME;\n\n  AISProxy.prototype.client = null;\n\n  AISProxy.prototype.currentTime = null;\n\n  AISProxy.prototype.idps = null;\n\n  AISProxy.prototype.idp = null;\n\n  AISProxy.prototype.token = null;\n\n  AISProxy.prototype.authz = null;\n\n  AISProxy.prototype.defaults = {\n    platformID: null,\n    resourceID: null,\n    contentID: null,\n    responseTargets: null,\n    query: \"hdnts\",\n    vcs: false,\n    logos: {\n      base: null,\n      group: null,\n      key: \"full\"\n    }\n  };\n\n  /** @override\n  */\n  AISProxy.prototype.getScript = function() {\n    return this.value.plugin;\n  };\n\n  /**\n  */\n  AISProxy.prototype.initialize = function() {\n    this.client = window.ais_client;\n    this.client.setLogging(this.facade.logger.enabled);\n    this.client.setPlatformId(this.value.platformID);\n    this.client.setUseCache(!/MSIE [7-8]/.test(navigator.userAgent));\n    this.client.assignhandler('bounce', this.bounceHandler.bind(this));\n    this.client.assignhandler('chooser', this.chooserHandler.bind(this));\n    this.client.assignhandler('init', this.initHandler.bind(this));\n    this.client.assignhandler('authz_query', this.authz_queryHandler.bind(this));\n    this.client.assignhandler('identity', this.identityHandler.bind(this));\n    this.client.assignhandler('logout_result', this.logoutHandler.bind(this));\n    this.client.assignhandler('vcs', this.vcsHandler.bind(this));\n    window.onunload = function() {};\n  };\n\n  /**\n  */\n  AISProxy.prototype.authorize = function() {\n    this.authz = null;\n    this.token = null;\n    this.disengage();\n    this.sendNotification(AISNotifications.START_AUTHENTICATION);\n  };\n\n  /**\n  */\n  AISProxy.prototype.authorized = function(token) {\n    if (token == null) {\n      token = this.token;\n    }\n    this.engage();\n    this.sendNotification(AISNotifications.AUTHENTICATION_COMPLETE);\n    this.sendNotification(SecurityNotifications.AUTHORIZED, token);\n  };\n\n  /**\n  */\n  AISProxy.prototype.play = function(time) {\n    this.sendNotification(Notifications.INITIALIZED);\n    this.sendNotification(Notifications.PLAY);\n    if (time != null) {\n      return this.sendNotification(Notifications.SEEK, time);\n    }\n  };\n\n  /**\n  */\n  AISProxy.prototype.engage = function() {\n    this.facade.registerCommand(Notifications.TIME_UPDATE, AISTimeUpdateCommand);\n    this.facade.registerCommand(Notifications.PAUSE, AISPauseCommand);\n    this.facade.registerCommand(Notifications.ENDED, AISEndedCommand);\n  };\n\n  /**\n  */\n  AISProxy.prototype.disengage = function() {\n    this.facade.removeCommand(Notifications.TIME_UPDATE);\n    this.facade.removeCommand(Notifications.PAUSE);\n    this.facade.removeCommand(Notifications.ENDED);\n  };\n\n  /**\n  */\n  AISProxy.prototype.logout = function() {\n    var height, method, target, width, _ref;\n    method = ((_ref = this.idp.window_display) != null ? _ref.method : void 0) || \"redirect\";\n    target = this.getTarget(method);\n    this.setRedirect(method);\n    switch (method) {\n      case \"redirect\":\n        window.open(this.client.logoutFormat(target), \"_top\");\n        break;\n      case \"popup\":\n        width = this.idp.window_display.width || 320;\n        height = this.idp.window_display.height || 240;\n        window.open(this.client.logoutFormat(target), 'ais_popup', 'width=' + width + ',height=' + height);\n    }\n  };\n\n  /**\n  */\n  AISProxy.prototype.bounce = function(resource) {\n    this.client.bounce();\n  };\n\n  /**\n  */\n  AISProxy.prototype.init = function(resource) {\n    this.client.init();\n  };\n\n  /**\n  */\n  AISProxy.prototype.choose = function() {\n    this.client.chooser();\n  };\n\n  /**\n  */\n  AISProxy.prototype.resourceAccess = function(resource) {\n    if (resource == null) {\n      resource = this.value.resourceID;\n    }\n    this.client.resourceAccess(resource);\n  };\n\n  /**\n  */\n  AISProxy.prototype.vcsSet = function(time) {\n    time = Utils.formatTimecode(time);\n    this.client.vcsSet(this.value.contentID, time);\n  };\n\n  /**\n  */\n  AISProxy.prototype.bounceHandler = function(type, resp) {\n    var auth;\n    auth = resp['authenticated'].toString() === 'true';\n    if (auth === false) {\n      this.sendNotification(Notifications.DISPATCH_EVENT, new Event(\"authenticationfailed\"));\n      this.choose();\n    } else if (auth === true) {\n      this.init();\n    }\n  };\n\n  /**\n  */\n  AISProxy.prototype.initHandler = function(type, resp) {\n    var key, key2, value, value2, _ref;\n    this.idp = resp.idps;\n    this.facade.idps = {};\n    _ref = resp.idps;\n    for (key in _ref) {\n      value = _ref[key];\n      this.facade.idps.key = key;\n      for (key2 in value) {\n        value2 = value[key2];\n        this.facade.idps[key2] = value2;\n      }\n      break;\n    }\n    for (key in resp) {\n      value = resp[key];\n      if (key !== \"idps\" && (value != null)) {\n        this.facade[key] = value;\n      }\n    }\n    if ((this.value.logos != null) && (this.facade.idps.logos != null)) {\n      this.facade.idps.logo = this.value.logos.base + this.facade.idps.logos[this.value.logos.key];\n    }\n    this.facade.player.sendNotification(Notifications.REMOVE_APPLICATION_STATE, \"authenticating\");\n    this.sendNotification(AISNotifications.AUTHENTICATED, this.facade.idps);\n    this.resourceAccess(this.value.resourceID);\n  };\n\n  /**\n  */\n  AISProxy.prototype.chooserHandler = function(type, resp) {\n    this.facade.sendNotification(Notifications.ADD_APPLICATION_STATE, \"authenticating\");\n    resp.possible_idps = this.idps = this.sort(resp.possible_idps, 'value', 'display_name');\n    this.sendNotification(AISNotifications.CHOOSE_AUTH_PROVIDER, resp);\n  };\n\n  AISProxy.prototype.launchIDPLogin = function(idp_platform_id) {\n    var height, idp, method, target, width, _ref;\n    this.sendNotification(AISNotifications.AUTHENTICATING, true);\n    idp = this.idps[idp_platform_id];\n    method = ((_ref = idp.window_display) != null ? _ref.method : void 0) || \"redirect\";\n    target = this.getTarget(method);\n    this.setRedirect(method);\n    switch (method) {\n      case \"redirect\":\n        window.open(this.client.loginFormat(idp_platform_id, target), \"_top\");\n        break;\n      case \"popup\":\n        method = idp.window_display.method || \"popup\";\n        width = idp.window_display.width || 320;\n        height = idp.window_display.height || 240;\n        window.open(this.client.loginFormat(idp_platform_id, target), 'ais_popup', 'width=' + width + ',height=' + height);\n    }\n  };\n\n  /**\n  */\n  AISProxy.prototype.identityHandler = function(type, resp) {\n    var aisuid;\n    aisuid = resp['identity']['attributes']['aisuid'];\n  };\n\n  /**\n  */\n  AISProxy.prototype.authz_queryHandler = function(type, resp) {\n    var auth, dimensions, resource, security;\n    auth = resp['authorization'].toString() === \"true\";\n    if (auth === false) {\n      this.sendNotification(SecurityNotifications.AUTHORIZATION_FAILED, resp);\n    } else if (auth === true) {\n      this.authz = resp;\n      dimensions = {\n        mvpdName: this.facade.idps.name,\n        viewerId: this.client.aisuid,\n        \"std:viewerId\": this.client.aisuid\n      };\n      this.facade.player.setParams({\n        \"mvpdname\": dimensions.mvpdName\n      });\n      this.facade.player.sendNotification(MediaAnalyticsNotifications.SET_DIMENSIONS, dimensions);\n      this.facade.viewerId = this.client.aisuid;\n      resource = resp['resource'];\n      if (resource != null) {\n        this.facade.resource = resource;\n      }\n      security = this.facade.player.security;\n      security.setKey(this.value.query || this.getDefaults().query);\n      security.setToken(resp['security_token']);\n      this.token = security.getSecret();\n      this.sendNotification(AISNotifications.AUTHENTICATING, false);\n      if (this.value.vcs === true && (this.value.contentID != null)) {\n        this.client.vcsGet(this.value.contentID);\n      } else {\n        this.authorized(this.token);\n      }\n    }\n  };\n\n  /**\n  */\n  AISProxy.prototype.logoutHandler = function(type, resp) {\n    top.location.href = top.location.href;\n  };\n\n  /**\n  */\n  AISProxy.prototype.vcsHandler = function(type, resp) {\n    if (resp['operation'] === 'get') {\n      if (resp['ph_pos'] === '00:00:00' || resp['ph_pos'] === \"00:00\") {\n        this.client.vcsSet(this.value.contentID, resp['ph_pos']);\n        this.authorized(this.token);\n      } else {\n        this.sendNotification(AISNotifications.CHOOSE_PLAY_OPTIONS, Utils.flattenTimecode(resp['ph_pos']));\n      }\n    }\n  };\n\n  /**\n  */\n  AISProxy.prototype.sort = function(obj, sortType, valueName) {\n    var data, index, item, key, returnObj, value, _i, _len;\n    returnObj = {};\n    data = [];\n    index = 0;\n    for (key in obj) {\n      value = obj[key];\n      data[index] = {\n        key: key,\n        value: value[valueName]\n      };\n      index++;\n    }\n    data.sort(function(a, b) {\n      var valueA, valueB, _ref, _ref1, _ref2, _ref3;\n      valueA = sortType === 'value' ? (_ref = a.value) != null ? _ref.toLowerCase() : void 0 : (_ref1 = a.key) != null ? _ref1.toLowercase() : void 0;\n      valueB = sortType === 'value' ? (_ref2 = b.value) != null ? _ref2.toLowerCase() : void 0 : (_ref3 = b.key) != null ? _ref3.toLowercase() : void 0;\n      if (valueA < valueB) {\n        return -1;\n      } else if (valueA > valueB) {\n        return 1;\n      } else {\n        return 0;\n      }\n    });\n    for (index = _i = 0, _len = data.length; _i < _len; index = ++_i) {\n      item = data[index];\n      returnObj[item.key] = obj[item.key];\n    }\n    return returnObj;\n  };\n\n  /**\n  */\n  AISProxy.prototype.setRedirect = function(method) {\n    var devToken, domain, loc;\n    try {\n      devToken = /\\/dev\\./;\n      loc = window.top.location.href || window.top.location;\n      domain = devToken.test(loc) ? loc.replace(devToken, \"/\") : null;\n      Cookies.setCookie(this.getTarget(method), loc, 1, \"/\", domain);\n    } catch (error) {\n\n    }\n  };\n\n  /**\n  */\n  AISProxy.prototype.getTarget = function(method) {\n    if (method == null) {\n      method = \"redirect\";\n    }\n    return this.value.responseTargets[method];\n  };\n\n  function FreeWheelWrapper() {\n    return FreeWheelWrapper.__super__.constructor.apply(this, arguments);\n  }\n\n\n  __extends(FreeWheelWrapper, AdWrapper);\n\n\n  FreeWheelWrapper.NAME = \"FreeWheelWrapper\";\n\n  FreeWheelWrapper.prototype.partner = \"freewheel\";\n\n  FreeWheelWrapper.prototype.flashPlugins = [\n    {\n      id: \"FreewheelPlugin\",\n      src: '#{paths.resources}plugins/FreewheelPlugin.swf',\n      blocking: false,\n      host: \"akamai\",\n      main: \"FreewheelPlugin\"\n    }, {\n      id: \"AdOptionsPlugin\",\n      src: '#{paths.resources}plugins/AdOptionsPlugin.swf',\n      blocking: false,\n      host: \"akamai\",\n      main: \"AdOptionsPlugin\",\n      type: \"application/x-shockwave-flash\"\n    }\n  ];\n\n  /** @override\n  */\n  FreeWheelWrapper.prototype.createXML = function(xml) {\n    var admedia, application, key, keyValue, prop, props, value, vendor, _i, _len, _ref;\n    application = xml.firstChild;\n    admedia = xml.getElementsByTagName(\"admedia\")[0];\n    if (!(admedia != null)) {\n      admedia = xml.createElement(\"admedia\");\n      application.appendChild(admedia);\n    }\n    vendor = xml.createElement(\"vendor\");\n    vendor.setAttribute(\"id\", \"freewheel\");\n    admedia.appendChild(vendor);\n    props = [\n      {\n        value: this.config.plugin.swf,\n        key: \"FREEWHEEL_AD_MANAGER_URL\"\n      }, {\n        value: this.config.serverUrl,\n        key: \"FREEWHEEL_SERVER_URL\"\n      }, {\n        value: this.config.networkId,\n        key: \"FREEWHEEL_NETWORK_ID\"\n      }, {\n        value: this.config.profileId,\n        key: \"FREEWHEEL_PROFILE\"\n      }, {\n        value: this.config.siteSectionId,\n        key: \"FREEWHEEL_SITE_SECTION_ID\"\n      }, {\n        value: this.config.siteSectionFallbackId,\n        key: \"FREEWHEEL_SITE_SECTION_FALLBACK_ID\"\n      }, {\n        value: this.config.prerollSlotId,\n        key: \"FREEWHEEL_PREROLL_SLOT_ID\"\n      }, {\n        value: this.config.midrollSlotId,\n        key: \"FREEWHEEL_MIDROLL_SLOT_ID\"\n      }, {\n        value: this.config.postrollSlotId,\n        key: \"FREEWHEEL_POSTROLL_SLOT_ID\"\n      }, {\n        value: this.config.videoAssetId,\n        key: \"FREEWHEEL_VIDEO_ASSET_ID\"\n      }, {\n        value: this.config.videoAssetFallbackId,\n        key: \"FREEWHEEL_VIDEO_ASSET_FALLBACK_ID\"\n      }, {\n        value: this.config.videoAssetVideoPlayRandom,\n        key: \"FREEWHEEL_VIDEO_ASSET_VIDEO_PLAY_RANDOM\"\n      }, {\n        value: this.config.visitorId,\n        key: \"FREEWHEEL_VISITOR_ID\"\n      }, {\n        value: this.config.keyValuesString,\n        key: \"FREEWHEEL_KEY_VALUES_STRING\"\n      }, {\n        value: this.config,\n        key: \"FREEWHEEL_SITE_SECTION_PAGE_VIEW_RANDOM\"\n      }, {\n        value: \"EXACT\",\n        key: \"FREEWHEEL_VIDEO_ASSET_DURATION_TYPE\"\n      }, {\n        value: this.config.visitorHeader,\n        key: \"FREEWHEEL_VISITOR_HTTP_HEADER_KEY_VALUE\"\n      }, {\n        value: this.config.synchronizeMultipleRequests,\n        key: \"FREEWHEEL_SYNCHRONIZE_MULTIPLE_REQUESTS\"\n      }, {\n        value: this.config.subsessionToken,\n        key: \"FREEWHEEL_SUBSESSION_TOKEN\"\n      }\n    ];\n    for (_i = 0, _len = props.length; _i < _len; _i++) {\n      prop = props[_i];\n      if (prop.value != null) {\n        this.createProperty(xml, prop.key, prop.value, vendor);\n      }\n    }\n    if (this.config.position != null) {\n      vendor.setAttribute(\"position\", this.config.position);\n    }\n    if (this.config.keyValues != null) {\n      keyValue = xml.createElement(\"property\");\n      keyValue.setAttribute(\"key\", \"FREEWHEEL_KEY_VALUE\");\n      _ref = this.config.keyValues;\n      for (key in _ref) {\n        value = _ref[key];\n        if (value != null) {\n          this.createProperty(xml, key, value, keyValue);\n        }\n      }\n      vendor.appendChild(keyValue);\n    }\n  };\n\n  /**\n   * @constructor\n   * @private\n  */\n  function FreeWheelProxy(config) {\n    this.media = {};\n    this.handlers = {\n      onRequestComplete: this.onRequestComplete.bind(this),\n      onSlotStarted: this.onSlotStarted.bind(this),\n      onSlotEnded: this.onSlotEnded.bind(this),\n      onAdImpression: this.onAdImpression.bind(this),\n      onAdImpressionEnd: this.onAdImpressionEnd.bind(this),\n      onAdClick: this.onAdClick.bind(this),\n      onResume: this.onResume.bind(this),\n      adtimeupdate: this.adTimeupdate.bind(this),\n      timeupdate: this.midrollCheck.bind(this),\n      seekupdate: this.seekingHandler.bind(this),\n      onAdEvent: this.onAdEvent.bind(this)\n    };\n    FreeWheelProxy.__super__.constructor.call(this, config);\n    this.adVO = this.createDefaultAdVO();\n  }\n\n\n  __extends(FreeWheelProxy, AdProxy);\n\n\n  /** @static\n  */\n  FreeWheelProxy.NAME = AdProxy.NAME;\n\n  FreeWheelProxy.prototype.partner = \"freewheel\";\n\n  FreeWheelProxy.prototype.context = null;\n\n  FreeWheelProxy.prototype.prerollSlots = null;\n\n  FreeWheelProxy.prototype.midrollSlots = null;\n\n  FreeWheelProxy.prototype.postrollSlots = null;\n\n  FreeWheelProxy.prototype.initialized = false;\n\n  FreeWheelProxy.prototype.playWhenLoaded = false;\n\n  FreeWheelProxy.prototype.handlers = null;\n\n  FreeWheelProxy.prototype.slot = null;\n\n  FreeWheelProxy.prototype.playbackCore = null;\n\n  FreeWheelProxy.prototype.nextMidroll = null;\n\n  FreeWheelProxy.prototype.midrollEngaged = false;\n\n  FreeWheelProxy.prototype.timeout = null;\n\n  FreeWheelProxy.prototype.curTime = 0;\n\n  FreeWheelProxy.prototype.mediator = null;\n\n  FreeWheelProxy.prototype.adPosition = 1;\n\n  FreeWheelProxy.prototype.currentAd = null;\n\n  FreeWheelProxy.prototype.defaults = {\n    networkId: \"96749\",\n    serverUrl: \"http://demo.v.fwmrm.net/ad/g/1\",\n    profileId: \"global-js\",\n    siteSectionId: \"DemoSiteGroup.01\",\n    siteSectionFallbackId: null,\n    siteSectionPageViewRandom: null,\n    videoAssetId: '#{media.guid}',\n    videoAssetFallbackId: null,\n    videoAssetVideoPlayRandom: null,\n    prerollSlotId: null,\n    midrollSlotId: null,\n    postrollSlotId: null,\n    visitorId: null,\n    keyValues: null,\n    keyValuesString: null,\n    renderers: null,\n    synchronizeMultipleRequests: null,\n    subsessionToken: null,\n    creativeParameters: null,\n    parameters: null\n  };\n\n  /**\n  */\n  FreeWheelProxy.prototype.initialize = function() {\n    var debug, level;\n    debug = this.getDebug();\n    switch (true) {\n      case debug === true:\n        level = tv.freewheel.SDK.LOG_LEVEL_INFO;\n        break;\n      case typeof debug === \"number\":\n        level = debug;\n        break;\n      default:\n        level = tv.freewheel.SDK.LOG_LEVEL_QUIET;\n    }\n    tv.freewheel.SDK.setLogLevel(level);\n    this.plugin = this.createPlugin();\n    this.plugin.setNetwork(this.value.networkId);\n    this.plugin.setServer(this.value.serverUrl);\n  };\n\n  FreeWheelProxy.prototype.createPlugin = function() {\n    return new tv.freewheel.SDK.AdManager();\n  };\n\n  /**\n  */\n  FreeWheelProxy.prototype.engage = function(media) {\n    this.media = media;\n    FreeWheelProxy.__super__.engage.call(this, media);\n    this.requestAd();\n  };\n\n  /**\n  */\n  FreeWheelProxy.prototype.requestAd = function() {\n    var cuePoints, index, key, keyValue, mediaElement, pair, pairs, parameter, renderer, renderers, scene, time, value, _i, _j, _k, _l, _len, _len1, _len2, _len3, _ref, _ref1, _ref2, _ref3;\n    this.terminateAllAds(true);\n    this.context = this.plugin.newContext();\n    if (this.value.synchronizeMultipleRequests != null) {\n      this.context.setCapability(\"sync\", this.value.synchronizeMultipleRequests ? tv.freewheel.SDK.CAPABILITY_STATUS_ON : tv.freewheel.SDK.CAPABILITY_STATUS_OFF);\n    }\n    this.context.registerVideoDisplayBase(this.facade.player.viewComponent.id);\n    mediaElement = this.getMediaElement();\n    if (mediaElement.nodeName.toLowerCase() !== \"video\") {\n      this.sendNotification(Notifications.PLAYBACK_CORE_CHANGE, this.facade.player.mediator);\n      this.mediator = this.facade.player.retrieveProxy(PlayerProxy.NAME).getActivePlaybackCore().mediator;\n    }\n    this.context.setContentVideoElement(this.getMediaElement());\n    this.context.setProfile(this.value.profileId);\n    this.context.setVideoAsset(this.value.videoAssetId, this.media.duration, this.value.networkId, null, null, this.value.videoAssetVideoPlayRandom, null, this.value.videoAssetFallbackId);\n    this.context.setSiteSection(this.value.siteSectionId, this.value.networkId, this.value.siteSectionPageViewRandom, null, this.value.siteSectionFallbackId);\n    if (this.value.subsessionToken != null) {\n      this.context.startSubsession(this.value.subsessionToken);\n    }\n    if (this.value.visitorId != null) {\n      this.context.setVisitor(this.value.visitorId);\n    }\n    if (this.value.keyValues != null) {\n      _ref = this.value.keyValues;\n      for (key in _ref) {\n        value = _ref[key];\n        if (value != null) {\n          this.context.addKeyValue(key, value);\n        }\n      }\n    }\n    if (this.value.keyValuesString != null) {\n      pairs = this.value.keyValuesString.split(\"&\");\n      for (_i = 0, _len = pairs.length; _i < _len; _i++) {\n        pair = pairs[_i];\n        if (!(pair !== \"\")) {\n          continue;\n        }\n        keyValue = pair.split(\"=\");\n        this.context.addKeyValue(keyValue[0], keyValue[1]);\n      }\n    }\n    this.context.addEventListener(tv.freewheel.SDK.EVENT_REQUEST_COMPLETE, this.handlers.onRequestComplete);\n    this.context.addEventListener(tv.freewheel.SDK.EVENT_SLOT_STARTED, this.handlers.onSlotStarted);\n    this.context.addEventListener(tv.freewheel.SDK.EVENT_SLOT_ENDED, this.handlers.onSlotEnded);\n    this.context.addEventListener(tv.freewheel.SDK.EVENT_AD_IMPRESSION, this.handlers.onAdImpression);\n    this.context.addEventListener(tv.freewheel.SDK.EVENT_AD_IMPRESSION_END, this.handlers.onAdImpressionEnd);\n    this.context.addEventListener(tv.freewheel.SDK.EVENT_AD_CLICK, this.handlers.onAdClick);\n    this.context.addEventListener(tv.freewheel.SDK.EVENT_AD, this.handlers.onAdEvent);\n    this.context.setParameter(tv.freewheel.SDK.PARAMETER_RENDERER_VIDEO_START_DETECT_TIMEOUT, 10000, tv.freewheel.SDK.PARAMETER_LEVEL_GLOBAL);\n    this.context.setParameter(tv.freewheel.SDK.PARAMETER_RENDERER_VIDEO_PROGRESS_DETECT_TIMEOUT, 10000, tv.freewheel.SDK.PARAMETER_LEVEL_GLOBAL);\n    this.context.setParameter(tv.freewheel.SDK.PARAMETER_EXTENSION_CONTENT_VIDEO_AUTO_SOURCE_RESTORE, false, tv.freewheel.SDK.PARAMETER_LEVEL_GLOBAL);\n    this.context.setParameter(tv.freewheel.SDK.PARAMETER_RENDERER_VIDEO_DISPLAY_CONTROLS_WHEN_PAUSE, false, tv.freewheel.SDK.PARAMETER_LEVEL_GLOBAL);\n    this.context.setParameter(tv.freewheel.SDK.PARAMETER_EXTENSION_CONTENT_VIDEO_AUTO_SOURCE_RESTORE, false, tv.freewheel.SDK.PARAMETER_LEVEL_GLOBAL);\n    if (this.value.parameters != null) {\n      _ref1 = this.value.parameters;\n      for (_j = 0, _len1 = _ref1.length; _j < _len1; _j++) {\n        parameter = _ref1[_j];\n        this.context.setParameter(parameter.key, parameter.value, parameter.level || tv.freewheel.SDK.PARAMETER_LEVEL_GLOBAL);\n      }\n    }\n    if (this.value.prerollSlotId != null) {\n      this.context.addTemporalSlot(this.value.prerollSlotId, tv.freewheel.SDK.ADUNIT_PREROLL, 0);\n    }\n    if (((_ref2 = this.media.scenes) != null ? _ref2.length : void 0) > 0 && (this.value.midrollSlotId != null)) {\n      cuePoints = [];\n      _ref3 = this.media.scenes;\n      for (index = _k = 0, _len2 = _ref3.length; _k < _len2; index = ++_k) {\n        scene = _ref3[index];\n        if (!(index > 0)) {\n          continue;\n        }\n        time = Utils.flattenTimecode(scene.sceneStartTime);\n        cuePoints.push(time);\n        this.context.addTemporalSlot(this.value.midrollSlotId, tv.freewheel.SDK.ADUNIT_MIDROLL, time);\n      }\n      this.facade.player.sendNotification(Notifications.ADD_CUE_POINTS, cuePoints);\n    }\n    if (this.value.postrollSlotId != null) {\n      this.context.addTemporalSlot(this.value.postrollSlotId, tv.freewheel.SDK.ADUNIT_POSTROLL, this.media.duration);\n    }\n    renderers = this.value.renderers;\n    if ((renderers != null ? renderers.length : void 0) > 0) {\n      for (_l = 0, _len3 = renderers.length; _l < _len3; _l++) {\n        renderer = renderers[_l];\n        this.context.addRenderer(renderer.url, renderer.baseUnit, renderer.contentType, renderer.slotType, renderer.soAdUnit, renderer.creativeApi, renderer.parameters);\n      }\n    }\n    this.initialized = false;\n    FreeWheelProxy.__super__.requestAd.call(this);\n    this.context.submitRequest();\n    this.facade.getViewComponent().container.style.pointerEvents = \"none\";\n  };\n\n  /**\n  */\n  FreeWheelProxy.prototype.reset = function() {\n    FreeWheelProxy.__super__.reset.call(this);\n    if (this.mediator != null) {\n      this.sendNotification(Notifications.PLAYBACK_CORE_CHANGE, this.mediator);\n      this.mediator = null;\n    }\n    this.facade.registerCommand(Notifications.PAUSED, AdContentPausedCommand);\n  };\n\n  /**\n  */\n  FreeWheelProxy.prototype.onRequestComplete = function(event) {\n    var createAdBreakVO, cues, slot, slots, _i, _len,\n      _this = this;\n    cues = [];\n    this.pods = [];\n    createAdBreakVO = function(slot) {\n      return new AdVO(slot.getCustomId(), slot.getCustomId(), slot.getTotalDuration(), 0, slot.getTimePositionClass().toLowerCase(), \"freewheel\", null, null, null, slot, slot.getAdCount(), slot.getTimePosition());\n    };\n    if (event.success) {\n      slots = this.context.getTemporalSlots();\n      for (_i = 0, _len = slots.length; _i < _len; _i++) {\n        slot = slots[_i];\n        switch (slot.getTimePositionClass()) {\n          case tv.freewheel.SDK.TIME_POSITION_CLASS_PREROLL:\n            if (this.value.prerollSlotId != null) {\n              this.pods.push(createAdBreakVO(slot));\n              this.prerollSlots.push(slot);\n            }\n            break;\n          case tv.freewheel.SDK.TIME_POSITION_CLASS_MIDROLL:\n            if (this.value.midrollSlotId != null) {\n              this.pods.push(createAdBreakVO(slot));\n              cues.push(slot.getTimePosition());\n              this.midrollSlots.push(slot);\n            }\n            break;\n          case tv.freewheel.SDK.TIME_POSITION_CLASS_POSTROLL:\n            if (this.value.postrollSlotId != null) {\n              this.pods.push(createAdBreakVO(slot));\n              this.postrollSlots.push(slot);\n            }\n        }\n      }\n    }\n    if (cues.length > 0) {\n      this.sendNotification(Notifications.ADD_CUE_POINTS, cues);\n    }\n    if (this.postrollSlots.length > 0) {\n      this.sendNotification(Notifications.HAS_POST_CONTENT, true);\n    }\n    this.initialized = true;\n    this.pods.sort(function(a, b) {\n      return a.time - b.time;\n    });\n    this.pods.forEach(function(pod, index) {\n      return pod.position = index;\n    });\n    this.sendNotification(AdNotifications.REQUEST_COMPLETE, {\n      pods: this.pods\n    });\n    this.sendNotification(AdNotifications.RESPONSE, {\n      pods: this.pods,\n      response: event,\n      context: this.context\n    });\n    if (this.playWhenLoaded === true) {\n      this.startAd();\n    }\n  };\n\n  /** @override\n  */\n  FreeWheelProxy.prototype.breakStart = function() {\n    var video;\n    FreeWheelProxy.__super__.breakStart.call(this);\n    this.adPosition = 1;\n    this.playbackCore = this.facade.player.retrieveProxy(PlayerProxy.NAME).getActivePlaybackCore();\n    this.playbackCore.setEnabled(false);\n    this.getMediaElement().removeEventListener(\"playing\", this.handlers.onResume);\n    video = this.getMediaElement();\n    video.addEventListener(\"playing\", this.playbackCore.handlers.playing);\n    video.addEventListener(\"pause\", this.playbackCore.handlers.pause);\n    video.addEventListener(\"waiting\", this.playbackCore.handlers.waiting);\n    video.addEventListener(\"seeking\", this.handlers.seekupdate);\n    this.timeout = setInterval(function() {\n      return this.curTime = video.currentTime;\n    }, 500);\n    if (this.adVO.type === \"midroll\") {\n      this.contentPause();\n    }\n  };\n\n  /** Prevent seeking during pre-roll\n  */\n  FreeWheelProxy.prototype.seekingHandler = function(event) {\n    if (event.target.currentTime > this.curTime) {\n      event.target.currentTime = this.curTime;\n    }\n  };\n\n  /**\n  */\n  FreeWheelProxy.prototype.onAdImpression = function(event) {\n    var rendition, _base, _ref, _ref1, _ref2;\n    if (((_ref = event.adInstance) != null ? typeof _ref.getSlot === \"function\" ? typeof (_base = _ref.getSlot()).getTimePositionClass === \"function\" ? _base.getTimePositionClass() : void 0 : void 0 : void 0) === tv.freewheel.SDK.TIME_POSITION_CLASS_DISPLAY) {\n      return;\n    }\n    this.currentAd = event.adInstance;\n    this.adVO.position = this.adPosition++;\n    this.adVO.id = this.currentAd.getAdId();\n    this.adVO.duration = (_ref1 = event.adInstance) != null ? _ref1.getDuration() : void 0;\n    rendition = (_ref2 = this.currentAd) != null ? _ref2.getActiveCreativeRendition() : void 0;\n    if (rendition != null) {\n      this.adVO.metadata.adwidth = rendition.getWidth();\n      this.adVO.metadata.adheight = rendition.getHeight();\n    }\n    this.sendNotification(AdNotifications.IMPRESSION, this.adVO);\n    this.sendNotification(AdNotifications.AD_STARTED, this.adVO);\n  };\n\n  /**\n  */\n  FreeWheelProxy.prototype.onAdEvent = function(event) {\n    switch (event.subType) {\n      case tv.freewheel.SDK.EVENT_AD_FIRST_QUARTILE:\n        this.sendNotification(AdNotifications.FIRST_QUARTILE, this.adVO);\n        break;\n      case tv.freewheel.SDK.EVENT_AD_MIDPOINT:\n        this.sendNotification(AdNotifications.MIDPOINT, this.adVO);\n        break;\n      case tv.freewheel.SDK.EVENT_AD_THIRD_QUARTILE:\n        this.sendNotification(AdNotifications.THIRD_QUARTILE, this.adVO);\n    }\n  };\n\n  /**\n  */\n  FreeWheelProxy.prototype.onAdImpressionEnd = function(event) {\n    this.sendNotification(AdNotifications.AD_ENDED, this.adVO);\n  };\n\n  /**\n  */\n  FreeWheelProxy.prototype.onAdClick = function(event) {\n    var paused;\n    paused = this.getMediaElement().paused;\n    if (paused === false) {\n      this.pause();\n    }\n    this.sendNotification(AdNotifications.AD_CLICKED, this.adVO);\n  };\n\n  /**\n  */\n  FreeWheelProxy.prototype.onResume = function(event) {\n    this.context.setVideoState(tv.freewheel.SDK.VIDEO_STATE_PLAYING);\n    this.getMediaElement().removeEventListener(\"playing\", this.handlers.onResume);\n  };\n\n  /**\n  */\n  FreeWheelProxy.prototype.adTimeupdate = function(event) {\n    try {\n      if (this.slot != null) {\n        this.currentAd = this.slot.getCurrentAdInstance();\n        if (this.currentAd != null) {\n          this.adVO.duration = this.currentAd.getDuration();\n          this.sendNotification(AdNotifications.AD_TIME_UPDATE, this.currentAd.getPlayheadTime());\n          this.sendNotification(AdNotifications.AD_TIME_REMAINING, this.currentAd.getDuration() - this.currentAd.getPlayheadTime());\n        }\n      }\n    } catch (error) {\n      this.facade.logger.error(\"[AMP FREEWHEEL ERROR]\", error);\n    }\n  };\n\n  /**\n  */\n  FreeWheelProxy.prototype.onSlotStarted = function(event) {\n    var slot;\n    slot = event.slot;\n    if (slot.getType() !== \"temporal\") {\n      return;\n    }\n    this.slot = slot;\n    this.getMediaElement().addEventListener(\"timeupdate\", this.handlers.adtimeupdate);\n  };\n\n  /**\n  */\n  FreeWheelProxy.prototype.onSlotEnded = function(event) {\n    var complete, index, midroll, pod, slot, slotTimePositionClass;\n    slot = event.slot;\n    complete = event.skipped === true ? this.sendNotification.bind(this, AdNotifications.BREAK_SKIPPED, slot) : this.endBreak.bind(this);\n    if (slot.getType() !== \"temporal\") {\n      return;\n    }\n    this.getMediaElement().removeEventListener(\"timeupdate\", this.handlers.adtimeupdate);\n    slotTimePositionClass = slot.getTimePositionClass();\n    pod = this.getPodById(slot.getCustomId());\n    pod.locked = true;\n    this.slot = null;\n    switch (slotTimePositionClass) {\n      case tv.freewheel.SDK.TIME_POSITION_CLASS_PREROLL:\n        if (this.prerollSlots.length) {\n          this.prerollSlots.shift();\n          if (this.prerollSlots.length) {\n            this.playAd(this.prerollSlots[0]);\n          } else {\n            complete();\n          }\n        }\n        break;\n      case tv.freewheel.SDK.TIME_POSITION_CLASS_MIDROLL:\n        index = this.midrollSlots.indexOf(this.nextMidroll);\n        if (index > -1) {\n          midroll = this.midrollSlots.splice(index, 1);\n        }\n        this.nextMidroll = null;\n        complete();\n        break;\n      case tv.freewheel.SDK.TIME_POSITION_CLASS_POSTROLL:\n        if (this.postrollSlots.length) {\n          this.postrollSlots.shift();\n          if (this.postrollSlots.length) {\n            this.playAd(this.postrollSlots[0]);\n          } else {\n            complete();\n          }\n        }\n    }\n  };\n\n  /**\n  */\n  FreeWheelProxy.prototype.playAd = function(ad) {\n    var activeCreativeRendition, adId, adInstance, creativeParameters, id, instance, metadata, pod, _i, _len, _ref, _ref1;\n    pod = this.getPodById(ad.getCustomId());\n    if ((pod != null ? pod.locked : void 0) === true) {\n      this.onSlotEnded({\n        slot: pod.metadata,\n        skipped: true\n      });\n      return;\n    }\n    metadata = {\n      adtype: ad.getType()\n    };\n    adInstance = ad != null ? (_ref = ad.getAdInstances()) != null ? _ref[0] : void 0 : void 0;\n    if (adInstance != null) {\n      adId = adInstance.getAdId();\n      metadata.adunit = adInstance.getSoAdUnit();\n      activeCreativeRendition = adInstance.getActiveCreativeRendition();\n      if (activeCreativeRendition != null) {\n        metadata.baseunit = activeCreativeRendition.getBaseUnit();\n        creativeParameters = this.value.creativeParameters;\n        if (creativeParameters != null) {\n          metadata.creativeparameters = {};\n          _ref1 = ad.getAdInstances();\n          for (_i = 0, _len = _ref1.length; _i < _len; _i++) {\n            instance = _ref1[_i];\n            id = instance.getAdId();\n            metadata.creativeparameters[id] = this.getCreativeParameters(instance);\n          }\n        }\n      }\n    }\n    if (!(adId != null)) {\n      adId = ad.getCustomId();\n    }\n    this.adVO = new AdVO(adId, ad.getCustomId(), (adInstance != null ? adInstance.getDuration() : NaN), this.adPosition, ad.getTimePositionClass().toLowerCase(), \"freewheel\", null, null, null, metadata, ad.getAdCount());\n    this.sendNotification(AdNotifications.AD_LOADED, this.adVO);\n    this.context.setVideoState(tv.freewheel.SDK.VIDEO_STATE_STOPPED);\n    ad.play();\n  };\n\n  /** @override\n  */\n  FreeWheelProxy.prototype.start = function() {\n    if (this.canPlay() === true) {\n      this.startAd();\n    } else {\n      this.playWhenLoaded = true;\n    }\n    return true;\n  };\n\n  /**\n  */\n  FreeWheelProxy.prototype.canPlay = function() {\n    return this.initialized === true;\n  };\n\n  /**\n  */\n  FreeWheelProxy.prototype.startAd = function() {\n    var adLocked, id, slot, _i, _len, _ref, _ref1;\n    this.playWhenLoaded = false;\n    if (this.prerollSlots.length) {\n      adLocked = false;\n      _ref = this.prerollSlots;\n      for (_i = 0, _len = _ref.length; _i < _len; _i++) {\n        slot = _ref[_i];\n        id = slot.getCustomId();\n        if (((_ref1 = this.getPodById(id)) != null ? _ref1.locked : void 0) === true) {\n          adLocked = true;\n        }\n        if (adLocked) {\n          this.breakEnd();\n        } else {\n          this.startBreak();\n          this.playAd(this.prerollSlots[0]);\n        }\n      }\n    } else {\n      this.endBreak();\n    }\n  };\n\n  /**\n  */\n  FreeWheelProxy.prototype.play = function() {\n    FreeWheelProxy.__super__.play.call(this);\n    this.getMediaElement().play();\n    if (this.terminateAdOnPlay === true) {\n      this.terminateAdOnPlay = false;\n      this.terminateAd();\n    }\n  };\n\n  /**\n  */\n  FreeWheelProxy.prototype.pause = function() {\n    var video;\n    FreeWheelProxy.__super__.pause.call(this);\n    video = this.getMediaElement();\n    video.pause();\n    setTimeout(function() {\n      return video.controls = false;\n    }, 0);\n  };\n\n  /**\n  */\n  FreeWheelProxy.prototype.breakEnd = function() {\n    var video,\n      _this = this;\n    FreeWheelProxy.__super__.breakEnd.call(this);\n    if (this.playbackCore == null) {\n      this.playbackCore = this.facade.player.retrieveProxy(PlayerProxy.NAME).getActivePlaybackCore();\n    }\n    video = this.getMediaElement();\n    video.removeEventListener(\"playing\", this.playbackCore.handlers.playing);\n    video.removeEventListener(\"pause\", this.playbackCore.handlers.pause);\n    video.removeEventListener(\"waiting\", this.playbackCore.handlers.waiting);\n    video.removeEventListener(\"seeking\", this.handlers.seekupdate);\n    clearInterval(this.timeout);\n    this.playbackCore.setEnabled(true);\n    if (this.appState.getEnded()) {\n      this.context.setVideoState(tv.freewheel.SDK.VIDEO_STATE_COMPLETED);\n      this.sendNotification(Notifications.MEDIA_SEQUENCE_ENDED);\n    } else {\n      setTimeout(function() {\n        _this.contentPlay();\n        _this.getMediaElement().addEventListener(\"playing\", _this.handlers.onResume);\n      }, 1);\n      setTimeout(function() {\n        _this.engageMidrollCheck();\n      }, 500);\n      return;\n    }\n  };\n\n  /** @override\n  */\n  FreeWheelProxy.prototype.contentStarted = function() {\n    this.engageMidrollCheck();\n  };\n\n  /** @override\n  */\n  FreeWheelProxy.prototype.contentSeek = function(time) {\n    this.nextMidroll = this.getPreviousMidroll(time);\n    if (!(this.nextMidroll != null)) {\n      this.nextMidroll = this.getNextMidroll(time);\n      return;\n    }\n    if (!this.midrollEngaged) {\n      this.engageMidrollCheck();\n    }\n  };\n\n  /** @override\n  */\n  FreeWheelProxy.prototype.contentEnded = function() {\n    var _ref,\n      _this = this;\n    this.context.setVideoState(tv.freewheel.SDK.VIDEO_STATE_STOPPED);\n    if (((_ref = this.postrollSlots) != null ? _ref.length : void 0)) {\n      setTimeout(function() {\n        _this.startBreak();\n        _this.playAd(_this.postrollSlots[0]);\n      }, 0);\n    } else {\n      this.context.setVideoState(tv.freewheel.SDK.VIDEO_STATE_COMPLETED);\n    }\n  };\n\n  /**\n  */\n  FreeWheelProxy.prototype.engageMidrollCheck = function() {\n    var _ref;\n    if (((_ref = this.midrollSlots) != null ? _ref.length : void 0) === 0 || this.midrollEngaged === true) {\n      return;\n    }\n    this.midrollEngaged = true;\n    this.getMediaElement().addEventListener(\"timeupdate\", this.handlers.timeupdate);\n  };\n\n  FreeWheelProxy.prototype.disengageMidrollCheck = function() {\n    this.getMediaElement().removeEventListener(\"timeupdate\", this.handlers.timeupdate);\n  };\n\n  /**\n  */\n  FreeWheelProxy.prototype.midrollCheck = function(event) {\n    var count, _base;\n    if (this.getMediaElement().paused) {\n      return;\n    }\n    if (this.appState.getSeeking() === true) {\n      return;\n    }\n    if (!(this.nextMidroll != null)) {\n      this.nextMidroll = this.getNextMidroll(this.playbackCore.getCurrentTime());\n      return;\n    }\n    if (this.playbackCore.getCurrentTime() < this.nextMidroll.getTimePosition()) {\n      return;\n    }\n    count = typeof (_base = this.nextMidroll).getAdCount === \"function\" ? _base.getAdCount() : void 0;\n    if (!(count != null)) {\n      return;\n    }\n    if (count === 0) {\n      this.onSlotEnded({\n        slot: this.nextMidroll,\n        skipped: true\n      });\n      return;\n    }\n    this.disengageMidrollCheck();\n    this.adVO.type = \"midroll\";\n    this.startBreak();\n    this.engageAds();\n    this.midrollEngaged = false;\n    this.playAd(this.nextMidroll);\n  };\n\n  /**\n  */\n  FreeWheelProxy.prototype.getNextMidroll = function(time) {\n    var midroll, _i, _len, _ref;\n    time = time >= 0 ? time : 0;\n    _ref = this.midrollSlots;\n    for (_i = 0, _len = _ref.length; _i < _len; _i++) {\n      midroll = _ref[_i];\n      if (time < midroll.getTimePosition()) {\n        return midroll;\n      }\n    }\n  };\n\n  /**\n  */\n  FreeWheelProxy.prototype.getPreviousMidroll = function(time) {\n    var midroll, pod, pods, _i, _len;\n    pods = this.pods.slice().reverse();\n    for (_i = 0, _len = pods.length; _i < _len; _i++) {\n      pod = pods[_i];\n      if (!(pod.type === \"midroll\")) {\n        continue;\n      }\n      midroll = pod.metadata;\n      if (time > midroll.getTimePosition()) {\n        if (pod.locked !== true) {\n          return midroll;\n        } else {\n          return null;\n        }\n      }\n    }\n  };\n\n  /**\n  */\n  FreeWheelProxy.prototype.terminateAd = function() {\n    var _base;\n    if (this.started === true && this.getMediaElement().paused === true) {\n      this.terminateAdOnPlay = true;\n      return;\n    }\n    if (this.slot != null) {\n      if (typeof (_base = this.slot).stop === \"function\") {\n        _base.stop();\n      }\n    }\n  };\n\n  /**\n  */\n  FreeWheelProxy.prototype.terminateAllAds = function(listeners) {\n    if (listeners === true && (this.context != null)) {\n      this.context.removeEventListener(tv.freewheel.SDK.EVENT_REQUEST_COMPLETE, this.handlers.onRequestComplete);\n      this.context.removeEventListener(tv.freewheel.SDK.EVENT_SLOT_STARTED, this.handlers.onSlotStarted);\n      this.context.removeEventListener(tv.freewheel.SDK.EVENT_SLOT_ENDED, this.handlers.onSlotEnded);\n      this.context.removeEventListener(tv.freewheel.SDK.EVENT_AD_IMPRESSION, this.handlers.onAdImpression);\n      this.context.removeEventListener(tv.freewheel.SDK.EVENT_AD_IMPRESSION_END, this.handlers.onAdImpressionEnd);\n    }\n    this.terminateAd();\n    this.prerollSlots = [];\n    this.midrollSlots = [];\n    this.postrollSlots = [];\n  };\n\n  /**\n  */\n  FreeWheelProxy.prototype.getCreativeParameters = function(instance) {\n    var param, payload, value, _i, _len, _ref;\n    if (this.config.creativeParameters && instance) {\n      value = null;\n      payload = {};\n      _ref = this.config.creativeParameters;\n      for (_i = 0, _len = _ref.length; _i < _len; _i++) {\n        param = _ref[_i];\n        value = null;\n        try {\n          value = instance.getActiveCreativeRendition().getParameter(param);\n        } catch (error) {\n          this.facade.logger.warn(\"[AMP FREEWHEEL WARNING]\", \"Could not retrieve Freewheel creative parameter: \" + param, error);\n        } finally {\n          if (value) {\n            payload[param] = value;\n          }\n        }\n      }\n    }\n    return payload;\n  };\n\n  FreeWheelProxy.prototype.contentPaused = function() {\n    if (!this.getInProgress()) {\n      this.context.setVideoState(tv.freewheel.SDK.VIDEO_STATE_PAUSED);\n      this.getMediaElement().addEventListener(\"playing\", this.handlers.onResume);\n    }\n  };\n\n  /**\n  */\n  FreeWheelProxy.prototype.destroy = function() {\n    this.terminateAllAds(true);\n  };\n\n  /**\n   * The StatsPlugin class.\n   *\n   * @param {Module}  app     The parent module of this plugin.\n   * @constructor\n   * @private\n   * @extends {Plugin}\n  */\n  function StatsPlugin() {\n    StatsPlugin.__super__.constructor.call(this);\n  }\n\n\n  __extends(StatsPlugin, Plugin);\n\n\n  StatsPlugin.prototype.moduleName = \"stats\";\n\n  /** @override\n  */\n  StatsPlugin.prototype.createModel = function() {\n    this.proxy = new StatsProxy(this.config);\n    this.registerProxy(this.proxy);\n  };\n\n  /** @override\n  */\n  StatsPlugin.prototype.createController = function() {\n    StatsPlugin.__super__.createController.call(this);\n    this.registerCommand(StatsNotifications.VISIBILITY_CHANGE, StatsVisibilityChangeCommand);\n  };\n\n  /** @override\n  */\n  StatsPlugin.prototype.createView = function() {\n    this.registerMediator(new StatsMediator());\n  };\n\n  /**\n  */\n  StatsPlugin.prototype.listNotificationInterests = function() {\n    return [Notifications.PLAYING, Notifications.TIME_UPDATE];\n  };\n\n  /** @override\n  */\n  StatsPlugin.prototype.listNotificationPublications = function() {\n    return StatsPlugin.__super__.listNotificationPublications.call(this).concat([Notifications.ADD_CONTROL, Notifications.REMOVE_CONTROL, Notifications.ADD_CONTROL_STATE, Notifications.REMOVE_CONTROL_STATE, StatsNotifications.VISIBILITY_CHANGE]);\n  };\n\n  /**\n   * @return   {boolean}  A boolean indicating whether or not the stats are hidden.\n   * @expose\n  */\n  StatsPlugin.prototype.getHidden = function() {\n    return this.proxy.getHidden();\n  };\n\n  /**\n   *\n   * @param   {boolean} value A boolean indicating whether or not the stats are hidden.\n   * @expose\n  */\n  StatsPlugin.prototype.setHidden = function(value) {\n    this.sendNotification(StatsNotifications.VISIBILITY_CHANGE, value);\n    return value;\n  };\n\n\n  AMP.registerPlugin(\"stats\", \"html\", StatsPlugin);\n\n  /**\n   * The IMAProxy class.\n   *\n   * @constructor\n   * @private\n   * @extends {AdProxy}\n   * @param {Object} config\n  */\n  function MOATProxy(config) {\n    MOATProxy.__super__.constructor.call(this, config);\n  }\n\n\n  __extends(MOATProxy, PluginProxy);\n\n\n  /** @static\n  */\n  MOATProxy.NAME = ModuleProxy.NAME;\n\n  MOATProxy.prototype.defaults = {\n    data: {\n      partnerCode: null\n    }\n  };\n\n  /**\n  */\n  MOATProxy.prototype.initSDK = function(adsManagerVO) {\n    var data, _ref;\n    if (typeof initMoatTracking !== \"undefined\" && initMoatTracking !== null) {\n      data = (_ref = this.getConfigurationData()) != null ? _ref.data : void 0;\n      initMoatTracking(adsManagerVO.adManager, {\n        \"partnerCode\": data.partnerCode,\n        \"viewMode\": adsManagerVO.viewMode,\n        \"slicer1\": data.slicer1,\n        \"slicer2\": data.slicer2\n      }, adsManagerVO.adContainer);\n    }\n  };\n\n  function MOATWrapper() {\n    return MOATWrapper.__super__.constructor.apply(this, arguments);\n  }\n\n\n  __extends(MOATWrapper, PluginWrapper);\n\n\n  MOATWrapper.NAME = \"MOATWrapper\";\n\n  MOATWrapper.prototype.flashPlugins = [\n    {\n      id: \"MOATAnalyticsPlugin\",\n      src: '#{paths.resources}plugins/MOATAnalyticsPlugin.swf',\n      blocking: false,\n      host: \"akamai\",\n      main: \"MOATAnalyticsPlugin\"\n    }\n  ];\n\n  /** @override\n  */\n  MOATWrapper.prototype.createXML = function(xml) {\n    var application, metrics, prop, props, vendor, _i, _len;\n    application = xml.firstChild;\n    metrics = xml.getElementsByTagName(\"metrics\")[0];\n    if (!(metrics != null)) {\n      metrics = xml.createElement(\"metrics\");\n      application.appendChild(metrics);\n    }\n    vendor = xml.createElement(\"vendor\");\n    vendor.setAttribute(\"id\", \"moat\");\n    metrics.appendChild(vendor);\n    props = [\n      {\n        value: this.config.data.partnerCode,\n        key: \"partnerCode\"\n      }, {\n        value: this.config.data.slicer1,\n        key: \"slicer1\"\n      }, {\n        value: this.config.data.slicer2,\n        key: \"slicer2\"\n      }\n    ];\n    for (_i = 0, _len = props.length; _i < _len; _i++) {\n      prop = props[_i];\n      if (prop.value != null) {\n        this.createProperty(xml, prop.key, prop.value, vendor);\n      }\n    }\n    return xml;\n  };\n\n  /**\n   * The MOATAdManagerLoadedCommand class.\n   *\n   * @constructor\n   * @private\n   * @extends {puremvc.SimpleCommand}\n  */\n  function MOATAdManagerLoadedCommand() {\n    MOATAdManagerLoadedCommand.__super__.constructor.call(this);\n  }\n\n\n  __extends(MOATAdManagerLoadedCommand, puremvc.SimpleCommand);\n\n\n  /**\n   * Executes the command.\n   *\n   * @param {puremvc.Notification} notification\n   *    The notification.\n   *\n   * @override\n  */\n  MOATAdManagerLoadedCommand.prototype.execute = function(notification) {\n    var moatProxy;\n    moatProxy = this.facade.retrieveProxy(MOATProxy.NAME);\n    if (notification.getBody()) {\n      moatProxy.initSDK(notification.getBody());\n    }\n  };\n\n  /**\n   * @constructor\n   * @private\n  */\n  function FreeWheelPlugin() {\n    FreeWheelPlugin.__super__.constructor.call(this);\n  }\n\n\n  __extends(FreeWheelPlugin, AdPlugin);\n\n\n  FreeWheelPlugin.prototype.moduleName = \"freewheel\";\n\n  FreeWheelPlugin.prototype.featureName = \"ads\";\n\n  /** @override\n  */\n  FreeWheelPlugin.prototype.createProxy = function() {\n    return new FreeWheelProxy(this.config);\n  };\n\n  /** @override\n  */\n  FreeWheelPlugin.prototype.isFullscreenDevice = function() {\n    return false;\n  };\n\n\n  AMP.registerPlugin(\"freewheel\", \"html\", FreeWheelPlugin);\n  AMP.registerPlugin(\"freewheel\", \"flash\", FreeWheelWrapper);\n\n  /**\n   * DASHPlaybackProxy constructor.\n   *\n   * @constructor\n   * @private\n   * @extends {PlaybackCoreProxy}\n  */\n  function DASHPlaybackProxy(data) {\n    DASHPlaybackProxy.__super__.constructor.call(this, data.types, data);\n    this.buffer = data.buffer;\n    this.temporalTypes = [\"vod\", \"live\", \"dvr\"];\n  }\n\n\n  __extends(DASHPlaybackProxy, PlaybackCoreProxy);\n\n\n  DASHPlaybackProxy.prototype.playbackCoreName = \"dash\";\n\n  DASHPlaybackProxy.prototype.context = null;\n\n  DASHPlaybackProxy.prototype.player = null;\n\n  DASHPlaybackProxy.prototype.buffer = null;\n\n  /** @override\n  */\n  DASHPlaybackProxy.prototype.resumecomplete = function() {\n    var track, _ref, _ref1;\n    track = (_ref = this.facade.getMediaElement()) != null ? (_ref1 = _ref.textTracks) != null ? _ref1[0] : void 0 : void 0;\n    if (track != null) {\n      track.mode = \"hidden\";\n    }\n    DASHPlaybackProxy.__super__.resumecomplete.call(this);\n  };\n\n  DASHPlaybackProxy.prototype.onerror = function() {};\n\n  /** @override\n  */\n  DASHPlaybackProxy.prototype.createTracks = function() {\n    var audio, count, current, index, item, tracks, _i, _len;\n    audio = this.player.getTracksFor(\"audio\");\n    current = this.player.getCurrentTrackFor(\"audio\");\n    tracks = this.facade.tracks.getAudioTracks();\n    count = audio.length;\n    for (index = _i = 0, _len = audio.length; _i < _len; index = ++_i) {\n      item = audio[index];\n      tracks.add(new Track({\n        kind: item.roles.join(\" \"),\n        label: item.id,\n        language: item.lang,\n        id: item.id,\n        enabled: item === current\n      }), index + 1 === count);\n    }\n  };\n\n  /** @override\n  */\n  DASHPlaybackProxy.prototype.load = function() {\n    if (!(this.player != null)) {\n      this.player = dashjs.MediaPlayer().create();\n      this.player.enableBufferOccupancyABR(true);\n      this.player.on(\"error\", this.onError.bind(this));\n      this.player.on(\"fragmentLoadingStarted\", this.onFragmentLoadStart.bind(this));\n      this.player.on(\"fragmentLoadingCompleted\", this.onFragmentLoaded.bind(this));\n      this.player.getDebug().setLogToBrowserConsole(this.facade.logger.enabled);\n      this.player.initialize(this.getMediaElement(), null, false);\n    }\n    DASHPlaybackProxy.__super__.load.call(this);\n  };\n\n  /** @override\n  */\n  DASHPlaybackProxy.prototype.applySrc = function() {\n    var keys;\n    keys = this.facade.getMedia().keys;\n    if (keys != null) {\n      this.player.setProtectionData(keys);\n    }\n    this.player.attachSource(this.getSrc());\n  };\n\n  /** @override\n  */\n  DASHPlaybackProxy.prototype.seek = function(value) {\n    return Promise.resolve(this.player.seek(value));\n  };\n\n  /** @override\n  */\n  DASHPlaybackProxy.prototype.getCurrentTime = function() {\n    var _ref;\n    return ((_ref = this.player) != null ? _ref.time() : void 0) || 0;\n  };\n\n  /** @override\n  */\n  DASHPlaybackProxy.prototype.getDuration = function() {\n    var _ref;\n    return ((_ref = this.player) != null ? _ref.duration() : void 0) || 0;\n  };\n\n  /**\n  */\n  DASHPlaybackProxy.prototype.getStats = function() {\n    return {};\n  };\n\n  /**\n  */\n  DASHPlaybackProxy.prototype.onFragmentLoadStart = function(event) {\n    var bitrate;\n    bitrate = event.request.mediaInfo.bitrateList[event.request.quality].bandwidth;\n    this.sendNotification(Notifications.FRAGMENT_LOAD_START, bitrate);\n  };\n\n  /**\n  */\n  DASHPlaybackProxy.prototype.onFragmentLoaded = function(event) {\n    var bitrate;\n    bitrate = event.request.mediaInfo.bitrateList[event.request.quality].bandwidth;\n    this.sendNotification(Notifications.FRAGMENT_LOADED, bitrate);\n  };\n\n  /**\n  */\n  DASHPlaybackProxy.prototype.onError = function(event) {\n    this.facade.logger.error(\"DASH JS Playback Error:\", event);\n  };\n\n  /** @override\n  */\n  DASHPlaybackProxy.prototype.setQuality = function(value) {\n    var _ref;\n    return (_ref = this.player) != null ? _ref.setQualityFor(\"video\", value) : void 0;\n  };\n\n  /** @override\n  */\n  DASHPlaybackProxy.prototype.getQuality = function() {\n    var _ref;\n    return (_ref = this.player) != null ? _ref.getQualityFor(\"video\") : void 0;\n  };\n\n  /** @override\n  */\n  DASHPlaybackProxy.prototype.getQualityLevels = function() {\n    var _ref;\n    return ((_ref = this.player) != null ? _ref.getBitrateInfoListFor(\"video\") : void 0) || DASHPlaybackProxy.__super__.getQualityLevels.call(this);\n  };\n\n  /** @override\n  */\n  DASHPlaybackProxy.prototype.destroy = function() {\n    var _ref;\n    if ((_ref = this.player) != null) {\n      _ref.reset();\n    }\n  };\n\n  /**\n   * The DASHChangeDisplayStateCommand class.\n   *\n   * @constructor\n   * @private\n   * @extends {puremvc.SimpleCommand}\n  */\n  function DASHChangeDisplayStateCommand() {\n    DASHChangeDisplayStateCommand.__super__.constructor.call(this);\n  }\n\n\n  __extends(DASHChangeDisplayStateCommand, puremvc.SimpleCommand);\n\n\n  /**\n   * Executes the command.\n   *\n   * @param {puremvc.Notification} notification\n   *    The notification.\n   *\n   * @override\n  */\n  DASHChangeDisplayStateCommand.prototype.execute = function(notification) {\n    var core, fullscreen, playback, proxy, state, target,\n      _this = this;\n    state = notification.getBody();\n    playback = this.facade.retrieveProxy(PlaybackProxy.NAME);\n    core = this.facade.getMediaElement();\n    if (!(core != null) || !core.webkitSupportsFullscreen) {\n      return;\n    }\n    proxy = this.facade.retrieveProxy(ApplicationStateProxy.NAME);\n    proxy.setDisplayState(state);\n    fullscreen = {};\n    target = this.facade.viewComponent;\n    if (target.requestFullscreen != null) {\n      fullscreen.enter = function() {\n        return target.requestFullscreen();\n      };\n      fullscreen.exit = function() {\n        return document.cancelFullscreen();\n      };\n      fullscreen.event = \"onfullscreenchange\";\n      fullscreen.element = \"fullscreenElement\";\n    } else if (target.webkitRequestFullScreen != null) {\n      fullscreen.enter = function() {\n        return target.webkitRequestFullScreen();\n      };\n      fullscreen.exit = function() {\n        return document.webkitCancelFullScreen();\n      };\n      fullscreen.event = \"onwebkitfullscreenchange\";\n      fullscreen.element = \"webkitFullscreenElement\";\n    } else if (target.mozRequestFullScreen != null) {\n      fullscreen.enter = function() {\n        return target.mozRequestFullscreen();\n      };\n      fullscreen.exit = function() {\n        return document.mozCancelFullScreen();\n      };\n      fullscreen.event = \"onmozfullscreenchange\";\n      fullscreen.element = \"mozFullscreenElement\";\n    } else if (target.msRequestFullScreen != null) {\n      fullscreen.enter = function() {\n        return target.msRequestFullscreen();\n      };\n      fullscreen.exit = function() {\n        return document.msCancelFullScreen();\n      };\n      fullscreen.event = \"onmozfullscreenchange\";\n      fullscreen.element = \"mozFullscreenElement\";\n    }\n    if (state === DisplayState.FULL_SCREEN) {\n      fullscreen.enter();\n      if (fullscreen.event != null) {\n        core[fullscreen.event] = function(event) {\n          if (!(document[fullscreen.element] != null)) {\n            return _this.sendNotification(Notifications.CHANGE_DISPLAY_STATE, DisplayState.NORMAL);\n          }\n        };\n      }\n    } else if (state === DisplayState.NORMAL) {\n      fullscreen.exit();\n      core[fullscreen.event] = null;\n    }\n    this.facade.dispatchEvent(new Event(\"fullscreenchange\", state === DisplayState.FULL_SCREEN));\n  };\n\n  /**\n   * @param {Object}  config  The plugin configuration object.\n   * @constructor\n   * @private\n   * @extends {PluginProxy}\n  */\n  function PlaybackPluginProxy(config) {\n    PlaybackPluginProxy.__super__.constructor.call(this, config);\n  }\n\n\n  __extends(PlaybackPluginProxy, PluginProxy);\n\n\n  /** @static\n  */\n  PlaybackPluginProxy.NAME = ModuleProxy.NAME;\n\n  PlaybackPluginProxy.prototype.playbackProxy = null;\n\n  PlaybackPluginProxy.prototype.createPlaybackProxy = function() {};\n\n  PlaybackPluginProxy.prototype.initialize = function() {\n    var player;\n    this.playbackProxy = this.createPlaybackProxy();\n    if (!(this.playbackProxy != null)) {\n      return;\n    }\n    this.sendNotification(Notifications.INITIALIZED);\n    player = this.facade.player.retrieveProxy(PlayerProxy.NAME);\n    player.registerPlaybackCore(this.playbackProxy);\n  };\n\n  PlaybackPluginProxy.prototype.destroy = function() {\n    var _ref;\n    if ((_ref = this.playbackProxy) != null) {\n      _ref.destroy();\n    }\n  };\n\n  /**\n   * The DASHProxy class.\n   *\n   * @param {Object}  config  The plugin configuration object.\n   * @constructor\n   * @private\n   * @extends {PluginProxy}\n  */\n  function DASHProxy(config) {\n    DASHProxy.__super__.constructor.call(this, config);\n  }\n\n\n  __extends(DASHProxy, PlaybackPluginProxy);\n\n\n  /** @static\n  */\n  DASHProxy.NAME = ModuleProxy.NAME;\n\n  DASHProxy.prototype.defaults = {\n    types: [\"application/dash+xml\"],\n    buffer: null\n  };\n\n  DASHProxy.prototype.createPlaybackProxy = function() {\n    var mediaSource;\n    mediaSource = window.MediaSource || window.WebKitMediaSource;\n    if (!(mediaSource != null)) {\n      return;\n    }\n    return new DASHPlaybackProxy(this.getConfigurationData());\n  };\n\n  /**\n   * The AMPChromeCastPlayer class.\n   *\n   * @param {Object} player\n   *    The player instance\n   *\n   * @constructor\n  */\n  function ChromeCastPlayer(shim) {\n    var index, rule, sheet, style;\n    this.shim = shim;\n    ChromeCastPlayer.__super__.constructor.call(this);\n    this.state = cast.receiver.media.PlayerState.IDLE;\n    try {\n      style = document.createElement('style');\n      style.type = 'text/css';\n      style.appendChild(document.createTextNode(\"\"));\n      document.head.appendChild(style);\n      sheet = style.sheet;\n      rule = \".akamai-html5.akamai-video::cue {color: #FFFFFF; background: #000000; visibility: hidden;}\";\n      index = sheet.insertRule(rule, 0);\n      this.cssRule = sheet.rules[index];\n    } catch (error) {\n      Logger.error(error);\n    }\n  }\n\n\n  __extends(ChromeCastPlayer, EventDispatcher);\n\n\n  ChromeCastPlayer.prototype.player = null;\n\n  ChromeCastPlayer.prototype.callbackMap = null;\n\n  ChromeCastPlayer.prototype.state = null;\n\n  ChromeCastPlayer.prototype.activeTrackId = null;\n\n  ChromeCastPlayer.prototype.cssRule = null;\n\n  ChromeCastPlayer.prototype.textTrackStyle = null;\n\n  ChromeCastPlayer.prototype.ccHandler = null;\n\n  ChromeCastPlayer.prototype.feed = null;\n\n  ChromeCastPlayer.prototype.media = null;\n\n  ChromeCastPlayer.prototype.tracks = null;\n\n  /**\n   *\n  */\n  ChromeCastPlayer.prototype.registerPlayer = function(player) {\n    var events, listener, readyHandler,\n      _this = this;\n    this.player = player;\n    events = [\"loadedmetadata\", \"ended\", \"error\"];\n    listener = this.dispatchEvent.bind(this);\n    events.forEach(function(type) {\n      return player.addEventListener(type, listener);\n    });\n    readyHandler = function() {\n      _this.player.removeEventListener(\"ready\", readyHandler);\n      _this.applyMedia();\n      _this.applyFeed();\n      _this.applyClassName();\n    };\n    this.player.addEventListener(\"ready\", readyHandler);\n    this.player.addEventListener(\"playing\", this.setState.bind(this, cast.receiver.media.PlayerState.PLAYING));\n    this.player.addEventListener(\"pause\", this.setState.bind(this, cast.receiver.media.PlayerState.PAUSED));\n    this.player.addEventListener(\"waiting\", this.setState.bind(this, cast.receiver.media.PlayerState.BUFFERING));\n  };\n\n  /**\n   * @private\n  */\n  ChromeCastPlayer.prototype.setState = function(state) {\n    if (state === this.state) {\n      return;\n    }\n    this.state = state;\n    this.shim.mediaManager.broadcastStatus(true);\n    return state;\n  };\n\n  /**\n   * Registers an API that the player should call when there is an error.\n   *\n   * @param {function(Object)} errorCallback\n   *    The callback method called when the player has an error.\n  */\n  ChromeCastPlayer.prototype.registerErrorCallback = function(errorCallback) {\n    this.onerror = errorCallback;\n  };\n\n  /**\n   * Registers an API that the player should call when the media has ended.\n   *\n   * @param {function()} endedCallback\n   *    The callback method called when the player has ended.\n  */\n  ChromeCastPlayer.prototype.registerEndedCallback = function(endedCallback) {\n    this.onended = endedCallback;\n  };\n\n  /**\n   * Registers an API that the player should call when load is complete.\n   *\n   * @param {function()} loadCallback\n   *    The callback method called when the player has completed load succesfully.\n  */\n  ChromeCastPlayer.prototype.registerLoadCallback = function(loadCallback) {\n    this.onloadedmetadata = loadCallback;\n  };\n\n  /**\n   * Called to unregister for error callbacks.\n  */\n  ChromeCastPlayer.prototype.unregisterErrorCallback = function() {\n    this.onerror = null;\n  };\n\n  /**\n   * Called to unregister for ended callbacks.\n  */\n  ChromeCastPlayer.prototype.unregisterEndedCallback = function() {\n    this.onended = null;\n  };\n\n  /**\n   * Called to unregister for load callbacks.\n  */\n  ChromeCastPlayer.prototype.unregisterLoadCallback = function() {\n    this.onloadedmetadata = null;\n  };\n\n  /**\n   * Loads content to be played.\n   *\n   * @param {string} contentId\n   *    The content ID. Should be treated as an opaque string.\n   *\n   * @param {boolean} autoplay\n   *    Whether the content should play after load.\n   *\n   * @param {number} opt_time\n   *    The expected current time after load (in seconds). Optional.\n   *\n   * @param {cast.receiver.media.TracksInfo} opt_tracksInfo\n   *    The tracks information. Optional.\n  */\n  ChromeCastPlayer.prototype.load = function(contentId, autoplay, opt_time, opt_tracksInfo) {\n    var customData, info, key, media, metadata, value, _ref, _ref1, _ref2, _ref3;\n    info = this.shim.mediaManager.getMediaInformation();\n    customData = info.customData || {};\n    metadata = info.metadata || {};\n    if (opt_tracksInfo != null) {\n      this.editTracksInfo(opt_tracksInfo);\n    } else {\n      this.activeTrackId = null;\n    }\n    if ((customData.feed != null) && (((_ref = this.player) != null ? _ref.feed : void 0) != null)) {\n      this.feed = customData.feed;\n      this.media = null;\n      this.applyFeed();\n      return;\n    }\n    this.feed = null;\n    media = {\n      src: contentId,\n      type: info.contentType,\n      title: metadata.title,\n      poster: (_ref1 = metadata.images) != null ? _ref1.url : void 0,\n      description: metadata.subtitle,\n      pubDate: new Date(info.releaseDate),\n      metadata: customData,\n      duration: info.duration,\n      startTime: opt_time || ((_ref2 = customData.media) != null ? _ref2.startTime : void 0),\n      autoplay: autoplay\n    };\n    if (customData.media != null) {\n      _ref3 = customData.media;\n      for (key in _ref3) {\n        value = _ref3[key];\n        if (!(media[key] != null)) {\n          media[key] = value;\n        }\n      }\n    }\n    this.tracks = info.tracks;\n    this.media = media;\n    this.applyMedia();\n  };\n\n  /**\n   *\n  */\n  ChromeCastPlayer.prototype.applyMedia = function() {\n    if (!(this.player != null) || !(this.media != null)) {\n      return;\n    }\n    this.ccHandler = this.loadTracks.bind(this, this.tracks);\n    this.player.addEventListener(\"loadedmetadata\", this.ccHandler);\n    this.player.setMedia(this.media);\n    this.setState(cast.receiver.media.PlayerState.BUFFERING);\n  };\n\n  /**\n   *\n  */\n  ChromeCastPlayer.prototype.loadTracks = function(tracks, event) {\n    var playbackCore, track, type;\n    this.player.removeEventListener(\"loadedmetadata\", this.ccHandler);\n    if ((tracks != null ? tracks.length : void 0) > 0) {\n      track = this.getTrack(0);\n      if (track != null) {\n        type = /ttml/.test(track.trackContentType) ? \"ttml\" : track.trackContentType;\n        playbackCore = this.player.retrieveProxy(\"PlayerProxy\").getActivePlaybackCore();\n        playbackCore.player.enableCaptions(true, type, track.trackContentId);\n      }\n    }\n  };\n\n  /**\n   *\n  */\n  ChromeCastPlayer.prototype.applyFeed = function() {\n    if (!(this.player != null) || !(this.feed != null)) {\n      return;\n    }\n    this.onmediachange = this.mediachangeHandler.bind(this);\n    this.player.addEventListener(\"mediachange\", this.onmediachange);\n    if (this.feed.data != null) {\n      this.player.feed.setData(this.feed.data);\n    } else if (feed.url != null) {\n      this.player.feed.setURL(this.feed.url);\n    }\n  };\n\n  /**\n   *\n  */\n  ChromeCastPlayer.prototype.mediachangeHandler = function(event) {\n    var media, mediaInfo;\n    this.player.removeEventListener(\"mediachange\", this.onmediachange);\n    media = this.player.getMedia();\n    mediaInfo = new cast.receiver.media.MediaInformation();\n    mediaInfo.contentId = media.src;\n    mediaInfo.contentType = media.type;\n    mediaInfo.customData = media.metadata;\n    mediaInfo.duration = media.duration;\n    mediaInfo.metadata = {\n      title: media.title,\n      subtitle: media.description,\n      images: [\n        {\n          url: media.poster\n        }\n      ],\n      releaseDate: media.pubDate.toISOString()\n    };\n    this.media = media;\n    this.shim.mediaManager.setMediaInformation(mediaInfo, true);\n  };\n\n  /**\n   * Resets the player.\n  */\n  ChromeCastPlayer.prototype.reset = function() {};\n\n  /**\n   * Starts playback.\n  */\n  ChromeCastPlayer.prototype.play = function() {\n    this.player.play();\n  };\n\n  /**\n   * Sets playback to start at a new time position.\n   *\n   * @param {number} time\n   *    The expected current time after seek (in seconds).\n   *\n   * @param {cast.receiver.media.SeekResumeState} opt_resumeState\n   *    The expected state after seek. Optional.\n  */\n  ChromeCastPlayer.prototype.seek = function(time, opt_resumeState) {\n    this.player.setCurrentTime(time);\n    switch (opt_resumeState) {\n      case cast.receiver.media.SeekResumeState.PLAYBACK_PAUSE:\n        this.player.pause();\n        break;\n      case cast.receiver.media.SeekResumeState.PLAYBACK_START:\n        this.player.play();\n    }\n  };\n\n  /**\n   * Pauses playback.\n  */\n  ChromeCastPlayer.prototype.pause = function() {\n    return this.player.pause();\n  };\n\n  /**\n   * Provides the state of the player.\n   *\n   * @return {cast.receiver.media.PlayerState\n   *    The current state of the player\n  */\n  ChromeCastPlayer.prototype.getState = function() {\n    return this.state;\n  };\n\n  /**\n   * Provides the current time of the media in seconds.\n   *\n   * @return {number\n   *    The current time of the video, in seconds.\n  */\n  ChromeCastPlayer.prototype.getCurrentTimeSec = function() {\n    if (this.player != null) {\n      return this.player.getCurrentTime();\n    } else {\n      return 0;\n    }\n  };\n\n  /**\n   * Provides the duration of the media in seconds.\n   *\n   * @return {number\n   *    Duration of the video, in seconds.\n  */\n  ChromeCastPlayer.prototype.getDurationSec = function() {\n    if (this.player != null) {\n      return this.player.getDuration();\n    } else {\n      return 0;\n    }\n  };\n\n  /**\n   * Provides the stream volume.\n   *\n   * @return {cast.receiver.media.Volume\n   *    The media volume\n  */\n  ChromeCastPlayer.prototype.getVolume = function() {\n    var volume;\n    volume = new cast.receiver.media.Volume();\n    volume.level = this.player.getVolume();\n    volume.muted = this.player.getMuted();\n    return volume;\n  };\n\n  /**\n   * Sets the stream volume.\n   *\n   * @param {cast.receiver.media.Volume} volume\n   *    New volume\n  */\n  ChromeCastPlayer.prototype.setVolume = function(volume) {\n    if (volume.level != null) {\n      this.player.setVolume(volume.level);\n    }\n    if (volume.muted === true) {\n      this.player.setMuted(true);\n    } else {\n      if (this.player.getMuted() === true) {\n        this.player.setMuted(false);\n      }\n    }\n    return volume;\n  };\n\n  /**\n   * Allows to edit the tracks information (active tracks and style).\n   *\n   * @param {cast.receiver.MediaManager.EditTracksInfoData} data\n   *    The tracks information. The tracks definition can not change so\n   *    the tracks field will be undefined (and should be ignored).\n  */\n  ChromeCastPlayer.prototype.editTracksInfo = function(data) {\n    var activeTrack, style;\n    if (data.activeTrackIds != null) {\n      activeTrack = data.activeTrackIds[0];\n      if (this.activeTrackId !== activeTrack) {\n        this.activeTrackId = activeTrack;\n        this.applyClassName();\n      }\n    }\n    style = data.textTrackStyle;\n    if ((style != null) && (this.cssRule != null)) {\n      this.textTrackStyle = style;\n      if (style.foregroundColor != null) {\n        this.cssRule.style.color = this.hexToRgba(style.foregroundColor);\n      }\n      if (style.backgroundColor != null) {\n        this.cssRule.style.backgroundColor = this.hexToRgba(style.backgroundColor);\n      }\n      if (style.windowType === cast.receiver.media.TextTrackWindowType.ROUNDED_CORNERS) {\n        this.cssRule.style.borderRadius = style.windowRoundedCornerRadius + \"px\";\n      }\n      if (style.fontScale != null) {\n        this.cssRule.style.fontSize = style.fontScale + \"em\";\n      }\n      if (style.fontFamily != null) {\n        this.cssRule.style.fontFamily = style.fontFamily;\n      }\n    }\n  };\n\n  ChromeCastPlayer.prototype.applyClassName = function(hex) {\n    var classList, className;\n    if (!(this.player != null)) {\n      return;\n    }\n    className = \"akamai-cc\";\n    classList = this.player.getMediaElement().classList;\n    if (this.activeTrackId != null) {\n      classList.add(className);\n    } else {\n      classList.remove(className);\n    }\n  };\n\n  ChromeCastPlayer.prototype.hexToRgba = function(hex) {\n    var a, b, g, r;\n    if (!/^#[A-Fa-f0-9]{6}([A-Fa-f0-9]{2})?$/.test(hex)) {\n      return hex;\n    }\n    r = parseInt(hex.substring(1, 3), 16);\n    g = parseInt(hex.substring(3, 5), 16);\n    b = parseInt(hex.substring(5, 7), 16);\n    a = hex.length === 9 ? parseInt(hex.substring(7, 9), 16) / 256 : 1;\n    return \"rgba(\" + r + \",\" + g + \",\" + b + \",\" + a + \")\";\n  };\n\n  ChromeCastPlayer.prototype.getTrack = function(id) {\n    var track;\n    if (!(id != null)) {\n      id = this.activeTrackId;\n    }\n    track = this.tracks.filter(function(item) {\n      return item.trackId === id;\n    })[0];\n    if (track != null) {\n      if (!(track.trackContentType != null)) {\n        track.trackContentType = cast.player.api.CaptionsType.CEA608;\n      }\n    }\n    return track;\n  };\n\n  /**\n   * @enum {string}\n   * @const\n   * @private\n  */\n\n  var ChromeCastConstants = {\n    CHANNEL_ID: \"urn:x-cast:com.akamai.amp.cast\",\n    APPLICATION_ID: \"CC1AD845\",\n    SUPPORTED_TYPES: [Utils.mimeTypes.m3u8, Utils.mimeTypes.mp4, Utils.mimeTypes.mpd, Utils.mimeTypes.ism, Utils.mimeTypes.webm, Utils.mimeTypes.mp3]\n  };\n\n  /**\n   * The ChromeCastSenderProxy class.\n   *\n   * @param {Object}  config  The plugin configuration object.\n   * @constructor\n   * @private\n   * @extends {PluginProxy}\n  */\n  function ChromeCastSenderProxy(config) {\n    this.messageBus = config.messageBus || ChromeCastConstants.CHANNEL_ID;\n    ChromeCastSenderProxy.__super__.constructor.call(this, config.sender);\n  }\n\n\n  __extends(ChromeCastSenderProxy, PluginProxy);\n\n\n  /** @static\n  */\n  ChromeCastSenderProxy.NAME = ModuleProxy.NAME;\n\n  ChromeCastSenderProxy.prototype.defaults = {\n    applicationID: ChromeCastConstants.APPLICATION_ID\n  };\n\n  ChromeCastSenderProxy.prototype.session = null;\n\n  ChromeCastSenderProxy.prototype.media = null;\n\n  ChromeCastSenderProxy.prototype.messageBus = null;\n\n  ChromeCastSenderProxy.prototype.feed = null;\n\n  ChromeCastSenderProxy.prototype.currentTime = null;\n\n  ChromeCastSenderProxy.prototype.duration = null;\n\n  ChromeCastSenderProxy.prototype.receiverAvailable = false;\n\n  ChromeCastSenderProxy.prototype.currentTime = 0;\n\n  ChromeCastSenderProxy.prototype.duration = 0;\n\n  ChromeCastSenderProxy.prototype.playerState = null;\n\n  ChromeCastSenderProxy.prototype.displayTimeTimeout = null;\n\n  /** @override\n  */\n  ChromeCastSenderProxy.prototype.initialize = function() {\n    var _ref,\n      _this = this;\n    if (typeof chrome !== \"undefined\" && chrome !== null ? (_ref = chrome.cast) != null ? _ref.isAvailable : void 0 : void 0) {\n      this.initializeCastApi();\n    } else {\n      window['__onGCastApiAvailable'] = function(loaded, errorInfo) {\n        if (loaded === true) {\n          _this.initializeCastApi();\n        } else {\n          _this.logError(\"cast load error\", errorInfo);\n        }\n      };\n    }\n  };\n\n  ChromeCastSenderProxy.prototype.initializeCastApi = function() {\n    var apiConfig, applicationID, sessionRequest;\n    applicationID = this.getConfigurationData().applicationID;\n    sessionRequest = new chrome.cast.SessionRequest(applicationID);\n    apiConfig = new chrome.cast.ApiConfig(sessionRequest, this.sessionListener.bind(this), this.receiverListener.bind(this), chrome.cast.AutoJoinPolicy.ORIGIN_SCOPED);\n    chrome.cast.initialize(apiConfig, this.onInitSuccess.bind(this), this.onInitError.bind(this));\n  };\n\n  ChromeCastSenderProxy.prototype.onInitSuccess = function(event) {\n    this.logEvent(\"init success\", event);\n  };\n\n  ChromeCastSenderProxy.prototype.onInitError = function(event) {\n    this.logError(\"init error\", event);\n  };\n\n  ChromeCastSenderProxy.prototype.receiverListener = function(event) {\n    this.receiverAvailable = event === 'available';\n    this.sendNotification(ChromeCastNotifications.AVAILABILITY_CHANGE, this.receiverAvailable);\n    this.logEvent(\"receiver \" + (this.receiverAvailable ? \"found\" : \"list empty\"));\n  };\n\n  ChromeCastSenderProxy.prototype.sessionListener = function(event) {\n    var session;\n    this.logEvent(\"session listener\", event);\n    session = event;\n    if (session.media.length !== 0) {\n      this.onMediaDiscovered(session.media[0]);\n    } else {\n      this.onRequestSessionSuccess(event);\n    }\n  };\n\n  ChromeCastSenderProxy.prototype.launch = function() {\n    chrome.cast.requestSession(this.onRequestSessionSuccess.bind(this), this.onLaunchError.bind(this));\n  };\n\n  ChromeCastSenderProxy.prototype.send = function(msg) {\n    var _ref;\n    if ((_ref = this.session) != null) {\n      if (typeof _ref.sendMessage === \"function\") {\n        _ref.sendMessage(this.messageBus, msg, this.onMessageSuccess.bind(this), this.onMessageError.bind(this));\n      }\n    }\n  };\n\n  ChromeCastSenderProxy.prototype.onLaunchError = function(event) {\n    this.logError(\"launch error.\", event);\n  };\n\n  ChromeCastSenderProxy.prototype.onRequestSessionSuccess = function(event) {\n    var playbackProxy;\n    this.logEvent(\"request session success.\", event);\n    this.session = event;\n    this.session.addMessageListener(this.messageBus, this.onMessage.bind(this));\n    this.session.addUpdateListener(this.onUpdate.bind(this));\n    this.session.sendMessage(this.messageBus, {\n      type: \"createPlayer\",\n      config: this.facade.player.getConfig()\n    }, this.onCreateSucess.bind(this), this.onMessageError.bind(this));\n    playbackProxy = this.facade.player.retrieveProxy(PlaybackProxy.NAME);\n    if (this.session.media.length === 0) {\n      this.loadMedia(playbackProxy.getCurrentTime());\n    }\n  };\n\n  ChromeCastSenderProxy.prototype.onUpdate = function(isAlive) {\n    if (!isAlive) {\n      this.sendNotification(Notifications.CHANGE_PLAYBACK_TARGET, \"amp\");\n      this.stopDisplayTimeUpdate();\n    }\n  };\n\n  ChromeCastSenderProxy.prototype.onCreateSucess = function(event) {\n    this.logEvent(\"MPL created\", event);\n    this.sendNotification(Notifications.CHANGE_PLAYBACK_TARGET, \"chromecast\");\n  };\n\n  ChromeCastSenderProxy.prototype.onMessageSuccess = function(event) {\n    this.logEvent(\"message sent\", event);\n  };\n\n  ChromeCastSenderProxy.prototype.onMessageError = function(event) {\n    this.logError(\"message error\", event);\n  };\n\n  ChromeCastSenderProxy.prototype.onMessage = function(namespace, message) {\n    var detail, target, type;\n    message = JSON.parse(message);\n    type = message.type;\n    detail = message.detail || {};\n    switch (type) {\n      case \"dispatchevent\":\n        target = detail.target === \"player\" ? this.facade.player : this.facade.player[detail.target];\n        if (target != null) {\n          target.dispatchEvent(detail.event);\n        }\n    }\n    this.sendNotification(Notifications.DISPATCH_EVENT, {\n      type: \"message\",\n      message: message\n    });\n  };\n\n  ChromeCastSenderProxy.prototype.onStop = function(event) {\n    this.logEvent(\"stop\");\n    this.session.stop(this.onStopSuccess.bind(this), this.onStopError.bind(this));\n  };\n\n  ChromeCastSenderProxy.prototype.onStopSuccess = function(event) {\n    this.logEvent(\"stop success\", event);\n  };\n\n  ChromeCastSenderProxy.prototype.onStopError = function(event) {\n    this.logError(\"stop error\", event);\n  };\n\n  ChromeCastSenderProxy.prototype.logEvent = function(message, data) {\n    if (message == null) {\n      message = data.type || \"\";\n    }\n    this.facade.logger.log(\"[AMP CHROMECAST] \" + message, data);\n  };\n\n  ChromeCastSenderProxy.prototype.logError = function(message, data) {\n    this.facade.logger.error(\"[AMP CHROMECAST ERROR] \" + message, data);\n  };\n\n  ChromeCastSenderProxy.prototype.loadMedia = function(startTime) {\n    var customData, feed, media, receiverCanPlay, request, source, _ref;\n    if (startTime == null) {\n      startTime = 0;\n    }\n    media = this.facade.player.retrieveProxy(MediaProxy.NAME).getData();\n    if (!(media != null)) {\n      return;\n    }\n    receiverCanPlay = function(type) {\n      if (ChromeCastConstants.SUPPORTED_TYPES.indexOf(type) > -1) {\n        return \"maybe\";\n      } else {\n        return \"\";\n      }\n    };\n    source = Utils.selectSource(media.source, receiverCanPlay);\n    if (!(source != null)) {\n      return;\n    }\n    customData = {\n      media: media\n    };\n    feed = (_ref = this.facade.player.getModules()) != null ? _ref.feed : void 0;\n    if (feed != null) {\n      customData.feed = {\n        data: feed.getData(),\n        url: feed.getURL()\n      };\n    }\n    request = this.mediaToLoadRequest(media, source, startTime, customData);\n    this.session.loadMedia(request, this.onMediaDiscovered.bind(this), this.onMediaError.bind(this));\n  };\n\n  ChromeCastSenderProxy.prototype.mediaToLoadRequest = function(media, source, startTime, customData) {\n    var index, mediaInfo, metadata, request, track, value, _i, _len, _ref, _ref1, _ref2;\n    metadata = new chrome.cast.media.GenericMediaMetadata();\n    metadata.title = media.title;\n    metadata.subtitle = media.description;\n    metadata.image = [new chrome.cast.Image(media.poster)];\n    metadata.releaseDate = (_ref = media.pubDate) != null ? typeof _ref.toISOString === \"function\" ? _ref.toISOString() : void 0 : void 0;\n    mediaInfo = new chrome.cast.media.MediaInfo(source.src, source.type);\n    mediaInfo.duration = media.duration;\n    mediaInfo.customData = customData;\n    mediaInfo.metadata = metadata;\n    if (((_ref1 = media.track) != null ? _ref1.length : void 0) > 0) {\n      mediaInfo.tracks = [];\n      _ref2 = media.track;\n      for (index = _i = 0, _len = _ref2.length; _i < _len; index = ++_i) {\n        value = _ref2[index];\n        track = new chrome.cast.media.Track(index, chrome.cast.media.TrackType.TEXT);\n        track.subtype = chrome.cast.media.TextTrackType.CAPTIONS;\n        track.name = \"Closed Captions\";\n        track.language = value.srclang;\n        track.customData = value;\n        track.trackContentId = value.src;\n        track.trackContentType = value.type;\n        mediaInfo.tracks.push(track);\n      }\n    }\n    request = new chrome.cast.media.LoadRequest(mediaInfo);\n    request.currentTime = startTime;\n    return request;\n  };\n\n  ChromeCastSenderProxy.prototype.onMediaDiscovered = function(media) {\n    if (this.media != null) {\n      this.media.removeUpdateListener(this.mediaStatusUpdate);\n    }\n    this.media = media;\n    this.mediaStatusUpdate = this.onMediaStatusUpdate.bind(this);\n    this.media.addUpdateListener(this.mediaStatusUpdate);\n    this.sendNotification(Notifications.CHANGE_PLAYBACK_TARGET, \"chromecast\");\n  };\n\n  ChromeCastSenderProxy.prototype.onMediaStatusUpdate = function(status) {\n    this.logEvent(\"mediastatusupdate\", status);\n    this.updatePlayerState(this.media.playerState);\n    this.updateDisplayTime();\n    if (status === false) {\n      this.stopDisplayTimeUpdate();\n    }\n  };\n\n  ChromeCastSenderProxy.prototype.updatePlayerState = function(playerState) {\n    var state;\n    if (playerState === this.playerState) {\n      return;\n    }\n    this.playerState = playerState;\n    switch (this.playerState) {\n      case chrome.cast.media.PlayerState.BUFFERING:\n        state = PlayState.WAITING;\n        break;\n      case chrome.cast.media.PlayerState.PLAYING:\n        state = PlayState.PLAYING;\n        break;\n      case chrome.cast.media.PlayerState.PAUSED:\n        state = PlayState.PAUSED;\n    }\n    this.sendNotification(Notifications.CHANGE_PLAY_STATE, state);\n    if (this.playerState === chrome.cast.media.PlayerState.PLAYING) {\n      this.startDisplayTimeUpdate();\n    } else {\n      this.stopDisplayTimeUpdate();\n    }\n  };\n\n  ChromeCastSenderProxy.prototype.startDisplayTimeUpdate = function() {\n    this.stopDisplayTimeUpdate();\n    this.displayTimeTimeout = setInterval(this.updateDisplayTime.bind(this), 100);\n  };\n\n  ChromeCastSenderProxy.prototype.stopDisplayTimeUpdate = function() {\n    clearInterval(this.displayTimeTimeout);\n    this.displayTimeTimeout = null;\n  };\n\n  ChromeCastSenderProxy.prototype.updateDisplayTime = function() {\n    var currentTime, duration, _ref;\n    currentTime = this.media.getEstimatedTime() || 0;\n    duration = ((_ref = this.media.media) != null ? _ref.duration : void 0) || currentTime;\n    if (duration !== this.duration) {\n      this.duration = duration;\n      this.sendNotification(Notifications.CHANGE_DURATION, this.duration);\n      return;\n    }\n    if (currentTime !== this.currentTime) {\n      this.currentTime = currentTime;\n      this.sendNotification(Notifications.DISPLAY_TIME, {\n        currentTime: this.currentTime,\n        duration: this.duration\n      });\n    }\n  };\n\n  ChromeCastSenderProxy.prototype.onMediaError = function(error) {\n    this.logError(\"media error\", error);\n    this.stopDisplayTimeUpdate();\n  };\n\n  ChromeCastSenderProxy.prototype.play = function() {\n    this.media.play();\n  };\n\n  ChromeCastSenderProxy.prototype.pause = function() {\n    this.media.pause();\n  };\n\n  ChromeCastSenderProxy.prototype.setCurrentTime = function(time) {\n    var request;\n    request = new chrome.cast.media.SeekRequest();\n    request.currentTime = time;\n    this.media.seek(request);\n  };\n\n  ChromeCastSenderProxy.prototype.getCurrentTime = function() {\n    return this.currentTime;\n  };\n\n  ChromeCastSenderProxy.prototype.isReceiverAvailable = function() {\n    return this.receiverAvailable;\n  };\n\n  /**\n   * The ChromeCastLaunchCommand class.\n   *\n   * @constructor\n   * @private\n   * @extends {PluginCommand}\n  */\n  function ChromeCastLaunchCommand() {\n    ChromeCastLaunchCommand.__super__.constructor.call(this);\n  }\n\n\n  __extends(ChromeCastLaunchCommand, PluginCommand);\n\n\n  /**\n   * Executes the command.\n   *\n   * @param {puremvc.Notification} notification\n   *    The notification.\n   *\n   * @override\n  */\n  ChromeCastLaunchCommand.prototype.execute = function(notification) {\n    this.proxy.launch();\n  };\n\n  /**\n   * The ChromeCastCaptioningVisibilityChangeCommand class.\n   *\n   * @constructor\n   * @private\n   * @extends {PluginCommand}\n  */\n  function ChromeCastCaptioningVisibilityChangeCommand() {\n    ChromeCastCaptioningVisibilityChangeCommand.__super__.constructor.call(this);\n  }\n\n\n  __extends(ChromeCastCaptioningVisibilityChangeCommand, PluginCommand);\n\n\n  /**\n   * Executes the command.\n   *\n   * @param {puremvc.Notification} notification\n   *    The notification.\n   *\n   * @override\n  */\n  ChromeCastCaptioningVisibilityChangeCommand.prototype.execute = function(notification) {\n    this.proxy.send({\n      type: \"captioning.visibilitychange\",\n      detail: {\n        visibility: notification.getBody()\n      }\n    });\n  };\n\n  /**\n   * The ChromeCastCaptioningSettingsChangeCommand class.\n   *\n   * @constructor\n   * @private\n   * @extends {PluginCommand}\n  */\n  function ChromeCastCaptioningSettingsChangeCommand() {\n    ChromeCastCaptioningSettingsChangeCommand.__super__.constructor.call(this);\n  }\n\n\n  __extends(ChromeCastCaptioningSettingsChangeCommand, PluginCommand);\n\n\n  /**\n   * Executes the command.\n   *\n   * @param {puremvc.Notification} notification\n   *    The notification.\n   *\n   * @override\n  */\n  ChromeCastCaptioningSettingsChangeCommand.prototype.execute = function(notification) {\n    this.proxy.send({\n      type: \"captioning.settingschange\",\n      detail: notification.getBody()\n    });\n  };\n\n  /**\n   * The ChromeCastReceiverReadyCommand class.\n   *\n   * @constructor\n   * @private\n   * @extends {PluginCommand}\n  */\n  function ChromeCastReceiverReadyCommand() {\n    ChromeCastReceiverReadyCommand.__super__.constructor.call(this);\n  }\n\n\n  __extends(ChromeCastReceiverReadyCommand, PluginCommand);\n\n\n  /**\n   * Executes the command.\n   *\n   * @param {puremvc.Notification} notification\n   *    The notification.\n   *\n   * @override\n  */\n  ChromeCastReceiverReadyCommand.prototype.execute = function(notification) {\n    this.facade.player.getViewComponent().hidden = false;\n    this.proxy.ready();\n  };\n\n  /**\n   * The ChromeCastBreakStartCommand class.\n   *\n   * @constructor\n   * @private\n   * @extends {PluginCommand}\n  */\n  function ChromeCastBreakStartCommand() {\n    ChromeCastBreakStartCommand.__super__.constructor.call(this);\n  }\n\n\n  __extends(ChromeCastBreakStartCommand, PluginCommand);\n\n\n  /**\n   * Executes the command.\n   *\n   * @param {puremvc.Notification} notification\n   *    The notification.\n   *\n   * @override\n  */\n  ChromeCastBreakStartCommand.prototype.execute = function(notification) {\n    var playbackCore;\n    this.facade.logger.debug(\"ChromeCastBreakStartCommand\");\n    playbackCore = this.facade.player.retrieveProxy(PlayerProxy.NAME).getActivePlaybackCore();\n    if (playbackCore.getPlaybackCoreName() === \"chromecast\") {\n      playbackCore.unload();\n      playbackCore.src = null;\n    }\n  };\n\n  /**\n   * ChromeCastPlaybackProxy constructor.\n   *\n   * @constructor\n   * @private\n   * @extends {PlaybackCoreProxy}\n  */\n  function ChromeCastPlaybackProxy(types, receiver) {\n    this.receiver = receiver;\n    ChromeCastPlaybackProxy.__super__.constructor.call(this, types);\n  }\n\n\n  __extends(ChromeCastPlaybackProxy, PlaybackCoreProxy);\n\n\n  ChromeCastPlaybackProxy.prototype.initialized = true;\n\n  ChromeCastPlaybackProxy.prototype.player = null;\n\n  ChromeCastPlaybackProxy.prototype.host = null;\n\n  ChromeCastPlaybackProxy.prototype.protocol = null;\n\n  ChromeCastPlaybackProxy.prototype.playbackCoreName = \"chromecast\";\n\n  ChromeCastPlaybackProxy.prototype.manifest = null;\n\n  ChromeCastPlaybackProxy.prototype.xhr = null;\n\n  ChromeCastPlaybackProxy.prototype.trackInfo = null;\n\n  ChromeCastPlaybackProxy.prototype.receiver = null;\n\n  /**\n   * @override\n   * @private\n  */\n  ChromeCastPlaybackProxy.prototype.reset = function() {\n    ChromeCastPlaybackProxy.__super__.reset.call(this);\n    this.xhr = null;\n    this.manifest = null;\n  };\n\n  ChromeCastPlaybackProxy.prototype.unload = function() {\n    if (this.player != null) {\n      this.trackInfo = {\n        activeTrackIds: [this.receiver.chromecastPlayer.activeTrackId],\n        textTrackStyle: this.receiver.chromecastPlayer.textTrackStyle\n      };\n      this.receiver.chromecastPlayer.activeTrackId = null;\n      this.receiver.chromecastPlayer.textTrackStyle = null;\n      this.player.unload();\n      this.player = null;\n    }\n  };\n\n  /** @override\n  */\n  ChromeCastPlaybackProxy.prototype.load = function() {\n    var _this = this;\n    if (this.xhr != null) {\n      if (this.manifest != null) {\n        this.loadMediaPlayer();\n      }\n    } else {\n      this.xhr = new XMLHttpRequest();\n      this.xhr.onload = function(event) {\n        if (_this.xhr.status === 200) {\n          _this.manifest = _this.xhr.responseText;\n          _this.loadMediaPlayer();\n        }\n      };\n      this.xhr.onerror = function(event) {\n        _this.facade.logger.error(event);\n        _this.player.unload();\n      };\n      this.xhr.open(\"GET\", this.getSrc());\n      this.xhr.send();\n    }\n  };\n\n  ChromeCastPlaybackProxy.prototype.loadMediaPlayer = function() {\n    var initStart, mediaProxy, type, types, video,\n      _this = this;\n    this.data.loading = true;\n    this.playWhenLoaded = true;\n    this.unload();\n    video = this.facade.getMediaElement();\n    video.addEventListener(\"loadedmetadata\", this.resumeHandlers.loadedmetadata);\n    video.addEventListener(\"loadedmetadata\", this.handlers.loadedmetadata);\n    video.addEventListener(\"durationchange\", this.handlers.durationchange);\n    video.addEventListener(\"canplaythrough\", this.handlers.canplaythrough);\n    if (video.src != null) {\n      video.src = null;\n    }\n    initStart = 0;\n    if (Logger.enabled === true) {\n      cast.player.api.setLoggerLevel(cast.player.api.LoggerLevel.DEBUG);\n    }\n    this.host = new cast.player.api.Host({\n      'mediaElement': video,\n      'url': this.getSrc()\n    });\n    this.host.updateManifestRequestInfo = function(requestInfo) {\n      if (requestInfo.url === _this.getSrc()) {\n        requestInfo.skipRequest = true;\n        requestInfo.setResponse(_this.manifest);\n      }\n    };\n    this.host.onError = function(errorCode) {\n      _this.facade.logger.error(\"Google Media Player Fatal Error - \" + errorCode);\n      _this.player.unload();\n    };\n    mediaProxy = this.facade.retrieveProxy(MediaProxy.NAME);\n    type = mediaProxy.getType();\n    types = Utils.mimeTypes;\n    switch (type) {\n      case types.m3u8:\n        this.protocol = cast.player.api.CreateHlsStreamingProtocol(this.host);\n        break;\n      case types.mpd:\n        this.protocol = cast.player.api.CreateDashStreamingProtocol(this.host);\n        break;\n      case types.ism:\n        this.protocol = cast.player.api.CreateSmoothStreamingProtocol(this.host);\n    }\n    if (this.protocol != null) {\n      this.player = new cast.player.api.Player(this.host);\n      this.player.load(this.protocol, initStart);\n    } else {\n      this.facade.logger.error(\"Google Media Player Error: Could not create protocol\");\n    }\n  };\n\n  /**\n   * @override\n  */\n  ChromeCastPlaybackProxy.prototype.resumecomplete = function() {\n    ChromeCastPlaybackProxy.__super__.resumecomplete.call(this);\n  };\n\n  /**\n   * The ChromeCastSeekCommand class.\n   *\n   * @constructor\n   * @private\n   * @extends {PluginCommand}\n  */\n  function ChromeCastMediaChangeCommand() {\n    ChromeCastMediaChangeCommand.__super__.constructor.call(this);\n  }\n\n\n  __extends(ChromeCastMediaChangeCommand, PluginCommand);\n\n\n  /**\n   * Executes the command.\n   *\n   * @param {puremvc.Notification} notification\n   *    The notification.\n   *\n   * @override\n  */\n  ChromeCastMediaChangeCommand.prototype.execute = function(notification) {\n    if (this.applicationState.getPlaybackTarget() !== \"chromecast\") {\n      return;\n    }\n    this.facade.logger.debug(\"ChromeCastMediaChangeCommand\");\n    this.proxy.loadMedia();\n  };\n\n  /**\n   * The ChromeCastReceiverMediator class.\n   *\n   * @constructor\n   * @private\n   * @extends {PluginMediator}\n  */\n  function ChromeCastReceiverMediator() {\n    ChromeCastReceiverMediator.__super__.constructor.call(this);\n  }\n\n\n  __extends(ChromeCastReceiverMediator, PluginMediator);\n\n\n  /**\n   * @override\n  */\n  ChromeCastReceiverMediator.prototype.onRegister = function() {\n    ChromeCastReceiverMediator.__super__.onRegister.call(this);\n    this.sendNotification(Notifications.ADD_APPLICATION_STATE, \"chromecast-receiver\");\n  };\n\n  /**\n   * The ChromeCastSenderMediator class.\n   *\n   * @constructor\n   * @private\n   * @extends {PluginMediator}\n  */\n  function ChromeCastSenderMediator() {\n    ChromeCastSenderMediator.__super__.constructor.call(this);\n  }\n\n\n  __extends(ChromeCastSenderMediator, PluginMediator);\n\n\n  ChromeCastSenderMediator.prototype.componentName = \"chromecast\";\n\n  ChromeCastSenderMediator.prototype.controls = null;\n\n  /**\n   * @override\n  */\n  ChromeCastSenderMediator.prototype.onRegister = function() {\n    ChromeCastSenderMediator.__super__.onRegister.call(this);\n    this.controls = new ChromeCastControlsMediator();\n  };\n\n  /**\n   * @override\n  */\n  ChromeCastSenderMediator.prototype.registerOverlay = function() {};\n\n  /**\n   * @override\n  */\n  ChromeCastSenderMediator.prototype.listNotificationInterests = function() {\n    return [Notifications.PLAYBACK_TARGET_CHANGE, Notifications.CHANGE_PLAY_STATE];\n  };\n\n  /**\n   * @override\n  */\n  ChromeCastSenderMediator.prototype.handleNotification = function(notification) {\n    var body, name, target;\n    name = notification.getName();\n    body = notification.getBody();\n    switch (name) {\n      case Notifications.PLAYBACK_TARGET_CHANGE:\n        target = body.value;\n        if (target === \"chromecast\") {\n          this.facade.registerMediator(this.controls);\n        } else {\n          this.facade.removeMediator(this.controls.getMediatorName());\n        }\n        break;\n      case Notifications.CHANGE_PLAY_STATE:\n        this.controls.setState(body);\n    }\n  };\n\n  /**\n   * The ChromeCastSenderMediator class.\n   *\n   * @constructor\n   * @extends {ChromeCastSenderMediator}\n   * @private\n  */\n  function ChromeCastHTMLSenderMediator() {\n    ChromeCastHTMLSenderMediator.__super__.constructor.call(this);\n  }\n\n\n  __extends(ChromeCastHTMLSenderMediator, ChromeCastSenderMediator);\n\n\n  ChromeCastHTMLSenderMediator.prototype.chromeCastButton = null;\n\n  /**\n   * @override\n  */\n  ChromeCastHTMLSenderMediator.prototype.onRegister = function() {\n    ChromeCastHTMLSenderMediator.__super__.onRegister.call(this);\n    this.chromeCastButton = new ChromeCastButtonMediator();\n    this.facade.registerMediator(this.chromeCastButton);\n  };\n\n  /**\n   * @override\n  */\n  ChromeCastHTMLSenderMediator.prototype.listNotificationInterests = function() {\n    return ChromeCastHTMLSenderMediator.__super__.listNotificationInterests.call(this).concat([ChromeCastNotifications.AVAILABILITY_CHANGE]);\n  };\n\n  /**\n   * @override\n  */\n  ChromeCastHTMLSenderMediator.prototype.handleNotification = function(notification) {\n    var body, name;\n    ChromeCastHTMLSenderMediator.__super__.handleNotification.call(this, notification);\n    name = notification.getName();\n    body = notification.getBody();\n    switch (name) {\n      case ChromeCastNotifications.AVAILABILITY_CHANGE:\n        if (body === true) {\n          this.sendNotification(Notifications.ADD_CONTROL_STATE, \"chromecast\");\n          this.facade.player.sendNotification(Notifications.ADD_CONTROL, this.chromeCastButton.getViewComponent());\n        } else {\n          this.sendNotification(Notifications.REMOVE_CONTROL_STATE, \"chromecast\");\n          this.facade.player.sendNotification(Notifications.REMOVE_CONTROL, this.chromeCastButton.getViewComponent());\n        }\n    }\n  };\n\n  /**\n   * The ChromeCastReceiverProxy class.\n   *\n   * @param {Object}  config  The plugin configuration object.\n   * @constructor\n   * @private\n   * @extends {PluginProxy}\n  */\n  function ChromeCastReceiverProxy(config) {\n    this.messageBus = config.messageBus || ChromeCastConstants.CHANNEL_ID;\n    ChromeCastReceiverProxy.__super__.constructor.call(this, config.receiver);\n  }\n\n\n  __extends(ChromeCastReceiverProxy, PluginProxy);\n\n\n  /** @static\n  */\n  ChromeCastReceiverProxy.NAME = ModuleProxy.NAME;\n\n  ChromeCastReceiverProxy.prototype.defaults = {\n    shim: null,\n    types: [\"application/x-mpegURL\", \"application/dash+xml\", \"application/vnd.ms-sstr+xml\"]\n  };\n\n  ChromeCastReceiverProxy.prototype.messageBus = null;\n\n  ChromeCastReceiverProxy.prototype.castReceiverManager = null;\n\n  ChromeCastReceiverProxy.prototype.castMessageBus = null;\n\n  ChromeCastReceiverProxy.prototype.startTime = 0;\n\n  ChromeCastReceiverProxy.prototype.currentTime = 0;\n\n  ChromeCastReceiverProxy.prototype.boundHandler = null;\n\n  ChromeCastReceiverProxy.prototype.amp = null;\n\n  ChromeCastReceiverProxy.prototype.mediaManager = null;\n\n  ChromeCastReceiverProxy.prototype.playbackCore = null;\n\n  ChromeCastReceiverProxy.prototype.teardownTimeout = null;\n\n  ChromeCastReceiverProxy.prototype.chromecastPlayer = null;\n\n  ChromeCastReceiverProxy.prototype.initialize = function() {\n    var core, player;\n    ChromeCastReceiverProxy.__super__.initialize.call(this);\n    this.sendNotification(Notifications.INITIALIZED);\n    core = new ChromeCastPlaybackProxy(this.getConfigurationData().types, this);\n    player = this.facade.player.retrieveProxy(PlayerProxy.NAME);\n    player.registerPlaybackCore(core);\n  };\n\n  ChromeCastReceiverProxy.prototype.ready = function() {\n    if (this.facade.logger.enabled === true) {\n      cast.receiver.logger.setLevelValue(cast.receiver.LoggerLevel.DEBUG);\n    }\n    this.shim = ChromeCastShim.getInstance();\n    this.castReceiverManager = this.shim.castReceiverManager;\n    this.castReceiverManager.onReady = this.castReceiverManager.onSystemVolumeChanged = this.castReceiverManager.onVisibilityChanged = this.logEvent.bind(this);\n    this.castReceiverManager.onSenderConnected = this.onSenderConnected.bind(this);\n    this.castReceiverManager.onSenderDisconnected = this.onSenderDisconnected.bind(this);\n    this.amp = this.facade.player;\n    this.chromecastPlayer = this.shim.player;\n    this.chromecastPlayer.registerPlayer(this.amp);\n    this.mediaManager = this.shim.mediaManager;\n    this.castMessageBus = this.shim.castMessageBuses[this.messageBus];\n    this.castMessageBus.onMessage = this.onMessage.bind(this);\n    this.amp.addEventListener(\"seeking\", this.eventHandler.bind(this));\n    this.amp.addEventListener(\"seeked\", this.eventHandler.bind(this));\n    this.amp.addEventListener(\"pause\", this.startTeardownTimeout.bind(this, 20 * 60));\n    this.amp.addEventListener(\"ended\", this.startTeardownTimeout.bind(this, 5 * 60));\n    this.amp.addEventListener(\"error\", this.startTeardownTimeout.bind(this, 5 * 60));\n    this.amp.addEventListener(\"playing\", this.stopTeardownTimeout.bind(this));\n    this.amp.addEventListener(\"loadedmetadata\", this.stopTeardownTimeout.bind(this));\n    if (this.amp.ads != null) {\n      this[\"amp\"].ads.addEventListener(\"breakstart\", this.dispatchEvent.bind(this, \"ads\"));\n      this[\"amp\"].ads.addEventListener(\"breakend\", this.onBreakEnd.bind(this));\n      this[\"amp\"].ads.addEventListener(\"started\", this.dispatchEvent.bind(this, \"ads\"));\n      this[\"amp\"].ads.addEventListener(\"ended\", this.dispatchEvent.bind(this, \"ads\"));\n      this[\"amp\"].ads.addEventListener(\"companion\", this.dispatchEvent.bind(this, \"ads\"));\n    }\n    this.startTeardownTimeout(5 * 60);\n  };\n\n  ChromeCastReceiverProxy.prototype.onBreakEnd = function(event) {\n    this.dispatchEvent(\"ads\", event);\n    if (this.amp.getEnded() === true) {\n      this.startTeardownTimeout(5 * 60);\n    }\n  };\n\n  ChromeCastReceiverProxy.prototype.logEvent = function(message, data) {\n    if (!(message != null)) {\n      message = data.type || \"\";\n    } else if (!(data != null)) {\n      data = message.data;\n      message = data.type;\n    }\n    this.facade.logger.log(\"[CHROMECAST] \", message, data);\n  };\n\n  ChromeCastReceiverProxy.prototype.onSenderConnected = function(event) {\n    this.logEvent(\"senderconnected\", event);\n    setTimeout(this.sendNotification.bind(this, Notifications.DISPATCH_EVENT, new Event(\"senderconnected\", event)), 0);\n  };\n\n  ChromeCastReceiverProxy.prototype.onSenderDisconnected = function(event) {\n    this.logEvent(\"sender disconnected\", event);\n    if (this.castReceiverManager.getSenders().length === 0 && event.reason === cast.receiver.system.DisconnectReason.REQUESTED_BY_SENDER) {\n      this.teardown();\n    }\n    setTimeout(this.sendNotification.bind(this, Notifications.DISPATCH_EVENT, new Event(\"senderdisconnected\", event)), 0);\n  };\n\n  ChromeCastReceiverProxy.prototype.onMessage = function(event) {\n    var detail, ids, message, textTrackStyle, type;\n    this.logEvent(\"message from sender\", event);\n    try {\n      message = event.data || event.message;\n      if (!(message != null)) {\n        return;\n      }\n      type = message.type;\n      detail = message.detail;\n      if (typeof detail === \"string\") {\n        detail = JSON.parse(detail);\n      }\n      if (!(detail != null)) {\n        return;\n      }\n      switch (type) {\n        case \"captioning.visibilitychange\":\n          ids = [];\n          if (detail.visibility === true) {\n            ids.push(0);\n          }\n          this.chromecastPlayer.editTracksInfo({\n            activeTrackIds: ids\n          });\n          break;\n        case \"captioning.settingschange\":\n          textTrackStyle = new cast.receiver.media.TextTrackStyle();\n          textTrackStyle.foregroundColor = detail.fontColor;\n          textTrackStyle.backgroundColor = detail.backgroundColor;\n          textTrackStyle.fontScale = detail.size;\n          textTrackStyle.windowColor = detail.windowColor;\n          textTrackStyle.fontFamily = detail.fontFamily;\n          textTrackStyle.edgeColor = detail.edgeColor;\n          textTrackStyle.edgeType = detail.edgeType;\n          this.chromecastPlayer.editTracksInfo({\n            textTrackStyle: textTrackStyle\n          });\n          break;\n        case \"stats.visibilitychange\":\n          this[\"amp\"].stats.setHidden(!detail.visibility);\n      }\n      this.sendNotification(Notifications.DISPATCH_EVENT, event);\n    } catch (error) {\n      this.error(error);\n    }\n  };\n\n  ChromeCastReceiverProxy.prototype.onClose = function(event) {\n    this.logEvent(\"message channel closed\", event);\n  };\n\n  ChromeCastReceiverProxy.prototype.eventHandler = function(event) {\n    var msg;\n    msg = {\n      type: event.type\n    };\n    if (event.detail != null) {\n      msg.detail = event.detail;\n    }\n    this.send(msg);\n  };\n\n  ChromeCastReceiverProxy.prototype.dispatchEvent = function(target, event) {\n    this.send({\n      type: \"dispatchevent\",\n      detail: {\n        target: target,\n        event: {\n          type: event.type,\n          detail: event.detail\n        }\n      }\n    });\n  };\n\n  ChromeCastReceiverProxy.prototype.send = function(message) {\n    this.castMessageBus.broadcast(message);\n  };\n\n  ChromeCastReceiverProxy.prototype.startTeardownTimeout = function(seconds) {\n    this.stopTeardownTimeout();\n    this.teardownTimeout = setTimeout(this.teardown.bind(this), seconds * 1000);\n  };\n\n  ChromeCastReceiverProxy.prototype.stopTeardownTimeout = function() {\n    clearTimeout(this.teardownTimeout);\n  };\n\n  ChromeCastReceiverProxy.prototype.teardown = function() {\n    window.close();\n  };\n\n  /**\n   * The ChromeCastFeedChangedCommand class.\n   *\n   * @constructor\n   * @private\n   * @extends {PluginCommand}\n  */\n  function ChromeCastFeedChangedCommand() {\n    ChromeCastFeedChangedCommand.__super__.constructor.call(this);\n  }\n\n\n  __extends(ChromeCastFeedChangedCommand, PluginCommand);\n\n\n  /**\n   * Executes the command.\n   *\n   * @param {puremvc.Notification} notification\n   *    The notification.\n   *\n   * @override\n  */\n  ChromeCastFeedChangedCommand.prototype.execute = function(notification) {\n    var _base;\n    if (typeof (_base = this.proxy).setFeed === \"function\") {\n      _base.setFeed(notification.getBody());\n    }\n  };\n\n  /**\n   * The ChromeCastSeekCommand class.\n   *\n   * @constructor\n   * @private\n   * @extends {PluginCommand}\n  */\n  function ChromeCastSeekCommand() {\n    ChromeCastSeekCommand.__super__.constructor.call(this);\n  }\n\n\n  __extends(ChromeCastSeekCommand, PluginCommand);\n\n\n  /**\n   * Executes the command.\n   *\n   * @param {puremvc.Notification} notification\n   *    The notification.\n   *\n   * @override\n  */\n  ChromeCastSeekCommand.prototype.execute = function(notification) {\n    this.facade.logger.debug(\"ChromeCastSeekCommand\");\n    this.plugin.setCurrentTime(notification.getBody());\n  };\n\n  /**\n   * The ChromeCastButtonMediator class.\n   *\n   * @constructor\n   * @extends {PluginMediator}\n   * @param {Object} parent\n   * @private\n  */\n  function ChromeCastButtonMediator() {\n    ChromeCastButtonMediator.__super__.constructor.call(this);\n  }\n\n\n  __extends(ChromeCastButtonMediator, ButtonMediator);\n\n\n  ChromeCastButtonMediator.prototype.componentName = \"chromecast\";\n\n  ChromeCastButtonMediator.prototype.onclick = function(event) {\n    event.stopImmediatePropagation();\n    this.sendNotification(ChromeCastNotifications.LAUNCH);\n    return false;\n  };\n\n  /**\n   * The ChromeCastTogglePlayPauseCommand class.\n   *\n   * @constructor\n   * @private\n   * @extends {PluginCommand}\n  */\n  function ChromeCastTogglePlayPauseCommand() {\n    ChromeCastTogglePlayPauseCommand.__super__.constructor.call(this);\n  }\n\n\n  __extends(ChromeCastTogglePlayPauseCommand, PluginCommand);\n\n\n  /**\n   * Executes the command.\n   *\n   * @param {puremvc.Notification} notification\n   *    The notification.\n   *\n   * @override\n  */\n  ChromeCastTogglePlayPauseCommand.prototype.execute = function(notification) {\n    switch (this.applicationState.getPlayState()) {\n      case PlayState.ENDED:\n        this.plugin.setCurrentTime(0);\n        this.plugin.play();\n        break;\n      case PlayState.PAUSED:\n      case PlayState.READY:\n        this.plugin.play();\n        break;\n      case PlayState.PLAYING:\n      case PlayState.WAITING:\n        this.plugin.pause();\n    }\n  };\n\n  /**\n   * The ChromeCastControlsMediator class.\n   *\n   * @constructor\n   * @extends {PluginMediator}\n   * @private\n  */\n  function ChromeCastControlsMediator() {\n    ChromeCastControlsMediator.__super__.constructor.call(this);\n  }\n\n\n  __extends(ChromeCastControlsMediator, ControlsMediator);\n\n\n  ChromeCastControlsMediator.prototype.componentName = \"chromecast-controls\";\n\n  ChromeCastControlsMediator.prototype.message = null;\n\n  ChromeCastControlsMediator.prototype.messageContainer = null;\n\n  ChromeCastControlsMediator.prototype.button = null;\n\n  ChromeCastControlsMediator.prototype.captioningActive = false;\n\n  /** @override\n  */\n  ChromeCastControlsMediator.prototype.onRegister = function() {\n    var button, fullscreen, _ref, _ref1;\n    ChromeCastControlsMediator.__super__.onRegister.call(this);\n    this.messageContainer = this.create(\"chromecast-message-container\");\n    this.message = this.createText(\"chromecast-message\", this.localizationManager.getString(\"MSG_CHROMECAST_MESSAGE\"), this.messageContainer);\n    this.button = new ChromeCastButtonMediator();\n    this.facade.registerMediator(this.button);\n    fullscreen = new FullScreenMediator(this.controlBar);\n    this.facade.registerMediator(fullscreen);\n    fullscreen.setDisabled(true);\n    this.sendNotification(Notifications.ADD_CONTROL, this.button.getViewComponent());\n    if (!this.viewComponent.getElementsByClassName(\"akamai-caption akamai-button\").length && ((_ref = this.facade.player.captioning) != null ? (_ref1 = _ref.config) != null ? _ref1.enabled : void 0 : void 0) === true) {\n      button = new ButtonMediator(this.localizationManager.getString(LocalizationConstants.MSG_CC), this.viewComponent.getElementsByClassName(\"akamai-control-bar\")[0], null, \"caption\", this.captionButtonClick.bind(this));\n      this.facade.registerMediator(button);\n      this.captionButton = button.getViewComponent();\n      this.sendNotification(Notifications.ADD_CONTROL, this.captionButton);\n      this.sendNotification(Notifications.ADD_CONTROL_STATE, \"cc-enabled\");\n    }\n  };\n\n  ChromeCastControlsMediator.prototype.captionButtonClick = function() {\n    var note;\n    this.captioningActive = !this.captioningActive;\n    try {\n      this.facade.player.parent.chromecast.postMessage({\n        type: \"captioning.visibilitychange\",\n        detail: {\n          visibility: this.captioningActive\n        }\n      });\n    } catch (error) {\n      this.facade.logger.error(\"[AMP Chromecast Captioning Error]\", error);\n    }\n    note = this.captioningActive ? Notifications.ADD_APPLICATION_STATE : Notifications.REMOVE_APPLICATION_STATE;\n    this.sendNotification(note, \"cc-active\");\n  };\n\n  /**\n   * The ChromeCastPlaybackTargetChangeCommand class.\n   *\n   * @constructor\n   * @private\n   * @extends {PluginCommand}\n  */\n  function ChromeCastPlaybackTargetChangeCommand() {\n    ChromeCastPlaybackTargetChangeCommand.__super__.constructor.call(this);\n  }\n\n\n  __extends(ChromeCastPlaybackTargetChangeCommand, PluginCommand);\n\n\n  /**\n   * Executes the command.\n   *\n   * @param {puremvc.Notification} notification\n   *    The notification.\n   *\n   * @override\n  */\n  ChromeCastPlaybackTargetChangeCommand.prototype.execute = function(notification) {\n    var body, currentTime, duration, target;\n    body = notification.getBody();\n    target = body.target;\n    if (target === \"chromecast\") {\n      this.player.pause();\n    } else if (target === \"amp\") {\n      currentTime = this.proxy.getCurrentTime();\n      duration = this.player.getDuration();\n      if (currentTime !== 0) {\n        if (currentTime !== duration) {\n          this.seekedHandler = this.seeked.bind(this);\n          this.player.addEventListener(\"seeked\", this.seekedHandler);\n        }\n        this.player.setCurrentTime(currentTime);\n      }\n    }\n  };\n\n  ChromeCastPlaybackTargetChangeCommand.prototype.seeked = function(event) {\n    this.player.removeEventListener(\"seeked\", this.seekedHandler);\n    this.player.play();\n  };\n\n  ChromeCastPlaybackTargetChangeCommand.prototype.seekedHandler = null;\n\n  /**\n   * The ChromeCastPlugin class.\n   *\n   * @param {Module}  app     The parent module of this plugin.\n   * @constructor\n   * @private\n   * @extends {Plugin}\n  */\n  function ChromeCastPlugin() {\n    ChromeCastPlugin.__super__.constructor.call(this);\n  }\n\n\n  __extends(ChromeCastPlugin, Plugin);\n\n\n  ChromeCastPlugin.prototype.moduleName = \"chromecast\";\n\n  /** @override\n  */\n  ChromeCastPlugin.prototype.isAvailable = function() {\n    return this.isSender() || this.isReceiver();\n  };\n\n  /** @override\n  */\n  ChromeCastPlugin.prototype.createModel = function() {\n    this.proxy = this.isSender() ? new ChromeCastSenderProxy(this.config) : new ChromeCastReceiverProxy(this.config);\n    this.registerProxy(this.proxy);\n  };\n\n  /** @override\n  */\n  ChromeCastPlugin.prototype.createController = function() {\n    ChromeCastPlugin.__super__.createController.call(this);\n    if (this.isSender()) {\n      this.registerCommand(Notifications.PLAYBACK_TARGET_CHANGE, ChromeCastPlaybackTargetChangeCommand);\n      this.registerCommand(ChromeCastNotifications.LAUNCH, ChromeCastLaunchCommand);\n      this.registerCommand(UserNotifications.TOGGLE_PLAY_PAUSE, ChromeCastTogglePlayPauseCommand);\n      this.registerCommand(UserNotifications.SEEK, ChromeCastSeekCommand);\n      this.registerCommand(CaptioningNotifications.VISIBILITY_CHANGE, ChromeCastCaptioningVisibilityChangeCommand);\n      this.registerCommand(CaptioningNotifications.SETTINGS_CHANGE, ChromeCastCaptioningSettingsChangeCommand);\n      this.registerCommand(Notifications.MEDIA_CHANGE, ChromeCastMediaChangeCommand);\n      this.registerCommand(ChromeCastNotifications.AVAILABILITY_CHANGE, PluginEventCommand);\n    } else if (this.isReceiver()) {\n      this.registerCommand(Notifications.READY, ChromeCastReceiverReadyCommand);\n      this.registerCommand(AdNotifications.BREAK_START, ChromeCastBreakStartCommand);\n    }\n  };\n\n  /** @override\n  */\n  ChromeCastPlugin.prototype.createView = function() {\n    if (this.isSender()) {\n      this.registerMediator(new ChromeCastHTMLSenderMediator());\n    } else if (this.isReceiver()) {\n      this.registerMediator(new ChromeCastReceiverMediator());\n    }\n  };\n\n  ChromeCastPlugin.prototype.isSender = function() {\n    return !ChromeCastPlugin.prototype.isReceiver() && /Chrome/.test(navigator.userAgent);\n  };\n\n  ChromeCastPlugin.prototype.isReceiver = function() {\n    return /CrKey/.test(navigator.userAgent);\n  };\n\n  /** @override\n  */\n  ChromeCastPlugin.prototype.listNotificationInterests = function() {\n    return [Notifications.READY, CaptioningNotifications.VISIBILITY_CHANGE, CaptioningNotifications.SETTINGS_CHANGE, AdNotifications.BREAK_START, Notifications.PLAYBACK_TARGET_CHANGE, Notifications.MEDIA_CHANGE];\n  };\n\n  /** @override\n  */\n  ChromeCastPlugin.prototype.listNotificationPublications = function() {\n    return ChromeCastPlugin.__super__.listNotificationPublications.apply(this, arguments).concat([Notifications.INITIALIZED, Notifications.ADD_CONTROL, Notifications.REMOVE_CONTROL, Notifications.ADD_CONTROL_STATE, Notifications.REMOVE_CONTROL_STATE, Notifications.CHANGE_PLAYBACK_TARGET, ChromeCastNotifications.AVAILABILITY_CHANGE, Notifications.CHANGE_PLAY_STATE, Notifications.CHANGE_DURATION, Notifications.DISPLAY_TIME]);\n  };\n\n  /**\n   * @expose\n  */\n  ChromeCastPlugin.prototype.play = function() {\n    var _base;\n    if (typeof (_base = this.proxy).play === \"function\") {\n      _base.play();\n    }\n  };\n\n  /**\n   * @expose\n  */\n  ChromeCastPlugin.prototype.pause = function() {\n    var _base;\n    if (typeof (_base = this.proxy).pause === \"function\") {\n      _base.pause();\n    }\n  };\n\n  /**\n   * @param {Number}  value   The time in seconds to seek to.\n   * @expose\n  */\n  ChromeCastPlugin.prototype.setCurrentTime = function(value) {\n    this.proxy.setCurrentTime(value);\n    return value;\n  };\n\n  /**\n   * Returns if The chromecast device's Availability\n   * @expose\n  */\n  ChromeCastPlugin.prototype.isReceiverAvailable = function() {\n    var _ref;\n    return ((_ref = this.proxy) != null ? typeof _ref.isReceiverAvailable === \"function\" ? _ref.isReceiverAvailable() : void 0 : void 0) || false;\n  };\n\n  ChromeCastPlugin.prototype.getMedia = function() {\n    return this.proxy.media;\n  };\n\n  ChromeCastPlugin.prototype.getSession = function() {\n    return this.proxy.session;\n  };\n\n  ChromeCastPlugin.prototype.getMediaManager = function() {\n    return this.proxy.mediaManager;\n  };\n\n  ChromeCastPlugin.prototype.getCastReceiverManager = function() {\n    return this.proxy.castReceiverManager;\n  };\n\n  ChromeCastPlugin.prototype.getCastMessageBus = function() {\n    return this.proxy.shim.castMessageBuses[this.proxy.messageBus];\n  };\n\n  /**\n   * sends a message across the message bus.\n   *\n   * @param {Object} msg\n   * @expose\n  */\n  ChromeCastPlugin.prototype.postMessage = function(msg) {\n    this.proxy.send(msg);\n  };\n\n\n  AMP.registerPlugin(\"chromecast\", \"html\", ChromeCastPlugin);\n\n  /**\n   * The ChromeCastFlashPlugin class.\n   *\n   * @param {Module}  app     The parent module of this plugin.\n   * @param {Object}  config  The plugin's configuration object.\n   * @constructor\n   * @extends {ChromeCastPlugin}\n   * @private\n  */\n  function ChromeCastFlashPlugin() {\n    ChromeCastFlashPlugin.__super__.constructor.call(this);\n  }\n\n\n  __extends(ChromeCastFlashPlugin, ChromeCastPlugin);\n\n\n  ChromeCastFlashPlugin.NAME = \"ChromeCastFlashPlugin\";\n\n  /** @override\n  */\n  ChromeCastFlashPlugin.prototype.createModel = function() {\n    this.proxy = new ChromeCastSenderProxy(this.config);\n    this.registerProxy(this.proxy);\n  };\n\n  /** @override\n  */\n  ChromeCastFlashPlugin.prototype.createController = function() {\n    ChromeCastFlashPlugin.__super__.createController.call(this);\n    this.registerCommand(Notifications.PLAYBACK_TARGET_CHANGE, ChromeCastPlaybackTargetChangeCommand);\n    this.registerCommand(ChromeCastNotifications.LAUNCH, ChromeCastLaunchCommand);\n    this.registerCommand(FeedNotifications.FEED_CHANGED, ChromeCastFeedChangedCommand);\n    this.registerCommand(UserNotifications.TOGGLE_PLAY_PAUSE, ChromeCastTogglePlayPauseCommand);\n    this.registerCommand(UserNotifications.SEEK, ChromeCastSeekCommand);\n  };\n\n  /** @override\n  */\n  ChromeCastFlashPlugin.prototype.createView = function() {\n    this.registerMediator(new ChromeCastSenderMediator());\n  };\n\n  /** @override\n  */\n  ChromeCastFlashPlugin.prototype.listNotificationInterests = function() {\n    return [FeedNotifications.FEED_CHANGED, Notifications.CHANGE_MEDIA, Notifications.PLAYBACK_TARGET_CHANGE];\n  };\n\n  /**\n   * @enum {string}\n   * @const\n   * @private\n  */\n\n  var ChromeCastNotifications = {\n    LAUNCH: \"launch\",\n    AVAILABILITY_CHANGE: \"availabilitychange\"\n  };\n\n  /**\n   * @constructor\n   * @extends {PluginWrapper}\n   * @private\n  */\n  function ChromeCastWrapper(player, init) {\n    if (!ChromeCastPlugin.prototype.isSender()) {\n      throw new Error(\"Chromecast not supported on this platform. Skipping plugin initialization.\");\n    }\n    ChromeCastWrapper.__super__.constructor.call(this, player, init);\n    this.plugin = new ChromeCastFlashPlugin();\n    this.plugin.initialize(init, this.player);\n    player.registerModule(this.plugin);\n  }\n\n\n  __extends(ChromeCastWrapper, PluginWrapper);\n\n\n  ChromeCastWrapper.NAME = \"ChromeCastWrapper\";\n\n  ChromeCastWrapper.prototype.buttonId = \"chromecastBtn\";\n\n  ChromeCastWrapper.prototype.plugin = null;\n\n  ChromeCastWrapper.prototype.flashView = {\n    elements: {\n      controls: {\n        elements: {\n          chromecastBtn: {}\n        }\n      }\n    }\n  };\n\n  /**\n  */\n  ChromeCastWrapper.prototype.listNotificationInterests = function() {\n    return ChromeCastWrapper.__super__.listNotificationInterests.call(this).concat([FlashNotifications.ELEMENT_EVENT, FlashNotifications.LOAD_STATE_READY, FlashNotifications.LOAD_STATE_LOADING, FlashNotifications.APPLICATION_STATE_CHANGE, ChromeCastNotifications.AVAILABILITY_CHANGE]);\n  };\n\n  /**\n  */\n  ChromeCastWrapper.prototype.handleNotification = function(notification) {\n    var body, isReceiverAvailable, name, _ref;\n    ChromeCastWrapper.__super__.handleNotification.call(this, notification);\n    name = notification.getName();\n    body = notification.getBody();\n    switch (name) {\n      case FlashNotifications.ELEMENT_EVENT:\n        if (body.type === \"click\" && body.element === this.buttonId) {\n          this.plugin.sendNotification(ChromeCastNotifications.LAUNCH);\n        }\n        break;\n      case ChromeCastNotifications.AVAILABILITY_CHANGE:\n        if (((_ref = this.player.mediaElement) != null ? _ref.setPlayerProperty : void 0) != null) {\n          this.player.mediaElement.setPlayerProperty(this.buttonId, {\n            visible: body\n          });\n        }\n        break;\n      case FlashNotifications.APPLICATION_STATE_CHANGE:\n      case FlashNotifications.LOAD_STATE_READY:\n      case FlashNotifications.LOAD_STATE_LOADING:\n        isReceiverAvailable = this.plugin.isReceiverAvailable();\n        if (isReceiverAvailable) {\n          this.player.mediaElement.setPlayerProperty(this.buttonId, {\n            state: 1\n          });\n        }\n        this.player.mediaElement.setPlayerProperty(this.buttonId, {\n          visible: isReceiverAvailable\n        });\n    }\n  };\n\n  /**\n   * @expose\n  */\n  ChromeCastWrapper.prototype.play = function() {\n    this.plugin.play();\n  };\n\n  /**\n   * @expose\n  */\n  ChromeCastWrapper.prototype.pause = function() {\n    this.plugin.pause();\n  };\n\n  /**\n   * @param {Number}  value   The time in seconds to seek to.\n   * @expose\n  */\n  ChromeCastWrapper.prototype.setCurrentTime = function(value) {\n    this.plugin.setCurrentTime(value);\n    return value;\n  };\n\n  ChromeCastWrapper.prototype.getMedia = function() {\n    return this.plugin.getMedia();\n  };\n\n  ChromeCastWrapper.prototype.getSession = function() {\n    return this.plugin.getSession();\n  };\n\n  ChromeCastWrapper.prototype.getMediaManager = function() {\n    return this.plugin.getMediaManager();\n  };\n\n  ChromeCastWrapper.prototype.getCastReceiverManager = function() {\n    return this.plugin.getCastReceiverManager();\n  };\n\n  ChromeCastWrapper.prototype.getCastMessageBus = function() {\n    return this.plugin.getCastMessageBuses();\n  };\n\n  /**\n   * sends a message across the message bus.\n   *\n   * @param {Object} msg\n   * @expose\n  */\n  ChromeCastWrapper.prototype.postMessage = function(msg) {\n    this.plugin.postMessage(msg);\n  };\n\n\n  AMP.registerPlugin(\"chromecast\", \"flash\", ChromeCastWrapper);\n\n  /**\n   * The MOATPlugin class.\n   *\n   * @param {Module}  app     The parent module of this plugin.\n   * @constructor\n   * @private\n   * @extends {AdPlugin}\n  */\n  function MOATPlugin() {\n    MOATPlugin.__super__.constructor.call(this);\n  }\n\n\n  __extends(MOATPlugin, Plugin);\n\n\n  MOATPlugin.prototype.moduleName = \"moat\";\n\n  /** @override\n  */\n  MOATPlugin.prototype.createModel = function() {\n    this.proxy = new MOATProxy(this.config);\n    this.registerProxy(this.proxy);\n  };\n\n  /** @override\n  */\n  MOATPlugin.prototype.createController = function() {\n    MOATPlugin.__super__.createController.call(this);\n    return this.registerCommand(AdNotifications.AD_MANAGER_LOADED, MOATAdManagerLoadedCommand);\n  };\n\n  /** @override\n  */\n  MOATPlugin.prototype.listNotificationInterests = function() {\n    return [AdNotifications.AD_MANAGER_LOADED];\n  };\n\n\n  AMP.registerPlugin(\"moat\", \"html\", MOATPlugin);\n  AMP.registerPlugin(\"moat\", \"flash\", MOATWrapper);\n\n  /**\n   * Create a ChromeCastShim.\n   *\n   * @param {?cast.receiver.CastReceiverManager.Config} config\n   * @param {Object.<string, string>} messageBuses\n  */\n  function ChromeCastShim(config, messageBuses) {\n    var key, value;\n    if (!/CrKey/.test(navigator.userAgent) || !(typeof cast !== \"undefined\" && cast !== null)) {\n      return;\n    }\n    ChromeCastShim.__super__.constructor.call(this);\n    this.castReceiverManager = cast.receiver.CastReceiverManager.getInstance();\n    this.castReceiverManager.onReady = this.dispatchEvent.bind(this, {\n      type: \"ready\"\n    });\n    this.castReceiverManager.onSenderConnected = this.dispatchEvent.bind(this, {\n      type: \"senderconnected\"\n    });\n    this.castReceiverManager.onSenderDisconnected = this.dispatchEvent.bind(this, {\n      type: \"senderdisconnected\"\n    });\n    this.castReceiverManager.onShutdown = this.dispatchEvent.bind(this, {\n      type: \"shutdown\"\n    });\n    this.castReceiverManager.onStandbyChanged = this.dispatchEvent.bind(this, {\n      type: \"standbychange\"\n    });\n    this.castReceiverManager.onSystemVolumeChanged = this.dispatchEvent.bind(this, {\n      type: \"systemvolumechanged\"\n    });\n    this.castReceiverManager.onVisibilityChanged = this.dispatchEvent.bind(this, {\n      type: \"visibilitychanged\"\n    });\n    this.player = new ChromeCastPlayer(this);\n    this.mediaManager = new cast.receiver.MediaManager(this.player);\n    if (!(messageBuses != null)) {\n      messageBuses = {};\n    }\n    messageBuses[ChromeCastConstants.CHANNEL_ID] = cast.receiver.CastMessageBus.MessageType.JSON;\n    this.castMessageBuses = {};\n    for (key in messageBuses) {\n      value = messageBuses[key];\n      this.castMessageBuses[key] = this.castReceiverManager.getCastMessageBus(key, value);\n      this.castMessageBuses[key].addEventListener(\"message\", this.dispatchEvent.bind(this));\n    }\n    this.castReceiverManager.start(config);\n    return;\n  }\n\n\n  __extends(ChromeCastShim, EventDispatcher);\n\n\n  /**\n   * @type {cast.receiver.CastReceiverManager}\n  */\n  ChromeCastShim.prototype.castReceiverManager = null;\n\n  /**\n   * @type {cast.receiver.MediaManager}\n  */\n  ChromeCastShim.prototype.mediaManager = null;\n\n  /**\n   * @type {Object.<string, cast.receiver.CastMessageBus>}\n  */\n  ChromeCastShim.prototype.castMessageBuses = null;\n\n  /**\n   * @type {cast.receiver.media.Player}\n  */\n  ChromeCastShim.prototype.player = null;\n\n  /**\n  */\n  ChromeCastShim.prototype.isSender = function() {\n    return !this.isReceiver() && /Chrome/.test(navigator.userAgent);\n  };\n\n  /**\n  */\n  ChromeCastShim.prototype.isReceiver = function() {\n    return /CrKey/.test(navigator.userAgent);\n  };\n\n  ChromeCastShim.getInstance = function() {\n    return this.instance;\n  };\n\n  ChromeCastShim.instance = new ChromeCastShim();\n\n  /**\n   * The DASHPlugin class.\n   *\n   * @param {Module}  app     The parent module of this plugin.\n   * @constructor\n   * @private\n   * @extends {Plugin}\n  */\n  function DASHPlugin() {\n    DASHPlugin.__super__.constructor.call(this);\n  }\n\n\n  __extends(DASHPlugin, Plugin);\n\n\n  DASHPlugin.prototype.moduleName = \"dash\";\n\n  /** @override\n  */\n  DASHPlugin.prototype.createModel = function() {\n    this.registerProxy(new DASHProxy(this.config));\n  };\n\n  /**\n   * Returns DASH PlaybackProxy\n   *\n  */\n  DASHPlugin.prototype.getPlaybackProxy = function() {\n    return this.proxy.playbackProxy;\n  };\n\n  /**\n   * Returns instance of DASH player\n   *\n  */\n  DASHPlugin.prototype.getInstance = function() {\n    return this.getPlaybackProxy().player;\n  };\n\n  DASHPlugin.prototype.registered = function() {\n    this.player.registerCommand(Notifications.CHANGE_DISPLAY_STATE, DASHChangeDisplayStateCommand);\n    DASHPlugin.__super__.registered.call(this);\n  };\n\n  /**\n  */\n  DASHPlugin.prototype.listNotificationPublications = function() {\n    return DASHPlugin.__super__.listNotificationPublications.call(this).concat([Notifications.FRAGMENT_LOAD_START, Notifications.FRAGMENT_LOADED]);\n  };\n\n\n  AMP.registerPlugin(\"dash\", \"html\", DASHPlugin);\n\n  /**\n   * The ControlPanelPlugin class.\n   *\n   * @param {Module}  app     The parent module of this plugin.\n   * @constructor\n   * @private\n   * @extends {Plugin}\n  */\n  function ControlPlugin() {\n    ControlPlugin.__super__.constructor.call(this);\n  }\n\n\n  __extends(ControlPlugin, Plugin);\n\n\n  /** @override\n  */\n  ControlPlugin.prototype.listNotificationPublications = function() {\n    return ControlPlugin.__super__.listNotificationPublications.apply(this, arguments).concat([Notifications.ADD_CONTROL, Notifications.REMOVE_CONTROL, Notifications.ADD_CONTROL_STATE, Notifications.REMOVE_CONTROL_STATE]);\n  };\n\n  /**\n   * The PanelControlMediator class.\n   *\n   * @constructor\n   * @private\n   * @extends {ButtonMediator}\n  */\n  function PanelControlMediator(componentName) {\n    PanelControlMediator.__super__.constructor.call(this, null, null, null, componentName, onclick);\n  }\n\n\n  __extends(PanelControlMediator, ButtonMediator);\n\n\n  PanelControlMediator.prototype.panel = null;\n\n  PanelControlMediator.prototype.timeout = null;\n\n  PanelControlMediator.prototype.closePanelDelayed = null;\n\n  /**\n   * @override\n  */\n  PanelControlMediator.prototype.onRegister = function() {\n    this.closePanelDelayed = this.delayedClosePanel.bind(this);\n    if (Utils.getDevice() === \"desktop\") {\n      this.onmouseleave = this.closePanelDelayed;\n      this.onmouseenter = this.openPanel;\n      this.onclick = this.clickHandler;\n    } else {\n      this.onclick = this.togglePanel;\n    }\n    PanelControlMediator.__super__.onRegister.call(this);\n    this.sendNotification(Notifications.ADD_CONTROL_STATE, \"\" + this.componentName + \"-enabled\");\n    this.sendNotification(Notifications.ADD_CONTROL, this.viewComponent);\n  };\n\n  PanelControlMediator.prototype.openPanel = function() {\n    clearTimeout(this.timeout);\n    this.sendNotification(PanelNotifications.OPEN_PANEL, this.panel);\n    this.panel.viewComponent.addEventListener(\"mouseleave\", this.closePanelDelayed);\n  };\n\n  PanelControlMediator.prototype.closePanel = function() {\n    if (Utils.isMouseOverElement(this.panel.viewComponent) || Utils.isMouseOverElement(this.viewComponent) || this.facade.player.retrieveProxy(ApplicationStateProxy.NAME).getIsUserActive()) {\n      return;\n    }\n    this.panel.viewComponent.addEventListener(\"mouseleave\", this.closePanelDelayed);\n    this.sendNotification(PanelNotifications.CLOSE_PANEL, this.panel);\n  };\n\n  PanelControlMediator.prototype.delayedClosePanel = function() {\n    this.timeout = setTimeout(this.closePanel.bind(this), 350);\n  };\n\n  PanelControlMediator.prototype.togglePanel = function(event) {\n    event.stopImmediatePropagation();\n    this.sendNotification(PanelNotifications.TOGGLE_PANEL, this.panel);\n  };\n\n  PanelControlMediator.prototype.clickPanel = function() {};\n\n  /**\n   * The PlayPauseMediator class.\n   *\n   * @constructor\n   * @private\n   * @extends {ButtonMediator}\n  */\n  function PanelMediator(componentName) {\n    PanelMediator.__super__.constructor.call(this, componentName, null, null, null);\n  }\n\n\n  __extends(PanelMediator, ComponentMediator);\n\n\n  PanelMediator.prototype.componentType = \"panel\";\n\n  PanelMediator.prototype.control = null;\n\n  /**\n   * @override\n  */\n  PanelMediator.prototype.onRegister = function() {\n    PanelMediator.__super__.onRegister.call(this);\n    this.sendNotification(PanelNotifications.ADD_PANEL, this);\n  };\n\n  /**\n   * The ControlProxy class.\n   *\n   * @constructor\n   * @private\n   * @extends {PluginProxy}\n  */\n  function ControlProxy(config) {\n    ControlProxy.__super__.constructor.call(this, config);\n  }\n\n\n  __extends(ControlProxy, PluginProxy);\n\n\n  /** @static\n  */\n  ControlProxy.NAME = ModuleProxy.NAME;\n\n  ControlProxy.prototype.loaded = true;\n\n  ControlProxy.prototype.controlName = null;\n\n  /**\n   *\n  */\n  ControlProxy.prototype.getControlName = function() {\n    return this.controlName;\n  };\n\n  ControlProxy.prototype.setControlName = function(value) {\n    return this.controlName = value;\n  };\n\n  /**\n   * The ControlPanelProxy class.\n   *\n   * @constructor\n   * @private\n   * @extends {PluginProxy}\n  */\n  function ControlPanelProxy(config) {\n    ControlPanelProxy.__super__.constructor.call(this, config);\n  }\n\n\n  __extends(ControlPanelProxy, ControlProxy);\n\n\n  /** @static\n  */\n  ControlPanelProxy.NAME = ModuleProxy.NAME;\n\n  ControlPanelProxy.prototype.hidden = true;\n\n  /**\n   *\n  */\n  ControlPanelProxy.prototype.getHidden = function() {\n    return this.hidden;\n  };\n\n  ControlPanelProxy.prototype.setHidden = function(value) {\n    this.hidden = value;\n    return value;\n  };\n\n  /**\n   * The VolumePanelProxy class.\n   *\n   * @constructor\n   * @private\n   * @extends {ControlPanelProxy}\n  */\n  function VolumePanelProxy(config) {\n    VolumePanelProxy.__super__.constructor.call(this, config);\n  }\n\n\n  __extends(VolumePanelProxy, ControlPanelProxy);\n\n\n  /** @static\n  */\n  VolumePanelProxy.NAME = ModuleProxy.NAME;\n\n  VolumePanelProxy.prototype.controlName = \"volume\";\n\n  VolumePanelProxy.prototype.defaults = {\n    direction: \"vertical\"\n  };\n\n  VolumePanelProxy.prototype.getDirection = function() {\n    return this.data.direction;\n  };\n\n  /**\n  */\n  function VolumePanelWrapper(player, config) {\n    if (config == null) {\n      config = {};\n    }\n    VolumePanelWrapper.__super__.constructor.call(this, player, config);\n  }\n\n\n  __extends(VolumePanelWrapper, PluginWrapper);\n\n\n  VolumePanelWrapper.NAME = \"VolumePanelWrapper\";\n\n\n  AMP.registerPlugin(\"volumepanel\", \"flash\", VolumePanelWrapper);\n\n  function VolumePanelControlMediator(componentName) {\n    VolumePanelControlMediator.__super__.constructor.call(this, componentName);\n  }\n\n\n  __extends(VolumePanelControlMediator, PanelControlMediator);\n\n\n  VolumePanelControlMediator.prototype.clickHandler = function() {\n    this.sendNotification(Notifications.TOGGLE_MUTED);\n  };\n\n  /**\n   * The VolumeMediator class.\n   *\n   * @constructor\n   * @private\n   * @extends {ModuleMediator}\n   * @param {Object} viewComponent\n  */\n  function VolumeMediator(parent, direction) {\n    VolumeMediator.__super__.constructor.call(this, parent, direction);\n  }\n\n\n  __extends(VolumeMediator, SliderMediator);\n\n\n  VolumeMediator.prototype.componentName = \"volume\";\n\n  VolumeMediator.prototype.draggable = true;\n\n  /**\n   * @override\n  */\n  VolumeMediator.prototype.valueChanged = function() {\n    this.sendNotification(Notifications.CHANGE_VOLUME, this.value);\n    this.sendNotification(UserSettingsNotifications.UPDATE_SETTINGS, {\n      volume: this.value\n    });\n  };\n\n  /**\n   * @override\n  */\n  VolumeMediator.prototype.listNotificationInterests = function() {\n    return [Notifications.VOLUME_CHANGE, Notifications.READY];\n  };\n\n  /**\n   * @override\n  */\n  VolumeMediator.prototype.handleNotification = function(notification) {\n    switch (notification.getName()) {\n      case Notifications.READY:\n        this.updateValue(this.facade.player.retrieveProxy(PlaybackProxy.NAME).getVolume());\n        break;\n      case Notifications.VOLUME_CHANGE:\n        this.updateValue(notification.getBody());\n    }\n  };\n\n  /**\n   * The ControlPanelMediator class.\n   *\n   * @constructor\n   * @private\n   * @extends {PluginMediator}\n  */\n  function ControlPanelMediator() {\n    ControlPanelMediator.__super__.constructor.call(this);\n    this.controls = {};\n  }\n\n\n  __extends(ControlPanelMediator, PluginMediator);\n\n\n  ControlPanelMediator.prototype.panel = null;\n\n  ControlPanelMediator.prototype.control = null;\n\n  ControlPanelMediator.prototype.separator = null;\n\n  ControlPanelMediator.prototype.controls = null;\n\n  ControlPanelMediator.prototype.labels = null;\n\n  ControlPanelMediator.prototype.closed = true;\n\n  ControlPanelMediator.prototype.panelClass = PanelMediator;\n\n  ControlPanelMediator.prototype.controlClass = PanelControlMediator;\n\n  /**\n   * @override\n  */\n  ControlPanelMediator.prototype.onRegister = function() {\n    this.panel = this.createPanel(this.componentName);\n    this.control = this.createControl(this.componentName);\n    this.separator = this.createSeparator(this.componentName);\n    this.panel.control = this.control;\n    this.control.panel = this.panel;\n    if (this.labels == null) {\n      this.labels = {};\n    }\n    this.createPanelControls(name);\n  };\n\n  ControlPanelMediator.prototype.createControl = function(name) {\n    var control;\n    control = new this.controlClass(name);\n    this.facade.registerMediator(control);\n    return control;\n  };\n\n  ControlPanelMediator.prototype.createPanel = function(name) {\n    var panel;\n    panel = new this.panelClass(name);\n    this.facade.registerMediator(panel);\n    return panel;\n  };\n\n  ControlPanelMediator.prototype.createSeparator = function(name) {\n    return this.create([\"separator\", \"icon\"], this.panel);\n  };\n\n  ControlPanelMediator.prototype.createPanelControls = function(name) {\n    var data, key, value, _ref;\n    data = this.plugin.getConfigurationData();\n    for (key in data) {\n      value = data[key];\n      if (value === true) {\n        this.controls[key] = this.addPanelControl(new ButtonMediator(this.localizationManager.getString(this.labels[key]), null, null, key, (_ref = this.panelButtonClickHandler) != null ? typeof _ref.bind === \"function\" ? _ref.bind(this, key) : void 0 : void 0));\n      }\n    }\n  };\n\n  ControlPanelMediator.prototype.addPanelControl = function(control) {\n    this.facade.registerMediator(control);\n    this.panel.getViewComponent().appendChild(control.getViewComponent());\n    return control;\n  };\n\n  /**\n  */\n  ControlPanelMediator.prototype.panelButtonClickHandler = function() {\n    this.sendNotification(PanelNotifications.CLOSE_PANEL, this.panel);\n  };\n\n  /**\n   * The VolumePanelMediator class.\n   *\n   * @constructor\n   * @private\n   * @extends {ControlPanelMediator}\n  */\n  function VolumePanelMediator() {\n    VolumePanelMediator.__super__.constructor.call(this);\n  }\n\n\n  __extends(VolumePanelMediator, ControlPanelMediator);\n\n\n  VolumePanelMediator.prototype.componentName = \"volume\";\n\n  VolumePanelMediator.prototype.slider = null;\n\n  VolumePanelMediator.prototype.level = null;\n\n  VolumePanelMediator.prototype.controlClass = VolumePanelControlMediator;\n\n  /**\n  */\n  VolumePanelMediator.prototype.onRegister = function() {\n    VolumePanelMediator.__super__.onRegister.call(this);\n    this.slider = new VolumeMediator(this.panel, this.plugin.getDirection());\n    this.facade.registerMediator(this.slider);\n  };\n\n  VolumePanelMediator.prototype.updateVolumeButton = function(percent) {\n    var level;\n    level = Math.ceil(percent * 10);\n    if (level === this.level) {\n      return;\n    }\n    if (this.level != null) {\n      this.sendNotification(Notifications.REMOVE_CONTROL_STATE, \"volume-\" + this.level);\n    }\n    this.level = level;\n    this.sendNotification(Notifications.ADD_CONTROL_STATE, \"volume-\" + this.level);\n  };\n\n  /**\n   * @override\n  */\n  VolumePanelMediator.prototype.listNotificationInterests = function() {\n    return VolumePanelMediator.__super__.listNotificationInterests.apply(this, arguments).concat([Notifications.VOLUME_CHANGE]);\n  };\n\n  /**\n   * @override\n  */\n  VolumePanelMediator.prototype.handleNotification = function(notification) {\n    VolumePanelMediator.__super__.handleNotification.call(this, notification);\n    switch (notification.getName()) {\n      case Notifications.VOLUME_CHANGE:\n        this.updateVolumeButton(notification.body);\n    }\n  };\n\n  /**\n   * The ControlPanelPlugin class.\n   *\n   * @param {Module}  app     The parent module of this plugin.\n   * @constructor\n   * @private\n   * @extends {Plugin}\n  */\n  function ControlPanelPlugin() {\n    ControlPanelPlugin.__super__.constructor.call(this);\n  }\n\n\n  __extends(ControlPanelPlugin, ControlPlugin);\n\n\n  /** @override\n  */\n  ControlPanelPlugin.prototype.listNotificationPublications = function() {\n    var key, value;\n    return ControlPanelPlugin.__super__.listNotificationPublications.call(this).concat((function() {\n      var _results;\n      _results = [];\n      for (key in PanelNotifications) {\n        value = PanelNotifications[key];\n        _results.push(value);\n      }\n      return _results;\n    })());\n  };\n\n  /**\n   * The PlaylistMediator class.\n   *\n   * @constructor\n   * @private\n   * @extends {PluginMediator}\n   * @param {Object} viewComponent\n  */\n  function PlaylistMediator(viewComponent) {\n    PlaylistMediator.__super__.constructor.call(this, viewComponent);\n  }\n\n\n  __extends(PlaylistMediator, PluginMediator);\n\n\n  /**\n   * Stats Mediator\n   *\n   * @static\n   * @type {string}\n  */\n  PlaylistMediator.prototype.componentName = \"playlist\";\n\n  PlaylistMediator.prototype.playlistButton = null;\n\n  /**\n   * @override\n  */\n  PlaylistMediator.prototype.onRegister = function() {\n    var button;\n    button = new ButtonMediator(null, this.viewComponent, null, \"playlist\", this.playlistOnClick.bind(this));\n    this.facade.registerMediator(button);\n    this.playlistButton = button.getViewComponent();\n    this.sendNotification(Notifications.ADD_CONTROL, this.playlistButton);\n    this.sendNotification(Notifications.ADD_CONTROL_STATE, \"playlist-enabled\");\n    PlaylistMediator.__super__.onRegister.call(this);\n  };\n\n  PlaylistMediator.prototype.playlistOnClick = function(event) {\n    this.facade.logger.debug('AMP Event: Playlist Clicked');\n  };\n\n  /**\n   * The VolumePanelPlugin class.\n   *\n   * @constructor\n   * @private\n   * @extends {Plugin}\n  */\n  function VolumePanelPlugin() {\n    VolumePanelPlugin.__super__.constructor.call(this);\n  }\n\n\n  __extends(VolumePanelPlugin, ControlPanelPlugin);\n\n\n  VolumePanelPlugin.prototype.moduleName = \"volumepanel\";\n\n  /** @override\n  */\n  VolumePanelPlugin.prototype.createFramework = function() {\n    if (!Utils.isVolumeSettable()) {\n      return;\n    } else {\n      VolumePanelPlugin.__super__.createFramework.call(this);\n    }\n  };\n\n  /** @override\n  */\n  VolumePanelPlugin.prototype.createModel = function() {\n    this.registerProxy(new VolumePanelProxy(this.config));\n  };\n\n  /** @override\n  */\n  VolumePanelPlugin.prototype.createView = function() {\n    if (!Utils.isVolumeSettable()) {\n      return;\n    }\n    this.registerMediator(new VolumePanelMediator());\n  };\n\n  /** @override\n  */\n  VolumePanelPlugin.prototype.listNotificationPublications = function() {\n    return VolumePanelPlugin.__super__.listNotificationPublications.apply(this, arguments).concat([Notifications.CHANGE_VOLUME, Notifications.TOGGLE_MUTED, UserSettingsNotifications.UPDATE_SETTINGS]);\n  };\n\n  /** @override\n  */\n  VolumePanelPlugin.prototype.listNotificationInterests = function() {\n    return VolumePanelPlugin.__super__.listNotificationInterests.apply(this, arguments).concat([Notifications.VOLUME_CHANGE, Notifications.READY]);\n  };\n\n\n  AMP.registerPlugin(\"volumepanel\", \"html\", VolumePanelPlugin);\n\n  /**\n  */\n  /** @constructor\n  */\n  function OutbrainProxy(config) {\n    OutbrainProxy.__super__.constructor.call(this, config);\n  }\n\n\n  __extends(OutbrainProxy, RecommendationsProxy);\n\n\n  /** @static\n  */\n  OutbrainProxy.NAME = ModuleProxy.NAME;\n\n  /** @override\n  */\n  OutbrainProxy.prototype.data = {\n    url: null,\n    target: null,\n    apiKey: null,\n    jsWidgetId: null\n  };\n\n  /** @override\n  */\n  OutbrainProxy.prototype.createRecommendations = function(feed) {\n    var item, rec, recs, _i, _len, _ref;\n    recs = [];\n    _ref = feed.documents.doc;\n    for (_i = 0, _len = _ref.length; _i < _len; _i++) {\n      item = _ref[_i];\n      rec = new RecommendationVO(item.video.id, item.url, item.video.title, item.video.title, item.thumbnail.url, 0, null, this.getTarget(), item);\n      recs.push(rec);\n    }\n    return recs;\n  };\n\n  /** @override\n  */\n  OutbrainProxy.prototype.getURL = function() {\n    var format, href, key, url, widgetJSId;\n    format = \"json\";\n    widgetJSId = encodeURIComponent(this.data.jsWidgetId);\n    key = encodeURIComponent(this.data.apiKey);\n    href = encodeURIComponent(document.location.href);\n    url = this.data.url + \"?format=\" + format + \"&widgetJSId=\" + widgetJSId + \"&settings=false&url=\" + href + \"&idx=0&key=\" + key + \"&rand=\" + Date.now() + \"&recs=true\";\n    return url;\n  };\n\n  /**\n   * @constructor\n   * @private\n   * @extends {RecommendationsWrapper}\n  */\n  function OutbrainWrapper(player, config) {\n    if (config == null) {\n      config = {};\n    }\n    OutbrainWrapper.__super__.constructor.call(this, player, config);\n  }\n\n\n  __extends(OutbrainWrapper, RecommendationsWrapper);\n\n\n  OutbrainWrapper.NAME = \"OutbrainWrapper\";\n\n  /**\n  */\n  OutbrainWrapper.prototype.createFlashVars = function(flashvars) {\n    OutbrainWrapper.__super__.createFlashVars.call(this, flashvars);\n    flashvars.recommendations_partner = \"outbrain\";\n    return flashvars;\n  };\n\n  /**\n  */\n  OutbrainWrapper.prototype.createXML = function(xml) {\n    var application, prop, props, recommendations, vendor, _i, _len;\n    application = xml.firstChild;\n    recommendations = xml.getElementsByTagName(\"recommendations\")[0];\n    if (!(recommendations != null)) {\n      recommendations = xml.createElement(\"recommendations\");\n      application.appendChild(recommendations);\n    }\n    vendor = xml.createElement(\"vendor\");\n    vendor.setAttribute(\"id\", \"outbrain\");\n    recommendations.appendChild(vendor);\n    props = [\n      {\n        value: this.config.url,\n        key: \"OUTBRAIN_BASE_URL\"\n      }, {\n        value: this.config.apiKey,\n        key: \"OUTBRAIN_API_KEY\"\n      }, {\n        value: this.config.jsWidgetId,\n        key: \"OUTBRAIN_WIDGET_JS_ID\"\n      }, {\n        value: this.config.mode,\n        key: \"OUTBRAIN_MODE\"\n      }, {\n        value: this.config.playerSrcId,\n        key: \"OUTBRAIN_PLAYER_SRC_ID\"\n      }, {\n        value: \"internal\",\n        key: \"OUTBRAIN_VIEW_PROVIDER\"\n      }, {\n        value: this.config.videoData,\n        key: \"videoData\"\n      }\n    ];\n    for (_i = 0, _len = props.length; _i < _len; _i++) {\n      prop = props[_i];\n      if (prop.value != null) {\n        this.createProperty(xml, prop.key, prop.value, vendor);\n      }\n    }\n    return xml;\n  };\n\n  /**\n   * The PlaylistPlugin class.\n   *\n   * @param {Module}  app     The parent module of this plugin.\n   * @constructor\n   * @private\n   * @extends {Plugin}\n  */\n  function PlaylistPlugin() {\n    PlaylistPlugin.__super__.constructor.call(this);\n  }\n\n\n  __extends(PlaylistPlugin, Plugin);\n\n\n  PlaylistPlugin.prototype.moduleName = \"playlist\";\n\n  /** @override\n  */\n  PlaylistPlugin.prototype.createView = function() {\n    this.registerMediator(new PlaylistMediator());\n  };\n\n  /** @override\n  */\n  PlaylistPlugin.prototype.listNotificationPublications = function() {\n    return PlaylistPlugin.__super__.listNotificationPublications.call(this).concat([Notifications.ADD_CONTROL, Notifications.REMOVE_CONTROL, Notifications.ADD_CONTROL_STATE, Notifications.REMOVE_CONTROL_STATE]);\n  };\n\n\n  AMP.registerPlugin(\"playlist\", \"html\", PlaylistPlugin);\n\n  function AdChoicesWrapper() {\n    return AdChoicesWrapper.__super__.constructor.apply(this, arguments);\n  }\n\n\n  __extends(AdChoicesWrapper, PluginWrapper);\n\n\n  AdChoicesWrapper.NAME = \"AdChoicesWrapper\";\n\n  AdChoicesWrapper.prototype.flashView = {\n    elements: {\n      adOptions: {\n        elements: {\n          adChoices: {\n            attributes: {\n              target: \"http://www.akamai.com/\"\n            }\n          }\n        }\n      }\n    }\n  };\n\n  /**\n   * The AdChoicesMediator class.\n   *\n   * @constructor\n   * @extends {ComponentMediator}\n   * @private\n  */\n  function AdChoicesMediator() {\n    AdChoicesMediator.__super__.constructor.call(this);\n  }\n\n\n  __extends(AdChoicesMediator, ComponentMediator);\n\n\n  AdChoicesMediator.prototype.componentName = \"ad-choices\";\n\n  AdChoicesMediator.prototype.icon = null;\n\n  AdChoicesMediator.prototype.text = null;\n\n  AdChoicesMediator.prototype.container = null;\n\n  /**\n   * @override\n  */\n  AdChoicesMediator.prototype.onRegister = function() {\n    var data;\n    AdChoicesMediator.__super__.onRegister.call(this);\n    data = this.facade.retrieveProxy(ModuleProxy.NAME);\n    this.container = this.create(\"ad-choices-link\", this, \"a\");\n    this.container.target = \"_blank\";\n    this.container.href = data.getTarget();\n    this.text = this.createText(\"ad-choices-text\", \"AdChoices\", this.container);\n    this.icon = this.create(\"ad-choices-icon\", this.container);\n  };\n\n  /**\n   * @override\n  */\n  AdChoicesMediator.prototype.listNotificationInterests = function() {\n    return [AdNotifications.AD_CONTAINER_CREATED];\n  };\n\n  /**\n   * @override\n  */\n  AdChoicesMediator.prototype.handleNotification = function(notification) {\n    var container;\n    switch (notification.getName()) {\n      case AdNotifications.AD_CONTAINER_CREATED:\n        container = notification.getBody();\n        if (container != null) {\n          container.appendChild(this.viewComponent);\n        }\n    }\n  };\n\n  /**\n   *\n  */\n  /** @constructor\n  */\n  function AdChoicesProxy(config) {\n    AdChoicesProxy.__super__.constructor.call(this, config);\n  }\n\n\n  __extends(AdChoicesProxy, ModuleProxy);\n\n\n  /** @static\n  */\n  AdChoicesProxy.NAME = ModuleProxy.NAME;\n\n  AdChoicesProxy.prototype.defaults = {\n    target: null\n  };\n\n  /**\n   *\n  */\n  AdChoicesProxy.prototype.getTarget = function() {\n    return this.data.target;\n  };\n\n  AdChoicesProxy.prototype.setTarget = function(value) {\n    return this.data.target = value;\n  };\n\n  /**\n   * The OutbrainPlugin class.\n   *\n   * @param {Module}  app     The parent module of this plugin.\n   * @constructor\n   * @private\n   * @extends {RecommendationsPlugin}\n  */\n  function OutbrainPlugin() {\n    OutbrainPlugin.__super__.constructor.call(this);\n  }\n\n\n  __extends(OutbrainPlugin, RecommendationsPlugin);\n\n\n  OutbrainPlugin.prototype.moduleName = \"outbrain\";\n\n  /** @override\n  */\n  OutbrainPlugin.prototype.createModel = function() {\n    OutbrainPlugin.__super__.createModel.call(this);\n    this.registerProxy(new OutbrainProxy(this.config));\n  };\n\n\n  AMP.registerPlugin(\"outbrain\", \"html\", OutbrainPlugin);\n  AMP.registerPlugin(\"outbrain\", \"flash\", OutbrainWrapper);\n\n  /**\n   * RaptPlaybackProxy constructor.\n   *\n   * @constructor\n   * @private\n   * @extends {PlaybackCoreProxy}\n  */\n  function RaptPlaybackProxy(data) {\n    this.name = this.playbackCoreName + \"-\" + Date.now();\n    RaptPlaybackProxy.__super__.constructor.call(this, data.types);\n  }\n\n\n  __extends(RaptPlaybackProxy, PlaybackCoreProxy);\n\n\n  RaptPlaybackProxy.prototype.playbackCoreName = \"rapt\";\n\n  RaptPlaybackProxy.prototype.mediaElement = null;\n\n  RaptPlaybackProxy.prototype.mediator = null;\n\n  /** @override\n  */\n  RaptPlaybackProxy.prototype.getMediaElement = function() {\n    return this.mediaElement;\n  };\n\n  RaptPlaybackProxy.prototype.onRegister = function() {\n    var iframe;\n    if (!(this.mediator != null)) {\n      this.mediator = new MediaElementMediator(\"rapt\", \"iframe\");\n      this.mediator.onRegister();\n      iframe = this.mediator.getViewComponent();\n      iframe.player = this.facade;\n      iframe.name = this.name;\n      iframe.setAttribute(\"allowfullscreen\", \"true\");\n      iframe.setAttribute(\"webkitallowfullscreen\", \"true\");\n      iframe.setAttribute(\"mozallowfullscreen\", \"true\");\n      iframe.setAttribute(\"scrolling\", \"no\");\n      iframe.setAttribute(\"frameborder\", \"0\");\n      iframe.setAttribute(\"marginwidth\", \"0\");\n      iframe.setAttribute(\"marginheight\", \"0\");\n      this.sendNotification(Notifications.PLAYBACK_CORE_CHANGE, this.mediator);\n      this.mediaElement = new RaptHTML5Video(this.name);\n      this.mediaElement.addEventListener(\"interactivebreakstart\", this.oninteractivebreakstart.bind(this));\n      this.mediaElement.addEventListener(\"interactivebreakend\", this.oninteractivebreakend.bind(this));\n      this.initialized = true;\n    }\n  };\n\n  RaptPlaybackProxy.prototype.replay = function() {\n    this.mediaElement.replay();\n  };\n\n  RaptPlaybackProxy.prototype.oninteractivebreakstart = function() {\n    this.sendNotification(Notifications.ADD_APPLICATION_STATE, \"interactive\");\n  };\n\n  RaptPlaybackProxy.prototype.oninteractivebreakend = function() {\n    this.sendNotification(Notifications.REMOVE_APPLICATION_STATE, \"interactive\");\n  };\n\n  function RaptHTML5Video(name) {\n    var logEvent,\n      _this = this;\n    this.name = name;\n    this.data = {\n      paused: false,\n      ended: false,\n      error: null,\n      duration: 0,\n      currentTime: 0,\n      src: null\n    };\n    this.startNode = null;\n    this.iframe = document.querySelector(\"iframe[name=\" + this.name + \"]\");\n    this.iframe.video = this;\n    this.iframe.onload = function() {\n      raptor.api.init(_this.iframe);\n    };\n    raptor.api.on(\"ready\", function(event, data) {\n      raptor.settings(\"defaultIFrame\", _this.name);\n      raptor.api.load();\n    });\n    raptor.api.on(\"play\", function(event, data) {\n      if (data.frameName !== _this.name) {\n        return;\n      }\n      _this.data.paused = false;\n      _this.dispatchEvent(\"play\");\n      _this.dispatchEvent(\"playing\");\n    });\n    raptor.api.on(\"pause\", function(event, data) {\n      if (data.frameName !== _this.name) {\n        return;\n      }\n      _this.updateData();\n      _this.data.paused = true;\n      _this.dispatchEvent(\"pause\");\n    });\n    raptor.api.on(\"error\", function(event, data) {\n      if (data.frameName !== _this.name) {\n        return;\n      }\n      _this.data.error = data;\n      _this.dispatchEvent(\"error\");\n    });\n    raptor.api.on(\"inboundReady\", function(event, data) {\n      if (data && data.frameName !== _this.name) {\n        return;\n      }\n      _this.updateData();\n      _this.dispatchEvent(\"loadedmetadata\");\n    });\n    raptor.api.on(\"timeUpdate\", function(event, data) {\n      if (data && data.frameName !== _this.name) {\n        return;\n      }\n      _this.updateData(data);\n    });\n    raptor.api.on(\"clipEnd\", function(event, data) {\n      if (data && data.frameName !== _this.name) {\n        return;\n      }\n      _this.dispatchEvent(\"interactivebreakstart\");\n    });\n    raptor.api.on(\"clipStart\", function(event, data) {\n      if (data && data.frameName !== _this.name) {\n        return;\n      }\n      if (data.isStart === \"true\") {\n        _this.startNode = raptor.api.nodes(_this.name)[data.clipname];\n      }\n      _this.dispatchEvent(\"interactivebreakend\");\n    });\n    raptor.api.on(\"projectEnd\", function(event, data) {\n      if (data && data.frameName !== _this.name) {\n        return;\n      }\n      _this.data.ended = true;\n      _this.dispatchEvent(\"ended\");\n    });\n    logEvent = function(event, data) {\n      console.log(\"RAPT: \", event.type, event, data);\n    };\n    raptor.api.on(\"inboundReady\", logEvent);\n    raptor.api.on(\"play\", logEvent);\n    raptor.api.on(\"pause\", logEvent);\n    raptor.api.on(\"error\", logEvent);\n    raptor.api.on(\"clipStart\", logEvent);\n    raptor.api.on(\"clipEnd\", logEvent);\n    raptor.api.on(\"clipSwitch\", logEvent);\n    raptor.api.on(\"projectStart\", logEvent);\n    raptor.api.on(\"projectEnd\", logEvent);\n    raptor.api.on(\"progress\", logEvent);\n    raptor.api.on(\"button\", logEvent);\n    raptor.api.on(\"windowed\", logEvent);\n    raptor.api.on(\"userTimed\", logEvent);\n    raptor.api.on(\"fullscreen\", logEvent);\n    raptor.api.on(\"volume\", logEvent);\n    raptor.api.on(\"mute\", logEvent);\n    raptor.api.on(\"unmute\", logEvent);\n  }\n\n  RaptHTML5Video.prototype.updateData = function(data) {\n    var time;\n    if (data == null) {\n      data = raptor.api.state(this.name);\n    }\n    if (!(data != null)) {\n      return;\n    }\n    time = parseFloat(data.duration);\n    if (time !== this.data.duration) {\n      this.data.duration = time;\n      this.dispatchEvent(\"durationchange\");\n    }\n    time = parseFloat(data.time || data.progressTime);\n    if (time !== this.data.currentTime) {\n      this.data.currentTime = time;\n      this.dispatchEvent(\"timeupdate\");\n    }\n  };\n\n  RaptHTML5Video.prototype.load = function() {\n    this.iframe.src = this.src;\n  };\n\n  RaptHTML5Video.prototype.play = function() {\n    raptor.api.play(this.name);\n  };\n\n  RaptHTML5Video.prototype.pause = function() {\n    raptor.api.pause(this.name);\n    this.updateData();\n  };\n\n  RaptHTML5Video.prototype.replay = function() {\n    raptor.api.setNode(this.startNode, this.name);\n  };\n\n  RaptHTML5Video.prototype.canPlayType = function(type) {\n    if (type === \"application/rapt\") {\n      return \"maybe\";\n    } else {\n      return \"\";\n    }\n  };\n\n  RaptHTML5Video.prototype.addEventListener = function(type, listener, capture) {\n    this.iframe.addEventListener(type, listener, capture);\n  };\n\n  RaptHTML5Video.prototype.dispatchEvent = function(event) {\n    if (typeof event === \"string\") {\n      event = new CustomEvent(event);\n    }\n    return this.iframe.dispatchEvent(event);\n  };\n\n  RaptHTML5Video.prototype.removeEventListener = function(type, listener, capture) {\n    this.iframe.removeEventListener(type, listener, capture);\n  };\n\n\n  if (Object.defineProperties != null) {\n  Object.defineProperties(RaptHTML5Video.prototype, {\n    src: {\n      set: function(value) {\n        this.data.src = value;\n      },\n      get: function() {\n        return this.data.src;\n      }\n    },\n    currentTime: {\n      set: function(value) {\n        raptor.api.setTime(value, this.name);\n      },\n      get: function() {\n        return this.data.currentTime;\n      }\n    },\n    duration: {\n      get: function() {\n        return this.data.duration;\n      }\n    },\n    paused: {\n      get: function() {\n        return this.data.paused;\n      }\n    },\n    ended: {\n      get: function() {\n        return this.data.ended;\n      }\n    },\n    error: {\n      get: function() {\n        return this.data.error;\n      }\n    },\n    readyState: {\n      get: function() {\n        return 1;\n      }\n    }\n  });\n  }\n\n  /**\n   * The DASHProxy class.\n   *\n   * @param {Object}  config  The plugin configuration object.\n   * @constructor\n   * @private\n   * @extends {PluginProxy}\n  */\n  function RaptProxy(config) {\n    RaptProxy.__super__.constructor.call(this, config);\n  }\n\n\n  __extends(RaptProxy, PluginProxy);\n\n\n  /** @static\n  */\n  RaptProxy.NAME = ModuleProxy.NAME;\n\n  RaptProxy.prototype.defaults = {\n    types: [\"application/rapt\"]\n  };\n\n  RaptProxy.prototype.player = null;\n\n  RaptProxy.prototype.initialize = function() {\n    var player;\n    this.sendNotification(Notifications.INITIALIZED);\n    this.player = new RaptPlaybackProxy(this.getConfigurationData());\n    player = this.facade.player.retrieveProxy(PlayerProxy.NAME);\n    player.registerPlaybackCore(this.player);\n  };\n\n  /**\n   * The AdChoicesPlugin class.\n   *\n   * @param {Module}  app     The parent module of this plugin.\n   * @constructor\n   * @private\n   * @extends {Plugin}\n  */\n  function AdChoicesPlugin() {\n    AdChoicesPlugin.__super__.constructor.call(this);\n  }\n\n\n  __extends(AdChoicesPlugin, Plugin);\n\n\n  AdChoicesPlugin.prototype.moduleName = \"adchoices\";\n\n  /** @override\n  */\n  AdChoicesPlugin.prototype.createModel = function() {\n    this.registerProxy(new AdChoicesProxy(this.config));\n  };\n\n  /** @override\n  */\n  AdChoicesPlugin.prototype.createView = function() {\n    this.registerMediator(new AdChoicesMediator());\n  };\n\n  /**\n   * @override\n  */\n  AdChoicesPlugin.prototype.listNotificationInterests = function() {\n    return [AdNotifications.AD_CONTAINER_CREATED];\n  };\n\n\n  AMP.registerPlugin(\"adchoices\", \"html\", AdChoicesPlugin);\n  AMP.registerPlugin(\"adchoices\", \"flash\", AdChoicesWrapper);\n\n  /**\n   * HLSPlaybackProxy constructor.\n   *\n   * @constructor\n   * @private\n   * @extends {PlaybackCoreProxy}\n  */\n  function HLSPlaybackProxy(config, plugin) {\n    this.hlsConfig = config.data;\n    if (config.withCredentials === true) {\n      this.hlsConfig.xhrSetup = function(xhr, url) {\n        xhr.withCredentials = true;\n      };\n    }\n    this.plugin = plugin;\n    HLSPlaybackProxy.__super__.constructor.call(this, config.types, config);\n    this.temporalTypes = [\"vod\", \"live\", \"dvr\"];\n  }\n\n\n  __extends(HLSPlaybackProxy, PlaybackCoreProxy);\n\n\n  HLSPlaybackProxy.prototype.playbackCoreName = \"hls\";\n\n  HLSPlaybackProxy.prototype.player = null;\n\n  HLSPlaybackProxy.prototype.hlsConfig = null;\n\n  HLSPlaybackProxy.prototype.fragErrorTime = 0;\n\n  HLSPlaybackProxy.prototype.timedMedatadata = null;\n\n  HLSPlaybackProxy.prototype.currentMedatadata = null;\n\n  HLSPlaybackProxy.prototype.id3Track = null;\n\n  /** @override\n  */\n  HLSPlaybackProxy.prototype.load = function() {\n    var hls, key, value, _ref, _ref1,\n      _this = this;\n    if (this.player != null) {\n      this.destroy();\n    }\n    hls = new Hls(this.hlsConfig);\n    hls.attachMedia(this.getMediaElement());\n    _ref = Hls.Events;\n    for (key in _ref) {\n      value = _ref[key];\n      hls.on(value, function(event, data) {\n        _this.plugin.dispatcher.dispatchEvent(new Event(event, data));\n      });\n    }\n    hls.on(Hls.Events.MANIFEST_PARSED, this.onManifestParsed.bind(this));\n    hls.on(Hls.Events.ERROR, this.onError.bind(this));\n    hls.on(Hls.Events.FRAG_PARSING_METADATA, this.onFragParsingMetadata.bind(this));\n    hls.on(Hls.Events.LEVEL_LOADED, this.onLevelLoaded.bind(this));\n    hls.on(Hls.Events.LEVEL_SWITCH, this.onLevelSwitch.bind(this));\n    hls.on(Hls.Events.FRAG_LOADING, this.onFragmentLoadStart.bind(this));\n    hls.on(Hls.Events.FRAG_LOADED, this.onFragmentLoaded.bind(this));\n    try {\n      _ref1 = this.config.quality;\n      for (key in _ref1) {\n        value = _ref1[key];\n        hls[key] = value;\n      }\n    } catch (_error) {}\n    this.player = hls;\n    HLSPlaybackProxy.__super__.load.call(this);\n  };\n\n  /** override\n  */\n  HLSPlaybackProxy.prototype.applyTextTrackHandlers = function(event) {\n    if ((this.id3Track != null) && event) {\n      return;\n    }\n    HLSPlaybackProxy.__super__.applyTextTrackHandlers.call(this, event);\n    if (event === false) {\n      return this.id3Track = null;\n    }\n    this.addMTextTrack();\n  };\n\n  HLSPlaybackProxy.prototype.addMTextTrack = function() {\n    if ((this.getMediaElement().addTextTrack != null) && !(this.id3Track != null)) {\n      this.id3Track = this.getMediaElement().addTextTrack(\"metadata\");\n    }\n  };\n\n  HLSPlaybackProxy.prototype.applySrc = function() {\n    this.currentMedatadata = null;\n    this.player.loadSource(this.getSrc());\n  };\n\n  /**\n  */\n  HLSPlaybackProxy.prototype.onManifestParsed = function(event, data) {\n    this.sendNotification(HLSNotifications.MANIFEST_PARSED, data);\n    this.player.loadLevel = -1;\n  };\n\n  /**\n  */\n  HLSPlaybackProxy.prototype.onLevelLoaded = function(event, data) {\n    var live;\n    this.sendNotification(HLSNotifications.LEVEL_LOADED, data);\n    live = data.details.live;\n    if (live === true) {\n      this.facade.mediaProxy.setTemporalType(\"live\");\n    }\n  };\n\n  /**\n  */\n  HLSPlaybackProxy.prototype.onLevelSwitch = function(event, data) {\n    this.sendNotification(Notifications.BITRATE_SWITCH, this.player.levels[data.level]);\n  };\n\n  /**\n  */\n  HLSPlaybackProxy.prototype.onFragParsingMetadata = function(events, data) {\n    var VTTCue, id3, str, time, _i, _len, _ref, _ref1;\n    if (!(this.id3Track != null)) {\n      this.applyTextTrackHandlers(true);\n    }\n    _ref = data.samples;\n    for (_i = 0, _len = _ref.length; _i < _len; _i++) {\n      data = _ref[_i];\n      time = data.dts;\n      if (!((data != null ? data.data : void 0) != null)) {\n        continue;\n      }\n      str = String.fromCharCode.apply(null, data.data.subarray(0, -1));\n      str = str.replace(/\\0/g, '');\n      id3 = {\n        startTime: time,\n        endTime: time,\n        key: str.replace(/(\\S*)\\{.*/, \"$1\").split(\" \")[1],\n        info: str.replace(/[^\\{]+\\{/, \"\"),\n        data: data\n      };\n      try {\n        VTTCue = window.VTTCue || window.TextTrackCue;\n        if (window.TextTrackCue === VTTCue) {\n          id3.endTime += 0.5;\n        }\n        if ((_ref1 = this.id3Track) != null) {\n          _ref1.addCue(new VTTCue(id3.startTime, id3.endTime, JSON.stringify(id3)));\n        }\n      } catch (_error) {}\n    }\n  };\n\n  HLSPlaybackProxy.prototype.onFragmentLoadStart = function(event, data) {\n    var bitrate;\n    bitrate = this.player.levels[data.frag.level].bitrate;\n    this.sendNotification(Notifications.FRAGMENT_LOAD_START, bitrate);\n  };\n\n  HLSPlaybackProxy.prototype.onFragmentLoaded = function(event, data) {\n    var bitrate;\n    bitrate = this.player.levels[data.frag.level].bitrate;\n    this.sendNotification(Notifications.FRAGMENT_LOADED, bitrate);\n  };\n\n  HLSPlaybackProxy.prototype.seek = function(value) {\n    return HLSPlaybackProxy.__super__.seek.call(this, value + this.getStartTime());\n  };\n\n  HLSPlaybackProxy.prototype.getCurrentTime = function() {\n    return this.getMediaElement().currentTime - this.getStartTime();\n  };\n\n  HLSPlaybackProxy.prototype.getDuration = function() {\n    var _ref, _ref1, _ref2, _ref3;\n    return ((_ref = this.player) != null ? (_ref1 = _ref.levels) != null ? (_ref2 = _ref1[this.player.currentLevel]) != null ? (_ref3 = _ref2.details) != null ? _ref3.totalduration : void 0 : void 0 : void 0 : void 0) || this.getMediaElement().duration;\n  };\n\n  HLSPlaybackProxy.prototype.getStartTime = function() {\n    return this.getMediaElement().duration - this.getDuration();\n  };\n\n  /** override\n  */\n  HLSPlaybackProxy.prototype.onplaying = function(event) {\n    HLSPlaybackProxy.__super__.onplaying.call(this);\n    this.retried = false;\n  };\n\n  /**\n  */\n  HLSPlaybackProxy.prototype.onError = function(event, data) {\n    this.plugin.sendNotification(Notifications.DISPATCH_EVENT, new Event(\"error\", data));\n    if (this.config.retryOnError === false || this.retried === true) {\n      this.retried = false;\n      this.error(data);\n      return;\n    }\n    if (data.fatal) {\n      switch (data.type) {\n        case Hls.ErrorTypes.NETWORK_ERROR:\n          this.retried = true;\n          this.player.startLoad();\n          this.facade.logger.error(\"[AMP HLS] Playback Error trying to recover:\", event);\n          break;\n        case Hls.ErrorTypes.MEDIA_ERROR:\n          this.retried = true;\n          this.player.recoverMediaError();\n          this.facade.logger.error(\"[AMP HLS] Playback Error trying to recover:\", event);\n          break;\n        default:\n          this.facade.logger.error(\"[AMP HLS] Playback Error:\", event);\n          this.error(data);\n      }\n    } else {\n      if (data.details === Hls.ErrorDetails.FRAG_LOOP_LOADING_ERROR) {\n        if (this.fragErrorTime === this.getMediaElement().currentTime) {\n          this.getMediaElement().currentTime++;\n          this.facade.logger.error(\"[AMP HLS] Frag Loop Load Error, Seeking to :\", this.getMediaElement().currentTime);\n        } else {\n          this.fragErrorTime = this.getMediaElement().currentTime;\n        }\n      }\n    }\n  };\n\n  HLSPlaybackProxy.prototype.error = function(data) {\n    switch (data.type) {\n      case Hls.ErrorTypes.NETWORK_ERROR:\n        data.code = MediaError.MEDIA_ERR_NETWORK;\n        break;\n      case Hls.ErrorTypes.MEDIA_ERROR:\n        data.code = MediaError.MEDIA_ERR_DECODE;\n        break;\n      default:\n        data.toString = function() {\n          return data.details;\n        };\n    }\n    this.sendNotification(Notifications.ERROR, data);\n  };\n\n  /** @override\n  */\n  HLSPlaybackProxy.prototype.setQuality = function(value) {\n    var _ref;\n    return (_ref = this.player) != null ? _ref.currentLevel = value : void 0;\n  };\n\n  /** @override\n  */\n  HLSPlaybackProxy.prototype.getQuality = function() {\n    var _ref;\n    return (_ref = this.player) != null ? _ref.currentLevel : void 0;\n  };\n\n  /** @override\n  */\n  HLSPlaybackProxy.prototype.getQualityLevels = function() {\n    var _ref;\n    return ((_ref = this.player) != null ? _ref.levels : void 0) || HLSPlaybackProxy.__super__.getQualityLevels.call(this);\n  };\n\n  /** @override\n  */\n  HLSPlaybackProxy.prototype.destroy = function() {\n    if (!(this.player != null)) {\n      return;\n    }\n    this.player.destroy();\n    this.player = null;\n  };\n\n  /**\n   * @constructor\n   * @extends {PluginWrapper}\n   * @private\n  */\n  function HLSWrapper(player, config) {\n    HLSWrapper.__super__.constructor.call(this, player, config);\n    Utils.flashTypes.push(Utils.mimeTypes.m3u8);\n  }\n\n\n  __extends(HLSWrapper, PluginWrapper);\n\n\n  HLSWrapper.NAME = \"HLSWrapper\";\n\n  HLSWrapper.prototype.flashPlugins = [\n    {\n      id: \"flashlsOSMF\",\n      src: '#{paths.resources}plugins/flashlsOSMF.swf',\n      host: \"osmf\",\n      type: \"application/x-shockwave-flash\"\n    }\n  ];\n\n\n  AMP.registerPlugin(\"hls\", \"flash\", HLSWrapper);\n\n  /**\n   * @enum {string}\n   * @const\n   * @private\n  */\n\n  var HLSNotifications = {\n    MANIFEST_PARSED: \"hlsManifestParsed\",\n    LEVEL_LOADED: \"hlsLevelLoaded\"\n  };\n\n  /**\n   * The HLSAdBreakStartCommand class.\n   *\n   * @constructor\n   * @private\n   * @extends {puremvc.SimpleCommand}\n  */\n  function HLSAdBreakStartCommand() {\n    HLSAdBreakStartCommand.__super__.constructor.call(this);\n  }\n\n\n  __extends(HLSAdBreakStartCommand, PluginCommand);\n\n\n  /**\n   * Executes the command.\n   *\n   * @param {puremvc.Notification} notification\n   *    The notification.\n   *\n   * @override\n  */\n  HLSAdBreakStartCommand.prototype.execute = function(notification) {\n    var _ref;\n    if (((_ref = notification.getBody()) != null ? _ref.partner : void 0) === \"freewheel\") {\n      this.proxy.destroy();\n    }\n  };\n\n  /**\n   * The HLSProxy class.\n   *\n   * @param {Object}  config  The plugin configuration object.\n   * @constructor\n   * @private\n   * @extends {PluginProxy}\n  */\n  function HLSProxy(config) {\n    HLSProxy.__super__.constructor.call(this, config);\n  }\n\n\n  __extends(HLSProxy, PlaybackPluginProxy);\n\n\n  /** @static\n  */\n  HLSProxy.NAME = ModuleProxy.NAME;\n\n  HLSProxy.prototype.defaults = {\n    types: [\"application/x-mpegURL\"],\n    data: {\n      enableWorker: true,\n      enableSoftwareAES: true,\n      enableCEA708Captions: true\n    },\n    buffer: null,\n    quality: null,\n    withCredentials: null\n  };\n\n  HLSProxy.prototype.createPlaybackProxy = function() {\n    var mediaSource;\n    mediaSource = window.MediaSource || window.WebKitMediaSource;\n    if (!(mediaSource != null) || !Hls.isSupported()) {\n      return;\n    }\n    return new HLSPlaybackProxy(this.getConfigurationData(), this.facade);\n  };\n\n  /**\n   * The RaptPlugin class.\n   *\n   * @constructor\n   * @private\n   * @extends {Plugin}\n  */\n  function RaptPlugin() {\n    RaptPlugin.__super__.constructor.call(this);\n  }\n\n\n  __extends(RaptPlugin, Plugin);\n\n\n  RaptPlugin.prototype.moduleName = \"rapt\";\n\n  /** @override\n  */\n  RaptPlugin.prototype.createModel = function() {\n    this.registerProxy(new RaptProxy(this.config));\n  };\n\n\n  AMP.registerPlugin(\"rapt\", \"html\", RaptPlugin);\n\n  /**\n   * The HLSPlugin class.\n   *\n   * @param {Module}  app     The parent module of this plugin.\n   * @constructor\n   * @private\n   * @extends {Plugin}\n  */\n  function HLSPlugin() {\n    HLSPlugin.__super__.constructor.call(this);\n  }\n\n\n  __extends(HLSPlugin, Plugin);\n\n\n  HLSPlugin.prototype.moduleName = \"hls\";\n\n  /** @override\n  */\n  HLSPlugin.prototype.createModel = function() {\n    this.proxy = new HLSProxy(this.config);\n    this.registerProxy(this.proxy);\n  };\n\n  HLSPlugin.prototype.createController = function() {\n    this.registerCommand(AdNotifications.BREAK_START, HLSAdBreakStartCommand);\n    HLSPlugin.__super__.createController.call(this);\n  };\n\n  /**\n   * Returns HLS PlaybackProxy\n   *\n  */\n  HLSPlugin.prototype.getPlaybackProxy = function() {\n    return this.proxy.playbackProxy;\n  };\n\n  /**\n   * Returns instance of HLS player\n   *\n  */\n  HLSPlugin.prototype.getInstance = function() {\n    return this.getPlaybackProxy().player;\n  };\n\n  /**\n  */\n  HLSPlugin.prototype.listNotificationInterests = function() {\n    return HLSPlugin.__super__.listNotificationInterests.call(this).concat([AdNotifications.BREAK_START]);\n  };\n\n  /**\n  */\n  HLSPlugin.prototype.listNotificationPublications = function() {\n    return HLSPlugin.__super__.listNotificationPublications.call(this).concat([Notifications.TIMED_METADATA, Notifications.BITRATE_SWITCH, HLSNotifications.MANIFEST_PARSED, Notifications.FRAGMENT_LOAD_START, Notifications.FRAGMENT_LOADED]);\n  };\n\n\n  AMP.registerPlugin(\"hls\", \"html\", HLSPlugin);\n\n\n  global[\"akamai\"] = {\n    \"amp\": {\n      \"AMP\": AMP,\n      \"utils\": {\n        \"Utils\": Utils,\n        \"QueryString\": QueryString,\n        \"Logger\": Logger\n      },\n      \"Config\": Config,\n      \"chromecast\": {\n        \"ChromeCastShim\": (typeof ChromeCastShim != \"undefined\") ? ChromeCastShim.getInstance() : null\n      },\n      \"XHR\": XHR,\n      \"Resource\": Resource,\n      \"Media\": MediaVO,\n      \"Authorization\": Authorization\n    }\n  };\n    /* End JS Lib\n    */\n    window[\"AKAMAI_MEDIA_PLAYER\"].saveSDK(version, global);\n  }\n  window.AKAMAI_MEDIA_PLAYER.setVersion(version);\n  })();\n"

/***/ },
/* 681 */
/***/ function(module, exports) {

	module.exports = "<application>\n  <player core_player_name=\"amp-premier-player\"\n          volume=\".75\"\n          mbr_starting_index=\"1\"\n          inpage_bitrate_index_limit=\"3\"\n          use_last_known_bitrate=\"false\"\n          use_netsession_client=\"false\"\n          netsession_install_prompt_frequency_secs=\"-1\"\n          ad_server_timeout=\"20\"\n          ad_control_enabled=\"true\"\n          dvr_enabled=\"1\"\n          branding_preload=\"none\"\n          hds_live_low_latency=\"true\"\n          fullscreen_enabled=\"true\"\n          show_feature_bar=\"false\"\n          suppress_events=\"mediaPlayerViewInitialized\"\n          caption_language=\"en-us\"\n          hds_fragment_retry_data_gap_threshold= \"20\"\n          ads_auto_fit=\"true\"\n          auto_replay=\"false\">\n  </player>\n  <view skin=\"{baseSkinUrl}webmd.assets.swf\">\n    <element id=\"endState\" enabled=\"false\" hideElements=\"viewAll\" />\n    <element id=\"logoOverlay\" style=\"height: 45px; width: 150px; right: 15px; bottom: 15px; opacity: 1.0;\"/>\n    <element id=\"captionDisplay\"\n             initState=\"off\"\n             position=\"relative\"\n             captionWidth=\"90\"\n             enabled=\"true\"\n             settingsEnabled=\"true\"\n             style=\"width: 100%; rightMargin:0; bottom: 0; windowColor:0x000000; windowOpacity:1.0; font: Arial; fontColor:0xffffff; fontBGColor:0x000000; fontBGOpacity:0; edgeType:none; edgeColor:0x000000; edgeOpacity:0; scroll:popOut; textAlign: center; fontSize:12; fontWeight:normal;\"\n             />\n    <element id=\"bufferingView\" mode=\"loader\" tether=\"true\" style=\"fontSize:30px;\" />\n    <element id=\"endSlate\" enabled=\"false\" hideElements=\"brandingLogo|viewAll\" />\n    <element id=\"controls\" height=\"28\" scrubPosition=\"inline\" itemMargin=\"5\" />\n    <element id=\"captionBtn\" />\n    <element id=\"recommendationSlate\" viewMode=\"grid\" items=\"6\" />\n    <element id=\"replayBtn\" />\n    <element id=\"playPauseBtn\" />\n    <element id=\"rewindBtn\" />\n    <element id=\"scrubBar\" style=\"height: 18px;\" />\n    <element id=\"loadedBar\" style=\"background: linear-gradient(90deg, #00FF00, #1B1B1B);\" />\n    <element id=\"playlistBtn\" />\n    <element id=\"timeLocationIndicator\" type=\"arrow\" color=\"#FFFFFF\" />\n    <element id=\"goLiveBtn\" />\n    <element id=\"shareBtn\" />\n    <element id=\"captionBtn\" />\n    <element id=\"statsBtn\" />\n    <element id=\"hdClientBtn\" />\n    <element id=\"chromecastBtn\"/>\n    <element id=\"volumeBar\" color=\"#CA2127\" />\n    <element id=\"volumeBtn\" />\n    <element id=\"fullscreenBtn\" />\n  </view>\n</application>\n"

/***/ },
/* 682 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(801);

/***/ },
/* 683 */
/***/ function(module, exports, __webpack_require__) {

	/* REACT HOT LOADER */ if (false) { (function () { var ReactHotAPI = require("/Users/jnunez/git/medscapetv/node_modules/react-hot-api/modules/index.js"), RootInstanceProvider = require("/Users/jnunez/git/medscapetv/node_modules/react-hot-loader/RootInstanceProvider.js"), ReactMount = require("react/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {
	
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _debounce2 = __webpack_require__(280);
	
	var _debounce3 = _interopRequireDefault(_debounce2);
	
	var _bind2 = __webpack_require__(659);
	
	var _bind3 = _interopRequireDefault(_bind2);
	
	var _throttle2 = __webpack_require__(289);
	
	var _throttle3 = _interopRequireDefault(_throttle2);
	
	var _get2 = __webpack_require__(38);
	
	var _get3 = _interopRequireDefault(_get2);
	
	var _util = __webpack_require__(12);
	
	var _reactRouter = __webpack_require__(87);
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reflux = __webpack_require__(54);
	
	var _tracking_actions = __webpack_require__(51);
	
	var _tracking_actions2 = _interopRequireDefault(_tracking_actions);
	
	var _video_actions = __webpack_require__(20);
	
	var _video_actions2 = _interopRequireDefault(_video_actions);
	
	var _video_store = __webpack_require__(85);
	
	var _video_store2 = _interopRequireDefault(_video_store);
	
	var _descriptor_store = __webpack_require__(191);
	
	var _descriptor_store2 = _interopRequireDefault(_descriptor_store);
	
	var _standalone_player = __webpack_require__(699);
	
	var _standalone_player2 = _interopRequireDefault(_standalone_player);
	
	var _chapters = __webpack_require__(684);
	
	var _chapters2 = _interopRequireDefault(_chapters);
	
	var _title_bar = __webpack_require__(688);
	
	var _title_bar2 = _interopRequireDefault(_title_bar);
	
	var _descriptor_actions = __webpack_require__(293);
	
	var _descriptor_actions2 = _interopRequireDefault(_descriptor_actions);
	
	var _animation = __webpack_require__(298);
	
	var _animation2 = _interopRequireDefault(_animation);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* global $ */
	exports.default = _react2.default.createClass({
	  displayName: 'Player.MedscapeTVTitleBar',
	  propTypes: {
	    descriptorJSON: _react.PropTypes.object,
	    params: _react.PropTypes.object,
	    location: _react.PropTypes.object
	  },
	  mixins: [(0, _reflux.connect)(_video_store2.default), (0, _reflux.connect)(_descriptor_store2.default)],
	  getDefaultProps: function getDefaultProps() {
	    var region = (0, _util.getRegion)();
	    if ((region !== '' || region !== 'us') && region !== null) {
	      if (typeof window['MedscapeTVInstance' + (0, _util.capitalizeFirstLetter)(region)] !== 'undefined') {
	        window.MedscapeTVInstance = window['MedscapeTVInstance' + (0, _util.capitalizeFirstLetter)(region)];
	      }
	    }
	    return {
	      descriptorJSON: window.MedscapeTVInstance
	    };
	  },
	  getInitialState: function getInitialState() {
	    return {
	      showMore: false,
	      video: {
	        isMouseIdle: false
	      },
	      descriptor: {
	        chapters: []
	      }
	    };
	  },
	  componentDidMount: function componentDidMount() {
	    var _this = this;
	
	    _descriptor_actions2.default.loadJSON(window.MedscapeTVInstance, this.props.params.videoUrlFragment);
	    this.scrollAnimationBreakPoint = 600;
	    if (!(0, _util.isMobile)() || (0, _util.isIpad)()) {
	      window.addEventListener('scroll', (0, _bind3.default)((0, _debounce3.default)(this.scrollHandler, 10, {
	        'leading': false,
	        'trailing': true
	      }), this));
	      $('#tvPlayer').bind('transitionend webkitTransitionEnd oTransitionEnd MSTransitionEnd', function (e) {
	        if (e.target.id === 'tvPlayer' && e.target.classList.contains('presistant-video-animation')) {
	          var mountPoint = document.querySelector('#tvPlayer'),
	              restOfPage = document.querySelector('.highlight-wrap');
	          restOfPage.classList.remove('presistant-video-margin');
	          mountPoint.classList.remove('presistant-video');
	          _this.scrollAnimationBreakPoint = $('.medscape-tv-chrome').offset().top;
	        }
	      });
	    } else {
	      window.addEventListener('scroll', (0, _bind3.default)((0, _throttle3.default)(this.mobileScrollHandler, 50), this));
	    }
	  },
	  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
	    if ((0, _get3.default)(this, 'state.video.meta.videoUrlFragment', null) !== nextProps.params.videoUrlFragment) {
	      _tracking_actions2.default.routeChange();
	      var vidIndex = _descriptor_store2.default.state.videos.findIndex(function (video) {
	        return video.videoUrlFragment === nextProps.params.videoUrlFragment;
	      });
	      if (vidIndex !== -1) {
	        _video_actions2.default.selectVideo(_descriptor_store2.default.state.videos[vidIndex], vidIndex);
	      }
	    }
	    if (nextProps.params.videoUrlFragment !== this.props.params.videoUrlFragment) {
	      if (!document.getElementById('medscape-tver').classList.contains('is-fullscreen') && !(0, _util.isMobile)()) {
	        document.getElementById('medscape-tver').style.opacity = 0;
	        this.prevHeight = document.getElementById('medscape-tver').offsetHeight;
	      }
	    }
	  },
	  componentDidUpdate: function componentDidUpdate(prevProps) {
	    if (prevProps.params.videoUrlFragment !== this.props.params.videoUrlFragment) {
	      if (!document.getElementById('medscape-tver').classList.contains('is-fullscreen') && !(0, _util.isMobile)()) {
	        var wrapper = document.getElementById('medscape-tver');
	        _animation2.default.updateHeight(wrapper, wrapper.firstChild, this.prevHeight);
	      }
	    }
	    if (this.scrollIds.length > 0 && this.firstRender === true) {
	      this.firstRender = false;
	      this.scrollIds = this.scrollIds.filter(function (id) {
	        var isInVp = (0, _util.isElementScrolled)(document.getElementById(id));
	        if (isInVp) {
	          _tracking_actions2.default.sectionScrollView(id);
	        }
	        return !isInVp;
	      });
	    }
	  },
	  getBreadCrumb: function getBreadCrumb() {
	    return (0, _util.isLocal)() ? '/' : '/mtv/' + window.MedscapeTVInstance.seriesUrlFragment + '/';
	  },
	
	  firstRender: true,
	  scrollIds: ['jsx-video-player', 'series-info', 'cast-list', 'info-graphic', 'more-med'],
	  scrollHandler: function scrollHandler() {
	    var pageFragment = (0, _get3.default)(this, 'props.routeParams.videoUrlFragment', '');
	    if (pageFragment !== '') {
	      var mountPoint = document.querySelector('#tvPlayer'),
	          restOfPage = document.querySelector('.highlight-wrap');
	      if (window.pageYOffset >= this.scrollAnimationBreakPoint && this.state.video.isPlaying === true && mountPoint.classList.contains('presistant-video-animation')) {
	        this.scrollAnimationBreakPoint = $('.medscape-tv-chrome').offset().top;
	        mountPoint.classList.add('presistant-video');
	        restOfPage.classList.add('presistant-video-margin');
	        mountPoint.classList.remove('presistant-video-animation');
	      }
	      if (window.pageYOffset < this.scrollAnimationBreakPoint && !mountPoint.classList.contains('presistant-video-animation')) {
	        mountPoint.classList.add('presistant-video-animation');
	      }
	      var overlays = document.querySelectorAll('.overlay'),
	          isOverlayVisible = Array.prototype.some.call(overlays, function (el) {
	        return el.classList.contains('is-visible');
	      });
	      if (!isOverlayVisible) {
	        var videoWrapElement = document.getElementById('video_player_screen');
	        if (videoWrapElement !== null) {
	          var videoScrollOffset = videoWrapElement.clientHeight / 1.33,
	              isVisible = (0, _util.isElementInViewport)(videoWrapElement, videoScrollOffset),
	              isPlaying = _video_store2.default.isPlaying();
	          if (!(0, _get3.default)(this, 'state.video.isFullScreen', false)) {
	            if (isVisible && !isPlaying && this.wasPlaying) {
	              window.trackingEnabled = false;
	              this.wasPlaying = false;
	            } else if (!isVisible && isPlaying) {
	              this.wasPlaying = true;
	              window.trackingEnabled = false;
	            }
	          }
	        }
	      }
	      if (this.scrollIds.length > 0) {
	        this.scrollIds = this.scrollIds.filter(function (id) {
	          var isInVp = (0, _util.isElementScrolled)(document.getElementById(id));
	          if (isInVp) {
	            _tracking_actions2.default.sectionScrollView(id);
	          }
	          return !isInVp;
	        });
	      }
	    }
	  },
	  mobileScrollHandler: function mobileScrollHandler() {
	    var pageFragment = (0, _get3.default)(this, 'props.routeParams.videoUrlFragment', '');
	    if (pageFragment !== '') {
	      var videoPlayerDiv = document.getElementById('medscape-tver'),
	          clientRect = videoPlayerDiv.getBoundingClientRect(),
	          mountPoint = document.getElementById('tvPlayer'),
	          jsxVidPlayer = document.getElementById('jsx-video-player');
	      if (clientRect.top + clientRect.height < clientRect.height / 2 && this.state.video.isPlaying === true) {
	        mountPoint.classList.add('presistant-video');
	        jsxVidPlayer.classList.add('presistant-video-margin');
	      }
	      if (mountPoint.classList.contains('presistant-video') && window.scrollY < 250) {
	        mountPoint.classList.remove('presistant-video');
	        jsxVidPlayer.classList.remove('presistant-video-margin');
	      }
	    }
	    if (this.scrollIds.length > 0) {
	      this.scrollIds = this.scrollIds.filter(function (id) {
	        var isInVp = (0, _util.isElementScrolled)(document.getElementById(id));
	        if (isInVp) {
	          _tracking_actions2.default.sectionScrollView(id);
	        }
	        return !isInVp;
	      });
	    }
	  },
	  showMore: function showMore() {
	    _tracking_actions2.default.showMore();
	    this.setState({
	      showMore: true
	    });
	  },
	
	  render: function render() {
	    var _this2 = this;
	
	    var title = void 0,
	        headerURL = void 0,
	        viewed = void 0,
	        titleBar = void 0,
	        breadCrumb = void 0;
	    var chapters = this.state.descriptor.chapterList || [],
	        hasMobileStyle = (0, _util.isMobile)() && !(0, _util.isIpad)(),
	        currentVideo = chapters.find(function (video) {
	      if (typeof video.videoUrlFragment === 'undefined') {
	        return false;
	      } else {
	        return video.videoUrlFragment === _this2.props.params.videoUrlFragment;
	      }
	    }),
	        videoIndex = chapters.indexOf(currentVideo);
	    if ((0, _get3.default)(this, 'state.video.meta', false)) {
	      headerURL = _descriptor_store2.default.state.headerURL;
	      title = this.state.video.meta.title;
	      viewed = this.state.video.viewed;
	    }
	    var showMore = null;
	    if (hasMobileStyle && !this.state.showMore) {
	      showMore = _react2.default.createElement(
	        'div',
	        { onClick: this.showMore, className: 'show-more' },
	        'SHOW MORE',
	        _react2.default.createElement(
	          'div',
	          { className: 'show-more-border' },
	          _react2.default.createElement('span', { className: 'down-arrow' })
	        )
	      );
	    }
	    if (videoIndex !== -1) {
	      titleBar = _react2.default.createElement(_title_bar2.default, {
	        chapters: chapters,
	        index: videoIndex
	      });
	      breadCrumb = _react2.default.createElement(
	        _reactRouter.Link,
	        { className: 'back-link', to: this.getBreadCrumb() },
	        _react2.default.createElement('img', { src: __webpack_require__(344), alt: 'LT' }),
	        window.MedscapeTVInstance.seriesTitle
	      );
	    }
	    if ((0, _get3.default)(currentVideo, 'hasTitleCard', false) === true) {
	      if (document.querySelector('.akamai-play')) {
	        document.querySelector('.akamai-play').innerHTML = '<div class="episode-legend">Episode ' + (videoIndex + 1) + ': ' + chapters[videoIndex].title + '</div>';
	      }
	    }
	    var mobilePresistantIfi = null;
	    if ((0, _util.isMobile)() && !(0, _util.isIpad)() && chapters[videoIndex] && chapters[videoIndex].ifiHTML) {
	      mobilePresistantIfi = _react2.default.createElement('div', { className: 'ifiLinks-sticky', dangerouslySetInnerHTML: { __html: chapters[videoIndex].ifiHTML } });
	    }
	    return _react2.default.createElement(
	      'div',
	      { className: 'medscape-tv' },
	      breadCrumb,
	      _react2.default.createElement(
	        'div',
	        { className: 'medscape-tv-player', id: 'tvPlayer', ref: 'tvPlayer' },
	        _react2.default.createElement(
	          'div',
	          { className: 'medscape-tv-poll-wrapper', id: 'pollWrapper', ref: 'pollWrapper' },
	          _react2.default.createElement(_standalone_player2.default, {
	            className: true,
	            id: 'medscape-tver',
	            videoIndex: videoIndex,
	            descriptorJSON: this.props.descriptorJSON,
	            videoUrlFragment: this.props.params.videoUrlFragment,
	            isMouseIdle: this.state.video.isMouseIdle
	          }),
	          titleBar
	        ),
	        mobilePresistantIfi
	      ),
	      _react2.default.createElement(_chapters2.default, {
	        ref: 'chaptersSlider',
	        chapters: chapters,
	        index: videoIndex,
	        headerURL: headerURL,
	        videoUrlFragmentUrl: this.props.location.pathname,
	        title: title,
	        hasMobileStyle: hasMobileStyle,
	        showMore: true,
	        viewed: viewed
	      }),
	      showMore
	    );
	  }
	});
	
	/* REACT HOT LOADER */ }).call(this); } finally { if (false) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("/Users/jnunez/git/medscapetv/node_modules/react-hot-loader/makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot apply hot update to " + "medscape_tv.jsx" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }

/***/ },
/* 684 */
/***/ function(module, exports, __webpack_require__) {

	/* REACT HOT LOADER */ if (false) { (function () { var ReactHotAPI = require("/Users/jnunez/git/medscapetv/node_modules/react-hot-api/modules/index.js"), RootInstanceProvider = require("/Users/jnunez/git/medscapetv/node_modules/react-hot-loader/RootInstanceProvider.js"), ReactMount = require("react/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {
	
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _get2 = __webpack_require__(38);
	
	var _get3 = _interopRequireDefault(_get2);
	
	var _map2 = __webpack_require__(286);
	
	var _map3 = _interopRequireDefault(_map2);
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _playlist_item = __webpack_require__(696);
	
	var _playlist_item2 = _interopRequireDefault(_playlist_item);
	
	var _reactSlick = __webpack_require__(732);
	
	var _reactSlick2 = _interopRequireDefault(_reactSlick);
	
	var _util = __webpack_require__(12);
	
	var _classnames = __webpack_require__(30);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _tracking_actions = __webpack_require__(51);
	
	var _tracking_actions2 = _interopRequireDefault(_tracking_actions);
	
	var _video_actions = __webpack_require__(20);
	
	var _video_actions2 = _interopRequireDefault(_video_actions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _react2.default.createClass({
	  displayName: 'MedscapeTV.Chapters',
	  propTypes: {
	    viewed: _react.PropTypes.object,
	    index: _react.PropTypes.number,
	    title: _react.PropTypes.string,
	    chapters: _react.PropTypes.array,
	    headerURL: _react.PropTypes.string,
	    children: _react.PropTypes.string,
	    duration: _react.PropTypes.number,
	    hasMobileStyle: _react.PropTypes.bool,
	    showMore: _react.PropTypes.bool,
	    video: _react.PropTypes.object,
	    videoUrlFragmentUrl: _react.PropTypes.string
	  },
	  getDefaultProps: function getDefaultProps() {
	    var index = 0;
	    if (typeof (0, _util.getParams)().startVideo !== 'undefined') {
	      index = (0, _util.getParams)().startVideo - 1;
	    }
	    return {
	      chapters: [],
	      viewed: {},
	      index: index,
	      isiLinks: []
	    };
	  },
	  getInitialState: function getInitialState() {
	    var index = 0;
	    if (typeof (0, _util.getParams)().startVideo !== 'undefined') {
	      index = (0, _util.getParams)().startVideo - 1;
	    }
	    return {
	      index: index,
	      viewed: this.props.viewed,
	      enabled: true
	    };
	  },
	  shouldComponentUpdate: function shouldComponentUpdate(nextProps) {
	    if (this.state.enabled === false) {
	      return false;
	    }
	    if (nextProps.showMore !== this.props.showMore) {
	      return true;
	    }
	    if (nextProps.index !== this.props.index) {
	      return true;
	    } else if (nextProps.chapters !== this.props.chapters) {
	      return true;
	    } else {
	      return false;
	    }
	  },
	  componentDidUpdate: function componentDidUpdate() {
	    var _this = this;
	
	    var breakpoint = (0, _get3.default)(this, 'refs.slider.state.breakpoint', 4);
	    var breakPointsToSlideNumbers = {
	      400: 2,
	      767: 3,
	      1024: 4
	    },
	        visibleSlides = breakPointsToSlideNumbers[breakpoint] || 4,
	        indexStart = this.state.index,
	        indexEnd = this.state.index + visibleSlides,
	        incrementedIndex = this.props.index + 1;
	    if (!(incrementedIndex >= indexStart && incrementedIndex <= indexEnd)) {
	      setTimeout(function () {
	        _this.refs.slider.slickGoTo(_this.props.index);
	      }, 500);
	    }
	  },
	  forceRepaint: function forceRepaint() {
	    this.refs.slider.slickGoTo(this.props.index - 1);
	    this.refs.slider.slickGoTo(this.props.index);
	  },
	  hasViewed: function hasViewed(index) {
	    return this.props.viewed[index];
	  },
	  enableClick: function enableClick(index) {
	    if (this.state.index < index) {
	      _tracking_actions2.default.slideNavigate('next');
	    } else if (this.state.index > index) {
	      _tracking_actions2.default.slideNavigate('prev');
	    }
	    this.setState({
	      enabled: true,
	      index: index
	    });
	  },
	  disableClick: function disableClick() {
	    this.setState({
	      enabled: false
	    });
	  },
	  extLink: function extLink() {
	    window.trackingEnabled = false;
	    _tracking_actions2.default.externalLink();
	    _video_actions2.default.pause();
	  },
	  renderChapter: function renderChapter(chapter, i) {
	    var isSelected = this.props.videoUrlFragmentUrl.endsWith(chapter.videoUrlFragment),
	        hasViewed = this.hasViewed(i);
	    if (typeof chapter.source === 'undefined') {
	      var thumbNail = (0, _get3.default)(chapter, 'thumbnail', ''),
	          title = (0, _get3.default)(chapter, 'title', ''),
	          videoTag = (0, _get3.default)(chapter, 'videoTag', ''),
	          csClasses = (0, _classnames2.default)({
	        'thumbnail-btn': true,
	        'coming-soon-thumb': true
	      });
	      var placeHolder = null;
	      if (chapter.isIfi === true) {
	        placeHolder = _react2.default.createElement(
	          'a',
	          { key: i, href: chapter.ifiHref, target: '_blank', onClick: this.extLink },
	          _react2.default.createElement(
	            'div',
	            { className: 'video-player-playlist-item' },
	            _react2.default.createElement('img', { className: csClasses, src: (0, _util.getImageServer)() + '/' + thumbNail }),
	            _react2.default.createElement(
	              'div',
	              { className: 'video-title' },
	              _react2.default.createElement(
	                'div',
	                { className: 'advertisment' },
	                videoTag
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'video-title' },
	                title
	              )
	            )
	          )
	        );
	      } else {
	        placeHolder = _react2.default.createElement(
	          'div',
	          { key: i },
	          _react2.default.createElement(
	            'div',
	            { className: 'video-player-playlist-item' },
	            _react2.default.createElement('img', { className: csClasses, src: (0, _util.getImageServer)() + '/' + thumbNail }),
	            _react2.default.createElement(
	              'div',
	              { className: 'video-title' },
	              _react2.default.createElement(
	                'div',
	                { className: 'coming-soon' },
	                'COMING SOON'
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'low-light' },
	                videoTag
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'video-title' },
	                title
	              )
	            )
	          )
	        );
	      }
	      return placeHolder;
	    } else {
	      if (this.props.hasMobileStyle) {
	        return _react2.default.createElement(_playlist_item2.default, {
	          key: i + '-pl',
	          hasViewed: hasViewed,
	          isSelected: isSelected,
	          index: i,
	          video: chapter,
	          isVisible: chapter.isVisible,
	          enabled: this.state.enabled
	        });
	      } else {
	        return _react2.default.createElement(
	          'div',
	          { key: i + '-pldiv' },
	          _react2.default.createElement(_playlist_item2.default, {
	            hasViewed: hasViewed,
	            isSelected: isSelected,
	            index: i,
	            video: chapter,
	            isVisible: chapter.isVisible,
	            enabled: this.state.enabled,
	            key: 'pl' + i
	          })
	        );
	      }
	    }
	  },
	  render: function render() {
	    var visibleChapters = this.props.chapters.filter(function (chapter) {
	      return chapter.isVisible !== false;
	    });
	    var chapters = (0, _map3.default)(visibleChapters, this.renderChapter, this);
	    var sliderClasses = (0, _classnames2.default)({
	      'slider': true,
	      'display-more': this.props.showMore
	    }),
	        settings = {
	      dots: false,
	      infinite: false,
	      speed: 300,
	      slidesToShow: 4,
	      slidesToScroll: 4,
	      centerMode: false,
	      rtl: false,
	      beforeChange: this.disableClick,
	      afterChange: this.enableClick,
	      draggable: !this.props.hasMobileStyle && (0, _util.isIpad)(),
	      responsive: [{ breakpoint: 400, settings: { slidesToShow: 2, slidesToScroll: 2 } }, { breakpoint: 767, settings: { slidesToShow: 3, slidesToScroll: 3 } }, { breakpoint: 1024, settings: { slidesToShow: 4, slidesToScroll: 4 } }]
	    };
	    if (!this.props.hasMobileStyle && chapters.length !== 0) {
	      chapters = _react2.default.createElement(
	        _reactSlick2.default,
	        _extends({ ref: 'slider' }, settings),
	        chapters
	      );
	    }
	    var numberOfEpisodes = this.props.chapters.filter(function (video) {
	      return video.isIndexed === true;
	    }).length;
	    return _react2.default.createElement(
	      'div',
	      { className: 'slider-wrap' },
	      _react2.default.createElement(
	        'div',
	        { className: sliderClasses },
	        _react2.default.createElement(
	          'div',
	          { className: 'episode-title' },
	          'EPISODES (',
	          numberOfEpisodes,
	          ')'
	        ),
	        chapters
	      )
	    );
	  }
	});
	
	/* REACT HOT LOADER */ }).call(this); } finally { if (false) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("/Users/jnunez/git/medscapetv/node_modules/react-hot-loader/makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot apply hot update to " + "chapters.jsx" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }

/***/ },
/* 685 */
/***/ function(module, exports, __webpack_require__) {

	/* REACT HOT LOADER */ if (false) { (function () { var ReactHotAPI = require("/Users/jnunez/git/medscapetv/node_modules/react-hot-api/modules/index.js"), RootInstanceProvider = require("/Users/jnunez/git/medscapetv/node_modules/react-hot-loader/RootInstanceProvider.js"), ReactMount = require("react/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {
	
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _util = __webpack_require__(12);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	__webpack_require__(171);
	exports.default = _react2.default.createClass({
	  displayName: 'MedscapeTV.Comments',
	  propTypes: {
	    videoUrlFragment: _react.PropTypes.string.isRequired
	  },
	  getDefaultProps: function getDefaultProps() {
	    return {
	      videoUrlFragment: ''
	    };
	  },
	  componentDidMount: function componentDidMount() {
	    document.getElementById('livefyre_iframe').setAttribute('src', 'http://www' + (0, _util.envCheck)() + '.medscape.com/mtv/' + window.MedscapeTVInstance.seriesUrlFragment + '/mtvc-' + this.props.videoUrlFragment);
	  },
	  shouldComponentUpdate: function shouldComponentUpdate(nextProps) {
	    return this.props.videoUrlFragment !== nextProps.videoUrlFragment;
	  },
	  componentDidUpdate: function componentDidUpdate() {
	    document.getElementById('livefyre_iframe').setAttribute('src', 'http://www' + (0, _util.envCheck)() + '.medscape.com/mtv/' + window.MedscapeTVInstance.seriesUrlFragment + '/mtvc-' + this.props.videoUrlFragment);
	  },
	  render: function render() {
	    return _react2.default.createElement('div', null);
	  }
	});
	
	/* REACT HOT LOADER */ }).call(this); } finally { if (false) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("/Users/jnunez/git/medscapetv/node_modules/react-hot-loader/makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot apply hot update to " + "comments.jsx" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }

/***/ },
/* 686 */
/***/ function(module, exports, __webpack_require__) {

	/* REACT HOT LOADER */ if (false) { (function () { var ReactHotAPI = require("/Users/jnunez/git/medscapetv/node_modules/react-hot-api/modules/index.js"), RootInstanceProvider = require("/Users/jnunez/git/medscapetv/node_modules/react-hot-loader/RootInstanceProvider.js"), ReactMount = require("react/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {
	
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _get2 = __webpack_require__(38);
	
	var _get3 = _interopRequireDefault(_get2);
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(87);
	
	var _util = __webpack_require__(12);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _react2.default.createClass({
	  displayName: 'MedscapeTV.TitleBar',
	  propTypes: {
	    chapters: _react.PropTypes.array,
	    index: _react.PropTypes.number
	  },
	  componentDidMount: function componentDidMount() {
	    if ((0, _util.isMobile)() && !(0, _util.isIpad)()) {
	      document.querySelector('.hero-bg').style.height = document.getElementById('medscape-tver').getBoundingClientRect().height + 20 + 'px';
	    }
	  },
	  render: function render() {
	    var basePath = (0, _util.isLocal)() ? '' : '/mtv/' + window.MedscapeTVInstance.seriesUrlFragment,
	        videoUrlFragment = (0, _get3.default)(window, 'MedscapeTVInstance.videos[0].videoUrlFragment', '/');
	    return _react2.default.createElement(
	      'div',
	      { className: 'episode-guide' },
	      _react2.default.createElement(
	        'div',
	        { className: 'ep-guide-overlay' },
	        _react2.default.createElement(
	          'div',
	          { className: 'ep-guide' },
	          _react2.default.createElement(
	            'div',
	            { className: 'title1' },
	            (0, _get3.default)(window, 'MedscapeTVInstance.specialtyTitle', '')
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'title2' },
	            (0, _get3.default)(window, 'MedscapeTVInstance.seriesTitle', '')
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'desc' },
	            (0, _get3.default)(window, 'MedscapeTVInstance.seriesSummary', '')
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'ep-buttons' },
	            _react2.default.createElement(
	              _reactRouter.Link,
	              { className: 'episode', to: basePath + '/' + videoUrlFragment },
	              _react2.default.createElement(
	                'span',
	                { className: 'episode' },
	                'Episode 1'
	              )
	            )
	          )
	        )
	      )
	    );
	  }
	});
	
	/* REACT HOT LOADER */ }).call(this); } finally { if (false) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("/Users/jnunez/git/medscapetv/node_modules/react-hot-loader/makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot apply hot update to " + "episode_guide.jsx" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }

/***/ },
/* 687 */
/***/ function(module, exports, __webpack_require__) {

	/* REACT HOT LOADER */ if (false) { (function () { var ReactHotAPI = require("/Users/jnunez/git/medscapetv/node_modules/react-hot-api/modules/index.js"), RootInstanceProvider = require("/Users/jnunez/git/medscapetv/node_modules/react-hot-loader/RootInstanceProvider.js"), ReactMount = require("react/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {
	
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(30);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _tracking_actions = __webpack_require__(51);
	
	var _tracking_actions2 = _interopRequireDefault(_tracking_actions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _react2.default.createClass({
	  displayName: 'MedscapeTV.TitleBar',
	  getInitialState: function getInitialState() {
	    return {
	      hideShareMenu: true
	    };
	  },
	  showShareMenu: function showShareMenu() {
	    this.setState({
	      hideShareMenu: false
	    });
	  },
	  hideShareMenu: function hideShareMenu() {
	    this.setState({
	      hideShareMenu: true
	    });
	  },
	  shareFaceBook: function shareFaceBook() {
	    _tracking_actions2.default.socialMedia('fb');
	    var fbShareLink = 'http://www.facebook.com/share.php?u=' + window.location + '?src=stfb&t=' + document.title;
	    window.open(fbShareLink);
	  },
	  shareTwitter: function shareTwitter() {
	    _tracking_actions2.default.socialMedia('tw');
	    var twitterShareLink = 'http://twitter.com/share?url=' + encodeURIComponent(window.location) + '?src=sttwit&text=' + encodeURIComponent(document.title);
	    window.open(twitterShareLink);
	  },
	  shareGoogle: function shareGoogle() {
	    _tracking_actions2.default.socialMedia('em');
	    var googleShareLink = 'https://plusone.google.com/_/+1/confirm?url=' + encodeURIComponent(window.location) + '?src=stgoogle&title=' + encodeURIComponent(document.title);
	    window.open(googleShareLink);
	  },
	  shareLinkedin: function shareLinkedin() {
	    _tracking_actions2.default.socialMedia('linkedin');
	    var LinkedInShareLink = 'https://www.linkedin.com/shareArticle?url=' + window.location + '&source=MedscapeTV&title=' + document.title + '&';
	    window.open(LinkedInShareLink);
	  },
	  shareEmail: function shareEmail() {
	    console.log('shareEmail');
	  },
	  sharePrint: function sharePrint() {
	    console.log('sharePrint');
	  },
	  render: function render() {
	    var shareMenuClasses = (0, _classnames2.default)({
	      'share-menu': true,
	      'hidden': this.state.hideShareMenu
	    });
	    return _react2.default.createElement(
	      'div',
	      { className: 'share-wrap',
	        onTouchStart: this.showShareMenu,
	        onMouseEnter: this.showShareMenu,
	        onMouseLeave: this.hideShareMenu },
	      'Share',
	      _react2.default.createElement(
	        'div',
	        { className: shareMenuClasses, onMouseLeave: this.hideShareMenu },
	        _react2.default.createElement(
	          'div',
	          { onClick: this.shareFaceBook, className: 'facebook-button' },
	          'Facebook'
	        ),
	        _react2.default.createElement(
	          'div',
	          { onClick: this.shareTwitter, className: 'twitter-button' },
	          'Twitter'
	        ),
	        _react2.default.createElement(
	          'div',
	          { onClick: this.shareGoogle, className: 'google-button' },
	          'Google'
	        ),
	        _react2.default.createElement(
	          'div',
	          { onClick: this.shareLinkedin, className: 'linkedIn-button' },
	          'LinkedIn'
	        )
	      )
	    );
	  }
	});
	
	/* REACT HOT LOADER */ }).call(this); } finally { if (false) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("/Users/jnunez/git/medscapetv/node_modules/react-hot-loader/makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot apply hot update to " + "share_menu.jsx" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }

/***/ },
/* 688 */
/***/ function(module, exports, __webpack_require__) {

	/* REACT HOT LOADER */ if (false) { (function () { var ReactHotAPI = require("/Users/jnunez/git/medscapetv/node_modules/react-hot-api/modules/index.js"), RootInstanceProvider = require("/Users/jnunez/git/medscapetv/node_modules/react-hot-loader/RootInstanceProvider.js"), ReactMount = require("react/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {
	
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _isEmpty2 = __webpack_require__(188);
	
	var _isEmpty3 = _interopRequireDefault(_isEmpty2);
	
	var _get2 = __webpack_require__(38);
	
	var _get3 = _interopRequireDefault(_get2);
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _util = __webpack_require__(12);
	
	var _reactRouter = __webpack_require__(87);
	
	var _share_menu = __webpack_require__(687);
	
	var _share_menu2 = _interopRequireDefault(_share_menu);
	
	var _transcript = __webpack_require__(689);
	
	var _transcript2 = _interopRequireDefault(_transcript);
	
	var _comments = __webpack_require__(685);
	
	var _comments2 = _interopRequireDefault(_comments);
	
	var _video_actions = __webpack_require__(20);
	
	var _video_actions2 = _interopRequireDefault(_video_actions);
	
	var _tracking_actions = __webpack_require__(51);
	
	var _tracking_actions2 = _interopRequireDefault(_tracking_actions);
	
	var _animation = __webpack_require__(298);
	
	var _animation2 = _interopRequireDefault(_animation);
	
	var _has_pretty_time = __webpack_require__(74);
	
	var _has_pretty_time2 = _interopRequireDefault(_has_pretty_time);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	__webpack_require__(171);
	exports.default = _react2.default.createClass({
	  displayName: 'MedscapeTV.TitleBar',
	  propTypes: {
	    chapters: _react.PropTypes.array,
	    index: _react.PropTypes.number
	  },
	  mixins: [_has_pretty_time2.default],
	  getInitialState: function getInitialState() {
	    return {
	      transcriptIsVisible: false,
	      commentingIsVisible: false
	    };
	  },
	  componentDidMount: function componentDidMount() {
	    var ifiContainer = document.querySelector('.ifiLinks');
	    if (ifiContainer !== null) {
	      var ifiLinks = ifiContainer.getElementsByTagName('a');
	      Array.prototype.forEach.call(ifiLinks, function (link) {
	        if (link.host === window.location.host) {
	          link.addEventListener('click', function () {
	            _tracking_actions2.default.internalLink();
	          });
	        } else {
	          link.addEventListener('click', function () {
	            _tracking_actions2.default.externalLink();
	          });
	        }
	      });
	    }
	    window.mtvHideOverlayTranscript = this.hideTranscript;
	    window.mtvShowOverlayTranscript = this.showTranscript;
	    window.mtvHideOverlayComments = this.hideComments;
	    window.mtvShowOverlayComments = this.showComments;
	    document.getElementById('comments-hide-btn').addEventListener('click', function () {
	      window.mtvHideOverlayComments();
	    });
	    document.getElementById('transcript-hide-btn').addEventListener('click', function () {
	      window.mtvHideOverlayTranscript();
	    });
	  },
	  componentDidUpdate: function componentDidUpdate() {
	    var ifiContainer = document.querySelector('.ifiLinks');
	    if (ifiContainer !== null) {
	      var ifiLinks = ifiContainer.getElementsByTagName('a');
	      Array.prototype.forEach.call(ifiLinks, function (link) {
	        if (link.host === window.location.host) {
	          link.addEventListener('click', function () {
	            _tracking_actions2.default.internalLink();
	          });
	        } else {
	          link.addEventListener('click', function () {
	            _tracking_actions2.default.externalLink();
	          });
	        }
	      });
	    }
	  },
	  showTranscript: function showTranscript() {
	    _tracking_actions2.default.transcriptOpen();
	    window.trackingEnabled = false;
	    this.setState({
	      transcriptIsVisible: true,
	      wasPaused: document.querySelector('video').paused
	    });
	    _video_actions2.default.pause();
	    document.body.classList.add('overlayed');
	    _animation2.default.slideFadeIn(document.getElementById('medscape-tv-transcript'), document.getElementsByClassName('medscape-tv-transcript')[0]);
	  },
	  hideTranscript: function hideTranscript() {
	    _tracking_actions2.default.transcriptClose();
	    window.trackingEnabled = false;
	    if (!this.state.wasPaused) {
	      _video_actions2.default.start();
	    }
	    this.setState({
	      transcriptIsVisible: false,
	      wasPaused: document.querySelector('video').paused
	    });
	    document.body.classList.remove('overlayed');
	    _animation2.default.slideFadeOut(document.getElementById('medscape-tv-transcript'), document.getElementsByClassName('medscape-tv-transcript')[0]);
	  },
	  showComments: function showComments() {
	    _tracking_actions2.default.commentsOpen();
	    window.trackingEnabled = false;
	    _video_actions2.default.pause();
	    document.body.classList.add('overlayed');
	    this.setState({
	      commentingIsVisible: true,
	      wasPaused: document.querySelector('video').paused
	    });
	    document.body.classList.add('overlayed');
	    _animation2.default.slideFadeIn(document.getElementById('medscape-tv-comments'), document.getElementsByClassName('medscape-tv-comments')[0]);
	  },
	  hideComments: function hideComments() {
	    _tracking_actions2.default.commentsClose();
	    window.trackingEnabled = false;
	    if (!this.state.wasPaused) {
	      _video_actions2.default.start();
	    }
	    this.setState({
	      commentingIsVisible: false,
	      wasPaused: document.querySelector('video').paused
	    });
	    document.body.classList.remove('overlayed');
	    _animation2.default.slideFadeOut(document.getElementById('medscape-tv-comments'), document.getElementsByClassName('medscape-tv-comments')[0]);
	  },
	  track: function track(upNextChapter) {
	    if (!upNextChapter.isAdvertisement) {
	      _tracking_actions2.default.selectVideo('vidmtv-show_' + ((0, _get3.default)(this, 'upNextChapter.video.videoIndex', 0) + 1));
	    } else {
	      _tracking_actions2.default.selectVideo('vidmtv-show_ifi');
	    }
	  },
	  render: function render() {
	    var chapters = (0, _get3.default)(this, 'props.chapters', []);
	    if ((0, _isEmpty3.default)(chapters)) {
	      return null;
	    }
	    var activeChapter = chapters[this.props.index],
	        upNextChapter = chapters[this.props.index + 1];
	    var transcriptComponent = void 0,
	        commentComponent = void 0,
	        shareMenuComp = void 0,
	        commentsComp = void 0,
	        transcriptComp = void 0,
	        upNextElement = void 0,
	        topBar = void 0,
	        title = '',
	        label = '';
	    title = '' + activeChapter.title;
	    if (activeChapter) {
	      if (activeChapter.isAdvertisement) {
	        label = _react2.default.createElement(
	          'span',
	          { className: 'label-advertisment' },
	          'INFORMATION FROM INDUSTRY'
	        );
	      } else {
	        if ((0, _util.isMobile)() && !(0, _util.isIpad)()) {
	          if (activeChapter.videoTag !== '') {
	            label = _react2.default.createElement(
	              'span',
	              { className: 'label-episode' },
	              activeChapter.videoTag,
	              ' | ',
	              activeChapter.duration
	            );
	          } else {
	            label = _react2.default.createElement(
	              'span',
	              { className: 'label-episode' },
	              'Episode ',
	              activeChapter.videoIndex + 1,
	              ' | ',
	              this.secondsToPrettyTime(activeChapter.duration, 2)
	            );
	          }
	        } else if (activeChapter.videoTag !== '') {
	          label = _react2.default.createElement(
	            'span',
	            { className: 'label-episode' },
	            activeChapter.videoTag
	          );
	        } else if (activeChapter.isIndexed) {
	          label = _react2.default.createElement(
	            'span',
	            { className: 'label-episode' },
	            'SEASON 1 - Episode ',
	            activeChapter.videoIndex + 1
	          );
	        }
	      }
	    }
	    if ((0, _get3.default)(activeChapter, 'hasSocialMedia', true)) {
	      transcriptComponent = _react2.default.createElement(_transcript2.default, { videoUrlFragment: activeChapter.videoUrlFragment });
	      commentComponent = _react2.default.createElement(_comments2.default, { videoUrlFragment: activeChapter.videoUrlFragment });
	      if (activeChapter.hasShare) {
	        shareMenuComp = _react2.default.createElement(_share_menu2.default, { ref: 'shareMenuRef' });
	      }
	      if (activeChapter.hasComments) {
	        commentsComp = _react2.default.createElement(
	          'div',
	          { onClick: this.showComments, className: 'comments-wrap' },
	          'Comments'
	        );
	      }
	      if (activeChapter.hasTranscript) {
	        transcriptComp = _react2.default.createElement(
	          'div',
	          { onClick: this.showTranscript, className: 'transcript-wrap' },
	          'Transcript'
	        );
	      }
	      topBar = _react2.default.createElement(
	        'div',
	        { className: 'social-media-wrap' },
	        label,
	        shareMenuComp,
	        commentsComp,
	        transcriptComp
	      );
	    } else {
	      topBar = _react2.default.createElement(
	        'div',
	        { className: 'social-media-wrap' },
	        label
	      );
	    }
	    var ifiLinks = null;
	    if (activeChapter.ifiHTML) {
	      ifiLinks = _react2.default.createElement('div', { className: 'ifiLinks', dangerouslySetInnerHTML: { __html: activeChapter.ifiHTML } });
	    }
	    if (typeof upNextChapter !== 'undefined' && typeof upNextChapter.source !== 'undefined') {
	      var upNextChapterlabel = null;
	      var basePath = (0, _util.isLocal)() ? '' : '/mtv/' + window.MedscapeTVInstance.seriesUrlFragment;
	      if (upNextChapter.isAdvertisement) {
	        upNextChapterlabel = _react2.default.createElement(
	          'span',
	          { className: 'label-advertisment' },
	          'INFORMATION FROM INDUSTRY'
	        );
	      }
	      upNextElement = _react2.default.createElement(
	        _reactRouter.Link,
	        { className: 'upNextChapter', onClick: this.track, to: basePath + '/' + upNextChapter.videoUrlFragment },
	        _react2.default.createElement(
	          'h1',
	          null,
	          'UP NEXT'
	        ),
	        upNextChapterlabel,
	        _react2.default.createElement(
	          'div',
	          { className: 'upNextChapterTitle' },
	          ' ',
	          upNextChapter.title
	        )
	      );
	    }
	    return _react2.default.createElement(
	      'div',
	      { className: 'medscape-tv-chrome' },
	      _react2.default.createElement(
	        'div',
	        { className: 'chrome-row' },
	        _react2.default.createElement(
	          'div',
	          { className: 'chrome-cell' },
	          ifiLinks,
	          topBar,
	          transcriptComponent,
	          commentComponent,
	          _react2.default.createElement('h1', { className: 'medscape-tv-chrome-title',
	            dangerouslySetInnerHTML: { __html: title } })
	        ),
	        upNextElement
	      )
	    );
	  }
	});
	
	/* REACT HOT LOADER */ }).call(this); } finally { if (false) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("/Users/jnunez/git/medscapetv/node_modules/react-hot-loader/makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot apply hot update to " + "title_bar.jsx" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }

/***/ },
/* 689 */
/***/ function(module, exports, __webpack_require__) {

	/* REACT HOT LOADER */ if (false) { (function () { var ReactHotAPI = require("/Users/jnunez/git/medscapetv/node_modules/react-hot-api/modules/index.js"), RootInstanceProvider = require("/Users/jnunez/git/medscapetv/node_modules/react-hot-loader/RootInstanceProvider.js"), ReactMount = require("react/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {
	
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _util = __webpack_require__(12);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* global $ */
	exports.default = _react2.default.createClass({
	  displayName: 'MedscapeTV.Transcript',
	  propTypes: {
	    videoUrlFragment: _react.PropTypes.string.isRequired
	  },
	  getDefaultProps: function getDefaultProps() {
	    return {
	      videoUrlFragment: null
	    };
	  },
	  getInitialState: function getInitialState() {
	    return {
	      itsHTML: undefined
	    };
	  },
	  componentDidMount: function componentDidMount() {
	    var url = (0, _util.isLocal)() ? 'sample-transcript.html' : 'http://www' + (0, _util.envCheck)() + '.medscape.com/mtv/' + window.MedscapeTVInstance.seriesUrlFragment + '/transcript-' + this.props.videoUrlFragment;
	    $.get(url).done(function (data) {
	      document.getElementById('transcript-content').innerHTML = data;
	    }).fail(function () {
	      document.getElementById('transcript-content').innerHTML = '';
	    });
	  },
	  shouldComponentUpdate: function shouldComponentUpdate(nextProps) {
	    return nextProps.videoUrlFragment !== this.props.videoUrlFragment;
	  },
	  componentDidUpdate: function componentDidUpdate() {
	    var url = (0, _util.isLocal)() ? 'sample-transcript.html' : 'http://www' + (0, _util.envCheck)() + '.medscape.com/mtv/' + window.MedscapeTVInstance.seriesUrlFragment + '/transcript-' + this.props.videoUrlFragment;
	    $.get(url).done(function (data) {
	      document.getElementById('transcript-content').innerHTML = data;
	    }).fail(function () {
	      document.getElementById('transcript-content').innerHTML = '';
	    });
	  },
	  createMarkup: function createMarkup() {
	    return { __html: this.state.itsHTML };
	  },
	  render: function render() {
	    return _react2.default.createElement('div', null);
	  }
	});
	
	/* REACT HOT LOADER */ }).call(this); } finally { if (false) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("/Users/jnunez/git/medscapetv/node_modules/react-hot-loader/makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot apply hot update to " + "transcript.jsx" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }

/***/ },
/* 690 */
/***/ function(module, exports, __webpack_require__) {

	/* REACT HOT LOADER */ if (false) { (function () { var ReactHotAPI = require("/Users/jnunez/git/medscapetv/node_modules/react-hot-api/modules/index.js"), RootInstanceProvider = require("/Users/jnunez/git/medscapetv/node_modules/react-hot-loader/RootInstanceProvider.js"), ReactMount = require("react/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {
	
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classnames = __webpack_require__(30);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _video_actions = __webpack_require__(20);
	
	var _video_actions2 = _interopRequireDefault(_video_actions);
	
	var _tracking_actions = __webpack_require__(51);
	
	var _tracking_actions2 = _interopRequireDefault(_tracking_actions);
	
	var _cc_list = __webpack_require__(691);
	
	var _cc_list2 = _interopRequireDefault(_cc_list);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _react2.default.createClass({
	  displayName: 'Player.CCButton',
	  propTypes: {
	    isCaptioningOn: _react.PropTypes.bool,
	    tracks: _react.PropTypes.array,
	    ccLang: _react.PropTypes.string
	  },
	  getDefaultProps: function getDefaultProps() {
	    return {
	      isCaptioningOn: false,
	      ccLang: 'Default'
	    };
	  },
	  getInitialState: function getInitialState() {
	    return { isOpen: false };
	  },
	  shouldComponentUpdate: function shouldComponentUpdate(newProps, newState) {
	    if (this.props.ccLang !== newProps.ccLang) {
	      return true;
	    }
	    if (this.props.isCaptioningOn !== newProps.isCaptioningOn) {
	      return true;
	    }
	    if (this.state.isOpen !== newState.isOpen) {
	      return true;
	    }
	    return false;
	  },
	  componentDidUpdate: function componentDidUpdate(newProps) {
	    if (this.props.isCaptioningOn !== newProps.isCaptioningOn) {
	      _video_actions2.default.setClosedCaptioning(this.props.isCaptioningOn);
	    }
	    if (newProps.ccLang === 'Default') {
	      _video_actions2.default.setClosedCaptioning(this.props.isCaptioningOn);
	    }
	  },
	  setCCState: function setCCState(state) {
	    this.setState({
	      isOpen: state
	    });
	    _video_actions2.default.setClosedCaptioning(state);
	    _tracking_actions2.default.closedCaption(state);
	  },
	  toggle: function toggle() {
	    var isCaptioningOn = this.props.isCaptioningOn;
	    var isOpen = this.state.isOpen;
	
	    if (this.hasMultiple()) {
	      this.setState({
	        isOpen: !isOpen
	      });
	    } else {
	      _video_actions2.default.setClosedCaptioning(!isCaptioningOn);
	      _tracking_actions2.default.closedCaption(!isCaptioningOn);
	    }
	  },
	  hasMultiple: function hasMultiple() {
	    var tracks = this.props.tracks;
	
	    return tracks && tracks.length > 1;
	  },
	  render: function render() {
	    var _this = this;
	
	    var _props = this.props;
	    var isCaptioningOn = _props.isCaptioningOn;
	    var tracks = _props.tracks;
	    var ccLang = _props.ccLang;
	    var isOpen = this.state.isOpen;
	    var classNames = (0, _classnames2.default)({
	      'video-player-cc-button': true,
	      'is-on': isCaptioningOn,
	      'is-open': isOpen
	    });
	    var list = null;
	    if (isOpen && this.hasMultiple()) {
	      list = _react2.default.createElement(_cc_list2.default, { tracks: tracks,
	        clickHandler: this.setCCState,
	        ccLang: ccLang });
	    }
	    return _react2.default.createElement(
	      'div',
	      { className: classNames, onClick: function onClick() {
	          _this.toggle();
	        } },
	      isCaptioningOn ? 'CC' : 'CC',
	      list
	    );
	  }
	});
	
	/* REACT HOT LOADER */ }).call(this); } finally { if (false) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("/Users/jnunez/git/medscapetv/node_modules/react-hot-loader/makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot apply hot update to " + "cc_button.jsx" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }

/***/ },
/* 691 */
/***/ function(module, exports, __webpack_require__) {

	/* REACT HOT LOADER */ if (false) { (function () { var ReactHotAPI = require("/Users/jnunez/git/medscapetv/node_modules/react-hot-api/modules/index.js"), RootInstanceProvider = require("/Users/jnunez/git/medscapetv/node_modules/react-hot-loader/RootInstanceProvider.js"), ReactMount = require("react/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {
	
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _video_actions = __webpack_require__(20);
	
	var _video_actions2 = _interopRequireDefault(_video_actions);
	
	var _classnames = __webpack_require__(30);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _tracking_actions = __webpack_require__(51);
	
	var _tracking_actions2 = _interopRequireDefault(_tracking_actions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _react2.default.createClass({
	  displayName: 'Player.CCList',
	  propTypes: {
	    tracks: _react.PropTypes.array.isRequired,
	    clickHandler: _react.PropTypes.func.isRequired,
	    ccLang: _react.PropTypes.string
	  },
	  languages: {
	    en: 'English',
	    es: 'Spanish',
	    sp: 'Spanish',
	    ja: 'Japanese',
	    pt: 'Portuguese',
	    de: 'German',
	    fr: 'French',
	    ko: 'Korean',
	    nl: 'Dutch',
	    ar: 'Arabic',
	    zh: 'Chinese',
	    it: 'Italian',
	    da: 'Danish',
	    ru: 'Cyrillic',
	    pl: 'Polish',
	    cr: 'Character'
	  },
	  selectLanguage: function selectLanguage(lang) {
	    if (lang !== '') {
	      _video_actions2.default.selectLanguage(lang);
	      document.querySelector('.akamai-captioning').style.display = 'block';
	      _tracking_actions2.default.selectLanguage(lang);
	    } else {
	      this.props.clickHandler(false);
	      _video_actions2.default.selectLanguage(lang);
	      document.querySelector('.akamai-captioning').style.display = 'none';
	    }
	  },
	  render: function render() {
	    var _this = this;
	
	    var items = this.props.tracks.map(function (track, i) {
	      // eslint-disable-line
	      var classNames = (0, _classnames2.default)({
	        'player-cc-list-item': true,
	        'is-selected': Object.keys(track)[0] === _this.props.ccLang
	      });
	      return _react2.default.createElement(
	        'li',
	        { key: i, className: classNames, onClick: function onClick() {
	            _this.selectLanguage(Object.keys(track)[0]);
	          } },
	        Object.keys(track)[0]
	      );
	    });
	    var offClassNames = (0, _classnames2.default)({
	      'player-cc-list-item': true,
	      'is-selected': this.props.ccLang === ''
	    });
	    items[items.length] = _react2.default.createElement(
	      'li',
	      { key: 'off_button', className: offClassNames, onClick: function onClick() {
	          _this.selectLanguage('');
	        } },
	      'Off'
	    );
	    return _react2.default.createElement(
	      'ul',
	      { className: 'player-cc-list' },
	      items
	    );
	  }
	});
	
	/* REACT HOT LOADER */ }).call(this); } finally { if (false) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("/Users/jnunez/git/medscapetv/node_modules/react-hot-loader/makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot apply hot update to " + "cc_list.jsx" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }

/***/ },
/* 692 */
/***/ function(module, exports, __webpack_require__) {

	/* REACT HOT LOADER */ if (false) { (function () { var ReactHotAPI = require("/Users/jnunez/git/medscapetv/node_modules/react-hot-api/modules/index.js"), RootInstanceProvider = require("/Users/jnunez/git/medscapetv/node_modules/react-hot-loader/RootInstanceProvider.js"), ReactMount = require("react/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {
	
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _get2 = __webpack_require__(38);
	
	var _get3 = _interopRequireDefault(_get2);
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _classnames = __webpack_require__(30);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _util = __webpack_require__(12);
	
	var _reflux = __webpack_require__(54);
	
	var _video_store = __webpack_require__(85);
	
	var _video_store2 = _interopRequireDefault(_video_store);
	
	var _has_pretty_time = __webpack_require__(74);
	
	var _has_pretty_time2 = _interopRequireDefault(_has_pretty_time);
	
	var _progress_bar = __webpack_require__(294);
	
	var _progress_bar2 = _interopRequireDefault(_progress_bar);
	
	var _play_button = __webpack_require__(695);
	
	var _play_button2 = _interopRequireDefault(_play_button);
	
	var _volume_slider = __webpack_require__(698);
	
	var _volume_slider2 = _interopRequireDefault(_volume_slider);
	
	var _cc_button = __webpack_require__(690);
	
	var _cc_button2 = _interopRequireDefault(_cc_button);
	
	var _fullscreen_button = __webpack_require__(694);
	
	var _fullscreen_button2 = _interopRequireDefault(_fullscreen_button);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _react2.default.createClass({
	  displayName: 'Player.Controls',
	  propTypes: {
	    playerId: _react.PropTypes.string.isRequired,
	    ccTracks: _react.PropTypes.array,
	    hasCC: _react.PropTypes.bool,
	    hasPlay: _react.PropTypes.bool,
	    hasScrub: _react.PropTypes.bool,
	    hasLength: _react.PropTypes.bool,
	    hasProgress: _react.PropTypes.bool,
	    hasFS: _react.PropTypes.bool,
	    autoPlayCC: _react.PropTypes.bool,
	    hasCCLangMenu: _react.PropTypes.bool,
	    hasMobileStyle: _react.PropTypes.bool,
	    isVideo: _react.PropTypes.bool
	  },
	  mixins: [(0, _reflux.connect)(_video_store2.default), _has_pretty_time2.default],
	  getDefaultProps: function getDefaultProps() {
	    return {
	      hasCC: true,
	      hasPlay: true,
	      hasScrub: true,
	      hasLength: true,
	      hasFS: true,
	      hasProgress: true,
	      hasVolume: true,
	      autoPlayCC: false
	    };
	  },
	  getInitialState: function getInitialState() {
	    return {};
	  },
	  componentDidUpdate: function componentDidUpdate() {
	    if ((0, _get3.default)(this, 'state.video..isFullScreen', false)) {
	      document.getElementById('tvPlayer').classList.remove('fade-in');
	    }
	  },
	  renderTimeTracking: function renderTimeTracking(currentTime, duration, media) {
	    if (!(0, _get3.default)(media, 'meta.hasLength', false)) {
	      return null;
	    }
	    return _react2.default.createElement(
	      'div',
	      { className: 'video-player-time-tracking' },
	      _react2.default.createElement(
	        'div',
	        { className: 'video-player-elapsed-time' },
	        this.secondsToPrettyTime(currentTime)
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'video-player-progress-divider' },
	        '/'
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'video-player-duration' },
	        this.secondsToPrettyTime(duration)
	      )
	    );
	  },
	  render: function render() {
	    var media = this.state.video || { isBuffering: true };
	    var currentTime = media.currentTime;
	    var classNames = (0, _classnames2.default)({
	      'video-player-controls': true,
	      'is-playing': media.isPlaying
	    });
	    var _props = this.props;
	    var hasMobileStyle = _props.hasMobileStyle;
	    var hasPlay = _props.hasPlay;
	
	    var playButton = void 0,
	        fsButton = void 0,
	        volume = void 0,
	        captions = void 0,
	        content = void 0;
	    if ((0, _get3.default)(media, 'meta.hasCc', false)) {
	      captions = _react2.default.createElement(_cc_button2.default, { tracks: media.meta.ccInfo,
	        isCaptioningOn: media.isCaptioningOn,
	        ccLang: media.ccLang });
	    }
	    if (hasPlay && !hasMobileStyle) {
	      playButton = _react2.default.createElement(_play_button2.default, { isPlaying: media.isPlaying, isEnded: media.isEnded });
	    }
	
	    if ((0, _get3.default)(media, 'meta.hasFs', false) && !hasMobileStyle || hasMobileStyle) {
	      fsButton = _react2.default.createElement(_fullscreen_button2.default, { isFullScreen: media.isFullScreen,
	        hasMobileStyle: this.props.hasMobileStyle,
	        isVideo: this.props.isVideo,
	        screenId: this.props.playerId });
	    }
	    if ((0, _get3.default)(media, 'meta.hasVolume', false) && !hasMobileStyle && !(0, _util.isIpad)()) {
	      volume = _react2.default.createElement(_volume_slider2.default, { currentVolume: media.currentVolume,
	        isFullScreen: media.isFullScreen });
	    }
	    var something = (0, _classnames2.default)({
	      'video-player-controls-wrap': true,
	      'is-idle': media.isMouseIdle
	    });
	    content = _react2.default.createElement(
	      'div',
	      { className: something },
	      _react2.default.createElement(_progress_bar2.default, _extends({}, media, {
	        currentTime: currentTime,
	        hasProgress: this.props.hasProgress,
	        hasScrub: (0, _get3.default)(media, 'meta.hasScrub', this.props.hasScrub),
	        hasLength: this.props.hasLength })),
	      _react2.default.createElement(
	        'div',
	        { className: classNames },
	        playButton,
	        this.renderTimeTracking(currentTime, media.duration, media),
	        fsButton,
	        captions,
	        volume
	      )
	    );
	    return content;
	  }
	});
	
	/* REACT HOT LOADER */ }).call(this); } finally { if (false) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("/Users/jnunez/git/medscapetv/node_modules/react-hot-loader/makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot apply hot update to " + "controls.jsx" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }

/***/ },
/* 693 */
/***/ function(module, exports, __webpack_require__) {

	/* REACT HOT LOADER */ if (false) { (function () { var ReactHotAPI = require("/Users/jnunez/git/medscapetv/node_modules/react-hot-api/modules/index.js"), RootInstanceProvider = require("/Users/jnunez/git/medscapetv/node_modules/react-hot-loader/RootInstanceProvider.js"), ReactMount = require("react/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {
	
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classnames = __webpack_require__(30);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(84);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _has_percentage_width = __webpack_require__(295);
	
	var _has_percentage_width2 = _interopRequireDefault(_has_percentage_width);
	
	var _util = __webpack_require__(12);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _react2.default.createClass({
	  displayName: 'Player.DragBar',
	  propTypes: {
	    onDragStart: _react.PropTypes.func,
	    onDragEnd: _react.PropTypes.func,
	    style: _react.PropTypes.object,
	    hasScrub: _react.PropTypes.bool,
	    currentTime: _react.PropTypes.number,
	    duration: _react.PropTypes.number,
	    isFullScreen: _react.PropTypes.bool
	  },
	  mixins: [_has_percentage_width2.default],
	  getInitialState: function getInitialState() {
	    return {
	      dragX: 0,
	      parentWidth: 1000
	    };
	  },
	  componentDidMount: function componentDidMount() {
	    this.setState({
	      parentWidth: _reactDom2.default.findDOMNode(this).parentNode.getBoundingClientRect().width
	    });
	  },
	  shouldComponentUpdate: function shouldComponentUpdate(nextProps, nextState) {
	    if (this.props.currentTime !== nextProps.currentTime) {
	      return true;
	    }
	    if (nextState.dragX === 0 && nextState.isDragging === true) {
	      return false;
	    }
	    if (typeof nextState.dragX === 'undefined') {
	      return false;
	    }
	    if (nextProps.currentTime === 0) {
	      return false;
	    } else {
	      return true;
	    }
	  },
	  onMouseMove: function onMouseMove(e) {
	    if (!this.props.hasScrub || document.getElementById('tvPlayer').classList.contains('presistant-video')) {
	      return;
	    }
	    var left = this.props.isFullScreen ? 0 : (0, _util.getOffset)(_reactDom2.default.findDOMNode(this), document).left;
	    this.setState({
	      dragX: e.pageX - left
	    });
	  },
	  onTouchMove: function onTouchMove(e) {
	    if (!this.props.hasScrub || document.getElementById('tvPlayer').classList.contains('presistant-video')) {
	      return;
	    }
	    e.preventDefault();
	    var touch = e.originalEvent.touches[0] || e.originalEvent.changedTouches[0];
	    this.setState({
	      dragX: touch.pageX - (0, _util.getOffset)(_reactDom2.default.findDOMNode(this), document).left
	    });
	  },
	  getCursorStyle: function getCursorStyle(elapsed, total) {
	    var num = Math.floor(elapsed / total * 8 - 9);
	    return {
	      'right': num + 'px'
	    };
	  },
	  dragStart: function dragStart(e) {
	    if (!this.props.hasScrub || document.getElementById('tvPlayer').classList.contains('presistant-video')) {
	      return;
	    }
	    e.stopPropagation();
	    this.setState({
	      isDragging: true,
	      dragX: 0
	    });
	    document.addEventListener('mousemove', this.onMouseMove);
	    document.addEventListener('mouseup', this.dragEnd);
	    document.addEventListener('touchmove', this.onTouchMove);
	    document.addEventListener('touchend', this.dragEnd);
	  },
	  dragEnd: function dragEnd(e) {
	    if (!this.props.hasScrub || document.getElementById('tvPlayer').classList.contains('presistant-video')) {
	      return;
	    }
	    if (this.state.isDragging === false) {
	      return;
	    } else {
	      document.removeEventListener('mousemove', this.onMouseMove);
	      document.removeEventListener('mouseup', this.dragEnd);
	      document.removeEventListener('touchmove', this.onTouchMove);
	      document.removeEventListener('touchend', this.dragEnd);
	      if (this.props.onDragEnd && !(0, _util.isDescendant)(document.querySelector('.video-player-progress-bar-wrap'), e.target)) {
	        this.props.onDragEnd(e);
	      }
	    }
	    this.setState({
	      isDragging: false
	    });
	  },
	  killEvent: function killEvent(e) {
	    e.stopPropagation();
	  },
	  render: function render() {
	    var classNames = (0, _classnames2.default)({
	      'video-player-elapsed-time-indicator': true,
	      'is-dragging': this.state.isDragging
	    }),
	        parentWidth = this.props.isFullScreen ? document.documentElement.offsetWidth : this.state.parentWidth,
	        style = this.state.isDragging ? this.getStyle(this.state.dragX, parentWidth, this.props.isFullScreen) : this.props.style;
	    var cursorStyle = this.getCursorStyle(this.props.currentTime, this.props.duration);
	    if (this.props.hasScrub) {
	      return _react2.default.createElement(
	        'div',
	        { className: classNames,
	          onMouseDown: this.dragStart,
	          onMouseUp: this.dragEnd,
	          onClick: this.killEvent,
	          onTouchStart: this.dragStart,
	          onTouchEnd: this.dragEnd,
	          onTouchMove: this.touchMove,
	          style: style },
	        _react2.default.createElement('div', { className: 'draggable-medtv',
	          style: cursorStyle })
	      );
	    } else {
	      return _react2.default.createElement('div', { className: classNames, style: style });
	    }
	  }
	}); /* eslint "react/no-did-mount-set-state": 0 */
	
	/* REACT HOT LOADER */ }).call(this); } finally { if (false) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("/Users/jnunez/git/medscapetv/node_modules/react-hot-loader/makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot apply hot update to " + "drag_bar.jsx" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }

/***/ },
/* 694 */
/***/ function(module, exports, __webpack_require__) {

	/* REACT HOT LOADER */ if (false) { (function () { var ReactHotAPI = require("/Users/jnunez/git/medscapetv/node_modules/react-hot-api/modules/index.js"), RootInstanceProvider = require("/Users/jnunez/git/medscapetv/node_modules/react-hot-loader/RootInstanceProvider.js"), ReactMount = require("react/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {
	
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classnames = __webpack_require__(30);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _video_actions = __webpack_require__(20);
	
	var _video_actions2 = _interopRequireDefault(_video_actions);
	
	var _screenfull = __webpack_require__(342);
	
	var _screenfull2 = _interopRequireDefault(_screenfull);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* global screenfull */
	exports.default = _react2.default.createClass({
	  displayName: 'Player.FullscreenButton',
	  propTypes: {
	    isFullScreen: _react.PropTypes.bool,
	    screenId: _react.PropTypes.string,
	    hasMobileStyle: _react.PropTypes.bool,
	    isVideo: _react.PropTypes.bool
	  },
	  mixins: [_react2.default.PureRenderMixin],
	  fullscreen: function fullscreen(e) {
	    e.preventDefault();
	    if (this.props.isFullScreen) {
	      _video_actions2.default.exitFullScreen();
	      document.getElementById('ads-pos-122-container').style.zIndex = 2;
	      if (_screenfull2.default) {
	        _screenfull2.default.exit();
	      }
	    } else {
	      _video_actions2.default.fullScreen();
	      document.getElementById('ads-pos-122-container').style.zIndex = 0;
	      if (_screenfull2.default) {
	        document.getElementById('tvPlayer').classList.remove('fade-in');
	        _screenfull2.default.request(document.getElementById(this.props.screenId));
	      }
	    }
	  },
	  render: function render() {
	    var classNames = (0, _classnames2.default)({
	      'video-player-fullscreen-button': true,
	      'is-fullscreen': this.props.isFullScreen
	    });
	    return _react2.default.createElement(
	      'button',
	      { className: classNames, onClick: this.fullscreen },
	      'FS'
	    );
	  }
	});
	
	/* REACT HOT LOADER */ }).call(this); } finally { if (false) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("/Users/jnunez/git/medscapetv/node_modules/react-hot-loader/makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot apply hot update to " + "fullscreen_button.jsx" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }

/***/ },
/* 695 */
/***/ function(module, exports, __webpack_require__) {

	/* REACT HOT LOADER */ if (false) { (function () { var ReactHotAPI = require("/Users/jnunez/git/medscapetv/node_modules/react-hot-api/modules/index.js"), RootInstanceProvider = require("/Users/jnunez/git/medscapetv/node_modules/react-hot-loader/RootInstanceProvider.js"), ReactMount = require("react/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {
	
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classnames = __webpack_require__(30);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _video_actions = __webpack_require__(20);
	
	var _video_actions2 = _interopRequireDefault(_video_actions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _react2.default.createClass({
	  displayName: 'Player.PlayButton',
	  propTypes: {
	    isPlaying: _react.PropTypes.bool,
	    isEnded: _react.PropTypes.bool
	  },
	  shouldComponentUpdate: function shouldComponentUpdate(nextProps) {
	    return nextProps.isPlaying !== this.props.isPlaying || nextProps.isEnded !== this.props.isEnded;
	  },
	  toggle: function toggle(e) {
	    e.preventDefault();
	    if (this.props.isPlaying) {
	      _video_actions2.default.pause();
	    } else if (this.props.isEnded) {
	      _video_actions2.default.replay();
	    } else {
	      _video_actions2.default.start();
	    }
	  },
	  render: function render() {
	    var playOrPause = this.props.isPlaying ? 'pause' : 'play';
	    var classNames = (0, _classnames2.default)({
	      'video-player-play-button': true,
	      'is-playing': this.props.isPlaying
	    });
	    if (this.props.isEnded) {
	      playOrPause = 'replay';
	    }
	
	    return _react2.default.createElement(
	      'button',
	      { onClick: this.toggle, className: classNames },
	      playOrPause
	    );
	  }
	});
	
	/* REACT HOT LOADER */ }).call(this); } finally { if (false) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("/Users/jnunez/git/medscapetv/node_modules/react-hot-loader/makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot apply hot update to " + "play_button.jsx" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }

/***/ },
/* 696 */
/***/ function(module, exports, __webpack_require__) {

	/* REACT HOT LOADER */ if (false) { (function () { var ReactHotAPI = require("/Users/jnunez/git/medscapetv/node_modules/react-hot-api/modules/index.js"), RootInstanceProvider = require("/Users/jnunez/git/medscapetv/node_modules/react-hot-loader/RootInstanceProvider.js"), ReactMount = require("react/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {
	
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _get2 = __webpack_require__(38);
	
	var _get3 = _interopRequireDefault(_get2);
	
	var _classnames = __webpack_require__(30);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _video_actions = __webpack_require__(20);
	
	var _video_actions2 = _interopRequireDefault(_video_actions);
	
	var _tracking_actions = __webpack_require__(51);
	
	var _tracking_actions2 = _interopRequireDefault(_tracking_actions);
	
	var _reactRouter = __webpack_require__(87);
	
	var _util = __webpack_require__(12);
	
	var _has_pretty_time = __webpack_require__(74);
	
	var _has_pretty_time2 = _interopRequireDefault(_has_pretty_time);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _react2.default.createClass({
	  displayName: 'Player.PlaylistItem',
	  propTypes: {
	    onClick: _react.PropTypes.func,
	    isSelected: _react.PropTypes.bool,
	    video: _react.PropTypes.object,
	    index: _react.PropTypes.number,
	    hasViewed: _react.PropTypes.bool,
	    duration: _react.PropTypes.number,
	    enabled: _react.PropTypes.bool
	  },
	  mixins: [_has_pretty_time2.default],
	  selectVideo: function selectVideo(e) {
	    if (this.props.enabled === false) {
	      return;
	    }
	    e.preventDefault();
	    if (!this.props.isSelected) {
	      if (this.props.onClick) {
	        this.props.onClick(e);
	      }
	      _video_actions2.default.selectVideo(this.props.video, this.props.index);
	    }
	  },
	  track: function track() {
	    if (!this.props.video.isAdvertisement) {
	      _tracking_actions2.default.selectVideo('vidmtv-show_' + ((0, _get3.default)(this, 'props.video.videoIndex', 0) + 1));
	    } else {
	      _tracking_actions2.default.selectVideo('vidmtv-show_ifi');
	    }
	  },
	  render: function render() {
	    var title = null;
	    if (this.props.video.isAdvertisement) {
	      title = _react2.default.createElement(
	        'div',
	        { className: 'advertisment' },
	        'INFORMATION FROM INDUSTRY'
	      );
	      if (this.props.isSelected === true) {
	        var trackingAnchorContainer = document.createElement('div');
	        var trackingPixelHTML = (0, _get3.default)(this, 'props.video.trackingPixelHTML', '');
	        trackingAnchorContainer.innerHTML = trackingPixelHTML;
	        document.body.appendChild(trackingAnchorContainer);
	      }
	    } else {
	      if (this.props.video.videoTag !== '') {
	        title = _react2.default.createElement(
	          'div',
	          { className: 'low-light' },
	          this.props.video.videoTag
	        );
	      } else if (this.props.video.isIndexed === true) {
	        title = _react2.default.createElement(
	          'div',
	          { className: 'low-light' },
	          ' ',
	          'Episode ' + ((0, _get3.default)(this, 'props.video.videoIndex', 0) + 1) + '   |   ',
	          ' ',
	          this.secondsToPrettyTime(this.props.video.duration, 2)
	        );
	      }
	    }
	    if (this.props.isSelected === true) {
	      document.getElementById('livefyre_iframe').setAttribute('src', 'http://www' + (0, _util.envCheck)() + '.medscape.com/mtv/' + window.MedscapeTVInstance.seriesUrlFragment + '/mtvc-' + this.props.video.videoUrlFragment);
	    }
	    var classNames = (0, _classnames2.default)({
	      'video-player-playlist-item': true,
	      'is-selected': this.props.isSelected,
	      'has-viewed': this.props.hasViewed
	    }),
	        basePath = (0, _util.isLocal)() ? '' : '/mtv/' + window.MedscapeTVInstance.seriesUrlFragment,
	        content = _react2.default.createElement(
	      'div',
	      { className: 'video-title' },
	      title,
	      _react2.default.createElement(
	        'div',
	        null,
	        this.props.video.title
	      )
	    );
	    var legend = null;
	    if (this.props.hasViewed) {
	      legend = _react2.default.createElement(
	        'div',
	        { className: 'watched' },
	        'WATCHED'
	      );
	    }
	    if (this.props.isSelected) {
	      legend = _react2.default.createElement(
	        'div',
	        { className: 'now-playing' },
	        'NOW PLAYING'
	      );
	    }
	    return _react2.default.createElement(
	      _reactRouter.Link,
	      { className: classNames, onClick: this.track, to: basePath + '/' + this.props.video.videoUrlFragment },
	      _react2.default.createElement('img', { className: 'thumbnail-btn', src: (0, _util.getImageServer)() + '/' + this.props.video.thumbnail }),
	      _react2.default.createElement('img', { className: 'hover-btn', src: (0, _util.getImageServer)() + '/pi/core/medscapetv/assets/images/video-player/play-overlay.svg' }),
	      legend,
	      content
	    );
	  }
	});
	
	/* REACT HOT LOADER */ }).call(this); } finally { if (false) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("/Users/jnunez/git/medscapetv/node_modules/react-hot-loader/makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot apply hot update to " + "playlist_item.jsx" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }

/***/ },
/* 697 */
/***/ function(module, exports, __webpack_require__) {

	/* REACT HOT LOADER */ if (false) { (function () { var ReactHotAPI = require("/Users/jnunez/git/medscapetv/node_modules/react-hot-api/modules/index.js"), RootInstanceProvider = require("/Users/jnunez/git/medscapetv/node_modules/react-hot-loader/RootInstanceProvider.js"), ReactMount = require("react/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {
	
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classnames = __webpack_require__(30);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _resizes_images = __webpack_require__(706);
	
	var _resizes_images2 = _interopRequireDefault(_resizes_images);
	
	var _video_actions = __webpack_require__(20);
	
	var _video_actions2 = _interopRequireDefault(_video_actions);
	
	var _util = __webpack_require__(12);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _react2.default.createClass({
	  displayName: 'Player.Screen',
	  propTypes: {
	    videoElementId: _react.PropTypes.string,
	    isPlaying: _react.PropTypes.bool,
	    hasStarted: _react.PropTypes.bool,
	    isEnded: _react.PropTypes.bool,
	    video: _react.PropTypes.object
	  },
	  mixins: [_resizes_images2.default],
	  componentDidMount: function componentDidMount() {
	    _video_actions2.default.load(this.props.videoElementId, this.props.video);
	    this.newMount = true;
	  },
	  componentDidUpdate: function componentDidUpdate(prevProp) {
	    if (prevProp.hasStarted === true) {
	      // Akamai bugged. They probobly wont fix.
	      // Our custom paused/play is more reliable so we use it to fix akamai.
	      var videoPlayer = document.getElementById(this.props.videoElementId),
	          videoPlayerScreen = document.getElementById('video_player_screen'),
	          videoPoster = document.querySelector('.akamai-poster');
	
	      if (videoPlayerScreen.classList.contains('is-paused')) {
	        videoPlayer.classList.remove('akamai-ready');
	        videoPlayer.classList.add('akamai-paused');
	        if (videoPoster !== null && this.newMount === false && !(0, _util.isMobile)()) {
	          videoPoster.classList.add('fade-in');
	          videoPoster.classList.remove('fade-out');
	        }
	      } else {
	        videoPlayer.classList.remove('akamai-paused');
	        videoPlayer.classList.remove('akamai-ready');
	        if (videoPoster !== null && this.newMount === false && !(0, _util.isMobile)()) {
	          videoPoster.classList.remove('fade-in');
	          videoPoster.classList.add('fade-out');
	        }
	      }
	      if (videoPoster !== null) {
	        if (this.newMount === true && !(0, _util.isMobile)()) {
	          videoPoster.classList.add('fade-out');
	        }
	        this.newMount = false;
	      }
	    }
	  },
	  toggle: function toggle(e) {
	    if (e.target.nodeName === 'OBJECT') return; // ignore events that are bubbling from the flash player
	    // VideoActions.toggle();
	  },
	  render: function render() {
	    var _props = this.props;
	    var isPlaying = _props.isPlaying;
	    var isEnded = _props.isEnded;
	    var videoElementId = _props.videoElementId;
	    var video = _props.video;
	    // so that the akamai player works outside of the React render chain
	    var akamaiDiv = "<div class='content' id='" + videoElementId + "'></div>";
	    var style = {
	      // backgroundImage: isPlaying? null : `url(${video.poster})`
	    };
	    var classes = (0, _classnames2.default)({
	      'video-player-screen': true,
	      'is-paused': !isPlaying,
	      'is-ended': isEnded,
	      'has-title-card': video.hasTitleCard
	    });
	    return _react2.default.createElement('div', { onTouchEnd: this.toggle,
	      onClick: this.toggle,
	      id: 'video_player_screen',
	      className: classes,
	      style: style,
	      dangerouslySetInnerHTML: { __html: akamaiDiv } });
	  }
	});
	
	/* REACT HOT LOADER */ }).call(this); } finally { if (false) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("/Users/jnunez/git/medscapetv/node_modules/react-hot-loader/makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot apply hot update to " + "screen.jsx" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }

/***/ },
/* 698 */
/***/ function(module, exports, __webpack_require__) {

	/* REACT HOT LOADER */ if (false) { (function () { var ReactHotAPI = require("/Users/jnunez/git/medscapetv/node_modules/react-hot-api/modules/index.js"), RootInstanceProvider = require("/Users/jnunez/git/medscapetv/node_modules/react-hot-loader/RootInstanceProvider.js"), ReactMount = require("react/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {
	
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classnames = __webpack_require__(30);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(84);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _video_actions = __webpack_require__(20);
	
	var _video_actions2 = _interopRequireDefault(_video_actions);
	
	var _has_slider_events = __webpack_require__(296);
	
	var _has_slider_events2 = _interopRequireDefault(_has_slider_events);
	
	var _util = __webpack_require__(12);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _react2.default.createClass({
	  displayName: 'Player.VolumeSlider',
	  propTypes: {
	    currentVolume: _react.PropTypes.number,
	    hasMute: _react.PropTypes.bool,
	    isFullScreen: _react.PropTypes.bool
	  },
	  mixins: [_has_slider_events2.default],
	  getDefaultProps: function getDefaultProps() {
	    return {
	      currentVolume: 0.75,
	      hasMute: true
	    };
	  },
	  getInitialState: function getInitialState() {
	    return {
	      lastVolume: 0.75,
	      percentHeight: 75,
	      parentHeight: 70
	    };
	  },
	  shouldComponentUpdate: function shouldComponentUpdate(nextProps, nextState) {
	    if (this.state.isActive !== nextState.isActive) {
	      return true;
	    }
	    if (this.state.isDragging === true) {
	      return true;
	    }if (nextProps.currentVolume !== this.props.currentVolume) {
	      return true;
	    } else {
	      return false;
	    }
	    return true;
	  },
	  onMouseMove: function onMouseMove(e) {
	    var top = this.props.isFullScreen ? (0, _util.getOffset)(_reactDom2.default.findDOMNode(this), document).top - 180 : (0, _util.getOffset)(_reactDom2.default.findDOMNode(this), document).top,
	        barHeight = document.querySelector('.video-player-volume-line').getBoundingClientRect().height,
	        percentHeight = this.getStyle((0, _util.getOffset)(_reactDom2.default.findDOMNode(this), document).top - e.pageY, barHeight, this.props.isFullScreen);
	    console.log('top - e.pageY', top - e.pageY);
	    console.log('barHeight', barHeight);
	    this.setState({
	      percentHeight: percentHeight
	    });
	  },
	  onTouchMove: function onTouchMove(e) {
	    e.preventDefault();
	    var touch = e.originalEvent.touches[0] || e.originalEvent.changedTouches[0],
	        percentHeight = this.getStyle((0, _util.getOffset)(_reactDom2.default.findDOMNode(this), document).top - touch.pageY, this.state.parentHeight, this.props.isFullScreen);
	    this.setState({
	      percentHeight: percentHeight
	    });
	  },
	  setVolume: function setVolume(e) {
	    e.preventDefault();
	    _video_actions2.default.setVolume(this.getSliderValueY(e, 1));
	  },
	  getCursorStyle: function getCursorStyle(elapsed, total) {
	    var num = Math.floor(elapsed / total * 10 + 20);
	    return {
	      'top': num + 'px'
	    };
	  },
	  getStyle: function getStyle(elapsed, total) {
	    var percent = (elapsed / total * 100).toFixed(2);
	    if (isNaN(percent) || percent < 0) {
	      percent = 0;
	    } else if (percent > 100) {
	      percent = 100;
	    }
	    return percent;
	  },
	  killEvent: function killEvent(e) {
	    e.stopPropagation();
	  },
	  showVolumeBar: function showVolumeBar() {
	    this.setState({
	      isActive: true
	    });
	  },
	  hideVolumeBar: function hideVolumeBar(e) {
	    var isActive = false;
	    if (e.relatedTarget === document.querySelector('.video-player-progress-bar-wrap') || e.relatedTarget === document.querySelector('.video-player-elapsed-time-indicator') || e.relatedTarget === document.querySelector('.video-player-loaded-bar') || (0, _util.isDescendant)(document.querySelector('.video-player-volume-slider'), e.relatedTarget)) {
	      isActive = true;
	    }
	    this.setState({
	      isActive: isActive
	    });
	  },
	  dragStart: function dragStart(e) {
	    e.stopPropagation();
	    this.setState({
	      isDragging: true,
	      dragY: 0
	    });
	    document.addEventListener('mousemove', this.onMouseMove);
	    document.addEventListener('mouseup', this.dragEnd);
	    document.addEventListener('touchmove', this.onTouchMove);
	    document.addEventListener('touchend', this.dragEnd);
	  },
	  dragEnd: function dragEnd(e) {
	    var percentHeight = this.getStyle((0, _util.getOffset)(_reactDom2.default.findDOMNode(this), document).top - e.pageY, this.state.parentHeight, this.props.isFullScreen);
	    this.setState({
	      percentHeight: percentHeight
	    });
	    if (this.state.isDragging === false) {
	      return;
	    } else {
	      document.removeEventListener('mousemove', this.onMouseMove);
	      document.removeEventListener('mouseup', this.dragEnd);
	      document.removeEventListener('touchmove', this.onTouchMove);
	      document.removeEventListener('touchend', this.dragEnd);
	      _video_actions2.default.setVolume(percentHeight / 100);
	      this.setState({
	        isDragging: false
	      });
	    }
	  },
	  mute: function mute(e) {
	    e.preventDefault();
	    if (this.props.currentVolume === 0) {
	      _video_actions2.default.unmute(this.state.lastVolume);
	      this.setState({
	        percentHeight: this.state.lastVolume * 100
	      });
	    } else {
	      this.setState({
	        lastVolume: this.props.currentVolume,
	        percentHeight: 0
	      });
	      _video_actions2.default.mute(0);
	    }
	  },
	  render: function render() {
	    var currentVolume = this.props.currentVolume,
	        volumeButtonClass = (0, _classnames2.default)({
	      'video-player-volume-muted-button': currentVolume === 0,
	      'video-player-volume-low-button': currentVolume > 0 && currentVolume <= 0.33,
	      'video-player-volume-med-button': currentVolume > 0.33 && currentVolume <= 0.66,
	      'video-player-volume-high-button': currentVolume > 0.66,
	      'video-player-volume-button': true
	    }),
	        mute = this.props.hasMute ? _react2.default.createElement(
	      'button',
	      { ref: 'muteButton',
	        className: volumeButtonClass,
	        onClick: this.mute },
	      'M'
	    ) : null,
	        classNames = (0, _classnames2.default)({
	      'video-player-volume-slider': true,
	      'is-muted': this.props.currentVolume === 0,
	      'is-active': this.state.isActive
	    }),
	        grabLine = (0, _classnames2.default)({
	      grabbable: true,
	      'video-player-volume-line': true
	    }),
	        indicatorCN = (0, _classnames2.default)({
	      grabbable: true,
	      'video-player-volume-indicator': true
	    }),
	        wrapCN = (0, _classnames2.default)({
	      grabbable: true,
	      'video-player-volume-boundary-wrap': true
	    });
	    return _react2.default.createElement(
	      'div',
	      { className: classNames, onMouseEnter: this.showVolumeBar, onMouseOut: this.hideVolumeBar },
	      mute,
	      _react2.default.createElement(
	        'div',
	        { className: wrapCN, onMouseOut: this.hideVolumeBar },
	        _react2.default.createElement(
	          'div',
	          { className: 'video-player-volume-boundary',
	            onClick: this.killEvent,
	            onMouseDown: this.dragStart,
	            onMouseUp: this.dragEnd,
	            onTouchStart: this.dragStart,
	            onTouchEnd: this.dragEnd,
	            onTouchMove: this.touchMove },
	          _react2.default.createElement(
	            'div',
	            { className: grabLine },
	            ' '
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: indicatorCN, style: { height: this.state.percentHeight + '%' } },
	            _react2.default.createElement('div', { className: 'video-player-volume-indicator-icon' })
	          )
	        )
	      )
	    );
	  }
	});
	
	/* REACT HOT LOADER */ }).call(this); } finally { if (false) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("/Users/jnunez/git/medscapetv/node_modules/react-hot-loader/makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot apply hot update to " + "volume_slider.jsx" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }

/***/ },
/* 699 */
/***/ function(module, exports, __webpack_require__) {

	/* REACT HOT LOADER */ if (false) { (function () { var ReactHotAPI = require("/Users/jnunez/git/medscapetv/node_modules/react-hot-api/modules/index.js"), RootInstanceProvider = require("/Users/jnunez/git/medscapetv/node_modules/react-hot-loader/RootInstanceProvider.js"), ReactMount = require("react/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {
	
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _get2 = __webpack_require__(38);
	
	var _get3 = _interopRequireDefault(_get2);
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _classnames = __webpack_require__(30);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reflux = __webpack_require__(54);
	
	var _util = __webpack_require__(12);
	
	var _toggles_play = __webpack_require__(707);
	
	var _toggles_play2 = _interopRequireDefault(_toggles_play);
	
	var _descriptor_store = __webpack_require__(191);
	
	var _descriptor_store2 = _interopRequireDefault(_descriptor_store);
	
	var _video_store = __webpack_require__(85);
	
	var _video_store2 = _interopRequireDefault(_video_store);
	
	var _controls = __webpack_require__(692);
	
	var _controls2 = _interopRequireDefault(_controls);
	
	var _screen = __webpack_require__(697);
	
	var _screen2 = _interopRequireDefault(_screen);
	
	var _episode_guide = __webpack_require__(686);
	
	var _episode_guide2 = _interopRequireDefault(_episode_guide);
	
	var _progress_bar = __webpack_require__(294);
	
	var _progress_bar2 = _interopRequireDefault(_progress_bar);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _react2.default.createClass({
	  displayName: 'StandalonePlayer',
	  propTypes: {
	    id: _react.PropTypes.string,
	    descriptorJSON: _react.PropTypes.object,
	    onVideoEnd: _react.PropTypes.func,
	    videoIndex: _react.PropTypes.number,
	    hasCC: _react.PropTypes.bool,
	    videoUrlFragment: _react.PropTypes.string,
	    isMouseIdle: _react.PropTypes.bool
	  },
	  mixins: [(0, _reflux.connect)(_descriptor_store2.default), (0, _reflux.connect)(_video_store2.default), _toggles_play2.default],
	  getDefaultProps: function getDefaultProps() {
	    return {
	      videoElementId: 'medscape-akamai-video-container',
	      isMouseIdle: false
	    };
	  },
	  getInitialState: function getInitialState() {
	    return { video: {} };
	  },
	  componentWillMount: function componentWillMount() {},
	  shouldComponentUpdate: function shouldComponentUpdate(nextProps, nextState) {
	    if (nextState.video.currentTime !== this.state.video.currentTime) {
	      return true;
	    }
	    if (nextProps.isMouseIdle !== this.props.isMouseIdle) {
	      return true;
	    }
	    if (nextProps.videoIndex !== this.props.videoIndex) {
	      return true;
	    }
	    if (this.props.videoUrlFragment !== nextProps.videoUrlFragment) {
	      return true;
	    }
	    var descriptor = this.state.descriptor,
	        video = nextState.video;
	    if (video.event === 'ended') {
	      if (this.props.onVideoEnd) this.props.onVideoEnd(video.index);
	    }
	
	    return nextState.descriptor !== descriptor || nextState.video.isFullScreen !== this.state.video.isFullScreen || nextState.video.isLoading !== this.state.video.isLoading || nextState.video.isPlaying !== this.state.video.isPlaying;
	  },
	  getVideoIndex: function getVideoIndex(videoUrlFragment) {
	    return this.props.descriptorJSON.videos.findIndex(function (video) {
	      return video.videoUrlFragment === videoUrlFragment;
	    });
	  },
	  renderControls: function renderControls() {
	    if ((0, _util.isMobile)() && !(0, _util.isIpad)()) {
	      var media = this.state.video || { isBuffering: true },
	          currentTime = media.currentTime;
	      return _react2.default.createElement(_progress_bar2.default, _extends({}, media, {
	        currentTime: currentTime,
	        hasProgress: true,
	        hasScrub: false,
	        hasLength: false }));
	    } else {
	      return _react2.default.createElement(_controls2.default, {
	        playerId: this.props.id,
	        hasCC: this.props.hasCC });
	    }
	  },
	  render: function render() {
	    var controls = void 0,
	        screenComponent = _react2.default.createElement(
	      'div',
	      { className: 'video-player-empty-shell' },
	      'loading. . .'
	    );
	    var descriptor = this.state.descriptor;
	    var isFullScreen = this.state.video.isFullScreen;
	    var isPlaying = (0, _get3.default)(this, 'state.video.isPlaying', false);
	    var hasStarted = (0, _get3.default)(this, 'state.video.hasStarted', false);
	    if (descriptor) {
	      var videoIndex = this.getVideoIndex(this.props.videoUrlFragment),
	          classNames = (0, _classnames2.default)({
	        'video-player-standalone': true,
	        'is-fullscreen': isFullScreen,
	        'is-playing': isPlaying,
	        'is-idle': this.props.isMouseIdle
	      });
	      if (videoIndex !== -1) {
	        if (document.querySelector('.hero-bg') !== null) {
	          document.querySelector('.hero-bg').style.display = 'none';
	        }
	        var video = descriptor.videos[videoIndex],
	            watermark = (0, _get3.default)(video, 'options.watermark', null);
	        screenComponent = _react2.default.createElement(
	          'div',
	          { className: classNames, id: this.props.id },
	          _react2.default.createElement(_screen2.default, {
	            onTouchEnd: this.start,
	            isPlaying: isPlaying,
	            hasStarted: hasStarted,
	            shouldShowNativeControls: !controls,
	            watermark: watermark,
	            videoElementId: 'medscape-akamai-video-container',
	            videoIndex: videoIndex,
	            video: video }),
	          this.renderControls()
	        );
	      } else {
	        if (document.querySelector('.hero-bg') !== null) {
	          document.querySelector('.hero-bg').style.display = 'block';
	        }
	        screenComponent = _react2.default.createElement(
	          'div',
	          { className: classNames, id: this.props.id },
	          _react2.default.createElement(_episode_guide2.default, null)
	        );
	      }
	    }
	    return screenComponent;
	  }
	});
	
	/* REACT HOT LOADER */ }).call(this); } finally { if (false) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("/Users/jnunez/git/medscapetv/node_modules/react-hot-loader/makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot apply hot update to " + "standalone_player.jsx" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }

/***/ },
/* 700 */
/***/ function(module, exports, __webpack_require__) {

	/* REACT HOT LOADER */ if (false) { (function () { var ReactHotAPI = require("/Users/jnunez/git/medscapetv/node_modules/react-hot-api/modules/index.js"), RootInstanceProvider = require("/Users/jnunez/git/medscapetv/node_modules/react-hot-loader/RootInstanceProvider.js"), ReactMount = require("react/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {
	
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _video_compiler = __webpack_require__(701);
	
	var _video_compiler2 = _interopRequireDefault(_video_compiler);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Compiler = function Compiler(descriptor, videoUrlFragment) {
	  this.descriptor = descriptor;
	  this.videoUrlFragment = videoUrlFragment;
	};
	
	Compiler.prototype = {
	  compile: function compile() {
	    var _this = this;
	
	    var inIndex = this.descriptor.videos.findIndex(function (video) {
	      return video.videoUrlFragment === _this.videoUrlFragment;
	    });
	    if (!isNaN(inIndex) && inIndex !== -1) {
	      this.descriptor.initialIndex = inIndex > this.descriptor.videos.length || inIndex < 0 ? 0 : inIndex;
	    } else if (this.descriptor.specialtyTitle === this.videoUrlFragment) {
	      this.descriptor.initialIndex = -1;
	    } else {
	      this.descriptor.initialIndex = 0;
	    }
	    this.mediaCompiler = new _video_compiler2.default(this.descriptor.videos, this.descriptor.ccInfo);
	    this.descriptor.isVideo = true;
	    this.mediaCompiler.compile();
	    this.descriptor.videos = this.mediaCompiler.getVideos();
	    return this;
	  },
	  getDescriptor: function getDescriptor() {
	    return this.descriptor;
	  }
	};
	
	exports.default = Compiler;
	
	/* REACT HOT LOADER */ }).call(this); } finally { if (false) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("/Users/jnunez/git/medscapetv/node_modules/react-hot-loader/makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot apply hot update to " + "compiler.js" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }

/***/ },
/* 701 */
/***/ function(module, exports, __webpack_require__) {

	/* REACT HOT LOADER */ if (false) { (function () { var ReactHotAPI = require("/Users/jnunez/git/medscapetv/node_modules/react-hot-api/modules/index.js"), RootInstanceProvider = require("/Users/jnunez/git/medscapetv/node_modules/react-hot-loader/RootInstanceProvider.js"), ReactMount = require("react/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {
	
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _isEmpty2 = __webpack_require__(188);
	
	var _isEmpty3 = _interopRequireDefault(_isEmpty2);
	
	var _reduce2 = __webpack_require__(288);
	
	var _reduce3 = _interopRequireDefault(_reduce2);
	
	var _isArray2 = __webpack_require__(17);
	
	var _isArray3 = _interopRequireDefault(_isArray2);
	
	var _util = __webpack_require__(12);
	
	var _has_pretty_time = __webpack_require__(74);
	
	var _has_pretty_time2 = _interopRequireDefault(_has_pretty_time);
	
	var _descriptor_compiler_methods = __webpack_require__(702);
	
	var _descriptor_compiler_methods2 = _interopRequireDefault(_descriptor_compiler_methods);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	var STREAM_CDN_HOST = 'http://webmd-vh.akamaihd.net',
	    MP4_CDN_HOST = 'http://webmd-a.akamaihd.net';
	
	var VideoCompiler = function VideoCompiler(videos, ccInfo) {
	  this.videos = videos;
	  this.isValid = true;
	  this.ccInfo = ccInfo;
	};
	
	VideoCompiler.prototype = (0, _util.mixin)(_has_pretty_time2.default, _descriptor_compiler_methods2.default, {
	  compile: function compile() {
	    return this.prefixImageRefs().setDurations().buildSources().setCC();
	  },
	  setCC: function setCC() {
	    var _this = this;
	
	    this.each(function (video) {
	      _this._setClosedCaptioning(video.ccFileRoot, video.ccInfo, video);
	    });
	  },
	  _setClosedCaptioning: function _setClosedCaptioning(prefix, captions, video) {
	    if (prefix && !(0, _isEmpty3.default)(captions)) {
	      video.track = (0, _reduce3.default)(Object.assign.apply(Object, [{}].concat(_toConsumableArray(captions))), function (acc, caption, key) {
	        // sloppy data :/
	        if (key !== '') {
	          // ALSO SLOPPY DATA
	          var url = '/' + prefix.replace(/^en\//, '') + '/' + caption;
	          url = url.replace(/\/\//g, '/');
	          url = (0, _util.imageServer)((0, _util.envCheck)()) + url;
	          return acc.concat({
	            kind: 'captions',
	            type: 'application/ttml+xml',
	            srclang: key.toLowerCase(),
	            src: (0, _util.isLocal)() ? '/assets/config/' + caption : url
	          });
	        } else {
	          return acc;
	        }
	      }, []);
	    }
	  },
	  buildSources: function buildSources(defaultRes) {
	    var res = defaultRes || '750k';
	    this.each(function (video) {
	      if ((0, _isArray3.default)(video.source)) return;
	      var fragment = video.source;
	      video.source = [{
	        src: STREAM_CDN_HOST + '/i/delivery' + fragment + '.csmil/master.m3u8',
	        type: 'application/x-mpegURL'
	      }, {
	        src: STREAM_CDN_HOST + '/z/delivery' + fragment + '.csmil/manifest.f4m',
	        type: 'video/f4m'
	      }, {
	        src: MP4_CDN_HOST + '/delivery' + fragment.split(',')[0] + res + '.mp4',
	        type: 'video/mp4'
	      }];
	    });
	    return this;
	  },
	  getVideos: function getVideos() {
	    return this.videos;
	  },
	  getVideo: function getVideo(i) {
	    return this.videos[i];
	  },
	  each: function each(f) {
	    if (!this.isValid) {
	      console.warn('attempting to compile a video config that doesn\'t have any video resources.');
	      return;
	    }
	    this.videos.forEach(f);
	  }
	});
	
	exports.default = VideoCompiler;
	
	/* REACT HOT LOADER */ }).call(this); } finally { if (false) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("/Users/jnunez/git/medscapetv/node_modules/react-hot-loader/makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot apply hot update to " + "video_compiler.js" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }

/***/ },
/* 702 */
/***/ function(module, exports, __webpack_require__) {

	/* REACT HOT LOADER */ if (false) { (function () { var ReactHotAPI = require("/Users/jnunez/git/medscapetv/node_modules/react-hot-api/modules/index.js"), RootInstanceProvider = require("/Users/jnunez/git/medscapetv/node_modules/react-hot-loader/RootInstanceProvider.js"), ReactMount = require("react/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {
	
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _util = __webpack_require__(12);
	
	exports.default = {
	  setDurations: function setDurations() {
	    var _this = this;
	
	    this.each(function (video) {
	      if (video.duration && typeof video.duration !== 'number') {
	        video.duration = _this.secondsFromPrettyTime(video.duration);
	      }
	    });
	    return this;
	  },
	
	  /*
	   * This is a temporary measure as the image paths are coming through prefixed with a bloody `en`
	   */
	  prefixImageRefs: function prefixImageRefs() {
	    this.each(function (media) {
	      ['poster', 'watermark', 'progressPoster'].forEach(function (key) {
	        // FIXME: I REALLY dislike shoving the envCheck in here.
	        // This is only for CME and it's so that we can test locally with
	        // remote config json.
	        if (media[key]) {
	          var env = (0, _util.isLocal)() ? '.qa00' : (0, _util.envCheck)();
	          media[key] = (0, _util.imageServer)(env) + '/' + media[key].replace(/^en\//, '');
	        }
	      });
	    });
	    return this;
	  }
	};
	
	/* REACT HOT LOADER */ }).call(this); } finally { if (false) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("/Users/jnunez/git/medscapetv/node_modules/react-hot-loader/makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot apply hot update to " + "descriptor_compiler_methods.js" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }

/***/ },
/* 703 */
/***/ function(module, exports, __webpack_require__) {

	/* REACT HOT LOADER */ if (false) { (function () { var ReactHotAPI = require("/Users/jnunez/git/medscapetv/node_modules/react-hot-api/modules/index.js"), RootInstanceProvider = require("/Users/jnunez/git/medscapetv/node_modules/react-hot-loader/RootInstanceProvider.js"), ReactMount = require("react/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {
	
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _util = __webpack_require__(12);
	
	exports.default = {
	  initMedscapeGlobals: function initMedscapeGlobals() {
	    var empty = function empty() {};
	    this.initGlobal('$userId', window.s_registered_user_id, undefined);
	    this.initGlobal('$metrics', window.s_md, {});
	    this.initGlobal('$wmdPageView', window.wmdPageview, empty);
	    this.initGlobal('$wmdTrack', window.wmdTrack, empty);
	    this.initGlobal('$wmdPageLink', window.wmdPageLink, empty);
	    this.initFromMeta('ipp');
	    this.initFromMeta('cp');
	    this.initFromUrlParam('cp');
	    this.initFromUrlParam('ipp');
	  },
	  initGlobal: function initGlobal(name, globe, fallback) {
	    if (typeof globe !== 'undefined') {
	      this[name] = globe;
	    } else {
	      this[name] = fallback;
	    }
	  },
	  initFromMeta: function initFromMeta(name) {
	    var metaElement = document.querySelector('[data-' + name + ']');
	    delete this[name];
	    if (metaElement !== null) {
	      this[name] = JSON.parse(metaElement.getAttribute('data-' + name));
	    }
	  },
	  initFromUrlParam: function initFromUrlParam(name) {
	    var itsParams = (0, _util.getParams)(window.location.search);
	    if (typeof itsParams[name] !== 'undefined') {
	      delete this[name];
	      this[name] = itsParams[name];
	      console.log('init from params:' + name + ':' + itsParams[name]);
	    }
	  }
	};
	
	/* REACT HOT LOADER */ }).call(this); } finally { if (false) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("/Users/jnunez/git/medscapetv/node_modules/react-hot-loader/makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot apply hot update to " + "has_medscape_globals.js" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }

/***/ },
/* 704 */
/***/ function(module, exports, __webpack_require__) {

	/* REACT HOT LOADER */ if (false) { (function () { var ReactHotAPI = require("/Users/jnunez/git/medscapetv/node_modules/react-hot-api/modules/index.js"), RootInstanceProvider = require("/Users/jnunez/git/medscapetv/node_modules/react-hot-loader/RootInstanceProvider.js"), ReactMount = require("react/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {
	
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _video_actions = __webpack_require__(20);
	
	var _video_actions2 = _interopRequireDefault(_video_actions);
	
	var _video_store = __webpack_require__(85);
	
	var _video_store2 = _interopRequireDefault(_video_store);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  setCurrentTime: function setCurrentTime(time) {
	    if (_video_store2.default.state.isEnded) {
	      // desktop
	      _video_actions2.default.replay();
	    }
	    _video_actions2.default.setCurrentTime(time);
	  }
	};
	
	/* REACT HOT LOADER */ }).call(this); } finally { if (false) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("/Users/jnunez/git/medscapetv/node_modules/react-hot-loader/makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot apply hot update to " + "ios_video_set_current_time.js" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }

/***/ },
/* 705 */
/***/ function(module, exports, __webpack_require__) {

	/* REACT HOT LOADER */ if (false) { (function () { var ReactHotAPI = require("/Users/jnunez/git/medscapetv/node_modules/react-hot-api/modules/index.js"), RootInstanceProvider = require("/Users/jnunez/git/medscapetv/node_modules/react-hot-loader/RootInstanceProvider.js"), ReactMount = require("react/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {
	
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _defaults2 = __webpack_require__(281);
	
	var _defaults3 = _interopRequireDefault(_defaults2);
	
	var _reject2 = __webpack_require__(671);
	
	var _reject3 = _interopRequireDefault(_reject2);
	
	var _forEach2 = __webpack_require__(664);
	
	var _forEach3 = _interopRequireDefault(_forEach2);
	
	var _keys2 = __webpack_require__(40);
	
	var _keys3 = _interopRequireDefault(_keys2);
	
	var _util = __webpack_require__(12);
	
	var _screenfull = __webpack_require__(342);
	
	var _screenfull2 = _interopRequireDefault(_screenfull);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  // mappings from Video API events to the event handlers in this
	  // store.
	  mediaEvents: {
	    playing: 'onStarted',
	    canplay: 'onCanPlay',
	    pause: 'onPause',
	    ended: 'onEnded',
	    ready: 'onReady', // relying on the video api's custom ready event instead.
	    durationchange: 'onProgress',
	    timeupdate: 'onProgress',
	    seeking: 'onBuffering',
	    volumechange: 'onVolumeChanged'
	  },
	  queued: [],
	  removeMediaEvents: function removeMediaEvents() {
	    var _this = this;
	
	    (0, _keys3.default)(this.getEventMappings()).forEach(function (event) {
	      _this.mediaApi.removeEventListener(event);
	    });
	  },
	  addMediaEvents: function addMediaEvents() {
	    var _this2 = this;
	
	    (0, _forEach3.default)(this.getEventMappings(), function (handler, event) {
	      _this2.mediaApi.addEventListener(event, _this2[handler], _this2);
	      // For debugging:
	      // this.mediaApi.addEventListener(event, () => console.log('Media Event>', event));
	    });
	  },
	  getEventMappings: function getEventMappings() {
	    return (0, _defaults3.default)(this.extraMediaEvents || {}, this.mediaEvents);
	  },
	
	  // shared agnostic media events
	  onCanPlay: function onCanPlay() {
	    this.setState({
	      event: 'canplay',
	      canPlay: true,
	      isBuffering: false,
	      isLoading: false
	    });
	  },
	  onEnded: function onEnded() {
	    this.state.viewed[this.state.index] = true;
	    this.setState({
	      isPlaying: false,
	      isEnded: true,
	      event: 'ended'
	    });
	  },
	  onPause: function onPause() {
	    if (this.state.isPlaying) {
	      this.mediaApi.pause();
	      this.setState({
	        isPlaying: false,
	        event: 'paused'
	      });
	    }
	  },
	  onSeeked: function onSeeked() {
	    this.setState({
	      event: 'seeked'
	    });
	  },
	  onMute: function onMute() {
	    this.onSetVolume(0);
	  },
	  onUnmute: function onUnmute(volume) {
	    this.onSetVolume(volume);
	  },
	  keyUpHandler: function keyUpHandler(e) {
	    if ((e.keyCode ? e.keyCode : e.which) === 27) {
	      this.onExitFullScreen();
	    }
	  },
	  fsChange: function fsChange() {
	    if (!_screenfull2.default.isFullscreen) {
	      this.onExitFullScreen();
	    }
	  },
	  onFullScreen: function onFullScreen() {
	    if (!_screenfull2.default) {
	      document.querySelector('body').classList.add('fallback-fullscreen');
	    } else if (_screenfull2.default.raw) {
	      document.addEventListener(_screenfull2.default.raw.fullscreenchange, this.fsChange);
	    } else {
	      document.addEventListener('keyup', this.keyUpHandler);
	    }
	    this.setState({
	      event: 'fullScreen',
	      isFullScreen: true
	    });
	  },
	  onExitFullScreen: function onExitFullScreen() {
	    if (!_screenfull2.default) {
	      document.querySelector('body').classList.remove('fallback-fullscreen');
	    } else if (_screenfull2.default.raw) {
	      document.removeEventListener(_screenfull2.default.raw.fullscreenchange, this.fsChange);
	    } else {
	      document.removeEventListener('keyup', this.keyUpHandler);
	    }
	    this.setState({
	      event: 'exitFullScreen',
	      isFullScreen: false
	    });
	  },
	  enqueue: function enqueue(method) {
	    var last = this.queued[this.queued.length - 1];
	    if (last && last[0] === method) {
	      this.queued = (0, _reject3.default)(this.queued, function (call) {
	        return call[0] !== method;
	      });
	    }
	    this.queued.push([method, [].slice.call(arguments, 1)]);
	  },
	  dequeue: function dequeue() {
	    var _this3 = this;
	
	    this.queued.forEach(function (call) {
	      setTimeout(function () {
	        _this3[call[0]].apply(_this3, call[1]);
	      }, 500);
	    });
	    this.queued = [];
	  },
	  clearQueue: function clearQueue(method) {
	    this.queued = (0, _reject3.default)(this.queued, function (call) {
	      return call[0] === method;
	    });
	  },
	  onStart: function onStart() {
	    console.log('on Start');
	  },
	  onStarted: function onStarted() {
	    console.log('onStart');
	  },
	  mouseMoveHandler: function mouseMoveHandler(e) {
	    if ((0, _util.isDescendant)(document.getElementById('tvPlayer'), e.target)) {
	      this._clearFullScreenIdleDetection();
	      document.removeEventListener('mousemove', this.mouseMoveHandler);
	      this._setupFullScreenIdleDetection();
	    }
	  },
	  _setupFullScreenIdleDetection: function _setupFullScreenIdleDetection() {
	    var _this4 = this;
	
	    this.idleTimeoutId = setTimeout(function () {
	      _this4.setState({ isMouseIdle: true, event: 'mouseMove' });
	    }, 3000);
	    document.addEventListener('mousemove', this.mouseMoveHandler);
	  },
	  _clearFullScreenIdleDetection: function _clearFullScreenIdleDetection() {
	    clearTimeout(this.idleTimeoutId);
	    document.removeEventListener('mousemove', this.mouseMoveHandler);
	    this.setState({ isMouseIdle: false, event: 'mouseMove' });
	  },
	
	  // shared utility methods
	  isReady: function isReady() {
	    return this._isReady;
	  },
	  isPlayingOrLoading: function isPlayingOrLoading() {
	    return !this._isReady || this.state.isPlaying || this.state.isLoading || this.state.isBuffering;
	  }
	};
	
	/* REACT HOT LOADER */ }).call(this); } finally { if (false) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("/Users/jnunez/git/medscapetv/node_modules/react-hot-loader/makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot apply hot update to " + "media_store.js" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }

/***/ },
/* 706 */
/***/ function(module, exports, __webpack_require__) {

	/* REACT HOT LOADER */ if (false) { (function () { var ReactHotAPI = require("/Users/jnunez/git/medscapetv/node_modules/react-hot-api/modules/index.js"), RootInstanceProvider = require("/Users/jnunez/git/medscapetv/node_modules/react-hot-loader/RootInstanceProvider.js"), ReactMount = require("react/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {
	
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	exports.default = {
	  resizeImageTo: function resizeImageTo(path, ratio, urlType) {
	    var _ratio$split = ratio.split('x');
	
	    var _ratio$split2 = _slicedToArray(_ratio$split, 2);
	
	    var w = _ratio$split2[0];
	    var h = _ratio$split2[1];
	    var url = path + '?interpolation=lanczos-none&resize=' + w + ':' + h;
	    if (urlType === 'style') {
	      return 'url(' + url + ')';
	    } else {
	      return url;
	    }
	  }
	};
	
	/* REACT HOT LOADER */ }).call(this); } finally { if (false) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("/Users/jnunez/git/medscapetv/node_modules/react-hot-loader/makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot apply hot update to " + "resizes_images.js" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }

/***/ },
/* 707 */
/***/ function(module, exports, __webpack_require__) {

	/* REACT HOT LOADER */ if (false) { (function () { var ReactHotAPI = require("/Users/jnunez/git/medscapetv/node_modules/react-hot-api/modules/index.js"), RootInstanceProvider = require("/Users/jnunez/git/medscapetv/node_modules/react-hot-loader/RootInstanceProvider.js"), ReactMount = require("react/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {
	
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _video_store = __webpack_require__(85);
	
	var _video_store2 = _interopRequireDefault(_video_store);
	
	var _video_actions = __webpack_require__(20);
	
	var _video_actions2 = _interopRequireDefault(_video_actions);
	
	var _util = __webpack_require__(12);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  toggle: function toggle(e) {
	    if (_video_store2.default.isPlaying()) {
	      this.stop(e);
	    } else {
	      this.start(e);
	    }
	  },
	  stop: function stop(e) {
	    e.stopPropagation();
	    e.preventDefault();
	    _video_actions2.default.pause();
	  },
	  start: function start(e) {
	    e.stopPropagation();
	    e.preventDefault();
	    var media = this.state.video || this.state.audio;
	    if (media.event === 'ended') {
	      _video_actions2.default.replay();
	    } else {
	      if ((0, _util.isIOS)()) {
	        // KILL ME. This is to get around iOS horseshit.
	        // The indirection of:
	        // VideoActions.start() => VideoStore.onStart() => videoApi.play()
	        // makes it appear that the click event isn't driving the
	        // `play` call, so we have to grab the api and call it
	        // directly here.
	        media.api.play();
	      } else {
	        // VideoActions.start();
	      }
	    }
	  }
	};
	
	/* REACT HOT LOADER */ }).call(this); } finally { if (false) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("/Users/jnunez/git/medscapetv/node_modules/react-hot-loader/makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot apply hot update to " + "toggles_play.js" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }

/***/ },
/* 708 */
/***/ function(module, exports, __webpack_require__) {

	/* REACT HOT LOADER */ if (false) { (function () { var ReactHotAPI = require("/Users/jnunez/git/medscapetv/node_modules/react-hot-api/modules/index.js"), RootInstanceProvider = require("/Users/jnunez/git/medscapetv/node_modules/react-hot-loader/RootInstanceProvider.js"), ReactMount = require("react/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {
	
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _keys2 = __webpack_require__(40);
	
	var _keys3 = _interopRequireDefault(_keys2);
	
	var _assign2 = __webpack_require__(279);
	
	var _assign3 = _interopRequireDefault(_assign2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  getWBChn: function getWBChn() {
	    this.setSubDOMenv = function () {
	      var subDOMenv = void 0;
	      var pageCurrentURL = window.location.href.toLowerCase();
	      if (/qa02/i.test(pageCurrentURL)) {
	        if (/staging/i.test(pageCurrentURL)) {
	          subDOMenv = '.staging.qa02';
	        } else {
	          subDOMenv = '.qa02';
	        }
	      } else if (/qa01/i.test(pageCurrentURL)) {
	        if (/staging/i.test(pageCurrentURL)) {
	          subDOMenv = '.staging.qa01';
	        } else {
	          subDOMenv = '.qa01';
	        }
	      } else if (/qa00/i.test(pageCurrentURL)) {
	        if (/staging/i.test(pageCurrentURL)) {
	          subDOMenv = '.staging.qa00';
	        } else {
	          subDOMenv = '.qa00';
	        }
	      } else if (/proddev/i.test(pageCurrentURL)) {
	        subDOMenv = '.proddev';
	      } else if (/staging/i.test(pageCurrentURL)) {
	        subDOMenv = '.staging';
	      } else {
	        subDOMenv = '';
	      }
	      return subDOMenv;
	    };
	    var subDOMenv = this.setSubDOMenv();
	    var News = new RegExp('www' + subDOMenv + '.medscape.com|wp' + subDOMenv + '.medscape.com|search' + subDOMenv + '.medscape.com|profreg' + subDOMenv + '.medscape.com|directory' + subDOMenv + '.medscape.com');
	    var Reference = new RegExp('reference' + subDOMenv + '.medscape.com|emedicine' + subDOMenv + '.medscape.com');
	    var Education = new RegExp('www' + subDOMenv + '.medscape.org');
	    var channel = 'reference';
	    switch (true) {
	      case Reference.test(location.host):
	        channel = 'reference';
	        break;
	      case News.test(location.host):
	        channel = 'news';
	        break;
	      case Education.test(location.host):
	        channel = 'education';
	        break;
	      case location.host.match('education.webmd.com') !== null:
	      default:
	        channel = 'reference';
	        break;
	    }
	    return channel;
	  },
	  onSelectLanguage: function onSelectLanguage(language) {
	    this._metrics('lang_' + language);
	  },
	
	  /**
	   * @param action {string} - 1-based chapter index
	   */
	  onChapter: function onChapter(chapter) {
	    this._metrics('chaplist_' + chapter);
	  },
	
	  /**
	   * @param action {string} - 1-based chapter index
	   */
	  onPlayList: function onPlayList(index) {
	    var newIndex = parseInt(index, 10) + 1;
	    this._metrics('show_' + newIndex);
	  },
	
	  /**
	   * @param action {string} - one of 'prev', 'next'
	   */
	  onSlideNavigate: function onSlideNavigate(action) {
	    this._metrics('slide-pgnm_' + action);
	  },
	  onSlideZoom: function onSlideZoom(isZoomed) {
	    var direction = isZoomed ? 'in' : 'out';
	    this._metrics('slide-zoom_' + direction);
	  },
	  onSlideThumb: function onSlideThumb(isThumb) {
	    var direction = isThumb ? 'open' : 'close';
	    this._metrics('slide-thmbnl_' + direction);
	  },
	  onSlideSelect: function onSlideSelect() {
	    this._metrics('slide-thmbsel');
	  },
	  setupGlobals: function setupGlobals() {
	    // setup globals so that Metrics code doesn't shit itself
	    window.s_assetname = window.s_assetname || null;
	    window.s_pageview_id = window.s_pageview_id || null;
	    window.s_md = window.s_md || {};
	  },
	  getPlayerName: function getPlayerName(hostOverride) {
	    var hostname = hostOverride || window.location.host,
	        map = {
	      'www.medscape.com': 'mscp',
	      'www.qa00.medscape.com': 'mscp',
	      'www.qa01.medscape.com': 'mscp',
	      'www.medscape.org': 'edu',
	      'www.qa00.medscape.org': 'edu',
	      'www.qa01.medscape.org': 'edu',
	      'reference.medscape.com': 'ref',
	      'reference.qa00.medscape.com': 'ref',
	      'reference.qa01.medscape.com': 'ref',
	      'education.webmd.com': 'wbmdedu',
	      'education.qa00.webmd.com': 'wbmdedu',
	      'education.qa01.webmd.com': 'wbmdedu',
	      'localhost:8080': 'edu'
	    },
	        name = map[hostname] || 'default';
	
	    return '' + name;
	  },
	  pageLink: function pageLink(link, obj) {
	    if (typeof addLinkTrackVars === 'undefined') return;
	    addLinkTrackVars((0, _keys3.default)(obj));
	    try {
	      (0, _assign3.default)(s_md, obj);
	      wmdPageLink(link);
	    } finally {
	      remLinkTrackVars((0, _keys3.default)(obj));
	    }
	  }
	}; /* global screenfull, ADB, s_pageview_id, s_md, wmdSetContext, wmdRemContext, remLinkTrackVars, addLinkTrackVars, wmdPageLink */
	
	/* REACT HOT LOADER */ }).call(this); } finally { if (false) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("/Users/jnunez/git/medscapetv/node_modules/react-hot-loader/makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot apply hot update to " + "tracking.js" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }

/***/ },
/* 709 */
/***/ function(module, exports, __webpack_require__) {

	/* REACT HOT LOADER */ if (false) { (function () { var ReactHotAPI = require("/Users/jnunez/git/medscapetv/node_modules/react-hot-api/modules/index.js"), RootInstanceProvider = require("/Users/jnunez/git/medscapetv/node_modules/react-hot-loader/RootInstanceProvider.js"), ReactMount = require("react/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {
	
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _get2 = __webpack_require__(38);
	
	var _get3 = _interopRequireDefault(_get2);
	
	var _assign2 = __webpack_require__(279);
	
	var _assign3 = _interopRequireDefault(_assign2);
	
	var _keys2 = __webpack_require__(40);
	
	var _keys3 = _interopRequireDefault(_keys2);
	
	var _camelCase2 = __webpack_require__(660);
	
	var _camelCase3 = _interopRequireDefault(_camelCase2);
	
	var _defaults2 = __webpack_require__(281);
	
	var _defaults3 = _interopRequireDefault(_defaults2);
	
	var _VideoHeartbeatMin = __webpack_require__(348);
	
	var _VideoHeartbeatMin2 = _interopRequireDefault(_VideoHeartbeatMin);
	
	var _util = __webpack_require__(12);
	
	var _reflux = __webpack_require__(54);
	
	var _reflux2 = _interopRequireDefault(_reflux);
	
	var _has_medscape_globals = __webpack_require__(703);
	
	var _has_medscape_globals2 = _interopRequireDefault(_has_medscape_globals);
	
	var _has_pretty_time = __webpack_require__(74);
	
	var _has_pretty_time2 = _interopRequireDefault(_has_pretty_time);
	
	var _video_store = __webpack_require__(85);
	
	var _video_store2 = _interopRequireDefault(_video_store);
	
	var _tracking = __webpack_require__(708);
	
	var _tracking2 = _interopRequireDefault(_tracking);
	
	var _tracking_actions = __webpack_require__(51);
	
	var _tracking_actions2 = _interopRequireDefault(_tracking_actions);
	
	var _video_actions = __webpack_require__(20);
	
	var _video_actions2 = _interopRequireDefault(_video_actions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; } /* eslint camelcase: 0 */
	/* global screenfull, ADB, s_pageview_id, s_md, wmdSetContext, wmdRemContext, remLinkTrackVars, addLinkTrackVars, wmdPageLink */
	
	
	exports.default = _reflux2.default.createStore({
	  listenables: _tracking_actions2.default,
	  mixins: [_has_medscape_globals2.default, _has_pretty_time2.default, _tracking2.default],
	  isFirstPlay: true,
	  isWaiting: false,
	  hasStarted: false,
	  hasEnded: false,
	  init: function init() {
	    this.contextDataVars = ['contextData.a.contentType', 'contextData.a.media.name', 'contextData.a.media.playerName', 'contextData.a.media.pageName', 'contextData.a.media.friendlyName', 'contextData.a.media.length', 'contextData.a.media.channel', 'contextData.a.media.view', 'contextData.a.media.ad.name', 'contextData.a.media.ad.podFriendlyName', 'contextData.a.media.ad.length', 'contextData.a.media.ad.pod', 'contextData.a.media.ad.podPosition', 'contextData.a.media.ad.podSecond', 'contextData.a.media.ad.CPM', 'contextData.a.media.ad.view', 'contextData.a.media.extcampaign', 'contextData.wb.vpgnm', 'contextData.wb.ecd', 'contextData.wb.vdname'];
	    this.initMedscapeGlobals();
	    this.$wmdPageView(window.location.href, 1);
	    this.isCPDisabled = typeof this.cp === 'undefined' ? true : false;
	    this.isIPPDisabled = true;
	    this.$metrics.prop6 = 'video-medscapetv';
	    this.listenTo(_video_store2.default, this.onVideoChange.bind(this));
	    if (typeof wmdSetContext !== 'undefined' && typeof remLinkTrackVars !== 'undefined') {
	      wmdSetContext('wb.chn', this.getWBChn());
	      wmdSetContext('wb.contype', 'video - mtv');
	      wmdSetContext('wb.toolin', 'video - mtv');
	    }
	    this.makeIppParticipationCall();
	    window.trackingEnabled = true;
	  },
	  onRouteChange: function onRouteChange() {
	    this.$wmdPageView(window.location.href, 1);
	  },
	  makeIppParticipationCall: function makeIppParticipationCall() {
	    var event = {
	      tacticId: (0, _get3.default)(this, 'ipp.tacticId', ''),
	      activityId: (0, _get3.default)(this, 'ipp.activityId', ''),
	      appname: 'mtvevent',
	      activityName: 'participation'
	    };
	    if (typeof window.postCp !== 'undefined') {
	      window.postCp(event);
	    }
	  },
	  makeIppContentCall: function makeIppContentCall(activityName) {
	    var event = {
	      tacticId: (0, _get3.default)(this, 'ipp.tacticId', ''),
	      activityId: (0, _get3.default)(this, 'ipp.activityId', ''),
	      appname: 'mtvcontent',
	      activityName: activityName
	    };
	    if (typeof window.postCp !== 'undefined') {
	      window.postCp(event);
	    }
	  },
	  resetDurationTracking: function resetDurationTracking() {
	    var _percentages;
	
	    this.percentages = (_percentages = {}, _defineProperty(_percentages, 25, true), _defineProperty(_percentages, 50, true), _defineProperty(_percentages, 75, true), _percentages);
	  },
	  onVideoChange: function onVideoChange(state) {
	    var event = state.video.event;
	    var handler = (0, _camelCase3.default)('on_' + event);
	    if (this[handler]) {
	      this[handler](state.video);
	    }
	  },
	  onSelectVideo: function onSelectVideo(media) {
	    this.pageLink(media);
	  },
	  onSocialMedia: function onSocialMedia(media) {
	    this.pageLink(window.MedscapeTVInstance.seriesUrlFragment + '/soc_bpm' + media + '-v');
	  },
	  onSlideNavigate: function onSlideNavigate(direction) {
	    this._metrics('show_' + direction);
	  },
	  onSectionScrollView: function onSectionScrollView(section) {
	    this._metrics('module_' + section);
	  },
	
	  // small_d
	  onTranscriptOpen: function onTranscriptOpen() {
	    this._metrics('trnscrpt_open');
	  },
	  onInternalLink: function onInternalLink() {
	    this._metrics('intlink');
	  },
	  onExternalLink: function onExternalLink() {
	    this._metrics('exlink');
	  },
	  onShowMore: function onShowMore() {
	    this._metrics('more');
	  },
	  onShowLess: function onShowLess() {
	    this._metrics('less');
	  },
	  onCommentsOpen: function onCommentsOpen() {
	    this._metrics('comments_open');
	  },
	  onTranscriptClose: function onTranscriptClose() {
	    this._metrics('trnscrpt_close');
	  },
	  onCommentsClose: function onCommentsClose() {
	    this._metrics('comments_close');
	  },
	  onVideoSelected: function onVideoSelected() {
	    if (!this.isFirstPlay && this.heartbeat) {
	      if (this.heartbeat._isDestroyed !== false) {
	        if (this.analyticsPlugin) {
	          this.analyticsPlugin.setAdMetadata(null);
	          this.analyticsPlugin.setVideoMetadata(null);
	        }
	        if (this.VideoPlayerPlugin) {
	          this.VideoPlayerPlugin.trackVideoUnload();
	          this.heartbeat.destroy();
	        }
	        this.hasEnded = false;
	      }
	    }
	    this.hasStarted = false;
	    this.hasEnded = false;
	    this.isFirstPlay = false;
	  },
	  setVideoMetadata: function setVideoMetadata() {
	    var video = window.MedscapeTVInstance.videos.filter(function (inVideo) {
	      return _video_store2.default.state.meta.videoUrlFragment === inVideo.videoUrlFragment;
	    });
	    var videoIndex = typeof video[0].videoIndex !== 'undefined' ? ('0' + (parseInt(video[0].videoIndex, 10) + 1)).slice(-2) : 'Ifi';
	    var contentString = 's01e' + videoIndex;
	    this.makeIppContentCall(contentString);
	    s_md.pageName = document.location.host.replace('www.', '') + document.location.pathname;
	    s_md.eVar1 = document.location.host.replace('www.', '') + document.location.pathname;
	    s_md.pageURL = document.location.href;
	    s_md.prop7 = document.location.pathname.substring(1);
	    this.analyticsPlugin.setVideoMetadata({
	      vdname: _video_store2.default.getTitle(),
	      chn: this.getWBChn(),
	      rs: s_md.prop50 || '',
	      site: s_md.prop3,
	      topic: s_md.eVar4 || s_md.prop4 || '',
	      dprofsn: s_md.prop19 || '',
	      dspclty: s_md.prop38 || '',
	      regid: s_md.prop47 || '',
	      dcntry: s_md.prop37 || '',
	      toolin: 'video - mtv',
	      pageName: document.location.host.replace('www.', '') + document.location.pathname,
	      extcampaign: typeof s_md.contextData['wb.ecd'] !== 'undefined' ? s_md.contextData['wb.ecd'] : ''
	    });
	  },
	  onPaused: function onPaused(state) {
	    // this is getting triggered at the end of the vid.
	    if (state.duration !== state.currentTime && this.VideoPlayerPlugin) {
	      if (this.VideoPlayerPlugin._isDestroyed !== true) {
	        this.VideoPlayerPlugin.trackPause();
	      }
	    }
	  },
	  onPlay: function onPlay(state) {
	    var isStart = !this.hasStarted && !this.hasEnded,
	        autoplay = (0, _get3.default)(state, 'meta.autoplay', true);
	
	    //    console.log('hasStarted', this.hasStarted);
	    //    console.log('hasEnded', this.hasEnded);
	    //           isReplay  = !this.hasStarted && this.hasEnded,
	    //         isCompleted = this.hasStarted && this.hasEnded;
	    if (isStart) {
	      this.addHeartbeatContext();
	      this.initHeartbeat();
	      this.remHeartbeatContext();
	      this.hasStarted = true;
	      this.hasEnded = false;
	      this.remHeartbeatContext();
	      this._metrics('start', { prop9: 'allvideo_start' }, '_');
	      this.resetDurationTracking();
	      this.VideoPlayerPlugin.trackVideoLoad();
	      this.VideoPlayerPlugin.trackSessionStart();
	      if (!autoplay) {
	        this._metrics('ctl_play');
	      }
	    }
	    this.VideoPlayerPlugin.trackPlay();
	  },
	  onEnded: function onEnded() {
	    if (this.hasEnded !== true) {
	      this._metrics('100pct', { prop9: 'allvideo_100pct' }, '_');
	      if (this.chapter) {
	        this.analyticsPlugin.setChapterMetadata(null);
	        this.VideoPlayerPlugin.trackChapterComplete();
	      }
	      this.analyticsPlugin.setAdMetadata(null);
	      this.analyticsPlugin.setVideoMetadata(null);
	      this.VideoPlayerPlugin.trackComplete();
	      this.VideoPlayerPlugin.trackVideoUnload();
	      this.hasEnded = true;
	    }
	    window.trackingEnabled = false;
	  },
	  onSettingTime: function onSettingTime() {
	    this._metrics('ctl_scrb');
	  },
	  onVolumeChanged: function onVolumeChanged(state) {
	    var currentVolume = state.currentVolume;
	
	    if (this.prevVolume !== currentVolume) {
	      if (currentVolume === 0) {
	        this.isMuted = true;
	        this._metrics('ctl_mute');
	      } else if (this.isMuted) {
	        this.isMuted = false;
	        this._metrics('ctl_unmute');
	      } else {
	        this._metrics('ctl_vol');
	      }
	    }
	    this.prevVolume = currentVolume;
	  },
	  onProgress: function onProgress(state) {
	    var _this = this;
	
	    var currentTime = state.currentTime;
	    var duration = state.duration;
	    var percent = currentTime / duration * 100;
	
	    [25, 50, 75].forEach(function (i) {
	      if (percent > i && _this.percentages[i]) {
	        _this.percentages[i] = false;
	        wmdSetContext('wb.vdname', _this.videoUrlFragment);
	        addLinkTrackVars('wb.vdname');
	        _this._metrics(i + 'pct', {}, '_');
	        wmdRemContext('wb.vdname');
	        remLinkTrackVars('wb.vdname');
	      }
	    });
	    if (this.isWaiting) {
	      this.isWaiting = false;
	      this.trackBufferComplete();
	    }
	    if (percent === 100) {
	      window.trackingEnabled = false;
	    }
	  },
	  onClosedCaption: function onClosedCaption(isOpen) {
	    if (isOpen) {
	      this._metrics('ctl_ccy');
	    } else {
	      this._metrics('ctl_ccn');
	    }
	  },
	  onFullScreen: function onFullScreen() {
	    if (!this.isFullScreen) {
	      this.isFullScreen = true;
	      this._metrics('ctl_bigr');
	    }
	  },
	  onExitFullScreen: function onExitFullScreen() {
	    if (this.isFullScreen) {
	      this.isFullScreen = false;
	      this._metrics('ctl_smalr');
	    }
	  },
	  initHeartbeat: function initHeartbeat() {
	    if (typeof _VideoHeartbeatMin2.default.ADB === 'undefined' || typeof s_md === 'undefined') {
	      // eslint-disable-line
	      return;
	    }
	    // Map values to make code readable;
	    var _HBT$ADB$va = _VideoHeartbeatMin2.default.ADB.va;
	    var plugins = _HBT$ADB$va.plugins;
	    var HeartbeatDelegate = _HBT$ADB$va.HeartbeatDelegate;
	    var HeartbeatConfig = _HBT$ADB$va.HeartbeatConfig;
	    var Heartbeat = _HBT$ADB$va.Heartbeat;
	    var _plugins$aa = plugins.aa;
	    var AdobeAnalyticsPluginConfig = _plugins$aa.AdobeAnalyticsPluginConfig;
	    var AdobeAnalyticsPluginDelegate = _plugins$aa.AdobeAnalyticsPluginDelegate;
	    var AdobeAnalyticsPlugin = _plugins$aa.AdobeAnalyticsPlugin;
	    var _plugins$ah = plugins.ah;
	    var AdobeHeartbeatPluginConfig = _plugins$ah.AdobeHeartbeatPluginConfig;
	    var AdobeHeartbeatPluginDelegate = _plugins$ah.AdobeHeartbeatPluginDelegate;
	    var AdobeHeartbeatPlugin = _plugins$ah.AdobeHeartbeatPlugin;
	    var _plugins$videoplayer = plugins.videoplayer;
	    var VideoPlayerPluginConfig = _plugins$videoplayer.VideoPlayerPluginConfig;
	    var VideoPlayerPluginDelegate = _plugins$videoplayer.VideoPlayerPluginDelegate;
	    var VideoPlayerPlugin = _plugins$videoplayer.VideoPlayerPlugin;
	    var VideoInfo = _plugins$videoplayer.VideoInfo;
	    var ChapterInfo = _plugins$videoplayer.ChapterInfo;
	
	
	    var analyticsPluginConfig = new AdobeAnalyticsPluginConfig(),
	        analyticsPluginDelegate = new AdobeAnalyticsPluginDelegate(),
	        analyticsPlugin = new AdobeAnalyticsPlugin(s_md, analyticsPluginDelegate),
	        // eslint-disable-line
	
	    heartbeatPluginConfig = new AdobeHeartbeatPluginConfig('http://webmd.hb.omtrdc.net', '16AD4362526701720A490D45@AdobeOrg'),
	        heartbeatPluginDelegate = new AdobeHeartbeatPluginDelegate(),
	        heartbeatPlugin = new AdobeHeartbeatPlugin(heartbeatPluginDelegate),
	        heartbeatConfig = new HeartbeatConfig(),
	        heartbeatDelegate = new HeartbeatDelegate(),
	        videoPlayerPluginConfig = new VideoPlayerPluginConfig(),
	        videoPlayerPluginDelegate = new VideoPlayerPluginDelegate(); // VideoStore.mediaApi._v.getMediaElement()
	    this.VideoPlayerPlugin = new VideoPlayerPlugin(videoPlayerPluginDelegate);
	
	    this.analyticsPlugin = analyticsPlugin;
	    this.videoPlayerPluginDelegate = videoPlayerPluginDelegate;
	
	    analyticsPluginConfig.channel = this.$metrics.prop47;
	    heartbeatPluginConfig.sdk = 'Heartbeats V-1.5.4';
	
	    this.addHeartbeatContext();
	    analyticsPluginConfig.debugLogging = false;
	    heartbeatPluginConfig.debugLogging = false;
	    heartbeatConfig.debugLogging = false;
	    videoPlayerPluginConfig.debugLogging = false;
	    heartbeatPluginConfig.quietMode = false;
	    this.setVideoMetadata();
	    videoPlayerPluginDelegate.getVideoInfo = function () {
	      var videoUrlFragment = (0, _get3.default)(_video_store2.default, 'state.meta.videoUrlFragment', 'video' + (_video_store2.default.getIndex() + 1)),
	          info = new VideoInfo();
	      info.id = _video_store2.default.getSeriesTitle() + '/' + videoUrlFragment;
	      info.name = 'video' + (_video_store2.default.getIndex() + 1);
	      info.playerName = 'mtvVideo';
	      info.length = _video_store2.default.getDuration();
	      info.streamType = 'vod';
	      info.playhead = _video_store2.default.getCurrentTime() || 0;
	      info.friendlyName = _video_store2.default.getTitle();
	      return info;
	    };
	
	    videoPlayerPluginDelegate.getChapterInfo = function () {
	      var info = new ChapterInfo();
	      info.name = 'video ' + (_video_store2.default.getIndex() + 1);
	      info.length = _video_store2.default.getDuration();
	      info.position = _video_store2.default.getCurrentTime();
	      info.startTime = 0;
	      return info;
	    };
	
	    // configure  plugins
	    heartbeatPlugin.configure(heartbeatPluginConfig);
	    analyticsPlugin.configure(analyticsPluginConfig);
	    this.VideoPlayerPlugin.configure(videoPlayerPluginConfig);
	    this.heartbeat = new Heartbeat(heartbeatDelegate, [this.VideoPlayerPlugin, analyticsPlugin, heartbeatPlugin]);
	    this.heartbeat.configure(heartbeatConfig);
	    window.heartbeat = this.heartbeat;
	
	    if (this.isFirstPlay) {
	      this.addCtlVideoEvents();
	    }
	  },
	  addCtlVideoEvents: function addCtlVideoEvents() {
	    var _this2 = this;
	
	    window.onbeforeunload = function () {
	      _this2.VideoPlayerPlugin.trackVideoUnload();
	      _this2.VideoPlayerPlugin.destroy();
	    };
	    document.querySelector('.akamai-overlays').addEventListener('click', function () {
	      _video_actions2.default.pause();
	    });
	
	    // Not heartbeat, this is used to track pause and play of the video through omniture.
	    _video_store2.default.mediaApi._v.getMediaElement().addEventListener('pause', function () {
	      window.video = _video_store2.default.mediaApi._v.getMediaElement();
	      if ((0, _util.isMobile)()) {
	        _video_actions2.default.pause();
	      }
	      if (window.trackingEnabled) {
	        if (_video_store2.default.state.event === 'videoSelected') {
	          return;
	        }
	        _this2._metrics('ctl_pause');
	      } else {
	        window.trackingEnabled = true;
	      }
	    });
	    _video_store2.default.mediaApi._v.getMediaElement().addEventListener('webkitendfullscreen', function () {
	      _video_store2.default.mediaApi._v.getMediaElement().setAttribute('controls', '');
	    });
	    _video_store2.default.mediaApi._v.getMediaElement().addEventListener('play', function () {
	      if (window.trackingEnabled) {
	        if (_video_store2.default.state.event === 'videoSelected') {
	          return;
	        }
	        _this2._metrics('ctl_play');
	      } else {
	        window.trackingEnabled = true;
	      }
	    });
	    _video_store2.default.mediaApi._v.getMediaElement().addEventListener('click', function () {
	      if (window.trackingEnabled) {
	        if (_video_store2.default.state.event === 'videoSelected') {
	          return;
	        }
	        if (_video_store2.default.mediaApi._v.getMediaElement().paused === true) {
	          _this2._metrics('ctl_play');
	        }
	      } else {
	        window.trackingEnabled = true;
	      }
	    });
	  },
	
	  /**
	   * @param name    - the link name, to be appended to `vidcme`
	   * @param options - props to be passed through to the beacon, e.g. prop9, etc. . .
	   * @param sep     - due to inconsistencies in the tracking spec, some values are
	   *                  separated by a hyphen and others by an underscore. This is
	   *                  appears to be arbitrary.
	   */
	  _metrics: function _metrics(name) {
	    var options = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];
	    var sep = arguments.length <= 2 || arguments[2] === undefined ? '-' : arguments[2];
	
	    if (remLinkTrackVars && s_md.linkTrackVars.indexOf('a.media') !== -1) {
	      remLinkTrackVars(this.contextDataVars.toString());
	    }
	    var opts = (0, _defaults3.default)(options, { prop24: s_pageview_id || '' }),
	        link = 'vidmtv' + sep + name;
	    this.pageLink(link, opts);
	  },
	  pageLink: function pageLink(link, obj) {
	    if (typeof addLinkTrackVars === 'undefined') return;
	    addLinkTrackVars((0, _keys3.default)(obj));
	    try {
	      (0, _assign3.default)(s_md, obj);
	      wmdPageLink(link);
	    } finally {
	      remLinkTrackVars((0, _keys3.default)(obj));
	    }
	  },
	  addHeartbeatContext: function addHeartbeatContext() {
	    if (typeof addLinkTrackVars === 'undefined') {
	      return;
	    } else {
	      addLinkTrackVars(this.contextDataVars.toString());
	    }
	  },
	  remHeartbeatContext: function remHeartbeatContext() {
	    if (typeof addLinkTrackVars === 'undefined') {
	      return;
	    } else {
	      remLinkTrackVars(this.contextDataVars.toString());
	    }
	  }
	});
	
	/* REACT HOT LOADER */ }).call(this); } finally { if (false) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("/Users/jnunez/git/medscapetv/node_modules/react-hot-loader/makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot apply hot update to " + "tracking_store.js" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }

/***/ },
/* 710 */
/***/ function(module, exports, __webpack_require__) {

	/* REACT HOT LOADER */ if (false) { (function () { var ReactHotAPI = require("/Users/jnunez/git/medscapetv/node_modules/react-hot-api/modules/index.js"), RootInstanceProvider = require("/Users/jnunez/git/medscapetv/node_modules/react-hot-loader/RootInstanceProvider.js"), ReactMount = require("react/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {
	
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (pluginUrl, ampURL) {
	  return {
	    domain: 'webmd.com',
	    paths: {
	      player: ampURL,
	      resources: ampURL
	    },
	    resources: [],
	    params: {},
	    controls: { mode: 'auto' },
	    fullscreen: {
	      enabled: true,
	      native: true
	    },
	    branding: {
	      id: 'logo',
	      logo: 'http://nkalaiya.mediadev.edgesuite.net/webmd_overlay.png'
	    },
	    playoverlay: { enabled: false },
	    flash: {
	      swf: ampURL + 'AkamaiPremierPlayer.swf',
	      debug: ampURL + 'AkamaiPremierPlayer-debug.swf',
	      vars: {
	        core_ads_enabled: false,
	        auto_play_override: false
	      },
	      xml: flashConfig.replace(/\{baseSkinUrl\}/g, ampURL)
	    },
	    mediaanalytics: {
	      resources: [{
	        type: 'text/javascript',
	        src: 'http://79423.analytics.edgesuite.net/html5/akamaihtml5-min.js'
	      }],
	      plugin: {
	        swf: 'http://79423.analytics.edgesuite.net/csma/plugin/csma.swf'
	      },
	      config: 'http://ma1-r.analytics.edgesuite.net/config/beacon-3018.xml?setVideoObject=1',
	      dimensions: {
	        title: '#{media.title}',
	        playerId: '#{player.mode} Player'
	      }
	    },
	
	    locales: {
	      es: {
	        MSG_RECOMMENDATIONS_TITLE: 'Recomendado',
	        MSG_CHROMECAST_MESSAGE: 'Video playing on another screen',
	        MSG_RU: 'Ruso',
	        MSG_IT: 'Italiano',
	        MSG_FR: 'Francés',
	        MSG_DE: 'Alemán',
	        MSG_ES: 'Español',
	        MSG_EN: 'Inglés',
	        MSG_CC: 'CC',
	        MSG_VIDEO: ' vídeos',
	        MSG_VIEW_ALL: 'Ver todos ',
	        MSG_RECOMMENDED: 'Recomendado',
	        MSG_NEXT_VIDEO: 'El próximo video comienza en: ',
	        MSG_REPLAY: 'Repetir',
	        MSG_GO_LIVE: 'IR A VIVIR',
	        MSG_NOT_AVAILABLE: 'No está disponible',
	        MSG_MAX_BITRATE_AVAILABLE: 'Tasa de bits máxima disponible',
	        MSG_CURRENT_BITRATE_PLAYING: 'Tasa de bits de reproducción actual',
	        MSG_CURRENT_WORKING_BANDWIDTH: 'Ancho de banda actual de trabajo',
	        MSG_STREAM_NOT_FOUND: 'Stream que no se encuentra',
	        MSG_ERROR_PREFIX: 'Se produjo un error:',
	        MSG_DEFAULT_ERROR_MESSAGE: 'Lo sentimos, no hemos podido jugar los medios de comunicación seleccionados. Por favor, inténtelo de nuevo, o seleccionar los medios de comunicación alternativos.',
	        MSG_LIVE: 'EN VIVO',
	        MSG_SEEK_TO: 'Tratar de',
	        MSG_CURRENT: 'corriente',
	        MSG_PREVIEW: 'vista previa',
	        MSG_PAUSE: 'romper',
	        MSG_CUSTOMIZE_CLIP_POINTS: 'Personalizar el inicio y el punto final del video.',
	        MSG_BUFFERING_TEXT: 'el almacenamiento en búfer',
	        MSG_VERSION_TEXT: 'versión',
	        MSG_SHARE_CONTENT_DISABLED: 'Compartir e incrustar están desactivados.',
	        MSG_SHARE_CONNECT_FAILURE: 'No se puede conectar. Por favor, inténtelo de nuevo.',
	        MSG_LINK_TEXT: 'enlace',
	        MSG_EMBED_TEXT: 'incrustar',
	        MSG_POST_TEXT: 'enviar',
	        MSG_SHARE_VIDEO_TEXT: 'Comparte este vídeo...',
	        MSG_EMAIL_SEND_SUCCESS_MESSAGE: 'Tu email ha sido enviado!',
	        MSG_EMAIL_SEND_FAILURE: 'El mensaje no pudo ser enviado.',
	        MSG_EMAIL_CHARACTERS_REMAINING_TEXT: 'personajes de la izquierda',
	        MSG_EMAIL_MESSAGE_INVALID: 'Por favor limite su mensaje a 500 caracteres o menos.',
	        MSG_EMAIL_ADDRESS_INVALID: 'Dirección de correo electrónico no válida',
	        MSG_EMAIL_MESSAGE: 'mensaje',
	        MSG_EMAIL_MESSAGE_DEFAULT: 'Echa un vistazo a este video de xxx',
	        MSG_EMAIL_VIDEO: 'Enviar este vídeo',
	        MSG_EMAIL_FROM: 'de',
	        MSG_EMAIL_TO: 'a'
	      },
	      en: {
	        MSG_RECOMMENDATIONS_TITLE: 'Recommended',
	        MSG_CHROMECAST_MESSAGE: 'Video playing on another screen',
	        MSG_RU: 'Russian',
	        MSG_IT: 'Italian',
	        MSG_FR: 'French',
	        MSG_DE: 'German',
	        MSG_ES: 'Spanish',
	        MSG_EN: 'English',
	        MSG_CC_APPLY: 'Apply',
	        MSG_CC_CANCEL: 'Cancel',
	        MSG_CC_RESET: 'Default',
	        MSG_CC_HIDE_ADVANCED: 'Hide Advanced Settings',
	        MSG_CC_SHOW_ADVANCED: 'Show Advanced Settings',
	        MSG_CC_OPACITY: 'Opacity :',
	        MSG_CC_WINDOW: 'Window :',
	        MSG_CC_BACKGROUND: 'Background :',
	        MSG_CC_COLOR: 'Color :',
	        MSG_CC_SCROLL: 'Scroll :',
	        MSG_CC_SIZE: 'Size :',
	        MSG_CC_EDGE: 'Edge :',
	        MSG_CC_FONT: 'Font :',
	        MSG_CC_PRESETS: 'Presets :',
	        MSG_CC_LANGUAGE: 'Track :',
	        MSG_CC_TITLE: 'Captions',
	        MSG_CC: 'CC',
	        MSG_VIDEO: ' videos',
	        MSG_VIEW_ALL: 'View all ',
	        MSG_RECOMMENDED: 'Recommended',
	        MSG_NEXT_VIDEO: 'Next video starts in: ',
	        MSG_REPLAY: 'Replay',
	        MSG_GO_LIVE: 'GO LIVE',
	        MSG_NOT_AVAILABLE: 'Not Available',
	        MSG_MAX_BITRATE_AVAILABLE: 'Max bitrate available',
	        MSG_CURRENT_BITRATE_PLAYING: 'Current bitrate playing',
	        MSG_CURRENT_WORKING_BANDWIDTH: 'Current working bandwidth',
	        MSG_STREAM_NOT_FOUND: 'Stream not found',
	        MSG_ERROR_PREFIX: 'Error encountered:',
	        MSG_DEFAULT_ERROR_MESSAGE: 'Sorry, we were unable to play the media you selected. Please try again, or select alternate media.',
	        MSG_LIVE: 'LIVE',
	        MSG_SEEK_TO: 'Seek to',
	        MSG_CURRENT: 'Currrent',
	        MSG_PREVIEW: 'Preview',
	        MSG_PAUSE: 'Pause',
	        MSG_CUSTOMIZE_CLIP_POINTS: 'Customize the start and end point of the video.',
	        MSG_BUFFERING_TEXT: 'buffering',
	        MSG_VERSION_TEXT: 'Version',
	        MSG_SHARE_CONTENT_DISABLED: 'Share and embed are disabled.',
	        MSG_SHARE_CONNECT_FAILURE: 'Unable to connect. Please try again.',
	        MSG_LINK_TEXT: 'Link',
	        MSG_EMBED_TEXT: 'Embed',
	        MSG_POST_TEXT: 'Post',
	        MSG_SHARE_VIDEO_TEXT: 'Share this video...',
	        MSG_EMAIL_SEND_SUCCESS_MESSAGE: 'Your email has been sent!',
	        MSG_EMAIL_SEND_FAILURE: 'Message could not be sent.',
	        MSG_EMAIL_CHARACTERS_REMAINING_TEXT: ' characters left',
	        MSG_EMAIL_MESSAGE_INVALID: 'Please limit your message to 500 characters or less.',
	        MSG_EMAIL_ADDRESS_INVALID: 'Invalid Email Address',
	        MSG_EMAIL_MESSAGE: 'Message',
	        MSG_EMAIL_MESSAGE_DEFAULT: 'Check out this video from xxx',
	        MSG_EMAIL_VIDEO: 'Email this video',
	        MSG_EMAIL_FROM: 'From',
	        MSG_EMAIL_TO: 'To'
	      }
	    }
	  };
	};
	
	var flashConfig = __webpack_require__(681);
	
	/* REACT HOT LOADER */ }).call(this); } finally { if (false) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("/Users/jnunez/git/medscapetv/node_modules/react-hot-loader/makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot apply hot update to " + "config.js" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }

/***/ },
/* 711 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* REACT HOT LOADER */ if (false) { (function () { var ReactHotAPI = require("/Users/jnunez/git/medscapetv/node_modules/react-hot-api/modules/index.js"), RootInstanceProvider = require("/Users/jnunez/git/medscapetv/node_modules/react-hot-loader/RootInstanceProvider.js"), ReactMount = require("react/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {
	
	'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; };
	
	/* global jQuery, akamai */
	/* eslint no-shadow:0 */
	/* eslint vars-on-top: 0 */
	/* eslint no-var: 0 */
	/* eslint consistent-return:0 */
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(817), __webpack_require__(20)], __WEBPACK_AMD_DEFINE_RESULT__ = function (AkamaiCore, VideoActions) {
	  function WebmdVideo(id, config) {
	    var self = this,
	        mode = 'auto',
	        isMobile = self.isMobile();
	    this._v = null;
	    this._t = null;
	    this._id = id;
	    this._isLoaded = false;
	    this._isMuted = false;
	    this._cbs = [];
	    this.adPlaying = false;
	    this.setEvents = {};
	
	    this._config = jQuery.extend({
	      autoplay: false,
	      media: {
	        autoplay: false,
	        mode: mode
	      },
	      controls: {
	        mode: isMobile ? 'auto' : 'none'
	      },
	      hls: {
	        quality: {
	          startLevel: 0
	        },
	        data: {
	          enableWorker: true,
	          enableSoftwareAES: true,
	          debug: false
	        }
	      },
	      captioning: {
	        enabled: true
	      },
	      mode: mode
	    }, config);
	  }
	
	  WebmdVideo.prototype.init = function (cb) {
	    var self = this,
	        isFF = window.mozInnerScreenX !== null,
	        isIE = window.navigator.userAgent.indexOf('MSIE ') > 0 || !!window.navigator.userAgent.match(/Trident.*rv\:11\./),
	        imgSvrPath = window.image_server_url || '//img.preview.webmd.com/dtmcms/preview',
	
	    //  basePluginUrl = window.location.host.indexOf('localhost') > -1
	    //                  ? '/resources/plugins/'
	    //                  : imgSvrPath + '/webmd/consumer_assets/site_images/amd_modules/video2/1/lib/',
	    baseSkinUrl = window.location.host.indexOf('localhost') > -1 ? '/amp/' : imgSvrPath + '/webmd/consumer_assets/site_images/amd_modules/video2/1/lib/';
	    var coreConfig = self._config;
	    coreConfig.flash.vars.auto_play_override = self._config.autoplay || false;
	
	    if (typeof coreConfig.flash !== 'undefined' && typeof coreConfig.flash.view !== 'undefined' && typeof coreConfig.flash.view.attributes !== 'undefined') {
	      coreConfig.flash.view.attributes.skin = coreConfig.flash.view.attributes.skin.replace('{baseSkinUrl}', baseSkinUrl);
	    }
	
	    coreConfig = jQuery.extend(true, coreConfig, self._config);
	
	    if (isFF === true || isIE === true) {
	      coreConfig.flash.params = {
	        'wmode': 'transparent'
	      };
	    }
	
	    self._v = akamai.amp.AMP.create(self._id, coreConfig, function () {
	      if (cb) {
	        cb();
	      }
	
	      self._cbs.forEach(function (cb) {
	        cb();
	      });
	      self._isLoaded = true;
	    });
	  };
	
	  WebmdVideo.prototype.ready = function (cb) {
	    var self = this;
	
	    if (self._isLoaded) {
	      cb();
	      return;
	    }
	
	    this._cbs.push(cb);
	  };
	
	  WebmdVideo.prototype.pause = function () {
	    this._v.pause();
	  };
	
	  WebmdVideo.prototype.destroy = function () {
	    document.getElementById(this._id).innerHTML = '';
	    if (this._v !== null) {
	      this._v.destroy();
	    }
	    this._v = null;
	  };
	
	  WebmdVideo.prototype.play = function () {
	    this._v.play();
	  };
	
	  WebmdVideo.prototype.replay = function () {
	    this._v.replay();
	  };
	
	  WebmdVideo.prototype.setVolume = function (inVolume) {
	    var itsVolume = inVolume > 1 ? parseFloat(inVolume) / 100 : inVolume;
	    this._v.setVolume(itsVolume);
	  };
	
	  WebmdVideo.prototype.setCurrentTime = function (t) {
	    this._v.setCurrentTime(t);
	  };
	
	  WebmdVideo.prototype.setMedia = function (json) {
	    this._v.setMedia(json);
	  };
	
	  WebmdVideo.prototype.setClosedCaption = function (b) {
	    if (typeof this._v.captioning !== 'undefined') {
	      this._v.captioning.setHidden(b);
	    } else {
	      console.log('error', 'The closed captioning feature is disabled, please enable it before turning it on!');
	    }
	  };
	
	  WebmdVideo.prototype.turnClosedCaptionOn = function () {
	    this.setClosedCaption(false);
	  };
	
	  WebmdVideo.prototype.turnClosedCaptionOff = function () {
	    this.setClosedCaption(true);
	  };
	
	  WebmdVideo.prototype.enterFullScreen = function () {
	    this._v.enterFullScreen();
	  };
	
	  WebmdVideo.prototype.exitFullScreen = function () {
	    this._v.exitFullScreen();
	  };
	
	  WebmdVideo.prototype.mute = function () {
	    this.setMuted(true);
	  };
	
	  WebmdVideo.prototype.unmute = function () {
	    this.setMuted(false);
	  };
	
	  WebmdVideo.prototype.setMuted = function (bool) {
	    this._v.setMuted(bool);
	  };
	
	  WebmdVideo.prototype.setCaptionLanguage = function (lan, captionOn) {
	    var config = this.getConfig();
	    if (typeof config.media === 'undefined') {
	      console.log('error', 'There is no media definition in your config');
	      return;
	    }
	    if (typeof config.media.track === 'undefined') {
	      console.log('error', 'There is no track definition in your media config');
	      return;
	    }
	    for (var i in config.media.track) {
	      if (typeof config.media.track[i] !== 'undefined' && config.media.track[i].srclang === lan) {
	        this._v.captioning.selectTrackByLanguage(lan);
	        if (captionOn) {
	          this.turnClosedCaptionOn();
	        }
	        return true;
	      }
	    }
	    // TODO throw error
	    console.log('error', 'Could not find the language ' + lan + ' in your media track definition');
	    return false;
	  };
	
	  WebmdVideo.prototype.end = function () {
	    this._v.end();
	  };
	
	  WebmdVideo.prototype.getClosedCaption = function () {
	    return this._v !== null ? !this._v.captioning.getHidden() : null;
	  };
	
	  WebmdVideo.prototype.getVolume = function () {
	    return this._v !== null ? this._v.getVolume() : 0;
	  };
	
	  WebmdVideo.prototype.getCurrentTime = function () {
	    return this._v !== null ? this._v.getCurrentTime() : 0;
	  };
	
	  WebmdVideo.prototype.getDuration = function () {
	    if (this.isMobile() && document.getElementById(this._id).getElementsByTagName('video').length > 0) {
	      return document.getElementById(this._id).getElementsByTagName('video')[0].duration > 9999999 ? 0 : document.getElementById(this._id).getElementsByTagName('video')[0].duration;
	    }
	    return this._v !== null ? this._v.getDuration() : 0;
	  };
	
	  WebmdVideo.prototype.getMedia = function () {
	    return this._v !== null ? this._v.getMedia() : 0;
	  };
	
	  WebmdVideo.prototype.getConfig = function () {
	    return this._config;
	  };
	
	  WebmdVideo.prototype.getAds = function () {
	    if (this._v !== null) {
	      return this._v.ads || null;
	    }
	    return null;
	  };
	
	  WebmdVideo.prototype.getId = function () {
	    return this._id;
	  };
	
	  WebmdVideo.prototype.isMobile = function () {
	    return (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)
	    );
	  };
	
	  WebmdVideo.prototype.isIpad = function () {
	    return (/iPad/i.test(navigator.userAgent)
	    );
	  };
	
	  WebmdVideo.prototype.isSmartPhone = function () {
	    var userAgentStr = navigator.userAgent,
	        isAndroidPhone,
	        isOtherPhones;
	    isAndroidPhone = userAgentStr.indexOf('Android') > -1 && userAgentStr.indexOf('Mobile') > -1;
	    isOtherPhones = /iPhone|iPod|BlackBerry|IEMobile/i.test(userAgentStr);
	    return isAndroidPhone === true || isOtherPhones === true;
	  };
	
	  WebmdVideo.prototype.isAutoplay = function () {
	    if (this.getConfig().autoplay || this.getConfig().media.autoplay) {
	      return true;
	    }
	    return false;
	  };
	
	  WebmdVideo.prototype.getTitle = function () {
	    return this.getConfig().title || null;
	  };
	
	  WebmdVideo.prototype.getPlayerType = function () {
	    var type = this._v.getPlayerType() || null;
	    if (type === null) {
	      if (this._config.mode === 'auto') {
	        type = 'flash';
	      } else {
	        type = this._config.mode;
	      }
	    }
	    return type;
	  };
	
	  WebmdVideo.prototype.addEventListener = function (e, f) {
	    var self = this,
	        $v = jQuery(self._v),
	        eventName = e.toString().split('.')[0];
	
	    if (typeof this.setEvents[eventName] === 'undefined') {
	      this.setEvents[eventName] = true;
	
	      switch (eventName) {
	        case 'volumechange':
	        case 'mute':
	        case 'unmute':
	          $v.on('volumechange', function (e) {
	            if (typeof e.detail === 'undefined' && typeof e.originalEvent.detail !== 'undefined') {
	              e.detail = e.originalEvent.detail;
	            }
	
	            // horrible, horrible workaround for html5 version of volume control not matching flash
	            if (_typeof(e.detail) !== 'object' && (typeof e.detail === 'number' || typeof e.detail === 'string')) {
	              var tmp = e.detail;
	              e.detail = {};
	              e.detail.currentVolume = tmp;
	            } else if (_typeof(e.detail) === 'object' && typeof e.detail.currentVolume === 'undefined') {
	              e.detail.currentVolume = 0;
	            }
	
	            jQuery(document.getElementById(self._id)).trigger('volumechange', { detail: e });
	
	            if (e.detail && e.detail.currentVolume <= 0) {
	              jQuery(document.getElementById(self._id)).trigger('mute', { detail: e });
	              self._isMuted = true;
	            } else if (self._isMuted === true && e.detail && e.detail.currentVolume > 0) {
	              jQuery(document.getElementById(self._id)).trigger('unmute', { detail: e });
	              self._isMuted = false;
	            }
	          });
	
	          this.setEvents.volumechange = true;
	          this.setEvents.mute = true;
	          this.setEvents.unmute = true;
	          break;
	
	        case 'play':
	          if (self.isMobile()) {
	            // playing
	            $v.on('playing', function (e) {
	              var $video;
	
	              if (self.isMobile() && self.isIpad()) {
	                $video = jQuery(document.getElementById(self._id)).find('video');
	
	                if ($video.length > 0) {
	                  $video.css({ '-webkit-transform': 'none' });
	                  jQuery(document.getElementById(self._id).parentNode.parentNode).find('.akamai-play').css({ display: 'none' });
	                }
	              }
	
	              jQuery(document.getElementById(self._id)).trigger('play', { detail: e });
	
	              if (self.adPlaying) {
	                jQuery(document.getElementById(self._id)).trigger('ad-play', { detail: e });
	              }
	            });
	          } else {
	            $v.on('playing', function (e) {
	              var $video;
	              if (self.isMobile() && self.isIpad()) {
	                $video = jQuery(document.getElementById(self._id)).find('video');
	
	                if ($video.length > 0) {
	                  $video.css({ '-webkit-transform': 'none' });
	                  jQuery(document.getElementById(self._id).parentNode.parentNode).find('.akamai-play').css({ display: 'none' });
	                }
	              }
	
	              jQuery(document.getElementById(self._id)).trigger('play', { detail: e });
	
	              if (self.adPlaying) {
	                jQuery(document.getElementById(self._id)).trigger('ad-play', { detail: e });
	              }
	            });
	          }
	          break;
	
	        case 'pause':
	          if (self.isMobile()) {
	            $v.on('pause', function (e) {
	              VideoActions.pause();
	              if (self.adPlaying) {
	                jQuery(document.getElementById(self._id)).trigger('ad-pause', { detail: e });
	              }
	            });
	          } else {
	            $v.on('pause', function (e) {
	              VideoActions.pause();
	              if (self.adPlaying) {
	                jQuery(document.getElementById(self._id)).trigger('ad-pause', { detail: e });
	              }
	            });
	          }
	          break;
	
	        case 'ended':
	          $v.on('ended', function (e) {
	            jQuery(document.getElementById(self._id)).trigger('ended', { detail: e });
	          });
	          break;
	
	        case 'visibilitychange':
	        case 'closedcaption-off':
	        case 'closedcaption-on':
	          if (typeof self._v.captioning !== 'undefined') {
	            jQuery(self._v.captioning).on('visibilitychange', function (e) {
	              jQuery(document.getElementById(self._id)).trigger('visibilitychange', { detail: e });
	
	              if (typeof e.originalEvent.detail !== 'undefined' && e.originalEvent.detail === true) {
	                jQuery(document.getElementById(self._id)).trigger('closedcaption-on', { detail: e });
	              } else {
	                jQuery(document.getElementById(self._id)).trigger('closedcaption-off', { detail: e });
	              }
	            });
	          }
	
	          this.setEvents.visibilitychange = true;
	          this.setEvents['closedcaption-off'] = true;
	          this.setEvents['closedcaption-on'] = true;
	
	          break;
	
	        case 'ad-started':
	          self.ready(function () {
	            if (typeof self._v.ads !== 'undefined') {
	              jQuery(self._v.ads).on('started', function (e) {
	                self.adPlaying = true;
	                jQuery(document.getElementById(self._id)).trigger('ad-started', { detail: e });
	              });
	            }
	          });
	          break;
	
	        case 'ad-ended':
	          self.ready(function () {
	            if (typeof self._v.ads !== 'undefined') {
	              jQuery(self._v.ads).on('breakend', function (e) {
	                self.adPlaying = false;
	                jQuery(document.getElementById(self._id)).trigger('ad-ended', { detail: e });
	              });
	            }
	          });
	          break;
	
	        case 'ad-request':
	          self.ready(function () {
	            if (typeof self._v.ads !== 'undefined') {
	              jQuery(self._v.ads).on('request', function (e) {
	                jQuery(document.getElementById(self._id)).trigger('ad-request', { detail: e });
	              });
	            }
	          });
	          break;
	
	        case 'ad-error':
	          self.ready(function () {
	            if (typeof self._v.ads !== 'undefined') {
	              jQuery(self._v.ads).on('error', function (e) {
	                jQuery(document.getElementById(self._id)).trigger('ad-error', { detail: e });
	              });
	            }
	          });
	          break;
	
	        case 'ad-loaded':
	          self.ready(function () {
	            if (typeof self._v.ads !== 'undefined') {
	              jQuery(self._v.ads).on('loaded', function (e) {
	                jQuery(document.getElementById(self._id)).trigger('ad-loaded', { detail: e });
	              });
	            }
	          });
	          break;
	        case 'companion':
	          self.ready(function () {
	            if (typeof self._v.ads !== 'undefined') {
	              jQuery(self._v.ads).on('companion', function (e) {
	                jQuery(document.getElementById(self._id)).trigger('ad-companion', { detail: e });
	              });
	            }
	          });
	          break;
	        case 'offline':
	          jQuery(window).on('offline', function (e) {
	            jQuery(document.getElementById(self._id)).trigger('offline', { detail: e });
	          });
	          break;
	        default:
	          $v.on(eventName, function (e) {
	            jQuery(document.getElementById(self._id)).trigger(eventName, { detail: e });
	          });
	          break;
	      }
	    }
	    jQuery(document.getElementById(this._id)).on(e, f);
	  };
	
	  WebmdVideo.prototype.triggerEvent = function (e) {
	    jQuery(document.getElementById(this._id)).trigger(e);
	  };
	  WebmdVideo.prototype.removeEventListener = function (e) {
	    jQuery(document.getElementById(this._id)).off(e);
	  };
	  return WebmdVideo;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	
	/* REACT HOT LOADER */ }).call(this); } finally { if (false) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("/Users/jnunez/git/medscapetv/node_modules/react-hot-loader/makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot apply hot update to " + "video-api.js" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }

/***/ },
/* 712 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {/* REACT HOT LOADER */ if (false) { (function () { var ReactHotAPI = require("/Users/jnunez/git/medscapetv/node_modules/react-hot-api/modules/index.js"), RootInstanceProvider = require("/Users/jnunez/git/medscapetv/node_modules/react-hot-loader/RootInstanceProvider.js"), ReactMount = require("react/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {
	
	"use strict";
	
	module.exports = global["Player"] = __webpack_require__(349);
	
	/* REACT HOT LOADER */ }).call(this); } finally { if (false) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("/Users/jnunez/git/medscapetv/node_modules/react-hot-loader/makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot apply hot update to " + "video_player.js" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 713 */
/***/ function(module, exports, __webpack_require__) {

	var canUseDOM = __webpack_require__(533);
	var enquire = canUseDOM && __webpack_require__(537);
	var json2mq = __webpack_require__(251);
	
	var ResponsiveMixin = {
	  media: function (query, handler) {
	    query = json2mq(query);
	    if (typeof handler === 'function') {
	      handler = {
	        match: handler
	      };
	    }
	    canUseDOM && enquire.register(query, handler);
	
	    // Queue the handlers to unregister them at unmount  
	    if (! this._responsiveMediaHandlers) {
	      this._responsiveMediaHandlers = [];
	    }
	    this._responsiveMediaHandlers.push({query: query, handler: handler});
	  },
	  componentWillUnmount: function () {
	    if (this._responsiveMediaHandlers) {
	      this._responsiveMediaHandlers.forEach(function(obj) {
	        canUseDOM && enquire.unregister(obj.query, obj.handler);
	      });
	    }
	  }
	};
	
	module.exports = ResponsiveMixin;


/***/ },
/* 714 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Link = __webpack_require__(299);
	
	var _Link2 = _interopRequireDefault(_Link);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * An <IndexLink> is used to link to an <IndexRoute>.
	 */
	var IndexLink = _react2.default.createClass({
	  displayName: 'IndexLink',
	  render: function render() {
	    return _react2.default.createElement(_Link2.default, _extends({}, this.props, { onlyActiveOnIndex: true }));
	  }
	});
	
	exports.default = IndexLink;
	module.exports = exports['default'];

/***/ },
/* 715 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _routerWarning = __webpack_require__(88);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	var _invariant = __webpack_require__(23);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _Redirect = __webpack_require__(301);
	
	var _Redirect2 = _interopRequireDefault(_Redirect);
	
	var _InternalPropTypes = __webpack_require__(98);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _React$PropTypes = _react2.default.PropTypes,
	    string = _React$PropTypes.string,
	    object = _React$PropTypes.object;
	
	/**
	 * An <IndexRedirect> is used to redirect from an indexRoute.
	 */
	/* eslint-disable react/require-render-return */
	
	var IndexRedirect = _react2.default.createClass({
	  displayName: 'IndexRedirect',
	
	
	  statics: {
	    createRouteFromReactElement: function createRouteFromReactElement(element, parentRoute) {
	      /* istanbul ignore else: sanity check */
	      if (parentRoute) {
	        parentRoute.indexRoute = _Redirect2.default.createRouteFromReactElement(element);
	      } else {
	         false ? (0, _routerWarning2.default)(false, 'An <IndexRedirect> does not make sense at the root of your route config') : void 0;
	      }
	    }
	  },
	
	  propTypes: {
	    to: string.isRequired,
	    query: object,
	    state: object,
	    onEnter: _InternalPropTypes.falsy,
	    children: _InternalPropTypes.falsy
	  },
	
	  /* istanbul ignore next: sanity check */
	  render: function render() {
	     true ?  false ? (0, _invariant2.default)(false, '<IndexRedirect> elements are for router configuration only and should not be rendered') : (0, _invariant2.default)(false) : void 0;
	  }
	});
	
	exports.default = IndexRedirect;
	module.exports = exports['default'];

/***/ },
/* 716 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _routerWarning = __webpack_require__(88);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	var _invariant = __webpack_require__(23);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _RouteUtils = __webpack_require__(61);
	
	var _InternalPropTypes = __webpack_require__(98);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var func = _react2.default.PropTypes.func;
	
	/**
	 * An <IndexRoute> is used to specify its parent's <Route indexRoute> in
	 * a JSX route config.
	 */
	/* eslint-disable react/require-render-return */
	
	var IndexRoute = _react2.default.createClass({
	  displayName: 'IndexRoute',
	
	
	  statics: {
	    createRouteFromReactElement: function createRouteFromReactElement(element, parentRoute) {
	      /* istanbul ignore else: sanity check */
	      if (parentRoute) {
	        parentRoute.indexRoute = (0, _RouteUtils.createRouteFromReactElement)(element);
	      } else {
	         false ? (0, _routerWarning2.default)(false, 'An <IndexRoute> does not make sense at the root of your route config') : void 0;
	      }
	    }
	  },
	
	  propTypes: {
	    path: _InternalPropTypes.falsy,
	    component: _InternalPropTypes.component,
	    components: _InternalPropTypes.components,
	    getComponent: func,
	    getComponents: func
	  },
	
	  /* istanbul ignore next: sanity check */
	  render: function render() {
	     true ?  false ? (0, _invariant2.default)(false, '<IndexRoute> elements are for router configuration only and should not be rendered') : (0, _invariant2.default)(false) : void 0;
	  }
	});
	
	exports.default = IndexRoute;
	module.exports = exports['default'];

/***/ },
/* 717 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _invariant = __webpack_require__(23);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _RouteUtils = __webpack_require__(61);
	
	var _InternalPropTypes = __webpack_require__(98);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _React$PropTypes = _react2.default.PropTypes,
	    string = _React$PropTypes.string,
	    func = _React$PropTypes.func;
	
	/**
	 * A <Route> is used to declare which components are rendered to the
	 * page when the URL matches a given pattern.
	 *
	 * Routes are arranged in a nested tree structure. When a new URL is
	 * requested, the tree is searched depth-first to find a route whose
	 * path matches the URL.  When one is found, all routes in the tree
	 * that lead to it are considered "active" and their components are
	 * rendered into the DOM, nested in the same order as in the tree.
	 */
	/* eslint-disable react/require-render-return */
	
	var Route = _react2.default.createClass({
	  displayName: 'Route',
	
	
	  statics: {
	    createRouteFromReactElement: _RouteUtils.createRouteFromReactElement
	  },
	
	  propTypes: {
	    path: string,
	    component: _InternalPropTypes.component,
	    components: _InternalPropTypes.components,
	    getComponent: func,
	    getComponents: func
	  },
	
	  /* istanbul ignore next: sanity check */
	  render: function render() {
	     true ?  false ? (0, _invariant2.default)(false, '<Route> elements are for router configuration only and should not be rendered') : (0, _invariant2.default)(false) : void 0;
	  }
	});
	
	exports.default = Route;
	module.exports = exports['default'];

/***/ },
/* 718 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _invariant = __webpack_require__(23);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _createTransitionManager2 = __webpack_require__(305);
	
	var _createTransitionManager3 = _interopRequireDefault(_createTransitionManager2);
	
	var _InternalPropTypes = __webpack_require__(98);
	
	var _RouterContext = __webpack_require__(195);
	
	var _RouterContext2 = _interopRequireDefault(_RouterContext);
	
	var _RouteUtils = __webpack_require__(61);
	
	var _RouterUtils = __webpack_require__(302);
	
	var _routerWarning = __webpack_require__(88);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var _React$PropTypes = _react2.default.PropTypes,
	    func = _React$PropTypes.func,
	    object = _React$PropTypes.object;
	
	/**
	 * A <Router> is a high-level API for automatically setting up
	 * a router that renders a <RouterContext> with all the props
	 * it needs each time the URL changes.
	 */
	
	var Router = _react2.default.createClass({
	  displayName: 'Router',
	
	
	  propTypes: {
	    history: object,
	    children: _InternalPropTypes.routes,
	    routes: _InternalPropTypes.routes, // alias for children
	    render: func,
	    createElement: func,
	    onError: func,
	    onUpdate: func,
	
	    // PRIVATE: For client-side rehydration of server match.
	    matchContext: object
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      render: function render(props) {
	        return _react2.default.createElement(_RouterContext2.default, props);
	      }
	    };
	  },
	  getInitialState: function getInitialState() {
	    return {
	      location: null,
	      routes: null,
	      params: null,
	      components: null
	    };
	  },
	  handleError: function handleError(error) {
	    if (this.props.onError) {
	      this.props.onError.call(this, error);
	    } else {
	      // Throw errors by default so we don't silently swallow them!
	      throw error; // This error probably occurred in getChildRoutes or getComponents.
	    }
	  },
	  createRouterObject: function createRouterObject(state) {
	    var matchContext = this.props.matchContext;
	
	    if (matchContext) {
	      return matchContext.router;
	    }
	
	    var history = this.props.history;
	
	    return (0, _RouterUtils.createRouterObject)(history, this.transitionManager, state);
	  },
	  createTransitionManager: function createTransitionManager() {
	    var matchContext = this.props.matchContext;
	
	    if (matchContext) {
	      return matchContext.transitionManager;
	    }
	
	    var history = this.props.history;
	    var _props = this.props,
	        routes = _props.routes,
	        children = _props.children;
	
	
	    !history.getCurrentLocation ?  false ? (0, _invariant2.default)(false, 'You have provided a history object created with history v2.x or ' + 'earlier. This version of React Router is only compatible with v3 ' + 'history objects. Please upgrade to history v3.x.') : (0, _invariant2.default)(false) : void 0;
	
	    return (0, _createTransitionManager3.default)(history, (0, _RouteUtils.createRoutes)(routes || children));
	  },
	  componentWillMount: function componentWillMount() {
	    var _this = this;
	
	    this.transitionManager = this.createTransitionManager();
	    this.router = this.createRouterObject(this.state);
	
	    this._unlisten = this.transitionManager.listen(function (error, state) {
	      if (error) {
	        _this.handleError(error);
	      } else {
	        // Keep the identity of this.router because of a caveat in ContextUtils:
	        // they only work if the object identity is preserved.
	        (0, _RouterUtils.assignRouterState)(_this.router, state);
	        _this.setState(state, _this.props.onUpdate);
	      }
	    });
	  },
	
	
	  /* istanbul ignore next: sanity check */
	  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
	     false ? (0, _routerWarning2.default)(nextProps.history === this.props.history, 'You cannot change <Router history>; it will be ignored') : void 0;
	
	     false ? (0, _routerWarning2.default)((nextProps.routes || nextProps.children) === (this.props.routes || this.props.children), 'You cannot change <Router routes>; it will be ignored') : void 0;
	  },
	  componentWillUnmount: function componentWillUnmount() {
	    if (this._unlisten) this._unlisten();
	  },
	  render: function render() {
	    var _state = this.state,
	        location = _state.location,
	        routes = _state.routes,
	        params = _state.params,
	        components = _state.components;
	
	    var _props2 = this.props,
	        createElement = _props2.createElement,
	        render = _props2.render,
	        props = _objectWithoutProperties(_props2, ['createElement', 'render']);
	
	    if (location == null) return null; // Async match
	
	    // Only forward non-Router-specific props to routing context, as those are
	    // the only ones that might be custom routing context props.
	    Object.keys(Router.propTypes).forEach(function (propType) {
	      return delete props[propType];
	    });
	
	    return render(_extends({}, props, {
	      router: this.router,
	      location: location,
	      routes: routes,
	      params: params,
	      components: components,
	      createElement: createElement
	    }));
	  }
	});
	
	exports.default = Router;
	module.exports = exports['default'];

/***/ },
/* 719 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.runEnterHooks = runEnterHooks;
	exports.runChangeHooks = runChangeHooks;
	exports.runLeaveHooks = runLeaveHooks;
	
	var _AsyncUtils = __webpack_require__(192);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var PendingHooks = function PendingHooks() {
	  var _this = this;
	
	  _classCallCheck(this, PendingHooks);
	
	  this.hooks = [];
	
	  this.add = function (hook) {
	    return _this.hooks.push(hook);
	  };
	
	  this.remove = function (hook) {
	    return _this.hooks = _this.hooks.filter(function (h) {
	      return h !== hook;
	    });
	  };
	
	  this.has = function (hook) {
	    return _this.hooks.indexOf(hook) !== -1;
	  };
	
	  this.clear = function () {
	    return _this.hooks = [];
	  };
	};
	
	var enterHooks = new PendingHooks();
	var changeHooks = new PendingHooks();
	
	function createTransitionHook(hook, route, asyncArity, pendingHooks) {
	  var isSync = hook.length < asyncArity;
	
	  var transitionHook = function transitionHook() {
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    hook.apply(route, args);
	
	    if (isSync) {
	      var callback = args[args.length - 1];
	      // Assume hook executes synchronously and
	      // automatically call the callback.
	      callback();
	    }
	  };
	
	  pendingHooks.add(transitionHook);
	
	  return transitionHook;
	}
	
	function getEnterHooks(routes) {
	  return routes.reduce(function (hooks, route) {
	    if (route.onEnter) hooks.push(createTransitionHook(route.onEnter, route, 3, enterHooks));
	    return hooks;
	  }, []);
	}
	
	function getChangeHooks(routes) {
	  return routes.reduce(function (hooks, route) {
	    if (route.onChange) hooks.push(createTransitionHook(route.onChange, route, 4, changeHooks));
	    return hooks;
	  }, []);
	}
	
	function runTransitionHooks(length, iter, callback) {
	  if (!length) {
	    callback();
	    return;
	  }
	
	  var redirectInfo = void 0;
	  function replace(location) {
	    redirectInfo = location;
	  }
	
	  (0, _AsyncUtils.loopAsync)(length, function (index, next, done) {
	    iter(index, replace, function (error) {
	      if (error || redirectInfo) {
	        done(error, redirectInfo); // No need to continue.
	      } else {
	        next();
	      }
	    });
	  }, callback);
	}
	
	/**
	 * Runs all onEnter hooks in the given array of routes in order
	 * with onEnter(nextState, replace, callback) and calls
	 * callback(error, redirectInfo) when finished. The first hook
	 * to use replace short-circuits the loop.
	 *
	 * If a hook needs to run asynchronously, it may use the callback
	 * function. However, doing so will cause the transition to pause,
	 * which could lead to a non-responsive UI if the hook is slow.
	 */
	function runEnterHooks(routes, nextState, callback) {
	  enterHooks.clear();
	  var hooks = getEnterHooks(routes);
	  return runTransitionHooks(hooks.length, function (index, replace, next) {
	    var wrappedNext = function wrappedNext() {
	      if (enterHooks.has(hooks[index])) {
	        next();
	        enterHooks.remove(hooks[index]);
	      }
	    };
	    hooks[index](nextState, replace, wrappedNext);
	  }, callback);
	}
	
	/**
	 * Runs all onChange hooks in the given array of routes in order
	 * with onChange(prevState, nextState, replace, callback) and calls
	 * callback(error, redirectInfo) when finished. The first hook
	 * to use replace short-circuits the loop.
	 *
	 * If a hook needs to run asynchronously, it may use the callback
	 * function. However, doing so will cause the transition to pause,
	 * which could lead to a non-responsive UI if the hook is slow.
	 */
	function runChangeHooks(routes, state, nextState, callback) {
	  changeHooks.clear();
	  var hooks = getChangeHooks(routes);
	  return runTransitionHooks(hooks.length, function (index, replace, next) {
	    var wrappedNext = function wrappedNext() {
	      if (changeHooks.has(hooks[index])) {
	        next();
	        changeHooks.remove(hooks[index]);
	      }
	    };
	    hooks[index](state, nextState, replace, wrappedNext);
	  }, callback);
	}
	
	/**
	 * Runs all onLeave hooks in the given array of routes in order.
	 */
	function runLeaveHooks(routes, prevState) {
	  for (var i = 0, len = routes.length; i < len; ++i) {
	    if (routes[i].onLeave) routes[i].onLeave.call(routes[i], prevState);
	  }
	}

/***/ },
/* 720 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _RouterContext = __webpack_require__(195);
	
	var _RouterContext2 = _interopRequireDefault(_RouterContext);
	
	var _routerWarning = __webpack_require__(88);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function () {
	  for (var _len = arguments.length, middlewares = Array(_len), _key = 0; _key < _len; _key++) {
	    middlewares[_key] = arguments[_key];
	  }
	
	  if (false) {
	    middlewares.forEach(function (middleware, index) {
	      process.env.NODE_ENV !== 'production' ? (0, _routerWarning2.default)(middleware.renderRouterContext || middleware.renderRouteComponent, 'The middleware specified at index ' + index + ' does not appear to be ' + 'a valid React Router middleware.') : void 0;
	    });
	  }
	
	  var withContext = middlewares.map(function (middleware) {
	    return middleware.renderRouterContext;
	  }).filter(Boolean);
	  var withComponent = middlewares.map(function (middleware) {
	    return middleware.renderRouteComponent;
	  }).filter(Boolean);
	
	  var makeCreateElement = function makeCreateElement() {
	    var baseCreateElement = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _react.createElement;
	    return function (Component, props) {
	      return withComponent.reduceRight(function (previous, renderRouteComponent) {
	        return renderRouteComponent(previous, props);
	      }, baseCreateElement(Component, props));
	    };
	  };
	
	  return function (renderProps) {
	    return withContext.reduceRight(function (previous, renderRouterContext) {
	      return renderRouterContext(previous, renderProps);
	    }, _react2.default.createElement(_RouterContext2.default, _extends({}, renderProps, {
	      createElement: makeCreateElement(renderProps.createElement)
	    })));
	  };
	};
	
	module.exports = exports['default'];

/***/ },
/* 721 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _createBrowserHistory = __webpack_require__(554);
	
	var _createBrowserHistory2 = _interopRequireDefault(_createBrowserHistory);
	
	var _createRouterHistory = __webpack_require__(304);
	
	var _createRouterHistory2 = _interopRequireDefault(_createRouterHistory);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _createRouterHistory2.default)(_createBrowserHistory2.default);
	module.exports = exports['default'];

/***/ },
/* 722 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _PatternUtils = __webpack_require__(86);
	
	function routeParamsChanged(route, prevState, nextState) {
	  if (!route.path) return false;
	
	  var paramNames = (0, _PatternUtils.getParamNames)(route.path);
	
	  return paramNames.some(function (paramName) {
	    return prevState.params[paramName] !== nextState.params[paramName];
	  });
	}
	
	/**
	 * Returns an object of { leaveRoutes, changeRoutes, enterRoutes } determined by
	 * the change from prevState to nextState. We leave routes if either
	 * 1) they are not in the next state or 2) they are in the next state
	 * but their params have changed (i.e. /users/123 => /users/456).
	 *
	 * leaveRoutes are ordered starting at the leaf route of the tree
	 * we're leaving up to the common parent route. enterRoutes are ordered
	 * from the top of the tree we're entering down to the leaf route.
	 *
	 * changeRoutes are any routes that didn't leave or enter during
	 * the transition.
	 */
	function computeChangedRoutes(prevState, nextState) {
	  var prevRoutes = prevState && prevState.routes;
	  var nextRoutes = nextState.routes;
	
	  var leaveRoutes = void 0,
	      changeRoutes = void 0,
	      enterRoutes = void 0;
	  if (prevRoutes) {
	    (function () {
	      var parentIsLeaving = false;
	      leaveRoutes = prevRoutes.filter(function (route) {
	        if (parentIsLeaving) {
	          return true;
	        } else {
	          var isLeaving = nextRoutes.indexOf(route) === -1 || routeParamsChanged(route, prevState, nextState);
	          if (isLeaving) parentIsLeaving = true;
	          return isLeaving;
	        }
	      });
	
	      // onLeave hooks start at the leaf route.
	      leaveRoutes.reverse();
	
	      enterRoutes = [];
	      changeRoutes = [];
	
	      nextRoutes.forEach(function (route) {
	        var isNew = prevRoutes.indexOf(route) === -1;
	        var paramsChanged = leaveRoutes.indexOf(route) !== -1;
	
	        if (isNew || paramsChanged) enterRoutes.push(route);else changeRoutes.push(route);
	      });
	    })();
	  } else {
	    leaveRoutes = [];
	    changeRoutes = [];
	    enterRoutes = nextRoutes;
	  }
	
	  return {
	    leaveRoutes: leaveRoutes,
	    changeRoutes: changeRoutes,
	    enterRoutes: enterRoutes
	  };
	}
	
	exports.default = computeChangedRoutes;
	module.exports = exports['default'];

/***/ },
/* 723 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _AsyncUtils = __webpack_require__(192);
	
	var _PromiseUtils = __webpack_require__(300);
	
	function getComponentsForRoute(nextState, route, callback) {
	  if (route.component || route.components) {
	    callback(null, route.component || route.components);
	    return;
	  }
	
	  var getComponent = route.getComponent || route.getComponents;
	  if (getComponent) {
	    var componentReturn = getComponent.call(route, nextState, callback);
	    if ((0, _PromiseUtils.isPromise)(componentReturn)) componentReturn.then(function (component) {
	      return callback(null, component);
	    }, callback);
	  } else {
	    callback();
	  }
	}
	
	/**
	 * Asynchronously fetches all components needed for the given router
	 * state and calls callback(error, components) when finished.
	 *
	 * Note: This operation may finish synchronously if no routes have an
	 * asynchronous getComponents method.
	 */
	function getComponents(nextState, callback) {
	  (0, _AsyncUtils.mapAsync)(nextState.routes, function (route, index, callback) {
	    getComponentsForRoute(nextState, route, callback);
	  }, callback);
	}
	
	exports.default = getComponents;
	module.exports = exports['default'];

/***/ },
/* 724 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _PatternUtils = __webpack_require__(86);
	
	/**
	 * Extracts an object of params the given route cares about from
	 * the given params object.
	 */
	function getRouteParams(route, params) {
	  var routeParams = {};
	
	  if (!route.path) return routeParams;
	
	  (0, _PatternUtils.getParamNames)(route.path).forEach(function (p) {
	    if (Object.prototype.hasOwnProperty.call(params, p)) {
	      routeParams[p] = params[p];
	    }
	  });
	
	  return routeParams;
	}
	
	exports.default = getRouteParams;
	module.exports = exports['default'];

/***/ },
/* 725 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _createHashHistory = __webpack_require__(555);
	
	var _createHashHistory2 = _interopRequireDefault(_createHashHistory);
	
	var _createRouterHistory = __webpack_require__(304);
	
	var _createRouterHistory2 = _interopRequireDefault(_createRouterHistory);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _createRouterHistory2.default)(_createHashHistory2.default);
	module.exports = exports['default'];

/***/ },
/* 726 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	exports.default = isActive;
	
	var _PatternUtils = __webpack_require__(86);
	
	function deepEqual(a, b) {
	  if (a == b) return true;
	
	  if (a == null || b == null) return false;
	
	  if (Array.isArray(a)) {
	    return Array.isArray(b) && a.length === b.length && a.every(function (item, index) {
	      return deepEqual(item, b[index]);
	    });
	  }
	
	  if ((typeof a === 'undefined' ? 'undefined' : _typeof(a)) === 'object') {
	    for (var p in a) {
	      if (!Object.prototype.hasOwnProperty.call(a, p)) {
	        continue;
	      }
	
	      if (a[p] === undefined) {
	        if (b[p] !== undefined) {
	          return false;
	        }
	      } else if (!Object.prototype.hasOwnProperty.call(b, p)) {
	        return false;
	      } else if (!deepEqual(a[p], b[p])) {
	        return false;
	      }
	    }
	
	    return true;
	  }
	
	  return String(a) === String(b);
	}
	
	/**
	 * Returns true if the current pathname matches the supplied one, net of
	 * leading and trailing slash normalization. This is sufficient for an
	 * indexOnly route match.
	 */
	function pathIsActive(pathname, currentPathname) {
	  // Normalize leading slash for consistency. Leading slash on pathname has
	  // already been normalized in isActive. See caveat there.
	  if (currentPathname.charAt(0) !== '/') {
	    currentPathname = '/' + currentPathname;
	  }
	
	  // Normalize the end of both path names too. Maybe `/foo/` shouldn't show
	  // `/foo` as active, but in this case, we would already have failed the
	  // match.
	  if (pathname.charAt(pathname.length - 1) !== '/') {
	    pathname += '/';
	  }
	  if (currentPathname.charAt(currentPathname.length - 1) !== '/') {
	    currentPathname += '/';
	  }
	
	  return currentPathname === pathname;
	}
	
	/**
	 * Returns true if the given pathname matches the active routes and params.
	 */
	function routeIsActive(pathname, routes, params) {
	  var remainingPathname = pathname,
	      paramNames = [],
	      paramValues = [];
	
	  // for...of would work here but it's probably slower post-transpilation.
	  for (var i = 0, len = routes.length; i < len; ++i) {
	    var route = routes[i];
	    var pattern = route.path || '';
	
	    if (pattern.charAt(0) === '/') {
	      remainingPathname = pathname;
	      paramNames = [];
	      paramValues = [];
	    }
	
	    if (remainingPathname !== null && pattern) {
	      var matched = (0, _PatternUtils.matchPattern)(pattern, remainingPathname);
	      if (matched) {
	        remainingPathname = matched.remainingPathname;
	        paramNames = [].concat(paramNames, matched.paramNames);
	        paramValues = [].concat(paramValues, matched.paramValues);
	      } else {
	        remainingPathname = null;
	      }
	
	      if (remainingPathname === '') {
	        // We have an exact match on the route. Just check that all the params
	        // match.
	        // FIXME: This doesn't work on repeated params.
	        return paramNames.every(function (paramName, index) {
	          return String(paramValues[index]) === String(params[paramName]);
	        });
	      }
	    }
	  }
	
	  return false;
	}
	
	/**
	 * Returns true if all key/value pairs in the given query are
	 * currently active.
	 */
	function queryIsActive(query, activeQuery) {
	  if (activeQuery == null) return query == null;
	
	  if (query == null) return true;
	
	  return deepEqual(query, activeQuery);
	}
	
	/**
	 * Returns true if a <Link> to the given pathname/query combination is
	 * currently active.
	 */
	function isActive(_ref, indexOnly, currentLocation, routes, params) {
	  var pathname = _ref.pathname,
	      query = _ref.query;
	
	  if (currentLocation == null) return false;
	
	  // TODO: This is a bit ugly. It keeps around support for treating pathnames
	  // without preceding slashes as absolute paths, but possibly also works
	  // around the same quirks with basenames as in matchRoutes.
	  if (pathname.charAt(0) !== '/') {
	    pathname = '/' + pathname;
	  }
	
	  if (!pathIsActive(pathname, currentLocation.pathname)) {
	    // The path check is necessary and sufficient for indexOnly, but otherwise
	    // we still need to check the routes.
	    if (indexOnly || !routeIsActive(pathname, routes, params)) {
	      return false;
	    }
	  }
	
	  return queryIsActive(query, currentLocation.query);
	}
	module.exports = exports['default'];

/***/ },
/* 727 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _Actions = __webpack_require__(118);
	
	var _invariant = __webpack_require__(23);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _createMemoryHistory = __webpack_require__(303);
	
	var _createMemoryHistory2 = _interopRequireDefault(_createMemoryHistory);
	
	var _createTransitionManager = __webpack_require__(305);
	
	var _createTransitionManager2 = _interopRequireDefault(_createTransitionManager);
	
	var _RouteUtils = __webpack_require__(61);
	
	var _RouterUtils = __webpack_require__(302);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	/**
	 * A high-level API to be used for server-side rendering.
	 *
	 * This function matches a location to a set of routes and calls
	 * callback(error, redirectLocation, renderProps) when finished.
	 *
	 * Note: You probably don't want to use this in a browser unless you're using
	 * server-side rendering with async routes.
	 */
	function match(_ref, callback) {
	  var history = _ref.history,
	      routes = _ref.routes,
	      location = _ref.location,
	      options = _objectWithoutProperties(_ref, ['history', 'routes', 'location']);
	
	  !(history || location) ?  false ? (0, _invariant2.default)(false, 'match needs a history or a location') : (0, _invariant2.default)(false) : void 0;
	
	  history = history ? history : (0, _createMemoryHistory2.default)(options);
	  var transitionManager = (0, _createTransitionManager2.default)(history, (0, _RouteUtils.createRoutes)(routes));
	
	  if (location) {
	    // Allow match({ location: '/the/path', ... })
	    location = history.createLocation(location);
	  } else {
	    location = history.getCurrentLocation();
	  }
	
	  transitionManager.match(location, function (error, redirectLocation, nextState) {
	    var renderProps = void 0;
	
	    if (nextState) {
	      var router = (0, _RouterUtils.createRouterObject)(history, transitionManager, nextState);
	      renderProps = _extends({}, nextState, {
	        router: router,
	        matchContext: { transitionManager: transitionManager, router: router }
	      });
	    }
	
	    callback(error, redirectLocation && history.createLocation(redirectLocation, _Actions.REPLACE), renderProps);
	  });
	}
	
	exports.default = match;
	module.exports = exports['default'];

/***/ },
/* 728 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	exports.default = matchRoutes;
	
	var _AsyncUtils = __webpack_require__(192);
	
	var _PromiseUtils = __webpack_require__(300);
	
	var _PatternUtils = __webpack_require__(86);
	
	var _routerWarning = __webpack_require__(88);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	var _RouteUtils = __webpack_require__(61);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getChildRoutes(route, location, paramNames, paramValues, callback) {
	  if (route.childRoutes) {
	    return [null, route.childRoutes];
	  }
	  if (!route.getChildRoutes) {
	    return [];
	  }
	
	  var sync = true,
	      result = void 0;
	
	  var partialNextState = {
	    location: location,
	    params: createParams(paramNames, paramValues)
	  };
	
	  var childRoutesReturn = route.getChildRoutes(partialNextState, function (error, childRoutes) {
	    childRoutes = !error && (0, _RouteUtils.createRoutes)(childRoutes);
	    if (sync) {
	      result = [error, childRoutes];
	      return;
	    }
	
	    callback(error, childRoutes);
	  });
	
	  if ((0, _PromiseUtils.isPromise)(childRoutesReturn)) childRoutesReturn.then(function (childRoutes) {
	    return callback(null, (0, _RouteUtils.createRoutes)(childRoutes));
	  }, callback);
	
	  sync = false;
	  return result; // Might be undefined.
	}
	
	function getIndexRoute(route, location, paramNames, paramValues, callback) {
	  if (route.indexRoute) {
	    callback(null, route.indexRoute);
	  } else if (route.getIndexRoute) {
	    var partialNextState = {
	      location: location,
	      params: createParams(paramNames, paramValues)
	    };
	
	    var indexRoutesReturn = route.getIndexRoute(partialNextState, function (error, indexRoute) {
	      callback(error, !error && (0, _RouteUtils.createRoutes)(indexRoute)[0]);
	    });
	
	    if ((0, _PromiseUtils.isPromise)(indexRoutesReturn)) indexRoutesReturn.then(function (indexRoute) {
	      return callback(null, (0, _RouteUtils.createRoutes)(indexRoute)[0]);
	    }, callback);
	  } else if (route.childRoutes) {
	    (function () {
	      var pathless = route.childRoutes.filter(function (childRoute) {
	        return !childRoute.path;
	      });
	
	      (0, _AsyncUtils.loopAsync)(pathless.length, function (index, next, done) {
	        getIndexRoute(pathless[index], location, paramNames, paramValues, function (error, indexRoute) {
	          if (error || indexRoute) {
	            var routes = [pathless[index]].concat(Array.isArray(indexRoute) ? indexRoute : [indexRoute]);
	            done(error, routes);
	          } else {
	            next();
	          }
	        });
	      }, function (err, routes) {
	        callback(null, routes);
	      });
	    })();
	  } else {
	    callback();
	  }
	}
	
	function assignParams(params, paramNames, paramValues) {
	  return paramNames.reduce(function (params, paramName, index) {
	    var paramValue = paramValues && paramValues[index];
	
	    if (Array.isArray(params[paramName])) {
	      params[paramName].push(paramValue);
	    } else if (paramName in params) {
	      params[paramName] = [params[paramName], paramValue];
	    } else {
	      params[paramName] = paramValue;
	    }
	
	    return params;
	  }, params);
	}
	
	function createParams(paramNames, paramValues) {
	  return assignParams({}, paramNames, paramValues);
	}
	
	function matchRouteDeep(route, location, remainingPathname, paramNames, paramValues, callback) {
	  var pattern = route.path || '';
	
	  if (pattern.charAt(0) === '/') {
	    remainingPathname = location.pathname;
	    paramNames = [];
	    paramValues = [];
	  }
	
	  // Only try to match the path if the route actually has a pattern, and if
	  // we're not just searching for potential nested absolute paths.
	  if (remainingPathname !== null && pattern) {
	    try {
	      var matched = (0, _PatternUtils.matchPattern)(pattern, remainingPathname);
	      if (matched) {
	        remainingPathname = matched.remainingPathname;
	        paramNames = [].concat(paramNames, matched.paramNames);
	        paramValues = [].concat(paramValues, matched.paramValues);
	      } else {
	        remainingPathname = null;
	      }
	    } catch (error) {
	      callback(error);
	    }
	
	    // By assumption, pattern is non-empty here, which is the prerequisite for
	    // actually terminating a match.
	    if (remainingPathname === '') {
	      var _ret2 = function () {
	        var match = {
	          routes: [route],
	          params: createParams(paramNames, paramValues)
	        };
	
	        getIndexRoute(route, location, paramNames, paramValues, function (error, indexRoute) {
	          if (error) {
	            callback(error);
	          } else {
	            if (Array.isArray(indexRoute)) {
	              var _match$routes;
	
	               false ? (0, _routerWarning2.default)(indexRoute.every(function (route) {
	                return !route.path;
	              }), 'Index routes should not have paths') : void 0;
	              (_match$routes = match.routes).push.apply(_match$routes, indexRoute);
	            } else if (indexRoute) {
	               false ? (0, _routerWarning2.default)(!indexRoute.path, 'Index routes should not have paths') : void 0;
	              match.routes.push(indexRoute);
	            }
	
	            callback(null, match);
	          }
	        });
	
	        return {
	          v: void 0
	        };
	      }();
	
	      if ((typeof _ret2 === 'undefined' ? 'undefined' : _typeof(_ret2)) === "object") return _ret2.v;
	    }
	  }
	
	  if (remainingPathname != null || route.childRoutes) {
	    // Either a) this route matched at least some of the path or b)
	    // we don't have to load this route's children asynchronously. In
	    // either case continue checking for matches in the subtree.
	    var onChildRoutes = function onChildRoutes(error, childRoutes) {
	      if (error) {
	        callback(error);
	      } else if (childRoutes) {
	        // Check the child routes to see if any of them match.
	        matchRoutes(childRoutes, location, function (error, match) {
	          if (error) {
	            callback(error);
	          } else if (match) {
	            // A child route matched! Augment the match and pass it up the stack.
	            match.routes.unshift(route);
	            callback(null, match);
	          } else {
	            callback();
	          }
	        }, remainingPathname, paramNames, paramValues);
	      } else {
	        callback();
	      }
	    };
	
	    var result = getChildRoutes(route, location, paramNames, paramValues, onChildRoutes);
	    if (result) {
	      onChildRoutes.apply(undefined, result);
	    }
	  } else {
	    callback();
	  }
	}
	
	/**
	 * Asynchronously matches the given location to a set of routes and calls
	 * callback(error, state) when finished. The state object will have the
	 * following properties:
	 *
	 * - routes       An array of routes that matched, in hierarchical order
	 * - params       An object of URL parameters
	 *
	 * Note: This operation may finish synchronously if no routes have an
	 * asynchronous getChildRoutes method.
	 */
	function matchRoutes(routes, location, callback, remainingPathname) {
	  var paramNames = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : [];
	  var paramValues = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : [];
	
	  if (remainingPathname === undefined) {
	    // TODO: This is a little bit ugly, but it works around a quirk in history
	    // that strips the leading slash from pathnames when using basenames with
	    // trailing slashes.
	    if (location.pathname.charAt(0) !== '/') {
	      location = _extends({}, location, {
	        pathname: '/' + location.pathname
	      });
	    }
	    remainingPathname = location.pathname;
	  }
	
	  (0, _AsyncUtils.loopAsync)(routes.length, function (index, next, done) {
	    matchRouteDeep(routes[index], location, remainingPathname, paramNames, paramValues, function (error, match) {
	      if (error || match) {
	        done(error, match);
	      } else {
	        next();
	      }
	    });
	  }, callback);
	}
	module.exports = exports['default'];

/***/ },
/* 729 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = withRouter;
	
	var _invariant = __webpack_require__(23);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _hoistNonReactStatics = __webpack_require__(557);
	
	var _hoistNonReactStatics2 = _interopRequireDefault(_hoistNonReactStatics);
	
	var _ContextUtils = __webpack_require__(193);
	
	var _PropTypes = __webpack_require__(194);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getDisplayName(WrappedComponent) {
	  return WrappedComponent.displayName || WrappedComponent.name || 'Component';
	}
	
	function withRouter(WrappedComponent, options) {
	  var withRef = options && options.withRef;
	
	  var WithRouter = _react2.default.createClass({
	    displayName: 'WithRouter',
	
	    mixins: [(0, _ContextUtils.ContextSubscriber)('router')],
	
	    contextTypes: { router: _PropTypes.routerShape },
	    propTypes: { router: _PropTypes.routerShape },
	
	    getWrappedInstance: function getWrappedInstance() {
	      !withRef ?  false ? (0, _invariant2.default)(false, 'To access the wrapped instance, you need to specify ' + '`{ withRef: true }` as the second argument of the withRouter() call.') : (0, _invariant2.default)(false) : void 0;
	
	      return this.wrappedInstance;
	    },
	    render: function render() {
	      var _this = this;
	
	      var router = this.props.router || this.context.router;
	      var params = router.params,
	          location = router.location,
	          routes = router.routes;
	
	      var props = _extends({}, this.props, { router: router, params: params, location: location, routes: routes });
	
	      if (withRef) {
	        props.ref = function (c) {
	          _this.wrappedInstance = c;
	        };
	      }
	
	      return _react2.default.createElement(WrappedComponent, props);
	    }
	  });
	
	  WithRouter.displayName = 'withRouter(' + getDisplayName(WrappedComponent) + ')';
	  WithRouter.WrappedComponent = WrappedComponent;
	
	  return (0, _hoistNonReactStatics2.default)(WithRouter, WrappedComponent);
	}
	module.exports = exports['default'];

/***/ },
/* 730 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.NextArrow = exports.PrevArrow = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(138);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PrevArrow = exports.PrevArrow = _react2.default.createClass({
	  displayName: 'PrevArrow',
	
	
	  clickHandler: function clickHandler(options, e) {
	    if (e) {
	      e.preventDefault();
	    }
	    this.props.clickHandler(options, e);
	  },
	  render: function render() {
	    var prevClasses = { 'slick-arrow': true, 'slick-prev': true };
	    var prevHandler = this.clickHandler.bind(this, { message: 'previous' });
	
	    if (!this.props.infinite && (this.props.currentSlide === 0 || this.props.slideCount <= this.props.slidesToShow)) {
	      prevClasses['slick-disabled'] = true;
	      prevHandler = null;
	    }
	
	    var prevArrowProps = {
	      key: '0',
	      'data-role': 'none',
	      className: (0, _classnames2.default)(prevClasses),
	      style: { display: 'block' },
	      onClick: prevHandler
	    };
	    var prevArrow;
	
	    if (this.props.prevArrow) {
	      prevArrow = _react2.default.cloneElement(this.props.prevArrow, prevArrowProps);
	    } else {
	      prevArrow = _react2.default.createElement(
	        'button',
	        _extends({ key: '0', type: 'button' }, prevArrowProps),
	        ' Previous'
	      );
	    }
	
	    return prevArrow;
	  }
	});
	
	var NextArrow = exports.NextArrow = _react2.default.createClass({
	  displayName: 'NextArrow',
	
	  clickHandler: function clickHandler(options, e) {
	    if (e) {
	      e.preventDefault();
	    }
	    this.props.clickHandler(options, e);
	  },
	  render: function render() {
	    var nextClasses = { 'slick-arrow': true, 'slick-next': true };
	    var nextHandler = this.clickHandler.bind(this, { message: 'next' });
	
	    if (!this.props.infinite) {
	      if (this.props.centerMode) {
	        // check if current slide is last slide
	        if (this.props.currentSlide >= this.props.slideCount - 1) {
	          nextClasses['slick-disabled'] = true;
	          nextHandler = null;
	        }
	      } else {
	        // check if all slides are shown in slider
	        if (this.props.slideCount <= this.props.slidesToShow || this.props.currentSlide >= this.props.slideCount - this.props.slidesToShow) {
	          nextClasses['slick-disabled'] = true;
	          nextHandler = null;
	        }
	      }
	    }
	
	    var nextArrowProps = {
	      key: '1',
	      'data-role': 'none',
	      className: (0, _classnames2.default)(nextClasses),
	      style: { display: 'block' },
	      onClick: nextHandler
	    };
	
	    var nextArrow;
	
	    if (this.props.nextArrow) {
	      nextArrow = _react2.default.cloneElement(this.props.nextArrow, nextArrowProps);
	    } else {
	      nextArrow = _react2.default.createElement(
	        'button',
	        _extends({ key: '1', type: 'button' }, nextArrowProps),
	        ' Next'
	      );
	    }
	
	    return nextArrow;
	  }
	});

/***/ },
/* 731 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.Dots = undefined;
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(138);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var getDotCount = function getDotCount(spec) {
	  var dots;
	  dots = Math.ceil(spec.slideCount / spec.slidesToScroll);
	  return dots;
	};
	
	var Dots = exports.Dots = _react2.default.createClass({
	  displayName: 'Dots',
	
	
	  clickHandler: function clickHandler(options, e) {
	    // In Autoplay the focus stays on clicked button even after transition
	    // to next slide. That only goes away by click somewhere outside
	    e.preventDefault();
	    this.props.clickHandler(options);
	  },
	  render: function render() {
	    var _this = this;
	
	    var dotCount = getDotCount({
	      slideCount: this.props.slideCount,
	      slidesToScroll: this.props.slidesToScroll
	    });
	
	    // Apply join & split to Array to pre-fill it for IE8
	    //
	    // Credit: http://stackoverflow.com/a/13735425/1849458
	    var dots = Array.apply(null, Array(dotCount + 1).join('0').split('')).map(function (x, i) {
	
	      var leftBound = i * _this.props.slidesToScroll;
	      var rightBound = i * _this.props.slidesToScroll + (_this.props.slidesToScroll - 1);
	      var className = (0, _classnames2.default)({
	        'slick-active': _this.props.currentSlide >= leftBound && _this.props.currentSlide <= rightBound
	      });
	
	      var dotOptions = {
	        message: 'dots',
	        index: i,
	        slidesToScroll: _this.props.slidesToScroll,
	        currentSlide: _this.props.currentSlide
	      };
	
	      return _react2.default.createElement(
	        'li',
	        { key: i, className: className },
	        _react2.default.createElement(
	          'button',
	          { onClick: _this.clickHandler.bind(_this, dotOptions) },
	          i + 1
	        )
	      );
	    });
	
	    return _react2.default.createElement(
	      'ul',
	      { className: this.props.dotsClass, style: { display: 'block' } },
	      dots
	    );
	  }
	});

/***/ },
/* 732 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = __webpack_require__(736);

/***/ },
/* 733 */
/***/ function(module, exports) {

	"use strict";
	
	var initialState = {
	    animating: false,
	    dragging: false,
	    autoPlayTimer: null,
	    currentDirection: 0,
	    currentLeft: null,
	    currentSlide: 0,
	    direction: 1,
	    listWidth: null,
	    listHeight: null,
	    // loadIndex: 0,
	    slideCount: null,
	    slideWidth: null,
	    slideHeight: null,
	    // sliding: false,
	    // slideOffset: 0,
	    swipeLeft: null,
	    touchObject: {
	        startX: 0,
	        startY: 0,
	        curX: 0,
	        curY: 0
	    },
	
	    lazyLoadedList: [],
	
	    // added for react
	    initialized: false,
	    edgeDragged: false,
	    swiped: false, // used by swipeEvent. differentites between touch and swipe.
	    trackStyle: {},
	    trackWidth: 0
	
	    // Removed
	    // transformsEnabled: false,
	    // $nextArrow: null,
	    // $prevArrow: null,
	    // $dots: null,
	    // $list: null,
	    // $slideTrack: null,
	    // $slides: null,
	};
	
	module.exports = initialState;

/***/ },
/* 734 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.InnerSlider = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _eventHandlers = __webpack_require__(735);
	
	var _eventHandlers2 = _interopRequireDefault(_eventHandlers);
	
	var _helpers = __webpack_require__(308);
	
	var _helpers2 = _interopRequireDefault(_helpers);
	
	var _initialState = __webpack_require__(733);
	
	var _initialState2 = _interopRequireDefault(_initialState);
	
	var _defaultProps = __webpack_require__(307);
	
	var _defaultProps2 = _interopRequireDefault(_defaultProps);
	
	var _classnames = __webpack_require__(138);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _objectAssign = __webpack_require__(6);
	
	var _objectAssign2 = _interopRequireDefault(_objectAssign);
	
	var _track = __webpack_require__(737);
	
	var _dots = __webpack_require__(731);
	
	var _arrows = __webpack_require__(730);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var InnerSlider = exports.InnerSlider = _react2.default.createClass({
	  displayName: 'InnerSlider',
	
	  mixins: [_helpers2.default, _eventHandlers2.default],
	  list: null,
	  track: null,
	  listRefHandler: function listRefHandler(ref) {
	    this.list = ref;
	  },
	  trackRefHandler: function trackRefHandler(ref) {
	    this.track = ref;
	  },
	  getInitialState: function getInitialState() {
	    return _extends({}, _initialState2.default, {
	      currentSlide: this.props.initialSlide
	    });
	  },
	  getDefaultProps: function getDefaultProps() {
	    return _defaultProps2.default;
	  },
	  componentWillMount: function componentWillMount() {
	    if (this.props.init) {
	      this.props.init();
	    }
	    this.setState({
	      mounted: true
	    });
	    var lazyLoadedList = [];
	    for (var i = 0; i < _react2.default.Children.count(this.props.children); i++) {
	      if (i >= this.state.currentSlide && i < this.state.currentSlide + this.props.slidesToShow) {
	        lazyLoadedList.push(i);
	      }
	    }
	
	    if (this.props.lazyLoad && this.state.lazyLoadedList.length === 0) {
	      this.setState({
	        lazyLoadedList: lazyLoadedList
	      });
	    }
	  },
	  componentDidMount: function componentDidMount() {
	    // Hack for autoplay -- Inspect Later
	    this.initialize(this.props);
	    this.adaptHeight();
	
	    // To support server-side rendering
	    if (!window) {
	      return;
	    }
	    if (window.addEventListener) {
	      window.addEventListener('resize', this.onWindowResized);
	    } else {
	      window.attachEvent('onresize', this.onWindowResized);
	    }
	  },
	  componentWillUnmount: function componentWillUnmount() {
	    if (this.animationEndCallback) {
	      clearTimeout(this.animationEndCallback);
	    }
	    if (window.addEventListener) {
	      window.removeEventListener('resize', this.onWindowResized);
	    } else {
	      window.detachEvent('onresize', this.onWindowResized);
	    }
	    if (this.state.autoPlayTimer) {
	      clearInterval(this.state.autoPlayTimer);
	    }
	  },
	  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
	    if (this.props.slickGoTo != nextProps.slickGoTo) {
	      if (false) {
	        console.warn('react-slick deprecation warning: slickGoTo prop is deprecated and it will be removed in next release. Use slickGoTo method instead');
	      }
	      this.changeSlide({
	        message: 'index',
	        index: nextProps.slickGoTo,
	        currentSlide: this.state.currentSlide
	      });
	    } else if (this.state.currentSlide >= nextProps.children.length) {
	      this.update(nextProps);
	      this.changeSlide({
	        message: 'index',
	        index: nextProps.children.length - nextProps.slidesToShow,
	        currentSlide: this.state.currentSlide
	      });
	    } else {
	      this.update(nextProps);
	    }
	  },
	  componentDidUpdate: function componentDidUpdate() {
	    this.adaptHeight();
	  },
	  onWindowResized: function onWindowResized() {
	    this.update(this.props);
	    // animating state should be cleared while resizing, otherwise autoplay stops working
	    this.setState({
	      animating: false
	    });
	  },
	  slickPrev: function slickPrev() {
	    this.changeSlide({ message: 'previous' });
	  },
	  slickNext: function slickNext() {
	    this.changeSlide({ message: 'next' });
	  },
	  slickGoTo: function slickGoTo(slide) {
	    typeof slide === 'number' && this.changeSlide({
	      message: 'index',
	      index: slide,
	      currentSlide: this.state.currentSlide
	    });
	  },
	  render: function render() {
	    var className = (0, _classnames2.default)('slick-initialized', 'slick-slider', this.props.className, {
	      'slick-vertical': this.props.vertical
	    });
	
	    var trackProps = {
	      fade: this.props.fade,
	      cssEase: this.props.cssEase,
	      speed: this.props.speed,
	      infinite: this.props.infinite,
	      centerMode: this.props.centerMode,
	      focusOnSelect: this.props.focusOnSelect ? this.selectHandler : null,
	      currentSlide: this.state.currentSlide,
	      lazyLoad: this.props.lazyLoad,
	      lazyLoadedList: this.state.lazyLoadedList,
	      rtl: this.props.rtl,
	      slideWidth: this.state.slideWidth,
	      slidesToShow: this.props.slidesToShow,
	      slidesToScroll: this.props.slidesToScroll,
	      slideCount: this.state.slideCount,
	      trackStyle: this.state.trackStyle,
	      variableWidth: this.props.variableWidth
	    };
	
	    var dots;
	
	    if (this.props.dots === true && this.state.slideCount >= this.props.slidesToShow) {
	      var dotProps = {
	        dotsClass: this.props.dotsClass,
	        slideCount: this.state.slideCount,
	        slidesToShow: this.props.slidesToShow,
	        currentSlide: this.state.currentSlide,
	        slidesToScroll: this.props.slidesToScroll,
	        clickHandler: this.changeSlide
	      };
	
	      dots = _react2.default.createElement(_dots.Dots, dotProps);
	    }
	
	    var prevArrow, nextArrow;
	
	    var arrowProps = {
	      infinite: this.props.infinite,
	      centerMode: this.props.centerMode,
	      currentSlide: this.state.currentSlide,
	      slideCount: this.state.slideCount,
	      slidesToShow: this.props.slidesToShow,
	      prevArrow: this.props.prevArrow,
	      nextArrow: this.props.nextArrow,
	      clickHandler: this.changeSlide
	    };
	
	    if (this.props.arrows) {
	      prevArrow = _react2.default.createElement(_arrows.PrevArrow, arrowProps);
	      nextArrow = _react2.default.createElement(_arrows.NextArrow, arrowProps);
	    }
	
	    var verticalHeightStyle = null;
	
	    if (this.props.vertical) {
	      verticalHeightStyle = {
	        height: this.state.listHeight
	      };
	    }
	
	    var centerPaddingStyle = null;
	
	    if (this.props.vertical === false) {
	      if (this.props.centerMode === true) {
	        centerPaddingStyle = {
	          padding: '0px ' + this.props.centerPadding
	        };
	      }
	    } else {
	      if (this.props.centerMode === true) {
	        centerPaddingStyle = {
	          padding: this.props.centerPadding + ' 0px'
	        };
	      }
	    }
	
	    var listStyle = (0, _objectAssign2.default)({}, verticalHeightStyle, centerPaddingStyle);
	
	    return _react2.default.createElement(
	      'div',
	      { className: className, onMouseEnter: this.onInnerSliderEnter, onMouseLeave: this.onInnerSliderLeave },
	      prevArrow,
	      _react2.default.createElement(
	        'div',
	        {
	          ref: this.listRefHandler,
	          className: 'slick-list',
	          style: listStyle,
	          onMouseDown: this.swipeStart,
	          onMouseMove: this.state.dragging ? this.swipeMove : null,
	          onMouseUp: this.swipeEnd,
	          onMouseLeave: this.state.dragging ? this.swipeEnd : null,
	          onTouchStart: this.swipeStart,
	          onTouchMove: this.state.dragging ? this.swipeMove : null,
	          onTouchEnd: this.swipeEnd,
	          onTouchCancel: this.state.dragging ? this.swipeEnd : null,
	          onKeyDown: this.props.accessibility ? this.keyHandler : null },
	        _react2.default.createElement(
	          _track.Track,
	          _extends({ ref: this.trackRefHandler }, trackProps),
	          this.props.children
	        )
	      ),
	      nextArrow,
	      dots
	    );
	  }
	});

/***/ },
/* 735 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _trackHelper = __webpack_require__(309);
	
	var _helpers = __webpack_require__(308);
	
	var _helpers2 = _interopRequireDefault(_helpers);
	
	var _objectAssign = __webpack_require__(6);
	
	var _objectAssign2 = _interopRequireDefault(_objectAssign);
	
	var _reactDom = __webpack_require__(84);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var EventHandlers = {
	  // Event handler for previous and next
	  changeSlide: function changeSlide(options) {
	    var indexOffset, previousInt, slideOffset, unevenOffset, targetSlide;
	    var _props = this.props;
	    var slidesToScroll = _props.slidesToScroll;
	    var slidesToShow = _props.slidesToShow;
	    var _state = this.state;
	    var slideCount = _state.slideCount;
	    var currentSlide = _state.currentSlide;
	
	    unevenOffset = slideCount % slidesToScroll !== 0;
	    indexOffset = unevenOffset ? 0 : (slideCount - currentSlide) % slidesToScroll;
	
	    if (options.message === 'previous') {
	      slideOffset = indexOffset === 0 ? slidesToScroll : slidesToShow - indexOffset;
	      targetSlide = currentSlide - slideOffset;
	      if (this.props.lazyLoad) {
	        previousInt = currentSlide - slideOffset;
	        targetSlide = previousInt === -1 ? slideCount - 1 : previousInt;
	      }
	    } else if (options.message === 'next') {
	      slideOffset = indexOffset === 0 ? slidesToScroll : indexOffset;
	      targetSlide = currentSlide + slideOffset;
	      if (this.props.lazyLoad) {
	        targetSlide = (currentSlide + slidesToScroll) % slideCount + indexOffset;
	      }
	    } else if (options.message === 'dots' || options.message === 'children') {
	      // Click on dots
	      targetSlide = options.index * options.slidesToScroll;
	      if (targetSlide === options.currentSlide) {
	        return;
	      }
	    } else if (options.message === 'index') {
	      targetSlide = parseInt(options.index);
	      if (targetSlide === options.currentSlide) {
	        return;
	      }
	    }
	
	    this.slideHandler(targetSlide);
	  },
	
	  // Accessiblity handler for previous and next
	  keyHandler: function keyHandler(e) {
	    //Dont slide if the cursor is inside the form fields and arrow keys are pressed
	    if (!e.target.tagName.match('TEXTAREA|INPUT|SELECT')) {
	      if (e.keyCode === 37 && this.props.accessibility === true) {
	        this.changeSlide({
	          message: this.props.rtl === true ? 'next' : 'previous'
	        });
	      } else if (e.keyCode === 39 && this.props.accessibility === true) {
	        this.changeSlide({
	          message: this.props.rtl === true ? 'previous' : 'next'
	        });
	      }
	    }
	  },
	  // Focus on selecting a slide (click handler on track)
	  selectHandler: function selectHandler(options) {
	    this.changeSlide(options);
	  },
	  swipeStart: function swipeStart(e) {
	    var touches, posX, posY;
	
	    if (this.props.swipe === false || 'ontouchend' in document && this.props.swipe === false) {
	      return;
	    } else if (this.props.draggable === false && e.type.indexOf('mouse') !== -1) {
	      return;
	    }
	    posX = e.touches !== undefined ? e.touches[0].pageX : e.clientX;
	    posY = e.touches !== undefined ? e.touches[0].pageY : e.clientY;
	    this.setState({
	      dragging: true,
	      touchObject: {
	        startX: posX,
	        startY: posY,
	        curX: posX,
	        curY: posY
	      }
	    });
	  },
	  swipeMove: function swipeMove(e) {
	    if (!this.state.dragging) {
	      e.preventDefault();
	      return;
	    }
	    if (this.state.animating) {
	      return;
	    }
	    var swipeLeft;
	    var curLeft, positionOffset;
	    var touchObject = this.state.touchObject;
	
	    curLeft = (0, _trackHelper.getTrackLeft)((0, _objectAssign2.default)({
	      slideIndex: this.state.currentSlide,
	      trackRef: this.track
	    }, this.props, this.state));
	    touchObject.curX = e.touches ? e.touches[0].pageX : e.clientX;
	    touchObject.curY = e.touches ? e.touches[0].pageY : e.clientY;
	    touchObject.swipeLength = Math.round(Math.sqrt(Math.pow(touchObject.curX - touchObject.startX, 2)));
	
	    if (this.props.verticalSwiping) {
	      touchObject.swipeLength = Math.round(Math.sqrt(Math.pow(touchObject.curY - touchObject.startY, 2)));
	    }
	
	    positionOffset = (this.props.rtl === false ? 1 : -1) * (touchObject.curX > touchObject.startX ? 1 : -1);
	
	    if (this.props.verticalSwiping) {
	      positionOffset = touchObject.curY > touchObject.startY ? 1 : -1;
	    }
	
	    var currentSlide = this.state.currentSlide;
	    var dotCount = Math.ceil(this.state.slideCount / this.props.slidesToScroll);
	    var swipeDirection = this.swipeDirection(this.state.touchObject);
	    var touchSwipeLength = touchObject.swipeLength;
	
	    if (this.props.infinite === false) {
	      if (currentSlide === 0 && swipeDirection === 'right' || currentSlide + 1 >= dotCount && swipeDirection === 'left') {
	        touchSwipeLength = touchObject.swipeLength * this.props.edgeFriction;
	
	        if (this.state.edgeDragged === false && this.props.edgeEvent) {
	          this.props.edgeEvent(swipeDirection);
	          this.setState({ edgeDragged: true });
	        }
	      }
	    }
	
	    if (this.state.swiped === false && this.props.swipeEvent) {
	      this.props.swipeEvent(swipeDirection);
	      this.setState({ swiped: true });
	    }
	
	    if (!this.props.vertical) {
	      swipeLeft = curLeft + touchSwipeLength * positionOffset;
	    } else {
	      swipeLeft = curLeft + touchSwipeLength * (this.state.listHeight / this.state.listWidth) * positionOffset;
	    }
	
	    if (this.props.verticalSwiping) {
	      swipeLeft = curLeft + touchSwipeLength * positionOffset;
	    }
	
	    this.setState({
	      touchObject: touchObject,
	      swipeLeft: swipeLeft,
	      trackStyle: (0, _trackHelper.getTrackCSS)((0, _objectAssign2.default)({ left: swipeLeft }, this.props, this.state))
	    });
	
	    if (Math.abs(touchObject.curX - touchObject.startX) < Math.abs(touchObject.curY - touchObject.startY) * 0.8) {
	      return;
	    }
	    if (touchObject.swipeLength > 4) {
	      e.preventDefault();
	    }
	  },
	  getNavigableIndexes: function getNavigableIndexes() {
	    var max = void 0;
	    var breakPoint = 0;
	    var counter = 0;
	    var indexes = [];
	
	    if (!this.props.infinite) {
	      max = this.state.slideCount;
	    } else {
	      breakPoint = this.props.slidesToShow * -1;
	      counter = this.props.slidesToShow * -1;
	      max = this.state.slideCount * 2;
	    }
	
	    while (breakPoint < max) {
	      indexes.push(breakPoint);
	      breakPoint = counter + this.props.slidesToScroll;
	
	      counter += this.props.slidesToScroll <= this.props.slidesToShow ? this.props.slidesToScroll : this.props.slidesToShow;
	    }
	
	    return indexes;
	  },
	  checkNavigable: function checkNavigable(index) {
	    var navigables = this.getNavigableIndexes();
	    var prevNavigable = 0;
	
	    if (index > navigables[navigables.length - 1]) {
	      index = navigables[navigables.length - 1];
	    } else {
	      for (var n in navigables) {
	        if (index < navigables[n]) {
	          index = prevNavigable;
	          break;
	        }
	
	        prevNavigable = navigables[n];
	      }
	    }
	
	    return index;
	  },
	  getSlideCount: function getSlideCount() {
	    var _this = this;
	
	    var centerOffset = this.props.centerMode ? this.state.slideWidth * Math.floor(this.props.slidesToShow / 2) : 0;
	
	    if (this.props.swipeToSlide) {
	      var swipedSlide = void 0;
	
	      var slickList = _reactDom2.default.findDOMNode(this.list);
	
	      var slides = slickList.querySelectorAll('.slick-slide');
	
	      Array.from(slides).every(function (slide) {
	        if (!_this.props.vertical) {
	          if (slide.offsetLeft - centerOffset + _this.getWidth(slide) / 2 > _this.state.swipeLeft * -1) {
	            swipedSlide = slide;
	            return false;
	          }
	        } else {
	          if (slide.offsetTop + _this.getHeight(slide) / 2 > _this.state.swipeLeft * -1) {
	            swipedSlide = slide;
	            return false;
	          }
	        }
	
	        return true;
	      });
	
	      var slidesTraversed = Math.abs(swipedSlide.dataset.index - this.state.currentSlide) || 1;
	
	      return slidesTraversed;
	    } else {
	      return this.props.slidesToScroll;
	    }
	  },
	
	  swipeEnd: function swipeEnd(e) {
	    if (!this.state.dragging) {
	      e.preventDefault();
	      return;
	    }
	    var touchObject = this.state.touchObject;
	    var minSwipe = this.state.listWidth / this.props.touchThreshold;
	    var swipeDirection = this.swipeDirection(touchObject);
	
	    if (this.props.verticalSwiping) {
	      minSwipe = this.state.listHeight / this.props.touchThreshold;
	    }
	
	    // reset the state of touch related state variables.
	    this.setState({
	      dragging: false,
	      edgeDragged: false,
	      swiped: false,
	      swipeLeft: null,
	      touchObject: {}
	    });
	    // Fix for #13
	    if (!touchObject.swipeLength) {
	      return;
	    }
	    if (touchObject.swipeLength > minSwipe) {
	      e.preventDefault();
	
	      var slideCount = void 0,
	          newSlide = void 0;
	
	      switch (swipeDirection) {
	
	        case 'left':
	        case 'down':
	          newSlide = this.state.currentSlide + this.getSlideCount();
	          slideCount = this.props.swipeToSlide ? this.checkNavigable(newSlide) : newSlide;
	          this.state.currentDirection = 0;
	          break;
	
	        case 'right':
	        case 'up':
	          newSlide = this.state.currentSlide - this.getSlideCount();
	          slideCount = this.props.swipeToSlide ? this.checkNavigable(newSlide) : newSlide;
	          this.state.currentDirection = 1;
	          break;
	
	        default:
	          slideCount = this.state.currentSlide;
	
	      }
	
	      this.slideHandler(slideCount);
	    } else {
	      // Adjust the track back to it's original position.
	      var currentLeft = (0, _trackHelper.getTrackLeft)((0, _objectAssign2.default)({
	        slideIndex: this.state.currentSlide,
	        trackRef: this.track
	      }, this.props, this.state));
	
	      this.setState({
	        trackStyle: (0, _trackHelper.getTrackAnimateCSS)((0, _objectAssign2.default)({ left: currentLeft }, this.props, this.state))
	      });
	    }
	  },
	  onInnerSliderEnter: function onInnerSliderEnter(e) {
	    if (this.props.autoplay && this.props.pauseOnHover) {
	      this.pause();
	    }
	  },
	  onInnerSliderLeave: function onInnerSliderLeave(e) {
	    if (this.props.autoplay && this.props.pauseOnHover) {
	      this.autoPlay();
	    }
	  }
	};
	
	exports.default = EventHandlers;

/***/ },
/* 736 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _innerSlider = __webpack_require__(734);
	
	var _objectAssign = __webpack_require__(6);
	
	var _objectAssign2 = _interopRequireDefault(_objectAssign);
	
	var _json2mq = __webpack_require__(251);
	
	var _json2mq2 = _interopRequireDefault(_json2mq);
	
	var _reactResponsiveMixin = __webpack_require__(713);
	
	var _reactResponsiveMixin2 = _interopRequireDefault(_reactResponsiveMixin);
	
	var _defaultProps = __webpack_require__(307);
	
	var _defaultProps2 = _interopRequireDefault(_defaultProps);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Slider = _react2.default.createClass({
	  displayName: 'Slider',
	
	  mixins: [_reactResponsiveMixin2.default],
	  innerSlider: null,
	  innerSliderRefHandler: function innerSliderRefHandler(ref) {
	    this.innerSlider = ref;
	  },
	  getInitialState: function getInitialState() {
	    return {
	      breakpoint: null
	    };
	  },
	  componentWillMount: function componentWillMount() {
	    var _this = this;
	
	    if (this.props.responsive) {
	      var breakpoints = this.props.responsive.map(function (breakpt) {
	        return breakpt.breakpoint;
	      });
	      breakpoints.sort(function (x, y) {
	        return x - y;
	      });
	
	      breakpoints.forEach(function (breakpoint, index) {
	        var bQuery;
	        if (index === 0) {
	          bQuery = (0, _json2mq2.default)({ minWidth: 0, maxWidth: breakpoint });
	        } else {
	          bQuery = (0, _json2mq2.default)({ minWidth: breakpoints[index - 1], maxWidth: breakpoint });
	        }
	        _this.media(bQuery, function () {
	          _this.setState({ breakpoint: breakpoint });
	        });
	      });
	
	      // Register media query for full screen. Need to support resize from small to large
	      var query = (0, _json2mq2.default)({ minWidth: breakpoints.slice(-1)[0] });
	
	      this.media(query, function () {
	        _this.setState({ breakpoint: null });
	      });
	    }
	  },
	
	  slickPrev: function slickPrev() {
	    this.innerSlider.slickPrev();
	  },
	
	  slickNext: function slickNext() {
	    this.innerSlider.slickNext();
	  },
	
	  slickGoTo: function slickGoTo(slide) {
	    this.innerSlider.slickGoTo(slide);
	  },
	
	  render: function render() {
	    var _this2 = this;
	
	    var settings;
	    var newProps;
	    if (this.state.breakpoint) {
	      newProps = this.props.responsive.filter(function (resp) {
	        return resp.breakpoint === _this2.state.breakpoint;
	      });
	      settings = newProps[0].settings === 'unslick' ? 'unslick' : (0, _objectAssign2.default)({}, this.props, newProps[0].settings);
	    } else {
	      settings = (0, _objectAssign2.default)({}, _defaultProps2.default, this.props);
	    }
	
	    var children = this.props.children;
	    if (!Array.isArray(children)) {
	      children = [children];
	    }
	
	    // Children may contain false or null, so we should filter them
	    children = children.filter(function (child) {
	      return !!child;
	    });
	
	    if (settings === 'unslick') {
	      // if 'unslick' responsive breakpoint setting used, just return the <Slider> tag nested HTML
	      return _react2.default.createElement(
	        'div',
	        null,
	        children
	      );
	    } else {
	      return _react2.default.createElement(
	        _innerSlider.InnerSlider,
	        _extends({ ref: this.innerSliderRefHandler }, settings),
	        children
	      );
	    }
	  }
	});
	
	module.exports = Slider;

/***/ },
/* 737 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.Track = undefined;
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _objectAssign = __webpack_require__(6);
	
	var _objectAssign2 = _interopRequireDefault(_objectAssign);
	
	var _classnames = __webpack_require__(138);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var getSlideClasses = function getSlideClasses(spec) {
	  var slickActive, slickCenter, slickCloned;
	  var centerOffset, index;
	
	  if (spec.rtl) {
	    index = spec.slideCount - 1 - spec.index;
	  } else {
	    index = spec.index;
	  }
	
	  slickCloned = index < 0 || index >= spec.slideCount;
	  if (spec.centerMode) {
	    centerOffset = Math.floor(spec.slidesToShow / 2);
	    slickCenter = (index - spec.currentSlide) % spec.slideCount === 0;
	    if (index > spec.currentSlide - centerOffset - 1 && index <= spec.currentSlide + centerOffset) {
	      slickActive = true;
	    }
	  } else {
	    slickActive = spec.currentSlide <= index && index < spec.currentSlide + spec.slidesToShow;
	  }
	  return (0, _classnames2.default)({
	    'slick-slide': true,
	    'slick-active': slickActive,
	    'slick-center': slickCenter,
	    'slick-cloned': slickCloned
	  });
	};
	
	var getSlideStyle = function getSlideStyle(spec) {
	  var style = {};
	
	  if (spec.variableWidth === undefined || spec.variableWidth === false) {
	    style.width = spec.slideWidth;
	  }
	
	  if (spec.fade) {
	    style.position = 'relative';
	    style.left = -spec.index * spec.slideWidth;
	    style.opacity = spec.currentSlide === spec.index ? 1 : 0;
	    style.transition = 'opacity ' + spec.speed + 'ms ' + spec.cssEase;
	    style.WebkitTransition = 'opacity ' + spec.speed + 'ms ' + spec.cssEase;
	  }
	
	  return style;
	};
	
	var getKey = function getKey(child, fallbackKey) {
	  // key could be a zero
	  return child.key === null || child.key === undefined ? fallbackKey : child.key;
	};
	
	var renderSlides = function renderSlides(spec) {
	  var key;
	  var slides = [];
	  var preCloneSlides = [];
	  var postCloneSlides = [];
	  var count = _react2.default.Children.count(spec.children);
	
	  _react2.default.Children.forEach(spec.children, function (elem, index) {
	    var child = void 0;
	    var childOnClickOptions = {
	      message: 'children',
	      index: index,
	      slidesToScroll: spec.slidesToScroll,
	      currentSlide: spec.currentSlide
	    };
	
	    if (!spec.lazyLoad | (spec.lazyLoad && spec.lazyLoadedList.indexOf(index) >= 0)) {
	      child = elem;
	    } else {
	      child = _react2.default.createElement('div', null);
	    }
	    var childStyle = getSlideStyle((0, _objectAssign2.default)({}, spec, { index: index }));
	    var slickClasses = getSlideClasses((0, _objectAssign2.default)({ index: index }, spec));
	    var cssClasses;
	
	    if (child.props.className) {
	      cssClasses = (0, _classnames2.default)(slickClasses, child.props.className);
	    } else {
	      cssClasses = slickClasses;
	    }
	
	    var onClick = function onClick(e) {
	      child.props && child.props.onClick && child.props.onClick(e);
	      if (spec.focusOnSelect) {
	        spec.focusOnSelect(childOnClickOptions);
	      }
	    };
	
	    slides.push(_react2.default.cloneElement(child, {
	      key: 'original' + getKey(child, index),
	      'data-index': index,
	      className: cssClasses,
	      tabIndex: '-1',
	      style: (0, _objectAssign2.default)({ outline: 'none' }, child.props.style || {}, childStyle),
	      onClick: onClick
	    }));
	
	    // variableWidth doesn't wrap properly.
	    if (spec.infinite && spec.fade === false) {
	      var infiniteCount = spec.variableWidth ? spec.slidesToShow + 1 : spec.slidesToShow;
	
	      if (index >= count - infiniteCount) {
	        key = -(count - index);
	        preCloneSlides.push(_react2.default.cloneElement(child, {
	          key: 'precloned' + getKey(child, key),
	          'data-index': key,
	          className: cssClasses,
	          style: (0, _objectAssign2.default)({}, child.props.style || {}, childStyle),
	          onClick: onClick
	        }));
	      }
	
	      if (index < infiniteCount) {
	        key = count + index;
	        postCloneSlides.push(_react2.default.cloneElement(child, {
	          key: 'postcloned' + getKey(child, key),
	          'data-index': key,
	          className: cssClasses,
	          style: (0, _objectAssign2.default)({}, child.props.style || {}, childStyle),
	          onClick: onClick
	        }));
	      }
	    }
	  });
	
	  if (spec.rtl) {
	    return preCloneSlides.concat(slides, postCloneSlides).reverse();
	  } else {
	    return preCloneSlides.concat(slides, postCloneSlides);
	  }
	};
	
	var Track = exports.Track = _react2.default.createClass({
	  displayName: 'Track',
	
	  render: function render() {
	    var slides = renderSlides.call(this, this.props);
	    return _react2.default.createElement(
	      'div',
	      { className: 'slick-track', style: this.props.trackStyle },
	      slides
	    );
	  }
	});

/***/ },
/* 738 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule AutoFocusUtils
	 */
	
	'use strict';
	
	var ReactDOMComponentTree = __webpack_require__(15);
	
	var focusNode = __webpack_require__(245);
	
	var AutoFocusUtils = {
	  focusDOMComponent: function () {
	    focusNode(ReactDOMComponentTree.getNodeFromInstance(this));
	  }
	};
	
	module.exports = AutoFocusUtils;

/***/ },
/* 739 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule BeforeInputEventPlugin
	 */
	
	'use strict';
	
	var EventConstants = __webpack_require__(52);
	var EventPropagators = __webpack_require__(100);
	var ExecutionEnvironment = __webpack_require__(22);
	var FallbackCompositionState = __webpack_require__(745);
	var SyntheticCompositionEvent = __webpack_require__(782);
	var SyntheticInputEvent = __webpack_require__(785);
	
	var keyOf = __webpack_require__(50);
	
	var END_KEYCODES = [9, 13, 27, 32]; // Tab, Return, Esc, Space
	var START_KEYCODE = 229;
	
	var canUseCompositionEvent = ExecutionEnvironment.canUseDOM && 'CompositionEvent' in window;
	
	var documentMode = null;
	if (ExecutionEnvironment.canUseDOM && 'documentMode' in document) {
	  documentMode = document.documentMode;
	}
	
	// Webkit offers a very useful `textInput` event that can be used to
	// directly represent `beforeInput`. The IE `textinput` event is not as
	// useful, so we don't use it.
	var canUseTextInputEvent = ExecutionEnvironment.canUseDOM && 'TextEvent' in window && !documentMode && !isPresto();
	
	// In IE9+, we have access to composition events, but the data supplied
	// by the native compositionend event may be incorrect. Japanese ideographic
	// spaces, for instance (\u3000) are not recorded correctly.
	var useFallbackCompositionData = ExecutionEnvironment.canUseDOM && (!canUseCompositionEvent || documentMode && documentMode > 8 && documentMode <= 11);
	
	/**
	 * Opera <= 12 includes TextEvent in window, but does not fire
	 * text input events. Rely on keypress instead.
	 */
	function isPresto() {
	  var opera = window.opera;
	  return typeof opera === 'object' && typeof opera.version === 'function' && parseInt(opera.version(), 10) <= 12;
	}
	
	var SPACEBAR_CODE = 32;
	var SPACEBAR_CHAR = String.fromCharCode(SPACEBAR_CODE);
	
	var topLevelTypes = EventConstants.topLevelTypes;
	
	// Events and their corresponding property names.
	var eventTypes = {
	  beforeInput: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onBeforeInput: null }),
	      captured: keyOf({ onBeforeInputCapture: null })
	    },
	    dependencies: [topLevelTypes.topCompositionEnd, topLevelTypes.topKeyPress, topLevelTypes.topTextInput, topLevelTypes.topPaste]
	  },
	  compositionEnd: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onCompositionEnd: null }),
	      captured: keyOf({ onCompositionEndCapture: null })
	    },
	    dependencies: [topLevelTypes.topBlur, topLevelTypes.topCompositionEnd, topLevelTypes.topKeyDown, topLevelTypes.topKeyPress, topLevelTypes.topKeyUp, topLevelTypes.topMouseDown]
	  },
	  compositionStart: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onCompositionStart: null }),
	      captured: keyOf({ onCompositionStartCapture: null })
	    },
	    dependencies: [topLevelTypes.topBlur, topLevelTypes.topCompositionStart, topLevelTypes.topKeyDown, topLevelTypes.topKeyPress, topLevelTypes.topKeyUp, topLevelTypes.topMouseDown]
	  },
	  compositionUpdate: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onCompositionUpdate: null }),
	      captured: keyOf({ onCompositionUpdateCapture: null })
	    },
	    dependencies: [topLevelTypes.topBlur, topLevelTypes.topCompositionUpdate, topLevelTypes.topKeyDown, topLevelTypes.topKeyPress, topLevelTypes.topKeyUp, topLevelTypes.topMouseDown]
	  }
	};
	
	// Track whether we've ever handled a keypress on the space key.
	var hasSpaceKeypress = false;
	
	/**
	 * Return whether a native keypress event is assumed to be a command.
	 * This is required because Firefox fires `keypress` events for key commands
	 * (cut, copy, select-all, etc.) even though no character is inserted.
	 */
	function isKeypressCommand(nativeEvent) {
	  return (nativeEvent.ctrlKey || nativeEvent.altKey || nativeEvent.metaKey) &&
	  // ctrlKey && altKey is equivalent to AltGr, and is not a command.
	  !(nativeEvent.ctrlKey && nativeEvent.altKey);
	}
	
	/**
	 * Translate native top level events into event types.
	 *
	 * @param {string} topLevelType
	 * @return {object}
	 */
	function getCompositionEventType(topLevelType) {
	  switch (topLevelType) {
	    case topLevelTypes.topCompositionStart:
	      return eventTypes.compositionStart;
	    case topLevelTypes.topCompositionEnd:
	      return eventTypes.compositionEnd;
	    case topLevelTypes.topCompositionUpdate:
	      return eventTypes.compositionUpdate;
	  }
	}
	
	/**
	 * Does our fallback best-guess model think this event signifies that
	 * composition has begun?
	 *
	 * @param {string} topLevelType
	 * @param {object} nativeEvent
	 * @return {boolean}
	 */
	function isFallbackCompositionStart(topLevelType, nativeEvent) {
	  return topLevelType === topLevelTypes.topKeyDown && nativeEvent.keyCode === START_KEYCODE;
	}
	
	/**
	 * Does our fallback mode think that this event is the end of composition?
	 *
	 * @param {string} topLevelType
	 * @param {object} nativeEvent
	 * @return {boolean}
	 */
	function isFallbackCompositionEnd(topLevelType, nativeEvent) {
	  switch (topLevelType) {
	    case topLevelTypes.topKeyUp:
	      // Command keys insert or clear IME input.
	      return END_KEYCODES.indexOf(nativeEvent.keyCode) !== -1;
	    case topLevelTypes.topKeyDown:
	      // Expect IME keyCode on each keydown. If we get any other
	      // code we must have exited earlier.
	      return nativeEvent.keyCode !== START_KEYCODE;
	    case topLevelTypes.topKeyPress:
	    case topLevelTypes.topMouseDown:
	    case topLevelTypes.topBlur:
	      // Events are not possible without cancelling IME.
	      return true;
	    default:
	      return false;
	  }
	}
	
	/**
	 * Google Input Tools provides composition data via a CustomEvent,
	 * with the `data` property populated in the `detail` object. If this
	 * is available on the event object, use it. If not, this is a plain
	 * composition event and we have nothing special to extract.
	 *
	 * @param {object} nativeEvent
	 * @return {?string}
	 */
	function getDataFromCustomEvent(nativeEvent) {
	  var detail = nativeEvent.detail;
	  if (typeof detail === 'object' && 'data' in detail) {
	    return detail.data;
	  }
	  return null;
	}
	
	// Track the current IME composition fallback object, if any.
	var currentComposition = null;
	
	/**
	 * @return {?object} A SyntheticCompositionEvent.
	 */
	function extractCompositionEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	  var eventType;
	  var fallbackData;
	
	  if (canUseCompositionEvent) {
	    eventType = getCompositionEventType(topLevelType);
	  } else if (!currentComposition) {
	    if (isFallbackCompositionStart(topLevelType, nativeEvent)) {
	      eventType = eventTypes.compositionStart;
	    }
	  } else if (isFallbackCompositionEnd(topLevelType, nativeEvent)) {
	    eventType = eventTypes.compositionEnd;
	  }
	
	  if (!eventType) {
	    return null;
	  }
	
	  if (useFallbackCompositionData) {
	    // The current composition is stored statically and must not be
	    // overwritten while composition continues.
	    if (!currentComposition && eventType === eventTypes.compositionStart) {
	      currentComposition = FallbackCompositionState.getPooled(nativeEventTarget);
	    } else if (eventType === eventTypes.compositionEnd) {
	      if (currentComposition) {
	        fallbackData = currentComposition.getData();
	      }
	    }
	  }
	
	  var event = SyntheticCompositionEvent.getPooled(eventType, targetInst, nativeEvent, nativeEventTarget);
	
	  if (fallbackData) {
	    // Inject data generated from fallback path into the synthetic event.
	    // This matches the property of native CompositionEventInterface.
	    event.data = fallbackData;
	  } else {
	    var customData = getDataFromCustomEvent(nativeEvent);
	    if (customData !== null) {
	      event.data = customData;
	    }
	  }
	
	  EventPropagators.accumulateTwoPhaseDispatches(event);
	  return event;
	}
	
	/**
	 * @param {string} topLevelType Record from `EventConstants`.
	 * @param {object} nativeEvent Native browser event.
	 * @return {?string} The string corresponding to this `beforeInput` event.
	 */
	function getNativeBeforeInputChars(topLevelType, nativeEvent) {
	  switch (topLevelType) {
	    case topLevelTypes.topCompositionEnd:
	      return getDataFromCustomEvent(nativeEvent);
	    case topLevelTypes.topKeyPress:
	      /**
	       * If native `textInput` events are available, our goal is to make
	       * use of them. However, there is a special case: the spacebar key.
	       * In Webkit, preventing default on a spacebar `textInput` event
	       * cancels character insertion, but it *also* causes the browser
	       * to fall back to its default spacebar behavior of scrolling the
	       * page.
	       *
	       * Tracking at:
	       * https://code.google.com/p/chromium/issues/detail?id=355103
	       *
	       * To avoid this issue, use the keypress event as if no `textInput`
	       * event is available.
	       */
	      var which = nativeEvent.which;
	      if (which !== SPACEBAR_CODE) {
	        return null;
	      }
	
	      hasSpaceKeypress = true;
	      return SPACEBAR_CHAR;
	
	    case topLevelTypes.topTextInput:
	      // Record the characters to be added to the DOM.
	      var chars = nativeEvent.data;
	
	      // If it's a spacebar character, assume that we have already handled
	      // it at the keypress level and bail immediately. Android Chrome
	      // doesn't give us keycodes, so we need to blacklist it.
	      if (chars === SPACEBAR_CHAR && hasSpaceKeypress) {
	        return null;
	      }
	
	      return chars;
	
	    default:
	      // For other native event types, do nothing.
	      return null;
	  }
	}
	
	/**
	 * For browsers that do not provide the `textInput` event, extract the
	 * appropriate string to use for SyntheticInputEvent.
	 *
	 * @param {string} topLevelType Record from `EventConstants`.
	 * @param {object} nativeEvent Native browser event.
	 * @return {?string} The fallback string for this `beforeInput` event.
	 */
	function getFallbackBeforeInputChars(topLevelType, nativeEvent) {
	  // If we are currently composing (IME) and using a fallback to do so,
	  // try to extract the composed characters from the fallback object.
	  if (currentComposition) {
	    if (topLevelType === topLevelTypes.topCompositionEnd || isFallbackCompositionEnd(topLevelType, nativeEvent)) {
	      var chars = currentComposition.getData();
	      FallbackCompositionState.release(currentComposition);
	      currentComposition = null;
	      return chars;
	    }
	    return null;
	  }
	
	  switch (topLevelType) {
	    case topLevelTypes.topPaste:
	      // If a paste event occurs after a keypress, throw out the input
	      // chars. Paste events should not lead to BeforeInput events.
	      return null;
	    case topLevelTypes.topKeyPress:
	      /**
	       * As of v27, Firefox may fire keypress events even when no character
	       * will be inserted. A few possibilities:
	       *
	       * - `which` is `0`. Arrow keys, Esc key, etc.
	       *
	       * - `which` is the pressed key code, but no char is available.
	       *   Ex: 'AltGr + d` in Polish. There is no modified character for
	       *   this key combination and no character is inserted into the
	       *   document, but FF fires the keypress for char code `100` anyway.
	       *   No `input` event will occur.
	       *
	       * - `which` is the pressed key code, but a command combination is
	       *   being used. Ex: `Cmd+C`. No character is inserted, and no
	       *   `input` event will occur.
	       */
	      if (nativeEvent.which && !isKeypressCommand(nativeEvent)) {
	        return String.fromCharCode(nativeEvent.which);
	      }
	      return null;
	    case topLevelTypes.topCompositionEnd:
	      return useFallbackCompositionData ? null : nativeEvent.data;
	    default:
	      return null;
	  }
	}
	
	/**
	 * Extract a SyntheticInputEvent for `beforeInput`, based on either native
	 * `textInput` or fallback behavior.
	 *
	 * @return {?object} A SyntheticInputEvent.
	 */
	function extractBeforeInputEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	  var chars;
	
	  if (canUseTextInputEvent) {
	    chars = getNativeBeforeInputChars(topLevelType, nativeEvent);
	  } else {
	    chars = getFallbackBeforeInputChars(topLevelType, nativeEvent);
	  }
	
	  // If no characters are being inserted, no BeforeInput event should
	  // be fired.
	  if (!chars) {
	    return null;
	  }
	
	  var event = SyntheticInputEvent.getPooled(eventTypes.beforeInput, targetInst, nativeEvent, nativeEventTarget);
	
	  event.data = chars;
	  EventPropagators.accumulateTwoPhaseDispatches(event);
	  return event;
	}
	
	/**
	 * Create an `onBeforeInput` event to match
	 * http://www.w3.org/TR/2013/WD-DOM-Level-3-Events-20131105/#events-inputevents.
	 *
	 * This event plugin is based on the native `textInput` event
	 * available in Chrome, Safari, Opera, and IE. This event fires after
	 * `onKeyPress` and `onCompositionEnd`, but before `onInput`.
	 *
	 * `beforeInput` is spec'd but not implemented in any browsers, and
	 * the `input` event does not provide any useful information about what has
	 * actually been added, contrary to the spec. Thus, `textInput` is the best
	 * available event to identify the characters that have actually been inserted
	 * into the target node.
	 *
	 * This plugin is also responsible for emitting `composition` events, thus
	 * allowing us to share composition fallback code for both `beforeInput` and
	 * `composition` event types.
	 */
	var BeforeInputEventPlugin = {
	
	  eventTypes: eventTypes,
	
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    return [extractCompositionEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget), extractBeforeInputEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget)];
	  }
	};
	
	module.exports = BeforeInputEventPlugin;

/***/ },
/* 740 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule CSSPropertyOperations
	 */
	
	'use strict';
	
	var CSSProperty = __webpack_require__(310);
	var ExecutionEnvironment = __webpack_require__(22);
	var ReactInstrumentation = __webpack_require__(31);
	
	var camelizeStyleName = __webpack_require__(539);
	var dangerousStyleValue = __webpack_require__(792);
	var hyphenateStyleName = __webpack_require__(546);
	var memoizeStringOnly = __webpack_require__(550);
	var warning = __webpack_require__(9);
	
	var processStyleName = memoizeStringOnly(function (styleName) {
	  return hyphenateStyleName(styleName);
	});
	
	var hasShorthandPropertyBug = false;
	var styleFloatAccessor = 'cssFloat';
	if (ExecutionEnvironment.canUseDOM) {
	  var tempStyle = document.createElement('div').style;
	  try {
	    // IE8 throws "Invalid argument." if resetting shorthand style properties.
	    tempStyle.font = '';
	  } catch (e) {
	    hasShorthandPropertyBug = true;
	  }
	  // IE8 only supports accessing cssFloat (standard) as styleFloat
	  if (document.documentElement.style.cssFloat === undefined) {
	    styleFloatAccessor = 'styleFloat';
	  }
	}
	
	if (false) {
	  // 'msTransform' is correct, but the other prefixes should be capitalized
	  var badVendoredStyleNamePattern = /^(?:webkit|moz|o)[A-Z]/;
	
	  // style values shouldn't contain a semicolon
	  var badStyleValueWithSemicolonPattern = /;\s*$/;
	
	  var warnedStyleNames = {};
	  var warnedStyleValues = {};
	  var warnedForNaNValue = false;
	
	  var warnHyphenatedStyleName = function (name, owner) {
	    if (warnedStyleNames.hasOwnProperty(name) && warnedStyleNames[name]) {
	      return;
	    }
	
	    warnedStyleNames[name] = true;
	    process.env.NODE_ENV !== 'production' ? warning(false, 'Unsupported style property %s. Did you mean %s?%s', name, camelizeStyleName(name), checkRenderMessage(owner)) : void 0;
	  };
	
	  var warnBadVendoredStyleName = function (name, owner) {
	    if (warnedStyleNames.hasOwnProperty(name) && warnedStyleNames[name]) {
	      return;
	    }
	
	    warnedStyleNames[name] = true;
	    process.env.NODE_ENV !== 'production' ? warning(false, 'Unsupported vendor-prefixed style property %s. Did you mean %s?%s', name, name.charAt(0).toUpperCase() + name.slice(1), checkRenderMessage(owner)) : void 0;
	  };
	
	  var warnStyleValueWithSemicolon = function (name, value, owner) {
	    if (warnedStyleValues.hasOwnProperty(value) && warnedStyleValues[value]) {
	      return;
	    }
	
	    warnedStyleValues[value] = true;
	    process.env.NODE_ENV !== 'production' ? warning(false, 'Style property values shouldn\'t contain a semicolon.%s ' + 'Try "%s: %s" instead.', checkRenderMessage(owner), name, value.replace(badStyleValueWithSemicolonPattern, '')) : void 0;
	  };
	
	  var warnStyleValueIsNaN = function (name, value, owner) {
	    if (warnedForNaNValue) {
	      return;
	    }
	
	    warnedForNaNValue = true;
	    process.env.NODE_ENV !== 'production' ? warning(false, '`NaN` is an invalid value for the `%s` css style property.%s', name, checkRenderMessage(owner)) : void 0;
	  };
	
	  var checkRenderMessage = function (owner) {
	    if (owner) {
	      var name = owner.getName();
	      if (name) {
	        return ' Check the render method of `' + name + '`.';
	      }
	    }
	    return '';
	  };
	
	  /**
	   * @param {string} name
	   * @param {*} value
	   * @param {ReactDOMComponent} component
	   */
	  var warnValidStyle = function (name, value, component) {
	    var owner;
	    if (component) {
	      owner = component._currentElement._owner;
	    }
	    if (name.indexOf('-') > -1) {
	      warnHyphenatedStyleName(name, owner);
	    } else if (badVendoredStyleNamePattern.test(name)) {
	      warnBadVendoredStyleName(name, owner);
	    } else if (badStyleValueWithSemicolonPattern.test(value)) {
	      warnStyleValueWithSemicolon(name, value, owner);
	    }
	
	    if (typeof value === 'number' && isNaN(value)) {
	      warnStyleValueIsNaN(name, value, owner);
	    }
	  };
	}
	
	/**
	 * Operations for dealing with CSS properties.
	 */
	var CSSPropertyOperations = {
	
	  /**
	   * Serializes a mapping of style properties for use as inline styles:
	   *
	   *   > createMarkupForStyles({width: '200px', height: 0})
	   *   "width:200px;height:0;"
	   *
	   * Undefined values are ignored so that declarative programming is easier.
	   * The result should be HTML-escaped before insertion into the DOM.
	   *
	   * @param {object} styles
	   * @param {ReactDOMComponent} component
	   * @return {?string}
	   */
	  createMarkupForStyles: function (styles, component) {
	    var serialized = '';
	    for (var styleName in styles) {
	      if (!styles.hasOwnProperty(styleName)) {
	        continue;
	      }
	      var styleValue = styles[styleName];
	      if (false) {
	        warnValidStyle(styleName, styleValue, component);
	      }
	      if (styleValue != null) {
	        serialized += processStyleName(styleName) + ':';
	        serialized += dangerousStyleValue(styleName, styleValue, component) + ';';
	      }
	    }
	    return serialized || null;
	  },
	
	  /**
	   * Sets the value for multiple styles on a node.  If a value is specified as
	   * '' (empty string), the corresponding style property will be unset.
	   *
	   * @param {DOMElement} node
	   * @param {object} styles
	   * @param {ReactDOMComponent} component
	   */
	  setValueForStyles: function (node, styles, component) {
	    if (false) {
	      ReactInstrumentation.debugTool.onHostOperation(component._debugID, 'update styles', styles);
	    }
	
	    var style = node.style;
	    for (var styleName in styles) {
	      if (!styles.hasOwnProperty(styleName)) {
	        continue;
	      }
	      if (false) {
	        warnValidStyle(styleName, styles[styleName], component);
	      }
	      var styleValue = dangerousStyleValue(styleName, styles[styleName], component);
	      if (styleName === 'float' || styleName === 'cssFloat') {
	        styleName = styleFloatAccessor;
	      }
	      if (styleValue) {
	        style[styleName] = styleValue;
	      } else {
	        var expansion = hasShorthandPropertyBug && CSSProperty.shorthandPropertyExpansions[styleName];
	        if (expansion) {
	          // Shorthand property that IE8 won't like unsetting, so unset each
	          // component to placate it
	          for (var individualStyleName in expansion) {
	            style[individualStyleName] = '';
	          }
	        } else {
	          style[styleName] = '';
	        }
	      }
	    }
	  }
	
	};
	
	module.exports = CSSPropertyOperations;

/***/ },
/* 741 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ChangeEventPlugin
	 */
	
	'use strict';
	
	var EventConstants = __webpack_require__(52);
	var EventPluginHub = __webpack_require__(99);
	var EventPropagators = __webpack_require__(100);
	var ExecutionEnvironment = __webpack_require__(22);
	var ReactDOMComponentTree = __webpack_require__(15);
	var ReactUpdates = __webpack_require__(46);
	var SyntheticEvent = __webpack_require__(53);
	
	var getEventTarget = __webpack_require__(210);
	var isEventSupported = __webpack_require__(211);
	var isTextInputElement = __webpack_require__(337);
	var keyOf = __webpack_require__(50);
	
	var topLevelTypes = EventConstants.topLevelTypes;
	
	var eventTypes = {
	  change: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onChange: null }),
	      captured: keyOf({ onChangeCapture: null })
	    },
	    dependencies: [topLevelTypes.topBlur, topLevelTypes.topChange, topLevelTypes.topClick, topLevelTypes.topFocus, topLevelTypes.topInput, topLevelTypes.topKeyDown, topLevelTypes.topKeyUp, topLevelTypes.topSelectionChange]
	  }
	};
	
	/**
	 * For IE shims
	 */
	var activeElement = null;
	var activeElementInst = null;
	var activeElementValue = null;
	var activeElementValueProp = null;
	
	/**
	 * SECTION: handle `change` event
	 */
	function shouldUseChangeEvent(elem) {
	  var nodeName = elem.nodeName && elem.nodeName.toLowerCase();
	  return nodeName === 'select' || nodeName === 'input' && elem.type === 'file';
	}
	
	var doesChangeEventBubble = false;
	if (ExecutionEnvironment.canUseDOM) {
	  // See `handleChange` comment below
	  doesChangeEventBubble = isEventSupported('change') && (!('documentMode' in document) || document.documentMode > 8);
	}
	
	function manualDispatchChangeEvent(nativeEvent) {
	  var event = SyntheticEvent.getPooled(eventTypes.change, activeElementInst, nativeEvent, getEventTarget(nativeEvent));
	  EventPropagators.accumulateTwoPhaseDispatches(event);
	
	  // If change and propertychange bubbled, we'd just bind to it like all the
	  // other events and have it go through ReactBrowserEventEmitter. Since it
	  // doesn't, we manually listen for the events and so we have to enqueue and
	  // process the abstract event manually.
	  //
	  // Batching is necessary here in order to ensure that all event handlers run
	  // before the next rerender (including event handlers attached to ancestor
	  // elements instead of directly on the input). Without this, controlled
	  // components don't work properly in conjunction with event bubbling because
	  // the component is rerendered and the value reverted before all the event
	  // handlers can run. See https://github.com/facebook/react/issues/708.
	  ReactUpdates.batchedUpdates(runEventInBatch, event);
	}
	
	function runEventInBatch(event) {
	  EventPluginHub.enqueueEvents(event);
	  EventPluginHub.processEventQueue(false);
	}
	
	function startWatchingForChangeEventIE8(target, targetInst) {
	  activeElement = target;
	  activeElementInst = targetInst;
	  activeElement.attachEvent('onchange', manualDispatchChangeEvent);
	}
	
	function stopWatchingForChangeEventIE8() {
	  if (!activeElement) {
	    return;
	  }
	  activeElement.detachEvent('onchange', manualDispatchChangeEvent);
	  activeElement = null;
	  activeElementInst = null;
	}
	
	function getTargetInstForChangeEvent(topLevelType, targetInst) {
	  if (topLevelType === topLevelTypes.topChange) {
	    return targetInst;
	  }
	}
	function handleEventsForChangeEventIE8(topLevelType, target, targetInst) {
	  if (topLevelType === topLevelTypes.topFocus) {
	    // stopWatching() should be a noop here but we call it just in case we
	    // missed a blur event somehow.
	    stopWatchingForChangeEventIE8();
	    startWatchingForChangeEventIE8(target, targetInst);
	  } else if (topLevelType === topLevelTypes.topBlur) {
	    stopWatchingForChangeEventIE8();
	  }
	}
	
	/**
	 * SECTION: handle `input` event
	 */
	var isInputEventSupported = false;
	if (ExecutionEnvironment.canUseDOM) {
	  // IE9 claims to support the input event but fails to trigger it when
	  // deleting text, so we ignore its input events.
	  // IE10+ fire input events to often, such when a placeholder
	  // changes or when an input with a placeholder is focused.
	  isInputEventSupported = isEventSupported('input') && (!('documentMode' in document) || document.documentMode > 11);
	}
	
	/**
	 * (For IE <=11) Replacement getter/setter for the `value` property that gets
	 * set on the active element.
	 */
	var newValueProp = {
	  get: function () {
	    return activeElementValueProp.get.call(this);
	  },
	  set: function (val) {
	    // Cast to a string so we can do equality checks.
	    activeElementValue = '' + val;
	    activeElementValueProp.set.call(this, val);
	  }
	};
	
	/**
	 * (For IE <=11) Starts tracking propertychange events on the passed-in element
	 * and override the value property so that we can distinguish user events from
	 * value changes in JS.
	 */
	function startWatchingForValueChange(target, targetInst) {
	  activeElement = target;
	  activeElementInst = targetInst;
	  activeElementValue = target.value;
	  activeElementValueProp = Object.getOwnPropertyDescriptor(target.constructor.prototype, 'value');
	
	  // Not guarded in a canDefineProperty check: IE8 supports defineProperty only
	  // on DOM elements
	  Object.defineProperty(activeElement, 'value', newValueProp);
	  if (activeElement.attachEvent) {
	    activeElement.attachEvent('onpropertychange', handlePropertyChange);
	  } else {
	    activeElement.addEventListener('propertychange', handlePropertyChange, false);
	  }
	}
	
	/**
	 * (For IE <=11) Removes the event listeners from the currently-tracked element,
	 * if any exists.
	 */
	function stopWatchingForValueChange() {
	  if (!activeElement) {
	    return;
	  }
	
	  // delete restores the original property definition
	  delete activeElement.value;
	
	  if (activeElement.detachEvent) {
	    activeElement.detachEvent('onpropertychange', handlePropertyChange);
	  } else {
	    activeElement.removeEventListener('propertychange', handlePropertyChange, false);
	  }
	
	  activeElement = null;
	  activeElementInst = null;
	  activeElementValue = null;
	  activeElementValueProp = null;
	}
	
	/**
	 * (For IE <=11) Handles a propertychange event, sending a `change` event if
	 * the value of the active element has changed.
	 */
	function handlePropertyChange(nativeEvent) {
	  if (nativeEvent.propertyName !== 'value') {
	    return;
	  }
	  var value = nativeEvent.srcElement.value;
	  if (value === activeElementValue) {
	    return;
	  }
	  activeElementValue = value;
	
	  manualDispatchChangeEvent(nativeEvent);
	}
	
	/**
	 * If a `change` event should be fired, returns the target's ID.
	 */
	function getTargetInstForInputEvent(topLevelType, targetInst) {
	  if (topLevelType === topLevelTypes.topInput) {
	    // In modern browsers (i.e., not IE8 or IE9), the input event is exactly
	    // what we want so fall through here and trigger an abstract event
	    return targetInst;
	  }
	}
	
	function handleEventsForInputEventIE(topLevelType, target, targetInst) {
	  if (topLevelType === topLevelTypes.topFocus) {
	    // In IE8, we can capture almost all .value changes by adding a
	    // propertychange handler and looking for events with propertyName
	    // equal to 'value'
	    // In IE9-11, propertychange fires for most input events but is buggy and
	    // doesn't fire when text is deleted, but conveniently, selectionchange
	    // appears to fire in all of the remaining cases so we catch those and
	    // forward the event if the value has changed
	    // In either case, we don't want to call the event handler if the value
	    // is changed from JS so we redefine a setter for `.value` that updates
	    // our activeElementValue variable, allowing us to ignore those changes
	    //
	    // stopWatching() should be a noop here but we call it just in case we
	    // missed a blur event somehow.
	    stopWatchingForValueChange();
	    startWatchingForValueChange(target, targetInst);
	  } else if (topLevelType === topLevelTypes.topBlur) {
	    stopWatchingForValueChange();
	  }
	}
	
	// For IE8 and IE9.
	function getTargetInstForInputEventIE(topLevelType, targetInst) {
	  if (topLevelType === topLevelTypes.topSelectionChange || topLevelType === topLevelTypes.topKeyUp || topLevelType === topLevelTypes.topKeyDown) {
	    // On the selectionchange event, the target is just document which isn't
	    // helpful for us so just check activeElement instead.
	    //
	    // 99% of the time, keydown and keyup aren't necessary. IE8 fails to fire
	    // propertychange on the first input event after setting `value` from a
	    // script and fires only keydown, keypress, keyup. Catching keyup usually
	    // gets it and catching keydown lets us fire an event for the first
	    // keystroke if user does a key repeat (it'll be a little delayed: right
	    // before the second keystroke). Other input methods (e.g., paste) seem to
	    // fire selectionchange normally.
	    if (activeElement && activeElement.value !== activeElementValue) {
	      activeElementValue = activeElement.value;
	      return activeElementInst;
	    }
	  }
	}
	
	/**
	 * SECTION: handle `click` event
	 */
	function shouldUseClickEvent(elem) {
	  // Use the `click` event to detect changes to checkbox and radio inputs.
	  // This approach works across all browsers, whereas `change` does not fire
	  // until `blur` in IE8.
	  return elem.nodeName && elem.nodeName.toLowerCase() === 'input' && (elem.type === 'checkbox' || elem.type === 'radio');
	}
	
	function getTargetInstForClickEvent(topLevelType, targetInst) {
	  if (topLevelType === topLevelTypes.topClick) {
	    return targetInst;
	  }
	}
	
	/**
	 * This plugin creates an `onChange` event that normalizes change events
	 * across form elements. This event fires at a time when it's possible to
	 * change the element's value without seeing a flicker.
	 *
	 * Supported elements are:
	 * - input (see `isTextInputElement`)
	 * - textarea
	 * - select
	 */
	var ChangeEventPlugin = {
	
	  eventTypes: eventTypes,
	
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    var targetNode = targetInst ? ReactDOMComponentTree.getNodeFromInstance(targetInst) : window;
	
	    var getTargetInstFunc, handleEventFunc;
	    if (shouldUseChangeEvent(targetNode)) {
	      if (doesChangeEventBubble) {
	        getTargetInstFunc = getTargetInstForChangeEvent;
	      } else {
	        handleEventFunc = handleEventsForChangeEventIE8;
	      }
	    } else if (isTextInputElement(targetNode)) {
	      if (isInputEventSupported) {
	        getTargetInstFunc = getTargetInstForInputEvent;
	      } else {
	        getTargetInstFunc = getTargetInstForInputEventIE;
	        handleEventFunc = handleEventsForInputEventIE;
	      }
	    } else if (shouldUseClickEvent(targetNode)) {
	      getTargetInstFunc = getTargetInstForClickEvent;
	    }
	
	    if (getTargetInstFunc) {
	      var inst = getTargetInstFunc(topLevelType, targetInst);
	      if (inst) {
	        var event = SyntheticEvent.getPooled(eventTypes.change, inst, nativeEvent, nativeEventTarget);
	        event.type = 'change';
	        EventPropagators.accumulateTwoPhaseDispatches(event);
	        return event;
	      }
	    }
	
	    if (handleEventFunc) {
	      handleEventFunc(topLevelType, targetNode, targetInst);
	    }
	  }
	
	};
	
	module.exports = ChangeEventPlugin;

/***/ },
/* 742 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule Danger
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(5);
	
	var DOMLazyTree = __webpack_require__(89);
	var ExecutionEnvironment = __webpack_require__(22);
	
	var createNodesFromMarkup = __webpack_require__(542);
	var emptyFunction = __webpack_require__(37);
	var invariant = __webpack_require__(2);
	
	var Danger = {
	
	  /**
	   * Replaces a node with a string of markup at its current position within its
	   * parent. The markup must render into a single root node.
	   *
	   * @param {DOMElement} oldChild Child node to replace.
	   * @param {string} markup Markup to render in place of the child node.
	   * @internal
	   */
	  dangerouslyReplaceNodeWithMarkup: function (oldChild, markup) {
	    !ExecutionEnvironment.canUseDOM ?  false ? invariant(false, 'dangerouslyReplaceNodeWithMarkup(...): Cannot render markup in a worker thread. Make sure `window` and `document` are available globally before requiring React when unit testing or use ReactDOMServer.renderToString() for server rendering.') : _prodInvariant('56') : void 0;
	    !markup ?  false ? invariant(false, 'dangerouslyReplaceNodeWithMarkup(...): Missing markup.') : _prodInvariant('57') : void 0;
	    !(oldChild.nodeName !== 'HTML') ?  false ? invariant(false, 'dangerouslyReplaceNodeWithMarkup(...): Cannot replace markup of the <html> node. This is because browser quirks make this unreliable and/or slow. If you want to render to the root you must use server rendering. See ReactDOMServer.renderToString().') : _prodInvariant('58') : void 0;
	
	    if (typeof markup === 'string') {
	      var newChild = createNodesFromMarkup(markup, emptyFunction)[0];
	      oldChild.parentNode.replaceChild(newChild, oldChild);
	    } else {
	      DOMLazyTree.replaceChildWithTree(oldChild, markup);
	    }
	  }
	
	};
	
	module.exports = Danger;

/***/ },
/* 743 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule DefaultEventPluginOrder
	 */
	
	'use strict';
	
	var keyOf = __webpack_require__(50);
	
	/**
	 * Module that is injectable into `EventPluginHub`, that specifies a
	 * deterministic ordering of `EventPlugin`s. A convenient way to reason about
	 * plugins, without having to package every one of them. This is better than
	 * having plugins be ordered in the same order that they are injected because
	 * that ordering would be influenced by the packaging order.
	 * `ResponderEventPlugin` must occur before `SimpleEventPlugin` so that
	 * preventing default on events is convenient in `SimpleEventPlugin` handlers.
	 */
	var DefaultEventPluginOrder = [keyOf({ ResponderEventPlugin: null }), keyOf({ SimpleEventPlugin: null }), keyOf({ TapEventPlugin: null }), keyOf({ EnterLeaveEventPlugin: null }), keyOf({ ChangeEventPlugin: null }), keyOf({ SelectEventPlugin: null }), keyOf({ BeforeInputEventPlugin: null })];
	
	module.exports = DefaultEventPluginOrder;

/***/ },
/* 744 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule EnterLeaveEventPlugin
	 */
	
	'use strict';
	
	var EventConstants = __webpack_require__(52);
	var EventPropagators = __webpack_require__(100);
	var ReactDOMComponentTree = __webpack_require__(15);
	var SyntheticMouseEvent = __webpack_require__(141);
	
	var keyOf = __webpack_require__(50);
	
	var topLevelTypes = EventConstants.topLevelTypes;
	
	var eventTypes = {
	  mouseEnter: {
	    registrationName: keyOf({ onMouseEnter: null }),
	    dependencies: [topLevelTypes.topMouseOut, topLevelTypes.topMouseOver]
	  },
	  mouseLeave: {
	    registrationName: keyOf({ onMouseLeave: null }),
	    dependencies: [topLevelTypes.topMouseOut, topLevelTypes.topMouseOver]
	  }
	};
	
	var EnterLeaveEventPlugin = {
	
	  eventTypes: eventTypes,
	
	  /**
	   * For almost every interaction we care about, there will be both a top-level
	   * `mouseover` and `mouseout` event that occurs. Only use `mouseout` so that
	   * we do not extract duplicate events. However, moving the mouse into the
	   * browser from outside will not fire a `mouseout` event. In this case, we use
	   * the `mouseover` top-level event.
	   */
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    if (topLevelType === topLevelTypes.topMouseOver && (nativeEvent.relatedTarget || nativeEvent.fromElement)) {
	      return null;
	    }
	    if (topLevelType !== topLevelTypes.topMouseOut && topLevelType !== topLevelTypes.topMouseOver) {
	      // Must not be a mouse in or mouse out - ignoring.
	      return null;
	    }
	
	    var win;
	    if (nativeEventTarget.window === nativeEventTarget) {
	      // `nativeEventTarget` is probably a window object.
	      win = nativeEventTarget;
	    } else {
	      // TODO: Figure out why `ownerDocument` is sometimes undefined in IE8.
	      var doc = nativeEventTarget.ownerDocument;
	      if (doc) {
	        win = doc.defaultView || doc.parentWindow;
	      } else {
	        win = window;
	      }
	    }
	
	    var from;
	    var to;
	    if (topLevelType === topLevelTypes.topMouseOut) {
	      from = targetInst;
	      var related = nativeEvent.relatedTarget || nativeEvent.toElement;
	      to = related ? ReactDOMComponentTree.getClosestInstanceFromNode(related) : null;
	    } else {
	      // Moving to a node from outside the window.
	      from = null;
	      to = targetInst;
	    }
	
	    if (from === to) {
	      // Nothing pertains to our managed components.
	      return null;
	    }
	
	    var fromNode = from == null ? win : ReactDOMComponentTree.getNodeFromInstance(from);
	    var toNode = to == null ? win : ReactDOMComponentTree.getNodeFromInstance(to);
	
	    var leave = SyntheticMouseEvent.getPooled(eventTypes.mouseLeave, from, nativeEvent, nativeEventTarget);
	    leave.type = 'mouseleave';
	    leave.target = fromNode;
	    leave.relatedTarget = toNode;
	
	    var enter = SyntheticMouseEvent.getPooled(eventTypes.mouseEnter, to, nativeEvent, nativeEventTarget);
	    enter.type = 'mouseenter';
	    enter.target = toNode;
	    enter.relatedTarget = fromNode;
	
	    EventPropagators.accumulateEnterLeaveDispatches(leave, enter, from, to);
	
	    return [leave, enter];
	  }
	
	};
	
	module.exports = EnterLeaveEventPlugin;

/***/ },
/* 745 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule FallbackCompositionState
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(6);
	
	var PooledClass = __webpack_require__(62);
	
	var getTextContentAccessor = __webpack_require__(335);
	
	/**
	 * This helper class stores information about text content of a target node,
	 * allowing comparison of content before and after a given event.
	 *
	 * Identify the node where selection currently begins, then observe
	 * both its text content and its current position in the DOM. Since the
	 * browser may natively replace the target node during composition, we can
	 * use its position to find its replacement.
	 *
	 * @param {DOMEventTarget} root
	 */
	function FallbackCompositionState(root) {
	  this._root = root;
	  this._startText = this.getText();
	  this._fallbackText = null;
	}
	
	_assign(FallbackCompositionState.prototype, {
	  destructor: function () {
	    this._root = null;
	    this._startText = null;
	    this._fallbackText = null;
	  },
	
	  /**
	   * Get current text of input.
	   *
	   * @return {string}
	   */
	  getText: function () {
	    if ('value' in this._root) {
	      return this._root.value;
	    }
	    return this._root[getTextContentAccessor()];
	  },
	
	  /**
	   * Determine the differing substring between the initially stored
	   * text content and the current content.
	   *
	   * @return {string}
	   */
	  getData: function () {
	    if (this._fallbackText) {
	      return this._fallbackText;
	    }
	
	    var start;
	    var startValue = this._startText;
	    var startLength = startValue.length;
	    var end;
	    var endValue = this.getText();
	    var endLength = endValue.length;
	
	    for (start = 0; start < startLength; start++) {
	      if (startValue[start] !== endValue[start]) {
	        break;
	      }
	    }
	
	    var minEnd = startLength - start;
	    for (end = 1; end <= minEnd; end++) {
	      if (startValue[startLength - end] !== endValue[endLength - end]) {
	        break;
	      }
	    }
	
	    var sliceTail = end > 1 ? 1 - end : undefined;
	    this._fallbackText = endValue.slice(start, sliceTail);
	    return this._fallbackText;
	  }
	});
	
	PooledClass.addPoolingTo(FallbackCompositionState);
	
	module.exports = FallbackCompositionState;

/***/ },
/* 746 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule HTMLDOMPropertyConfig
	 */
	
	'use strict';
	
	var DOMProperty = __webpack_require__(90);
	
	var MUST_USE_PROPERTY = DOMProperty.injection.MUST_USE_PROPERTY;
	var HAS_BOOLEAN_VALUE = DOMProperty.injection.HAS_BOOLEAN_VALUE;
	var HAS_NUMERIC_VALUE = DOMProperty.injection.HAS_NUMERIC_VALUE;
	var HAS_POSITIVE_NUMERIC_VALUE = DOMProperty.injection.HAS_POSITIVE_NUMERIC_VALUE;
	var HAS_OVERLOADED_BOOLEAN_VALUE = DOMProperty.injection.HAS_OVERLOADED_BOOLEAN_VALUE;
	
	var HTMLDOMPropertyConfig = {
	  isCustomAttribute: RegExp.prototype.test.bind(new RegExp('^(data|aria)-[' + DOMProperty.ATTRIBUTE_NAME_CHAR + ']*$')),
	  Properties: {
	    /**
	     * Standard Properties
	     */
	    accept: 0,
	    acceptCharset: 0,
	    accessKey: 0,
	    action: 0,
	    allowFullScreen: HAS_BOOLEAN_VALUE,
	    allowTransparency: 0,
	    alt: 0,
	    async: HAS_BOOLEAN_VALUE,
	    autoComplete: 0,
	    // autoFocus is polyfilled/normalized by AutoFocusUtils
	    // autoFocus: HAS_BOOLEAN_VALUE,
	    autoPlay: HAS_BOOLEAN_VALUE,
	    capture: HAS_BOOLEAN_VALUE,
	    cellPadding: 0,
	    cellSpacing: 0,
	    charSet: 0,
	    challenge: 0,
	    checked: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	    cite: 0,
	    classID: 0,
	    className: 0,
	    cols: HAS_POSITIVE_NUMERIC_VALUE,
	    colSpan: 0,
	    content: 0,
	    contentEditable: 0,
	    contextMenu: 0,
	    controls: HAS_BOOLEAN_VALUE,
	    coords: 0,
	    crossOrigin: 0,
	    data: 0, // For `<object />` acts as `src`.
	    dateTime: 0,
	    'default': HAS_BOOLEAN_VALUE,
	    defer: HAS_BOOLEAN_VALUE,
	    dir: 0,
	    disabled: HAS_BOOLEAN_VALUE,
	    download: HAS_OVERLOADED_BOOLEAN_VALUE,
	    draggable: 0,
	    encType: 0,
	    form: 0,
	    formAction: 0,
	    formEncType: 0,
	    formMethod: 0,
	    formNoValidate: HAS_BOOLEAN_VALUE,
	    formTarget: 0,
	    frameBorder: 0,
	    headers: 0,
	    height: 0,
	    hidden: HAS_BOOLEAN_VALUE,
	    high: 0,
	    href: 0,
	    hrefLang: 0,
	    htmlFor: 0,
	    httpEquiv: 0,
	    icon: 0,
	    id: 0,
	    inputMode: 0,
	    integrity: 0,
	    is: 0,
	    keyParams: 0,
	    keyType: 0,
	    kind: 0,
	    label: 0,
	    lang: 0,
	    list: 0,
	    loop: HAS_BOOLEAN_VALUE,
	    low: 0,
	    manifest: 0,
	    marginHeight: 0,
	    marginWidth: 0,
	    max: 0,
	    maxLength: 0,
	    media: 0,
	    mediaGroup: 0,
	    method: 0,
	    min: 0,
	    minLength: 0,
	    // Caution; `option.selected` is not updated if `select.multiple` is
	    // disabled with `removeAttribute`.
	    multiple: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	    muted: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	    name: 0,
	    nonce: 0,
	    noValidate: HAS_BOOLEAN_VALUE,
	    open: HAS_BOOLEAN_VALUE,
	    optimum: 0,
	    pattern: 0,
	    placeholder: 0,
	    poster: 0,
	    preload: 0,
	    profile: 0,
	    radioGroup: 0,
	    readOnly: HAS_BOOLEAN_VALUE,
	    rel: 0,
	    required: HAS_BOOLEAN_VALUE,
	    reversed: HAS_BOOLEAN_VALUE,
	    role: 0,
	    rows: HAS_POSITIVE_NUMERIC_VALUE,
	    rowSpan: HAS_NUMERIC_VALUE,
	    sandbox: 0,
	    scope: 0,
	    scoped: HAS_BOOLEAN_VALUE,
	    scrolling: 0,
	    seamless: HAS_BOOLEAN_VALUE,
	    selected: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	    shape: 0,
	    size: HAS_POSITIVE_NUMERIC_VALUE,
	    sizes: 0,
	    span: HAS_POSITIVE_NUMERIC_VALUE,
	    spellCheck: 0,
	    src: 0,
	    srcDoc: 0,
	    srcLang: 0,
	    srcSet: 0,
	    start: HAS_NUMERIC_VALUE,
	    step: 0,
	    style: 0,
	    summary: 0,
	    tabIndex: 0,
	    target: 0,
	    title: 0,
	    // Setting .type throws on non-<input> tags
	    type: 0,
	    useMap: 0,
	    value: 0,
	    width: 0,
	    wmode: 0,
	    wrap: 0,
	
	    /**
	     * RDFa Properties
	     */
	    about: 0,
	    datatype: 0,
	    inlist: 0,
	    prefix: 0,
	    // property is also supported for OpenGraph in meta tags.
	    property: 0,
	    resource: 0,
	    'typeof': 0,
	    vocab: 0,
	
	    /**
	     * Non-standard Properties
	     */
	    // autoCapitalize and autoCorrect are supported in Mobile Safari for
	    // keyboard hints.
	    autoCapitalize: 0,
	    autoCorrect: 0,
	    // autoSave allows WebKit/Blink to persist values of input fields on page reloads
	    autoSave: 0,
	    // color is for Safari mask-icon link
	    color: 0,
	    // itemProp, itemScope, itemType are for
	    // Microdata support. See http://schema.org/docs/gs.html
	    itemProp: 0,
	    itemScope: HAS_BOOLEAN_VALUE,
	    itemType: 0,
	    // itemID and itemRef are for Microdata support as well but
	    // only specified in the WHATWG spec document. See
	    // https://html.spec.whatwg.org/multipage/microdata.html#microdata-dom-api
	    itemID: 0,
	    itemRef: 0,
	    // results show looking glass icon and recent searches on input
	    // search fields in WebKit/Blink
	    results: 0,
	    // IE-only attribute that specifies security restrictions on an iframe
	    // as an alternative to the sandbox attribute on IE<10
	    security: 0,
	    // IE-only attribute that controls focus behavior
	    unselectable: 0
	  },
	  DOMAttributeNames: {
	    acceptCharset: 'accept-charset',
	    className: 'class',
	    htmlFor: 'for',
	    httpEquiv: 'http-equiv'
	  },
	  DOMPropertyNames: {}
	};
	
	module.exports = HTMLDOMPropertyConfig;

/***/ },
/* 747 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule React
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(6);
	
	var ReactChildren = __webpack_require__(313);
	var ReactComponent = __webpack_require__(315);
	var ReactClass = __webpack_require__(314);
	var ReactDOMFactories = __webpack_require__(755);
	var ReactElement = __webpack_require__(45);
	var ReactPropTypes = __webpack_require__(327);
	var ReactVersion = __webpack_require__(328);
	
	var onlyChild = __webpack_require__(798);
	var warning = __webpack_require__(9);
	
	var createElement = ReactElement.createElement;
	var createFactory = ReactElement.createFactory;
	var cloneElement = ReactElement.cloneElement;
	
	if (false) {
	  var ReactElementValidator = require('./ReactElementValidator');
	  createElement = ReactElementValidator.createElement;
	  createFactory = ReactElementValidator.createFactory;
	  cloneElement = ReactElementValidator.cloneElement;
	}
	
	var __spread = _assign;
	
	if (false) {
	  var warned = false;
	  __spread = function () {
	    process.env.NODE_ENV !== 'production' ? warning(warned, 'React.__spread is deprecated and should not be used. Use ' + 'Object.assign directly or another helper function with similar ' + 'semantics. You may be seeing this warning due to your compiler. ' + 'See https://fb.me/react-spread-deprecation for more details.') : void 0;
	    warned = true;
	    return _assign.apply(null, arguments);
	  };
	}
	
	var React = {
	
	  // Modern
	
	  Children: {
	    map: ReactChildren.map,
	    forEach: ReactChildren.forEach,
	    count: ReactChildren.count,
	    toArray: ReactChildren.toArray,
	    only: onlyChild
	  },
	
	  Component: ReactComponent,
	
	  createElement: createElement,
	  cloneElement: cloneElement,
	  isValidElement: ReactElement.isValidElement,
	
	  // Classic
	
	  PropTypes: ReactPropTypes,
	  createClass: ReactClass.createClass,
	  createFactory: createFactory,
	  createMixin: function (mixin) {
	    // Currently a noop. Will be used to validate and trace mixins.
	    return mixin;
	  },
	
	  // This looks DOM specific but these are actually isomorphic helpers
	  // since they are just generating DOM strings.
	  DOM: ReactDOMFactories,
	
	  version: ReactVersion,
	
	  // Deprecated hook for JSX spread, don't use this for anything.
	  __spread: __spread
	};
	
	module.exports = React;

/***/ },
/* 748 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactChildReconciler
	 */
	
	'use strict';
	
	var ReactReconciler = __webpack_require__(91);
	
	var instantiateReactComponent = __webpack_require__(336);
	var KeyEscapeUtils = __webpack_require__(200);
	var shouldUpdateReactComponent = __webpack_require__(212);
	var traverseAllChildren = __webpack_require__(213);
	var warning = __webpack_require__(9);
	
	function instantiateChild(childInstances, child, name, selfDebugID) {
	  // We found a component instance.
	  var keyUnique = childInstances[name] === undefined;
	  if (false) {
	    var ReactComponentTreeDevtool = require('./ReactComponentTreeDevtool');
	    process.env.NODE_ENV !== 'production' ? warning(keyUnique, 'flattenChildren(...): Encountered two children with the same key, ' + '`%s`. Child keys must be unique; when two children share a key, only ' + 'the first child will be used.%s', KeyEscapeUtils.unescape(name), ReactComponentTreeDevtool.getStackAddendumByID(selfDebugID)) : void 0;
	  }
	  if (child != null && keyUnique) {
	    childInstances[name] = instantiateReactComponent(child, true);
	  }
	}
	
	/**
	 * ReactChildReconciler provides helpers for initializing or updating a set of
	 * children. Its output is suitable for passing it onto ReactMultiChild which
	 * does diffed reordering and insertion.
	 */
	var ReactChildReconciler = {
	  /**
	   * Generates a "mount image" for each of the supplied children. In the case
	   * of `ReactDOMComponent`, a mount image is a string of markup.
	   *
	   * @param {?object} nestedChildNodes Nested child maps.
	   * @return {?object} A set of child instances.
	   * @internal
	   */
	  instantiateChildren: function (nestedChildNodes, transaction, context, selfDebugID // __DEV__ only
	  ) {
	    if (nestedChildNodes == null) {
	      return null;
	    }
	    var childInstances = {};
	
	    if (false) {
	      traverseAllChildren(nestedChildNodes, function (childInsts, child, name) {
	        return instantiateChild(childInsts, child, name, selfDebugID);
	      }, childInstances);
	    } else {
	      traverseAllChildren(nestedChildNodes, instantiateChild, childInstances);
	    }
	    return childInstances;
	  },
	
	  /**
	   * Updates the rendered children and returns a new set of children.
	   *
	   * @param {?object} prevChildren Previously initialized set of children.
	   * @param {?object} nextChildren Flat child element maps.
	   * @param {ReactReconcileTransaction} transaction
	   * @param {object} context
	   * @return {?object} A new set of child instances.
	   * @internal
	   */
	  updateChildren: function (prevChildren, nextChildren, removedNodes, transaction, context) {
	    // We currently don't have a way to track moves here but if we use iterators
	    // instead of for..in we can zip the iterators and check if an item has
	    // moved.
	    // TODO: If nothing has changed, return the prevChildren object so that we
	    // can quickly bailout if nothing has changed.
	    if (!nextChildren && !prevChildren) {
	      return;
	    }
	    var name;
	    var prevChild;
	    for (name in nextChildren) {
	      if (!nextChildren.hasOwnProperty(name)) {
	        continue;
	      }
	      prevChild = prevChildren && prevChildren[name];
	      var prevElement = prevChild && prevChild._currentElement;
	      var nextElement = nextChildren[name];
	      if (prevChild != null && shouldUpdateReactComponent(prevElement, nextElement)) {
	        ReactReconciler.receiveComponent(prevChild, nextElement, transaction, context);
	        nextChildren[name] = prevChild;
	      } else {
	        if (prevChild) {
	          removedNodes[name] = ReactReconciler.getHostNode(prevChild);
	          ReactReconciler.unmountComponent(prevChild, false);
	        }
	        // The child must be instantiated before it's mounted.
	        var nextChildInstance = instantiateReactComponent(nextElement, true);
	        nextChildren[name] = nextChildInstance;
	      }
	    }
	    // Unmount children that are no longer present.
	    for (name in prevChildren) {
	      if (prevChildren.hasOwnProperty(name) && !(nextChildren && nextChildren.hasOwnProperty(name))) {
	        prevChild = prevChildren[name];
	        removedNodes[name] = ReactReconciler.getHostNode(prevChild);
	        ReactReconciler.unmountComponent(prevChild, false);
	      }
	    }
	  },
	
	  /**
	   * Unmounts all rendered children. This should be used to clean up children
	   * when this component is unmounted.
	   *
	   * @param {?object} renderedChildren Previously initialized set of children.
	   * @internal
	   */
	  unmountChildren: function (renderedChildren, safely) {
	    for (var name in renderedChildren) {
	      if (renderedChildren.hasOwnProperty(name)) {
	        var renderedChild = renderedChildren[name];
	        ReactReconciler.unmountComponent(renderedChild, safely);
	      }
	    }
	  }
	
	};
	
	module.exports = ReactChildReconciler;

/***/ },
/* 749 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactCompositeComponent
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(5),
	    _assign = __webpack_require__(6);
	
	var ReactComponentEnvironment = __webpack_require__(202);
	var ReactCurrentOwner = __webpack_require__(75);
	var ReactElement = __webpack_require__(45);
	var ReactErrorUtils = __webpack_require__(203);
	var ReactInstanceMap = __webpack_require__(101);
	var ReactInstrumentation = __webpack_require__(31);
	var ReactNodeTypes = __webpack_require__(325);
	var ReactPropTypeLocations = __webpack_require__(205);
	var ReactReconciler = __webpack_require__(91);
	
	var checkReactTypeSpec = __webpack_require__(791);
	
	var emptyObject = __webpack_require__(116);
	var invariant = __webpack_require__(2);
	var shouldUpdateReactComponent = __webpack_require__(212);
	var warning = __webpack_require__(9);
	
	function StatelessComponent(Component) {}
	StatelessComponent.prototype.render = function () {
	  var Component = ReactInstanceMap.get(this)._currentElement.type;
	  var element = Component(this.props, this.context, this.updater);
	  warnIfInvalidElement(Component, element);
	  return element;
	};
	
	function warnIfInvalidElement(Component, element) {
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(element === null || element === false || ReactElement.isValidElement(element), '%s(...): A valid React element (or null) must be returned. You may have ' + 'returned undefined, an array or some other invalid object.', Component.displayName || Component.name || 'Component') : void 0;
	    process.env.NODE_ENV !== 'production' ? warning(!Component.childContextTypes, '%s(...): childContextTypes cannot be defined on a functional component.', Component.displayName || Component.name || 'Component') : void 0;
	  }
	}
	
	function invokeComponentDidMountWithTimer() {
	  var publicInstance = this._instance;
	  if (this._debugID !== 0) {
	    ReactInstrumentation.debugTool.onBeginLifeCycleTimer(this._debugID, 'componentDidMount');
	  }
	  publicInstance.componentDidMount();
	  if (this._debugID !== 0) {
	    ReactInstrumentation.debugTool.onEndLifeCycleTimer(this._debugID, 'componentDidMount');
	  }
	}
	
	function invokeComponentDidUpdateWithTimer(prevProps, prevState, prevContext) {
	  var publicInstance = this._instance;
	  if (this._debugID !== 0) {
	    ReactInstrumentation.debugTool.onBeginLifeCycleTimer(this._debugID, 'componentDidUpdate');
	  }
	  publicInstance.componentDidUpdate(prevProps, prevState, prevContext);
	  if (this._debugID !== 0) {
	    ReactInstrumentation.debugTool.onEndLifeCycleTimer(this._debugID, 'componentDidUpdate');
	  }
	}
	
	function shouldConstruct(Component) {
	  return Component.prototype && Component.prototype.isReactComponent;
	}
	
	/**
	 * ------------------ The Life-Cycle of a Composite Component ------------------
	 *
	 * - constructor: Initialization of state. The instance is now retained.
	 *   - componentWillMount
	 *   - render
	 *   - [children's constructors]
	 *     - [children's componentWillMount and render]
	 *     - [children's componentDidMount]
	 *     - componentDidMount
	 *
	 *       Update Phases:
	 *       - componentWillReceiveProps (only called if parent updated)
	 *       - shouldComponentUpdate
	 *         - componentWillUpdate
	 *           - render
	 *           - [children's constructors or receive props phases]
	 *         - componentDidUpdate
	 *
	 *     - componentWillUnmount
	 *     - [children's componentWillUnmount]
	 *   - [children destroyed]
	 * - (destroyed): The instance is now blank, released by React and ready for GC.
	 *
	 * -----------------------------------------------------------------------------
	 */
	
	/**
	 * An incrementing ID assigned to each component when it is mounted. This is
	 * used to enforce the order in which `ReactUpdates` updates dirty components.
	 *
	 * @private
	 */
	var nextMountID = 1;
	
	/**
	 * @lends {ReactCompositeComponent.prototype}
	 */
	var ReactCompositeComponentMixin = {
	
	  /**
	   * Base constructor for all composite component.
	   *
	   * @param {ReactElement} element
	   * @final
	   * @internal
	   */
	  construct: function (element) {
	    this._currentElement = element;
	    this._rootNodeID = null;
	    this._instance = null;
	    this._hostParent = null;
	    this._hostContainerInfo = null;
	
	    // See ReactUpdateQueue
	    this._updateBatchNumber = null;
	    this._pendingElement = null;
	    this._pendingStateQueue = null;
	    this._pendingReplaceState = false;
	    this._pendingForceUpdate = false;
	
	    this._renderedNodeType = null;
	    this._renderedComponent = null;
	    this._context = null;
	    this._mountOrder = 0;
	    this._topLevelWrapper = null;
	
	    // See ReactUpdates and ReactUpdateQueue.
	    this._pendingCallbacks = null;
	
	    // ComponentWillUnmount shall only be called once
	    this._calledComponentWillUnmount = false;
	
	    if (false) {
	      this._warnedAboutRefsInRender = false;
	    }
	  },
	
	  /**
	   * Initializes the component, renders markup, and registers event listeners.
	   *
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {?object} hostParent
	   * @param {?object} hostContainerInfo
	   * @param {?object} context
	   * @return {?string} Rendered markup to be inserted into the DOM.
	   * @final
	   * @internal
	   */
	  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
	    this._context = context;
	    this._mountOrder = nextMountID++;
	    this._hostParent = hostParent;
	    this._hostContainerInfo = hostContainerInfo;
	
	    var publicProps = this._currentElement.props;
	    var publicContext = this._processContext(context);
	
	    var Component = this._currentElement.type;
	
	    var updateQueue = transaction.getUpdateQueue();
	
	    // Initialize the public class
	    var inst = this._constructComponent(publicProps, publicContext, updateQueue);
	    var renderedElement;
	
	    // Support functional components
	    if (!shouldConstruct(Component) && (inst == null || inst.render == null)) {
	      renderedElement = inst;
	      warnIfInvalidElement(Component, renderedElement);
	      !(inst === null || inst === false || ReactElement.isValidElement(inst)) ?  false ? invariant(false, '%s(...): A valid React element (or null) must be returned. You may have returned undefined, an array or some other invalid object.', Component.displayName || Component.name || 'Component') : _prodInvariant('105', Component.displayName || Component.name || 'Component') : void 0;
	      inst = new StatelessComponent(Component);
	    }
	
	    if (false) {
	      // This will throw later in _renderValidatedComponent, but add an early
	      // warning now to help debugging
	      if (inst.render == null) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '%s(...): No `render` method found on the returned component ' + 'instance: you may have forgotten to define `render`.', Component.displayName || Component.name || 'Component') : void 0;
	      }
	
	      var propsMutated = inst.props !== publicProps;
	      var componentName = Component.displayName || Component.name || 'Component';
	
	      process.env.NODE_ENV !== 'production' ? warning(inst.props === undefined || !propsMutated, '%s(...): When calling super() in `%s`, make sure to pass ' + 'up the same props that your component\'s constructor was passed.', componentName, componentName) : void 0;
	    }
	
	    // These should be set up in the constructor, but as a convenience for
	    // simpler class abstractions, we set them up after the fact.
	    inst.props = publicProps;
	    inst.context = publicContext;
	    inst.refs = emptyObject;
	    inst.updater = updateQueue;
	
	    this._instance = inst;
	
	    // Store a reference from the instance back to the internal representation
	    ReactInstanceMap.set(inst, this);
	
	    if (false) {
	      // Since plain JS classes are defined without any special initialization
	      // logic, we can not catch common errors early. Therefore, we have to
	      // catch them here, at initialization time, instead.
	      process.env.NODE_ENV !== 'production' ? warning(!inst.getInitialState || inst.getInitialState.isReactClassApproved, 'getInitialState was defined on %s, a plain JavaScript class. ' + 'This is only supported for classes created using React.createClass. ' + 'Did you mean to define a state property instead?', this.getName() || 'a component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(!inst.getDefaultProps || inst.getDefaultProps.isReactClassApproved, 'getDefaultProps was defined on %s, a plain JavaScript class. ' + 'This is only supported for classes created using React.createClass. ' + 'Use a static property to define defaultProps instead.', this.getName() || 'a component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(!inst.propTypes, 'propTypes was defined as an instance property on %s. Use a static ' + 'property to define propTypes instead.', this.getName() || 'a component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(!inst.contextTypes, 'contextTypes was defined as an instance property on %s. Use a ' + 'static property to define contextTypes instead.', this.getName() || 'a component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(typeof inst.componentShouldUpdate !== 'function', '%s has a method called ' + 'componentShouldUpdate(). Did you mean shouldComponentUpdate()? ' + 'The name is phrased as a question because the function is ' + 'expected to return a value.', this.getName() || 'A component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(typeof inst.componentDidUnmount !== 'function', '%s has a method called ' + 'componentDidUnmount(). But there is no such lifecycle method. ' + 'Did you mean componentWillUnmount()?', this.getName() || 'A component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(typeof inst.componentWillRecieveProps !== 'function', '%s has a method called ' + 'componentWillRecieveProps(). Did you mean componentWillReceiveProps()?', this.getName() || 'A component') : void 0;
	    }
	
	    var initialState = inst.state;
	    if (initialState === undefined) {
	      inst.state = initialState = null;
	    }
	    !(typeof initialState === 'object' && !Array.isArray(initialState)) ?  false ? invariant(false, '%s.state: must be set to an object or null', this.getName() || 'ReactCompositeComponent') : _prodInvariant('106', this.getName() || 'ReactCompositeComponent') : void 0;
	
	    this._pendingStateQueue = null;
	    this._pendingReplaceState = false;
	    this._pendingForceUpdate = false;
	
	    var markup;
	    if (inst.unstable_handleError) {
	      markup = this.performInitialMountWithErrorHandling(renderedElement, hostParent, hostContainerInfo, transaction, context);
	    } else {
	      markup = this.performInitialMount(renderedElement, hostParent, hostContainerInfo, transaction, context);
	    }
	
	    if (inst.componentDidMount) {
	      if (false) {
	        transaction.getReactMountReady().enqueue(invokeComponentDidMountWithTimer, this);
	      } else {
	        transaction.getReactMountReady().enqueue(inst.componentDidMount, inst);
	      }
	    }
	
	    return markup;
	  },
	
	  _constructComponent: function (publicProps, publicContext, updateQueue) {
	    if (false) {
	      ReactCurrentOwner.current = this;
	      try {
	        return this._constructComponentWithoutOwner(publicProps, publicContext, updateQueue);
	      } finally {
	        ReactCurrentOwner.current = null;
	      }
	    } else {
	      return this._constructComponentWithoutOwner(publicProps, publicContext, updateQueue);
	    }
	  },
	
	  _constructComponentWithoutOwner: function (publicProps, publicContext, updateQueue) {
	    var Component = this._currentElement.type;
	    var instanceOrElement;
	    if (shouldConstruct(Component)) {
	      if (false) {
	        if (this._debugID !== 0) {
	          ReactInstrumentation.debugTool.onBeginLifeCycleTimer(this._debugID, 'ctor');
	        }
	      }
	      instanceOrElement = new Component(publicProps, publicContext, updateQueue);
	      if (false) {
	        if (this._debugID !== 0) {
	          ReactInstrumentation.debugTool.onEndLifeCycleTimer(this._debugID, 'ctor');
	        }
	      }
	    } else {
	      // This can still be an instance in case of factory components
	      // but we'll count this as time spent rendering as the more common case.
	      if (false) {
	        if (this._debugID !== 0) {
	          ReactInstrumentation.debugTool.onBeginLifeCycleTimer(this._debugID, 'render');
	        }
	      }
	      instanceOrElement = Component(publicProps, publicContext, updateQueue);
	      if (false) {
	        if (this._debugID !== 0) {
	          ReactInstrumentation.debugTool.onEndLifeCycleTimer(this._debugID, 'render');
	        }
	      }
	    }
	    return instanceOrElement;
	  },
	
	  performInitialMountWithErrorHandling: function (renderedElement, hostParent, hostContainerInfo, transaction, context) {
	    var markup;
	    var checkpoint = transaction.checkpoint();
	    try {
	      markup = this.performInitialMount(renderedElement, hostParent, hostContainerInfo, transaction, context);
	    } catch (e) {
	      if (false) {
	        if (this._debugID !== 0) {
	          ReactInstrumentation.debugTool.onError();
	        }
	      }
	      // Roll back to checkpoint, handle error (which may add items to the transaction), and take a new checkpoint
	      transaction.rollback(checkpoint);
	      this._instance.unstable_handleError(e);
	      if (this._pendingStateQueue) {
	        this._instance.state = this._processPendingState(this._instance.props, this._instance.context);
	      }
	      checkpoint = transaction.checkpoint();
	
	      this._renderedComponent.unmountComponent(true);
	      transaction.rollback(checkpoint);
	
	      // Try again - we've informed the component about the error, so they can render an error message this time.
	      // If this throws again, the error will bubble up (and can be caught by a higher error boundary).
	      markup = this.performInitialMount(renderedElement, hostParent, hostContainerInfo, transaction, context);
	    }
	    return markup;
	  },
	
	  performInitialMount: function (renderedElement, hostParent, hostContainerInfo, transaction, context) {
	    var inst = this._instance;
	    if (inst.componentWillMount) {
	      if (false) {
	        if (this._debugID !== 0) {
	          ReactInstrumentation.debugTool.onBeginLifeCycleTimer(this._debugID, 'componentWillMount');
	        }
	      }
	      inst.componentWillMount();
	      if (false) {
	        if (this._debugID !== 0) {
	          ReactInstrumentation.debugTool.onEndLifeCycleTimer(this._debugID, 'componentWillMount');
	        }
	      }
	      // When mounting, calls to `setState` by `componentWillMount` will set
	      // `this._pendingStateQueue` without triggering a re-render.
	      if (this._pendingStateQueue) {
	        inst.state = this._processPendingState(inst.props, inst.context);
	      }
	    }
	
	    // If not a stateless component, we now render
	    if (renderedElement === undefined) {
	      renderedElement = this._renderValidatedComponent();
	    }
	
	    var nodeType = ReactNodeTypes.getType(renderedElement);
	    this._renderedNodeType = nodeType;
	    var child = this._instantiateReactComponent(renderedElement, nodeType !== ReactNodeTypes.EMPTY /* shouldHaveDebugID */
	    );
	    this._renderedComponent = child;
	    if (false) {
	      if (child._debugID !== 0 && this._debugID !== 0) {
	        ReactInstrumentation.debugTool.onSetParent(child._debugID, this._debugID);
	      }
	    }
	
	    var markup = ReactReconciler.mountComponent(child, transaction, hostParent, hostContainerInfo, this._processChildContext(context));
	
	    if (false) {
	      if (this._debugID !== 0) {
	        ReactInstrumentation.debugTool.onSetChildren(this._debugID, child._debugID !== 0 ? [child._debugID] : []);
	      }
	    }
	
	    return markup;
	  },
	
	  getHostNode: function () {
	    return ReactReconciler.getHostNode(this._renderedComponent);
	  },
	
	  /**
	   * Releases any resources allocated by `mountComponent`.
	   *
	   * @final
	   * @internal
	   */
	  unmountComponent: function (safely) {
	    if (!this._renderedComponent) {
	      return;
	    }
	    var inst = this._instance;
	
	    if (inst.componentWillUnmount && !inst._calledComponentWillUnmount) {
	      inst._calledComponentWillUnmount = true;
	      if (false) {
	        if (this._debugID !== 0) {
	          ReactInstrumentation.debugTool.onBeginLifeCycleTimer(this._debugID, 'componentWillUnmount');
	        }
	      }
	      if (safely) {
	        var name = this.getName() + '.componentWillUnmount()';
	        ReactErrorUtils.invokeGuardedCallback(name, inst.componentWillUnmount.bind(inst));
	      } else {
	        inst.componentWillUnmount();
	      }
	      if (false) {
	        if (this._debugID !== 0) {
	          ReactInstrumentation.debugTool.onEndLifeCycleTimer(this._debugID, 'componentWillUnmount');
	        }
	      }
	    }
	
	    if (this._renderedComponent) {
	      ReactReconciler.unmountComponent(this._renderedComponent, safely);
	      this._renderedNodeType = null;
	      this._renderedComponent = null;
	      this._instance = null;
	    }
	
	    // Reset pending fields
	    // Even if this component is scheduled for another update in ReactUpdates,
	    // it would still be ignored because these fields are reset.
	    this._pendingStateQueue = null;
	    this._pendingReplaceState = false;
	    this._pendingForceUpdate = false;
	    this._pendingCallbacks = null;
	    this._pendingElement = null;
	
	    // These fields do not really need to be reset since this object is no
	    // longer accessible.
	    this._context = null;
	    this._rootNodeID = null;
	    this._topLevelWrapper = null;
	
	    // Delete the reference from the instance to this internal representation
	    // which allow the internals to be properly cleaned up even if the user
	    // leaks a reference to the public instance.
	    ReactInstanceMap.remove(inst);
	
	    // Some existing components rely on inst.props even after they've been
	    // destroyed (in event handlers).
	    // TODO: inst.props = null;
	    // TODO: inst.state = null;
	    // TODO: inst.context = null;
	  },
	
	  /**
	   * Filters the context object to only contain keys specified in
	   * `contextTypes`
	   *
	   * @param {object} context
	   * @return {?object}
	   * @private
	   */
	  _maskContext: function (context) {
	    var Component = this._currentElement.type;
	    var contextTypes = Component.contextTypes;
	    if (!contextTypes) {
	      return emptyObject;
	    }
	    var maskedContext = {};
	    for (var contextName in contextTypes) {
	      maskedContext[contextName] = context[contextName];
	    }
	    return maskedContext;
	  },
	
	  /**
	   * Filters the context object to only contain keys specified in
	   * `contextTypes`, and asserts that they are valid.
	   *
	   * @param {object} context
	   * @return {?object}
	   * @private
	   */
	  _processContext: function (context) {
	    var maskedContext = this._maskContext(context);
	    if (false) {
	      var Component = this._currentElement.type;
	      if (Component.contextTypes) {
	        this._checkContextTypes(Component.contextTypes, maskedContext, ReactPropTypeLocations.context);
	      }
	    }
	    return maskedContext;
	  },
	
	  /**
	   * @param {object} currentContext
	   * @return {object}
	   * @private
	   */
	  _processChildContext: function (currentContext) {
	    var Component = this._currentElement.type;
	    var inst = this._instance;
	    if (false) {
	      ReactInstrumentation.debugTool.onBeginProcessingChildContext();
	    }
	    var childContext = inst.getChildContext && inst.getChildContext();
	    if (false) {
	      ReactInstrumentation.debugTool.onEndProcessingChildContext();
	    }
	    if (childContext) {
	      !(typeof Component.childContextTypes === 'object') ?  false ? invariant(false, '%s.getChildContext(): childContextTypes must be defined in order to use getChildContext().', this.getName() || 'ReactCompositeComponent') : _prodInvariant('107', this.getName() || 'ReactCompositeComponent') : void 0;
	      if (false) {
	        this._checkContextTypes(Component.childContextTypes, childContext, ReactPropTypeLocations.childContext);
	      }
	      for (var name in childContext) {
	        !(name in Component.childContextTypes) ?  false ? invariant(false, '%s.getChildContext(): key "%s" is not defined in childContextTypes.', this.getName() || 'ReactCompositeComponent', name) : _prodInvariant('108', this.getName() || 'ReactCompositeComponent', name) : void 0;
	      }
	      return _assign({}, currentContext, childContext);
	    }
	    return currentContext;
	  },
	
	  /**
	   * Assert that the context types are valid
	   *
	   * @param {object} typeSpecs Map of context field to a ReactPropType
	   * @param {object} values Runtime values that need to be type-checked
	   * @param {string} location e.g. "prop", "context", "child context"
	   * @private
	   */
	  _checkContextTypes: function (typeSpecs, values, location) {
	    checkReactTypeSpec(typeSpecs, values, location, this.getName(), null, this._debugID);
	  },
	
	  receiveComponent: function (nextElement, transaction, nextContext) {
	    var prevElement = this._currentElement;
	    var prevContext = this._context;
	
	    this._pendingElement = null;
	
	    this.updateComponent(transaction, prevElement, nextElement, prevContext, nextContext);
	  },
	
	  /**
	   * If any of `_pendingElement`, `_pendingStateQueue`, or `_pendingForceUpdate`
	   * is set, update the component.
	   *
	   * @param {ReactReconcileTransaction} transaction
	   * @internal
	   */
	  performUpdateIfNecessary: function (transaction) {
	    if (this._pendingElement != null) {
	      ReactReconciler.receiveComponent(this, this._pendingElement, transaction, this._context);
	    } else if (this._pendingStateQueue !== null || this._pendingForceUpdate) {
	      this.updateComponent(transaction, this._currentElement, this._currentElement, this._context, this._context);
	    } else {
	      this._updateBatchNumber = null;
	    }
	  },
	
	  /**
	   * Perform an update to a mounted component. The componentWillReceiveProps and
	   * shouldComponentUpdate methods are called, then (assuming the update isn't
	   * skipped) the remaining update lifecycle methods are called and the DOM
	   * representation is updated.
	   *
	   * By default, this implements React's rendering and reconciliation algorithm.
	   * Sophisticated clients may wish to override this.
	   *
	   * @param {ReactReconcileTransaction} transaction
	   * @param {ReactElement} prevParentElement
	   * @param {ReactElement} nextParentElement
	   * @internal
	   * @overridable
	   */
	  updateComponent: function (transaction, prevParentElement, nextParentElement, prevUnmaskedContext, nextUnmaskedContext) {
	    var inst = this._instance;
	    !(inst != null) ?  false ? invariant(false, 'Attempted to update component `%s` that has already been unmounted (or failed to mount).', this.getName() || 'ReactCompositeComponent') : _prodInvariant('136', this.getName() || 'ReactCompositeComponent') : void 0;
	
	    var willReceive = false;
	    var nextContext;
	    var nextProps;
	
	    // Determine if the context has changed or not
	    if (this._context === nextUnmaskedContext) {
	      nextContext = inst.context;
	    } else {
	      nextContext = this._processContext(nextUnmaskedContext);
	      willReceive = true;
	    }
	
	    nextProps = nextParentElement.props;
	
	    // Not a simple state update but a props update
	    if (prevParentElement !== nextParentElement) {
	      willReceive = true;
	    }
	
	    // An update here will schedule an update but immediately set
	    // _pendingStateQueue which will ensure that any state updates gets
	    // immediately reconciled instead of waiting for the next batch.
	    if (willReceive && inst.componentWillReceiveProps) {
	      if (false) {
	        if (this._debugID !== 0) {
	          ReactInstrumentation.debugTool.onBeginLifeCycleTimer(this._debugID, 'componentWillReceiveProps');
	        }
	      }
	      inst.componentWillReceiveProps(nextProps, nextContext);
	      if (false) {
	        if (this._debugID !== 0) {
	          ReactInstrumentation.debugTool.onEndLifeCycleTimer(this._debugID, 'componentWillReceiveProps');
	        }
	      }
	    }
	
	    var nextState = this._processPendingState(nextProps, nextContext);
	    var shouldUpdate = true;
	
	    if (!this._pendingForceUpdate && inst.shouldComponentUpdate) {
	      if (false) {
	        if (this._debugID !== 0) {
	          ReactInstrumentation.debugTool.onBeginLifeCycleTimer(this._debugID, 'shouldComponentUpdate');
	        }
	      }
	      shouldUpdate = inst.shouldComponentUpdate(nextProps, nextState, nextContext);
	      if (false) {
	        if (this._debugID !== 0) {
	          ReactInstrumentation.debugTool.onEndLifeCycleTimer(this._debugID, 'shouldComponentUpdate');
	        }
	      }
	    }
	
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(shouldUpdate !== undefined, '%s.shouldComponentUpdate(): Returned undefined instead of a ' + 'boolean value. Make sure to return true or false.', this.getName() || 'ReactCompositeComponent') : void 0;
	    }
	
	    this._updateBatchNumber = null;
	    if (shouldUpdate) {
	      this._pendingForceUpdate = false;
	      // Will set `this.props`, `this.state` and `this.context`.
	      this._performComponentUpdate(nextParentElement, nextProps, nextState, nextContext, transaction, nextUnmaskedContext);
	    } else {
	      // If it's determined that a component should not update, we still want
	      // to set props and state but we shortcut the rest of the update.
	      this._currentElement = nextParentElement;
	      this._context = nextUnmaskedContext;
	      inst.props = nextProps;
	      inst.state = nextState;
	      inst.context = nextContext;
	    }
	  },
	
	  _processPendingState: function (props, context) {
	    var inst = this._instance;
	    var queue = this._pendingStateQueue;
	    var replace = this._pendingReplaceState;
	    this._pendingReplaceState = false;
	    this._pendingStateQueue = null;
	
	    if (!queue) {
	      return inst.state;
	    }
	
	    if (replace && queue.length === 1) {
	      return queue[0];
	    }
	
	    var nextState = _assign({}, replace ? queue[0] : inst.state);
	    for (var i = replace ? 1 : 0; i < queue.length; i++) {
	      var partial = queue[i];
	      _assign(nextState, typeof partial === 'function' ? partial.call(inst, nextState, props, context) : partial);
	    }
	
	    return nextState;
	  },
	
	  /**
	   * Merges new props and state, notifies delegate methods of update and
	   * performs update.
	   *
	   * @param {ReactElement} nextElement Next element
	   * @param {object} nextProps Next public object to set as properties.
	   * @param {?object} nextState Next object to set as state.
	   * @param {?object} nextContext Next public object to set as context.
	   * @param {ReactReconcileTransaction} transaction
	   * @param {?object} unmaskedContext
	   * @private
	   */
	  _performComponentUpdate: function (nextElement, nextProps, nextState, nextContext, transaction, unmaskedContext) {
	    var inst = this._instance;
	
	    var hasComponentDidUpdate = Boolean(inst.componentDidUpdate);
	    var prevProps;
	    var prevState;
	    var prevContext;
	    if (hasComponentDidUpdate) {
	      prevProps = inst.props;
	      prevState = inst.state;
	      prevContext = inst.context;
	    }
	
	    if (inst.componentWillUpdate) {
	      if (false) {
	        if (this._debugID !== 0) {
	          ReactInstrumentation.debugTool.onBeginLifeCycleTimer(this._debugID, 'componentWillUpdate');
	        }
	      }
	      inst.componentWillUpdate(nextProps, nextState, nextContext);
	      if (false) {
	        if (this._debugID !== 0) {
	          ReactInstrumentation.debugTool.onEndLifeCycleTimer(this._debugID, 'componentWillUpdate');
	        }
	      }
	    }
	
	    this._currentElement = nextElement;
	    this._context = unmaskedContext;
	    inst.props = nextProps;
	    inst.state = nextState;
	    inst.context = nextContext;
	
	    this._updateRenderedComponent(transaction, unmaskedContext);
	
	    if (hasComponentDidUpdate) {
	      if (false) {
	        transaction.getReactMountReady().enqueue(invokeComponentDidUpdateWithTimer.bind(this, prevProps, prevState, prevContext), this);
	      } else {
	        transaction.getReactMountReady().enqueue(inst.componentDidUpdate.bind(inst, prevProps, prevState, prevContext), inst);
	      }
	    }
	  },
	
	  /**
	   * Call the component's `render` method and update the DOM accordingly.
	   *
	   * @param {ReactReconcileTransaction} transaction
	   * @internal
	   */
	  _updateRenderedComponent: function (transaction, context) {
	    var prevComponentInstance = this._renderedComponent;
	    var prevRenderedElement = prevComponentInstance._currentElement;
	    var nextRenderedElement = this._renderValidatedComponent();
	    if (shouldUpdateReactComponent(prevRenderedElement, nextRenderedElement)) {
	      ReactReconciler.receiveComponent(prevComponentInstance, nextRenderedElement, transaction, this._processChildContext(context));
	    } else {
	      var oldHostNode = ReactReconciler.getHostNode(prevComponentInstance);
	      ReactReconciler.unmountComponent(prevComponentInstance, false);
	
	      var nodeType = ReactNodeTypes.getType(nextRenderedElement);
	      this._renderedNodeType = nodeType;
	      var child = this._instantiateReactComponent(nextRenderedElement, nodeType !== ReactNodeTypes.EMPTY /* shouldHaveDebugID */
	      );
	      this._renderedComponent = child;
	      if (false) {
	        if (child._debugID !== 0 && this._debugID !== 0) {
	          ReactInstrumentation.debugTool.onSetParent(child._debugID, this._debugID);
	        }
	      }
	
	      var nextMarkup = ReactReconciler.mountComponent(child, transaction, this._hostParent, this._hostContainerInfo, this._processChildContext(context));
	
	      if (false) {
	        if (this._debugID !== 0) {
	          ReactInstrumentation.debugTool.onSetChildren(this._debugID, child._debugID !== 0 ? [child._debugID] : []);
	        }
	      }
	
	      this._replaceNodeWithMarkup(oldHostNode, nextMarkup, prevComponentInstance);
	    }
	  },
	
	  /**
	   * Overridden in shallow rendering.
	   *
	   * @protected
	   */
	  _replaceNodeWithMarkup: function (oldHostNode, nextMarkup, prevInstance) {
	    ReactComponentEnvironment.replaceNodeWithMarkup(oldHostNode, nextMarkup, prevInstance);
	  },
	
	  /**
	   * @protected
	   */
	  _renderValidatedComponentWithoutOwnerOrContext: function () {
	    var inst = this._instance;
	
	    if (false) {
	      if (this._debugID !== 0) {
	        ReactInstrumentation.debugTool.onBeginLifeCycleTimer(this._debugID, 'render');
	      }
	    }
	    var renderedComponent = inst.render();
	    if (false) {
	      if (this._debugID !== 0) {
	        ReactInstrumentation.debugTool.onEndLifeCycleTimer(this._debugID, 'render');
	      }
	    }
	
	    if (false) {
	      // We allow auto-mocks to proceed as if they're returning null.
	      if (renderedComponent === undefined && inst.render._isMockFunction) {
	        // This is probably bad practice. Consider warning here and
	        // deprecating this convenience.
	        renderedComponent = null;
	      }
	    }
	
	    return renderedComponent;
	  },
	
	  /**
	   * @private
	   */
	  _renderValidatedComponent: function () {
	    var renderedComponent;
	    ReactCurrentOwner.current = this;
	    try {
	      renderedComponent = this._renderValidatedComponentWithoutOwnerOrContext();
	    } finally {
	      ReactCurrentOwner.current = null;
	    }
	    !(
	    // TODO: An `isValidNode` function would probably be more appropriate
	    renderedComponent === null || renderedComponent === false || ReactElement.isValidElement(renderedComponent)) ?  false ? invariant(false, '%s.render(): A valid React element (or null) must be returned. You may have returned undefined, an array or some other invalid object.', this.getName() || 'ReactCompositeComponent') : _prodInvariant('109', this.getName() || 'ReactCompositeComponent') : void 0;
	
	    return renderedComponent;
	  },
	
	  /**
	   * Lazily allocates the refs object and stores `component` as `ref`.
	   *
	   * @param {string} ref Reference name.
	   * @param {component} component Component to store as `ref`.
	   * @final
	   * @private
	   */
	  attachRef: function (ref, component) {
	    var inst = this.getPublicInstance();
	    !(inst != null) ?  false ? invariant(false, 'Stateless function components cannot have refs.') : _prodInvariant('110') : void 0;
	    var publicComponentInstance = component.getPublicInstance();
	    if (false) {
	      var componentName = component && component.getName ? component.getName() : 'a component';
	      process.env.NODE_ENV !== 'production' ? warning(publicComponentInstance != null, 'Stateless function components cannot be given refs ' + '(See ref "%s" in %s created by %s). ' + 'Attempts to access this ref will fail.', ref, componentName, this.getName()) : void 0;
	    }
	    var refs = inst.refs === emptyObject ? inst.refs = {} : inst.refs;
	    refs[ref] = publicComponentInstance;
	  },
	
	  /**
	   * Detaches a reference name.
	   *
	   * @param {string} ref Name to dereference.
	   * @final
	   * @private
	   */
	  detachRef: function (ref) {
	    var refs = this.getPublicInstance().refs;
	    delete refs[ref];
	  },
	
	  /**
	   * Get a text description of the component that can be used to identify it
	   * in error messages.
	   * @return {string} The name or null.
	   * @internal
	   */
	  getName: function () {
	    var type = this._currentElement.type;
	    var constructor = this._instance && this._instance.constructor;
	    return type.displayName || constructor && constructor.displayName || type.name || constructor && constructor.name || null;
	  },
	
	  /**
	   * Get the publicly accessible representation of this component - i.e. what
	   * is exposed by refs and returned by render. Can be null for stateless
	   * components.
	   *
	   * @return {ReactComponent} the public component instance.
	   * @internal
	   */
	  getPublicInstance: function () {
	    var inst = this._instance;
	    if (inst instanceof StatelessComponent) {
	      return null;
	    }
	    return inst;
	  },
	
	  // Stub
	  _instantiateReactComponent: null
	
	};
	
	var ReactCompositeComponent = {
	
	  Mixin: ReactCompositeComponentMixin
	
	};
	
	module.exports = ReactCompositeComponent;

/***/ },
/* 750 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDOM
	 */
	
	/* globals __REACT_DEVTOOLS_GLOBAL_HOOK__*/
	
	'use strict';
	
	var ReactDOMComponentTree = __webpack_require__(15);
	var ReactDefaultInjection = __webpack_require__(766);
	var ReactMount = __webpack_require__(323);
	var ReactReconciler = __webpack_require__(91);
	var ReactUpdates = __webpack_require__(46);
	var ReactVersion = __webpack_require__(328);
	
	var findDOMNode = __webpack_require__(793);
	var getHostComponentFromComposite = __webpack_require__(333);
	var renderSubtreeIntoContainer = __webpack_require__(800);
	var warning = __webpack_require__(9);
	
	ReactDefaultInjection.inject();
	
	var React = {
	  findDOMNode: findDOMNode,
	  render: ReactMount.render,
	  unmountComponentAtNode: ReactMount.unmountComponentAtNode,
	  version: ReactVersion,
	
	  /* eslint-disable camelcase */
	  unstable_batchedUpdates: ReactUpdates.batchedUpdates,
	  unstable_renderSubtreeIntoContainer: renderSubtreeIntoContainer
	};
	
	// Inject the runtime into a devtools global hook regardless of browser.
	// Allows for debugging when the hook is injected on the page.
	/* eslint-enable camelcase */
	if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ !== 'undefined' && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.inject === 'function') {
	  __REACT_DEVTOOLS_GLOBAL_HOOK__.inject({
	    ComponentTree: {
	      getClosestInstanceFromNode: ReactDOMComponentTree.getClosestInstanceFromNode,
	      getNodeFromInstance: function (inst) {
	        // inst is an internal instance (but could be a composite)
	        if (inst._renderedComponent) {
	          inst = getHostComponentFromComposite(inst);
	        }
	        if (inst) {
	          return ReactDOMComponentTree.getNodeFromInstance(inst);
	        } else {
	          return null;
	        }
	      }
	    },
	    Mount: ReactMount,
	    Reconciler: ReactReconciler
	  });
	}
	
	if (false) {
	  var ExecutionEnvironment = require('fbjs/lib/ExecutionEnvironment');
	  if (ExecutionEnvironment.canUseDOM && window.top === window.self) {
	
	    // First check if devtools is not installed
	    if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined') {
	      // If we're in Chrome or Firefox, provide a download link if not installed.
	      if (navigator.userAgent.indexOf('Chrome') > -1 && navigator.userAgent.indexOf('Edge') === -1 || navigator.userAgent.indexOf('Firefox') > -1) {
	        // Firefox does not have the issue with devtools loaded over file://
	        var showFileUrlMessage = window.location.protocol.indexOf('http') === -1 && navigator.userAgent.indexOf('Firefox') === -1;
	        console.debug('Download the React DevTools ' + (showFileUrlMessage ? 'and use an HTTP server (instead of a file: URL) ' : '') + 'for a better development experience: ' + 'https://fb.me/react-devtools');
	      }
	    }
	
	    var testFunc = function testFn() {};
	    process.env.NODE_ENV !== 'production' ? warning((testFunc.name || testFunc.toString()).indexOf('testFn') !== -1, 'It looks like you\'re using a minified copy of the development build ' + 'of React. When deploying React apps to production, make sure to use ' + 'the production build which skips development warnings and is faster. ' + 'See https://fb.me/react-minification for more details.') : void 0;
	
	    // If we're in IE8, check to see if we are in compatibility mode and provide
	    // information on preventing compatibility mode
	    var ieCompatibilityMode = document.documentMode && document.documentMode < 8;
	
	    process.env.NODE_ENV !== 'production' ? warning(!ieCompatibilityMode, 'Internet Explorer is running in compatibility mode; please add the ' + 'following tag to your HTML to prevent this from happening: ' + '<meta http-equiv="X-UA-Compatible" content="IE=edge" />') : void 0;
	
	    var expectedFeatures = [
	    // shims
	    Array.isArray, Array.prototype.every, Array.prototype.forEach, Array.prototype.indexOf, Array.prototype.map, Date.now, Function.prototype.bind, Object.keys, String.prototype.split, String.prototype.trim];
	
	    for (var i = 0; i < expectedFeatures.length; i++) {
	      if (!expectedFeatures[i]) {
	        process.env.NODE_ENV !== 'production' ? warning(false, 'One or more ES5 shims expected by React are not available: ' + 'https://fb.me/react-warning-polyfills') : void 0;
	        break;
	      }
	    }
	  }
	}
	
	module.exports = React;

/***/ },
/* 751 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDOMButton
	 */
	
	'use strict';
	
	var DisabledInputUtils = __webpack_require__(139);
	
	/**
	 * Implements a <button> host component that does not receive mouse events
	 * when `disabled` is set.
	 */
	var ReactDOMButton = {
	  getHostProps: DisabledInputUtils.getHostProps
	};
	
	module.exports = ReactDOMButton;

/***/ },
/* 752 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDOMComponent
	 */
	
	/* global hasOwnProperty:true */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(5),
	    _assign = __webpack_require__(6);
	
	var AutoFocusUtils = __webpack_require__(738);
	var CSSPropertyOperations = __webpack_require__(740);
	var DOMLazyTree = __webpack_require__(89);
	var DOMNamespaces = __webpack_require__(197);
	var DOMProperty = __webpack_require__(90);
	var DOMPropertyOperations = __webpack_require__(312);
	var EventConstants = __webpack_require__(52);
	var EventPluginHub = __webpack_require__(99);
	var EventPluginRegistry = __webpack_require__(198);
	var ReactBrowserEventEmitter = __webpack_require__(140);
	var ReactComponentBrowserEnvironment = __webpack_require__(316);
	var ReactDOMButton = __webpack_require__(751);
	var ReactDOMComponentFlags = __webpack_require__(317);
	var ReactDOMComponentTree = __webpack_require__(15);
	var ReactDOMInput = __webpack_require__(758);
	var ReactDOMOption = __webpack_require__(760);
	var ReactDOMSelect = __webpack_require__(318);
	var ReactDOMTextarea = __webpack_require__(763);
	var ReactInstrumentation = __webpack_require__(31);
	var ReactMultiChild = __webpack_require__(771);
	var ReactServerRenderingTransaction = __webpack_require__(775);
	
	var emptyFunction = __webpack_require__(37);
	var escapeTextContentForBrowser = __webpack_require__(142);
	var invariant = __webpack_require__(2);
	var isEventSupported = __webpack_require__(211);
	var keyOf = __webpack_require__(50);
	var shallowEqual = __webpack_require__(247);
	var validateDOMNesting = __webpack_require__(214);
	var warning = __webpack_require__(9);
	
	var Flags = ReactDOMComponentFlags;
	var deleteListener = EventPluginHub.deleteListener;
	var getNode = ReactDOMComponentTree.getNodeFromInstance;
	var listenTo = ReactBrowserEventEmitter.listenTo;
	var registrationNameModules = EventPluginRegistry.registrationNameModules;
	
	// For quickly matching children type, to test if can be treated as content.
	var CONTENT_TYPES = { 'string': true, 'number': true };
	
	var STYLE = keyOf({ style: null });
	var HTML = keyOf({ __html: null });
	var RESERVED_PROPS = {
	  children: null,
	  dangerouslySetInnerHTML: null,
	  suppressContentEditableWarning: null
	};
	
	// Node type for document fragments (Node.DOCUMENT_FRAGMENT_NODE).
	var DOC_FRAGMENT_TYPE = 11;
	
	function getDeclarationErrorAddendum(internalInstance) {
	  if (internalInstance) {
	    var owner = internalInstance._currentElement._owner || null;
	    if (owner) {
	      var name = owner.getName();
	      if (name) {
	        return ' This DOM node was rendered by `' + name + '`.';
	      }
	    }
	  }
	  return '';
	}
	
	function friendlyStringify(obj) {
	  if (typeof obj === 'object') {
	    if (Array.isArray(obj)) {
	      return '[' + obj.map(friendlyStringify).join(', ') + ']';
	    } else {
	      var pairs = [];
	      for (var key in obj) {
	        if (Object.prototype.hasOwnProperty.call(obj, key)) {
	          var keyEscaped = /^[a-z$_][\w$_]*$/i.test(key) ? key : JSON.stringify(key);
	          pairs.push(keyEscaped + ': ' + friendlyStringify(obj[key]));
	        }
	      }
	      return '{' + pairs.join(', ') + '}';
	    }
	  } else if (typeof obj === 'string') {
	    return JSON.stringify(obj);
	  } else if (typeof obj === 'function') {
	    return '[function object]';
	  }
	  // Differs from JSON.stringify in that undefined because undefined and that
	  // inf and nan don't become null
	  return String(obj);
	}
	
	var styleMutationWarning = {};
	
	function checkAndWarnForMutatedStyle(style1, style2, component) {
	  if (style1 == null || style2 == null) {
	    return;
	  }
	  if (shallowEqual(style1, style2)) {
	    return;
	  }
	
	  var componentName = component._tag;
	  var owner = component._currentElement._owner;
	  var ownerName;
	  if (owner) {
	    ownerName = owner.getName();
	  }
	
	  var hash = ownerName + '|' + componentName;
	
	  if (styleMutationWarning.hasOwnProperty(hash)) {
	    return;
	  }
	
	  styleMutationWarning[hash] = true;
	
	   false ? warning(false, '`%s` was passed a style object that has previously been mutated. ' + 'Mutating `style` is deprecated. Consider cloning it beforehand. Check ' + 'the `render` %s. Previous style: %s. Mutated style: %s.', componentName, owner ? 'of `' + ownerName + '`' : 'using <' + componentName + '>', friendlyStringify(style1), friendlyStringify(style2)) : void 0;
	}
	
	/**
	 * @param {object} component
	 * @param {?object} props
	 */
	function assertValidProps(component, props) {
	  if (!props) {
	    return;
	  }
	  // Note the use of `==` which checks for null or undefined.
	  if (voidElementTags[component._tag]) {
	    !(props.children == null && props.dangerouslySetInnerHTML == null) ?  false ? invariant(false, '%s is a void element tag and must neither have `children` nor use `dangerouslySetInnerHTML`.%s', component._tag, component._currentElement._owner ? ' Check the render method of ' + component._currentElement._owner.getName() + '.' : '') : _prodInvariant('137', component._tag, component._currentElement._owner ? ' Check the render method of ' + component._currentElement._owner.getName() + '.' : '') : void 0;
	  }
	  if (props.dangerouslySetInnerHTML != null) {
	    !(props.children == null) ?  false ? invariant(false, 'Can only set one of `children` or `props.dangerouslySetInnerHTML`.') : _prodInvariant('60') : void 0;
	    !(typeof props.dangerouslySetInnerHTML === 'object' && HTML in props.dangerouslySetInnerHTML) ?  false ? invariant(false, '`props.dangerouslySetInnerHTML` must be in the form `{__html: ...}`. Please visit https://fb.me/react-invariant-dangerously-set-inner-html for more information.') : _prodInvariant('61') : void 0;
	  }
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(props.innerHTML == null, 'Directly setting property `innerHTML` is not permitted. ' + 'For more information, lookup documentation on `dangerouslySetInnerHTML`.') : void 0;
	    process.env.NODE_ENV !== 'production' ? warning(props.suppressContentEditableWarning || !props.contentEditable || props.children == null, 'A component is `contentEditable` and contains `children` managed by ' + 'React. It is now your responsibility to guarantee that none of ' + 'those nodes are unexpectedly modified or duplicated. This is ' + 'probably not intentional.') : void 0;
	    process.env.NODE_ENV !== 'production' ? warning(props.onFocusIn == null && props.onFocusOut == null, 'React uses onFocus and onBlur instead of onFocusIn and onFocusOut. ' + 'All React events are normalized to bubble, so onFocusIn and onFocusOut ' + 'are not needed/supported by React.') : void 0;
	  }
	  !(props.style == null || typeof props.style === 'object') ?  false ? invariant(false, 'The `style` prop expects a mapping from style properties to values, not a string. For example, style={{marginRight: spacing + \'em\'}} when using JSX.%s', getDeclarationErrorAddendum(component)) : _prodInvariant('62', getDeclarationErrorAddendum(component)) : void 0;
	}
	
	function enqueuePutListener(inst, registrationName, listener, transaction) {
	  if (transaction instanceof ReactServerRenderingTransaction) {
	    return;
	  }
	  if (false) {
	    // IE8 has no API for event capturing and the `onScroll` event doesn't
	    // bubble.
	    process.env.NODE_ENV !== 'production' ? warning(registrationName !== 'onScroll' || isEventSupported('scroll', true), 'This browser doesn\'t support the `onScroll` event') : void 0;
	  }
	  var containerInfo = inst._hostContainerInfo;
	  var isDocumentFragment = containerInfo._node && containerInfo._node.nodeType === DOC_FRAGMENT_TYPE;
	  var doc = isDocumentFragment ? containerInfo._node : containerInfo._ownerDocument;
	  listenTo(registrationName, doc);
	  transaction.getReactMountReady().enqueue(putListener, {
	    inst: inst,
	    registrationName: registrationName,
	    listener: listener
	  });
	}
	
	function putListener() {
	  var listenerToPut = this;
	  EventPluginHub.putListener(listenerToPut.inst, listenerToPut.registrationName, listenerToPut.listener);
	}
	
	function inputPostMount() {
	  var inst = this;
	  ReactDOMInput.postMountWrapper(inst);
	}
	
	function textareaPostMount() {
	  var inst = this;
	  ReactDOMTextarea.postMountWrapper(inst);
	}
	
	function optionPostMount() {
	  var inst = this;
	  ReactDOMOption.postMountWrapper(inst);
	}
	
	var setContentChildForInstrumentation = emptyFunction;
	if (false) {
	  setContentChildForInstrumentation = function (content) {
	    var hasExistingContent = this._contentDebugID != null;
	    var debugID = this._debugID;
	    var contentDebugID = debugID + '#text';
	
	    if (content == null) {
	      if (hasExistingContent) {
	        ReactInstrumentation.debugTool.onUnmountComponent(this._contentDebugID);
	      }
	      this._contentDebugID = null;
	      return;
	    }
	
	    this._contentDebugID = contentDebugID;
	    var text = '' + content;
	
	    ReactInstrumentation.debugTool.onSetDisplayName(contentDebugID, '#text');
	    ReactInstrumentation.debugTool.onSetParent(contentDebugID, debugID);
	    ReactInstrumentation.debugTool.onSetText(contentDebugID, text);
	
	    if (hasExistingContent) {
	      ReactInstrumentation.debugTool.onBeforeUpdateComponent(contentDebugID, content);
	      ReactInstrumentation.debugTool.onUpdateComponent(contentDebugID);
	    } else {
	      ReactInstrumentation.debugTool.onBeforeMountComponent(contentDebugID, content);
	      ReactInstrumentation.debugTool.onMountComponent(contentDebugID);
	      ReactInstrumentation.debugTool.onSetChildren(debugID, [contentDebugID]);
	    }
	  };
	}
	
	// There are so many media events, it makes sense to just
	// maintain a list rather than create a `trapBubbledEvent` for each
	var mediaEvents = {
	  topAbort: 'abort',
	  topCanPlay: 'canplay',
	  topCanPlayThrough: 'canplaythrough',
	  topDurationChange: 'durationchange',
	  topEmptied: 'emptied',
	  topEncrypted: 'encrypted',
	  topEnded: 'ended',
	  topError: 'error',
	  topLoadedData: 'loadeddata',
	  topLoadedMetadata: 'loadedmetadata',
	  topLoadStart: 'loadstart',
	  topPause: 'pause',
	  topPlay: 'play',
	  topPlaying: 'playing',
	  topProgress: 'progress',
	  topRateChange: 'ratechange',
	  topSeeked: 'seeked',
	  topSeeking: 'seeking',
	  topStalled: 'stalled',
	  topSuspend: 'suspend',
	  topTimeUpdate: 'timeupdate',
	  topVolumeChange: 'volumechange',
	  topWaiting: 'waiting'
	};
	
	function trapBubbledEventsLocal() {
	  var inst = this;
	  // If a component renders to null or if another component fatals and causes
	  // the state of the tree to be corrupted, `node` here can be null.
	  !inst._rootNodeID ?  false ? invariant(false, 'Must be mounted to trap events') : _prodInvariant('63') : void 0;
	  var node = getNode(inst);
	  !node ?  false ? invariant(false, 'trapBubbledEvent(...): Requires node to be rendered.') : _prodInvariant('64') : void 0;
	
	  switch (inst._tag) {
	    case 'iframe':
	    case 'object':
	      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent(EventConstants.topLevelTypes.topLoad, 'load', node)];
	      break;
	    case 'video':
	    case 'audio':
	
	      inst._wrapperState.listeners = [];
	      // Create listener for each media event
	      for (var event in mediaEvents) {
	        if (mediaEvents.hasOwnProperty(event)) {
	          inst._wrapperState.listeners.push(ReactBrowserEventEmitter.trapBubbledEvent(EventConstants.topLevelTypes[event], mediaEvents[event], node));
	        }
	      }
	      break;
	    case 'source':
	      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent(EventConstants.topLevelTypes.topError, 'error', node)];
	      break;
	    case 'img':
	      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent(EventConstants.topLevelTypes.topError, 'error', node), ReactBrowserEventEmitter.trapBubbledEvent(EventConstants.topLevelTypes.topLoad, 'load', node)];
	      break;
	    case 'form':
	      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent(EventConstants.topLevelTypes.topReset, 'reset', node), ReactBrowserEventEmitter.trapBubbledEvent(EventConstants.topLevelTypes.topSubmit, 'submit', node)];
	      break;
	    case 'input':
	    case 'select':
	    case 'textarea':
	      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent(EventConstants.topLevelTypes.topInvalid, 'invalid', node)];
	      break;
	  }
	}
	
	function postUpdateSelectWrapper() {
	  ReactDOMSelect.postUpdateWrapper(this);
	}
	
	// For HTML, certain tags should omit their close tag. We keep a whitelist for
	// those special-case tags.
	
	var omittedCloseTags = {
	  'area': true,
	  'base': true,
	  'br': true,
	  'col': true,
	  'embed': true,
	  'hr': true,
	  'img': true,
	  'input': true,
	  'keygen': true,
	  'link': true,
	  'meta': true,
	  'param': true,
	  'source': true,
	  'track': true,
	  'wbr': true
	};
	
	// NOTE: menuitem's close tag should be omitted, but that causes problems.
	var newlineEatingTags = {
	  'listing': true,
	  'pre': true,
	  'textarea': true
	};
	
	// For HTML, certain tags cannot have children. This has the same purpose as
	// `omittedCloseTags` except that `menuitem` should still have its closing tag.
	
	var voidElementTags = _assign({
	  'menuitem': true
	}, omittedCloseTags);
	
	// We accept any tag to be rendered but since this gets injected into arbitrary
	// HTML, we want to make sure that it's a safe tag.
	// http://www.w3.org/TR/REC-xml/#NT-Name
	
	var VALID_TAG_REGEX = /^[a-zA-Z][a-zA-Z:_\.\-\d]*$/; // Simplified subset
	var validatedTagCache = {};
	var hasOwnProperty = {}.hasOwnProperty;
	
	function validateDangerousTag(tag) {
	  if (!hasOwnProperty.call(validatedTagCache, tag)) {
	    !VALID_TAG_REGEX.test(tag) ?  false ? invariant(false, 'Invalid tag: %s', tag) : _prodInvariant('65', tag) : void 0;
	    validatedTagCache[tag] = true;
	  }
	}
	
	function isCustomComponent(tagName, props) {
	  return tagName.indexOf('-') >= 0 || props.is != null;
	}
	
	var globalIdCounter = 1;
	
	/**
	 * Creates a new React class that is idempotent and capable of containing other
	 * React components. It accepts event listeners and DOM properties that are
	 * valid according to `DOMProperty`.
	 *
	 *  - Event listeners: `onClick`, `onMouseDown`, etc.
	 *  - DOM properties: `className`, `name`, `title`, etc.
	 *
	 * The `style` property functions differently from the DOM API. It accepts an
	 * object mapping of style properties to values.
	 *
	 * @constructor ReactDOMComponent
	 * @extends ReactMultiChild
	 */
	function ReactDOMComponent(element) {
	  var tag = element.type;
	  validateDangerousTag(tag);
	  this._currentElement = element;
	  this._tag = tag.toLowerCase();
	  this._namespaceURI = null;
	  this._renderedChildren = null;
	  this._previousStyle = null;
	  this._previousStyleCopy = null;
	  this._hostNode = null;
	  this._hostParent = null;
	  this._rootNodeID = null;
	  this._domID = null;
	  this._hostContainerInfo = null;
	  this._wrapperState = null;
	  this._topLevelWrapper = null;
	  this._flags = 0;
	  if (false) {
	    this._ancestorInfo = null;
	    setContentChildForInstrumentation.call(this, null);
	  }
	}
	
	ReactDOMComponent.displayName = 'ReactDOMComponent';
	
	ReactDOMComponent.Mixin = {
	
	  /**
	   * Generates root tag markup then recurses. This method has side effects and
	   * is not idempotent.
	   *
	   * @internal
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {?ReactDOMComponent} the containing DOM component instance
	   * @param {?object} info about the host container
	   * @param {object} context
	   * @return {string} The computed markup.
	   */
	  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
	    this._rootNodeID = globalIdCounter++;
	    this._domID = hostContainerInfo._idCounter++;
	    this._hostParent = hostParent;
	    this._hostContainerInfo = hostContainerInfo;
	
	    var props = this._currentElement.props;
	
	    switch (this._tag) {
	      case 'audio':
	      case 'form':
	      case 'iframe':
	      case 'img':
	      case 'link':
	      case 'object':
	      case 'source':
	      case 'video':
	        this._wrapperState = {
	          listeners: null
	        };
	        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
	        break;
	      case 'button':
	        props = ReactDOMButton.getHostProps(this, props, hostParent);
	        break;
	      case 'input':
	        ReactDOMInput.mountWrapper(this, props, hostParent);
	        props = ReactDOMInput.getHostProps(this, props);
	        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
	        break;
	      case 'option':
	        ReactDOMOption.mountWrapper(this, props, hostParent);
	        props = ReactDOMOption.getHostProps(this, props);
	        break;
	      case 'select':
	        ReactDOMSelect.mountWrapper(this, props, hostParent);
	        props = ReactDOMSelect.getHostProps(this, props);
	        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
	        break;
	      case 'textarea':
	        ReactDOMTextarea.mountWrapper(this, props, hostParent);
	        props = ReactDOMTextarea.getHostProps(this, props);
	        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
	        break;
	    }
	
	    assertValidProps(this, props);
	
	    // We create tags in the namespace of their parent container, except HTML
	    // tags get no namespace.
	    var namespaceURI;
	    var parentTag;
	    if (hostParent != null) {
	      namespaceURI = hostParent._namespaceURI;
	      parentTag = hostParent._tag;
	    } else if (hostContainerInfo._tag) {
	      namespaceURI = hostContainerInfo._namespaceURI;
	      parentTag = hostContainerInfo._tag;
	    }
	    if (namespaceURI == null || namespaceURI === DOMNamespaces.svg && parentTag === 'foreignobject') {
	      namespaceURI = DOMNamespaces.html;
	    }
	    if (namespaceURI === DOMNamespaces.html) {
	      if (this._tag === 'svg') {
	        namespaceURI = DOMNamespaces.svg;
	      } else if (this._tag === 'math') {
	        namespaceURI = DOMNamespaces.mathml;
	      }
	    }
	    this._namespaceURI = namespaceURI;
	
	    if (false) {
	      var parentInfo;
	      if (hostParent != null) {
	        parentInfo = hostParent._ancestorInfo;
	      } else if (hostContainerInfo._tag) {
	        parentInfo = hostContainerInfo._ancestorInfo;
	      }
	      if (parentInfo) {
	        // parentInfo should always be present except for the top-level
	        // component when server rendering
	        validateDOMNesting(this._tag, this, parentInfo);
	      }
	      this._ancestorInfo = validateDOMNesting.updatedAncestorInfo(parentInfo, this._tag, this);
	    }
	
	    var mountImage;
	    if (transaction.useCreateElement) {
	      var ownerDocument = hostContainerInfo._ownerDocument;
	      var el;
	      if (namespaceURI === DOMNamespaces.html) {
	        if (this._tag === 'script') {
	          // Create the script via .innerHTML so its "parser-inserted" flag is
	          // set to true and it does not execute
	          var div = ownerDocument.createElement('div');
	          var type = this._currentElement.type;
	          div.innerHTML = '<' + type + '></' + type + '>';
	          el = div.removeChild(div.firstChild);
	        } else if (props.is) {
	          el = ownerDocument.createElement(this._currentElement.type, props.is);
	        } else {
	          // Separate else branch instead of using `props.is || undefined` above becuase of a Firefox bug.
	          // See discussion in https://github.com/facebook/react/pull/6896
	          // and discussion in https://bugzilla.mozilla.org/show_bug.cgi?id=1276240
	          el = ownerDocument.createElement(this._currentElement.type);
	        }
	      } else {
	        el = ownerDocument.createElementNS(namespaceURI, this._currentElement.type);
	      }
	      ReactDOMComponentTree.precacheNode(this, el);
	      this._flags |= Flags.hasCachedChildNodes;
	      if (!this._hostParent) {
	        DOMPropertyOperations.setAttributeForRoot(el);
	      }
	      this._updateDOMProperties(null, props, transaction);
	      var lazyTree = DOMLazyTree(el);
	      this._createInitialChildren(transaction, props, context, lazyTree);
	      mountImage = lazyTree;
	    } else {
	      var tagOpen = this._createOpenTagMarkupAndPutListeners(transaction, props);
	      var tagContent = this._createContentMarkup(transaction, props, context);
	      if (!tagContent && omittedCloseTags[this._tag]) {
	        mountImage = tagOpen + '/>';
	      } else {
	        mountImage = tagOpen + '>' + tagContent + '</' + this._currentElement.type + '>';
	      }
	    }
	
	    switch (this._tag) {
	      case 'input':
	        transaction.getReactMountReady().enqueue(inputPostMount, this);
	        if (props.autoFocus) {
	          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
	        }
	        break;
	      case 'textarea':
	        transaction.getReactMountReady().enqueue(textareaPostMount, this);
	        if (props.autoFocus) {
	          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
	        }
	        break;
	      case 'select':
	        if (props.autoFocus) {
	          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
	        }
	        break;
	      case 'button':
	        if (props.autoFocus) {
	          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
	        }
	        break;
	      case 'option':
	        transaction.getReactMountReady().enqueue(optionPostMount, this);
	        break;
	    }
	
	    return mountImage;
	  },
	
	  /**
	   * Creates markup for the open tag and all attributes.
	   *
	   * This method has side effects because events get registered.
	   *
	   * Iterating over object properties is faster than iterating over arrays.
	   * @see http://jsperf.com/obj-vs-arr-iteration
	   *
	   * @private
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {object} props
	   * @return {string} Markup of opening tag.
	   */
	  _createOpenTagMarkupAndPutListeners: function (transaction, props) {
	    var ret = '<' + this._currentElement.type;
	
	    for (var propKey in props) {
	      if (!props.hasOwnProperty(propKey)) {
	        continue;
	      }
	      var propValue = props[propKey];
	      if (propValue == null) {
	        continue;
	      }
	      if (registrationNameModules.hasOwnProperty(propKey)) {
	        if (propValue) {
	          enqueuePutListener(this, propKey, propValue, transaction);
	        }
	      } else {
	        if (propKey === STYLE) {
	          if (propValue) {
	            if (false) {
	              // See `_updateDOMProperties`. style block
	              this._previousStyle = propValue;
	            }
	            propValue = this._previousStyleCopy = _assign({}, props.style);
	          }
	          propValue = CSSPropertyOperations.createMarkupForStyles(propValue, this);
	        }
	        var markup = null;
	        if (this._tag != null && isCustomComponent(this._tag, props)) {
	          if (!RESERVED_PROPS.hasOwnProperty(propKey)) {
	            markup = DOMPropertyOperations.createMarkupForCustomAttribute(propKey, propValue);
	          }
	        } else {
	          markup = DOMPropertyOperations.createMarkupForProperty(propKey, propValue);
	        }
	        if (markup) {
	          ret += ' ' + markup;
	        }
	      }
	    }
	
	    // For static pages, no need to put React ID and checksum. Saves lots of
	    // bytes.
	    if (transaction.renderToStaticMarkup) {
	      return ret;
	    }
	
	    if (!this._hostParent) {
	      ret += ' ' + DOMPropertyOperations.createMarkupForRoot();
	    }
	    ret += ' ' + DOMPropertyOperations.createMarkupForID(this._domID);
	    return ret;
	  },
	
	  /**
	   * Creates markup for the content between the tags.
	   *
	   * @private
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {object} props
	   * @param {object} context
	   * @return {string} Content markup.
	   */
	  _createContentMarkup: function (transaction, props, context) {
	    var ret = '';
	
	    // Intentional use of != to avoid catching zero/false.
	    var innerHTML = props.dangerouslySetInnerHTML;
	    if (innerHTML != null) {
	      if (innerHTML.__html != null) {
	        ret = innerHTML.__html;
	      }
	    } else {
	      var contentToUse = CONTENT_TYPES[typeof props.children] ? props.children : null;
	      var childrenToUse = contentToUse != null ? null : props.children;
	      if (contentToUse != null) {
	        // TODO: Validate that text is allowed as a child of this node
	        ret = escapeTextContentForBrowser(contentToUse);
	        if (false) {
	          setContentChildForInstrumentation.call(this, contentToUse);
	        }
	      } else if (childrenToUse != null) {
	        var mountImages = this.mountChildren(childrenToUse, transaction, context);
	        ret = mountImages.join('');
	      }
	    }
	    if (newlineEatingTags[this._tag] && ret.charAt(0) === '\n') {
	      // text/html ignores the first character in these tags if it's a newline
	      // Prefer to break application/xml over text/html (for now) by adding
	      // a newline specifically to get eaten by the parser. (Alternately for
	      // textareas, replacing "^\n" with "\r\n" doesn't get eaten, and the first
	      // \r is normalized out by HTMLTextAreaElement#value.)
	      // See: <http://www.w3.org/TR/html-polyglot/#newlines-in-textarea-and-pre>
	      // See: <http://www.w3.org/TR/html5/syntax.html#element-restrictions>
	      // See: <http://www.w3.org/TR/html5/syntax.html#newlines>
	      // See: Parsing of "textarea" "listing" and "pre" elements
	      //  from <http://www.w3.org/TR/html5/syntax.html#parsing-main-inbody>
	      return '\n' + ret;
	    } else {
	      return ret;
	    }
	  },
	
	  _createInitialChildren: function (transaction, props, context, lazyTree) {
	    // Intentional use of != to avoid catching zero/false.
	    var innerHTML = props.dangerouslySetInnerHTML;
	    if (innerHTML != null) {
	      if (innerHTML.__html != null) {
	        DOMLazyTree.queueHTML(lazyTree, innerHTML.__html);
	      }
	    } else {
	      var contentToUse = CONTENT_TYPES[typeof props.children] ? props.children : null;
	      var childrenToUse = contentToUse != null ? null : props.children;
	      if (contentToUse != null) {
	        // TODO: Validate that text is allowed as a child of this node
	        if (false) {
	          setContentChildForInstrumentation.call(this, contentToUse);
	        }
	        DOMLazyTree.queueText(lazyTree, contentToUse);
	      } else if (childrenToUse != null) {
	        var mountImages = this.mountChildren(childrenToUse, transaction, context);
	        for (var i = 0; i < mountImages.length; i++) {
	          DOMLazyTree.queueChild(lazyTree, mountImages[i]);
	        }
	      }
	    }
	  },
	
	  /**
	   * Receives a next element and updates the component.
	   *
	   * @internal
	   * @param {ReactElement} nextElement
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {object} context
	   */
	  receiveComponent: function (nextElement, transaction, context) {
	    var prevElement = this._currentElement;
	    this._currentElement = nextElement;
	    this.updateComponent(transaction, prevElement, nextElement, context);
	  },
	
	  /**
	   * Updates a DOM component after it has already been allocated and
	   * attached to the DOM. Reconciles the root DOM node, then recurses.
	   *
	   * @param {ReactReconcileTransaction} transaction
	   * @param {ReactElement} prevElement
	   * @param {ReactElement} nextElement
	   * @internal
	   * @overridable
	   */
	  updateComponent: function (transaction, prevElement, nextElement, context) {
	    var lastProps = prevElement.props;
	    var nextProps = this._currentElement.props;
	
	    switch (this._tag) {
	      case 'button':
	        lastProps = ReactDOMButton.getHostProps(this, lastProps);
	        nextProps = ReactDOMButton.getHostProps(this, nextProps);
	        break;
	      case 'input':
	        ReactDOMInput.updateWrapper(this);
	        lastProps = ReactDOMInput.getHostProps(this, lastProps);
	        nextProps = ReactDOMInput.getHostProps(this, nextProps);
	        break;
	      case 'option':
	        lastProps = ReactDOMOption.getHostProps(this, lastProps);
	        nextProps = ReactDOMOption.getHostProps(this, nextProps);
	        break;
	      case 'select':
	        lastProps = ReactDOMSelect.getHostProps(this, lastProps);
	        nextProps = ReactDOMSelect.getHostProps(this, nextProps);
	        break;
	      case 'textarea':
	        ReactDOMTextarea.updateWrapper(this);
	        lastProps = ReactDOMTextarea.getHostProps(this, lastProps);
	        nextProps = ReactDOMTextarea.getHostProps(this, nextProps);
	        break;
	    }
	
	    assertValidProps(this, nextProps);
	    this._updateDOMProperties(lastProps, nextProps, transaction);
	    this._updateDOMChildren(lastProps, nextProps, transaction, context);
	
	    if (this._tag === 'select') {
	      // <select> value update needs to occur after <option> children
	      // reconciliation
	      transaction.getReactMountReady().enqueue(postUpdateSelectWrapper, this);
	    }
	  },
	
	  /**
	   * Reconciles the properties by detecting differences in property values and
	   * updating the DOM as necessary. This function is probably the single most
	   * critical path for performance optimization.
	   *
	   * TODO: Benchmark whether checking for changed values in memory actually
	   *       improves performance (especially statically positioned elements).
	   * TODO: Benchmark the effects of putting this at the top since 99% of props
	   *       do not change for a given reconciliation.
	   * TODO: Benchmark areas that can be improved with caching.
	   *
	   * @private
	   * @param {object} lastProps
	   * @param {object} nextProps
	   * @param {?DOMElement} node
	   */
	  _updateDOMProperties: function (lastProps, nextProps, transaction) {
	    var propKey;
	    var styleName;
	    var styleUpdates;
	    for (propKey in lastProps) {
	      if (nextProps.hasOwnProperty(propKey) || !lastProps.hasOwnProperty(propKey) || lastProps[propKey] == null) {
	        continue;
	      }
	      if (propKey === STYLE) {
	        var lastStyle = this._previousStyleCopy;
	        for (styleName in lastStyle) {
	          if (lastStyle.hasOwnProperty(styleName)) {
	            styleUpdates = styleUpdates || {};
	            styleUpdates[styleName] = '';
	          }
	        }
	        this._previousStyleCopy = null;
	      } else if (registrationNameModules.hasOwnProperty(propKey)) {
	        if (lastProps[propKey]) {
	          // Only call deleteListener if there was a listener previously or
	          // else willDeleteListener gets called when there wasn't actually a
	          // listener (e.g., onClick={null})
	          deleteListener(this, propKey);
	        }
	      } else if (isCustomComponent(this._tag, lastProps)) {
	        if (!RESERVED_PROPS.hasOwnProperty(propKey)) {
	          DOMPropertyOperations.deleteValueForAttribute(getNode(this), propKey);
	        }
	      } else if (DOMProperty.properties[propKey] || DOMProperty.isCustomAttribute(propKey)) {
	        DOMPropertyOperations.deleteValueForProperty(getNode(this), propKey);
	      }
	    }
	    for (propKey in nextProps) {
	      var nextProp = nextProps[propKey];
	      var lastProp = propKey === STYLE ? this._previousStyleCopy : lastProps != null ? lastProps[propKey] : undefined;
	      if (!nextProps.hasOwnProperty(propKey) || nextProp === lastProp || nextProp == null && lastProp == null) {
	        continue;
	      }
	      if (propKey === STYLE) {
	        if (nextProp) {
	          if (false) {
	            checkAndWarnForMutatedStyle(this._previousStyleCopy, this._previousStyle, this);
	            this._previousStyle = nextProp;
	          }
	          nextProp = this._previousStyleCopy = _assign({}, nextProp);
	        } else {
	          this._previousStyleCopy = null;
	        }
	        if (lastProp) {
	          // Unset styles on `lastProp` but not on `nextProp`.
	          for (styleName in lastProp) {
	            if (lastProp.hasOwnProperty(styleName) && (!nextProp || !nextProp.hasOwnProperty(styleName))) {
	              styleUpdates = styleUpdates || {};
	              styleUpdates[styleName] = '';
	            }
	          }
	          // Update styles that changed since `lastProp`.
	          for (styleName in nextProp) {
	            if (nextProp.hasOwnProperty(styleName) && lastProp[styleName] !== nextProp[styleName]) {
	              styleUpdates = styleUpdates || {};
	              styleUpdates[styleName] = nextProp[styleName];
	            }
	          }
	        } else {
	          // Relies on `updateStylesByID` not mutating `styleUpdates`.
	          styleUpdates = nextProp;
	        }
	      } else if (registrationNameModules.hasOwnProperty(propKey)) {
	        if (nextProp) {
	          enqueuePutListener(this, propKey, nextProp, transaction);
	        } else if (lastProp) {
	          deleteListener(this, propKey);
	        }
	      } else if (isCustomComponent(this._tag, nextProps)) {
	        if (!RESERVED_PROPS.hasOwnProperty(propKey)) {
	          DOMPropertyOperations.setValueForAttribute(getNode(this), propKey, nextProp);
	        }
	      } else if (DOMProperty.properties[propKey] || DOMProperty.isCustomAttribute(propKey)) {
	        var node = getNode(this);
	        // If we're updating to null or undefined, we should remove the property
	        // from the DOM node instead of inadvertently setting to a string. This
	        // brings us in line with the same behavior we have on initial render.
	        if (nextProp != null) {
	          DOMPropertyOperations.setValueForProperty(node, propKey, nextProp);
	        } else {
	          DOMPropertyOperations.deleteValueForProperty(node, propKey);
	        }
	      }
	    }
	    if (styleUpdates) {
	      CSSPropertyOperations.setValueForStyles(getNode(this), styleUpdates, this);
	    }
	  },
	
	  /**
	   * Reconciles the children with the various properties that affect the
	   * children content.
	   *
	   * @param {object} lastProps
	   * @param {object} nextProps
	   * @param {ReactReconcileTransaction} transaction
	   * @param {object} context
	   */
	  _updateDOMChildren: function (lastProps, nextProps, transaction, context) {
	    var lastContent = CONTENT_TYPES[typeof lastProps.children] ? lastProps.children : null;
	    var nextContent = CONTENT_TYPES[typeof nextProps.children] ? nextProps.children : null;
	
	    var lastHtml = lastProps.dangerouslySetInnerHTML && lastProps.dangerouslySetInnerHTML.__html;
	    var nextHtml = nextProps.dangerouslySetInnerHTML && nextProps.dangerouslySetInnerHTML.__html;
	
	    // Note the use of `!=` which checks for null or undefined.
	    var lastChildren = lastContent != null ? null : lastProps.children;
	    var nextChildren = nextContent != null ? null : nextProps.children;
	
	    // If we're switching from children to content/html or vice versa, remove
	    // the old content
	    var lastHasContentOrHtml = lastContent != null || lastHtml != null;
	    var nextHasContentOrHtml = nextContent != null || nextHtml != null;
	    if (lastChildren != null && nextChildren == null) {
	      this.updateChildren(null, transaction, context);
	    } else if (lastHasContentOrHtml && !nextHasContentOrHtml) {
	      this.updateTextContent('');
	      if (false) {
	        ReactInstrumentation.debugTool.onSetChildren(this._debugID, []);
	      }
	    }
	
	    if (nextContent != null) {
	      if (lastContent !== nextContent) {
	        this.updateTextContent('' + nextContent);
	        if (false) {
	          setContentChildForInstrumentation.call(this, nextContent);
	        }
	      }
	    } else if (nextHtml != null) {
	      if (lastHtml !== nextHtml) {
	        this.updateMarkup('' + nextHtml);
	      }
	      if (false) {
	        ReactInstrumentation.debugTool.onSetChildren(this._debugID, []);
	      }
	    } else if (nextChildren != null) {
	      if (false) {
	        setContentChildForInstrumentation.call(this, null);
	      }
	
	      this.updateChildren(nextChildren, transaction, context);
	    }
	  },
	
	  getHostNode: function () {
	    return getNode(this);
	  },
	
	  /**
	   * Destroys all event registrations for this instance. Does not remove from
	   * the DOM. That must be done by the parent.
	   *
	   * @internal
	   */
	  unmountComponent: function (safely) {
	    switch (this._tag) {
	      case 'audio':
	      case 'form':
	      case 'iframe':
	      case 'img':
	      case 'link':
	      case 'object':
	      case 'source':
	      case 'video':
	        var listeners = this._wrapperState.listeners;
	        if (listeners) {
	          for (var i = 0; i < listeners.length; i++) {
	            listeners[i].remove();
	          }
	        }
	        break;
	      case 'html':
	      case 'head':
	      case 'body':
	        /**
	         * Components like <html> <head> and <body> can't be removed or added
	         * easily in a cross-browser way, however it's valuable to be able to
	         * take advantage of React's reconciliation for styling and <title>
	         * management. So we just document it and throw in dangerous cases.
	         */
	         true ?  false ? invariant(false, '<%s> tried to unmount. Because of cross-browser quirks it is impossible to unmount some top-level components (eg <html>, <head>, and <body>) reliably and efficiently. To fix this, have a single top-level component that never unmounts render these elements.', this._tag) : _prodInvariant('66', this._tag) : void 0;
	        break;
	    }
	
	    this.unmountChildren(safely);
	    ReactDOMComponentTree.uncacheNode(this);
	    EventPluginHub.deleteAllListeners(this);
	    ReactComponentBrowserEnvironment.unmountIDFromEnvironment(this._rootNodeID);
	    this._rootNodeID = null;
	    this._domID = null;
	    this._wrapperState = null;
	
	    if (false) {
	      setContentChildForInstrumentation.call(this, null);
	    }
	  },
	
	  getPublicInstance: function () {
	    return getNode(this);
	  }
	
	};
	
	_assign(ReactDOMComponent.prototype, ReactDOMComponent.Mixin, ReactMultiChild.Mixin);
	
	module.exports = ReactDOMComponent;

/***/ },
/* 753 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDOMContainerInfo
	 */
	
	'use strict';
	
	var validateDOMNesting = __webpack_require__(214);
	
	var DOC_NODE_TYPE = 9;
	
	function ReactDOMContainerInfo(topLevelWrapper, node) {
	  var info = {
	    _topLevelWrapper: topLevelWrapper,
	    _idCounter: 1,
	    _ownerDocument: node ? node.nodeType === DOC_NODE_TYPE ? node : node.ownerDocument : null,
	    _node: node,
	    _tag: node ? node.nodeName.toLowerCase() : null,
	    _namespaceURI: node ? node.namespaceURI : null
	  };
	  if (false) {
	    info._ancestorInfo = node ? validateDOMNesting.updatedAncestorInfo(null, info._tag, null) : null;
	  }
	  return info;
	}
	
	module.exports = ReactDOMContainerInfo;

/***/ },
/* 754 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDOMEmptyComponent
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(6);
	
	var DOMLazyTree = __webpack_require__(89);
	var ReactDOMComponentTree = __webpack_require__(15);
	
	var ReactDOMEmptyComponent = function (instantiate) {
	  // ReactCompositeComponent uses this:
	  this._currentElement = null;
	  // ReactDOMComponentTree uses these:
	  this._hostNode = null;
	  this._hostParent = null;
	  this._hostContainerInfo = null;
	  this._domID = null;
	};
	_assign(ReactDOMEmptyComponent.prototype, {
	  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
	    var domID = hostContainerInfo._idCounter++;
	    this._domID = domID;
	    this._hostParent = hostParent;
	    this._hostContainerInfo = hostContainerInfo;
	
	    var nodeValue = ' react-empty: ' + this._domID + ' ';
	    if (transaction.useCreateElement) {
	      var ownerDocument = hostContainerInfo._ownerDocument;
	      var node = ownerDocument.createComment(nodeValue);
	      ReactDOMComponentTree.precacheNode(this, node);
	      return DOMLazyTree(node);
	    } else {
	      if (transaction.renderToStaticMarkup) {
	        // Normally we'd insert a comment node, but since this is a situation
	        // where React won't take over (static pages), we can simply return
	        // nothing.
	        return '';
	      }
	      return '<!--' + nodeValue + '-->';
	    }
	  },
	  receiveComponent: function () {},
	  getHostNode: function () {
	    return ReactDOMComponentTree.getNodeFromInstance(this);
	  },
	  unmountComponent: function () {
	    ReactDOMComponentTree.uncacheNode(this);
	  }
	});
	
	module.exports = ReactDOMEmptyComponent;

/***/ },
/* 755 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDOMFactories
	 */
	
	'use strict';
	
	var ReactElement = __webpack_require__(45);
	
	var mapObject = __webpack_require__(549);
	
	/**
	 * Create a factory that creates HTML tag elements.
	 *
	 * @param {string} tag Tag name (e.g. `div`).
	 * @private
	 */
	function createDOMFactory(tag) {
	  if (false) {
	    var ReactElementValidator = require('./ReactElementValidator');
	    return ReactElementValidator.createFactory(tag);
	  }
	  return ReactElement.createFactory(tag);
	}
	
	/**
	 * Creates a mapping from supported HTML tags to `ReactDOMComponent` classes.
	 * This is also accessible via `React.DOM`.
	 *
	 * @public
	 */
	var ReactDOMFactories = mapObject({
	  a: 'a',
	  abbr: 'abbr',
	  address: 'address',
	  area: 'area',
	  article: 'article',
	  aside: 'aside',
	  audio: 'audio',
	  b: 'b',
	  base: 'base',
	  bdi: 'bdi',
	  bdo: 'bdo',
	  big: 'big',
	  blockquote: 'blockquote',
	  body: 'body',
	  br: 'br',
	  button: 'button',
	  canvas: 'canvas',
	  caption: 'caption',
	  cite: 'cite',
	  code: 'code',
	  col: 'col',
	  colgroup: 'colgroup',
	  data: 'data',
	  datalist: 'datalist',
	  dd: 'dd',
	  del: 'del',
	  details: 'details',
	  dfn: 'dfn',
	  dialog: 'dialog',
	  div: 'div',
	  dl: 'dl',
	  dt: 'dt',
	  em: 'em',
	  embed: 'embed',
	  fieldset: 'fieldset',
	  figcaption: 'figcaption',
	  figure: 'figure',
	  footer: 'footer',
	  form: 'form',
	  h1: 'h1',
	  h2: 'h2',
	  h3: 'h3',
	  h4: 'h4',
	  h5: 'h5',
	  h6: 'h6',
	  head: 'head',
	  header: 'header',
	  hgroup: 'hgroup',
	  hr: 'hr',
	  html: 'html',
	  i: 'i',
	  iframe: 'iframe',
	  img: 'img',
	  input: 'input',
	  ins: 'ins',
	  kbd: 'kbd',
	  keygen: 'keygen',
	  label: 'label',
	  legend: 'legend',
	  li: 'li',
	  link: 'link',
	  main: 'main',
	  map: 'map',
	  mark: 'mark',
	  menu: 'menu',
	  menuitem: 'menuitem',
	  meta: 'meta',
	  meter: 'meter',
	  nav: 'nav',
	  noscript: 'noscript',
	  object: 'object',
	  ol: 'ol',
	  optgroup: 'optgroup',
	  option: 'option',
	  output: 'output',
	  p: 'p',
	  param: 'param',
	  picture: 'picture',
	  pre: 'pre',
	  progress: 'progress',
	  q: 'q',
	  rp: 'rp',
	  rt: 'rt',
	  ruby: 'ruby',
	  s: 's',
	  samp: 'samp',
	  script: 'script',
	  section: 'section',
	  select: 'select',
	  small: 'small',
	  source: 'source',
	  span: 'span',
	  strong: 'strong',
	  style: 'style',
	  sub: 'sub',
	  summary: 'summary',
	  sup: 'sup',
	  table: 'table',
	  tbody: 'tbody',
	  td: 'td',
	  textarea: 'textarea',
	  tfoot: 'tfoot',
	  th: 'th',
	  thead: 'thead',
	  time: 'time',
	  title: 'title',
	  tr: 'tr',
	  track: 'track',
	  u: 'u',
	  ul: 'ul',
	  'var': 'var',
	  video: 'video',
	  wbr: 'wbr',
	
	  // SVG
	  circle: 'circle',
	  clipPath: 'clipPath',
	  defs: 'defs',
	  ellipse: 'ellipse',
	  g: 'g',
	  image: 'image',
	  line: 'line',
	  linearGradient: 'linearGradient',
	  mask: 'mask',
	  path: 'path',
	  pattern: 'pattern',
	  polygon: 'polygon',
	  polyline: 'polyline',
	  radialGradient: 'radialGradient',
	  rect: 'rect',
	  stop: 'stop',
	  svg: 'svg',
	  text: 'text',
	  tspan: 'tspan'
	
	}, createDOMFactory);
	
	module.exports = ReactDOMFactories;

/***/ },
/* 756 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDOMFeatureFlags
	 */
	
	'use strict';
	
	var ReactDOMFeatureFlags = {
	  useCreateElement: true
	};
	
	module.exports = ReactDOMFeatureFlags;

/***/ },
/* 757 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDOMIDOperations
	 */
	
	'use strict';
	
	var DOMChildrenOperations = __webpack_require__(196);
	var ReactDOMComponentTree = __webpack_require__(15);
	
	/**
	 * Operations used to process updates to DOM nodes.
	 */
	var ReactDOMIDOperations = {
	
	  /**
	   * Updates a component's children by processing a series of updates.
	   *
	   * @param {array<object>} updates List of update configurations.
	   * @internal
	   */
	  dangerouslyProcessChildrenUpdates: function (parentInst, updates) {
	    var node = ReactDOMComponentTree.getNodeFromInstance(parentInst);
	    DOMChildrenOperations.processUpdates(node, updates);
	  }
	};
	
	module.exports = ReactDOMIDOperations;

/***/ },
/* 758 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDOMInput
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(5),
	    _assign = __webpack_require__(6);
	
	var DisabledInputUtils = __webpack_require__(139);
	var DOMPropertyOperations = __webpack_require__(312);
	var LinkedValueUtils = __webpack_require__(201);
	var ReactDOMComponentTree = __webpack_require__(15);
	var ReactUpdates = __webpack_require__(46);
	
	var invariant = __webpack_require__(2);
	var warning = __webpack_require__(9);
	
	var didWarnValueLink = false;
	var didWarnCheckedLink = false;
	var didWarnValueDefaultValue = false;
	var didWarnCheckedDefaultChecked = false;
	var didWarnControlledToUncontrolled = false;
	var didWarnUncontrolledToControlled = false;
	
	function forceUpdateIfMounted() {
	  if (this._rootNodeID) {
	    // DOM component is still mounted; update
	    ReactDOMInput.updateWrapper(this);
	  }
	}
	
	function isControlled(props) {
	  var usesChecked = props.type === 'checkbox' || props.type === 'radio';
	  return usesChecked ? props.checked !== undefined : props.value !== undefined;
	}
	
	/**
	 * Implements an <input> host component that allows setting these optional
	 * props: `checked`, `value`, `defaultChecked`, and `defaultValue`.
	 *
	 * If `checked` or `value` are not supplied (or null/undefined), user actions
	 * that affect the checked state or value will trigger updates to the element.
	 *
	 * If they are supplied (and not null/undefined), the rendered element will not
	 * trigger updates to the element. Instead, the props must change in order for
	 * the rendered element to be updated.
	 *
	 * The rendered element will be initialized as unchecked (or `defaultChecked`)
	 * with an empty value (or `defaultValue`).
	 *
	 * @see http://www.w3.org/TR/2012/WD-html5-20121025/the-input-element.html
	 */
	var ReactDOMInput = {
	  getHostProps: function (inst, props) {
	    var value = LinkedValueUtils.getValue(props);
	    var checked = LinkedValueUtils.getChecked(props);
	
	    var hostProps = _assign({
	      // Make sure we set .type before any other properties (setting .value
	      // before .type means .value is lost in IE11 and below)
	      type: undefined
	    }, DisabledInputUtils.getHostProps(inst, props), {
	      defaultChecked: undefined,
	      defaultValue: undefined,
	      value: value != null ? value : inst._wrapperState.initialValue,
	      checked: checked != null ? checked : inst._wrapperState.initialChecked,
	      onChange: inst._wrapperState.onChange
	    });
	
	    return hostProps;
	  },
	
	  mountWrapper: function (inst, props) {
	    if (false) {
	      LinkedValueUtils.checkPropTypes('input', props, inst._currentElement._owner);
	
	      var owner = inst._currentElement._owner;
	
	      if (props.valueLink !== undefined && !didWarnValueLink) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '`valueLink` prop on `input` is deprecated; set `value` and `onChange` instead.') : void 0;
	        didWarnValueLink = true;
	      }
	      if (props.checkedLink !== undefined && !didWarnCheckedLink) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '`checkedLink` prop on `input` is deprecated; set `value` and `onChange` instead.') : void 0;
	        didWarnCheckedLink = true;
	      }
	      if (props.checked !== undefined && props.defaultChecked !== undefined && !didWarnCheckedDefaultChecked) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '%s contains an input of type %s with both checked and defaultChecked props. ' + 'Input elements must be either controlled or uncontrolled ' + '(specify either the checked prop, or the defaultChecked prop, but not ' + 'both). Decide between using a controlled or uncontrolled input ' + 'element and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
	        didWarnCheckedDefaultChecked = true;
	      }
	      if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValueDefaultValue) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '%s contains an input of type %s with both value and defaultValue props. ' + 'Input elements must be either controlled or uncontrolled ' + '(specify either the value prop, or the defaultValue prop, but not ' + 'both). Decide between using a controlled or uncontrolled input ' + 'element and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
	        didWarnValueDefaultValue = true;
	      }
	    }
	
	    var defaultValue = props.defaultValue;
	    inst._wrapperState = {
	      initialChecked: props.checked != null ? props.checked : props.defaultChecked,
	      initialValue: props.value != null ? props.value : defaultValue,
	      listeners: null,
	      onChange: _handleChange.bind(inst)
	    };
	
	    if (false) {
	      inst._wrapperState.controlled = isControlled(props);
	    }
	  },
	
	  updateWrapper: function (inst) {
	    var props = inst._currentElement.props;
	
	    if (false) {
	      var controlled = isControlled(props);
	      var owner = inst._currentElement._owner;
	
	      if (!inst._wrapperState.controlled && controlled && !didWarnUncontrolledToControlled) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '%s is changing an uncontrolled input of type %s to be controlled. ' + 'Input elements should not switch from uncontrolled to controlled (or vice versa). ' + 'Decide between using a controlled or uncontrolled input ' + 'element for the lifetime of the component. More info: https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
	        didWarnUncontrolledToControlled = true;
	      }
	      if (inst._wrapperState.controlled && !controlled && !didWarnControlledToUncontrolled) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '%s is changing a controlled input of type %s to be uncontrolled. ' + 'Input elements should not switch from controlled to uncontrolled (or vice versa). ' + 'Decide between using a controlled or uncontrolled input ' + 'element for the lifetime of the component. More info: https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
	        didWarnControlledToUncontrolled = true;
	      }
	    }
	
	    // TODO: Shouldn't this be getChecked(props)?
	    var checked = props.checked;
	    if (checked != null) {
	      DOMPropertyOperations.setValueForProperty(ReactDOMComponentTree.getNodeFromInstance(inst), 'checked', checked || false);
	    }
	
	    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	    var value = LinkedValueUtils.getValue(props);
	    if (value != null) {
	
	      // Cast `value` to a string to ensure the value is set correctly. While
	      // browsers typically do this as necessary, jsdom doesn't.
	      var newValue = '' + value;
	
	      // To avoid side effects (such as losing text selection), only set value if changed
	      if (newValue !== node.value) {
	        node.value = newValue;
	      }
	    } else {
	      if (props.value == null && props.defaultValue != null) {
	        node.defaultValue = '' + props.defaultValue;
	      }
	      if (props.checked == null && props.defaultChecked != null) {
	        node.defaultChecked = !!props.defaultChecked;
	      }
	    }
	  },
	
	  postMountWrapper: function (inst) {
	    var props = inst._currentElement.props;
	
	    // This is in postMount because we need access to the DOM node, which is not
	    // available until after the component has mounted.
	    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	
	    // Detach value from defaultValue. We won't do anything if we're working on
	    // submit or reset inputs as those values & defaultValues are linked. They
	    // are not resetable nodes so this operation doesn't matter and actually
	    // removes browser-default values (eg "Submit Query") when no value is
	    // provided.
	    if (props.type !== 'submit' && props.type !== 'reset') {
	      node.value = node.value;
	    }
	
	    // Normally, we'd just do `node.checked = node.checked` upon initial mount, less this bug
	    // this is needed to work around a chrome bug where setting defaultChecked
	    // will sometimes influence the value of checked (even after detachment).
	    // Reference: https://bugs.chromium.org/p/chromium/issues/detail?id=608416
	    // We need to temporarily unset name to avoid disrupting radio button groups.
	    var name = node.name;
	    if (name !== '') {
	      node.name = '';
	    }
	    node.defaultChecked = !node.defaultChecked;
	    node.defaultChecked = !node.defaultChecked;
	    if (name !== '') {
	      node.name = name;
	    }
	  }
	};
	
	function _handleChange(event) {
	  var props = this._currentElement.props;
	
	  var returnValue = LinkedValueUtils.executeOnChange(props, event);
	
	  // Here we use asap to wait until all updates have propagated, which
	  // is important when using controlled components within layers:
	  // https://github.com/facebook/react/issues/1698
	  ReactUpdates.asap(forceUpdateIfMounted, this);
	
	  var name = props.name;
	  if (props.type === 'radio' && name != null) {
	    var rootNode = ReactDOMComponentTree.getNodeFromInstance(this);
	    var queryRoot = rootNode;
	
	    while (queryRoot.parentNode) {
	      queryRoot = queryRoot.parentNode;
	    }
	
	    // If `rootNode.form` was non-null, then we could try `form.elements`,
	    // but that sometimes behaves strangely in IE8. We could also try using
	    // `form.getElementsByName`, but that will only return direct children
	    // and won't include inputs that use the HTML5 `form=` attribute. Since
	    // the input might not even be in a form, let's just use the global
	    // `querySelectorAll` to ensure we don't miss anything.
	    var group = queryRoot.querySelectorAll('input[name=' + JSON.stringify('' + name) + '][type="radio"]');
	
	    for (var i = 0; i < group.length; i++) {
	      var otherNode = group[i];
	      if (otherNode === rootNode || otherNode.form !== rootNode.form) {
	        continue;
	      }
	      // This will throw if radio buttons rendered by different copies of React
	      // and the same name are rendered into the same form (same as #1939).
	      // That's probably okay; we don't support it just as we don't support
	      // mixing React radio buttons with non-React ones.
	      var otherInstance = ReactDOMComponentTree.getInstanceFromNode(otherNode);
	      !otherInstance ?  false ? invariant(false, 'ReactDOMInput: Mixing React and non-React radio inputs with the same `name` is not supported.') : _prodInvariant('90') : void 0;
	      // If this is a controlled radio button group, forcing the input that
	      // was previously checked to update will cause it to be come re-checked
	      // as appropriate.
	      ReactUpdates.asap(forceUpdateIfMounted, otherInstance);
	    }
	  }
	
	  return returnValue;
	}
	
	module.exports = ReactDOMInput;

/***/ },
/* 759 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDOMInstrumentation
	 */
	
	'use strict';
	
	var debugTool = null;
	
	if (false) {
	  var ReactDOMDebugTool = require('./ReactDOMDebugTool');
	  debugTool = ReactDOMDebugTool;
	}
	
	module.exports = { debugTool: debugTool };

/***/ },
/* 760 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDOMOption
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(6);
	
	var ReactChildren = __webpack_require__(313);
	var ReactDOMComponentTree = __webpack_require__(15);
	var ReactDOMSelect = __webpack_require__(318);
	
	var warning = __webpack_require__(9);
	var didWarnInvalidOptionChildren = false;
	
	function flattenChildren(children) {
	  var content = '';
	
	  // Flatten children and warn if they aren't strings or numbers;
	  // invalid types are ignored.
	  ReactChildren.forEach(children, function (child) {
	    if (child == null) {
	      return;
	    }
	    if (typeof child === 'string' || typeof child === 'number') {
	      content += child;
	    } else if (!didWarnInvalidOptionChildren) {
	      didWarnInvalidOptionChildren = true;
	       false ? warning(false, 'Only strings and numbers are supported as <option> children.') : void 0;
	    }
	  });
	
	  return content;
	}
	
	/**
	 * Implements an <option> host component that warns when `selected` is set.
	 */
	var ReactDOMOption = {
	  mountWrapper: function (inst, props, hostParent) {
	    // TODO (yungsters): Remove support for `selected` in <option>.
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(props.selected == null, 'Use the `defaultValue` or `value` props on <select> instead of ' + 'setting `selected` on <option>.') : void 0;
	    }
	
	    // Look up whether this option is 'selected'
	    var selectValue = null;
	    if (hostParent != null) {
	      var selectParent = hostParent;
	
	      if (selectParent._tag === 'optgroup') {
	        selectParent = selectParent._hostParent;
	      }
	
	      if (selectParent != null && selectParent._tag === 'select') {
	        selectValue = ReactDOMSelect.getSelectValueContext(selectParent);
	      }
	    }
	
	    // If the value is null (e.g., no specified value or after initial mount)
	    // or missing (e.g., for <datalist>), we don't change props.selected
	    var selected = null;
	    if (selectValue != null) {
	      var value;
	      if (props.value != null) {
	        value = props.value + '';
	      } else {
	        value = flattenChildren(props.children);
	      }
	      selected = false;
	      if (Array.isArray(selectValue)) {
	        // multiple
	        for (var i = 0; i < selectValue.length; i++) {
	          if ('' + selectValue[i] === value) {
	            selected = true;
	            break;
	          }
	        }
	      } else {
	        selected = '' + selectValue === value;
	      }
	    }
	
	    inst._wrapperState = { selected: selected };
	  },
	
	  postMountWrapper: function (inst) {
	    // value="" should make a value attribute (#6219)
	    var props = inst._currentElement.props;
	    if (props.value != null) {
	      var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	      node.setAttribute('value', props.value);
	    }
	  },
	
	  getHostProps: function (inst, props) {
	    var hostProps = _assign({ selected: undefined, children: undefined }, props);
	
	    // Read state only from initial mount because <select> updates value
	    // manually; we need the initial state only for server rendering
	    if (inst._wrapperState.selected != null) {
	      hostProps.selected = inst._wrapperState.selected;
	    }
	
	    var content = flattenChildren(props.children);
	
	    if (content) {
	      hostProps.children = content;
	    }
	
	    return hostProps;
	  }
	
	};
	
	module.exports = ReactDOMOption;

/***/ },
/* 761 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDOMSelection
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(22);
	
	var getNodeForCharacterOffset = __webpack_require__(796);
	var getTextContentAccessor = __webpack_require__(335);
	
	/**
	 * While `isCollapsed` is available on the Selection object and `collapsed`
	 * is available on the Range object, IE11 sometimes gets them wrong.
	 * If the anchor/focus nodes and offsets are the same, the range is collapsed.
	 */
	function isCollapsed(anchorNode, anchorOffset, focusNode, focusOffset) {
	  return anchorNode === focusNode && anchorOffset === focusOffset;
	}
	
	/**
	 * Get the appropriate anchor and focus node/offset pairs for IE.
	 *
	 * The catch here is that IE's selection API doesn't provide information
	 * about whether the selection is forward or backward, so we have to
	 * behave as though it's always forward.
	 *
	 * IE text differs from modern selection in that it behaves as though
	 * block elements end with a new line. This means character offsets will
	 * differ between the two APIs.
	 *
	 * @param {DOMElement} node
	 * @return {object}
	 */
	function getIEOffsets(node) {
	  var selection = document.selection;
	  var selectedRange = selection.createRange();
	  var selectedLength = selectedRange.text.length;
	
	  // Duplicate selection so we can move range without breaking user selection.
	  var fromStart = selectedRange.duplicate();
	  fromStart.moveToElementText(node);
	  fromStart.setEndPoint('EndToStart', selectedRange);
	
	  var startOffset = fromStart.text.length;
	  var endOffset = startOffset + selectedLength;
	
	  return {
	    start: startOffset,
	    end: endOffset
	  };
	}
	
	/**
	 * @param {DOMElement} node
	 * @return {?object}
	 */
	function getModernOffsets(node) {
	  var selection = window.getSelection && window.getSelection();
	
	  if (!selection || selection.rangeCount === 0) {
	    return null;
	  }
	
	  var anchorNode = selection.anchorNode;
	  var anchorOffset = selection.anchorOffset;
	  var focusNode = selection.focusNode;
	  var focusOffset = selection.focusOffset;
	
	  var currentRange = selection.getRangeAt(0);
	
	  // In Firefox, range.startContainer and range.endContainer can be "anonymous
	  // divs", e.g. the up/down buttons on an <input type="number">. Anonymous
	  // divs do not seem to expose properties, triggering a "Permission denied
	  // error" if any of its properties are accessed. The only seemingly possible
	  // way to avoid erroring is to access a property that typically works for
	  // non-anonymous divs and catch any error that may otherwise arise. See
	  // https://bugzilla.mozilla.org/show_bug.cgi?id=208427
	  try {
	    /* eslint-disable no-unused-expressions */
	    currentRange.startContainer.nodeType;
	    currentRange.endContainer.nodeType;
	    /* eslint-enable no-unused-expressions */
	  } catch (e) {
	    return null;
	  }
	
	  // If the node and offset values are the same, the selection is collapsed.
	  // `Selection.isCollapsed` is available natively, but IE sometimes gets
	  // this value wrong.
	  var isSelectionCollapsed = isCollapsed(selection.anchorNode, selection.anchorOffset, selection.focusNode, selection.focusOffset);
	
	  var rangeLength = isSelectionCollapsed ? 0 : currentRange.toString().length;
	
	  var tempRange = currentRange.cloneRange();
	  tempRange.selectNodeContents(node);
	  tempRange.setEnd(currentRange.startContainer, currentRange.startOffset);
	
	  var isTempRangeCollapsed = isCollapsed(tempRange.startContainer, tempRange.startOffset, tempRange.endContainer, tempRange.endOffset);
	
	  var start = isTempRangeCollapsed ? 0 : tempRange.toString().length;
	  var end = start + rangeLength;
	
	  // Detect whether the selection is backward.
	  var detectionRange = document.createRange();
	  detectionRange.setStart(anchorNode, anchorOffset);
	  detectionRange.setEnd(focusNode, focusOffset);
	  var isBackward = detectionRange.collapsed;
	
	  return {
	    start: isBackward ? end : start,
	    end: isBackward ? start : end
	  };
	}
	
	/**
	 * @param {DOMElement|DOMTextNode} node
	 * @param {object} offsets
	 */
	function setIEOffsets(node, offsets) {
	  var range = document.selection.createRange().duplicate();
	  var start, end;
	
	  if (offsets.end === undefined) {
	    start = offsets.start;
	    end = start;
	  } else if (offsets.start > offsets.end) {
	    start = offsets.end;
	    end = offsets.start;
	  } else {
	    start = offsets.start;
	    end = offsets.end;
	  }
	
	  range.moveToElementText(node);
	  range.moveStart('character', start);
	  range.setEndPoint('EndToStart', range);
	  range.moveEnd('character', end - start);
	  range.select();
	}
	
	/**
	 * In modern non-IE browsers, we can support both forward and backward
	 * selections.
	 *
	 * Note: IE10+ supports the Selection object, but it does not support
	 * the `extend` method, which means that even in modern IE, it's not possible
	 * to programmatically create a backward selection. Thus, for all IE
	 * versions, we use the old IE API to create our selections.
	 *
	 * @param {DOMElement|DOMTextNode} node
	 * @param {object} offsets
	 */
	function setModernOffsets(node, offsets) {
	  if (!window.getSelection) {
	    return;
	  }
	
	  var selection = window.getSelection();
	  var length = node[getTextContentAccessor()].length;
	  var start = Math.min(offsets.start, length);
	  var end = offsets.end === undefined ? start : Math.min(offsets.end, length);
	
	  // IE 11 uses modern selection, but doesn't support the extend method.
	  // Flip backward selections, so we can set with a single range.
	  if (!selection.extend && start > end) {
	    var temp = end;
	    end = start;
	    start = temp;
	  }
	
	  var startMarker = getNodeForCharacterOffset(node, start);
	  var endMarker = getNodeForCharacterOffset(node, end);
	
	  if (startMarker && endMarker) {
	    var range = document.createRange();
	    range.setStart(startMarker.node, startMarker.offset);
	    selection.removeAllRanges();
	
	    if (start > end) {
	      selection.addRange(range);
	      selection.extend(endMarker.node, endMarker.offset);
	    } else {
	      range.setEnd(endMarker.node, endMarker.offset);
	      selection.addRange(range);
	    }
	  }
	}
	
	var useIEOffsets = ExecutionEnvironment.canUseDOM && 'selection' in document && !('getSelection' in window);
	
	var ReactDOMSelection = {
	  /**
	   * @param {DOMElement} node
	   */
	  getOffsets: useIEOffsets ? getIEOffsets : getModernOffsets,
	
	  /**
	   * @param {DOMElement|DOMTextNode} node
	   * @param {object} offsets
	   */
	  setOffsets: useIEOffsets ? setIEOffsets : setModernOffsets
	};
	
	module.exports = ReactDOMSelection;

/***/ },
/* 762 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDOMTextComponent
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(5),
	    _assign = __webpack_require__(6);
	
	var DOMChildrenOperations = __webpack_require__(196);
	var DOMLazyTree = __webpack_require__(89);
	var ReactDOMComponentTree = __webpack_require__(15);
	var ReactInstrumentation = __webpack_require__(31);
	
	var escapeTextContentForBrowser = __webpack_require__(142);
	var invariant = __webpack_require__(2);
	var validateDOMNesting = __webpack_require__(214);
	
	/**
	 * Text nodes violate a couple assumptions that React makes about components:
	 *
	 *  - When mounting text into the DOM, adjacent text nodes are merged.
	 *  - Text nodes cannot be assigned a React root ID.
	 *
	 * This component is used to wrap strings between comment nodes so that they
	 * can undergo the same reconciliation that is applied to elements.
	 *
	 * TODO: Investigate representing React components in the DOM with text nodes.
	 *
	 * @class ReactDOMTextComponent
	 * @extends ReactComponent
	 * @internal
	 */
	var ReactDOMTextComponent = function (text) {
	  // TODO: This is really a ReactText (ReactNode), not a ReactElement
	  this._currentElement = text;
	  this._stringText = '' + text;
	  // ReactDOMComponentTree uses these:
	  this._hostNode = null;
	  this._hostParent = null;
	
	  // Properties
	  this._domID = null;
	  this._mountIndex = 0;
	  this._closingComment = null;
	  this._commentNodes = null;
	};
	
	_assign(ReactDOMTextComponent.prototype, {
	
	  /**
	   * Creates the markup for this text node. This node is not intended to have
	   * any features besides containing text content.
	   *
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @return {string} Markup for this text node.
	   * @internal
	   */
	  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
	    if (false) {
	      ReactInstrumentation.debugTool.onSetText(this._debugID, this._stringText);
	
	      var parentInfo;
	      if (hostParent != null) {
	        parentInfo = hostParent._ancestorInfo;
	      } else if (hostContainerInfo != null) {
	        parentInfo = hostContainerInfo._ancestorInfo;
	      }
	      if (parentInfo) {
	        // parentInfo should always be present except for the top-level
	        // component when server rendering
	        validateDOMNesting('#text', this, parentInfo);
	      }
	    }
	
	    var domID = hostContainerInfo._idCounter++;
	    var openingValue = ' react-text: ' + domID + ' ';
	    var closingValue = ' /react-text ';
	    this._domID = domID;
	    this._hostParent = hostParent;
	    if (transaction.useCreateElement) {
	      var ownerDocument = hostContainerInfo._ownerDocument;
	      var openingComment = ownerDocument.createComment(openingValue);
	      var closingComment = ownerDocument.createComment(closingValue);
	      var lazyTree = DOMLazyTree(ownerDocument.createDocumentFragment());
	      DOMLazyTree.queueChild(lazyTree, DOMLazyTree(openingComment));
	      if (this._stringText) {
	        DOMLazyTree.queueChild(lazyTree, DOMLazyTree(ownerDocument.createTextNode(this._stringText)));
	      }
	      DOMLazyTree.queueChild(lazyTree, DOMLazyTree(closingComment));
	      ReactDOMComponentTree.precacheNode(this, openingComment);
	      this._closingComment = closingComment;
	      return lazyTree;
	    } else {
	      var escapedText = escapeTextContentForBrowser(this._stringText);
	
	      if (transaction.renderToStaticMarkup) {
	        // Normally we'd wrap this between comment nodes for the reasons stated
	        // above, but since this is a situation where React won't take over
	        // (static pages), we can simply return the text as it is.
	        return escapedText;
	      }
	
	      return '<!--' + openingValue + '-->' + escapedText + '<!--' + closingValue + '-->';
	    }
	  },
	
	  /**
	   * Updates this component by updating the text content.
	   *
	   * @param {ReactText} nextText The next text content
	   * @param {ReactReconcileTransaction} transaction
	   * @internal
	   */
	  receiveComponent: function (nextText, transaction) {
	    if (nextText !== this._currentElement) {
	      this._currentElement = nextText;
	      var nextStringText = '' + nextText;
	      if (nextStringText !== this._stringText) {
	        // TODO: Save this as pending props and use performUpdateIfNecessary
	        // and/or updateComponent to do the actual update for consistency with
	        // other component types?
	        this._stringText = nextStringText;
	        var commentNodes = this.getHostNode();
	        DOMChildrenOperations.replaceDelimitedText(commentNodes[0], commentNodes[1], nextStringText);
	
	        if (false) {
	          ReactInstrumentation.debugTool.onSetText(this._debugID, nextStringText);
	        }
	      }
	    }
	  },
	
	  getHostNode: function () {
	    var hostNode = this._commentNodes;
	    if (hostNode) {
	      return hostNode;
	    }
	    if (!this._closingComment) {
	      var openingComment = ReactDOMComponentTree.getNodeFromInstance(this);
	      var node = openingComment.nextSibling;
	      while (true) {
	        !(node != null) ?  false ? invariant(false, 'Missing closing comment for text component %s', this._domID) : _prodInvariant('67', this._domID) : void 0;
	        if (node.nodeType === 8 && node.nodeValue === ' /react-text ') {
	          this._closingComment = node;
	          break;
	        }
	        node = node.nextSibling;
	      }
	    }
	    hostNode = [this._hostNode, this._closingComment];
	    this._commentNodes = hostNode;
	    return hostNode;
	  },
	
	  unmountComponent: function () {
	    this._closingComment = null;
	    this._commentNodes = null;
	    ReactDOMComponentTree.uncacheNode(this);
	  }
	
	});
	
	module.exports = ReactDOMTextComponent;

/***/ },
/* 763 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDOMTextarea
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(5),
	    _assign = __webpack_require__(6);
	
	var DisabledInputUtils = __webpack_require__(139);
	var LinkedValueUtils = __webpack_require__(201);
	var ReactDOMComponentTree = __webpack_require__(15);
	var ReactUpdates = __webpack_require__(46);
	
	var invariant = __webpack_require__(2);
	var warning = __webpack_require__(9);
	
	var didWarnValueLink = false;
	var didWarnValDefaultVal = false;
	
	function forceUpdateIfMounted() {
	  if (this._rootNodeID) {
	    // DOM component is still mounted; update
	    ReactDOMTextarea.updateWrapper(this);
	  }
	}
	
	/**
	 * Implements a <textarea> host component that allows setting `value`, and
	 * `defaultValue`. This differs from the traditional DOM API because value is
	 * usually set as PCDATA children.
	 *
	 * If `value` is not supplied (or null/undefined), user actions that affect the
	 * value will trigger updates to the element.
	 *
	 * If `value` is supplied (and not null/undefined), the rendered element will
	 * not trigger updates to the element. Instead, the `value` prop must change in
	 * order for the rendered element to be updated.
	 *
	 * The rendered element will be initialized with an empty value, the prop
	 * `defaultValue` if specified, or the children content (deprecated).
	 */
	var ReactDOMTextarea = {
	  getHostProps: function (inst, props) {
	    !(props.dangerouslySetInnerHTML == null) ?  false ? invariant(false, '`dangerouslySetInnerHTML` does not make sense on <textarea>.') : _prodInvariant('91') : void 0;
	
	    // Always set children to the same thing. In IE9, the selection range will
	    // get reset if `textContent` is mutated.  We could add a check in setTextContent
	    // to only set the value if/when the value differs from the node value (which would
	    // completely solve this IE9 bug), but Sebastian+Ben seemed to like this solution.
	    // The value can be a boolean or object so that's why it's forced to be a string.
	    var hostProps = _assign({}, DisabledInputUtils.getHostProps(inst, props), {
	      value: undefined,
	      defaultValue: undefined,
	      children: '' + inst._wrapperState.initialValue,
	      onChange: inst._wrapperState.onChange
	    });
	
	    return hostProps;
	  },
	
	  mountWrapper: function (inst, props) {
	    if (false) {
	      LinkedValueUtils.checkPropTypes('textarea', props, inst._currentElement._owner);
	      if (props.valueLink !== undefined && !didWarnValueLink) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '`valueLink` prop on `textarea` is deprecated; set `value` and `onChange` instead.') : void 0;
	        didWarnValueLink = true;
	      }
	      if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValDefaultVal) {
	        process.env.NODE_ENV !== 'production' ? warning(false, 'Textarea elements must be either controlled or uncontrolled ' + '(specify either the value prop, or the defaultValue prop, but not ' + 'both). Decide between using a controlled or uncontrolled textarea ' + 'and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components') : void 0;
	        didWarnValDefaultVal = true;
	      }
	    }
	
	    var value = LinkedValueUtils.getValue(props);
	    var initialValue = value;
	
	    // Only bother fetching default value if we're going to use it
	    if (value == null) {
	      var defaultValue = props.defaultValue;
	      // TODO (yungsters): Remove support for children content in <textarea>.
	      var children = props.children;
	      if (children != null) {
	        if (false) {
	          process.env.NODE_ENV !== 'production' ? warning(false, 'Use the `defaultValue` or `value` props instead of setting ' + 'children on <textarea>.') : void 0;
	        }
	        !(defaultValue == null) ?  false ? invariant(false, 'If you supply `defaultValue` on a <textarea>, do not pass children.') : _prodInvariant('92') : void 0;
	        if (Array.isArray(children)) {
	          !(children.length <= 1) ?  false ? invariant(false, '<textarea> can only have at most one child.') : _prodInvariant('93') : void 0;
	          children = children[0];
	        }
	
	        defaultValue = '' + children;
	      }
	      if (defaultValue == null) {
	        defaultValue = '';
	      }
	      initialValue = defaultValue;
	    }
	
	    inst._wrapperState = {
	      initialValue: '' + initialValue,
	      listeners: null,
	      onChange: _handleChange.bind(inst)
	    };
	  },
	
	  updateWrapper: function (inst) {
	    var props = inst._currentElement.props;
	
	    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	    var value = LinkedValueUtils.getValue(props);
	    if (value != null) {
	      // Cast `value` to a string to ensure the value is set correctly. While
	      // browsers typically do this as necessary, jsdom doesn't.
	      var newValue = '' + value;
	
	      // To avoid side effects (such as losing text selection), only set value if changed
	      if (newValue !== node.value) {
	        node.value = newValue;
	      }
	      if (props.defaultValue == null) {
	        node.defaultValue = newValue;
	      }
	    }
	    if (props.defaultValue != null) {
	      node.defaultValue = props.defaultValue;
	    }
	  },
	
	  postMountWrapper: function (inst) {
	    // This is in postMount because we need access to the DOM node, which is not
	    // available until after the component has mounted.
	    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	
	    // Warning: node.value may be the empty string at this point (IE11) if placeholder is set.
	    node.value = node.textContent; // Detach value from defaultValue
	  }
	};
	
	function _handleChange(event) {
	  var props = this._currentElement.props;
	  var returnValue = LinkedValueUtils.executeOnChange(props, event);
	  ReactUpdates.asap(forceUpdateIfMounted, this);
	  return returnValue;
	}
	
	module.exports = ReactDOMTextarea;

/***/ },
/* 764 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDOMTreeTraversal
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(5);
	
	var invariant = __webpack_require__(2);
	
	/**
	 * Return the lowest common ancestor of A and B, or null if they are in
	 * different trees.
	 */
	function getLowestCommonAncestor(instA, instB) {
	  !('_hostNode' in instA) ?  false ? invariant(false, 'getNodeFromInstance: Invalid argument.') : _prodInvariant('33') : void 0;
	  !('_hostNode' in instB) ?  false ? invariant(false, 'getNodeFromInstance: Invalid argument.') : _prodInvariant('33') : void 0;
	
	  var depthA = 0;
	  for (var tempA = instA; tempA; tempA = tempA._hostParent) {
	    depthA++;
	  }
	  var depthB = 0;
	  for (var tempB = instB; tempB; tempB = tempB._hostParent) {
	    depthB++;
	  }
	
	  // If A is deeper, crawl up.
	  while (depthA - depthB > 0) {
	    instA = instA._hostParent;
	    depthA--;
	  }
	
	  // If B is deeper, crawl up.
	  while (depthB - depthA > 0) {
	    instB = instB._hostParent;
	    depthB--;
	  }
	
	  // Walk in lockstep until we find a match.
	  var depth = depthA;
	  while (depth--) {
	    if (instA === instB) {
	      return instA;
	    }
	    instA = instA._hostParent;
	    instB = instB._hostParent;
	  }
	  return null;
	}
	
	/**
	 * Return if A is an ancestor of B.
	 */
	function isAncestor(instA, instB) {
	  !('_hostNode' in instA) ?  false ? invariant(false, 'isAncestor: Invalid argument.') : _prodInvariant('35') : void 0;
	  !('_hostNode' in instB) ?  false ? invariant(false, 'isAncestor: Invalid argument.') : _prodInvariant('35') : void 0;
	
	  while (instB) {
	    if (instB === instA) {
	      return true;
	    }
	    instB = instB._hostParent;
	  }
	  return false;
	}
	
	/**
	 * Return the parent instance of the passed-in instance.
	 */
	function getParentInstance(inst) {
	  !('_hostNode' in inst) ?  false ? invariant(false, 'getParentInstance: Invalid argument.') : _prodInvariant('36') : void 0;
	
	  return inst._hostParent;
	}
	
	/**
	 * Simulates the traversal of a two-phase, capture/bubble event dispatch.
	 */
	function traverseTwoPhase(inst, fn, arg) {
	  var path = [];
	  while (inst) {
	    path.push(inst);
	    inst = inst._hostParent;
	  }
	  var i;
	  for (i = path.length; i-- > 0;) {
	    fn(path[i], false, arg);
	  }
	  for (i = 0; i < path.length; i++) {
	    fn(path[i], true, arg);
	  }
	}
	
	/**
	 * Traverses the ID hierarchy and invokes the supplied `cb` on any IDs that
	 * should would receive a `mouseEnter` or `mouseLeave` event.
	 *
	 * Does not invoke the callback on the nearest common ancestor because nothing
	 * "entered" or "left" that element.
	 */
	function traverseEnterLeave(from, to, fn, argFrom, argTo) {
	  var common = from && to ? getLowestCommonAncestor(from, to) : null;
	  var pathFrom = [];
	  while (from && from !== common) {
	    pathFrom.push(from);
	    from = from._hostParent;
	  }
	  var pathTo = [];
	  while (to && to !== common) {
	    pathTo.push(to);
	    to = to._hostParent;
	  }
	  var i;
	  for (i = 0; i < pathFrom.length; i++) {
	    fn(pathFrom[i], true, argFrom);
	  }
	  for (i = pathTo.length; i-- > 0;) {
	    fn(pathTo[i], false, argTo);
	  }
	}
	
	module.exports = {
	  isAncestor: isAncestor,
	  getLowestCommonAncestor: getLowestCommonAncestor,
	  getParentInstance: getParentInstance,
	  traverseTwoPhase: traverseTwoPhase,
	  traverseEnterLeave: traverseEnterLeave
	};

/***/ },
/* 765 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDefaultBatchingStrategy
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(6);
	
	var ReactUpdates = __webpack_require__(46);
	var Transaction = __webpack_require__(103);
	
	var emptyFunction = __webpack_require__(37);
	
	var RESET_BATCHED_UPDATES = {
	  initialize: emptyFunction,
	  close: function () {
	    ReactDefaultBatchingStrategy.isBatchingUpdates = false;
	  }
	};
	
	var FLUSH_BATCHED_UPDATES = {
	  initialize: emptyFunction,
	  close: ReactUpdates.flushBatchedUpdates.bind(ReactUpdates)
	};
	
	var TRANSACTION_WRAPPERS = [FLUSH_BATCHED_UPDATES, RESET_BATCHED_UPDATES];
	
	function ReactDefaultBatchingStrategyTransaction() {
	  this.reinitializeTransaction();
	}
	
	_assign(ReactDefaultBatchingStrategyTransaction.prototype, Transaction.Mixin, {
	  getTransactionWrappers: function () {
	    return TRANSACTION_WRAPPERS;
	  }
	});
	
	var transaction = new ReactDefaultBatchingStrategyTransaction();
	
	var ReactDefaultBatchingStrategy = {
	  isBatchingUpdates: false,
	
	  /**
	   * Call the provided function in a context within which calls to `setState`
	   * and friends are batched such that components aren't updated unnecessarily.
	   */
	  batchedUpdates: function (callback, a, b, c, d, e) {
	    var alreadyBatchingUpdates = ReactDefaultBatchingStrategy.isBatchingUpdates;
	
	    ReactDefaultBatchingStrategy.isBatchingUpdates = true;
	
	    // The code is written this way to avoid extra allocations
	    if (alreadyBatchingUpdates) {
	      callback(a, b, c, d, e);
	    } else {
	      transaction.perform(callback, null, a, b, c, d, e);
	    }
	  }
	};
	
	module.exports = ReactDefaultBatchingStrategy;

/***/ },
/* 766 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDefaultInjection
	 */
	
	'use strict';
	
	var BeforeInputEventPlugin = __webpack_require__(739);
	var ChangeEventPlugin = __webpack_require__(741);
	var DefaultEventPluginOrder = __webpack_require__(743);
	var EnterLeaveEventPlugin = __webpack_require__(744);
	var HTMLDOMPropertyConfig = __webpack_require__(746);
	var ReactComponentBrowserEnvironment = __webpack_require__(316);
	var ReactDOMComponent = __webpack_require__(752);
	var ReactDOMComponentTree = __webpack_require__(15);
	var ReactDOMEmptyComponent = __webpack_require__(754);
	var ReactDOMTreeTraversal = __webpack_require__(764);
	var ReactDOMTextComponent = __webpack_require__(762);
	var ReactDefaultBatchingStrategy = __webpack_require__(765);
	var ReactEventListener = __webpack_require__(768);
	var ReactInjection = __webpack_require__(769);
	var ReactReconcileTransaction = __webpack_require__(773);
	var SVGDOMPropertyConfig = __webpack_require__(777);
	var SelectEventPlugin = __webpack_require__(778);
	var SimpleEventPlugin = __webpack_require__(779);
	
	var alreadyInjected = false;
	
	function inject() {
	  if (alreadyInjected) {
	    // TODO: This is currently true because these injections are shared between
	    // the client and the server package. They should be built independently
	    // and not share any injection state. Then this problem will be solved.
	    return;
	  }
	  alreadyInjected = true;
	
	  ReactInjection.EventEmitter.injectReactEventListener(ReactEventListener);
	
	  /**
	   * Inject modules for resolving DOM hierarchy and plugin ordering.
	   */
	  ReactInjection.EventPluginHub.injectEventPluginOrder(DefaultEventPluginOrder);
	  ReactInjection.EventPluginUtils.injectComponentTree(ReactDOMComponentTree);
	  ReactInjection.EventPluginUtils.injectTreeTraversal(ReactDOMTreeTraversal);
	
	  /**
	   * Some important event plugins included by default (without having to require
	   * them).
	   */
	  ReactInjection.EventPluginHub.injectEventPluginsByName({
	    SimpleEventPlugin: SimpleEventPlugin,
	    EnterLeaveEventPlugin: EnterLeaveEventPlugin,
	    ChangeEventPlugin: ChangeEventPlugin,
	    SelectEventPlugin: SelectEventPlugin,
	    BeforeInputEventPlugin: BeforeInputEventPlugin
	  });
	
	  ReactInjection.HostComponent.injectGenericComponentClass(ReactDOMComponent);
	
	  ReactInjection.HostComponent.injectTextComponentClass(ReactDOMTextComponent);
	
	  ReactInjection.DOMProperty.injectDOMPropertyConfig(HTMLDOMPropertyConfig);
	  ReactInjection.DOMProperty.injectDOMPropertyConfig(SVGDOMPropertyConfig);
	
	  ReactInjection.EmptyComponent.injectEmptyComponentFactory(function (instantiate) {
	    return new ReactDOMEmptyComponent(instantiate);
	  });
	
	  ReactInjection.Updates.injectReconcileTransaction(ReactReconcileTransaction);
	  ReactInjection.Updates.injectBatchingStrategy(ReactDefaultBatchingStrategy);
	
	  ReactInjection.Component.injectEnvironment(ReactComponentBrowserEnvironment);
	}
	
	module.exports = {
	  inject: inject
	};

/***/ },
/* 767 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactEventEmitterMixin
	 */
	
	'use strict';
	
	var EventPluginHub = __webpack_require__(99);
	
	function runEventQueueInBatch(events) {
	  EventPluginHub.enqueueEvents(events);
	  EventPluginHub.processEventQueue(false);
	}
	
	var ReactEventEmitterMixin = {
	
	  /**
	   * Streams a fired top-level event to `EventPluginHub` where plugins have the
	   * opportunity to create `ReactEvent`s to be dispatched.
	   */
	  handleTopLevel: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    var events = EventPluginHub.extractEvents(topLevelType, targetInst, nativeEvent, nativeEventTarget);
	    runEventQueueInBatch(events);
	  }
	};
	
	module.exports = ReactEventEmitterMixin;

/***/ },
/* 768 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactEventListener
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(6);
	
	var EventListener = __webpack_require__(244);
	var ExecutionEnvironment = __webpack_require__(22);
	var PooledClass = __webpack_require__(62);
	var ReactDOMComponentTree = __webpack_require__(15);
	var ReactUpdates = __webpack_require__(46);
	
	var getEventTarget = __webpack_require__(210);
	var getUnboundedScrollPosition = __webpack_require__(544);
	
	/**
	 * Find the deepest React component completely containing the root of the
	 * passed-in instance (for use when entire React trees are nested within each
	 * other). If React trees are not nested, returns null.
	 */
	function findParent(inst) {
	  // TODO: It may be a good idea to cache this to prevent unnecessary DOM
	  // traversal, but caching is difficult to do correctly without using a
	  // mutation observer to listen for all DOM changes.
	  while (inst._hostParent) {
	    inst = inst._hostParent;
	  }
	  var rootNode = ReactDOMComponentTree.getNodeFromInstance(inst);
	  var container = rootNode.parentNode;
	  return ReactDOMComponentTree.getClosestInstanceFromNode(container);
	}
	
	// Used to store ancestor hierarchy in top level callback
	function TopLevelCallbackBookKeeping(topLevelType, nativeEvent) {
	  this.topLevelType = topLevelType;
	  this.nativeEvent = nativeEvent;
	  this.ancestors = [];
	}
	_assign(TopLevelCallbackBookKeeping.prototype, {
	  destructor: function () {
	    this.topLevelType = null;
	    this.nativeEvent = null;
	    this.ancestors.length = 0;
	  }
	});
	PooledClass.addPoolingTo(TopLevelCallbackBookKeeping, PooledClass.twoArgumentPooler);
	
	function handleTopLevelImpl(bookKeeping) {
	  var nativeEventTarget = getEventTarget(bookKeeping.nativeEvent);
	  var targetInst = ReactDOMComponentTree.getClosestInstanceFromNode(nativeEventTarget);
	
	  // Loop through the hierarchy, in case there's any nested components.
	  // It's important that we build the array of ancestors before calling any
	  // event handlers, because event handlers can modify the DOM, leading to
	  // inconsistencies with ReactMount's node cache. See #1105.
	  var ancestor = targetInst;
	  do {
	    bookKeeping.ancestors.push(ancestor);
	    ancestor = ancestor && findParent(ancestor);
	  } while (ancestor);
	
	  for (var i = 0; i < bookKeeping.ancestors.length; i++) {
	    targetInst = bookKeeping.ancestors[i];
	    ReactEventListener._handleTopLevel(bookKeeping.topLevelType, targetInst, bookKeeping.nativeEvent, getEventTarget(bookKeeping.nativeEvent));
	  }
	}
	
	function scrollValueMonitor(cb) {
	  var scrollPosition = getUnboundedScrollPosition(window);
	  cb(scrollPosition);
	}
	
	var ReactEventListener = {
	  _enabled: true,
	  _handleTopLevel: null,
	
	  WINDOW_HANDLE: ExecutionEnvironment.canUseDOM ? window : null,
	
	  setHandleTopLevel: function (handleTopLevel) {
	    ReactEventListener._handleTopLevel = handleTopLevel;
	  },
	
	  setEnabled: function (enabled) {
	    ReactEventListener._enabled = !!enabled;
	  },
	
	  isEnabled: function () {
	    return ReactEventListener._enabled;
	  },
	
	  /**
	   * Traps top-level events by using event bubbling.
	   *
	   * @param {string} topLevelType Record from `EventConstants`.
	   * @param {string} handlerBaseName Event name (e.g. "click").
	   * @param {object} handle Element on which to attach listener.
	   * @return {?object} An object with a remove function which will forcefully
	   *                  remove the listener.
	   * @internal
	   */
	  trapBubbledEvent: function (topLevelType, handlerBaseName, handle) {
	    var element = handle;
	    if (!element) {
	      return null;
	    }
	    return EventListener.listen(element, handlerBaseName, ReactEventListener.dispatchEvent.bind(null, topLevelType));
	  },
	
	  /**
	   * Traps a top-level event by using event capturing.
	   *
	   * @param {string} topLevelType Record from `EventConstants`.
	   * @param {string} handlerBaseName Event name (e.g. "click").
	   * @param {object} handle Element on which to attach listener.
	   * @return {?object} An object with a remove function which will forcefully
	   *                  remove the listener.
	   * @internal
	   */
	  trapCapturedEvent: function (topLevelType, handlerBaseName, handle) {
	    var element = handle;
	    if (!element) {
	      return null;
	    }
	    return EventListener.capture(element, handlerBaseName, ReactEventListener.dispatchEvent.bind(null, topLevelType));
	  },
	
	  monitorScrollValue: function (refresh) {
	    var callback = scrollValueMonitor.bind(null, refresh);
	    EventListener.listen(window, 'scroll', callback);
	  },
	
	  dispatchEvent: function (topLevelType, nativeEvent) {
	    if (!ReactEventListener._enabled) {
	      return;
	    }
	
	    var bookKeeping = TopLevelCallbackBookKeeping.getPooled(topLevelType, nativeEvent);
	    try {
	      // Event queue being processed in the same cycle allows
	      // `preventDefault`.
	      ReactUpdates.batchedUpdates(handleTopLevelImpl, bookKeeping);
	    } finally {
	      TopLevelCallbackBookKeeping.release(bookKeeping);
	    }
	  }
	};
	
	module.exports = ReactEventListener;

/***/ },
/* 769 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactInjection
	 */
	
	'use strict';
	
	var DOMProperty = __webpack_require__(90);
	var EventPluginHub = __webpack_require__(99);
	var EventPluginUtils = __webpack_require__(199);
	var ReactComponentEnvironment = __webpack_require__(202);
	var ReactClass = __webpack_require__(314);
	var ReactEmptyComponent = __webpack_require__(319);
	var ReactBrowserEventEmitter = __webpack_require__(140);
	var ReactHostComponent = __webpack_require__(321);
	var ReactUpdates = __webpack_require__(46);
	
	var ReactInjection = {
	  Component: ReactComponentEnvironment.injection,
	  Class: ReactClass.injection,
	  DOMProperty: DOMProperty.injection,
	  EmptyComponent: ReactEmptyComponent.injection,
	  EventPluginHub: EventPluginHub.injection,
	  EventPluginUtils: EventPluginUtils.injection,
	  EventEmitter: ReactBrowserEventEmitter.injection,
	  HostComponent: ReactHostComponent.injection,
	  Updates: ReactUpdates.injection
	};
	
	module.exports = ReactInjection;

/***/ },
/* 770 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactMarkupChecksum
	 */
	
	'use strict';
	
	var adler32 = __webpack_require__(790);
	
	var TAG_END = /\/?>/;
	var COMMENT_START = /^<\!\-\-/;
	
	var ReactMarkupChecksum = {
	  CHECKSUM_ATTR_NAME: 'data-react-checksum',
	
	  /**
	   * @param {string} markup Markup string
	   * @return {string} Markup string with checksum attribute attached
	   */
	  addChecksumToMarkup: function (markup) {
	    var checksum = adler32(markup);
	
	    // Add checksum (handle both parent tags, comments and self-closing tags)
	    if (COMMENT_START.test(markup)) {
	      return markup;
	    } else {
	      return markup.replace(TAG_END, ' ' + ReactMarkupChecksum.CHECKSUM_ATTR_NAME + '="' + checksum + '"$&');
	    }
	  },
	
	  /**
	   * @param {string} markup to use
	   * @param {DOMElement} element root React element
	   * @returns {boolean} whether or not the markup is the same
	   */
	  canReuseMarkup: function (markup, element) {
	    var existingChecksum = element.getAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME);
	    existingChecksum = existingChecksum && parseInt(existingChecksum, 10);
	    var markupChecksum = adler32(markup);
	    return markupChecksum === existingChecksum;
	  }
	};
	
	module.exports = ReactMarkupChecksum;

/***/ },
/* 771 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactMultiChild
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(5);
	
	var ReactComponentEnvironment = __webpack_require__(202);
	var ReactInstanceMap = __webpack_require__(101);
	var ReactInstrumentation = __webpack_require__(31);
	var ReactMultiChildUpdateTypes = __webpack_require__(324);
	
	var ReactCurrentOwner = __webpack_require__(75);
	var ReactReconciler = __webpack_require__(91);
	var ReactChildReconciler = __webpack_require__(748);
	
	var emptyFunction = __webpack_require__(37);
	var flattenChildren = __webpack_require__(794);
	var invariant = __webpack_require__(2);
	
	/**
	 * Make an update for markup to be rendered and inserted at a supplied index.
	 *
	 * @param {string} markup Markup that renders into an element.
	 * @param {number} toIndex Destination index.
	 * @private
	 */
	function makeInsertMarkup(markup, afterNode, toIndex) {
	  // NOTE: Null values reduce hidden classes.
	  return {
	    type: ReactMultiChildUpdateTypes.INSERT_MARKUP,
	    content: markup,
	    fromIndex: null,
	    fromNode: null,
	    toIndex: toIndex,
	    afterNode: afterNode
	  };
	}
	
	/**
	 * Make an update for moving an existing element to another index.
	 *
	 * @param {number} fromIndex Source index of the existing element.
	 * @param {number} toIndex Destination index of the element.
	 * @private
	 */
	function makeMove(child, afterNode, toIndex) {
	  // NOTE: Null values reduce hidden classes.
	  return {
	    type: ReactMultiChildUpdateTypes.MOVE_EXISTING,
	    content: null,
	    fromIndex: child._mountIndex,
	    fromNode: ReactReconciler.getHostNode(child),
	    toIndex: toIndex,
	    afterNode: afterNode
	  };
	}
	
	/**
	 * Make an update for removing an element at an index.
	 *
	 * @param {number} fromIndex Index of the element to remove.
	 * @private
	 */
	function makeRemove(child, node) {
	  // NOTE: Null values reduce hidden classes.
	  return {
	    type: ReactMultiChildUpdateTypes.REMOVE_NODE,
	    content: null,
	    fromIndex: child._mountIndex,
	    fromNode: node,
	    toIndex: null,
	    afterNode: null
	  };
	}
	
	/**
	 * Make an update for setting the markup of a node.
	 *
	 * @param {string} markup Markup that renders into an element.
	 * @private
	 */
	function makeSetMarkup(markup) {
	  // NOTE: Null values reduce hidden classes.
	  return {
	    type: ReactMultiChildUpdateTypes.SET_MARKUP,
	    content: markup,
	    fromIndex: null,
	    fromNode: null,
	    toIndex: null,
	    afterNode: null
	  };
	}
	
	/**
	 * Make an update for setting the text content.
	 *
	 * @param {string} textContent Text content to set.
	 * @private
	 */
	function makeTextContent(textContent) {
	  // NOTE: Null values reduce hidden classes.
	  return {
	    type: ReactMultiChildUpdateTypes.TEXT_CONTENT,
	    content: textContent,
	    fromIndex: null,
	    fromNode: null,
	    toIndex: null,
	    afterNode: null
	  };
	}
	
	/**
	 * Push an update, if any, onto the queue. Creates a new queue if none is
	 * passed and always returns the queue. Mutative.
	 */
	function enqueue(queue, update) {
	  if (update) {
	    queue = queue || [];
	    queue.push(update);
	  }
	  return queue;
	}
	
	/**
	 * Processes any enqueued updates.
	 *
	 * @private
	 */
	function processQueue(inst, updateQueue) {
	  ReactComponentEnvironment.processChildrenUpdates(inst, updateQueue);
	}
	
	var setParentForInstrumentation = emptyFunction;
	var setChildrenForInstrumentation = emptyFunction;
	if (false) {
	  var getDebugID = function (inst) {
	    if (!inst._debugID) {
	      // Check for ART-like instances. TODO: This is silly/gross.
	      var internal;
	      if (internal = ReactInstanceMap.get(inst)) {
	        inst = internal;
	      }
	    }
	    return inst._debugID;
	  };
	  setParentForInstrumentation = function (child) {
	    if (child._debugID !== 0) {
	      ReactInstrumentation.debugTool.onSetParent(child._debugID, getDebugID(this));
	    }
	  };
	  setChildrenForInstrumentation = function (children) {
	    var debugID = getDebugID(this);
	    // TODO: React Native empty components are also multichild.
	    // This means they still get into this method but don't have _debugID.
	    if (debugID !== 0) {
	      ReactInstrumentation.debugTool.onSetChildren(debugID, children ? Object.keys(children).map(function (key) {
	        return children[key]._debugID;
	      }) : []);
	    }
	  };
	}
	
	/**
	 * ReactMultiChild are capable of reconciling multiple children.
	 *
	 * @class ReactMultiChild
	 * @internal
	 */
	var ReactMultiChild = {
	
	  /**
	   * Provides common functionality for components that must reconcile multiple
	   * children. This is used by `ReactDOMComponent` to mount, update, and
	   * unmount child components.
	   *
	   * @lends {ReactMultiChild.prototype}
	   */
	  Mixin: {
	
	    _reconcilerInstantiateChildren: function (nestedChildren, transaction, context) {
	      if (false) {
	        if (this._currentElement) {
	          try {
	            ReactCurrentOwner.current = this._currentElement._owner;
	            return ReactChildReconciler.instantiateChildren(nestedChildren, transaction, context, this._debugID);
	          } finally {
	            ReactCurrentOwner.current = null;
	          }
	        }
	      }
	      return ReactChildReconciler.instantiateChildren(nestedChildren, transaction, context);
	    },
	
	    _reconcilerUpdateChildren: function (prevChildren, nextNestedChildrenElements, removedNodes, transaction, context) {
	      var nextChildren;
	      if (false) {
	        if (this._currentElement) {
	          try {
	            ReactCurrentOwner.current = this._currentElement._owner;
	            nextChildren = flattenChildren(nextNestedChildrenElements, this._debugID);
	          } finally {
	            ReactCurrentOwner.current = null;
	          }
	          ReactChildReconciler.updateChildren(prevChildren, nextChildren, removedNodes, transaction, context);
	          return nextChildren;
	        }
	      }
	      nextChildren = flattenChildren(nextNestedChildrenElements);
	      ReactChildReconciler.updateChildren(prevChildren, nextChildren, removedNodes, transaction, context);
	      return nextChildren;
	    },
	
	    /**
	     * Generates a "mount image" for each of the supplied children. In the case
	     * of `ReactDOMComponent`, a mount image is a string of markup.
	     *
	     * @param {?object} nestedChildren Nested child maps.
	     * @return {array} An array of mounted representations.
	     * @internal
	     */
	    mountChildren: function (nestedChildren, transaction, context) {
	      var children = this._reconcilerInstantiateChildren(nestedChildren, transaction, context);
	      this._renderedChildren = children;
	
	      var mountImages = [];
	      var index = 0;
	      for (var name in children) {
	        if (children.hasOwnProperty(name)) {
	          var child = children[name];
	          if (false) {
	            setParentForInstrumentation.call(this, child);
	          }
	          var mountImage = ReactReconciler.mountComponent(child, transaction, this, this._hostContainerInfo, context);
	          child._mountIndex = index++;
	          mountImages.push(mountImage);
	        }
	      }
	
	      if (false) {
	        setChildrenForInstrumentation.call(this, children);
	      }
	
	      return mountImages;
	    },
	
	    /**
	     * Replaces any rendered children with a text content string.
	     *
	     * @param {string} nextContent String of content.
	     * @internal
	     */
	    updateTextContent: function (nextContent) {
	      var prevChildren = this._renderedChildren;
	      // Remove any rendered children.
	      ReactChildReconciler.unmountChildren(prevChildren, false);
	      for (var name in prevChildren) {
	        if (prevChildren.hasOwnProperty(name)) {
	           true ?  false ? invariant(false, 'updateTextContent called on non-empty component.') : _prodInvariant('118') : void 0;
	        }
	      }
	      // Set new text content.
	      var updates = [makeTextContent(nextContent)];
	      processQueue(this, updates);
	    },
	
	    /**
	     * Replaces any rendered children with a markup string.
	     *
	     * @param {string} nextMarkup String of markup.
	     * @internal
	     */
	    updateMarkup: function (nextMarkup) {
	      var prevChildren = this._renderedChildren;
	      // Remove any rendered children.
	      ReactChildReconciler.unmountChildren(prevChildren, false);
	      for (var name in prevChildren) {
	        if (prevChildren.hasOwnProperty(name)) {
	           true ?  false ? invariant(false, 'updateTextContent called on non-empty component.') : _prodInvariant('118') : void 0;
	        }
	      }
	      var updates = [makeSetMarkup(nextMarkup)];
	      processQueue(this, updates);
	    },
	
	    /**
	     * Updates the rendered children with new children.
	     *
	     * @param {?object} nextNestedChildrenElements Nested child element maps.
	     * @param {ReactReconcileTransaction} transaction
	     * @internal
	     */
	    updateChildren: function (nextNestedChildrenElements, transaction, context) {
	      // Hook used by React ART
	      this._updateChildren(nextNestedChildrenElements, transaction, context);
	    },
	
	    /**
	     * @param {?object} nextNestedChildrenElements Nested child element maps.
	     * @param {ReactReconcileTransaction} transaction
	     * @final
	     * @protected
	     */
	    _updateChildren: function (nextNestedChildrenElements, transaction, context) {
	      var prevChildren = this._renderedChildren;
	      var removedNodes = {};
	      var nextChildren = this._reconcilerUpdateChildren(prevChildren, nextNestedChildrenElements, removedNodes, transaction, context);
	      if (!nextChildren && !prevChildren) {
	        return;
	      }
	      var updates = null;
	      var name;
	      // `nextIndex` will increment for each child in `nextChildren`, but
	      // `lastIndex` will be the last index visited in `prevChildren`.
	      var lastIndex = 0;
	      var nextIndex = 0;
	      var lastPlacedNode = null;
	      for (name in nextChildren) {
	        if (!nextChildren.hasOwnProperty(name)) {
	          continue;
	        }
	        var prevChild = prevChildren && prevChildren[name];
	        var nextChild = nextChildren[name];
	        if (prevChild === nextChild) {
	          updates = enqueue(updates, this.moveChild(prevChild, lastPlacedNode, nextIndex, lastIndex));
	          lastIndex = Math.max(prevChild._mountIndex, lastIndex);
	          prevChild._mountIndex = nextIndex;
	        } else {
	          if (prevChild) {
	            // Update `lastIndex` before `_mountIndex` gets unset by unmounting.
	            lastIndex = Math.max(prevChild._mountIndex, lastIndex);
	            // The `removedNodes` loop below will actually remove the child.
	          }
	          // The child must be instantiated before it's mounted.
	          updates = enqueue(updates, this._mountChildAtIndex(nextChild, lastPlacedNode, nextIndex, transaction, context));
	        }
	        nextIndex++;
	        lastPlacedNode = ReactReconciler.getHostNode(nextChild);
	      }
	      // Remove children that are no longer present.
	      for (name in removedNodes) {
	        if (removedNodes.hasOwnProperty(name)) {
	          updates = enqueue(updates, this._unmountChild(prevChildren[name], removedNodes[name]));
	        }
	      }
	      if (updates) {
	        processQueue(this, updates);
	      }
	      this._renderedChildren = nextChildren;
	
	      if (false) {
	        setChildrenForInstrumentation.call(this, nextChildren);
	      }
	    },
	
	    /**
	     * Unmounts all rendered children. This should be used to clean up children
	     * when this component is unmounted. It does not actually perform any
	     * backend operations.
	     *
	     * @internal
	     */
	    unmountChildren: function (safely) {
	      var renderedChildren = this._renderedChildren;
	      ReactChildReconciler.unmountChildren(renderedChildren, safely);
	      this._renderedChildren = null;
	    },
	
	    /**
	     * Moves a child component to the supplied index.
	     *
	     * @param {ReactComponent} child Component to move.
	     * @param {number} toIndex Destination index of the element.
	     * @param {number} lastIndex Last index visited of the siblings of `child`.
	     * @protected
	     */
	    moveChild: function (child, afterNode, toIndex, lastIndex) {
	      // If the index of `child` is less than `lastIndex`, then it needs to
	      // be moved. Otherwise, we do not need to move it because a child will be
	      // inserted or moved before `child`.
	      if (child._mountIndex < lastIndex) {
	        return makeMove(child, afterNode, toIndex);
	      }
	    },
	
	    /**
	     * Creates a child component.
	     *
	     * @param {ReactComponent} child Component to create.
	     * @param {string} mountImage Markup to insert.
	     * @protected
	     */
	    createChild: function (child, afterNode, mountImage) {
	      return makeInsertMarkup(mountImage, afterNode, child._mountIndex);
	    },
	
	    /**
	     * Removes a child component.
	     *
	     * @param {ReactComponent} child Child to remove.
	     * @protected
	     */
	    removeChild: function (child, node) {
	      return makeRemove(child, node);
	    },
	
	    /**
	     * Mounts a child with the supplied name.
	     *
	     * NOTE: This is part of `updateChildren` and is here for readability.
	     *
	     * @param {ReactComponent} child Component to mount.
	     * @param {string} name Name of the child.
	     * @param {number} index Index at which to insert the child.
	     * @param {ReactReconcileTransaction} transaction
	     * @private
	     */
	    _mountChildAtIndex: function (child, afterNode, index, transaction, context) {
	      var mountImage = ReactReconciler.mountComponent(child, transaction, this, this._hostContainerInfo, context);
	      child._mountIndex = index;
	      return this.createChild(child, afterNode, mountImage);
	    },
	
	    /**
	     * Unmounts a rendered child.
	     *
	     * NOTE: This is part of `updateChildren` and is here for readability.
	     *
	     * @param {ReactComponent} child Component to unmount.
	     * @private
	     */
	    _unmountChild: function (child, node) {
	      var update = this.removeChild(child, node);
	      child._mountIndex = null;
	      return update;
	    }
	
	  }
	
	};
	
	module.exports = ReactMultiChild;

/***/ },
/* 772 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactOwner
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(5);
	
	var invariant = __webpack_require__(2);
	
	/**
	 * ReactOwners are capable of storing references to owned components.
	 *
	 * All components are capable of //being// referenced by owner components, but
	 * only ReactOwner components are capable of //referencing// owned components.
	 * The named reference is known as a "ref".
	 *
	 * Refs are available when mounted and updated during reconciliation.
	 *
	 *   var MyComponent = React.createClass({
	 *     render: function() {
	 *       return (
	 *         <div onClick={this.handleClick}>
	 *           <CustomComponent ref="custom" />
	 *         </div>
	 *       );
	 *     },
	 *     handleClick: function() {
	 *       this.refs.custom.handleClick();
	 *     },
	 *     componentDidMount: function() {
	 *       this.refs.custom.initialize();
	 *     }
	 *   });
	 *
	 * Refs should rarely be used. When refs are used, they should only be done to
	 * control data that is not handled by React's data flow.
	 *
	 * @class ReactOwner
	 */
	var ReactOwner = {
	
	  /**
	   * @param {?object} object
	   * @return {boolean} True if `object` is a valid owner.
	   * @final
	   */
	  isValidOwner: function (object) {
	    return !!(object && typeof object.attachRef === 'function' && typeof object.detachRef === 'function');
	  },
	
	  /**
	   * Adds a component by ref to an owner component.
	   *
	   * @param {ReactComponent} component Component to reference.
	   * @param {string} ref Name by which to refer to the component.
	   * @param {ReactOwner} owner Component on which to record the ref.
	   * @final
	   * @internal
	   */
	  addComponentAsRefTo: function (component, ref, owner) {
	    !ReactOwner.isValidOwner(owner) ?  false ? invariant(false, 'addComponentAsRefTo(...): Only a ReactOwner can have refs. You might be adding a ref to a component that was not created inside a component\'s `render` method, or you have multiple copies of React loaded (details: https://fb.me/react-refs-must-have-owner).') : _prodInvariant('119') : void 0;
	    owner.attachRef(ref, component);
	  },
	
	  /**
	   * Removes a component by ref from an owner component.
	   *
	   * @param {ReactComponent} component Component to dereference.
	   * @param {string} ref Name of the ref to remove.
	   * @param {ReactOwner} owner Component on which the ref is recorded.
	   * @final
	   * @internal
	   */
	  removeComponentAsRefFrom: function (component, ref, owner) {
	    !ReactOwner.isValidOwner(owner) ?  false ? invariant(false, 'removeComponentAsRefFrom(...): Only a ReactOwner can have refs. You might be removing a ref to a component that was not created inside a component\'s `render` method, or you have multiple copies of React loaded (details: https://fb.me/react-refs-must-have-owner).') : _prodInvariant('120') : void 0;
	    var ownerPublicInstance = owner.getPublicInstance();
	    // Check that `component`'s owner is still alive and that `component` is still the current ref
	    // because we do not want to detach the ref if another component stole it.
	    if (ownerPublicInstance && ownerPublicInstance.refs[ref] === component.getPublicInstance()) {
	      owner.detachRef(ref);
	    }
	  }
	
	};
	
	module.exports = ReactOwner;

/***/ },
/* 773 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactReconcileTransaction
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(6);
	
	var CallbackQueue = __webpack_require__(311);
	var PooledClass = __webpack_require__(62);
	var ReactBrowserEventEmitter = __webpack_require__(140);
	var ReactInputSelection = __webpack_require__(322);
	var ReactInstrumentation = __webpack_require__(31);
	var Transaction = __webpack_require__(103);
	var ReactUpdateQueue = __webpack_require__(206);
	
	/**
	 * Ensures that, when possible, the selection range (currently selected text
	 * input) is not disturbed by performing the transaction.
	 */
	var SELECTION_RESTORATION = {
	  /**
	   * @return {Selection} Selection information.
	   */
	  initialize: ReactInputSelection.getSelectionInformation,
	  /**
	   * @param {Selection} sel Selection information returned from `initialize`.
	   */
	  close: ReactInputSelection.restoreSelection
	};
	
	/**
	 * Suppresses events (blur/focus) that could be inadvertently dispatched due to
	 * high level DOM manipulations (like temporarily removing a text input from the
	 * DOM).
	 */
	var EVENT_SUPPRESSION = {
	  /**
	   * @return {boolean} The enabled status of `ReactBrowserEventEmitter` before
	   * the reconciliation.
	   */
	  initialize: function () {
	    var currentlyEnabled = ReactBrowserEventEmitter.isEnabled();
	    ReactBrowserEventEmitter.setEnabled(false);
	    return currentlyEnabled;
	  },
	
	  /**
	   * @param {boolean} previouslyEnabled Enabled status of
	   *   `ReactBrowserEventEmitter` before the reconciliation occurred. `close`
	   *   restores the previous value.
	   */
	  close: function (previouslyEnabled) {
	    ReactBrowserEventEmitter.setEnabled(previouslyEnabled);
	  }
	};
	
	/**
	 * Provides a queue for collecting `componentDidMount` and
	 * `componentDidUpdate` callbacks during the transaction.
	 */
	var ON_DOM_READY_QUEUEING = {
	  /**
	   * Initializes the internal `onDOMReady` queue.
	   */
	  initialize: function () {
	    this.reactMountReady.reset();
	  },
	
	  /**
	   * After DOM is flushed, invoke all registered `onDOMReady` callbacks.
	   */
	  close: function () {
	    this.reactMountReady.notifyAll();
	  }
	};
	
	/**
	 * Executed within the scope of the `Transaction` instance. Consider these as
	 * being member methods, but with an implied ordering while being isolated from
	 * each other.
	 */
	var TRANSACTION_WRAPPERS = [SELECTION_RESTORATION, EVENT_SUPPRESSION, ON_DOM_READY_QUEUEING];
	
	if (false) {
	  TRANSACTION_WRAPPERS.push({
	    initialize: ReactInstrumentation.debugTool.onBeginFlush,
	    close: ReactInstrumentation.debugTool.onEndFlush
	  });
	}
	
	/**
	 * Currently:
	 * - The order that these are listed in the transaction is critical:
	 * - Suppresses events.
	 * - Restores selection range.
	 *
	 * Future:
	 * - Restore document/overflow scroll positions that were unintentionally
	 *   modified via DOM insertions above the top viewport boundary.
	 * - Implement/integrate with customized constraint based layout system and keep
	 *   track of which dimensions must be remeasured.
	 *
	 * @class ReactReconcileTransaction
	 */
	function ReactReconcileTransaction(useCreateElement) {
	  this.reinitializeTransaction();
	  // Only server-side rendering really needs this option (see
	  // `ReactServerRendering`), but server-side uses
	  // `ReactServerRenderingTransaction` instead. This option is here so that it's
	  // accessible and defaults to false when `ReactDOMComponent` and
	  // `ReactDOMTextComponent` checks it in `mountComponent`.`
	  this.renderToStaticMarkup = false;
	  this.reactMountReady = CallbackQueue.getPooled(null);
	  this.useCreateElement = useCreateElement;
	}
	
	var Mixin = {
	  /**
	   * @see Transaction
	   * @abstract
	   * @final
	   * @return {array<object>} List of operation wrap procedures.
	   *   TODO: convert to array<TransactionWrapper>
	   */
	  getTransactionWrappers: function () {
	    return TRANSACTION_WRAPPERS;
	  },
	
	  /**
	   * @return {object} The queue to collect `onDOMReady` callbacks with.
	   */
	  getReactMountReady: function () {
	    return this.reactMountReady;
	  },
	
	  /**
	   * @return {object} The queue to collect React async events.
	   */
	  getUpdateQueue: function () {
	    return ReactUpdateQueue;
	  },
	
	  /**
	   * Save current transaction state -- if the return value from this method is
	   * passed to `rollback`, the transaction will be reset to that state.
	   */
	  checkpoint: function () {
	    // reactMountReady is the our only stateful wrapper
	    return this.reactMountReady.checkpoint();
	  },
	
	  rollback: function (checkpoint) {
	    this.reactMountReady.rollback(checkpoint);
	  },
	
	  /**
	   * `PooledClass` looks for this, and will invoke this before allowing this
	   * instance to be reused.
	   */
	  destructor: function () {
	    CallbackQueue.release(this.reactMountReady);
	    this.reactMountReady = null;
	  }
	};
	
	_assign(ReactReconcileTransaction.prototype, Transaction.Mixin, Mixin);
	
	PooledClass.addPoolingTo(ReactReconcileTransaction);
	
	module.exports = ReactReconcileTransaction;

/***/ },
/* 774 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactRef
	 */
	
	'use strict';
	
	var ReactOwner = __webpack_require__(772);
	
	var ReactRef = {};
	
	function attachRef(ref, component, owner) {
	  if (typeof ref === 'function') {
	    ref(component.getPublicInstance());
	  } else {
	    // Legacy ref
	    ReactOwner.addComponentAsRefTo(component, ref, owner);
	  }
	}
	
	function detachRef(ref, component, owner) {
	  if (typeof ref === 'function') {
	    ref(null);
	  } else {
	    // Legacy ref
	    ReactOwner.removeComponentAsRefFrom(component, ref, owner);
	  }
	}
	
	ReactRef.attachRefs = function (instance, element) {
	  if (element === null || element === false) {
	    return;
	  }
	  var ref = element.ref;
	  if (ref != null) {
	    attachRef(ref, instance, element._owner);
	  }
	};
	
	ReactRef.shouldUpdateRefs = function (prevElement, nextElement) {
	  // If either the owner or a `ref` has changed, make sure the newest owner
	  // has stored a reference to `this`, and the previous owner (if different)
	  // has forgotten the reference to `this`. We use the element instead
	  // of the public this.props because the post processing cannot determine
	  // a ref. The ref conceptually lives on the element.
	
	  // TODO: Should this even be possible? The owner cannot change because
	  // it's forbidden by shouldUpdateReactComponent. The ref can change
	  // if you swap the keys of but not the refs. Reconsider where this check
	  // is made. It probably belongs where the key checking and
	  // instantiateReactComponent is done.
	
	  var prevEmpty = prevElement === null || prevElement === false;
	  var nextEmpty = nextElement === null || nextElement === false;
	
	  return(
	    // This has a few false positives w/r/t empty components.
	    prevEmpty || nextEmpty || nextElement._owner !== prevElement._owner || nextElement.ref !== prevElement.ref
	  );
	};
	
	ReactRef.detachRefs = function (instance, element) {
	  if (element === null || element === false) {
	    return;
	  }
	  var ref = element.ref;
	  if (ref != null) {
	    detachRef(ref, instance, element._owner);
	  }
	};
	
	module.exports = ReactRef;

/***/ },
/* 775 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactServerRenderingTransaction
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(6);
	
	var PooledClass = __webpack_require__(62);
	var Transaction = __webpack_require__(103);
	var ReactInstrumentation = __webpack_require__(31);
	var ReactServerUpdateQueue = __webpack_require__(776);
	
	/**
	 * Executed within the scope of the `Transaction` instance. Consider these as
	 * being member methods, but with an implied ordering while being isolated from
	 * each other.
	 */
	var TRANSACTION_WRAPPERS = [];
	
	if (false) {
	  TRANSACTION_WRAPPERS.push({
	    initialize: ReactInstrumentation.debugTool.onBeginFlush,
	    close: ReactInstrumentation.debugTool.onEndFlush
	  });
	}
	
	var noopCallbackQueue = {
	  enqueue: function () {}
	};
	
	/**
	 * @class ReactServerRenderingTransaction
	 * @param {boolean} renderToStaticMarkup
	 */
	function ReactServerRenderingTransaction(renderToStaticMarkup) {
	  this.reinitializeTransaction();
	  this.renderToStaticMarkup = renderToStaticMarkup;
	  this.useCreateElement = false;
	  this.updateQueue = new ReactServerUpdateQueue(this);
	}
	
	var Mixin = {
	  /**
	   * @see Transaction
	   * @abstract
	   * @final
	   * @return {array} Empty list of operation wrap procedures.
	   */
	  getTransactionWrappers: function () {
	    return TRANSACTION_WRAPPERS;
	  },
	
	  /**
	   * @return {object} The queue to collect `onDOMReady` callbacks with.
	   */
	  getReactMountReady: function () {
	    return noopCallbackQueue;
	  },
	
	  /**
	   * @return {object} The queue to collect React async events.
	   */
	  getUpdateQueue: function () {
	    return this.updateQueue;
	  },
	
	  /**
	   * `PooledClass` looks for this, and will invoke this before allowing this
	   * instance to be reused.
	   */
	  destructor: function () {},
	
	  checkpoint: function () {},
	
	  rollback: function () {}
	};
	
	_assign(ReactServerRenderingTransaction.prototype, Transaction.Mixin, Mixin);
	
	PooledClass.addPoolingTo(ReactServerRenderingTransaction);
	
	module.exports = ReactServerRenderingTransaction;

/***/ },
/* 776 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactServerUpdateQueue
	 * 
	 */
	
	'use strict';
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var ReactUpdateQueue = __webpack_require__(206);
	var Transaction = __webpack_require__(103);
	var warning = __webpack_require__(9);
	
	function warnNoop(publicInstance, callerName) {
	  if (false) {
	    var constructor = publicInstance.constructor;
	    process.env.NODE_ENV !== 'production' ? warning(false, '%s(...): Can only update a mounting component. ' + 'This usually means you called %s() outside componentWillMount() on the server. ' + 'This is a no-op. Please check the code for the %s component.', callerName, callerName, constructor && (constructor.displayName || constructor.name) || 'ReactClass') : void 0;
	  }
	}
	
	/**
	 * This is the update queue used for server rendering.
	 * It delegates to ReactUpdateQueue while server rendering is in progress and
	 * switches to ReactNoopUpdateQueue after the transaction has completed.
	 * @class ReactServerUpdateQueue
	 * @param {Transaction} transaction
	 */
	
	var ReactServerUpdateQueue = function () {
	  /* :: transaction: Transaction; */
	
	  function ReactServerUpdateQueue(transaction) {
	    _classCallCheck(this, ReactServerUpdateQueue);
	
	    this.transaction = transaction;
	  }
	
	  /**
	   * Checks whether or not this composite component is mounted.
	   * @param {ReactClass} publicInstance The instance we want to test.
	   * @return {boolean} True if mounted, false otherwise.
	   * @protected
	   * @final
	   */
	
	
	  ReactServerUpdateQueue.prototype.isMounted = function isMounted(publicInstance) {
	    return false;
	  };
	
	  /**
	   * Enqueue a callback that will be executed after all the pending updates
	   * have processed.
	   *
	   * @param {ReactClass} publicInstance The instance to use as `this` context.
	   * @param {?function} callback Called after state is updated.
	   * @internal
	   */
	
	
	  ReactServerUpdateQueue.prototype.enqueueCallback = function enqueueCallback(publicInstance, callback, callerName) {
	    if (this.transaction.isInTransaction()) {
	      ReactUpdateQueue.enqueueCallback(publicInstance, callback, callerName);
	    }
	  };
	
	  /**
	   * Forces an update. This should only be invoked when it is known with
	   * certainty that we are **not** in a DOM transaction.
	   *
	   * You may want to call this when you know that some deeper aspect of the
	   * component's state has changed but `setState` was not called.
	   *
	   * This will not invoke `shouldComponentUpdate`, but it will invoke
	   * `componentWillUpdate` and `componentDidUpdate`.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @internal
	   */
	
	
	  ReactServerUpdateQueue.prototype.enqueueForceUpdate = function enqueueForceUpdate(publicInstance) {
	    if (this.transaction.isInTransaction()) {
	      ReactUpdateQueue.enqueueForceUpdate(publicInstance);
	    } else {
	      warnNoop(publicInstance, 'forceUpdate');
	    }
	  };
	
	  /**
	   * Replaces all of the state. Always use this or `setState` to mutate state.
	   * You should treat `this.state` as immutable.
	   *
	   * There is no guarantee that `this.state` will be immediately updated, so
	   * accessing `this.state` after calling this method may return the old value.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object|function} completeState Next state.
	   * @internal
	   */
	
	
	  ReactServerUpdateQueue.prototype.enqueueReplaceState = function enqueueReplaceState(publicInstance, completeState) {
	    if (this.transaction.isInTransaction()) {
	      ReactUpdateQueue.enqueueReplaceState(publicInstance, completeState);
	    } else {
	      warnNoop(publicInstance, 'replaceState');
	    }
	  };
	
	  /**
	   * Sets a subset of the state. This only exists because _pendingState is
	   * internal. This provides a merging strategy that is not available to deep
	   * properties which is confusing. TODO: Expose pendingState or don't use it
	   * during the merge.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object|function} partialState Next partial state to be merged with state.
	   * @internal
	   */
	
	
	  ReactServerUpdateQueue.prototype.enqueueSetState = function enqueueSetState(publicInstance, partialState) {
	    if (this.transaction.isInTransaction()) {
	      ReactUpdateQueue.enqueueSetState(publicInstance, partialState);
	    } else {
	      warnNoop(publicInstance, 'setState');
	    }
	  };
	
	  return ReactServerUpdateQueue;
	}();
	
	module.exports = ReactServerUpdateQueue;

/***/ },
/* 777 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule SVGDOMPropertyConfig
	 */
	
	'use strict';
	
	var NS = {
	  xlink: 'http://www.w3.org/1999/xlink',
	  xml: 'http://www.w3.org/XML/1998/namespace'
	};
	
	// We use attributes for everything SVG so let's avoid some duplication and run
	// code instead.
	// The following are all specified in the HTML config already so we exclude here.
	// - class (as className)
	// - color
	// - height
	// - id
	// - lang
	// - max
	// - media
	// - method
	// - min
	// - name
	// - style
	// - target
	// - type
	// - width
	var ATTRS = {
	  accentHeight: 'accent-height',
	  accumulate: 0,
	  additive: 0,
	  alignmentBaseline: 'alignment-baseline',
	  allowReorder: 'allowReorder',
	  alphabetic: 0,
	  amplitude: 0,
	  arabicForm: 'arabic-form',
	  ascent: 0,
	  attributeName: 'attributeName',
	  attributeType: 'attributeType',
	  autoReverse: 'autoReverse',
	  azimuth: 0,
	  baseFrequency: 'baseFrequency',
	  baseProfile: 'baseProfile',
	  baselineShift: 'baseline-shift',
	  bbox: 0,
	  begin: 0,
	  bias: 0,
	  by: 0,
	  calcMode: 'calcMode',
	  capHeight: 'cap-height',
	  clip: 0,
	  clipPath: 'clip-path',
	  clipRule: 'clip-rule',
	  clipPathUnits: 'clipPathUnits',
	  colorInterpolation: 'color-interpolation',
	  colorInterpolationFilters: 'color-interpolation-filters',
	  colorProfile: 'color-profile',
	  colorRendering: 'color-rendering',
	  contentScriptType: 'contentScriptType',
	  contentStyleType: 'contentStyleType',
	  cursor: 0,
	  cx: 0,
	  cy: 0,
	  d: 0,
	  decelerate: 0,
	  descent: 0,
	  diffuseConstant: 'diffuseConstant',
	  direction: 0,
	  display: 0,
	  divisor: 0,
	  dominantBaseline: 'dominant-baseline',
	  dur: 0,
	  dx: 0,
	  dy: 0,
	  edgeMode: 'edgeMode',
	  elevation: 0,
	  enableBackground: 'enable-background',
	  end: 0,
	  exponent: 0,
	  externalResourcesRequired: 'externalResourcesRequired',
	  fill: 0,
	  fillOpacity: 'fill-opacity',
	  fillRule: 'fill-rule',
	  filter: 0,
	  filterRes: 'filterRes',
	  filterUnits: 'filterUnits',
	  floodColor: 'flood-color',
	  floodOpacity: 'flood-opacity',
	  focusable: 0,
	  fontFamily: 'font-family',
	  fontSize: 'font-size',
	  fontSizeAdjust: 'font-size-adjust',
	  fontStretch: 'font-stretch',
	  fontStyle: 'font-style',
	  fontVariant: 'font-variant',
	  fontWeight: 'font-weight',
	  format: 0,
	  from: 0,
	  fx: 0,
	  fy: 0,
	  g1: 0,
	  g2: 0,
	  glyphName: 'glyph-name',
	  glyphOrientationHorizontal: 'glyph-orientation-horizontal',
	  glyphOrientationVertical: 'glyph-orientation-vertical',
	  glyphRef: 'glyphRef',
	  gradientTransform: 'gradientTransform',
	  gradientUnits: 'gradientUnits',
	  hanging: 0,
	  horizAdvX: 'horiz-adv-x',
	  horizOriginX: 'horiz-origin-x',
	  ideographic: 0,
	  imageRendering: 'image-rendering',
	  'in': 0,
	  in2: 0,
	  intercept: 0,
	  k: 0,
	  k1: 0,
	  k2: 0,
	  k3: 0,
	  k4: 0,
	  kernelMatrix: 'kernelMatrix',
	  kernelUnitLength: 'kernelUnitLength',
	  kerning: 0,
	  keyPoints: 'keyPoints',
	  keySplines: 'keySplines',
	  keyTimes: 'keyTimes',
	  lengthAdjust: 'lengthAdjust',
	  letterSpacing: 'letter-spacing',
	  lightingColor: 'lighting-color',
	  limitingConeAngle: 'limitingConeAngle',
	  local: 0,
	  markerEnd: 'marker-end',
	  markerMid: 'marker-mid',
	  markerStart: 'marker-start',
	  markerHeight: 'markerHeight',
	  markerUnits: 'markerUnits',
	  markerWidth: 'markerWidth',
	  mask: 0,
	  maskContentUnits: 'maskContentUnits',
	  maskUnits: 'maskUnits',
	  mathematical: 0,
	  mode: 0,
	  numOctaves: 'numOctaves',
	  offset: 0,
	  opacity: 0,
	  operator: 0,
	  order: 0,
	  orient: 0,
	  orientation: 0,
	  origin: 0,
	  overflow: 0,
	  overlinePosition: 'overline-position',
	  overlineThickness: 'overline-thickness',
	  paintOrder: 'paint-order',
	  panose1: 'panose-1',
	  pathLength: 'pathLength',
	  patternContentUnits: 'patternContentUnits',
	  patternTransform: 'patternTransform',
	  patternUnits: 'patternUnits',
	  pointerEvents: 'pointer-events',
	  points: 0,
	  pointsAtX: 'pointsAtX',
	  pointsAtY: 'pointsAtY',
	  pointsAtZ: 'pointsAtZ',
	  preserveAlpha: 'preserveAlpha',
	  preserveAspectRatio: 'preserveAspectRatio',
	  primitiveUnits: 'primitiveUnits',
	  r: 0,
	  radius: 0,
	  refX: 'refX',
	  refY: 'refY',
	  renderingIntent: 'rendering-intent',
	  repeatCount: 'repeatCount',
	  repeatDur: 'repeatDur',
	  requiredExtensions: 'requiredExtensions',
	  requiredFeatures: 'requiredFeatures',
	  restart: 0,
	  result: 0,
	  rotate: 0,
	  rx: 0,
	  ry: 0,
	  scale: 0,
	  seed: 0,
	  shapeRendering: 'shape-rendering',
	  slope: 0,
	  spacing: 0,
	  specularConstant: 'specularConstant',
	  specularExponent: 'specularExponent',
	  speed: 0,
	  spreadMethod: 'spreadMethod',
	  startOffset: 'startOffset',
	  stdDeviation: 'stdDeviation',
	  stemh: 0,
	  stemv: 0,
	  stitchTiles: 'stitchTiles',
	  stopColor: 'stop-color',
	  stopOpacity: 'stop-opacity',
	  strikethroughPosition: 'strikethrough-position',
	  strikethroughThickness: 'strikethrough-thickness',
	  string: 0,
	  stroke: 0,
	  strokeDasharray: 'stroke-dasharray',
	  strokeDashoffset: 'stroke-dashoffset',
	  strokeLinecap: 'stroke-linecap',
	  strokeLinejoin: 'stroke-linejoin',
	  strokeMiterlimit: 'stroke-miterlimit',
	  strokeOpacity: 'stroke-opacity',
	  strokeWidth: 'stroke-width',
	  surfaceScale: 'surfaceScale',
	  systemLanguage: 'systemLanguage',
	  tableValues: 'tableValues',
	  targetX: 'targetX',
	  targetY: 'targetY',
	  textAnchor: 'text-anchor',
	  textDecoration: 'text-decoration',
	  textRendering: 'text-rendering',
	  textLength: 'textLength',
	  to: 0,
	  transform: 0,
	  u1: 0,
	  u2: 0,
	  underlinePosition: 'underline-position',
	  underlineThickness: 'underline-thickness',
	  unicode: 0,
	  unicodeBidi: 'unicode-bidi',
	  unicodeRange: 'unicode-range',
	  unitsPerEm: 'units-per-em',
	  vAlphabetic: 'v-alphabetic',
	  vHanging: 'v-hanging',
	  vIdeographic: 'v-ideographic',
	  vMathematical: 'v-mathematical',
	  values: 0,
	  vectorEffect: 'vector-effect',
	  version: 0,
	  vertAdvY: 'vert-adv-y',
	  vertOriginX: 'vert-origin-x',
	  vertOriginY: 'vert-origin-y',
	  viewBox: 'viewBox',
	  viewTarget: 'viewTarget',
	  visibility: 0,
	  widths: 0,
	  wordSpacing: 'word-spacing',
	  writingMode: 'writing-mode',
	  x: 0,
	  xHeight: 'x-height',
	  x1: 0,
	  x2: 0,
	  xChannelSelector: 'xChannelSelector',
	  xlinkActuate: 'xlink:actuate',
	  xlinkArcrole: 'xlink:arcrole',
	  xlinkHref: 'xlink:href',
	  xlinkRole: 'xlink:role',
	  xlinkShow: 'xlink:show',
	  xlinkTitle: 'xlink:title',
	  xlinkType: 'xlink:type',
	  xmlBase: 'xml:base',
	  xmlLang: 'xml:lang',
	  xmlSpace: 'xml:space',
	  y: 0,
	  y1: 0,
	  y2: 0,
	  yChannelSelector: 'yChannelSelector',
	  z: 0,
	  zoomAndPan: 'zoomAndPan'
	};
	
	var SVGDOMPropertyConfig = {
	  Properties: {},
	  DOMAttributeNamespaces: {
	    xlinkActuate: NS.xlink,
	    xlinkArcrole: NS.xlink,
	    xlinkHref: NS.xlink,
	    xlinkRole: NS.xlink,
	    xlinkShow: NS.xlink,
	    xlinkTitle: NS.xlink,
	    xlinkType: NS.xlink,
	    xmlBase: NS.xml,
	    xmlLang: NS.xml,
	    xmlSpace: NS.xml
	  },
	  DOMAttributeNames: {}
	};
	
	Object.keys(ATTRS).forEach(function (key) {
	  SVGDOMPropertyConfig.Properties[key] = 0;
	  if (ATTRS[key]) {
	    SVGDOMPropertyConfig.DOMAttributeNames[key] = ATTRS[key];
	  }
	});
	
	module.exports = SVGDOMPropertyConfig;

/***/ },
/* 778 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule SelectEventPlugin
	 */
	
	'use strict';
	
	var EventConstants = __webpack_require__(52);
	var EventPropagators = __webpack_require__(100);
	var ExecutionEnvironment = __webpack_require__(22);
	var ReactDOMComponentTree = __webpack_require__(15);
	var ReactInputSelection = __webpack_require__(322);
	var SyntheticEvent = __webpack_require__(53);
	
	var getActiveElement = __webpack_require__(246);
	var isTextInputElement = __webpack_require__(337);
	var keyOf = __webpack_require__(50);
	var shallowEqual = __webpack_require__(247);
	
	var topLevelTypes = EventConstants.topLevelTypes;
	
	var skipSelectionChangeEvent = ExecutionEnvironment.canUseDOM && 'documentMode' in document && document.documentMode <= 11;
	
	var eventTypes = {
	  select: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onSelect: null }),
	      captured: keyOf({ onSelectCapture: null })
	    },
	    dependencies: [topLevelTypes.topBlur, topLevelTypes.topContextMenu, topLevelTypes.topFocus, topLevelTypes.topKeyDown, topLevelTypes.topMouseDown, topLevelTypes.topMouseUp, topLevelTypes.topSelectionChange]
	  }
	};
	
	var activeElement = null;
	var activeElementInst = null;
	var lastSelection = null;
	var mouseDown = false;
	
	// Track whether a listener exists for this plugin. If none exist, we do
	// not extract events. See #3639.
	var hasListener = false;
	var ON_SELECT_KEY = keyOf({ onSelect: null });
	
	/**
	 * Get an object which is a unique representation of the current selection.
	 *
	 * The return value will not be consistent across nodes or browsers, but
	 * two identical selections on the same node will return identical objects.
	 *
	 * @param {DOMElement} node
	 * @return {object}
	 */
	function getSelection(node) {
	  if ('selectionStart' in node && ReactInputSelection.hasSelectionCapabilities(node)) {
	    return {
	      start: node.selectionStart,
	      end: node.selectionEnd
	    };
	  } else if (window.getSelection) {
	    var selection = window.getSelection();
	    return {
	      anchorNode: selection.anchorNode,
	      anchorOffset: selection.anchorOffset,
	      focusNode: selection.focusNode,
	      focusOffset: selection.focusOffset
	    };
	  } else if (document.selection) {
	    var range = document.selection.createRange();
	    return {
	      parentElement: range.parentElement(),
	      text: range.text,
	      top: range.boundingTop,
	      left: range.boundingLeft
	    };
	  }
	}
	
	/**
	 * Poll selection to see whether it's changed.
	 *
	 * @param {object} nativeEvent
	 * @return {?SyntheticEvent}
	 */
	function constructSelectEvent(nativeEvent, nativeEventTarget) {
	  // Ensure we have the right element, and that the user is not dragging a
	  // selection (this matches native `select` event behavior). In HTML5, select
	  // fires only on input and textarea thus if there's no focused element we
	  // won't dispatch.
	  if (mouseDown || activeElement == null || activeElement !== getActiveElement()) {
	    return null;
	  }
	
	  // Only fire when selection has actually changed.
	  var currentSelection = getSelection(activeElement);
	  if (!lastSelection || !shallowEqual(lastSelection, currentSelection)) {
	    lastSelection = currentSelection;
	
	    var syntheticEvent = SyntheticEvent.getPooled(eventTypes.select, activeElementInst, nativeEvent, nativeEventTarget);
	
	    syntheticEvent.type = 'select';
	    syntheticEvent.target = activeElement;
	
	    EventPropagators.accumulateTwoPhaseDispatches(syntheticEvent);
	
	    return syntheticEvent;
	  }
	
	  return null;
	}
	
	/**
	 * This plugin creates an `onSelect` event that normalizes select events
	 * across form elements.
	 *
	 * Supported elements are:
	 * - input (see `isTextInputElement`)
	 * - textarea
	 * - contentEditable
	 *
	 * This differs from native browser implementations in the following ways:
	 * - Fires on contentEditable fields as well as inputs.
	 * - Fires for collapsed selection.
	 * - Fires after user input.
	 */
	var SelectEventPlugin = {
	
	  eventTypes: eventTypes,
	
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    if (!hasListener) {
	      return null;
	    }
	
	    var targetNode = targetInst ? ReactDOMComponentTree.getNodeFromInstance(targetInst) : window;
	
	    switch (topLevelType) {
	      // Track the input node that has focus.
	      case topLevelTypes.topFocus:
	        if (isTextInputElement(targetNode) || targetNode.contentEditable === 'true') {
	          activeElement = targetNode;
	          activeElementInst = targetInst;
	          lastSelection = null;
	        }
	        break;
	      case topLevelTypes.topBlur:
	        activeElement = null;
	        activeElementInst = null;
	        lastSelection = null;
	        break;
	
	      // Don't fire the event while the user is dragging. This matches the
	      // semantics of the native select event.
	      case topLevelTypes.topMouseDown:
	        mouseDown = true;
	        break;
	      case topLevelTypes.topContextMenu:
	      case topLevelTypes.topMouseUp:
	        mouseDown = false;
	        return constructSelectEvent(nativeEvent, nativeEventTarget);
	
	      // Chrome and IE fire non-standard event when selection is changed (and
	      // sometimes when it hasn't). IE's event fires out of order with respect
	      // to key and input events on deletion, so we discard it.
	      //
	      // Firefox doesn't support selectionchange, so check selection status
	      // after each key entry. The selection changes after keydown and before
	      // keyup, but we check on keydown as well in the case of holding down a
	      // key, when multiple keydown events are fired but only one keyup is.
	      // This is also our approach for IE handling, for the reason above.
	      case topLevelTypes.topSelectionChange:
	        if (skipSelectionChangeEvent) {
	          break;
	        }
	      // falls through
	      case topLevelTypes.topKeyDown:
	      case topLevelTypes.topKeyUp:
	        return constructSelectEvent(nativeEvent, nativeEventTarget);
	    }
	
	    return null;
	  },
	
	  didPutListener: function (inst, registrationName, listener) {
	    if (registrationName === ON_SELECT_KEY) {
	      hasListener = true;
	    }
	  }
	};
	
	module.exports = SelectEventPlugin;

/***/ },
/* 779 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule SimpleEventPlugin
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(5);
	
	var EventConstants = __webpack_require__(52);
	var EventListener = __webpack_require__(244);
	var EventPropagators = __webpack_require__(100);
	var ReactDOMComponentTree = __webpack_require__(15);
	var SyntheticAnimationEvent = __webpack_require__(780);
	var SyntheticClipboardEvent = __webpack_require__(781);
	var SyntheticEvent = __webpack_require__(53);
	var SyntheticFocusEvent = __webpack_require__(784);
	var SyntheticKeyboardEvent = __webpack_require__(786);
	var SyntheticMouseEvent = __webpack_require__(141);
	var SyntheticDragEvent = __webpack_require__(783);
	var SyntheticTouchEvent = __webpack_require__(787);
	var SyntheticTransitionEvent = __webpack_require__(788);
	var SyntheticUIEvent = __webpack_require__(102);
	var SyntheticWheelEvent = __webpack_require__(789);
	
	var emptyFunction = __webpack_require__(37);
	var getEventCharCode = __webpack_require__(208);
	var invariant = __webpack_require__(2);
	var keyOf = __webpack_require__(50);
	
	var topLevelTypes = EventConstants.topLevelTypes;
	
	var eventTypes = {
	  abort: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onAbort: true }),
	      captured: keyOf({ onAbortCapture: true })
	    }
	  },
	  animationEnd: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onAnimationEnd: true }),
	      captured: keyOf({ onAnimationEndCapture: true })
	    }
	  },
	  animationIteration: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onAnimationIteration: true }),
	      captured: keyOf({ onAnimationIterationCapture: true })
	    }
	  },
	  animationStart: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onAnimationStart: true }),
	      captured: keyOf({ onAnimationStartCapture: true })
	    }
	  },
	  blur: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onBlur: true }),
	      captured: keyOf({ onBlurCapture: true })
	    }
	  },
	  canPlay: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onCanPlay: true }),
	      captured: keyOf({ onCanPlayCapture: true })
	    }
	  },
	  canPlayThrough: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onCanPlayThrough: true }),
	      captured: keyOf({ onCanPlayThroughCapture: true })
	    }
	  },
	  click: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onClick: true }),
	      captured: keyOf({ onClickCapture: true })
	    }
	  },
	  contextMenu: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onContextMenu: true }),
	      captured: keyOf({ onContextMenuCapture: true })
	    }
	  },
	  copy: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onCopy: true }),
	      captured: keyOf({ onCopyCapture: true })
	    }
	  },
	  cut: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onCut: true }),
	      captured: keyOf({ onCutCapture: true })
	    }
	  },
	  doubleClick: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onDoubleClick: true }),
	      captured: keyOf({ onDoubleClickCapture: true })
	    }
	  },
	  drag: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onDrag: true }),
	      captured: keyOf({ onDragCapture: true })
	    }
	  },
	  dragEnd: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onDragEnd: true }),
	      captured: keyOf({ onDragEndCapture: true })
	    }
	  },
	  dragEnter: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onDragEnter: true }),
	      captured: keyOf({ onDragEnterCapture: true })
	    }
	  },
	  dragExit: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onDragExit: true }),
	      captured: keyOf({ onDragExitCapture: true })
	    }
	  },
	  dragLeave: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onDragLeave: true }),
	      captured: keyOf({ onDragLeaveCapture: true })
	    }
	  },
	  dragOver: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onDragOver: true }),
	      captured: keyOf({ onDragOverCapture: true })
	    }
	  },
	  dragStart: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onDragStart: true }),
	      captured: keyOf({ onDragStartCapture: true })
	    }
	  },
	  drop: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onDrop: true }),
	      captured: keyOf({ onDropCapture: true })
	    }
	  },
	  durationChange: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onDurationChange: true }),
	      captured: keyOf({ onDurationChangeCapture: true })
	    }
	  },
	  emptied: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onEmptied: true }),
	      captured: keyOf({ onEmptiedCapture: true })
	    }
	  },
	  encrypted: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onEncrypted: true }),
	      captured: keyOf({ onEncryptedCapture: true })
	    }
	  },
	  ended: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onEnded: true }),
	      captured: keyOf({ onEndedCapture: true })
	    }
	  },
	  error: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onError: true }),
	      captured: keyOf({ onErrorCapture: true })
	    }
	  },
	  focus: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onFocus: true }),
	      captured: keyOf({ onFocusCapture: true })
	    }
	  },
	  input: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onInput: true }),
	      captured: keyOf({ onInputCapture: true })
	    }
	  },
	  invalid: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onInvalid: true }),
	      captured: keyOf({ onInvalidCapture: true })
	    }
	  },
	  keyDown: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onKeyDown: true }),
	      captured: keyOf({ onKeyDownCapture: true })
	    }
	  },
	  keyPress: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onKeyPress: true }),
	      captured: keyOf({ onKeyPressCapture: true })
	    }
	  },
	  keyUp: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onKeyUp: true }),
	      captured: keyOf({ onKeyUpCapture: true })
	    }
	  },
	  load: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onLoad: true }),
	      captured: keyOf({ onLoadCapture: true })
	    }
	  },
	  loadedData: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onLoadedData: true }),
	      captured: keyOf({ onLoadedDataCapture: true })
	    }
	  },
	  loadedMetadata: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onLoadedMetadata: true }),
	      captured: keyOf({ onLoadedMetadataCapture: true })
	    }
	  },
	  loadStart: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onLoadStart: true }),
	      captured: keyOf({ onLoadStartCapture: true })
	    }
	  },
	  // Note: We do not allow listening to mouseOver events. Instead, use the
	  // onMouseEnter/onMouseLeave created by `EnterLeaveEventPlugin`.
	  mouseDown: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onMouseDown: true }),
	      captured: keyOf({ onMouseDownCapture: true })
	    }
	  },
	  mouseMove: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onMouseMove: true }),
	      captured: keyOf({ onMouseMoveCapture: true })
	    }
	  },
	  mouseOut: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onMouseOut: true }),
	      captured: keyOf({ onMouseOutCapture: true })
	    }
	  },
	  mouseOver: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onMouseOver: true }),
	      captured: keyOf({ onMouseOverCapture: true })
	    }
	  },
	  mouseUp: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onMouseUp: true }),
	      captured: keyOf({ onMouseUpCapture: true })
	    }
	  },
	  paste: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onPaste: true }),
	      captured: keyOf({ onPasteCapture: true })
	    }
	  },
	  pause: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onPause: true }),
	      captured: keyOf({ onPauseCapture: true })
	    }
	  },
	  play: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onPlay: true }),
	      captured: keyOf({ onPlayCapture: true })
	    }
	  },
	  playing: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onPlaying: true }),
	      captured: keyOf({ onPlayingCapture: true })
	    }
	  },
	  progress: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onProgress: true }),
	      captured: keyOf({ onProgressCapture: true })
	    }
	  },
	  rateChange: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onRateChange: true }),
	      captured: keyOf({ onRateChangeCapture: true })
	    }
	  },
	  reset: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onReset: true }),
	      captured: keyOf({ onResetCapture: true })
	    }
	  },
	  scroll: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onScroll: true }),
	      captured: keyOf({ onScrollCapture: true })
	    }
	  },
	  seeked: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onSeeked: true }),
	      captured: keyOf({ onSeekedCapture: true })
	    }
	  },
	  seeking: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onSeeking: true }),
	      captured: keyOf({ onSeekingCapture: true })
	    }
	  },
	  stalled: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onStalled: true }),
	      captured: keyOf({ onStalledCapture: true })
	    }
	  },
	  submit: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onSubmit: true }),
	      captured: keyOf({ onSubmitCapture: true })
	    }
	  },
	  suspend: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onSuspend: true }),
	      captured: keyOf({ onSuspendCapture: true })
	    }
	  },
	  timeUpdate: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onTimeUpdate: true }),
	      captured: keyOf({ onTimeUpdateCapture: true })
	    }
	  },
	  touchCancel: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onTouchCancel: true }),
	      captured: keyOf({ onTouchCancelCapture: true })
	    }
	  },
	  touchEnd: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onTouchEnd: true }),
	      captured: keyOf({ onTouchEndCapture: true })
	    }
	  },
	  touchMove: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onTouchMove: true }),
	      captured: keyOf({ onTouchMoveCapture: true })
	    }
	  },
	  touchStart: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onTouchStart: true }),
	      captured: keyOf({ onTouchStartCapture: true })
	    }
	  },
	  transitionEnd: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onTransitionEnd: true }),
	      captured: keyOf({ onTransitionEndCapture: true })
	    }
	  },
	  volumeChange: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onVolumeChange: true }),
	      captured: keyOf({ onVolumeChangeCapture: true })
	    }
	  },
	  waiting: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onWaiting: true }),
	      captured: keyOf({ onWaitingCapture: true })
	    }
	  },
	  wheel: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onWheel: true }),
	      captured: keyOf({ onWheelCapture: true })
	    }
	  }
	};
	
	var topLevelEventsToDispatchConfig = {
	  topAbort: eventTypes.abort,
	  topAnimationEnd: eventTypes.animationEnd,
	  topAnimationIteration: eventTypes.animationIteration,
	  topAnimationStart: eventTypes.animationStart,
	  topBlur: eventTypes.blur,
	  topCanPlay: eventTypes.canPlay,
	  topCanPlayThrough: eventTypes.canPlayThrough,
	  topClick: eventTypes.click,
	  topContextMenu: eventTypes.contextMenu,
	  topCopy: eventTypes.copy,
	  topCut: eventTypes.cut,
	  topDoubleClick: eventTypes.doubleClick,
	  topDrag: eventTypes.drag,
	  topDragEnd: eventTypes.dragEnd,
	  topDragEnter: eventTypes.dragEnter,
	  topDragExit: eventTypes.dragExit,
	  topDragLeave: eventTypes.dragLeave,
	  topDragOver: eventTypes.dragOver,
	  topDragStart: eventTypes.dragStart,
	  topDrop: eventTypes.drop,
	  topDurationChange: eventTypes.durationChange,
	  topEmptied: eventTypes.emptied,
	  topEncrypted: eventTypes.encrypted,
	  topEnded: eventTypes.ended,
	  topError: eventTypes.error,
	  topFocus: eventTypes.focus,
	  topInput: eventTypes.input,
	  topInvalid: eventTypes.invalid,
	  topKeyDown: eventTypes.keyDown,
	  topKeyPress: eventTypes.keyPress,
	  topKeyUp: eventTypes.keyUp,
	  topLoad: eventTypes.load,
	  topLoadedData: eventTypes.loadedData,
	  topLoadedMetadata: eventTypes.loadedMetadata,
	  topLoadStart: eventTypes.loadStart,
	  topMouseDown: eventTypes.mouseDown,
	  topMouseMove: eventTypes.mouseMove,
	  topMouseOut: eventTypes.mouseOut,
	  topMouseOver: eventTypes.mouseOver,
	  topMouseUp: eventTypes.mouseUp,
	  topPaste: eventTypes.paste,
	  topPause: eventTypes.pause,
	  topPlay: eventTypes.play,
	  topPlaying: eventTypes.playing,
	  topProgress: eventTypes.progress,
	  topRateChange: eventTypes.rateChange,
	  topReset: eventTypes.reset,
	  topScroll: eventTypes.scroll,
	  topSeeked: eventTypes.seeked,
	  topSeeking: eventTypes.seeking,
	  topStalled: eventTypes.stalled,
	  topSubmit: eventTypes.submit,
	  topSuspend: eventTypes.suspend,
	  topTimeUpdate: eventTypes.timeUpdate,
	  topTouchCancel: eventTypes.touchCancel,
	  topTouchEnd: eventTypes.touchEnd,
	  topTouchMove: eventTypes.touchMove,
	  topTouchStart: eventTypes.touchStart,
	  topTransitionEnd: eventTypes.transitionEnd,
	  topVolumeChange: eventTypes.volumeChange,
	  topWaiting: eventTypes.waiting,
	  topWheel: eventTypes.wheel
	};
	
	for (var type in topLevelEventsToDispatchConfig) {
	  topLevelEventsToDispatchConfig[type].dependencies = [type];
	}
	
	var ON_CLICK_KEY = keyOf({ onClick: null });
	var onClickListeners = {};
	
	var SimpleEventPlugin = {
	
	  eventTypes: eventTypes,
	
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    var dispatchConfig = topLevelEventsToDispatchConfig[topLevelType];
	    if (!dispatchConfig) {
	      return null;
	    }
	    var EventConstructor;
	    switch (topLevelType) {
	      case topLevelTypes.topAbort:
	      case topLevelTypes.topCanPlay:
	      case topLevelTypes.topCanPlayThrough:
	      case topLevelTypes.topDurationChange:
	      case topLevelTypes.topEmptied:
	      case topLevelTypes.topEncrypted:
	      case topLevelTypes.topEnded:
	      case topLevelTypes.topError:
	      case topLevelTypes.topInput:
	      case topLevelTypes.topInvalid:
	      case topLevelTypes.topLoad:
	      case topLevelTypes.topLoadedData:
	      case topLevelTypes.topLoadedMetadata:
	      case topLevelTypes.topLoadStart:
	      case topLevelTypes.topPause:
	      case topLevelTypes.topPlay:
	      case topLevelTypes.topPlaying:
	      case topLevelTypes.topProgress:
	      case topLevelTypes.topRateChange:
	      case topLevelTypes.topReset:
	      case topLevelTypes.topSeeked:
	      case topLevelTypes.topSeeking:
	      case topLevelTypes.topStalled:
	      case topLevelTypes.topSubmit:
	      case topLevelTypes.topSuspend:
	      case topLevelTypes.topTimeUpdate:
	      case topLevelTypes.topVolumeChange:
	      case topLevelTypes.topWaiting:
	        // HTML Events
	        // @see http://www.w3.org/TR/html5/index.html#events-0
	        EventConstructor = SyntheticEvent;
	        break;
	      case topLevelTypes.topKeyPress:
	        // Firefox creates a keypress event for function keys too. This removes
	        // the unwanted keypress events. Enter is however both printable and
	        // non-printable. One would expect Tab to be as well (but it isn't).
	        if (getEventCharCode(nativeEvent) === 0) {
	          return null;
	        }
	      /* falls through */
	      case topLevelTypes.topKeyDown:
	      case topLevelTypes.topKeyUp:
	        EventConstructor = SyntheticKeyboardEvent;
	        break;
	      case topLevelTypes.topBlur:
	      case topLevelTypes.topFocus:
	        EventConstructor = SyntheticFocusEvent;
	        break;
	      case topLevelTypes.topClick:
	        // Firefox creates a click event on right mouse clicks. This removes the
	        // unwanted click events.
	        if (nativeEvent.button === 2) {
	          return null;
	        }
	      /* falls through */
	      case topLevelTypes.topContextMenu:
	      case topLevelTypes.topDoubleClick:
	      case topLevelTypes.topMouseDown:
	      case topLevelTypes.topMouseMove:
	      case topLevelTypes.topMouseOut:
	      case topLevelTypes.topMouseOver:
	      case topLevelTypes.topMouseUp:
	        EventConstructor = SyntheticMouseEvent;
	        break;
	      case topLevelTypes.topDrag:
	      case topLevelTypes.topDragEnd:
	      case topLevelTypes.topDragEnter:
	      case topLevelTypes.topDragExit:
	      case topLevelTypes.topDragLeave:
	      case topLevelTypes.topDragOver:
	      case topLevelTypes.topDragStart:
	      case topLevelTypes.topDrop:
	        EventConstructor = SyntheticDragEvent;
	        break;
	      case topLevelTypes.topTouchCancel:
	      case topLevelTypes.topTouchEnd:
	      case topLevelTypes.topTouchMove:
	      case topLevelTypes.topTouchStart:
	        EventConstructor = SyntheticTouchEvent;
	        break;
	      case topLevelTypes.topAnimationEnd:
	      case topLevelTypes.topAnimationIteration:
	      case topLevelTypes.topAnimationStart:
	        EventConstructor = SyntheticAnimationEvent;
	        break;
	      case topLevelTypes.topTransitionEnd:
	        EventConstructor = SyntheticTransitionEvent;
	        break;
	      case topLevelTypes.topScroll:
	        EventConstructor = SyntheticUIEvent;
	        break;
	      case topLevelTypes.topWheel:
	        EventConstructor = SyntheticWheelEvent;
	        break;
	      case topLevelTypes.topCopy:
	      case topLevelTypes.topCut:
	      case topLevelTypes.topPaste:
	        EventConstructor = SyntheticClipboardEvent;
	        break;
	    }
	    !EventConstructor ?  false ? invariant(false, 'SimpleEventPlugin: Unhandled event type, `%s`.', topLevelType) : _prodInvariant('86', topLevelType) : void 0;
	    var event = EventConstructor.getPooled(dispatchConfig, targetInst, nativeEvent, nativeEventTarget);
	    EventPropagators.accumulateTwoPhaseDispatches(event);
	    return event;
	  },
	
	  didPutListener: function (inst, registrationName, listener) {
	    // Mobile Safari does not fire properly bubble click events on
	    // non-interactive elements, which means delegated click listeners do not
	    // fire. The workaround for this bug involves attaching an empty click
	    // listener on the target node.
	    if (registrationName === ON_CLICK_KEY) {
	      var id = inst._rootNodeID;
	      var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	      if (!onClickListeners[id]) {
	        onClickListeners[id] = EventListener.listen(node, 'click', emptyFunction);
	      }
	    }
	  },
	
	  willDeleteListener: function (inst, registrationName) {
	    if (registrationName === ON_CLICK_KEY) {
	      var id = inst._rootNodeID;
	      onClickListeners[id].remove();
	      delete onClickListeners[id];
	    }
	  }
	
	};
	
	module.exports = SimpleEventPlugin;

/***/ },
/* 780 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule SyntheticAnimationEvent
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(53);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/css3-animations/#AnimationEvent-interface
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/AnimationEvent
	 */
	var AnimationEventInterface = {
	  animationName: null,
	  elapsedTime: null,
	  pseudoElement: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticEvent}
	 */
	function SyntheticAnimationEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticAnimationEvent, AnimationEventInterface);
	
	module.exports = SyntheticAnimationEvent;

/***/ },
/* 781 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule SyntheticClipboardEvent
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(53);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/clipboard-apis/
	 */
	var ClipboardEventInterface = {
	  clipboardData: function (event) {
	    return 'clipboardData' in event ? event.clipboardData : window.clipboardData;
	  }
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticClipboardEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticClipboardEvent, ClipboardEventInterface);
	
	module.exports = SyntheticClipboardEvent;

/***/ },
/* 782 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule SyntheticCompositionEvent
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(53);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/#events-compositionevents
	 */
	var CompositionEventInterface = {
	  data: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticCompositionEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticCompositionEvent, CompositionEventInterface);
	
	module.exports = SyntheticCompositionEvent;

/***/ },
/* 783 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule SyntheticDragEvent
	 */
	
	'use strict';
	
	var SyntheticMouseEvent = __webpack_require__(141);
	
	/**
	 * @interface DragEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var DragEventInterface = {
	  dataTransfer: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticDragEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticMouseEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticMouseEvent.augmentClass(SyntheticDragEvent, DragEventInterface);
	
	module.exports = SyntheticDragEvent;

/***/ },
/* 784 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule SyntheticFocusEvent
	 */
	
	'use strict';
	
	var SyntheticUIEvent = __webpack_require__(102);
	
	/**
	 * @interface FocusEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var FocusEventInterface = {
	  relatedTarget: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticFocusEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticUIEvent.augmentClass(SyntheticFocusEvent, FocusEventInterface);
	
	module.exports = SyntheticFocusEvent;

/***/ },
/* 785 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule SyntheticInputEvent
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(53);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/2013/WD-DOM-Level-3-Events-20131105
	 *      /#events-inputevents
	 */
	var InputEventInterface = {
	  data: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticInputEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticInputEvent, InputEventInterface);
	
	module.exports = SyntheticInputEvent;

/***/ },
/* 786 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule SyntheticKeyboardEvent
	 */
	
	'use strict';
	
	var SyntheticUIEvent = __webpack_require__(102);
	
	var getEventCharCode = __webpack_require__(208);
	var getEventKey = __webpack_require__(795);
	var getEventModifierState = __webpack_require__(209);
	
	/**
	 * @interface KeyboardEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var KeyboardEventInterface = {
	  key: getEventKey,
	  location: null,
	  ctrlKey: null,
	  shiftKey: null,
	  altKey: null,
	  metaKey: null,
	  repeat: null,
	  locale: null,
	  getModifierState: getEventModifierState,
	  // Legacy Interface
	  charCode: function (event) {
	    // `charCode` is the result of a KeyPress event and represents the value of
	    // the actual printable character.
	
	    // KeyPress is deprecated, but its replacement is not yet final and not
	    // implemented in any major browser. Only KeyPress has charCode.
	    if (event.type === 'keypress') {
	      return getEventCharCode(event);
	    }
	    return 0;
	  },
	  keyCode: function (event) {
	    // `keyCode` is the result of a KeyDown/Up event and represents the value of
	    // physical keyboard key.
	
	    // The actual meaning of the value depends on the users' keyboard layout
	    // which cannot be detected. Assuming that it is a US keyboard layout
	    // provides a surprisingly accurate mapping for US and European users.
	    // Due to this, it is left to the user to implement at this time.
	    if (event.type === 'keydown' || event.type === 'keyup') {
	      return event.keyCode;
	    }
	    return 0;
	  },
	  which: function (event) {
	    // `which` is an alias for either `keyCode` or `charCode` depending on the
	    // type of the event.
	    if (event.type === 'keypress') {
	      return getEventCharCode(event);
	    }
	    if (event.type === 'keydown' || event.type === 'keyup') {
	      return event.keyCode;
	    }
	    return 0;
	  }
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticKeyboardEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticUIEvent.augmentClass(SyntheticKeyboardEvent, KeyboardEventInterface);
	
	module.exports = SyntheticKeyboardEvent;

/***/ },
/* 787 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule SyntheticTouchEvent
	 */
	
	'use strict';
	
	var SyntheticUIEvent = __webpack_require__(102);
	
	var getEventModifierState = __webpack_require__(209);
	
	/**
	 * @interface TouchEvent
	 * @see http://www.w3.org/TR/touch-events/
	 */
	var TouchEventInterface = {
	  touches: null,
	  targetTouches: null,
	  changedTouches: null,
	  altKey: null,
	  metaKey: null,
	  ctrlKey: null,
	  shiftKey: null,
	  getModifierState: getEventModifierState
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticTouchEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticUIEvent.augmentClass(SyntheticTouchEvent, TouchEventInterface);
	
	module.exports = SyntheticTouchEvent;

/***/ },
/* 788 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule SyntheticTransitionEvent
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(53);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/2009/WD-css3-transitions-20090320/#transition-events-
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/TransitionEvent
	 */
	var TransitionEventInterface = {
	  propertyName: null,
	  elapsedTime: null,
	  pseudoElement: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticEvent}
	 */
	function SyntheticTransitionEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticTransitionEvent, TransitionEventInterface);
	
	module.exports = SyntheticTransitionEvent;

/***/ },
/* 789 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule SyntheticWheelEvent
	 */
	
	'use strict';
	
	var SyntheticMouseEvent = __webpack_require__(141);
	
	/**
	 * @interface WheelEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var WheelEventInterface = {
	  deltaX: function (event) {
	    return 'deltaX' in event ? event.deltaX :
	    // Fallback to `wheelDeltaX` for Webkit and normalize (right is positive).
	    'wheelDeltaX' in event ? -event.wheelDeltaX : 0;
	  },
	  deltaY: function (event) {
	    return 'deltaY' in event ? event.deltaY :
	    // Fallback to `wheelDeltaY` for Webkit and normalize (down is positive).
	    'wheelDeltaY' in event ? -event.wheelDeltaY :
	    // Fallback to `wheelDelta` for IE<9 and normalize (down is positive).
	    'wheelDelta' in event ? -event.wheelDelta : 0;
	  },
	  deltaZ: null,
	
	  // Browsers without "deltaMode" is reporting in raw wheel delta where one
	  // notch on the scroll is always +/- 120, roughly equivalent to pixels.
	  // A good approximation of DOM_DELTA_LINE (1) is 5% of viewport size or
	  // ~40 pixels, for DOM_DELTA_SCREEN (2) it is 87.5% of viewport size.
	  deltaMode: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticMouseEvent}
	 */
	function SyntheticWheelEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticMouseEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticMouseEvent.augmentClass(SyntheticWheelEvent, WheelEventInterface);
	
	module.exports = SyntheticWheelEvent;

/***/ },
/* 790 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule adler32
	 * 
	 */
	
	'use strict';
	
	var MOD = 65521;
	
	// adler32 is not cryptographically strong, and is only used to sanity check that
	// markup generated on the server matches the markup generated on the client.
	// This implementation (a modified version of the SheetJS version) has been optimized
	// for our use case, at the expense of conforming to the adler32 specification
	// for non-ascii inputs.
	function adler32(data) {
	  var a = 1;
	  var b = 0;
	  var i = 0;
	  var l = data.length;
	  var m = l & ~0x3;
	  while (i < m) {
	    var n = Math.min(i + 4096, m);
	    for (; i < n; i += 4) {
	      b += (a += data.charCodeAt(i)) + (a += data.charCodeAt(i + 1)) + (a += data.charCodeAt(i + 2)) + (a += data.charCodeAt(i + 3));
	    }
	    a %= MOD;
	    b %= MOD;
	  }
	  for (; i < l; i++) {
	    b += a += data.charCodeAt(i);
	  }
	  a %= MOD;
	  b %= MOD;
	  return a | b << 16;
	}
	
	module.exports = adler32;

/***/ },
/* 791 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule checkReactTypeSpec
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(5);
	
	var ReactPropTypeLocationNames = __webpack_require__(204);
	
	var invariant = __webpack_require__(2);
	var warning = __webpack_require__(9);
	
	var loggedTypeFailures = {};
	
	/**
	 * Assert that the values match with the type specs.
	 * Error messages are memorized and will only be shown once.
	 *
	 * @param {object} typeSpecs Map of name to a ReactPropType
	 * @param {object} values Runtime values that need to be type-checked
	 * @param {string} location e.g. "prop", "context", "child context"
	 * @param {string} componentName Name of the component for error messages.
	 * @param {?object} element The React element that is being type-checked
	 * @param {?number} debugID The React component instance that is being type-checked
	 * @private
	 */
	function checkReactTypeSpec(typeSpecs, values, location, componentName, element, debugID) {
	  for (var typeSpecName in typeSpecs) {
	    if (typeSpecs.hasOwnProperty(typeSpecName)) {
	      var error;
	      // Prop type validation may throw. In case they do, we don't want to
	      // fail the render phase where it didn't fail before. So we log it.
	      // After these have been cleaned up, we'll let them throw.
	      try {
	        // This is intentionally an invariant that gets caught. It's the same
	        // behavior as without this statement except with a better message.
	        !(typeof typeSpecs[typeSpecName] === 'function') ?  false ? invariant(false, '%s: %s type `%s` is invalid; it must be a function, usually from React.PropTypes.', componentName || 'React class', ReactPropTypeLocationNames[location], typeSpecName) : _prodInvariant('84', componentName || 'React class', ReactPropTypeLocationNames[location], typeSpecName) : void 0;
	        error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location);
	      } catch (ex) {
	        error = ex;
	      }
	       false ? warning(!error || error instanceof Error, '%s: type specification of %s `%s` is invalid; the type checker ' + 'function must return `null` or an `Error` but returned a %s. ' + 'You may have forgotten to pass an argument to the type checker ' + 'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' + 'shape all require an argument).', componentName || 'React class', ReactPropTypeLocationNames[location], typeSpecName, typeof error) : void 0;
	      if (error instanceof Error && !(error.message in loggedTypeFailures)) {
	        // Only monitor this failure once because there tends to be a lot of the
	        // same error.
	        loggedTypeFailures[error.message] = true;
	
	        var componentStackInfo = '';
	
	        if (false) {
	          var ReactComponentTreeDevtool = require('./ReactComponentTreeDevtool');
	          if (debugID !== null) {
	            componentStackInfo = ReactComponentTreeDevtool.getStackAddendumByID(debugID);
	          } else if (element !== null) {
	            componentStackInfo = ReactComponentTreeDevtool.getCurrentStackAddendum(element);
	          }
	        }
	
	         false ? warning(false, 'Failed %s type: %s%s', location, error.message, componentStackInfo) : void 0;
	      }
	    }
	  }
	}
	
	module.exports = checkReactTypeSpec;

/***/ },
/* 792 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule dangerousStyleValue
	 */
	
	'use strict';
	
	var CSSProperty = __webpack_require__(310);
	var warning = __webpack_require__(9);
	
	var isUnitlessNumber = CSSProperty.isUnitlessNumber;
	var styleWarnings = {};
	
	/**
	 * Convert a value into the proper css writable value. The style name `name`
	 * should be logical (no hyphens), as specified
	 * in `CSSProperty.isUnitlessNumber`.
	 *
	 * @param {string} name CSS property name such as `topMargin`.
	 * @param {*} value CSS property value such as `10px`.
	 * @param {ReactDOMComponent} component
	 * @return {string} Normalized style value with dimensions applied.
	 */
	function dangerousStyleValue(name, value, component) {
	  // Note that we've removed escapeTextForBrowser() calls here since the
	  // whole string will be escaped when the attribute is injected into
	  // the markup. If you provide unsafe user data here they can inject
	  // arbitrary CSS which may be problematic (I couldn't repro this):
	  // https://www.owasp.org/index.php/XSS_Filter_Evasion_Cheat_Sheet
	  // http://www.thespanner.co.uk/2007/11/26/ultimate-xss-css-injection/
	  // This is not an XSS hole but instead a potential CSS injection issue
	  // which has lead to a greater discussion about how we're going to
	  // trust URLs moving forward. See #2115901
	
	  var isEmpty = value == null || typeof value === 'boolean' || value === '';
	  if (isEmpty) {
	    return '';
	  }
	
	  var isNonNumeric = isNaN(value);
	  if (isNonNumeric || value === 0 || isUnitlessNumber.hasOwnProperty(name) && isUnitlessNumber[name]) {
	    return '' + value; // cast to string
	  }
	
	  if (typeof value === 'string') {
	    if (false) {
	      // Allow '0' to pass through without warning. 0 is already special and
	      // doesn't require units, so we don't need to warn about it.
	      if (component && value !== '0') {
	        var owner = component._currentElement._owner;
	        var ownerName = owner ? owner.getName() : null;
	        if (ownerName && !styleWarnings[ownerName]) {
	          styleWarnings[ownerName] = {};
	        }
	        var warned = false;
	        if (ownerName) {
	          var warnings = styleWarnings[ownerName];
	          warned = warnings[name];
	          if (!warned) {
	            warnings[name] = true;
	          }
	        }
	        if (!warned) {
	          process.env.NODE_ENV !== 'production' ? warning(false, 'a `%s` tag (owner: `%s`) was passed a numeric string value ' + 'for CSS property `%s` (value: `%s`) which will be treated ' + 'as a unitless number in a future version of React.', component._currentElement.type, ownerName || 'unknown', name, value) : void 0;
	        }
	      }
	    }
	    value = value.trim();
	  }
	  return value + 'px';
	}
	
	module.exports = dangerousStyleValue;

/***/ },
/* 793 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule findDOMNode
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(5);
	
	var ReactCurrentOwner = __webpack_require__(75);
	var ReactDOMComponentTree = __webpack_require__(15);
	var ReactInstanceMap = __webpack_require__(101);
	
	var getHostComponentFromComposite = __webpack_require__(333);
	var invariant = __webpack_require__(2);
	var warning = __webpack_require__(9);
	
	/**
	 * Returns the DOM node rendered by this element.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#reactdom.finddomnode
	 *
	 * @param {ReactComponent|DOMElement} componentOrElement
	 * @return {?DOMElement} The root node of this element.
	 */
	function findDOMNode(componentOrElement) {
	  if (false) {
	    var owner = ReactCurrentOwner.current;
	    if (owner !== null) {
	      process.env.NODE_ENV !== 'production' ? warning(owner._warnedAboutRefsInRender, '%s is accessing findDOMNode inside its render(). ' + 'render() should be a pure function of props and state. It should ' + 'never access something that requires stale data from the previous ' + 'render, such as refs. Move this logic to componentDidMount and ' + 'componentDidUpdate instead.', owner.getName() || 'A component') : void 0;
	      owner._warnedAboutRefsInRender = true;
	    }
	  }
	  if (componentOrElement == null) {
	    return null;
	  }
	  if (componentOrElement.nodeType === 1) {
	    return componentOrElement;
	  }
	
	  var inst = ReactInstanceMap.get(componentOrElement);
	  if (inst) {
	    inst = getHostComponentFromComposite(inst);
	    return inst ? ReactDOMComponentTree.getNodeFromInstance(inst) : null;
	  }
	
	  if (typeof componentOrElement.render === 'function') {
	     true ?  false ? invariant(false, 'findDOMNode was called on an unmounted component.') : _prodInvariant('44') : void 0;
	  } else {
	     true ?  false ? invariant(false, 'Element appears to be neither ReactComponent nor DOMNode (keys: %s)', Object.keys(componentOrElement)) : _prodInvariant('45', Object.keys(componentOrElement)) : void 0;
	  }
	}
	
	module.exports = findDOMNode;

/***/ },
/* 794 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule flattenChildren
	 * 
	 */
	
	'use strict';
	
	var KeyEscapeUtils = __webpack_require__(200);
	var traverseAllChildren = __webpack_require__(213);
	var warning = __webpack_require__(9);
	
	/**
	 * @param {function} traverseContext Context passed through traversal.
	 * @param {?ReactComponent} child React child component.
	 * @param {!string} name String name of key path to child.
	 * @param {number=} selfDebugID Optional debugID of the current internal instance.
	 */
	function flattenSingleChildIntoContext(traverseContext, child, name, selfDebugID) {
	  // We found a component instance.
	  if (traverseContext && typeof traverseContext === 'object') {
	    var result = traverseContext;
	    var keyUnique = result[name] === undefined;
	    if (false) {
	      var ReactComponentTreeDevtool = require('./ReactComponentTreeDevtool');
	      process.env.NODE_ENV !== 'production' ? warning(keyUnique, 'flattenChildren(...): Encountered two children with the same key, ' + '`%s`. Child keys must be unique; when two children share a key, only ' + 'the first child will be used.%s', KeyEscapeUtils.unescape(name), ReactComponentTreeDevtool.getStackAddendumByID(selfDebugID)) : void 0;
	    }
	    if (keyUnique && child != null) {
	      result[name] = child;
	    }
	  }
	}
	
	/**
	 * Flattens children that are typically specified as `props.children`. Any null
	 * children will not be included in the resulting object.
	 * @return {!object} flattened children keyed by name.
	 */
	function flattenChildren(children, selfDebugID) {
	  if (children == null) {
	    return children;
	  }
	  var result = {};
	
	  if (false) {
	    traverseAllChildren(children, function (traverseContext, child, name) {
	      return flattenSingleChildIntoContext(traverseContext, child, name, selfDebugID);
	    }, result);
	  } else {
	    traverseAllChildren(children, flattenSingleChildIntoContext, result);
	  }
	  return result;
	}
	
	module.exports = flattenChildren;

/***/ },
/* 795 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule getEventKey
	 */
	
	'use strict';
	
	var getEventCharCode = __webpack_require__(208);
	
	/**
	 * Normalization of deprecated HTML5 `key` values
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent#Key_names
	 */
	var normalizeKey = {
	  'Esc': 'Escape',
	  'Spacebar': ' ',
	  'Left': 'ArrowLeft',
	  'Up': 'ArrowUp',
	  'Right': 'ArrowRight',
	  'Down': 'ArrowDown',
	  'Del': 'Delete',
	  'Win': 'OS',
	  'Menu': 'ContextMenu',
	  'Apps': 'ContextMenu',
	  'Scroll': 'ScrollLock',
	  'MozPrintableKey': 'Unidentified'
	};
	
	/**
	 * Translation from legacy `keyCode` to HTML5 `key`
	 * Only special keys supported, all others depend on keyboard layout or browser
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent#Key_names
	 */
	var translateToKey = {
	  8: 'Backspace',
	  9: 'Tab',
	  12: 'Clear',
	  13: 'Enter',
	  16: 'Shift',
	  17: 'Control',
	  18: 'Alt',
	  19: 'Pause',
	  20: 'CapsLock',
	  27: 'Escape',
	  32: ' ',
	  33: 'PageUp',
	  34: 'PageDown',
	  35: 'End',
	  36: 'Home',
	  37: 'ArrowLeft',
	  38: 'ArrowUp',
	  39: 'ArrowRight',
	  40: 'ArrowDown',
	  45: 'Insert',
	  46: 'Delete',
	  112: 'F1', 113: 'F2', 114: 'F3', 115: 'F4', 116: 'F5', 117: 'F6',
	  118: 'F7', 119: 'F8', 120: 'F9', 121: 'F10', 122: 'F11', 123: 'F12',
	  144: 'NumLock',
	  145: 'ScrollLock',
	  224: 'Meta'
	};
	
	/**
	 * @param {object} nativeEvent Native browser event.
	 * @return {string} Normalized `key` property.
	 */
	function getEventKey(nativeEvent) {
	  if (nativeEvent.key) {
	    // Normalize inconsistent values reported by browsers due to
	    // implementations of a working draft specification.
	
	    // FireFox implements `key` but returns `MozPrintableKey` for all
	    // printable characters (normalized to `Unidentified`), ignore it.
	    var key = normalizeKey[nativeEvent.key] || nativeEvent.key;
	    if (key !== 'Unidentified') {
	      return key;
	    }
	  }
	
	  // Browser does not implement `key`, polyfill as much of it as we can.
	  if (nativeEvent.type === 'keypress') {
	    var charCode = getEventCharCode(nativeEvent);
	
	    // The enter-key is technically both printable and non-printable and can
	    // thus be captured by `keypress`, no other non-printable key should.
	    return charCode === 13 ? 'Enter' : String.fromCharCode(charCode);
	  }
	  if (nativeEvent.type === 'keydown' || nativeEvent.type === 'keyup') {
	    // While user keyboard layout determines the actual meaning of each
	    // `keyCode` value, almost all function keys have a universal value.
	    return translateToKey[nativeEvent.keyCode] || 'Unidentified';
	  }
	  return '';
	}
	
	module.exports = getEventKey;

/***/ },
/* 796 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule getNodeForCharacterOffset
	 */
	
	'use strict';
	
	/**
	 * Given any node return the first leaf node without children.
	 *
	 * @param {DOMElement|DOMTextNode} node
	 * @return {DOMElement|DOMTextNode}
	 */
	
	function getLeafNode(node) {
	  while (node && node.firstChild) {
	    node = node.firstChild;
	  }
	  return node;
	}
	
	/**
	 * Get the next sibling within a container. This will walk up the
	 * DOM if a node's siblings have been exhausted.
	 *
	 * @param {DOMElement|DOMTextNode} node
	 * @return {?DOMElement|DOMTextNode}
	 */
	function getSiblingNode(node) {
	  while (node) {
	    if (node.nextSibling) {
	      return node.nextSibling;
	    }
	    node = node.parentNode;
	  }
	}
	
	/**
	 * Get object describing the nodes which contain characters at offset.
	 *
	 * @param {DOMElement|DOMTextNode} root
	 * @param {number} offset
	 * @return {?object}
	 */
	function getNodeForCharacterOffset(root, offset) {
	  var node = getLeafNode(root);
	  var nodeStart = 0;
	  var nodeEnd = 0;
	
	  while (node) {
	    if (node.nodeType === 3) {
	      nodeEnd = nodeStart + node.textContent.length;
	
	      if (nodeStart <= offset && nodeEnd >= offset) {
	        return {
	          node: node,
	          offset: offset - nodeStart
	        };
	      }
	
	      nodeStart = nodeEnd;
	    }
	
	    node = getLeafNode(getSiblingNode(node));
	  }
	}
	
	module.exports = getNodeForCharacterOffset;

/***/ },
/* 797 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule getVendorPrefixedEventName
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(22);
	
	/**
	 * Generate a mapping of standard vendor prefixes using the defined style property and event name.
	 *
	 * @param {string} styleProp
	 * @param {string} eventName
	 * @returns {object}
	 */
	function makePrefixMap(styleProp, eventName) {
	  var prefixes = {};
	
	  prefixes[styleProp.toLowerCase()] = eventName.toLowerCase();
	  prefixes['Webkit' + styleProp] = 'webkit' + eventName;
	  prefixes['Moz' + styleProp] = 'moz' + eventName;
	  prefixes['ms' + styleProp] = 'MS' + eventName;
	  prefixes['O' + styleProp] = 'o' + eventName.toLowerCase();
	
	  return prefixes;
	}
	
	/**
	 * A list of event names to a configurable list of vendor prefixes.
	 */
	var vendorPrefixes = {
	  animationend: makePrefixMap('Animation', 'AnimationEnd'),
	  animationiteration: makePrefixMap('Animation', 'AnimationIteration'),
	  animationstart: makePrefixMap('Animation', 'AnimationStart'),
	  transitionend: makePrefixMap('Transition', 'TransitionEnd')
	};
	
	/**
	 * Event names that have already been detected and prefixed (if applicable).
	 */
	var prefixedEventNames = {};
	
	/**
	 * Element to check for prefixes on.
	 */
	var style = {};
	
	/**
	 * Bootstrap if a DOM exists.
	 */
	if (ExecutionEnvironment.canUseDOM) {
	  style = document.createElement('div').style;
	
	  // On some platforms, in particular some releases of Android 4.x,
	  // the un-prefixed "animation" and "transition" properties are defined on the
	  // style object but the events that fire will still be prefixed, so we need
	  // to check if the un-prefixed events are usable, and if not remove them from the map.
	  if (!('AnimationEvent' in window)) {
	    delete vendorPrefixes.animationend.animation;
	    delete vendorPrefixes.animationiteration.animation;
	    delete vendorPrefixes.animationstart.animation;
	  }
	
	  // Same as above
	  if (!('TransitionEvent' in window)) {
	    delete vendorPrefixes.transitionend.transition;
	  }
	}
	
	/**
	 * Attempts to determine the correct vendor prefixed event name.
	 *
	 * @param {string} eventName
	 * @returns {string}
	 */
	function getVendorPrefixedEventName(eventName) {
	  if (prefixedEventNames[eventName]) {
	    return prefixedEventNames[eventName];
	  } else if (!vendorPrefixes[eventName]) {
	    return eventName;
	  }
	
	  var prefixMap = vendorPrefixes[eventName];
	
	  for (var styleProp in prefixMap) {
	    if (prefixMap.hasOwnProperty(styleProp) && styleProp in style) {
	      return prefixedEventNames[eventName] = prefixMap[styleProp];
	    }
	  }
	
	  return '';
	}
	
	module.exports = getVendorPrefixedEventName;

/***/ },
/* 798 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule onlyChild
	 */
	'use strict';
	
	var _prodInvariant = __webpack_require__(5);
	
	var ReactElement = __webpack_require__(45);
	
	var invariant = __webpack_require__(2);
	
	/**
	 * Returns the first child in a collection of children and verifies that there
	 * is only one child in the collection.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.only
	 *
	 * The current implementation of this function assumes that a single child gets
	 * passed without a wrapper, but the purpose of this helper function is to
	 * abstract away the particular structure of children.
	 *
	 * @param {?object} children Child collection structure.
	 * @return {ReactElement} The first and only `ReactElement` contained in the
	 * structure.
	 */
	function onlyChild(children) {
	  !ReactElement.isValidElement(children) ?  false ? invariant(false, 'onlyChild must be passed a children with exactly one child.') : _prodInvariant('23') : void 0;
	  return children;
	}
	
	module.exports = onlyChild;

/***/ },
/* 799 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule quoteAttributeValueForBrowser
	 */
	
	'use strict';
	
	var escapeTextContentForBrowser = __webpack_require__(142);
	
	/**
	 * Escapes attribute value to prevent scripting attacks.
	 *
	 * @param {*} value Value to escape.
	 * @return {string} An escaped string.
	 */
	function quoteAttributeValueForBrowser(value) {
	  return '"' + escapeTextContentForBrowser(value) + '"';
	}
	
	module.exports = quoteAttributeValueForBrowser;

/***/ },
/* 800 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	* @providesModule renderSubtreeIntoContainer
	*/
	
	'use strict';
	
	var ReactMount = __webpack_require__(323);
	
	module.exports = ReactMount.renderSubtreeIntoContainer;

/***/ },
/* 801 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule update
	 */
	
	/* global hasOwnProperty:true */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(5),
	    _assign = __webpack_require__(6);
	
	var keyOf = __webpack_require__(50);
	var invariant = __webpack_require__(2);
	var hasOwnProperty = {}.hasOwnProperty;
	
	function shallowCopy(x) {
	  if (Array.isArray(x)) {
	    return x.concat();
	  } else if (x && typeof x === 'object') {
	    return _assign(new x.constructor(), x);
	  } else {
	    return x;
	  }
	}
	
	var COMMAND_PUSH = keyOf({ $push: null });
	var COMMAND_UNSHIFT = keyOf({ $unshift: null });
	var COMMAND_SPLICE = keyOf({ $splice: null });
	var COMMAND_SET = keyOf({ $set: null });
	var COMMAND_MERGE = keyOf({ $merge: null });
	var COMMAND_APPLY = keyOf({ $apply: null });
	
	var ALL_COMMANDS_LIST = [COMMAND_PUSH, COMMAND_UNSHIFT, COMMAND_SPLICE, COMMAND_SET, COMMAND_MERGE, COMMAND_APPLY];
	
	var ALL_COMMANDS_SET = {};
	
	ALL_COMMANDS_LIST.forEach(function (command) {
	  ALL_COMMANDS_SET[command] = true;
	});
	
	function invariantArrayCase(value, spec, command) {
	  !Array.isArray(value) ?  false ? invariant(false, 'update(): expected target of %s to be an array; got %s.', command, value) : _prodInvariant('1', command, value) : void 0;
	  var specValue = spec[command];
	  !Array.isArray(specValue) ?  false ? invariant(false, 'update(): expected spec of %s to be an array; got %s. Did you forget to wrap your parameter in an array?', command, specValue) : _prodInvariant('2', command, specValue) : void 0;
	}
	
	/**
	 * Returns a updated shallow copy of an object without mutating the original.
	 * See https://facebook.github.io/react/docs/update.html for details.
	 */
	function update(value, spec) {
	  !(typeof spec === 'object') ?  false ? invariant(false, 'update(): You provided a key path to update() that did not contain one of %s. Did you forget to include {%s: ...}?', ALL_COMMANDS_LIST.join(', '), COMMAND_SET) : _prodInvariant('3', ALL_COMMANDS_LIST.join(', '), COMMAND_SET) : void 0;
	
	  if (hasOwnProperty.call(spec, COMMAND_SET)) {
	    !(Object.keys(spec).length === 1) ?  false ? invariant(false, 'Cannot have more than one key in an object with %s', COMMAND_SET) : _prodInvariant('4', COMMAND_SET) : void 0;
	
	    return spec[COMMAND_SET];
	  }
	
	  var nextValue = shallowCopy(value);
	
	  if (hasOwnProperty.call(spec, COMMAND_MERGE)) {
	    var mergeObj = spec[COMMAND_MERGE];
	    !(mergeObj && typeof mergeObj === 'object') ?  false ? invariant(false, 'update(): %s expects a spec of type \'object\'; got %s', COMMAND_MERGE, mergeObj) : _prodInvariant('5', COMMAND_MERGE, mergeObj) : void 0;
	    !(nextValue && typeof nextValue === 'object') ?  false ? invariant(false, 'update(): %s expects a target of type \'object\'; got %s', COMMAND_MERGE, nextValue) : _prodInvariant('6', COMMAND_MERGE, nextValue) : void 0;
	    _assign(nextValue, spec[COMMAND_MERGE]);
	  }
	
	  if (hasOwnProperty.call(spec, COMMAND_PUSH)) {
	    invariantArrayCase(value, spec, COMMAND_PUSH);
	    spec[COMMAND_PUSH].forEach(function (item) {
	      nextValue.push(item);
	    });
	  }
	
	  if (hasOwnProperty.call(spec, COMMAND_UNSHIFT)) {
	    invariantArrayCase(value, spec, COMMAND_UNSHIFT);
	    spec[COMMAND_UNSHIFT].forEach(function (item) {
	      nextValue.unshift(item);
	    });
	  }
	
	  if (hasOwnProperty.call(spec, COMMAND_SPLICE)) {
	    !Array.isArray(value) ?  false ? invariant(false, 'Expected %s target to be an array; got %s', COMMAND_SPLICE, value) : _prodInvariant('7', COMMAND_SPLICE, value) : void 0;
	    !Array.isArray(spec[COMMAND_SPLICE]) ?  false ? invariant(false, 'update(): expected spec of %s to be an array of arrays; got %s. Did you forget to wrap your parameters in an array?', COMMAND_SPLICE, spec[COMMAND_SPLICE]) : _prodInvariant('8', COMMAND_SPLICE, spec[COMMAND_SPLICE]) : void 0;
	    spec[COMMAND_SPLICE].forEach(function (args) {
	      !Array.isArray(args) ?  false ? invariant(false, 'update(): expected spec of %s to be an array of arrays; got %s. Did you forget to wrap your parameters in an array?', COMMAND_SPLICE, spec[COMMAND_SPLICE]) : _prodInvariant('8', COMMAND_SPLICE, spec[COMMAND_SPLICE]) : void 0;
	      nextValue.splice.apply(nextValue, args);
	    });
	  }
	
	  if (hasOwnProperty.call(spec, COMMAND_APPLY)) {
	    !(typeof spec[COMMAND_APPLY] === 'function') ?  false ? invariant(false, 'update(): expected spec of %s to be a function; got %s.', COMMAND_APPLY, spec[COMMAND_APPLY]) : _prodInvariant('9', COMMAND_APPLY, spec[COMMAND_APPLY]) : void 0;
	    nextValue = spec[COMMAND_APPLY](nextValue);
	  }
	
	  for (var k in spec) {
	    if (!(ALL_COMMANDS_SET.hasOwnProperty(k) && ALL_COMMANDS_SET[k])) {
	      nextValue[k] = update(value[k], spec[k]);
	    }
	  }
	
	  return nextValue;
	}
	
	module.exports = update;

/***/ },
/* 802 */
/***/ function(module, exports) {

	'use strict';
	
	/**
	 * Representation of a single EventEmitter function.
	 *
	 * @param {Function} fn Event handler to be called.
	 * @param {Mixed} context Context for function execution.
	 * @param {Boolean} once Only emit once
	 * @api private
	 */
	function EE(fn, context, once) {
	  this.fn = fn;
	  this.context = context;
	  this.once = once || false;
	}
	
	/**
	 * Minimal EventEmitter interface that is molded against the Node.js
	 * EventEmitter interface.
	 *
	 * @constructor
	 * @api public
	 */
	function EventEmitter() { /* Nothing to set */ }
	
	/**
	 * Holds the assigned EventEmitters by name.
	 *
	 * @type {Object}
	 * @private
	 */
	EventEmitter.prototype._events = undefined;
	
	/**
	 * Return a list of assigned event listeners.
	 *
	 * @param {String} event The events that should be listed.
	 * @returns {Array}
	 * @api public
	 */
	EventEmitter.prototype.listeners = function listeners(event) {
	  if (!this._events || !this._events[event]) return [];
	  if (this._events[event].fn) return [this._events[event].fn];
	
	  for (var i = 0, l = this._events[event].length, ee = new Array(l); i < l; i++) {
	    ee[i] = this._events[event][i].fn;
	  }
	
	  return ee;
	};
	
	/**
	 * Emit an event to all registered event listeners.
	 *
	 * @param {String} event The name of the event.
	 * @returns {Boolean} Indication if we've emitted an event.
	 * @api public
	 */
	EventEmitter.prototype.emit = function emit(event, a1, a2, a3, a4, a5) {
	  if (!this._events || !this._events[event]) return false;
	
	  var listeners = this._events[event]
	    , len = arguments.length
	    , args
	    , i;
	
	  if ('function' === typeof listeners.fn) {
	    if (listeners.once) this.removeListener(event, listeners.fn, true);
	
	    switch (len) {
	      case 1: return listeners.fn.call(listeners.context), true;
	      case 2: return listeners.fn.call(listeners.context, a1), true;
	      case 3: return listeners.fn.call(listeners.context, a1, a2), true;
	      case 4: return listeners.fn.call(listeners.context, a1, a2, a3), true;
	      case 5: return listeners.fn.call(listeners.context, a1, a2, a3, a4), true;
	      case 6: return listeners.fn.call(listeners.context, a1, a2, a3, a4, a5), true;
	    }
	
	    for (i = 1, args = new Array(len -1); i < len; i++) {
	      args[i - 1] = arguments[i];
	    }
	
	    listeners.fn.apply(listeners.context, args);
	  } else {
	    var length = listeners.length
	      , j;
	
	    for (i = 0; i < length; i++) {
	      if (listeners[i].once) this.removeListener(event, listeners[i].fn, true);
	
	      switch (len) {
	        case 1: listeners[i].fn.call(listeners[i].context); break;
	        case 2: listeners[i].fn.call(listeners[i].context, a1); break;
	        case 3: listeners[i].fn.call(listeners[i].context, a1, a2); break;
	        default:
	          if (!args) for (j = 1, args = new Array(len -1); j < len; j++) {
	            args[j - 1] = arguments[j];
	          }
	
	          listeners[i].fn.apply(listeners[i].context, args);
	      }
	    }
	  }
	
	  return true;
	};
	
	/**
	 * Register a new EventListener for the given event.
	 *
	 * @param {String} event Name of the event.
	 * @param {Functon} fn Callback function.
	 * @param {Mixed} context The context of the function.
	 * @api public
	 */
	EventEmitter.prototype.on = function on(event, fn, context) {
	  var listener = new EE(fn, context || this);
	
	  if (!this._events) this._events = {};
	  if (!this._events[event]) this._events[event] = listener;
	  else {
	    if (!this._events[event].fn) this._events[event].push(listener);
	    else this._events[event] = [
	      this._events[event], listener
	    ];
	  }
	
	  return this;
	};
	
	/**
	 * Add an EventListener that's only called once.
	 *
	 * @param {String} event Name of the event.
	 * @param {Function} fn Callback function.
	 * @param {Mixed} context The context of the function.
	 * @api public
	 */
	EventEmitter.prototype.once = function once(event, fn, context) {
	  var listener = new EE(fn, context || this, true);
	
	  if (!this._events) this._events = {};
	  if (!this._events[event]) this._events[event] = listener;
	  else {
	    if (!this._events[event].fn) this._events[event].push(listener);
	    else this._events[event] = [
	      this._events[event], listener
	    ];
	  }
	
	  return this;
	};
	
	/**
	 * Remove event listeners.
	 *
	 * @param {String} event The event we want to remove.
	 * @param {Function} fn The listener that we need to find.
	 * @param {Boolean} once Only remove once listeners.
	 * @api public
	 */
	EventEmitter.prototype.removeListener = function removeListener(event, fn, once) {
	  if (!this._events || !this._events[event]) return this;
	
	  var listeners = this._events[event]
	    , events = [];
	
	  if (fn) {
	    if (listeners.fn && (listeners.fn !== fn || (once && !listeners.once))) {
	      events.push(listeners);
	    }
	    if (!listeners.fn) for (var i = 0, length = listeners.length; i < length; i++) {
	      if (listeners[i].fn !== fn || (once && !listeners[i].once)) {
	        events.push(listeners[i]);
	      }
	    }
	  }
	
	  //
	  // Reset the array, or remove it completely if we have no more listeners.
	  //
	  if (events.length) {
	    this._events[event] = events.length === 1 ? events[0] : events;
	  } else {
	    delete this._events[event];
	  }
	
	  return this;
	};
	
	/**
	 * Remove all listeners or only the listeners for the specified event.
	 *
	 * @param {String} event The event want to remove all listeners for.
	 * @api public
	 */
	EventEmitter.prototype.removeAllListeners = function removeAllListeners(event) {
	  if (!this._events) return this;
	
	  if (event) delete this._events[event];
	  else this._events = {};
	
	  return this;
	};
	
	//
	// Alias methods names because people roll like that.
	//
	EventEmitter.prototype.off = EventEmitter.prototype.removeListener;
	EventEmitter.prototype.addListener = EventEmitter.prototype.on;
	
	//
	// This function doesn't apply anymore.
	//
	EventEmitter.prototype.setMaxListeners = function setMaxListeners() {
	  return this;
	};
	
	//
	// Expose the module.
	//
	EventEmitter.EventEmitter = EventEmitter;
	EventEmitter.EventEmitter2 = EventEmitter;
	EventEmitter.EventEmitter3 = EventEmitter;
	
	//
	// Expose the module.
	//
	module.exports = EventEmitter;


/***/ },
/* 803 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(global, setImmediate) {/*! Native Promise Only
	    v0.7.6-a (c) Kyle Simpson
	    MIT License: http://getify.mit-license.org
	*/
	!function(t,n,e){n[t]=n[t]||e(),"undefined"!=typeof module&&module.exports?module.exports=n[t]:"function"=="function"&&__webpack_require__(850)&&!(__WEBPACK_AMD_DEFINE_RESULT__ = function(){return n[t]}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__))}("Promise","undefined"!=typeof global?global:this,function(){"use strict";function t(t,n){l.add(t,n),h||(h=y(l.drain))}function n(t){var n,e=typeof t;return null==t||"object"!=e&&"function"!=e||(n=t.then),"function"==typeof n?n:!1}function e(){for(var t=0;t<this.chain.length;t++)o(this,1===this.state?this.chain[t].success:this.chain[t].failure,this.chain[t]);this.chain.length=0}function o(t,e,o){var r,i;try{e===!1?o.reject(t.msg):(r=e===!0?t.msg:e.call(void 0,t.msg),r===o.promise?o.reject(TypeError("Promise-chain cycle")):(i=n(r))?i.call(r,o.resolve,o.reject):o.resolve(r))}catch(c){o.reject(c)}}function r(o){var c,u,a=this;if(!a.triggered){a.triggered=!0,a.def&&(a=a.def);try{(c=n(o))?(u=new f(a),c.call(o,function(){r.apply(u,arguments)},function(){i.apply(u,arguments)})):(a.msg=o,a.state=1,a.chain.length>0&&t(e,a))}catch(s){i.call(u||new f(a),s)}}}function i(n){var o=this;o.triggered||(o.triggered=!0,o.def&&(o=o.def),o.msg=n,o.state=2,o.chain.length>0&&t(e,o))}function c(t,n,e,o){for(var r=0;r<n.length;r++)!function(r){t.resolve(n[r]).then(function(t){e(r,t)},o)}(r)}function f(t){this.def=t,this.triggered=!1}function u(t){this.promise=t,this.state=0,this.triggered=!1,this.chain=[],this.msg=void 0}function a(n){if("function"!=typeof n)throw TypeError("Not a function");if(0!==this.__NPO__)throw TypeError("Not a promise");this.__NPO__=1;var o=new u(this);this.then=function(n,r){var i={success:"function"==typeof n?n:!0,failure:"function"==typeof r?r:!1};return i.promise=new this.constructor(function(t,n){if("function"!=typeof t||"function"!=typeof n)throw TypeError("Not a function");i.resolve=t,i.reject=n}),o.chain.push(i),0!==o.state&&t(e,o),i.promise},this["catch"]=function(t){return this.then(void 0,t)};try{n.call(void 0,function(t){r.call(o,t)},function(t){i.call(o,t)})}catch(c){i.call(o,c)}}var s,h,l,p=Object.prototype.toString,y="undefined"!=typeof setImmediate?function(t){return setImmediate(t)}:setTimeout;try{Object.defineProperty({},"x",{}),s=function(t,n,e,o){return Object.defineProperty(t,n,{value:e,writable:!0,configurable:o!==!1})}}catch(d){s=function(t,n,e){return t[n]=e,t}}l=function(){function t(t,n){this.fn=t,this.self=n,this.next=void 0}var n,e,o;return{add:function(r,i){o=new t(r,i),e?e.next=o:n=o,e=o,o=void 0},drain:function(){var t=n;for(n=e=h=void 0;t;)t.fn.call(t.self),t=t.next}}}();var g=s({},"constructor",a,!1);return s(a,"prototype",g,!1),s(g,"__NPO__",0,!1),s(a,"resolve",function(t){var n=this;return t&&"object"==typeof t&&1===t.__NPO__?t:new n(function(n,e){if("function"!=typeof n||"function"!=typeof e)throw TypeError("Not a function");n(t)})}),s(a,"reject",function(t){return new this(function(n,e){if("function"!=typeof n||"function"!=typeof e)throw TypeError("Not a function");e(t)})}),s(a,"all",function(t){var n=this;return"[object Array]"!=p.call(t)?n.reject(TypeError("Not an array")):0===t.length?n.resolve([]):new n(function(e,o){if("function"!=typeof e||"function"!=typeof o)throw TypeError("Not a function");var r=t.length,i=Array(r),f=0;c(n,t,function(t,n){i[t]=n,++f===r&&e(i)},o)})}),s(a,"race",function(t){var n=this;return"[object Array]"!=p.call(t)?n.reject(TypeError("Not an array")):new n(function(e,o){if("function"!=typeof e||"function"!=typeof o)throw TypeError("Not a function");c(n,t,function(t,n){e(n)},o)})}),a});
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(144).setImmediate))

/***/ },
/* 804 */
/***/ function(module, exports) {

	/**
	 * A module of methods that you want to include in all actions.
	 * This module is consumed by `createAction`.
	 */
	module.exports = {
	};


/***/ },
/* 805 */
/***/ function(module, exports, __webpack_require__) {

	var _ = __webpack_require__(25),
	    ListenerMethods = __webpack_require__(339);
	
	/**
	 * A module meant to be consumed as a mixin by a React component. Supplies the methods from
	 * `ListenerMethods` mixin and takes care of teardown of subscriptions.
	 * Note that if you're using the `connect` mixin you don't need this mixin, as connect will
	 * import everything this mixin contains!
	 */
	module.exports = _.extend({
	
	    /**
	     * Cleans up all listener previously registered.
	     */
	    componentWillUnmount: ListenerMethods.stopListeningToAll
	
	}, ListenerMethods);


/***/ },
/* 806 */
/***/ function(module, exports, __webpack_require__) {

	var _ = __webpack_require__(25);
	
	/**
	 * A module of methods for object that you want to be able to listen to.
	 * This module is consumed by `createStore` and `createAction`
	 */
	module.exports = {
	
	    /**
	     * Hook used by the publisher that is invoked before emitting
	     * and before `shouldEmit`. The arguments are the ones that the action
	     * is invoked with. If this function returns something other than
	     * undefined, that will be passed on as arguments for shouldEmit and
	     * emission.
	     */
	    preEmit: function() {},
	
	    /**
	     * Hook used by the publisher after `preEmit` to determine if the
	     * event should be emitted with given arguments. This may be overridden
	     * in your application, default implementation always returns true.
	     *
	     * @returns {Boolean} true if event should be emitted
	     */
	    shouldEmit: function() { return true; },
	
	    /**
	     * Subscribes the given callback for action triggered
	     *
	     * @param {Function} callback The callback to register as event handler
	     * @param {Mixed} [optional] bindContext The context to bind the callback with
	     * @returns {Function} Callback that unsubscribes the registered event handler
	     */
	    listen: function(callback, bindContext) {
	        bindContext = bindContext || this;
	        var eventHandler = function(args) {
	            if (aborted){
	                return;
	            }
	            callback.apply(bindContext, args);
	        }, me = this, aborted = false;
	        this.emitter.addListener(this.eventLabel, eventHandler);
	        return function() {
	            aborted = true;
	            me.emitter.removeListener(me.eventLabel, eventHandler);
	        };
	    },
	
	    /**
	     * Attach handlers to promise that trigger the completed and failed
	     * child publishers, if available.
	     *
	     * @param {Object} The promise to attach to
	     */
	    promise: function(promise) {
	        var me = this;
	
	        var canHandlePromise =
	            this.children.indexOf('completed') >= 0 &&
	            this.children.indexOf('failed') >= 0;
	
	        if (!canHandlePromise){
	            throw new Error('Publisher must have "completed" and "failed" child publishers');
	        }
	
	        promise.then(function(response) {
	            return me.completed(response);
	        }, function(error) {
	            return me.failed(error);
	        });
	    },
	
	    /**
	     * Subscribes the given callback for action triggered, which should
	     * return a promise that in turn is passed to `this.promise`
	     *
	     * @param {Function} callback The callback to register as event handler
	     */
	    listenAndPromise: function(callback, bindContext) {
	        var me = this;
	        bindContext = bindContext || this;
	        this.willCallPromise = (this.willCallPromise || 0) + 1;
	
	        var removeListen = this.listen(function() {
	
	            if (!callback) {
	                throw new Error('Expected a function returning a promise but got ' + callback);
	            }
	
	            var args = arguments,
	                promise = callback.apply(bindContext, args);
	            return me.promise.call(me, promise);
	        }, bindContext);
	
	        return function () {
	          me.willCallPromise--;
	          removeListen.call(me);
	        };
	
	    },
	
	    /**
	     * Publishes an event using `this.emitter` (if `shouldEmit` agrees)
	     */
	    trigger: function() {
	        var args = arguments,
	            pre = this.preEmit.apply(this, args);
	        args = pre === undefined ? args : _.isArguments(pre) ? pre : [].concat(pre);
	        if (this.shouldEmit.apply(this, args)) {
	            this.emitter.emit(this.eventLabel, args);
	        }
	    },
	
	    /**
	     * Tries to publish the event on the next tick
	     */
	    triggerAsync: function(){
	        var args = arguments,me = this;
	        _.nextTick(function() {
	            me.trigger.apply(me, args);
	        });
	    },
	
	    /**
	     * Returns a Promise for the triggered action
	     *
	     * @return {Promise}
	     *   Resolved by completed child action.
	     *   Rejected by failed child action.
	     *   If listenAndPromise'd, then promise associated to this trigger.
	     *   Otherwise, the promise is for next child action completion.
	     */
	    triggerPromise: function(){
	        var me = this;
	        var args = arguments;
	
	        var canHandlePromise =
	            this.children.indexOf('completed') >= 0 &&
	            this.children.indexOf('failed') >= 0;
	
	        var promise = _.createPromise(function(resolve, reject) {
	            // If `listenAndPromise` is listening
	            // patch `promise` w/ context-loaded resolve/reject
	            if (me.willCallPromise) {
	                _.nextTick(function() {
	                    var old_promise_method = me.promise;
	                    me.promise = function (promise) {
	                        promise.then(resolve, reject);
	                        // Back to your regularly schedule programming.
	                        me.promise = old_promise_method;
	                        return me.promise.apply(me, arguments);
	                    };
	                    me.trigger.apply(me, args);
	                });
	                return;
	            }
	
	            if (canHandlePromise) {
	                var removeSuccess = me.completed.listen(function(args) {
	                    removeSuccess();
	                    removeFailed();
	                    resolve(args);
	                });
	
	                var removeFailed = me.failed.listen(function(args) {
	                    removeSuccess();
	                    removeFailed();
	                    reject(args);
	                });
	            }
	
	            me.triggerAsync.apply(me, args);
	
	            if (!canHandlePromise) {
	                resolve();
	            }
	        });
	
	        return promise;
	    }
	};


/***/ },
/* 807 */
/***/ function(module, exports) {

	/**
	 * A module of methods that you want to include in all stores.
	 * This module is consumed by `createStore`.
	 */
	module.exports = {
	};


/***/ },
/* 808 */
/***/ function(module, exports) {

	module.exports = function(store, definition) {
	  for (var name in definition) {
	    if (Object.getOwnPropertyDescriptor && Object.defineProperty) {
	        var propertyDescriptor = Object.getOwnPropertyDescriptor(definition, name);
	
	        if (!propertyDescriptor.value || typeof propertyDescriptor.value !== 'function' || !definition.hasOwnProperty(name)) {
	            continue;
	        }
	
	        store[name] = definition[name].bind(store);
	    } else {
	        var property = definition[name];
	
	        if (typeof property !== 'function' || !definition.hasOwnProperty(name)) {
	            continue;
	        }
	
	        store[name] = property.bind(store);
	    }
	  }
	
	  return store;
	};


/***/ },
/* 809 */
/***/ function(module, exports, __webpack_require__) {

	var Reflux = __webpack_require__(76),
	    _ = __webpack_require__(25);
	
	module.exports = function(listenable,key){
	    return {
	        getInitialState: function(){
	            if (!_.isFunction(listenable.getInitialState)) {
	                return {};
	            } else if (key === undefined) {
	                return listenable.getInitialState();
	            } else {
	                return _.object([key],[listenable.getInitialState()]);
	            }
	        },
	        componentDidMount: function(){
	            _.extend(this,Reflux.ListenerMethods);
	            var me = this, cb = (key === undefined ? this.setState : function(v){me.setState(_.object([key],[v]));});
	            this.listenTo(listenable,cb);
	        },
	        componentWillUnmount: Reflux.ListenerMixin.componentWillUnmount
	    };
	};


/***/ },
/* 810 */
/***/ function(module, exports, __webpack_require__) {

	var Reflux = __webpack_require__(76),
	  _ = __webpack_require__(25);
	
	module.exports = function(listenable, key, filterFunc) {
	    filterFunc = _.isFunction(key) ? key : filterFunc;
	    return {
	        getInitialState: function() {
	            if (!_.isFunction(listenable.getInitialState)) {
	                return {};
	            } else if (_.isFunction(key)) {
	                return filterFunc.call(this, listenable.getInitialState());
	            } else {
	                // Filter initial payload from store.
	                var result = filterFunc.call(this, listenable.getInitialState());
	                if (result) {
	                  return _.object([key], [result]);
	                } else {
	                  return {};
	                }
	            }
	        },
	        componentDidMount: function() {
	            _.extend(this, Reflux.ListenerMethods);
	            var me = this;
	            var cb = function(value) {
	                if (_.isFunction(key)) {
	                    me.setState(filterFunc.call(me, value));
	                } else {
	                    var result = filterFunc.call(me, value);
	                    me.setState(_.object([key], [result]));
	                }
	            };
	
	            this.listenTo(listenable, cb);
	        },
	        componentWillUnmount: Reflux.ListenerMixin.componentWillUnmount
	    };
	};
	


/***/ },
/* 811 */
/***/ function(module, exports, __webpack_require__) {

	var _ = __webpack_require__(25),
	    Reflux = __webpack_require__(76),
	    Keep = __webpack_require__(215),
	    allowed = {preEmit:1,shouldEmit:1};
	
	/**
	 * Creates an action functor object. It is mixed in with functions
	 * from the `PublisherMethods` mixin. `preEmit` and `shouldEmit` may
	 * be overridden in the definition object.
	 *
	 * @param {Object} definition The action object definition
	 */
	var createAction = function(definition) {
	
	    definition = definition || {};
	    if (!_.isObject(definition)){
	        definition = {actionName: definition};
	    }
	
	    for(var a in Reflux.ActionMethods){
	        if (!allowed[a] && Reflux.PublisherMethods[a]) {
	            throw new Error("Cannot override API method " + a +
	                " in Reflux.ActionMethods. Use another method name or override it on Reflux.PublisherMethods instead."
	            );
	        }
	    }
	
	    for(var d in definition){
	        if (!allowed[d] && Reflux.PublisherMethods[d]) {
	            throw new Error("Cannot override API method " + d +
	                " in action creation. Use another method name or override it on Reflux.PublisherMethods instead."
	            );
	        }
	    }
	
	    definition.children = definition.children || [];
	    if (definition.asyncResult){
	        definition.children = definition.children.concat(["completed","failed"]);
	    }
	
	    var i = 0, childActions = {};
	    for (; i < definition.children.length; i++) {
	        var name = definition.children[i];
	        childActions[name] = createAction(name);
	    }
	
	    var context = _.extend({
	        eventLabel: "action",
	        emitter: new _.EventEmitter(),
	        _isAction: true
	    }, Reflux.PublisherMethods, Reflux.ActionMethods, definition);
	
	    var functor = function() {
	        return functor[functor.sync?"trigger":"triggerPromise"].apply(functor, arguments);
	    };
	
	    _.extend(functor,childActions,context);
	
	    Keep.createdActions.push(functor);
	
	    return functor;
	
	};
	
	module.exports = createAction;


/***/ },
/* 812 */
/***/ function(module, exports, __webpack_require__) {

	var Reflux = __webpack_require__(76);
	
	
	/**
	 * A mixin factory for a React component. Meant as a more convenient way of using the `ListenerMixin`,
	 * without having to manually set listeners in the `componentDidMount` method.
	 *
	 * @param {Action|Store} listenable An Action or Store that should be
	 *  listened to.
	 * @param {Function|String} callback The callback to register as event handler
	 * @param {Function|String} defaultCallback The callback to register as default handler
	 * @returns {Object} An object to be used as a mixin, which sets up the listener for the given listenable.
	 */
	module.exports = function(listenable,callback,initial){
	    return {
	        /**
	         * Set up the mixin before the initial rendering occurs. Import methods from `ListenerMethods`
	         * and then make the call to `listenTo` with the arguments provided to the factory function
	         */
	        componentDidMount: function() {
	            for(var m in Reflux.ListenerMethods){
	                if (this[m] !== Reflux.ListenerMethods[m]){
	                    if (this[m]){
	                        throw "Can't have other property '"+m+"' when using Reflux.listenTo!";
	                    }
	                    this[m] = Reflux.ListenerMethods[m];
	                }
	            }
	            this.listenTo(listenable,callback,initial);
	        },
	        /**
	         * Cleans up all listener previously registered.
	         */
	        componentWillUnmount: Reflux.ListenerMethods.stopListeningToAll
	    };
	};


/***/ },
/* 813 */
/***/ function(module, exports, __webpack_require__) {

	var Reflux = __webpack_require__(76);
	
	/**
	 * A mixin factory for a React component. Meant as a more convenient way of using the `listenerMixin`,
	 * without having to manually set listeners in the `componentDidMount` method. This version is used
	 * to automatically set up a `listenToMany` call.
	 *
	 * @param {Object} listenables An object of listenables
	 * @returns {Object} An object to be used as a mixin, which sets up the listeners for the given listenables.
	 */
	module.exports = function(listenables){
	    return {
	        /**
	         * Set up the mixin before the initial rendering occurs. Import methods from `ListenerMethods`
	         * and then make the call to `listenTo` with the arguments provided to the factory function
	         */
	        componentDidMount: function() {
	            for(var m in Reflux.ListenerMethods){
	                if (this[m] !== Reflux.ListenerMethods[m]){
	                    if (this[m]){
	                        throw "Can't have other property '"+m+"' when using Reflux.listenToMany!";
	                    }
	                    this[m] = Reflux.ListenerMethods[m];
	                }
	            }
	            this.listenToMany(listenables);
	        },
	        /**
	         * Cleans up all listener previously registered.
	         */
	        componentWillUnmount: Reflux.ListenerMethods.stopListeningToAll
	    };
	};


/***/ },
/* 814 */
/***/ function(module, exports, __webpack_require__) {

	var _ = __webpack_require__(25);
	
	module.exports = function mix(def) {
	    var composed = {
	        init: [],
	        preEmit: [],
	        shouldEmit: []
	    };
	
	    var updated = (function mixDef(mixin) {
	        var mixed = {};
	        if (mixin.mixins) {
	            mixin.mixins.forEach(function (subMixin) {
	                _.extend(mixed, mixDef(subMixin));
	            });
	        }
	        _.extend(mixed, mixin);
	        Object.keys(composed).forEach(function (composable) {
	            if (mixin.hasOwnProperty(composable)) {
	                composed[composable].push(mixin[composable]);
	            }
	        });
	        return mixed;
	    }(def));
	
	    if (composed.init.length > 1) {
	        updated.init = function () {
	            var args = arguments;
	            composed.init.forEach(function (init) {
	                init.apply(this, args);
	            }, this);
	        };
	    }
	    if (composed.preEmit.length > 1) {
	        updated.preEmit = function () {
	            return composed.preEmit.reduce(function (args, preEmit) {
	                var newValue = preEmit.apply(this, args);
	                return newValue === undefined ? args : [newValue];
	            }.bind(this), arguments);
	        };
	    }
	    if (composed.shouldEmit.length > 1) {
	        updated.shouldEmit = function () {
	            var args = arguments;
	            return !composed.shouldEmit.some(function (shouldEmit) {
	                return !shouldEmit.apply(this, args);
	            }, this);
	        };
	    }
	    Object.keys(composed).forEach(function (composable) {
	        if (composed[composable].length === 1) {
	            updated[composable] = composed[composable][0];
	        }
	    });
	
	    return updated;
	};


/***/ },
/* 815 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global, process) {/**
	 * Copyright (c) 2014, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * https://raw.github.com/facebook/regenerator/master/LICENSE file. An
	 * additional grant of patent rights can be found in the PATENTS file in
	 * the same directory.
	 */
	
	!(function(global) {
	  "use strict";
	
	  var hasOwn = Object.prototype.hasOwnProperty;
	  var undefined; // More compressible than void 0.
	  var $Symbol = typeof Symbol === "function" ? Symbol : {};
	  var iteratorSymbol = $Symbol.iterator || "@@iterator";
	  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";
	
	  var inModule = typeof module === "object";
	  var runtime = global.regeneratorRuntime;
	  if (runtime) {
	    if (inModule) {
	      // If regeneratorRuntime is defined globally and we're in a module,
	      // make the exports object identical to regeneratorRuntime.
	      module.exports = runtime;
	    }
	    // Don't bother evaluating the rest of this file if the runtime was
	    // already defined globally.
	    return;
	  }
	
	  // Define the runtime globally (as expected by generated code) as either
	  // module.exports (if we're in a module) or a new, empty object.
	  runtime = global.regeneratorRuntime = inModule ? module.exports : {};
	
	  function wrap(innerFn, outerFn, self, tryLocsList) {
	    // If outerFn provided, then outerFn.prototype instanceof Generator.
	    var generator = Object.create((outerFn || Generator).prototype);
	    var context = new Context(tryLocsList || []);
	
	    // The ._invoke method unifies the implementations of the .next,
	    // .throw, and .return methods.
	    generator._invoke = makeInvokeMethod(innerFn, self, context);
	
	    return generator;
	  }
	  runtime.wrap = wrap;
	
	  // Try/catch helper to minimize deoptimizations. Returns a completion
	  // record like context.tryEntries[i].completion. This interface could
	  // have been (and was previously) designed to take a closure to be
	  // invoked without arguments, but in all the cases we care about we
	  // already have an existing method we want to call, so there's no need
	  // to create a new function object. We can even get away with assuming
	  // the method takes exactly one argument, since that happens to be true
	  // in every case, so we don't have to touch the arguments object. The
	  // only additional allocation required is the completion record, which
	  // has a stable shape and so hopefully should be cheap to allocate.
	  function tryCatch(fn, obj, arg) {
	    try {
	      return { type: "normal", arg: fn.call(obj, arg) };
	    } catch (err) {
	      return { type: "throw", arg: err };
	    }
	  }
	
	  var GenStateSuspendedStart = "suspendedStart";
	  var GenStateSuspendedYield = "suspendedYield";
	  var GenStateExecuting = "executing";
	  var GenStateCompleted = "completed";
	
	  // Returning this object from the innerFn has the same effect as
	  // breaking out of the dispatch switch statement.
	  var ContinueSentinel = {};
	
	  // Dummy constructor functions that we use as the .constructor and
	  // .constructor.prototype properties for functions that return Generator
	  // objects. For full spec compliance, you may wish to configure your
	  // minifier not to mangle the names of these two functions.
	  function Generator() {}
	  function GeneratorFunction() {}
	  function GeneratorFunctionPrototype() {}
	
	  var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype;
	  GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
	  GeneratorFunctionPrototype.constructor = GeneratorFunction;
	  GeneratorFunctionPrototype[toStringTagSymbol] = GeneratorFunction.displayName = "GeneratorFunction";
	
	  // Helper for defining the .next, .throw, and .return methods of the
	  // Iterator interface in terms of a single ._invoke method.
	  function defineIteratorMethods(prototype) {
	    ["next", "throw", "return"].forEach(function(method) {
	      prototype[method] = function(arg) {
	        return this._invoke(method, arg);
	      };
	    });
	  }
	
	  runtime.isGeneratorFunction = function(genFun) {
	    var ctor = typeof genFun === "function" && genFun.constructor;
	    return ctor
	      ? ctor === GeneratorFunction ||
	        // For the native GeneratorFunction constructor, the best we can
	        // do is to check its .name property.
	        (ctor.displayName || ctor.name) === "GeneratorFunction"
	      : false;
	  };
	
	  runtime.mark = function(genFun) {
	    if (Object.setPrototypeOf) {
	      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
	    } else {
	      genFun.__proto__ = GeneratorFunctionPrototype;
	      if (!(toStringTagSymbol in genFun)) {
	        genFun[toStringTagSymbol] = "GeneratorFunction";
	      }
	    }
	    genFun.prototype = Object.create(Gp);
	    return genFun;
	  };
	
	  // Within the body of any async function, `await x` is transformed to
	  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
	  // `value instanceof AwaitArgument` to determine if the yielded value is
	  // meant to be awaited. Some may consider the name of this method too
	  // cutesy, but they are curmudgeons.
	  runtime.awrap = function(arg) {
	    return new AwaitArgument(arg);
	  };
	
	  function AwaitArgument(arg) {
	    this.arg = arg;
	  }
	
	  function AsyncIterator(generator) {
	    function invoke(method, arg, resolve, reject) {
	      var record = tryCatch(generator[method], generator, arg);
	      if (record.type === "throw") {
	        reject(record.arg);
	      } else {
	        var result = record.arg;
	        var value = result.value;
	        if (value instanceof AwaitArgument) {
	          return Promise.resolve(value.arg).then(function(value) {
	            invoke("next", value, resolve, reject);
	          }, function(err) {
	            invoke("throw", err, resolve, reject);
	          });
	        }
	
	        return Promise.resolve(value).then(function(unwrapped) {
	          // When a yielded Promise is resolved, its final value becomes
	          // the .value of the Promise<{value,done}> result for the
	          // current iteration. If the Promise is rejected, however, the
	          // result for this iteration will be rejected with the same
	          // reason. Note that rejections of yielded Promises are not
	          // thrown back into the generator function, as is the case
	          // when an awaited Promise is rejected. This difference in
	          // behavior between yield and await is important, because it
	          // allows the consumer to decide what to do with the yielded
	          // rejection (swallow it and continue, manually .throw it back
	          // into the generator, abandon iteration, whatever). With
	          // await, by contrast, there is no opportunity to examine the
	          // rejection reason outside the generator function, so the
	          // only option is to throw it from the await expression, and
	          // let the generator function handle the exception.
	          result.value = unwrapped;
	          resolve(result);
	        }, reject);
	      }
	    }
	
	    if (typeof process === "object" && process.domain) {
	      invoke = process.domain.bind(invoke);
	    }
	
	    var previousPromise;
	
	    function enqueue(method, arg) {
	      function callInvokeWithMethodAndArg() {
	        return new Promise(function(resolve, reject) {
	          invoke(method, arg, resolve, reject);
	        });
	      }
	
	      return previousPromise =
	        // If enqueue has been called before, then we want to wait until
	        // all previous Promises have been resolved before calling invoke,
	        // so that results are always delivered in the correct order. If
	        // enqueue has not been called before, then it is important to
	        // call invoke immediately, without waiting on a callback to fire,
	        // so that the async generator function has the opportunity to do
	        // any necessary setup in a predictable way. This predictability
	        // is why the Promise constructor synchronously invokes its
	        // executor callback, and why async functions synchronously
	        // execute code before the first await. Since we implement simple
	        // async functions in terms of async generators, it is especially
	        // important to get this right, even though it requires care.
	        previousPromise ? previousPromise.then(
	          callInvokeWithMethodAndArg,
	          // Avoid propagating failures to Promises returned by later
	          // invocations of the iterator.
	          callInvokeWithMethodAndArg
	        ) : callInvokeWithMethodAndArg();
	    }
	
	    // Define the unified helper method that is used to implement .next,
	    // .throw, and .return (see defineIteratorMethods).
	    this._invoke = enqueue;
	  }
	
	  defineIteratorMethods(AsyncIterator.prototype);
	
	  // Note that simple async functions are implemented on top of
	  // AsyncIterator objects; they just return a Promise for the value of
	  // the final result produced by the iterator.
	  runtime.async = function(innerFn, outerFn, self, tryLocsList) {
	    var iter = new AsyncIterator(
	      wrap(innerFn, outerFn, self, tryLocsList)
	    );
	
	    return runtime.isGeneratorFunction(outerFn)
	      ? iter // If outerFn is a generator, return the full iterator.
	      : iter.next().then(function(result) {
	          return result.done ? result.value : iter.next();
	        });
	  };
	
	  function makeInvokeMethod(innerFn, self, context) {
	    var state = GenStateSuspendedStart;
	
	    return function invoke(method, arg) {
	      if (state === GenStateExecuting) {
	        throw new Error("Generator is already running");
	      }
	
	      if (state === GenStateCompleted) {
	        if (method === "throw") {
	          throw arg;
	        }
	
	        // Be forgiving, per 25.3.3.3.3 of the spec:
	        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
	        return doneResult();
	      }
	
	      while (true) {
	        var delegate = context.delegate;
	        if (delegate) {
	          if (method === "return" ||
	              (method === "throw" && delegate.iterator[method] === undefined)) {
	            // A return or throw (when the delegate iterator has no throw
	            // method) always terminates the yield* loop.
	            context.delegate = null;
	
	            // If the delegate iterator has a return method, give it a
	            // chance to clean up.
	            var returnMethod = delegate.iterator["return"];
	            if (returnMethod) {
	              var record = tryCatch(returnMethod, delegate.iterator, arg);
	              if (record.type === "throw") {
	                // If the return method threw an exception, let that
	                // exception prevail over the original return or throw.
	                method = "throw";
	                arg = record.arg;
	                continue;
	              }
	            }
	
	            if (method === "return") {
	              // Continue with the outer return, now that the delegate
	              // iterator has been terminated.
	              continue;
	            }
	          }
	
	          var record = tryCatch(
	            delegate.iterator[method],
	            delegate.iterator,
	            arg
	          );
	
	          if (record.type === "throw") {
	            context.delegate = null;
	
	            // Like returning generator.throw(uncaught), but without the
	            // overhead of an extra function call.
	            method = "throw";
	            arg = record.arg;
	            continue;
	          }
	
	          // Delegate generator ran and handled its own exceptions so
	          // regardless of what the method was, we continue as if it is
	          // "next" with an undefined arg.
	          method = "next";
	          arg = undefined;
	
	          var info = record.arg;
	          if (info.done) {
	            context[delegate.resultName] = info.value;
	            context.next = delegate.nextLoc;
	          } else {
	            state = GenStateSuspendedYield;
	            return info;
	          }
	
	          context.delegate = null;
	        }
	
	        if (method === "next") {
	          // Setting context._sent for legacy support of Babel's
	          // function.sent implementation.
	          context.sent = context._sent = arg;
	
	        } else if (method === "throw") {
	          if (state === GenStateSuspendedStart) {
	            state = GenStateCompleted;
	            throw arg;
	          }
	
	          if (context.dispatchException(arg)) {
	            // If the dispatched exception was caught by a catch block,
	            // then let that catch block handle the exception normally.
	            method = "next";
	            arg = undefined;
	          }
	
	        } else if (method === "return") {
	          context.abrupt("return", arg);
	        }
	
	        state = GenStateExecuting;
	
	        var record = tryCatch(innerFn, self, context);
	        if (record.type === "normal") {
	          // If an exception is thrown from innerFn, we leave state ===
	          // GenStateExecuting and loop back for another invocation.
	          state = context.done
	            ? GenStateCompleted
	            : GenStateSuspendedYield;
	
	          var info = {
	            value: record.arg,
	            done: context.done
	          };
	
	          if (record.arg === ContinueSentinel) {
	            if (context.delegate && method === "next") {
	              // Deliberately forget the last sent value so that we don't
	              // accidentally pass it on to the delegate.
	              arg = undefined;
	            }
	          } else {
	            return info;
	          }
	
	        } else if (record.type === "throw") {
	          state = GenStateCompleted;
	          // Dispatch the exception by looping back around to the
	          // context.dispatchException(arg) call above.
	          method = "throw";
	          arg = record.arg;
	        }
	      }
	    };
	  }
	
	  // Define Generator.prototype.{next,throw,return} in terms of the
	  // unified ._invoke helper method.
	  defineIteratorMethods(Gp);
	
	  Gp[iteratorSymbol] = function() {
	    return this;
	  };
	
	  Gp[toStringTagSymbol] = "Generator";
	
	  Gp.toString = function() {
	    return "[object Generator]";
	  };
	
	  function pushTryEntry(locs) {
	    var entry = { tryLoc: locs[0] };
	
	    if (1 in locs) {
	      entry.catchLoc = locs[1];
	    }
	
	    if (2 in locs) {
	      entry.finallyLoc = locs[2];
	      entry.afterLoc = locs[3];
	    }
	
	    this.tryEntries.push(entry);
	  }
	
	  function resetTryEntry(entry) {
	    var record = entry.completion || {};
	    record.type = "normal";
	    delete record.arg;
	    entry.completion = record;
	  }
	
	  function Context(tryLocsList) {
	    // The root entry object (effectively a try statement without a catch
	    // or a finally block) gives us a place to store values thrown from
	    // locations where there is no enclosing try statement.
	    this.tryEntries = [{ tryLoc: "root" }];
	    tryLocsList.forEach(pushTryEntry, this);
	    this.reset(true);
	  }
	
	  runtime.keys = function(object) {
	    var keys = [];
	    for (var key in object) {
	      keys.push(key);
	    }
	    keys.reverse();
	
	    // Rather than returning an object with a next method, we keep
	    // things simple and return the next function itself.
	    return function next() {
	      while (keys.length) {
	        var key = keys.pop();
	        if (key in object) {
	          next.value = key;
	          next.done = false;
	          return next;
	        }
	      }
	
	      // To avoid creating an additional object, we just hang the .value
	      // and .done properties off the next function object itself. This
	      // also ensures that the minifier will not anonymize the function.
	      next.done = true;
	      return next;
	    };
	  };
	
	  function values(iterable) {
	    if (iterable) {
	      var iteratorMethod = iterable[iteratorSymbol];
	      if (iteratorMethod) {
	        return iteratorMethod.call(iterable);
	      }
	
	      if (typeof iterable.next === "function") {
	        return iterable;
	      }
	
	      if (!isNaN(iterable.length)) {
	        var i = -1, next = function next() {
	          while (++i < iterable.length) {
	            if (hasOwn.call(iterable, i)) {
	              next.value = iterable[i];
	              next.done = false;
	              return next;
	            }
	          }
	
	          next.value = undefined;
	          next.done = true;
	
	          return next;
	        };
	
	        return next.next = next;
	      }
	    }
	
	    // Return an iterator with no values.
	    return { next: doneResult };
	  }
	  runtime.values = values;
	
	  function doneResult() {
	    return { value: undefined, done: true };
	  }
	
	  Context.prototype = {
	    constructor: Context,
	
	    reset: function(skipTempReset) {
	      this.prev = 0;
	      this.next = 0;
	      // Resetting context._sent for legacy support of Babel's
	      // function.sent implementation.
	      this.sent = this._sent = undefined;
	      this.done = false;
	      this.delegate = null;
	
	      this.tryEntries.forEach(resetTryEntry);
	
	      if (!skipTempReset) {
	        for (var name in this) {
	          // Not sure about the optimal order of these conditions:
	          if (name.charAt(0) === "t" &&
	              hasOwn.call(this, name) &&
	              !isNaN(+name.slice(1))) {
	            this[name] = undefined;
	          }
	        }
	      }
	    },
	
	    stop: function() {
	      this.done = true;
	
	      var rootEntry = this.tryEntries[0];
	      var rootRecord = rootEntry.completion;
	      if (rootRecord.type === "throw") {
	        throw rootRecord.arg;
	      }
	
	      return this.rval;
	    },
	
	    dispatchException: function(exception) {
	      if (this.done) {
	        throw exception;
	      }
	
	      var context = this;
	      function handle(loc, caught) {
	        record.type = "throw";
	        record.arg = exception;
	        context.next = loc;
	        return !!caught;
	      }
	
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        var record = entry.completion;
	
	        if (entry.tryLoc === "root") {
	          // Exception thrown outside of any try block that could handle
	          // it, so set the completion value of the entire function to
	          // throw the exception.
	          return handle("end");
	        }
	
	        if (entry.tryLoc <= this.prev) {
	          var hasCatch = hasOwn.call(entry, "catchLoc");
	          var hasFinally = hasOwn.call(entry, "finallyLoc");
	
	          if (hasCatch && hasFinally) {
	            if (this.prev < entry.catchLoc) {
	              return handle(entry.catchLoc, true);
	            } else if (this.prev < entry.finallyLoc) {
	              return handle(entry.finallyLoc);
	            }
	
	          } else if (hasCatch) {
	            if (this.prev < entry.catchLoc) {
	              return handle(entry.catchLoc, true);
	            }
	
	          } else if (hasFinally) {
	            if (this.prev < entry.finallyLoc) {
	              return handle(entry.finallyLoc);
	            }
	
	          } else {
	            throw new Error("try statement without catch or finally");
	          }
	        }
	      }
	    },
	
	    abrupt: function(type, arg) {
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        if (entry.tryLoc <= this.prev &&
	            hasOwn.call(entry, "finallyLoc") &&
	            this.prev < entry.finallyLoc) {
	          var finallyEntry = entry;
	          break;
	        }
	      }
	
	      if (finallyEntry &&
	          (type === "break" ||
	           type === "continue") &&
	          finallyEntry.tryLoc <= arg &&
	          arg <= finallyEntry.finallyLoc) {
	        // Ignore the finally entry if control is not jumping to a
	        // location outside the try/catch block.
	        finallyEntry = null;
	      }
	
	      var record = finallyEntry ? finallyEntry.completion : {};
	      record.type = type;
	      record.arg = arg;
	
	      if (finallyEntry) {
	        this.next = finallyEntry.finallyLoc;
	      } else {
	        this.complete(record);
	      }
	
	      return ContinueSentinel;
	    },
	
	    complete: function(record, afterLoc) {
	      if (record.type === "throw") {
	        throw record.arg;
	      }
	
	      if (record.type === "break" ||
	          record.type === "continue") {
	        this.next = record.arg;
	      } else if (record.type === "return") {
	        this.rval = record.arg;
	        this.next = "end";
	      } else if (record.type === "normal" && afterLoc) {
	        this.next = afterLoc;
	      }
	    },
	
	    finish: function(finallyLoc) {
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        if (entry.finallyLoc === finallyLoc) {
	          this.complete(entry.completion, entry.afterLoc);
	          resetTryEntry(entry);
	          return ContinueSentinel;
	        }
	      }
	    },
	
	    "catch": function(tryLoc) {
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        if (entry.tryLoc === tryLoc) {
	          var record = entry.completion;
	          if (record.type === "throw") {
	            var thrown = record.arg;
	            resetTryEntry(entry);
	          }
	          return thrown;
	        }
	      }
	
	      // The context.catch method must only be called with a location
	      // argument that corresponds to a known catch block.
	      throw new Error("illegal catch attempt");
	    },
	
	    delegateYield: function(iterable, resultName, nextLoc) {
	      this.delegate = {
	        iterator: values(iterable),
	        resultName: resultName,
	        nextLoc: nextLoc
	      };
	
	      return ContinueSentinel;
	    }
	  };
	})(
	  // Among the various tricks for obtaining a reference to the global
	  // object, this seems to be the most reliable technique that does not
	  // use indirect eval (which violates Content Security Policy).
	  typeof global === "object" ? global :
	  typeof window === "object" ? window :
	  typeof self === "object" ? self : this
	);
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(292)))

/***/ },
/* 816 */
/***/ function(module, exports) {

	/*
		MIT License http://www.opensource.org/licenses/mit-license.php
		Author Tobias Koppers @sokra
	*/
	module.exports = function(src) {
		if (typeof execScript === "function")
			execScript(src);
		else
			eval.call(null, src);
	}

/***/ },
/* 817 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(816)(__webpack_require__(680))

/***/ },
/* 818 */
/***/ function(module, exports) {

	'use strict';
	module.exports = function (str) {
		return encodeURIComponent(str).replace(/[!'()*]/g, function (c) {
			return '%' + c.charCodeAt(0).toString(16).toUpperCase();
		});
	};


/***/ },
/* 819 */
/***/ function(module, exports) {

	var camel2hyphen = function (str) {
	  return str
	          .replace(/[A-Z]/g, function (match) {
	            return '-' + match.toLowerCase();
	          })
	          .toLowerCase();
	};
	
	module.exports = camel2hyphen;

/***/ },
/* 820 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(535);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(343)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../node_modules/css-loader/index.js!../../node_modules/autoprefixer-loader/index.js!../../node_modules/sass-loader/index.js!./base.scss", function() {
				var newContent = require("!!../../node_modules/css-loader/index.js!../../node_modules/autoprefixer-loader/index.js!../../node_modules/sass-loader/index.js!./base.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 821 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(536);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(343)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../node_modules/css-loader/index.js!../../node_modules/autoprefixer-loader/index.js!../../node_modules/sass-loader/index.js!./main.scss", function() {
				var newContent = require("!!../../node_modules/css-loader/index.js!../../node_modules/autoprefixer-loader/index.js!../../node_modules/sass-loader/index.js!./main.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 822 */
/***/ function(module, exports) {

	
	exports = module.exports = trim;
	
	function trim(str){
	  return str.replace(/^\s*|\s*$/g, '');
	}
	
	exports.left = function(str){
	  return str.replace(/^\s*/, '');
	};
	
	exports.right = function(str){
	  return str.replace(/\s*$/, '');
	};


/***/ },
/* 823 */
/***/ function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiIHN0YW5kYWxvbmU9Im5vIj8+Cjxzdmcgd2lkdGg9IjE3cHgiIGhlaWdodD0iMjhweCIgdmlld0JveD0iMCAwIDE3IDI4IiB2ZXJzaW9uPSIxLjEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiPgogICAgPCEtLSBHZW5lcmF0b3I6IHNrZXRjaHRvb2wgMy43ICgyODE2OSkgLSBodHRwOi8vd3d3LmJvaGVtaWFuY29kaW5nLmNvbS9za2V0Y2ggLS0+CiAgICA8dGl0bGU+Q0M5QTdFMUEtMkM2RC00MDhFLUFCQUUtNjVGQTI1Mjg2RDk0PC90aXRsZT4KICAgIDxkZXNjPkNyZWF0ZWQgd2l0aCBza2V0Y2h0b29sLjwvZGVzYz4KICAgIDxkZWZzPjwvZGVmcz4KICAgIDxnIGlkPSJQYWdlLTEiIHN0cm9rZT0ibm9uZSIgc3Ryb2tlLXdpZHRoPSIxIiBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPgogICAgICAgIDxnIGlkPSJCdXR0b25zIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtMjk1LjAwMDAwMCwgLTEyNC4wMDAwMDApIiBmaWxsPSIjRkZGRkZGIj4KICAgICAgICAgICAgPGcgaWQ9IkNhcm91c2VsTGVmdEFycm93IiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgzMDkuMTQyMTM2LCAxMzguMTQyMTM2KSBzY2FsZSgtMSwgMSkgcm90YXRlKC0zMTUuMDAwMDAwKSB0cmFuc2xhdGUoLTMwOS4xNDIxMzYsIC0xMzguMTQyMTM2KSB0cmFuc2xhdGUoMjk5LjE0MjEzNiwgMTI4LjE0MjEzNikiPgogICAgICAgICAgICAgICAgPHJlY3QgaWQ9IlJlY3RhbmdsZS0yMjMwIiB4PSIyLjI3MzczNjc1ZS0xMyIgeT0iMS4xMzY4NjgzOGUtMTMiIHdpZHRoPSIxOS41MjI2MzQ0IiBoZWlnaHQ9IjMuNDg3NjkwNTMiPjwvcmVjdD4KICAgICAgICAgICAgICAgIDxwb2x5Z29uIGlkPSJSZWN0YW5nbGUtMjIzMCIgcG9pbnRzPSIxNi40NjgzMzg1IDE5LjM4NjYwMjEgMTYuNDY4MzM4NSAwLjU1MzA3MzIzNSAxOS45NTYwMjkgMC41NTMwNzMyMzUgMTkuOTU2MDI5IDE5LjM4NjYwMjEiPjwvcG9seWdvbj4KICAgICAgICAgICAgPC9nPgogICAgICAgIDwvZz4KICAgIDwvZz4KPC9zdmc+"

/***/ },
/* 824 */
/***/ function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiIHN0YW5kYWxvbmU9Im5vIj8+Cjxzdmcgd2lkdGg9IjE3cHgiIGhlaWdodD0iMjhweCIgdmlld0JveD0iMCAwIDE3IDI4IiB2ZXJzaW9uPSIxLjEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiPgogICAgPCEtLSBHZW5lcmF0b3I6IHNrZXRjaHRvb2wgMy43ICgyODE2OSkgLSBodHRwOi8vd3d3LmJvaGVtaWFuY29kaW5nLmNvbS9za2V0Y2ggLS0+CiAgICA8dGl0bGU+Q0Y1RTZFRTItQjcxRC00OTgxLUFFQjctM0RENzk3QTdCQ0E0PC90aXRsZT4KICAgIDxkZXNjPkNyZWF0ZWQgd2l0aCBza2V0Y2h0b29sLjwvZGVzYz4KICAgIDxkZWZzPjwvZGVmcz4KICAgIDxnIGlkPSJQYWdlLTEiIHN0cm9rZT0ibm9uZSIgc3Ryb2tlLXdpZHRoPSIxIiBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPgogICAgICAgIDxnIGlkPSJCdXR0b25zIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtMzkxLjAwMDAwMCwgLTEyNC4wMDAwMDApIiBmaWxsPSIjRkZGRkZGIj4KICAgICAgICAgICAgPGcgaWQ9IkNhcm91c2VsUmlnaHRBcnJvdyIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMzk0LjE0MjEzNiwgMTM4LjE0MjEzNikgcm90YXRlKC0zMTUuMDAwMDAwKSB0cmFuc2xhdGUoLTM5NC4xNDIxMzYsIC0xMzguMTQyMTM2KSB0cmFuc2xhdGUoMzg0LjE0MjEzNiwgMTI4LjE0MjEzNikiPgogICAgICAgICAgICAgICAgPHJlY3QgaWQ9IlJlY3RhbmdsZS0yMjMwIiB4PSItMi4yNzM3MzY3NWUtMTMiIHk9Ii0xLjEzNjg2ODM4ZS0xMyIgd2lkdGg9IjE5LjUyMjYzNDQiIGhlaWdodD0iMy40ODc2OTA1MyI+PC9yZWN0PgogICAgICAgICAgICAgICAgPHBvbHlnb24gaWQ9IlJlY3RhbmdsZS0yMjMwIiBwb2ludHM9IjE2LjQ2ODMzODUgMTkuMzg2NjAyMSAxNi40NjgzMzg1IDAuNTUzMDczMjM1IDE5Ljk1NjAyOSAwLjU1MzA3MzIzNSAxOS45NTYwMjkgMTkuMzg2NjAyMSI+PC9wb2x5Z29uPgogICAgICAgICAgICA8L2c+CiAgICAgICAgPC9nPgogICAgPC9nPgo8L3N2Zz4K"

/***/ },
/* 825 */
/***/ function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiIHN0YW5kYWxvbmU9Im5vIj8+Cjxzdmcgd2lkdGg9IjE0cHgiIGhlaWdodD0iMTJweCIgdmlld0JveD0iMCAwIDE0IDEyIiB2ZXJzaW9uPSIxLjEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiPgogICAgPCEtLSBHZW5lcmF0b3I6IHNrZXRjaHRvb2wgMy43ICgyODE2OSkgLSBodHRwOi8vd3d3LmJvaGVtaWFuY29kaW5nLmNvbS9za2V0Y2ggLS0+CiAgICA8dGl0bGU+QzczRjQxRUQtRDQ0Qy00MzhCLTk0QjAtNzBFQ0IxMERDREZBPC90aXRsZT4KICAgIDxkZXNjPkNyZWF0ZWQgd2l0aCBza2V0Y2h0b29sLjwvZGVzYz4KICAgIDxkZWZzPjwvZGVmcz4KICAgIDxnIGlkPSJQYWdlLTEiIHN0cm9rZT0ibm9uZSIgc3Ryb2tlLXdpZHRoPSIxIiBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPgogICAgICAgIDxnIGlkPSJCdXR0b25zIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtMTE0LjAwMDAwMCwgLTc0MS4wMDAwMDApIiBmaWxsPSIjMDA3Q0IwIj4KICAgICAgICAgICAgPGcgaWQ9IkNvbW1lbnRzSWNvbiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMTE0LjAwMDAwMCwgNzQxLjAwMDAwMCkiPgogICAgICAgICAgICAgICAgPHBvbHlnb24gaWQ9IkZpbGwtMSIgcG9pbnRzPSIxMC4wOTAyNDgxIDggMTEgMTIgNiA5LjIzMzk1NzM4Ij48L3BvbHlnb24+CiAgICAgICAgICAgICAgICA8cG9seWdvbiBpZD0iRmlsbC0yIiBwb2ludHM9IjAgMCAxNCAwIDE0IDEwIDAgMTAiPjwvcG9seWdvbj4KICAgICAgICAgICAgPC9nPgogICAgICAgIDwvZz4KICAgIDwvZz4KPC9zdmc+"

/***/ },
/* 826 */
/***/ function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiIHN0YW5kYWxvbmU9Im5vIj8+Cjxzdmcgd2lkdGg9IjE0cHgiIGhlaWdodD0iOXB4IiB2aWV3Qm94PSIwIDAgMTQgOSIgdmVyc2lvbj0iMS4xIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIj4KICAgIDwhLS0gR2VuZXJhdG9yOiBza2V0Y2h0b29sIDMuNyAoMjgxNjkpIC0gaHR0cDovL3d3dy5ib2hlbWlhbmNvZGluZy5jb20vc2tldGNoIC0tPgogICAgPHRpdGxlPkY3REVDRDJFLTQwQjUtNDIyQy05NkMyLTE4MkU4RjU5QUIyQTwvdGl0bGU+CiAgICA8ZGVzYz5DcmVhdGVkIHdpdGggc2tldGNodG9vbC48L2Rlc2M+CiAgICA8ZGVmcz48L2RlZnM+CiAgICA8ZyBpZD0iUGFnZS0xIiBzdHJva2U9Im5vbmUiIHN0cm9rZS13aWR0aD0iMSIgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIj4KICAgICAgICA8ZyBpZD0iQnV0dG9ucyIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTEyMy4wMDAwMDAsIC0xMDI3LjAwMDAwMCkiIGZpbGw9IiMwMDVCODEiPgogICAgICAgICAgICA8ZyBpZD0iR3JvdXAtMiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMTE1LjAwMDAwMCwgOTU0LjAwMDAwMCkiPgogICAgICAgICAgICAgICAgPGcgaWQ9IkVtYWlsIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSg4LjAwMDAwMCwgNzMuMDAwMDAwKSI+CiAgICAgICAgICAgICAgICAgICAgPHBvbHlnb24gaWQ9IkZpbGwtMSIgcG9pbnRzPSIwLjk1NTE4MTgxOCAwIDcuMjA3MTAxMDEgNC4yODkxMDM0NSAxMy41Mzk2MjYzIDAiPjwvcG9seWdvbj4KICAgICAgICAgICAgICAgICAgICA8cG9seWdvbiBpZD0iRmlsbC0yIiBwb2ludHM9IjAgOSAxNCA5IDE0IDEuNDY1Mzc5MzEgNy4xNTE1OTU5NiA2LjA5MzM3OTMxIDAgMS4xOTc3OTMxIj48L3BvbHlnb24+CiAgICAgICAgICAgICAgICA8L2c+CiAgICAgICAgICAgIDwvZz4KICAgICAgICA8L2c+CiAgICA8L2c+Cjwvc3ZnPg=="

/***/ },
/* 827 */
/***/ function(module, exports) {

	module.exports = "data:image/svg+xml;base64,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"

/***/ },
/* 828 */
/***/ function(module, exports) {

	module.exports = "data:image/svg+xml;base64,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"

/***/ },
/* 829 */
/***/ function(module, exports) {

	module.exports = "data:image/svg+xml;base64,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"

/***/ },
/* 830 */
/***/ function(module, exports) {

	module.exports = "data:image/svg+xml;base64,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"

/***/ },
/* 831 */
/***/ function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiIHN0YW5kYWxvbmU9Im5vIj8+Cjxzdmcgd2lkdGg9IjVweCIgaGVpZ2h0PSIxMnB4IiB2aWV3Qm94PSIwIDAgNSAxMiIgdmVyc2lvbj0iMS4xIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIj4KICAgIDwhLS0gR2VuZXJhdG9yOiBza2V0Y2h0b29sIDMuNyAoMjgxNjkpIC0gaHR0cDovL3d3dy5ib2hlbWlhbmNvZGluZy5jb20vc2tldGNoIC0tPgogICAgPHRpdGxlPkJEQzRBM0EzLTQxOTMtNDUzOC1BMTdGLTcwMkY2NTZCRjBDNjwvdGl0bGU+CiAgICA8ZGVzYz5DcmVhdGVkIHdpdGggc2tldGNodG9vbC48L2Rlc2M+CiAgICA8ZGVmcz48L2RlZnM+CiAgICA8ZyBpZD0iUGFnZS0xIiBzdHJva2U9Im5vbmUiIHN0cm9rZS13aWR0aD0iMSIgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIj4KICAgICAgICA8ZyBpZD0iQnV0dG9ucyIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTI4My4wMDAwMDAsIC05NjQuMDAwMDAwKSIgZmlsbD0iIzNENUQ5NyI+CiAgICAgICAgICAgIDxnIGlkPSJHcm91cC0yLUNvcHktNiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMjY5LjAwMDAwMCwgOTU0LjAwMDAwMCkiPgogICAgICAgICAgICAgICAgPHBhdGggZD0iTTE0LjkxODgzNjEsMjIgTDE2Ljc1NjUwODQsMjIgTDE2Ljc1NjUwODQsMTUuNTY4MTQ3IEwxOC43NzE1MTYxLDE1LjU2ODE0NyBMMTguOTgyODQ4NCwxMy43MzA0NzQ3IEwxNi43NTY1MDg0LDEzLjczMDQ3NDcgTDE2Ljc1NjUwODQsMTIuNTUyNTI2OCBDMTYuNzU2NTA4NCwxMi4xMDA0NTk0IDE3LjQ0MDEyMjUsMTEuODkyODAyNSAxNy42NTIzNzM3LDExLjg5MjgwMjUgTDE4LjU5NDE4MDcsMTEuODkyODAyNSBMMTguNTk0MTgwNywxMC4wMDczNTA3IEwxNy4wODA4NTc2LDEwIEMxNS4wOTE1NzczLDEwIDE0LjkxODgzNjEsMTEuNDgzMDAxNSAxNC45MTg4MzYxLDEyLjQzMTI0MDQgTDE0LjkxODgzNjEsMTMuNzMwNDc0NyBMMTQsMTMuNzMwNDc0NyBMMTQsMTUuNTY4MTQ3IEwxNC45MTg4MzYxLDE1LjU2ODE0NyBMMTQuOTE4ODM2MSwyMiIgaWQ9IkZhY2Vib29rIj48L3BhdGg+CiAgICAgICAgICAgIDwvZz4KICAgICAgICA8L2c+CiAgICA8L2c+Cjwvc3ZnPgo="

/***/ },
/* 832 */
/***/ function(module, exports) {

	module.exports = "data:image/svg+xml;base64,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"

/***/ },
/* 833 */
/***/ function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiIHN0YW5kYWxvbmU9Im5vIj8+Cjxzdmcgd2lkdGg9IjEycHgiIGhlaWdodD0iMTJweCIgdmlld0JveD0iMCAwIDEyIDEyIiB2ZXJzaW9uPSIxLjEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiPgogICAgPCEtLSBHZW5lcmF0b3I6IHNrZXRjaHRvb2wgMy43ICgyODE2OSkgLSBodHRwOi8vd3d3LmJvaGVtaWFuY29kaW5nLmNvbS9za2V0Y2ggLS0+CiAgICA8dGl0bGU+RDA5RkE0N0ItOTZBNS00QTRGLUI3OUQtMTk4RUUxNUNDNjU3PC90aXRsZT4KICAgIDxkZXNjPkNyZWF0ZWQgd2l0aCBza2V0Y2h0b29sLjwvZGVzYz4KICAgIDxkZWZzPjwvZGVmcz4KICAgIDxnIGlkPSJQYWdlLTEiIHN0cm9rZT0ibm9uZSIgc3Ryb2tlLXdpZHRoPSIxIiBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPgogICAgICAgIDxnIGlkPSJCdXR0b25zIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtMTU2LjAwMDAwMCwgLTk5NS4wMDAwMDApIiBmaWxsPSIjMUI3REIyIj4KICAgICAgICAgICAgPGcgaWQ9Ikdyb3VwLTIiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDExNS4wMDAwMDAsIDk1NC4wMDAwMDApIj4KICAgICAgICAgICAgICAgIDxwYXRoIGQ9Ik00MS4xNTMsNTMgTDQzLjcyNDY2NjcsNTMgTDQzLjcyNDY2NjcsNDQuOTAzMjU3MiBMNDEuMTUzLDQ0LjkwMzI1NzIgTDQxLjE1Myw1MyBaIE00Mi40NTU2NjY3LDQxIEM0MS41NzU1LDQxIDQxLDQxLjYwNDM1MTcgNDEsNDIuMzk4ODE2OSBDNDEsNDMuMTc2MTg5MyA0MS41NTkxNjY3LDQzLjc5ODE1NyA0Mi40MjE4MzMzLDQzLjc5ODE1NyBMNDIuNDM4ODMzMyw0My43OTgxNTcgQzQzLjMzNiw0My43OTgxNTcgNDMuODkzODMzMyw0My4xNzYxODkzIDQzLjg5MzgzMzMsNDIuMzk4ODE2OSBDNDMuODc3LDQxLjYwNDM1MTcgNDMuMzM2LDQxIDQyLjQ1NTY2NjcsNDEgTDQyLjQ1NTY2NjcsNDEgWiBNNTMsNDguMzU2ODY5OCBMNTMsNTMgTDUwLjQyNzY2NjcsNTMgTDUwLjQyNzY2NjcsNDguNjY4MjAyNSBDNTAuNDI3NjY2Nyw0Ny41ODAxOTUxIDUwLjA1Niw0Ni44Mzc1MzE0IDQ5LjEyNSw0Ni44Mzc1MzE0IEM0OC40MTQsNDYuODM3NTMxNCA0Ny45OTE1LDQ3LjMzNzU4MjMgNDcuODA1MzMzMyw0Ny44MjE5MzU3IEM0Ny43Mzc2NjY3LDQ3Ljk5NDk1NjUgNDcuNzIsNDguMjM1NDc2MiA0Ny43Miw0OC40NzgwODkgTDQ3LjcyLDUzIEw0NS4xNDcxNjY3LDUzIEM0NS4xNDcxNjY3LDUzIDQ1LjE4MTY2NjcsNDUuNjYyODM5MiA0NS4xNDcxNjY3LDQ0LjkwMzI1NzIgTDQ3LjcyLDQ0LjkwMzI1NzIgTDQ3LjcyLDQ2LjA1MDU2NjEgQzQ3LjcxNDgzMzMsNDYuMDU5NDYxMyA0Ny43MDc2NjY3LDQ2LjA2ODM1NjYgNDcuNzAzMTY2Nyw0Ni4wNzcwNzc0IEw0Ny43Miw0Ni4wNzcwNzc0IEw0Ny43Miw0Ni4wNTA1NjYxIEM0OC4wNjE4MzMzLDQ1LjUwMDEwOSA0OC42NzE4MzMzLDQ0LjcxMzE0MzcgNTAuMDM4MzMzMyw0NC43MTMxNDM3IEM1MS43MzExNjY3LDQ0LjcxMzE0MzcgNTMsNDUuODcwMDQ1NSA1Myw0OC4zNTY4Njk4IEw1Myw0OC4zNTY4Njk4IFoiIGlkPSJMaW5rZWRpbiI+PC9wYXRoPgogICAgICAgICAgICA8L2c+CiAgICAgICAgPC9nPgogICAgPC9nPgo8L3N2Zz4="

/***/ },
/* 834 */
/***/ function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiIHN0YW5kYWxvbmU9Im5vIj8+Cjxzdmcgd2lkdGg9IjExcHgiIGhlaWdodD0iMTVweCIgdmlld0JveD0iMCAwIDExIDE1IiB2ZXJzaW9uPSIxLjEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiPgogICAgPCEtLSBHZW5lcmF0b3I6IHNrZXRjaHRvb2wgMy42LjEgKDI2MzEzKSAtIGh0dHA6Ly93d3cuYm9oZW1pYW5jb2RpbmcuY29tL3NrZXRjaCAtLT4KICAgIDx0aXRsZT45NTBEOEI5MC0yNUQ5LTQ1QkMtODFEMS05MzQ0NzU4MkEyRjk8L3RpdGxlPgogICAgPGRlc2M+Q3JlYXRlZCB3aXRoIHNrZXRjaHRvb2wuPC9kZXNjPgogICAgPGRlZnM+PC9kZWZzPgogICAgPGcgaWQ9IlBhZ2UtMSIgc3Ryb2tlPSJub25lIiBzdHJva2Utd2lkdGg9IjEiIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCI+CiAgICAgICAgPGcgaWQ9IlBsYXllckNvbnRyb2xzLUNvcHkiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC0xMTUuMDAwMDAwLCAtMTMxLjAwMDAwMCkiIGZpbGw9IiMwMDVCODEiPgogICAgICAgICAgICA8ZyBpZD0iUGF1c2UiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDExNS4wMDAwMDAsIDEzMS4wMDAwMDApIj4KICAgICAgICAgICAgICAgIDxyZWN0IGlkPSJSZWN0YW5nbGUtMTE5OSIgeD0iMCIgeT0iMCIgd2lkdGg9IjQiIGhlaWdodD0iMTUiPjwvcmVjdD4KICAgICAgICAgICAgICAgIDxyZWN0IGlkPSJSZWN0YW5nbGUtMTE5OSIgeD0iNyIgeT0iMCIgd2lkdGg9IjQiIGhlaWdodD0iMTUiPjwvcmVjdD4KICAgICAgICAgICAgPC9nPgogICAgICAgIDwvZz4KICAgIDwvZz4KPC9zdmc+Cg=="

/***/ },
/* 835 */
/***/ function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiIHN0YW5kYWxvbmU9Im5vIj8+Cjxzdmcgd2lkdGg9IjExcHgiIGhlaWdodD0iMTVweCIgdmlld0JveD0iMCAwIDExIDE1IiB2ZXJzaW9uPSIxLjEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiPgogICAgPCEtLSBHZW5lcmF0b3I6IHNrZXRjaHRvb2wgMy42LjEgKDI2MzEzKSAtIGh0dHA6Ly93d3cuYm9oZW1pYW5jb2RpbmcuY29tL3NrZXRjaCAtLT4KICAgIDx0aXRsZT45NTBEOEI5MC0yNUQ5LTQ1QkMtODFEMS05MzQ0NzU4MkEyRjk8L3RpdGxlPgogICAgPGRlc2M+Q3JlYXRlZCB3aXRoIHNrZXRjaHRvb2wuPC9kZXNjPgogICAgPGRlZnM+PC9kZWZzPgogICAgPGcgaWQ9IlBhZ2UtMSIgc3Ryb2tlPSJub25lIiBzdHJva2Utd2lkdGg9IjEiIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCI+CiAgICAgICAgPGcgaWQ9IlBsYXllckNvbnRyb2xzLUNvcHkiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC0xMTUuMDAwMDAwLCAtMTMxLjAwMDAwMCkiIGZpbGw9IiNGRkZGRkYiPgogICAgICAgICAgICA8ZyBpZD0iUGF1c2UiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDExNS4wMDAwMDAsIDEzMS4wMDAwMDApIj4KICAgICAgICAgICAgICAgIDxyZWN0IGlkPSJSZWN0YW5nbGUtMTE5OSIgeD0iMCIgeT0iMCIgd2lkdGg9IjQiIGhlaWdodD0iMTUiPjwvcmVjdD4KICAgICAgICAgICAgICAgIDxyZWN0IGlkPSJSZWN0YW5nbGUtMTE5OSIgeD0iNyIgeT0iMCIgd2lkdGg9IjQiIGhlaWdodD0iMTUiPjwvcmVjdD4KICAgICAgICAgICAgPC9nPgogICAgICAgIDwvZz4KICAgIDwvZz4KPC9zdmc+"

/***/ },
/* 836 */
/***/ function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiIHN0YW5kYWxvbmU9Im5vIj8+Cjxzdmcgd2lkdGg9IjE0cHgiIGhlaWdodD0iMTlweCIgdmlld0JveD0iMCAwIDE0IDE5IiB2ZXJzaW9uPSIxLjEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiPgogICAgPCEtLSBHZW5lcmF0b3I6IHNrZXRjaHRvb2wgMy42LjEgKDI2MzEzKSAtIGh0dHA6Ly93d3cuYm9oZW1pYW5jb2RpbmcuY29tL3NrZXRjaCAtLT4KICAgIDx0aXRsZT5ERUYzRjVEQy00MzI3LTQ4RTEtQjFCRS01NEYyMzYxQzc5QUU8L3RpdGxlPgogICAgPGRlc2M+Q3JlYXRlZCB3aXRoIHNrZXRjaHRvb2wuPC9kZXNjPgogICAgPGRlZnM+PC9kZWZzPgogICAgPGcgaWQ9IlBhZ2UtMSIgc3Ryb2tlPSJub25lIiBzdHJva2Utd2lkdGg9IjEiIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCI+CiAgICAgICAgPGcgaWQ9IlBsYXllckNvbnRyb2xzLUNvcHkiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC0xOTUuMDAwMDAwLCAtMTI5LjAwMDAwMCkiIGZpbGw9IiMwMDVCODEiPgogICAgICAgICAgICA8cGF0aCBkPSJNMTk1LDEyOSBMMjA5LDEzOC41IEwxOTUsMTQ4IEwxOTUsMTI5IFoiIGlkPSJQbGF5Ij48L3BhdGg+CiAgICAgICAgPC9nPgogICAgPC9nPgo8L3N2Zz4K"

/***/ },
/* 837 */
/***/ function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiIHN0YW5kYWxvbmU9Im5vIj8+Cjxzdmcgd2lkdGg9IjE0cHgiIGhlaWdodD0iMTlweCIgdmlld0JveD0iMCAwIDE0IDE5IiB2ZXJzaW9uPSIxLjEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiPgogICAgPCEtLSBHZW5lcmF0b3I6IHNrZXRjaHRvb2wgMy42LjEgKDI2MzEzKSAtIGh0dHA6Ly93d3cuYm9oZW1pYW5jb2RpbmcuY29tL3NrZXRjaCAtLT4KICAgIDx0aXRsZT5ERUYzRjVEQy00MzI3LTQ4RTEtQjFCRS01NEYyMzYxQzc5QUU8L3RpdGxlPgogICAgPGRlc2M+Q3JlYXRlZCB3aXRoIHNrZXRjaHRvb2wuPC9kZXNjPgogICAgPGRlZnM+PC9kZWZzPgogICAgPGcgaWQ9IlBhZ2UtMSIgc3Ryb2tlPSJub25lIiBzdHJva2Utd2lkdGg9IjEiIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCI+CiAgICAgICAgPGcgaWQ9IlBsYXllckNvbnRyb2xzLUNvcHkiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC0xOTUuMDAwMDAwLCAtMTI5LjAwMDAwMCkiIGZpbGw9IiNGRkZGRkYiPgogICAgICAgICAgICA8cGF0aCBkPSJNMTk1LDEyOSBMMjA5LDEzOC41IEwxOTUsMTQ4IEwxOTUsMTI5IFoiIGlkPSJQbGF5Ij48L3BhdGg+CiAgICAgICAgPC9nPgogICAgPC9nPgo8L3N2Zz4="

/***/ },
/* 838 */
/***/ function(module, exports) {

	module.exports = "data:image/svg+xml;base64,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"

/***/ },
/* 839 */
/***/ function(module, exports) {

	module.exports = "data:image/svg+xml;base64,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"

/***/ },
/* 840 */
/***/ function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiIHN0YW5kYWxvbmU9Im5vIj8+Cjxzdmcgd2lkdGg9IjE0cHgiIGhlaWdodD0iMTRweCIgdmlld0JveD0iMCAwIDE0IDE0IiB2ZXJzaW9uPSIxLjEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiPgogICAgPCEtLSBHZW5lcmF0b3I6IHNrZXRjaHRvb2wgMy43ICgyODE2OSkgLSBodHRwOi8vd3d3LmJvaGVtaWFuY29kaW5nLmNvbS9za2V0Y2ggLS0+CiAgICA8dGl0bGU+RjVDQjc3ODQtODVEMS00NDM3LTg0N0EtQzE0RTZDNjgyMzY3PC90aXRsZT4KICAgIDxkZXNjPkNyZWF0ZWQgd2l0aCBza2V0Y2h0b29sLjwvZGVzYz4KICAgIDxkZWZzPjwvZGVmcz4KICAgIDxnIGlkPSJQYWdlLTEiIHN0cm9rZT0ibm9uZSIgc3Ryb2tlLXdpZHRoPSIxIiBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCI+CiAgICAgICAgPGcgaWQ9IkJ1dHRvbnMiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC0yODUuMDAwMDAwLCAtNzM5LjAwMDAwMCkiIHN0cm9rZT0iIzAwN0NCMCI+CiAgICAgICAgICAgIDxnIGlkPSJUcmFuc2NyaXB0SWNvbiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMjg1LjAwMDAwMCwgNzQwLjAwMDAwMCkiPgogICAgICAgICAgICAgICAgPHBhdGggZD0iTTAsMCBMMTAsMCBNMCwzIEwxNCwzIE0wLDYgTDEzLDYgTTAsOSBMMTQsOSBNMCwxMiBMOSwxMiIgaWQ9IkltcG9ydGVkLUxheWVycyI+PC9wYXRoPgogICAgICAgICAgICA8L2c+CiAgICAgICAgPC9nPgogICAgPC9nPgo8L3N2Zz4="

/***/ },
/* 841 */
/***/ function(module, exports) {

	module.exports = "data:image/svg+xml;base64,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"

/***/ },
/* 842 */
/***/ function(module, exports) {

	module.exports = "data:image/svg+xml;base64,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"

/***/ },
/* 843 */
/***/ function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiIHN0YW5kYWxvbmU9Im5vIj8+Cjxzdmcgd2lkdGg9IjE5cHgiIGhlaWdodD0iMTVweCIgdmlld0JveD0iMCAwIDE5IDE1IiB2ZXJzaW9uPSIxLjEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiPgogICAgPCEtLSBHZW5lcmF0b3I6IHNrZXRjaHRvb2wgMy42LjEgKDI2MzEzKSAtIGh0dHA6Ly93d3cuYm9oZW1pYW5jb2RpbmcuY29tL3NrZXRjaCAtLT4KICAgIDx0aXRsZT4yREU0MEM2Ni1ERkM4LTRDQkYtQTE2RC1COUM4RUMzQkQ2QUM8L3RpdGxlPgogICAgPGRlc2M+Q3JlYXRlZCB3aXRoIHNrZXRjaHRvb2wuPC9kZXNjPgogICAgPGRlZnM+PC9kZWZzPgogICAgPGcgaWQ9IlBhZ2UtMSIgc3Ryb2tlPSJub25lIiBzdHJva2Utd2lkdGg9IjEiIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCI+CiAgICAgICAgPGcgaWQ9IlBsYXllckNvbnRyb2xzLUNvcHkiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC0xMTguMDAwMDAwLCAtNDY4LjAwMDAwMCkiIGZpbGw9IiNGRkZGRkYiPgogICAgICAgICAgICA8ZyBpZD0iVm9sdW1lSGlnaCIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMTE3LjA5NDAzNywgNDY4LjAwMDAwMCkiPgogICAgICAgICAgICAgICAgPHBhdGggZD0iTTkuOTA0NTg5NDcsMCBMNC44MzM3NjA1OSw0LjI1OTU1NDE0IEwwLjkwODAyNDA1Nyw0LjI1OTU1NDE0IEwwLjkwODAyNDA1Nyw3LjU1NjQ1NjI4IEwwLjkwNTk2MzMwMyw3LjU1ODYyNzY4IEwwLjkwODAyNDA1Nyw3LjU2MDc5OTA3IEwwLjkwODAyNDA1NywxMC44MjM2ODI3IEw0Ljg1MzY4MTIxLDEwLjgyMzY4MjcgTDkuOTA0NTg5NDcsMTUgTDkuOTA0NTg5NDcsMTAuODIzNjgyNyBMOS45MDU5NjMzLDEwLjgyMzY4MjcgTDkuOTA1OTYzMyw0LjI1OTU1NDE0IEw5LjkwNDU4OTQ3LDQuMjU5NTU0MTQgTDkuOTA0NTg5NDcsMCBMOS45MDQ1ODk0NywwIFogTTkuMjEyODYzMDEsMTMuNTAxMDEzMyBMNS4yODA5NDQyMiwxMC4yNDk3MTA1IEw1LjA5MjcyODY4LDEwLjA5NDA5MzggTDEuNjAwNDM3NDMsMTAuMDk0MDkzOCBMMS42MDA0Mzc0Myw0Ljk4OTE0MzAyIEw1LjA3NTU1NTczLDQuOTg5MTQzMDIgTDkuMjEyODYzMDEsMS41MTQxODY0NSBMOS4yMTI4NjMwMSw0LjI1OTU1NDE0IEw5LjIxMzU0OTkzLDQuOTg5MTQzMDIgTDkuMjEzNTQ5OTMsMTAuMDk0MDkzOCBMOS4yMTI4NjMwMSwxMy41MDEwMTMzIFoiIGlkPSJGaWxsLTExIj48L3BhdGg+CiAgICAgICAgICAgICAgICA8cGF0aCBkPSJNMTEuOTUyNTQyNiw0LjM3MTc5MDM2IEMxMi43NTA5NDE1LDUuMjcxMTA0NDcgMTMuMTcyMzM4OCw2LjM0MjE1NjE3IDEzLjE3MjMzODgsNy40NzA0NTM3NSBDMTMuMTcyMzM4OCw4LjYyMjE0MjEgMTIuNzM0OTI5OCw5LjcxMTY2MDIyIDExLjkwNTk2MzMsMTAuNjIxNDM4NiBMMTIuNDg3NDc3MSwxMSBDMTMuNDE1NDI0Nyw5Ljk4MDY1NDI0IDEzLjkwNTk2MzMsOC43NjAwMjQ2MiAxMy45MDU5NjMzLDcuNDcwNDUzNzUgQzEzLjkwNTk2MzMsNi4yMDY3MzU4NCAxMy40MzM2MTk4LDUuMDA3MDM0ODIgMTIuNTM5MTUxMSw0IEwxMS45NTI1NDI2LDQuMzcxNzkwMzYiIGlkPSJGaWxsLTEyIj48L3BhdGg+CiAgICAgICAgICAgICAgICA8cGF0aCBkPSJNMTQuNDk3NzQ4MywyIEwxMy45MDU5NjMzLDIuNDA0NTYwMDQgQzE1LjM0NjYzMjcsMy44NDg4NzcxOCAxNi4xMzkyMjksNS42Nzg4NDk2OCAxNi4xMzkyMjksNy41NTY3MTQwMiBDMTYuMTM5MjI5LDkuNDExODkyNzYgMTUuNDAyMTYwMSwxMS4xNTc0MjQ0IDE0LjAwODY1MDksMTIuNjAzNjMyIEwxNC42MDgwNDI0LDEzIEMxNi4xMTEwODUsMTEuNDM5NzM0MiAxNi45MDU5NjMzLDkuNTU3NDU4NzUgMTYuOTA1OTYzMyw3LjU1NjcxNDAyIEMxNi45MDU5NjMzLDUuNTMxMzkzMjIgMTYuMDUwOTkzNywzLjU1ODM3NTM0IDE0LjQ5Nzc0ODMsMiIgaWQ9IkZpbGwtMTMiPjwvcGF0aD4KICAgICAgICAgICAgICAgIDxwYXRoIGQ9Ik0xNS45MDU5NjMzLDAuNDE2MjUgQzE3Ljk5NzAwOTIsMi4zODgxMjUgMTkuMTQ4MjUwNyw0LjkyNDM3NSAxOS4xNDgyNTA3LDcuNTU3NSBDMTkuMTQ4MjUwNywxMC4xMzc1IDE4LjAzNjg4ODgsMTIuNjM1IDE2LjAxOTU4MjYsMTQuNTkgTDE2LjU5NDQ1MDksMTUgQzE4LjcyOTg5MTEsMTIuOTMwNjI1IDE5LjkwNTk2MzMsMTAuMjg3NSAxOS45MDU5NjMzLDcuNTU3NSBDMTkuOTA1OTYzMyw0Ljc3MTI1IDE4LjY4Nzc1NDEsMi4wODY4NzUgMTYuNDc0ODEyMSwwIEwxNS45MDU5NjMzLDAuNDE2MjUgWiIgaWQ9IkZpbGwtMTQiPjwvcGF0aD4KICAgICAgICAgICAgPC9nPgogICAgICAgIDwvZz4KICAgIDwvZz4KPC9zdmc+Cg=="

/***/ },
/* 844 */
/***/ function(module, exports) {

	module.exports = "data:image/svg+xml;base64,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"

/***/ },
/* 845 */
/***/ function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiIHN0YW5kYWxvbmU9Im5vIj8+Cjxzdmcgd2lkdGg9IjEzcHgiIGhlaWdodD0iMTVweCIgdmlld0JveD0iMCAwIDEzIDE1IiB2ZXJzaW9uPSIxLjEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiPgogICAgPCEtLSBHZW5lcmF0b3I6IHNrZXRjaHRvb2wgMy42LjEgKDI2MzEzKSAtIGh0dHA6Ly93d3cuYm9oZW1pYW5jb2RpbmcuY29tL3NrZXRjaCAtLT4KICAgIDx0aXRsZT5DRjY5QkNENy1BNjE3LTRGMjEtQjQ1Ni1CNjJCRjFGOTRFMjY8L3RpdGxlPgogICAgPGRlc2M+Q3JlYXRlZCB3aXRoIHNrZXRjaHRvb2wuPC9kZXNjPgogICAgPGRlZnM+PC9kZWZzPgogICAgPGcgaWQ9IlBhZ2UtMSIgc3Ryb2tlPSJub25lIiBzdHJva2Utd2lkdGg9IjEiIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCI+CiAgICAgICAgPGcgaWQ9IlBsYXllckNvbnRyb2xzLUNvcHkiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC0zMjEuMDAwMDAwLCAtNDY4LjAwMDAwMCkiIGZpbGw9IiNGRkZGRkYiPgogICAgICAgICAgICA8ZyBpZD0iVm9sdW1lTG93IiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgzMjEuMDAwMDAwLCA0NjguMDAwMDAwKSI+CiAgICAgICAgICAgICAgICA8cGF0aCBkPSJNOC45OTg2MjYxNiwwIEwzLjkyNzc5NzI4LDQuMjU5NTU0MTQgTDAuMDAyMDYwNzU0MDgsNC4yNTk1NTQxNCBMMC4wMDIwNjA3NTQwOCw3LjU1NjQ1NjI4IEwwLDcuNTU4NjI3NjggTDAuMDAyMDYwNzU0MDgsNy41NjA3OTkwNyBMMC4wMDIwNjA3NTQwOCwxMC44MjM2ODI3IEwzLjk0NzcxNzkxLDEwLjgyMzY4MjcgTDguOTk4NjI2MTYsMTUgTDguOTk4NjI2MTYsMTAuODIzNjgyNyBMOSwxMC44MjM2ODI3IEw5LDQuMjU5NTU0MTQgTDguOTk4NjI2MTYsNC4yNTk1NTQxNCBMOC45OTg2MjYxNiwwIEw4Ljk5ODYyNjE2LDAgWiBNOC4zMDY4OTk3MSwxMy41MDEwMTMzIEw0LjM3NDk4MDkyLDEwLjI0OTcxMDUgTDQuMTg2NzY1MzgsMTAuMDk0MDkzOCBMMC42OTQ0NzQxMjYsMTAuMDk0MDkzOCBMMC42OTQ0NzQxMjYsNC45ODkxNDMwMiBMNC4xNjk1OTI0Myw0Ljk4OTE0MzAyIEw4LjMwNjg5OTcxLDEuNTE0MTg2NDUgTDguMzA2ODk5NzEsNC4yNTk1NTQxNCBMOC4zMDc1ODY2Myw0Ljk4OTE0MzAyIEw4LjMwNzU4NjYzLDEwLjA5NDA5MzggTDguMzA2ODk5NzEsMTMuNTAxMDEzMyBaIiBpZD0iRmlsbC0xMSI+PC9wYXRoPgogICAgICAgICAgICAgICAgPHBhdGggZD0iTTExLjA0NjU3OTMsNC4zNzE3OTAzNiBDMTEuODQ0OTc4Miw1LjI3MTEwNDQ3IDEyLjI2NjM3NTUsNi4zNDIxNTYxNyAxMi4yNjYzNzU1LDcuNDcwNDUzNzUgQzEyLjI2NjM3NTUsOC42MjIxNDIxIDExLjgyODk2NjUsOS43MTE2NjAyMiAxMSwxMC42MjE0Mzg2IEwxMS41ODE1MTM4LDExIEMxMi41MDk0NjE0LDkuOTgwNjU0MjQgMTMsOC43NjAwMjQ2MiAxMyw3LjQ3MDQ1Mzc1IEMxMyw2LjIwNjczNTg0IDEyLjUyNzY1NjUsNS4wMDcwMzQ4MiAxMS42MzMxODc4LDQgTDExLjA0NjU3OTMsNC4zNzE3OTAzNiIgaWQ9IkZpbGwtMTIiPjwvcGF0aD4KICAgICAgICAgICAgPC9nPgogICAgICAgIDwvZz4KICAgIDwvZz4KPC9zdmc+Cg=="

/***/ },
/* 846 */
/***/ function(module, exports) {

	module.exports = "data:image/svg+xml;base64,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"

/***/ },
/* 847 */
/***/ function(module, exports) {

	module.exports = "data:image/svg+xml;base64,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"

/***/ },
/* 848 */
/***/ function(module, exports) {

	module.exports = "data:image/svg+xml;base64,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"

/***/ },
/* 849 */
/***/ function(module, exports) {

	module.exports = "data:image/svg+xml;base64,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"

/***/ },
/* 850 */
/***/ function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(__webpack_amd_options__) {module.exports = __webpack_amd_options__;
	
	/* WEBPACK VAR INJECTION */}.call(exports, {}))

/***/ },
/* 851 */
/***/ function(module, exports) {

	module.exports = function(module) {
		if(!module.webpackPolyfill) {
			module.deprecate = function() {};
			module.paths = [];
			// module.parent = undefined by default
			module.children = [];
			module.webpackPolyfill = 1;
		}
		return module;
	}


/***/ },
/* 852 */
/***/ function(module, exports) {

	(function(self) {
	  'use strict';
	
	  if (self.fetch) {
	    return
	  }
	
	  var support = {
	    searchParams: 'URLSearchParams' in self,
	    iterable: 'Symbol' in self && 'iterator' in Symbol,
	    blob: 'FileReader' in self && 'Blob' in self && (function() {
	      try {
	        new Blob()
	        return true
	      } catch(e) {
	        return false
	      }
	    })(),
	    formData: 'FormData' in self,
	    arrayBuffer: 'ArrayBuffer' in self
	  }
	
	  function normalizeName(name) {
	    if (typeof name !== 'string') {
	      name = String(name)
	    }
	    if (/[^a-z0-9\-#$%&'*+.\^_`|~]/i.test(name)) {
	      throw new TypeError('Invalid character in header field name')
	    }
	    return name.toLowerCase()
	  }
	
	  function normalizeValue(value) {
	    if (typeof value !== 'string') {
	      value = String(value)
	    }
	    return value
	  }
	
	  // Build a destructive iterator for the value list
	  function iteratorFor(items) {
	    var iterator = {
	      next: function() {
	        var value = items.shift()
	        return {done: value === undefined, value: value}
	      }
	    }
	
	    if (support.iterable) {
	      iterator[Symbol.iterator] = function() {
	        return iterator
	      }
	    }
	
	    return iterator
	  }
	
	  function Headers(headers) {
	    this.map = {}
	
	    if (headers instanceof Headers) {
	      headers.forEach(function(value, name) {
	        this.append(name, value)
	      }, this)
	
	    } else if (headers) {
	      Object.getOwnPropertyNames(headers).forEach(function(name) {
	        this.append(name, headers[name])
	      }, this)
	    }
	  }
	
	  Headers.prototype.append = function(name, value) {
	    name = normalizeName(name)
	    value = normalizeValue(value)
	    var list = this.map[name]
	    if (!list) {
	      list = []
	      this.map[name] = list
	    }
	    list.push(value)
	  }
	
	  Headers.prototype['delete'] = function(name) {
	    delete this.map[normalizeName(name)]
	  }
	
	  Headers.prototype.get = function(name) {
	    var values = this.map[normalizeName(name)]
	    return values ? values[0] : null
	  }
	
	  Headers.prototype.getAll = function(name) {
	    return this.map[normalizeName(name)] || []
	  }
	
	  Headers.prototype.has = function(name) {
	    return this.map.hasOwnProperty(normalizeName(name))
	  }
	
	  Headers.prototype.set = function(name, value) {
	    this.map[normalizeName(name)] = [normalizeValue(value)]
	  }
	
	  Headers.prototype.forEach = function(callback, thisArg) {
	    Object.getOwnPropertyNames(this.map).forEach(function(name) {
	      this.map[name].forEach(function(value) {
	        callback.call(thisArg, value, name, this)
	      }, this)
	    }, this)
	  }
	
	  Headers.prototype.keys = function() {
	    var items = []
	    this.forEach(function(value, name) { items.push(name) })
	    return iteratorFor(items)
	  }
	
	  Headers.prototype.values = function() {
	    var items = []
	    this.forEach(function(value) { items.push(value) })
	    return iteratorFor(items)
	  }
	
	  Headers.prototype.entries = function() {
	    var items = []
	    this.forEach(function(value, name) { items.push([name, value]) })
	    return iteratorFor(items)
	  }
	
	  if (support.iterable) {
	    Headers.prototype[Symbol.iterator] = Headers.prototype.entries
	  }
	
	  function consumed(body) {
	    if (body.bodyUsed) {
	      return Promise.reject(new TypeError('Already read'))
	    }
	    body.bodyUsed = true
	  }
	
	  function fileReaderReady(reader) {
	    return new Promise(function(resolve, reject) {
	      reader.onload = function() {
	        resolve(reader.result)
	      }
	      reader.onerror = function() {
	        reject(reader.error)
	      }
	    })
	  }
	
	  function readBlobAsArrayBuffer(blob) {
	    var reader = new FileReader()
	    reader.readAsArrayBuffer(blob)
	    return fileReaderReady(reader)
	  }
	
	  function readBlobAsText(blob) {
	    var reader = new FileReader()
	    reader.readAsText(blob)
	    return fileReaderReady(reader)
	  }
	
	  function Body() {
	    this.bodyUsed = false
	
	    this._initBody = function(body) {
	      this._bodyInit = body
	      if (typeof body === 'string') {
	        this._bodyText = body
	      } else if (support.blob && Blob.prototype.isPrototypeOf(body)) {
	        this._bodyBlob = body
	      } else if (support.formData && FormData.prototype.isPrototypeOf(body)) {
	        this._bodyFormData = body
	      } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
	        this._bodyText = body.toString()
	      } else if (!body) {
	        this._bodyText = ''
	      } else if (support.arrayBuffer && ArrayBuffer.prototype.isPrototypeOf(body)) {
	        // Only support ArrayBuffers for POST method.
	        // Receiving ArrayBuffers happens via Blobs, instead.
	      } else {
	        throw new Error('unsupported BodyInit type')
	      }
	
	      if (!this.headers.get('content-type')) {
	        if (typeof body === 'string') {
	          this.headers.set('content-type', 'text/plain;charset=UTF-8')
	        } else if (this._bodyBlob && this._bodyBlob.type) {
	          this.headers.set('content-type', this._bodyBlob.type)
	        } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
	          this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8')
	        }
	      }
	    }
	
	    if (support.blob) {
	      this.blob = function() {
	        var rejected = consumed(this)
	        if (rejected) {
	          return rejected
	        }
	
	        if (this._bodyBlob) {
	          return Promise.resolve(this._bodyBlob)
	        } else if (this._bodyFormData) {
	          throw new Error('could not read FormData body as blob')
	        } else {
	          return Promise.resolve(new Blob([this._bodyText]))
	        }
	      }
	
	      this.arrayBuffer = function() {
	        return this.blob().then(readBlobAsArrayBuffer)
	      }
	
	      this.text = function() {
	        var rejected = consumed(this)
	        if (rejected) {
	          return rejected
	        }
	
	        if (this._bodyBlob) {
	          return readBlobAsText(this._bodyBlob)
	        } else if (this._bodyFormData) {
	          throw new Error('could not read FormData body as text')
	        } else {
	          return Promise.resolve(this._bodyText)
	        }
	      }
	    } else {
	      this.text = function() {
	        var rejected = consumed(this)
	        return rejected ? rejected : Promise.resolve(this._bodyText)
	      }
	    }
	
	    if (support.formData) {
	      this.formData = function() {
	        return this.text().then(decode)
	      }
	    }
	
	    this.json = function() {
	      return this.text().then(JSON.parse)
	    }
	
	    return this
	  }
	
	  // HTTP methods whose capitalization should be normalized
	  var methods = ['DELETE', 'GET', 'HEAD', 'OPTIONS', 'POST', 'PUT']
	
	  function normalizeMethod(method) {
	    var upcased = method.toUpperCase()
	    return (methods.indexOf(upcased) > -1) ? upcased : method
	  }
	
	  function Request(input, options) {
	    options = options || {}
	    var body = options.body
	    if (Request.prototype.isPrototypeOf(input)) {
	      if (input.bodyUsed) {
	        throw new TypeError('Already read')
	      }
	      this.url = input.url
	      this.credentials = input.credentials
	      if (!options.headers) {
	        this.headers = new Headers(input.headers)
	      }
	      this.method = input.method
	      this.mode = input.mode
	      if (!body) {
	        body = input._bodyInit
	        input.bodyUsed = true
	      }
	    } else {
	      this.url = input
	    }
	
	    this.credentials = options.credentials || this.credentials || 'omit'
	    if (options.headers || !this.headers) {
	      this.headers = new Headers(options.headers)
	    }
	    this.method = normalizeMethod(options.method || this.method || 'GET')
	    this.mode = options.mode || this.mode || null
	    this.referrer = null
	
	    if ((this.method === 'GET' || this.method === 'HEAD') && body) {
	      throw new TypeError('Body not allowed for GET or HEAD requests')
	    }
	    this._initBody(body)
	  }
	
	  Request.prototype.clone = function() {
	    return new Request(this)
	  }
	
	  function decode(body) {
	    var form = new FormData()
	    body.trim().split('&').forEach(function(bytes) {
	      if (bytes) {
	        var split = bytes.split('=')
	        var name = split.shift().replace(/\+/g, ' ')
	        var value = split.join('=').replace(/\+/g, ' ')
	        form.append(decodeURIComponent(name), decodeURIComponent(value))
	      }
	    })
	    return form
	  }
	
	  function headers(xhr) {
	    var head = new Headers()
	    var pairs = (xhr.getAllResponseHeaders() || '').trim().split('\n')
	    pairs.forEach(function(header) {
	      var split = header.trim().split(':')
	      var key = split.shift().trim()
	      var value = split.join(':').trim()
	      head.append(key, value)
	    })
	    return head
	  }
	
	  Body.call(Request.prototype)
	
	  function Response(bodyInit, options) {
	    if (!options) {
	      options = {}
	    }
	
	    this.type = 'default'
	    this.status = options.status
	    this.ok = this.status >= 200 && this.status < 300
	    this.statusText = options.statusText
	    this.headers = options.headers instanceof Headers ? options.headers : new Headers(options.headers)
	    this.url = options.url || ''
	    this._initBody(bodyInit)
	  }
	
	  Body.call(Response.prototype)
	
	  Response.prototype.clone = function() {
	    return new Response(this._bodyInit, {
	      status: this.status,
	      statusText: this.statusText,
	      headers: new Headers(this.headers),
	      url: this.url
	    })
	  }
	
	  Response.error = function() {
	    var response = new Response(null, {status: 0, statusText: ''})
	    response.type = 'error'
	    return response
	  }
	
	  var redirectStatuses = [301, 302, 303, 307, 308]
	
	  Response.redirect = function(url, status) {
	    if (redirectStatuses.indexOf(status) === -1) {
	      throw new RangeError('Invalid status code')
	    }
	
	    return new Response(null, {status: status, headers: {location: url}})
	  }
	
	  self.Headers = Headers
	  self.Request = Request
	  self.Response = Response
	
	  self.fetch = function(input, init) {
	    return new Promise(function(resolve, reject) {
	      var request
	      if (Request.prototype.isPrototypeOf(input) && !init) {
	        request = input
	      } else {
	        request = new Request(input, init)
	      }
	
	      var xhr = new XMLHttpRequest()
	
	      function responseURL() {
	        if ('responseURL' in xhr) {
	          return xhr.responseURL
	        }
	
	        // Avoid security warnings on getResponseHeader when not allowed by CORS
	        if (/^X-Request-URL:/m.test(xhr.getAllResponseHeaders())) {
	          return xhr.getResponseHeader('X-Request-URL')
	        }
	
	        return
	      }
	
	      xhr.onload = function() {
	        var options = {
	          status: xhr.status,
	          statusText: xhr.statusText,
	          headers: headers(xhr),
	          url: responseURL()
	        }
	        var body = 'response' in xhr ? xhr.response : xhr.responseText
	        resolve(new Response(body, options))
	      }
	
	      xhr.onerror = function() {
	        reject(new TypeError('Network request failed'))
	      }
	
	      xhr.ontimeout = function() {
	        reject(new TypeError('Network request failed'))
	      }
	
	      xhr.open(request.method, request.url, true)
	
	      if (request.credentials === 'include') {
	        xhr.withCredentials = true
	      }
	
	      if ('responseType' in xhr && support.blob) {
	        xhr.responseType = 'blob'
	      }
	
	      request.headers.forEach(function(value, name) {
	        xhr.setRequestHeader(name, value)
	      })
	
	      xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit)
	    })
	  }
	  self.fetch.polyfill = true
	})(typeof self !== 'undefined' ? self : this);


/***/ }
/******/ ])));


/** WEBPACK FOOTER **
 ** medscape-tv.bundle.js
 **/